webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1996);
	module.exports = __webpack_require__(1718);


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(5);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _logger = __webpack_require__(3156);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _actions = __webpack_require__(490);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(1375);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _profile = __webpack_require__(1582);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _auth = __webpack_require__(1388);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _client = __webpack_require__(1421);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _clientGroup = __webpack_require__(1424);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	var _clientTypes = __webpack_require__(1427);
	
	var _clientTypes2 = _interopRequireDefault(_clientTypes);
	
	var _addressTypes = __webpack_require__(1382);
	
	var _addressTypes2 = _interopRequireDefault(_addressTypes);
	
	var _contactTypes = __webpack_require__(1430);
	
	var _contactTypes2 = _interopRequireDefault(_contactTypes);
	
	var _providerGroup = __webpack_require__(1588);
	
	var _providerGroup2 = _interopRequireDefault(_providerGroup);
	
	var _country = __webpack_require__(1433);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _siteLanguages = __webpack_require__(1615);
	
	var _siteLanguages2 = _interopRequireDefault(_siteLanguages);
	
	var _city = __webpack_require__(1418);
	
	var _city2 = _interopRequireDefault(_city);
	
	var _municipality = __webpack_require__(1499);
	
	var _municipality2 = _interopRequireDefault(_municipality);
	
	var _postal = __webpack_require__(1546);
	
	var _postal2 = _interopRequireDefault(_postal);
	
	var _product = __webpack_require__(1555);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _productGroup = __webpack_require__(1564);
	
	var _productGroup2 = _interopRequireDefault(_productGroup);
	
	var _productPackaging = __webpack_require__(1567);
	
	var _productPackaging2 = _interopRequireDefault(_productPackaging);
	
	var _packagingMaterial = __webpack_require__(1531);
	
	var _packagingMaterial2 = _interopRequireDefault(_packagingMaterial);
	
	var _packagingType = __webpack_require__(1534);
	
	var _packagingType2 = _interopRequireDefault(_packagingType);
	
	var _tax = __webpack_require__(1630);
	
	var _tax2 = _interopRequireDefault(_tax);
	
	var _plan = __webpack_require__(1543);
	
	var _plan2 = _interopRequireDefault(_plan);
	
	var _organizationType = __webpack_require__(1519);
	
	var _organizationType2 = _interopRequireDefault(_organizationType);
	
	var _productType = __webpack_require__(1579);
	
	var _productType2 = _interopRequireDefault(_productType);
	
	var _productSubtype = __webpack_require__(1573);
	
	var _productSubtype2 = _interopRequireDefault(_productSubtype);
	
	var _producer = __webpack_require__(1552);
	
	var _producer2 = _interopRequireDefault(_producer);
	
	var _order = __webpack_require__(491);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _bill = __webpack_require__(1400);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _orderProduct = __webpack_require__(1507);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _creditNoteProduct = __webpack_require__(1436);
	
	var _creditNoteProduct2 = _interopRequireDefault(_creditNoteProduct);
	
	var _creditNoteReason = __webpack_require__(1439);
	
	var _creditNoteReason2 = _interopRequireDefault(_creditNoteReason);
	
	var _billProduct = __webpack_require__(1403);
	
	var _billProduct2 = _interopRequireDefault(_billProduct);
	
	var _ediOrder = __webpack_require__(1448);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _ediOrderItem = __webpack_require__(1451);
	
	var _ediOrderItem2 = _interopRequireDefault(_ediOrderItem);
	
	var _businessDay = __webpack_require__(1409);
	
	var _businessDay2 = _interopRequireDefault(_businessDay);
	
	var _messageTemplateType = __webpack_require__(1490);
	
	var _messageTemplateType2 = _interopRequireDefault(_messageTemplateType);
	
	var _campaign = __webpack_require__(1412);
	
	var _campaign2 = _interopRequireDefault(_campaign);
	
	var _productDeposit = __webpack_require__(1558);
	
	var _productDeposit2 = _interopRequireDefault(_productDeposit);
	
	var _depositSystem = __webpack_require__(1445);
	
	var _depositSystem2 = _interopRequireDefault(_depositSystem);
	
	var _sidebar = __webpack_require__(1612);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _modal = __webpack_require__(1493);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _accountingProvider = __webpack_require__(1376);
	
	var _accountingProvider2 = _interopRequireDefault(_accountingProvider);
	
	var _supplier = __webpack_require__(1627);
	
	var _supplier2 = _interopRequireDefault(_supplier);
	
	var _warehouse = __webpack_require__(1648);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _unitOfMeasure = __webpack_require__(1639);
	
	var _unitOfMeasure2 = _interopRequireDefault(_unitOfMeasure);
	
	var _stock = __webpack_require__(1618);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _adjustment = __webpack_require__(1385);
	
	var _adjustment2 = _interopRequireDefault(_adjustment);
	
	var _purchase = __webpack_require__(1591);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _view = __webpack_require__(1645);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _shippingProvider = __webpack_require__(1609);
	
	var _shippingProvider2 = _interopRequireDefault(_shippingProvider);
	
	var _packageUnitType = __webpack_require__(1528);
	
	var _packageUnitType2 = _interopRequireDefault(_packageUnitType);
	
	var _unitType = __webpack_require__(1642);
	
	var _unitType2 = _interopRequireDefault(_unitType);
	
	var _package = __webpack_require__(1522);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _packageOrderProduct = __webpack_require__(1525);
	
	var _packageOrderProduct2 = _interopRequireDefault(_packageOrderProduct);
	
	var _chartOfAccounts = __webpack_require__(1415);
	
	var _chartOfAccounts2 = _interopRequireDefault(_chartOfAccounts);
	
	var _productTag = __webpack_require__(1576);
	
	var _productTag2 = _interopRequireDefault(_productTag);
	
	var _priceField = __webpack_require__(1549);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	var _productFlow = __webpack_require__(1561);
	
	var _productFlow2 = _interopRequireDefault(_productFlow);
	
	var _exciseGroup = __webpack_require__(1457);
	
	var _exciseGroup2 = _interopRequireDefault(_exciseGroup);
	
	var _additionalCode = __webpack_require__(1379);
	
	var _additionalCode2 = _interopRequireDefault(_additionalCode);
	
	var _organizationMember = __webpack_require__(1510);
	
	var _organizationMember2 = _interopRequireDefault(_organizationMember);
	
	var _organizationMemberProductBusinesshour = __webpack_require__(1516);
	
	var _organizationMemberProductBusinesshour2 = _interopRequireDefault(_organizationMemberProductBusinesshour);
	
	var _organizationMemberBooking = __webpack_require__(1513);
	
	var _organizationMemberBooking2 = _interopRequireDefault(_organizationMemberBooking);
	
	var _modules = __webpack_require__(1496);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _transactionType = __webpack_require__(1633);
	
	var _transactionType2 = _interopRequireDefault(_transactionType);
	
	var _transfer = __webpack_require__(1636);
	
	var _transfer2 = _interopRequireDefault(_transfer);
	
	var _material = __webpack_require__(1484);
	
	var _material2 = _interopRequireDefault(_material);
	
	var _materialType = __webpack_require__(1487);
	
	var _materialType2 = _interopRequireDefault(_materialType);
	
	var _batch = __webpack_require__(1391);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _batchLog = __webpack_require__(1397);
	
	var _batchLog2 = _interopRequireDefault(_batchLog);
	
	var _recipe = __webpack_require__(1594);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	var _recipeType = __webpack_require__(1606);
	
	var _recipeType2 = _interopRequireDefault(_recipeType);
	
	var _recipeIngredience = __webpack_require__(1597);
	
	var _recipeIngredience2 = _interopRequireDefault(_recipeIngredience);
	
	var _batchIngredience = __webpack_require__(1394);
	
	var _batchIngredience2 = _interopRequireDefault(_batchIngredience);
	
	var _recipeProcedure = __webpack_require__(1600);
	
	var _recipeProcedure2 = _interopRequireDefault(_recipeProcedure);
	
	var _recipeProduct = __webpack_require__(1603);
	
	var _recipeProduct2 = _interopRequireDefault(_recipeProduct);
	
	var _equipment = __webpack_require__(1454);
	
	var _equipment2 = _interopRequireDefault(_equipment);
	
	var _license = __webpack_require__(1466);
	
	var _license2 = _interopRequireDefault(_license);
	
	var _licenseType = __webpack_require__(1481);
	
	var _licenseType2 = _interopRequireDefault(_licenseType);
	
	var _licensePermit = __webpack_require__(1472);
	
	var _licensePermit2 = _interopRequireDefault(_licensePermit);
	
	var _licensePermitType = __webpack_require__(1478);
	
	var _licensePermitType2 = _interopRequireDefault(_licensePermitType);
	
	var _licenseGroup = __webpack_require__(1469);
	
	var _licenseGroup2 = _interopRequireDefault(_licenseGroup);
	
	var _licensePermitGroup = __webpack_require__(1475);
	
	var _licensePermitGroup2 = _interopRequireDefault(_licensePermitGroup);
	
	var _excisePeriod = __webpack_require__(1460);
	
	var _excisePeriod2 = _interopRequireDefault(_excisePeriod);
	
	var _subscriberList = __webpack_require__(1624);
	
	var _subscriberList2 = _interopRequireDefault(_subscriberList);
	
	var _subscriber = __webpack_require__(1621);
	
	var _subscriber2 = _interopRequireDefault(_subscriber);
	
	var _partner = __webpack_require__(1537);
	
	var _partner2 = _interopRequireDefault(_partner);
	
	var _orderPickup = __webpack_require__(1504);
	
	var _orderPickup2 = _interopRequireDefault(_orderPickup);
	
	var _productRecommendation = __webpack_require__(1570);
	
	var _productRecommendation2 = _interopRequireDefault(_productRecommendation);
	
	var _paymentMethods = __webpack_require__(1540);
	
	var _paymentMethods2 = _interopRequireDefault(_paymentMethods);
	
	var _language = __webpack_require__(1463);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _currency = __webpack_require__(1442);
	
	var _currency2 = _interopRequireDefault(_currency);
	
	var _project = __webpack_require__(1585);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _bridgeHandoff = __webpack_require__(1406);
	
	var _bridgeHandoff2 = _interopRequireDefault(_bridgeHandoff);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var debug = ("production") !== 'production';
	
	exports.default = new _vuex2.default.Store({
	  actions: actions,
	
	  getters: getters,
	
	  modules: {
	    profile: _profile2.default,
	    auth: _auth2.default,
	    client: _client2.default,
	    clientGroup: _clientGroup2.default,
	    clientTypes: _clientTypes2.default,
	    addressTypes: _addressTypes2.default,
	    contactTypes: _contactTypes2.default,
	    providerGroup: _providerGroup2.default,
	    country: _country2.default,
	    siteLanguages: _siteLanguages2.default,
	    city: _city2.default,
	    municipality: _municipality2.default,
	    postal: _postal2.default,
	    product: _product2.default,
	    productGroup: _productGroup2.default,
	    productPackaging: _productPackaging2.default,
	    packagingMaterial: _packagingMaterial2.default,
	    packagingType: _packagingType2.default,
	    tax: _tax2.default,
	    plan: _plan2.default,
	    organizationType: _organizationType2.default,
	    productType: _productType2.default,
	    productSubtype: _productSubtype2.default,
	    producer: _producer2.default,
	    order: _order2.default,
	    bill: _bill2.default,
	    orderProduct: _orderProduct2.default,
	    ediOrder: _ediOrder2.default,
	    ediOrderItem: _ediOrderItem2.default,
	    businessDay: _businessDay2.default,
	    messageTemplateType: _messageTemplateType2.default,
	    creditNoteProduct: _creditNoteProduct2.default,
	    creditNoteReason: _creditNoteReason2.default,
	    billProduct: _billProduct2.default,
	    campaign: _campaign2.default,
	    productDeposit: _productDeposit2.default,
	    depositSystem: _depositSystem2.default,
	    accountingProvider: _accountingProvider2.default,
	    chartOfAccounts: _chartOfAccounts2.default,
	    supplier: _supplier2.default,
	    warehouse: _warehouse2.default,
	    unitOfMeasure: _unitOfMeasure2.default,
	    stock: _stock2.default,
	    adjustment: _adjustment2.default,
	    purchase: _purchase2.default,
	    view: _view2.default,
	    shippingProvider: _shippingProvider2.default,
	    productTag: _productTag2.default,
	    priceField: _priceField2.default,
	    productFlow: _productFlow2.default,
	    exciseGroup: _exciseGroup2.default,
	    additionalCode: _additionalCode2.default,
	    modules: _modules2.default,
	    packageUnitType: _packageUnitType2.default,
	    unitType: _unitType2.default,
	    pckg: _package2.default,
	    packageOrderProduct: _packageOrderProduct2.default,
	
	    sidebar: _sidebar2.default,
	    modal: _modal2.default,
	    organizationMember: _organizationMember2.default,
	    organizationMemberProductBusinesshour: _organizationMemberProductBusinesshour2.default,
	    organizationMemberBooking: _organizationMemberBooking2.default,
	    transactionType: _transactionType2.default,
	    transfer: _transfer2.default,
	    material: _material2.default,
	    materialType: _materialType2.default,
	    batch: _batch2.default,
	    batchLog: _batchLog2.default,
	    recipe: _recipe2.default,
	    recipeType: _recipeType2.default,
	    recipeIngredience: _recipeIngredience2.default,
	    batchIngredience: _batchIngredience2.default,
	    recipeProcedure: _recipeProcedure2.default,
	    recipeProduct: _recipeProduct2.default,
	    equipment: _equipment2.default,
	    license: _license2.default,
	    licenseType: _licenseType2.default,
	    licensePermitType: _licensePermitType2.default,
	    licensePermit: _licensePermit2.default,
	    licensePermitGroup: _licensePermitGroup2.default,
	    licenseGroup: _licenseGroup2.default,
	    excisePeriod: _excisePeriod2.default,
	    subscriberList: _subscriberList2.default,
	    subscriber: _subscriber2.default,
	    partner: _partner2.default,
	    orderPickup: _orderPickup2.default,
	    productRecommendation: _productRecommendation2.default,
	    paymentMethods: _paymentMethods2.default,
	    language: _language2.default,
	    currency: _currency2.default,
	    project: _project2.default,
	    bridgeHandoff: _bridgeHandoff2.default
	  },
	
	  strict: debug,
	
	  plugins: debug ? [(0, _logger2.default)()] : []
	});

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Transformer = function () {
	  function Transformer() {
	    _classCallCheck(this, Transformer);
	  }
	
	  _createClass(Transformer, null, [{
	    key: "fetchCollection",
	    value: function fetchCollection(items) {
	      var _this = this;
	
	      return items.map(function (item) {
	        return _this.fetch(item);
	      });
	    }
	  }, {
	    key: "sendCollection",
	    value: function sendCollection(items) {
	      var _this2 = this;
	
	      return items.map(function (item) {
	        return _this2.send(item);
	      });
	    }
	  }]);
	
	  return Transformer;
	}();
	
	exports.default = Transformer;

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _errors = __webpack_require__(1717);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function snakeToCamel(str) {
	  return str.replace(/_([a-z])/g, function (_, c) {
	    return c.toUpperCase();
	  });
	}
	
	var Forms = function () {
	  function Forms(data) {
	    _classCallCheck(this, Forms);
	
	    this.successMessage = '';
	    this.initialData = {};
	    this.fields = {};
	    this.labels = {};
	    this.options = {};
	    this.overrideOptions = {};
	    this.displays = {};
	    this.hidden = [];
	    this.disabled = [];
	    this.tooltips = {};
	    this.extraAttr = {};
	    this.loading = false;
	    this.quickForms = {};
	    this.initialAssign(data);
	
	    this.errors = new _errors2.default();
	    this.assignData = this.assignData.bind(this);
	    this.recordErrors = this.recordErrors.bind(this);
	    this.clearErrors = this.clearErrors.bind(this);
	  }
	
	  _createClass(Forms, [{
	    key: 'setQuickForm',
	    value: function setQuickForm(field, component) {
	      this.quickForms[field] = component;
	    }
	  }, {
	    key: 'setDisplays',
	    value: function setDisplays(field) {
	      var displays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      this.displays[field] = displays;
	    }
	  }, {
	    key: 'setOptions',
	    value: function setOptions(field) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      this.options[field] = options;
	    }
	  }, {
	    key: 'setOverrideOptions',
	    value: function setOverrideOptions(field) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      this.overrideOptions[field] = options;
	    }
	  }, {
	    key: 'setFieldValue',
	    value: function setFieldValue(field) {
	      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      if (this.fields[field] === 'file') {
	        if (!value) {
	          this[field] = {};
	        } else {
	          this[field] = Object.assign({}, value);
	        }
	      } else {
	        this[field] = value;
	      }
	    }
	  }, {
	    key: 'setField',
	    value: function setField(field) {
	      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'text';
	
	      this.fields[field] = type;
	    }
	  }, {
	    key: 'setLabels',
	    value: function setLabels(field, label) {
	      this.labels[field] = label;
	    }
	  }, {
	    key: 'initialAssign',
	    value: function initialAssign(data) {
	      var _this = this;
	
	      Object.keys(data).forEach(function (key) {
	        _this.initialData[key] = data[key].value;
	        if (typeof data[key] === 'string') {
	          _this.setField(key);
	          _this.setFieldValue(key, data[key]);
	          return;
	        }
	        _this.setField(key, data[key].type);
	        _this.setFieldValue(key, data[key].value);
	        if (data[key].type === 'select' || data[key].type === 'autocomplete') {
	          _this.setOptions(key);
	          if (data[key].type === 'autocomplete') {
	            _this.setDisplays(key);
	          }
	        }
	
	        if (typeof data[key].attributes !== 'undefined') {
	          _this.setExtraAttr(key, data[key].attributes);
	        }
	        _this.setLabels(key, data[key].label);
	      });
	    }
	  }, {
	    key: 'assignData',
	    value: function assignData(data) {
	      var _this2 = this;
	
	      Object.keys(data).map(function (key) {
	        if (_this2[key] !== undefined) {
	          _this2.setFieldValue(key, data[key]);
	        }
	        return null;
	      });
	    }
	  }, {
	    key: 'data',
	    value: function data() {
	      var data = Object.assign({}, this);
	      delete data.errors;
	      delete data.fields;
	      delete data.displays;
	      delete data.successMessage;
	      delete data.options;
	      delete data.labels;
	      delete data.hidden;
	      delete data.disabled;
	      delete data.extraAttr;
	      delete data.tooltips;
	      delete data.loading;
	      delete data.initialData;
	      delete data.quickForms;
	      return data;
	    }
	  }, {
	    key: 'recordErrors',
	    value: function recordErrors(errors) {
	      if (!errors || (typeof errors === 'undefined' ? 'undefined' : _typeof(errors)) !== 'object') {
	        this.errors.record({});
	        return;
	      }
	      var payload = errors;
	      if (payload.errors && _typeof(payload.errors) === 'object' && !Array.isArray(payload.errors)) {
	        payload = payload.errors;
	      }
	      var fieldKeys = Object.keys(this.fields);
	      var validErrors = {};
	      Object.keys(payload).forEach(function (key) {
	        if (key === 'message' || key === 'error') {
	          return;
	        }
	        var val = payload[key];
	        if (fieldKeys.indexOf(key) >= 0) {
	          validErrors[key] = val;
	          return;
	        }
	        var camel = snakeToCamel(key);
	        if (fieldKeys.indexOf(camel) >= 0) {
	          validErrors[camel] = val;
	        }
	      });
	      this.errors.record(validErrors);
	    }
	  }, {
	    key: 'clearErrors',
	    value: function clearErrors(field) {
	      this.errors.clear(field);
	    }
	  }, {
	    key: 'clearSuccess',
	    value: function clearSuccess(field, value) {
	      var oldValue = this[field];
	      if (typeof oldValue === 'number') {
	        oldValue = oldValue.toString();
	      }
	
	      if (typeof value === 'number') {
	        value = value.toString();
	      }
	
	      if (oldValue !== value) {
	        this.successMessage = '';
	      }
	    }
	  }, {
	    key: 'enableField',
	    value: function enableField(field) {
	      if (this.disabled.indexOf(field) >= 0) {
	        this.disabled.splice(this.disabled.indexOf(field), 1);
	      }
	    }
	  }, {
	    key: 'disableField',
	    value: function disableField(field) {
	      if (this.disabled.indexOf(field) < 0) {
	        this.disabled.push(field);
	      }
	    }
	  }, {
	    key: 'isDisabled',
	    value: function isDisabled(field) {
	      return this.disabled.indexOf(field) >= 0;
	    }
	  }, {
	    key: 'hideField',
	    value: function hideField(field) {
	      if (this.hidden.indexOf(field) < 0) {
	        this.hidden.push(field);
	        this[field] = '';
	      }
	    }
	  }, {
	    key: 'showField',
	    value: function showField(field) {
	      this.hidden.splice(this.hidden.indexOf(field), 1);
	    }
	  }, {
	    key: 'isHidden',
	    value: function isHidden(field) {
	      return this.hidden.indexOf(field) >= 0;
	    }
	  }, {
	    key: 'setTooltip',
	    value: function setTooltip(field, text) {
	      var placement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'top-end';
	
	      this.tooltips[field] = {
	        text: text,
	        placement: placement
	      };
	    }
	  }, {
	    key: 'setExtraAttr',
	    value: function setExtraAttr(field) {
	      var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this.extraAttr[field] = attrs;
	    }
	  }, {
	    key: 'getExtraAttr',
	    value: function getExtraAttr(field) {
	      return this.extraAttr[field] ? this.extraAttr[field] : {};
	    }
	  }, {
	    key: 'setAttrValue',
	    value: function setAttrValue(field, attr, value) {
	      this.extraAttr[field][attr] = value;
	    }
	  }, {
	    key: 'resetValues',
	    value: function resetValues() {
	      this.assignData(this.initialData);
	    }
	  }, {
	    key: 'removeField',
	    value: function removeField(field) {
	      delete this.fields[field];
	      delete this.labels[field];
	    }
	  }]);
	
	  return Forms;
	}();
	
	exports.default = Forms;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2389)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1793),
	  /* template */
	  null,
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GET_ACCOUNT = exports.GET_ACCOUNT = 'GET_ACCOUNT';
	var GET_ADDRESS = exports.GET_ADDRESS = 'GET_ADDRESS';
	var GET_CONTACT = exports.GET_CONTACT = 'GET_CONTACT';
	var GET_ORGANIZATION_SETTINGS = exports.GET_ORGANIZATION_SETTINGS = 'GET_ORGANIZATION_SETTINGS';
	var RESET_PROFILE = exports.RESET_PROFILE = 'RESET_PROFILE';
	var GET_PUBLIC_PROFILE = exports.GET_PUBLIC_PROFILE = 'GET_PUBLIC_PROFILE';
	
	var CHECK_AUTHENTICATION = exports.CHECK_AUTHENTICATION = 'CHECK_AUTHENTICATION';
	var LOGOUT = exports.LOGOUT = 'LOGOUT';
	var LOGIN = exports.LOGIN = 'LOGIN';
	var UPDATE_REFRESHING = exports.UPDATE_REFRESHING = 'UPDATE_REFRESHING';
	var SET_MAINTENANCE_MODE = exports.SET_MAINTENANCE_MODE = 'SET_MAINTENANCE_MODE';
	var TWO_FACTOR_VERIFICATION = exports.TWO_FACTOR_VERIFICATION = 'TWO_FACTOR_VERIFICATION';
	var CHECK_TWO_FACTOR_VERIFICATION = exports.CHECK_TWO_FACTOR_VERIFICATION = 'CHECK_TWO_FACTOR_VERIFICATION';
	
	var FETCH_ALL_PLANS = exports.FETCH_ALL_PLANS = 'FETCH_ALL_PLANS';
	var SET_CHOSEN_PLAN = exports.SET_CHOSEN_PLAN = 'SET_CHOSEN_PLAN';
	
	var FETCH_ALL_ORGANIZATION_TYPES = exports.FETCH_ALL_ORGANIZATION_TYPES = 'FETCH_ALL_ORGANIZATION_TYPES';
	
	var FETCH_CLIENTS = exports.FETCH_CLIENTS = 'FETCH_CLIENTS';
	var RESET_CLIENTS = exports.RESET_CLIENTS = 'RESET_CLIENTS';
	var FETCH_ALL_CLIENTS = exports.FETCH_ALL_CLIENTS = 'FETCH_ALL_CLIENTS';
	var FETCH_ALL_CLIENT_OPTIONS = exports.FETCH_ALL_CLIENT_OPTIONS = 'FETCH_ALL_CLIENT_OPTIONS';
	var FETCH_ALL_CLIENT_TYPES = exports.FETCH_ALL_CLIENT_TYPES = 'FETCH_ALL_CLIENT_TYPES';
	var CLIENT_QUERY = exports.CLIENT_QUERY = 'CLIENT_QUERY';
	
	var FETCH_ADDRESS_TYPES = exports.FETCH_ADDRESS_TYPES = 'FETCH_ADDRESS_TYPES';
	
	var FETCH_CONTACT_TYPES = exports.FETCH_CONTACT_TYPES = 'FETCH_CONTACT_TYPES';
	
	var SET_CURRENT_CLIENT_CONTACTS = exports.SET_CURRENT_CLIENT_CONTACTS = 'SET_CURRENT_CLIENT_CONTACTS';
	var ADD_CLIENT_CONTACT = exports.ADD_CLIENT_CONTACT = 'ADD_CLIENT_CONTACT';
	var DELETE_CLIENT_CONTACT = exports.DELETE_CLIENT_CONTACT = 'DELETE_CLIENT_CONTACT';
	var UPDATE_CLIENT_CONTACT = exports.UPDATE_CLIENT_CONTACT = 'UPDATE_CLIENT_CONTACT';
	
	var SET_CURRENT_CLIENT_ADDRESSES = exports.SET_CURRENT_CLIENT_ADDRESSES = 'SET_CURRENT_CLIENT_ADDRESSES';
	var ADD_CLIENT_ADDRESS = exports.ADD_CLIENT_ADDRESS = 'ADD_CLIENT_ADDRESS';
	var UPDATE_CLIENT_ADDRESS = exports.UPDATE_CLIENT_ADDRESS = 'UPDATE_CLIENT_ADDRESS';
	var DELETE_CLIENT_ADDRESS = exports.DELETE_CLIENT_ADDRESS = 'DELETE_CLIENT_ADDRESS';
	
	var SELECTED_PROVIDER = exports.SELECTED_PROVIDER = 'SELECTED_PROVIDER';
	var DOWNLOAD_PROVIDER_LIST = exports.DOWNLOAD_PROVIDER_LIST = 'DOWNLOAD_PROVIDER_LIST';
	var CLIENT_PROVIDER = exports.CLIENT_PROVIDER = 'CLIENT_PROVIDER';
	var ADD_NEW_DOWNLOAD_PROVIDER_LIST = exports.ADD_NEW_DOWNLOAD_PROVIDER_LIST = 'ADD_NEW_DOWNLOAD_PROVIDER_LIST';
	
	var FETCH_PAGINATED_CLIENT_GROUPS = exports.FETCH_PAGINATED_CLIENT_GROUPS = 'FETCH_PAGINATED_CLIENT_GROUPS';
	var FETCH_ALL_CLIENT_GROUPS = exports.FETCH_ALL_CLIENT_GROUPS = 'FETCH_ALL_CLIENT_GROUPS';
	var ADD_CLIENT_GROUP = exports.ADD_CLIENT_GROUP = 'ADD_CLIENT_GROUP';
	var UPDATE_CLIENT_GROUP = exports.UPDATE_CLIENT_GROUP = 'UPDATE_CLIENT_GROUP';
	var RESET_CLIENT_GROUPS = exports.RESET_CLIENT_GROUPS = 'RESET_CLIENT_GROUPS';
	
	var FETCH_PAGINATED_PRODUCTS = exports.FETCH_PAGINATED_PRODUCTS = 'FETCH_PAGINATED_PRODUCTS';
	var RESET_PRODUCTS = exports.RESET_PRODUCTS = 'RESET_PRODUCTS';
	var FETCH_ALL_PRODUCTS = exports.FETCH_ALL_PRODUCTS = 'FETCH_ALL_PRODUCTS';
	var FETCH_ALL_PRODUCTS_BASIC = exports.FETCH_ALL_PRODUCTS_BASIC = 'FETCH_ALL_PRODUCTS_BASIC';
	var FETCH_ALL_PRODUCT_TRANSACTIONS = exports.FETCH_ALL_PRODUCT_TRANSACTIONS = 'FETCH_ALL_PRODUCT_TRANSACTIONS';
	var FETCH_ALL_PRODUCT_TRANSACTIONSV2 = exports.FETCH_ALL_PRODUCT_TRANSACTIONSV2 = 'FETCH_ALL_PRODUCT_TRANSACTIONSV2';
	var FETCH_PRODUCT_TRANSACTIONSV2 = exports.FETCH_PRODUCT_TRANSACTIONSV2 = 'FETCH_PRODUCT_TRANSACTIONSV2';
	var ADD_PRODUCT_PRICE = exports.ADD_PRODUCT_PRICE = 'ADD_PRODUCT_PRICE';
	var UPDATE_PRODUCT_PRICE = exports.UPDATE_PRODUCT_PRICE = 'UPDATE_PRODUCT_PRICE';
	var REMOVE_PRODUCT_PRICE = exports.REMOVE_PRODUCT_PRICE = 'REMOVE_PRODUCT_PRICE';
	var FETCH_PRODUCT_PRICES = exports.FETCH_PRODUCT_PRICES = 'FETCH_PRODUCT_PRICES';
	var PRODUCT_QUERY = exports.PRODUCT_QUERY = 'PRODUCT_QUERY';
	var SET_PRODUCT_GROUPING = exports.SET_PRODUCT_GROUPING = 'SET_PRODUCT_GROUPING';
	
	var FETCH_PAGINATED_PRODUCT_GROUPS = exports.FETCH_PAGINATED_PRODUCT_GROUPS = 'FETCH_PAGINATED_PRODUCT_GROUPS';
	var FETCH_ALL_PRODUCT_GROUPS = exports.FETCH_ALL_PRODUCT_GROUPS = 'FETCH_ALL_PRODUCT_GROUPS';
	var RESET_PRODUCT_GROUPS = exports.RESET_PRODUCT_GROUPS = 'RESET_PRODUCT_GROUPS';
	
	var FETCH_PAGINATED_PRODUCT_PACKAGINGS = exports.FETCH_PAGINATED_PRODUCT_PACKAGINGS = 'FETCH_PAGINATED_PRODUCT_PACKAGINGS';
	var FETCH_ALL_PRODUCT_PACKAGINGS = exports.FETCH_ALL_PRODUCT_PACKAGINGS = 'FETCH_ALL_PRODUCT_PACKAGINGS';
	var RESET_PRODUCT_PACKAGINGS = exports.RESET_PRODUCT_PACKAGINGS = 'RESET_PRODUCT_PACKAGINGS';
	var ADD_NULL_PRODUCT_PACKAGINGS = exports.ADD_NULL_PRODUCT_PACKAGINGS = 'ADD_NULL_PRODUCT_PACKAGINGS';
	
	var FETCH_PACKAGING_MATERIALS = exports.FETCH_PACKAGING_MATERIALS = 'FETCH_PACKAGING_MATERIALS';
	
	var FETCH_UNIT_TYPES = exports.FETCH_UNIT_TYPES = 'FETCH_UNIT_TYPES';
	
	var FETCH_PACKAGING_TYPES = exports.FETCH_PACKAGING_TYPES = 'FETCH_PACKAGING_TYPES';
	
	var FETCH_PAGINATED_ORDERS = exports.FETCH_PAGINATED_ORDERS = 'FETCH_PAGINATED_ORDERS';
	var FETCH_ALL_ORDERS = exports.FETCH_ALL_ORDERS = 'FETCH_ALL_ORDERS';
	var RESET_ORDERS = exports.RESET_ORDERS = 'RESET_ORDERS';
	var RESET_CURRENT_ORDER = exports.RESET_CURRENT_ORDER = 'RESET_CURRENT_ORDER';
	var FETCH_ORDER_TYPES = exports.FETCH_ORDER_TYPES = 'FETCH_ORDER_TYPES';
	var FETCH_CURRENT_ORDER = exports.FETCH_CURRENT_ORDER = 'FETCH_CURRENT_ORDER';
	var UPDATE_CURRENT_ORDER = exports.UPDATE_CURRENT_ORDER = 'UPDATE_CURRENT_ORDER';
	var FETCH_ORDER_EVENTS = exports.FETCH_ORDER_EVENTS = 'FETCH_ORDER_EVENTS';
	var ORDER_QUERY = exports.ORDER_QUERY = 'ORDER_QUERY';
	
	var FETCH_ALL_PRODUCT_TYPES = exports.FETCH_ALL_PRODUCT_TYPES = 'FETCH_ALL_PRODUCT_TYPES';
	
	var FETCH_ALL_PRODUCT_SUBTYPES = exports.FETCH_ALL_PRODUCT_SUBTYPES = 'FETCH_ALL_PRODUCT_SUBTYPES';
	
	var FETCH_ALL_PRODUCT_RECOMMENDATIONS = exports.FETCH_ALL_PRODUCT_RECOMMENDATIONS = 'FETCH_ALL_PRODUCT_RECOMMENDATIONS';
	
	var FETCH_ALL_PRODUCERS = exports.FETCH_ALL_PRODUCERS = 'FETCH_ALL_PRODUCERS';
	
	var FETCH_ALL_PRODUCT_DEPOSITS = exports.FETCH_ALL_PRODUCT_DEPOSITS = 'FETCH_ALL_PRODUCT_DEPOSITS';
	var ADD_NULL_DEPOSIT_LIST = exports.ADD_NULL_DEPOSIT_LIST = 'ADD_NULL_DEPOSIT_LIST';
	
	var FETCH_ALL_DEPOSIT_SYSTEMS = exports.FETCH_ALL_DEPOSIT_SYSTEMS = 'FETCH_ALL_DEPOSIT_SYSTEMS';
	var ADD_NULL_DEPOSIT_SYSTEM = exports.ADD_NULL_DEPOSIT_SYSTEM = 'ADD_NULL_DEPOSIT_SYSTEM';
	
	var FETCH_COUNTRIES = exports.FETCH_COUNTRIES = 'FETCH_COUNTRIES';
	
	var FETCH_CITIES = exports.FETCH_CITIES = 'FETCH_CITIES';
	
	var FETCH_MUNICIPALITIES = exports.FETCH_MUNICIPALITIES = 'FETCH_MUNICIPALITIES';
	
	var FETCH_POSTALS = exports.FETCH_POSTALS = 'FETCH_POSTALS';
	
	var FETCH_TAXES = exports.FETCH_TAXES = 'FETCH_TAXES';
	
	var FETCH_BUSINESS_DAYS = exports.FETCH_BUSINESS_DAYS = 'FETCH_BUSINESS_DAYS';
	
	var FETCH_BUSINESS_HOURS = exports.FETCH_BUSINESS_HOURS = 'FETCH_BUSINESS_HOURS';
	var STORE_BUSINESS_HOUR = exports.STORE_BUSINESS_HOUR = 'STORE_BUSINESS_HOUR';
	var DESTROY_BUSINESS_HOUR = exports.DESTROY_BUSINESS_HOUR = 'DESTROY_BUSINESS_HOUR';
	
	var FETCH_BUSINESS_HOUR_EXCEPTIONS = exports.FETCH_BUSINESS_HOUR_EXCEPTIONS = 'FETCH_BUSINESS_HOUR_EXCEPTIONS';
	var STORE_BUSINESS_HOUR_EXCEPTION = exports.STORE_BUSINESS_HOUR_EXCEPTION = 'STORE_BUSINESS_HOUR_EXCEPTION';
	var DESTROY_BUSINESS_HOUR_EXCEPTION = exports.DESTROY_BUSINESS_HOUR_EXCEPTION = 'DESTROY_BUSINESS_HOUR_EXCEPTION';
	
	var FETCH_PAGINATED_BILLS = exports.FETCH_PAGINATED_BILLS = 'FETCH_PAGINATED_BILLS';
	var RESET_BILLS = exports.RESET_BILLS = 'RESET_BILLS';
	var FETCH_BILL_STATUSES = exports.FETCH_BILL_STATUSES = 'FETCH_BILL_STATUSES';
	var FETCH_BILL_TYPES = exports.FETCH_BILL_TYPES = 'FETCH_BILL_TYPES';
	var FETCH_CURRENT_BILL = exports.FETCH_CURRENT_BILL = 'FETCH_CURRENT_BILL';
	var BILL_QUERY = exports.BILL_QUERY = 'BILL_QUERY';
	
	var FETCH_ALL_ORDER_PRODUCTS = exports.FETCH_ALL_ORDER_PRODUCTS = 'FETCH_ALL_ORDER_PRODUCTS';
	var REMOVE_ORDER_PRODUCT = exports.REMOVE_ORDER_PRODUCT = 'REMOVE_ORDER_PRODUCT';
	var ADD_ORDER_PRODUCT = exports.ADD_ORDER_PRODUCT = 'ADD_ORDER_PRODUCT';
	var UPDATE_ORDER_PRODUCT = exports.UPDATE_ORDER_PRODUCT = 'UPDATE_ORDER_PRODUCT';
	var RESET_ORDER_PRODUCTS = exports.RESET_ORDER_PRODUCTS = 'RESET_ORDER_PRODUCTS';
	
	var FETCH_ALL_BILL_PRODUCTS = exports.FETCH_ALL_BILL_PRODUCTS = 'FETCH_ALL_BILL_PRODUCTS';
	var REMOVE_BILL_PRODUCT = exports.REMOVE_BILL_PRODUCT = 'REMOVE_BILL_PRODUCT';
	var ADD_BILL_PRODUCT = exports.ADD_BILL_PRODUCT = 'ADD_BILL_PRODUCT';
	var UPDATE_BILL_PRODUCT = exports.UPDATE_BILL_PRODUCT = 'UPDATE_BILL_PRODUCT';
	var RESET_BILL_PRODUCTS = exports.RESET_BILL_PRODUCTS = 'RESET_BILL_PRODUCTS';
	
	var FETCH_ALL_CREDIT_NOTE_PRODUCTS = exports.FETCH_ALL_CREDIT_NOTE_PRODUCTS = 'FETCH_ALL_CREDIT_NOTE_PRODUCTS';
	var REMOVE_CREDIT_NOTE_PRODUCT = exports.REMOVE_CREDIT_NOTE_PRODUCT = 'REMOVE_CREDIT_NOTE_PRODUCT';
	var ADD_CREDIT_NOTE_PRODUCT = exports.ADD_CREDIT_NOTE_PRODUCT = 'ADD_CREDIT_NOTE_PRODUCT';
	var UPDATE_CREDIT_NOTE_PRODUCT = exports.UPDATE_CREDIT_NOTE_PRODUCT = 'UPDATE_CREDIT_NOTE_PRODUCT';
	var RESET_CREDIT_NOTE_PRODUCTS = exports.RESET_CREDIT_NOTE_PRODUCTS = 'RESET_CREDIT_NOTE_PRODUCTS';
	var FETCH_ALL_CREDIT_NOTE_REASONS = exports.FETCH_ALL_CREDIT_NOTE_REASONS = 'FETCH_ALL_CREDIT_NOTE_REASONS';
	var FETCH_CURRENT_CREDIT_NOTE_REASON = exports.FETCH_CURRENT_CREDIT_NOTE_REASON = 'FETCH_CURRENT_CREDIT_NOTE_REASON';
	
	var FETCH_ALL_EDI_ORDERS = exports.FETCH_ALL_EDI_ORDERS = 'FETCH_ALL_EDI_ORDERS';
	var FETCH_PAGINATED_EDI_ORDERS = exports.FETCH_PAGINATED_EDI_ORDERS = 'FETCH_PAGINATED_EDI_ORDERS';
	var FETCH_CURRENT_EDI_ORDER = exports.FETCH_CURRENT_EDI_ORDER = 'FETCH_CURRENT_EDI_ORDER';
	var RESET_CURRENT_EDI_ORDER = exports.RESET_CURRENT_EDI_ORDER = 'RESET_CURRENT_EDI_ORDER';
	
	var FETCH_ALL_EDI_ORDER_ITEMS = exports.FETCH_ALL_EDI_ORDER_ITEMS = 'FETCH_ALL_EDI_ORDER_ITEMS';
	var UPDATE_EDI_ORDER_ITEM = exports.UPDATE_EDI_ORDER_ITEM = 'UPDATE_EDI_ORDER_ITEM';
	
	var FETCH_ALL_MESSAGE_TEMPLATE_TYPES = exports.FETCH_ALL_MESSAGE_TEMPLATE_TYPES = 'FETCH_ALL_MESSAGE_TEMPLATE_TYPES';
	
	var FETCH_ALL_ACCOUNTING_PROVIDERS = exports.FETCH_ALL_ACCOUNTING_PROVIDERS = 'FETCH_ALL_ACCOUNTING_PROVIDERS';
	
	var FETCH_ALL_CHART_OF_ACCOUNTS = exports.FETCH_ALL_CHART_OF_ACCOUNTS = 'FETCH_ALL_CHART_OF_ACCOUNTS';
	var UPDATE_CHART_OF_ACCOUNTS_ITEM = exports.UPDATE_CHART_OF_ACCOUNTS_ITEM = 'UPDATE_CHART_OF_ACCOUNTS_ITEM';
	var REMOVE_CHART_OF_ACCOUNTS_ITEM = exports.REMOVE_CHART_OF_ACCOUNTS_ITEM = 'REMOVE_CHART_OF_ACCOUNTS_ITEM';
	var ADD_CHART_OF_ACCOUNTS_ITEM = exports.ADD_CHART_OF_ACCOUNTS_ITEM = 'ADD_CHART_OF_ACCOUNTS_ITEM';
	
	var FETCH_PAGINATED_CAMPAIGNS = exports.FETCH_PAGINATED_CAMPAIGNS = 'FETCH_PAGINATED_CAMPAIGNS';
	var FETCH_ALL_CAMPAIGNS = exports.FETCH_ALL_CAMPAIGNS = 'FETCH_ALL_CAMPAIGNS';
	var RESET_CAMPAIGNS = exports.RESET_CAMPAIGNS = 'RESET_CAMPAIGNS';
	
	var FETCH_CAMPAIGN_TYPES = exports.FETCH_CAMPAIGN_TYPES = 'FETCH_CAMPAIGN_TYPES';
	
	var TOGGLE_INNERSIDEBAR = exports.TOGGLE_INNERSIDEBAR = 'TOGGLE_INNERSIDEBAR';
	var SET_INNERSIDEBAR = exports.SET_INNERSIDEBAR = 'SET_INNERSIDEBAR';
	var UNSET_INNERSIDEBAR = exports.UNSET_INNERSIDEBAR = 'UNSET_INNERSIDEBAR';
	var DISABLE_INNERSIDEBAR = exports.DISABLE_INNERSIDEBAR = 'DISABLE_INNERSIDEBAR';
	var ENABLE_INNERSIDEBAR = exports.ENABLE_INNERSIDEBAR = 'ENABLE_INNERSIDEBAR';
	
	var TOGGLE_MODAL = exports.TOGGLE_MODAL = 'TOGGLE_MODAL';
	var SET_MODAL_CONTENT = exports.SET_MODAL_CONTENT = 'SET_MODAL_CONTENT';
	var SET_MODAL_PROPS = exports.SET_MODAL_PROPS = 'SET_MODAL_PROPS';
	var UNSET_MODAL_CONTENT = exports.UNSET_MODAL_CONTENT = 'UNSET_MODAL_CONTENT';
	var SET_MODAL_SIZE = exports.SET_MODAL_SIZE = 'SET_MODAL_SIZE';
	var SET_MODAL_CLASS = exports.SET_MODAL_CLASS = 'SET_MODAL_CLASS';
	var SET_MODAL_CLOSE_ON_CLICK = exports.SET_MODAL_CLOSE_ON_CLICK = 'SET_MODAL_CLOSE_ON_CLICK';
	var SET_MODAL_SHOW_CLOSE = exports.SET_MODAL_SHOW_CLOSE = 'SET_MODAL_SHOW_CLOSE';
	var SET_MODAL_CLOSE_ON_PRESS_ESCAPE = exports.SET_MODAL_CLOSE_ON_PRESS_ESCAPE = 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE';
	var SET_MODAL_BUTTON_LOADING = exports.SET_MODAL_BUTTON_LOADING = 'SET_MODAL_BUTTON_LOADING';
	var UPDATE_PREVIEW_PARAM = exports.UPDATE_PREVIEW_PARAM = 'UPDATE_PREVIEW_PARAM';
	
	var FETCH_ALL_SUPPLIERS = exports.FETCH_ALL_SUPPLIERS = 'FETCH_ALL_SUPPLIERS';
	var FETCH_PAGINATE_SUPPLIERS = exports.FETCH_PAGINATE_SUPPLIERS = 'FETCH_PAGINATE_SUPPLIERS';
	var FETCH_CURRENT_SUPPLIER = exports.FETCH_CURRENT_SUPPLIER = 'FETCH_CURRENT_SUPPLIER';
	
	var FETCH_ALL_WAREHOUSES = exports.FETCH_ALL_WAREHOUSES = 'FETCH_ALL_WAREHOUSES';
	var FETCH_PAGINATE_WAREHOUSES = exports.FETCH_PAGINATE_WAREHOUSES = 'FETCH_PAGINATE_WAREHOUSES';
	var FETCH_CURRENT_WAREHOUSE = exports.FETCH_CURRENT_WAREHOUSE = 'FETCH_CURRENT_WAREHOUSE';
	var FETCH_PAGINATE_WAREHOUSE_PRODUCTS = exports.FETCH_PAGINATE_WAREHOUSE_PRODUCTS = 'FETCH_PAGINATE_WAREHOUSE_PRODUCTS';
	var FETCH_ALL_WAREHOUSE_TRANSACTIONS = exports.FETCH_ALL_WAREHOUSE_TRANSACTIONS = 'FETCH_ALL_WAREHOUSE_TRANSACTIONS';
	
	var FETCH_ALL_WAREHOUSE_TRANSACTIONSV2 = exports.FETCH_ALL_WAREHOUSE_TRANSACTIONSV2 = 'FETCH_ALL_WAREHOUSE_TRANSACTIONSV2';
	var FETCH_PAGINATE_WAREHOUSE_TRANSACTIONSV2 = exports.FETCH_PAGINATE_WAREHOUSE_TRANSACTIONSV2 = 'FETCH_PAGINATE_WAREHOUSE_TRANSACTIONSV2';
	
	var FETCH_ALL_UNIT_OF_MEASURES = exports.FETCH_ALL_UNIT_OF_MEASURES = 'FETCH_ALL_UNIT_OF_MEASURES';
	var FETCH_PAGINATE_UNIT_OF_MEASURES = exports.FETCH_PAGINATE_UNIT_OF_MEASURES = 'FETCH_PAGINATE_UNIT_OF_MEASURES';
	var FETCH_CURRENT_UNIT_OF_MEASURES = exports.FETCH_CURRENT_UNIT_OF_MEASURES = 'FETCH_CURRENT_UNIT_OF_MEASURES';
	
	var FETCH_ALL_STOCKS = exports.FETCH_ALL_STOCKS = 'FETCH_ALL_STOCKS';
	var FETCH_PAGINATE_STOCKS = exports.FETCH_PAGINATE_STOCKS = 'FETCH_PAGINATE_STOCKS';
	var FETCH_CURRENT_STOCK = exports.FETCH_CURRENT_STOCK = 'FETCH_CURRENT_STOCK';
	var FETCH_CURRENT_STOCK_PRODUCTS = exports.FETCH_CURRENT_STOCK_PRODUCTS = 'FETCH_CURRENT_STOCK_PRODUCTS';
	var REFRESH_STOCK_PRODUCTS = exports.REFRESH_STOCK_PRODUCTS = 'REFRESH_STOCK_PRODUCTS';
	var PUSH_TO_STOCK_PRODUCTS = exports.PUSH_TO_STOCK_PRODUCTS = 'PUSH_TO_STOCK_PRODUCTS';
	var DELETE_TO_STOCK_PRODUCTS = exports.DELETE_TO_STOCK_PRODUCTS = 'DELETE_TO_STOCK_PRODUCTS';
	var EDIT_TO_STOCK_PRODUCTS = exports.EDIT_TO_STOCK_PRODUCTS = 'EDIT_TO_STOCK_PRODUCTS';
	var SET_STOCK_SELECTED_WAREHOUSE = exports.SET_STOCK_SELECTED_WAREHOUSE = 'SET_STOCK_SELECTED_WAREHOUSE';
	
	var FETCH_CURRENT_STOCK_PRODUCTS_CUSTOM = exports.FETCH_CURRENT_STOCK_PRODUCTS_CUSTOM = 'FETCH_CURRENT_STOCK_PRODUCTS_CUSTOM';
	var PUSH_TO_STOCK_PRODUCTS_CUSTOM = exports.PUSH_TO_STOCK_PRODUCTS_CUSTOM = 'PUSH_TO_STOCK_PRODUCTS_CUSTOM';
	var REFRESH_STOCK_PRODUCTS_CUSTOM = exports.REFRESH_STOCK_PRODUCTS_CUSTOM = 'REFRESH_STOCK_PRODUCTS_CUSTOM';
	var UPDATE_TO_STOCK_PRODUCTS = exports.UPDATE_TO_STOCK_PRODUCTS = 'UPDATE_TO_STOCK_PRODUCTS';
	var DELETE_FROM_STOCK_PRODUCTS_CUSTOM = exports.DELETE_FROM_STOCK_PRODUCTS_CUSTOM = 'DELETE_FROM_STOCK_PRODUCTS_CUSTOM';
	var FETCH_ALL_ADJUSTMENTS = exports.FETCH_ALL_ADJUSTMENTS = 'FETCH_ALL_ADJUSTMENTS';
	var FETCH_PAGINATE_ADJUSTMENTS = exports.FETCH_PAGINATE_ADJUSTMENTS = 'FETCH_PAGINATE_ADJUSTMENTS';
	var FETCH_CURRENT_ADJUSTMENT = exports.FETCH_CURRENT_ADJUSTMENT = 'FETCH_CURRENT_ADJUSTMENT';
	
	var FETCH_ALL_PURCHASES = exports.FETCH_ALL_PURCHASES = 'FETCH_ALL_PURCHASES';
	var FETCH_PAGINATE_PURCHASES = exports.FETCH_PAGINATE_PURCHASES = 'FETCH_PAGINATE_PURCHASES';
	var FETCH_CURRENT_PURCHASE = exports.FETCH_CURRENT_PURCHASE = 'FETCH_CURRENT_PURCHASE';
	var FETCH_PURCHASE_STATUSES = exports.FETCH_PURCHASE_STATUSES = 'FETCH_PURCHASE_STATUSES';
	
	var TYPE_OF_VIEW = exports.TYPE_OF_VIEW = 'TYPE_OF_VIEW';
	var TYPE_OF_ORDER_VIEW = exports.TYPE_OF_ORDER_VIEW = 'TYPE_OF_ORDER_VIEW';
	
	var FETCH_ALL_SHIPPING_PROVIDERS = exports.FETCH_ALL_SHIPPING_PROVIDERS = 'FETCH_ALL_SHIPPING_PROVIDERS';
	var FETCH_CURRENT_SHIPPING_PROVIDER = exports.FETCH_CURRENT_SHIPPING_PROVIDER = 'FETCH_CURRENT_SHIPPING_PROVIDER';
	
	var FETCH_PAGINATED_PRODUCT_TAGS = exports.FETCH_PAGINATED_PRODUCT_TAGS = 'FETCH_PAGINATED_PRODUCT_TAGS';
	var FETCH_ALL_PRODUCT_TAGS = exports.FETCH_ALL_PRODUCT_TAGS = 'FETCH_ALL_PRODUCT_TAGS';
	var RESET_PRODUCT_TAGS = exports.RESET_PRODUCT_TAGS = 'RESET_PRODUCT_TAGS';
	
	var FETCH_PAGINATED_PRICE_FIELDS = exports.FETCH_PAGINATED_PRICE_FIELDS = 'FETCH_PAGINATED_PRICE_FIELDS';
	var FETCH_ALL_PRICE_FIELDS = exports.FETCH_ALL_PRICE_FIELDS = 'FETCH_ALL_PRICE_FIELDS';
	var RESET_PRICE_FIELDS = exports.RESET_PRICE_FIELDS = 'RESET_PRICE_FIELDS';
	
	var FETCH_ALL_PRODUCTFLOWS = exports.FETCH_ALL_PRODUCTFLOWS = 'FETCH_ALL_PRODUCTFLOWS';
	var FETCH_PAGINATE_PRODUCTFLOWS = exports.FETCH_PAGINATE_PRODUCTFLOWS = 'FETCH_PAGINATE_PRODUCTFLOWS';
	var FETCH_CURRENT_PRODUCTFLOW = exports.FETCH_CURRENT_PRODUCTFLOW = 'FETCH_CURRENT_PRODUCTFLOW';
	var FETCH_ALL_PRODUCTFLOW_ORDERS = exports.FETCH_ALL_PRODUCTFLOW_ORDERS = 'FETCH_ALL_PRODUCTFLOW_ORDERS';
	
	var FETCH_EXCISE_GROUPS = exports.FETCH_EXCISE_GROUPS = 'FETCH_EXCISE_GROUPS';
	var ADD_NULL_TO_EXCISE_GROUPS_LIST = exports.ADD_NULL_TO_EXCISE_GROUPS_LIST = 'ADD_NULL_TO_EXCISE_GROUPS_LIST';
	var FETCH_EXCISE_PACKAGING_GROUPS = exports.FETCH_EXCISE_PACKAGING_GROUPS = 'FETCH_EXCISE_PACKAGING_GROUPS';
	var FETCH_EXCISE_BASIC = exports.FETCH_EXCISE_BASIC = 'FETCH_EXCISE_BASIC';
	
	var FETCH_ADDITIONAL_CODE = exports.FETCH_ADDITIONAL_CODE = 'FETCH_ADDITIONAL_CODE';
	
	var FETCH_ALL_ORGANIZATION_MEMBERS = exports.FETCH_ALL_ORGANIZATION_MEMBERS = 'FETCH_ALL_ORGANIZATION_MEMBERS';
	var ADD_ORGANIZATION_MEMBER = exports.ADD_ORGANIZATION_MEMBER = 'ADD_ORGANIZATION_MEMBER';
	
	var FETCH_ALL_ORGANIZATION_MEMBER_PRODUCT_BUSINESSHOURS = exports.FETCH_ALL_ORGANIZATION_MEMBER_PRODUCT_BUSINESSHOURS = 'FETCH_ALL_ORGANIZATION_MEMBER_PRODUCT_BUSINESSHOURS';
	var FETCH_ALL_ORGANIZATION_MEMBER_BOOKINGS = exports.FETCH_ALL_ORGANIZATION_MEMBER_BOOKINGS = 'FETCH_ALL_ORGANIZATION_MEMBER_BOOKINGS';
	var ADD_ORGANIZATION_MEMBER_BOOKING = exports.ADD_ORGANIZATION_MEMBER_BOOKING = 'ADD_ORGANIZATION_MEMBER_BOOKING';
	
	var FETCH_ALL_MODULES = exports.FETCH_ALL_MODULES = 'FETCH_ALL_MODULES';
	var FETCH_ALL_TRANSACTION_TYPES = exports.FETCH_ALL_TRANSACTION_TYPES = 'FETCH_ALL_TRANSACTION_TYPES';
	
	var FETCH_ALL_TRANSFERS = exports.FETCH_ALL_TRANSFERS = 'FETCH_ALL_TRANSFERS';
	var FETCH_PAGINATE_TRANSFERS = exports.FETCH_PAGINATE_TRANSFERS = 'FETCH_PAGINATE_TRANSFERS';
	var FETCH_CURRENT_TRANSFER = exports.FETCH_CURRENT_TRANSFER = 'FETCH_CURRENT_TRANSFER';
	var FETCH_TRANSFER_STATUSES = exports.FETCH_TRANSFER_STATUSES = 'FETCH_TRANSFER_STATUSES';
	
	var FETCH_PAGINATED_MATERIALS = exports.FETCH_PAGINATED_MATERIALS = 'FETCH_PAGINATED_MATERIALS';
	var FETCH_ALL_MATERIALS = exports.FETCH_ALL_MATERIALS = 'FETCH_ALL_MATERIALS';
	var MATERIAL_QUERY = exports.MATERIAL_QUERY = 'MATERIAL_QUERY';
	
	var FETCH_ALL_MATERIAL_TYPES = exports.FETCH_ALL_MATERIAL_TYPES = 'FETCH_ALL_MATERIAL_TYPES';
	
	var ADD_BATCH = exports.ADD_BATCH = 'ADD_BATCH';
	var FETCH_PAGINATED_BATCHES = exports.FETCH_PAGINATED_BATCHES = 'FETCH_PAGINATED_BATCHES';
	var FETCH_ALL_BATCHES = exports.FETCH_ALL_BATCHES = 'FETCH_ALL_BATCHES';
	var BATCH_QUERY = exports.BATCH_QUERY = 'BATCH_QUERY';
	
	var FETCH_PAGINATED_BATCH_LOGS = exports.FETCH_PAGINATED_BATCH_LOGS = 'FETCH_PAGINATED_BATCH_LOGS';
	var FETCH_ALL_BATCH_LOGS = exports.FETCH_ALL_BATCH_LOGS = 'FETCH_ALL_BATCH_LOGS';
	var BATCH_LOG_QUERY = exports.BATCH_LOG_QUERY = 'BATCH_LOG_QUERY';
	
	var FETCH_PAGINATED_RECIPES = exports.FETCH_PAGINATED_RECIPES = 'FETCH_PAGINATED_RECIPES';
	var FETCH_ALL_RECIPES = exports.FETCH_ALL_RECIPES = 'FETCH_ALL_RECIPES';
	var RECIPE_QUERY = exports.RECIPE_QUERY = 'RECIPE_QUERY';
	
	var FETCH_ALL_RECIPE_TYPES = exports.FETCH_ALL_RECIPE_TYPES = 'FETCH_ALL_RECIPE_TYPES';
	
	var FETCH_ALL_RECIPE_INGREDIENCES = exports.FETCH_ALL_RECIPE_INGREDIENCES = 'FETCH_ALL_RECIPE_INGREDIENCES';
	var REMOVE_RECIPE_INGREDIENCE = exports.REMOVE_RECIPE_INGREDIENCE = 'REMOVE_RECIPE_INGREDIENCE';
	var ADD_RECIPE_INGREDIENCE = exports.ADD_RECIPE_INGREDIENCE = 'ADD_RECIPE_INGREDIENCE';
	var UPDATE_RECIPE_INGREDIENCE = exports.UPDATE_RECIPE_INGREDIENCE = 'UPDATE_RECIPE_INGREDIENCE';
	var RESET_RECIPE_INGREDIENCES = exports.RESET_RECIPE_INGREDIENCES = 'RESET_RECIPE_INGREDIENCES';
	
	var FETCH_ALL_BATCH_INGREDIENCES = exports.FETCH_ALL_BATCH_INGREDIENCES = 'FETCH_ALL_BATCH_INGREDIENCES';
	var REMOVE_BATCH_INGREDIENCE = exports.REMOVE_BATCH_INGREDIENCE = 'REMOVE_BATCH_INGREDIENCE';
	var ADD_BATCH_INGREDIENCE = exports.ADD_BATCH_INGREDIENCE = 'ADD_BATCH_INGREDIENCE';
	var UPDATE_BATCH_INGREDIENCE = exports.UPDATE_BATCH_INGREDIENCE = 'UPDATE_BATCH_INGREDIENCE';
	var RESET_BATCH_INGREDIENCES = exports.RESET_BATCH_INGREDIENCES = 'RESET_BATCH_INGREDIENCES';
	
	var FETCH_ALL_RECIPE_PROCEDURES = exports.FETCH_ALL_RECIPE_PROCEDURES = 'FETCH_ALL_RECIPE_PROCEDURES';
	var REMOVE_RECIPE_PROCEDURE = exports.REMOVE_RECIPE_PROCEDURE = 'REMOVE_RECIPE_PROCEDURE';
	var ADD_RECIPE_PROCEDURE = exports.ADD_RECIPE_PROCEDURE = 'ADD_RECIPE_PROCEDURE';
	var UPDATE_RECIPE_PROCEDURE = exports.UPDATE_RECIPE_PROCEDURE = 'UPDATE_RECIPE_PROCEDURE';
	var RESET_RECIPE_PROCEDURES = exports.RESET_RECIPE_PROCEDURES = 'RESET_RECIPE_PROCEDURES';
	
	var FETCH_ALL_RECIPE_PRODUCTS = exports.FETCH_ALL_RECIPE_PRODUCTS = 'FETCH_ALL_RECIPE_PRODUCTS';
	var REMOVE_RECIPE_PRODUCT = exports.REMOVE_RECIPE_PRODUCT = 'REMOVE_RECIPE_PRODUCT';
	var ADD_RECIPE_PRODUCT = exports.ADD_RECIPE_PRODUCT = 'ADD_RECIPE_PRODUCT';
	var RESET_RECIPE_PRODUCTS = exports.RESET_RECIPE_PRODUCTS = 'RESET_RECIPE_PRODUCTS';
	
	var FETCH_PAGINATED_EQUIPMENTS = exports.FETCH_PAGINATED_EQUIPMENTS = 'FETCH_PAGINATED_EQUIPMENTS';
	var FETCH_ALL_EQUIPMENTS = exports.FETCH_ALL_EQUIPMENTS = 'FETCH_ALL_EQUIPMENTS';
	var EQUIPMENT_QUERY = exports.EQUIPMENT_QUERY = 'EQUIPMENT_QUERY';
	
	var FETCH_SITELANGUAGES = exports.FETCH_SITELANGUAGES = 'FETCH_SITELANGUAGES';
	
	var FETCH_AVAILABLE_WIDGETS = exports.FETCH_AVAILABLE_WIDGETS = 'FETCH_AVAILABLE_WIDGETS';
	var FETCH_USER_WIDGETS = exports.FETCH_USER_WIDGETS = 'FETCH_USER_WIDGETS';
	var FETCH_BEST_CLIENTS_WIDGETS = exports.FETCH_BEST_CLIENTS_WIDGETS = 'FETCH_BEST_CLIENTS_WIDGETS';
	var FETCH_WAITING_PROCESSED_WIDGETS = exports.FETCH_WAITING_PROCESSED_WIDGETS = 'FETCH_WAITING_PROCESSED_WIDGETS';
	var FETCH_WAITING_DELIVERED_WIDGETS = exports.FETCH_WAITING_DELIVERED_WIDGETS = 'FETCH_WAITING_DELIVERED_WIDGETS';
	var FETCH_ORDER_RECEIVED_WIDGETS = exports.FETCH_ORDER_RECEIVED_WIDGETS = 'FETCH_ORDER_RECEIVED_WIDGETS';
	var FETCH_REVENUE_WIDGETS = exports.FETCH_REVENUE_WIDGETS = 'FETCH_REVENUE_WIDGETS';
	var FETCH_POPULAR_PRODUCTS_WIDGETS = exports.FETCH_POPULAR_PRODUCTS_WIDGETS = 'FETCH_POPULAR_PRODUCTS_WIDGETS';
	var FETCH_SOLD_PRODUCTS_WIDGETS = exports.FETCH_SOLD_PRODUCTS_WIDGETS = 'FETCH_SOLD_PRODUCTS_WIDGETS';
	
	var FETCH_PAGINATED_EXCISE_PERIODS = exports.FETCH_PAGINATED_EXCISE_PERIODS = 'FETCH_PAGINATED_EXCISE_PERIODS';
	var FETCH_ALL_EXCISE_PERIODS = exports.FETCH_ALL_EXCISE_PERIODS = 'FETCH_ALL_EXCISE_PERIODS';
	
	var FETCH_PAGINATED_SUBSCRIBER_LIST = exports.FETCH_PAGINATED_SUBSCRIBER_LIST = 'FETCH_PAGINATED_SUBSCRIBER_LIST';
	var FETCH_ALL_SUBSCRIBER_LIST = exports.FETCH_ALL_SUBSCRIBER_LIST = 'FETCH_ALL_SUBSCRIBELIST_LIST';
	var FETCH_CURRENT_SUBSCRIBER_LIST = exports.FETCH_CURRENT_SUBSCRIBER_LIST = 'FETCH_CURRENT_SUBSCRIBER_LIST';
	var SET_MODIFIED_CLIENT_GROUP = exports.SET_MODIFIED_CLIENT_GROUP = 'SET_MODIFIED_CLIENT_GROUP';
	var SET_CANCEL_CLIENT_GROUP_ADD = exports.SET_CANCEL_CLIENT_GROUP_ADD = 'SET_CANCEL_CLIENT_GROUP_ADD';
	
	var FETCH_ALL_SUBSCRIBER = exports.FETCH_ALL_SUBSCRIBER = 'FETCH_ALL_SUBSCRIBER';
	var FETCH_PAGINATED_SUBSCRIBER = exports.FETCH_PAGINATED_SUBSCRIBER = 'FETCH_PAGINATED_SUBSCRIBER';
	var FETCH_ALL_PACKAGE_UNIT_TYPES = exports.FETCH_ALL_PACKAGE_UNIT_TYPES = 'FETCH_ALL_PACKAGE_UNIT_TYPES';
	
	var FETCH_ALL_PACKAGES = exports.FETCH_ALL_PACKAGES = 'FETCH_ALL_PACKAGES';
	
	var FETCH_ALL_PACKAGE_ORDER_PRODUCTS = exports.FETCH_ALL_PACKAGE_ORDER_PRODUCTS = 'FETCH_ALL_PACKAGE_ORDER_PRODUCTS';
	
	var FETCH_USER_APP_VERSION = exports.FETCH_USER_APP_VERSION = 'FETCH_USER_APP_VERSION';
	
	var FETCH_USER_APP_TOAST = exports.FETCH_USER_APP_TOAST = 'FETCH_USER_APP_TOAST';
	
	var FETCH_ALL_PARTNERS = exports.FETCH_ALL_PARTNERS = 'FETCH_ALL_PARTNERS';
	
	var FETCH_PAGINATED_ORDER_PICKUPS = exports.FETCH_PAGINATED_ORDER_PICKUPS = 'FETCH_PAGINATED_ORDER_PICKUPS';
	var FETCH_ALL_ORDER_PICKUPS = exports.FETCH_ALL_ORDER_PICKUPS = 'FETCH_ALL_ORDER_PICKUPS';
	var RESET_ORDER_PICKUPS = exports.RESET_ORDER_PICKUPS = 'RESET_ORDER_PICKUPS';
	var RESET_CURRENT_ORDER_PICKUP = exports.RESET_CURRENT_ORDER_PICKUP = 'RESET_CURRENT_ORDER_PICKUP';
	var FETCH_ORDER_PICKUPS_TYPES = exports.FETCH_ORDER_PICKUPS_TYPES = 'FETCH_ORDER_PICKUPS_TYPES';
	var FETCH_CURRENT_ORDER_PICKUP = exports.FETCH_CURRENT_ORDER_PICKUP = 'FETCH_CURRENT_ORDER_PICKUP';
	var FETCH_ORDER_PICKUPS_EVENTS = exports.FETCH_ORDER_PICKUPS_EVENTS = 'FETCH_ORDER_PICKUPS_EVENTS';
	var ORDER_PICKUPS_QUERY = exports.ORDER_PICKUPS_QUERY = 'ORDER_PICKUPS_QUERY';
	
	var FETCH_ALL_LICENSES = exports.FETCH_ALL_LICENSES = 'FETCH_ALL_LICENSES';
	var FETCH_ALL_LICENSE_TYPES = exports.FETCH_ALL_LICENSE_TYPES = 'FETCH_ALL_LICENSE_TYPES';
	var ADD_NULL_LICENSE_TYPE = exports.ADD_NULL_LICENSE_TYPE = 'ADD_NULL_LICENSE_TYPE';
	var FETCH_ALL_LICENSE_PERMIT_TYPES = exports.FETCH_ALL_LICENSE_PERMIT_TYPES = 'FETCH_ALL_LICENSE_PERMIT_TYPES';
	var FETCH_ALL_LICENSE_PERMITS = exports.FETCH_ALL_LICENSE_PERMITS = 'FETCH_ALL_LICENSE_PERMITS';
	var FETCH_ALL_LICENSE_GROUPS = exports.FETCH_ALL_LICENSE_GROUPS = 'FETCH_ALL_LICENSE_GROUPS';
	var FETCH_ALL_LICENSE_PERMIT_GROUPS = exports.FETCH_ALL_LICENSE_PERMIT_GROUPS = 'FETCH_ALL_LICENSE_PERMIT_GROUPS';
	
	var FETCH_PAYMENT_METHODS = exports.FETCH_PAYMENT_METHODS = 'FETCH_PAYMENT_METHODS';
	
	var FETCH_LANGUAGES = exports.FETCH_LANGUAGES = 'FETCH_LANGUAGES';
	
	var FETCH_CURRENCIES = exports.FETCH_CURRENCIES = 'FETCH_CURRENCIES';
	
	var FETCH_PROJECTS = exports.FETCH_PROJECTS = 'FETCH_PROJECTS';
	var RESET_PROJECTS = exports.RESET_PROJECTS = 'RESET_PROJECTS';
	var FETCH_ALL_PROJECTS = exports.FETCH_ALL_PROJECTS = 'FETCH_ALL_PROJECTS';
	
	var SET_BRIDGE_HANDOFF = exports.SET_BRIDGE_HANDOFF = 'SET_BRIDGE_HANDOFF';

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  buildUrl: function buildUrl(base, queries) {
	    var url = '?';
	    var keys = Object.keys(queries).filter(function (key) {
	      return queries[key];
	    });
	    keys.forEach(function (key, index) {
	      url += key + '=' + queries[key];
	      if (index < keys.length - 1) url += '&';
	    });
	    return '' + base + url;
	  },
	  closeDropdown: function closeDropdown(e, dropdownState) {
	    if (e.target.dataset.toggle !== 'dropdown' && e.target.parentElement.dataset.toggle !== 'dropdown') {
	      if (dropdownState === true) {
	        return false;
	      }
	    }
	    return true;
	  }
	};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _find = __webpack_require__(226);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _wizard = __webpack_require__(869);
	
	var _wizard2 = _interopRequireDefault(_wizard);
	
	var _update = __webpack_require__(864);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _updateUser = __webpack_require__(866);
	
	var _updateUser2 = _interopRequireDefault(_updateUser);
	
	var _offDebugMode = __webpack_require__(858);
	
	var _offDebugMode2 = _interopRequireDefault(_offDebugMode);
	
	var _onDebugMode = __webpack_require__(859);
	
	var _onDebugMode2 = _interopRequireDefault(_onDebugMode);
	
	var _switchOrganization = __webpack_require__(862);
	
	var _switchOrganization2 = _interopRequireDefault(_switchOrganization);
	
	var _updateProductIndexSettings = __webpack_require__(865);
	
	var _updateProductIndexSettings2 = _interopRequireDefault(_updateProductIndexSettings);
	
	var _subscription = __webpack_require__(861);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	var _unpaidInvoice = __webpack_require__(863);
	
	var _unpaidInvoice2 = _interopRequireDefault(_unpaidInvoice);
	
	var _updateUserAppVersion = __webpack_require__(868);
	
	var _updateUserAppVersion2 = _interopRequireDefault(_updateUserAppVersion);
	
	var _fetchUserAppVersion = __webpack_require__(856);
	
	var _fetchUserAppVersion2 = _interopRequireDefault(_fetchUserAppVersion);
	
	var _updateUserAppToast = __webpack_require__(867);
	
	var _updateUserAppToast2 = _interopRequireDefault(_updateUserAppToast);
	
	var _wooCredentials = __webpack_require__(870);
	
	var _wooCredentials2 = _interopRequireDefault(_wooCredentials);
	
	var _wordpressCredentials = __webpack_require__(872);
	
	var _wordpressCredentials2 = _interopRequireDefault(_wordpressCredentials);
	
	var _wooGenerateToken = __webpack_require__(871);
	
	var _wooGenerateToken2 = _interopRequireDefault(_wooGenerateToken);
	
	var _wordpressGenerateToken = __webpack_require__(873);
	
	var _wordpressGenerateToken2 = _interopRequireDefault(_wordpressGenerateToken);
	
	var _rememberPerPage = __webpack_require__(860);
	
	var _rememberPerPage2 = _interopRequireDefault(_rememberPerPage);
	
	var _languages = __webpack_require__(857);
	
	var _languages2 = _interopRequireDefault(_languages);
	
	var _currencies = __webpack_require__(854);
	
	var _currencies2 = _interopRequireDefault(_currencies);
	
	var _defaultLanguageNCurrency = __webpack_require__(855);
	
	var _defaultLanguageNCurrency2 = _interopRequireDefault(_defaultLanguageNCurrency);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  find: _find2.default,
	  wizard: _wizard2.default,
	  update: _update2.default,
	  updateUser: _updateUser2.default,
	  offDebugMode: _offDebugMode2.default,
	  onDebugMode: _onDebugMode2.default,
	  switchOrganization: _switchOrganization2.default,
	  updateProductIndexSettings: _updateProductIndexSettings2.default,
	  subscription: _subscription2.default,
	  unpaidInvoice: _unpaidInvoice2.default,
	  updateUserAppVersion: _updateUserAppVersion2.default,
	  fetchUserAppVersion: _fetchUserAppVersion2.default,
	  updateUserAppToast: _updateUserAppToast2.default,
	  wooCredentials: _wooCredentials2.default,
	  wordpressCredentials: _wordpressCredentials2.default,
	  rememberPerPage: _rememberPerPage2.default,
	  wooGenerateToken: _wooGenerateToken2.default,
	  wordpressGenerateToken: _wordpressGenerateToken2.default,
	  languages: _languages2.default,
	  currencies: _currencies2.default,
	  defaultLanguageNCurrency: _defaultLanguageNCurrency2.default
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1796),
	  /* template */
	  __webpack_require__(3106),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaginationTransformer = function (_Transformer) {
	  _inherits(PaginationTransformer, _Transformer);
	
	  function PaginationTransformer() {
	    _classCallCheck(this, PaginationTransformer);
	
	    return _possibleConstructorReturn(this, (PaginationTransformer.__proto__ || Object.getPrototypeOf(PaginationTransformer)).apply(this, arguments));
	  }
	
	  _createClass(PaginationTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(pagination) {
	      return {
	        currentPage: pagination.current_page,
	        lastPage: pagination.last_page,
	        limit: pagination.limit,
	        totalCount: pagination.total_count,
	        counters: pagination.counters
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(pagination) {
	      return {
	        current_page: pagination.currentPage,
	        last_page: pagination.lastPage,
	        limit: pagination.limit,
	        total_count: pagination.totalCount
	      };
	    }
	  }]);
	
	  return PaginationTransformer;
	}(_transformer2.default);
	
	exports.default = PaginationTransformer;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1824),
	  /* template */
	  __webpack_require__(2957),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1815),
	  /* template */
	  __webpack_require__(2983),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2377)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1760),
	  /* template */
	  __webpack_require__(3103),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      search: '',
	      limit: 25
	    };
	  },
	
	
	  methods: {
	    onChange: function onChange(name, value) {
	      this[name] = value;
	      this.all(1, this.limit);
	    },
	    getSearch: function getSearch() {
	      var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 25;
	
	      this.limit = limit;
	      return this.search;
	    }
	  },
	
	  components: {
	    VText: __webpack_require__(182)
	  }
	};

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(1190);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _destroy = __webpack_require__(1189);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(1196);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1195);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1199);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _quickUpdate = __webpack_require__(1192);
	
	var _quickUpdate2 = _interopRequireDefault(_quickUpdate);
	
	var _all = __webpack_require__(1184);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _allBasic = __webpack_require__(1185);
	
	var _allBasic2 = _interopRequireDefault(_allBasic);
	
	var _transactions = __webpack_require__(1197);
	
	var _transactions2 = _interopRequireDefault(_transactions);
	
	var _transactionsV = __webpack_require__(1198);
	
	var _transactionsV2 = _interopRequireDefault(_transactionsV);
	
	var _merge = __webpack_require__(1191);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _search = __webpack_require__(303);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _searchAll = __webpack_require__(1194);
	
	var _searchAll2 = _interopRequireDefault(_searchAll);
	
	var _counts = __webpack_require__(1188);
	
	var _counts2 = _interopRequireDefault(_counts);
	
	var _bulkUpdate = __webpack_require__(1187);
	
	var _bulkUpdate2 = _interopRequireDefault(_bulkUpdate);
	
	var _bulkSyncToWoo = __webpack_require__(1186);
	
	var _bulkSyncToWoo2 = _interopRequireDefault(_bulkSyncToWoo);
	
	var _removeImage = __webpack_require__(1193);
	
	var _removeImage2 = _interopRequireDefault(_removeImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  items: _items2.default,
	  destroy: _destroy2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  all: _all2.default,
	  allBasic: _allBasic2.default,
	  transactions: _transactions2.default,
	  transactionsV2: _transactionsV2.default,
	  merge: _merge2.default,
	  search: _search2.default,
	  searchAll: _searchAll2.default,
	  quickUpdate: _quickUpdate2.default,
	  counts: _counts2.default,
	  bulkUpdate: _bulkUpdate2.default,
	  bulkSyncToWoo: _bulkSyncToWoo2.default,
	  removeImage: _removeImage2.default
	};

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _show = __webpack_require__(158);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1142);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _updateMessages = __webpack_require__(1146);
	
	var _updateMessages2 = _interopRequireDefault(_updateMessages);
	
	var _updateBooking = __webpack_require__(1145);
	
	var _updateBooking2 = _interopRequireDefault(_updateBooking);
	
	var _updateAccounting = __webpack_require__(1143);
	
	var _updateAccounting2 = _interopRequireDefault(_updateAccounting);
	
	var _updateBilling = __webpack_require__(1144);
	
	var _updateBilling2 = _interopRequireDefault(_updateBilling);
	
	var _createCOA = __webpack_require__(1138);
	
	var _createCOA2 = _interopRequireDefault(_createCOA);
	
	var _emailInvoiceCopy = __webpack_require__(1140);
	
	var _emailInvoiceCopy2 = _interopRequireDefault(_emailInvoiceCopy);
	
	var _ediNotificationRecipients = __webpack_require__(1139);
	
	var _ediNotificationRecipients2 = _interopRequireDefault(_ediNotificationRecipients);
	
	var _lowStockNotificationRecipients = __webpack_require__(1141);
	
	var _lowStockNotificationRecipients2 = _interopRequireDefault(_lowStockNotificationRecipients);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  show: _show2.default,
	  update: _update2.default,
	  updateMessages: _updateMessages2.default,
	  updateBooking: _updateBooking2.default,
	  updateAccounting: _updateAccounting2.default,
	  updateBilling: _updateBilling2.default,
	  createCOA: _createCOA2.default,
	  emailInvoiceCopy: _emailInvoiceCopy2.default,
	  ediNotificationRecipients: _ediNotificationRecipients2.default,
	  lowStockNotificationRecipients: _lowStockNotificationRecipients2.default
	};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _destroy = __webpack_require__(1354);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(1360);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1358);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1365);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _all = __webpack_require__(1353);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(488);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _products = __webpack_require__(1356);
	
	var _products2 = _interopRequireDefault(_products);
	
	var _destroyProducts = __webpack_require__(1355);
	
	var _destroyProducts2 = _interopRequireDefault(_destroyProducts);
	
	var _transactions = __webpack_require__(1362);
	
	var _transactions2 = _interopRequireDefault(_transactions);
	
	var _transactionsV = __webpack_require__(1363);
	
	var _transactionsV2 = _interopRequireDefault(_transactionsV);
	
	var _transactionsV2All = __webpack_require__(1364);
	
	var _transactionsV2All2 = _interopRequireDefault(_transactionsV2All);
	
	var _stockManagement = __webpack_require__(1359);
	
	var _stockManagement2 = _interopRequireDefault(_stockManagement);
	
	var _transactionTypes = __webpack_require__(1361);
	
	var _transactionTypes2 = _interopRequireDefault(_transactionTypes);
	
	var _search = __webpack_require__(1357);
	
	var _search2 = _interopRequireDefault(_search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  destroy: _destroy2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  all: _all2.default,
	  items: _items2.default,
	  products: _products2.default,
	  transactions: _transactions2.default,
	  transactionsV2: _transactionsV2.default,
	  transactionsV2All: _transactionsV2All2.default,
	  stockManagement: _stockManagement2.default,
	  transactionTypes: _transactionTypes2.default,
	  search: _search2.default,
	  destroyProducts: _destroyProducts2.default
	};

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2381)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1845),
	  /* template */
	  __webpack_require__(3110),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _productWarehouse = __webpack_require__(196);
	
	var _productWarehouse2 = _interopRequireDefault(_productWarehouse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductTransformer = function (_Transformer) {
	  _inherits(ProductTransformer, _Transformer);
	
	  function ProductTransformer() {
	    _classCallCheck(this, ProductTransformer);
	
	    return _possibleConstructorReturn(this, (ProductTransformer.__proto__ || Object.getPrototypeOf(ProductTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(product) {
	      var fieldsData = [];
	      try {
	        if (product.fields_json !== '') {
	          if ((product.fields_json !== undefined || product.fields_json !== 'undefined') && product.fields_json !== null) {
	            fieldsData = JSON.parse(product.fields_json);
	          }
	        }
	      } catch (e) {
	        fieldsData = [];
	      }
	
	      return {
	        id: product.id,
	        name: product.name,
	        number: product.number,
	        description: product.description,
	        productGroupId: product.product_group_id,
	        productTagId: product.product_tag_id,
	        productType: product.product_type,
	        productTypeGroup: product.product_type_group,
	        productTypeId: product.product_type_id,
	        productSubtypeId: product.product_subtype_id,
	        productPackagingId: product.product_packaging_id,
	        productPackagingName: product.product_packaging_name,
	        subType: product.sub_type,
	        productParentId: product.product_parent_id,
	        productParentName: product.product_parent_name,
	        containsAlcohol: product.contains_alcohol,
	        alcoholPercentage: product.alcohol_percentage,
	        price: product.price,
	        taxPercentage: product.tax_percentage,
	        taxId: product.tax_id,
	        icon: product.icon ? { url: product.icon } : undefined,
	        duration: product.duration,
	        breaktime: product.breaktime,
	        appointable: product.appointable,
	        productDepositId: product.product_deposit_id,
	        depositSystemId: product.deposit_system_id,
	        productDepositCheckbox: product.product_deposit_id,
	        qty: product.qty,
	        externalId: product.external_id,
	        warehouses: product.warehouses !== undefined ? _productWarehouse2.default.fetchCollection(product.warehouses) : [],
	        childProducts: product.child_products,
	        fieldsJSON: fieldsData,
	        excisable: product.excisable,
	        paidExcise: product.paid_excise ? 1 : 0,
	        inventoryExclude: product.inventory_exclude,
	        purchasePrice: product.purchase_price,
	        costPrice: product.cost_price,
	        errorUpdate: product.error_update,
	        ddpVmp: product.ddpVmp,
	        retailPriceVmp: product.retailPriceVmp,
	        salePriceHoreca: product.salePriceHoreca,
	        salesPriceAsko: product.salesPriceAsko,
	        salesPriceVinhuset: product.salesPriceVinhuset,
	        salesPriceWholesale: product.salesPriceWholesale,
	        salesPriceGrocery: product.salesPriceGrocery,
	        salesPriceBusiness: product.salesPriceBusiness,
	        salesPriceSpecialtyStore: product.salesPriceSpecialtyStore,
	        coop: product.coop,
	        rema1000: product.rema1000,
	        marketplace: product.marketplace,
	        epd: product.epd,
	        sku: product.sku,
	        gtin: product.gtin,
	        gtinMultipack: product.gtin_multipack,
	        sa: product.sa,
	        nobb: product.nobb,
	        vmp: product.vmp,
	        note: product.note,
	        isActive: product.is_active,
	        exciseAlcoholGroup: product.excise_alcohol_group,
	        exciseBasicGroup: product.excise_basic_group,
	        excisePackagingGroup: product.excise_packaging_group,
	        exciseAlcoholGroupName: product.excise_alcohol_group_name,
	        exciseBasicGroupName: product.excise_basic_group_name,
	        excisePackagingGroupName: product.excise_packaging_group_name,
	        packaging_group: product.packaging_group,
	        initial: product.initial,
	        initialValueSku: product.initial_value_sku,
	        custom_sku: product.custom_sku,
	        update_sku: product.update_sku,
	        orderProductNote: product.order_product_note,
	        country: product.country,
	        region: product.region,
	        subRegion: product.subRegion,
	        supplier_id: product.supplier_id,
	        supplier_name: product.supplier_name,
	        vintage: product.vintage,
	        producer: product.producer_id,
	        bottleVolume: product.bottle_volume,
	        packagingMaterial: product.packaging_material,
	        packagingMaterialId: product.packaging_material_id,
	        packagingName: product.packaging_name,
	        packagingQuantity: product.packaging_quantity,
	        corkType: product.cork_type,
	        lastChanged: product.last_changed,
	        marketplaceHasPending: product.marketplace_has_pending,
	        marketplaceStatus: product.marketplace_status,
	        marketplaceEnabled: product.marketplace_enabled,
	        chartOfAccounts: product.chart_of_accounts,
	        weightMultipack: product.weightMultipack,
	        sugar: product.sugar,
	        acid: product.acid,
	        fullness: product.fullness,
	        freshness: product.freshness,
	        bitterness: product.bitterness,
	        tannins: product.tannins,
	        colour: product.colour,
	        odour: product.odour,
	        taste: product.taste,
	        storagePorential: product.storagePorential,
	        organic: product.organic,
	        biodynamic: product.biodynamic,
	        locallyProduced: product.locallyProduced,
	        environmentallySmart: product.environmentallySmart,
	        freeOrLowOnGluten: product.freeOrLowOnGluten,
	        kosher: product.kosher,
	        storagePotential: product.storagePotential,
	        ingredients: product.ingredients,
	        recommendations: product.recommendations,
	        prices: product.prices,
	        selectedPrice: product.selected_price,
	        manualProcessOrder: product.manual_process_order,
	        productBundleGroup: product.product_bundle_group,
	        unProductCodeId: product.un_product_code_id,
	        minimumOrderQuantity: product.minimum_order_quantity,
	        orderableUnitId: product.orderable_unit_id,
	        syncToWoo: product.sync_to_woo,
	        sellInCase: product.sell_in_case,
	        minQty: product.min_qty,
	        groupOf: product.group_of,
	        onlineStorePrice: product.onlineStorePrice,
	        isSharedWarehouse: product.is_shared_warehouse
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(product) {
	      return {
	        id: product.id,
	        name: product.name,
	        description: product.description ? product.description : '',
	        product_group_id: product.productGroupId ? product.productGroupId.toString() : '',
	        product_tag_id: product.productTagId ? product.productTagId.toString() : '',
	        product_type_id: product.productTypeId,
	        product_subtype_id: product.productSubtypeId,
	        product_packaging_id: product.productPackagingId ? product.productPackagingId : '',
	        product_parent_id: product.productParentId,
	        contains_alcohol: product.containsAlcohol,
	        alcohol_percentage: product.alcoholPercentage,
	        bottle_volume: product.bottleVolume,
	        price: product.price,
	        purchase_price: product.purchasePrice,
	        cost_price: product.costPrice,
	        excisable: product.excisable ? 1 : 0,
	        paid_excise: product.paidExcise ? 1 : 0,
	        inventory_exclude: product.inventoryExclude,
	        tax_id: product.taxId,
	        icon: product.icon && product.icon.file ? product.icon.file : '',
	        duration: product.duration,
	        breaktime: product.breaktime,
	        appointable: product.appointable !== '' ? +product.appointable : '',
	        product_deposit_id: product.productDepositId,
	        deposit_system_id: product.depositSystemId,
	        country: product.country,
	        deposit: product.deposit,
	        product_deposit_checkbox: product.productDepositCheckbox,
	        external_id: product.externalId,
	        fields_json: product.alcoholPercentage ? JSON.stringify(Object.assign({}, product, {
	          alcohol_percentage: product.alcoholPercentage,
	          alcoholPercentage: undefined
	        })) : JSON.stringify(product),
	        source_product_id: product.sourceProductId,
	        merge_product_id: product.mergeProductId,
	        ddpVmp: product.ddpVmp,
	        retailPriceVmp: product.retailPriceVmp,
	        salePriceHoreca: product.salePriceHoreca,
	        salesPriceAsko: product.salesPriceAsko,
	        salesPriceVinhuset: product.salesPriceVinhuset,
	        salesPriceWholesale: product.salesPriceWholesale,
	        salesPriceGrocery: product.salesPriceGrocery,
	        salesPriceBusiness: product.salesPriceBusiness,
	        salesPriceSpecialtyStore: product.salesPriceSpecialtyStore,
	        coop: product.coop,
	        rema1000: product.rema1000,
	        marketplace: product.marketplace,
	        price_fields: product.price_fields,
	        epd: product.epd,
	        gtin: product.gtin,
	        gtin_multipack: product.gtinMultipack,
	        sa: product.sa,
	        nobb: product.nobb,
	        vmp: product.vmp,
	        packaging: product.packaging,
	        weightUnit: product.weightUnit,
	        weightMultipack: product.weightMultipack,
	        numberUnitsMultiPackaging: product.numberUnitsMultiPackaging,
	        numberUnitsPallet: product.numberUnitsPallet,
	        availableVinhuset: product.availableVinhuset,
	        availableAsko: product.availableAsko,
	        note: product.note ? product.note : '',
	        is_active: product.isActive,
	        manual_process_order: product.manualProcessOrder,
	        excise_alcohol_group: product.exciseAlcoholGroup,
	        excise_basic_group: product.exciseBasicGroup,
	        excise_packaging_group: product.excisePackagingGroup,
	        packaging_group: product.packagingGroup,
	        custom_sku: product.custom_sku,
	        update_sku: product.update_sku,
	        marketplace_enabled: product.marketplaceEnabled ? 1 : 0,
	        income_account_id: product.chartOfAccounts,
	        producer_id: product.producer,
	        sugar: product.sugar,
	        acid: product.acid,
	        fullness: product.fullness,
	        freshness: product.freshness,
	        bitterness: product.bitterness,
	        tannins: product.tannins,
	        colour: product.colour,
	        odour: product.odour,
	        taste: product.taste,
	        storagePorential: product.storagePorential,
	        ingredients: product.ingredients,
	        organic: product.organic,
	        biodynamic: product.biodynamic,
	        locallyProduced: product.locallyProduced,
	        environmentallySmart: product.environmentallySmart,
	        freeOrLowOnGluten: product.freeOrLowOnGluten,
	        kosher: product.kosher,
	        recommendations: product.recommendations,
	        un_product_code_id: _typeof(product.unProductCodeId) === 'object' ? product.unProductCodeId.id : product.unProductCodeId,
	        minimum_order_quantity: product.minimumOrderQuantity,
	        orderable_unit_id: product.orderableUnitId,
	        sync_to_woo: product.syncToWoo,
	        sell_in_case: product.sellInCase,
	        min_qty: product.minQty,
	        group_of: product.groupOf,
	        online_store_price: product.onlineStorePrice
	      };
	    }
	  }, {
	    key: 'sendMerge',
	    value: function sendMerge(product) {
	      return {
	        source_product_id: product.sourceProductId,
	        destination_product_id: product.destinationProductId
	      };
	    }
	  }]);
	
	  return ProductTransformer;
	}(_transformer2.default);
	
	exports.default = ProductTransformer;

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(978);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _allOptions = __webpack_require__(979);
	
	var _allOptions2 = _interopRequireDefault(_allOptions);
	
	var _destroy = __webpack_require__(982);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(989);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _update = __webpack_require__(990);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _show = __webpack_require__(988);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _items = __webpack_require__(986);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _counts = __webpack_require__(981);
	
	var _counts2 = _interopRequireDefault(_counts);
	
	var _findBusiness = __webpack_require__(984);
	
	var _findBusiness2 = _interopRequireDefault(_findBusiness);
	
	var _ehfLookup = __webpack_require__(983);
	
	var _ehfLookup2 = _interopRequireDefault(_ehfLookup);
	
	var _updateAddress = __webpack_require__(991);
	
	var _updateAddress2 = _interopRequireDefault(_updateAddress);
	
	var _bulkUpdate = __webpack_require__(980);
	
	var _bulkUpdate2 = _interopRequireDefault(_bulkUpdate);
	
	var _glnLookup = __webpack_require__(985);
	
	var _glnLookup2 = _interopRequireDefault(_glnLookup);
	
	var _sendCatalogue = __webpack_require__(987);
	
	var _sendCatalogue2 = _interopRequireDefault(_sendCatalogue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  allOptions: _allOptions2.default,
	  destroy: _destroy2.default,
	  store: _store2.default,
	  update: _update2.default,
	  show: _show2.default,
	  items: _items2.default,
	  counts: _counts2.default,
	  findBusiness: _findBusiness2.default,
	  ehfLookup: _ehfLookup2.default,
	  updateAddress: _updateAddress2.default,
	  bulkUpdate: _bulkUpdate2.default,
	  glnLookup: _glnLookup2.default,
	  sendCatalogue: _sendCatalogue2.default
	};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(1082);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _subscribe = __webpack_require__(1083);
	
	var _subscribe2 = _interopRequireDefault(_subscribe);
	
	var _unsubscribe = __webpack_require__(1084);
	
	var _unsubscribe2 = _interopRequireDefault(_unsubscribe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  items: _items2.default,
	  subscribe: _subscribe2.default,
	  unsubscribe: _unsubscribe2.default
	};

/***/ }),
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2391)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1804),
	  /* template */
	  null,
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(299);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _allBulk = __webpack_require__(1122);
	
	var _allBulk2 = _interopRequireDefault(_allBulk);
	
	var _store = __webpack_require__(1127);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _bulkStore = __webpack_require__(1124);
	
	var _bulkStore2 = _interopRequireDefault(_bulkStore);
	
	var _destroy = __webpack_require__(1125);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _update = __webpack_require__(1128);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _search = __webpack_require__(1126);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _batchUpdate = __webpack_require__(1123);
	
	var _batchUpdate2 = _interopRequireDefault(_batchUpdate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  allBulk: _allBulk2.default,
	  store: _store2.default,
	  destroy: _destroy2.default,
	  update: _update2.default,
	  search: _search2.default,
	  bulkStore: _bulkStore2.default,
	  batchUpdate: _batchUpdate2.default
	};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BatchTransformer = function (_Transformer) {
	  _inherits(BatchTransformer, _Transformer);
	
	  function BatchTransformer() {
	    _classCallCheck(this, BatchTransformer);
	
	    return _possibleConstructorReturn(this, (BatchTransformer.__proto__ || Object.getPrototypeOf(BatchTransformer)).apply(this, arguments));
	  }
	
	  _createClass(BatchTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(batch) {
	      return {
	        id: batch.id,
	        recipeId: batch.recipe_id,
	        recipe: batch.recipe,
	        ingrediences: batch.ingrediences,
	        name: batch.name,
	        code: batch.code,
	        status: batch.status,
	        priorityNumber: batch.priority_number,
	        batchNumber: batch.batch_number,
	        startDate: batch.start_date,
	        endDate: batch.end_date,
	        bestBeforeDate: batch.best_before_date,
	        expirationDate: batch.expiration_date,
	        notes: batch.notes,
	        isActive: batch.is_active,
	        ingredienceDeductionType: batch.ingredience_deduction_type,
	        custom: batch.custom,
	        plannedStartingDate: batch.planned_starting_date
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(batch) {
	      return {
	        id: batch.id,
	        recipe_id: batch.recipeId,
	        status: batch.status,
	        priority_number: batch.priorityNumber,
	        batch_number: batch.batchNumber,
	        start_date: batch.startDate ? (0, _moment2.default)(batch.startDate).format('YYYY-MM-DD') : null,
	        end_date: batch.endDate ? (0, _moment2.default)(batch.endDate).format('YYYY-MM-DD') : null,
	        best_before_date: batch.bestBeforeDate ? (0, _moment2.default)(batch.bestBeforeDate).format('YYYY-MM-DD') : null,
	        expiration_date: batch.expirationDate ? (0, _moment2.default)(batch.expirationDate).format('YYYY-MM-DD') : null,
	        notes: batch.notes,
	        is_active: batch.isActive,
	        custom: batch.custom,
	        product_id: batch.productId,
	        warehouse_id: batch.warehouseId,
	        planned_starting_date: batch.plannedStartingDate ? (0, _moment2.default)(batch.plannedStartingDate).format('YYYY-MM-DD') : null
	      };
	    }
	  }]);
	
	  return BatchTransformer;
	}(_transformer2.default);
	
	exports.default = BatchTransformer;

/***/ }),
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1800),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _login = __webpack_require__(898);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _loginUsingToken = __webpack_require__(899);
	
	var _loginUsingToken2 = _interopRequireDefault(_loginUsingToken);
	
	var _logout = __webpack_require__(900);
	
	var _logout2 = _interopRequireDefault(_logout);
	
	var _register = __webpack_require__(902);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _registerEmail = __webpack_require__(903);
	
	var _registerEmail2 = _interopRequireDefault(_registerEmail);
	
	var _checkBusiness = __webpack_require__(897);
	
	var _checkBusiness2 = _interopRequireDefault(_checkBusiness);
	
	var _token = __webpack_require__(907);
	
	var _token2 = _interopRequireDefault(_token);
	
	var _personalInfo = __webpack_require__(901);
	
	var _personalInfo2 = _interopRequireDefault(_personalInfo);
	
	var _resendConfirmation = __webpack_require__(904);
	
	var _resendConfirmation2 = _interopRequireDefault(_resendConfirmation);
	
	var _resetPassword = __webpack_require__(906);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _updatePassword = __webpack_require__(908);
	
	var _updatePassword2 = _interopRequireDefault(_updatePassword);
	
	var _verifySmsTwoFactorCode = __webpack_require__(910);
	
	var _verifySmsTwoFactorCode2 = _interopRequireDefault(_verifySmsTwoFactorCode);
	
	var _resendSmsTwoFactorCode = __webpack_require__(905);
	
	var _resendSmsTwoFactorCode2 = _interopRequireDefault(_resendSmsTwoFactorCode);
	
	var _verifyGoogleTwoFactorCode = __webpack_require__(909);
	
	var _verifyGoogleTwoFactorCode2 = _interopRequireDefault(_verifyGoogleTwoFactorCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  login: _login2.default,
	  logout: _logout2.default,
	  register: _register2.default,
	  registerEmail: _registerEmail2.default,
	  checkBusiness: _checkBusiness2.default,
	  token: _token2.default,
	  personalInfo: _personalInfo2.default,
	  resendConfirmation: _resendConfirmation2.default,
	  resetPassword: _resetPassword2.default,
	  updatePassword: _updatePassword2.default,
	  loginUsingToken: _loginUsingToken2.default,
	  verifySmsTwoFactorCode: _verifySmsTwoFactorCode2.default,
	  resendSmsTwoFactorCode: _resendSmsTwoFactorCode2.default,
	  verifyGoogleTwoFactorCode: _verifyGoogleTwoFactorCode2.default
	};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1096);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(1112);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _destroy = __webpack_require__(1107);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _bulkCancel = __webpack_require__(1097);
	
	var _bulkCancel2 = _interopRequireDefault(_bulkCancel);
	
	var _store = __webpack_require__(1117);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1115);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1118);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _confirm = __webpack_require__(1103);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _bulkConfirm = __webpack_require__(1098);
	
	var _bulkConfirm2 = _interopRequireDefault(_bulkConfirm);
	
	var _confirmShipping = __webpack_require__(1105);
	
	var _confirmShipping2 = _interopRequireDefault(_confirmShipping);
	
	var _bulkConfirmShipping = __webpack_require__(1100);
	
	var _bulkConfirmShipping2 = _interopRequireDefault(_bulkConfirmShipping);
	
	var _bulkConfirmAndShipping = __webpack_require__(1099);
	
	var _bulkConfirmAndShipping2 = _interopRequireDefault(_bulkConfirmAndShipping);
	
	var _events = __webpack_require__(1110);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _confirmAsOrdered = __webpack_require__(1104);
	
	var _confirmAsOrdered2 = _interopRequireDefault(_confirmAsOrdered);
	
	var _search = __webpack_require__(1114);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _simpleOrder = __webpack_require__(1116);
	
	var _simpleOrder2 = _interopRequireDefault(_simpleOrder);
	
	var _counts = __webpack_require__(1106);
	
	var _counts2 = _interopRequireDefault(_counts);
	
	var _getNextPreviousId = __webpack_require__(1111);
	
	var _getNextPreviousId2 = _interopRequireDefault(_getNextPreviousId);
	
	var _clientSetting = __webpack_require__(1101);
	
	var _clientSetting2 = _interopRequireDefault(_clientSetting);
	
	var _returnOrder = __webpack_require__(1113);
	
	var _returnOrder2 = _interopRequireDefault(_returnOrder);
	
	var _completeReturnOrder = __webpack_require__(1102);
	
	var _completeReturnOrder2 = _interopRequireDefault(_completeReturnOrder);
	
	var _downloadShippingLabel = __webpack_require__(1109);
	
	var _downloadShippingLabel2 = _interopRequireDefault(_downloadShippingLabel);
	
	var _downloadPalletLabel = __webpack_require__(1108);
	
	var _downloadPalletLabel2 = _interopRequireDefault(_downloadPalletLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  items: _items2.default,
	  destroy: _destroy2.default,
	  bulkCancel: _bulkCancel2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  confirm: _confirm2.default,
	  bulkConfirm: _bulkConfirm2.default,
	  confirmShipping: _confirmShipping2.default,
	  bulkConfirmShipping: _bulkConfirmShipping2.default,
	  bulkConfirmAndShipping: _bulkConfirmAndShipping2.default,
	  events: _events2.default,
	  confirmAsOrdered: _confirmAsOrdered2.default,
	  search: _search2.default,
	  simpleOrder: _simpleOrder2.default,
	  counts: _counts2.default,
	  getNextPreviousId: _getNextPreviousId2.default,
	  clientSetting: _clientSetting2.default,
	  returnOrder: _returnOrder2.default,
	  completeReturnOrder: _completeReturnOrder2.default,
	  downloadShippingLabel: _downloadShippingLabel2.default,
	  downloadPalletLabel: _downloadPalletLabel2.default
	};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _client = __webpack_require__(56);
	
	var _client2 = _interopRequireDefault(_client);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BillTransformer = function (_Transformer) {
	  _inherits(BillTransformer, _Transformer);
	
	  function BillTransformer() {
	    _classCallCheck(this, BillTransformer);
	
	    return _possibleConstructorReturn(this, (BillTransformer.__proto__ || Object.getPrototypeOf(BillTransformer)).apply(this, arguments));
	  }
	
	  _createClass(BillTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(bill) {
	      if (bill.country) bill.bill_address.country = bill.country;
	      return {
	        id: bill.id,
	        hashid: bill.hashid,
	        totalValue: bill.total_value,
	        totalQuantity: bill.total_quantity,
	        roundInvoiceTotal: bill.round_invoice_total,
	        orderId: bill.order_id,
	        billStatusId: bill.bill_status_id,
	        billStatus: bill.bill_status,
	        billTypeId: bill.bill_type_id,
	        billType: bill.bill_type,
	        creditNoteSource: bill.credit_note_source,
	        creditNotes: bill.credit_notes,
	        creditNoteValue: bill.credit_note_value,
	        creditNoteReason: bill.credit_note_reason,
	        billingNumber: bill.billing_number,
	        client: _typeof(bill.client) === 'object' ? _client2.default.fetch(bill.client) : bill.client,
	        dueDate: bill.due_date,
	        paymentDate: bill.payment_date,
	        date: bill.date,
	        paymentMessage: bill.paymentMessage,
	        kidNumber: bill.kid_number,
	        note: bill.note,
	        sourceBillNumber: bill.source_billing_number,
	        billAddressStreetName: bill.bill_address_street_name,
	        billAddressSecondStreetName: bill.bill_address_second_street_name,
	        billAddressPostalCode: bill.bill_address_postal_code,
	        billAddressCityName: bill.bill_address_city_name,
	        billSentAt: bill.bill_sent_at,
	        updatedAt: bill.updated_at,
	        storeName: bill.store_name,
	        creditNoteReasonId: bill.credit_note_reason_id,
	        billAddressMissing: bill.bill_address_missing,
	        billAddress: bill.bill_address,
	        clientId: bill.client_id,
	        billProducts: bill.bill_products,
	        summaryGrouping: bill.summary_grouping,
	        emailCopy: bill.email_copy,
	        amountDue: bill.amount_due,
	        amountPaid: bill.amount_paid,
	        totalGross: bill.total_gross,
	        ediOrderError: bill.edi_order_error,
	        sendVia: bill.send_via,
	        language: bill.language,
	        languageId: bill.language_id,
	        currency: bill.currency,
	        currencyId: bill.currency_id,
	        billReminders: bill.bill_reminders,
	        latestBillReminder: bill.latest_bill_reminder,
	        penaltyFees: bill.penalty_fees,
	        canCreateReminderWithFee: bill.can_create_reminder_with_fee,
	        reminderFeesTotalAmount: bill.reminder_fees_total_amount,
	        reminderWithFeeWarning: bill.reminder_with_fee_warning
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(bill) {
	      return {
	        id: bill.id,
	        hashid: bill.hashid,
	        order_id: bill.orderId,
	        round_invoice_total: bill.roundInvoiceTotal,
	        bill_status_id: bill.billStatusId,
	        bill_type_id: bill.billTypeId,
	        credit_note_source: bill.creditNoteSource,
	        credit_note_value: bill.creditNoteValue,
	        credit_note_reason: bill.creditNoteReason,
	        due_date: bill.dueDate,
	        payment_date: bill.paymentDate,
	        date: bill.date,
	        kid_number: bill.kidNumber,
	        paymentMessage: bill.paymentMessage,
	        note: bill.note,
	        updated_at: bill.updatedAt,
	        credit_note_reason_id: bill.creditNoteReasonId,
	        summary_grouping: bill.summaryGrouping,
	        language_id: bill.languageId,
	        currency_id: bill.currencyId
	      };
	    }
	  }]);
	
	  return BillTransformer;
	}(_transformer2.default);
	
	exports.default = BillTransformer;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _clientType = __webpack_require__(495);
	
	var _clientType2 = _interopRequireDefault(_clientType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientTransformer = function (_Transformer) {
	  _inherits(ClientTransformer, _Transformer);
	
	  function ClientTransformer() {
	    _classCallCheck(this, ClientTransformer);
	
	    return _possibleConstructorReturn(this, (ClientTransformer.__proto__ || Object.getPrototypeOf(ClientTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ClientTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(client) {
	      return {
	        id: client.id,
	        clientNumber: client.client_number,
	        name: client.name,
	        active: client.active,
	        subscribedAt: client.subscribed_at,
	        companyName: client.company_name,
	        description: client.description,
	        clientGroupId: client.client_group_id,
	        firstName: client.first_name,
	        lastName: client.last_name,
	        email: client.email,
	        emails: client.emails,
	        phoneNumber: client.phone_number,
	        mobileNumber: client.mobile_number,
	        streetName: client.street_name,
	        secondStreetName: client.second_street_name,
	        postalCode: client.postal_code,
	        cityName: client.city_name,
	        countryId: client.country_id,
	        careOf: client.care_of,
	        ordersCount: client.orders_count,
	        billsCount: client.bills_count,
	        totalValueInvoiced: client.total_value_invoiced,
	        totalValueInvoicedDue: client.total_value_invoiced_due,
	        invoiceSendMethod: client.invoice_send_method,
	        picture: client.picture ? { url: client.picture } : undefined,
	        typeId: client.type_id,
	        clientTypeId: client.client_type_id,
	        clientTypeName: client.client_type_name,
	        createdAt: client.created_at,
	        balance: client.balance,
	        organizationNumber: client.organization_number,
	        clientType: client.client_type !== undefined ? _clientType2.default.fetch(client.client_type) : [],
	        addresses: client.client_addresses,
	        deliveryAddress: client.delivery_address,
	        contacts: client.client_contacts,
	        externalCustomerNumber: client.external_customer_number,
	        billingType: client.billing_type,
	        automaticBilling: client.automatic_billing,
	        billingInterval: client.billing_interval,
	        startBilling: client.start_billing,
	        billingMethodLocked: client.billing_method_locked,
	        automateBillingMethodLocked: client.automate_billing_method_locked,
	        priceFieldId: client.price_field_id,
	        pricePercentageDiscount: client.price_percentage_discount,
	        ehfBilling3_0: client.ehf_billing_3_0,
	        isActive: client.is_active,
	        dueDays: client.due_days,
	        turnoverLastSent: client.turnover_last_sent,
	        isProducer: client.is_producer,
	        isSupplier: client.is_supplier,
	        clientParent: client.client_parent,
	        clientParentId: client.client_parent_id,
	        billMainParent: client.bill_main_parent,
	        marketplaces: client.marketplaces,
	        manualProcessOrder: client.manual_process_order,
	        syncToWoo: client.sync_to_woo,
	        systemGenerated: client.system_generated,
	        gln: client.gln,
	        glnXKoord: client.gln_x_koord,
	        glnYKoord: client.gln_y_koord,
	        orderReference: client.order_reference,
	        currencyId: client.currency_id === 0 ? 1 : client.currency_id,
	        languageId: client.language_id,
	        projectId: client.project_id,
	        orderNote: client.order_note,
	        receivables_account_id: client.receivables_account_id,
	        custNo: client.cust_no
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(client) {
	      return {
	        id: client.id,
	        user_id: client.userId,
	        type_id: client.typeId,
	        client_group_id: client.clientGroupId,
	        first_name: client.firstName,
	        last_name: client.lastName,
	        client_type: client.clientType,
	        email: client.email,
	        company_name: client.companyName,
	        picture: client.picture && client.picture.file ? client.picture.file : '',
	        organization_number: client.organizationNumber,
	        invoice_send_method: client.invoiceSendMethod,
	        externalCustomerNumber: client.externalCustomerNumber,
	        billing_type: client.billingType,
	        automatic_billing: client.automaticBilling,
	        billing_interval: client.billingInterval,
	        start_billing: client.startBilling,
	        price_field_id: client.priceFieldId || '',
	        price_percentage_discount: client.pricePercentageDiscount,
	        is_active: client.isActive,
	        due_days: client.dueDays,
	        is_producer: client.isProducer,
	        is_supplier: client.isSupplier,
	        client_parent_id: client.clientParent.id,
	        bill_main_parent: client.billMainParent,
	        is_sub_client: client.isSubClient,
	        manual_process_order: client.manualProcessOrder,
	        sync_to_woo: client.syncToWoo,
	        gln: client.gln,
	        gln_x_koord: client.glnXKoord,
	        gln_y_koord: client.glnYKoord,
	        order_reference: client.orderReference,
	        currency_id: client.currencyId,
	        language_id: client.languageId,
	        project_id: client.projectId,
	        order_note: client.orderNote,
	        receivables_account_id: client.receivables_account_id || ''
	      };
	    }
	  }]);
	
	  return ClientTransformer;
	}(_transformer2.default);
	
	exports.default = ClientTransformer;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _bill = __webpack_require__(55);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _warehouse = __webpack_require__(62);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _client = __webpack_require__(56);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _booking = __webpack_require__(1659);
	
	var _booking2 = _interopRequireDefault(_booking);
	
	var _ediOrder = __webpack_require__(61);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderTransformer = function (_Transformer) {
	  _inherits(OrderTransformer, _Transformer);
	
	  function OrderTransformer() {
	    _classCallCheck(this, OrderTransformer);
	
	    return _possibleConstructorReturn(this, (OrderTransformer.__proto__ || Object.getPrototypeOf(OrderTransformer)).apply(this, arguments));
	  }
	
	  _createClass(OrderTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(order) {
	      return {
	        id: order.id,
	        number: order.number,
	        createdAt: order.created_at,
	        totalValue: order.total_value,
	        totalQuantity: order.total_quantity,
	        productId: order.product_id,
	        roundInvoiceTotal: order.round_invoice_total,
	        hashid: order.hashid,
	        clientId: order.client_id,
	        clientName: order.client_name,
	        serviceName: order.service_name,
	        orderTypeId: order.order_type_id,
	        ediOrderId: order.edi_order_id,
	        ediRequestedDeliveryDate: order.edi_requested_delivery_date,
	        ediStatus: order.edi_status,
	        ediType: order.edi_type,
	        ediStore: order.edi_store,
	        orderNumber: order.order_number,
	        zreOrderSource: order.zre_order_source,
	        zreOrderSourceOrderNumber: order.zre_order_source_order_number,
	        orderStatusId: order.order_status_id,
	        orderStatus: order.order_status,
	        orderType: order.order_type,
	        discount: order.discount,
	        sent: order.sent,
	        date: order.date,
	        time: order.time,
	        duration: order.duration,
	        details: order.details,
	        bills: order.bills !== undefined ? _bill2.default.fetchCollection(order.bills) : undefined,
	        warehouseId: order.warehouse_id,
	        warehouse: order.warehouse !== undefined ? _warehouse2.default.fetch(order.warehouse) : [],
	        client: order.client !== undefined ? _client2.default.fetch(order.client) : [],
	        booking: order.booking !== undefined ? _booking2.default.fetch(order.booking) : [],
	        referenceNumber: order.reference_number,
	        ediOrder: order.edi_order !== undefined ? _ediOrder2.default.fetch(order.edi_order) : [],
	        shippingProvider: order.shipping_provider,
	        createdDate: order.created_date,
	        orderTrackingNumber: order.tracking_number,
	        trackingUrl: order.tracking_url,
	        orderProducts: order.order_products,
	        isVinmonopolet: order.is_vinmonopolet,
	        isAsko: order.is_asko,
	        isRema: order.is_rema,
	        isCoop: order.is_coop,
	        orderPickupId: order.order_pickup_id,
	        pickup: order.pickup,
	        pickupDate: order.pickup_date,
	        pickupBy: order.pickup_by,
	        pickupStatus: order.pickup_status,
	        deliveryDate: order.delivery_date,
	        shippingDate: order.shipping_date,
	        note: order.note,
	        internalNote: order.internal_note,
	        isBilled: order.is_billed,
	        sendVia: order.send_via,
	        projectId: order.project_id
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(order) {
	      return {
	        id: order.id,
	        number: order.number,
	        round_invoice_total: order.roundInvoiceTotal,
	        hashid: order.hashid,
	        client_id: order.clientId,
	        product_id: order.productId,
	        order_type_id: order.orderTypeId,
	        edi_order_id: order.ediOrderId,
	        discount: order.discount,
	        sent: order.sent,
	        created_at: order.createdAt,
	        date: order.date ? (0, _moment2.default)(order.date).format('YYYY-MM-DD') : '',
	        time: order.time,
	        duration: order.duration,
	        details: order.details,
	        warehouse_id: order.warehouseId,
	        batch_id: order.batchId,
	        reference_number: order.referenceNumber,
	        internal_note: order.internalNote,
	        invoice_external: order.invoiceExternal ? order.invoiceExternal : false,
	        order_confirm_notification: order.orderConfirmNotification,
	        project_id: order.projectId
	      };
	    }
	  }]);
	
	  return OrderTransformer;
	}(_transformer2.default);
	
	exports.default = OrderTransformer;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _purchaseProduct = __webpack_require__(504);
	
	var _purchaseProduct2 = _interopRequireDefault(_purchaseProduct);
	
	var _warehouse = __webpack_require__(62);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _purchaseStatus = __webpack_require__(505);
	
	var _purchaseStatus2 = _interopRequireDefault(_purchaseStatus);
	
	var _client = __webpack_require__(56);
	
	var _client2 = _interopRequireDefault(_client);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PurchaseTransformer = function (_Transformer) {
	  _inherits(PurchaseTransformer, _Transformer);
	
	  function PurchaseTransformer() {
	    _classCallCheck(this, PurchaseTransformer);
	
	    return _possibleConstructorReturn(this, (PurchaseTransformer.__proto__ || Object.getPrototypeOf(PurchaseTransformer)).apply(this, arguments));
	  }
	
	  _createClass(PurchaseTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(adj) {
	      return {
	        id: adj.id,
	        supplierId: adj.supplier_id,
	        producerId: adj.producer_id,
	        comments: adj.comments,
	        purchaseNumber: adj.purchase_number,
	        total_qty: adj.total_qty,
	        code: adj.code,
	        name: adj.name,
	        warehouseId: adj.warehouse_id,
	        createdAt: adj.created_at,
	        products: adj.products !== undefined ? _purchaseProduct2.default.fetchCollection(adj.products) : [],
	        warehouse: adj.warehouse !== undefined ? _warehouse2.default.fetch(adj.warehouse) : [],
	        warehouseName: adj.warehouse_name,
	        supplier: adj.supplier !== undefined ? _client2.default.fetch(adj.supplier) : [],
	        supplierName: adj.supplier_name,
	        status: adj.status,
	        purchaseStatus: adj.purchase_status !== undefined ? _purchaseStatus2.default.fetch(adj.purchase_status) : [],
	        expectedDeliveryDate: adj.expected_delivery_date,
	        receiveDate: adj.receive_date,
	        hashId: adj.hash_id,
	        userLang: adj.user_lang
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(adj) {
	      return {
	        supplier_id: adj.supplierId,
	        warehouse_id: adj.warehouseId,
	        products: _purchaseProduct2.default.sendCollection(adj.products),
	        comments: adj.comments,
	        purchase_number: adj.purchaseNumber,
	        status: adj.status,
	        name: adj.name,
	        expected_delivery_date: adj.expectedDeliveryDate
	      };
	    }
	  }]);
	
	  return PurchaseTransformer;
	}(_transformer2.default);
	
	exports.default = PurchaseTransformer;

/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(911);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(914);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _store = __webpack_require__(919);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(917);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(920);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _nextBatchNumber = __webpack_require__(915);
	
	var _nextBatchNumber2 = _interopRequireDefault(_nextBatchNumber);
	
	var _setProcedureStatus = __webpack_require__(916);
	
	var _setProcedureStatus2 = _interopRequireDefault(_setProcedureStatus);
	
	var _startBatch = __webpack_require__(918);
	
	var _startBatch2 = _interopRequireDefault(_startBatch);
	
	var _completeBatch = __webpack_require__(912);
	
	var _completeBatch2 = _interopRequireDefault(_completeBatch);
	
	var _deductAllIngredience = __webpack_require__(913);
	
	var _deductAllIngredience2 = _interopRequireDefault(_deductAllIngredience);
	
	var _updateBatchTransfer = __webpack_require__(921);
	
	var _updateBatchTransfer2 = _interopRequireDefault(_updateBatchTransfer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  items: _items2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  nextBatchNumber: _nextBatchNumber2.default,
	  setProcedureStatus: _setProcedureStatus2.default,
	  startBatch: _startBatch2.default,
	  completeBatch: _completeBatch2.default,
	  deductAllIngredience: _deductAllIngredience2.default,
	  updateBatchTransfer: _updateBatchTransfer2.default
	};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EdiOrderTransformer = function (_Transformer) {
	  _inherits(EdiOrderTransformer, _Transformer);
	
	  function EdiOrderTransformer() {
	    _classCallCheck(this, EdiOrderTransformer);
	
	    return _possibleConstructorReturn(this, (EdiOrderTransformer.__proto__ || Object.getPrototypeOf(EdiOrderTransformer)).apply(this, arguments));
	  }
	
	  _createClass(EdiOrderTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(ediOrder) {
	      return {
	        id: ediOrder.id,
	        hashid: ediOrder.hashid,
	        orderId: ediOrder.order_id,
	        orderNumber: ediOrder.order_number,
	        orderType: ediOrder.order_type,
	        clientName: ediOrder.client_name,
	        serviceName: ediOrder.service_name,
	        totalValue: ediOrder.total_amount,
	        totalQuantity: ediOrder.total_quantity,
	        organizationId: ediOrder.organization_id,
	        ediSupplierId: ediOrder.edi_supplier_id,
	        ediBuyerId: ediOrder.edi_buyer_id,
	        ediStoreId: ediOrder.edi_store_id,
	        ediOrderStatusId: ediOrder.edi_order_status_id,
	        ediOrderTypeId: ediOrder.edi_order_type_id,
	        ediSupplierLocationId: ediOrder.edi_supplier_location_id,
	        ediBuyerLocationId: ediOrder.edi_buyer_location_id,
	        ediBuyerVatId: ediOrder.edi_buyer_vat_id,
	        ediStorePartyId: ediOrder.edi_store_party_id,
	        ediStoreName: ediOrder.edi_store_name,
	        ediStoreStreet: ediOrder.edi_store_street,
	        ediStorePostCode: ediOrder.edi_store_post_code,
	        ediOrderTypeName: ediOrder.edi_order_type_name,
	        ediOrderStatusName: ediOrder.edi_order_status_name,
	        ediOrderNumber: ediOrder.edi_order_number,
	        requestedDeliveryDate: ediOrder.requested_delivery_date ? (0, _moment2.default)(ediOrder.requested_delivery_date).format('DD.MM.Y') : null,
	
	        shippingProvider: ediOrder.shipping_provider,
	        numberOfItems: ediOrder.number_of_items,
	        ediOrderSource: ediOrder.edi_order_source,
	        ediOrderSourceOrderId: ediOrder.edi_order_source_order_id,
	        ediOrderSourceOrderNumber: ediOrder.edi_order_source_order_number,
	        createdAt: ediOrder.created_at ? (0, _moment2.default)(ediOrder.created_at).format('D.M.Y') : null,
	        standard: ediOrder.standard,
	        hasOrderConfirmation: ediOrder.has_order_confirmation
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(ediOrder) {
	      return {
	        id: ediOrder.id,
	        hashid: ediOrder.hashid,
	        order_number: ediOrder.orderNumber,
	        organization_id: ediOrder.organizationId,
	        edi_supplier_id: ediOrder.ediSupplierId,
	        edi_buyer_id: ediOrder.ediBuyerId,
	        edi_store_id: ediOrder.ediStoreId,
	        edi_order_status_id: ediOrder.ediOrderStatusId,
	        edi_order_type_id: ediOrder.ediOrderTypeId,
	        edi_supplier_location_id: ediOrder.ediSupplierLocationId,
	        edi_buyer_location_id: ediOrder.ediBuyerLocationId,
	        edi_buyer_vat_id: ediOrder.ediBuyerVatId,
	        edi_store_party_id: ediOrder.ediStorePartyId,
	        edi_store_name: ediOrder.ediStoreName,
	        edi_store_street: ediOrder.ediStoreStreet,
	        edi_store_post_code: ediOrder.ediStorePostCode,
	        edi_order_type_name: ediOrder.ediOrderTypeName,
	        edi_order_status_name: ediOrder.ediOrderStatusName,
	        edi_order_number: ediOrder.ediOrderNumber,
	        requested_delivery_date: ediOrder.requestedDeliveryDate ? (0, _moment2.default)(ediOrder.requestedDeliveryDate).format('Y-MM-DD HH:mm:ss') : null,
	        delivery_date: ediOrder.deliveryDate ? (0, _moment2.default)(ediOrder.deliveryDate).format('Y-MM-DD HH:mm:ss') : null,
	        discount: ediOrder.discount,
	        number_of_items: ediOrder.numberOfItems
	      };
	    }
	  }]);
	
	  return EdiOrderTransformer;
	}(_transformer2.default);
	
	exports.default = EdiOrderTransformer;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _warehouseContact = __webpack_require__(1714);
	
	var _warehouseContact2 = _interopRequireDefault(_warehouseContact);
	
	var _warehouseAddress = __webpack_require__(1713);
	
	var _warehouseAddress2 = _interopRequireDefault(_warehouseAddress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarehouseTransformer = function (_Transformer) {
	  _inherits(WarehouseTransformer, _Transformer);
	
	  function WarehouseTransformer() {
	    _classCallCheck(this, WarehouseTransformer);
	
	    return _possibleConstructorReturn(this, (WarehouseTransformer.__proto__ || Object.getPrototypeOf(WarehouseTransformer)).apply(this, arguments));
	  }
	
	  _createClass(WarehouseTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(warehouse) {
	      return {
	        id: warehouse.id,
	        name: warehouse.name,
	        location: warehouse.location,
	        isBonded: warehouse.is_bonded,
	        isActive: warehouse.is_active,
	        isLocked: warehouse.is_locked,
	        typeId: warehouse.type_id,
	        partnerId: warehouse.partner_id,
	        typeName: warehouse.type_name,
	        address: warehouse.address !== undefined ? _warehouseAddress2.default.fetch(warehouse.address) : [],
	        contact: warehouse.contact !== undefined ? _warehouseContact2.default.fetch(warehouse.contact) : [],
	        isSharedToYou: warehouse.is_shared_to_you,
	        shippingProviders: warehouse.shipping_providers
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(warehouse) {
	      return {
	        id: warehouse.id,
	        name: warehouse.name,
	        location: warehouse.location,
	        partner_id: warehouse.partnerId,
	        is_bonded: warehouse.isBonded,
	        is_active: warehouse.isActive,
	        first_name: warehouse.firstName,
	        last_name: warehouse.lastName,
	        email: warehouse.email,
	        phone_number: warehouse.phoneNumber,
	        street_name_1: warehouse.streetName1,
	        street_name_2: warehouse.streetName2,
	        country_id: warehouse.countryId,
	        city: warehouse.city,
	        postal_code: warehouse.postalCode,
	        shipping_providers: warehouse.shippingProviders
	      };
	    }
	  }]);
	
	  return WarehouseTransformer;
	}(_transformer2.default);
	
	exports.default = WarehouseTransformer;

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1001);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BatchIngredienceTransformer = function (_Transformer) {
	  _inherits(BatchIngredienceTransformer, _Transformer);
	
	  function BatchIngredienceTransformer() {
	    _classCallCheck(this, BatchIngredienceTransformer);
	
	    return _possibleConstructorReturn(this, (BatchIngredienceTransformer.__proto__ || Object.getPrototypeOf(BatchIngredienceTransformer)).apply(this, arguments));
	  }
	
	  _createClass(BatchIngredienceTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(batchIngredience) {
	      return {
	        id: batchIngredience.id,
	        batchId: batchIngredience.batch_id,
	        batch: batchIngredience.batch,
	        recipeId: batchIngredience.recipe_id,
	        recipe: batchIngredience.recipe,
	        materialId: batchIngredience.material_id,
	        materialName: batchIngredience.material_name,
	        materialType: batchIngredience.material_type,
	        unitMeasure: batchIngredience.unit_measure,
	        amount: batchIngredience.amount,
	        deductedAmount: batchIngredience.deducted_amount
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(batchIngredience) {
	      return {
	        id: batchIngredience.id,
	        batch_id: batchIngredience.batchId,
	        recipe_id: batchIngredience.recipeId,
	        material_id: batchIngredience.materialId,
	        amount: batchIngredience.amount
	      };
	    }
	  }]);
	
	  return BatchIngredienceTransformer;
	}(_transformer2.default);
	
	exports.default = BatchIngredienceTransformer;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _stockProduct = __webpack_require__(1707);
	
	var _stockProduct2 = _interopRequireDefault(_stockProduct);
	
	var _warehouse = __webpack_require__(62);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StockTransformer = function (_Transformer) {
	  _inherits(StockTransformer, _Transformer);
	
	  function StockTransformer() {
	    _classCallCheck(this, StockTransformer);
	
	    return _possibleConstructorReturn(this, (StockTransformer.__proto__ || Object.getPrototypeOf(StockTransformer)).apply(this, arguments));
	  }
	
	  _createClass(StockTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(stock) {
	      return {
	        id: stock.id,
	        warehouseId: stock.warehouse_id,
	        total_qty: stock.total_qty,
	        descriptions: stock.descriptions,
	        code: stock.code,
	        name: stock.name,
	        createdAt: stock.created_at,
	        products: stock.products !== undefined ? _stockProduct2.default.fetchCollection(stock.products) : [],
	        warehouse: stock.warehouse !== undefined ? _warehouse2.default.fetch(stock.warehouse) : [],
	        warehouseName: stock.warehouse_name,
	        transactionDate: stock.transaction_date,
	        status: stock.status
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(stock) {
	      return {
	        warehouse_id: stock.warehouseId,
	        name: stock.name,
	        products: _stockProduct2.default.sendCollection(stock.products),
	        descriptions: stock.descriptions,
	        transaction_date: stock.transactionDate
	      };
	    }
	  }]);
	
	  return StockTransformer;
	}(_transformer2.default);
	
	exports.default = StockTransformer;

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	  computed: _extends({}, (0, _vuex.mapGetters)(['stockMutationsHandedOff', 'stockDecommissioned']), {
	    bridgeStockWriteBlocked: function bridgeStockWriteBlocked() {
	      return this.stockMutationsHandedOff || this.stockDecommissioned;
	    }
	  })
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _adjustmentProduct = __webpack_require__(1653);
	
	var _adjustmentProduct2 = _interopRequireDefault(_adjustmentProduct);
	
	var _stock = __webpack_require__(68);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _warehouse = __webpack_require__(62);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdjustmentTransformer = function (_Transformer) {
	  _inherits(AdjustmentTransformer, _Transformer);
	
	  function AdjustmentTransformer() {
	    _classCallCheck(this, AdjustmentTransformer);
	
	    return _possibleConstructorReturn(this, (AdjustmentTransformer.__proto__ || Object.getPrototypeOf(AdjustmentTransformer)).apply(this, arguments));
	  }
	
	  _createClass(AdjustmentTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(adj) {
	      return {
	        id: adj.id,
	        stockId: adj.stock_id,
	        batchId: adj.batch_id,
	        reason: adj.reason,
	        total_qty: adj.total_qty,
	        code: adj.code,
	        warehouseId: adj.warehouse_id,
	        warehouseName: adj.warehouse_name,
	        createdAt: adj.created_at,
	        type: adj.type,
	        products: adj.products !== undefined ? _adjustmentProduct2.default.fetchCollection(adj.products) : [],
	        stock: adj.stock !== undefined ? _stock2.default.fetch(adj.stock) : [],
	        warehouse: adj.warehouse !== undefined ? _warehouse2.default.fetch(adj.warehouse) : [],
	        status: adj.status,
	        adjustmentTypeId: adj.adjustment_type_id,
	        adjustmentType: adj.adjustment_type
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(adj) {
	      return {
	        stock_id: adj.stockId,
	        batch_id: adj.batchId,
	        warehouse_id: adj.warehouseId,
	        products: _adjustmentProduct2.default.sendCollection(adj.products),
	        reason: adj.reason,
	        type: adj.type,
	        adjustment_type_id: adj.adjustmentTypeId
	      };
	    }
	  }]);
	
	  return AdjustmentTransformer;
	}(_transformer2.default);
	
	exports.default = AdjustmentTransformer;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _accountingProvider = __webpack_require__(492);
	
	var _accountingProvider2 = _interopRequireDefault(_accountingProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrganizationSettingsTransformer = function (_Transformer) {
	  _inherits(OrganizationSettingsTransformer, _Transformer);
	
	  function OrganizationSettingsTransformer() {
	    _classCallCheck(this, OrganizationSettingsTransformer);
	
	    return _possibleConstructorReturn(this, (OrganizationSettingsTransformer.__proto__ || Object.getPrototypeOf(OrganizationSettingsTransformer)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationSettingsTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(os) {
	      return {
	        billingNumberDefault: os.billing_number_default,
	        smsFrom: os.sms_from,
	        orderNumberDefault: os.order_number_default,
	        customerNumberDefault: os.customer_number_default,
	        invoiceNotes: os.invoice_notes,
	        billNotes: os.bill_notes,
	        creditNoteNotes: os.credit_note_notes,
	        timeslotGap: os.timeslot_gap,
	        remindersEnabled: os.reminders_enabled,
	        defaultDueDays: os.default_due_days,
	        messageTemplateTypeId: os.message_template_type_id,
	        defaultEdiProductGroupName: os.default_edi_product_group_name,
	        defaultEdiClientGroupName: os.default_edi_client_group_name,
	        defaultEdiClientName: os.default_edi_client_name,
	        defaultEdiClientContactPhoneNumber: os.default_edi_client_contact_phone_number,
	        defaultEdiClientAddressStreetName: os.default_edi_client_address_street_name,
	        defaultEdiClientAddressCityId: os.default_edi_client_address_city_id,
	        defaultEdiClientAddressZipCode: os.default_edi_client_address_zipcode,
	        defaultEdiTaxPercentage: os.default_edi_tax_percentage,
	        ediOrderNumberDefault: os.edi_order_number_default,
	        ediOrderDeliveryNoteNumberDefault: os.edi_order_delivery_note_number_default,
	        invoiceEmailTitle: os.invoice_email_title,
	        invoiceEmailTemplate: os.invoice_email_template,
	        creditNoteEmailTitle: os.credit_note_email_title,
	        creditNoteEmailTemplate: os.credit_note_email_template,
	        reminderEmailTitle: os.reminder_email_title,
	        reminderEmailTemplate: os.reminder_email_template,
	        roundInvoiceTotal: os.round_invoice_total,
	        defaultClientGroupId: os.default_client_group_id,
	        tosAccepted: os.tos_accepted,
	        marketingAllowed: os.marketing_allowed,
	        customTos: os.custom_tos,
	        supplierNumberDefault: os.supplier_number_default,
	        productNumberDefault: os.product_number_default,
	        productNumberInitial: os.product_number_initial,
	        accountingProviderId: os.accounting_provider_id,
	        accountingProvider: os.acounting_provider !== undefined ? _accountingProvider2.default.fetch(os.acounting_provider) : undefined,
	        productInfoDisplay: os.product_info_display,
	        facebookPixelId: os.facebook_pixel_id,
	        customOrderProductNote: os.order_product_note,
	        ediBillingProcess: os.edi_billing_process,
	        paymentIdentitificationGeneration: os.payment_identification_generation,
	        paymentIdentitificationTemplate: os.payment_identification_template,
	        paymentIdentitificationNumberLength: os.payment_identification_number_length,
	        defaultProductTypeName: os.default_product_type_name,
	        defaultShippingProvider: os.default_shipping_provider,
	        defaultWarehouse: os.default_warehouse,
	        priceFields: os.price_fields,
	        visiblePriceFields: os.visible_price_fields,
	        defaultPriceField: os.default_price_field,
	        fikenCompanies: os.fiken_companies,
	        hasFikenToken: os.fiken_has_access_token,
	
	        hasPowerOfficeToken: os.poweroffice_has_access_token,
	        powerofficeClientKey: os.poweroffice_client_key,
	        powerofficeCompanySlug: os.poweroffice_company_slug,
	        powerofficeAppKey: os.poweroffice_app_key,
	        powerofficeIntegrationType: os.poweroffice_integration_type,
	
	        unimicroAccessToken: os.unimicro_access_token,
	        unimicroRefreshToken: os.unimicro_refresh_token,
	        unimicroTokenExpiresAt: os.unimicro_token_expires_at,
	        hasUniMicroToken: os.unimicro_has_access_token,
	        uniMicroRefreshExpired: os.unimicro_refresh_expired,
	        unimicroEnvironment: os.unimicro_environment,
	        unimicroInvoiceSeriesId: os.unimicro_invoice_series_id,
	
	        orderConfirmNotificationEmailTitle: os.order_confirm_notification_email_title,
	        orderConfirmNotificationEmailTemplate: os.order_confirm_notification_email_template,
	        orderTrackingEmailTitle: os.order_tracking_email_title,
	        orderTrackingEmailTemplate: os.order_tracking_email_template,
	        penaltyAfter: os.penalty_after,
	        bulkPriceUpdateStatus: os.bulk_price_update_status,
	        bulkPriceUpdateEntries: os.bulk_price_update_entries,
	        receivablesAccountDefaultId: os.receivables_account_default_id != null ? os.receivables_account_default_id : null,
	        incomeAccountDefaultId: os.income_account_default_id != null ? os.income_account_default_id : null,
	        vatAccountDefaultId: os.vat_account_default_id != null ? os.vat_account_default_id : null,
	        depositAccountDefaultId: os.deposit_account_default_id != null ? os.deposit_account_default_id : null
	      };
	    }
	  }, {
	    key: 'sendAccountingAccountDefaults',
	    value: function sendAccountingAccountDefaults(os) {
	      return {
	        receivables_account_default_id: os.receivablesAccountDefaultId != null ? os.receivablesAccountDefaultId : null,
	        income_account_default_id: os.incomeAccountDefaultId != null ? os.incomeAccountDefaultId : null,
	        vat_account_default_id: os.vatAccountDefaultId != null ? os.vatAccountDefaultId : null,
	        deposit_account_default_id: os.depositAccountDefaultId != null ? os.depositAccountDefaultId : null
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(os) {
	      return {
	        billing_number_default: os.billingNumberDefault,
	        sms_from: os.smsFrom,
	        order_number_default: os.orderNumberDefault,
	        customer_number_default: os.customerNumberDefault,
	        invoice_notes: os.invoiceNotes,
	        bill_notes: os.billNotes,
	        credit_note_notes: os.creditNoteNotes,
	        timeslot_gap: os.timeslotGap,
	        reminders_enabled: os.remindersEnabled,
	        default_due_days: os.defaultDueDays,
	        message_template_type_id: os.messageTemplateTypeId,
	        default_edi_product_group_name: os.defaultEdiProductGroupName,
	        default_edi_client_group_name: os.defaultEdiClientGroupName,
	        default_edi_client_name: os.defaultEdiClientName,
	        default_edi_client_contact_phone_number: os.defaultEdiClientContactPhoneNumber,
	        default_edi_client_address_street_name: os.defaultEdiClientAddressStreetName,
	        default_edi_client_address_city_id: os.defaultEdiClientAddressCityId,
	        default_edi_client_address_zipcode: os.defaultEdiClientAddressZipCode,
	        default_edi_tax_percentage: os.defaultEdiTaxPercentage,
	        edi_order_number_default: os.ediOrderNumberDefault,
	        edi_order_delivery_note_number_default: os.ediOrderDeliveryNoteNumberDefault,
	        invoice_email_title: os.invoiceEmailTitle,
	        invoice_email_template: os.invoiceEmailTemplate,
	        credit_note_email_title: os.creditNoteEmailTitle,
	        credit_note_email_template: os.creditNoteEmailTemplate,
	        reminder_email_title: os.reminderEmailTitle,
	        reminder_email_template: os.reminderEmailTemplate,
	        round_invoice_total: os.roundInvoiceTotal,
	        default_client_group_id: os.defaultClientGroupId,
	        tos_accepted: os.tosAccepted,
	        marketing_allowed: os.marketingAllowed,
	        custom_tos: os.customTos,
	        supplier_number_default: os.supplierNumberDefault,
	        product_number_default: os.productNumberDefault,
	        product_number_initial: os.productNumberInitial !== undefined ? os.productNumberInitial.toUpperCase() : '',
	        accounting_provider_id: os.accountingProviderId,
	        product_info_display: os.productInfoDisplay,
	        facebook_pixel_id: os.facebookPixelId,
	        custom_order_product_note: os.customOrderProductNote,
	        edi_billing_process: os.ediBillingProcess,
	        payment_identification_generation: os.paymentIdentitificationGeneration,
	        payment_identification_template: os.paymentIdentitificationTemplate,
	        payment_identification_number_length: os.paymentIdentitificationNumberLength,
	        default_product_type_name: os.defaultProductTypeName,
	        default_shipping_provider: os.defaultShippingProvider,
	        default_warehouse: os.defaultWarehouse,
	        price_fields: os.priceFields,
	        visible_price_fields: os.visiblePriceFields,
	        default_price_field: os.defaultPriceField,
	
	        unimicroClientId: os.unimicro_client_id,
	        unimicroClientSecret: os.unimicro_client_secret,
	        unimicroAccessToken: os.unimicro_access_token,
	        unimicroRefreshToken: os.unimicro_refresh_token,
	        unimicroTokenExpiresAt: os.unimicro_token_expires_at,
	        hasUniMicroToken: os.unimicro_has_access_token,
	        uniMicroRefreshExpired: os.unimicro_refresh_expired,
	        unimicroEnvironment: os.unimicro_environment,
	
	        order_confirm_notification_email_title: os.orderConfirmNotificationEmailTitle,
	        order_confirm_notification_email_template: os.orderConfirmNotificationEmailTemplate,
	        order_tracking_email_title: os.orderTrackingEmailTitle,
	        order_tracking_email_template: os.orderTrackingEmailTemplate,
	        penalty_after: os.penaltyAfter,
	        receivables_account_default_id: os.receivablesAccountDefaultId,
	        income_account_default_id: os.incomeAccountDefaultId,
	        vat_account_default_id: os.vatAccountDefaultId,
	        deposit_account_default_id: os.depositAccountDefaultId
	      };
	    }
	  }]);
	
	  return OrganizationSettingsTransformer;
	}(_transformer2.default);
	
	exports.default = OrganizationSettingsTransformer;

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(938);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _show = __webpack_require__(943);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _store = __webpack_require__(944);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _update = __webpack_require__(945);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _updateRoundInvoiceTotal = __webpack_require__(946);
	
	var _updateRoundInvoiceTotal2 = _interopRequireDefault(_updateRoundInvoiceTotal);
	
	var _destroy = __webpack_require__(936);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _archiveReport = __webpack_require__(932);
	
	var _archiveReport2 = _interopRequireDefault(_archiveReport);
	
	var _generateKID = __webpack_require__(937);
	
	var _generateKID2 = _interopRequireDefault(_generateKID);
	
	var _validateKID = __webpack_require__(947);
	
	var _validateKID2 = _interopRequireDefault(_validateKID);
	
	var _attachmentPdf = __webpack_require__(933);
	
	var _attachmentPdf2 = _interopRequireDefault(_attachmentPdf);
	
	var _markAsPaid = __webpack_require__(939);
	
	var _markAsPaid2 = _interopRequireDefault(_markAsPaid);
	
	var _bulkMarkAsPaid = __webpack_require__(934);
	
	var _bulkMarkAsPaid2 = _interopRequireDefault(_bulkMarkAsPaid);
	
	var _payment = __webpack_require__(940);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _sendReminder = __webpack_require__(941);
	
	var _sendReminder2 = _interopRequireDefault(_sendReminder);
	
	var _sendReminderPreview = __webpack_require__(942);
	
	var _sendReminderPreview2 = _interopRequireDefault(_sendReminderPreview);
	
	var _createReminder = __webpack_require__(935);
	
	var _createReminder2 = _interopRequireDefault(_createReminder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  items: _items2.default,
	  store: _store2.default,
	  destroy: _destroy2.default,
	  show: _show2.default,
	  update: _update2.default,
	  updateRoundInvoiceTotal: _updateRoundInvoiceTotal2.default,
	  archiveReport: _archiveReport2.default,
	  generateKID: _generateKID2.default,
	  validateKID: _validateKID2.default,
	  attachmentPdf: _attachmentPdf2.default,
	  markAsPaid: _markAsPaid2.default,
	  bulkMarkAsPaid: _bulkMarkAsPaid2.default,
	  payment: _payment2.default,
	  sendReminder: _sendReminder2.default,
	  sendReminderPreview: _sendReminderPreview2.default,
	  createReminder: _createReminder2.default
	};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(973);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(454);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _destroy = __webpack_require__(974);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(976);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(975);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(977);
	
	var _update2 = _interopRequireDefault(_update);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  items: _items2.default,
	  destroy: _destroy2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default
	};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1037);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _packaging = __webpack_require__(1039);
	
	var _packaging2 = _interopRequireDefault(_packaging);
	
	var _basic = __webpack_require__(1038);
	
	var _basic2 = _interopRequireDefault(_basic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  packaging: _packaging2.default,
	  basic: _basic2.default
	};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(1173);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _store = __webpack_require__(1175);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1174);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1176);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _all = __webpack_require__(1172);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  items: _items2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  all: _all2.default
	};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1204);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _destroy = __webpack_require__(1289);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(1291);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1290);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1292);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _all = __webpack_require__(480);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warehouseShippingProvider = __webpack_require__(1293);
	
	var _warehouseShippingProvider2 = _interopRequireDefault(_warehouseShippingProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  destroy: _destroy2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  all: _all2.default,
	  warehouseShippingProvider: _warehouseShippingProvider2.default
	};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fetchAvailableWidgets = __webpack_require__(1366);
	
	var _fetchAvailableWidgets2 = _interopRequireDefault(_fetchAvailableWidgets);
	
	var _fetchUserWidgets = __webpack_require__(489);
	
	var _fetchUserWidgets2 = _interopRequireDefault(_fetchUserWidgets);
	
	var _updateUserWidgets = __webpack_require__(1374);
	
	var _updateUserWidgets2 = _interopRequireDefault(_updateUserWidgets);
	
	var _fetchBestClientsWidgets = __webpack_require__(1367);
	
	var _fetchBestClientsWidgets2 = _interopRequireDefault(_fetchBestClientsWidgets);
	
	var _fetchWaitingProcessedWidgets = __webpack_require__(1373);
	
	var _fetchWaitingProcessedWidgets2 = _interopRequireDefault(_fetchWaitingProcessedWidgets);
	
	var _fetchWaitingDeliveredWidgets = __webpack_require__(1372);
	
	var _fetchWaitingDeliveredWidgets2 = _interopRequireDefault(_fetchWaitingDeliveredWidgets);
	
	var _fetchOrderReceivedWidgets = __webpack_require__(1368);
	
	var _fetchOrderReceivedWidgets2 = _interopRequireDefault(_fetchOrderReceivedWidgets);
	
	var _fetchRevenueWidgets = __webpack_require__(1370);
	
	var _fetchRevenueWidgets2 = _interopRequireDefault(_fetchRevenueWidgets);
	
	var _fetchPopularProductsWidgets = __webpack_require__(1369);
	
	var _fetchPopularProductsWidgets2 = _interopRequireDefault(_fetchPopularProductsWidgets);
	
	var _fetchSoldProductsWidgets = __webpack_require__(1371);
	
	var _fetchSoldProductsWidgets2 = _interopRequireDefault(_fetchSoldProductsWidgets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchAvailableWidgets: _fetchAvailableWidgets2.default,
	  fetchUserWidgets: _fetchUserWidgets2.default,
	  updateUserWidgets: _updateUserWidgets2.default,
	  fetchBestClientsWidgets: _fetchBestClientsWidgets2.default,
	  fetchWaitingProcessedWidgets: _fetchWaitingProcessedWidgets2.default,
	  fetchWaitingDeliveredWidgets: _fetchWaitingDeliveredWidgets2.default,
	  fetchOrderReceivedWidgets: _fetchOrderReceivedWidgets2.default,
	  fetchRevenueWidgets: _fetchRevenueWidgets2.default,
	  fetchPopularProductsWidgets: _fetchPopularProductsWidgets2.default,
	  fetchSoldProductsWidgets: _fetchSoldProductsWidgets2.default
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreditNoteProductTransformer = function (_Transformer) {
	  _inherits(CreditNoteProductTransformer, _Transformer);
	
	  function CreditNoteProductTransformer() {
	    _classCallCheck(this, CreditNoteProductTransformer);
	
	    return _possibleConstructorReturn(this, (CreditNoteProductTransformer.__proto__ || Object.getPrototypeOf(CreditNoteProductTransformer)).apply(this, arguments));
	  }
	
	  _createClass(CreditNoteProductTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(creditNoteProduct) {
	      var product = [];
	      if (creditNoteProduct.product) {
	        product = _product2.default.fetch(creditNoteProduct.product);
	      }
	      var data = Object.assign(product, {
	        id: creditNoteProduct.id,
	        orderProductId: creditNoteProduct.order_product_id,
	        billProductId: creditNoteProduct.bill_product_id,
	        orderProduct: creditNoteProduct.order_product,
	        billProduct: creditNoteProduct.bill_product,
	        orderProductDeposit: creditNoteProduct.order_product_deposit,
	        productDepositId: creditNoteProduct.product_deposit_id,
	        billId: creditNoteProduct.bill_id,
	        taxId: creditNoteProduct.tax_id,
	        taxPercentage: creditNoteProduct.tax_percentage,
	        quantity: creditNoteProduct.quantity,
	        price: creditNoteProduct.price,
	        discount: creditNoteProduct.discount,
	        billNote: creditNoteProduct.bill_note,
	        refNumber: creditNoteProduct.ref_number,
	        refId: creditNoteProduct.ref_id,
	        refType: creditNoteProduct.ref_type,
	        exceedCreditnoteAmount: creditNoteProduct.exceed_creditnote_amount
	      });
	      return data;
	    }
	  }, {
	    key: 'send',
	    value: function send(creditNoteProduct) {
	      return {
	        id: creditNoteProduct.id,
	        price: creditNoteProduct.price,
	        order_product_id: creditNoteProduct.orderProductId,
	        bill_product_id: creditNoteProduct.billProductId,
	        order_product: creditNoteProduct.orderProduct,
	        product_deposit_id: creditNoteProduct.productDepositId,
	        bill_product: creditNoteProduct.billProduct,
	        bill_id: creditNoteProduct.billId,
	        quantity: creditNoteProduct.quantity,
	        discount: creditNoteProduct.discount,
	        tax_id: creditNoteProduct.taxId
	      };
	    }
	  }]);
	
	  return CreditNoteProductTransformer;
	}(_transformer2.default);
	
	exports.default = CreditNoteProductTransformer;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecipeTransformer = function (_Transformer) {
	  _inherits(RecipeTransformer, _Transformer);
	
	  function RecipeTransformer() {
	    _classCallCheck(this, RecipeTransformer);
	
	    return _possibleConstructorReturn(this, (RecipeTransformer.__proto__ || Object.getPrototypeOf(RecipeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(RecipeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(recipe) {
	      return {
	        id: recipe.id,
	        organizationId: recipe.organization_id,
	        recipeTypeId: recipe.recipe_type_id,
	        recipeType: recipe.recipe_type,
	        name: recipe.name,
	        notes: recipe.notes,
	        isActive: recipe.is_active,
	        ingrediences: recipe.ingrediences,
	        procedures: recipe.procedures,
	        products: recipe.products
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(recipe) {
	      return {
	        id: recipe.id,
	        organization_id: recipe.organizationId,
	        recipe_type_id: recipe.recipeTypeId,
	        name: recipe.name,
	        notes: recipe.notes,
	        is_active: recipe.isActive
	      };
	    }
	  }]);
	
	  return RecipeTransformer;
	}(_transformer2.default);
	
	exports.default = RecipeTransformer;

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: {
	    formatDate: function formatDate(date) {
	      return (0, _moment2.default)(date).format('DD-MM-YYYY');
	    },
	    formatDateWithTime: function formatDateWithTime(date) {
	      return (0, _moment2.default)(date).format('DD-MM-YYYY HH:mm:ss');
	    },
	    formatDateLong: function formatDateLong(date) {
	      return (0, _moment2.default)(date).format('LL');
	    },
	    isValidDate: function isValidDate(date) {
	      return (0, _moment2.default)(date).isValid();
	    }
	  }
	};

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    camelize: function camelize(str) {
	      if (!str) return '';
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  }
	};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsTransformer = function (_Transformer) {
	  _inherits(NewsTransformer, _Transformer);
	
	  function NewsTransformer() {
	    _classCallCheck(this, NewsTransformer);
	
	    return _possibleConstructorReturn(this, (NewsTransformer.__proto__ || Object.getPrototypeOf(NewsTransformer)).apply(this, arguments));
	  }
	
	  _createClass(NewsTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(news) {
	      return {
	        id: news.id,
	        subject: news.subject,
	        body: news.body,
	        sent: news.sent,
	        sendAfterDate: news.send_after_date,
	        sendAfter: news.send_after,
	        newsCampaignId: news.news_campaign_id,
	        newsStatusId: news.news_status_id,
	        status: news.status,
	        emailSendTracking: news.email_send_tracking,
	        sentSuccess: news.sent_success,
	        sentFailed: news.sent_failed,
	        testEmail: news.custom_test_email,
	        htmlEmail: news.html_email
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(news) {
	      return {
	        id: news.id,
	        subject: news.subject,
	        body: news.body,
	        send_after_date: news.sendAfterDate,
	        campaign_type: news.campaignType,
	        send_after: news.sendAfter,
	        news_campaign_id: news.newsCampaignId,
	        news_status_id: news.newsStatusId,
	        custom_test_email: news.testEmail,
	        test_email_check: news.testEmailCheck,
	        html_email: news.htmlEmail
	      };
	    }
	  }]);
	
	  return NewsTransformer;
	}(_transformer2.default);
	
	exports.default = NewsTransformer;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductGroupTransformer = function (_Transformer) {
	  _inherits(ProductGroupTransformer, _Transformer);
	
	  function ProductGroupTransformer() {
	    _classCallCheck(this, ProductGroupTransformer);
	
	    return _possibleConstructorReturn(this, (ProductGroupTransformer.__proto__ || Object.getPrototypeOf(ProductGroupTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductGroupTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(productGroup) {
	      return {
	        id: productGroup.id,
	        parentGroupId: productGroup.parent_group_id,
	        name: productGroup.name,
	        description: productGroup.description,
	        productsCount: productGroup.products_count,
	        exciseDutyId: productGroup.excise_group_id
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(productGroup) {
	      return {
	        id: productGroup.id,
	        name: productGroup.name,
	        parent_group_id: productGroup.parentGroupId,
	        description: productGroup.description,
	        excise_group_id: productGroup.exciseDutyId
	      };
	    }
	  }]);
	
	  return ProductGroupTransformer;
	}(_transformer2.default);
	
	exports.default = ProductGroupTransformer;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecipeIngredienceTransformer = function (_Transformer) {
	  _inherits(RecipeIngredienceTransformer, _Transformer);
	
	  function RecipeIngredienceTransformer() {
	    _classCallCheck(this, RecipeIngredienceTransformer);
	
	    return _possibleConstructorReturn(this, (RecipeIngredienceTransformer.__proto__ || Object.getPrototypeOf(RecipeIngredienceTransformer)).apply(this, arguments));
	  }
	
	  _createClass(RecipeIngredienceTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(recipeIngredience) {
	      return {
	        id: recipeIngredience.id,
	        recipeId: recipeIngredience.recipe_id,
	        recipe: recipeIngredience.recipe,
	        materialId: recipeIngredience.material_id,
	        materialName: recipeIngredience.material_name,
	        materialType: recipeIngredience.material_type,
	        unitMeasure: recipeIngredience.unit_measure,
	        amount: recipeIngredience.amount
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(recipeIngredience) {
	      return {
	        id: recipeIngredience.id,
	        recipe_id: recipeIngredience.recipeId,
	        material_id: recipeIngredience.materialId,
	        amount: recipeIngredience.amount
	      };
	    }
	  }]);
	
	  return RecipeIngredienceTransformer;
	}(_transformer2.default);
	
	exports.default = RecipeIngredienceTransformer;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _supplierContact = __webpack_require__(1709);
	
	var _supplierContact2 = _interopRequireDefault(_supplierContact);
	
	var _supplierAddress = __webpack_require__(1708);
	
	var _supplierAddress2 = _interopRequireDefault(_supplierAddress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SupplierTransformer = function (_Transformer) {
	  _inherits(SupplierTransformer, _Transformer);
	
	  function SupplierTransformer() {
	    _classCallCheck(this, SupplierTransformer);
	
	    return _possibleConstructorReturn(this, (SupplierTransformer.__proto__ || Object.getPrototypeOf(SupplierTransformer)).apply(this, arguments));
	  }
	
	  _createClass(SupplierTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(supplier) {
	      return {
	        id: supplier.id,
	        name: supplier.name,
	        code: supplier.code,
	        number: supplier.number,
	        address: supplier.address !== undefined ? _supplierAddress2.default.fetch(supplier.address) : [],
	        contact: supplier.contact !== undefined ? _supplierContact2.default.fetch(supplier.contact) : []
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(supplier) {
	      return {
	        id: supplier.id,
	        name: supplier.name,
	        code: supplier.code,
	        number: supplier.number,
	        email: supplier.email,
	        street_name_1: supplier.streetName1,
	        street_name_2: supplier.streetName2,
	        country_id: supplier.countryId,
	        city: supplier.city,
	        postal_code: supplier.postalCode,
	        phonenumber: supplier.phonenumber,
	        mobilenumber: supplier.mobilenumber
	      };
	    }
	  }]);
	
	  return SupplierTransformer;
	}(_transformer2.default);
	
	exports.default = SupplierTransformer;

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2326)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1749),
	  /* template */
	  __webpack_require__(3010),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2366)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1834),
	  /* template */
	  __webpack_require__(3070),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 124 */,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1074);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(1075);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _store = __webpack_require__(1077);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1076);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1078);
	
	var _update2 = _interopRequireDefault(_update);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  items: _items2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default
	};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(471);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _destroy = __webpack_require__(1212);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(1214);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1213);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1215);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _all = __webpack_require__(1211);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  items: _items2.default,
	  destroy: _destroy2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  all: _all2.default
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _destroy = __webpack_require__(1325);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(1327);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1326);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1328);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _all = __webpack_require__(1323);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(484);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _counts = __webpack_require__(1324);
	
	var _counts2 = _interopRequireDefault(_counts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  destroy: _destroy2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  all: _all2.default,
	  items: _items2.default,
	  counts: _counts2.default
	};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1329);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientGroupTransformer = function (_Transformer) {
	  _inherits(ClientGroupTransformer, _Transformer);
	
	  function ClientGroupTransformer() {
	    _classCallCheck(this, ClientGroupTransformer);
	
	    return _possibleConstructorReturn(this, (ClientGroupTransformer.__proto__ || Object.getPrototypeOf(ClientGroupTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ClientGroupTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(clientGroup) {
	      return {
	        id: clientGroup.id,
	        name: clientGroup.name,
	        description: clientGroup.description,
	        clientsCount: clientGroup.clients_count,
	        priceFieldId: clientGroup.price_field_id,
	        receivables_account_id: clientGroup.receivables_account_id
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(clientGroup) {
	      return {
	        id: clientGroup.id,
	        name: clientGroup.name,
	        description: clientGroup.description,
	        price_field_id: clientGroup.priceFieldId,
	        receivables_account_id: clientGroup.receivables_account_id
	      };
	    }
	  }]);
	
	  return ClientGroupTransformer;
	}(_transformer2.default);
	
	exports.default = ClientGroupTransformer;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EquipmentTransformer = function (_Transformer) {
	  _inherits(EquipmentTransformer, _Transformer);
	
	  function EquipmentTransformer() {
	    _classCallCheck(this, EquipmentTransformer);
	
	    return _possibleConstructorReturn(this, (EquipmentTransformer.__proto__ || Object.getPrototypeOf(EquipmentTransformer)).apply(this, arguments));
	  }
	
	  _createClass(EquipmentTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(equipment) {
	      return {
	        id: equipment.id,
	        organizationId: equipment.organization_id,
	        name: equipment.name,
	        isActive: equipment.is_active
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(equipment) {
	      return {
	        id: equipment.id,
	        name: equipment.name,
	        is_active: equipment.isActive
	      };
	    }
	  }]);
	
	  return EquipmentTransformer;
	}(_transformer2.default);
	
	exports.default = EquipmentTransformer;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MaterialTransformer = function (_Transformer) {
	  _inherits(MaterialTransformer, _Transformer);
	
	  function MaterialTransformer() {
	    _classCallCheck(this, MaterialTransformer);
	
	    return _possibleConstructorReturn(this, (MaterialTransformer.__proto__ || Object.getPrototypeOf(MaterialTransformer)).apply(this, arguments));
	  }
	
	  _createClass(MaterialTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(material) {
	      return {
	        id: material.id,
	        organizationId: material.organization_id,
	        materialTypeId: material.material_type_id,
	        materialType: material.material_type,
	        unitMeasureId: material.unit_measure_id,
	        unitMeasure: material.unit_measure,
	        supplierId: material.supplier_id,
	        name: material.name,
	        description: material.description,
	        isActive: material.is_active,
	        minimumStockLevel: material.minimum_stock_level
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(material) {
	      return {
	        id: material.id,
	        organization_id: material.organizationId,
	        material_type_id: material.materialTypeId,
	        unit_measure_id: material.unitMeasureId,
	        supplier_id: material.supplierId,
	        name: material.name,
	        description: material.description,
	        is_active: material.isActive,
	        minimum_stock_level: material.minimumStockLevel
	      };
	    }
	  }]);
	
	  return MaterialTransformer;
	}(_transformer2.default);
	
	exports.default = MaterialTransformer;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PriceFieldTransformer = function (_Transformer) {
	  _inherits(PriceFieldTransformer, _Transformer);
	
	  function PriceFieldTransformer() {
	    _classCallCheck(this, PriceFieldTransformer);
	
	    return _possibleConstructorReturn(this, (PriceFieldTransformer.__proto__ || Object.getPrototypeOf(PriceFieldTransformer)).apply(this, arguments));
	  }
	
	  _createClass(PriceFieldTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(model) {
	      return {
	        id: model.id,
	        field: model.field,
	        name: model.name,
	        organizationId: model.organization_id,
	        exclusiveToPlan: model.exclusive_to_plans
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(model) {
	      return {
	        id: model.id,
	        field: model.field
	      };
	    }
	  }]);
	
	  return PriceFieldTransformer;
	}(_transformer2.default);
	
	exports.default = PriceFieldTransformer;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductFlowTransformer = function (_Transformer) {
	  _inherits(ProductFlowTransformer, _Transformer);
	
	  function ProductFlowTransformer() {
	    _classCallCheck(this, ProductFlowTransformer);
	
	    return _possibleConstructorReturn(this, (ProductFlowTransformer.__proto__ || Object.getPrototypeOf(ProductFlowTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductFlowTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(productFlow) {
	      return {
	        id: productFlow.id,
	        title: productFlow.title,
	        orderId: productFlow.order_id,
	        descriptions: productFlow.descriptions,
	        productId: productFlow.product_id,
	        qty: productFlow.qty,
	        orderNumber: productFlow.order.number,
	        productName: productFlow.product.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(productFlow) {
	      return {
	        id: productFlow.id,
	        title: productFlow.title,
	        order_id: productFlow.orderId,
	        product_id: productFlow.productId,
	        descriptions: productFlow.descriptions,
	        qty: productFlow.qty
	      };
	    }
	  }]);
	
	  return ProductFlowTransformer;
	}(_transformer2.default);
	
	exports.default = ProductFlowTransformer;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductPackagingTransformer = function (_Transformer) {
	  _inherits(ProductPackagingTransformer, _Transformer);
	
	  function ProductPackagingTransformer() {
	    _classCallCheck(this, ProductPackagingTransformer);
	
	    return _possibleConstructorReturn(this, (ProductPackagingTransformer.__proto__ || Object.getPrototypeOf(ProductPackagingTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductPackagingTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(productPackaging) {
	      return {
	        id: productPackaging.id,
	        name: productPackaging.name,
	        volume: productPackaging.volume,
	        qtyInCrate: productPackaging.qty_in_crate,
	        packagingTypeId: productPackaging.packaging_type_id,
	        packagingMaterialId: productPackaging.packaging_material_id,
	        materialId: productPackaging.material_id,
	        crateMaterialId: productPackaging.crate_material_id,
	        productDepositId: productPackaging.product_deposit_id,
	        depositSystemId: productPackaging.deposit_system_id,
	        exciseBasicGroup: productPackaging.excise_basic_group,
	        excisePackagingGroup: productPackaging.excise_packaging_group,
	        overrideProducts: productPackaging.override_products,
	        productsCount: productPackaging.products_count
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(productPackaging) {
	      return {
	        id: productPackaging.id,
	        name: productPackaging.name,
	        volume: productPackaging.volume,
	        qty_in_crate: productPackaging.qtyInCrate,
	        packaging_type_id: productPackaging.packagingTypeId,
	        packaging_material_id: productPackaging.packagingMaterialId,
	        material_id: productPackaging.materialId ? productPackaging.materialId : null,
	        crate_material_id: productPackaging.crateMaterialId ? productPackaging.crateMaterialId : null,
	        excise_basic_group: productPackaging.exciseBasicGroup ? productPackaging.exciseBasicGroup : null,
	        excise_packaging_group: productPackaging.excisePackagingGroup ? productPackaging.excisePackagingGroup : null,
	        deposit_system_id: productPackaging.depositSystemId ? productPackaging.depositSystemId : null,
	        product_deposit_id: productPackaging.productDepositId ? productPackaging.productDepositId : null,
	        override_products: productPackaging.overrideProducts
	      };
	    }
	  }]);
	
	  return ProductPackagingTransformer;
	}(_transformer2.default);
	
	exports.default = ProductPackagingTransformer;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductTagTransformer = function (_Transformer) {
	  _inherits(ProductTagTransformer, _Transformer);
	
	  function ProductTagTransformer() {
	    _classCallCheck(this, ProductTagTransformer);
	
	    return _possibleConstructorReturn(this, (ProductTagTransformer.__proto__ || Object.getPrototypeOf(ProductTagTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductTagTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(model) {
	      return {
	        id: model.id,
	        tag: model.tag,
	        productCount: model.product_count
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(model) {
	      return {
	        id: model.id,
	        tag: model.tag
	      };
	    }
	  }]);
	
	  return ProductTagTransformer;
	}(_transformer2.default);
	
	exports.default = ProductTagTransformer;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecipeProcedureTransformer = function (_Transformer) {
	  _inherits(RecipeProcedureTransformer, _Transformer);
	
	  function RecipeProcedureTransformer() {
	    _classCallCheck(this, RecipeProcedureTransformer);
	
	    return _possibleConstructorReturn(this, (RecipeProcedureTransformer.__proto__ || Object.getPrototypeOf(RecipeProcedureTransformer)).apply(this, arguments));
	  }
	
	  _createClass(RecipeProcedureTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(recipeProcedure) {
	      return {
	        id: recipeProcedure.id,
	        name: recipeProcedure.name,
	        step: recipeProcedure.step,
	        recipeId: recipeProcedure.recipe_id,
	        recipe: recipeProcedure.recipe,
	        procedureId: recipeProcedure.procedure_id,
	        procedure: recipeProcedure.procedure,
	        equipmentId: recipeProcedure.equipment_id,
	        equipment: recipeProcedure.equipment,
	        status: recipeProcedure.status,
	        dateStart: recipeProcedure.date_start,
	        dateEnd: recipeProcedure.date_end,
	        ingrediences: recipeProcedure.ingrediences,
	        notes: recipeProcedure.notes
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(recipeProcedure) {
	      return {
	        id: recipeProcedure.id,
	        name: recipeProcedure.name,
	        step: recipeProcedure.step,
	        recipe_id: recipeProcedure.recipeId,
	        procedure_id: recipeProcedure.procedureId,
	        equipment_id: recipeProcedure.equipmentId,
	        ingredience_ids: recipeProcedure.ingredienceIds,
	        notes: recipeProcedure.notes
	      };
	    }
	  }]);
	
	  return RecipeProcedureTransformer;
	}(_transformer2.default);
	
	exports.default = RecipeProcedureTransformer;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnitOfMeasureTransformer = function (_Transformer) {
	  _inherits(UnitOfMeasureTransformer, _Transformer);
	
	  function UnitOfMeasureTransformer() {
	    _classCallCheck(this, UnitOfMeasureTransformer);
	
	    return _possibleConstructorReturn(this, (UnitOfMeasureTransformer.__proto__ || Object.getPrototypeOf(UnitOfMeasureTransformer)).apply(this, arguments));
	  }
	
	  _createClass(UnitOfMeasureTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(unitOfMeasure) {
	      return {
	        id: unitOfMeasure.id,
	        name: unitOfMeasure.name,
	        code: unitOfMeasure.code
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(unitOfMeasure) {
	      return {
	        id: unitOfMeasure.id,
	        name: unitOfMeasure.name,
	        code: unitOfMeasure.code
	      };
	    }
	  }]);
	
	  return UnitOfMeasureTransformer;
	}(_transformer2.default);
	
	exports.default = UnitOfMeasureTransformer;

/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1790),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 157 */,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _organizationSettings = __webpack_require__(83);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  _store2.default.dispatch('getOrganizationSettings', _organizationSettings2.default.fetch(data));
	
	  resolve(_organizationSettings2.default.fetch(data));
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('organization_settings').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _find = __webpack_require__(1168);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _all = __webpack_require__(1166);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _fetchSuggestions = __webpack_require__(1167);
	
	var _fetchSuggestions2 = _interopRequireDefault(_fetchSuggestions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  find: _find2.default,
	  all: _all2.default,
	  fetchSuggestions: _fetchSuggestions2.default
	};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(468);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _destroy = __webpack_require__(1180);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(1182);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1181);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1183);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _all = __webpack_require__(1179);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  items: _items2.default,
	  destroy: _destroy2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  all: _all2.default
	};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _destroy = __webpack_require__(1233);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(1244);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1240);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1246);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _all = __webpack_require__(1232);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(475);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _markAsDone = __webpack_require__(1237);
	
	var _markAsDone2 = _interopRequireDefault(_markAsDone);
	
	var _saveAsDraft = __webpack_require__(1238);
	
	var _saveAsDraft2 = _interopRequireDefault(_saveAsDraft);
	
	var _showPurchaseEmailInformation = __webpack_require__(1242);
	
	var _showPurchaseEmailInformation2 = _interopRequireDefault(_showPurchaseEmailInformation);
	
	var _download = __webpack_require__(1235);
	
	var _download2 = _interopRequireDefault(_download);
	
	var _showPdf = __webpack_require__(1241);
	
	var _showPdf2 = _interopRequireDefault(_showPdf);
	
	var _send = __webpack_require__(1239);
	
	var _send2 = _interopRequireDefault(_send);
	
	var _unfinished = __webpack_require__(1245);
	
	var _unfinished2 = _interopRequireDefault(_unfinished);
	
	var _showUnfinished = __webpack_require__(1243);
	
	var _showUnfinished2 = _interopRequireDefault(_showUnfinished);
	
	var _destroyUnfinished = __webpack_require__(1234);
	
	var _destroyUnfinished2 = _interopRequireDefault(_destroyUnfinished);
	
	var _markAsCancel = __webpack_require__(1236);
	
	var _markAsCancel2 = _interopRequireDefault(_markAsCancel);
	
	var _updateDraft = __webpack_require__(1247);
	
	var _updateDraft2 = _interopRequireDefault(_updateDraft);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  destroy: _destroy2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  all: _all2.default,
	  items: _items2.default,
	  saveAsDraft: _saveAsDraft2.default,
	  markAsDone: _markAsDone2.default,
	  showPurchaseEmailInformation: _showPurchaseEmailInformation2.default,
	  download: _download2.default,
	  showPdf: _showPdf2.default,
	  send: _send2.default,
	  unfinished: _unfinished2.default,
	  showUnfinished: _showUnfinished2.default,
	  destroyUnfinished: _destroyUnfinished2.default,
	  markAsCancel: _markAsCancel2.default,
	  updateDraft: _updateDraft2.default
	};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _destroy = __webpack_require__(1300);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(1304);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1303);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1305);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _all = __webpack_require__(1299);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(482);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _warehouseProduct = __webpack_require__(1307);
	
	var _warehouseProduct2 = _interopRequireDefault(_warehouseProduct);
	
	var _warehouseProducts = __webpack_require__(1308);
	
	var _warehouseProducts2 = _interopRequireDefault(_warehouseProducts);
	
	var _downloadProduct = __webpack_require__(1301);
	
	var _downloadProduct2 = _interopRequireDefault(_downloadProduct);
	
	var _updateDraft = __webpack_require__(1306);
	
	var _updateDraft2 = _interopRequireDefault(_updateDraft);
	
	var _saveDraft = __webpack_require__(1302);
	
	var _saveDraft2 = _interopRequireDefault(_saveDraft);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  destroy: _destroy2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  all: _all2.default,
	  items: _items2.default,
	  warehouseProduct: _warehouseProduct2.default,
	  warehouseProducts: _warehouseProducts2.default,
	  downloadProduct: _downloadProduct2.default,
	  updateDraft: _updateDraft2.default,
	  saveDraft: _saveDraft2.default
	};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CampaignTransformer = function (_Transformer) {
	  _inherits(CampaignTransformer, _Transformer);
	
	  function CampaignTransformer() {
	    _classCallCheck(this, CampaignTransformer);
	
	    return _possibleConstructorReturn(this, (CampaignTransformer.__proto__ || Object.getPrototypeOf(CampaignTransformer)).apply(this, arguments));
	  }
	
	  _createClass(CampaignTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(campaign) {
	      return {
	        id: campaign.id,
	        name: campaign.name,
	        description: campaign.description,
	        campaignTypeId: campaign.campaign_type_id,
	        campaignType: campaign.campaign_type,
	        newsSubscriberListId: campaign.news_subscriber_list_id,
	        newsSubscriberList: campaign.news_subscriber_list,
	        createdAt: campaign.created_at
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(campaign) {
	      return {
	        name: campaign.name,
	        description: campaign.description,
	        campaign_type_id: campaign.campaignTypeId,
	        news_subscriber_list_id: campaign.newsSubscriberListId
	      };
	    }
	  }]);
	
	  return CampaignTransformer;
	}(_transformer2.default);
	
	exports.default = CampaignTransformer;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderProductTransformer = function (_Transformer) {
	  _inherits(OrderProductTransformer, _Transformer);
	
	  function OrderProductTransformer() {
	    _classCallCheck(this, OrderProductTransformer);
	
	    return _possibleConstructorReturn(this, (OrderProductTransformer.__proto__ || Object.getPrototypeOf(OrderProductTransformer)).apply(this, arguments));
	  }
	
	  _createClass(OrderProductTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(orderProduct) {
	      var product = _product2.default.fetch(orderProduct.product);
	      var data = Object.assign(product, {
	        id: orderProduct.id,
	        orderId: orderProduct.order_id,
	        name: orderProduct.name,
	        note: orderProduct.note,
	        billNote: orderProduct.note,
	        productId: orderProduct.product_id,
	        batchId: orderProduct.batch_id,
	        batchName: orderProduct.batch_name,
	        taxId: orderProduct.tax_id,
	        taxPercentage: orderProduct.tax_percentage,
	        description: orderProduct.description,
	        price: orderProduct.price,
	        quantity: orderProduct.quantity,
	        available: orderProduct.available,
	        discount: orderProduct.discount,
	        total: orderProduct.total,
	        totalTax: orderProduct.total_tax,
	        ediOrderItemId: orderProduct.edi_order_item_id,
	        quantityOrdered: orderProduct.quantity_ordered,
	        quantityConfirmed: orderProduct.quantity_confirmed,
	        quantityReceived: orderProduct.quantity_received,
	        quantityPacked: orderProduct.quantity_packed,
	        quantityUnpacked: orderProduct.quantity_unpacked,
	        productDeposit: orderProduct.product_deposit,
	        productDepositId: orderProduct.product_deposit_id,
	        returnCode: orderProduct.return_code,
	        returnCodeDescription: orderProduct.return_code_description,
	        gtin: orderProduct.gtin,
	        batchIds: orderProduct.batch_ids,
	        warehouseTransactions: orderProduct.warehouse_transactions,
	        unitTypeId: orderProduct.unit_type_id,
	        unitQuantity: orderProduct.unit_quantity || '',
	        bundleGroupId: orderProduct.bundle_group_id || '',
	        prevOrderProductPackage: orderProduct.prev_order_product_package
	      });
	      return data;
	    }
	  }, {
	    key: 'send',
	    value: function send(orderProduct) {
	      return {
	        id: orderProduct.id,
	        name: orderProduct.name,
	        note: orderProduct.note,
	        product_id: orderProduct.productId,
	        batch_id: orderProduct.batchId,
	        tax_id: orderProduct.taxId,
	        description: orderProduct.description,
	        price: orderProduct.price,
	        quantity: orderProduct.quantity,
	        discount: orderProduct.discount,
	        total: orderProduct.total,
	        total_tax: orderProduct.totalTax,
	        edi_order_item_id: orderProduct.ediOrderItemId,
	        quantity_confirmed: orderProduct.quantityConfirmed,
	        quantity_received: orderProduct.quantityReceived,
	        product_deposit_id: orderProduct.productDepositId,
	        batch_ids: orderProduct.batchIds,
	        unit_type_id: orderProduct.unitTypeId,
	        unit_quantity: orderProduct.unitQuantity
	      };
	    }
	  }]);
	
	  return OrderProductTransformer;
	}(_transformer2.default);
	
	exports.default = OrderProductTransformer;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubscriberListTransformer = function (_Transformer) {
	  _inherits(SubscriberListTransformer, _Transformer);
	
	  function SubscriberListTransformer() {
	    _classCallCheck(this, SubscriberListTransformer);
	
	    return _possibleConstructorReturn(this, (SubscriberListTransformer.__proto__ || Object.getPrototypeOf(SubscriberListTransformer)).apply(this, arguments));
	  }
	
	  _createClass(SubscriberListTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(subscriberList) {
	      return {
	        id: subscriberList.id,
	        name: subscriberList.name,
	        fromName: subscriberList.fromName,
	        fromEmail: subscriberList.fromEmail,
	        description: subscriberList.description,
	        doubleOptinRequired: subscriberList.doubleOptinRequired,
	        optinEmailSubject: subscriberList.optinEmailSubject,
	        optinEmailBody: subscriberList.optinEmailBody,
	        emailCount: subscriberList.email_count
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(subscriberList) {
	      return {
	        name: subscriberList.name,
	        fromName: subscriberList.fromName,
	        fromEmail: subscriberList.fromEmail,
	        description: subscriberList.description,
	        doubleOptinRequired: subscriberList.doubleOptinRequired,
	        optinEmailSubject: subscriberList.optinEmailSubject,
	        optinEmailBody: subscriberList.optinEmailBody
	      };
	    }
	  }]);
	
	  return SubscriberListTransformer;
	}(_transformer2.default);
	
	exports.default = SubscriberListTransformer;

/***/ }),
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/kundan-logo.8958aa6.png";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1802),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(452);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _store = __webpack_require__(966);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(965);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(967);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _destroy = __webpack_require__(964);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  items: _items2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  destroy: _destroy2.default
	};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(293);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _createCoa = __webpack_require__(969);
	
	var _createCoa2 = _interopRequireDefault(_createCoa);
	
	var _store = __webpack_require__(971);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _update = __webpack_require__(972);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _destroy = __webpack_require__(970);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  createCoa: _createCoa2.default,
	  store: _store2.default,
	  update: _update2.default,
	  destroy: _destroy2.default
	};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(1023);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _show = __webpack_require__(1026);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _confirm = __webpack_require__(1020);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _bulkConfirm = __webpack_require__(1016);
	
	var _bulkConfirm2 = _interopRequireDefault(_bulkConfirm);
	
	var _cancel = __webpack_require__(1019);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	var _process = __webpack_require__(1025);
	
	var _process2 = _interopRequireDefault(_process);
	
	var _bulkProcess = __webpack_require__(1018);
	
	var _bulkProcess2 = _interopRequireDefault(_bulkProcess);
	
	var _bulkConfirmAndShipping = __webpack_require__(1017);
	
	var _bulkConfirmAndShipping2 = _interopRequireDefault(_bulkConfirmAndShipping);
	
	var _invoice = __webpack_require__(1022);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	var _linkOrder = __webpack_require__(1024);
	
	var _linkOrder2 = _interopRequireDefault(_linkOrder);
	
	var _creditNote = __webpack_require__(1021);
	
	var _creditNote2 = _interopRequireDefault(_creditNote);
	
	var _all = __webpack_require__(1015);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  items: _items2.default,
	  show: _show2.default,
	  confirm: _confirm2.default,
	  bulkConfirm: _bulkConfirm2.default,
	  cancel: _cancel2.default,
	  process: _process2.default,
	  bulkProcess: _bulkProcess2.default,
	  bulkConfirmAndShipping: _bulkConfirmAndShipping2.default,
	  invoice: _invoice2.default,
	  creditNote: _creditNote2.default,
	  all: _all2.default,
	  linkOrder: _linkOrder2.default
	};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1149);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(1153);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _update = __webpack_require__(1154);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _destroy = __webpack_require__(1150);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _show = __webpack_require__(1151);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _showMixPallet = __webpack_require__(1152);
	
	var _showMixPallet2 = _interopRequireDefault(_showMixPallet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  store: _store2.default,
	  update: _update2.default,
	  destroy: _destroy2.default,
	  show: _show2.default,
	  showMixPallet: _showMixPallet2.default
	};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(1158);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _all = __webpack_require__(1155);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _update = __webpack_require__(1159);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _destroy = __webpack_require__(1156);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _show = __webpack_require__(1157);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  all: _all2.default,
	  update: _update2.default,
	  destroy: _destroy2.default,
	  show: _show2.default
	};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1226);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _destroy = __webpack_require__(1227);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(1229);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _update = __webpack_require__(1230);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _items = __webpack_require__(1228);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  destroy: _destroy2.default,
	  store: _store2.default,
	  update: _update2.default,
	  items: _items2.default
	};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1249);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(1252);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _store = __webpack_require__(1254);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1253);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1256);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _storeProduct = __webpack_require__(1255);
	
	var _storeProduct2 = _interopRequireDefault(_storeProduct);
	
	var _bulkStoreProduct = __webpack_require__(1250);
	
	var _bulkStoreProduct2 = _interopRequireDefault(_bulkStoreProduct);
	
	var _destroyProduct = __webpack_require__(1251);
	
	var _destroyProduct2 = _interopRequireDefault(_destroyProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  items: _items2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  storeProduct: _storeProduct2.default,
	  bulkStoreProduct: _bulkStoreProduct2.default,
	  destroyProduct: _destroyProduct2.default
	};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1315);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(1317);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _store = __webpack_require__(1320);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1318);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1322);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _destroy = __webpack_require__(1316);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _storeRules = __webpack_require__(1321);
	
	var _storeRules2 = _interopRequireDefault(_storeRules);
	
	var _showRules = __webpack_require__(1319);
	
	var _showRules2 = _interopRequireDefault(_showRules);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  items: _items2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  destroy: _destroy2.default,
	  storeRules: _storeRules2.default,
	  showRules: _showRules2.default
	};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _destroy = __webpack_require__(1344);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(1346);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1345);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1347);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _all = __webpack_require__(1343);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(487);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  destroy: _destroy2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  all: _all2.default,
	  items: _items2.default
	};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddressTransformer = function (_Transformer) {
	  _inherits(AddressTransformer, _Transformer);
	
	  function AddressTransformer() {
	    _classCallCheck(this, AddressTransformer);
	
	    return _possibleConstructorReturn(this, (AddressTransformer.__proto__ || Object.getPrototypeOf(AddressTransformer)).apply(this, arguments));
	  }
	
	  _createClass(AddressTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(address) {
	      return {
	        careOf: address.care_of,
	        streetName: address.street_name,
	        secondStreetName: address.second_street_name,
	        postalCode: address.postal_code,
	        cityName: address.city_name,
	        countryId: address.country_id
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(address) {
	      return {
	        care_of: address.careOf,
	        street_name: address.streetName,
	        second_street_name: address.secondStreetName,
	        postal_code: address.postalCode,
	        city_name: address.cityName,
	        country_id: address.countryId
	      };
	    }
	  }]);
	
	  return AddressTransformer;
	}(_transformer2.default);
	
	exports.default = AddressTransformer;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketplaceProductTransformer = function (_Transformer) {
	  _inherits(MarketplaceProductTransformer, _Transformer);
	
	  function MarketplaceProductTransformer() {
	    _classCallCheck(this, MarketplaceProductTransformer);
	
	    return _possibleConstructorReturn(this, (MarketplaceProductTransformer.__proto__ || Object.getPrototypeOf(MarketplaceProductTransformer)).apply(this, arguments));
	  }
	
	  _createClass(MarketplaceProductTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(marketplaceProduct) {
	      return {
	        name: marketplaceProduct.name,
	        productId: marketplaceProduct.product_id,
	        productTypeId: marketplaceProduct.product_type_id,
	        price: marketplaceProduct.price,
	        containsAlcohol: marketplaceProduct.contains_alcohol,
	        image: marketplaceProduct.image ? { url: marketplaceProduct.image } : undefined,
	        status: marketplaceProduct.status,
	        shortDescription: marketplaceProduct.short_description,
	        longDescription: marketplaceProduct.long_description,
	        approvedAt: marketplaceProduct.approved_at
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(marketplaceProduct) {
	      return {
	        name: marketplaceProduct.name,
	        product_id: marketplaceProduct.productId,
	        product_type_id: marketplaceProduct.productTypeId,
	        image: marketplaceProduct.image && marketplaceProduct.image.file ? marketplaceProduct.image.file : '',
	        price: marketplaceProduct.price,
	        status: marketplaceProduct.status,
	        short_description: marketplaceProduct.shortDescription,
	        long_description: marketplaceProduct.longDescription,
	        approved_at: marketplaceProduct.approvedAt
	      };
	    }
	  }]);
	
	  return MarketplaceProductTransformer;
	}(_transformer2.default);
	
	exports.default = MarketplaceProductTransformer;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _warehouse = __webpack_require__(62);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductWarehouseTransformer = function (_Transformer) {
	  _inherits(ProductWarehouseTransformer, _Transformer);
	
	  function ProductWarehouseTransformer() {
	    _classCallCheck(this, ProductWarehouseTransformer);
	
	    return _possibleConstructorReturn(this, (ProductWarehouseTransformer.__proto__ || Object.getPrototypeOf(ProductWarehouseTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductWarehouseTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(transaction) {
	      return {
	        id: transaction.id,
	        warehouseId: transaction.warehouse_id,
	        productId: transaction.product_id,
	        batchId: transaction.batch_id,
	        minimum_stock_level: transaction.minimum_stock_level,
	        warehouse: transaction.warehouse !== undefined ? _warehouse2.default.fetch(transaction.warehouse) : [],
	        qty: transaction.qty,
	        qtyNumber: transaction.qty_number,
	        currentQty: transaction.current_qty,
	        batchName: transaction.batch_name,
	        totalItemQty: transaction.total_item_qty,
	        totalCrateQty: transaction.total_crate_qty,
	        totalLooseQty: transaction.total_loose_qty
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(transaction) {
	      return {
	        id: transaction.id
	      };
	    }
	  }]);
	
	  return ProductWarehouseTransformer;
	}(_transformer2.default);
	
	exports.default = ProductWarehouseTransformer;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientTransformer = function (_Transformer) {
	  _inherits(ClientTransformer, _Transformer);
	
	  function ClientTransformer() {
	    _classCallCheck(this, ClientTransformer);
	
	    return _possibleConstructorReturn(this, (ClientTransformer.__proto__ || Object.getPrototypeOf(ClientTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ClientTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(project) {
	      return {
	        id: project.id,
	        organizationId: project.organization_id,
	        name: project.name,
	        description: project.description
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(project) {
	      return {
	        id: project.id,
	        organization_id: project.organizationId,
	        name: project.name,
	        description: project.description
	      };
	    }
	  }]);
	
	  return ClientTransformer;
	}(_transformer2.default);
	
	exports.default = ClientTransformer;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShippingConfirmTransformer = function (_Transformer) {
	  _inherits(ShippingConfirmTransformer, _Transformer);
	
	  function ShippingConfirmTransformer() {
	    _classCallCheck(this, ShippingConfirmTransformer);
	
	    return _possibleConstructorReturn(this, (ShippingConfirmTransformer.__proto__ || Object.getPrototypeOf(ShippingConfirmTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ShippingConfirmTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(shipping) {
	      return {
	        shippingProviderId: shipping.shipping_provider_id,
	        shippingDate: shipping.delivery_date,
	        confirmDate: shipping.confirm_date
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(shipping) {
	      return {
	        shipping_provider_id: shipping.shippingProviderId,
	        warehouse_id: shipping.warehouseId,
	        delivery_date: shipping.deliveryDate ? (0, _moment2.default)(shipping.deliveryDate).format('Y-MM-DD HH:mm:ss') : '',
	        shipping_date: shipping.shippingDate ? (0, _moment2.default)(shipping.shippingDate).format('Y-MM-DD HH:mm:ss') : '',
	        confirm_date: shipping.confirmDate ? (0, _moment2.default)(shipping.confirmDate).format('Y-MM-DD HH:mm:ss') : ''
	      };
	    }
	  }]);
	
	  return ShippingConfirmTransformer;
	}(_transformer2.default);
	
	exports.default = ShippingConfirmTransformer;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShippingProviderTransformer = function (_Transformer) {
	  _inherits(ShippingProviderTransformer, _Transformer);
	
	  function ShippingProviderTransformer() {
	    _classCallCheck(this, ShippingProviderTransformer);
	
	    return _possibleConstructorReturn(this, (ShippingProviderTransformer.__proto__ || Object.getPrototypeOf(ShippingProviderTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ShippingProviderTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(shippingProvider) {
	      return {
	        id: shippingProvider.id,
	        name: shippingProvider.name,
	        code: shippingProvider.code
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(shippingProvider) {
	      return {
	        id: shippingProvider.id,
	        name: shippingProvider.name,
	        code: shippingProvider.code
	      };
	    }
	  }]);
	
	  return ShippingProviderTransformer;
	}(_transformer2.default);
	
	exports.default = ShippingProviderTransformer;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _transferProduct = __webpack_require__(1711);
	
	var _transferProduct2 = _interopRequireDefault(_transferProduct);
	
	var _stock = __webpack_require__(68);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _warehouse = __webpack_require__(62);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TransferTransformer = function (_Transformer) {
	  _inherits(TransferTransformer, _Transformer);
	
	  function TransferTransformer() {
	    _classCallCheck(this, TransferTransformer);
	
	    return _possibleConstructorReturn(this, (TransferTransformer.__proto__ || Object.getPrototypeOf(TransferTransformer)).apply(this, arguments));
	  }
	
	  _createClass(TransferTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(transfer) {
	      return {
	        id: transfer.id,
	        code: transfer.code,
	        name: transfer.name,
	        batchId: transfer.batch_id,
	        status: transfer.status,
	        transferType: transfer.transfer_type,
	        transferTypeName: transfer.transfer_type_name,
	        date: (0, _moment2.default)(transfer.transfer_date).format('MM-DD-YYYY'),
	        fromWarehouseId: transfer.from_warehouse_id,
	        fromWarehouse: transfer.from_warehouse !== undefined ? _warehouse2.default.fetch(transfer.from_warehouse) : [],
	        toWarehouseId: transfer.to_warehouse_id,
	        toWarehouse: transfer.to_warehouse !== undefined ? _warehouse2.default.fetch(transfer.to_warehouse) : [],
	        comments: transfer.comments,
	        createdAt: transfer.created_at,
	        products: transfer.products !== undefined ? _transferProduct2.default.fetchCollection(transfer.products) : [],
	        stock: transfer.stock !== undefined ? _stock2.default.fetch(transfer.stock) : [],
	        warehouse: transfer.warehouse !== undefined ? _warehouse2.default.fetch(transfer.warehouse) : [],
	        toWarehouseName: transfer.to_warehouse_name,
	        fromWarehouseName: transfer.from_warehouse_name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(transfer) {
	      return {
	        transfer_type: transfer.transferType,
	        date: transfer.date,
	        from_warehouse_id: transfer.fromWarehouseId,
	        to_warehouse_id: transfer.toWarehouseId,
	        batch_id: transfer.batchId,
	        comments: transfer.comments,
	        products: _transferProduct2.default.sendCollection(transfer.products)
	      };
	    }
	  }]);
	
	  return TransferTransformer;
	}(_transformer2.default);
	
	exports.default = TransferTransformer;

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sortBatchOptions = sortBatchOptions;
	exports.defaultBatchId = defaultBatchId;
	function sortBatchOptions(options) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$hideEmpty = _ref.hideEmpty,
	      hideEmpty = _ref$hideEmpty === undefined ? false : _ref$hideEmpty,
	      _ref$keepId = _ref.keepId,
	      keepId = _ref$keepId === undefined ? null : _ref$keepId;
	
	  var hasStock = function hasStock(option) {
	    return Number(option.available) > 0;
	  };
	  var keep = function keep(option) {
	    return keepId !== null && keepId !== undefined && keepId !== '' && option.id.toString() === keepId.toString();
	  };
	
	  var real = options.filter(function (option) {
	    return option && option.id !== undefined;
	  });
	  var withStock = real.filter(hasStock);
	  var hide = hideEmpty && withStock.length > 0;
	  var empty = real.filter(function (option) {
	    return !hasStock(option) && (!hide || keep(option));
	  });
	
	  return withStock.concat(empty);
	}
	
	function defaultBatchId(options) {
	  var option = options.find(function (o) {
	    return Number(o.available) > 0;
	  }) || options[0];
	  return option ? option.id.toString() : '';
	}
	
	exports.default = { sortBatchOptions: sortBatchOptions, defaultBatchId: defaultBatchId };

/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _account = __webpack_require__(237);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(account, resolve) {
	  account = _account2.default.fetch(account);
	  _store2.default.dispatch('getAccount', account);
	  resolve(account);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/account').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _destroy = __webpack_require__(882);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(886);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(885);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(887);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _all = __webpack_require__(881);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(443);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _downloadProduct = __webpack_require__(883);
	
	var _downloadProduct2 = _interopRequireDefault(_downloadProduct);
	
	var _updateDraft = __webpack_require__(888);
	
	var _updateDraft2 = _interopRequireDefault(_updateDraft);
	
	var _saveDraft = __webpack_require__(884);
	
	var _saveDraft2 = _interopRequireDefault(_saveDraft);
	
	var _adjustmentType = __webpack_require__(880);
	
	var _adjustmentType2 = _interopRequireDefault(_adjustmentType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  destroy: _destroy2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  all: _all2.default,
	  items: _items2.default,
	  downloadProduct: _downloadProduct2.default,
	  updateDraft: _updateDraft2.default,
	  saveDraft: _saveDraft2.default,
	  adjustmentType: _adjustmentType2.default
	};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1029);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(1030);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _store = __webpack_require__(1032);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1031);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1033);
	
	var _update2 = _interopRequireDefault(_update);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  items: _items2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default
	};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _show = __webpack_require__(1055);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _send = __webpack_require__(1051);
	
	var _send2 = _interopRequireDefault(_send);
	
	var _sendEHF = __webpack_require__(1053);
	
	var _sendEHF2 = _interopRequireDefault(_sendEHF);
	
	var _sendTripletex = __webpack_require__(1054);
	
	var _sendTripletex2 = _interopRequireDefault(_sendTripletex);
	
	var _sendEDI = __webpack_require__(1052);
	
	var _sendEDI2 = _interopRequireDefault(_sendEDI);
	
	var _showDeliveryNote = __webpack_require__(1057);
	
	var _showDeliveryNote2 = _interopRequireDefault(_showDeliveryNote);
	
	var _showBillEmailInformation = __webpack_require__(1056);
	
	var _showBillEmailInformation2 = _interopRequireDefault(_showBillEmailInformation);
	
	var _download = __webpack_require__(1049);
	
	var _download2 = _interopRequireDefault(_download);
	
	var _downloadDeliveryNote = __webpack_require__(1050);
	
	var _downloadDeliveryNote2 = _interopRequireDefault(_downloadDeliveryNote);
	
	var _bulkDownloadDeliveryNote = __webpack_require__(1048);
	
	var _bulkDownloadDeliveryNote2 = _interopRequireDefault(_bulkDownloadDeliveryNote);
	
	var _bulkDownload = __webpack_require__(1047);
	
	var _bulkDownload2 = _interopRequireDefault(_bulkDownload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  show: _show2.default,
	  showDeliveryNote: _showDeliveryNote2.default,
	  send: _send2.default,
	  sendEHF: _sendEHF2.default,
	  sendTripletex: _sendTripletex2.default,
	  sendEDI: _sendEDI2.default,
	  showBillEmailInformation: _showBillEmailInformation2.default,
	  download: _download2.default,
	  bulkDownload: _bulkDownload2.default,
	  downloadDeliveryNote: _downloadDeliveryNote2.default,
	  bulkDownloadDeliveryNote: _bulkDownloadDeliveryNote2.default
	};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(1202);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1201);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _items = __webpack_require__(469);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _update = __webpack_require__(1203);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _destroy = __webpack_require__(1200);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  show: _show2.default,
	  items: _items2.default,
	  update: _update2.default,
	  destroy: _destroy2.default
	};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(1219);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _store = __webpack_require__(1221);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1220);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1222);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _all = __webpack_require__(1218);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  items: _items2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  all: _all2.default
	};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1223);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _show = __webpack_require__(474);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1231);
	
	var _update2 = _interopRequireDefault(_update);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  show: _show2.default,
	  update: _update2.default
	};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(1336);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1334);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _all = __webpack_require__(1332);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(1333);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _showDeliveryNote = __webpack_require__(1335);
	
	var _showDeliveryNote2 = _interopRequireDefault(_showDeliveryNote);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  show: _show2.default,
	  all: _all2.default,
	  items: _items2.default,
	  showDeliveryNote: _showDeliveryNote2.default
	};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1348);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _authorize = __webpack_require__(1349);
	
	var _authorize2 = _interopRequireDefault(_authorize);
	
	var _findProduct = __webpack_require__(1351);
	
	var _findProduct2 = _interopRequireDefault(_findProduct);
	
	var _syncSelected = __webpack_require__(1352);
	
	var _syncSelected2 = _interopRequireDefault(_syncSelected);
	
	var _cancelSync = __webpack_require__(1350);
	
	var _cancelSync2 = _interopRequireDefault(_cancelSync);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  authorize: _authorize2.default,
	  findProduct: _findProduct2.default,
	  syncSelected: _syncSelected2.default,
	  cancelSync: _cancelSync2.default
	};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountTransformer = function (_Transformer) {
	  _inherits(AccountTransformer, _Transformer);
	
	  function AccountTransformer() {
	    _classCallCheck(this, AccountTransformer);
	
	    return _possibleConstructorReturn(this, (AccountTransformer.__proto__ || Object.getPrototypeOf(AccountTransformer)).apply(this, arguments));
	  }
	
	  _createClass(AccountTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(account) {
	      return {
	        id: account.id,
	        userId: account.user_id,
	        password: account.password,
	        passwordConfirmation: account.password_confirmation,
	        firstName: account.first_name,
	        lastName: account.last_name,
	        email: account.email,
	        phoneNumber: account.phone_number,
	        mobileNumber: account.mobile_number,
	        careOf: account.care_of,
	        streetName: account.street_name,
	        secondStreetName: account.second_street_name,
	        postalCode: account.postal_code,
	        cityName: account.city_name,
	        countryId: account.country_id,
	        userMobileNumber: account.user_mobile_number,
	        sms2faEnabled: account.sms_2fa_enabled,
	        google2faEnabled: account.google_2fa_enabled,
	        userEmail: account.user_email,
	        language: account.language,
	        userFirstName: account.user_first_name,
	        userLastName: account.user_last_name,
	        businessRegistrationNumber: account.business_registration_number,
	        isImpersonated: account.is_impersonated,
	        debugMode: account.debug_mode,
	        isVatRegistered: account.is_vat_registered,
	        isRegisteredBusinessEnterprise: account.is_registered_business_enterprise,
	        bankAccount: account.bank_account,
	        smallScaleManufacturer: account.is_small_scale_manufacturer,
	        verified: account.verified,
	        subscribed: account.subscribed,
	        organizationType: account.organization_type,
	        organizationTypeId: account.organization_type_id,
	        organizationName: account.organization_name,
	        organizationDescription: account.organization_description,
	        organizationProfilePicture: account.organization_profile_picture ? { url: account.organization_profile_picture } : undefined,
	        plan: account.plan,
	        modules: account.modules,
	        organizations: account.subscribed_to_organizations,
	        organizationMembers: account.organization_members,
	        productDisplay: account.product_display,
	        productGrouping: account.product_grouping,
	        gs1number: account.gs1number,
	        isPartner: account.is_partner,
	        isInternational: account.is_international,
	        bankName: account.bank_name,
	        swift: account.swift,
	        iban: account.iban,
	        allowProducerBatches: account.allow_producer_batches,
	        stockReportBeta: account.stock_report_beta,
	        hasPartner: account.has_partner
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(account) {
	      return {
	        email: account.email,
	        password: account.password,
	        password_confirmation: account.passwordConfirmation,
	        first_name: account.firstName,
	        last_name: account.lastName,
	        phone_number: account.phoneNumber ? account.phoneNumber : '',
	        mobile_number: account.mobileNumber ? account.mobileNumber : '',
	        care_of: account.careOf,
	        street_name: account.streetName,
	        second_street_name: account.secondStreetName ? account.secondStreetName : '',
	        postal_code: account.postalCode,
	        city_name: account.cityName,
	        country_id: account.countryId,
	        user_email: account.userEmail,
	        language: account.language,
	        user_first_name: account.userFirstName,
	        user_last_name: account.userLastName,
	        business_registration_number: account.businessRegistrationNumber,
	        is_vat_registered: account.isVatRegistered === true || account.isVatRegistered === 1 ? 1 : 0,
	        is_registered_business_enterprise: account.isRegisteredBusinessEnterprise === true || account.isRegisteredBusinessEnterprise === 1 ? 1 : 0,
	        bank_account: account.bankAccount,
	        is_small_scale_manufacturer: account.smallScaleManufacturer === true || account.smallScaleManufacturer === 1 ? 1 : 0,
	        organization_type_id: account.organizationTypeId,
	        organization_name: account.organizationName ? account.organizationName : '',
	        organization_description: account.organizationDescription ? account.organizationDescription : '',
	        organization_profile_picture: account.organizationProfilePicture && account.organizationProfilePicture.file ? account.organizationProfilePicture.file : '',
	        gs1number: account.gs1number,
	        is_international: account.isInternational === true || account.isInternational === 1 ? 1 : 0,
	        bank_name: account.bankName,
	        swift: account.swift,
	        iban: account.iban
	      };
	    }
	  }]);
	
	  return AccountTransformer;
	}(_transformer2.default);
	
	exports.default = AccountTransformer;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BatchLogTransformer = function (_Transformer) {
	  _inherits(BatchLogTransformer, _Transformer);
	
	  function BatchLogTransformer() {
	    _classCallCheck(this, BatchLogTransformer);
	
	    return _possibleConstructorReturn(this, (BatchLogTransformer.__proto__ || Object.getPrototypeOf(BatchLogTransformer)).apply(this, arguments));
	  }
	
	  _createClass(BatchLogTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(batch) {
	      return {
	        id: batch.id,
	        batchId: batch.batch_id,
	        description: batch.description,
	        timestamp: (0, _moment2.default)(batch.timestamp).format('MMM DD, YYYY HH:MM'),
	        userId: batch.user_id,
	        userFullname: batch.user_fullname
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(batch) {
	      return {
	        id: batch.id,
	        batch_id: batch.batchId,
	        description: batch.description,
	        timestamp: batch.timestamp
	      };
	    }
	  }]);
	
	  return BatchLogTransformer;
	}(_transformer2.default);
	
	exports.default = BatchLogTransformer;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChartOfAccountsTransformer = function (_Transformer) {
	  _inherits(ChartOfAccountsTransformer, _Transformer);
	
	  function ChartOfAccountsTransformer() {
	    _classCallCheck(this, ChartOfAccountsTransformer);
	
	    return _possibleConstructorReturn(this, (ChartOfAccountsTransformer.__proto__ || Object.getPrototypeOf(ChartOfAccountsTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ChartOfAccountsTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(elem) {
	      return {
	        id: elem.id,
	        code: elem.code,
	        name: elem.name,
	        description: elem.description
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(elem) {
	      return {
	        id: elem.id,
	        code: elem.code,
	        name: elem.name,
	        description: elem.description
	      };
	    }
	  }]);
	
	  return ChartOfAccountsTransformer;
	}(_transformer2.default);
	
	exports.default = ChartOfAccountsTransformer;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactTransformer = function (_Transformer) {
	  _inherits(ContactTransformer, _Transformer);
	
	  function ContactTransformer() {
	    _classCallCheck(this, ContactTransformer);
	
	    return _possibleConstructorReturn(this, (ContactTransformer.__proto__ || Object.getPrototypeOf(ContactTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ContactTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(contact) {
	      return {
	        email: contact.email,
	        firstName: contact.first_name,
	        lastName: contact.last_name,
	        phoneNumber: contact.phone_number,
	        mobileNumber: contact.mobile_number
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(contact) {
	      return {
	        email: contact.email,
	        first_name: contact.firstName,
	        last_name: contact.lastName,
	        phone_number: contact.phoneNumber,
	        mobile_number: contact.mobileNumber
	      };
	    }
	  }]);
	
	  return ContactTransformer;
	}(_transformer2.default);
	
	exports.default = ContactTransformer;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductBundleTransformer = function (_Transformer) {
	  _inherits(ProductBundleTransformer, _Transformer);
	
	  function ProductBundleTransformer() {
	    _classCallCheck(this, ProductBundleTransformer);
	
	    return _possibleConstructorReturn(this, (ProductBundleTransformer.__proto__ || Object.getPrototypeOf(ProductBundleTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductBundleTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(productBundle) {
	      return {
	        name: productBundle.name,
	        price: productBundle.price,
	        description: productBundle.description,
	        products: productBundle.products,
	        productBundleGroup: productBundle.product_bundle_group
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(productBundle) {
	      return {
	        name: productBundle.name,
	        price: productBundle.price,
	        description: productBundle.description
	      };
	    }
	  }]);
	
	  return ProductBundleTransformer;
	}(_transformer2.default);
	
	exports.default = ProductBundleTransformer;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PublicProfileTransformer = function (_Transformer) {
	  _inherits(PublicProfileTransformer, _Transformer);
	
	  function PublicProfileTransformer() {
	    _classCallCheck(this, PublicProfileTransformer);
	
	    return _possibleConstructorReturn(this, (PublicProfileTransformer.__proto__ || Object.getPrototypeOf(PublicProfileTransformer)).apply(this, arguments));
	  }
	
	  _createClass(PublicProfileTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(publicProfile) {
	      return {
	        id: publicProfile.id,
	        profileUrl: publicProfile.profile_url,
	        header: publicProfile.header,
	        subheader: publicProfile.subheader,
	        defaultReminderTitle: publicProfile.default_reminder_title,
	        defaultReminder: publicProfile.default_reminder,
	        defaultCancelMessageTitle: publicProfile.default_cancel_message_title,
	        defaultCancelMessage: publicProfile.default_cancel_message,
	        appointmentConfirmationTemplate: publicProfile.appointment_confirmation_template,
	        appointmentConfirmationTitle: publicProfile.appointment_confirmation_title,
	        backgroundImage: publicProfile.background_image ? { url: publicProfile.background_image } : undefined,
	        stripeConnect: publicProfile.stripe_connect,
	        bookingRequirePayment: publicProfile.booking_require_payment,
	        bookingRequireAddress: publicProfile.booking_require_address,
	        orgName: publicProfile.org_name,
	        orgEmail: publicProfile.org_email,
	        orgId: publicProfile.org_id,
	        optinEmailSubject: publicProfile.optinEmailSubject,
	        optinEmailBody: publicProfile.optinEmailBody
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(publicProfile) {
	      return {
	        id: publicProfile.id,
	        profile_url: publicProfile.profileUrl,
	        header: publicProfile.header,
	        subheader: publicProfile.subheader,
	        default_reminder_title: publicProfile.defaultReminderTitle ? publicProfile.defaultReminderTitle : '',
	        default_reminder: publicProfile.defaultReminder ? publicProfile.defaultReminder : '',
	        default_cancel_message_title: publicProfile.defaultCancelMessageTitle ? publicProfile.defaultCancelMessageTitle : '',
	        default_cancel_message: publicProfile.defaultCancelMessage ? publicProfile.defaultCancelMessage : '',
	        appointment_confirmation_title: publicProfile.appointmentConfirmationTitle ? publicProfile.appointmentConfirmationTitle : '',
	        appointment_confirmation_template: publicProfile.appointmentConfirmationTemplate ? publicProfile.appointmentConfirmationTemplate : '',
	        background_image: publicProfile.backgroundImage.file ? publicProfile.backgroundImage.file : '',
	        booking_require_payment: publicProfile.bookingRequirePayment,
	        booking_require_address: publicProfile.bookingRequireAddress
	      };
	    }
	  }]);
	
	  return PublicProfileTransformer;
	}(_transformer2.default);
	
	exports.default = PublicProfileTransformer;

/***/ }),
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2361)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1774),
	  /* template */
	  __webpack_require__(3060),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2279)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1837),
	  /* template */
	  __webpack_require__(2921),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-149e038b",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2294)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1847),
	  /* template */
	  __webpack_require__(2949),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2325)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1865),
	  /* template */
	  __webpack_require__(3009),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1946),
	  /* template */
	  __webpack_require__(3062),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _en = __webpack_require__(845);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _no = __webpack_require__(847);
	
	var _no2 = _interopRequireDefault(_no);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  en: _en2.default,
	  no: _no2.default
	};

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      mq: {}
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.mq = window.matchMedia('(min-width: 780px)');
	    this.mq.addListener(function () {
	      if (_this.onMqChange && typeof _this.onMqChange === 'function') {
	        _this.onMqChange();
	      }
	      _this.$forceUpdate();
	    });
	  },
	
	
	  methods: {
	    isDesktop: function isDesktop() {
	      return this.mq.matches;
	    }
	  }
	};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(876);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _creditNoteProduct = __webpack_require__(99);
	
	var _creditNoteProduct2 = _interopRequireDefault(_creditNoteProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var billProducts = _creditNoteProduct2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllBillProducts', billProducts);
	  resolve(billProducts);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/bills/' + id + '/products').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _businessHour = __webpack_require__(493);
	
	var _businessHour2 = _interopRequireDefault(_businessHour);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var hours = _businessHour2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchBusinessHours', hours);
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('business_hours').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _businessHourException = __webpack_require__(306);
	
	var _businessHourException2 = _interopRequireDefault(_businessHourException);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var hours = _businessHourException2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchBusinessHourExceptions', hours);
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('business_hour_exceptions').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _chartOfAccounts = __webpack_require__(239);
	
	var _chartOfAccounts2 = _interopRequireDefault(_chartOfAccounts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var chartOfAccounts = _chartOfAccounts2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllChartOfAccounts', chartOfAccounts);
	  resolve(chartOfAccounts);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/chart_of_accounts').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(996);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _creditNoteProduct = __webpack_require__(99);
	
	var _creditNoteProduct2 = _interopRequireDefault(_creditNoteProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var creditNoteProducts = _creditNoteProduct2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllCreditNoteProducts', creditNoteProducts);
	  resolve(creditNoteProducts);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/credit_notes/' + id + '/products').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1014);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entries = __webpack_require__(1035);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _update = __webpack_require__(1036);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _checkFlag = __webpack_require__(1034);
	
	var _checkFlag2 = _interopRequireDefault(_checkFlag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  entries: _entries2.default,
	  update: _update2.default,
	  checkFlag: _checkFlag2.default
	};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(1087);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _store = __webpack_require__(1091);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1090);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1093);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _destroy = __webpack_require__(1086);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _test = __webpack_require__(1092);
	
	var _test2 = _interopRequireDefault(_test);
	
	var _sendReport = __webpack_require__(1089);
	
	var _sendReport2 = _interopRequireDefault(_sendReport);
	
	var _newsEmailTrackings = __webpack_require__(1088);
	
	var _newsEmailTrackings2 = _interopRequireDefault(_newsEmailTrackings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  items: _items2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  destroy: _destroy2.default,
	  test: _test2.default,
	  sendReport: _sendReport2.default,
	  newsEmailTrackings: _newsEmailTrackings2.default
	};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _orderProduct = __webpack_require__(164);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  console.log('[orderProduct/all] API response (data.data):', data.data);
	  console.log('[orderProduct/all] discount per item (raw):', (data.data || []).map(function (p) {
	    return { id: p.id, product_id: p.product_id, name: p.name, discount: p.discount };
	  }));
	
	  var orderProducts = _orderProduct2.default.fetchCollection(data.data);
	
	  console.log('[orderProduct/all] transformed orderProducts (discount):', orderProducts.map(function (p) {
	    return { id: p.id, productId: p.productId, name: p.name, discount: p.discount };
	  }));
	
	  _store2.default.dispatch('fetchAllOrderProducts', orderProducts);
	  resolve(orderProducts);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/orders/' + id + '/products').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1129);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1164);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1177);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(1178);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  store: _store2.default
	};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productSearch = __webpack_require__(502);
	
	var _productSearch2 = _interopRequireDefault(_productSearch);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var products = _productSearch2.default.fetchCollection(data.data);
	  resolve(products);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('products/search/products', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _destroy = __webpack_require__(1206);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(1209);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1208);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1210);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _all = __webpack_require__(1205);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(470);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _orders = __webpack_require__(1207);
	
	var _orders2 = _interopRequireDefault(_orders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  destroy: _destroy2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  all: _all2.default,
	  items: _items2.default,
	  orders: _orders2.default
	};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _aggregatedSales = __webpack_require__(1272);
	
	var _aggregatedSales2 = _interopRequireDefault(_aggregatedSales);
	
	var _clients = __webpack_require__(1275);
	
	var _clients2 = _interopRequireDefault(_clients);
	
	var _sales = __webpack_require__(1284);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _bills = __webpack_require__(1273);
	
	var _bills2 = _interopRequireDefault(_bills);
	
	var _fees = __webpack_require__(1281);
	
	var _fees2 = _interopRequireDefault(_fees);
	
	var _warehouses = __webpack_require__(1288);
	
	var _warehouses2 = _interopRequireDefault(_warehouses);
	
	var _excises = __webpack_require__(1280);
	
	var _excises2 = _interopRequireDefault(_excises);
	
	var _checkExportFlag = __webpack_require__(1274);
	
	var _checkExportFlag2 = _interopRequireDefault(_checkExportFlag);
	
	var _helsedir = __webpack_require__(1282);
	
	var _helsedir2 = _interopRequireDefault(_helsedir);
	
	var _infinitum = __webpack_require__(1283);
	
	var _infinitum2 = _interopRequireDefault(_infinitum);
	
	var _excisePeriods = __webpack_require__(1279);
	
	var _excisePeriods2 = _interopRequireDefault(_excisePeriods);
	
	var _showExcisePeriod = __webpack_require__(1286);
	
	var _showExcisePeriod2 = _interopRequireDefault(_showExcisePeriod);
	
	var _closeExcisePeriod = __webpack_require__(1276);
	
	var _closeExcisePeriod2 = _interopRequireDefault(_closeExcisePeriod);
	
	var _warehouseTransactions = __webpack_require__(1287);
	
	var _warehouseTransactions2 = _interopRequireDefault(_warehouseTransactions);
	
	var _downloadTurnOverPdf = __webpack_require__(1277);
	
	var _downloadTurnOverPdf2 = _interopRequireDefault(_downloadTurnOverPdf);
	
	var _sendTurnOverPdf = __webpack_require__(1285);
	
	var _sendTurnOverPdf2 = _interopRequireDefault(_sendTurnOverPdf);
	
	var _exciseCalendar = __webpack_require__(1278);
	
	var _exciseCalendar2 = _interopRequireDefault(_exciseCalendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  aggregatedSales: _aggregatedSales2.default,
	  clients: _clients2.default,
	  sales: _sales2.default,
	  bills: _bills2.default,
	  fees: _fees2.default,
	  warehouses: _warehouses2.default,
	  excises: _excises2.default,
	  checkExportFlag: _checkExportFlag2.default,
	  helsedir: _helsedir2.default,
	  infinitum: _infinitum2.default,
	  excisePeriods: _excisePeriods2.default,
	  showExcisePeriod: _showExcisePeriod2.default,
	  closeExcisePeriod: _closeExcisePeriod2.default,
	  warehouseTransactions: _warehouseTransactions2.default,
	  downloadTurnOverPdf: _downloadTurnOverPdf2.default,
	  exciseCalendar: _exciseCalendar2.default,
	  sendTurnOverPdf: _sendTurnOverPdf2.default
	};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var businessHourExceptionsTransformer = function (_Transformer) {
	  _inherits(businessHourExceptionsTransformer, _Transformer);
	
	  function businessHourExceptionsTransformer() {
	    _classCallCheck(this, businessHourExceptionsTransformer);
	
	    return _possibleConstructorReturn(this, (businessHourExceptionsTransformer.__proto__ || Object.getPrototypeOf(businessHourExceptionsTransformer)).apply(this, arguments));
	  }
	
	  _createClass(businessHourExceptionsTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(businessHourException) {
	      return {
	        id: businessHourException.id,
	        start: businessHourException.start,
	        end: businessHourException.end,
	        message: businessHourException.message,
	        confirmed: businessHourException.confirmed
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(businessHourException) {
	      return {
	        id: businessHourException.id,
	        start: businessHourException.start,
	        end: businessHourException.end,
	        message: businessHourException.message,
	        confirmed: businessHourException.confirmed
	      };
	    }
	  }]);
	
	  return businessHourExceptionsTransformer;
	}(_transformer2.default);
	
	exports.default = businessHourExceptionsTransformer;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CountryTransformer = function (_Transformer) {
	  _inherits(CountryTransformer, _Transformer);
	
	  function CountryTransformer() {
	    _classCallCheck(this, CountryTransformer);
	
	    return _possibleConstructorReturn(this, (CountryTransformer.__proto__ || Object.getPrototypeOf(CountryTransformer)).apply(this, arguments));
	  }
	
	  _createClass(CountryTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(country) {
	      return {
	        id: country.id,
	        name: country.name,
	        code: country.code
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(country) {
	      return {
	        id: country.id,
	        name: country.name
	      };
	    }
	  }]);
	
	  return CountryTransformer;
	}(_transformer2.default);
	
	exports.default = CountryTransformer;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountSetupTransformer = function (_Transformer) {
	  _inherits(AccountSetupTransformer, _Transformer);
	
	  function AccountSetupTransformer() {
	    _classCallCheck(this, AccountSetupTransformer);
	
	    return _possibleConstructorReturn(this, (AccountSetupTransformer.__proto__ || Object.getPrototypeOf(AccountSetupTransformer)).apply(this, arguments));
	  }
	
	  _createClass(AccountSetupTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(accountSetup) {
	      return {
	        firstName: accountSetup.first_name,
	        lastName: accountSetup.last_name,
	        email: accountSetup.email,
	        businessRegistrationNumber: accountSetup.business_registration_number,
	        password: accountSetup.password,
	        passwordConfirmation: accountSetup.password_confirmation,
	        planId: accountSetup.plan_id,
	        organizationTypeId: accountSetup.organization_type_id,
	        businessName: accountSetup.business_name,
	        mobile: accountSetup.mobile,
	        address: accountSetup.address,
	        postalCode: accountSetup.postal_code,
	        city: accountSetup.city,
	        country: accountSetup.country
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(accountSetup) {
	      return {
	        password: accountSetup.password,
	        password_confirmation: accountSetup.passwordConfirmation,
	        plan: accountSetup.plan,
	        planType: accountSetup.type,
	        name: accountSetup.name,
	        email: accountSetup.email,
	        mobile: accountSetup.mobile,
	        organization_type: accountSetup.organizationType,
	        business_registration_number: accountSetup.businessRegistrationNumber,
	        business_name: accountSetup.businessName,
	        address: accountSetup.address,
	        postal_code: accountSetup.postalCode,
	        city: accountSetup.city,
	        country: accountSetup.country,
	        is_vat_registered: accountSetup.isVatRegistered,
	        is_registered_business_enterprise: accountSetup.isRegisteredBusinessEnterprise,
	        tos_accepted: accountSetup.tosAccepted,
	        marketing_allowed: accountSetup.marketingAllowed
	      };
	    }
	  }]);
	
	  return AccountSetupTransformer;
	}(_transformer2.default);
	
	exports.default = AccountSetupTransformer;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExciseDutyTransformer = function (_Transformer) {
	  _inherits(ExciseDutyTransformer, _Transformer);
	
	  function ExciseDutyTransformer() {
	    _classCallCheck(this, ExciseDutyTransformer);
	
	    return _possibleConstructorReturn(this, (ExciseDutyTransformer.__proto__ || Object.getPrototypeOf(ExciseDutyTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ExciseDutyTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(excise) {
	      return {
	        id: excise.id,
	        title: excise.title,
	        type: excise.type,
	        description: excise.description,
	        group_id: excise.group_id,
	        unit_type: excise.unit_type,
	        rate: excise.rate,
	        code: excise.code,
	        codeId: excise.code_id
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(excise) {
	      return {
	        id: excise.id
	      };
	    }
	  }]);
	
	  return ExciseDutyTransformer;
	}(_transformer2.default);
	
	exports.default = ExciseDutyTransformer;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExcisePeriodTransformer = function (_Transformer) {
	  _inherits(ExcisePeriodTransformer, _Transformer);
	
	  function ExcisePeriodTransformer() {
	    _classCallCheck(this, ExcisePeriodTransformer);
	
	    return _possibleConstructorReturn(this, (ExcisePeriodTransformer.__proto__ || Object.getPrototypeOf(ExcisePeriodTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ExcisePeriodTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(period) {
	      return {
	        id: period.id,
	        calendarMonth: period.calendar_month,
	        monthName: (0, _moment2.default)(period.calendar_month).format('YYYY/MM'),
	        exciseStatusId: period.excise_status_id,
	        exciseStatus: period.excise_status,
	        closedAt: period.closed_at
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(period) {
	      return {
	        id: period.id,
	        calendar_month: period.calendarMonth,
	        excise_status_id: period.exciseStatusId,
	        excise_status: period.exciseStatus,
	        closed_at: period.closedAt
	      };
	    }
	  }]);
	
	  return ExcisePeriodTransformer;
	}(_transformer2.default);
	
	exports.default = ExcisePeriodTransformer;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _licensePermitGroup = __webpack_require__(1673);
	
	var _licensePermitGroup2 = _interopRequireDefault(_licensePermitGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var licenseTransformer = function (_Transformer) {
	  _inherits(licenseTransformer, _Transformer);
	
	  function licenseTransformer() {
	    _classCallCheck(this, licenseTransformer);
	
	    return _possibleConstructorReturn(this, (licenseTransformer.__proto__ || Object.getPrototypeOf(licenseTransformer)).apply(this, arguments));
	  }
	
	  _createClass(licenseTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(license) {
	      return {
	        id: license.id,
	        organizationNumber: license.organization_number,
	        ownerOrganizationNumber: license.owner_organization_number,
	        licenseTypeId: license.license_type_id,
	        licenseType: license.license_type,
	        licensePermitTypeId: license.license_permit_type_id,
	        licensePermitType: license.license_permit_type,
	        licenseNumber: license.license_number,
	        name: license.name,
	        streetName: license.street_name,
	        postalCode: license.postal_code,
	        city: license.city,
	        municipality: license.municipality,
	        municipalityNumber: license.municipality_number,
	        validFrom: license.valid_from,
	        validTo: license.valid_to,
	        licensePermitGroups: license.license_permit_groups ? _licensePermitGroup2.default.fetchCollection(license.license_permit_groups) : [],
	        licenseFile: license.license_file || ''
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(license) {
	      return {
	        id: license.id,
	        organization_number: license.organizationNumber,
	        owner_organization_number: license.ownerOrganizationNumber,
	        license_type_id: license.licenseTypeId,
	        license_permit_type_id: license.licensePermitTypeId,
	        license_group_ids: license.licenseGroupIds,
	        license_number: license.licenseNumber,
	        name: license.name,
	        street_name: license.streetName,
	        postal_code: license.postalCode,
	        city: license.city,
	        municipality: license.municipality,
	        municipality_number: license.municipalityNumber,
	        valid_from: license.validFrom,
	        valid_to: license.validTo,
	        license_file: license.licenseFile && license.licenseFile.file ? license.licenseFile.file : ''
	      };
	    }
	  }]);
	
	  return licenseTransformer;
	}(_transformer2.default);
	
	exports.default = licenseTransformer;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrganizationMemberTransformer = function (_Transformer) {
	  _inherits(OrganizationMemberTransformer, _Transformer);
	
	  function OrganizationMemberTransformer() {
	    _classCallCheck(this, OrganizationMemberTransformer);
	
	    return _possibleConstructorReturn(this, (OrganizationMemberTransformer.__proto__ || Object.getPrototypeOf(OrganizationMemberTransformer)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationMemberTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(organizationMember) {
	      return {
	        id: organizationMember.id,
	        user: organizationMember.user,
	        title: organizationMember.title,
	        color: organizationMember.color,
	        isAccepted: organizationMember.is_accepted,
	        organizationMemberProducts: organizationMember.organization_member_products
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(organizationMember) {
	      return {
	        first_name: organizationMember.firstname,
	        last_name: organizationMember.lastname,
	        email: organizationMember.email
	      };
	    }
	  }]);
	
	  return OrganizationMemberTransformer;
	}(_transformer2.default);
	
	exports.default = OrganizationMemberTransformer;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrganizationMemberBookingTransformer = function (_Transformer) {
	  _inherits(OrganizationMemberBookingTransformer, _Transformer);
	
	  function OrganizationMemberBookingTransformer() {
	    _classCallCheck(this, OrganizationMemberBookingTransformer);
	
	    return _possibleConstructorReturn(this, (OrganizationMemberBookingTransformer.__proto__ || Object.getPrototypeOf(OrganizationMemberBookingTransformer)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationMemberBookingTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(organizationMemberBooking) {
	      return {
	        id: organizationMemberBooking.id,
	        order: organizationMemberBooking.order,
	        organizationMemberProduct: organizationMemberBooking.organization_member_product,
	        date: organizationMemberBooking.date,
	        startTime: organizationMemberBooking.start_time,
	        endTime: organizationMemberBooking.end_time,
	        status: organizationMemberBooking.status
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(organizationMemberBooking) {
	      return {
	        id: organizationMemberBooking.id,
	        product_id: organizationMemberBooking.product_id,
	        member_id: organizationMemberBooking.member_id,
	        client_id: organizationMemberBooking.client_id,
	        date: organizationMemberBooking.date,
	        start_time: organizationMemberBooking.start_time,
	        order_number: organizationMemberBooking.order_number
	      };
	    }
	  }]);
	
	  return OrganizationMemberBookingTransformer;
	}(_transformer2.default);
	
	exports.default = OrganizationMemberBookingTransformer;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var packageTransformer = function (_Transformer) {
	  _inherits(packageTransformer, _Transformer);
	
	  function packageTransformer() {
	    _classCallCheck(this, packageTransformer);
	
	    return _possibleConstructorReturn(this, (packageTransformer.__proto__ || Object.getPrototypeOf(packageTransformer)).apply(this, arguments));
	  }
	
	  _createClass(packageTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(pckg) {
	      return {
	        id: pckg.id,
	        packageUnitTypeId: pckg.package_unit_type_id,
	        packageUnitType: pckg.package_unit_type,
	        packageUnitTypeNoCode: pckg.package_unit_type_no_code,
	        parentId: pckg.parent_id,
	        sscc: pckg.sscc,
	        name: pckg.name,
	        packingLevel: pckg.packing_level,
	        numberOfProducts: pckg.number_of_products,
	        totalQuantity: pckg.total_quantity,
	        totalGrossWeight: pckg.total_gross_weight,
	        totalNetWeight: pckg.total_net_weight,
	        totalStackWeight: pckg.total_stack_weight
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(pckg) {
	      return {
	        order_id: pckg.orderId,
	        package_unit_type_id: pckg.packageUnitTypeId,
	        parent_id: pckg.parentId,
	        sscc: pckg.sscc,
	        package_type: pckg.packageType,
	        packing_level: pckg.packingLevel
	      };
	    }
	  }]);
	
	  return packageTransformer;
	}(_transformer2.default);
	
	exports.default = packageTransformer;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var packageTransformer = function (_Transformer) {
	  _inherits(packageTransformer, _Transformer);
	
	  function packageTransformer() {
	    _classCallCheck(this, packageTransformer);
	
	    return _possibleConstructorReturn(this, (packageTransformer.__proto__ || Object.getPrototypeOf(packageTransformer)).apply(this, arguments));
	  }
	
	  _createClass(packageTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(packageOrderProduct) {
	      return {
	        id: packageOrderProduct.id,
	        hashid: packageOrderProduct.hashid,
	        orderProductId: packageOrderProduct.order_product_id,
	        quantity: packageOrderProduct.quantity,
	        quantityUnit: packageOrderProduct.quantity_unit,
	        quantityText: packageOrderProduct.quantity_text,
	        grossWeight: packageOrderProduct.gross_weight,
	        netWeight: packageOrderProduct.net_weight,
	        stackWeight: packageOrderProduct.stack_weight,
	        bestBefore: packageOrderProduct.best_before,
	        maxTopLoad: packageOrderProduct.max_top_load,
	        batchLotNumber: packageOrderProduct.batch_lot_number,
	        temperatureRequirement: packageOrderProduct.temperature_requirement,
	        packageId: packageOrderProduct.package_id,
	        gtin: packageOrderProduct.gtin,
	        productName: packageOrderProduct.product_name,
	        quantityExceedError: packageOrderProduct.quantity_exceed_error,
	        weights: packageOrderProduct.weights,
	        temperatureText: packageOrderProduct.temperature_text
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(packageOrderProduct) {
	      return {
	        id: packageOrderProduct.id,
	        order_product_id: packageOrderProduct.orderProductId,
	        quantity: packageOrderProduct.quantity,
	        quantity_unit: packageOrderProduct.quantityUnit,
	        gross_weight: packageOrderProduct.grossWeight,
	        net_weight: packageOrderProduct.netWeight,
	        stack_weight: packageOrderProduct.stackWeight,
	        best_before: packageOrderProduct.bestBefore,
	        max_top_load: packageOrderProduct.maxTopLoad,
	        batch_lot_number: packageOrderProduct.batchLotNumber,
	        temperature_requirement: packageOrderProduct.temperatureRequirement,
	        package_id: packageOrderProduct.packageId
	      };
	    }
	  }]);
	
	  return packageTransformer;
	}(_transformer2.default);
	
	exports.default = packageTransformer;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostalTransformer = function (_Transformer) {
	  _inherits(PostalTransformer, _Transformer);
	
	  function PostalTransformer() {
	    _classCallCheck(this, PostalTransformer);
	
	    return _possibleConstructorReturn(this, (PostalTransformer.__proto__ || Object.getPrototypeOf(PostalTransformer)).apply(this, arguments));
	  }
	
	  _createClass(PostalTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(item) {
	      return {
	        id: item.id,
	        postalCode: item.postal_code,
	        cityId: item.city_id,
	        cityName: item.city_name,
	        municipalityId: item.municipality_id,
	        stateId: item.state_id
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(item) {
	      return {
	        id: item.id,
	        postal_code: item.postalCode,
	        city_id: item.cityId,
	        municipality_id: item.municipalityId,
	        state_id: item.stateId
	      };
	    }
	  }]);
	
	  return PostalTransformer;
	}(_transformer2.default);
	
	exports.default = PostalTransformer;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProducerTransformer = function (_Transformer) {
	  _inherits(ProducerTransformer, _Transformer);
	
	  function ProducerTransformer() {
	    _classCallCheck(this, ProducerTransformer);
	
	    return _possibleConstructorReturn(this, (ProducerTransformer.__proto__ || Object.getPrototypeOf(ProducerTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProducerTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(producer) {
	      return {
	        id: producer.id,
	        name: producer.name,
	        typeId: producer.type_id
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(producer) {
	      return {
	        id: producer.id,
	        name: producer.name,
	        type_id: producer.typeId
	      };
	    }
	  }]);
	
	  return ProducerTransformer;
	}(_transformer2.default);
	
	exports.default = ProducerTransformer;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarehouseTransactionTransformer = function (_Transformer) {
	  _inherits(WarehouseTransactionTransformer, _Transformer);
	
	  function WarehouseTransactionTransformer() {
	    _classCallCheck(this, WarehouseTransactionTransformer);
	
	    return _possibleConstructorReturn(this, (WarehouseTransactionTransformer.__proto__ || Object.getPrototypeOf(WarehouseTransactionTransformer)).apply(this, arguments));
	  }
	
	  _createClass(WarehouseTransactionTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(transaction) {
	      return {
	        id: transaction.id,
	        transactionId: transaction.transaction_id,
	        code: transaction.code,
	        via: transaction.via,
	        parentModelId: transaction.parent_model_id,
	        customerName: transaction.customer_name,
	        productName: transaction.product_name,
	        beforeQty: transaction.before_qty,
	        adjustmentQty: transaction.adjustment_qty,
	        afterQty: transaction.after_qty,
	        status: transaction.status,
	        createdAt: transaction.created_at,
	        warehouse: transaction.warehouse,
	        billingNumber: transaction.billing_number,
	        client: transaction.client,
	        batchName: transaction.batch_name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(transaction) {
	      return {
	        id: transaction.id
	      };
	    }
	  }]);
	
	  return WarehouseTransactionTransformer;
	}(_transformer2.default);
	
	exports.default = WarehouseTransactionTransformer;

/***/ }),
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1762),
	  /* template */
	  __webpack_require__(3024),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2360)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1784),
	  /* template */
	  __webpack_require__(3057),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2323)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1785),
	  /* template */
	  __webpack_require__(3004),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1789),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1792),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1798),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1799),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1803),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1820),
	  /* template */
	  __webpack_require__(3071),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2331)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1826),
	  /* template */
	  __webpack_require__(3020),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2333)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1838),
	  /* template */
	  __webpack_require__(3022),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-593382eb",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1862),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2319)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1895),
	  /* template */
	  __webpack_require__(2997),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2338)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1899),
	  /* template */
	  __webpack_require__(3030),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-5e4ab80e",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1942),
	  /* template */
	  __webpack_require__(2898),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _en = __webpack_require__(849);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _no = __webpack_require__(850);
	
	var _no2 = _interopRequireDefault(_no);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  en: _en2.default,
	  'nb-NO': _no2.default
	};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _address = __webpack_require__(194);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  _store2.default.dispatch('getAddress', _address2.default.fetch(data));
	
	  resolve(_address2.default.fetch(data));
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('addresses').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(879);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _adjustment = __webpack_require__(82);
	
	var _adjustment2 = _interopRequireDefault(_adjustment);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var adjustments = _adjustment2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedAdjustments', { adjustments: adjustments, pagination: pagination });
	  resolve({ adjustments: adjustments, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/adjustments', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fetchUserAppVersion = __webpack_require__(893);
	
	var _fetchUserAppVersion2 = _interopRequireDefault(_fetchUserAppVersion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchUserAppVersion: _fetchUserAppVersion2.default
	};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _batchIngredience = __webpack_require__(67);
	
	var _batchIngredience2 = _interopRequireDefault(_batchIngredience);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var batchIngrediences = _batchIngredience2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllMaterials', batchIngrediences);
	  resolve(batchIngrediences);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/production/batch_ingredience').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(930);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(447);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _store = __webpack_require__(931);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  items: _items2.default,
	  store: _store2.default
	};

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _batchLog = __webpack_require__(238);
	
	var _batchLog2 = _interopRequireDefault(_batchLog);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var batchLogs = _batchLog2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedBatchLogs', { batchLogs: batchLogs, pagination: pagination });
	  resolve(batchLogs);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('production/batch_log', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(290);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _search = __webpack_require__(950);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _store = __webpack_require__(951);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _bulkStore = __webpack_require__(948);
	
	var _bulkStore2 = _interopRequireDefault(_bulkStore);
	
	var _update = __webpack_require__(952);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _destroy = __webpack_require__(949);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  store: _store2.default,
	  bulkStore: _bulkStore2.default,
	  destroy: _destroy2.default,
	  search: _search2.default,
	  update: _update2.default
	};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(953);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(954);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(292);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(963);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _destroy = __webpack_require__(962);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  store: _store2.default,
	  destroy: _destroy2.default
	};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _campaign = __webpack_require__(163);
	
	var _campaign2 = _interopRequireDefault(_campaign);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var campaigns = _campaign2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedCampaigns', { campaigns: campaigns, pagination: pagination });
	  resolve(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('news_campaigns?page=' + page + '&limit=' + limit).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(968);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _clientGroup = __webpack_require__(129);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var clientGroups = _clientGroup2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedClientGroups', { clientGroups: clientGroups, pagination: pagination });
	  resolve(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('client_groups', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _contact = __webpack_require__(240);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  _store2.default.dispatch('getContact', _contact2.default.fetch(data));
	
	  resolve(_contact2.default.fetch(data));
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('contacts').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(1004);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _update = __webpack_require__(1005);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _show = __webpack_require__(1003);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _download = __webpack_require__(1002);
	
	var _download2 = _interopRequireDefault(_download);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  update: _update2.default,
	  show: _show2.default,
	  download: _download2.default
	};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1027);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _confirm = __webpack_require__(1028);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  confirm: _confirm2.default
	};

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fields = __webpack_require__(1042);
	
	var _fields2 = _interopRequireDefault(_fields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fields: _fields2.default
	};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1058);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(1059);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  store: _store2.default
	};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _destroy = __webpack_require__(1070);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _store = __webpack_require__(1072);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1071);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1073);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _all = __webpack_require__(1069);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  destroy: _destroy2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  all: _all2.default
	};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1079);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1085);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1130);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(1131);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  store: _store2.default
	};

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1132);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(1133);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _update = __webpack_require__(1134);
	
	var _update2 = _interopRequireDefault(_update);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  store: _store2.default,
	  update: _update2.default
	};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1162);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1163);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1165);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productGroup = __webpack_require__(110);
	
	var _productGroup2 = _interopRequireDefault(_productGroup);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var productGroups = _productGroup2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedProductGroups', { productGroups: productGroups, pagination: pagination });
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('product_groups', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var products = _product2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedProducts', { products: products, pagination: pagination });
	  resolve(products);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('product_bundles', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productFlow = __webpack_require__(133);
	
	var _productFlow2 = _interopRequireDefault(_productFlow);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var productFlows = _productFlow2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedproductFlows', { productFlows: productFlows, pagination: pagination });
	  resolve({ productFlows: productFlows, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/productflow', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productPackaging = __webpack_require__(134);
	
	var _productPackaging2 = _interopRequireDefault(_productPackaging);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var productPackagings = _productPackaging2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedProductPackagings', { productPackagings: productPackagings, pagination: pagination });
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('product_packagings', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1216);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1217);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _publicProfile = __webpack_require__(242);
	
	var _publicProfile2 = _interopRequireDefault(_publicProfile);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  _store2.default.dispatch('getPublicProfile', _publicProfile2.default.fetch(data));
	
	  resolve(_publicProfile2.default.fetch(data));
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('public_profile').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _purchase = __webpack_require__(58);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var purchases = _purchase2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedPurchases', { purchases: purchases, pagination: pagination });
	  resolve({ purchases: purchases, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/purchases', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1248);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _recipeIngredience = __webpack_require__(111);
	
	var _recipeIngredience2 = _interopRequireDefault(_recipeIngredience);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var recipeIngrediences = _recipeIngredience2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllMaterials', recipeIngrediences);
	  resolve(recipeIngrediences);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/production/recipe_ingredience').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _recipeProcedure = __webpack_require__(136);
	
	var _recipeProcedure2 = _interopRequireDefault(_recipeProcedure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var recipeProcedures = _recipeProcedure2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllRecipeProcedures', recipeProcedures);
	  resolve(recipeProcedures);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/production/recipe_procedure').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1269);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _shippingProvider = __webpack_require__(199);
	
	var _shippingProvider2 = _interopRequireDefault(_shippingProvider);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var shippingProviders = _shippingProvider2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('FetchAllShippingProviders', shippingProviders);
	  resolve(shippingProviders);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/shipping_providers', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1294);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _stock = __webpack_require__(68);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var stocks = _stock2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedStocks', { stocks: stocks, pagination: pagination });
	  resolve({ stocks: stocks, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/stocks', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1309);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(1312);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _items = __webpack_require__(1311);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _destroy = __webpack_require__(1310);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _subscribeSwitch = __webpack_require__(1313);
	
	var _subscribeSwitch2 = _interopRequireDefault(_subscribeSwitch);
	
	var _subscribeSwitchAll = __webpack_require__(1314);
	
	var _subscribeSwitchAll2 = _interopRequireDefault(_subscribeSwitchAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  store: _store2.default,
	  items: _items2.default,
	  destroy: _destroy2.default,
	  subscribeSwitch: _subscribeSwitch2.default,
	  subscribeSwitchAll: _subscribeSwitchAll2.default
	};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _supplier = __webpack_require__(112);
	
	var _supplier2 = _interopRequireDefault(_supplier);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var suppliers = _supplier2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedSuppliers', { suppliers: suppliers, pagination: pagination });
	  resolve({ suppliers: suppliers, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/suppliers', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1330);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _find = __webpack_require__(1331);
	
	var _find2 = _interopRequireDefault(_find);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  find: _find2.default
	};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _authorize = __webpack_require__(1339);
	
	var _authorize2 = _interopRequireDefault(_authorize);
	
	var _token = __webpack_require__(1342);
	
	var _token2 = _interopRequireDefault(_token);
	
	var _status = __webpack_require__(1341);
	
	var _status2 = _interopRequireDefault(_status);
	
	var _numberSeries = __webpack_require__(1340);
	
	var _numberSeries2 = _interopRequireDefault(_numberSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  authorize: _authorize2.default,
	  token: _token2.default,
	  status: _status2.default,
	  numberSeries: _numberSeries2.default
	};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _unitOfMeasure = __webpack_require__(137);
	
	var _unitOfMeasure2 = _interopRequireDefault(_unitOfMeasure);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var unitOfMeasures = _unitOfMeasure2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedUnitOfMeasures', { unitOfMeasures: unitOfMeasures, pagination: pagination });
	  resolve({ unitOfMeasures: unitOfMeasures, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/unit_of_measures', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _warehouse = __webpack_require__(62);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var warehouses = _warehouse2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedWarehouses', { warehouses: warehouses, pagination: pagination });
	  resolve({ warehouses: warehouses, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/warehouses', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var widgetsData = data;
	  _store2.default.dispatch('fetchWidgets', widgetsData);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('user-widgets').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setBridgeHandoff = exports.resetProjects = exports.fetchAllProjects = exports.fetchProjects = exports.fetchCurrencies = exports.fetchLanguages = exports.fetchPaymentMethods = exports.setOrderPickupQuery = exports.resetOrderPickups = exports.fetchOrderPickupEvents = exports.fetchCurrentOrderPickup = exports.fetchOrderPickupTypes = exports.fetchAllOrderPickups = exports.fetchPaginatedOrderPickups = exports.fetchAllPartners = exports.fetchLatestVersion = exports.fetchToastResp = exports.fetchAllPackageOrderProducts = exports.fetchAllPackages = exports.fetchAllPackageUnitTypes = exports.fetchPaginatedSubscriber = exports.fetchAllSubscriber = exports.setCancelClientGroupAdd = exports.setchModifiedClientGroup = exports.fetchCurrentSubscriberList = exports.fetchPaginatedSubscriberList = exports.fetchAllSubscriberList = exports.fetchPaginatedExcisePeriods = exports.fetchAllLicensePermitGroups = exports.fetchAllLicenseGroups = exports.fetchAllLicensePermitTypes = exports.fetchAllLicensePermits = exports.setNullLicenseType = exports.fetchAllLicenseTypes = exports.fetchAllLicenses = exports.fetchCurrentTransfer = exports.fetchPaginatedTransfers = exports.FetchAllTransfers = exports.fetchAllTransactionTypes = exports.fetchAllModules = exports.addOrganizationMemberBooking = exports.fetchAllOrganizationMemberBookings = exports.fetchAllOrganizationMemberProductBusinessHours = exports.addOrganizationMember = exports.fetchAllOrganizationMembers = exports.fetchAdditionalCode = exports.setNullOnExciseGroup = exports.fetchExciseBasicGroup = exports.fetchExcisePackagingGroup = exports.fetchExciseGroup = exports.fetchproductFlowOrders = exports.fetchCurrentproductFlow = exports.fetchPaginatedproductFlows = exports.FetchAllproductFlows = exports.fetchCurrentShippingProvider = exports.FetchAllShippingProviders = exports.setOrderTypeView = undefined;
	exports.setView = exports.fetchPurchaseStatuses = exports.fetchCurrentPurchase = exports.fetchPaginatedPurchases = exports.FetchAllPurchases = exports.fetchCurrentAdjustment = exports.fetchPaginatedAdjustments = exports.FetchAllAdjustments = exports.RefreshStockProductsCustom = exports.RefreshStockProducts = exports.PushToStockProductsCustom = exports.allCurrentStockProductsCustom = exports.EditToStockProducts = exports.DeleteFromStockProductsCustom = exports.UpdateToStockProducts = exports.deleteStockProduct = exports.setStockSelectedWarehouse = exports.PushToStockProducts = exports.allCurrentStockProducts = exports.fetchCurrentStock = exports.fetchPaginatedStocks = exports.FetchAllStocks = exports.fetchCurrentUnitOfMeasure = exports.fetchPaginatedUnitOfMeasures = exports.FetchAllUnitOfMeasures = exports.fetchPaginatedWarehouseTransactionsV2 = exports.fetchAllWarehouseTransactionsV2 = exports.fetchAllWarehouseTransactions = exports.fetchPaginatedWarehouseProducts = exports.fetchCurrentWarehouse = exports.fetchPaginatedWarehouses = exports.FetchAllWarehouses = exports.fetchCurrentSupplier = exports.fetchPaginatedSuppliers = exports.FetchAllSuppliers = exports.fetchCampaignTypes = exports.fetchPaginatedCampaigns = exports.removeChartOfAccountsItem = exports.updateChartOfAccountsItem = exports.addChartOfAccountsItem = exports.fetchAllChartOfAccounts = exports.fetchAllAccountingProviders = exports.fetchAllMessageTemplateTypes = exports.updateEdiOrderItem = exports.fetchAllEdiOrderItems = exports.fetchCurrentEdiOrder = exports.fetchPaginatedEdiOrders = exports.fetchAllEdiOrders = exports.removeCreditNoteProduct = exports.updateCreditNoteProduct = exports.addCreditNoteProduct = exports.fetchAllCreditNoteProducts = exports.removeBillProduct = exports.updateBillProduct = exports.addBillProduct = exports.fetchAllBillProducts = exports.removeOrderProduct = exports.updateOrderProduct = exports.addOrderProduct = exports.fetchAllOrderProducts = exports.fetchCurrentCreditNoteReason = exports.fetchAllCreditNoteReasons = exports.setBillQuery = exports.fetchCurrentBill = exports.fetchBillTypes = exports.fetchBillStatuses = exports.fetchPaginatedBills = exports.destroyBusinessHourException = exports.storeBusinessHourException = exports.fetchBusinessHourExceptions = exports.destroyBusinessHour = exports.storeBusinessHour = exports.fetchBusinessHours = exports.fetchBusinessDays = exports.fetchTaxes = exports.fetchPostals = exports.fetchMunicipalities = exports.fetchCities = exports.fetchCountries = exports.fetchSiteLanguages = exports.fetchSoldProductsDataWidgets = exports.fetchPopularProductsDataWidgets = exports.fetchRevenueDataWidgets = exports.fetchOrderReceivedDataWidgets = exports.fetchWaitingDeiveredDataWidgets = exports.fetchWaitingProcessedDataWidgets = exports.fetchBestClientsDataWidgets = exports.fetchWidgets = exports.fetchAvailableWidgets = exports.setOrderQuery = exports.resetOrders = exports.fetchOrderEvents = exports.fetchCurrentOrder = exports.fetchOrderTypes = exports.fetchAllOrders = exports.fetchPaginatedOrders = exports.fetchPaginatedPriceFields = exports.fetchAllPriceFields = exports.fetchPaginatedProductTags = exports.fetchAllProductTags = undefined;
	exports.fetchAllProductGroups = exports.fetchAllProducers = exports.fetchAllProductRecommendations = exports.fetchAllProductSubtypes = exports.fetchAllProductTypes = exports.fetchUnitTypes = exports.fetchPackagingTypes = exports.setNullProductPackagings = exports.fetchAllProductPackagings = exports.fetchPackagingMaterials = exports.fetchPaginatedProductPackagings = exports.fetchPaginatedProductGroups = exports.removeProductPrice = exports.updateProductPrice = exports.addProductPrice = exports.fetchAllProductPrice = exports.setNullDepositSystem = exports.fetchAllDepositSystems = exports.setNullDeposit = exports.fetchAllProductDeposits = exports.resetProducts = exports.setProductGrouping = exports.setProductQuery = exports.fetchProductTransactionsV2 = exports.fetchAllProductTransactionsV2 = exports.fetchAllProductTransactions = exports.fetchAllProductsBasic = exports.fetchAllProducts = exports.fetchPaginatedProducts = exports.deleteClientAddress = exports.updateClientAddress = exports.addClientAddress = exports.setCurrentClientAddresses = exports.deleteClientContact = exports.updateClientContact = exports.addClientContact = exports.setCurrentClientContacts = exports.fetchaddressTypes = exports.fetchcontactTypes = exports.setEquipmentQuery = exports.fetchAllEquipments = exports.fetchPaginatedEquipments = exports.removeRecipeProduct = exports.addRecipeProduct = exports.fetchAllRecipeProducts = exports.removeRecipeProcedure = exports.updateRecipeProcedure = exports.addRecipeProcedure = exports.fetchAllRecipeProcedures = exports.removeBatchIngredience = exports.updateBatchIngredience = exports.addBatchIngredience = exports.fetchAllBatchIngrediences = exports.removeRecipeIngredience = exports.updateRecipeIngredience = exports.addRecipeIngredience = exports.fetchAllRecipeIngrediences = exports.fetchAllRecipeTypes = exports.setRecipeQuery = exports.fetchAllRecipes = exports.fetchPaginatedRecipes = exports.setBatchLogQuery = exports.fetchAllBatchLogs = exports.fetchPaginatedBatchLogs = exports.setBatchQuery = exports.addBatch = exports.fetchAllBatches = exports.fetchPaginatedBatches = exports.fetchAllMaterialTypes = exports.setMaterialQuery = exports.fetchAllMaterials = exports.fetchPaginatedMaterials = exports.updateClientGroup = exports.fetchAllClientGroups = exports.fetchPaginatedClientGroups = exports.setClientQuery = exports.resetClients = exports.fetchAllClientOptions = exports.fetchAllClients = exports.fetchClients = exports.fetchAllClientTypes = exports.fetchAllOrganizationTypes = exports.setChosenPlan = exports.fetchAllPlans = exports.checkTwoFactorVerification = exports.twoFactorVerification = exports.checkAuthentication = exports.logout = exports.login = exports.setMaintenanceMode = exports.setNewClientProvider = exports.setNewProviderItemList = exports.setClientProvider = exports.setDownloadProviderList = exports.setSelectedProvider = exports.getPublicProfile = exports.getOrganizationSettings = exports.getContact = exports.getAddress = exports.getAccount = undefined;
	
	var _mutationTypes = __webpack_require__(10);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var getAccount = exports.getAccount = function getAccount(_ref, account) {
	  var commit = _ref.commit;
	
	  commit(types.GET_ACCOUNT, account);
	};
	
	var getAddress = exports.getAddress = function getAddress(_ref2, address) {
	  var commit = _ref2.commit;
	
	  commit(types.GET_ADDRESS, address);
	};
	
	var getContact = exports.getContact = function getContact(_ref3, contact) {
	  var commit = _ref3.commit;
	
	  commit(types.GET_CONTACT, contact);
	};
	
	var getOrganizationSettings = exports.getOrganizationSettings = function getOrganizationSettings(_ref4, settings) {
	  var commit = _ref4.commit;
	
	  commit(types.GET_ORGANIZATION_SETTINGS, settings);
	};
	
	var getPublicProfile = exports.getPublicProfile = function getPublicProfile(_ref5, publicProfile) {
	  var commit = _ref5.commit;
	
	  commit(types.GET_PUBLIC_PROFILE, publicProfile);
	};
	
	var setSelectedProvider = exports.setSelectedProvider = function setSelectedProvider(_ref6, selectedProvider) {
	  var commit = _ref6.commit;
	
	  commit(types.SELECTED_PROVIDER, selectedProvider);
	};
	
	var setDownloadProviderList = exports.setDownloadProviderList = function setDownloadProviderList(_ref7, providerList) {
	  var commit = _ref7.commit;
	
	  commit(types.DOWNLOAD_PROVIDER_LIST, providerList);
	};
	
	var setClientProvider = exports.setClientProvider = function setClientProvider(_ref8, clientProviderItem) {
	  var commit = _ref8.commit;
	
	  commit(types.CLIENT_PROVIDER, clientProviderItem);
	};
	
	var setNewProviderItemList = exports.setNewProviderItemList = function setNewProviderItemList(_ref9, newPproviderList) {
	  var commit = _ref9.commit;
	
	  commit(types.ADD_NEW_DOWNLOAD_PROVIDER_LIST, newPproviderList);
	};
	
	var setNewClientProvider = exports.setNewClientProvider = function setNewClientProvider(_ref10, newPproviderList) {
	  var commit = _ref10.commit;
	
	  commit(types.ADD_NEW_DOWNLOAD_PROVIDER_LIST, newPproviderList);
	};
	
	var setMaintenanceMode = exports.setMaintenanceMode = function setMaintenanceMode(_ref11, status) {
	  var commit = _ref11.commit;
	
	  commit(types.SET_MAINTENANCE_MODE, status);
	};
	
	var login = exports.login = function login(_ref12, token) {
	  var commit = _ref12.commit;
	
	  commit(types.LOGIN, token);
	};
	
	var logout = exports.logout = function logout(_ref13) {
	  var commit = _ref13.commit;
	
	  commit(types.RESET_PROFILE);
	  commit(types.RESET_CLIENTS);
	  commit(types.RESET_CLIENT_GROUPS);
	  commit(types.RESET_PRODUCTS);
	  commit(types.RESET_PRODUCT_GROUPS);
	  commit(types.RESET_ORDERS);
	  commit(types.RESET_ORDER_PRODUCTS);
	  commit(types.RESET_CREDIT_NOTE_PRODUCTS);
	  commit(types.RESET_BILL_PRODUCTS);
	  commit(types.RESET_BILLS);
	  commit(types.LOGOUT);
	};
	
	var checkAuthentication = exports.checkAuthentication = function checkAuthentication(_ref14) {
	  var commit = _ref14.commit;
	
	  commit(types.CHECK_AUTHENTICATION);
	};
	
	var twoFactorVerification = exports.twoFactorVerification = function twoFactorVerification(_ref15, _ref16) {
	  var commit = _ref15.commit;
	  var token = _ref16.token,
	      userId = _ref16.userId,
	      verificationType = _ref16.verificationType,
	      mobileNumber = _ref16.mobileNumber;
	
	  commit(types.TWO_FACTOR_VERIFICATION, {
	    token: token,
	    userId: userId,
	    verificationType: verificationType,
	    mobileNumber: mobileNumber
	  });
	};
	
	var checkTwoFactorVerification = exports.checkTwoFactorVerification = function checkTwoFactorVerification(_ref17) {
	  var commit = _ref17.commit;
	
	  commit(types.CHECK_TWO_FACTOR_VERIFICATION);
	};
	
	var fetchAllPlans = exports.fetchAllPlans = function fetchAllPlans(_ref18, plans) {
	  var commit = _ref18.commit;
	
	  commit(types.FETCH_ALL_PLANS, plans);
	};
	
	var setChosenPlan = exports.setChosenPlan = function setChosenPlan(_ref19, plan) {
	  var commit = _ref19.commit;
	
	  commit(types.SET_CHOSEN_PLAN, plan);
	};
	
	var fetchAllOrganizationTypes = exports.fetchAllOrganizationTypes = function fetchAllOrganizationTypes(_ref20, organizationTypes) {
	  var commit = _ref20.commit;
	
	  commit(types.FETCH_ALL_ORGANIZATION_TYPES, organizationTypes);
	};
	
	var fetchAllClientTypes = exports.fetchAllClientTypes = function fetchAllClientTypes(_ref21, clientTypes) {
	  var commit = _ref21.commit;
	
	  commit(types.FETCH_ALL_CLIENT_TYPES, clientTypes);
	};
	
	var fetchClients = exports.fetchClients = function fetchClients(_ref22, _ref23) {
	  var commit = _ref22.commit;
	  var clients = _ref23.clients,
	      pagination = _ref23.pagination;
	
	  commit(types.FETCH_CLIENTS, { clients: clients, pagination: pagination });
	};
	
	var fetchAllClients = exports.fetchAllClients = function fetchAllClients(_ref24, clients) {
	  var commit = _ref24.commit;
	
	  commit(types.FETCH_ALL_CLIENTS, clients);
	};
	
	var fetchAllClientOptions = exports.fetchAllClientOptions = function fetchAllClientOptions(_ref25, clients) {
	  var commit = _ref25.commit;
	
	  commit(types.FETCH_ALL_CLIENT_OPTIONS, clients);
	};
	
	var resetClients = exports.resetClients = function resetClients(_ref26) {
	  var commit = _ref26.commit;
	
	  commit(types.RESET_CLIENTS);
	};
	
	var setClientQuery = exports.setClientQuery = function setClientQuery(_ref27, _ref28) {
	  var commit = _ref27.commit;
	  var page = _ref28.page,
	      limit = _ref28.limit,
	      search = _ref28.search;
	
	  commit(types.CLIENT_QUERY, { page: page, limit: limit, search: search });
	};
	
	var fetchPaginatedClientGroups = exports.fetchPaginatedClientGroups = function fetchPaginatedClientGroups(_ref29, _ref30) {
	  var commit = _ref29.commit;
	  var clientGroups = _ref30.clientGroups,
	      pagination = _ref30.pagination;
	
	  commit(types.FETCH_PAGINATED_CLIENT_GROUPS, { clientGroups: clientGroups, pagination: pagination });
	};
	
	var fetchAllClientGroups = exports.fetchAllClientGroups = function fetchAllClientGroups(_ref31, clientGroups) {
	  var commit = _ref31.commit;
	
	  commit(types.FETCH_ALL_CLIENT_GROUPS, clientGroups);
	};
	
	var updateClientGroup = exports.updateClientGroup = function updateClientGroup(_ref32, clientGroup) {
	  var commit = _ref32.commit;
	
	  commit(types.UPDATE_CLIENT_GROUP, clientGroup);
	};
	
	var fetchPaginatedMaterials = exports.fetchPaginatedMaterials = function fetchPaginatedMaterials(_ref33, _ref34) {
	  var commit = _ref33.commit;
	  var materials = _ref34.materials,
	      pagination = _ref34.pagination;
	
	  commit(types.FETCH_PAGINATED_MATERIALS, { materials: materials, pagination: pagination });
	};
	
	var fetchAllMaterials = exports.fetchAllMaterials = function fetchAllMaterials(_ref35, materials) {
	  var commit = _ref35.commit;
	
	  commit(types.FETCH_ALL_MATERIALS, materials);
	};
	
	var setMaterialQuery = exports.setMaterialQuery = function setMaterialQuery(_ref36, _ref37) {
	  var commit = _ref36.commit;
	  var page = _ref37.page,
	      limit = _ref37.limit,
	      search = _ref37.search;
	
	  commit(types.MATERIAL_QUERY, { page: page, limit: limit, search: search });
	};
	
	var fetchAllMaterialTypes = exports.fetchAllMaterialTypes = function fetchAllMaterialTypes(_ref38, materialTypes) {
	  var commit = _ref38.commit;
	
	  commit(types.FETCH_ALL_MATERIAL_TYPES, materialTypes);
	};
	
	var fetchPaginatedBatches = exports.fetchPaginatedBatches = function fetchPaginatedBatches(_ref39, _ref40) {
	  var commit = _ref39.commit;
	  var batches = _ref40.batches,
	      pagination = _ref40.pagination;
	
	  commit(types.FETCH_PAGINATED_BATCHES, { batches: batches, pagination: pagination });
	};
	
	var fetchAllBatches = exports.fetchAllBatches = function fetchAllBatches(_ref41, batches) {
	  var commit = _ref41.commit;
	
	  commit(types.FETCH_ALL_BATCHES, batches);
	};
	
	var addBatch = exports.addBatch = function addBatch(_ref42, batch) {
	  var commit = _ref42.commit;
	
	  commit(types.ADD_BATCH, batch);
	};
	
	var setBatchQuery = exports.setBatchQuery = function setBatchQuery(_ref43, _ref44) {
	  var commit = _ref43.commit;
	  var page = _ref44.page,
	      limit = _ref44.limit,
	      search = _ref44.search;
	
	  commit(types.BATCH_QUERY, { page: page, limit: limit, search: search });
	};
	
	var fetchPaginatedBatchLogs = exports.fetchPaginatedBatchLogs = function fetchPaginatedBatchLogs(_ref45, _ref46) {
	  var commit = _ref45.commit;
	  var batchLogs = _ref46.batchLogs,
	      pagination = _ref46.pagination;
	
	  commit(types.FETCH_PAGINATED_BATCH_LOGS, { batchLogs: batchLogs, pagination: pagination });
	};
	
	var fetchAllBatchLogs = exports.fetchAllBatchLogs = function fetchAllBatchLogs(_ref47, batchLogs) {
	  var commit = _ref47.commit;
	
	  commit(types.FETCH_ALL_BATCH_LOGS, batchLogs);
	};
	
	var setBatchLogQuery = exports.setBatchLogQuery = function setBatchLogQuery(_ref48, _ref49) {
	  var commit = _ref48.commit;
	  var page = _ref49.page,
	      limit = _ref49.limit,
	      search = _ref49.search;
	
	  commit(types.BATCH_QUERY, { page: page, limit: limit, search: search });
	};
	
	var fetchPaginatedRecipes = exports.fetchPaginatedRecipes = function fetchPaginatedRecipes(_ref50, _ref51) {
	  var commit = _ref50.commit;
	  var recipes = _ref51.recipes,
	      pagination = _ref51.pagination;
	
	  commit(types.FETCH_PAGINATED_RECIPES, { recipes: recipes, pagination: pagination });
	};
	
	var fetchAllRecipes = exports.fetchAllRecipes = function fetchAllRecipes(_ref52, recipes) {
	  var commit = _ref52.commit;
	
	  commit(types.FETCH_ALL_RECIPES, recipes);
	};
	
	var setRecipeQuery = exports.setRecipeQuery = function setRecipeQuery(_ref53, _ref54) {
	  var commit = _ref53.commit;
	  var page = _ref54.page,
	      limit = _ref54.limit,
	      search = _ref54.search;
	
	  commit(types.RECIPE_QUERY, { page: page, limit: limit, search: search });
	};
	
	var fetchAllRecipeTypes = exports.fetchAllRecipeTypes = function fetchAllRecipeTypes(_ref55, recipeTypes) {
	  var commit = _ref55.commit;
	
	  commit(types.FETCH_ALL_RECIPE_TYPES, recipeTypes);
	};
	
	var fetchAllRecipeIngrediences = exports.fetchAllRecipeIngrediences = function fetchAllRecipeIngrediences(_ref56, recipeIngrediences) {
	  var commit = _ref56.commit;
	
	  commit(types.FETCH_ALL_RECIPE_INGREDIENCES, recipeIngrediences);
	};
	
	var addRecipeIngredience = exports.addRecipeIngredience = function addRecipeIngredience(_ref57, recipeIngredience) {
	  var commit = _ref57.commit;
	
	  commit(types.ADD_RECIPE_INGREDIENCE, recipeIngredience);
	};
	
	var updateRecipeIngredience = exports.updateRecipeIngredience = function updateRecipeIngredience(_ref58, _ref59) {
	  var commit = _ref58.commit;
	  var recipeIngredience = _ref59.recipeIngredience,
	      id = _ref59.id;
	
	  commit(types.UPDATE_RECIPE_INGREDIENCE, { recipeIngredience: recipeIngredience, id: id });
	};
	
	var removeRecipeIngredience = exports.removeRecipeIngredience = function removeRecipeIngredience(_ref60, id) {
	  var commit = _ref60.commit;
	
	  commit(types.REMOVE_RECIPE_INGREDIENCE, id);
	};
	
	var fetchAllBatchIngrediences = exports.fetchAllBatchIngrediences = function fetchAllBatchIngrediences(_ref61, batchIngrediences) {
	  var commit = _ref61.commit;
	
	  commit(types.FETCH_ALL_BATCH_INGREDIENCES, batchIngrediences);
	};
	
	var addBatchIngredience = exports.addBatchIngredience = function addBatchIngredience(_ref62, batchIngredience) {
	  var commit = _ref62.commit;
	
	  commit(types.ADD_BATCH_INGREDIENCE, batchIngredience);
	};
	
	var updateBatchIngredience = exports.updateBatchIngredience = function updateBatchIngredience(_ref63, _ref64) {
	  var commit = _ref63.commit;
	  var batchIngredience = _ref64.batchIngredience,
	      id = _ref64.id;
	
	  commit(types.UPDATE_BATCH_INGREDIENCE, { batchIngredience: batchIngredience, id: id });
	};
	
	var removeBatchIngredience = exports.removeBatchIngredience = function removeBatchIngredience(_ref65, id) {
	  var commit = _ref65.commit;
	
	  commit(types.REMOVE_BATCH_INGREDIENCE, id);
	};
	
	var fetchAllRecipeProcedures = exports.fetchAllRecipeProcedures = function fetchAllRecipeProcedures(_ref66, recipeProcedures) {
	  var commit = _ref66.commit;
	
	  commit(types.FETCH_ALL_RECIPE_PROCEDURES, recipeProcedures);
	};
	
	var addRecipeProcedure = exports.addRecipeProcedure = function addRecipeProcedure(_ref67, recipeProcedure) {
	  var commit = _ref67.commit;
	
	  commit(types.ADD_RECIPE_PROCEDURE, recipeProcedure);
	};
	
	var updateRecipeProcedure = exports.updateRecipeProcedure = function updateRecipeProcedure(_ref68, _ref69) {
	  var commit = _ref68.commit;
	  var recipeProcedure = _ref69.recipeProcedure,
	      id = _ref69.id;
	
	  commit(types.UPDATE_RECIPE_PROCEDURE, { recipeProcedure: recipeProcedure, id: id });
	};
	
	var removeRecipeProcedure = exports.removeRecipeProcedure = function removeRecipeProcedure(_ref70, id) {
	  var commit = _ref70.commit;
	
	  commit(types.REMOVE_RECIPE_PROCEDURE, id);
	};
	
	var fetchAllRecipeProducts = exports.fetchAllRecipeProducts = function fetchAllRecipeProducts(_ref71, recipeProducts) {
	  var commit = _ref71.commit;
	
	  commit(types.FETCH_ALL_RECIPE_PRODUCTS, recipeProducts);
	};
	
	var addRecipeProduct = exports.addRecipeProduct = function addRecipeProduct(_ref72, recipeProduct) {
	  var commit = _ref72.commit;
	
	  commit(types.ADD_RECIPE_PRODUCT, recipeProduct);
	};
	
	var removeRecipeProduct = exports.removeRecipeProduct = function removeRecipeProduct(_ref73, id) {
	  var commit = _ref73.commit;
	
	  commit(types.REMOVE_RECIPE_PRODUCT, id);
	};
	
	var fetchPaginatedEquipments = exports.fetchPaginatedEquipments = function fetchPaginatedEquipments(_ref74, _ref75) {
	  var commit = _ref74.commit;
	  var equipments = _ref75.equipments,
	      pagination = _ref75.pagination;
	
	  commit(types.FETCH_PAGINATED_EQUIPMENTS, { equipments: equipments, pagination: pagination });
	};
	
	var fetchAllEquipments = exports.fetchAllEquipments = function fetchAllEquipments(_ref76, equipments) {
	  var commit = _ref76.commit;
	
	  commit(types.FETCH_ALL_EQUIPMENTS, equipments);
	};
	
	var setEquipmentQuery = exports.setEquipmentQuery = function setEquipmentQuery(_ref77, _ref78) {
	  var commit = _ref77.commit;
	  var page = _ref78.page,
	      limit = _ref78.limit,
	      search = _ref78.search;
	
	  commit(types.EQUIPMENT_QUERY, { page: page, limit: limit, search: search });
	};
	
	var fetchcontactTypes = exports.fetchcontactTypes = function fetchcontactTypes(_ref79, contactTypes) {
	  var commit = _ref79.commit;
	
	  commit(types.FETCH_CONTACT_TYPES, contactTypes);
	};
	
	var fetchaddressTypes = exports.fetchaddressTypes = function fetchaddressTypes(_ref80, addressTypes) {
	  var commit = _ref80.commit;
	
	  commit(types.FETCH_ADDRESS_TYPES, addressTypes);
	};
	
	var setCurrentClientContacts = exports.setCurrentClientContacts = function setCurrentClientContacts(_ref81, clientContacts) {
	  var commit = _ref81.commit;
	
	  commit(types.SET_CURRENT_CLIENT_CONTACTS, clientContacts);
	};
	
	var addClientContact = exports.addClientContact = function addClientContact(_ref82, clientContact) {
	  var commit = _ref82.commit;
	
	  commit(types.ADD_CLIENT_CONTACT, clientContact);
	};
	
	var updateClientContact = exports.updateClientContact = function updateClientContact(_ref83, _ref84) {
	  var commit = _ref83.commit;
	  var data = _ref84.data,
	      i = _ref84.i;
	
	  commit(types.UPDATE_CLIENT_CONTACT, { data: data, i: i });
	};
	
	var deleteClientContact = exports.deleteClientContact = function deleteClientContact(_ref85, i) {
	  var commit = _ref85.commit;
	
	  commit(types.DELETE_CLIENT_CONTACT, i);
	};
	
	var setCurrentClientAddresses = exports.setCurrentClientAddresses = function setCurrentClientAddresses(_ref86, clientAddresses) {
	  var commit = _ref86.commit;
	
	  commit(types.SET_CURRENT_CLIENT_ADDRESSES, clientAddresses);
	};
	
	var addClientAddress = exports.addClientAddress = function addClientAddress(_ref87, clientAddress) {
	  var commit = _ref87.commit;
	
	  commit(types.ADD_CLIENT_ADDRESS, clientAddress);
	};
	
	var updateClientAddress = exports.updateClientAddress = function updateClientAddress(_ref88, _ref89) {
	  var commit = _ref88.commit;
	  var data = _ref89.data,
	      i = _ref89.i;
	
	  commit(types.UPDATE_CLIENT_ADDRESS, { data: data, i: i });
	};
	
	var deleteClientAddress = exports.deleteClientAddress = function deleteClientAddress(_ref90, i) {
	  var commit = _ref90.commit;
	
	  commit(types.DELETE_CLIENT_ADDRESS, i);
	};
	
	var fetchPaginatedProducts = exports.fetchPaginatedProducts = function fetchPaginatedProducts(_ref91, _ref92) {
	  var commit = _ref91.commit;
	  var products = _ref92.products,
	      pagination = _ref92.pagination;
	
	  commit(types.FETCH_PAGINATED_PRODUCTS, { products: products, pagination: pagination });
	};
	
	var fetchAllProducts = exports.fetchAllProducts = function fetchAllProducts(_ref93, products) {
	  var commit = _ref93.commit;
	
	  commit(types.FETCH_ALL_PRODUCTS, products);
	};
	
	var fetchAllProductsBasic = exports.fetchAllProductsBasic = function fetchAllProductsBasic(_ref94, products) {
	  var commit = _ref94.commit;
	
	  commit(types.FETCH_ALL_PRODUCTS_BASIC, products);
	};
	
	var fetchAllProductTransactions = exports.fetchAllProductTransactions = function fetchAllProductTransactions(_ref95, transasctions) {
	  var commit = _ref95.commit;
	
	  commit(types.FETCH_ALL_PRODUCT_TRANSACTIONS, transasctions);
	};
	
	var fetchAllProductTransactionsV2 = exports.fetchAllProductTransactionsV2 = function fetchAllProductTransactionsV2(_ref96, transactionsV2) {
	  var commit = _ref96.commit;
	
	  commit(types.FETCH_ALL_PRODUCT_TRANSACTIONSV2, transactionsV2);
	};
	
	var fetchProductTransactionsV2 = exports.fetchProductTransactionsV2 = function fetchProductTransactionsV2(_ref97, _ref98) {
	  var commit = _ref97.commit;
	  var transactionsV2 = _ref98.transactionsV2,
	      pagination = _ref98.pagination;
	
	  commit(types.FETCH_PRODUCT_TRANSACTIONSV2, { transactionsV2: transactionsV2, pagination: pagination });
	};
	
	var setProductQuery = exports.setProductQuery = function setProductQuery(_ref99, _ref100) {
	  var commit = _ref99.commit;
	  var page = _ref100.page,
	      limit = _ref100.limit,
	      search = _ref100.search,
	      grouping = _ref100.grouping;
	
	  commit(types.PRODUCT_QUERY, { page: page, limit: limit, search: search, grouping: grouping });
	};
	
	var setProductGrouping = exports.setProductGrouping = function setProductGrouping(_ref101, grouping) {
	  var commit = _ref101.commit;
	
	  commit(types.SET_PRODUCT_GROUPING, grouping);
	};
	
	var resetProducts = exports.resetProducts = function resetProducts(_ref102) {
	  var commit = _ref102.commit;
	
	  commit(types.RESET_PRODUCTS);
	};
	
	var fetchAllProductDeposits = exports.fetchAllProductDeposits = function fetchAllProductDeposits(_ref103, productDeposits) {
	  var commit = _ref103.commit;
	
	  commit(types.FETCH_ALL_PRODUCT_DEPOSITS, productDeposits);
	};
	
	var setNullDeposit = exports.setNullDeposit = function setNullDeposit(_ref104) {
	  var commit = _ref104.commit;
	
	  commit(types.ADD_NULL_DEPOSIT_LIST);
	};
	
	var fetchAllDepositSystems = exports.fetchAllDepositSystems = function fetchAllDepositSystems(_ref105, depositSystems) {
	  var commit = _ref105.commit;
	
	  commit(types.FETCH_ALL_DEPOSIT_SYSTEMS, depositSystems);
	};
	
	var setNullDepositSystem = exports.setNullDepositSystem = function setNullDepositSystem(_ref106) {
	  var commit = _ref106.commit;
	
	  commit(types.ADD_NULL_DEPOSIT_SYSTEM);
	};
	
	var fetchAllProductPrice = exports.fetchAllProductPrice = function fetchAllProductPrice(_ref107, productPrices) {
	  var commit = _ref107.commit;
	
	  commit(types.FETCH_PRODUCT_PRICES, productPrices);
	};
	
	var addProductPrice = exports.addProductPrice = function addProductPrice(_ref108, productPrice) {
	  var commit = _ref108.commit;
	
	  commit(types.ADD_PRODUCT_PRICE, productPrice);
	};
	
	var updateProductPrice = exports.updateProductPrice = function updateProductPrice(_ref109, _ref110) {
	  var commit = _ref109.commit;
	  var index = _ref110.index,
	      productPrice = _ref110.productPrice;
	
	  commit(types.UPDATE_PRODUCT_PRICE, { index: index, productPrice: productPrice });
	};
	
	var removeProductPrice = exports.removeProductPrice = function removeProductPrice(_ref111, index) {
	  var commit = _ref111.commit;
	
	  commit(types.REMOVE_PRODUCT_PRICE, index);
	};
	
	var fetchPaginatedProductGroups = exports.fetchPaginatedProductGroups = function fetchPaginatedProductGroups(_ref112, _ref113) {
	  var commit = _ref112.commit;
	  var productGroups = _ref113.productGroups,
	      pagination = _ref113.pagination;
	
	  commit(types.FETCH_PAGINATED_PRODUCT_GROUPS, { productGroups: productGroups, pagination: pagination });
	};
	
	var fetchPaginatedProductPackagings = exports.fetchPaginatedProductPackagings = function fetchPaginatedProductPackagings(_ref114, _ref115) {
	  var commit = _ref114.commit;
	  var productPackagings = _ref115.productPackagings,
	      pagination = _ref115.pagination;
	
	  commit(types.FETCH_PAGINATED_PRODUCT_PACKAGINGS, { productPackagings: productPackagings, pagination: pagination });
	};
	
	var fetchPackagingMaterials = exports.fetchPackagingMaterials = function fetchPackagingMaterials(_ref116, packagingMaterials) {
	  var commit = _ref116.commit;
	
	  commit(types.FETCH_PACKAGING_MATERIALS, packagingMaterials);
	};
	
	var fetchAllProductPackagings = exports.fetchAllProductPackagings = function fetchAllProductPackagings(_ref117, productPackagings) {
	  var commit = _ref117.commit;
	
	  commit(types.FETCH_ALL_PRODUCT_PACKAGINGS, productPackagings);
	};
	
	var setNullProductPackagings = exports.setNullProductPackagings = function setNullProductPackagings(_ref118) {
	  var commit = _ref118.commit;
	
	  commit(types.ADD_NULL_PRODUCT_PACKAGINGS);
	};
	
	var fetchPackagingTypes = exports.fetchPackagingTypes = function fetchPackagingTypes(_ref119, packagingTypes) {
	  var commit = _ref119.commit;
	
	  commit(types.FETCH_PACKAGING_TYPES, packagingTypes);
	};
	
	var fetchUnitTypes = exports.fetchUnitTypes = function fetchUnitTypes(_ref120, unitTypes) {
	  var commit = _ref120.commit;
	
	  commit(types.FETCH_UNIT_TYPES, unitTypes);
	};
	
	var fetchAllProductTypes = exports.fetchAllProductTypes = function fetchAllProductTypes(_ref121, productTypes) {
	  var commit = _ref121.commit;
	
	  commit(types.FETCH_ALL_PRODUCT_TYPES, productTypes);
	};
	
	var fetchAllProductSubtypes = exports.fetchAllProductSubtypes = function fetchAllProductSubtypes(_ref122, productSubtypes) {
	  var commit = _ref122.commit;
	
	  commit(types.FETCH_ALL_PRODUCT_SUBTYPES, productSubtypes);
	};
	
	var fetchAllProductRecommendations = exports.fetchAllProductRecommendations = function fetchAllProductRecommendations(_ref123, productRecommendations) {
	  var commit = _ref123.commit;
	
	  commit(types.FETCH_ALL_PRODUCT_RECOMMENDATIONS, productRecommendations);
	};
	
	var fetchAllProducers = exports.fetchAllProducers = function fetchAllProducers(_ref124, producers) {
	  var commit = _ref124.commit;
	
	  commit(types.FETCH_ALL_PRODUCERS, producers);
	};
	
	var fetchAllProductGroups = exports.fetchAllProductGroups = function fetchAllProductGroups(_ref125, productGroups) {
	  var commit = _ref125.commit;
	
	  commit(types.FETCH_ALL_PRODUCT_GROUPS, productGroups);
	};
	
	var fetchAllProductTags = exports.fetchAllProductTags = function fetchAllProductTags(_ref126, productTags) {
	  var commit = _ref126.commit;
	
	  commit(types.FETCH_ALL_PRODUCT_TAGS, productTags);
	};
	var fetchPaginatedProductTags = exports.fetchPaginatedProductTags = function fetchPaginatedProductTags(_ref127, _ref128) {
	  var commit = _ref127.commit;
	  var productTags = _ref128.productTags,
	      pagination = _ref128.pagination;
	
	  commit(types.FETCH_PAGINATED_PRODUCT_TAGS, { productTags: productTags, pagination: pagination });
	};
	
	var fetchAllPriceFields = exports.fetchAllPriceFields = function fetchAllPriceFields(_ref129, priceFields) {
	  var commit = _ref129.commit;
	
	  commit(types.FETCH_ALL_PRICE_FIELDS, priceFields);
	};
	var fetchPaginatedPriceFields = exports.fetchPaginatedPriceFields = function fetchPaginatedPriceFields(_ref130, _ref131) {
	  var commit = _ref130.commit;
	  var priceFields = _ref131.priceFields,
	      pagination = _ref131.pagination;
	
	  commit(types.FETCH_PAGINATED_PRICE_FIELDS, { priceFields: priceFields, pagination: pagination });
	};
	
	var fetchPaginatedOrders = exports.fetchPaginatedOrders = function fetchPaginatedOrders(_ref132, _ref133) {
	  var commit = _ref132.commit;
	  var orders = _ref133.orders,
	      pagination = _ref133.pagination;
	
	  commit(types.FETCH_PAGINATED_ORDERS, { orders: orders, pagination: pagination });
	};
	
	var fetchAllOrders = exports.fetchAllOrders = function fetchAllOrders(_ref134, orders) {
	  var commit = _ref134.commit;
	
	  commit(types.FETCH_ALL_ORDERS, orders);
	};
	
	var fetchOrderTypes = exports.fetchOrderTypes = function fetchOrderTypes(_ref135, orderTypes) {
	  var commit = _ref135.commit;
	
	  commit(types.FETCH_ORDER_TYPES, orderTypes);
	};
	
	var fetchCurrentOrder = exports.fetchCurrentOrder = function fetchCurrentOrder(_ref136, order) {
	  var commit = _ref136.commit;
	
	  commit(types.FETCH_CURRENT_ORDER, order);
	};
	
	var fetchOrderEvents = exports.fetchOrderEvents = function fetchOrderEvents(_ref137, events) {
	  var commit = _ref137.commit;
	
	  commit(types.FETCH_ORDER_EVENTS, events);
	};
	
	var resetOrders = exports.resetOrders = function resetOrders(_ref138) {
	  var commit = _ref138.commit;
	
	  commit(types.RESET_ORDERS);
	};
	
	var setOrderQuery = exports.setOrderQuery = function setOrderQuery(_ref139, _ref140) {
	  var commit = _ref139.commit;
	  var page = _ref140.page,
	      limit = _ref140.limit,
	      search = _ref140.search;
	
	  commit(types.ORDER_QUERY, { page: page, limit: limit, search: search });
	};
	
	var fetchAvailableWidgets = exports.fetchAvailableWidgets = function fetchAvailableWidgets(_ref141, availableWidgetsData) {
	  var commit = _ref141.commit;
	
	  commit(types.FETCH_AVAILABLE_WIDGETS, availableWidgetsData);
	};
	
	var fetchWidgets = exports.fetchWidgets = function fetchWidgets(_ref142, widgetsData) {
	  var commit = _ref142.commit;
	
	  commit(types.FETCH_USER_WIDGETS, widgetsData);
	};
	
	var fetchBestClientsDataWidgets = exports.fetchBestClientsDataWidgets = function fetchBestClientsDataWidgets(_ref143, bestClientsWidgetsData) {
	  var commit = _ref143.commit;
	
	  commit(types.FETCH_BEST_CLIENTS_WIDGETS, bestClientsWidgetsData);
	};
	
	var fetchWaitingProcessedDataWidgets = exports.fetchWaitingProcessedDataWidgets = function fetchWaitingProcessedDataWidgets(_ref144, waitingProcessedWidgetsData) {
	  var commit = _ref144.commit;
	
	  commit(types.FETCH_WAITING_PROCESSED_WIDGETS, waitingProcessedWidgetsData);
	};
	
	var fetchWaitingDeiveredDataWidgets = exports.fetchWaitingDeiveredDataWidgets = function fetchWaitingDeiveredDataWidgets(_ref145, waitingDeliveredWidgetsData) {
	  var commit = _ref145.commit;
	
	  commit(types.FETCH_WAITING_DELIVERED_WIDGETS, waitingDeliveredWidgetsData);
	};
	
	var fetchOrderReceivedDataWidgets = exports.fetchOrderReceivedDataWidgets = function fetchOrderReceivedDataWidgets(_ref146, orderReceivedWidgetsData) {
	  var commit = _ref146.commit;
	
	  commit(types.FETCH_ORDER_RECEIVED_WIDGETS, orderReceivedWidgetsData);
	};
	
	var fetchRevenueDataWidgets = exports.fetchRevenueDataWidgets = function fetchRevenueDataWidgets(_ref147, revenueWidgetsData) {
	  var commit = _ref147.commit;
	
	  commit(types.FETCH_REVENUE_WIDGETS, revenueWidgetsData);
	};
	
	var fetchPopularProductsDataWidgets = exports.fetchPopularProductsDataWidgets = function fetchPopularProductsDataWidgets(_ref148, popularProductsWidgetsData) {
	  var commit = _ref148.commit;
	
	  commit(types.FETCH_POPULAR_PRODUCTS_WIDGETS, popularProductsWidgetsData);
	};
	
	var fetchSoldProductsDataWidgets = exports.fetchSoldProductsDataWidgets = function fetchSoldProductsDataWidgets(_ref149, soldProductsWidgetsData) {
	  var commit = _ref149.commit;
	
	  commit(types.FETCH_SOLD_PRODUCTS_WIDGETS, soldProductsWidgetsData);
	};
	
	var fetchSiteLanguages = exports.fetchSiteLanguages = function fetchSiteLanguages(_ref150, _ref151) {
	  var commit = _ref150.commit;
	  var siteLanguagesData = _ref151.siteLanguagesData;
	
	  commit(types.FETCH_SITELANGUAGES, { siteLanguagesData: siteLanguagesData });
	};
	
	var fetchCountries = exports.fetchCountries = function fetchCountries(_ref152, _ref153) {
	  var commit = _ref152.commit;
	  var countries = _ref153.countries,
	      pagination = _ref153.pagination;
	
	  commit(types.FETCH_COUNTRIES, { countries: countries, pagination: pagination });
	};
	
	var fetchCities = exports.fetchCities = function fetchCities(_ref154, _ref155) {
	  var commit = _ref154.commit;
	  var cities = _ref155.cities;
	
	  commit(types.FETCH_CITIES, { cities: cities });
	};
	
	var fetchMunicipalities = exports.fetchMunicipalities = function fetchMunicipalities(_ref156, _ref157) {
	  var commit = _ref156.commit;
	  var municipalities = _ref157.municipalities;
	
	  commit(types.FETCH_MUNICIPALITIES, { municipalities: municipalities });
	};
	
	var fetchPostals = exports.fetchPostals = function fetchPostals(_ref158, _ref159) {
	  var commit = _ref158.commit;
	  var postals = _ref159.postals;
	
	  commit(types.FETCH_POSTALS, { postals: postals });
	};
	
	var fetchTaxes = exports.fetchTaxes = function fetchTaxes(_ref160, _ref161) {
	  var commit = _ref160.commit;
	  var taxes = _ref161.taxes;
	
	  commit(types.FETCH_TAXES, { taxes: taxes });
	};
	
	var fetchBusinessDays = exports.fetchBusinessDays = function fetchBusinessDays(_ref162, days) {
	  var commit = _ref162.commit;
	
	  commit(types.FETCH_BUSINESS_DAYS, days);
	};
	
	var fetchBusinessHours = exports.fetchBusinessHours = function fetchBusinessHours(_ref163, hours) {
	  var commit = _ref163.commit;
	
	  commit(types.FETCH_BUSINESS_HOURS, hours);
	};
	
	var storeBusinessHour = exports.storeBusinessHour = function storeBusinessHour(_ref164, b) {
	  var commit = _ref164.commit;
	
	  commit(types.STORE_BUSINESS_HOUR, b);
	};
	
	var destroyBusinessHour = exports.destroyBusinessHour = function destroyBusinessHour(_ref165, id) {
	  var commit = _ref165.commit;
	
	  commit(types.DESTROY_BUSINESS_HOUR, id);
	};
	
	var fetchBusinessHourExceptions = exports.fetchBusinessHourExceptions = function fetchBusinessHourExceptions(_ref166, hours) {
	  var commit = _ref166.commit;
	
	  commit(types.FETCH_BUSINESS_HOUR_EXCEPTIONS, hours);
	};
	
	var storeBusinessHourException = exports.storeBusinessHourException = function storeBusinessHourException(_ref167, e) {
	  var commit = _ref167.commit;
	
	  commit(types.STORE_BUSINESS_HOUR_EXCEPTION, e);
	};
	
	var destroyBusinessHourException = exports.destroyBusinessHourException = function destroyBusinessHourException(_ref168, id) {
	  var commit = _ref168.commit;
	
	  commit(types.DESTROY_BUSINESS_HOUR_EXCEPTION, id);
	};
	
	var fetchPaginatedBills = exports.fetchPaginatedBills = function fetchPaginatedBills(_ref169, _ref170) {
	  var commit = _ref169.commit;
	  var bills = _ref170.bills,
	      pagination = _ref170.pagination;
	
	  commit(types.FETCH_PAGINATED_BILLS, { bills: bills, pagination: pagination });
	};
	
	var fetchBillStatuses = exports.fetchBillStatuses = function fetchBillStatuses(_ref171, statuses) {
	  var commit = _ref171.commit;
	
	  commit(types.FETCH_BILL_STATUSES, statuses);
	};
	
	var fetchBillTypes = exports.fetchBillTypes = function fetchBillTypes(_ref172, billTypes) {
	  var commit = _ref172.commit;
	
	  commit(types.FETCH_BILL_TYPES, billTypes);
	};
	
	var fetchCurrentBill = exports.fetchCurrentBill = function fetchCurrentBill(_ref173, bill) {
	  var commit = _ref173.commit;
	
	  commit(types.FETCH_CURRENT_BILL, bill);
	};
	
	var setBillQuery = exports.setBillQuery = function setBillQuery(_ref174, _ref175) {
	  var commit = _ref174.commit;
	  var page = _ref175.page,
	      limit = _ref175.limit,
	      search = _ref175.search;
	
	  commit(types.BILL_QUERY, { page: page, limit: limit, search: search });
	};
	
	var fetchAllCreditNoteReasons = exports.fetchAllCreditNoteReasons = function fetchAllCreditNoteReasons(_ref176, creditNoteReasons) {
	  var commit = _ref176.commit;
	
	  commit(types.FETCH_ALL_CREDIT_NOTE_REASONS, creditNoteReasons);
	};
	
	var fetchCurrentCreditNoteReason = exports.fetchCurrentCreditNoteReason = function fetchCurrentCreditNoteReason(_ref177, creditNoteReason) {
	  var commit = _ref177.commit;
	
	  commit(types.FETCH_CURRENT_CREDIT_NOTE_REASON, creditNoteReason);
	};
	
	var fetchAllOrderProducts = exports.fetchAllOrderProducts = function fetchAllOrderProducts(_ref178, orderProducts) {
	  var commit = _ref178.commit;
	
	  commit(types.FETCH_ALL_ORDER_PRODUCTS, orderProducts);
	};
	
	var addOrderProduct = exports.addOrderProduct = function addOrderProduct(_ref179, orderProduct) {
	  var commit = _ref179.commit;
	
	  commit(types.ADD_ORDER_PRODUCT, orderProduct);
	};
	
	var updateOrderProduct = exports.updateOrderProduct = function updateOrderProduct(_ref180, _ref181) {
	  var commit = _ref180.commit;
	  var orderProduct = _ref181.orderProduct,
	      id = _ref181.id;
	
	  commit(types.UPDATE_ORDER_PRODUCT, { orderProduct: orderProduct, id: id });
	};
	
	var removeOrderProduct = exports.removeOrderProduct = function removeOrderProduct(_ref182, id) {
	  var commit = _ref182.commit;
	
	  commit(types.REMOVE_ORDER_PRODUCT, id);
	};
	
	var fetchAllBillProducts = exports.fetchAllBillProducts = function fetchAllBillProducts(_ref183, billProducts) {
	  var commit = _ref183.commit;
	
	  commit(types.FETCH_ALL_BILL_PRODUCTS, billProducts);
	};
	
	var addBillProduct = exports.addBillProduct = function addBillProduct(_ref184, billProduct) {
	  var commit = _ref184.commit;
	
	  commit(types.ADD_BILL_PRODUCT, billProduct);
	};
	
	var updateBillProduct = exports.updateBillProduct = function updateBillProduct(_ref185, _ref186) {
	  var commit = _ref185.commit;
	  var billProduct = _ref186.billProduct,
	      id = _ref186.id;
	
	  commit(types.UPDATE_BILL_PRODUCT, { billProduct: billProduct, id: id });
	};
	
	var removeBillProduct = exports.removeBillProduct = function removeBillProduct(_ref187, id) {
	  var commit = _ref187.commit;
	
	  commit(types.REMOVE_BILL_PRODUCT, id);
	};
	
	var fetchAllCreditNoteProducts = exports.fetchAllCreditNoteProducts = function fetchAllCreditNoteProducts(_ref188, creditNoteProducts) {
	  var commit = _ref188.commit;
	
	  commit(types.FETCH_ALL_CREDIT_NOTE_PRODUCTS, creditNoteProducts);
	};
	
	var addCreditNoteProduct = exports.addCreditNoteProduct = function addCreditNoteProduct(_ref189, creditNoteProduct) {
	  var commit = _ref189.commit;
	
	  commit(types.ADD_CREDIT_NOTE_PRODUCT, creditNoteProduct);
	};
	
	var updateCreditNoteProduct = exports.updateCreditNoteProduct = function updateCreditNoteProduct(_ref190, _ref191) {
	  var commit = _ref190.commit;
	  var creditNoteProduct = _ref191.creditNoteProduct,
	      id = _ref191.id;
	
	  commit(types.UPDATE_CREDIT_NOTE_PRODUCT, { creditNoteProduct: creditNoteProduct, id: id });
	};
	
	var removeCreditNoteProduct = exports.removeCreditNoteProduct = function removeCreditNoteProduct(_ref192, id) {
	  var commit = _ref192.commit;
	
	  commit(types.REMOVE_CREDIT_NOTE_PRODUCT, id);
	};
	
	var fetchAllEdiOrders = exports.fetchAllEdiOrders = function fetchAllEdiOrders(_ref193, ediOrders) {
	  var commit = _ref193.commit;
	
	  commit(types.FETCH_ALL_EDI_ORDERS, ediOrders);
	};
	
	var fetchPaginatedEdiOrders = exports.fetchPaginatedEdiOrders = function fetchPaginatedEdiOrders(_ref194, _ref195) {
	  var commit = _ref194.commit;
	  var ediOrders = _ref195.ediOrders,
	      pagination = _ref195.pagination;
	
	  commit(types.FETCH_PAGINATED_EDI_ORDERS, { ediOrders: ediOrders, pagination: pagination });
	};
	
	var fetchCurrentEdiOrder = exports.fetchCurrentEdiOrder = function fetchCurrentEdiOrder(_ref196, ediOrder) {
	  var commit = _ref196.commit;
	
	  commit(types.FETCH_CURRENT_EDI_ORDER, ediOrder);
	};
	
	var fetchAllEdiOrderItems = exports.fetchAllEdiOrderItems = function fetchAllEdiOrderItems(_ref197, ediOrderItems) {
	  var commit = _ref197.commit;
	
	  commit(types.FETCH_ALL_EDI_ORDER_ITEMS, ediOrderItems);
	};
	
	var updateEdiOrderItem = exports.updateEdiOrderItem = function updateEdiOrderItem(_ref198, _ref199) {
	  var commit = _ref198.commit;
	  var ediOrderItem = _ref199.ediOrderItem,
	      id = _ref199.id;
	
	  commit(types.UPDATE_EDI_ORDER_ITEM, { ediOrderItem: ediOrderItem, id: id });
	};
	
	var fetchAllMessageTemplateTypes = exports.fetchAllMessageTemplateTypes = function fetchAllMessageTemplateTypes(_ref200, templateTypes) {
	  var commit = _ref200.commit;
	
	  commit(types.FETCH_ALL_MESSAGE_TEMPLATE_TYPES, templateTypes);
	};
	
	var fetchAllAccountingProviders = exports.fetchAllAccountingProviders = function fetchAllAccountingProviders(_ref201, accountingProviders) {
	  var commit = _ref201.commit;
	
	  commit(types.FETCH_ALL_ACCOUNTING_PROVIDERS, accountingProviders);
	};
	
	var fetchAllChartOfAccounts = exports.fetchAllChartOfAccounts = function fetchAllChartOfAccounts(_ref202, chartOfAccounts) {
	  var commit = _ref202.commit;
	
	  commit(types.FETCH_ALL_CHART_OF_ACCOUNTS, chartOfAccounts);
	};
	
	var addChartOfAccountsItem = exports.addChartOfAccountsItem = function addChartOfAccountsItem(_ref203, chartOfAccounts) {
	  var commit = _ref203.commit;
	
	  commit(types.ADD_CHART_OF_ACCOUNTS_ITEM, chartOfAccounts);
	};
	
	var updateChartOfAccountsItem = exports.updateChartOfAccountsItem = function updateChartOfAccountsItem(_ref204, _ref205) {
	  var commit = _ref204.commit;
	  var data = _ref205.data,
	      id = _ref205.id;
	
	  commit(types.UPDATE_CHART_OF_ACCOUNTS_ITEM, { data: data, id: id });
	};
	
	var removeChartOfAccountsItem = exports.removeChartOfAccountsItem = function removeChartOfAccountsItem(_ref206, id) {
	  var commit = _ref206.commit;
	
	  commit(types.REMOVE_CHART_OF_ACCOUNTS_ITEM, id);
	};
	
	var fetchPaginatedCampaigns = exports.fetchPaginatedCampaigns = function fetchPaginatedCampaigns(_ref207, _ref208) {
	  var commit = _ref207.commit;
	  var campaigns = _ref208.campaigns,
	      pagination = _ref208.pagination;
	
	  commit(types.FETCH_PAGINATED_CAMPAIGNS, { campaigns: campaigns, pagination: pagination });
	};
	
	var fetchCampaignTypes = exports.fetchCampaignTypes = function fetchCampaignTypes(_ref209, campaignTypes) {
	  var commit = _ref209.commit;
	
	  commit(types.FETCH_CAMPAIGN_TYPES, campaignTypes);
	};
	
	var FetchAllSuppliers = exports.FetchAllSuppliers = function FetchAllSuppliers(_ref210, suppliers) {
	  var commit = _ref210.commit;
	
	  commit(types.FETCH_ALL_SUPPLIERS, suppliers);
	};
	
	var fetchPaginatedSuppliers = exports.fetchPaginatedSuppliers = function fetchPaginatedSuppliers(_ref211, _ref212) {
	  var commit = _ref211.commit;
	  var suppliers = _ref212.suppliers,
	      pagination = _ref212.pagination;
	
	  commit(types.FETCH_PAGINATE_SUPPLIERS, { suppliers: suppliers, pagination: pagination });
	};
	
	var fetchCurrentSupplier = exports.fetchCurrentSupplier = function fetchCurrentSupplier(_ref213, supplier) {
	  var commit = _ref213.commit;
	
	  commit(types.FETCH_CURRENT_SUPPLIER, supplier);
	};
	
	var FetchAllWarehouses = exports.FetchAllWarehouses = function FetchAllWarehouses(_ref214, warehouses) {
	  var commit = _ref214.commit;
	
	  commit(types.FETCH_ALL_WAREHOUSES, warehouses);
	};
	
	var fetchPaginatedWarehouses = exports.fetchPaginatedWarehouses = function fetchPaginatedWarehouses(_ref215, _ref216) {
	  var commit = _ref215.commit;
	  var warehouses = _ref216.warehouses,
	      pagination = _ref216.pagination;
	
	  commit(types.FETCH_PAGINATE_WAREHOUSES, { warehouses: warehouses, pagination: pagination });
	};
	
	var fetchCurrentWarehouse = exports.fetchCurrentWarehouse = function fetchCurrentWarehouse(_ref217, warehouse) {
	  var commit = _ref217.commit;
	
	  commit(types.FETCH_CURRENT_WAREHOUSE, warehouse);
	};
	
	var fetchPaginatedWarehouseProducts = exports.fetchPaginatedWarehouseProducts = function fetchPaginatedWarehouseProducts(_ref218, _ref219) {
	  var commit = _ref218.commit;
	  var products = _ref219.products,
	      pagination = _ref219.pagination;
	
	  commit(types.FETCH_PAGINATE_WAREHOUSE_PRODUCTS, { products: products, pagination: pagination });
	};
	
	var fetchAllWarehouseTransactions = exports.fetchAllWarehouseTransactions = function fetchAllWarehouseTransactions(_ref220, transasctions) {
	  var commit = _ref220.commit;
	
	  commit(types.FETCH_ALL_WAREHOUSE_TRANSACTIONS, transasctions);
	};
	
	var fetchAllWarehouseTransactionsV2 = exports.fetchAllWarehouseTransactionsV2 = function fetchAllWarehouseTransactionsV2(_ref221, transactionsV2All) {
	  var commit = _ref221.commit;
	
	  commit(types.FETCH_ALL_WAREHOUSE_TRANSACTIONSV2, transactionsV2All);
	};
	var fetchPaginatedWarehouseTransactionsV2 = exports.fetchPaginatedWarehouseTransactionsV2 = function fetchPaginatedWarehouseTransactionsV2(_ref222, _ref223) {
	  var commit = _ref222.commit;
	  var transactions = _ref223.transactions,
	      pagination = _ref223.pagination;
	
	  commit(types.FETCH_PAGINATE_WAREHOUSE_TRANSACTIONSV2, { transactions: transactions, pagination: pagination });
	};
	
	var FetchAllUnitOfMeasures = exports.FetchAllUnitOfMeasures = function FetchAllUnitOfMeasures(_ref224, unitOfMeasures) {
	  var commit = _ref224.commit;
	
	  commit(types.FETCH_ALL_UNIT_OF_MEASURES, unitOfMeasures);
	};
	
	var fetchPaginatedUnitOfMeasures = exports.fetchPaginatedUnitOfMeasures = function fetchPaginatedUnitOfMeasures(_ref225, _ref226) {
	  var commit = _ref225.commit;
	  var unitOfMeasures = _ref226.unitOfMeasures,
	      pagination = _ref226.pagination;
	
	  commit(types.FETCH_PAGINATE_UNIT_OF_MEASURES, { unitOfMeasures: unitOfMeasures, pagination: pagination });
	};
	
	var fetchCurrentUnitOfMeasure = exports.fetchCurrentUnitOfMeasure = function fetchCurrentUnitOfMeasure(_ref227, unitOfMeasure) {
	  var commit = _ref227.commit;
	
	  commit(types.FETCH_CURRENT_UNIT_OF_MEASURES, unitOfMeasure);
	};
	
	var FetchAllStocks = exports.FetchAllStocks = function FetchAllStocks(_ref228, stocks) {
	  var commit = _ref228.commit;
	
	  commit(types.FETCH_ALL_STOCKS, stocks);
	};
	
	var fetchPaginatedStocks = exports.fetchPaginatedStocks = function fetchPaginatedStocks(_ref229, _ref230) {
	  var commit = _ref229.commit;
	  var stocks = _ref230.stocks,
	      pagination = _ref230.pagination;
	
	  commit(types.FETCH_PAGINATE_STOCKS, { stocks: stocks, pagination: pagination });
	};
	
	var fetchCurrentStock = exports.fetchCurrentStock = function fetchCurrentStock(_ref231, stock) {
	  var commit = _ref231.commit;
	
	  commit(types.FETCH_CURRENT_STOCK, stock);
	};
	
	var allCurrentStockProducts = exports.allCurrentStockProducts = function allCurrentStockProducts(_ref232, products) {
	  var commit = _ref232.commit;
	
	  commit(types.FETCH_CURRENT_STOCK_PRODUCTS, products);
	};
	
	var PushToStockProducts = exports.PushToStockProducts = function PushToStockProducts(_ref233, product) {
	  var commit = _ref233.commit;
	
	  commit(types.PUSH_TO_STOCK_PRODUCTS, product);
	};
	
	var setStockSelectedWarehouse = exports.setStockSelectedWarehouse = function setStockSelectedWarehouse(_ref234, warehouseId) {
	  var commit = _ref234.commit;
	
	  commit(types.SET_STOCK_SELECTED_WAREHOUSE, warehouseId);
	};
	
	var deleteStockProduct = exports.deleteStockProduct = function deleteStockProduct(_ref235, i) {
	  var commit = _ref235.commit;
	
	  commit(types.DELETE_TO_STOCK_PRODUCTS, i);
	};
	
	var UpdateToStockProducts = exports.UpdateToStockProducts = function UpdateToStockProducts(_ref236, _ref237) {
	  var commit = _ref236.commit;
	  var data = _ref237.data,
	      i = _ref237.i;
	
	  commit(types.UPDATE_TO_STOCK_PRODUCTS, { data: data, i: i });
	};
	
	var DeleteFromStockProductsCustom = exports.DeleteFromStockProductsCustom = function DeleteFromStockProductsCustom(_ref238, i) {
	  var commit = _ref238.commit;
	
	  commit(types.DELETE_FROM_STOCK_PRODUCTS_CUSTOM, i);
	};
	
	var EditToStockProducts = exports.EditToStockProducts = function EditToStockProducts(_ref239, _ref240) {
	  var commit = _ref239.commit;
	  var data = _ref240.data,
	      i = _ref240.i;
	
	  commit(types.EDIT_TO_STOCK_PRODUCTS, { data: data, i: i });
	};
	
	var allCurrentStockProductsCustom = exports.allCurrentStockProductsCustom = function allCurrentStockProductsCustom(_ref241, products) {
	  var commit = _ref241.commit;
	
	  commit(types.FETCH_CURRENT_STOCK_PRODUCTS_CUSTOM, products);
	};
	
	var PushToStockProductsCustom = exports.PushToStockProductsCustom = function PushToStockProductsCustom(_ref242, product) {
	  var commit = _ref242.commit;
	
	  commit(types.PUSH_TO_STOCK_PRODUCTS_CUSTOM, product);
	};
	
	var RefreshStockProducts = exports.RefreshStockProducts = function RefreshStockProducts(_ref243) {
	  var commit = _ref243.commit;
	
	  commit(types.REFRESH_STOCK_PRODUCTS);
	};
	
	var RefreshStockProductsCustom = exports.RefreshStockProductsCustom = function RefreshStockProductsCustom(_ref244) {
	  var commit = _ref244.commit;
	
	  commit(types.REFRESH_STOCK_PRODUCTS_CUSTOM);
	};
	
	var FetchAllAdjustments = exports.FetchAllAdjustments = function FetchAllAdjustments(_ref245, adjustments) {
	  var commit = _ref245.commit;
	
	  commit(types.FETCH_ALL_ADJUSTMENTS, adjustments);
	};
	
	var fetchPaginatedAdjustments = exports.fetchPaginatedAdjustments = function fetchPaginatedAdjustments(_ref246, _ref247) {
	  var commit = _ref246.commit;
	  var adjustments = _ref247.adjustments,
	      pagination = _ref247.pagination;
	
	  commit(types.FETCH_PAGINATE_ADJUSTMENTS, { adjustments: adjustments, pagination: pagination });
	};
	
	var fetchCurrentAdjustment = exports.fetchCurrentAdjustment = function fetchCurrentAdjustment(_ref248, adjustment) {
	  var commit = _ref248.commit;
	
	  commit(types.FETCH_CURRENT_ADJUSTMENT, adjustment);
	};
	
	var FetchAllPurchases = exports.FetchAllPurchases = function FetchAllPurchases(_ref249, purchases) {
	  var commit = _ref249.commit;
	
	  commit(types.FETCH_ALL_PURCHASES, purchases);
	};
	
	var fetchPaginatedPurchases = exports.fetchPaginatedPurchases = function fetchPaginatedPurchases(_ref250, _ref251) {
	  var commit = _ref250.commit;
	  var purchases = _ref251.purchases,
	      pagination = _ref251.pagination;
	
	  commit(types.FETCH_PAGINATE_PURCHASES, { purchases: purchases, pagination: pagination });
	};
	
	var fetchCurrentPurchase = exports.fetchCurrentPurchase = function fetchCurrentPurchase(_ref252, purchase) {
	  var commit = _ref252.commit;
	
	  commit(types.FETCH_CURRENT_PURCHASE, purchase);
	};
	
	var fetchPurchaseStatuses = exports.fetchPurchaseStatuses = function fetchPurchaseStatuses(_ref253, statuses) {
	  var commit = _ref253.commit;
	
	  commit(types.FETCH_PURCHASE_STATUSES, statuses);
	};
	
	var setView = exports.setView = function setView(_ref254, view) {
	  var commit = _ref254.commit;
	
	  commit(types.TYPE_OF_VIEW, view);
	};
	var setOrderTypeView = exports.setOrderTypeView = function setOrderTypeView(_ref255, orderViewType) {
	  var commit = _ref255.commit;
	
	  commit(types.TYPE_OF_ORDER_VIEW, orderViewType);
	};
	var FetchAllShippingProviders = exports.FetchAllShippingProviders = function FetchAllShippingProviders(_ref256, shippingProviders) {
	  var commit = _ref256.commit;
	
	  commit(types.FETCH_ALL_SHIPPING_PROVIDERS, shippingProviders);
	};
	
	var fetchCurrentShippingProvider = exports.fetchCurrentShippingProvider = function fetchCurrentShippingProvider(_ref257, shippingProvider) {
	  var commit = _ref257.commit;
	
	  commit(types.FETCH_CURRENT_SHIPPING_PROVIDER, shippingProvider);
	};
	
	var FetchAllproductFlows = exports.FetchAllproductFlows = function FetchAllproductFlows(_ref258, productFlows) {
	  var commit = _ref258.commit;
	
	  commit(types.FETCH_ALL_PRODUCTFLOWS, productFlows);
	};
	
	var fetchPaginatedproductFlows = exports.fetchPaginatedproductFlows = function fetchPaginatedproductFlows(_ref259, _ref260) {
	  var commit = _ref259.commit;
	  var productFlows = _ref260.productFlows,
	      pagination = _ref260.pagination;
	
	  commit(types.FETCH_PAGINATE_PRODUCTFLOWS, { productFlows: productFlows, pagination: pagination });
	};
	
	var fetchCurrentproductFlow = exports.fetchCurrentproductFlow = function fetchCurrentproductFlow(_ref261, productFlow) {
	  var commit = _ref261.commit;
	
	  commit(types.FETCH_CURRENT_PRODUCTFLOW, productFlow);
	};
	
	var fetchproductFlowOrders = exports.fetchproductFlowOrders = function fetchproductFlowOrders(_ref262, orders) {
	  var commit = _ref262.commit;
	
	  commit(types.FETCH_ALL_PRODUCTFLOW_ORDERS, orders);
	};
	
	var fetchExciseGroup = exports.fetchExciseGroup = function fetchExciseGroup(_ref263, _ref264) {
	  var commit = _ref263.commit;
	  var exciseGroups = _ref264.exciseGroups;
	
	  commit(types.FETCH_EXCISE_GROUPS, { exciseGroups: exciseGroups });
	};
	
	var fetchExcisePackagingGroup = exports.fetchExcisePackagingGroup = function fetchExcisePackagingGroup(_ref265, _ref266) {
	  var commit = _ref265.commit;
	  var excisePackagingGroups = _ref266.excisePackagingGroups;
	
	  commit(types.FETCH_EXCISE_PACKAGING_GROUPS, { excisePackagingGroups: excisePackagingGroups });
	};
	
	var fetchExciseBasicGroup = exports.fetchExciseBasicGroup = function fetchExciseBasicGroup(_ref267, _ref268) {
	  var commit = _ref267.commit;
	  var exciseBasicGroups = _ref268.exciseBasicGroups;
	
	  commit(types.FETCH_EXCISE_BASIC, { exciseBasicGroups: exciseBasicGroups });
	};
	
	var setNullOnExciseGroup = exports.setNullOnExciseGroup = function setNullOnExciseGroup(_ref269) {
	  var commit = _ref269.commit;
	
	  commit(types.ADD_NULL_TO_EXCISE_GROUPS_LIST);
	};
	
	var fetchAdditionalCode = exports.fetchAdditionalCode = function fetchAdditionalCode(_ref270, _ref271) {
	  var commit = _ref270.commit;
	  var exciseAdditionals = _ref271.exciseAdditionals;
	
	  commit(types.FETCH_ADDITIONAL_CODE, { exciseAdditionals: exciseAdditionals });
	};
	
	var fetchAllOrganizationMembers = exports.fetchAllOrganizationMembers = function fetchAllOrganizationMembers(_ref272, organizationMembers) {
	  var commit = _ref272.commit;
	
	  commit(types.FETCH_ALL_ORGANIZATION_MEMBERS, organizationMembers);
	};
	var addOrganizationMember = exports.addOrganizationMember = function addOrganizationMember(_ref273, organizationMember) {
	  var commit = _ref273.commit;
	
	  commit(types.ADD_ORGANIZATION_MEMBER, organizationMember);
	};
	
	var fetchAllOrganizationMemberProductBusinessHours = exports.fetchAllOrganizationMemberProductBusinessHours = function fetchAllOrganizationMemberProductBusinessHours(_ref274, businesshours) {
	  var commit = _ref274.commit;
	
	  commit(types.FETCH_ALL_ORGANIZATION_MEMBER_PRODUCT_BUSINESSHOURS, businesshours);
	};
	
	var fetchAllOrganizationMemberBookings = exports.fetchAllOrganizationMemberBookings = function fetchAllOrganizationMemberBookings(_ref275, organizationMemberBookings) {
	  var commit = _ref275.commit;
	
	  commit(types.FETCH_ALL_ORGANIZATION_MEMBER_BOOKINGS, organizationMemberBookings);
	};
	var addOrganizationMemberBooking = exports.addOrganizationMemberBooking = function addOrganizationMemberBooking(_ref276, organizationMemberBooking) {
	  var commit = _ref276.commit;
	
	  commit(types.ADD_ORGANIZATION_MEMBER_BOOKING, organizationMemberBooking);
	};
	
	var fetchAllModules = exports.fetchAllModules = function fetchAllModules(_ref277, modules) {
	  var commit = _ref277.commit;
	
	  commit(types.FETCH_ALL_MODULES, modules);
	};
	
	var fetchAllTransactionTypes = exports.fetchAllTransactionTypes = function fetchAllTransactionTypes(_ref278, transactionTypes) {
	  var commit = _ref278.commit;
	
	  commit(types.FETCH_ALL_TRANSACTION_TYPES, transactionTypes);
	};
	
	var FetchAllTransfers = exports.FetchAllTransfers = function FetchAllTransfers(_ref279, transfers) {
	  var commit = _ref279.commit;
	
	  commit(types.FETCH_ALL_TRANSFERS, transfers);
	};
	
	var fetchPaginatedTransfers = exports.fetchPaginatedTransfers = function fetchPaginatedTransfers(_ref280, _ref281) {
	  var commit = _ref280.commit;
	  var transfers = _ref281.transfers,
	      pagination = _ref281.pagination;
	
	  commit(types.FETCH_PAGINATE_TRANSFERS, { transfers: transfers, pagination: pagination });
	};
	
	var fetchCurrentTransfer = exports.fetchCurrentTransfer = function fetchCurrentTransfer(_ref282, transfer) {
	  var commit = _ref282.commit;
	
	  commit(types.FETCH_CURRENT_TRANSFER, transfer);
	};
	
	var fetchAllLicenses = exports.fetchAllLicenses = function fetchAllLicenses(_ref283, licenses) {
	  var commit = _ref283.commit;
	
	  commit(types.FETCH_ALL_LICENSES, licenses);
	};
	var fetchAllLicenseTypes = exports.fetchAllLicenseTypes = function fetchAllLicenseTypes(_ref284, licenseTypes) {
	  var commit = _ref284.commit;
	
	  commit(types.FETCH_ALL_LICENSE_TYPES, licenseTypes);
	};
	var setNullLicenseType = exports.setNullLicenseType = function setNullLicenseType(_ref285) {
	  var commit = _ref285.commit;
	
	  commit(types.ADD_NULL_LICENSE_TYPE);
	};
	var fetchAllLicensePermits = exports.fetchAllLicensePermits = function fetchAllLicensePermits(_ref286, licensePermits) {
	  var commit = _ref286.commit;
	
	  commit(types.FETCH_ALL_LICENSE_PERMITS, licensePermits);
	};
	var fetchAllLicensePermitTypes = exports.fetchAllLicensePermitTypes = function fetchAllLicensePermitTypes(_ref287, licensePermitTypes) {
	  var commit = _ref287.commit;
	
	  commit(types.FETCH_ALL_LICENSE_PERMIT_TYPES, licensePermitTypes);
	};
	var fetchAllLicenseGroups = exports.fetchAllLicenseGroups = function fetchAllLicenseGroups(_ref288, licenseGroups) {
	  var commit = _ref288.commit;
	
	  commit(types.FETCH_ALL_LICENSE_GROUPS, licenseGroups);
	};
	var fetchAllLicensePermitGroups = exports.fetchAllLicensePermitGroups = function fetchAllLicensePermitGroups(_ref289, licensePermitGroups) {
	  var commit = _ref289.commit;
	
	  commit(types.FETCH_ALL_LICENSE_PERMIT_GROUPS, licensePermitGroups);
	};
	
	var fetchPaginatedExcisePeriods = exports.fetchPaginatedExcisePeriods = function fetchPaginatedExcisePeriods(_ref290, _ref291) {
	  var commit = _ref290.commit;
	  var excisePeriods = _ref291.excisePeriods,
	      pagination = _ref291.pagination;
	
	  commit(types.FETCH_PAGINATED_EXCISE_PERIODS, { excisePeriods: excisePeriods, pagination: pagination });
	};
	
	var fetchAllSubscriberList = exports.fetchAllSubscriberList = function fetchAllSubscriberList(_ref292, subscriberList) {
	  var commit = _ref292.commit;
	
	  commit(types.FETCH_ALL_SUBSCRIBER_LIST, subscriberList);
	};
	var fetchPaginatedSubscriberList = exports.fetchPaginatedSubscriberList = function fetchPaginatedSubscriberList(_ref293, _ref294) {
	  var commit = _ref293.commit;
	  var subscriberList = _ref294.subscriberList,
	      pagination = _ref294.pagination;
	
	  commit(types.FETCH_PAGINATED_SUBSCRIBER_LIST, { subscriberList: subscriberList, pagination: pagination });
	};
	var fetchCurrentSubscriberList = exports.fetchCurrentSubscriberList = function fetchCurrentSubscriberList(_ref295, subscriberList) {
	  var commit = _ref295.commit;
	
	  commit(types.FETCH_CURRENT_SUBSCRIBER_LIST, subscriberList);
	};
	var setchModifiedClientGroup = exports.setchModifiedClientGroup = function setchModifiedClientGroup(_ref296, modifiedClientGroup) {
	  var commit = _ref296.commit;
	
	  commit(types.SET_MODIFIED_CLIENT_GROUP, modifiedClientGroup);
	};
	var setCancelClientGroupAdd = exports.setCancelClientGroupAdd = function setCancelClientGroupAdd(_ref297, cancelClientGroupAdd) {
	  var commit = _ref297.commit;
	
	  commit(types.SET_CANCEL_CLIENT_GROUP_ADD, cancelClientGroupAdd);
	};
	
	var fetchAllSubscriber = exports.fetchAllSubscriber = function fetchAllSubscriber(_ref298, subscriber) {
	  var commit = _ref298.commit;
	
	  commit(types.FETCH_ALL_SUBSCRIBER, subscriber);
	};
	var fetchPaginatedSubscriber = exports.fetchPaginatedSubscriber = function fetchPaginatedSubscriber(_ref299, _ref300) {
	  var commit = _ref299.commit;
	  var subscriber = _ref300.subscriber,
	      pagination = _ref300.pagination;
	
	  commit(types.FETCH_PAGINATED_SUBSCRIBER, { subscriber: subscriber, pagination: pagination });
	};
	var fetchAllPackageUnitTypes = exports.fetchAllPackageUnitTypes = function fetchAllPackageUnitTypes(_ref301, packageUnitTypes) {
	  var commit = _ref301.commit;
	
	  commit(types.FETCH_ALL_PACKAGE_UNIT_TYPES, packageUnitTypes);
	};
	
	var fetchAllPackages = exports.fetchAllPackages = function fetchAllPackages(_ref302, packages) {
	  var commit = _ref302.commit;
	
	  commit(types.FETCH_ALL_PACKAGES, packages);
	};
	
	var fetchAllPackageOrderProducts = exports.fetchAllPackageOrderProducts = function fetchAllPackageOrderProducts(_ref303, packageOrderProducts) {
	  var commit = _ref303.commit;
	
	  commit(types.FETCH_ALL_PACKAGE_ORDER_PRODUCTS, packageOrderProducts);
	};
	
	var fetchToastResp = exports.fetchToastResp = function fetchToastResp(_ref304, appToastData) {
	  var commit = _ref304.commit;
	
	  commit(types.FETCH_USER_APP_TOAST, appToastData);
	};
	
	var fetchLatestVersion = exports.fetchLatestVersion = function fetchLatestVersion(_ref305, appVersionData) {
	  var commit = _ref305.commit;
	
	  commit(types.FETCH_USER_APP_VERSION, appVersionData);
	};
	
	var fetchAllPartners = exports.fetchAllPartners = function fetchAllPartners(_ref306, partners) {
	  var commit = _ref306.commit;
	
	  commit(types.FETCH_ALL_PARTNERS, partners);
	};
	
	var fetchPaginatedOrderPickups = exports.fetchPaginatedOrderPickups = function fetchPaginatedOrderPickups(_ref307, _ref308) {
	  var commit = _ref307.commit;
	  var orderPickups = _ref308.orderPickups,
	      pagination = _ref308.pagination;
	
	  commit(types.FETCH_PAGINATED_ORDER_PICKUPS, { orderPickups: orderPickups, pagination: pagination });
	};
	
	var fetchAllOrderPickups = exports.fetchAllOrderPickups = function fetchAllOrderPickups(_ref309, orderPickups) {
	  var commit = _ref309.commit;
	
	  commit(types.FETCH_ALL_ORDER_PICKUPS, orderPickups);
	};
	
	var fetchOrderPickupTypes = exports.fetchOrderPickupTypes = function fetchOrderPickupTypes(_ref310, orderPickupTypes) {
	  var commit = _ref310.commit;
	
	  commit(types.FETCH_ORDER_PICKUP_TYPES, orderPickupTypes);
	};
	
	var fetchCurrentOrderPickup = exports.fetchCurrentOrderPickup = function fetchCurrentOrderPickup(_ref311, orderPickup) {
	  var commit = _ref311.commit;
	
	  commit(types.FETCH_CURRENT_ORDER_PICKUP, orderPickup);
	};
	
	var fetchOrderPickupEvents = exports.fetchOrderPickupEvents = function fetchOrderPickupEvents(_ref312, events) {
	  var commit = _ref312.commit;
	
	  commit(types.FETCH_ORDER_PICKUP_EVENTS, events);
	};
	
	var resetOrderPickups = exports.resetOrderPickups = function resetOrderPickups(_ref313) {
	  var commit = _ref313.commit;
	
	  commit(types.RESET_ORDER_PICKUPS);
	};
	
	var setOrderPickupQuery = exports.setOrderPickupQuery = function setOrderPickupQuery(_ref314, _ref315) {
	  var commit = _ref314.commit;
	  var page = _ref315.page,
	      limit = _ref315.limit,
	      search = _ref315.search;
	
	  commit(types.ORDER_PICKUP_QUERY, { page: page, limit: limit, search: search });
	};
	
	var fetchPaymentMethods = exports.fetchPaymentMethods = function fetchPaymentMethods(_ref316, paymentMethods) {
	  var commit = _ref316.commit;
	
	  commit(types.FETCH_PAYMENT_METHODS, paymentMethods);
	};
	
	var fetchLanguages = exports.fetchLanguages = function fetchLanguages(_ref317, languages) {
	  var commit = _ref317.commit;
	
	  commit(types.FETCH_LANGUAGES, languages);
	};
	
	var fetchCurrencies = exports.fetchCurrencies = function fetchCurrencies(_ref318, currencies) {
	  var commit = _ref318.commit;
	
	  commit(types.FETCH_CURRENCIES, currencies);
	};
	
	var fetchProjects = exports.fetchProjects = function fetchProjects(_ref319, _ref320) {
	  var commit = _ref319.commit;
	  var projects = _ref320.projects,
	      pagination = _ref320.pagination;
	
	  commit(types.FETCH_PROJECTS, { projects: projects, pagination: pagination });
	};
	
	var fetchAllProjects = exports.fetchAllProjects = function fetchAllProjects(_ref321, projects) {
	  var commit = _ref321.commit;
	
	  commit(types.FETCH_ALL_PROJECTS, projects);
	};
	
	var resetProjects = exports.resetProjects = function resetProjects(_ref322) {
	  var commit = _ref322.commit;
	
	  commit(types.RESET_PROJECTS);
	};
	
	var setBridgeHandoff = exports.setBridgeHandoff = function setBridgeHandoff(_ref323, payload) {
	  var commit = _ref323.commit;
	
	  commit(types.SET_BRIDGE_HANDOFF, payload);
	};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1503);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1502);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountingProviderTransformer = function (_Transformer) {
	  _inherits(AccountingProviderTransformer, _Transformer);
	
	  function AccountingProviderTransformer() {
	    _classCallCheck(this, AccountingProviderTransformer);
	
	    return _possibleConstructorReturn(this, (AccountingProviderTransformer.__proto__ || Object.getPrototypeOf(AccountingProviderTransformer)).apply(this, arguments));
	  }
	
	  _createClass(AccountingProviderTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(accountingProvider) {
	      return {
	        id: accountingProvider.id,
	        name: accountingProvider.name,
	        slug: accountingProvider.slug
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(accountingProvider) {
	      return {
	        id: accountingProvider.id,
	        name: accountingProvider.name
	      };
	    }
	  }]);
	
	  return AccountingProviderTransformer;
	}(_transformer2.default);
	
	exports.default = AccountingProviderTransformer;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var businessHoursTransformer = function (_Transformer) {
	  _inherits(businessHoursTransformer, _Transformer);
	
	  function businessHoursTransformer() {
	    _classCallCheck(this, businessHoursTransformer);
	
	    return _possibleConstructorReturn(this, (businessHoursTransformer.__proto__ || Object.getPrototypeOf(businessHoursTransformer)).apply(this, arguments));
	  }
	
	  _createClass(businessHoursTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(businessHour) {
	      return {
	        id: businessHour.id,
	        businessDays: businessHour.business_days,
	        start: businessHour.start,
	        end: businessHour.end
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(businessHour) {
	      return {
	        id: businessHour.id,
	        business_days: businessHour.businessDays,
	        start: businessHour.start,
	        end: businessHour.end
	      };
	    }
	  }]);
	
	  return businessHoursTransformer;
	}(_transformer2.default);
	
	exports.default = businessHoursTransformer;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var catalogueTransformer = function (_Transformer) {
	  _inherits(catalogueTransformer, _Transformer);
	
	  function catalogueTransformer() {
	    _classCallCheck(this, catalogueTransformer);
	
	    return _possibleConstructorReturn(this, (catalogueTransformer.__proto__ || Object.getPrototypeOf(catalogueTransformer)).apply(this, arguments));
	  }
	
	  _createClass(catalogueTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(catalogues) {
	      return {
	        id: catalogues.id,
	        clientId: catalogues.client_id,
	        actionCode: catalogues.action_code,
	        productGroupId: catalogues.product_group_id,
	        name: catalogues.name,
	        issuedAt: catalogues.issued_at,
	        versionId: catalogues.version_id,
	        validFrom: catalogues.valid_from,
	        validTo: catalogues.valid_to,
	        reference: catalogues.reference,
	        note: catalogues.note
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(catalogues) {
	      return {
	        id: catalogues.id,
	        client_id: catalogues.clientId,
	        action_code: catalogues.actionCode,
	        product_group_id: catalogues.productGroupId,
	        name: catalogues.name,
	        issued_at: catalogues.issuedAt,
	        version_id: catalogues.versionId,
	        valid_from: catalogues.validFrom,
	        valid_to: catalogues.validTo,
	        reference: catalogues.reference,
	        note: catalogues.note
	      };
	    }
	  }]);
	
	  return catalogueTransformer;
	}(_transformer2.default);
	
	exports.default = catalogueTransformer;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientTypeTransformer = function (_Transformer) {
	  _inherits(ClientTypeTransformer, _Transformer);
	
	  function ClientTypeTransformer() {
	    _classCallCheck(this, ClientTypeTransformer);
	
	    return _possibleConstructorReturn(this, (ClientTypeTransformer.__proto__ || Object.getPrototypeOf(ClientTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ClientTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(clientType) {
	      return {
	        id: clientType.id,
	        name: clientType.name,
	        exciseAdditionalCode: clientType.excise_additional_code
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(clientType) {
	      return {
	        id: clientType.id,
	        name: clientType.name,
	        excise_additional_code: clientType.exciseAdditionalCode
	      };
	    }
	  }]);
	
	  return ClientTypeTransformer;
	}(_transformer2.default);
	
	exports.default = ClientTypeTransformer;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckBusinessTransformer = function (_Transformer) {
	  _inherits(CheckBusinessTransformer, _Transformer);
	
	  function CheckBusinessTransformer() {
	    _classCallCheck(this, CheckBusinessTransformer);
	
	    return _possibleConstructorReturn(this, (CheckBusinessTransformer.__proto__ || Object.getPrototypeOf(CheckBusinessTransformer)).apply(this, arguments));
	  }
	
	  _createClass(CheckBusinessTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(checkBusiness) {
	      return {
	        email: checkBusiness.email ? checkBusiness.email : '',
	        businessRegistrationNumber: checkBusiness.business_registration_number ? checkBusiness.business_registration_number : '',
	        businessName: checkBusiness.name ? checkBusiness.name : '',
	        type: checkBusiness.business_type ? checkBusiness.business_type : '',
	        address: checkBusiness.address ? checkBusiness.address : '',
	        postalCode: checkBusiness.postal_code ? checkBusiness.postal_code : '',
	        city: checkBusiness.city ? checkBusiness.city : '',
	        country: checkBusiness.country ? checkBusiness.country : '',
	        isVatRegistered: checkBusiness.is_vat_registered ? checkBusiness.is_vat_registered : '',
	        isRegisteredBusinessEnterprise: checkBusiness.is_registered_business_enterprise ? checkBusiness.is_registered_business_enterprise : ''
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(checkBusiness) {
	      return {
	        email: checkBusiness.email,
	        business_registration_number: checkBusiness.businessRegistrationNumber
	      };
	    }
	  }]);
	
	  return CheckBusinessTransformer;
	}(_transformer2.default);
	
	exports.default = CheckBusinessTransformer;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EdiOrderItemTransformer = function (_Transformer) {
	  _inherits(EdiOrderItemTransformer, _Transformer);
	
	  function EdiOrderItemTransformer() {
	    _classCallCheck(this, EdiOrderItemTransformer);
	
	    return _possibleConstructorReturn(this, (EdiOrderItemTransformer.__proto__ || Object.getPrototypeOf(EdiOrderItemTransformer)).apply(this, arguments));
	  }
	
	  _createClass(EdiOrderItemTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(ediOrderItem) {
	      return {
	        id: ediOrderItem.id,
	        ediOrderId: ediOrderItem.edi_order_id,
	        productId: ediOrderItem.product_id,
	        ediOrderItemProductId: ediOrderItem.edi_order_item_product_id,
	        lineNumber: ediOrderItem.line_number,
	        description: ediOrderItem.description,
	        quantityOrdered: ediOrderItem.quantity_ordered,
	        quantityConfirmed: ediOrderItem.quantity_confirmed,
	        quantityReceived: ediOrderItem.quantity_received,
	        packageUnitType: ediOrderItem.package_unit_type,
	        price: ediOrderItem.price,
	        buyerOrderQuantity: ediOrderItem.buyer_order_quantity,
	        buyerOrderLineNumber: ediOrderItem.buyer_order_line_number,
	        supplierOrderQuantity: ediOrderItem.supplier_order_quantity,
	        supplierOrderLineNumber: ediOrderItem.supplier_order_line_number,
	        orderResponseStatus: ediOrderItem.order_response_status,
	        productNumber: ediOrderItem.product_number,
	        batchIds: ediOrderItem.batch_ids
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(ediOrderItem) {
	      return {
	        id: ediOrderItem.id,
	        edi_order_id: ediOrderItem.ediOrderId,
	        product_id: ediOrderItem.productId,
	        edi_order_item_product_id: ediOrderItem.ediOrderItemProductId,
	        line_number: ediOrderItem.lineNumber,
	        description: ediOrderItem.description,
	        quantity_ordered: ediOrderItem.quantityOrdered,
	        quantity_confirmed: ediOrderItem.quantityConfirmed,
	        quantity_received: ediOrderItem.quantityReceived,
	        package_unit_type: ediOrderItem.packageUnitType,
	        price: ediOrderItem.price,
	        buyer_order_quantity: ediOrderItem.buyerOrderQuantity,
	        buyer_order_line_number: ediOrderItem.buyerOrderLineNumber,
	        supplier_order_quantity: ediOrderItem.supplierOrderQuantity,
	        supplier_order_line_number: ediOrderItem.supplierOrderLineNumber,
	        order_response_status: ediOrderItem.orderResponseStatus,
	        product_number: ediOrderItem.productNumber,
	        batch_ids: ediOrderItem.batchIds
	      };
	    }
	  }]);
	
	  return EdiOrderItemTransformer;
	}(_transformer2.default);
	
	exports.default = EdiOrderItemTransformer;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailTransformer = function (_Transformer) {
	  _inherits(EmailTransformer, _Transformer);
	
	  function EmailTransformer() {
	    _classCallCheck(this, EmailTransformer);
	
	    return _possibleConstructorReturn(this, (EmailTransformer.__proto__ || Object.getPrototypeOf(EmailTransformer)).apply(this, arguments));
	  }
	
	  _createClass(EmailTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(item) {
	      return {
	        toEmail: item.to_email,
	        fromEmail: item.from_email,
	        fromName: item.from_name,
	        attachmentName: item.attachment_name,
	        message: item.message,
	        title: item.title,
	        userEmail: item.user_email,
	        commonEmail: item.common_email
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(item) {
	      return {
	        to_email: item.toEmail,
	        from_email: item.fromEmail,
	        from_name: item.fromName,
	        attachment_name: item.attachmentName,
	        message: item.message,
	        title: item.title
	      };
	    }
	  }]);
	
	  return EmailTransformer;
	}(_transformer2.default);
	
	exports.default = EmailTransformer;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExciseEntryTransformer = function (_Transformer) {
	  _inherits(ExciseEntryTransformer, _Transformer);
	
	  function ExciseEntryTransformer() {
	    _classCallCheck(this, ExciseEntryTransformer);
	
	    return _possibleConstructorReturn(this, (ExciseEntryTransformer.__proto__ || Object.getPrototypeOf(ExciseEntryTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ExciseEntryTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(entry) {
	      return {
	        id: entry.id,
	        flag: entry.flag,
	        createdAt: (0, _moment2.default)(entry.created_at).format('DD-MM-YY'),
	        excisableType: entry.excisable_type,
	        productName: entry.product,
	        qty: entry.qty,
	        volume: entry.volume,
	        abv: entry.abv,
	        amountLiter: entry.amount_liter,
	        exciseType: entry.excise_type,
	        exciseGroup: entry.excise_group,
	        exciseBasic: entry.excise_basic,
	        excisePackaging: entry.excise_packaging,
	        exciseAdditionalCode: entry.additional_code,
	        additionalCodeDesc: entry.additional_code_desc,
	        excisableId: entry.excisable_id,
	        excisable: entry.excisable,
	        linkId: entry.link_id,
	        receiverName: entry.receiver_name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(entry) {
	      return {
	        id: entry.id,
	        excise_group_id: entry.exciseGroup,
	        excise_basic_id: entry.exciseBasic,
	        excise_packaging_id: entry.excisePackaging,
	        excise_additional_code_id: entry.exciseAdditionalCode
	      };
	    }
	  }]);
	
	  return ExciseEntryTransformer;
	}(_transformer2.default);
	
	exports.default = ExciseEntryTransformer;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var businessHourExceptionsTransformer = function (_Transformer) {
	  _inherits(businessHourExceptionsTransformer, _Transformer);
	
	  function businessHourExceptionsTransformer() {
	    _classCallCheck(this, businessHourExceptionsTransformer);
	
	    return _possibleConstructorReturn(this, (businessHourExceptionsTransformer.__proto__ || Object.getPrototypeOf(businessHourExceptionsTransformer)).apply(this, arguments));
	  }
	
	  _createClass(businessHourExceptionsTransformer, null, [{
	    key: 'send',
	    value: function send(previewParams) {
	      return {
	        email_to: previewParams.email_to,
	        email_cc: previewParams.email_cc,
	        message: previewParams.message,
	        subject: previewParams.subject,
	
	        test: previewParams.test,
	        notes: previewParams.notes
	      };
	    }
	  }]);
	
	  return businessHourExceptionsTransformer;
	}(_transformer2.default);
	
	exports.default = businessHourExceptionsTransformer;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderPickupTransformer = function (_Transformer) {
	  _inherits(OrderPickupTransformer, _Transformer);
	
	  function OrderPickupTransformer() {
	    _classCallCheck(this, OrderPickupTransformer);
	
	    return _possibleConstructorReturn(this, (OrderPickupTransformer.__proto__ || Object.getPrototypeOf(OrderPickupTransformer)).apply(this, arguments));
	  }
	
	  _createClass(OrderPickupTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(orderPickup) {
	      return {
	        id: orderPickup.id,
	        orderId: orderPickup.order_id,
	        organizationId: orderPickup.organization_id,
	        shippingProviderId: orderPickup.shipping_provider_id,
	        shippingStatusId: orderPickup.shipping_status_id,
	        number: orderPickup.number,
	        organization: orderPickup.organization,
	        shippingProvider: orderPickup.shipping_provider,
	        shippingStatus: orderPickup.shipping_status,
	        pickupPriority: orderPickup.pickup_priority,
	        note: orderPickup.note,
	        pickupBy: orderPickup.pickup_by,
	        pickupDate: orderPickup.pickup_date,
	        shippingDate: orderPickup.shipping_date,
	        deliveryDate: orderPickup.delivery_date,
	        createdAt: orderPickup.created_at,
	        trackingUrl: orderPickup.tracking_url,
	        customerName: orderPickup.customer_name
	      };
	    }
	  }]);
	
	  return OrderPickupTransformer;
	}(_transformer2.default);
	
	exports.default = OrderPickupTransformer;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _productWarehouse = __webpack_require__(196);
	
	var _productWarehouse2 = _interopRequireDefault(_productWarehouse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductSearchTransformer = function (_Transformer) {
	  _inherits(ProductSearchTransformer, _Transformer);
	
	  function ProductSearchTransformer() {
	    _classCallCheck(this, ProductSearchTransformer);
	
	    return _possibleConstructorReturn(this, (ProductSearchTransformer.__proto__ || Object.getPrototypeOf(ProductSearchTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductSearchTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(product) {
	      var fieldsData = [];
	      try {
	        if (product.fields_json !== '') {
	          if ((product.fields_json !== undefined || product.fields_json !== 'undefined') && product.fields_json !== null) {
	            fieldsData = JSON.parse(product.fields_json);
	          }
	        }
	      } catch (e) {
	        fieldsData = [];
	      }
	      return {
	        id: product.id,
	        name: product.name,
	        number: product.number,
	        description: product.description,
	        productGroupId: product.product_group_id,
	        productType: product.product_type,
	        productTypeId: product.product_type_id,
	        productPackagingId: product.product_packaging_id,
	        productPackagingName: product.product_packaging_name,
	        price: product.price,
	        taxPercentage: product.tax_percentage,
	        taxId: product.tax_id,
	        icon: product.icon ? { url: product.icon } : undefined,
	        duration: product.duration,
	        breaktime: product.breaktime,
	        appointable: product.appointable,
	        productDepositId: product.product_deposit_id,
	        product_deposit_checkbox: product.product_deposit_checkbox,
	        qty: product.qty,
	        currentStock: product.qty,
	        externalId: product.external_id,
	        warehouses: product.warehouses !== undefined ? _productWarehouse2.default.fetchCollection(product.warehouses) : [],
	        fieldsJSON: fieldsData,
	        excisable: product.excisable,
	        purchasePrice: product.purchase_price,
	        costPrice: product.cost_price,
	        errorUpdate: product.error_update,
	        warehouseId: product.warehouse_id,
	        orderProductNote: product.order_product_note,
	        salePriceHoreca: product.salePriceHoreca,
	        ddpVmp: product.ddpVmp
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(product) {
	      return {
	        id: product.id
	      };
	    }
	  }]);
	
	  return ProductSearchTransformer;
	}(_transformer2.default);
	
	exports.default = ProductSearchTransformer;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductTypeTransformer = function (_Transformer) {
	  _inherits(ProductTypeTransformer, _Transformer);
	
	  function ProductTypeTransformer() {
	    _classCallCheck(this, ProductTypeTransformer);
	
	    return _possibleConstructorReturn(this, (ProductTypeTransformer.__proto__ || Object.getPrototypeOf(ProductTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(productType) {
	      return {
	        id: productType.id,
	        name: productType.name,
	        group: productType.group,
	        subGroup: productType.sub_group,
	        stockable: productType.stockable
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(productType) {
	      return {
	        id: productType.id,
	        name: productType.name,
	        group: productType.group,
	        sub_group: productType.subGroup,
	        stockable: productType.stockable
	      };
	    }
	  }]);
	
	  return ProductTypeTransformer;
	}(_transformer2.default);
	
	exports.default = ProductTypeTransformer;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PurchaseProductTransformer = function (_Transformer) {
	  _inherits(PurchaseProductTransformer, _Transformer);
	
	  function PurchaseProductTransformer() {
	    _classCallCheck(this, PurchaseProductTransformer);
	
	    return _possibleConstructorReturn(this, (PurchaseProductTransformer.__proto__ || Object.getPrototypeOf(PurchaseProductTransformer)).apply(this, arguments));
	  }
	
	  _createClass(PurchaseProductTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(purchase) {
	      var isPurchaseEdit = purchase.qty_receive.toString();
	      if (_vue2.default.router.history.current.name === 'inventory.purchase.edit') {
	        isPurchaseEdit = purchase.qty.toString();
	      }
	
	      return {
	        id: purchase.id,
	        name: purchase.product !== undefined ? purchase.product.name : '',
	        batchId: purchase.batch_id,
	        qty: purchase.qty.toString(),
	        productId: purchase.product !== undefined ? _product2.default.fetch(purchase.product) : purchase.product_id,
	        purchasePrice: purchase.purchase_price.toString(),
	        costPrice: purchase.cost_price.toString(),
	        purchaseId: purchase.purchase_id,
	        notes: purchase.notes,
	        qtyReceive: purchase.qty_receive !== undefined ? isPurchaseEdit : 0,
	        qtyDamage: purchase.qty_damage !== undefined ? purchase.qty_damage.toString() : 0,
	        product: purchase.product !== undefined ? _product2.default.fetch(purchase.product) : []
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(purchase) {
	      var productId = _typeof(purchase.productId) === 'object' ? purchase.productId.id : purchase.productId;
	      return {
	        purchase_product_id: purchase.id,
	        qty: purchase.qty,
	        batch_id: purchase.batchId,
	        id: productId,
	        purchase_price: purchase.purchasePrice,
	        cost_price: purchase.costPrice,
	        notes: purchase.notes,
	        qty_receive: purchase.qtyReceive !== undefined ? purchase.qtyReceive : 0,
	        qty_damage: purchase.qtyDamage !== undefined ? purchase.qtyDamage : 0
	      };
	    }
	  }]);
	
	  return PurchaseProductTransformer;
	}(_transformer2.default);
	
	exports.default = PurchaseProductTransformer;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var purchaseStatusesTransformer = function (_Transformer) {
	  _inherits(purchaseStatusesTransformer, _Transformer);
	
	  function purchaseStatusesTransformer() {
	    _classCallCheck(this, purchaseStatusesTransformer);
	
	    return _possibleConstructorReturn(this, (purchaseStatusesTransformer.__proto__ || Object.getPrototypeOf(purchaseStatusesTransformer)).apply(this, arguments));
	  }
	
	  _createClass(purchaseStatusesTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(purchaseStatuses) {
	      return {
	        id: purchaseStatuses.id,
	        name: purchaseStatuses.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(purchaseStatuses) {
	      return {
	        id: purchaseStatuses.id,
	        name: purchaseStatuses.name
	      };
	    }
	  }]);
	
	  return purchaseStatusesTransformer;
	}(_transformer2.default);
	
	exports.default = purchaseStatusesTransformer;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubscriberTransformer = function (_Transformer) {
	  _inherits(SubscriberTransformer, _Transformer);
	
	  function SubscriberTransformer() {
	    _classCallCheck(this, SubscriberTransformer);
	
	    return _possibleConstructorReturn(this, (SubscriberTransformer.__proto__ || Object.getPrototypeOf(SubscriberTransformer)).apply(this, arguments));
	  }
	
	  _createClass(SubscriberTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(subscriber) {
	      return {
	        id: subscriber.id,
	        hash_code: subscriber.hash_code,
	        contact_id: subscriber.contact_id,
	        name: subscriber.name,
	        email: subscriber.email,
	        subscribe: subscriber.subscribe,
	        created_at: subscriber.created_at
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(subscriber) {
	      return {
	        contact_ids: subscriber.contact_ids
	      };
	    }
	  }]);
	
	  return SubscriberTransformer;
	}(_transformer2.default);
	
	exports.default = SubscriberTransformer;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TransactionTypeTransformer = function (_Transformer) {
	  _inherits(TransactionTypeTransformer, _Transformer);
	
	  function TransactionTypeTransformer() {
	    _classCallCheck(this, TransactionTypeTransformer);
	
	    return _possibleConstructorReturn(this, (TransactionTypeTransformer.__proto__ || Object.getPrototypeOf(TransactionTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(TransactionTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(transactionType) {
	      return {
	        id: transactionType.id,
	        code: transactionType.code,
	        description: transactionType.description,
	        relations: transactionType.relations
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(transactionType) {
	      return {
	        id: transactionType.id,
	        code: transactionType.code,
	        description: transactionType.description
	      };
	    }
	  }]);
	
	  return TransactionTypeTransformer;
	}(_transformer2.default);
	
	exports.default = TransactionTypeTransformer;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarehouseReportTransformer = function (_Transformer) {
	  _inherits(WarehouseReportTransformer, _Transformer);
	
	  function WarehouseReportTransformer() {
	    _classCallCheck(this, WarehouseReportTransformer);
	
	    return _possibleConstructorReturn(this, (WarehouseReportTransformer.__proto__ || Object.getPrototypeOf(WarehouseReportTransformer)).apply(this, arguments));
	  }
	
	  _createClass(WarehouseReportTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(item) {
	      return {
	        productName: item.product_name,
	        nameOfWarehouse: item.name_of_warehouse,
	        productNumber: item.product_number,
	        productValue: item.product_value.toLocaleString('no-NB', { style: 'currency', currency: 'NOK' }),
	        vmpNumber: item.vmp_number,
	        qtyAvailable: item.qty_available,
	        crateQtyAvailable: item.qty_crate
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send() {
	      return {};
	    }
	  }]);
	
	  return WarehouseReportTransformer;
	}(_transformer2.default);
	
	exports.default = WarehouseReportTransformer;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.router = undefined;
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuexRouterSync = __webpack_require__(3155);
	
	var _vuexRouterSync2 = _interopRequireDefault(_vuexRouterSync);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(827);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _auth = __webpack_require__(53);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _vueRouter = __webpack_require__(3143);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(853);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _routeMiddleware = __webpack_require__(852);
	
	var _routeMiddleware2 = _interopRequireDefault(_routeMiddleware);
	
	var _vueI18n = __webpack_require__(764);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _elementUi = __webpack_require__(2244);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _locale = __webpack_require__(287);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _numberFormats = __webpack_require__(440);
	
	var _numberFormats2 = _interopRequireDefault(_numberFormats);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vue2GoogleMaps = __webpack_require__(3154);
	
	var VueGoogleMaps = _interopRequireWildcard(_vue2GoogleMaps);
	
	var _vueToastNotification = __webpack_require__(3145);
	
	var _vueToastNotification2 = _interopRequireDefault(_vueToastNotification);
	
	__webpack_require__(2404);
	
	__webpack_require__(2405);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.config.debug = ("production") !== 'production';
	
	var getBridgeBlockedToastMessage = function getBridgeBlockedToastMessage() {
	  var locale = _store2.default.state.profile.account && _store2.default.state.profile.account.language || ("no");
	  var fallbackLocale = _locale2.default[locale] ? locale : 'en';
	
	  return _locale2.default[fallbackLocale].static.bridgeHandoff.blockedToast;
	};
	
	_vue2.default.config.keyCodes = {
	  decimal: 190
	};
	
	_store2.default.dispatch('checkAuthentication');
	
	var logoutErrors = [40102, 40103];
	_axios2.default.defaults.baseURL = ("https://api.kundan.no");
	_axios2.default.defaults.headers.common.Accept = 'application/json';
	_axios2.default.interceptors.response.use(function (response) {
	  return response;
	}, function (error) {
	  var data = error.response && error.response.data;
	  var isBridgeHandoffRejection = data && (data.state === 'handed_off' || data.state === 'decommissioned') && (error.response.status === 409 || error.response.status === 410);
	  if (isBridgeHandoffRejection) {
	    _store2.default.dispatch('setBridgeHandoff', {
	      stock_mutations_handed_off: true,
	      stock_decommissioned: data.state === 'decommissioned',
	      inventory_app_url: data.inventory_app_url || ''
	    });
	
	    if (_vue2.default.$toast) {
	      _vue2.default.$toast.open({
	        message: getBridgeBlockedToastMessage(),
	        type: 'warning',
	        duration: 6000,
	        position: 'top-right',
	        queue: false
	      });
	    }
	  }
	
	  if (error.response.status === 401 && error.response.request.responseURL.indexOf('retry=1') === -1) {
	    var errorCode = error.response.data.error.code;
	
	    if (logoutErrors.indexOf(errorCode) >= 0) {
	      _auth2.default.logout();
	      return Promise.reject(error);
	    }
	
	    if (errorCode === 40104) {
	      return _auth2.default.token.getRefreshedToken(error.response);
	    }
	
	    if (errorCode === 40113 && _vue2.default.router.history.current.matched.some(function (record) {
	      return record.meta.emailVerificationRequired;
	    })) {
	      _vue2.default.router.push({
	        name: 'dashboard'
	      });
	    }
	
	    if (errorCode === 40112) {
	      _vue2.default.router.push({
	        name: 'dashboard'
	      });
	    }
	  }
	  return Promise.reject(error);
	});
	_axios2.default.interceptors.request.use(function (config) {
	  if (localStorage.getItem('id_token')) {
	    config.headers.Authorization = 'Bearer ' + localStorage.getItem('id_token');
	  }
	  return config;
	}, function (error) {
	  return Promise.reject(error);
	});
	_vue2.default.$http = _axios2.default;
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = exports.router = new _vueRouter2.default({
	  routes: _routes2.default
	});
	router.beforeEach(_routeMiddleware2.default.beforeEach);
	
	_vuexRouterSync2.default.sync(_store2.default, router);
	
	_vue2.default.router = router;
	
	_vue2.default.use(_vueI18n2.default);
	
	_moment2.default.locale( true ? 'nb' : process.env.language);
	var _i18n = new _vueI18n2.default({
	  locale: ("no"),
	  messages: _locale2.default,
	  numberFormats: _numberFormats2.default,
	  fallbackLocale: 'en'
	});
	
	_vue2.default.use(_elementUi2.default, {
	  i18n: function i18n(key) {
	    return _i18n.t(key);
	  }
	});
	
	exports.default = {
	  router: router
	};
	
	
	_vue2.default.use(VueGoogleMaps, {
	  load: {
	    key: ("AIzaSyAsTB95pY6ujXaWiNnAwvwIRmd9My-tuQE"),
	    libraries: 'places' }
	});
	
	_vue2.default.filter('numberformat', function (value) {
	  if (isNaN(value)) {
	    return value;
	  }
	  value = parseFloat(value).toFixed(2);
	
	  return value.replace(/\d(?=(\d{3})+\.)/g, '$&,');
	});
	
	_vue2.default.use(_vueToastNotification2.default);

/***/ }),
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */
/***/ (function(module, exports) {

	module.exports = {"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}

/***/ }),
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2268)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1743),
	  /* template */
	  __webpack_require__(2900),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2400)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1754),
	  /* template */
	  __webpack_require__(3140),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1765),
	  /* template */
	  __webpack_require__(2923),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2387)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1770),
	  /* template */
	  __webpack_require__(3123),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2393)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1776),
	  /* template */
	  __webpack_require__(3130),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1779),
	  /* template */
	  __webpack_require__(3081),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2397)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1781),
	  /* template */
	  __webpack_require__(3136),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2285)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1813),
	  /* template */
	  __webpack_require__(2929),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1816),
	  /* template */
	  __webpack_require__(3046),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2278)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1817),
	  /* template */
	  __webpack_require__(2919),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2352)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1884),
	  /* template */
	  __webpack_require__(3048),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-6a2f5897",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2290)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1893),
	  /* template */
	  __webpack_require__(2942),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1902),
	  /* template */
	  __webpack_require__(3061),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1907),
	  /* template */
	  __webpack_require__(2909),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2306)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1923),
	  /* template */
	  __webpack_require__(2972),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2324)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1925),
	  /* template */
	  __webpack_require__(3008),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-50f7c750",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2376)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1926),
	  /* template */
	  __webpack_require__(3101),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2383)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1971),
	  /* template */
	  __webpack_require__(3114),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-b97a6120",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  translated: {
	    US: 'United States',
	    CA: 'Canada',
	    AF: 'Afghanistan',
	    AL: 'Albania',
	    DZ: 'Algeria',
	    AS: 'American Samoa',
	    AD: 'Andorra',
	    AO: 'Angola',
	    AI: 'Anguilla',
	    AQ: 'Antarctica',
	    AG: 'Antigua and/or Barbuda',
	    AR: 'Argentina',
	    AM: 'Armenia',
	    AW: 'Aruba',
	    AU: 'Australia',
	    AT: 'Austria',
	    AZ: 'Azerbaijan',
	    BS: 'Bahamas',
	    BH: 'Bahrain',
	    BD: 'Bangladesh',
	    BB: 'Barbados',
	    BY: 'Belarus',
	    BE: 'Belgium',
	    BZ: 'Belize',
	    BJ: 'Benin',
	    BM: 'Bermuda',
	    BT: 'Bhutan',
	    BO: 'Bolivia',
	    BA: 'Bosnia and Herzegovina',
	    BW: 'Botswana',
	    BV: 'Bouvet Island',
	    BR: 'Brazil',
	    IO: 'British lndian Ocean Territory',
	    BN: 'Brunei Darussalam',
	    BG: 'Bulgaria',
	    BF: 'Burkina Faso',
	    BI: 'Burundi',
	    KH: 'Cambodia',
	    CM: 'Cameroon',
	    CV: 'Cape Verde',
	    KY: 'Cayman Islands',
	    CF: 'Central African Republic',
	    TD: 'Chad',
	    CL: 'Chile',
	    CN: 'China',
	    CX: 'Christmas Island',
	    CC: 'Cocos (Keeling) Islands',
	    CO: 'Colombia',
	    KM: 'Comoros',
	    CG: 'Congo',
	    CK: 'Cook Islands',
	    CR: 'Costa Rica',
	    HR: 'Croatia (Hrvatska)',
	    CU: 'Cuba',
	    CY: 'Cyprus',
	    CZ: 'Czech Republic',
	    CD: 'Democratic Republic of Congo',
	    DK: 'Denmark',
	    DJ: 'Djibouti',
	    DM: 'Dominica',
	    DO: 'Dominican Republic',
	    TP: 'East Timor',
	    EC: 'Ecudaor',
	    EG: 'Egypt',
	    SV: 'El Salvador',
	    GQ: 'Equatorial Guinea',
	    ER: 'Eritrea',
	    EE: 'Estonia',
	    ET: 'Ethiopia',
	    FK: 'Falkland Islands (Malvinas)',
	    FO: 'Faroe Islands',
	    FJ: 'Fiji',
	    FI: 'Finland',
	    FR: 'France',
	    FX: 'France, Metropolitan',
	    GF: 'French Guiana',
	    PF: 'French Polynesia',
	    TF: 'French Southern Territories',
	    GA: 'Gabon',
	    GM: 'Gambia',
	    GE: 'Georgia',
	    DE: 'Germany',
	    GH: 'Ghana',
	    GI: 'Gibraltar',
	    GR: 'Greece',
	    GL: 'Greenland',
	    GD: 'Grenada',
	    GP: 'Guadeloupe',
	    GU: 'Guam',
	    GT: 'Guatemala',
	    GN: 'Guinea',
	    GW: 'Guinea-Bissau',
	    GY: 'Guyana',
	    HT: 'Haiti',
	    HM: 'Heard and Mc Donald Islands',
	    HN: 'Honduras',
	    HK: 'Hong Kong',
	    HU: 'Hungary',
	    IS: 'Iceland',
	    IN: 'India',
	    ID: 'Indonesia',
	    IR: 'Iran (Islamic Republic of)',
	    IQ: 'Iraq',
	    IE: 'Ireland',
	    IL: 'Israel',
	    IT: 'Italy',
	    CI: 'Ivory Coast',
	    JM: 'Jamaica',
	    JP: 'Japan',
	    JO: 'Jordan',
	    KZ: 'Kazakhstan',
	    KE: 'Kenya',
	    KI: 'Kiribati',
	    KP: 'Korea, Democratic People\'s Republic of',
	    KR: 'Korea, Republic of',
	    KW: 'Kuwait',
	    KG: 'Kyrgyzstan',
	    LA: 'Lao People\'s Democratic Republic',
	    LV: 'Latvia',
	    LB: 'Lebanon',
	    LS: 'Lesotho',
	    LR: 'Liberia',
	    LY: 'Libyan Arab Jamahiriya',
	    LI: 'Liechtenstein',
	    LT: 'Lithuania',
	    LU: 'Luxembourg',
	    MO: 'Macau',
	    MK: 'Macedonia',
	    MG: 'Madagascar',
	    MW: 'Malawi',
	    MY: 'Malaysia',
	    MV: 'Maldives',
	    ML: 'Mali',
	    MT: 'Malta',
	    MH: 'Marshall Islands',
	    MQ: 'Martinique',
	    MR: 'Mauritania',
	    MU: 'Mauritius',
	    TY: 'Mayotte',
	    MX: 'Mexico',
	    FM: 'Micronesia, Federated States of',
	    MD: 'Moldova, Republic of',
	    MC: 'Monaco',
	    MN: 'Mongolia',
	    MS: 'Montserrat',
	    MA: 'Morocco',
	    MZ: 'Mozambique',
	    MM: 'Myanmar',
	    NA: 'Namibia',
	    NR: 'Nauru',
	    NP: 'Nepal',
	    NL: 'Netherlands',
	    AN: 'Netherlands Antilles',
	    NC: 'New Caledonia',
	    NZ: 'New Zealand',
	    NI: 'Nicaragua',
	    NE: 'Niger',
	    NG: 'Nigeria',
	    NU: 'Niue',
	    NF: 'Norfork Island',
	    MP: 'Northern Mariana Islands',
	    NO: 'Norway',
	    OM: 'Oman',
	    PK: 'Pakistan',
	    PW: 'Palau',
	    PA: 'Panama',
	    PG: 'Papua New Guinea',
	    PY: 'Paraguay',
	    PE: 'Peru',
	    PH: 'Philippines',
	    PN: 'Pitcairn',
	    PL: 'Poland',
	    PT: 'Portugal',
	    PR: 'Puerto Rico',
	    QA: 'Qatar',
	    SS: 'Republic of South Sudan',
	    RE: 'Reunion',
	    RO: 'Romania',
	    RU: 'Russian Federation',
	    RW: 'Rwanda',
	    KN: 'Saint Kitts and Nevis',
	    LC: 'Saint Lucia',
	    VC: 'Saint Vincent and the Grenadines',
	    WS: 'Samoa',
	    SM: 'San Marino',
	    ST: 'Sao Tome and Principe',
	    SA: 'Saudi Arabia',
	    SN: 'Senegal',
	    RS: 'Serbia',
	    SC: 'Seychelles',
	    SL: 'Sierra Leone',
	    SG: 'Singapore',
	    SK: 'Slovakia',
	    SI: 'Slovenia',
	    SB: 'Solomon Islands',
	    SO: 'Somalia',
	    ZA: 'South Africa',
	    GS: 'South Georgia South Sandwich Islands',
	    ES: 'Spain',
	    LK: 'Sri Lanka',
	    SH: 'St. Helena',
	    PM: 'St. Pierre and Miquelon',
	    SD: 'Sudan',
	    SR: 'Suriname',
	    SJ: 'Svalbarn and Jan Mayen Islands',
	    SZ: 'Swaziland',
	    SE: 'Sweden',
	    CH: 'Switzerland',
	    SY: 'Syrian Arab Republic',
	    TW: 'Taiwan',
	    TJ: 'Tajikistan',
	    TZ: 'Tanzania, United Republic of',
	    TH: 'Thailand',
	    TG: 'Togo',
	    TK: 'Tokelau',
	    TO: 'Tonga',
	    TT: 'Trinidad and Tobago',
	    TN: 'Tunisia',
	    TR: 'Turkey',
	    TM: 'Turkmenistan',
	    TC: 'Turks and Caicos Islands',
	    TV: 'Tuvalu',
	    UG: 'Uganda',
	    UA: 'Ukraine',
	    AE: 'United Arab Emirates',
	    GB: 'United Kingdom',
	    UM: 'United States minor outlying islands',
	    UY: 'Uruguay',
	    UZ: 'Uzbekistan',
	    VU: 'Vanuatu',
	    VA: 'Vatican City State',
	    VE: 'Venezuela',
	    VN: 'Vietnam',
	    VG: 'Virgin Islands (British)',
	    VI: 'Virgin Islands (U.S.)',
	    WF: 'Wallis and Futuna Islands',
	    EH: 'Western Sahara',
	    YE: 'Yemen',
	    YU: 'Yugoslavia',
	    ZR: 'Zaire',
	    ZM: 'Zambia',
	    ZW: 'Zimbabwe'
	  }
	};

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _country = __webpack_require__(844);
	
	var _country2 = _interopRequireDefault(_country);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  country: _country2.default,
	  static: {
	    collicareConfirmedShippingReminderEmpty: 'Required order details are missing. Please go to the order details edit page and enter the contact and opening details for delivery.',
	    collicareConfirmedShippingReminder: 'Important! Please double-check the details below to ensure accurate and efficient delivery.',
	    sharedWarehouseProduct: 'Note! This product is coming from a shared warehouse. Only fields in the "Online Store" tab is available for updates.',
	    tripletexCreditNoteNotice: 'Note! Sync to Tripletex is only supported for fully credited invoices',
	    loadingProductLines: 'Loading lines…',
	    bundleProductPreview: {
	      openProductEdit: 'Open product edit',
	      bundleProducts: 'Bundle products',
	      title: 'Bundle Product view',
	      view: 'View'
	    },
	    productBundles: {
	      filters: {
	        title: 'Product Bundles',
	        all: 'All'
	      },
	      create: {
	        title: 'Add Product Bundle'
	      },
	      edit: {
	        title: 'Edit Product Bundle'
	      },
	      index: {
	        title: 'Product Bundles Overview'
	      },
	      formTabs: {
	        bundleInformation: 'Bundle Information'
	      }
	    },
	    reminderTable: {
	      type: 'Type',
	      freeAmount: 'Fee Amount',
	      dateCreated: 'Date Created',
	      reminder: 'Reminder',
	      notes: 'Notes',
	      percentage: 'Percentage',
	      fixed: 'Fixed',
	      newDueDate: 'New Due Date'
	    },
	    sharedWarehouse: {
	      notAllowed: 'You are not allowed to edit this since this is shared warehouse.'
	    },
	    bulkProcessOrder: {
	      title: 'Bulk processing of orders'
	    },
	    bulkProcessBill: {
	      title: 'Bulk processing of bills',
	      payment_date_options: {
	        selectDate: 'Select a payment date for all the selected bills',
	        dueDate: 'Use the bills due date for the payment date for each bill'
	      }
	    },
	    bulkDestroyProducts: {
	      title: 'Selected products to be destroyed',
	      name: 'Product',
	      productQty: 'Qty',
	      batch: 'Batch',
	      qtyToDestroy: 'To be Destroyed Qty',
	      available: 'Qty'
	    },
	    clientInfo: {
	      billAddressMissing: 'Bill address is missing. Click to update (button above)'
	    },
	    clientAddress: {
	      edit: {
	        title: 'Update customer address'
	      }
	    },
	    producers: {
	      add: 'Add Producer'
	    },
	    referenceSign: {
	      invoice: 'INV',
	      order: 'ORD'
	    },
	    alertMissingDetails: {
	      customerNoContactEmail: {
	        message: 'This customer has no contact email registered. Please update the customer in order to send the invoice.',
	        linkText: 'Edit client'
	      }
	    },
	    accountAlert: {
	      greetings: 'Hi',
	      msgPart1: 'your account subscription',
	      msgPart2Ending: "please make sure that the subscription is renewed so you won't to lose features in your account. Please contact.",
	      msgPart2Ended: 'your subscription has expired and features on your account may be reduced. Please contact',
	      partial: {
	        willEndIn: 'your subscription expires in',
	        days: 'days',
	        day: 'day'
	      }
	    },
	    unpaidInvoiceAlert: {
	      title: 'Overdue invoice',
	      body: 'Your Kundan account will be locked if the invoice is not paid. Please pay the overdue invoice, or contact'
	    },
	    bridgeHandoff: {
	      handedOff: 'Stock operations for this organization have moved to the Inventory App. This view is now read-only — use the Inventory App to create or edit stock, adjustments, transfers and receiving.',
	      decommissioned: 'Stock operations for this organization have been permanently moved to the Inventory App. This module is retained as a read-only archive.',
	      openApp: 'Open Inventory App',
	      blockedToast: 'This action has moved to the Inventory App. Use the Inventory App to complete it.'
	    },
	    widgets: {
	      soldProduct: {
	        filters: {
	          last3Months: 'Last 3 months',
	          last6Months: 'Last 6 months',
	          thisYear: 'This year'
	        }
	      }
	    },
	    license: {
	      licenseNumber: 'License #',
	      organizationNumber: 'Organization #',
	      licenseType: 'License Type',
	      licensePermitType: 'License Permit Type',
	      validFrom: 'Valid From',
	      validTo: 'Valid To',
	      add: 'Add License',
	      organizationNumberRequired: 'Please add the organization number in order to add a license',
	      groups: 'Groups'
	    },
	    releaseNote: {
	      toast: {
	        message: 'Kundan has been upgraded, please click this to make it yours :)'
	      },
	      modal: {
	        btnNext: 'NEXT',
	        btnPrev: 'BACK',
	        learnLink: 'Learn More',
	        pageOf: 'of',
	        versionRelease: 'Release'
	      },
	      close: {
	        gotIt: 'Got it'
	      }
	    },
	    defaultText: {
	      noData: 'No Data',
	      client: {
	        noDataMsg: "It looks like you have no clients yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Client'
	      },
	      clientGroup: {
	        noDataMsg: "It looks like you have no client groups yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Client Group'
	      },
	      product: {
	        noDataMsg: "It looks like you have no products yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Product'
	      },
	      productGroup: {
	        noDataMsg: "It looks like you have no product groups yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Product Group'
	      },
	      order: {
	        noDataMsg: "It looks like you have no orders yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Order'
	      },
	      edi: {
	        noDataMsg: 'It looks like you have no edi orders yet. Vinmonpolet usually orders Tuesdays and Thursdays'
	      },
	      bill: {
	        noDataMsg: "It looks like you have no bills yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Bill'
	      },
	      supplier: {
	        noDataMsg: "It looks like you have no supplier yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Supplier'
	      },
	      warehouse: {
	        noDataMsg: "It looks like you have no warehouse yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Warehouse'
	      },
	      unitOfMeasure: {
	        noDataMsg: "It looks like you have no unit of measures yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Unit of Measures'
	      },
	      stock: {
	        noDataMsg: "It looks like you have no stocks yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Stocks'
	      },
	      adjustment: {
	        noDataMsg: "It looks like you have no adjustment yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Adjustment Stock'
	      },
	      purchase: {
	        noDataMsg: "It looks like you have no puchase yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Purchase'
	      },
	      productTags: {
	        noDataMsg: "It looks like you have no product tag yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Product Tag'
	      },
	      PriceFields: {
	        noDataMsg: "It looks like you have no price field yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Price Field'
	      },
	      exciseEntry: {
	        noDataMsg: 'It looks like you have no Excise entries yet'
	      },
	      material: {
	        noDataMsg: "It looks like you have no materials yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Add Material'
	      },
	      batch: {
	        noDataMsg: "It looks like you have no batch yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Batch'
	      },
	      recipe: {
	        noDataMsg: "It looks like you have no recipe yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Add Recipe'
	      },
	      equipment: {
	        noDataMsg: "It looks like you have no equipment yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Add Equipment'
	      },
	      productPackaging: {
	        noDataMsg: "It looks like you have no packagings yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Add Packaging'
	      }
	    },
	
	    bulkProductAdd: {
	      emptySelectionError: 'Please add atleast one item!',
	      saveError: 'Could not save. Please check the details and try again.'
	    },
	    module: {
	      index: {
	        title: 'Modules List'
	      },
	      info: {
	        description: 'Description',
	        name: 'Name',
	        type: 'Type',
	        group: 'Group',
	        price: 'Price'
	      },
	      warning: {
	        subscribe: 'Subscribe this module?',
	        unsubscribe: 'Unsubscribed  this module?'
	      },
	      error: {
	        vmpError: 'An error occured while enabling the module, please make sure to follow instructions and try again.'
	      },
	      subscribe: {
	        title: 'Subscribe form'
	      },
	      vmp: {
	        intro: 'For VMP module to work properly please do the the following steps:',
	        step1: '1. Follow the descriptions found here:',
	        step2: '2. Add the following email to give Kundan access:'
	      },
	      unimicro: {
	        intro: 'Please provide your UniMicro credentials below to connect your accounting integration.',
	        unimicro_client_id: {
	          label: 'Client ID',
	          placeholder: 'Enter your UniMicro Client ID'
	        },
	        unimicro_client_secret: {
	          label: 'Client Secret',
	          placeholder: 'Enter your UniMicro Client Secret'
	        },
	        unimicro_access_token: {
	          label: 'Access Token',
	          placeholder: 'Paste your UniMicro Access Token'
	        },
	        unimicro_refresh_token: {
	          label: 'Refresh Token',
	          placeholder: 'Paste your UniMicro Refresh Token'
	        },
	        unimicro_environment: {
	          label: 'Environment',
	          placeholder: 'Select your UniMicro Environment'
	        }
	      },
	      fiken: {
	        intro: 'Clicking "Subscribe" will redirect you to Fiken site for account authorization.',
	        fiken_company_slug: {
	          label: 'Company to be used for the integration',
	          placeholder: 'Select Company'
	        }
	      },
	      poweroffice: {
	        intro: 'BETA! Our PowerOffice integration offers 2 types; "Standard" and "Alternative".<br><br>Select "Standard" if you want the traditional sync of accounting data when sending invoices from Kundan. For more details on the "Alternative" approach please contact <a href="mailto:support@kundan.no">customer service</a> for more guidance.'
	      },
	      ehf: {
	        intro: 'By clicking "Subscribe" you agree to the terms of using EHF Module:',
	        terms: 'I understand and accept the fees of sending EHF invoices are set to NOK 3 per EHF'
	      },
	      visma: {
	        intro: 'Clicking "Subscribe" will redirect you to Visma eAccounting site for account authorization.'
	      }
	    },
	    exciseEntry: {
	      title: 'Excise Entries',
	      filters: {
	        label: 'Filters',
	        all: 'All',
	        source: {
	          all: 'All',
	          order: 'Order',
	          creditNote: 'Credit Note'
	        }
	      },
	      index: {
	        title: 'Excise Product entries'
	      },
	      allProduct: 'All Products',
	      table: {
	        productName: 'Product',
	        flag: 'Flag',
	        qty: 'Quantity',
	        exciseType: 'Excise Type',
	        exciseGroup: 'Excise Group',
	        excisableType: 'Excisable Type',
	        createdAt: 'Date',
	        additionalCode: 'Additional Code',
	        exciseBasic: 'Excise Basic',
	        excisePackaging: 'Excise Packaging',
	        exciseAdditionalCode: 'Additional Code',
	        volume: 'Volume',
	        abv: 'ABV',
	        liter: 'Liter',
	        receiverName: 'Name'
	      },
	      export: 'Export',
	      update: {
	        success: 'Successfully Updated'
	      }
	    },
	
	    wooProducts: {
	      attributes: {
	        abv: 'ABV',
	        beer_style: 'Beer Style',
	        country: 'Country',
	        ebu: 'EBU',
	        ibu: 'IBU',
	        packaging_material: 'Packaging Material',
	        packaging_type: 'Packaging Type',
	        producer: 'Producer',
	        quantity_in_crate: 'Quantity in Crate',
	        region: 'Region',
	        volum: 'Volum',
	        weight: 'Weight',
	        free_of_alcohol: 'Free of Alcohol',
	        free_or_low_on_gluten: 'Free or Low on Gluten',
	        sugar: 'Sugar',
	        acid: 'Acid',
	        fullness: 'Fullness',
	        freshness: 'Freshness',
	        tannins: 'Tannins',
	        bitterness: 'Bitterness',
	        colour: 'Colour',
	        odour: 'Odour',
	        taste: 'Taste',
	        storage_potential: 'Storage Potential',
	        ingredients: 'Ingredients',
	        organic: 'Organic',
	        biodynamic: 'Biodynamic',
	        locally_produced: 'Locally Produced',
	        environmentally_smart: 'Environmentally Smart',
	        kosher: 'Kosher',
	        recommended_with: 'Recommended With'
	      }
	    },
	
	    materials: {
	      title: 'Materials',
	      filters: {
	        title: 'Materials',
	        active: 'Active',
	        deactivated: 'Deactive',
	        all: 'All'
	      },
	      index: {
	        title: 'Materials'
	      },
	      create: {
	        title: 'Add Material',
	        success: 'Successfully Created'
	      },
	      edit: {
	        title: 'Edit Material',
	        success: 'Material edited successfully'
	      },
	      formTabs: {
	        materialInformation: 'Material Information'
	      },
	      types: {
	        malt: 'Malt',
	        hops: 'Hops',
	        yeast: 'Yeast',
	        sugar: 'Sugar',
	        various: 'Various',
	        packaging: 'Packaging',
	        label: 'Label',
	        capsuleOrCork: 'Capsule or cork',
	        cratesAndBoxes: 'Crates and boxes'
	      },
	      unitOfMeasures: {
	        gram: 'Gram',
	        kilogram: 'Kilogram',
	        liter: 'Liter',
	        piece: 'Piece'
	      },
	      recipeTypes: {
	        beer: 'Beer',
	        wine: 'Wine',
	        cider: 'Cider',
	        liquor: 'Liquor'
	      },
	      table: {
	        name: 'Name',
	        description: 'Description',
	        materialType: 'Material'
	      }
	    },
	
	    batches: {
	      title: 'Batch',
	      filters: {
	        title: 'Batch',
	        notStarted: 'Not started',
	        upcoming: 'Planned',
	        ongoing: 'Ongoing',
	        completed: 'Complete',
	        all: 'All'
	      },
	      index: {
	        title: 'Batch'
	      },
	      create: {
	        title: 'Add Batch',
	        success: 'Successfully Created'
	      },
	      edit: {
	        title: 'Edit Batch',
	        success: 'Successfully Updated'
	      },
	      logs: {
	        add: 'Add Batch Log'
	      },
	      view: {
	        title: 'View Batch',
	        status: 'Status',
	        recipe: 'Recipe Name',
	        estimated: 'Estimated',
	        startDate: 'Start Date',
	        endDate: 'End Date',
	        plannedStartingDate: 'Planned Starting Date',
	        bestBeforeDate: 'Best Before Date',
	        upcomingProcedures: 'Upcoming Procedures',
	        ongoingProcedures: 'Ongoing Procedures',
	        completedProcedures: 'Completed Procedures',
	        createBatchTransfer: 'Create Batch Transfer',
	        startBatch: {
	          title: 'Start batch',
	          confirm: 'All materials amounts specified in the recipe will be deducted from the material warehouse. Do you wish to continue?',
	          success: 'Batch started',
	          stockError: 'The following materials has no enough stocks to start the batch:',
	          stockErrorOptions: {
	            adjustQty: 'Adjust Quantity of ingredience(s)',
	            addNew: 'Add new similar ingredience(s)',
	            purchaseOrder: 'Make a purchase order',
	            stockAdjustment: 'Make a stock adjustment'
	          }
	        },
	        completeBatch: {
	          title: 'Complete batch',
	          confirmButton: 'OK, Complete Batch',
	          confirm: 'All materials amounts specified in the recipe will be deducted from the material warehouse. Do you wish to continue?',
	          success: 'Batch Completed',
	          stockError: 'The following materials has no enough stocks to complete the batch:',
	          stockErrorOptions: {
	            adjustQty: 'Adjust Quantity of ingredience(s)',
	            addNew: 'Add new similar ingredience(s)',
	            purchaseOrder: 'Make a purchase order',
	            stockAdjustment: 'Make a stock adjustment'
	          }
	        },
	        deductIngredience: {
	          title: 'Ingredience Deduction',
	          text: 'Add new deduction for',
	          confirmButton: 'OK, Deduct Now',
	          cancelButton: 'Deduct Later',
	          invalidDeductionAmount: 'Invalid Deduction Amount',
	          generalError: 'An error has occured deducting ingredience, please check your deduction input and try again.',
	          stockError: 'The following materials has no enough stocks:',
	          deductAll: {
	            title: 'Deduct All Ingrediences',
	            message: 'Are you sure to deduct all ingrediences from the warehouse?',
	            button: 'Deduct All Ingrediences from Warehouse',
	            confirmButton: 'Deduct All'
	          }
	        },
	        startProcedure: {
	          confirm: 'All materials amounts specified in this procedure will be deducted from the material warehouse. Do you wish to continue?'
	        }
	      },
	      formTabs: {
	        batchInformation: 'Batch Information',
	        edit: 'Edit',
	        details: 'Details',
	        materials: 'Materials',
	        log: 'Log'
	      },
	      statuses: {
	        planned: 'Planned',
	        started: 'Started',
	        ongoing: 'Ongoing',
	        completed: 'Completed'
	      },
	      table: {
	        name: 'Name',
	        batchNumber: 'Batch Number',
	        status: 'Status'
	      }
	    },
	
	    recipes: {
	      title: 'Recipe',
	      filters: {
	        title: 'Recipe',
	        all: 'All'
	      },
	      index: {
	        title: 'Recipe'
	      },
	      create: {
	        title: 'Add a recipe',
	        success: 'Successfully Created'
	      },
	      edit: {
	        title: 'Edit recipe',
	        success: 'Successfully Updated',
	        ingrediences: 'Ingrediences',
	        procedures: 'Procedures',
	        equipment: 'Equipment',
	        addProcedure: 'Add Procedure',
	        editProcedure: 'Edit Procedure',
	        step: 'Step'
	      },
	      types: {
	        beer: 'Beer',
	        wine: 'Wine',
	        cider: 'Cider',
	        liquor: 'Liquor',
	        water: 'Water'
	      },
	      formTabs: {
	        recipeInformation: 'Recipe Information',
	        ingrediencesAndProcedures: 'Ingrediences and Procedures',
	        products: 'Products'
	      }
	    },
	
	    recipeIngrediences: {
	      index: {
	        addIngrediences: 'Add Ingrediences',
	        confirmDelete: 'This will permanently delete the recipe ingredience. Continue?',
	        confirmDeleteTitle: 'Delete Recipe Ingredience'
	      }
	    },
	
	    equipments: {
	      title: 'Equipment',
	      filters: {
	        title: 'Equipment',
	        all: 'All'
	      },
	      index: {
	        title: 'Equipment'
	      },
	      create: {
	        title: 'Add equipment',
	        success: 'Successfully Created'
	      },
	      edit: {
	        title: 'Edit equipment',
	        success: 'Successfully Updated'
	      },
	      formTabs: {
	        equipmentInformation: 'Equipment Information'
	      },
	      table: {
	        name: 'Name',
	        status: 'Status'
	      }
	    },
	
	    members: {
	      title: 'Members',
	      index: {
	        products: 'Products',
	        addProduct: 'Add Product',
	        addMember: 'Add Member',
	        tab: {
	          members: 'Members',
	          calendarSchedule: 'Calendar Schedule'
	        },
	        table: {
	          members: {
	            firstName: 'Firstname',
	            lastName: 'Lastname',
	            email: 'Email',
	            color: 'Color',
	            title: 'Title',
	            status: 'Status',
	            view: 'View'
	          }
	        },
	        dialog: {
	          cancel: 'Cancel',
	          update: 'Update',
	          add: 'Add',
	          addMember: {
	            title: 'Add member',
	            firstName: 'Firstname',
	            lastName: 'Lastname',
	            email: 'Email'
	          },
	          addBooking: {
	            showOrder: 'Show order',
	            title: 'Add booking',
	            selectProduct: 'Select product',
	            selectPractitioner: 'Select practitioner',
	            selectClient: 'Select client'
	          }
	        },
	        options: {
	          businessHours: 'Business Hours',
	          booking: 'Booking'
	        },
	        calendar: {
	          today: 'Today'
	        }
	      },
	      show: {
	        products: 'Products',
	        addProduct: 'Add Product',
	        addMember: 'Add Member'
	      }
	    },
	
	    account: {
	      toggleDebugMode: 'Toggle Debug Mode',
	      confirmDebugMode: 'Are you sure you want to toggle debug mode?',
	      onDebugMode: 'Debug mode turned on',
	      offDebugMode: 'Debug mode turned off',
	      switchOrganization: 'Switch Organization',
	      confirmSwitchOrganization: 'Are you sure you want to switch organization?',
	      switchingOrganizationMessage: 'Redirecting to new account... Please wait'
	    },
	
	    home: {
	      welcomeMsg: 'Make something awesome!'
	    },
	
	    unsubscribed: {
	      success: 'You were successfully unsubscribed from the campaign.',
	      error: "Sorry, but we couldn't unsubscribe you from the campaign. Please try again later."
	    },
	
	    accountSetup: {
	      title: 'Welcome! Your account has been created, and a password should arrive in your email within a few minutes. \n Take a few seconds to enter your info...',
	      termsError: 'You must read our Terms before registering.',
	      crm: 'Customer Relationship Management(CRM)',
	      invoicing: 'Order and Invoicing',
	      edi: 'Electronic Data Interchange (EDI)',
	      booking: 'Online Booking',
	      headerMessage1: 'Your',
	      headerMessage2: 'account has been created. We sent you an email together with your password. Please let us know who you are..'
	    },
	
	    emailSetup: {
	      title: "Let's get you started, what's your email address?",
	      emailExistSuggestion: 'Email already taken would you like to login instead ?',
	      crm: 'Customer Relationship Management(CRM)',
	      invoicing: 'Order and Invoicing',
	      edi: 'Electronic Data Interchange (EDI)',
	      booking: 'Online Booking',
	      headerMessage1: 'Let`s get started with ',
	      headerMessage2: 'Simply enter your email and you`re all set!',
	      termsError: 'You must read our Terms before registering.'
	    },
	
	    registerEdi: {
	      title: 'EDI'
	    },
	
	    registerOnlineBooking: {
	      title: 'Online Booking'
	    },
	
	    personalInfo: {
	      title: 'Personal Information'
	    },
	
	    registerDone: {
	      title: 'Successfully Subscribed!',
	      firstParagraph: 'Your account has been created.',
	      secondParagraph1: "Congratulations, you have successfully registered for the 14 days trial. A email with a confirmation link has been sent to you. If you don't receive it in the next few minutes click ",
	      secondParagraph2: 'here',
	      secondParagraph3: 'that we will send it to you again.',
	      error: 'Could not resend the link, please contact us if the problem persist.',
	      confirmationResent: 'A email confirmation has been resent successfully.'
	    },
	
	    login: {
	      title: 'Login to your Kundan account',
	      newUser: 'New User',
	      forgotPassword: 'Forgot your password?',
	      errorBoxTitle: 'Wrong login',
	      inactiveAccount: 'Subscription ended, please contact support'
	    },
	
	    resetPassword: {
	      title: 'Reset Password',
	      firstParagraph: 'We will send you an email with a link to reset the password.',
	      successMessage: 'A email with the link has been sent.'
	    },
	
	    smsTwoFactorVerification: {
	      title: 'SMS Two Factor Authentication',
	      enabled: 'Enabled',
	      verificationCodeSent: 'The verification code has been sent to your mobile number',
	      successMessage: 'Successfully verified code.',
	      verificationCodeIncorrect: 'The code you entered is incorrect',
	      enableWarningMessage: 'To enable SMS Two Factor Authentication on your account: <br/> <br/> 1. Enter your Mobile Number and click Send Code. <br/> 2. Enter the verification code you received.',
	      verifyMobileNUmber: 'Verify Your Mobile Number',
	      enterMobileNUmber: 'Enter Mobile Number',
	      sendCode: 'Send Code',
	      resendCode: 'Resend Code',
	      codeVerification: 'Verification Code',
	      enterToken: 'Enter Code',
	      verifyCode: 'Verify Code',
	      invalidMobileNumber: 'The mobile number you entered is invalid.',
	      requiredMobileNumber: 'Please enter your mobile number.',
	      unableToSendVerification: 'Unable to send verification code',
	      smsTwoFactorAuthEnabled: 'SMS Two Factor Authentication has been enabled on your account.',
	      google2faEnabledWarning: 'Google Two-Factor Authentication is currently enabled on your account, only one Two-Factor Authentication module can be enabled at a time.'
	    },
	
	    googleTwoFactorVerification: {
	      title: 'Google Two Factor Authentication',
	      enabled: 'Enabled',
	      successMessage: 'Successfully verified code.',
	      verificationCodeIncorrect: 'The code you entered is incorrect',
	      enableWarningMessage: 'To enable Google Two Factor Authentication on your account:<br/><br/> <b>1. Scan the QR Code below with Google Authenticator App. <br/> 2. Enter the verification code and click Verify Code.</b>',
	      codeVerification: 'Verification Code',
	      enterToken: 'Enter Code',
	      verifyCode: 'Verify Code',
	      smsTwoFactorAuthEnabled: 'Google Two Factor Authentication has been enabled on your account.',
	      sms2faEnabledWarning: 'SMS Two-Factor Authentication is currently enabled on your account, only one Two-Factor Authentication module can be enabled at a time.'
	    },
	
	    dashboard: {
	      title: 'Dashboard',
	      emailConfirmationTitle: 'Please verify your email before continuing',
	      emailConfirmationText1: 'Before you can access the account you must verify your email address.',
	      emailConfirmationText2: 'All you have todo is to check your email account. Don`t forget to check your spam folder in case the email is missing.',
	      emailConfirmationText3: 'Follow the steps in the email in order to verify you address. Do note, your passoword to Kundan is also located in the same email.',
	      emailConfirmationText4: 'Note! If you can`t find our email anywhere, you can simply request a new email by clicking the link below:',
	      emailConfirmationResendButton: 'Click here to re-send the verification email',
	      emailConfirmationResendLoading: 'Sending email... please wait!',
	      emailConfirmationResent: 'New verification email sent!',
	      emailConfirmationText5: 'Note! Please note it may take a few minutes untill the email appears. In case of problems, please don`t hesistate contacting us.',
	      emailConfirmationResentWarning: 'Confirmation sent, please check your inbox.',
	      emailConfirmationResentError: "We couldn't resend your confirmation email, please try again later.",
	      expiredSubscriptionWarning: 'Your subscription has expired, please renew your plan or choose a more suitable one.',
	      updateInformation: 'Please update information fields below.',
	      fieldsMissing: 'Fields Missing',
	      completed: 'COMPLETED',
	      addWidgetBtn: 'Add widget'
	    },
	
	    bulkAddProducts: {
	      selectedProducts: {
	        title: 'Selected products',
	        noneSelected: 'No products selected',
	        productName: 'Product',
	        productQty: 'Qty',
	        batch: 'Batch',
	        unitTypeId: 'Unit Type',
	        unitQty: 'Unit Qty',
	        qty: 'Qty',
	        available: 'Available'
	      },
	      findProducts: {
	        search: 'Search for product...'
	      }
	    },
	
	    supplier: {
	      index: {
	        title: 'Supplier'
	      },
	      filters: {
	        title: 'Suppliers',
	        today: 'Today',
	        all: 'All'
	      },
	      create: {
	        title: 'Create Supplier',
	        success: 'Successfully Created'
	      },
	      update: {
	        title: 'Update Supplier',
	        success: 'Successfully Updated'
	      },
	      edit: {
	        supplier: 'Suppleir'
	      },
	      info: {
	        phone: 'Phone Number',
	        email: 'Email',
	        code: 'Code',
	        name: 'Name',
	        streetName2: 'Street Name 2',
	        streetName1: 'Street Name',
	        country: 'Country',
	        city: 'City'
	      },
	      table: {
	        id: 'ID',
	        number: 'Number',
	        name: 'Name',
	        code: 'Code'
	      }
	    },
	    productFlow: {
	      title: 'Product Flow',
	      index: {
	        title: 'Product Flow'
	      },
	      update: {
	        title: 'Update Product Flow',
	        success: 'Successfully Updated'
	      },
	      filters: {
	        title: 'Product Flow',
	        today: 'Today',
	        all: 'All',
	        view: 'View Product Flow'
	      },
	      create: {
	        title: 'Create Product Flow',
	        success: 'Successfully Created'
	      },
	      info: {
	        title: 'Title',
	        product: 'Product',
	        order: 'Order Number',
	        qty: 'Quantity',
	        descriptions: 'Descriptions'
	      }
	    },
	
	    warehouse: {
	      index: {
	        title: 'Warehouse'
	      },
	      transactionNavigation: {
	        addTransaction: 'Add transaction',
	        stockCount: 'Stock count',
	        stockAdjustment: 'Stock adjustment',
	        transfer: 'Transfer',
	        purchase: 'Purchase'
	      },
	      filters: {
	        title: 'Warehouses',
	        today: 'Today',
	        all: 'All',
	        view: 'View Warehouses'
	      },
	      create: {
	        title: 'Create Warehouse',
	        success: 'Successfully Created'
	      },
	      update: {
	        title: 'Update Warehouse',
	        success: 'Successfully Updated'
	      },
	      edit: {
	        supplier: 'Warehouse'
	      },
	      addTransaction: {
	        title: 'Create transaction'
	      },
	      info: {
	        location: 'Location',
	        name: 'Name',
	        isBonded: '(Bonded / Untaxed items)',
	        notBonded: '(Taxed items)',
	        type: 'Type',
	        locked: ' (locked)'
	      },
	      formTabs: {
	        products: 'Products',
	        transactions: 'Transactions'
	      },
	      products: {
	        noDataMsg: 'No products found',
	        name: 'Product Name',
	        batchName: 'Batch',
	        qty: 'Quantity',
	        minimumStockLevel: 'Minimum Stock Level',
	        producer: 'Producer',
	        hideOutOfStock: 'Hide out of stock',
	        bulkDestroyProducts: 'Destroy Products'
	      },
	      destroyProduct: {
	        success: 'Successfully marked products as destroyed',
	        error: 'An error has occured processing products destruction.'
	      },
	      transactions: {
	        noDataMsg: 'No transactions found',
	        table: {
	          id: 'ID #',
	          qty: 'Quantity',
	          via: 'Via',
	          code: 'Transaction Code',
	          createdAt: 'Date',
	          productName: 'Product',
	          beforeqty: 'Before',
	          totalQty: 'Total quantity',
	          afterqty: 'After',
	          status: 'Status',
	          client: 'Customer',
	          warehouse: 'Warehouse',
	          billingNumber: 'Billing Number',
	          batchName: 'Batch'
	        },
	        filter: {
	          transactionType: [{
	            value: 'all',
	            label: 'All transaction type'
	          }, {
	            value: 'SO',
	            label: 'Sales Order'
	          }, {
	            value: 'PO',
	            label: 'Purchase Ordering Recieving'
	          }, {
	            value: 'PA',
	            label: 'PO Recieving Adjustment'
	          }, {
	            value: 'SC',
	            label: 'Stock Count Adjustment'
	          }, {
	            value: 'AJ',
	            label: 'Adjustment'
	          }, {
	            value: 'TW',
	            label: 'Transfer Between Warehouse'
	          }, {
	            value: 'TB',
	            label: 'From Batch'
	          }, {
	            value: 'TL',
	            label: 'Transfer From Other Liquor Licencee'
	          }, {
	            value: 'RS',
	            label: 'Return Of Stock'
	          }, {
	            value: 'OC',
	            label: 'Order Cancel'
	          }, {
	            value: 'BI',
	            label: 'Batch Ingredience'
	          }, {
	            value: 'PD',
	            label: 'Product Destruction'
	          }, {
	            value: 'TC',
	            label: 'Transaction Correction'
	          }]
	        }
	      }
	    },
	    unitOfMeasure: {
	      index: {
	        title: 'Unit of Measures'
	      },
	      filters: {
	        title: 'Unit of Measures',
	        today: 'Today',
	        all: 'All'
	      },
	      create: {
	        title: 'Create Unit of Measures',
	        success: 'Successfully Created'
	      },
	      update: {
	        title: 'Update Unit of Measures',
	        success: 'Successfully Updated'
	      },
	      edit: {
	        supplier: 'Unit of Measures'
	      },
	      info: {
	        code: 'Code',
	        name: 'Name'
	      }
	    },
	
	    stock: {
	      noData: 'No data found.',
	      index: {
	        title: 'Stocks'
	      },
	      filters: {
	        title: 'Stock Counts',
	        create: 'Create Stock Counts',
	        all: 'All'
	      },
	      create: {
	        title: 'Create Stock',
	        success: 'Successfully Created'
	      },
	      draft: {
	        success: 'Successfully save draft',
	        title: 'Complete Stock on draft'
	      },
	      view: {
	        title: 'Stocks',
	        details: 'stock Details',
	        products: 'List Of Products',
	        productsLegend: 'Product Table',
	        adjustment: 'List of Adjustment',
	        adjustmentLegend: 'Adjustment Table',
	        detailsLegend: 'Stock Details'
	      },
	      info: {
	        code: 'Code',
	        qty: 'Total Quantity',
	        warehouse: 'Warehouse',
	        createdAt: 'Date Created',
	        transactionDate: 'Transaction Date',
	        name: 'Name',
	        status: 'Status'
	      },
	      products: {
	        sku: 'ID',
	        name: 'Product Name',
	        physicalCount: 'Physical Counts',
	        currentCount: 'Current Counts',
	        variance: 'Variance'
	      }
	    },
	
	    purchase: {
	      noData: 'No data found.',
	      index: {
	        title: 'Puchases'
	      },
	      filters: {
	        title: 'Puchase',
	        create: 'Create Puchase',
	        all: 'All'
	      },
	      create: {
	        title: 'Create Puchase',
	        success: 'Successfully Created',
	        unfinished: 'Unfinished'
	      },
	      update: {
	        title: 'Update Puchase',
	        success: 'Successfully Update',
	        error: 'Error on updating'
	      },
	      cancel: {
	        title: 'Cancel Puchase',
	        success: 'Successfully Cancel',
	        error: 'Error on cancelling'
	      },
	      pending: {
	        title: 'Pending Puchase',
	        success: 'Successfully Pending',
	        error: 'Error on pending'
	      },
	      view: {
	        title: 'Puchases',
	        details: 'stock Details',
	        products: 'List Of Products',
	        productsLegend: 'Product Table',
	        adjustment: 'List of Adjustment',
	        adjustmentLegend: 'Adjustment Table',
	        detailsLegend: 'Purchase Details',
	        documentBtnDropdown: 'Document',
	        sendPurchaseDocument: 'Email purchase document',
	        downloadPurchaseDocument: 'Download purchase document'
	      },
	      info: {
	        code: 'Code',
	        qty: 'Total Quantity',
	        warehouse: 'Warehouse',
	        supplier: 'Supplier',
	        createdAt: 'Date Created',
	        name: 'Name',
	        comments: 'Comments',
	        status: 'Status',
	        receiveDate: 'Received Date'
	      },
	      products: {
	        sku: 'ID',
	        name: 'Product Name',
	        qty: 'Quantity',
	        qtyReceive: 'Quantity Received',
	        qtyDamage: 'Quantity Damage',
	        purchasePrice: 'Purchase Price',
	        costPrice: 'Cost Price',
	        notes: 'Notes'
	      },
	      edit: {
	        sendPurchaseSuccess: 'Purchase was sent successfully.',
	        sendPurchaseError: 'There was a error with the purchase, please try again later.'
	      },
	      status: {
	        draft: 'Draft',
	        progress: 'Progress',
	        cancelled: 'Cancelled',
	        done: 'Done',
	        unfinished: 'Unfinished',
	        pending_external: 'Progress External',
	        pending: 'Pending'
	      }
	    },
	
	    inventory: {
	      title: 'Products',
	      transaction: {
	        title: 'Transactions'
	      },
	      products: {
	        create: 'Create Products',
	        view: 'View Products'
	      }
	    },
	
	    adjustment: {
	      noData: 'No data found.',
	      index: {
	        title: 'Stock Adjustments'
	      },
	      filters: {
	        title: 'Stock Adjustments',
	        create: 'Create Stocks Adjustment',
	        all: 'All'
	      },
	      create: {
	        title: 'Create Stock  Adjustment',
	        success: 'Successfully Created'
	      },
	      draft: {
	        success: 'Successfully save draft',
	        title: 'Complete Stock  Adjustment Draft'
	      },
	      view: {
	        title: 'Adjustment',
	        details: 'Adjustment Details',
	        products: 'List Of Products',
	        productsLegend: 'Product Table',
	        adjustment: 'List of Adjustment',
	        adjustmentLegend: 'Adjustment Table',
	        detailsLegend: 'Adjustment Details'
	      },
	      info: {
	        code: 'Code',
	        qty: 'Total Quantity',
	        stock: 'Stock',
	        warehouse: 'Warehouse',
	        createdAt: 'Date Created',
	        reason: 'Reason',
	        status: 'Status',
	        adjustmentType: 'Adjustment type'
	      },
	      products: {
	        sku: 'ID',
	        name: 'Product Name',
	        qty: 'Quantity',
	        exciseAdditionalCode: 'Additional Code'
	      },
	      statuses: {
	        Adjustment: 'Adjustment',
	        Wastage: 'Wastage',
	        Destruction: 'Destruction'
	      }
	    },
	
	    transfer: {
	      noData: 'No data found.',
	      index: {
	        title: 'Stock Transfers'
	      },
	      filters: {
	        title: 'Stock Transfers',
	        create: 'Create Stocks Transfer',
	        all: 'All'
	      },
	      create: {
	        title: 'Create Stock  Transfer',
	        success: 'Successfully Created'
	      },
	      draft: {
	        success: 'Successfully save draft',
	        title: 'Complete Stock  Transfer Draft'
	      },
	      view: {
	        title: 'Transfer',
	        details: 'Transfer Details',
	        products: 'List Of Products',
	        productsLegend: 'Product Table',
	        Transfer: 'List of Transfer',
	        transferLegend: 'Transfer Table',
	        detailsLegend: 'Transfer Details'
	      },
	      info: {
	        type: 'Type',
	        code: 'Code',
	        qty: 'Total Quantity',
	        stock: 'Stock',
	        fromWarehouse: 'From Warehouse',
	        toWarehouse: 'To Warehouse',
	        createdAt: 'Date Created',
	        reason: 'Reason',
	        status: 'Status',
	        comments: 'Comments'
	      },
	      products: {
	        sku: 'ID',
	        name: 'Product Name',
	        qty: 'Quantity',
	        notes: 'Notes',
	        batch: 'Batch'
	      }
	    },
	
	    reports: {
	      downloadReport: 'Download report',
	      exciseEntryLabel: 'Excise entry',
	      noData: 'No data found for this period.',
	      clients: {
	        title: 'Client Reports',
	        client: 'Client',
	        id: 'ID',
	        balance: 'Balance ($)',
	        createdAt: 'Created At',
	        turnover: {
	          groupButton: 'Revenue',
	          viewTurnover: 'View revenue report',
	          downloadTurnover: 'Download revenue report',
	          emailTurnover: 'Send revenue report',
	          bulk: {
	            title: 'Bulksending av omsetningsrapport',
	            processing: 'Behandler...',
	            clients: 'Valgte kunder',
	            noDataSelectedClient: 'Please wait zip file is currently process, below list will not included in zip file.',
	            noDataAllSelectedClient: 'Unable to process due to all selected client is no data.',
	            yearOf: 'Period of'
	          }
	        },
	        clientSearch: {
	          placeholder: 'e.g. name or client number'
	        }
	      },
	      warehouse: {
	        warehouse_beta: 'Stock Report Beta',
	        warehouse: 'Warehouse Report',
	        all: 'All Warehouses',
	        transactionType: {
	          all: 'All transactions',
	          groupByProduct: 'Group By: Product'
	        },
	        warehouse_required: 'Please select a warehouse',
	        month_required: 'Velg en måned',
	        as_of_date: 'As of date',
	        date_range: 'Date range',
	        pick_date: 'Pick date'
	      },
	      greenDot: {
	        detailed: {
	          downloadDetailedReport: 'Download detailed report'
	        }
	      },
	      exciseEntry: {
	        title: 'Excise Entries',
	        dateRange: {
	          placeholder: 'Select the Month'
	        },
	        table: {
	          title: 'Group',
	          description: 'Description',
	          totalQuantity: 'Total Quantity',
	          totalVolume: 'Total',
	          exciseEntries: 'Excises',
	          product_name: 'Product Name',
	          product_volume: 'Product Volume',
	          product_basic: 'Product Excise Basic',
	          product_package: 'Product Excise Package',
	          order_id: 'Order ID',
	          quantity: 'Quantity',
	          created_at: 'Created At',
	          order_customer_name: 'Customer Name',
	          unitType: 'Unity Type',
	          receiverName: 'Name'
	        }
	      },
	      sales: {
	        title: 'Order Report',
	        exportYtd: 'Download YTD report',
	        dateRange: {
	          placeholder: 'Select the month'
	        },
	        group: {
	          placeholder: 'Group by',
	          names: {
	            orders: 'Order',
	            clients: 'Clients',
	            products: 'Products'
	          }
	        },
	        type: {
	          placeholder: 'Order Type'
	        },
	        filter: {
	          placeholder: 'Search',
	          label: 'filter'
	        },
	        id: 'ID',
	        status: 'Status',
	        name: 'Name',
	        sales: 'Sales ($)',
	        credit: 'Credit ($)',
	        total: 'Balance ($)',
	        clearedInvoices: 'Amount billed',
	        clearedCredit: 'Amount credited',
	        export: 'Export'
	      },
	
	      aggregatedSales: {
	        title: 'Aggregated Sales Report',
	        export: 'Download Excel',
	        includeCancelled: 'Incl. cancelled',
	        dateRange: {
	          placeholder: 'Select period'
	        },
	        groupBy: {
	          placeholder: 'Group by',
	          product: 'Product',
	          client: 'Customer',
	          clientType: 'Customer type',
	          month: 'Month',
	          year: 'Year'
	        },
	        sort: {
	          placeholder: 'Sort by',
	          revenueDesc: 'Revenue (high → low)',
	          revenueAsc: 'Revenue (low → high)',
	          volumeDesc: 'Volume (high → low)',
	          volumeAsc: 'Volume (low → high)'
	        },
	        columns: {
	          productName: 'Product',
	          productNumber: 'Product no.',
	          clientName: 'Customer',
	          clientNumber: 'Customer no.',
	          clientTypeName: 'Customer type',
	          period: 'Period',
	          totalRevenueNet: 'Net revenue (NOK)',
	          totalRevenueGross: 'Gross revenue (NOK)',
	          totalVolumeLiters: 'Volume (liters)',
	          orderCount: 'Order count',
	          totalQuantityUnits: 'Units'
	        },
	        statuses: {
	          label: 'Order status',
	          placeholder: 'Empty = default (confirmed, shipped, delivered, invoiced)',
	          options: {
	            confirmed: 'Confirmed',
	            shipped: 'Shipped',
	            delivered: 'Delivered',
	            invoiced: 'Invoiced',
	            created: 'Created',
	            cancelled: 'Cancelled'
	          }
	        },
	        summary: {
	          totalRevenueNet: 'Net revenue',
	          totalVolumeliters: 'Total volume',
	          orderCount: 'Order count'
	        },
	        metrics: {
	          label: 'Show columns'
	        }
	      },
	
	      bills: {
	        title: 'Bill Reports',
	        export: 'Export',
	        invoiceNumber: 'Invoice #',
	        billTypeName: 'Type',
	        status: 'Status',
	        invoiceDate: 'Invoice Date',
	        dueDate: 'Due Date',
	        customer: 'Customer',
	        email: 'Email',
	        address: 'Address',
	        sum: 'Sum',
	        vat: 'Vat',
	        invoiceAmount: 'Invoice Amount',
	        paidAmount: 'Paid Amount',
	        dueAmount: 'Due Amount',
	        balance: 'Balance',
	        draft: 'Draft',
	        pending: 'Pending',
	        sent: 'Sent',
	        sending: 'Sending',
	        cleared: 'Cleared',
	        partlypaid: 'Partly paid',
	        cancelled: 'Cancelled',
	        total: 'Total',
	        allClients: 'All clients',
	        cash: 'Cash',
	        banktransfer: 'Bank transfer',
	        paid: 'Paid',
	        due: 'Due'
	      },
	      fees: {
	        skatteetaten: {
	          title: 'Skatteetaten',
	          due_info: 'Due 18. every month'
	        },
	        helsedir: {
	          title: 'Helsedirektoratet',
	          due_info: 'Due 18. every month'
	        },
	        brod: {
	          title: 'Bryggeriforeningen',
	          due_info: 'Due 18. every month'
	        },
	        infinitum: {
	          title: 'Infinitum',
	          due_info: 'Due 7. every month'
	        },
	        title: 'Fee Reports',
	        export: 'Export in Excel',
	        exportCsv: 'Export in Csv',
	        filter: 'Filter',
	        all: 'All client',
	        orderNumber: 'Order #',
	        client: 'Client',
	        excisable: 'Excise tax?',
	        productType: 'Type',
	        internalItemNumber: 'Number',
	        externalItemNumber: 'VP number',
	        productName: 'Name',
	        producerName: 'Producer',
	        vintage: 'Vintage',
	        alcoholPercentage: 'Alcohol (%)',
	        bottleVolume: 'Bottle Volum',
	        packagingType: 'Packing Type',
	        corkType: 'Cork Type',
	        isTaxable: 'Excise tax?',
	        numberOfBottlesSold: 'Bottles sold',
	        numberOfLitersSold: 'Liters sold',
	        orderProducts: 'Orders',
	        order_id: 'Order ID',
	        quantity_confirmed: 'Quantity',
	        order_date: 'Date Ordered',
	        client_name: 'Client Name',
	        number: 'Order Number',
	        month_placeholder: 'Select a month',
	        readyToCloseWarning: 'This period is soon due and ready to be closed. Click the close button to close the period and download the reports.',
	        changedWarning: 'This period has been changed. Click the close button to close the period and download the reports.',
	        closeButton: 'Close',
	        confirm: {
	          title: 'Close Excise Period',
	          message: 'Are you sure to close this excise period?',
	          button: 'Continue'
	        },
	        closeSuccessMessage: 'Successfully closed excise period, you may now download your reports',
	        exciseStatus: {
	          ongoing: 'Ongoing',
	          readyToBeClosed: 'Ready to be closed',
	          changed: 'Changed',
	          closed: 'Closed'
	        }
	      },
	      brod: {
	        export: 'Download Report'
	      }
	    },
	
	    accountInformation: {
	      title: 'Account Information',
	      profile: 'Profile',
	      basicInformation: 'Basic Information',
	      userInformation: 'User Information',
	      generalInformation: 'General',
	      organizationInformation: 'Organization Information',
	      businessInformation: 'Business Information',
	      productInformation: 'Product Information',
	      loginInformation: 'Login Information',
	      addressInformation: 'Address Information',
	      userSetting: 'Preferred Setting',
	      contactInformation: 'Contact Information',
	      passwordTitle: 'Change Password',
	      accountSaveSuccess: 'The account was successfully updated.',
	      passwordSaveSuccess: 'The password was successfully updated.',
	      addressSaveSuccess: 'The address and contact was successfully updated.',
	      general: 'General',
	      email: 'Email',
	      booking: 'Booking',
	      accounting: 'Accounting',
	      shippingProvider: 'Shipping Providers',
	      project: 'Projects',
	      twoFactorAuthentication: 'Two-Factor Authentication',
	      advance: 'Advance'
	    },
	
	    profileAddress: {
	      title: 'Address Information',
	      addressSaveSuccess: 'The address was successfully updated.'
	    },
	
	    profileContact: {
	      title: 'Contact Information',
	      addressSaveSuccess: 'The contact was successfully updated.'
	    },
	
	    organizationSettings: {
	      title: 'Settings',
	      ediSettings: 'EDI Settings',
	      settingsSaveSuccess: 'The organization settings were successfully updated.',
	      settingsSaveError: 'Could not save organization settings.',
	      disabledFieldTooltips: "This field can't be changed after the first order is created.",
	      disabledProductFieldTooltips: "This field can't be changed after the first product is created.",
	      messageTemplates: 'Customize your emails',
	      booking: 'Booking',
	      payment_identification: 'Payment Identification',
	      accounting: 'Accounting settings for export',
	      coa: {
	        title: 'Chart of accounts',
	        noCoa: 'Chart of accounts has not yet been created',
	        createCoa: 'Create COA',
	        code: {
	          label: 'Code',
	          placeholder: 'Code'
	        },
	        name: {
	          label: 'Name',
	          placeholder: 'Name'
	        },
	        description: {
	          label: 'Description',
	          placeholder: 'Description'
	        },
	        orgDefault: {
	          label: 'Organization default',
	          none: 'None',
	          receivables: 'Receivables',
	          income: 'Income',
	          vat: 'VAT',
	          deposit: 'Deposit'
	        }
	      },
	      ediBillingMethod: {
	        options: {
	          auto: 'Automatisk',
	          halfAuto: 'Halv automatisk',
	          manuel: 'Manuell'
	        }
	      },
	      emailInvoiceCopy: {
	        title: 'Email for invoice copy'
	      },
	      ediNotifyRecipients: {
	        title: 'Edi Notification Recipients',
	        addBtn: 'New Email'
	      },
	      lowStockNotifyRecipients: {
	        title: 'Low Stock Notification Recipients',
	        addBtn: 'New Email'
	      },
	      bulk_price_update: 'Bulk Price Update',
	      summary: 'Summary',
	      bulk_price_update_success: 'Product(s) price updated!',
	      bulk_price_update_status: {
	        running: {
	          title: 'The bulk price update is in progress...',
	          description: 'The system will automatically send an email once the process is complete. Please wait until it\'s finished before starting another update.'
	        },
	        failed: {
	          title: 'The bulk price update has failed',
	          description: 'The system encountered an issue during the process. As a result, we have aborted and reverted the changes. Please contact our support team, and we will investigate the issue. Once resolved, we will notify you and allow you to run the update again.'
	        }
	      },
	      bulk_price_update_entries: {
	        title: 'Bulk Price Update Entries/Histories'
	      },
	      completed: 'Completed',
	      failed: 'Failed'
	    },
	
	    publicProfile: {
	      title: 'Public Profile',
	      profileSettings: 'Profile Settings',
	      mainSettings: 'MAIN SETTINGS',
	      checkoutSettings: 'Checkoutsettings',
	      connectToStripe: 'Connect Stripe',
	      stripeConnected: 'Stripe connected',
	      defaults: 'DEFAULTS',
	      profileUrl: 'Profile Url',
	      updateSucess: 'The public profile was successfully updated.'
	    },
	
	    businessHours: {
	      title: 'Businesshours',
	      businessHoursTitle: 'Open hours',
	      businessHourExceptionsTitle: 'Exceptional hours',
	      exceptionalHoursSaveKeep: 'Keep em',
	      exceptionalHoursSaveCancel: 'Cancel em'
	    },
	
	    clientGroups: {
	      index: {
	        title: 'Client Groups Overview',
	        clientsCount: ' clients',
	        confirmDelete: 'This will permanently delete the group. Continue?',
	        confirmDeleteTitle: 'Delete Client Group',
	        deleteHasClientsError: 'Cannot delete group with clients in it.',
	        deleteError: 'Client group could not be deleted.'
	      },
	      create: {
	        title: 'Add Client Group',
	        success: 'Client Group added successfully!'
	      },
	      edit: {
	        title: 'Edit Client Group',
	        success: 'Client Group updated successfully!'
	      }
	    },
	
	    clients: {
	      organizationNumber: 'Fetch data from Brreg',
	      info: {
	        clientNumber: 'Client #:',
	        organizationNumber: 'Organization number:',
	        billType: 'Bill type:',
	        phone: 'Phone:',
	        email: 'Email:',
	        totalOrders: 'Total Orders:',
	        totalRevenue: 'Total Revenue:',
	        pendingPayments: 'Pending Payments:',
	        clientType: 'Client Type:',
	        isProducer: 'Is Producer:',
	        clientGroup: 'Client Group:',
	        firstName: 'First Name',
	        lastName: 'Last Name',
	        phoneNumber: 'Phone Number:',
	        mobileNumber: 'Mobile Number:',
	        streetName: 'Street Name:',
	        secondStreetName: 'Second Street Name:',
	        postalCode: 'Postal Code:',
	        city: 'City:',
	        orders: 'Orders',
	        bills: 'Bills',
	        totalBought: 'Total invoiced',
	        totalPending: 'Total invoiced, not paid',
	        systemGenerated: 'System generated',
	        ehfInvoiceSupport: 'EHF invoicing (Peppol)',
	        ehfSupport: {
	          yes: 'Yes — registered for EHF billing 3.0 in Peppol directory',
	          no: 'No — not registered for EHF 3.0 (save customer after org. no. to re-check)',
	          needsOrgNumber: 'Cannot verify — add organization number'
	        },
	        ehfListLabel: 'EHF (Peppol)',
	        ehfListVerified: 'Verified for EHF invoicing',
	        ehfListNotVerified: 'Not verified for EHF invoicing',
	        value: {
	          billType: {
	            options: {
	              single: 'Single',
	              consolidate: 'Consolidate'
	            }
	          }
	        }
	      },
	      index: {
	        bulkMaxLimitExceededError: 'The maximum invoices selection for bulk action is up to',
	        editTooltip: 'Edit Client Profile',
	        deleteTooltip: 'Delete Client',
	        title: 'Clients Overview',
	        confirmDelete: 'This will permanently delete the client and its orders. Continue?',
	        confirmDeleteTitle: 'Delete Client',
	        downloadAllClients: 'Download All Clients',
	        importClients: 'Drag and drop excel file here to import clients...',
	        importClientsErrorMessage: 'An error has occured during import. Please check your file and try again.',
	        importClientsSuccessMessage: 'Successfully imported clients.',
	        importData: 'Import Data',
	        exportData: 'Export Data',
	        phoneNumber: 'Phone Number',
	        email: 'Email',
	        sortName: {
	          placeholder: 'Sorter'
	        },
	        search: {
	          placeholder: 'Search by name, email or organization number'
	        },
	        listing: {
	          placeholder: 'Select Type'
	        }
	      },
	      table: {
	        name: 'Name',
	        custNo: 'Customer No.',
	        organizationNumber: 'Org. no.',
	        billType: 'Bill Type',
	        phone: 'Phone',
	        email: 'Email',
	        ehf: 'EHF',
	        ordersCount: 'Orders count',
	        createdAt: 'Created',
	        parentClient: 'Parent client',
	        billMainParent: 'Bill main parent'
	      },
	      delete: {
	        title: 'Warning',
	        confirm: 'Do you wish to delete this customer? Customers with orders cannot be deleted.',
	        success: 'Customer deleted'
	      },
	      create: {
	        title: 'Add Client',
	        success: 'Client added successfully!',
	        brrig: {
	          warning: 'Organization not found'
	        },
	        gotoEdit: 'Do you want to add more details?',
	        addMore: 'Create a new client',
	        gotoIndex: "I'm good, take me to the client index"
	      },
	      edit: {
	        title: 'Edit Client',
	        clientInfo: 'Client Information',
	        success: 'Client updated successfully!',
	        overview: 'Overview',
	        clientOrders: 'Client Orders',
	        latestOrders: 'LATEST ORDERS',
	        latestBills: 'LATEST BILLS',
	        recentActivities: 'RECENT ACTIVITIES',
	        viewAll: 'VIEW ALL',
	        allBills: 'All Bills',
	        bills: 'BILLS',
	        allActivities: 'All Activities',
	        activities: 'ACTIVITIES',
	        allOrders: 'All Orders',
	        orders: 'ORDERS',
	        editInformation: 'Edit Information',
	        totalOrders: 'TOTAL ORDERS',
	        totalBills: 'TOTAL BILLS',
	        totalActivities: 'TOTAL ACTIVITIES',
	        noActivity: 'No Activity',
	        errorNoClient: 'Please choose the client',
	        glnSuccess: 'GLN number and coordinates is available, see the fields.',
	        glnError: 'GLN number and coordinates is not found!, please check your organization number.'
	      },
	      catalogues: {
	        title: 'Catalogues',
	        sendCatalogue: 'Send Catalogue',
	        actionCodes: {
	          add: 'Add',
	          update: 'Update',
	          replace: 'Replace',
	          delete: 'Delete'
	        }
	      }
	    },
	
	    productGroups: {
	      formTabs: {
	        groupInformation: 'Group Information',
	        pricingOptions: 'Pricing Options'
	      },
	      filters: {
	        title: 'Product Groups',
	        latest: 'Latest',
	        pastMonth: 'Past Month',
	        all: 'All'
	      },
	      index: {
	        title: 'Product Groups Overview',
	        productsCount: ' products',
	        confirmDelete: 'This will permanently delete the group. Continue?',
	        confirmDeleteTitle: 'Delete Product Group',
	        deleteHasProductError: 'Cannot delete group with products in it.',
	        deleteError: 'Product group could not be deleted.'
	      },
	      create: {
	        title: 'Add Product Group',
	        success: 'Product group added successfully'
	      },
	      edit: {
	        title: 'Edit Product Groups',
	        success: 'Product group edited successfully'
	      }
	    },
	
	    productPackagings: {
	      formTabs: {
	        packagingInformation: 'Packaging Information',
	        pricingOptions: 'Pricing Options'
	      },
	      filters: {
	        title: 'Product Packagings',
	        latest: 'Latest',
	        pastMonth: 'Past Month',
	        all: 'All'
	      },
	      index: {
	        title: 'Product Packagings Overview',
	        productsCount: ' products',
	        confirmDelete: 'This will permanently delete the packaging. Continue?',
	        confirmDeleteTitle: 'Delete Product Packaging',
	        deleteHasProductError: 'Cannot delete packaging with products in it.',
	        deleteError: 'Product packaging could not be deleted.'
	      },
	      create: {
	        title: 'Add Product Packaging',
	        success: 'Product packaging added successfully'
	      },
	      edit: {
	        title: 'Edit Product Packagings',
	        success: 'Product packaging edited successfully',
	        delete: 'Product packaging deleted'
	      }
	    },
	
	    productTags: {
	      formTabs: {
	        tagInformation: 'Tag Information'
	      },
	      index: {
	        title: 'Product Tags',
	        productsCount: ' products'
	      },
	      filters: {
	        title: 'Product Tags',
	        all: 'All'
	      },
	      create: {
	        title: 'Add Product Tag',
	        success: 'Product Tag added successfully'
	      },
	      edit: {
	        title: 'Edit Product Tag',
	        success: 'Product Tag edited successfully'
	      }
	    },
	    priceFields: {
	      formTabs: {
	        tagInformation: 'Field Information'
	      },
	      index: {
	        title: 'Price Field',
	        productsCount: ' products'
	      },
	      filters: {
	        title: 'Price Fields',
	        all: 'All'
	      },
	      create: {
	        title: 'Add Price Field',
	        success: 'Product Price Field successfully'
	      },
	      edit: {
	        title: 'Edit Price Field',
	        success: 'Price Field edited successfully'
	      }
	    },
	    campaigns: {
	      listNotSetup: 'Please set up list on this campaign otherwise news will not sent!',
	      noDataMsg: 'No campaign email found',
	      index: {
	        title: 'Campaigns Overview',
	        description: 'Description',
	        campaignType: 'Type',
	        confirmDelete: 'This will permanently delete the campaign. Continue?',
	        confirmDeleteTitle: 'Delete Campaign',
	        deleteHasClientsError: 'Cannot delete campaign with emails in it.',
	        deleteError: 'Campaign could not be deleted.'
	      },
	      create: {
	        title: 'Add Campaign',
	        tabTitle: 'Campaing information',
	        campaignTypeTooltip: 'Sequence: test description. <br/><br/> Broadcast: test description.'
	      },
	      edit: {
	        title: 'Edit Campaign',
	        campaignInfo: 'Campaign Information',
	        overview: 'Campaign Overview',
	        emails: 'Emails',
	        emailBodyTooltip: 'Variables available:<br/><br/>Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}',
	        clients: 'Clients',
	        totalSubscribers: 'Subscribers',
	        unsubscribed: 'Unsubscribed',
	        bounced: 'Bounced',
	        latestSubscribers: 'Latest Subscribers',
	        latestUnsubscribed: 'Latest Unsubscribed',
	        latestBounced: 'Latest Bounced',
	        viewAll: 'View All',
	        updateSuccess: 'Campaign updated successfully.',
	        removeClientError: 'Client could not be removed from campaign.',
	        addClients: {
	          placeholder: 'Select clients'
	        },
	        addClientGroups: {
	          placeholder: 'Select client groups'
	        },
	        emailTracking: {
	          noDataMsg: 'No record found',
	          dateRange: 'Date range:',
	          countLabel: {
	            opened: 'Opened',
	            delivered: 'Delivered',
	            clicked: 'Clicked',
	            dropped: 'Dropped',
	            bounced: 'Bounced',
	            complained: 'Complained',
	            failed: 'Failed',
	            unsubscribed: 'Unsubscribed'
	          },
	          graphLabel: 'Graph',
	          recipientLabel: 'Recipients',
	          noRecipientAvailable: 'No recipients available',
	          dateRangDropDown: {
	            group1: 'Text with icon',
	            today: 'Today',
	            all: 'All',
	            group2: 'Line chart',
	            dateRange: 'Date range'
	          },
	          datePicker: {
	            shortcut: {
	              last3Days: 'Last 3 days',
	              lastWeek: 'Last week',
	              lastMonth: 'Last Month',
	              last3Month: 'Last 3 Months'
	            }
	          }
	        }
	      }
	    },
	
	    subscriberList: {
	      index: {
	        title: 'List Overview',
	        description: 'Description',
	        confirmDelete: 'This will permanently delete the list. Continue?',
	        confirmDeleteTitle: 'Delete List',
	        deleteError: 'List could not be deleted.',
	        topInfo: 'List info.',
	        fromEmail: 'Email',
	        fromName: 'Name',
	        emailCount: 'Email count'
	      },
	      create: {
	        title: 'Create List',
	        tabTitle: 'List Information'
	      },
	      edit: {
	        sendingEmailLoading: 'We are sending optin link for each emails, please wait...',
	        filterLabel: 'Filter by:',
	        tab1Title: 'Subscribers',
	        tab2Title: 'Setting',
	        tab3Title: 'Rules',
	        title: 'Edit Subscriber List',
	        overview: 'Subscriber List Overview',
	        totalSubscribers: 'Subscribers',
	        unsubscribed: 'Unsubscribed',
	        latestSubscribers: 'Latest Subscribers',
	        latestUnsubscribed: 'Latest Unsubscribed',
	        viewAll: 'View All',
	        deleteList: 'Delete List',
	        delete: 'Delete',
	        deleteConfirmHeaderMsg: 'Warning',
	        deleteConfirmBodyMsg: 'Do you wish to delete this list?, This list will permanently deleted.',
	        addClients: {
	          placeholder: 'Select clients'
	        },
	        addClientGroups: {
	          placeholder: 'Select client groups'
	        },
	        subscribers: {
	          subscribeSwitchTooltip: 'Currently: subscirbed',
	          unsubscribeSwitchTooltip: 'Currently: unsubscribe',
	          delete: 'Delete',
	          deleteConfirmHeaderMsg: 'Warning',
	          deleteConfirmBodyMsg: 'Do you wish to delete this email?, This email will no longer part of this list.',
	          alreadyInList: ' - already in this list',
	          subscribeConfirmHeaderMsg: 'Warning',
	          subscribe: 'Subscribe',
	          unsubscribe: 'Unsubscribe',
	          ableToReceive: 'Do you wish to subscribe this email? This email will receive newsletter.',
	          unableToReceive: 'Do you wish to unsubscribe this email? This email will no longer receive newsletter.',
	          ableToReceiveAll: 'Do you wish to subscribe all emails? All emails will receive newsletter.',
	          unableToReceiveAll: 'Do you wish to unsubscribe all emails? All emails will no longer receive newsletter.',
	          groupModalHeaderTitle: 'Client Group:',
	          groupModalCancel: 'Cancel',
	          groupModalApply: 'Apply'
	        },
	        filters: {
	          all: 'All',
	          unsubscribe: 'Unsubscribe'
	        }
	      }
	    },
	
	    news: {
	      index: {
	        title: 'Emails overview',
	        confirmDelete: 'This will permanently delete the email. Continue?',
	        confirmDeleteTitle: 'Delete Email',
	        deleteError: 'Email could not be deleted.'
	      },
	      create: {
	        title: 'Create Email',
	        createSucess: 'Email created successfully.',
	        sendTestSucess: 'Test email sent!'
	      },
	      edit: {
	        title: 'Edit Email',
	        updateSucess: 'Email updated successfully.'
	      }
	    },
	
	    products: {
	      types: {
	        product: 'Product',
	        bundle: 'Bundle',
	        child: 'Child',
	        service: 'Service',
	        plan: 'Plan',
	        beverage: 'Beverage',
	        beer: 'Beer',
	        mead: 'Mead',
	        wine: 'Wine',
	        liquor: 'Liquor',
	        cider: 'Cider',
	        carbonated: 'Carbonated',
	        nonCarbonated: 'Non-carbonated',
	        material: 'Material',
	        alcohol: 'Alcohol',
	        nonAlcohol: 'Non-Alcohol',
	        lightWine: 'Light Wine',
	        strongWine: 'Strong Wine',
	        redWine: 'Red Wine',
	        sparklingWine: 'Sparkling Wine'
	      },
	      formTabs: {
	        productInformation: 'Product Information',
	        productIndentification: 'Product Identification',
	        pricingOptions: 'Product details',
	        inventory: 'Inventory',
	        transactions: 'Transactions',
	        transactionsv2: 'Transactions V2',
	        mergeProduct: 'Merge Product',
	        childProducts: 'Child Products',
	        syncDetails: 'Sync Details'
	      },
	      filters: {
	        title: 'Products',
	        latest: 'Latest',
	        pastMonth: 'Past Month',
	        all: 'All',
	        withDeposit: 'With Deposit',
	        active: 'Active',
	        deactivated: 'Deactived',
	        asko: 'Available Asko',
	        vinhuset: 'Available Vinhuset',
	        marketplace: 'Available DrikkeRiket',
	        onlineStore: 'Available Online Store',
	        materials: 'Materials',
	        placeholder: 'Select Filter',
	        type: 'Type',
	        producer: 'Producer',
	        alcohol: 'Alcohol',
	        alcoholFree: 'AlcoholFree'
	      },
	      labels: {
	        priceAndTax: 'Price and tax',
	        productDetails: 'Product details',
	        mergeProduct: 'Merge Product',
	        childProducts: 'Child Products / Variations',
	        productInformation: 'Product Information',
	        productIndentification: 'Product Identification',
	        priceForm: 'Price and tax',
	        detailsForm: 'Product details',
	        exciseForm: 'Excise details',
	        packagingForm: 'Packaging details',
	        fieldPrice: 'Price Fields',
	        marketplace: 'Marketplace Selling',
	        alcohol: 'Alcohol',
	        alcoholFree: 'AlcoholFree',
	        onlineStore: 'Online Store'
	      },
	      index: {
	        title: 'Products Overview',
	        confirmDelete: 'This will permanently delete the product. Continue?',
	        confirmDeleteTitle: 'Delete Product',
	        downloadAllProducts: 'Download All Products',
	        importProducts: 'Drag and drop excel file here to import products...',
	        importProductsErrorMessage: 'An error has occured during import. Please check your file and try again.',
	        importProductsSuccessMessage: 'Successfully imported products.',
	        importProductsErrorPopupTitle: 'The import encountered some errors:',
	        importData: 'Import Data',
	        exportData: 'Export Data',
	        row: 'Row'
	      },
	      create: {
	        title: 'Add Product',
	        success: 'Product added successfully',
	        options: {
	          edit: 'Do you want to add more details?',
	          addMore: 'Create a new product',
	          gotoIndex: "I'm good, take me to the product index"
	        },
	        vmp: {
	          fetch: 'Sync from VMP'
	        }
	      },
	      syncVmp: {
	        title: 'Sync Vinmonopolet Products',
	        validatingData: 'Validating Data...',
	        added: 'Added',
	        updated: 'Updated',
	        noDataToBeSynced: 'We found no new data to sync.',
	        syncSuccess: 'Sync Successful.',
	        syncError: 'An error occurred during sync.',
	        inputRequired: 'Vinmonopolet number is required',
	        noModuleWarning: 'Please go to the <a href="/#/modules" target="_blank">"Modules"</a> page and enable Vinmonopolet to continue.',
	        existingProducts: 'Existing products',
	        newProducts: 'New products',
	        syncFieldTitle: 'Select Fields to Sync',
	        fields: {
	          name: 'Name',
	          type: 'Product type',
	          subtype: 'Product Subtype',
	          retailPriceVmp: 'Retail Price VMP',
	          producer: 'Producer',
	          country: 'Country',
	          vintage: 'Vintage',
	          alcohol_percentage: 'Alcohol Percentage',
	          bottle_volume: 'Bottle Volume',
	          cork_type: 'Cork Type',
	          packaging_material: 'Packaging Material',
	          gtin: 'GTIN',
	          colour: 'colour',
	          odour: 'Odour',
	          region: 'Region',
	          subRegion: 'SubRegion',
	          sugar: 'Sugar',
	          acid: 'Acid',
	          fullness: 'Fullness',
	          freshness: 'Freshness',
	          tannins: 'Tannins',
	          bitterness: 'Bitterness',
	          sweetness: 'Sweetness',
	          taste: 'Taste',
	          recommendedFood: 'Recommended Foods',
	          storagePotential: 'Storage Potential',
	          ingredients: 'Ingredients',
	          organic: 'Organic',
	          biodynamic: 'Biodynamic',
	          locallyProduced: 'Locally Produced',
	          environmentallySmart: 'Environmentally Smart',
	          freeOrLowOnGluten: 'Free Or Low On Gluten',
	          kosher: 'Kosher'
	        }
	      },
	      edit: {
	        title: 'Edit Product',
	        success: 'Product edited successfully',
	        error: 'Product edited failed to update'
	      },
	      delete: {
	        title: 'Warning',
	        confirm: 'Delete this product?',
	        success: 'Product successfully deleted',
	        imageConfirm: 'Delete this product image?',
	        imageSuccess: 'Product image successfully deleted'
	      },
	      merge: {
	        success: 'Product successfully merged'
	      },
	      warehouse: {
	        noDataMsg: 'No warehouse found',
	        table: {
	          qty: 'Quantity',
	          name: 'Warehouse',
	          warehouseId: 'Warehouse #',
	          batchName: 'Batch'
	        }
	      },
	      transactions: {
	        noDataMsg: 'No transactions found',
	        table: {
	          qty: 'Quantity',
	          via: 'Via',
	          status: 'Status',
	          client: 'Customer',
	          warehouse: 'Warehouse',
	          billingNumber: 'Billing Number',
	          createdAt: 'Date',
	          id: 'ID #',
	          productName: 'Product',
	          batchName: 'Batch',
	          beforeqty: 'Before',
	          afterqty: 'After'
	        }
	      },
	      table: {
	        id: 'ID',
	        price: 'Price',
	        name: 'Name',
	        qty: 'Quantity',
	        warehouses: 'Warehouse',
	        number: 'Number',
	        description: 'Description',
	        case: 'Case',
	        loose: 'Loose',
	        total: 'Total'
	      },
	      indexSettings: {
	        displayType: 'Display Type',
	        groupBy: 'Group By',
	        views: {
	          grid: 'Grid',
	          list: 'List'
	        },
	        groups: {
	          None: 'None',
	          Producer: 'Producer',
	          Type: 'Type'
	        }
	      }
	    },
	    bills: {
	      billLines: 'Bill lines',
	      formTabs: {
	        invoiceInformation: 'Invoice Information',
	        edit: 'Edit invoice',
	        emails: 'Emails',
	        reminders: 'Reminders'
	      },
	      message: {
	        delete: 'Do you want to delete this export?',
	        title: 'Delete Confirmed'
	      },
	      filters: {
	        title: 'Invoices',
	        today: 'Today',
	        upcoming: 'Upcoming',
	        pending: 'Pending',
	        sent: 'Sent',
	        overdue: 'Overdue',
	        cancelled: 'Cancelled',
	        paid: 'Paid',
	        partlyPaid: 'Partly Paid',
	        all: 'All',
	        creditNote: 'Credit Note',
	        invoice: 'Invoice'
	      },
	      index: {
	        remainingToPay: 'remaining to pay',
	        bulkMaxLimitExceededError: 'The maximum invoices selection for bulk action is up to',
	        title: 'Bills Overview',
	        confirmDelete: 'This will permanently delete the bill. Continue?',
	        confirmDeleteTitle: 'Delete Bill',
	        clientName: 'Client',
	        deleteError: 'Bill could not be deleted.',
	        deleteNotDraftError: 'Only drafts can be deleted.',
	        billStatus: 'Status',
	        dueDateFormated: 'Due Date',
	        invoiceDateFormated: 'Invoice Date',
	        billType: 'Type',
	        quantities: 'qty',
	        confirmActionTitle: 'Confirm',
	        confirmAction1: 'Are you sure you want to proceed with',
	        confirmAction2: 'on all the',
	        confirmAction3: 'selected bills',
	        email: 'Email',
	        ehf: 'Ehf',
	        paid: 'Paid',
	        sent: 'Sent',
	        edi: 'Edi',
	        action: {
	          markBilledAsPaid: 'Mark Billed as Paid'
	        },
	        overdueBadge: 'Overdue'
	      },
	      table: {
	        id: 'ID',
	        name: 'Invoice #',
	        type: 'Type',
	        status: 'Status',
	        client: 'Customer',
	        amountDue: 'Amount due',
	        amountPaid: 'Amount paid',
	        totalGross: 'Total gross',
	        dueDate: 'Due date',
	        invoiceDate: 'Invoice date'
	      },
	      create: {
	        title: 'Add Bill',
	        success: 'Bill created successfully!',
	        orderError: 'Only one bill can be created per order'
	      },
	      exportBill: {
	        title: 'Export Bill',
	        btn: 'Create',
	        confirmSuccess: 'Successfully created export',
	        error: 'Internal Error',
	        providerNotSet: 'Please select accounting provider',
	        datePeriod: 'Select period',
	        description: {
	          label: 'Description',
	          placeholder: 'Enter your description'
	        },
	        billsDateRange: {
	          placeholder: 'Select the Date Range',
	          placeholderStart: 'Start date',
	          placeholderEnd: 'End date',
	          label: 'Select period'
	        },
	        download: {
	          periode: 'Periode',
	          description: 'Description',
	          provider: 'Provider',
	          download: 'Download',
	          noData: 'No data found'
	        }
	      },
	      edit: {
	        orderReference: 'Order Reference',
	        title: 'Edit Bill',
	        detailsLegend: 'Bill Details',
	        billStatus: 'Status',
	        sourceOrder: 'Source Order',
	        sourceBill: 'Source Bill',
	        customerDetails: 'Customer Details',
	        address: 'Address',
	        updateSuccess: 'The bill was updated successfully.',
	        sendPreviewInfo: 'Please wait',
	        creditNoteTitle: 'Edit Credit Note',
	        showInvoiceBtn: 'Show Invoice',
	        downloadInvoiceBtn: 'Download Invoice',
	        showCreditNoteBtn: 'Show Credit Note',
	        downloadCreditNoteBtn: 'Download Credit Note',
	        sendInvoiceBtn: 'Send invoice by email',
	        sendEdiInvoiceBtn: 'Send invoice (EDI)',
	        sendEdiCreditNoteBtn: 'Send credit note (EDI)',
	        sendEhfInvoiceBtn: 'Send EHF',
	        sendInvoiceEmailFallbackBtn: 'Send invoice by email (differs from customer preference)',
	        sendCreditNoteEmailFallbackBtn: 'Send credit note by email (differs from customer preference)',
	        ehfNotVerifiedTitle: 'EHF is not ready for this customer',
	        ehfNotVerifiedBody: 'This customer has EHF as the billing method, but Peppol verification (EHF billing 3.0) is not recorded. Update the customer (save again) or send by email temporarily.',
	        ehfNotVerifiedClientLink: 'Open customer',
	        ehfNotVerifiedNoEmail: 'The customer has no email address; add one on the customer card before you can send by email.',
	        ehfPreferredOverEmailTitle: 'This customer can receive EHF',
	        ehfPreferredOverEmailBody: 'The billing method is set to email, but the customer is verified for EHF (Peppol). For most B2B invoices, EHF is preferred. You can send via EHF now, or use email if you still need to.',
	        ehfPreferredOverEmailNoEmail: 'Without a customer email you cannot send by email here — add an email on the customer card, or send via EHF.',
	        ehfPreferredOverEmailSendEhfBtn: 'Send with EHF (recommended)',
	        ehfPreferredOverEmailSendInvoiceEmailBtn: 'Send invoice by email',
	        ehfPreferredOverEmailSendCreditNoteEmailBtn: 'Send credit note by email',
	        ehfModuleUpsellTitle: 'Enable the EHF module for this customer',
	        ehfModuleUpsellTitleNoPeppolYet: 'Enable the EHF module first',
	        ehfModuleUpsellBody: 'This customer is verified for EHF (Peppol), but the EHF module is not enabled on your account. With EHF you can send B2B invoices electronically instead of email — often faster and more reliable.',
	        ehfModuleUpsellBodyNoPeppolYet: 'This customer has EHF as the billing method, but the EHF module is not enabled on your account. Enable the module to send via EHF. You can then save the customer again for Peppol verification if needed, or send by email temporarily.',
	        ehfModuleUpsellLink: 'Click here to enable the EHF module',
	        ehfModuleUpsellUnavailable: 'The EHF module is not available right now. Contact support if you need help.',
	        resendInvoiceBtn: 'Resend',
	        sendReminder: 'Send Reminder',
	        overdueInvoiceNotice: 'This invoice is past its due date. Open the Reminders tab to send a payment reminder by email.',
	        overdueBadge: 'Overdue',
	        invoiceWithReminderFee: 'Reminder PDF',
	        invoiceSent: 'Invoice sent',
	        sendCreditNoteBtn: 'Send credit note by email',
	        sendInvoiceSuccess: 'Invoice was successfully queued for sending.',
	        sendInvoiceError: 'There was a error with the invoice, please try again later.',
	        createCreditNoteBtn: 'Credit Note',
	        createNoteError: 'There was a error with the credit note, please try again later.',
	        creditNoteProducttitle: 'Credit Note Products',
	        noCreditNoteSource: 'No credit note source available',
	        noClientEmailNoInvoice: 'Client does not have email to send invoice.',
	        invoice: 'Invoice',
	        creditnote: 'Credit Note',
	        creditNoteReason: 'Creditnote reason',
	        to: 'To',
	        from: 'From',
	        subject: 'Subject',
	        messageBody: 'Message Body',
	        notes: 'Notes',
	        attachment: 'Attachment',
	        order: 'Order',
	        date: 'Date',
	        paymentDate: 'Payment Date',
	        dueDate: 'Due Date',
	        invoiceNumber: 'Invoice #',
	        cc: 'Send a copy to',
	        deliveredTo: 'Delivered to',
	        validateKidNumber: 'Validate KID',
	        generateKidNumber: 'Generate KID',
	        kidGenerateSuccess: 'Updated',
	        validKID: 'KID valid',
	        invalidKID: 'KID invalid',
	        emailTracking: {
	          delivered: 'Delivered',
	          opened: 'Opened',
	          clicked: 'Clicked',
	          dropped: 'Dropped',
	          bounced: 'Bounced',
	          complained: 'Complained',
	          failed: 'Failed',
	          recipient: 'Recipient',
	          date: 'Date',
	          type: 'Type',
	          device: 'Device'
	        }
	      },
	      crediNoteReason: {
	        title: 'Tell us why you are making this credit note'
	      }
	    },
	
	    appointments: {
	      index: {
	        title: 'Appointments Overview',
	        futureFilter: 'From today on',
	        cancelled: 'Cancelled',
	        completed: 'Completed',
	        created: 'Created',
	        ongoing: 'Ongoing',
	        noSlots: 'No slots available for the day.',
	        freeSlot: 'Free slot!',
	        nothingScheduled: 'Nothing scheduled.',
	        exception: 'Exception',
	        displayWeekend: 'Display Weekend',
	        week: 'Week'
	      },
	      create: {
	        title: 'Add Appointment'
	      },
	      edit: {
	        title: 'Edit Appointment',
	        editButton: 'Go to Overview',
	        destroyError: 'Sorry, we could not cancel this appointment.'
	      }
	    },
	
	    shippingProviderAll: 'All providers',
	
	    orderPickups: {
	      title: 'Order pickups',
	      filter: {
	        label: 'Filter by'
	      },
	      tableHead: {
	        order: 'Order',
	        status: 'Status',
	        customer: 'Customer',
	        shippingProvider: 'Shipping provider'
	      },
	      table: {
	        number: 'Order #',
	        createdAt: 'Created at',
	        pickupDate: 'Pickup date',
	        pickupBy: 'Pickup by',
	        shippingProvider: 'Shipping provider',
	        shippingDate: 'Shipping date',
	        tracking: 'Tracking',
	        openTracking: 'Open tracking',
	        noTracking: 'No tracking registered yet',
	        deliveryDate: 'Delivery date',
	        missing: 'Missing',
	        noData: 'No available data'
	      },
	      index: {
	        shippingStatuses: {
	          all: 'All status',
	          new: 'New',
	          picked: 'Picked',
	          shipped: 'Shipped',
	          delivered: 'Delivered',
	          cancelled: 'Cancelled'
	        }
	      }
	    },
	
	    orders: {
	      types: {
	        all: 'All',
	        product: 'Product',
	        edi: 'EDI',
	        appointment: 'Appointment',
	        sale: 'Sale',
	        return: 'Return',
	        wordpress: 'Drikkeriket',
	        transfer: 'Transfer'
	      },
	      shippingConfirm: {
	        title: 'Confirmed Shipping',
	        unassignedProductWarning: 'There are still unassigned products to the package.',
	        unassignedProductError: 'You need to assign ALL the products to continue.',
	        manageDelivery: 'Manage Delivery',
	        shippingProviderRequired: 'Shipping provider is required',
	        addShippingProviderBtn: 'Click here to add shipping provider options'
	      },
	      orderTable: {
	        productErrorMessage: 'Product not found'
	      },
	      orderConfirm: {
	        title: 'Confirm Order',
	        znbTitle: 'Set Excise',
	        exciseWarningMessage: 'There are beverage product(s) in this order with missing excise. Click the product link in the table to set it up.',
	        upsellMessage: "You're selling beverage product. Make your life easier by subscribing to the excise module. Contact us at support@kundan.no for a free trial",
	        clientType: 'Client type',
	        excisable: 'Excisable',
	        nonExcisable: 'Non Excisable',
	        exciseCode: 'Excise code',
	        exciseCheck: 'Excise Check',
	        paidExcise: 'Paid Excise',
	        paidExciseYes: 'PAID',
	        paidExciseNo: 'UNPAID',
	        packagingCheck: 'Packaging',
	        table: {
	          product: 'Product',
	          excise: 'Excisegroups',
	          exciseGroup: {
	            beverage: 'Beverage',
	            packaging: 'Packaging',
	            basic: 'Basic'
	          },
	          bottleVolume: 'Volume (ℓ)',
	          alcoholPercentage: 'Alkohol %'
	        },
	        orderConfirmNotification: 'Send an order confirm notificaiton to client'
	      },
	      orderWarehouse: {
	        title: 'Order Warehouse'
	      },
	      orderInternalNote: {
	        title: 'Internal note'
	      },
	      purchaseReceive: {
	        title: 'Received Purchase'
	      },
	      status: {
	        undefined: 'Undefined',
	        created: 'New',
	        Done: 'Done',
	        done: 'Done',
	        confirmed: 'Confirmed',
	        processed: 'Processed',
	        received: 'Received',
	        completed: 'Completed',
	        invoiced: 'Invoice created',
	        invoiced_externally: 'Invoiced externally',
	        bill_sent: 'Invoiced',
	        credited: 'Credit Noted',
	        cancelled: 'Cancelled',
	        shipping_confirmed: 'Shipping Confirmed',
	        invoiced_consolidated: 'Invoiced Consolidated',
	        waiting_autobilling: 'Waiting Auto-Billing',
	        picked: 'Order picked',
	        shipped: 'Order sent',
	        delivered: 'Order delivered',
	        vipps_processing: 'Vipps Processing'
	      },
	      formTabs: {
	        orderInformation: 'Order Information',
	        deliveryNote: 'Delivery Information',
	        edit: 'Edit Order',
	        events: 'Order Events'
	      },
	      orderLines: 'Order lines',
	      index: {
	        bulkMaxLimitExceededError: 'The maximum order selection for bulk action is up to',
	        editTooltip: 'Edit Order',
	        deleteTooltip: 'Delete Order',
	        title: 'Orders Overview',
	        confirmDelete: 'This will permanently delete the order. Continue?',
	        confirmDeleteTitle: 'Delete Order',
	        clientName: 'Client',
	        orderType: 'Order Type',
	        activity: 'Activity',
	        start: 'Start',
	        service: 'Service Name',
	        cancelled: 'Cancelled',
	        confirmCancel: 'This will cancel the order. Continue?',
	        confirmCancelTitle: 'Cancel Order',
	        status: 'Status',
	        ediNumber: 'EDI Number',
	        deliveryDate: 'Delivery Date',
	        pickupDate: 'Pickup Date',
	        client: 'Client',
	        items: 'Items',
	        type: 'Type',
	        qty: 'Qty',
	        referenceNumber: 'Order Reference',
	        createdDate: 'Ordre created'
	      },
	      table: {
	        id: 'ID',
	        name: 'Number',
	        type: 'Type',
	        status: 'Status',
	        clientName: 'Customer',
	        totalValue: 'Amount',
	        totalQuantity: 'Quantity',
	        createdDate: 'Date',
	        amountDue: 'Amount due',
	        amountPaid: 'Amount paid',
	        totalGross: 'Total gross'
	      },
	      create: {
	        title: 'Add Order'
	      },
	      edit: {
	        orderReference: 'Order Reference',
	        returnOrderComplete: 'Return Order completed',
	        modalFormTitle: 'QUICK PRODUCT EDIT',
	        exciseModalFormTitle: 'Update Excise for',
	        title: 'Edit Order',
	        detailsLegend: 'Order Details',
	        ediTitle: 'EDI Order Information',
	        billsAndCreditNotes: 'Bills and Credit Notes from this order',
	        bill: 'Bill',
	        creditNote: 'Credit Note',
	        customerDetails: 'Customer Details',
	        address: 'Address',
	        successMessage: 'Order updated!',
	        orderProducttitle: 'Order Products',
	        noProductWarning: 'No products on this order yet.',
	        addProductButton: 'Add product',
	        subtotal: 'Subtotal',
	        discount: 'Discount',
	        tax: 'Tax',
	        deposit: 'Deposit',
	        rounding: 'Rounding',
	        total: 'Total',
	        quantityError: 'Quantity cannot be 0.',
	        priceError: 'Price cannot be 0.',
	        productErrorMessage: 'Product not found',
	        orderType: 'Order Type',
	        client: 'Client',
	        createBillButton: 'Create Bill',
	        missingEdiDetails: 'Missing EDI details, please contact suppport.',
	        cancelError: 'Order could not be cancelled.',
	        cancelSuccess: 'Order(s) has been successfully cancelled.',
	        returnSuccess: 'Order(s) has been successfully returned.',
	        pleaseConfirmAllOrderProducts: 'Please confirm the quantities of the order products before proceeding.',
	        pleaseLinkTheSourceOrder: 'Please link the EDI Order source for this order.',
	        quantityMustNotBeGreaterThanQuantityOrdered: 'Quantity confirmed cannot exceed the quanity ordered',
	        originalOrderItems: 'Original Order Items',
	        orText: 'or',
	        roundInvoiceTotal: 'Round Invoice Total',
	        storeName: 'Store Name',
	        storeAddress: 'Store Address',
	        requestedDeliveryDate: 'Requested Delivery Date',
	        confirmedDeliveryDate: 'Confirmed Delivery Date',
	        pickupDate: 'Pickup Date',
	        shippingProvider: 'Shipping Method',
	        trackingNumber: 'Tracking Number',
	        trackingUrlNotAvail: 'Tracking url not available',
	        company: 'Company',
	        name: 'Name',
	        appointmentDate: 'Appointment Date',
	        appointmentTime: 'Appointment Time',
	        appointmentDuration: 'Appointment Duration',
	        ediNumber: 'EDI Number',
	        linkedEdiNumber: 'Linked EDI Number',
	        orderNumber: 'Order Number',
	        orderDate: 'Order date',
	        orderStatus: 'Ordre status',
	        creditNotes: 'Credit Notes',
	        minutes: 'Minutes',
	        unconfirmed: 'Unconfirmed',
	        warehouse: 'Warehouse',
	        availableQty: 'Available',
	        nonBatch: 'Non-batch',
	        packageTitle: 'Manage Packages',
	        pickup: 'Pickup',
	        pickupBy: 'Pickup By',
	        deliveryDate: 'Delivery Date',
	        shippingDate: 'Shipping Date',
	        note: 'Note',
	        shippingOrder: 'Shipping Order',
	        shippingOrderText: 'View',
	        referenceNumber: 'Order Reference',
	        internalNote: 'Note'
	      },
	      package: {
	        newPackageCardTitle: 'Create package',
	        UnassignedProductCardTitle: 'Unassgined Products',
	        created: 'Package successfully created',
	        error: 'Error creating package',
	        addProductToPackageTitle: 'Add products to package',
	        editProductToPackageTitle: 'Edit products in the package',
	        downloadAllShippingLabel: 'Download shipping label',
	        downloadProductMixLabel: 'Download product packaging label',
	        viewShippingLabel: 'View shipping label',
	        viewProductMixLabel: 'View mixed products label',
	        editPackage: 'Edit package',
	        deletePackage: 'Delete package',
	        addProduct: 'Add product',
	        btnAddProduct: 'Add product',
	        unassignedTable: {
	          name: 'Name',
	          gtin: 'GTIN',
	          quantityConfirmed: 'Quantity Confirmed',
	          quantityPacked: 'Quantity Packed',
	          quantityUnpacked: 'Unassigned Quantites'
	        },
	        createdPackage: {
	          sscc: 'SSCC',
	          unitType: 'Pallet Type',
	          numberOfProducts: 'Number of Products',
	          totalQuantity: 'Total Quantity',
	          totalNetWeight: 'Total Net Weight',
	          totalGrossWeight: 'Total Gross Weight',
	          totalStackWeight: 'Total Stack Weight',
	          products: 'Products',
	          table: {
	            gtin: 'GTIN',
	            productName: 'Product Name',
	            quantity: 'Quantity',
	            weight: 'Weight',
	            bestBefore: 'Best Before',
	            maxTopLoad: 'Max Top Load',
	            lotBatchNumber: 'Lot / Batch Number',
	            temperatureRequirement: 'Temperature Requirement'
	          }
	        }
	      }
	    },
	
	    packageOrderProduct: {
	      add: {
	        error: 'Error!',
	        quantityExceedError: 'Quantity exceeded. Please check the unpacked quantities.',
	        success: 'Successfully added the product to the package.'
	      },
	      edit: {
	        error: 'Error!',
	        quantityExceedError: 'Quantity exceeded. Please check the unpacked quantities.',
	        success: 'Successfully updated the product to the package.'
	      },
	      destroy: {
	        confirm: 'Remove order product from the package?',
	        error: 'Error!',
	        success: 'Successfully removed the product to the package.'
	      }
	    },
	
	    package: {
	      destroy: {
	        confirm: 'All orders inside the package will be unassigned. Boxes inside will be deleted. Delete the package?',
	        error: 'Error!',
	        success: 'Successfully deleted the package.'
	      }
	    },
	
	    ediOrders: {
	      index: {
	        title: 'EDI Orders Overview',
	        cardHeader: 'Order # ',
	        orderNumber: 'Vinmonopolet order number #',
	        ediOrderTypeName: 'Order type #',
	        created: 'Created',
	        confirmed: 'Confirmed',
	        processed: 'processed',
	        shipped: 'Shipped',
	        picked: 'Picked',
	        received: 'received',
	        completed: 'completed',
	        pending: 'pending',
	        out_of_stock: 'Out of Stock',
	        invoiced: 'invoice created',
	        invoiced_externally: 'Invoiced externally',
	        bill_sent: 'invoiced',
	        credited: 'credited',
	        cancelled: 'cancelled',
	        shipping_confirmed: 'Shipping Confirmed',
	        invoiced_consolidated: 'Invoiced Consolidated',
	        waiting_autobilling: 'Waiting Auto-Billing',
	        vipps_processing: 'Vipps Processing',
	        confirmAction1: 'Are you sure you want to proceed with',
	        confirmAction2: 'on all the',
	        confirmAction3: 'selected orders',
	        action: {
	          confirmOrder: 'Confirm Order',
	          confirmShipping: 'Confirm Shipping',
	          confirmOrderAndShipping: 'Confirm Order & Shipping',
	          createInvoice: 'Create Invoice',
	          cancelOrder: 'Cancel Order'
	        }
	      },
	      edit: {
	        title: 'EDI Order Information',
	        orderNumber: 'Order Number',
	        orderReference: 'Order Reference',
	        requestedDeliveryDate: 'Requested Delivery Date',
	        noEdiOrderItemWarning: 'No item on this order.',
	        ediOrderType: 'EDI Order Type',
	        partyId: 'Store ID',
	        storeName: 'Store Name',
	        deliveryDate: 'Delivery Date',
	        ediOrderStatus: 'Status',
	        invalidDeliveryDate: 'Please, enter a valid delivery date.',
	        confirmSuccess: 'Order was confirmed successfully.',
	        vippsProcessingTitle: 'Please Wait.',
	        vippsProcessing: 'Order is processing Vipps payment, please reload the page after a few minutes.',
	        confirmError: 'There was an error with the order, please try again later.',
	        invoiceSuccess: 'Invoice was created successfully.',
	        invoiceSentSuccess: 'Invoice was sent successfully.',
	        creditNoteSentSuccess: 'Credit note was sent successfully.',
	        invoiceError: 'There was an error with the order, please try again later.',
	        processSuccess: 'Order was processed successfully.',
	        processError: 'There was an error with the order, please try again later.',
	        pleaseConfirmAllOrders: 'Please confirm all items in this order.',
	        cancelSuccess: 'Order was cancelled successfully.',
	        returnSuccess: 'Order was successfully returned.',
	        confirmCancel: 'Are you sure you want to cancel this order?',
	        cancelError: 'There was an error with the order, please try again later.',
	        ediOrderSourceWineMonopolyOrderReference: 'Source Vinmonopolet Order Reference',
	        orderDate: 'Order Date',
	        warehouseChanged: 'Warehouse updated'
	      }
	    },
	
	    settings: {
	      generalSettings: 'General Settings',
	      productDisplay: 'Product additional info to display',
	      newField: 'New Field',
	      edi: {
	        defaultEdiProductGroupName: 'Default EDI product group name',
	        defaultEdiClientGroupName: 'Default EDI client group name',
	        defaultEdiClientName: 'Default EDI client name',
	        defaultEdiClientContactPhoneNumber: 'Default EDI client phone number',
	        defaultEdiClientAddressStreetName: 'Default EDI client street name',
	        defaultEdiClientAddressCityId: 'Default EDI client city',
	        defaultEdiClientAddressZipCode: 'Default EDI client zip code',
	        defaultEdiTaxPercentage: 'Default EDI tax percentage',
	        ediOrderNumberDefault: 'Default EDI order number',
	        ediOrderDeliveryNoteNumberDefault: 'Default EDI delivery note number'
	      }
	    }
	  },
	
	  layouts: {
	    header: {
	      individual: 'Personal',
	      company: 'Company',
	      viewClient: 'View customer'
	    },
	
	    sidebar: {
	      storeSynced: 'Active Online Store',
	      dashboard: 'Dashboard',
	      profile: 'Profile',
	      account: 'Account',
	      address: 'Address',
	      contact: 'Contact',
	      settings: 'Settings',
	      clientGroups: 'Client Groups',
	      clients: 'Clients',
	      clientGroup: 'Client Group',
	      clientAgreements: 'Client Agreements',
	      newAgreement: 'New Agreement',
	      importAgreement: 'Import Agreement',
	      newOrders: 'New',
	      today: 'Today',
	      upcoming: 'Upcoming',
	      members: 'Members',
	      pending: 'Pending',
	      inTransit: 'In Transit',
	      confirmed: 'Confirmed',
	      complete: 'Complete',
	      recieved: 'Recieved',
	      invoiced: 'Invoiced',
	      credited: 'Credited',
	      cancelled: 'Cancelled',
	      outOfStock: 'Out of Stock',
	      done: 'Done',
	      latest: 'Latest',
	      active: 'Active',
	      inActive: 'In Active',
	      pastMonth: 'Past Month',
	      all: 'All',
	      productGroups: 'Product Groups',
	      production: 'Production',
	      products: 'Products',
	      services: 'Services',
	      wordpress: 'Wordpress',
	
	      orders: 'Orders',
	      allOrders: 'All Orders',
	      booking: 'Booking',
	      ediOrders: 'EDI',
	      orderFilter: 'Order Status',
	
	      logout: 'Logout',
	      publicProfile: 'Public',
	      appointments: 'Appointments',
	      bills: 'Bills',
	      edi: 'EDI',
	      reports: 'Reports',
	      newsletter: 'Newsletter',
	      subscriberList: 'Lists',
	
	      orderedPastWeek: 'Ordered past week',
	      orderedPastMonth: 'Ordered past month',
	      neverOrdered: 'Prospects',
	      emptyOrders: 'With only empty orders',
	      switchToOrganization: 'Change to',
	      supplier: 'Suppliers',
	      warehouse: 'Warehouses',
	      unitOfMeasure: 'Unit of Measures',
	      stock: 'Stock',
	      inventory: 'Inventory',
	      billExport: 'Export',
	      modules: 'Modules',
	      deactivated: 'Deactivated',
	      notInvoiced: 'Not invoiced',
	      orderPickups: {
	        title: 'Orderplukk',
	        viewAll: 'Vis alle'
	      }
	    }
	  },
	  pricingAgreements: {
	    title: 'Pricing agreements',
	    titleWithCount: 'Pricing agreements ({count})',
	    newAgreement: 'New agreement',
	    createOne: 'Create one',
	    importFromTemplate: 'Import from template',
	    importFromTemplateLink: 'import from Excel/CSV template',
	    noAgreements: 'No pricing agreements.',
	    customer: 'Customer',
	    selectCustomer: 'Select customer',
	    agreementName: 'Agreement name',
	    agreementNamePlaceholder: 'Optional; uses template name if empty',
	    file: 'File',
	    downloadTemplate: 'Download template (XLSX)',
	    chooseFile: 'Choose file (CSV or XLSX)',
	    cancel: 'Cancel',
	    import: 'Import',
	    active: 'Active',
	    inactive: 'Inactive',
	    valid: 'Valid',
	    lineCount: '{n} line(s)',
	    newPricingAgreement: 'New pricing agreement',
	    orImportLink: 'Or',
	    name: 'Name',
	    namePlaceholder: 'e.g. Seasonal agreement',
	    validFrom: 'Valid from',
	    validTo: 'Valid to',
	    from: 'From',
	    to: 'To',
	    save: 'Save',
	    createButton: 'Create',
	    back: 'Back',
	    editPricingAgreement: 'Edit pricing agreement',
	    product: 'Product',
	    products: 'Products',
	    addProduct: 'Add product',
	    searchProductByName: 'Search product by name',
	    minQty: 'Min qty',
	    discountLabel: 'Discount',
	    discountPercent: 'Discount %',
	    discountAmount: 'Discount amount',
	    discountAmt: 'Discount amt',
	    perUnit: 'Per unit',
	    comment: 'Comment',
	    noProductsInAgreement: 'No products in this agreement.',
	    productFallback: 'Product #',
	    confirm: 'Confirm',
	    deleteProductConfirm: 'Delete this product from the agreement?',
	    agreementUpdated: 'Agreement updated',
	    errorUpdatingAgreement: 'Error updating agreement',
	    productAndMinQtyRequired: 'Product and Min qty required',
	    setDiscountOrAmount: 'Set either Discount % or Discount amount',
	    productAdded: 'Product added',
	    errorAddingProduct: 'Error adding product',
	    minQtyAtLeast1: 'Min qty must be at least 1',
	    productUpdated: 'Product updated',
	    errorUpdatingProduct: 'Error updating product',
	    productRemoved: 'Product removed',
	    errorRemovingProduct: 'Error removing product',
	    importCreated: 'Agreement created. {count} line(s) added.',
	    importSkipped: '{count} row(s) skipped.',
	    importFailed: 'Import failed',
	    unmatchedTitle: 'Match products (no EPD/GTIN)',
	    unmatchedIntro: 'Products with no EPD/GTIN or no discount % appear here. Select product if needed, enter discount %, then click Add.',
	    importedName: 'Imported name',
	    addLine: 'Add',
	    lineAdded: 'Line added',
	    closeAndViewAgreement: 'Close and view agreement',
	    needToMatch: '{count} product(s) need matching',
	    searchProductsInAgreement: 'Search products',
	    noProductsMatchSearch: 'No products match your search.',
	    searchAgreements: 'Search agreements',
	    noAgreementsMatchSearch: 'No agreements match your search or filter.',
	    deleteAgreementConfirm: 'Delete this pricing agreement? This cannot be undone.',
	    customerHasAgreementConfirm: 'This customer already has a pricing agreement. Do you want to continue importing?',
	    agreementDeleted: 'Pricing agreement deleted',
	    errorDeletingAgreement: 'Error deleting pricing agreement',
	    errorCreatingAgreement: 'Error creating agreement',
	    validationNameAlreadyExists: 'This customer already has a pricing agreement with this name.',
	    lines: 'Lines',
	    actions: 'Actions',
	    sortNameAsc: 'Name (A → Z)',
	    sortNameDesc: 'Name (Z → A)',
	    sortCustomerAsc: 'Customer (A → Z)',
	    sortCustomerDesc: 'Customer (Z → A)',
	    sortValidFromDesc: 'Valid from (newest)',
	    sortValidFromAsc: 'Valid from (oldest)',
	    sortProductNameAsc: 'Name (A to Z)',
	    sortProductNameDesc: 'Name (Z to A)',
	    sortMinQtyAsc: 'Min qty (low to high)',
	    sortMinQtyDesc: 'Min qty (high to low)'
	  },
	  button: {
	    search: 'Search',
	    createReminder: 'Create Reminder',
	    creditNoteReason: 'Set Credit Note Reason',
	    glnLookup: 'Fetch Data FROM GLN',
	    markAs: 'Mark as',
	    pending: 'Pending',
	    updateDraft: 'Update draft',
	    updatePending: 'Update Pending',
	    complete: 'Complete',
	    createReturnOrder: 'Create return order',
	    addClient: 'Add New Client',
	    addClientGroup: 'Add Client Group',
	    addBookingOrder: 'Add Booking Order',
	    addEdiOrder: 'Add Edi Order',
	    addCampaign: 'Add Campaign',
	    addSubscriberList: 'Create List',
	    enter: 'Enter',
	    expand: 'Expand',
	    register: 'Register',
	    next: 'Next',
	    getStarted: 'Get Started',
	    done: 'Done',
	    save: 'Save',
	    update: 'Update',
	    view: 'View',
	    clear: 'Clear',
	    confirm: 'Confirm',
	    shippingConfirm: 'Confirm Shipping',
	    purcahseReceive: 'Received Purchase',
	    process: 'Process',
	    proceed: 'Proceed',
	    createInvoice: 'Create Invoice',
	    invoiceExternally: 'Invoice Externally',
	    updateInvoice: 'Update Invoice',
	    saveDraft: 'Save as Draft',
	    markAsCleared: 'Mark as Cleared',
	    createCreditNote: 'Create Credit Note',
	    showPrintableDeliveryNote: 'Show Printable Delivery Note',
	    downloadPrintableDeliveryNote: 'Download Printable Delivery Note',
	    login: 'Login',
	    send: 'Send',
	    resend: 'Re-send',
	    sendTest: 'Send Test',
	    cancel: 'Cancel',
	    cancelEDIOrder: 'Cancel EDI order',
	    cancelOrder: 'Cancel order',
	    cancelOrders: 'Cancel Orders',
	    delete: 'Delete',
	    deleteProduct: 'Delete product',
	    deleteClient: 'Delete customer',
	    downloadImport: 'Download / Import',
	    yes: 'Yes',
	    no: 'No',
	    skip: 'Skip',
	    registerCRM: 'Signup CRM',
	    registerInvoicing: 'Signup Invoicing',
	    registerBooking: 'Signup Booking',
	    registerEDI: 'Signup EDI',
	    editText: 'Edit Text',
	    testEmail: 'Test',
	    testEmailTitle: 'Send a test invoice to your email',
	    addMultipleProducts: 'Add Products',
	    add: 'Add',
	    edit: 'Edit',
	    book: 'Book',
	    close: 'Close',
	    receipt: 'Create Receipt',
	    markAsDraft: 'Draft',
	    markAsDone: 'Received',
	    merge: 'Merge',
	    confirmAsOrder: 'Confirmed as Order',
	    import: 'Import',
	    adjustment: {
	      completeAdjustment: 'Complete adjustment',
	      exportAdjustmentProducts: 'Download products'
	    },
	    stockCount: {
	      completeStockCount: 'Complete inventory count'
	    },
	    export: 'Export data',
	    dragAndDropImport: 'Drag and drop files here...',
	    subscribe: 'Subscribe',
	    unsubscribe: 'Unsubscribed',
	    syncData: 'Sync Data',
	    startSync: 'Start Sync',
	    fetchFromVmp: 'Fetch from VMP',
	    confirmSync: 'Confirm Sync',
	    syncNow: 'Sync Now',
	    continue: 'Continue',
	    setMinimumStock: 'Set minimum stock',
	    destroy: 'destroy',
	    unsubscribeAll: 'Unsubscribe all',
	    subscribeAll: 'Subscribe all',
	    goToEditPage: 'Go to edit page',
	    reload: 'Reload',
	    bulkPriceUpdate: 'Bulk Price Update'
	  },
	
	  search: {
	    title: {
	      placeholder: 'Search'
	    }
	  },
	
	  sort: {
	    title: 'Sort by',
	    placeholder: 'Select',
	    older: 'Older',
	    newer: 'Newer',
	    lastName: 'Last name',
	    name: 'Name',
	    bestPaying: 'Best paying',
	    worstPaying: 'Worst paying',
	    biggestDebtors: 'Biggest Debtors',
	    clientsCountDesc: 'Most clients',
	    clientsCountAsc: 'Least clients',
	    lastWeek: 'Last week',
	    last14Days: 'Last 14 days',
	    last21Days: 'Last 21 days',
	    lastMonth: 'Last month'
	  },
	
	  listType: {
	    all: 'All',
	    order: 'Regular Order',
	    edi: 'EDI Order'
	  },
	
	  orderActions: {
	    select: {
	      label: 'Select Action',
	      placeholder: 'Action'
	    },
	    confirmOrder: 'Confirm orders',
	    confirmShipping: 'Confirm orders shipping',
	    confirmOrderAndShipping: 'Confirm order & shipping (a combination of the first 2 options above)',
	    dowloadDeliverySlip: 'Download delivery slips',
	    createInvoice: 'Create invoices',
	    cancelOrder: 'Cancel orders'
	  },
	
	  productActions: {
	    select: {
	      label: 'Select Action',
	      placeholder: 'Action'
	    },
	    activateProduct: 'Activate Product',
	    deactivateProduct: 'Deactivate Product',
	    syncToWoo: 'Sync to WP Store'
	  },
	
	  clientActions: {
	    select: {
	      label: 'Select Action',
	      placeholder: 'Action'
	    },
	    isSubClient: 'Is Sub Client',
	    isProducer: 'Is Producer',
	    activateClient: 'Activate Client',
	    deactivateClient: 'Deactivate Client'
	  },
	
	  billActions: {
	    markBilledAsPaid: 'Mark billed as paid',
	    downloadInvoicePdf: 'Download Invoice PDF'
	  },
	
	  messages: {
	    warning: 'Warning',
	    newer: 'Newer',
	    lastName: 'Last name'
	  },
	
	  form: {
	    batch: {
	      transferDate: {
	        placeholder: '',
	        label: 'Date'
	      },
	      productName: {
	        placeholder: '',
	        label: 'Products'
	      },
	      qty: {
	        placeholder: '',
	        label: 'QTY'
	      },
	      warehouse: {
	        placeholder: '',
	        label: 'Warehouse'
	      }
	    },
	    bundleProductPreview: {
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      price: {
	        label: 'Price',
	        placeholder: 'Price'
	      }
	    },
	    unimicroCredentialsModal: {
	      title: 'UniMicro Credentials',
	      intro: 'Please provide your UniMicro credentials below to connect your accounting integration.',
	      unimicro_client_id: {
	        label: 'Client ID',
	        placeholder: 'Enter your UniMicro Client ID'
	      },
	      unimicro_client_secret: {
	        label: 'Client Secret',
	        placeholder: 'Enter your UniMicro Client Secret'
	      },
	      unimicro_access_token: {
	        label: 'Access Token',
	        placeholder: 'Paste your UniMicro Access Token'
	      },
	      unimicro_refresh_token: {
	        label: 'Refresh Token',
	        placeholder: 'Paste your UniMicro Refresh Token'
	      }
	    },
	    billReminderModal: {
	      title: 'Create Reminder',
	      reminderType: {
	        label: 'Reminder Type',
	        placeholder: ''
	      },
	      feeAmount: {
	        label: 'Fee Amount',
	        placeholder: ''
	      },
	      penaltyFee: {
	        label: 'Penalty fee',
	        placeholder: '',
	        options: {
	          withFees: 'With Fees',
	          withoutFees: 'Without Fees'
	        }
	      },
	      notes: {
	        label: 'Notes',
	        placeholder: 'Notes'
	      }
	    },
	    license: {
	      organizationNumber: {
	        label: 'Organization Number',
	        placeholder: ''
	      },
	      licenseTypeId: {
	        label: 'License Type',
	        placeholder: ''
	      },
	      licensePermitTypeId: {
	        label: 'License Permit Type',
	        placeholder: ''
	      },
	      licenseGroupIds: {
	        label: 'License Groups',
	        placeholder: ''
	      },
	      validFrom: {
	        label: 'Valid from',
	        placeholder: ''
	      },
	      validTo: {
	        label: 'Valid to',
	        placeholder: ''
	      },
	      licenseFile: {
	        label: 'License file',
	        placeholder: ''
	      },
	      licenseNumber: {
	        label: 'License Number',
	        placeholder: ''
	      },
	      name: {
	        label: 'Name',
	        placeholder: ''
	      },
	      streetName: {
	        label: 'Street Address',
	        placeholder: ''
	      },
	      postalCode: {
	        label: 'Postal Code',
	        placeholder: ''
	      },
	      city: {
	        label: 'City',
	        placeholder: ''
	      },
	      municipality: {
	        label: 'Municipality',
	        placeholder: ''
	      },
	      municipalityNumber: {
	        label: 'Municipality Number',
	        placeholder: ''
	      }
	    },
	    bulkSendTurnOver: {
	      from: {
	        label: 'From',
	        placeholder: 'From'
	      },
	      subject: {
	        label: 'Subject',
	        placeholder: 'Subject'
	      },
	      message: {
	        label: 'Message',
	        placeholder: 'Message'
	      }
	    },
	    wooCredentialsModal: {
	      routesTitle: 'Copy and paste below url to woocommerce webhook',
	      title: 'Woocommerce api (From kundan system to woocommerce)',
	      kundanWordpressPluginToken: 'Kundan Wordpress Plugin Token',
	      websiteUrl: {
	        placeholder: 'Website url',
	        label: 'Website url'
	      },
	      apiKey: {
	        placeholder: 'Api key',
	        label: 'Api key'
	      },
	      secretKey: {
	        placeholder: 'Secret key',
	        label: 'Secret key'
	      },
	      language: {
	        placeholder: '',
	        label: 'Language'
	      },
	      productAttributes: {
	        placeholder: '',
	        label: 'Product Attributes'
	      },
	      syncProductGroup: {
	        placeholder: '',
	        label: 'Sync Product Type Group/Sub-group'
	      },
	      syncSelectedProductsOnly: {
	        placeholder: '',
	        label: 'Sync Selected Products Only'
	      },
	      warehouseId: {
	        placeholder: '',
	        label: 'Warehouse Id'
	      },
	      secret: {
	        title: 'Woocommerce secret keys (From woocommerce to kundan system)',
	        apiOrderCreated: {
	          placeholder: 'Order Secret key (created)',
	          label: 'Order Secret key (created)'
	        },
	        apiOrderUpdated: {
	          placeholder: 'Order Secret key (updated)',
	          label: 'Order Secret key (updated)'
	        },
	        apiOrderDeleted: {
	          placeholder: 'Order Secret key (deleted)',
	          label: 'Order Secret key (deleted)'
	        },
	        apiCustomerCreated: {
	          placeholder: 'Customer Secret key (created)',
	          label: 'Customer Secret key (created)'
	        },
	        apiCustomerUpdated: {
	          placeholder: 'Customer Secret key (updated)',
	          label: 'Customer Secret key (updated)'
	        },
	        apiCustomerDeleted: {
	          placeholder: 'Customer Secret key (deleted)',
	          label: 'Customer Secret key (deleted)'
	        },
	        apiProductCreated: {
	          placeholder: 'Product Secret key (created)',
	          label: 'Product Secret key (created)'
	        },
	        apiProductUpdated: {
	          placeholder: 'Product Secret key (updated)',
	          label: 'Product Secret key (updated)'
	        },
	        apiProductDeleted: {
	          placeholder: 'Product Secret key (deleted)',
	          label: 'Product Secret key (deleted)'
	        }
	      }
	    },
	    wordpressCredentialsModal: {
	      title: 'Wordpress api',
	      kundanWordpressPluginToken: 'Kundan Wordpress Plugin Token',
	      websiteUrl: {
	        placeholder: 'Website url',
	        label: 'Website url'
	      }
	    },
	    orderInternalNote: {
	      internalNote: {
	        placeholder: 'Internal note',
	        label: 'Internal note'
	      }
	    },
	    orderWarehouse: {
	      warehouseId: {
	        placeholder: 'Select Warehouse',
	        label: 'Warehouse'
	      }
	    },
	    module: {
	      fiken_email: {
	        placeholder: 'Enter Email',
	        label: 'Email'
	      },
	      fiken_password: {
	        placeholder: 'Enter password',
	        label: 'Password'
	      },
	      poweroffice_client_key: {
	        placeholder: 'Enter Client Key',
	        label: 'Client key'
	      },
	      poweroffice_company_slug: {
	        placeholder: 'Enter Company Slug',
	        label: 'Company slug'
	      },
	
	      poweroffice_app_key: {
	        placeholder: 'Enter App Key',
	        label: 'App key'
	      },
	      poweroffice_integration_type: {
	        label: 'Integration Type',
	        placeholder: 'Select Integration Type'
	      },
	      tripletex_consumer_token: {
	        placeholder: 'Enter Consumer Token',
	        label: 'Consumer Token'
	      },
	      tripletex_employee_token: {
	        placeholder: 'Enter Employee Token',
	        label: 'Employee Token'
	      },
	      preferred_invoice_sender: {
	        placeholder: 'Select Preferred Invoice Sender',
	        label: 'Send Invoice From'
	      },
	      preferred_send_type: {
	        placeholder: 'Select Preferred Send Type',
	        label: 'Send Type'
	      },
	      vmp_wholesaler_id: {
	        placeholder: 'Enter Wholesaler ID',
	        label: 'Enter Wholesaler ID'
	      },
	      public_marketplace: {
	        placeholder: 'Activate',
	        label: 'Public marketplace'
	      },
	      marketplaces_enabled: {
	        placeholder: '',
	        label: 'Partnerstore'
	      },
	      ongoing_warehouse_warehouse: {
	        placeholder: '',
	        label: 'Ongoing warehouse ID'
	      },
	      ongoing_warehouse_username: {
	        placeholder: '',
	        label: 'Ongoing username'
	      },
	      ongoing_warehouse_password: {
	        placeholder: '',
	        label: 'Ongoing password'
	      },
	      ongoing_warehouse_goods_owner_id: {
	        placeholder: '',
	        label: 'Ongoing Goods Owner ID'
	      }
	    },
	    multipleProductAdd: {
	      product: {
	        placeholder: 'Type to start searching...',
	        label: ''
	      }
	    },
	    exciseEntry: {
	      product: {
	        placeholder: 'Product select',
	        label: ''
	      },
	      source: {
	        placeholder: 'Source select',
	        label: ''
	      }
	    },
	    shippingConfirm: {
	      shippingProviderId: {
	        placeholder: 'Shipping Provider',
	        label: 'Shipping Provider'
	      },
	      shippingDate: {
	        placeholder: 'Shipping Date',
	        label: 'Shipping Date'
	      },
	      importantReminder: {
	        placeholder: 'Important Reminder',
	        label: 'Important Reminder'
	      }
	    },
	    orderConfirm: {
	      confirmDate: {
	        placeholder: 'Date Confirmed',
	        label: 'Date Confirmed'
	      },
	      deliveryDate: {
	        placeholder: 'Delivery Date',
	        label: 'Delivery Date'
	      },
	      warehouseId: {
	        placeholder: 'Select warehouse',
	        label: 'Warehouse'
	      }
	    },
	    billConfirm: {
	      paymentDateOption: {
	        placeholder: 'Select Payment Date Option',
	        label: 'Payment Date Option'
	      },
	      paymentDate: {
	        placeholder: 'Payment Date',
	        label: 'Payment Date'
	      },
	      paymentMethod: {
	        label: 'Payment methods',
	        placeholder: 'Payment methods'
	      }
	    },
	    purchaseReceive: {
	      receiveDate: {
	        placeholder: 'Date Received',
	        label: 'Date Received'
	      }
	    },
	    registerBillPayment: {
	      paymentDate: {
	        placeholder: 'Payment date',
	        label: 'Payment date'
	      },
	      paymentInFull: {
	        placeholder: 'Yes',
	        label: 'Payment in full?'
	      },
	      paymentAmount: {
	        placeholder: 'Payment amount',
	        label: 'Payment amount'
	      }
	    },
	    registerCreditNoteReason: {
	      creditNoteReasonId: {
	        label: 'Reason for crediting',
	        placeholder: 'Select a reason'
	      },
	      reasonNote: {
	        label: 'Actions',
	        placeholder: 'Actions'
	      },
	      additionalDescription: {
	        label: 'Additional info',
	        placeholder: 'Enter any additional info (not required)'
	      },
	      systemAttributes: {
	        label: '',
	        placeholder: ''
	      }
	    },
	    billPaymentModal: {
	      title: 'Bill payment',
	      amountDue: 'Amount due on the',
	      isFullyPaid: {
	        label: 'Fully paid',
	        placeholder: 'Fully paid'
	      },
	      paymentMethod: {
	        label: 'Payment method',
	        placeholder: 'payment method'
	      },
	      amountPaid: {
	        label: 'Amount paid',
	        placeholder: 'Amount paid'
	      },
	      paymentDate: {
	        label: 'Payment date',
	        placeholder: 'Payment date'
	      },
	      reference: {
	        label: 'Reference',
	        placeholder: 'Reference'
	      },
	      internalNote: {
	        label: 'Internal note',
	        placeholder: 'Internal note'
	      }
	    },
	    supplier: {
	      basicInformation: 'Basic Information',
	      contactInformation: 'Contact Information',
	      AddressInformation: 'Address Information',
	      code: {
	        placeholder: 'Code',
	        label: 'Supplier code'
	      },
	      name: {
	        placeholder: 'Name',
	        label: 'Supplier Name'
	      },
	      email: {
	        placeholder: 'Email',
	        label: 'Supplier Email'
	      },
	      phonenumber: {
	        placeholder: 'Phone Number',
	        label: 'Supplier phone number'
	      },
	      mobilenumber: {
	        placeholder: 'Mobile Number',
	        label: 'Supplier mobile number'
	      },
	      streetName1: {
	        placeholder: 'Street Name',
	        label: 'Supplier street name'
	      },
	      streetName2: {
	        placeholder: 'Street Name 2',
	        label: 'Supplier street name 2'
	      },
	      city: {
	        placeholder: 'City',
	        label: 'Supplier city'
	      },
	      countryId: {
	        placeholder: 'Country',
	        label: 'Supplier country'
	      },
	      postalCode: {
	        placeholder: 'Postal Code',
	        label: 'Supplier postal code'
	      }
	    },
	
	    warehouse: {
	      basicInformation: 'Basic Information',
	      contactInformation: 'Contact',
	      addressInformation: 'Address',
	      warehouseInformation: 'Warehouse',
	      location: {
	        placeholder: 'Location',
	        label: 'Warehouse location'
	      },
	      name: {
	        placeholder: 'Name',
	        label: 'Warehouse Name'
	      },
	      isActive: {
	        placeholder: '',
	        label: 'Active'
	      },
	      typeName: {
	        placeholder: 'Type',
	        label: 'Warehouse Type'
	      },
	      partnerId: {
	        placeholder: 'Owner',
	        label: 'Owner'
	      },
	      isBonded: {
	        label: 'Bonded warehouse',
	        placeholder: ''
	      },
	      shippingProviders: {
	        label: 'Warehouse providers',
	        placeholder: ''
	      },
	      contact: {
	        firstName: {
	          label: 'First name',
	          placeholder: ''
	        },
	        lastName: {
	          label: 'Last name',
	          placeholder: ''
	        },
	        email: {
	          label: 'Email address',
	          placeholder: ''
	        },
	        phoneNumber: {
	          label: 'Phone number',
	          placeholder: ''
	        }
	      },
	      address: {
	        streetName1: {
	          label: 'Street name',
	          placeholder: ''
	        },
	        streetName2: {
	          label: 'Street name 2',
	          placeholder: ''
	        },
	        postalCode: {
	          label: 'Postal code',
	          placeholder: ''
	        },
	        city: {
	          label: 'City',
	          placeholder: ''
	        },
	        countryId: {
	          label: 'Country',
	          placeholder: ''
	        }
	      },
	      productTab: {
	        modal: {
	          title: 'Stock management',
	          minimumStockLevel: {
	            label: 'Minimum stock level',
	            placeholder: 'Minimum stock level'
	          }
	        }
	      }
	    },
	
	    productFlow: {
	      basicInformation: 'Basic Information',
	      title: {
	        placeholder: 'Title',
	        label: 'Title'
	      },
	      descriptions: {
	        placeholder: 'Descriptions',
	        label: 'Descriptions'
	      },
	      orderId: {
	        placeholder: 'Order',
	        label: 'Order'
	      },
	      productId: {
	        placeholder: 'Product',
	        label: 'Product'
	      },
	      qty: {
	        placeholder: 'Return/Damage',
	        label: 'Return/Damage'
	      }
	    },
	
	    unitOfMeasure: {
	      basicInformation: 'Basic Information',
	      code: {
	        placeholder: 'Code',
	        label: 'Unit of Measure Code'
	      },
	      name: {
	        placeholder: 'Name',
	        label: 'Unit of Measure Name'
	      }
	    },
	
	    stock: {
	      basicInformation: 'Basic Information',
	      warehouseId: {
	        placeholder: 'Warehouse',
	        label: 'Warehouse'
	      },
	      name: {
	        placeholder: 'Name of stock count',
	        label: 'Name of stock count'
	      },
	      descriptions: {
	        placeholder: 'Enter Description',
	        label: 'Description'
	      },
	      transactionDate: {
	        placeholder: '',
	        label: 'Transaction Date'
	      }
	    },
	
	    adjustment: {
	      basicInformation: 'Basic Information',
	      stockId: {
	        placeholder: 'Stock',
	        label: 'Stock'
	      },
	      reason: {
	        placeholder: 'Reason',
	        label: 'Reason'
	      },
	      warehouseId: {
	        placeholder: 'Warehouse',
	        label: 'Warehouse'
	      },
	      adjustmentTypeId: {
	        placeholder: 'Adjustment type',
	        label: 'Adjustment type'
	      },
	      adjustmentTypeList: {
	        adjustment: 'Adjustment',
	        wastage: 'Wastage',
	        destruction: 'Destruction'
	      },
	      adjustmentStatus: {
	        completed: 'Completed',
	        draft: 'Draft',
	        pending: 'Pending',
	        sent: 'Sent',
	        cancelled: 'Cancelled',
	        deviation: 'Deviation'
	      }
	    },
	
	    purchase: {
	      basicInformation: 'Basic Information',
	      producerId: {
	        placeholder: 'Producer',
	        label: 'Producer'
	      },
	      supplierId: {
	        placeholder: 'Supplier',
	        label: 'Supplier'
	      },
	      comments: {
	        placeholder: 'Comments',
	        label: 'Comments'
	      },
	      name: {
	        placeholder: 'Name',
	        label: 'Name'
	      },
	      purchaseNumber: {
	        placeholder: 'PO #',
	        label: 'PO #'
	      },
	      warehouseId: {
	        placeholder: 'Warehouse',
	        label: 'Warehouse'
	      },
	      status: {
	        placeholder: 'Status',
	        label: 'Status'
	      },
	      expectedDeliveryDate: {
	        placeholder: 'Pick date',
	        label: 'Expected deliverydate'
	      }
	    },
	
	    transfer: {
	      basicInformation: 'Transferdetails',
	      date: {
	        placeholder: 'Transfer Date',
	        label: 'Transfer Date'
	      },
	      transferType: {
	        placeholder: 'Transfer Type',
	        label: 'Transfer Type'
	      },
	      fromWarehouseId: {
	        placeholder: 'From Warehouse',
	        label: 'From Warehouse'
	      },
	      toWarehouseId: {
	        placeholder: 'To Warehouse',
	        label: 'To Warehouse'
	      },
	      batchId: {
	        placeholder: 'Select Batch',
	        label: 'Batch'
	      },
	      comments: {
	        placeholder: 'Comments',
	        label: 'Comments'
	      },
	      products: {
	        placeholder: 'Pick a Products',
	        label: 'Products'
	      },
	      batches: {
	        placeholder: 'Pick a Batches',
	        label: 'Batches'
	      },
	      productId: {
	        label: 'Product Name',
	        placeholder: 'Select product'
	      },
	      qty: {
	        label: 'QTY',
	        placeholder: 'QTY'
	      }
	    },
	
	    register: {
	      organizationType: {
	        label: 'This is account is for:',
	        personal: 'Personal Use',
	        company: 'Company Use'
	      },
	      businessRegistrationNumber: {
	        placeholder: 'Business Registration Number'
	      },
	      firstName: {
	        placeholder: 'First Name'
	      },
	      lastName: {
	        placeholder: 'Last Name'
	      },
	      name: {
	        placeholder: 'Business Name'
	      },
	      email: {
	        placeholder: 'Email'
	      },
	      password: {
	        placeholder: 'Password'
	      },
	      passwordConfirmation: {
	        placeholder: 'Retype Password'
	      },
	      planId: {
	        placeholder: 'Plan'
	      },
	      organizationTypeId: {
	        placeholder: 'Organization Type'
	      },
	      organizationTypeOption: {
	        placeholder: 'I am singing up for a company'
	      },
	      isVatRegistered: {
	        placeholder: 'VAT registered'
	      },
	      isRegisteredBusinessEnterprise: {
	        placeholder: 'Registered as business enterprise'
	      },
	      tosAccepted: {
	        placeholder: 'I agree to the <a href="http://www.kundan.no/regler/">Terms of Service</a>'
	      },
	      marketingAllowed: {
	        placeholder: 'I would like to receive info and marketing offers by Kundan!'
	      }
	    },
	
	    personalInfo: {
	      phoneNumber: {
	        placeholder: 'Phone Number'
	      },
	      streetName: {
	        placeholder: 'Street Name'
	      },
	      secondStreetName: {
	        placeholder: 'Street Name 2'
	      },
	      postalCode: {
	        placeholder: 'Postal Code'
	      },
	      countryId: {
	        placeholder: 'Select a Country'
	      },
	      cityName: {
	        placeholder: 'City'
	      }
	    },
	
	    login: {
	      email: {
	        placeholder: 'Email'
	      },
	      password: {
	        placeholder: 'Password'
	      }
	    },
	
	    resetPassword: {
	      email: {
	        placeholder: 'Type your email'
	      }
	    },
	
	    twoFactorVerification: {
	      code: {
	        label: 'Enter Code',
	        placeholder: 'Enter Code'
	      },
	      verifyButton: {
	        label: 'Verify'
	      },
	      resendButton: {
	        label: 'Resend'
	      }
	    },
	
	    accountInformation: {
	      email: {
	        label: 'Email',
	        placeholder: 'Email'
	      },
	      firstName: {
	        label: 'First Name',
	        placeholder: 'First Name'
	      },
	      lastName: {
	        label: 'Last Name',
	        placeholder: 'Last Name'
	      },
	      userEmail: {
	        label: 'Email',
	        placeholder: 'Email'
	      },
	      userFirstName: {
	        label: 'First Name',
	        placeholder: 'First Name'
	      },
	      userLastName: {
	        label: 'Last Name',
	        placeholder: 'Last Name'
	      },
	      bankAccount: {
	        label: 'Bank Account',
	        placeholder: 'Bank Account'
	      },
	      smallScaleManufacturer: {
	        label: 'Yearly production above 500.000 liter',
	        placeholder: 'Activate'
	      },
	      businessRegistrationNumber: {
	        label: 'Business Registration Number',
	        placeholder: 'Business Registration Number'
	      },
	      isInternational: {
	        label: 'International',
	        placeholder: 'Activate'
	      },
	      bankName: {
	        label: 'Bank Name',
	        placeholder: 'Bank Name'
	      },
	      swift: {
	        label: 'Swift/Bic',
	        placeholder: 'Swift/Bic'
	      },
	      iban: {
	        label: 'IBAN',
	        placeholder: 'IBAN'
	      },
	      isVatRegistered: {
	        label: 'VAT Registered',
	        placeholder: 'Activate'
	      },
	      isRegisteredBusinessEnterprise: {
	        label: 'Registered Business Enterprise',
	        placeholder: 'Activate'
	      },
	      organizationTypeId: {
	        label: 'Select a Organization Type',
	        placeholder: 'Organization Type'
	      },
	      organizationName: {
	        label: 'Business Name',
	        placeholder: 'Business Name'
	      },
	      name: {
	        label: 'Organization Name',
	        placeholder: 'Organization Name'
	      },
	      organizationDescription: {
	        label: 'Business Description',
	        placeholder: 'Business Description'
	      },
	      description: {
	        label: 'Organization Description',
	        placeholder: 'Organization Description'
	      },
	      organizationProfilePicture: {
	        label: 'Organization Profile Picture',
	        placeholder: 'Organization Profile Picture',
	        changeImage: 'Change image'
	      },
	      phoneNumber: {
	        label: 'Phone Number',
	        placeholder: 'Phone Number'
	      },
	      mobileNumber: {
	        label: 'Mobile Number',
	        placeholder: 'Mobile Number'
	      },
	      profilePicture: {
	        label: 'Organization Profile Picture',
	        placeholder: 'Organization Profile Picture'
	      },
	      streetName: {
	        label: 'Street Name',
	        placeholder: 'Street Name'
	      },
	      gs1number: {
	        label: 'GS1 supplier number',
	        placeholder: 'GS1 supplier number'
	      }
	    },
	
	    passwordForm: {
	      currentPassword: {
	        label: 'Current Password',
	        placeholder: 'Current Password'
	      },
	      password: {
	        label: 'Password',
	        placeholder: 'Password'
	      },
	      passwordConfirmation: {
	        label: 'Retype Password',
	        placeholder: 'Retype Password'
	      }
	    },
	
	    contactForm: {
	      email: {
	        label: 'Email',
	        placeholder: 'Email'
	      },
	      firstName: {
	        label: 'First Name',
	        placeholder: 'First Name'
	      },
	      lastName: {
	        label: 'Last Name',
	        placeholder: 'Last Name'
	      },
	      phoneNumber: {
	        label: 'Phone Number',
	        placeholder: 'Phone Number'
	      },
	      mobileNumber: {
	        label: 'Mobile Number',
	        placeholder: 'Mobile Number'
	      },
	      streetName: {
	        label: 'Street Name',
	        placeholder: 'Street Name'
	      },
	      secondStreetName: {
	        label: 'Street Name 2',
	        placeholder: 'Street Name 2'
	      },
	      postalCode: {
	        label: 'Postal Code',
	        placeholder: 'Postal Code'
	      },
	      countryId: {
	        label: 'Country',
	        placeholder: 'Country'
	      },
	      cityName: {
	        label: 'City',
	        placeholder: 'City'
	      },
	      careOf: {
	        label: 'C/O',
	        placeholder: 'C/O'
	      }
	    },
	
	    userSettingForm: {
	      language: {
	        label: 'Language',
	        placeholder: 'Select Language'
	      }
	    },
	
	    profileAddress: {
	      streetName: {
	        label: 'Street Name',
	        placeholder: 'Street Name'
	      },
	      secondStreetName: {
	        label: 'Street Name 2',
	        placeholder: 'Street Name 2'
	      },
	      postalCode: {
	        label: 'Postal Code',
	        placeholder: 'Postal Code'
	      },
	      countryId: {
	        label: 'Select a Country',
	        placeholder: 'Select a Country'
	      },
	      cityName: {
	        label: 'City',
	        placeholder: 'City'
	      }
	    },
	
	    profileContact: {
	      email: {
	        label: 'Email',
	        placeholder: 'Email'
	      },
	      firstName: {
	        label: 'First Name',
	        placeholder: 'First Name'
	      },
	      lastName: {
	        label: 'Last Name',
	        placeholder: 'Last Name'
	      },
	      phoneNumber: {
	        label: 'Phone Number',
	        placeholder: 'Phone Number'
	      },
	      mobileNumber: {
	        label: 'Mobile Number',
	        placeholder: 'Mobile Number'
	      }
	    },
	
	    organizationSettings: {
	      penaltyTypeForDueInvoice: {
	        label: 'Reminder Type for Due Invoice',
	        placeholder: 'Reminder Type for Due Invoice'
	      },
	      penaltyFee: {
	        label: 'Penalty fee',
	        placeholder: 'Penalty fee'
	      },
	      interestPercentage: {
	        label: 'Interest percentage',
	        placeholder: 'Interest percentage'
	      },
	      penaltyAfter: {
	        label: 'After dueDate start penalty in (days)',
	        placeholder: 'No. of days'
	      },
	      tosAccepted: {
	        label: 'Accepting terms of service',
	        placeholder: 'I accept the following terms of service: http://www.kundan.no/regler/'
	      },
	      marketingAllowed: {
	        label: 'Marketing offers',
	        placeholder: 'I agreee to receive offers and information via email from Kundan AS.'
	      },
	      customTos: {
	        label: 'Custom TOS',
	        placeholder: 'Here you can specify your own TOS for your own products and services.'
	      },
	      customOrderProductNote: {
	        label: 'Custom Order Product Note',
	        placeholder: 'Here you can specify your own order product note'
	      },
	      facebookPixelId: {
	        label: 'Facebook Pixel ID',
	        placeholder: 'Facebook Pixel ID'
	      },
	      defaultClientGroupId: {
	        label: 'Default Client Group',
	        placeholder: 'Select the default client group'
	      },
	      defaultDueDays: {
	        label: 'Default Due Days',
	        placeholder: 'Default Due Days'
	      },
	      orderNumberDefault: {
	        label: 'Order Number Default',
	        placeholder: 'Order Number Default'
	      },
	      productNumberDefault: {
	        label: 'Product Number Default',
	        placeholder: 'Product Number Default'
	      },
	      productNumberInitial: {
	        label: 'Product Number Initial',
	        placeholder: 'Product Number Initial'
	      },
	      defaultProductTypeName: {
	        label: 'Product Type Default',
	        placeholder: 'Product Type Default'
	      },
	      customerNumberDefault: {
	        label: 'Customer Number Default',
	        placeholder: 'Customer Number Default'
	      },
	      supplierNumberDefault: {
	        label: 'Supplier Number Default',
	        placeholder: 'Supplier Number Default'
	      },
	      timeslotGap: {
	        label: 'Gap in timeslots',
	        placeholder: 'Gap in timeslots'
	      },
	      invoiceNotes: {
	        label: 'Invoice Notes',
	        placeholder: 'Notes to be displayed in the invoice.'
	      },
	      billNotes: {
	        label: 'Bill Notes',
	        placeholder: 'Notes to be displayed in the bill PDF.'
	      },
	      creditNoteNotes: {
	        label: 'Credit Note Notes',
	        placeholder: 'Notes to be displayed in the credit note.'
	      },
	      billingNumberDefault: {
	        label: 'Billing Number Default',
	        placeholder: 'Billing Number Default'
	      },
	      remindersEnabled: {
	        label: 'Enable reminders',
	        placeholder: 'Enable reminders'
	      },
	      messageTemplateTypeId: {
	        label: 'Message Template Types',
	        placeholder: 'Select the type'
	      },
	      smsFrom: {
	        label: 'SMS from field',
	        placeholder: 'SMS from field'
	      },
	      roundInvoiceTotal: {
	        label: 'Round Invoice Total',
	        placeholder: 'Round Invoice Total'
	      },
	      invoiceEmailTitle: {
	        label: 'Invoice email template title',
	        placeholder: 'Invoice email template title',
	        tooltip: 'Variables available:<br/><br/>Company Name: {customer_name} <br/> Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Bill number: {bill_number}<br/><br/>The following are available for bookings:<br/><br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}'
	      },
	      invoiceEmailTemplate: {
	        label: 'Invoice email template',
	        placeholder: 'Invoice email template',
	        tooltip: 'Variables available:<br/><br/>Company Name: {customer_name} <br/> Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Bill number: {bill_number}<br/>Invoice/Credit Note link: {link}<br/><br/>The following are available for bookings:<br/><br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}'
	      },
	      creditNoteEmailTitle: {
	        label: 'Credit Note email template title',
	        placeholder: 'Credit Note email template title'
	      },
	      creditNoteEmailTemplate: {
	        label: 'Credit Note email template',
	        placeholder: 'Credit Note email template'
	      },
	      reminderEmailTitle: {
	        label: 'Payment reminder email template title',
	        placeholder: 'Payment reminder email template title',
	        tooltip: 'Variables available:<br/><br/>Company/Individual Name: {customer_name} <br/>Bill number: {bill_number}<br/>Invoice link: {link}<br/>Organization Name: {organization_name}<br/>Organization Contact Name: {organization_contact_name}<br/>Due Date: {due_date}'
	      },
	      reminderEmailTemplate: {
	        label: 'Payment reminder email template',
	        placeholder: 'Payment reminder email template',
	        tooltip: 'Variables available:<br/><br/>Company/Individual Name: {customer_name} <br/>Bill number: {bill_number}<br/>Invoice link: {link}<br/>Organization Name: {organization_name}<br/>Organization Contact Name: {organization_contact_name}<br/>Due Date: {due_date}'
	      },
	      orderConfirmNotificationEmailTitle: {
	        label: 'Order confirm notification email template title',
	        placeholder: 'Order confirm notification email template title',
	        tooltip: 'Variables available:<br/><br/>Company/Individual Name: {customer_name} <br/>Order number: {order_number}<br/>Order: {order}<br/>Organization Name: {organization_name}'
	      },
	      orderConfirmNotificationEmailTemplate: {
	        label: 'Order confirm notification email template',
	        placeholder: 'Order confirm notification email template',
	        tooltip: 'Variables available:<br/><br/>Company/Individual Name: {customer_name} <br/>Order number: {order_number}<br/>Order: {order}<br/>Organization Name: {organization_name}'
	      },
	      orderTrackingEmailTitle: {
	        label: 'Order tracking email template title',
	        placeholder: 'Order tracking email email template title',
	        tooltip: 'Variables available:<br/><br/>Company/Individual Name: {customer_name} <br/>Order number: {order_number}<br/>Order: {order}<br/>Order tracking number: {order_tracking_number}<br/>Order tracking link: {tracking}<br/>Organization Name: {organization_name}'
	      },
	      orderTrackingEmailTemplate: {
	        label: 'Order tracking email template',
	        placeholder: 'Order tracking email email template',
	        tooltip: 'Variables available:<br/><br/>Company/Individual Name: {customer_name} <br/>Order number: {order_number}<br/>Order: {order}<br/>Order tracking number: {order_tracking_number}<br/>Order tracking link: {tracking}<br/>Organization Name: {organization_name}'
	      },
	      accountingProviderId: {
	        label: 'Select accounting provider',
	        placeholder: 'Select the accounting provider'
	      },
	      coa1460: {
	        label: 'Purchased goods for resale',
	        placeholder: ''
	      },
	      coa1500: {
	        label: 'Accounts receivable',
	        placeholder: ''
	      },
	      coa1610: {
	        label: 'VAT from purchases',
	        placeholder: ''
	      },
	      coa1910: {
	        label: 'Petty cash',
	        placeholder: ''
	      },
	      coa1920: {
	        label: 'Cash in bank',
	        placeholder: ''
	      },
	      coa2400: {
	        label: 'Trade Creditors',
	        placeholder: ''
	      },
	      coa2700: {
	        label: 'VAT from sales',
	        placeholder: ''
	      },
	      coa3010: {
	        label: 'Revenue from products',
	        placeholder: ''
	      },
	      coa3020: {
	        label: 'Revenue from services',
	        placeholder: ''
	      },
	      coa3060: {
	        label: 'Return of products',
	        placeholder: ''
	      },
	      coa3080: {
	        label: 'Discounts provided',
	        placeholder: ''
	      },
	      descriptionBill: {
	        label: 'Description',
	        placeholder: 'your description'
	      },
	      ediBillingProcess: {
	        label: 'EDI Billing Process',
	        placeholder: 'EDI Billing Process'
	      },
	      paymentIdentitificationGeneration: {
	        label: 'Generate payment identification',
	        placeholder: ''
	      },
	      paymentIdentitificationTemplate: {
	        label: 'Template',
	        placeholder: ''
	      },
	      paymentIdentitificationNumberLength: {
	        label: 'Length of payment number',
	        placeholder: ''
	      },
	      paymentIdentitificationModulusType: {
	        label: 'Modulus type',
	        placeholder: ''
	      },
	      defaultShippingProvider: {
	        label: 'Default Shipping Provider',
	        placeholder: ''
	      },
	      defaultWarehouse: {
	        label: 'Default Warehouse',
	        placeholder: ''
	      },
	      priceFields: {
	        label: 'Price Fields',
	        placeholder: ''
	      },
	      visiblePriceFields: {
	        label: 'Visible Price Fields',
	        placeholder: ''
	      },
	      defaultPriceField: {
	        label: 'Default Price Field',
	        placeholder: ''
	      },
	      email_invoice_copy: {
	        label: 'Email',
	        placeholder: 'Email'
	      },
	      percentage: {
	        label: 'Percentage (%)',
	        placeholder: 'Percentage (%)'
	      },
	      enableRounding: {
	        label: 'Enable Rounding',
	        placeholder: 'Enable Rounding'
	      },
	      roundingType: {
	        label: 'Rounding Type',
	        placeholder: 'Rounding Type',
	        options: {
	          nearest_1: 'Nearest 1',
	          nearest_0_50: 'Nearest 0.50',
	          nearest_0_25: 'Nearest 0.25',
	          nearest_0_99: 'Nearest 0.99',
	          round_half_up: 'Round Half Up',
	          round_half_down: 'Round Half Down',
	          round_half_even: 'Round Half Even (Banker\'s Rounding)',
	          round_towards_zero: 'Round Towards Zero',
	          round_away_from_zero: 'Round Away From Zero'
	        }
	      },
	      priceType: {
	        label: 'Price Type',
	        placeholder: 'Price Type'
	      }
	    },
	
	    emailFormSettings: {
	      emails: {
	        label: 'Emails',
	        placeholder: 'Emails'
	      }
	    },
	
	    checkout: {
	      bookingRequireAddress: {
	        label: 'Address required',
	        placeholder: 'Yes'
	      },
	      bookingRequirePayment: {
	        label: 'Payment required',
	        placeholder: 'Yes'
	      }
	    },
	
	    publicProfile: {
	      profileUrl: {
	        label: 'Profile URL',
	        placeholder: 'Profile URL'
	      },
	      header: {
	        label: 'Header',
	        placeholder: 'Header'
	      },
	      subheader: {
	        label: 'Sub Header',
	        placeholder: 'Sub Header'
	      },
	      defaultReminderTitle: {
	        label: 'Default reminder title',
	        placeholder: 'Default reminder title',
	        tooltip: 'Variables available:<br/><br/>Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}'
	      },
	      defaultReminder: {
	        label: 'Default reminder message',
	        placeholder: 'Default reminder message',
	        tooltip: 'Variables available:<br/><br/>Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}'
	      },
	      defaultCancelMessageTitle: {
	        label: 'Default cancel message title',
	        placeholder: 'Default cancel message title',
	        tooltip: 'Variables available:<br/><br/>Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}'
	      },
	      defaultCancelMessage: {
	        label: 'Default cancel message',
	        placeholder: 'Default cancel message',
	        tooltip: 'Variables available:<br/><br/>Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}'
	      },
	      appointmentConfirmationTitle: {
	        label: 'Default confirmation message title',
	        placeholder: 'Default confirmation message title',
	        tooltip: 'Variables available:<br/><br/>Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}'
	      },
	      appointmentConfirmationTemplate: {
	        label: 'Default confirmation message',
	        placeholder: 'Default confirmation message',
	        tooltip: 'Variables available:<br/><br/>Customer name: {customer_firstname}<br/>Customer last name: {customer_lastname}<br/>Appointment product: {product}<br/>Appointment date: {date}<br/>Appointment time: {time}'
	      },
	      backgroundImage: {
	        label: 'Background Image',
	        placeholder: 'Background Image',
	        changeImage: 'Change Image'
	      }
	    },
	
	    clientGroups: {
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      description: {
	        label: 'Description',
	        placeholder: 'Description'
	      },
	      priceFieldId: {
	        label: 'Pricefield',
	        placeholder: 'Pricefield'
	      },
	      receivables_account_id: {
	        label: 'Receivables account',
	        placeholder: 'Receivables account',
	        help: 'Used for accounting exports when a client in this group has no receivables account set.'
	      }
	    },
	
	    clients: {
	      basicInformation: 'Basic Information',
	      otherInformation: 'Other Information',
	      contacts: 'Contacts',
	      addresses: 'Addresses',
	      licenses: 'Licenses',
	      postalAddressError: 'Postal address details are required.',
	      primaryContactError: 'Primary contact details are required.',
	      addContact: 'Add Contact',
	      noContactWarning: 'No contacts yet.',
	      isSubClient: {
	        label: 'Is sub client?',
	        placeholder: ''
	      },
	      projectId: {
	        label: 'Project',
	        placeholder: ''
	      },
	      billMainParent: {
	        label: 'Bill main Parent',
	        placeholder: ''
	      },
	      dueDays: {
	        label: 'Due days',
	        placeholder: 'Due days'
	      },
	      startBilling: {
	        label: 'Start billing',
	        placeholder: 'Start billing'
	      },
	      billingInterval: {
	        label: 'Billing interval',
	        placeholder: 'Billing interval'
	      },
	      automaticBilling: {
	        label: 'Automatic billing',
	        placeholder: 'Automatic billing'
	      },
	      billingType: {
	        label: 'Billing type',
	        placeholder: 'Billing type'
	      },
	      externalCustomerNumber: {
	        label: 'External customer #',
	        placeholder: ''
	      },
	      orderReference: {
	        label: 'Order Reference',
	        placeholder: ''
	      },
	      orderNote: {
	        label: 'Order Note',
	        placeholder: ''
	      },
	      priceFieldId: {
	        label: 'Price field',
	        placeholder: 'Price field'
	      },
	      receivables_account_id: {
	        label: 'Receivables Account',
	        placeholder: 'Receivables Account',
	        help: 'If empty, the client group receivables account (if set) is used before the organization default.'
	      },
	      pricePercentageDiscount: {
	        label: 'Price discount',
	        placeholder: 'Price discount'
	      },
	      languageId: {
	        label: 'Language',
	        placeholder: 'language'
	      },
	      currencyId: {
	        label: 'Currency',
	        placeholder: 'Currency'
	      },
	      typeId: {
	        label: 'Type',
	        placeholder: 'Type'
	      },
	      fullName: {
	        label: 'Full Name',
	        placeholder: 'First Name'
	      },
	      clientGroupId: {
	        label: 'Select a Client Group',
	        placeholder: 'Client Groups'
	      },
	      firstName: {
	        label: 'First Name',
	        placeholder: 'First Name'
	      },
	      lastName: {
	        label: 'Last Name',
	        placeholder: 'Last Name'
	      },
	      clientParent: {
	        label: 'Client parent',
	        placeholder: 'Client parent'
	      },
	      companyName: {
	        label: 'Company Name',
	        placeholder: 'Company Name'
	      },
	      clientType: {
	        label: 'Client Type',
	        placeholder: 'Client Type'
	      },
	      contactType: {
	        label: 'Contact Type',
	        placeholder: 'Contact Type'
	      },
	      email: {
	        label: 'Email',
	        placeholder: 'Email'
	      },
	      invoiceSendMethod: {
	        label: 'Invoice Send Method',
	        placeholder: 'Preferred Invoice Send Method'
	      },
	      phoneNumber: {
	        label: 'Phone Number',
	        placeholder: 'Phone Number'
	      },
	      mobileNumber: {
	        label: 'Mobile Number',
	        placeholder: 'Mobile Number',
	        tooltip: 'The mobile number should be in the format 4xx xx xxx or 9xx xx xxx.'
	      },
	      careOf: {
	        label: 'C/O:',
	        placeholder: 'C/O'
	      },
	      streetName: {
	        label: 'Street Name',
	        placeholder: 'Street Name'
	      },
	      secondStreetName: {
	        label: 'Street Name 2',
	        placeholder: 'Street Name 2'
	      },
	      postalCode: {
	        label: 'Postal Code',
	        placeholder: 'Postal Code'
	      },
	      countryId: {
	        label: 'Select a Country',
	        placeholder: 'Select a Country'
	      },
	      cityId: {
	        label: 'City',
	        placeholder: 'City'
	      },
	      cityName: {
	        label: 'City',
	        placeholder: 'City'
	      },
	      picture: {
	        label: 'Picture',
	        placeholder: 'Drop file here or click to upload',
	        changeImage: 'Change Image'
	      },
	      organizationNumber: {
	        label: 'Organization Number',
	        placeholder: 'Enter Organization number'
	      },
	      isProducer: {
	        label: 'Is producer',
	        placeholder: 'Active'
	      },
	      isSupplier: {
	        placeholder: 'Active',
	        label: 'Is supplier'
	      },
	      isActive: {
	        label: 'Is active',
	        placeholder: 'Active'
	      },
	      manualProcessOrder: {
	        label: 'Manual Process Order',
	        placeholder: 'Enabled'
	      },
	      gln: {
	        label: 'GLN number',
	        placeholder: 'GLN number'
	      },
	      glnXKoord: {
	        label: 'GLN x-coordinates',
	        placeholder: 'GLN x-coordinates'
	      },
	      glnYKoord: {
	        label: 'GLN y-coordinates',
	        placeholder: 'GLN y-coordinates'
	      },
	      syncToWoo: {
	        label: 'Sync To WP Store',
	        placeholder: ''
	      }
	    },
	
	    catalogues: {
	      actionCode: {
	        label: 'Action code',
	        placeholder: 'Action code'
	      },
	      productGroupId: {
	        label: 'Product Group',
	        placeholder: 'Product Group'
	      },
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      issuedAt: {
	        label: 'Issued At',
	        placeholder: 'Issued At'
	      },
	      versionId: {
	        label: 'Version',
	        placeholder: 'Version'
	      },
	      validFrom: {
	        label: 'Valid From',
	        placeholder: 'Valid From'
	      },
	      validTo: {
	        label: 'Valid To',
	        placeholder: 'Valid To'
	      },
	      reference: {
	        label: 'Reference',
	        placeholder: 'Reference'
	      },
	      note: {
	        label: 'Internal note',
	        placeholder: 'Internal note'
	      }
	    },
	
	    producers: {
	      typeId: {
	        label: 'Type',
	        placeholder: 'Type'
	      },
	      name: {
	        label: 'Company Name',
	        placeholder: 'Enter Company Name'
	      }
	    },
	
	    billingTypes: {
	      options: {
	        single: 'Single',
	        consolidate: 'Consolidate'
	      }
	    },
	
	    automaticBilling: {
	      options: {
	        none: 'None',
	        weekly: 'Weekly',
	        monthly: 'Monthly'
	      }
	    },
	
	    billingInterval: {
	      week: {
	        options: {
	          week1: '1 week',
	          week2: '2 weeks',
	          week3: '3 weeks'
	        }
	      },
	      month: {
	        options: {
	          month1: '1 month',
	          month2: '2 months',
	          month3: '3 months',
	          month4: '4 months',
	          month5: '5 months',
	          month6: '6 months'
	        }
	      }
	    },
	
	    startBilling: {
	      week: {
	        options: {
	          monday: 'Monday',
	          tuesday: 'Tuesday',
	          wednesday: 'Wednesday',
	          thursday: 'Thursday',
	          friday: 'Friday',
	          saturday: 'Saturday'
	        }
	      },
	      month: {
	        options: {
	          day: 'Day'
	        }
	      }
	    },
	
	    addressTypes: {
	      updateActions: 'Update Actions',
	      options: {
	        postal: 'Postal',
	        physicalAddress: 'Physical Address',
	        deliveryAddress: 'Delivery Address'
	      }
	    },
	
	    contactTypes: {
	      options: {
	        primary: 'Primary',
	        accounting: 'Accounting'
	      }
	    },
	
	    productGroups: {
	      parentGroupId: {
	        label: 'Parent group',
	        placeholder: 'Select parent group'
	      },
	      exciseGroupId: {
	        label: 'Excise Group',
	        placeholder: 'Excise Group'
	      },
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      description: {
	        label: 'Description',
	        placeholder: 'Description'
	      }
	    },
	
	    productBundles: {
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      description: {
	        label: 'Description',
	        placeholder: 'Description'
	      },
	      price: {
	        label: 'Price',
	        placeholder: 'Price'
	      },
	      groupName: {
	        label: 'Group Name',
	        placeholder: 'Group Name'
	      },
	      groupPrice: {
	        label: 'Group Price',
	        placeholder: ''
	      },
	      groupTax: {
	        label: 'VAT %',
	        placeholder: ''
	      }
	    },
	
	    productPackagings: {
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      volume: {
	        label: 'Volume (ℓ)',
	        placeholder: 'Volume (ℓ)'
	      },
	      qtyInCrate: {
	        label: 'Quantity in Crate',
	        placeholder: 'Quantity in Crate'
	      },
	      packagingTypeId: {
	        label: 'Packaging Type',
	        placeholder: 'Packaging Type'
	      },
	      packagingMaterialId: {
	        label: 'Packaging Material',
	        placeholder: 'Packaging Material'
	      },
	      materialId: {
	        label: 'Raw material used for each unit tapped',
	        placeholder: 'Raw material'
	      },
	      crateMaterialId: {
	        label: 'Raw material used for each crate tapped.',
	        placeholder: 'Crate raw material'
	      },
	      overrideProductsConfirm: {
	        title: 'Override related products',
	        description: 'This will update all excise and deposit of products that belong to this package.'
	      }
	    },
	
	    productTags: {
	      tag: {
	        label: 'Tag',
	        placeholder: 'Tag'
	      }
	    },
	
	    priceFields: {
	      field: {
	        label: 'Field',
	        placeholder: 'Field'
	      }
	    },
	    products: {
	      number: {
	        label: 'Number',
	        placeholder: 'Number'
	      },
	      exciseGroupId: {
	        label: 'Excise Group',
	        placeholder: 'Excise Group'
	      },
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      description: {
	        label: 'Description',
	        placeholder: 'Description'
	      },
	      subType: {
	        label: 'Sub Type',
	        placeholder: 'Select Sub Type'
	      },
	      recommendations: {
	        label: 'Recommended for',
	        placeholder: 'Select Recommendations'
	      },
	      note: {
	        label: 'Internal Note',
	        placeholder: 'Internal Note'
	      },
	      isActive: {
	        label: 'Active product',
	        placeholder: 'Yes'
	      },
	      containSugar: {
	        label: 'Contains Sugar',
	        placeholder: 'Activate sugar content'
	      },
	      lowCalorie: {
	        label: 'Low-calorie?',
	        placeholder: 'Mark if the product is low-calorie (BROD report)'
	      },
	      containsAlcohol: {
	        label: 'Contains Alcohol',
	        placeholder: 'Yes'
	      },
	      externalId: {
	        label: 'External ID',
	        placeholder: 'External ID'
	      },
	      exciseAlcoholGroup: {
	        label: 'Select a Product Group',
	        placeholder: 'Product Groups'
	      },
	      excisePackagingGroup: {
	        label: 'Select Packaging Excise Group',
	        placeholder: 'Select Packaging Excise Group'
	      },
	      exciseBasicGroup: {
	        label: 'Select Basic Excise Group',
	        placeholder: 'Select Basic Excise Group'
	      },
	      chartOfAccounts: {
	        label: 'Select accounting',
	        placeholder: 'Accounting'
	      },
	      productTagId: {
	        label: 'Select a Product Tags',
	        placeholder: 'Product Tags'
	      },
	      productGroupId: {
	        label: 'Select a Product Group',
	        placeholder: 'Product Group'
	      },
	      alcoholPercentage: {
	        label: 'Alkohol %',
	        placeholder: 'ABV'
	      },
	      productPackagingId: {
	        label: 'Select a Packaging',
	        placeholder: 'Product Packaging'
	      },
	      productPackagingName: {
	        label: 'Product Packaging',
	        placeholder: 'Product Packaging'
	      },
	      packagingType: {
	        label: 'Packaging Type',
	        placeholder: 'Packaging Type'
	      },
	      productTypeId: {
	        label: 'Select a Product Type',
	        placeholder: 'Product Types'
	      },
	      productSubtype: {
	        label: 'Subtype',
	        placeholder: 'Product subtype'
	      },
	      productSubtypeId: {
	        label: 'Subtype',
	        placeholder: 'Product Sub Types'
	      },
	      productType: {
	        label: 'Select a Product Type',
	        placeholder: 'Product Types'
	      },
	      productParentId: {
	        label: 'Select a Parent Product',
	        placeholder: 'Parent Product'
	      },
	      taxId: {
	        label: 'Select a VAT Percentage',
	        placeholder: 'VAT'
	      },
	      price: {
	        label: 'Price',
	        placeholder: 'Price'
	      },
	      retailPrice: {
	        label: 'Retail Price',
	        placeholder: 'Retail Price'
	      },
	      marketplace: {
	        label: 'Marketplace Price',
	        placeholder: 'Marketplace Price'
	      },
	      duration: {
	        label: 'Duration',
	        placeholder: 'Duration'
	      },
	      breaktime: {
	        label: 'Breaktime',
	        placeholder: 'Breaktime'
	      },
	      appointable: {
	        label: 'Is appointable?',
	        placeholder: 'Yes'
	      },
	      icon: {
	        label: 'Select a Icon',
	        placeholder: 'Icon',
	        changeImage: 'Change Image',
	        removeImage: 'Remove Image'
	      },
	      image: {
	        label: 'Select an image',
	        placeholder: 'Image',
	        changeImage: 'Change Image'
	      },
	      depositCheck: {
	        label: 'Deposit',
	        placeholder: 'Deposit'
	      },
	      deposit: {
	        label: 'Deposit?',
	        placeholder: ''
	      },
	      productDepositCheckbox: {
	        label: 'Deposit',
	        placeholder: 'Deposit'
	      },
	      productDepositId: {
	        label: 'Deposit',
	        placeholder: 'Deposit'
	      },
	      overrideProducts: {
	        label: 'Override products',
	        placeholder: ''
	      },
	      purchasePrice: {
	        label: 'Purchase price',
	        placeholder: ''
	      },
	      costPrice: {
	        label: 'Cost price',
	        placeholder: ''
	      },
	      salesPriceVinhusetAsko: {
	        label: 'Sales Price Vinhuset Asko',
	        placeholder: ''
	      },
	      coop: {
	        label: 'Coop',
	        placeholder: ''
	      },
	      rema1000: {
	        label: 'Rema 1000',
	        placeholder: ''
	      },
	      excisable: {
	        label: 'Excisable',
	        placeholder: 'Active excisable'
	      },
	      paidExcise: {
	        label: 'Paid Excise',
	        placeholder: ''
	      },
	      producer: {
	        label: 'Producer name',
	        placeholder: ''
	      },
	      region: {
	        label: 'Region',
	        placeholder: ''
	      },
	      subRegion: {
	        label: 'SubRegion',
	        placeholder: ''
	      },
	      country: {
	        label: 'Country',
	        placeholder: ''
	      },
	      vintage: {
	        label: 'Vintage',
	        placeholder: ''
	      },
	      alcohol_percentage: {
	        label: 'Alcohol (%)',
	        placeholder: ''
	      },
	      bottle_volume: {
	        label: 'Bottle volum (ℓ)',
	        placeholder: ''
	      },
	      sugar: {
	        label: 'Sugar (g)',
	        placeholder: ''
	      },
	      acid: {
	        label: 'Acid',
	        placeholder: ''
	      },
	      fullness: {
	        label: 'Fullness',
	        placeholder: ''
	      },
	      freshness: {
	        label: 'Freshness',
	        placeholder: ''
	      },
	      bitterness: {
	        label: 'Bitterness',
	        placeholder: ''
	      },
	      sweetness: {
	        label: 'Sweetness',
	        placeholder: ''
	      },
	      tannins: {
	        label: 'Tannins',
	        placeholder: ''
	      },
	      colour: {
	        label: 'Colour',
	        placeholder: ''
	      },
	      odour: {
	        label: 'Odor',
	        placeholder: ''
	      },
	      taste: {
	        label: 'Taste',
	        placeholder: ''
	      },
	      storagePotential: {
	        label: 'Storage Potential',
	        placeholder: ''
	      },
	      ingredients: {
	        label: 'Ingredients',
	        placeholder: ''
	      },
	      organic: {
	        label: 'Organic',
	        placeholder: ''
	      },
	      biodynamic: {
	        label: 'Biodynamic',
	        placeholder: ''
	      },
	      locallyProduced: {
	        label: 'Locally Produced',
	        placeholder: ''
	      },
	      environmentallySmart: {
	        label: 'Environmentally Smart',
	        placeholder: ''
	      },
	      freeOrLowOnGluten: {
	        label: 'Free Or Low On Gluten',
	        placeholder: ''
	      },
	      kosher: {
	        label: 'Kosher',
	        placeholder: ''
	      },
	      cork_type: {
	        label: 'Cork type',
	        placeholder: ''
	      },
	      packaging_type: {
	        label: 'Package Type',
	        placeholder: ''
	      },
	      gtin: {
	        label: 'Main GTIN number',
	        placeholder: ''
	      },
	      gtinMultipack: {
	        label: 'GTIN multipack',
	        placeholder: ''
	      },
	      sa: {
	        label: 'SA # ',
	        placeholder: 'Suppliers Article number'
	      },
	      nobb: {
	        label: 'NOBB #',
	        placeholder: 'Norwegian construction number'
	      },
	      sourceProductId: {
	        label: 'Source Product',
	        placeholder: 'Source Product'
	      },
	      destinationProductId: {
	        label: 'Merge to',
	        placeholder: 'Merge to'
	      },
	      qty: {
	        label: 'Quantity',
	        placeholder: 'Quantity'
	      },
	      is_taxable: {
	        label: 'Is Taxable',
	        placeholder: 'Taxable'
	      },
	      inventoryExclude: {
	        label: 'Inventory Excluded',
	        placeholder: 'Yes'
	      },
	      priceField: {
	        label: 'Price Field',
	        placeholder: 'Price Field'
	      },
	      priceFieldPrice: {
	        label: 'Price',
	        placeholder: 'Price'
	      },
	      retailPriceVmp: {
	        label: 'Retail Price Vmp',
	        placeholder: ''
	      },
	      ddpVmp: {
	        label: 'ddpVmp',
	        placeholder: ''
	      },
	      salePriceHoreca: {
	        label: 'Sale Price Horeca',
	        placeholder: ''
	      },
	      salesPriceAsko: {
	        label: 'Sales Price Asko',
	        placeholder: ''
	      },
	      salesPriceVinhuset: {
	        label: 'Sales Price Vinhuset',
	        placeholder: ''
	      },
	      salesPriceWholesale: {
	        label: 'Sales Price Wholesale',
	        placeholder: ''
	      },
	      salesPriceGrocery: {
	        label: 'Sales Price Grocery',
	        placeholder: ''
	      },
	      salesPriceBusiness: {
	        label: 'Sales Price Business',
	        placeholder: ''
	      },
	      salesPriceSpecialtyStore: {
	        label: 'Sales Price Specialty Store',
	        placeholder: ''
	      },
	      packaging: {
	        label: 'Packaging',
	        placeholder: ''
	      },
	      weightUnit: {
	        label: 'Weight Unit',
	        placeholder: ''
	      },
	      weightMultipack: {
	        label: 'Weight Multi Pack',
	        placeholder: ''
	      },
	      measureUnit: {
	        label: 'Unit of Measure',
	        placeholder: ''
	      },
	      measureMultiPackaging: {
	        label: 'Measure Multi Packaging',
	        placeholder: ''
	      },
	      numberUnitsMultiPackaging: {
	        label: 'Number of Units Multi Packaging',
	        placeholder: ''
	      },
	      numberUnitsPallet: {
	        label: 'Number Units Pallet',
	        placeholder: ''
	      },
	      availableVinhuset: {
	        label: 'Available Vinhuset',
	        placeholder: ''
	      },
	      availableAsko: {
	        label: 'Available Asko',
	        placeholder: ''
	      },
	      epd: {
	        label: 'EPD',
	        placeholder: ''
	      },
	      sku: {
	        label: 'SKU',
	        placeholder: ''
	      },
	      vmp: {
	        label: 'VMP',
	        placeholder: ''
	      },
	      internalNote: {
	        label: 'Internal Note',
	        placeholder: ''
	      },
	      depositSystemId: {
	        label: 'Deposit System',
	        placeholder: 'Deposit System'
	      },
	      bottleVolume: {
	        label: 'Bottle Volume',
	        placeholder: 'Bottle Volume'
	      },
	      corkType: {
	        label: 'Cork Type',
	        placeholder: 'Cork Type'
	      },
	      lastChanged: {
	        label: 'Last Changed',
	        placeholder: 'Last Changed'
	      },
	      marketplaceEnabled: {
	        label: 'Marketplace',
	        placeholder: 'Enabled'
	      },
	      shortDescription: {
	        label: 'Short Description',
	        placeholder: 'Enter product short description'
	      },
	      longDescription: {
	        label: 'Long Description',
	        placeholder: 'Enter product long description'
	      },
	      manualProcessOrder: {
	        label: 'Manual Process Order',
	        placeholder: 'Enabled'
	      },
	      unProductCodeId: {
	        label: 'UN Product Code',
	        placeholder: 'Search UN Product Code...'
	      },
	      updateSku: {
	        label: 'Update SKU?',
	        placeholder: ''
	      },
	      minimumOrderQuantity: {
	        label: 'Minimum Order Quantity',
	        placeholder: ''
	      },
	      orderableUnitId: {
	        label: 'Orderable Unit',
	        placeholder: ''
	      },
	      syncToWoo: {
	        label: 'Sync To WP Store',
	        placeholder: ''
	      },
	      onlineStorePrice: {
	        label: 'Salesprice Online Store',
	        placeholder: ''
	      },
	      sellInCase: {
	        label: 'Sell In Case',
	        placeholder: ''
	      },
	      minQty: {
	        label: 'Minimum Quantity',
	        placeholder: ''
	      },
	      groupOf: {
	        label: 'Group Of',
	        placeholder: ''
	      },
	      packagingMaterial: {
	        label: 'Packaging Material',
	        placeholder: ''
	      },
	      packagingMaterialId: {
	        label: 'Packaging Material Id',
	        placeholder: ''
	      },
	      packagingName: {
	        label: 'Packaging Name',
	        placeholder: ''
	      },
	      packagingQuantity: {
	        label: 'Quantity in Package',
	        placeholder: ''
	      }
	    },
	
	    materials: {
	      number: {
	        label: 'Number',
	        placeholder: 'Number'
	      },
	      materialTypeId: {
	        label: 'Material Type',
	        placeholder: 'Material Type'
	      },
	      unitMeasureId: {
	        label: 'Unit of Measure',
	        placeholder: 'Unit of Measure'
	      },
	      supplierId: {
	        label: 'Supplier/Producer',
	        placeholder: 'Supplier/Producer'
	      },
	      minimumStockLevel: {
	        label: 'Minimum Stock Level',
	        placeholder: 'Minimum Stock Level'
	      },
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      description: {
	        label: 'Description',
	        placeholder: 'Description'
	      }
	    },
	
	    batches: {
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      batchNumber: {
	        label: 'Batch Number',
	        placeholder: 'Batch Number'
	      },
	      priorityNumber: {
	        label: 'Priority Number',
	        placeholder: 'Priority Number'
	      },
	      recipeId: {
	        label: 'Recipe',
	        placeholder: 'Recipe'
	      },
	      plannedStartingDate: {
	        label: 'Planned Starting Date',
	        placeholder: 'Planned Starting Date'
	      },
	      startDate: {
	        label: 'Start Date',
	        placeholder: 'Start Date'
	      },
	      endDate: {
	        label: 'End Date',
	        placeholder: 'End Date'
	      },
	      bestBeforeDate: {
	        label: 'Best Before Date',
	        placeholder: 'Best Before Date'
	      },
	      expirationDate: {
	        label: 'Expiration Date',
	        placeholder: 'Expiration Date'
	      },
	      notes: {
	        label: 'Notes',
	        placeholder: 'Notes'
	      },
	      description: {
	        label: 'Description',
	        placeholder: 'Description'
	      },
	      timestamp: {
	        label: 'Timestamp',
	        placeholder: 'Timestamp'
	      },
	      statuses: {
	        planned: 'Plan',
	        started: 'Start New',
	        completed: 'Register Done'
	      }
	    },
	
	    recipes: {
	      recipeTypeId: {
	        label: 'Recipe Type',
	        placeholder: 'Recipe Type'
	      },
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      step: {
	        label: 'Step',
	        placeholder: 'Step'
	      },
	      notes: {
	        label: 'Notes',
	        placeholder: 'Notes'
	      },
	      product: {
	        label: 'Product',
	        placeholder: 'Product'
	      },
	      ingredienceIds: {
	        label: 'Ingrediences',
	        placeholder: 'Ingrediences'
	      },
	      equipmentId: {
	        label: 'Equipment',
	        placeholder: 'Equipment'
	      }
	    },
	
	    equipments: {
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      isActive: {
	        label: 'Status',
	        placeholder: 'Active'
	      }
	    },
	
	    campaigns: {
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      description: {
	        label: 'Description',
	        placeholder: 'Description'
	      },
	      campaignTypeId: {
	        label: 'Campaign Type',
	        placeholder: 'Campaign Type'
	      },
	      newsSubscriberListId: {
	        label: 'List',
	        placeholder: 'List'
	      }
	    },
	
	    subscriberList: {
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      selectDefaultEmail: {
	        label: 'Use Default Email',
	        placeholder: ''
	      },
	      fromEmail: {
	        label: 'From Email',
	        placeholder: 'From Email'
	      },
	      selectDefaultName: {
	        label: 'Use Default Name',
	        placeholder: ''
	      },
	      fromName: {
	        label: 'From Name',
	        placeholder: 'From Name'
	      },
	      description: {
	        label: 'Description',
	        placeholder: 'Description'
	      },
	      doubleOptinRequired: {
	        label: 'Double optin',
	        placeholder: ''
	      },
	      optinEmailSubject: {
	        label: 'Subject',
	        placeholder: 'Subject'
	      },
	      optinEmailBody: {
	        label: 'Body',
	        placeholder: 'Body'
	      }
	    },
	
	    news: {
	      subject: {
	        label: 'Subject',
	        placeholder: 'Subject'
	      },
	      body: {
	        label: 'Body',
	        placeholder: 'Body'
	      },
	      sendAfterDate: {
	        label: 'Send date',
	        placeholder: 'Send date'
	      },
	      sendAfterTime: {
	        label: 'Send time',
	        placeholder: 'Send time'
	      },
	      sendAfter: {
	        label: 'Send after (hours)',
	        placeholder: 'Send after'
	      },
	      testEmail: {
	        label: 'Test email',
	        placeholder: 'mail@mail.com'
	      },
	      testEmailCheck: {
	        label: 'Use custom email',
	        placeholder: ''
	      },
	      status: {
	        label: 'Status'
	      },
	      htmlEmail: {
	        label: 'Use Html Email',
	        placeholder: ''
	      }
	    },
	
	    orders: {
	      createdAt: {
	        label: 'Order Date',
	        placeholder: 'Order Date'
	      },
	      orderTypeId: {
	        label: 'Order Type',
	        placeholder: 'Order Type'
	      },
	      projectId: {
	        label: 'Project',
	        placeholder: 'Project'
	      },
	      productId: {
	        label: 'Select the product',
	        placeholder: 'Product'
	      },
	      batchId: {
	        label: 'Select a batch',
	        placeholder: 'Batch'
	      },
	      available: {
	        label: 'Available',
	        placeholder: 'Available'
	      },
	      clientId: {
	        label: 'Select the client',
	        placeholder: 'Clients'
	      },
	      referenceNumber: {
	        label: 'Order Reference',
	        placeholder: 'Order Reference'
	      },
	      internalNote: {
	        label: 'Internal Note',
	        placeholder: 'Internal Note'
	      },
	      date: {
	        label: 'Date',
	        placeholder: 'Date'
	      },
	      slot: {
	        label: 'Select slot',
	        placeholder: 'Time Slots'
	      },
	      timeSlots: {
	        label: 'Start time'
	      },
	      time: {
	        label: 'Time',
	        placeholder: 'Time'
	      },
	      duration: {
	        label: 'Duration',
	        placeholder: 'Duration'
	      },
	      details: {
	        label: 'Details',
	        placeholder: 'Details'
	      },
	      warehouseId: {
	        label: 'Warehouse',
	        placeholder: 'Warehouse'
	      }
	    },
	
	    ediOrders: {
	      deliveryDate: {
	        label: 'Delivery Date',
	        placeholder: 'Delivery Date'
	      },
	      orderNumber: {
	        label: 'Vinmonopolet order number',
	        placeholder: 'Select or search order number'
	      }
	    },
	
	    bills: {
	      languageId: {
	        label: 'Select language',
	        placeholder: 'Language'
	      },
	      currencyId: {
	        label: 'Select currency',
	        placeholder: 'Currency'
	      },
	      orderId: {
	        label: 'Select the order',
	        placeholder: 'Orders'
	      },
	      billTypeId: {
	        label: 'Select the bill type',
	        placeholder: 'Types'
	      },
	      billStatusId: {
	        label: 'Select the bill status',
	        placeholder: 'Statuses'
	      },
	      dueDate: {
	        label: 'Due Date',
	        placeholder: 'Due Date'
	      },
	      summaryGrouping: {
	        label: 'Summary grouping',
	        placeholder: ''
	      },
	      date: {
	        label: 'Date',
	        placeholder: 'Date'
	      },
	      paymentDate: {
	        label: 'Payment Date',
	        placeholder: 'Payment Date'
	      },
	      creditNoteValue: {
	        label: 'Credit note value',
	        placeholder: 'Value'
	      },
	      paymentMessage: {
	        label: 'Payment Message',
	        placeholder: 'Message Text / KID'
	      },
	      kidNumber: {
	        label: 'KID Number',
	        placeholder: 'KID'
	      },
	      note: {
	        label: 'Notes',
	        placeholder: 'Notes'
	      }
	    },
	
	    addEditPackage: {
	      packageUnitTypeId: {
	        label: 'Package Unit Type',
	        placeholder: 'Package Unit Type'
	      },
	      sscc: {
	        label: 'SSCC',
	        placeholder: 'Serial Shipping Container Code'
	      },
	      parentId: {
	        label: 'Parent ID',
	        placeholder: 'Parent ID'
	      },
	      packingLevel: {
	        label: 'Package Type',
	        placeholder: 'Package Type'
	      }
	    },
	
	    addEditProductToPackage: {
	      productName: {
	        label: 'Product',
	        placeholder: 'Product'
	      },
	      orderProductId: {
	        label: 'Product',
	        placeholder: 'Product'
	      },
	      quantity: {
	        label: 'Quantity',
	        placeholder: 'Quantity'
	      },
	      quantityUnit: {
	        label: 'Quantity Unit',
	        placeholder: 'Quantity Unit'
	      },
	      grossWeight: {
	        label: 'Gross Weight',
	        placeholder: 'Gross Weight'
	      },
	      netWeight: {
	        label: 'Net Weight',
	        placeholder: 'Net Weight'
	      },
	      stackWeight: {
	        label: 'Stack Weight',
	        placeholder: 'Stack Weight'
	      },
	      bestBefore: {
	        label: 'Best Before',
	        placeholder: 'Best Before'
	      },
	      maxTopLoad: {
	        label: 'Max Top Load',
	        placeholder: 'Max Top Load'
	      },
	      batchLotNumber: {
	        label: 'Batch / Lot Number',
	        placeholder: 'Batch / Lot Number'
	      },
	      temperatureRequirement: {
	        label: 'Temperature (in °C)',
	        placeholder: 'Temperature (in °C)'
	      }
	    }
	  },
	
	  table: {
	    noData: 'No data found.',
	    projects: {
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      description: {
	        label: 'Description',
	        placeholder: 'Description'
	      }
	    },
	    clientReports: {
	      id: 'id',
	      name: 'Name',
	      clientNumber: 'Client #',
	      balance: 'Balance',
	      createdAt: 'Created At',
	      lastSent: 'Last Sent'
	    },
	    stock: {
	      products: {
	        productId: {
	          label: 'Name',
	          placeholder: 'Name'
	        },
	        batchId: {
	          label: 'Batch',
	          placeholder: 'Select batch'
	        },
	        currentCount: {
	          label: 'Current Count',
	          placeholder: 'Current Count'
	        },
	        physicalCount: {
	          label: 'Physical Count',
	          placeholder: 'Physical Count'
	        },
	        variance: {
	          label: 'Variance',
	          placeholder: 'Variance'
	        }
	      }
	    },
	    adjustment: {
	      products: {
	        productId: {
	          label: 'Product',
	          placeholder: 'Pick a product'
	        },
	        batchId: {
	          label: 'Batch',
	          placeholder: 'Batch'
	        },
	        qty: {
	          label: 'Adjustment (+/-)',
	          placeholder: 'Adjustment (+/-)',
	          customDeduct: 'Deduct'
	        },
	        currentAdjustment: {
	          label: 'System inventory',
	          placeholder: 'System inventory'
	        },
	        exciseAdditionalCode: {
	          label: 'Additional Code',
	          placeholder: ''
	        }
	      }
	    },
	    warehouseReports: {
	      productName: 'Product',
	      productValue: 'Product Value',
	      nameOfWarehouse: 'Warehouse',
	      productNumber: 'Number',
	      vmpNumber: 'VMP Number',
	      qtyAvailable: 'Quantity'
	    },
	    products: {
	      productId: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      qty: {
	        label: 'Quantity',
	        placeholder: 'Quantity'
	      },
	      priceField: {
	        label: 'Price Field',
	        placeholder: 'Price Field'
	      },
	      priceFieldPrice: {
	        label: 'Price',
	        placeholder: 'Price'
	      }
	    },
	    shippingProviders: {
	      name: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      code: {
	        label: 'Code',
	        placeholder: 'Code'
	      }
	    },
	    productBundles: {
	      productId: {
	        label: 'Product',
	        placeholder: 'Product'
	      },
	      price: {
	        label: 'Price',
	        placeholder: 'Price'
	      },
	      qty: {
	        label: 'Qty',
	        placeholder: 'Qty'
	      }
	    },
	    productsCustom: {
	      productId: {
	        label: 'Name',
	        placeholder: 'Name'
	      },
	      qty: {
	        label: 'Quantity',
	        placeholder: 'Quantity'
	      },
	      currentAdjustment: {
	        label: 'System Stock Count',
	        placeholder: 'System Stock Count'
	      },
	      qtyReceive: {
	        label: 'Quantity Received',
	        placeholder: 'Quantity Received'
	      },
	      qtyDamage: {
	        label: 'Quantity Damage',
	        placeholder: 'Quantity Damage'
	      },
	      costPrice: {
	        label: 'Cost Price',
	        placeholder: 'Cost Price'
	      },
	      purchasePrice: {
	        label: 'Purchase Price',
	        placeholder: 'Purchase Price'
	      },
	      notes: {
	        label: 'Notes',
	        placeholder: 'Notes'
	      },
	      batchId: {
	        label: 'Batch',
	        placement: 'Batch'
	      }
	    },
	    orderProducts: {
	      addProductsButton: 'Add Products',
	      addAllBillProductsButton: 'Add all invoice lines',
	      addAllBillProductsNothing: 'All invoice lines are already on this credit note.',
	      addAllBillProductsSuccess: 'Added {count} line(s) to the credit note.',
	      addAllBillProductsError: 'Could not add all lines. Try adding them individually.',
	      name: {
	        label: 'Description',
	        placeholder: 'Name'
	      },
	      note: {
	        label: 'Note',
	        placeholder: 'Note'
	      },
	      productDepositId: {
	        label: 'Deposit',
	        placeholder: 'Deposit'
	      },
	      taxId: {
	        label: 'Tax (%)',
	        placeholder: 'Select...'
	      },
	      batchId: {
	        label: 'Batch',
	        placeholder: 'Select...'
	      },
	      batchIds: {
	        label: 'Batch',
	        placeholder: 'Select...'
	      },
	      transactions: {
	        label: 'Transactions',
	        placeholder: 'Select...'
	      },
	      available: {
	        label: 'Available',
	        placeholder: 'Available'
	      },
	      price: {
	        label: 'Unit Price',
	        placeholder: 'Price'
	      },
	      quantity: {
	        label: 'Quantity',
	        placeholder: 'Quantity'
	      },
	      discount: {
	        label: 'Discount (%)',
	        placeholder: 'Discount (%)'
	      },
	      quantityOrdered: {
	        label: 'Qty Ordered',
	        placeholder: 'Qty Ordered'
	      },
	      quantityConfirmed: {
	        label: 'Qty Confirmed',
	        placeholder: 'Qty Confirmed'
	      },
	      quantityReceived: {
	        label: 'Qty Received',
	        placeholder: 'Qty Received'
	      },
	      quantityUnconfirmed: {
	        label: 'Unconfirmed',
	        placeholder: 'Unconfirmed'
	      },
	      returnCodeDescription: {
	        label: 'Return Reason'
	      },
	      unitTypeId: {
	        label: 'Unit Type',
	        placeholder: ''
	      },
	      unitQuantity: {
	        label: 'Unit Qty',
	        placeholder: ''
	      }
	    },
	    creditNoteProducts: {
	      billProductId: {
	        label: 'Product',
	        placeholder: 'Choose a Product'
	      },
	      orderProductId: {
	        label: 'Product',
	        placeholder: 'Choose a Product'
	      },
	      productDepositId: {
	        label: 'Deposit',
	        placeholder: 'Deposit'
	      },
	      taxId: {
	        label: 'Tax (%)',
	        placeholder: 'Select...'
	      },
	      price: {
	        label: 'Price',
	        placeholder: 'Price'
	      },
	      quantity: {
	        label: 'Quantity',
	        placeholder: 'Quantity'
	      },
	      discount: {
	        label: 'Discount (%)',
	        placeholder: 'Discount (%)'
	      }
	    },
	    businessHours: {
	      addOpeningHours: 'Add Opening Hours',
	      businessDays: {
	        placeholder: 'Days',
	        label: 'Days'
	      },
	      start: {
	        placeholder: 'Start time',
	        label: 'Start Time'
	      },
	      end: {
	        placeholder: 'End time',
	        label: 'End Time'
	      }
	    },
	    businessHourExceptions: {
	      addExceptionalHours: 'Add Exceptional Hours',
	      date: {
	        placeholder: 'Date',
	        label: 'Date'
	      },
	      start: {
	        placeholder: 'Start time',
	        label: 'Start Time'
	      },
	      end: {
	        placeholder: 'End time',
	        label: 'End Time'
	      },
	      message: {
	        placeholder: 'Message',
	        label: 'Message'
	      }
	    },
	    recipeIngrediences: {
	      materialId: {
	        label: 'Material',
	        placeholder: 'Material'
	      },
	      amount: {
	        label: 'Amount',
	        placeholder: 'Amount'
	      },
	      unitMeasure: {
	        label: 'Unit of Measure',
	        placeholder: 'Unit of Measure'
	      },
	      deductedAmount: {
	        label: 'Deducted Amount',
	        placeholder: 'Deducted Amount'
	      },
	      noResult: 'No ingrediences added yet.'
	    },
	    ediOrderItems: {
	      name: {
	        label: 'Product',
	        placeholder: 'Name'
	      },
	      price: {
	        label: 'Price'
	      },
	      quantityOrdered: {
	        label: 'Quantity Ordered'
	      },
	      quantityConfirmed: {
	        label: 'Quantity Confirmed'
	      },
	      max: {
	        label: 'Max'
	      }
	    },
	    billProducts: {
	      billProductId: {
	        label: 'Product',
	        placeholder: 'Product'
	      },
	      orderProductId: {
	        label: 'Product',
	        placeholder: 'Product'
	      },
	      orderProduct: {
	        label: 'Product',
	        placeholder: 'Product'
	      },
	      productDepositId: {
	        label: 'Pant',
	        placeholder: 'Velg pant'
	      },
	      taxId: {
	        label: 'Tax (%)',
	        placeholder: 'Tax...'
	      },
	      price: {
	        label: 'Price',
	        placeholder: 'Price'
	      },
	      quantity: {
	        label: 'Quantity',
	        placeholder: 'Quantity'
	      },
	      discount: {
	        label: 'Discount (%)',
	        placeholder: 'Discount (%)'
	      },
	      ref: {
	        label: 'Ref #',
	        placeholder: 'Ref #'
	      }
	    }
	  },
	
	  el: {
	    colorpicker: {
	      confirm: 'OK',
	      clear: 'Clear'
	    },
	    datepicker: {
	      now: 'Now',
	      today: 'Today',
	      cancel: 'Cancel',
	      clear: 'Clear',
	      confirm: 'OK',
	      selectDate: 'Select date',
	      selectTime: 'Select time',
	      startDate: 'Start Date',
	      startTime: 'Start Time',
	      endDate: 'End Date',
	      endTime: 'End Time',
	      prevMonth: 'Previous Month',
	      nextMonth: 'Next Month',
	      prevYear: 'Previous Year',
	      nextYear: 'Next Year',
	      year: '',
	      month1: 'Jan',
	      month2: 'Feb',
	      month3: 'Mar',
	      month4: 'Apr',
	      month5: 'May',
	      month6: 'Jun',
	      month7: 'Jul',
	      month8: 'Aug',
	      month9: 'Sep',
	      month10: 'Oct',
	      month11: 'Nov',
	      month12: 'Dec',
	
	      weeks: {
	        sun: 'Sun',
	        mon: 'Mon',
	        tue: 'Tue',
	        wed: 'Wed',
	        thu: 'Thu',
	        fri: 'Fri',
	        sat: 'Sat'
	      },
	      months: {
	        jan: 'Jan',
	        feb: 'Feb',
	        mar: 'Mar',
	        apr: 'Apr',
	        may: 'May',
	        jun: 'Jun',
	        jul: 'Jul',
	        aug: 'Aug',
	        sep: 'Sep',
	        oct: 'Oct',
	        nov: 'Nov',
	        dec: 'Dec'
	      }
	    },
	    select: {
	      loading: 'Loading',
	      noMatch: 'No matching data',
	      noData: 'No data',
	      placeholder: 'Select'
	    },
	    cascader: {
	      noMatch: 'No matching data',
	      placeholder: 'Select'
	    },
	    pagination: {
	      goto: 'Go to',
	      pagesize: '/page',
	      total: 'Total {total}',
	      pageClassifier: ''
	    },
	    messagebox: {
	      title: 'Message',
	      confirm: 'OK',
	      cancel: 'Cancel',
	      error: 'Illegal input'
	    },
	    upload: {
	      delete: 'Delete',
	      preview: 'Preview',
	      continue: 'Continue'
	    },
	    table: {
	      emptyText: 'No Data',
	      confirmFilter: 'Confirm',
	      resetFilter: 'Reset',
	      clearFilter: 'All'
	    },
	    tree: {
	      emptyText: 'No Data'
	    }
	  },
	
	  creditNoteWarning: {
	    invoiceInfo: {
	      exciseInventoryActivated: 'You have excise and inventory module activated on your account. Make sure to mark you credit note as cleared in order to trigger a product return!',
	      specialChargeActivated: 'You have a special charge activated in your account. Remember to complete the credit note to register any returns!',
	      storageModuleEnabled: 'You have storage module enabled in your account. Remember to complete the credit note to register any returns!',
	      noClientEmail: 'You can\'t send a credit note since the client\'s email is missing.'
	    }
	  },
	
	  warnings: {
	    billReminder: {
	      unableToCreateWithFee: 'Unable to create reminder with fees.',
	      reasons: {
	        max2: 'because you have already created 2 reminder with fees.',
	        notDue: 'a reminder with a fee cannot be created before 14 days after the due date.',
	        oneReminderFee: 'because you already sent 1st reminder, before you can sent again please wait',
	        oneReminderFeeDays: 'days before sending a new reminder.'
	      }
	    }
	  }
	};

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  translated: {
	    US: 'USA',
	    CA: 'Canada',
	    AF: 'Afghanistan',
	    AL: 'Albania',
	    DZ: 'Algerie',
	    AS: 'Amerikansk Samoa',
	    AD: 'Andorra',
	    AO: 'Angola',
	    AI: 'Anguilla',
	    AQ: 'Antarktis',
	    AG: 'Antigua og/eller Barbuda',
	    AR: 'Argentina',
	    AM: 'Armenia',
	    AW: 'Aruba',
	    AU: 'Australia',
	    AT: 'Østerrike',
	    AZ: 'Aserbajdsjan',
	    BS: 'Bahamas',
	    BH: 'Bahrain',
	    BD: 'Bangladesh',
	    BB: 'Barbados',
	    BY: 'Hviterussland',
	    BE: 'Belgia',
	    BZ: 'Belize',
	    BJ: 'Benin',
	    BM: 'Bermuda',
	    BT: 'Bhutan',
	    BO: 'Bolivia',
	    BA: 'Bosnia og Herzegovina',
	    BW: 'Botswana',
	    BV: 'Bouvetøya',
	    BR: 'Brasil',
	    IO: 'Britisk territorium i det indiske hav',
	    BN: 'Brunei Darussalam',
	    BG: 'Bulgaria',
	    BF: 'Burkina Faso',
	    BI: 'Burundi',
	    KH: 'Kambodsja',
	    CM: 'Kamerun',
	    CV: 'Kapp Verde',
	    KY: 'Caymanøyene',
	    CF: 'Den sentralafrikanske republikk',
	    TD: 'Tsjad',
	    CL: 'Chile',
	    CN: 'Kina',
	    CX: 'Juleøya',
	    CC: 'Kokosøyene (Keeling).',
	    CO: 'Colombia',
	    KM: 'Komorene',
	    CG: 'Kongo',
	    CK: 'Cook-øyene',
	    CR: 'Costa Rica',
	    HR: 'Kroatia (Hrvatska)',
	    CU: 'Cuba',
	    CY: 'Kypros',
	    CZ: 'Tsjekkisk Republikk',
	    CD: 'Den demokratiske republikken Kongo',
	    DK: 'Danmark',
	    DJ: 'Djibouti',
	    DM: 'Dominica',
	    DO: 'Den Dominikanske republikk',
	    TP: 'Øst-Timor',
	    EC: 'Ecuador',
	    EG: 'Egypt',
	    SV: 'El Salvador',
	    GQ: 'Ekvatorial-Guinea',
	    ER: 'Eritrea',
	    EE: 'Estland',
	    ET: 'Etiopia',
	    FK: 'Falklandsøyene (Malvinas)',
	    FO: 'Færøyene',
	    FJ: 'Fiji',
	    FI: 'Finland',
	    FR: 'Frankrike',
	    FX: 'Frankrike, Metropolitan',
	    GF: 'Fransk Guyana',
	    PF: 'Fransk Polynesia',
	    TF: 'Franske Sørlige Territorier',
	    GA: 'Gabon',
	    GM: 'Gambia',
	    GE: 'Georgia',
	    DE: 'Tyskland',
	    GH: 'Ghana',
	    GI: 'Gibraltar',
	    GR: 'Hellas',
	    GL: 'Grønland',
	    GD: 'Grenada',
	    GP: 'Guadeloupe',
	    GU: 'Guam',
	    GT: 'Guatemala',
	    GN: 'Guinea',
	    GW: 'Guinea-Bissau',
	    GY: 'Guyana',
	    HT: 'Haiti',
	    HM: 'Heard and Mc Donald Islands',
	    HN: 'Honduras',
	    HK: 'Hong Kong',
	    HU: 'Ungarn',
	    IS: 'Island',
	    IN: 'India',
	    ID: 'Indonesia',
	    IR: 'Iran (den islamske republikken)',
	    IQ: 'Irak',
	    IE: 'Irland',
	    IL: 'Israel',
	    IT: 'Italia',
	    CI: 'Elfenbenskysten',
	    JM: 'Jamaica',
	    JP: 'Japan',
	    JO: 'Jordan',
	    KZ: 'Kazakhstan',
	    KE: 'Kenya',
	    KI: 'Kiribati',
	    KP: 'Korea, Den demokratiske folkerepublikken',
	    KR: 'Korea, Republikken',
	    KW: 'Kuwait',
	    KG: 'Kirgisistan',
	    LA: 'Lao folkets Demokratiske Republikk',
	    LV: 'Latvia',
	    LB: 'Libanon',
	    LS: 'Lesotho',
	    LR: 'Liberia',
	    LY: 'Libya Arab Jamahiriya',
	    LI: 'Liechtenstein',
	    LT: 'Litauen',
	    LU: 'Luxembourg',
	    MO: 'Macau',
	    MK: 'Macedonia',
	    MG: 'Madagaskar',
	    MW: 'Malawi',
	    MY: 'Malaysia',
	    MV: 'Maldivene',
	    ML: 'Mali',
	    MT: 'Malta',
	    MH: 'Marshalløyene',
	    MQ: 'Martinique',
	    MR: 'Mauritania',
	    MU: 'Mauritius',
	    TY: 'Mayotte',
	    MX: 'Mexico',
	    FM: 'Fødererte Stater av Mikronesia',
	    MD: 'Moldova',
	    MC: 'Monaco',
	    MN: 'Mongolia',
	    MS: 'Montserrat',
	    MA: 'Marokko',
	    MZ: 'Mosambik',
	    MM: 'Myanmar',
	    NA: 'Namibia',
	    NR: 'Nauru',
	    NP: 'Nepal',
	    NL: 'Nederland',
	    AN: 'De nederlandske Antillene',
	    NC: 'Ny Caledonia',
	    NZ: 'New Zealand',
	    NI: 'Nicaragua',
	    NE: 'Niger',
	    NG: 'Nigeria',
	    NU: 'Niue',
	    NF: 'Norfolkøya',
	    MP: 'Nord-Marianene',
	    NO: 'Norge',
	    OM: 'Oman',
	    PK: 'Pakistan',
	    PW: 'Palau',
	    PA: 'Panama',
	    PG: 'Papua Ny-Guinea',
	    PY: 'Paraguay',
	    PE: 'Peru',
	    PH: 'Filippinene',
	    PN: 'Pitcairn',
	    PL: 'Polen',
	    PT: 'Portugal',
	    PR: 'Puerto Rico',
	    QA: 'Qatar',
	    SS: 'Republikken Sør-Sudan',
	    RE: 'Reunion',
	    RO: 'Romania',
	    RU: 'Den Russiske Føderasjonen',
	    RW: 'Rwanda',
	    KN: 'Saint Kitts and Nevis',
	    LC: 'Saint Lucia',
	    VC: 'Saint Vincent og Grenadinene',
	    WS: 'Samoa',
	    SM: 'San Marino',
	    ST: 'Sao Tome and Principe',
	    SA: 'Saudi Arabia',
	    SN: 'Senegal',
	    RS: 'Serbia',
	    SC: 'Seychellene',
	    SL: 'Sierra Leone',
	    SG: 'Singapore',
	    SK: 'Slovakia',
	    SI: 'Slovenia',
	    SB: 'Solomon øyene',
	    SO: 'Somalia',
	    ZA: 'Sør-Afrika',
	    GS: 'Sør-Georgia Sør-Sandwichøyene',
	    ES: 'Spania',
	    LK: 'Sri Lanka',
	    SH: 'St. Helena',
	    PM: 'St. Pierre og Miquelon',
	    SD: 'Sudan',
	    SR: 'Surinam',
	    SJ: 'Svalbarn og Jan Mayen-øyene',
	    SZ: 'Swaziland',
	    SE: 'Sverige',
	    CH: 'Sveits',
	    SY: 'Den syriske arabiske republikk',
	    TW: 'Taiwan',
	    TJ: 'Tajikistan',
	    TZ: 'Den forente republikk Tanzania',
	    TH: 'Thailand',
	    TG: 'Togo',
	    TK: 'Tokelau',
	    TO: 'Tonga',
	    TT: 'Trinidad og Tobago',
	    TN: 'Tunisia',
	    TR: 'Tyrkia',
	    TM: 'Turkmenistan',
	    TC: 'Turks- og Caicosøyene',
	    TV: 'Tuvalu',
	    UG: 'Uganda',
	    UA: 'Ukraina',
	    AE: 'De forente arabiske emirater',
	    GB: 'Storbritannia',
	    UM: 'USAs ytre øyer',
	    UY: 'Uruguay',
	    UZ: 'Usbekistan',
	    VU: 'Vanuatu',
	    VA: 'Vatikanstaten',
	    VE: 'Venezuela',
	    VN: 'Vietnam',
	    VG: 'Jomfruøyene (britiske)',
	    VI: 'Jomfruøyene (USA)',
	    WF: 'Wallis og Futuna-øyene',
	    EH: 'Vestre Sahara',
	    YE: 'Jemen',
	    YU: 'Jugoslavia',
	    ZR: 'Zaire',
	    ZM: 'Zambia',
	    ZW: 'Zimbabwe'
	  }
	};

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _country = __webpack_require__(846);
	
	var _country2 = _interopRequireDefault(_country);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  country: _country2.default,
	  static: {
	    collicareConfirmedShippingReminderEmpty: 'Nødvendige ordredetaljer mangler. Trykk på knappen "Lukk" og gå til fanen som heter "Rediger Ordre" for å skriv inn kontakt- og åpningsdetaljene for levering. Husk å lagre og bekreft levering på nytt.',
	    collicareConfirmedShippingReminder: 'NB! Disse detaljene brukes for levering. Vennligst sjekk at informasjonen er korrekt før godkjenning! Hvis nødvendig kan du redigere detaljene fra fanen som heter "Rediger Ordre"',
	    sharedWarehouseProduct: 'NB! Dette produktet kommer fra et delt varelager. Kun feltene under fanen "Nettbutikk" er mulig å oppdatere.',
	    tripletexCreditNoteNotice: 'NB! Synkronisering til tripletex støttes bare for fullt kreditert fakturaer',
	    loadingProductLines: 'Laster linjer…',
	    bundleProductPreview: {
	      openProductEdit: 'Åpne produktredigering',
	      bundleProducts: 'Tilhørende produkter',
	      title: 'Produktpakke',
	      view: 'Rediger',
	      table: {
	        sku: 'SKU',
	        name: 'Produkt',
	        action: 'Handling'
	      }
	    },
	    productBundles: {
	      filters: {
	        title: 'Produktpakke',
	        all: 'Alle'
	      },
	      create: {
	        title: 'Legg til produktpakke'
	      },
	      edit: {
	        title: 'Rediger produktpakke'
	      },
	      index: {
	        title: 'Oversikt over produktpakker'
	      },
	      formTabs: {
	        bundleInformation: 'Bundle Information'
	      }
	    },
	    reminderTable: {
	      type: 'Type',
	      freeAmount: 'Gebyrbeløp',
	      dateCreated: 'Date laget',
	      reminder: 'Påminnelse',
	      notes: 'Notater',
	      percentage: 'Prosentdel',
	      fixed: 'Fikset',
	      newDueDate: 'Ny forfallsdato'
	    },
	    sharedWarehouse: {
	      notAllowed: 'Du har ikke lov til å redigere dette siden dette er et delt lager.'
	    },
	    bulkProcessOrder: {
	      title: 'Bulk behandling av order'
	    },
	    bulkProcessBill: {
	      title: 'Bulk behandling av fakturaer',
	      payment_date_options: {
	        selectDate: 'Velg felles betalingsdato for alle fakturaer',
	        dueDate: 'Sett betalingsdato til forfallsdato'
	      }
	    },
	    bulkDestroyProducts: {
	      title: 'Utvalgte produkter som skal destrueres',
	      name: 'Produktnavn',
	      productQty: 'Antall',
	      batch: 'Parti',
	      qtyToDestroy: 'Antall å destruere',
	      available: 'Antall tilgjengelig'
	    },
	    clientInfo: {
	      billAddressMissing: 'Fakturaadressen mangler! Oppdater her'
	    },
	    clientAddress: {
	      edit: {
	        title: 'Oppdatering av kundeadresse'
	      }
	    },
	    producers: {
	      add: 'Opprett produsent'
	    },
	    referenceSign: {
	      invoice: 'FKT',
	      order: 'ORD'
	    },
	    alertMissingDetails: {
	      customerNoContactEmail: {
	        message: 'Denne kunden har ingen registrert kontakt epost. Vennligst oppdater kunden for å sende faktura.',
	        linkText: 'Rediger kunde'
	      }
	    },
	    accountAlert: {
	      greetings: 'Hei',
	      msgPart1: 'kontobonnementet ditt',
	      msgPart2Ending: 'vennligst se til at abonnementet blir fornyet for å ikke miste funksjoner på din konto. Vennligst ta kontakt med',
	      msgPart2Ended: 'ditt abonnement har utløpt og funksjoner på din konto kan være redusert. Vennligst ta kontakt med',
	      partial: {
	        willEndIn: 'ditt abonnement utløper om',
	        days: 'dager',
	        day: 'dag'
	      }
	    },
	    unpaidInvoiceAlert: {
	      title: 'Forfalt faktura',
	      body: 'Kundan-kontoen deres vil bli sperret dersom fakturaen ikke betales. Vennligst betal forfalt faktura, eller ta kontakt med'
	    },
	    bridgeHandoff: {
	      handedOff: 'Lageroperasjoner for denne organisasjonen er flyttet til Inventory App. Denne visningen er nå skrivebeskyttet — bruk Inventory App for å opprette eller endre lager, justeringer, overføringer og mottak.',
	      decommissioned: 'Lageroperasjoner for denne organisasjonen er permanent flyttet til Inventory App. Denne modulen beholdes som et skrivebeskyttet arkiv.',
	      openApp: 'Åpne Inventory App',
	      blockedToast: 'Denne handlingen er flyttet til Inventory App. Bruk Inventory App for å fullføre den.'
	    },
	    widgets: {
	      soldProduct: {
	        filters: {
	          last3Months: 'Siste 3 måneder',
	          last6Months: 'Siste 6 måneder',
	          thisYear: 'Hittil i år'
	        }
	      }
	    },
	    license: {
	      licenseNumber: 'Tillatelse #',
	      organizationNumber: 'Organisasjonsnummer',
	      licenseType: 'Lisenstype',
	      licensePermitType: 'Tillatelsesgruppe',
	      validFrom: 'Gyldig fra',
	      validTo: 'Gyldig til',
	      add: 'Legg til lisense',
	      organizationNumberRequired: 'Du må legge til organisasjonsnummer på kunden før du kan legge til lisens',
	      groups: 'Varegrupper'
	    },
	    releaseNote: {
	      page: {
	        title: 'Hva er nytt i Kundan?',
	        subTitle: 'Endringslogg'
	      },
	      toast: {
	        message: 'Ny versjon av Kundan er ute nå! Klikk her for å bruke siste versjon :)'
	      },
	      modal: {
	        btnNext: 'NESTE',
	        btnPrev: 'TILBAKE',
	        learnLink: 'Les mer',
	        pageOf: 'av',
	        versionRelease: 'Versjon'
	      },
	      close: {
	        gotIt: 'Kjør på'
	      }
	    },
	    defaultText: {
	      noData: 'Ingen Data',
	      client: {
	        noDataMsg: 'Vi finner ingen kunder på din konto. Men vi kan opprette en her: ',
	        noDataBtn: 'Opprett kunde'
	      },
	      clientGroup: {
	        noDataMsg: 'Det ser ikke ut som du har opprettet noen kunde-gruppe på din konto? Skal vi lage en nå? ',
	        noDataBtn: 'Opprett kunde-gruppe'
	      },
	      product: {
	        noDataMsg: 'Vi finner ingen produkter på din konto? Skal vi opprette et? ',
	        noDataBtn: 'Opprett produkt'
	      },
	      productGroup: {
	        noDataMsg: 'Vi finner ingen produkt-grupper. Skal vi lage en nå?',
	        noDataBtn: 'Opprett produkt-grupper'
	      },
	      order: {
	        noDataMsg: 'Vi finner ingen ordre på din konto. Opprett din første ordre ved å klikke her: ',
	        noDataBtn: 'Opprett ordre'
	      },
	      edi: {
	        noDataMsg: 'Vi finner ingen EDI ordre på din konto. Vennligst sjekk igjen senere.'
	      },
	      bill: {
	        noDataMsg: 'Vi finner ingen fakturaer på din konto. Vil du opprette en kan vi gjøre det her: ',
	        noDataBtn: 'Opprett faktura'
	      },
	      supplier: {
	        noDataMsg: 'Du har ikke opprettet noen leverandør ennå. Vil du opprette en kan du gjøre det her: ',
	        noDataBtn: 'Opprett leverandør'
	      },
	      warehouse: {
	        noDataMsg: 'Du har ikke opprettet noe lager ennå. Vil du opprette et lager kan du gjøre det her: ',
	        noDataBtn: 'Opprett lager'
	      },
	      unitOfMeasure: {
	        noDataMsg: "It looks like you have no unit of measures yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Unit of Measures'
	      },
	      stock: {
	        noDataMsg: 'Du har ikke opprettet noe lagertelling ennå. Vil du opprette en lagertelling kan du gjøre det her: ',
	        noDataBtn: 'Opprett lagertelling'
	      },
	      adjustment: {
	        noDataMsg: 'Du har ikke opprettet noe lagerjustering ennå. Vil du opprette en lagerjustering kan du gjøre det her: ',
	        noDataBtn: 'Opprett lagerjustering'
	      },
	      purchase: {
	        noDataMsg: 'Du har ikke opprettet noe innkjøp ennå. Vil du opprette et innkjøp kan du gjøre det her: ',
	        noDataBtn: 'Opprett innkjøp'
	      },
	      transfer: {
	        noDataMsg: 'Du har ikke opprettet noe overføringer ennå. Vil du opprette en overføring kan du gjøre det her: ',
	        noDataBtn: 'Opprett overføring'
	      },
	      productTags: {
	        noDataMsg: 'Du har ikke opprettet noen stikko ennå. Vil du opprette et innkjøp kan du gjøre det her:',
	        noDataBtn: 'Opprett stikkord'
	      },
	      PriceFields: {
	        noDataMsg: "It looks like you have no price field yet? Don't sweat it, we can add one right now simply by clicking here.",
	        noDataBtn: 'Create New Price Field'
	      },
	      exciseEntry: {
	        noDataMsg: 'It looks like you have no Excise entries yet'
	      },
	      material: {
	        noDataMsg: 'Du har ikke opprettet noen materialer ennå. Vil du opprette et kan du gjøre det her: ',
	        noDataBtn: 'Legg til materiale'
	      },
	      batch: {
	        noDataMsg: 'Du har ikke opprettet noen batcher ennå. Vil du opprette en kan du gjøre det her: ',
	        noDataBtn: 'Opprett batch'
	      },
	      recipe: {
	        noDataMsg: 'Du har ikke opprettet noen oppskrifter ennå. Vil du opprette en kan du gjøre det her: ',
	        noDataBtn: 'Legg til oppskrift'
	      },
	      equipment: {
	        noDataMsg: 'Du har ikke lagt inn noe utstyr ennå. Vil du legge til et kan du gjøre det her: ',
	        noDataBtn: 'Legg til utstyr'
	      },
	      productPackaging: {
	        noDataMsg: 'Du har ikke lagt inn noe forpakning ennå. Vil du legge til et kan du gjøre det her: ',
	        noDataBtn: 'Legg til forpakning'
	      },
	      productBundle: {
	        noDataMsg: 'Du har ikke lagt inn noen produktpakke ennå. Vil du legge til en kan du gjøre det her: ',
	        noDataBtn: 'Legg til produktpakke'
	      }
	    },
	    module: {
	      index: {
	        title: 'Modul oversikt'
	      },
	      info: {
	        description: 'Detaljer',
	        name: 'Navn',
	        type: 'Type',
	        group: 'Gruppe',
	        price: 'Pris'
	      },
	      warning: {
	        subscribe: 'Ønsker du å abonnere på denne modulen?',
	        unsubscribe: 'Ønsker du å deaktivere denne modulen?'
	      },
	      error: {
	        vmpError: 'Det oppstod en feil under aktivering av modulen. Sørg for å følge instruksjonene og prøv igjen.'
	      },
	      subscribe: {
	        title: 'Abonnering'
	      },
	      vmp: {
	        intro: 'Før du kan begynne å bruke modulen for synkronisering av produkter med Vinmonopolet, må følgende steg gjennomføres:',
	        step1: '1. Følg beskrivelsen for oppretting av API brukere her:',
	        step2: '2. Legg så til følgende e-post for å gi Kundan tilgang:'
	      },
	      fiken: {
	        intro: 'Ved å klikke "Abonnere" vil du bli videresendt til Fiken for å autorisere integreringen.',
	        fiken_company_slug: {
	          label: 'Velg hvilke selskap i Fiken som skal integreres',
	          placeholder: 'Velg selskap'
	        }
	      },
	      poweroffice: {
	        intro: 'Vår PowerOffice-integrasjon tilbyr 2 typer; "Standard" og "Alternativ".<br><br>Velg "Standard" hvis du ønsker tradisjonell synkronisering av regnskapsdata ved sending av fakturaer fra Kundan. For mer info om "Alternativ" løsning, vennligst kontakt <a href="mailto:support@kundan.no">kundeservice</a> for mer veiledning.'
	      },
	      ehf: {
	        intro: 'Ved abonnering av EHF akepteres følgende betingelser for bruk:',
	        terms: 'Sending av EHF belastes kr. 3,- pr. transaksjon. Faktureres etterskuddsvis månedlig.'
	      },
	      visma: {
	        intro: 'Ved å klikke på "Abonner" vil du bli videresendt til Visma eAccounting for kontoautorisasjon. Du vil bli videresendt tilbake til Kundan når autoriseringen er fullført.'
	      }
	    },
	    exciseEntry: {
	      title: 'Særavgiftsregister',
	      filters: {
	        label: 'Filtre',
	        all: 'Vis',
	        source: {
	          all: 'Vis',
	          order: 'Ordre',
	          creditNote: 'Kreditnota'
	        }
	      },
	      index: {
	        title: 'Særavgiftsoppføringer'
	      },
	      allProduct: 'Alle produkter',
	      table: {
	        productName: 'Produkt',
	        flag: 'Status',
	        qty: 'Antall',
	        volume: 'Volum',
	        abv: 'ABV (%)',
	        liter: 'Liter',
	        exciseType: 'Type',
	        exciseGroup: 'Avgiftsgruppe',
	        exciseBasic: 'Grunnavgift',
	        excisePackaging: 'Miljøavgift',
	        excisableType: 'Kildetype',
	        createdAt: 'Dato',
	        additionalCode: 'Tilleggskode',
	        exciseAdditionalCode: 'Tilleggskode'
	      },
	      export: 'Eksporter',
	      update: {
	        success: 'Oppdatering vellykket!'
	      }
	    },
	
	    wooProducts: {
	      attributes: {
	        abv: 'ABV',
	        beer_style: 'Beer Style',
	        country: 'Country',
	        ebu: 'EBU',
	        ibu: 'IBU',
	        packaging_material: 'Packaging Material',
	        packaging_type: 'Packaging Type',
	        producer: 'Producer',
	        quantity_in_crate: 'Quantity in Crate',
	        region: 'Distrikt',
	        sub_region: 'Underdistrikt',
	        volum: 'Volum',
	        weight: 'Weight',
	        free_of_alcohol: 'Alkoholfri',
	        free_or_low_on_gluten: 'Glutenfri',
	        sugar: 'Sugar',
	        acid: 'Acid',
	        fullness: 'Fullness',
	        freshness: 'Freshness',
	        tannins: 'Tannins',
	        bitterness: 'Bitterness',
	        sweetness: 'Sødme',
	        colour: 'Colour',
	        odour: 'Odour',
	        taste: 'Taste',
	        storage_potential: 'Storage Potential',
	        ingredients: 'Ingredienser',
	        organic: 'Organic',
	        biodynamic: 'Biodynamic',
	        locally_produced: 'Locally Produced',
	        environmentally_smart: 'Environmentally Smart',
	        kosher: 'Kosher',
	        recommended_with: 'Recommended With'
	      }
	    },
	
	    materials: {
	      title: 'Materialer',
	      filters: {
	        title: 'Materialer',
	        active: 'Aktive',
	        deactivated: 'Deaktive',
	        all: 'Vis alle'
	      },
	      index: {
	        title: 'Materialer'
	      },
	      create: {
	        title: 'Legg til materialer',
	        success: 'Oppretting vellykket'
	      },
	      edit: {
	        title: 'Rediger material',
	        success: 'Oppdatering vellykket'
	      },
	      formTabs: {
	        materialInformation: 'Materialinformasjon'
	      },
	      table: {
	        id: 'ID',
	        name: 'Navn',
	        description: 'Beskrivelse'
	      },
	      types: {
	        malt: 'Malt',
	        hops: 'Humle',
	        yeast: 'Gjær',
	        sugar: 'Sukker',
	        various: 'Diverse',
	        packaging: 'Forpakning',
	        label: 'Etikett',
	        capsuleOrCork: 'Kapsel eller kork',
	        cratesAndBoxes: 'Kasser og esker'
	      },
	      unitOfMeasures: {
	        gram: 'Gram',
	        kilogram: 'Kilo',
	        milliliter: 'Milliliter',
	        liter: 'Liter',
	        piece: 'Stykk'
	      }
	    },
	
	    batches: {
	      title: 'Batcher',
	      filters: {
	        title: 'Batcher',
	        notStarted: 'Ikke startet',
	        upcoming: 'Planlagt',
	        ongoing: 'Pågår',
	        completed: 'Fullført',
	        all: 'Vis alle'
	      },
	      index: {
	        title: 'Batcher'
	      },
	      create: {
	        title: 'Opprett batch',
	        success: 'Oppretting vellykket'
	      },
	      edit: {
	        title: 'Rediger batch',
	        success: 'Oppdatering vellykket'
	      },
	      logs: {
	        add: 'Ny loggoppføring'
	      },
	      view: {
	        title: 'Vis batch',
	        status: 'Status',
	        recipe: 'Oppskrift',
	        estimated: 'Estimert',
	        startDate: 'Dato startet',
	        endDate: 'Dato avsluttet',
	        plannedStartingDate: 'Planlagt startdato',
	        bestBeforeDate: 'Best før dato',
	        upcomingProcedures: 'Kommende prosedyrer',
	        ongoingProcedures: 'Pågående prosedyre',
	        completedProcedures: 'Fullført prosedyrer',
	        createBatchTransfer: 'Tappe / overfør til lager',
	        startBatch: {
	          title: 'Start batch',
	          confirm: 'Når du starter batchen trekkes alle råvaremengdene spesifisert i oppskriften fra material varelageret. Ønsker du å fortsette?',
	          success: 'Batch startet',
	          stockError: 'Følgende materialer har ikke nok på lagre til å starte batchen',
	          stockErrorOptions: {
	            adjustQty: 'Juster mengde ingredienser',
	            addNew: 'Legg til nye lignende ingredienser',
	            purchaseOrder: 'Opprett innkjøpsordre',
	            stockAdjustment: 'Opprett lagerjustering'
	          }
	        },
	        completeBatch: {
	          title: 'Fullfør batch',
	          confirmButton: 'OK, fullfør batch',
	          confirm: 'Alle ingredienser spesifisert i opp oppskriften vil bli trukket fra lager. Ønsker du å fortsette?',
	          success: 'Batch fullført',
	          stockError: 'Følgende ingredienser er i manko for å kunne fullføre batchen:',
	          stockErrorOptions: {
	            adjustQty: 'Juster mengden ingredienser',
	            addNew: 'Bytt ut ingredienser',
	            purchaseOrder: 'Gjør en innkjøp',
	            stockAdjustment: 'Gjør en lagerjustering'
	          }
	        },
	        deductIngredience: {
	          confirmButton: 'OK',
	          cancelButton: 'Utsett',
	          stockError: 'Følgende ingredienser har ikke nok mengder på lager:',
	          deductAll: {
	            title: 'Trekk alle ingredienser',
	            message: 'Ønsker du å trekke alle ingredienser fra lager?',
	            button: 'Trekk alle fra lager',
	            confirmButton: 'Trekk alle'
	          }
	        },
	        startProcedure: {
	          confirm: 'All materials amounts specified in this procedure will be deducted from the material warehouse. Do you wish to continue?'
	        }
	      },
	      formTabs: {
	        batchInformation: 'Batchinformasjon',
	        edit: 'Rediger',
	        details: 'Detaljer',
	        materials: 'Materialer',
	        log: 'Logg'
	      },
	      statuses: {
	        planned: 'Planlegg batch',
	        started: 'Start ny batch',
	        ongoing: 'Pågående',
	        completed: 'Fullført batch'
	      },
	      table: {
	        name: 'Navn',
	        batchNumber: 'Batch nummer',
	        status: 'Status'
	      }
	    },
	
	    recipes: {
	      title: 'Oppskrifter',
	      filters: {
	        title: 'Oppskrifter',
	        all: 'Vis alle'
	      },
	      index: {
	        title: 'Oppskrifter'
	      },
	      create: {
	        title: 'Legg til oppskrift',
	        success: 'Successfully Created'
	      },
	      edit: {
	        title: 'Rediger oppskrift',
	        success: 'Oppretting vellykket',
	        ingrediences: 'Ingredienser',
	        procedures: 'prosedyrer',
	        equipment: 'Utstyr',
	        addProcedure: 'Legg til prosedyre',
	        editProcedure: 'Rediger prosedyre',
	        step: 'Steg'
	      },
	      types: {
	        beer: 'Øl',
	        wine: 'Vin',
	        cider: 'Sider',
	        liquor: 'Brennevin',
	        water: 'Vann'
	      },
	      formTabs: {
	        recipeInformation: 'Oppskrift informasjon',
	        ingrediencesAndProcedures: 'Ingredienser og prosedyrer',
	        products: 'Produkter'
	      }
	    },
	
	    recipeIngrediences: {
	      index: {
	        confirmDelete: 'Dette vil slette ingrediensene i oppskriften. Vil du fortsette?',
	        confirmDeleteTitle: 'Slett oppskrift ingredienser'
	      }
	    },
	
	    equipments: {
	      title: 'Utstyr',
	      filters: {
	        title: 'Utstyr',
	        all: 'Vis alle'
	      },
	      index: {
	        title: 'Utstyr'
	      },
	      create: {
	        title: 'Legg til utstyr',
	        success: 'Successfully Created'
	      },
	      edit: {
	        title: 'Rediger utstyr',
	        success: 'Oppretting vellykket'
	      },
	      formTabs: {
	        equipmentInformation: 'Utstyr informasjon'
	      },
	      table: {
	        name: 'Navn',
	        status: 'Status'
	      }
	    },
	
	    members: {
	      title: 'Brukere',
	      index: {
	        products: 'Produkter',
	        addProduct: 'Legg til produkt',
	        addMember: 'Legg til bruker',
	        tab: {
	          members: 'Brukere',
	          calendarSchedule: 'Kalenderplan'
	        },
	        table: {
	          members: {
	            firstName: 'Fornavn',
	            lastName: 'Etternavn',
	            email: 'Epost',
	            title: 'Title',
	            color: 'Farge',
	            status: 'Status',
	            view: 'Vis'
	          }
	        },
	        dialog: {
	          cancel: 'Avbryt',
	          update: 'Oppdater',
	          add: 'Legg til',
	          addMember: {
	            title: 'Legg til bruker',
	            firstName: 'Fornavn',
	            lastName: 'Etternavn',
	            email: 'Epost'
	          },
	          addBooking: {
	            showOrder: 'Vis ordre',
	            title: 'Legg til avtale',
	            selectProduct: 'Velg tjeneste',
	            selectPractitioner: 'Velg behandler',
	            selectClient: 'Velg kunde'
	          }
	        },
	        options: {
	          businessHours: 'Arbeidstimer',
	          booking: 'Avtaler'
	        },
	        calendar: {
	          today: 'I dag'
	        }
	      },
	      show: {
	        products: 'Produkter',
	        addProduct: 'Legg til produkt',
	        addMember: 'Add Member',
	        deleteMember: 'Slett bruker',
	        addHour: 'Legg til tid',
	        options: {
	          start: 'Start',
	          end: 'Slutt'
	        },
	        table: {
	          product: {
	            name: 'Produkt',
	            price: 'Pris',
	            duration: 'Varighet'
	          }
	        },
	        dialog: {
	          cancel: 'Avbryt',
	          delete: 'Slett',
	          add: 'Legg til',
	          addProduct: {
	            title: 'Legg til produkt'
	          },
	          deleteMember: {
	            title: 'Legg til avtale',
	            text: 'Ønsker du å slette brukeren'
	          },
	          deleteMemberProduct: {
	            title: 'Legg til avtale',
	            text: 'Ønsker du å fjerne denne tjenesten fra valgt behandler?'
	          }
	        }
	      }
	    },
	
	    account: {
	      toggleDebugMode: 'Toggle Debug Mode',
	      confirmDebugMode: 'Are you sure you want to toggle debug mode?',
	      onDebugMode: 'Debug mode turned on',
	      offDebugMode: 'Debug mode turned off',
	      switchOrganization: 'Endre organisasjon',
	      confirmSwitchOrganization: 'Ønsker du å bytte organisasjon?',
	      switchingOrganizationMessage: 'Logger inn på ny konto... Vennligst vent'
	    },
	
	    home: {
	      welcomeMsg: "Bli itj fart ut'n bart!"
	    },
	
	    accountSetup: {
	      title: 'Opprett konto',
	      termsError: 'Du må lese og akseptere våre betingelser før registrering.',
	      crm: 'Customer Relationship Management(CRM)',
	      invoicing: 'Order and Invoicing',
	      edi: 'Electronic Data Interchange (EDI)',
	      booking: 'Online Booking',
	      headerMessage1: 'Your',
	      headerMessage2: 'account has been created. We sent you an email together with your password. Please let us know who you are..'
	    },
	
	    emailSetup: {
	      title: 'La oss komme i gang! Hva er din epost adresse?',
	      emailExistSuggestion: 'Epost adressen er allerede i bruk. Ønsker du å logge inn i stede?',
	      crm: 'Kundan System (CMR) ?',
	      invoicing: 'Faktura System ?',
	      edi: 'EDI system!',
	      booking: 'Booking System ?',
	      headerMessage1: 'Prøv vårt unike ',
	      headerMessage2: 'Fyll inn din info, og du er straks i gang!',
	      termsError: 'Du må lese våre betingelser før registrering.'
	    },
	
	    personalInfo: {
	      title: 'Personlig informasjon.'
	    },
	
	    registerDone: {
	      title: 'Vellykket registrering!',
	      firstParagraph: 'Din konto er opprettet.',
	      secondParagraph1: 'Gratulerer, du er nå registrert for 14 dagers prøveperiode. En epost med bekreftelseslink er sendt til deg. Om du ikke mottar den i løpet av få minutter, klikk ',
	      secondParagraph2: 'her',
	      secondParagraph3: 'så vil vi sende den til deg igjen.',
	      error: 'Kunne ikke sende linken, vennligst kontakt oss om problemet fortsetter.',
	      confirmationResent: 'En epost bekreftelse har blitt sendt på nytt.'
	    },
	
	    login: {
	      title: 'Logg inn',
	      newUser: 'Ny bruker?',
	      forgotPassword: 'Glemt passord?',
	      errorBoxTitle: 'Feil login, vennligst prøv igjen!',
	      inactiveAccount: 'Abonnementet er avsluttet, vennligst kontakt kundestøtte'
	    },
	
	    resetPassword: {
	      title: 'Lag nytt passord',
	      firstParagraph: 'Vi sender deg en epost med link for hvordan lage nytt passord.',
	      successMessage: 'En epost har blitt sendt til din adresse. Vennligst sjekk denne for å lage nytt passord.'
	    },
	
	    smsTwoFactorVerification: {
	      title: 'SMS tofaktorautentisering',
	      enabled: 'Aktivert',
	      verificationCodeSent: 'Bekreftelseskoden er sendt til mobilnummeret ditt',
	      successMessage: 'Bekreftet kode',
	      verificationCodeIncorrect: 'Koden du skrev inn er feil',
	      enableWarningMessage: 'Slik aktiverer du SMS-tofaktorautentisering på kontoen din: <br/> <br/> 1. Skriv inn mobilnummeret ditt og klikk Send kode. <br/> 2. Angi bekreftelseskoden du mottok.',
	      verifyMobileNUmber: 'Bekreft mobilnummeret ditt',
	      enterMobileNUmber: 'Angi mobilnummer',
	      sendCode: 'Send kode',
	      resendCode: 'Send kode på nytt',
	      codeVerification: 'Kodeverifisering',
	      enterToken: 'Skriv inn kode',
	      verifyCode: 'Bekreft kode',
	      invalidMobileNumber: 'Mobilnummeret du oppga er ugyldig.',
	      requiredMobileNumber: 'Skriv inn mobilnummeret ditt.',
	      unableToSendVerification: 'Kan ikke sende bekreftelseskode',
	      smsTwoFactorAuthEnabled: 'SMS tofaktorautentisering er aktivert på kontoen din.',
	      google2faEnabledWarning: 'Googles tofaktorautentisering er for øyeblikket aktivert på kontoen din, bare en tofaktorautentiseringsmodul kan aktiveres om gangen.'
	    },
	
	    googleTwoFactorVerification: {
	      title: 'Googles tofaktorautentisering',
	      enabled: 'Aktivert',
	      successMessage: 'Bekreftet kode.',
	      verificationCodeIncorrect: 'Koden du skrev inn er feil',
	      enableWarningMessage: 'Slik aktiverer du Google Two Factor Autentication på kontoen din: <br/> <br/> <b> 1. Skann QR-koden nedenfor med Google Authenticator App. <br/> 2. Skriv inn bekreftelseskoden, og klikk Bekreft kode. </b>',
	      codeVerification: 'Bekreftelseskode',
	      enterToken: 'Skriv inn kode',
	      verifyCode: 'Bekreft kode',
	      smsTwoFactorAuthEnabled: 'Google tofaktorautentisering er aktivert på kontoen din.',
	      sms2faEnabledWarning: 'SMS tofaktorautentisering er for øyeblikket aktivert på kontoen din, bare en tofaktorautentiseringsmodul kan aktiveres om gangen.'
	    },
	
	    dashboard: {
	      title: 'Kontrollpanel',
	      emailConfirmationTitle: 'Før du går videre må du bekrefte eposten din',
	      emailConfirmationText1: 'Før vi gir deg tilgang til å bruke kontoen trenger vi at du bekrefter epost adressen din. Dette gjør vi for å sikre at ingen uvedkommende registrerer seg med din epost adresse.',
	      emailConfirmationText2: 'Alt du trenger å gjøre er å sjekke epost kontoen din og åpne eposten vi har sendt deg. (Husk å sjekke spam/søppel mappa hvis du ikke finner eposten).',
	      emailConfirmationText3: 'I eposten følger du enkelt bekrivelsen og klikker på lenken for å bekrefte din registrering. Du finner også ditt passord for å logge inn på Kundan i denne eposten.',
	      emailConfirmationText4: 'PS! Hvis du av en eller annen grunn ikke finner eposten vi har sendt deg, kan du alltids få tilsendt eposten på nytt ved å klikke på lenken under:',
	      emailConfirmationResendButton: 'Klikk her for å sende meg en ny bekreftelses-epost',
	      emailConfirmationResendLoading: 'Sender epost... vennligst vent!',
	      emailConfirmationResent: 'Ny epost har nå blitt sendt!',
	      emailConfirmationText5: 'PS! Det kan ta noen minutter før eposten dukker opp. Nøl ikke med å kontakt oss hvis problemer oppstår underveis',
	      emailConfirmationResentWarning: 'Verifiserings-epost sendt. Vennligst sjekk eposten din.',
	      emailConfirmationResentError: 'Vi kunne dessverre ikke sende verifiserings-eposten akkurat nå, vennligst prøv igjen senere eller ta kontakt med support hvis problemet ikke løser seg.',
	      expiredSubscriptionWarning: 'Ditt abonnement har utløpt. Vennligst forny eller velg et abonnement som er mer passende.',
	      updateInformation: 'Vennligst oppdater følgende felter.',
	      fieldsMissing: 'Felt mangler',
	      completed: 'FULLFØRT',
	      accountInformation: 'Kontoinformasjon',
	      organizationSettings: 'Firma innstillinger',
	      addWidgetBtn: 'Legg til widget'
	    },
	
	    bulkProductAdd: {
	      emptySelectionError: 'Legg til minst én vare!',
	      saveError: 'Kunne ikke lagre. Sjekk detaljene og prøv igjen.'
	    },
	    bulkAddProducts: {
	      selectedProducts: {
	        title: 'Valgte produkter',
	        noneSelected: 'Ingen produkter valgt',
	        productName: 'Produkt',
	        productQty: 'Antall',
	        unitTypeId: 'Enhet',
	        unitQty: 'Antall',
	        qty: 'Total',
	        available: 'Lagerantall'
	      },
	      findProducts: {
	        search: 'Skriv inn produktnavn...'
	      }
	    },
	
	    supplier: {
	      index: {
	        title: 'Leverandør'
	      },
	      filters: {
	        title: 'Leverandører',
	        today: 'I dag',
	        all: 'Alle'
	      },
	      create: {
	        title: 'Opprett leverandør',
	        success: 'Leverandør opprettet!'
	      },
	      update: {
	        title: 'Oppdater leverandør',
	        success: 'Leverandør oppdatert!'
	      },
	      edit: {
	        supplier: 'Leverandør'
	      },
	      info: {
	        phone: 'Telefon',
	        email: 'Epost',
	        code: 'Kode',
	        name: 'Navn',
	        streetName1: 'Adresse',
	        streetName2: 'Adresse 2',
	        country: 'Land',
	        city: 'By'
	      }
	    },
	
	    warehouse: {
	      index: {
	        title: 'Varelager'
	      },
	      transactionNavigation: {
	        addTransaction: 'Opprett transaksjon',
	        stockCount: 'Lagertelling',
	        stockAdjustment: 'Lagerjustering',
	        transfer: 'Overføring',
	        purchase: 'Innkjøp'
	      },
	      filters: {
	        title: 'Varelager',
	        today: 'I dag',
	        all: 'Alle',
	        view: 'Vis varelager'
	      },
	      create: {
	        title: 'Opprett lager',
	        success: 'Varelager opprettet!'
	      },
	      update: {
	        title: 'Oppdater lager',
	        success: 'Varelager oppdatert!'
	      },
	      cancel: {
	        title: 'Kanseller innkjøp',
	        success: 'Innkjøp kansellert',
	        error: 'En feil oppsto under kansellering'
	      },
	      pending: {
	        title: 'Innkjøp på vent',
	        success: 'Innkjøp oppdatert',
	        error: 'Feil ved innkjøp'
	      },
	      edit: {
	        supplier: 'Varelager'
	      },
	      addTransaction: {
	        title: 'Opprett transaksjon'
	      },
	      info: {
	        location: 'Sted',
	        name: 'Navn',
	        isBonded: '(Tollager / Ubeskattede varer)',
	        notBonded: '(Beskattede varer)',
	        type: 'Type',
	        locked: ' (låst)'
	      },
	      formTabs: {
	        products: 'Produkter',
	        transactions: 'Transaksjoner'
	      },
	      products: {
	        noDataMsg: 'Ingen produkter funnet på lager',
	        name: 'Produktnavn',
	        batchName: 'Batch',
	        qty: 'Lagermengde',
	        minimumStockLevel: 'Minimum lagerbehov',
	        producer: 'Produsent',
	        hideOutOfStock: 'Skjul utsolgte produkter',
	        bulkDestroyProducts: 'Destruer produkter'
	      },
	      transactions: {
	        noDataMsg: 'Ingen transaksjoner registrert',
	        table: {
	          qty: 'Antall',
	          via: 'Type',
	          code: 'Nummer',
	          createdAt: 'Dato',
	          id: 'ID #',
	          productName: 'Produkt',
	          beforeqty: 'Før',
	          totalQty: 'Antall',
	          afterqty: 'Etter',
	          status: 'Status',
	          client: 'Kunde',
	          warehouse: 'Varelager',
	          billingNumber: 'Faktura',
	          batchName: 'Parti'
	        },
	        filter: {
	          transactionType: [{
	            value: 'all',
	            label: 'Alle transaksjonstype'
	          }, {
	            value: 'SO',
	            label: 'Salgsordre'
	          }, {
	            value: 'PO',
	            label: 'Innkjøpsordre'
	          }, {
	            value: 'PA',
	            label: 'Innkjøpsordre justert'
	          }, {
	            value: 'SC',
	            label: 'Lagertelling'
	          }, {
	            value: 'AJ',
	            label: 'Lagerjustering'
	          }, {
	            value: 'TW',
	            label: 'Overføring mellom lager'
	          }, {
	            value: 'TB',
	            label: 'Fra batch'
	          }, {
	            value: 'TL',
	            label: 'Overføring fra annen bevillingshaver'
	          }, {
	            value: 'RS',
	            label: 'Retur av salg'
	          }, {
	            value: 'OC',
	            label: 'Ordre kansellering'
	          }, {
	            value: 'BI',
	            label: 'Batch ingredienser'
	          }, {
	            value: 'PD',
	            label: 'Destruksjon'
	          }, {
	            value: 'TC',
	            label: 'Korrigering'
	          }]
	        }
	      }
	    },
	    unitOfMeasure: {
	      index: {
	        title: 'Unit of Measures'
	      },
	      filters: {
	        title: 'Unit of Measures',
	        today: 'Today',
	        all: 'All'
	      },
	      create: {
	        title: 'Create Unit of Measures',
	        success: 'Successfully Created'
	      },
	      update: {
	        title: 'Update Unit of Measures',
	        success: 'Successfully Updated'
	      },
	      edit: {
	        supplier: 'Unit of Measures'
	      },
	      info: {
	        code: 'Kode',
	        qty: 'Antall',
	        warehouse: 'Lagersted',
	        supplier: 'Leverandør',
	        createdAt: 'Opprettet dato',
	        name: 'Navn',
	        comments: 'Kommentar',
	        status: 'Status',
	        receiveDate: 'Mottatt dato'
	      }
	    },
	
	    stock: {
	      noData: 'Ingen data funnet.',
	      index: {
	        title: 'Lagertelling'
	      },
	      filters: {
	        title: 'Vis lagertelling',
	        create: 'Opprett lagertelling',
	        all: 'Alle'
	      },
	      create: {
	        title: 'Opprett lagertelling',
	        success: 'Oppretting vellykket'
	      },
	      draft: {
	        success: 'Successfully save draft'
	      },
	      view: {
	        title: 'Lagertelling',
	        details: 'Generell',
	        products: 'Produktliste',
	        productsLegend: 'Produkttabell',
	        adjustment: 'Korrigeringsliste',
	        adjustmentLegend: 'Korrigeringstabel',
	        detailsLegend: 'Lager detaljer'
	      },
	      info: {
	        code: 'Kode',
	        qty: 'Total mengde',
	        warehouse: 'Lagersted',
	        createdAt: 'Dato opprettet',
	        transactionDate: 'Transaksjonsdato',
	        name: 'Navn',
	        status: 'Status'
	      },
	      products: {
	        sku: 'ID',
	        name: 'Produktnavn',
	        physicalCount: 'Ny beholdning',
	        currentCount: 'Lagerbeholdning',
	        variance: 'Forskjell (+/-)'
	      }
	    },
	
	    purchase: {
	      noData: 'Ingen data funnet.',
	      index: {
	        title: 'Innkjøp'
	      },
	      filters: {
	        title: 'Vis innkjøp',
	        create: 'Opprett innkjøp',
	        all: 'Alle'
	      },
	      create: {
	        title: 'Opprett innkjøp',
	        success: 'Vellykket oppretting av innkjøp',
	        unfinished: 'Ikke fullført'
	      },
	      update: {
	        title: 'Oppdater innkjøp',
	        success: 'Vellykket oppdatering av innkjøp',
	        error: 'En feil oppstod under oppdatering'
	      },
	      cancel: {
	        title: 'Kanseller innkjøp',
	        success: 'Kansellering vellykket',
	        error: 'En feil oppstod under kansellering'
	      },
	      pending: {
	        title: 'Innkjøp til behandling',
	        success: 'Oppdatering vellykket',
	        error: 'Feil ved oppdatering'
	      },
	      view: {
	        title: 'Innkjøp',
	        details: 'Lagerdetaljer',
	        products: 'Produktliste',
	        productsLegend: 'Produkttabell',
	        adjustment: 'List of Adjustment',
	        adjustmentLegend: 'Adjustment Table',
	        detailsLegend: 'Innkjøpsdetaljer',
	        documentBtnDropdown: 'Dokument',
	        sendPurchaseDocument: 'Send innkjøpsdokument',
	        downloadPurchaseDocument: 'Last ned innkjøpsdokument'
	      },
	      info: {
	        code: 'Kode',
	        qty: 'Antall',
	        warehouse: 'Lagersted',
	        supplier: 'Leverandør',
	        createdAt: 'Dato opprettet',
	        name: 'Navn',
	        comments: 'Kommentar',
	        status: 'Status',
	        receiveDate: 'Dato mottatt'
	      },
	      products: {
	        sku: 'ID',
	        name: 'Produktnavn',
	        qty: 'Antall',
	        qtyReceive: 'Antall mottatt',
	        qtyDamage: 'Antall ødelagt/manko',
	        purchasePrice: 'Innkjøpspris',
	        costPrice: 'Kostpris',
	        notes: 'Notat'
	      },
	      status: {
	        draft: 'Utkast',
	        progress: 'Under behandling',
	        cancelled: 'Kansellert',
	        done: 'Fullført',
	        unfinished: 'Ikke fullført',
	        pending_external: 'Venter ekstern godkjenning',
	        pending: 'Venter'
	      }
	    },
	
	    inventory: {
	      title: 'Produkter',
	      transaction: {
	        title: 'Transaksjoner'
	      },
	      products: {
	        create: 'Opprett produkt',
	        view: 'Vis produkter'
	      }
	    },
	
	    adjustment: {
	      noData: 'Ingen data funnet.',
	      index: {
	        title: 'Lagerjustering'
	      },
	      filters: {
	        title: 'Vis lagerjustering',
	        create: 'Opprett lagerjustering',
	        all: 'Alle'
	      },
	      create: {
	        title: 'Opprett lagerjustering',
	        success: 'Oppretting vellykket'
	      },
	      view: {
	        title: 'Lagerjustering',
	        details: 'Justeringsdetaljer',
	        products: 'Produkter',
	        productsLegend: 'Produktoversikt',
	        adjustment: 'List of Adjustment',
	        adjustmentLegend: 'Adjustment Table',
	        detailsLegend: 'Adjustment Details'
	      },
	      info: {
	        code: 'Kode',
	        qty: 'Antall',
	        stock: 'Beholdning',
	        warehouse: 'Lagersted',
	        createdAt: 'Dato opprettet',
	        reason: 'Årsak',
	        status: 'Status',
	        adjustmentType: 'Justeringstype'
	      },
	      products: {
	        sku: 'ID',
	        name: 'Produktnavn',
	        qty: 'Antall',
	        exciseAdditionalCode: 'Tilleggskode'
	      },
	      draft: {
	        deleteMessage: 'Ønsker du å slett lagerjusteringen?'
	      },
	      statuses: {
	        adjustment: 'Standardjustering',
	        wastage: 'Mankojustering',
	        destruction: 'Destruksjon'
	      }
	    },
	
	    transfer: {
	      noData: 'Ingen data funnet.',
	      index: {
	        title: 'Overføring'
	      },
	      filters: {
	        title: 'Vis overføring',
	        create: 'Opprett overføring',
	        all: 'Alle'
	      },
	      create: {
	        title: 'Opprett overføring',
	        success: 'Oppretting vellykket',
	        button: 'Fullfør overføring'
	      },
	      view: {
	        title: 'Overføring',
	        details: 'Overføringsdetaljer',
	        products: 'Produkter',
	        productsLegend: 'Produkter',
	        adjustment: 'List of Adjustment',
	        adjustmentLegend: 'Adjustment Table',
	        detailsLegend: 'Overføringsdetaljer'
	      },
	      info: {
	        code: 'Kode',
	        qty: 'Antall',
	        stock: 'Beholdning',
	        fromWarehouse: 'Fra lager',
	        toWarehouse: 'Til lager',
	        createdAt: 'Dato opprettet',
	        reason: 'Årsak',
	        status: 'Status'
	      },
	      products: {
	        sku: 'ID',
	        name: 'Produktnavn',
	        qty: 'Antall'
	      },
	      draft: {
	        deleteMessage: 'Ønsker du å slett overføringen?'
	      }
	    },
	
	    reports: {
	      downloadReport: 'Last ned rapport',
	      exciseEntryLabel: 'Oppføringer',
	      noData: 'Ingen data funnet på denne perioden.',
	      clients: {
	        title: 'Kunderapport',
	        client: 'Kunde',
	        id: 'ID',
	        balance: 'Balanse (kr)',
	        createdAt: 'Opprettet dato',
	        turnover: {
	          groupButton: 'Omsetning',
	          viewTurnover: 'Vis omsetningsrapport',
	          downloadTurnover: 'Last ned omsetningsrapport',
	          emailTurnover: 'Send omsetningsrapport',
	          bulk: {
	            title: 'Bulksending av omsetningsrapport',
	            processing: 'Behandler...',
	            clients: 'Valgte kunder',
	            noDataSelectedClient: 'Vennligst vent mens vi zipper filen for deg. De listet under vil ikke bli inkludert i zip-fil.',
	            noDataAllSelectedClient: 'Ingen omsetningsdata funnet på de valgte kundene.',
	            yearOf: 'Periode'
	          }
	        },
	        clientSearch: {
	          placeholder: 'f.eks. navn eller kundenummer'
	        }
	      },
	      warehouse: {
	        warehouse_beta: 'Lagerrapport Beta',
	        warehouse: 'Lagerrapport',
	        all: 'Alle lagre',
	        transactionType: {
	          all: 'Alle transaksjonstype',
	          groupByProduct: 'Grupper produkter'
	        },
	        warehouse_required: 'Vennligst velg et lager',
	        month_required: 'Velg en måned',
	        as_of_date: 'Per dato',
	        date_range: 'Datointervall',
	        pick_date: 'Velg dato'
	      },
	      greenDot: {
	        detailed: {
	          downloadDetailedReport: 'Last ned detaljert rapport'
	        }
	      },
	      exciseEntry: {
	        title: 'Avgifter',
	        dateRange: {
	          placeholder: 'Velg en dato'
	        },
	        table: {
	          group: 'Gruppe',
	          description: 'Forklaring',
	          totalQuantity: 'Summert antall',
	          totalVolume: 'Summert volum',
	          unitType: 'Enhetstype',
	          exciseEntries: 'Oppslag',
	          product_name: 'Produkt',
	          product_volume: 'Volum',
	          order_id: 'Ordre ID',
	          quantity: 'Antall',
	          created_at: 'Dato opprettet',
	          excisable_id: 'Kilde',
	          order_customer_name: 'Kunde',
	          receiverName: 'Navn'
	        }
	      },
	      sales: {
	        title: 'Ordrerapport',
	        export: 'Last ned i Excel',
	        exportYtd: 'Last ned HIÅ rapport',
	        dateRange: {
	          placeholder: 'Velg periode',
	          placeholderStart: 'Startdato',
	          placeholderEnd: 'Sluttdato'
	        },
	        group: {
	          placeholder: 'Velg filter',
	          names: {
	            orders: 'Ordre',
	            clients: 'Kunder',
	            products: 'Produkter'
	          }
	        },
	        id: 'ID',
	        status: 'Status',
	        name: 'Navn',
	        sales: 'Salg (kr)',
	        credit: 'Kreditt (kr)',
	        total: 'Balanse (kr)',
	        clearedInvoices: 'Fakturert (kr)',
	        clearedCredit: 'Kreditert (kr)'
	      },
	
	      aggregatedSales: {
	        title: 'Aggregert salgsrapport',
	        export: 'Last ned Excel',
	        includeCancelled: 'Inkl. kansellerte',
	        dateRange: {
	          placeholder: 'Velg periode'
	        },
	        groupBy: {
	          placeholder: 'Grupper etter',
	          product: 'Produkt',
	          client: 'Kunde',
	          clientType: 'Kundetype',
	          month: 'Måned',
	          year: 'År'
	        },
	        sort: {
	          placeholder: 'Sorter etter',
	          revenueDesc: 'Omsetning (høy → lav)',
	          revenueAsc: 'Omsetning (lav → høy)',
	          volumeDesc: 'Volum (høy → lav)',
	          volumeAsc: 'Volum (lav → høy)'
	        },
	        columns: {
	          productName: 'Produkt',
	          productNumber: 'Produktnr.',
	          clientName: 'Kunde',
	          clientNumber: 'Kundenr.',
	          clientTypeName: 'Kundetype',
	          period: 'Periode',
	          totalRevenueNet: 'Omsetning netto (kr)',
	          totalRevenueGross: 'Omsetning brutto (kr)',
	          totalVolumeLiters: 'Volum (liter)',
	          orderCount: 'Antall ordre',
	          totalQuantityUnits: 'Antall enheter'
	        },
	        statuses: {
	          label: 'Ordrestatus',
	          placeholder: 'Tom = standard (bekreftet, sendt, levert, fakturert)',
	          options: {
	            confirmed: 'Bekreftet',
	            shipped: 'Sendt',
	            delivered: 'Levert',
	            invoiced: 'Fakturert',
	            created: 'Opprettet',
	            cancelled: 'Kansellert'
	          }
	        },
	        summary: {
	          totalRevenueNet: 'Netto omsetning',
	          totalVolumeliters: 'Totalt volum',
	          orderCount: 'Antall ordre'
	        },
	        metrics: {
	          label: 'Vis kolonner'
	        }
	      },
	
	      bills: {
	        title: 'Fakturarapport',
	        export: 'Last ned Excel',
	        invoiceNumber: 'Faktura #',
	        billTypeName: 'Type',
	        status: 'Status',
	        invoiceDate: 'Fakturadato',
	        dueDate: 'Forfallsdato',
	        customer: 'Kunde',
	        email: 'Epost',
	        address: 'Adresse',
	        sum: 'Sum',
	        vat: 'MVA',
	        invoiceAmount: 'Fakturabeløp',
	        paidAmount: 'Betalt beløp',
	        dueAmount: 'Å betale',
	        balance: 'Balanse',
	        draft: 'Kladd',
	        pending: 'Venter',
	        sent: 'Sendt',
	        sending: 'Sender',
	        cleared: 'Betalt',
	        partlypaid: 'Delbetalt',
	        cancelled: 'Kreditert',
	        total: 'Total',
	        allClients: 'Alle kunder',
	        cash: 'Kontanter',
	        banktransfer: 'Bankoverføring',
	        paid: 'Betalt',
	        due: 'Grunn'
	      },
	      fees: {
	        skatteetaten: {
	          title: 'Skatteetaten',
	          due_info: 'Forfall 18. hver mnd.'
	        },
	        helsedir: {
	          title: 'Helsedirektoratet',
	          due_info: 'Forfall 18. hver mnd.'
	        },
	        brod: {
	          title: 'Bryggeriforeningen',
	          due_info: 'Forfall 18. hver mnd.'
	        },
	        infinitum: {
	          title: 'Infinitum',
	          due_info: 'Forfall 7. hver mnd.'
	        },
	        title: 'Avgiftsrapport',
	        export: 'Last ned i Excel',
	        exportCsv: 'Last ned Elsær',
	        filter: 'Filter',
	        orderNumber: 'Order #',
	        client: 'Kunde',
	        excisable: 'Avgiftsberegning',
	        productType: 'Varetype',
	        internalItemNumber: 'Varenr.',
	        externalItemNumber: 'VMP varenr.',
	        productName: 'Varenavn',
	        producerName: 'Produsent',
	        vintage: 'Årgang',
	        alcoholPercentage: 'Alkohol (%)',
	        bottleVolume: 'Flaskevolum (ℓ)',
	        packagingType: 'Emballasjetype',
	        corkType: 'Korktype',
	        isTaxable: 'Avgiftsberegning',
	        numberOfBottlesSold: 'Antall flasker',
	        numberOfLitersSold: 'Antall liter',
	        all: 'Alle kunder',
	        orderProducts: 'Bestillinger',
	        order_id: 'Bestillings ID',
	        quantity_confirmed: 'Mengde',
	        order_date: 'Dato bestilt',
	        client_name: 'Klientens navn',
	        number: 'Ordrenummer',
	        month_placeholder: 'Velg en måned',
	        readyToCloseWarning: 'Denne perioden er nå klar for lukking. Klikk på knappen under for å låse perioden og for å kunne laste ned nødvendige filer for rapportering.',
	        changedWarning: 'Denne perioden har blitt endret. Klikk på knappen under for å låse perioden og for å kunne laste ned nødvendige filer for rapportering.',
	        closeButton: 'Lukk',
	        confirm: {
	          title: 'Lukk avgiftsperiode',
	          message: 'Ønsker du å lukke denne perioden? NB! Dette låser perioden fra flere oppføringer.',
	          button: 'Fortsett'
	        },
	        closeSuccessMessage: 'Lukking vellykket! Du har nå tilgang til å laste ned dine rapporter under.',
	        exciseStatus: {
	          ongoing: 'Pågående',
	          readyToBeClosed: 'Klar for lukking',
	          changed: 'Periode endret',
	          closed: 'Lukket'
	        }
	      },
	      brod: {
	        export: 'Last ned i Excel'
	      }
	    },
	
	    accountInformation: {
	      title: 'Kontoinformasjon',
	      profile: 'Profil',
	      basicInformation: 'Basis informasjon',
	      userInformation: 'Bruker informasjon',
	      generalInformation: 'Generell',
	      organizationInformation: 'Enhetsopplysninger',
	      businessInformation: 'Firmaopplysninger',
	      loginInformation: 'Logg inn informasjon',
	      addressInformation: 'Adresse informasjon',
	      userSetting: 'Foretrukket innstilling',
	      contactInformation: 'Kontakt informasjon',
	      passwordTitle: 'Endre passord',
	      accountSaveSuccess: 'Kontoinformasjon lagret.',
	      passwordSaveSuccess: 'Passord lagret.',
	      addressSaveSuccess: 'The address and contact was successfully updated.',
	      general: 'Generelle',
	      email: 'Email',
	      booking: 'Booking',
	      accounting: 'Regnskap',
	      shippingProvider: 'Fraktleverandør',
	      project: 'Prosjekter',
	      twoFactorAuthentication: 'To-faktor autentisering',
	      advance: 'Prisjustering'
	    },
	
	    profileAddress: {
	      title: 'Adresseinformasjon',
	      addressSaveSuccess: 'Adresse lagret.'
	    },
	
	    profileContact: {
	      title: 'Kontaktinformasjon',
	      addressSaveSuccess: 'Kontakt lagret.'
	    },
	
	    organizationSettings: {
	      title: 'Innstillinger',
	      ediSettings: 'EDI innstillinger',
	      settingsSaveSuccess: 'Organistasjonsinstillinger lagret.',
	      settingsSaveError: 'Kunne ikke lagre organisasjonsinnstillinger.',
	      disabledFieldTooltips: 'Dette feltet kan ikke endres etter funksjonen er tatt i bruk',
	      messageTemplates: 'Tilpass e-postene dine',
	      booking: 'Booking',
	      payment_identification: 'KID',
	      accounting: 'Eksport av regnskapsdata',
	      coa: {
	        title: 'Kontoplan',
	        noCoa: 'Kontoplan er ikke opprettet ennå',
	        createCoa: 'Opprett Kontoplan',
	        code: {
	          label: 'Kode',
	          placeholder: 'Kode'
	        },
	        name: {
	          label: 'Navn',
	          placeholder: 'Navn'
	        },
	        description: {
	          label: 'Beskrivelse',
	          placeholder: 'Beskrivelse'
	        },
	        orgDefault: {
	          label: 'Standardkonto',
	          none: 'Ingen',
	          receivables: 'Fordringer',
	          income: 'Inntekt',
	          vat: 'MVA',
	          deposit: 'Pant'
	        }
	      },
	      ediBillingMethod: {
	        options: {
	          auto: 'Automatisk - Fakturaoppretting og sending',
	          halfAuto: 'Halv automatisk - Fakturaoppretting, manuell sending',
	          manuel: 'Manuell - Manuell oppretting og sending av faktura'
	        }
	      },
	      emailInvoiceCopy: {
	        title: 'Epost for fakturakopi'
	      },
	      ediNotifyRecipients: {
	        title: 'Mottakere av Edi-varsling',
	        addBtn: 'Ny e-post'
	      },
	      lowStockNotifyRecipients: {
	        title: 'Mottakere av lagervarsling',
	        addBtn: 'Ny e-post'
	      },
	      bulk_price_update: 'Bulk prisoppdatering',
	      summary: 'Sammendrag',
	      bulk_price_update_success: 'Produkt(er) pris oppdatert!',
	      bulk_price_update_status: {
	        running: {
	          title: 'Bulkoppdateringen pågår...',
	          description: 'Systemet vil automatisk sende en e-post når prosessen er fullført. Vennligst vent til den er ferdig før du starter en ny oppdatering.'
	        },
	        failed: {
	          title: 'Bulkprisoppdateringen mislyktes',
	          description: 'Systemet opplevde et problem under prosessen. Som et resultat har vi avbrutt og reversert endringene. Vennligst kontakt vårt supportteam, og vi vil undersøke problemet. Når det er løst, vil vi varsle deg og la deg kjøre oppdateringen igjen.'
	        }
	      },
	      bulk_price_update_entries: {
	        title: 'Historiske Prisjusteringer'
	      },
	      bulkPriceUpdateHistory: {
	        date: 'Tidspunkt',
	        percentage: '%',
	        roundingRules: 'Avrunding',
	        priceTypes: 'Pristype'
	      },
	      completed: 'Fullført',
	      failed: 'Mislykket'
	    },
	
	    publicProfile: {
	      title: 'Booking innstillinger',
	      profileSettings: 'Profile Settings',
	      mainSettings: 'Offentlig side informasjon',
	      checkoutSettings: 'Utsjekkingsinnstillinger',
	      connectToStripe: 'Koble til Stripe',
	      stripeConnected: 'Stripe er tilkoblet',
	      defaults: 'SMS og epost maler',
	      profileUrl: 'Din booking nettside',
	      updateSucess: 'Booking innstillinger lagret.'
	    },
	
	    businessHours: {
	      title: 'Bedriftstider',
	      businessHoursTitle: 'Åpningstider',
	      businessHourExceptionsTitle: 'Unntakstid',
	      exceptionalHoursSaveKeep: 'Beholde avtaler',
	      exceptionalHoursSaveCancel: 'Kansellere avtaler'
	    },
	
	    checkout: {
	      connectToStripe: 'Koble til Stripe',
	      stripeConnected: 'Stripe tilkoblet',
	      checkoutSettings: 'Utsjekkingsinstillinger'
	    },
	
	    clientGroups: {
	      index: {
	        title: 'Kundegruppe oversikt',
	        clientsCount: ' kunder',
	        confirmDelete: 'Dette vil permanent slette gruppen. Fortsette?',
	        confirmDeleteTitle: 'Slette kundegruppe',
	        deleteHasClientsError: 'Kan ikke slette gruppen med kunder.',
	        deleteError: 'Kundegruppen kan ikke slettes.'
	      },
	      create: {
	        title: 'Legg til kundegruppe',
	        success: 'Kundegruppe lagt til!'
	      },
	      edit: {
	        title: 'Endre kundegruppe',
	        success: 'Kundegruppe oppdatert!'
	      }
	    },
	
	    clients: {
	      organizationNumber: 'Hent fra Brreg',
	      info: {
	        clientNumber: 'Kunde #:',
	        organizationNumber: 'Organisasjonsnummer:',
	        billType: 'Faktureringsvalg:',
	        phone: 'Telefon:',
	        email: 'Epost:',
	        totalOrders: 'Total ordre:',
	        totalRevenue: 'Total fortjeneste:',
	        pendingPayments: 'Venter betaling:',
	        clientType: 'Kunde type:',
	        clientGroup: 'Kunde gruppe:',
	        firstName: 'Fornavn',
	        lastName: 'Etternavn',
	        phoneNumber: 'Telefonnummer:',
	        mobileNumber: 'Mobilnummer:',
	        streetName: 'Adresse:',
	        secondStreetName: 'Adresse 2:',
	        postalCode: 'Postkode:',
	        city: 'By:',
	        orders: 'Antall ordre',
	        bills: 'Antall fakturaer',
	        totalBought: 'Sum fakturert',
	        totalPending: 'Sum fakturert, ikke betalt',
	        systemGenerated: 'System generert',
	        ehfInvoiceSupport: 'EHF-faktura (Peppol)',
	        ehfSupport: {
	          yes: 'Ja — registrert for EHF 3.0 i Peppol',
	          no: 'Nei — ikke registrert for EHF 3.0 (lagre kunde med org.nr for ny sjekk)',
	          needsOrgNumber: 'Kan ikke verifisere — legg inn organisasjonsnummer'
	        },
	        ehfListLabel: 'EHF (Peppol)',
	        ehfListVerified: 'Verifisert for EHF-faktura',
	        ehfListNotVerified: 'Ikke verifisert for EHF-faktura',
	
	        value: {
	          billType: {
	            options: {
	              single: 'Enkeltvis',
	              consolidate: 'Samlet'
	            }
	          }
	        }
	      },
	      index: {
	        bulkMaxLimitExceededError: 'Du har valgt for mange fakturaer! Vennligst reduser antall markerte fakturaer til maks',
	        editTooltip: 'Rediger klientprofil',
	        deleteTooltip: 'Slett klient',
	        title: 'Kundeoversikt',
	        confirmDelete: 'Dette vil permanent slette kunden og ordrene. Fortsette?',
	        confirmDeleteTitle: 'Slett kunde',
	        downloadAllClients: 'Last ned kunder',
	        importClients: 'Dra og slipp Excel fil for importering av kunder...',
	        importClientsErrorMessage: 'En feil oppsto under import. Vennligst sjekk filen og prøv på nytt.',
	        importClientsSuccessMessage: 'Import vellykket!',
	        importData: 'Import Data',
	        exportData: 'Export Data',
	        sortName: {
	          placeholder: 'Sorter'
	        },
	        searchName: {
	          placeholder: 'Søk'
	        },
	        search: {
	          placeholder: 'Søk på navn, e-post eller organisasjonsnummer'
	        },
	        listing: {
	          placeholder: 'Select Type'
	        },
	        phoneNumber: 'Telefonnummer',
	        email: 'Epost'
	      },
	      table: {
	        name: 'Navn',
	        custNo: 'Kundenr.',
	        organizationNumber: 'Org.nr.',
	        billType: 'Faktureringsvalg',
	        phone: 'Telefon',
	        email: 'Epost',
	        ehf: 'EHF',
	        ordersCount: 'Ordreantall',
	        createdAt: 'Opprettet',
	        parentClient: 'Foreldre klient',
	        billMainParent: 'Bill hovedforelder'
	      },
	      delete: {
	        title: 'Advarsel',
	        confirm: 'Ønsker du å slette kunden? Kunder med ordre kan ikke slettes.',
	        success: 'Kunden slettet'
	      },
	      create: {
	        title: 'Legg til kunde',
	        success: 'Oppretting vellykket!',
	        brrig: {
	          warning: 'Ingen match funnet hos Brønnøysundregistrene'
	        },
	        gotoEdit: 'Legge til flere detaljer',
	        addMore: 'Opprett en ny kunde',
	        gotoIndex: 'Gå til kundeoversikten'
	      },
	      edit: {
	        title: 'Endre kunde',
	        clientInfo: 'Kundeinformasjon',
	        success: 'Kunde oppdatert!',
	        overview: 'Oversikt',
	        clientOrders: 'Kundeordrer',
	        latestOrders: 'SISTE ORDRER',
	        latestBills: 'SISTE FAKTURAER',
	        recentActivities: 'SISTE AKTIVITET',
	        viewAll: 'SE ALLE',
	        allBills: 'Alle fakturaer',
	        bills: 'FAKTURAER',
	        allActivities: 'All aktivitet',
	        activities: 'AKTIVITETER',
	        allOrders: 'Alle ordrer',
	        orders: 'ORDRER',
	        editInformation: 'Endre informasjon',
	        totalOrders: 'TOTAL ORDRER',
	        totalBills: 'TOTAL FAKTURAER',
	        totalActivities: 'TOTAL AKTIVITET',
	        noActivity: 'Ingen aktivitet',
	        errorNoClient: 'Vennligst velg klienten',
	        glnSuccess: 'GLN-nummer og koordinater er tilgjengelig, se feltene.',
	        glnError: 'Finner ikke GLN-nummer og koordinater, sjekk organisasjonsnummeret!'
	      },
	      catalogues: {
	        title: 'EHF katalog',
	        sendCatalogue: 'Send EHF katalog',
	        actionCodes: {
	          add: 'Ny',
	          update: 'Oppdater',
	          replace: 'Erstatt',
	          delete: 'Slett'
	        }
	      }
	    },
	
	    productGroups: {
	      formTabs: {
	        groupInformation: 'Gruppe informasjon',
	        pricingOptions: 'Pris detaljer'
	      },
	      filters: {
	        title: 'Produktgruppe',
	        latest: 'Siste',
	        pastMonth: 'Siste mnd.',
	        all: 'Alle'
	      },
	      index: {
	        title: 'Produktgruppe oversikt',
	        productsCount: ' produkter',
	        confirmDelete: 'Dette vil permanent slette gruppen. Fortsette?',
	        confirmDeleteTitle: 'Slette produktgruppe',
	        deleteHasProductError: 'Kan ikke slette gruppen med produkter.',
	        deleteError: 'Produktgruppe kan ikke slettes.'
	      },
	      create: {
	        title: 'Opprett produktgruppe'
	      },
	      edit: {
	        title: 'Endre produktgruppe'
	      }
	    },
	
	    productPackagings: {
	      formTabs: {
	        packagingInformation: 'Forpakninger',
	        pricingOptions: 'Pricing Options'
	      },
	      filters: {
	        title: 'Forpakninger',
	        all: 'Alle'
	      },
	      index: {
	        title: 'Forpakninger',
	        productsCount: ' produkter',
	        confirmDelete: 'Dette vil slette forpakningen. Ønsker du å fortsette?',
	        confirmDeleteTitle: 'Slett orodukt forpakning',
	        deleteHasProductError: 'Kan ikke slette forpakning tilknyttet produkter.',
	        deleteError: 'Produkt forpakning kunne ikke slettes.'
	      },
	      create: {
	        title: 'Opprett forpakning',
	        success: 'Forpakning opprettet'
	      },
	      edit: {
	        title: 'Rediger forpakning',
	        success: 'Forpakning oppdatert',
	        delete: 'Produktforpakning slette'
	      }
	    },
	
	    productTags: {
	      formTabs: {
	        tagInformation: 'Stikkord informasjon'
	      },
	      index: {
	        title: 'Produkt stikkord',
	        productsCount: ' products'
	      },
	      filters: {
	        title: 'Produkt stikkord',
	        all: 'Alle'
	      },
	      create: {
	        title: 'Opprett stikkord',
	        success: 'Produkt stikkord opprettet!'
	      },
	      edit: {
	        title: 'Rediger stikkord',
	        success: 'Produkt stikkord endret!'
	      }
	    },
	
	    priceFields: {
	      formTabs: {
	        tagInformation: 'Field Information'
	      },
	      index: {
	        title: 'Price Field',
	        productsCount: ' products'
	      },
	      filters: {
	        title: 'Price Fields',
	        all: 'All'
	      },
	      create: {
	        title: 'Add Price Field',
	        success: 'Product Price Field successfully'
	      },
	      edit: {
	        title: 'Edit Price Field',
	        success: 'Price Field edited successfully'
	      }
	    },
	    campaigns: {
	      listNotSetup: 'Sett opp listen på denne kampanjen ellers blir ikke nyheter sendt!',
	      noDataMsg: 'Ingen kampanje-e-post funnet',
	      index: {
	        title: 'Kampanje oversikt',
	        description: 'Forklaring',
	        campaignType: 'Type',
	        confirmDelete: 'Dette vil slette hele kampanjen. Ønsker du å fortsette?',
	        confirmDeleteTitle: 'Slett kampanje',
	        deleteHasClientsError: 'Kan ikke slette kampanje som inneholder eposter.',
	        deleteError: 'Kampanjen kunne ikke slettes.'
	      },
	      create: {
	        title: 'Legg til kampanje',
	        tabTitle: 'Kampanjen informasjon',
	        campaignTypeTooltip: 'Sequence: test description. <br/><br/> Broadcast: test description.'
	      },
	      edit: {
	        title: 'Rediger kampanje',
	        campaignInfo: 'Kampanjen informasjon',
	        overview: 'Kampanjen oversikt',
	        emails: 'Eposter',
	        emailBodyTooltip: 'Tilgjengelige variabler:<br/><br/>Fornavn på kunde: {customer_firstname}<br/>Etternavn på kunde: {customer_lastname}',
	        clients: 'Kunder',
	        totalSubscribers: 'Abonnementer',
	        unsubscribed: 'Avmeldte',
	        bounced: 'Retur',
	        latestSubscribers: 'Siste påmeldte',
	        latestUnsubscribed: 'Siste avmeldte',
	        latestBounced: 'Siste returnerte',
	        viewAll: 'Vis alle',
	        updateSuccess: 'Kampanjen ble lagret!',
	        removeClientError: 'Kunde kunne ikke bli slettet fra kampanjen.',
	        addClients: {
	          placeholder: 'Velg kunde'
	        },
	        addClientGroups: {
	          placeholder: 'Velg kundegruppe'
	        },
	        emailTracking: {
	          noDataMsg: 'Ingen poster funnet',
	          dateRange: 'Datointervall:',
	          countLabel: {
	            opened: 'åpnet',
	            delivered: 'leveres',
	            clicked: 'klikket',
	            dropped: 'droppet',
	            bounced: 'Returnerte',
	            complained: 'klaget',
	            failed: 'mislyktes',
	            unsubscribed: 'utmeldings'
	          },
	          graphLabel: 'Kurve',
	          recipientLabel: 'mottakere',
	          noRecipientAvailable: 'Ingen mottakere tilgjengelig',
	          dateRangDropDown: {
	            group1: 'Tekst med ikon',
	            today: 'I dag',
	            all: 'Alle',
	            group2: 'Linjediagram',
	            dateRange: 'Datointervall'
	          },
	          datePicker: {
	            shortcut: {
	              last3Days: 'Siste 3 dager',
	              lastWeek: 'Forrige uke',
	              lastMonth: 'Last Month',
	              last3Month: 'Forrige måned'
	            }
	          }
	        }
	      }
	    },
	
	    subscriberList: {
	      index: {
	        title: ' oversikt',
	        description: 'Beskrivelse',
	        confirmDelete: 'Dette vil slette listen permanent. Fortsette?',
	        confirmDeleteTitle: 'Slett liste',
	        deleteError: 'Listen kunne ikke slettes.',
	        topInfo: 'Listeinfo.',
	        fromEmail: 'e-post',
	        fromName: 'Navn',
	        emailCount: 'Antall e -poster'
	      },
	      create: {
	        title: 'Lag liste',
	        tabTitle: 'Liste informasjon'
	      },
	      edit: {
	        sendingEmailLoading: 'Vi sender optin link for hver e-post, vennligst vent ...',
	        filterLabel: 'Filtrer etter:',
	        tab1Title: 'abonnenter',
	        tab2Title: 'Innstilling',
	        tab3Title: 'Regler',
	        title: 'Rediger abonnentliste',
	        overview: 'Oversikt over abonnentliste',
	        totalSubscribers: 'abonnenter',
	        unsubscribed: 'utmeldings',
	        latestSubscribers: 'Siste abonnenter',
	        latestUnsubscribed: 'Siste avmelding',
	        viewAll: 'Se alt',
	        deleteList: 'Slett liste',
	        delete: 'Slett',
	        deleteConfirmHeaderMsg: 'Advarsel',
	        deleteConfirmBodyMsg: 'Ønsker du å slette denne listen ?, Denne listen vil bli slettet permanent.',
	        addClients: {
	          placeholder: 'Velg klienter'
	        },
	        addClientGroups: {
	          placeholder: 'Velg klientgrupper'
	        },
	        subscribers: {
	          subscribeSwitchTooltip: 'Foreløpig: subcirbed',
	          unsubscribeSwitchTooltip: 'Foreløpig: melde deg ut',
	          delete: 'Slett',
	          deleteConfirmHeaderMsg: 'Advarsel',
	          deleteConfirmBodyMsg: 'Ønsker du å slette denne e-postmeldingen ?, Denne e-posten vil ikke lenger være en del av denne listen.',
	          alreadyInList: '- allerede på denne listen',
	          subscribeConfirmHeaderMsg: 'Advarsel',
	          subscribe: 'Abonnere',
	          unsubscribe: 'Avslutte abonnementet',
	          ableToReceive: 'Ønsker du å abonnere på denne e-postmeldingen? Denne e-posten vil motta nyhetsbrev.',
	          unableToReceive: 'Ønsker du å melde deg av denne e-postmeldingen? Denne e-posten vil ikke lenger motta nyhetsbrev.',
	          groupModalHeaderTitle: 'Kundegruppe:',
	          groupModalCancel: 'Avbryt',
	          groupModalApply: 'Søke om'
	        },
	        filters: {
	          all: 'Alle',
	          unsubscribe: 'Avslutte abonnementet'
	        }
	      }
	    },
	
	    news: {
	      index: {
	        title: 'Epost oversikt',
	        confirmDelete: 'Dette vil slette eposten. Fortsett?',
	        confirmDeleteTitle: 'Slett epost',
	        deleteError: 'Epost kunne ikke slettes'
	      },
	      create: {
	        title: 'Opprett epost',
	        createSucess: 'Epost opprettet!',
	        sendTestSucess: 'Send epost test'
	      },
	      edit: {
	        title: 'Rediger epost',
	        updateSucess: 'Epost oppdatert.'
	      }
	    },
	
	    products: {
	      types: {
	        product: 'Produkt',
	        bundle: 'Pakke',
	        service: 'Tjeneste',
	        plan: 'Plan',
	        beverage: 'Drikkevare',
	        child: 'Sub-produkt',
	        beer: 'Øl',
	        mead: 'Mjød',
	        wine: 'Vin',
	        liquor: 'Brennevin',
	        cider: 'Sider',
	        carbonated: 'Kullsyreholdige',
	        nonCarbonated: 'Kullsyrefri',
	        material: 'Materialer',
	        alcohol: 'Alkohol',
	        nonAlcohol: 'Alkoholfri',
	        lightWine: 'Svakvin',
	        strongWine: 'Sterkvin'
	      },
	      formTabs: {
	        productInformation: 'Produkt informasjon',
	        pricingOptions: 'Produkt detaljer',
	        inventory: 'Varelager',
	        transactions: 'Transaksjoner',
	        transactionsOld: 'Transaksjoner (ikke gyldig)',
	        mergeProduct: 'Produkt sammenslåing',
	        childProducts: 'Tilhørende produkter',
	        syncDetails: 'Detaljer'
	      },
	      labels: {
	        priceAndTax: 'Pris og avgifter',
	        productDetails: 'Produktdetaljer',
	        mergeProduct: 'Produktsammenslåing',
	        productInformation: 'Produktinformasjon',
	        priceForm: 'Pris og avgifter',
	        detailsForm: 'Produktdetaljer',
	        exciseForm: 'Særavgiftsdetaljer',
	        packagingForm: 'Forpakningsdetaljer',
	        productIndentification: 'Produkt identifikasjon',
	        marketplace: 'DrikkeRiket',
	        alcohol: 'Alkohol',
	        alcoholFree: 'Alkoholfri',
	        onlineStore: 'Nettbutikk'
	      },
	      filters: {
	        title: 'Produkter',
	        latest: 'Siste',
	        pastMonth: 'Siste mnd.',
	        all: 'Alle',
	        withDeposit: 'Med pant',
	        active: 'Aktive',
	        deactivated: 'Inaktive',
	        asko: 'Tilgjengelig Asko',
	        vinhuset: 'Tilgjengelig Vinhuset',
	        marketplace: 'Tilgjengelig DrikkeRiket',
	        onlineStore: 'Tilgjengelig Nettbutikk',
	        materials: 'Materialer',
	        placeholder: 'Velg filter',
	        type: 'Type',
	        producer: 'Produsent',
	        alcohol: 'Alkohol',
	        alcoholFree: 'Alkoholfri'
	      },
	      index: {
	        title: 'Produktoversikt',
	        confirmDelete: 'Dette vil permanent slette produktet. Fortsette??',
	        confirmDeleteTitle: 'Slett produkt',
	        downloadAllProducts: 'Last ned alle produkter',
	        importProducts: 'Dra og slipp Excel fil for importering av produkter...',
	        importProductsErrorMessage: 'En feil oppsto under import. Vennligst sjekk filen og prøv på nytt.',
	        importProductsSuccessMessage: 'Import vellykket!',
	        importProductsErrorPopupTitle: 'Følgende må korrigeres i importen:',
	        importData: 'Importer data',
	        exportData: 'Eksporter data',
	        row: 'Rad'
	      },
	      create: {
	        title: 'Opprett produkt',
	        success: 'Produkt opprettet!',
	        options: {
	          edit: 'Legge til flere detaljer',
	          addMore: 'Opprett et nytt produkt',
	          gotoIndex: 'Gå til produktoversikten'
	        },
	        vmp: {
	          fetch: 'Hent data fra VMP'
	        }
	      },
	      syncVmp: {
	        title: 'Synkroniser VMP',
	        validatingData: 'Henter data...',
	        added: 'Nye',
	        updated: 'Oppdatert',
	        noDataToBeSynced: 'Vi fant ingen data å synkronisere.',
	        syncSuccess: 'Synkronisering fullført.',
	        syncError: 'Feil oppsto under synkroniseringen.',
	        inputRequired: 'Vinmonopolet nummer er påkrevd',
	        noModuleWarning: 'Før du kan hente produktdata fra VMP må du aktiverer Vinmonopolet modulen. Gå til <a href="/#/modules" target="_blank">"Moduler"</a> for å aktivere.',
	        existingProducts: 'Eksisterende produkter',
	        newProducts: 'Nye produkter',
	        syncFieldTitle: 'Produktsynkronisering',
	        packagingPopupTitle: '',
	        fields: {
	          name: 'Navn',
	          type: 'Produkttype',
	          subtype: 'Velg subtype',
	          retailPriceVmp: 'Utsalgspris VMP',
	          producer: 'Produsent',
	          country: 'Land',
	          vintage: 'Årgang',
	          alcohol_percentage: 'Alkohol %',
	          bottle_volume: 'Flaskevolum',
	          cork_type: 'Korktype',
	          packaging_material: 'Emballasjetype',
	          gtin: 'GTIN',
	          colour: 'Farge',
	          odour: 'Lukt',
	          region: 'Distrikt',
	          subRegion: 'Underdistrikt',
	          sugar: 'Sukker',
	          acid: 'Syre',
	          fullness: 'Fylde',
	          freshness: 'Friskhet',
	          tannins: 'Garvestoffer',
	          bitterness: 'Bitterhet',
	          sweetness: 'Sødme',
	          taste: 'Smak',
	          recommendedFood: 'Anbefalt mat',
	          storagePotential: 'Lagringsgrad',
	          ingredients: 'Ingredienser',
	          organic: 'Økologisk',
	          biodynamic: 'Biodynamisk',
	          locallyProduced: 'Lokalprodusert',
	          environmentallySmart: 'Fairtrade',
	          freeOrLowOnGluten: 'Lav på gluten',
	          kosher: 'Kosher'
	        }
	      },
	      edit: {
	        title: 'Endre produkt',
	        success: 'Produkt endret!',
	        error: 'Produkt oppdatering feilet. Vennligst sjekk for mangler.'
	      },
	      delete: {
	        title: 'Advarsel',
	        confirm: 'Slett dette produktet?',
	        success: 'Produktet er slettet',
	        imageConfirm: 'Ønsker du å slette produktbildet?',
	        imageSuccess: 'Produktbilde slettet'
	      },
	      warehouse: {
	        noDataMsg: 'Ingen varelager funnet på dette produktet',
	        table: {
	          qty: 'Antall',
	          name: 'Lagersted',
	          warehouseId: 'Lager #',
	          batchName: 'Parti',
	          totalValue: 'Verdi'
	        }
	      },
	      merge: {
	        success: 'Produktet ble flettet'
	      },
	      transactions: {
	        noDataMsg: 'Ingen transaksjoner funnet',
	        table: {
	          beforeqty: 'Før',
	          qty: 'Antall',
	          afterqty: 'Etter',
	          via: 'Type',
	          code: 'ID/Nummer',
	          createdAt: 'Dato',
	          id: 'ID #',
	          status: 'Status',
	          client: 'Kunde',
	          warehouse: 'Lagersted',
	          billingNumber: 'Faktura #',
	          productName: 'Produkt',
	          batchName: 'Batch'
	        }
	      },
	      table: {
	        id: 'ID',
	        price: 'Pris',
	        name: 'Produktnavn',
	        qty: 'Antall',
	        warehouses: 'Lagersted',
	        description: 'Forklaring',
	        number: 'Produktnr',
	        externalId: 'Eksternt produktnr',
	        case: 'kasse(r)',
	        loose: 'løse',
	        total: 'totalt'
	      },
	      indexSettings: {
	        displayType: 'Visningstype',
	        groupBy: 'Grupper',
	        views: {
	          grid: 'Rutenett',
	          list: 'Liste'
	        },
	        groups: {
	          None: 'Ingen',
	          Producer: 'Produsent',
	          Type: 'Produkttype'
	        }
	      }
	    },
	    bills: {
	      billLines: 'Fakturalinjer',
	      formTabs: {
	        invoiceInformation: 'Fakturainformasjon',
	        edit: 'Rediger faktura',
	        emails: 'E-poster',
	        reminders: 'Påminnelser'
	      },
	      message: {
	        delete: 'Ønsker du å slette denne eksport filen?',
	        title: 'Bekreft sletting'
	      },
	      filters: {
	        title: 'Fakturaer',
	        today: 'I dag',
	        upcoming: 'Kommende',
	        pending: 'Venter',
	        sent: 'Sendt',
	        overdue: 'Forfalt',
	        cancelled: 'Kansellert',
	        paid: 'Betalt',
	        partlyPaid: 'Delbetalt',
	        all: 'Alle',
	        creditNote: 'Kreditnota',
	        invoice: 'Faktura'
	      },
	      index: {
	        remainingToPay: 'gjenstår å betale',
	        bulkMaxLimitExceededError: 'Du har valgt for mange fakturaer! Vennligst reduser antall markerte fakturaer til maks',
	        title: 'Fakturaoversikt',
	        confirmDelete: 'Dette vil permanent slette faktura. Fortsette?',
	        confirmDeleteTitle: 'Slett faktura',
	        deleteError: 'Faktura kan ikke slettes.',
	        deleteNotDraftError: 'Kun utkast kan slettes.',
	        billStatus: 'Status',
	        dueDateFormated: 'Forfallsdato',
	        invoiceDateFormated: 'Fakturadato',
	        billType: 'Type',
	        clientName: 'Kunde',
	        quantities: 'mengder',
	        confirmActionTitle: 'Vennligst bekreft',
	        confirmAction1: 'Ønsker du å ',
	        confirmAction2: 'på de',
	        confirmAction3: 'valgte fakturaene?',
	        email: 'Epost',
	        ehf: 'Ehf',
	        paid: 'Betalt',
	        sent: 'Sendt',
	        edi: 'Edi',
	        action: {
	          markBilledAsPaid: 'merke faktura som betalt'
	        },
	        overdueBadge: 'Forfalt'
	      },
	      table: {
	        id: 'ID',
	        name: 'Faktura',
	        paymentDate: 'Betalingsdato',
	        type: 'Type',
	        status: 'Status',
	        client: 'Kunde',
	        amountDue: 'Å betale',
	        amountPaid: 'Betalt beløp',
	        totalGross: 'Sum brutto',
	        dueDate: 'Forfallsdato',
	        invoiceDate: 'Fakturadato'
	      },
	      create: {
	        title: 'Opprett faktura',
	        success: 'Faktura opprettet!',
	        orderError: 'Kun en faktura kan opprettes per ordre'
	      },
	      exportBill: {
	        title: 'Eksporter fakturadata',
	        btn: 'Generer fakturadata',
	        confirmSuccess: 'Successfully created export',
	        error: 'Internal Error',
	        providerNotSet: 'Vennligst velg regnskapssystemet for eksport. Se "Innstillinger->Regnskap".',
	        datePeriod: 'Velg periode',
	        description: {
	          label: 'Beskrivelse',
	          placeholder: 'Skriv inn beskrivelse (valgfritt)'
	        },
	        billsDateRange: {
	          placeholder: 'Velg periode',
	          placeholderStart: 'Fra dato',
	          placeholderEnd: 'Til dato',
	          label: 'Velg periode'
	        },
	        download: {
	          periode: 'Periode',
	          description: 'Beskrivelse',
	          provider: 'Regnskapssystem',
	          download: 'Last ned',
	          noData: 'Ingen data generert'
	        }
	      },
	      edit: {
	        orderReference: 'Notat',
	        title: 'Faktura',
	        detailsLegend: 'Fakturadetaljer',
	        billStatus: 'Status',
	        sourceOrder: 'Source Order',
	        sourceBill: 'Source Bill',
	        customerDetails: 'Kundedetaljer',
	        address: 'Adresse',
	        updateSuccess: 'Faktura oppdatert.',
	        sendPreviewInfo: 'Vennligst vent...',
	        creditNoteTitle: 'Endre kreditnota',
	        showInvoiceBtn: 'Vis faktura',
	        downloadInvoiceBtn: 'Last ned faktura',
	        showCreditNoteBtn: 'Vis kreditnota',
	        downloadCreditNoteBtn: 'Last ned kreditnota',
	        sendInvoiceBtn: 'Send e-post faktura',
	        sendEdiInvoiceBtn: 'Send faktura (EDI)',
	        sendEdiCreditNoteBtn: 'Send kreditnota (EDI)',
	        sendEhfInvoiceBtn: 'Send EHF',
	        sendInvoiceEmailFallbackBtn: 'Send faktura på e-post (avviker fra kundens valg)',
	        sendCreditNoteEmailFallbackBtn: 'Send kreditnota på e-post (avviker fra kundens valg)',
	        ehfNotVerifiedTitle: 'EHF er ikke klar for denne kunden',
	        ehfNotVerifiedBody: 'Kunden har EHF som fakturametode, men Peppol-verifisering (EHF 3.0) er ikke registrert. Oppdater kunden (lagre på nytt) eller send midlertidig på e-post.',
	        ehfNotVerifiedClientLink: 'Gå til kunde',
	        ehfNotVerifiedNoEmail: 'Kunden har ikke e-postadresse; legg inn kontakt på kundekortet før du kan sende på e-post.',
	        ehfPreferredOverEmailTitle: 'Kunden kan ta imot EHF',
	        ehfPreferredOverEmailBody: 'Fakturametode er satt til e-post, men kunden er verifisert for EHF (Peppol). For de fleste B2B-fakturaer er EHF å foretrekke. Du kan sende med EHF nå, eller likevel bruke e-post om du må.',
	        ehfPreferredOverEmailNoEmail: 'Uten e-post på kunden kan du ikke sende på e-post her — legg inn e-post på kundekortet, eller send med EHF.',
	        ehfPreferredOverEmailSendEhfBtn: 'Send med EHF (anbefalt)',
	        ehfPreferredOverEmailSendInvoiceEmailBtn: 'Send faktura på e-post',
	        ehfPreferredOverEmailSendCreditNoteEmailBtn: 'Send kreditnota på e-post',
	        ehfModuleUpsellTitle: 'Aktiver EHF-modulen for denne kunden',
	        ehfModuleUpsellTitleNoPeppolYet: 'Aktiver EHF-modulen først',
	        ehfModuleUpsellBody: 'Kunden er verifisert for EHF (Peppol), men EHF-modulen er ikke aktivert på kontoen din. Med EHF kan du sende B2B-fakturaer elektronisk i stedet for e-post — ofte raskere og mer pålitelig.',
	        ehfModuleUpsellBodyNoPeppolYet: 'Kunden har EHF som fakturametode, men EHF-modulen er ikke aktivert på kontoen din. Aktiver modulen for å sende via EHF. Etterpå kan du lagre kunden på nytt for Peppol-verifisering ved behov, eller sende midlertidig på e-post.',
	        ehfModuleUpsellLink: 'Trykk her for å aktivere EHF-modulen',
	        ehfModuleUpsellUnavailable: 'EHF-modulen er ikke tilgjengelig akkurat nå. Kontakt support om du trenger hjelp.',
	        resendInvoiceBtn: 'Send faktura på nytt',
	        sendReminder: 'Send påminnelse',
	        overdueInvoiceNotice: 'Forfallsdato er passert for denne fakturaen. Under fanen Påminnelser kan du sende betalingspåminnelse på e-post.',
	        overdueBadge: 'Forfalt',
	        invoiceWithReminderFee: 'Påminnelse PDF',
	        invoiceSent: 'Faktura sendt',
	        sendCreditNoteBtn: 'Send e-post kreditnota',
	        sendInvoiceSuccess: 'Faktura ble satt i kø for sending.',
	        sendInvoiceError: 'Feil i faktura, vennligst prøv igjen senere.',
	        createCreditNoteBtn: 'Opprett kreditnota',
	        createNoteError: 'Feil i kreditnota, vennligst prøv igjen senere.',
	        creditNoteProducttitle: 'Kreditnota',
	        noCreditNoteSource: 'Ingen kreditnota kilde funnet',
	        noClientEmailNoInvoice: 'Kunde mangler epost for å kunne sende faktura.',
	        invoice: 'Faktura',
	        creditnote: 'Kreditnota',
	        creditNoteReason: 'Årsak',
	        to: 'Til',
	        from: 'Fra',
	        subject: 'Emne',
	        messageBody: 'Beskjed',
	        notes: 'Merknader',
	        attachment: 'Vedlegg',
	        order: 'Ordre',
	        date: 'Dato',
	        paymentDate: 'Betalingsdato',
	        dueDate: 'Forfallsdato',
	        invoiceNumber: 'Faktura #',
	        cc: 'Send en kopi til',
	        deliveredTo: 'Levert',
	        validateKidNumber: 'Valider KID',
	        generateKidNumber: 'Lag KID',
	        kidGenerateSuccess: 'Oppdatert',
	        validKID: 'KID er gyldig',
	        invalidKID: 'KID er ugyldig',
	        emailTracking: {
	          delivered: 'Levert',
	          opened: 'Åpnet',
	          clicked: 'Klikket',
	          dropped: 'Droppet',
	          bounced: 'Returnert',
	          complained: 'Klaget',
	          failed: 'Mislykket',
	          recipient: 'Mottakeren',
	          date: 'Dato',
	          type: 'Type',
	          device: 'Enhet'
	        }
	      },
	      crediNoteReason: {
	        title: 'Begrunnelse for kreditering'
	      }
	    },
	
	    appointments: {
	      index: {
	        title: 'Avtale oversikt',
	        futureFilter: 'Fra i dag',
	        cancelled: 'Kansellert',
	        completed: 'Fullført',
	        created: 'Opprettet',
	        ongoing: 'Pågående',
	        noSlots: 'Ingen ledige tidspunkt for denne dagen.',
	        freeSlot: 'Ledig tid!',
	        nothingScheduled: 'Ingen avtaler.',
	        exception: 'Unntak',
	        displayWeekend: 'Vis helg',
	        week: 'Uke'
	      },
	      create: {
	        title: 'Legg til avtale'
	      },
	      edit: {
	        title: 'Rediger time',
	        editButton: 'Vis timebestillingen',
	        destroyError: 'Beklager, men timen kunne ikke kanselleres.'
	      }
	    },
	
	    shippingProviderAll: 'Alle leverandører',
	
	    orderPickups: {
	      title: 'Ordre logistikk',
	      filter: {
	        label: 'Filtrer etter'
	      },
	      tableHead: {
	        order: 'Ordre',
	        status: 'Status',
	        customer: 'Kunde',
	        shippingProvider: 'Fraktleverandør'
	      },
	      table: {
	        number: 'Ordre #',
	        createdAt: 'Opprettet',
	        pickupDate: 'Hentedato',
	        pickupBy: 'Hentet av',
	        shippingProvider: 'Fraktleverandør',
	        shippingDate: 'Forsendelsesdato',
	        tracking: 'Sporing',
	        openTracking: 'Åpne sporing',
	        noTracking: 'Ingen sporing registrert ennå',
	        deliveryDate: 'Leveringsdato',
	        missing: 'Mangler',
	        noData: 'Ingen tilgjengelige data'
	      },
	      index: {
	        shippingStatuses: {
	          all: 'All statuser',
	          new: 'Ny',
	          picked: 'Plukket',
	          shipped: 'På vei',
	          delivered: 'Levert',
	          cancelled: 'Kansellert'
	        }
	      }
	    },
	
	    orders: {
	      types: {
	        all: 'Alle',
	        product: 'Produkter',
	        edi: 'EDI',
	        appointment: 'Avtale',
	        sale: 'Salg',
	        return: 'Retur',
	        wordpress: 'Drikkeriket',
	        transfer: 'Overføring'
	      },
	      shippingConfirm: {
	        title: 'Bekreft levering',
	        unassignedProductWarning: 'Det er fortsatt ufordelte produkter til pakken.',
	        unassignedProductError: 'Du må tilordne ALLE produktene for å fortsette.',
	        manageDelivery: 'Administrer levering',
	        shippingProviderRequired: 'Fraktleverandør er påkrevd men ikke knyttet til varelaget.',
	        addShippingProviderBtn: 'Klikk her for å legge til fraktleverandør alternativer'
	      },
	      orderTable: {
	        productErrorMessage: 'Produkt ikke funnet'
	      },
	      orderConfirm: {
	        title: 'Bekreft ordre',
	        znbTitle: 'Bekreft avgift',
	        exciseWarningMessage: 'Ordren inneholder drikkevare(r) som mangler avgiftsdata. Klikk på produktlinken for å oppdatere dataene før du går videre.',
	        upsellMessage: 'Du selger drikkevare(r) men har ikke avgiftsmodulen aktivert for enklere rapportering til skattemyndigheter og andre enheter. Ta kontakt med support@kundan.no for en gratis prøve!',
	        clientType: 'Kundetype',
	        excisable: 'Avgiftspliktig',
	        nonExcisable: 'Ikke avgiftspliktig',
	        exciseCode: 'Avgiftskode',
	        exciseCheck: 'Avgiftsdata',
	        paidExcise: 'Avgifter',
	        paidExciseYes: 'BETALT',
	        paidExciseNo: 'UBETALT',
	        packagingCheck: 'Forpakning',
	        table: {
	          product: 'Produkt',
	          excise: 'Avgiftsgrupper',
	          exciseGroup: {
	            beverage: 'Drikkevareavg.',
	            packaging: 'Miljøavg.',
	            basic: 'Grunnavg.'
	          },
	          bottleVolume: 'Volum (ℓ)',
	          alcoholPercentage: 'Alkohol %'
	        },
	        orderConfirmNotification: 'Send en ordrebekreftelsesmelding til kunden'
	      },
	      orderWarehouse: {
	        title: 'Oppdater lagersted'
	      },
	      orderInternalNote: {
	        title: 'Notat'
	      },
	      purchaseReceive: {
	        title: 'Mottatt innkjøp'
	      },
	      status: {
	        undefined: 'Udefinert',
	        created: 'Ny',
	        Done: 'Ferdig',
	        confirmed: 'Bekreftet',
	        processed: 'Behandlet',
	        received: 'Mottatt',
	        completed: 'Fullført',
	        invoiced: 'Faktura opprettet',
	        invoiced_externally: 'Fakturert eksternt',
	        bill_sent: 'Fakturert',
	        credited: 'Kreditnotert',
	        cancelled: 'Kansellert',
	        shipping_confirmed: 'Ordre behandlet, under transport',
	        invoiced_consolidated: 'Samlefakturert',
	        waiting_autobilling: 'Venter autofaktura',
	        picked: 'Ordre plukket',
	        shipped: 'Ordre på vei til kunde',
	        delivered: 'Ordre levert kunde',
	        vipps_processing: 'Vipps behandling'
	      },
	      formTabs: {
	        orderInformation: 'Ordre informasjon',
	        deliveryNote: 'Leveringsinformasjon',
	        edit: 'Rediger ordre'
	      },
	      orderLines: 'Ordrelinjer',
	      index: {
	        bulkMaxLimitExceededError: 'Du har valgt for mange ordre! Vennligst reduser antall markerte ordre til maks',
	        editTooltip: 'Rediger bestilling',
	        deleteTooltip: 'Slett rekkefølge',
	        title: 'Ordreoversikt',
	        confirmDelete: 'Dette vil permanent slette ordren. Fortsett?',
	        confirmDeleteTitle: 'Slett ordre',
	        clientName: 'Kunde',
	        orderType: 'Ordretype',
	        activity: 'Aktivitet',
	        start: 'Start',
	        service: 'Tjeneste',
	        confirmCancel: 'Dette vil avbryte ordren. Fortsett?',
	        confirmCancelTitle: 'Kanseller ordre',
	        status: 'Status',
	        ediNumber: 'EDI nummer',
	        deliveryDate: 'Leveringsdato',
	        pickupDate: 'Plukkdato',
	        client: 'Kunde',
	        items: 'Varer',
	        type: 'Type',
	        qty: 'Antall',
	        referenceNumber: 'Ordre referanse',
	        createdDate: 'Ordredato'
	      },
	      table: {
	        id: 'ID',
	        name: 'Nummer',
	        type: 'Type',
	        status: 'Status',
	        clientName: 'Kunde',
	        totalValue: 'Pris',
	        totalQuantity: 'Antall',
	        createdDate: 'Ordredato',
	        amountDue: 'Å betale',
	        amountPaid: 'Betalt beløp'
	      },
	      create: {
	        title: 'Opprett ordre'
	      },
	      edit: {
	        orderReference: 'Ordrereferanse',
	        returnOrderComplete: 'Returordre fullført',
	        modalFormTitle: 'PRODUKT REDIGERING',
	        title: 'Endre ordre',
	        detailsLegend: 'Ordredetaljer',
	        ediTitle: 'EDI Ordre',
	        billsAndCreditNotes: 'Faktura og kreditnota fra denne ordren',
	        bill: 'Faktura',
	        creditNote: 'Kreditnota',
	        customerDetails: 'Kundedetaljer',
	        address: 'Adresse',
	        successMessage: 'Oppdatert ordre!',
	        orderProducttitle: 'Ordreprodukt',
	        noProductWarning: 'Ingen produkter er valgt. Klikk på "Legg til" for å legge til en produktlinje manuelt.',
	        addProductButton: 'Opprett produkt',
	        subtotal: 'Nettobeløp',
	        discount: 'Rabatt',
	        tax: 'Merverdiavgift',
	        deposit: 'Pant',
	        rounding: 'Øreavrunding',
	        total: 'Totalbeløp',
	        quantityError: 'Sum kan ikke være 0.',
	        priceError: 'Prisen kan ikke være 0.',
	        productErrorMessage: 'Produkt ikke funnet',
	        orderType: 'Ordretype',
	        client: 'Kunde',
	        createBillButton: 'Opprett faktura',
	        missingEdiDetails: 'EDI detaljer mangler, vennligst kontakt support.',
	        cancelError: 'Ordre kunne ikke kanselleres.',
	        cancelSuccess: 'Ordren(e) er kansellert.',
	        returnSuccess: 'Ordren(e) har blitt returnert.',
	        pleaseConfirmAllOrderProducts: 'Vennligst bekreft antallet du kan levere før du går videre!',
	        pleaseLinkTheSourceOrder: 'Velg hvilken opprinnelig ordre denne ordren stammer fra. Hvis ukjent klikker du "Lag kreditnota".',
	        quantityMustNotBeGreaterThanQuantityOrdered: 'Antallet man bekrefter kan ikke overstige antallet bestilt',
	        originalOrderItems: 'Original Order Items',
	        orText: 'eller',
	        roundInvoiceTotal: 'Aktiver øreavrunding på denne fakturaen',
	        storeName: 'Butikknavn',
	        storeAddress: 'Butikkadresse',
	        requestedDeliveryDate: 'Ønsket leveringsdato',
	        confirmedDeliveryDate: 'Bekreftet leveringsdato',
	        pickupDate: 'Plukkdato',
	        shippingProvider: 'Leveringstype',
	        trackingNumber: 'Sporingsnummer',
	        trackingUrlNotAvail: 'Sporingsadresse er ikke tilgjengelig',
	        company: 'Selskap',
	        name: 'Navn',
	        appointmentDate: 'Avtaledato',
	        appointmentTime: 'Avtaletid',
	        appointmentDuration: 'Varighet',
	        ediNumber: 'EDI nummer',
	        linkedEdiNumber: 'Knyttet EDI nummer',
	        orderNumber: 'Ordrenummer',
	        orderDate: 'Ordredato',
	        orderStatus: 'Ordrestatus',
	        creditNotes: 'Kreditnota',
	        minutes: 'Minutter',
	        unconfirmed: 'Ubekreftet',
	        warehouse: 'Lagersted',
	        availableQty: 'På lager',
	        nonBatch: 'Ingen batch',
	        packageTitle: 'Administrer Pakker',
	        pickup: 'Leveringsstatus',
	        pickupBy: 'Henting av',
	        deliveryDate: 'Leveringsdato',
	        shippingDate: 'Forsendelsesdato',
	        note: 'Merk',
	        shippingOrder: 'Logistikk',
	        shippingOrderText: 'Vis logistikk detaljer',
	        referenceNumber: 'Ordre referanse',
	        internalNote: 'Merk'
	      },
	      package: {
	        newPackageCardTitle: 'Opprett pakke',
	        UnassignedProductCardTitle: 'Ikke-tildelte produkter',
	        created: 'Pakken ble opprettet',
	        error: 'Feil ved oppretting av pakke',
	        addProductToPackageTitle: 'Legg til produkter i pakken',
	        editProductToPackageTitle: 'Rediger produkter i pakken',
	        viewShippingLabel: 'Vis leveringsetikett',
	        viewProductMixLabel: 'Vis pakkseddel etikett',
	        editPackage: 'Rediger pakke',
	        deletePackage: 'Slett pakken',
	        btnAddProduct: 'Legg til produkt',
	        addProduct: 'Legg til produkt',
	        unassignedTable: {
	          name: 'Produktnavn',
	          gtin: 'GTIN',
	          quantityConfirmed: 'Enheter bekreftet',
	          quantityPacked: 'Enheter pakket',
	          quantityUnpacked: 'Enheter ikke pakket'
	        },
	        createdPackage: {
	          sscc: 'SSCC',
	          unitType: 'Enhetstype',
	          numberOfProducts: 'Antall produkter',
	          totalQuantity: 'Totalt antall',
	          totalNetWeight: 'Total nettovekt',
	          totalGrossWeight: 'Total bruttovekt',
	          totalStackWeight: 'Total topplast',
	          products: 'Produkter',
	          table: {
	            gtin: 'GTIN',
	            productName: 'Produktnavn',
	            quantity: 'Mengde',
	            weight: 'Vekt',
	            bestBefore: 'Best før',
	            maxTopLoad: 'Maks topplast',
	            lotBatchNumber: 'Lot / Batch nummer',
	            temperatureRequirement: 'Temperaturbehov'
	          }
	        }
	      }
	    },
	
	    packageOrderProduct: {
	      add: {
	        error: 'Feil!',
	        quantityExceedError: 'Antall overskredet. Vennligst sjekk utpakket antall.',
	        success: 'Vellykket lagt produktet til pakken.'
	      },
	      edit: {
	        error: 'Feil!',
	        quantityExceedError: 'Antall overskredet. Vennligst sjekk utpakket antall.',
	        success: 'Vellykket oppdatert produktet til pakken.'
	      },
	      destroy: {
	        confirm: 'Fjern bestillingsprodukt fra pakke?',
	        error: 'Feil!',
	        success: 'Vellykket fjernet produktet til pakken.'
	      }
	    },
	
	    package: {
	      destroy: {
	        confirm: 'Alle bestillinger i pakken vil ikke bli tildelt. Bokser inni vil bli slettet. Slett pakken?.',
	        error: 'Error!',
	        success: 'Vellykket slettet pakken.'
	      }
	    },
	
	    ediOrders: {
	      index: {
	        title: 'EDI ordreoversikt',
	        cardHeader: 'Ordre # ',
	        orderNumber: 'VP #',
	        ediOrderTypeName: 'Type',
	        created: 'Ny ordre, klar for behandling',
	        confirmed: 'Ordre bekreftet, under behandling',
	        processed: 'Ordre behandlet, under transport',
	        shipped: 'Under transport',
	        picked: 'Ordre plukket',
	        received: 'Levering bekreftet mottatt',
	        completed: 'Ordre fullført',
	        pending: 'Venter',
	        out_of_stock: 'Utsolgt',
	        invoiced: 'Faktura opprettet',
	        invoiced_externally: 'Fakturert eksternt',
	        bill_sent: 'Fakturert',
	        credited: 'Kreditnota opprettet',
	        cancelled: 'Ordre kansellert',
	        shipping_confirmed: 'Ordre behandlet, under transport',
	        invoiced_consolidated: 'Samlefakturert',
	        waiting_autobilling: 'Venter autofaktura',
	        vipps_processing: 'Vipps behandling'
	      },
	      edit: {
	        title: 'EDI ordreinformasjon',
	        orderNumber: 'Ordrenummer',
	        orderReference: 'Ordrereferanse',
	        requestedDeliveryDate: 'Be om leveringsdato',
	        noEdiOrderItemWarning: 'Ingen varer i denne ordren.',
	        ediOrderType: 'EDI ordretype',
	        partyId: 'Butikk ID',
	        storeName: 'Butikknavn',
	        deliveryDate: 'Leveringsdato',
	        ediOrderStatus: 'Status',
	        invalidDeliveryDate: 'Vennligst velg en gyldig leveringsdato.',
	        confirmSuccess: 'Ordre bekreftet.',
	        vippsProcessingTitle: 'Vennligst vent',
	        vippsProcessing: 'Bestillingen behandler Vipps-betalingen, vennligst last inn siden igjen etter noen minutter.',
	        confirmError: 'En feil oppstod i ordren, vennligst prøv igjen senere.',
	        invoiceSuccess: 'Faktura opprettet.',
	        invoiceSentSuccess: 'Faktura sendt.',
	        creditNoteSentSuccess: 'Kreditnota sendt.',
	        invoiceError: 'En feil oppstod i ordren, vennligst prøv igjen senere.',
	        processSuccess: 'Ordre behandlet.',
	        processError: 'En feil oppstod i ordren, vennligst prøv igjen senere.',
	        pleaseConfirmAllOrders: 'Vennligst bekreft alle varer i denne ordren.',
	        cancelSuccess: 'Ordre kansellert.',
	        returnSuccess: 'Ordren(e) har blitt returnert.',
	        confirmCancel: 'Er du sikker på at du ønsker å kansellere denne ordren?',
	        cancelError: 'En feil oppstod i ordren, vennligst prøv igjen senere.',
	        ediOrderSourceWineMonopolyOrderReference: 'Opprinnelig ordrereferanse',
	        orderDate: 'Ordredato',
	        warehouseChanged: 'Lagersted endret'
	      }
	    },
	
	    settings: {
	      generalSettings: 'Generelle Innstillinger',
	      productDisplay: 'Detaljert produktvisning',
	      newField: 'Nytt felt',
	      edi: {
	        defaultEdiProductGroupName: 'Standard EDI produktgruppe navn',
	        defaultEdiClientGroupName: 'Standard EDI kundegruppe navn',
	        defaultEdiClientName: 'Standard EDI kundenavn',
	        defaultEdiClientContactPhoneNumber: 'Standard EDI kundetelefonnummer',
	        defaultEdiClientAddressStreetName: 'Standard EDI kunde gatenavn',
	        defaultEdiClientAddressCityId: 'Standard EDI kunde by',
	        defaultEdiClientAddressZipCode: 'Standard EDI kunde postnummer',
	        defaultEdiTaxPercentage: 'Standard EDI MVA prosent',
	        ediOrderNumberDefault: 'Standard EDI ordrenummer',
	        ediOrderDeliveryNoteNumberDefault: 'Standard EDI pakkseddel'
	      }
	    }
	  },
	
	  layouts: {
	    header: {
	      individual: 'Enkeltpersonforetak (ENK)',
	      company: 'Aksjeselskap (AS)',
	      viewClient: 'Vis kunde'
	    },
	
	    sidebar: {
	      storeSynced: 'Aktiv nettbutikk',
	      dashboard: 'Skrivebord',
	      profile: 'Profil',
	      account: 'Konto',
	      address: 'Adresse',
	      contact: 'Kontakt',
	      settings: 'Instillinger',
	      clientGroups: 'Kundegrupper',
	      clients: 'Kunder',
	      clientGroup: 'Kundegrupper',
	      clientAgreements: 'Kundeavtaler',
	      newAgreement: 'Ny avtale',
	      importAgreement: 'Importer avtale',
	      newOrders: 'Nye',
	      today: 'I dag',
	      upcoming: 'Kommende',
	      members: 'Brukere',
	      calendar: 'Kalender',
	      pending: 'I påvente av',
	      inTransit: 'På vei',
	      confirmed: 'Bekreftet',
	      complete: 'Fullført',
	      recieved: 'Mottatt',
	      invoiced: 'Fakturert',
	      credited: 'Kreditert',
	      cancelled: 'Kansellert',
	      outOfStock: 'Utsolgt',
	      done: 'Ferdig',
	      latest: 'Siste',
	      active: 'Aktive',
	      inActive: 'Inaktive',
	      pastMonth: 'Siste måned',
	      all: 'Alle',
	      productGroups: 'Produktgrupper',
	      production: 'Produksjon',
	      products: 'Produkter',
	      services: 'Tjenester',
	      wordpress: 'Wordpress',
	      orders: 'Ordre',
	      booking: 'BOOKING',
	      ediOrders: 'EDI ordre',
	      orderFilter: 'Ordrestatus',
	      logout: 'Logg ut',
	      publicProfile: 'Offentlig',
	      appointments: 'Avtaler',
	      bills: 'Regnskap',
	      edi: 'EDI',
	      allOrders: 'Alle ordre',
	      reports: 'Rapport',
	      newsletter: 'Nyhetsbrev',
	      subscriberList: 'Lister',
	      orderedPastWeek: 'Bestilt sist uke',
	      orderedPastMonth: 'Bestilt sist måned',
	      neverOrdered: 'Uten ordre',
	      emptyOrders: 'Uten ordre',
	      switchToOrganization: 'Bytt til',
	      supplier: 'Leverandør',
	      warehouse: 'Lagersted',
	      unitOfMeasure: 'Unit of Measures',
	      stock: 'Lager',
	      inventory: 'Lager',
	      billExport: 'Eksport av data',
	      modules: 'Moduler',
	      deactivated: 'Deactivated',
	      notInvoiced: 'Ikke fakturert',
	      orderPickups: {
	        title: 'Orderplukk',
	        viewAll: 'Vis alle'
	      }
	    }
	  },
	  pricingAgreements: {
	    title: 'Prisavtaler',
	    titleWithCount: 'Prisavtaler ({count})',
	    newAgreement: 'Ny avtale',
	    createOne: 'Opprett en',
	    importFromTemplate: 'Importer fra mal',
	    importFromTemplateLink: 'importer fra Excel/CSV-mal',
	    noAgreements: 'Ingen prisavtaler.',
	    customer: 'Kunde',
	    selectCustomer: 'Velg kunde',
	    agreementName: 'Avtalenavn',
	    agreementNamePlaceholder: 'Valgfritt; bruker malens navn hvis tom',
	    file: 'Fil',
	    downloadTemplate: 'Last ned mal (XLSX)',
	    chooseFile: 'Velg fil (CSV eller XLSX)',
	    cancel: 'Avbryt',
	    import: 'Importer',
	    active: 'Aktiv',
	    inactive: 'Inaktiv',
	    valid: 'Gyldig',
	    lineCount: '{n} linje(r)',
	    newPricingAgreement: 'Ny prisavtale',
	    orImportLink: 'Eller',
	    name: 'Navn',
	    namePlaceholder: 'f.eks. Sesongavtale',
	    validFrom: 'Gyldig fra',
	    validTo: 'Gyldig til',
	    from: 'Fra',
	    to: 'Til',
	    save: 'Lagre',
	    createButton: 'Opprett',
	    back: 'Tilbake',
	    editPricingAgreement: 'Rediger prisavtale',
	    product: 'Produkt',
	    products: 'Produkter',
	    addProduct: 'Legg til produkt',
	    searchProductByName: 'Søk produkt etter navn',
	    minQty: 'Min. antall',
	    discountLabel: 'Rabatt',
	    discountPercent: 'Rabatt %',
	    discountAmount: 'Rabattbeløp',
	    discountAmt: 'Rabattbeløp',
	    perUnit: 'Per enhet',
	    comment: 'Kommentar',
	    noProductsInAgreement: 'Ingen produkter i denne avtalen.',
	    productFallback: 'Produkt #',
	    confirm: 'Bekreft',
	    deleteProductConfirm: 'Slette dette produktet fra avtalen?',
	    agreementUpdated: 'Avtale oppdatert',
	    errorUpdatingAgreement: 'Feil ved oppdatering av avtale',
	    productAndMinQtyRequired: 'Produkt og min. antall må fylles ut',
	    setDiscountOrAmount: 'Angi enten Rabatt % eller Rabattbeløp',
	    productAdded: 'Produkt lagt til',
	    errorAddingProduct: 'Feil ved tillegg av produkt',
	    minQtyAtLeast1: 'Min. antall må være minst 1',
	    productUpdated: 'Produkt oppdatert',
	    errorUpdatingProduct: 'Feil ved oppdatering av produkt',
	    productRemoved: 'Produkt fjernet',
	    errorRemovingProduct: 'Feil ved fjerning av produkt',
	    importCreated: 'Avtale opprettet. {count} linje(r) lagt til.',
	    importSkipped: '{count} rad(er) hoppet over.',
	    importFailed: 'Import feilet',
	    unmatchedTitle: 'Koble til produkter (mangler EPD/GTIN)',
	    unmatchedIntro: 'Produkter uten EPD/GTIN eller uten rabatt % vises her. Velg produkt om nødvendig, fyll inn rabatt %, deretter klikk Legg til.',
	    importedName: 'Importert navn',
	    addLine: 'Legg til',
	    lineAdded: 'Linje lagt til',
	    closeAndViewAgreement: 'Lukk og vis avtale',
	    needToMatch: '{count} produkt(er) trenger tilkobling',
	    searchProductsInAgreement: 'Søk produkter',
	    noProductsMatchSearch: 'Ingen produkter matcher søket.',
	    searchAgreements: 'Søk avtaler',
	    noAgreementsMatchSearch: 'Ingen avtaler matcher søk eller filter.',
	    deleteAgreementConfirm: 'Slette denne prisavtalen? Dette kan ikke angres.',
	    customerHasAgreementConfirm: 'Denne kunden har allerede en prisavtale. Vil du fortsette med import?',
	    agreementDeleted: 'Prisavtale slettet',
	    errorDeletingAgreement: 'Feil ved sletting av prisavtale',
	    errorCreatingAgreement: 'Feil ved opprettelse av avtale',
	    validationNameAlreadyExists: 'Denne kunden har allerede en prisavtale med dette navnet.',
	    lines: 'Linjer',
	    actions: 'Handlinger',
	    sortNameAsc: 'Navn (A → Z)',
	    sortNameDesc: 'Navn (Z → A)',
	    sortCustomerAsc: 'Kunde (A → Z)',
	    sortCustomerDesc: 'Kunde (Z → A)',
	    sortValidFromDesc: 'Gyldig fra (nyeste)',
	    sortValidFromAsc: 'Gyldig fra (eldste)',
	    sortProductNameAsc: 'Navn (A til Z)',
	    sortProductNameDesc: 'Navn (Z til A)',
	    sortMinQtyAsc: 'Min. antall (lav til høy)',
	    sortMinQtyDesc: 'Min. antall (høy til lav)'
	  },
	  button: {
	    search: 'Søk',
	    createReminder: 'Lag påminnelse',
	    creditNoteReason: 'Angi Årsak for kreditnota',
	    glnLookup: 'Hent data FRA GLN',
	    markAs: 'Merk som',
	    pending: 'Avventer',
	    updateDraft: 'Oppdater utkastet',
	    updatePending: 'Oppdater Venter',
	    complete: 'Ferdigstill',
	    createReturnOrder: 'Opprett returordre',
	    addClient: 'Legg til ny kunde',
	    addClientGroup: 'Legg til kundegruppe',
	    addBookingOrder: 'Legg til bestillingsordre',
	    addEdiOrder: 'Legg til Edi-ordre',
	    addCampaign: 'Legg til kampanje',
	    addSubscriberList: 'Lag liste',
	    enter: 'Logg inn',
	    expand: 'Utvid',
	    register: 'Registrer',
	    next: 'Neste',
	    getStarted: 'Fullfør registreringen',
	    save: 'Lagre',
	    update: 'Oppdater',
	    view: 'Vis',
	    clear: 'Klar',
	    confirm: 'Bekreft',
	    shippingConfirm: 'Bekreft levering',
	    purcahseReceive: 'Mottatt innkjøp',
	    process: 'Bekreft levering',
	    proceed: 'Bekreft levering',
	    createInvoice: 'Lag faktura',
	    invoiceExternally: 'Merk som: Fakturert eksternt',
	    updateInvoice: 'Oppdater faktura',
	    saveDraft: 'Lagre kladd',
	    markAsCleared: 'Merk som fullført',
	    createCreditNote: 'Lag kreditnota',
	    showPrintableDeliveryNote: 'Vis pakkseddel',
	    downloadPrintableDeliveryNote: 'Last ned pakkseddel',
	    login: 'Logg inn',
	    send: 'Send',
	    resend: 'Send igjen',
	    sendTest: 'Send test epost',
	    cancel: 'Avbryt',
	    cancelEDIOrder: 'Kanseller ordre',
	    cancelOrder: 'Kanseller ordre',
	    cancelOrders: 'Kanseller valgte ordre',
	    delete: 'Slett',
	    deleteProduct: 'Slett produkt',
	    deleteClient: 'Slett kunde',
	    downloadImport: 'Last ned',
	    yes: 'Ja',
	    no: 'Nei',
	    skip: 'Skip',
	    registerCRM: 'Prøv kundesystemet',
	    registerInvoicing: 'Prøv faktura',
	    registerBooking: 'Prøv booking',
	    registerEDI: 'Prøv EDI',
	    editText: 'Rediger mal',
	    testEmail: 'Test',
	    testEmailTitle: 'Send en testfaktura til e-posten din',
	    add: 'Legg til',
	    edit: 'Rediger',
	    book: 'Bestill',
	    close: 'Lukk',
	    markAsDraft: 'Utkast',
	    markAsDone: 'Ta mottak',
	    merge: 'Slå sammen produkter',
	    confirmAsOrder: 'Bekreft som bestilt',
	    import: 'Import',
	    adjustment: {
	      completeAdjustment: 'Fullfør lagerjustering',
	      exportAdjustmentProducts: 'Last ned produkter'
	    },
	    stockCount: {
	      completeStockCount: 'Fullfør lagertelling'
	    },
	    export: 'Eksporter data',
	    dragAndDropImport: 'Dra og slipp filer her...',
	    subscribe: 'Abonnere',
	    unsubscribe: 'Deaktiver',
	    syncData: 'Synkroniser data',
	    startSync: 'Start synkronisering',
	    confirmSync: 'Bekreft synkronisering',
	    syncNow: 'Synkroniser nå',
	    continue: 'Fortsett',
	    fetchFromVmp: 'Hent data fra Vinmonopolet',
	    setMinimumStock: 'Sett minimumsbeholdning',
	    destroy: 'Destruer',
	    unsubscribeAll: 'Avslutt abonnementet på alle',
	    subscribeAll: 'Abonner på alle',
	    goToEditPage: 'Gå til Rediger side',
	    reload: 'Oppdater',
	    bulkPriceUpdate: 'Bulk prisoppdatering'
	  },
	
	  search: {
	    title: {
	      placeholder: 'Søk'
	    }
	  },
	
	  sort: {
	    month: 'Måned',
	    last: 'Siste',
	    older: 'Eldre',
	    newer: 'Nyere',
	    lastName: 'Etternavn',
	    name: 'Navn',
	    title: 'Sorter etter',
	    placeholder: 'Velg',
	    bestPaying: 'Beste kunde',
	    worstPaying: 'Dårligste kunde',
	    biggestDebtors: 'Mest utestående',
	    clientsCountDesc: 'Flest kunder',
	    clientsCountAsc: 'Færrest kunder',
	    lastWeek: 'Forrige uke',
	    last14Days: 'Siste 14 dager',
	    last21Days: 'Siste 21 dager',
	    lastMonth: 'Forrige måned'
	  },
	
	  listType: {
	    all: 'Alle ordre',
	    order: 'Andre ordre',
	    edi: 'EDI ordre'
	  },
	
	  messages: {
	    warning: 'Advarsel',
	    newer: 'Nyere',
	    lastName: 'Etternavn'
	  },
	
	  orderActions: {
	    select: {
	      label: 'Velg handling',
	      placeholder: 'Handling'
	    },
	    confirmOrder: 'Bekreft ordre',
	    confirmShipping: 'Bekreft sending',
	    confirmOrderAndShipping: 'Bekreft ordre & sending',
	    dowloadDeliverySlip: 'Last ned pakkseddel',
	    createInvoice: 'Opprett faktura',
	    cancelOrder: 'Kanseller ordre'
	  },
	
	  productActions: {
	    select: {
	      label: 'Velg handling',
	      placeholder: 'Handling'
	    },
	    activateProduct: 'Aktiver produktet',
	    deactivateProduct: 'Deaktiver produkt',
	    syncToWoo: 'Synkroniser til Nettbutikk'
	  },
	
	  clientActions: {
	    select: {
	      label: 'Velg handling',
	      placeholder: 'Handling'
	    },
	    isSubClient: 'Er underklient',
	    isProducer: 'er produsent',
	    activateClient: 'Aktiver klient',
	    deactivateClient: 'Deaktiver klient'
	  },
	
	  billActions: {
	    markBilledAsPaid: 'Merk faktura som betalt',
	    downloadInvoicePdf: 'Last ned faktura PDF'
	  },
	
	  form: {
	    batch: {
	      transferDate: {
	        placeholder: '',
	        label: 'Dato'
	      },
	      productName: {
	        placeholder: '',
	        label: 'Produkter'
	      },
	      qty: {
	        placeholder: '',
	        label: 'Mengde'
	      },
	      warehouse: {
	        placeholder: '',
	        label: 'Varelager'
	      }
	    },
	    bundleProductPreview: {
	      name: {
	        label: 'Navn',
	        placeholder: 'Navn'
	      },
	      price: {
	        label: 'Pris',
	        placeholder: 'Pris'
	      }
	    },
	    billReminderModal: {
	      title: 'Lag påminnelse',
	      reminderType: {
	        label: 'Type påminnelse',
	        placeholder: ''
	      },
	      feeAmount: {
	        label: 'Gebyrbeløp',
	        placeholder: ''
	      },
	      penaltyFee: {
	        label: 'Straffegebyr',
	        placeholder: '',
	        options: {
	          withFees: 'Med gebyrer',
	          withoutFees: 'Uten gebyrer'
	        }
	      },
	      notes: {
	        label: 'Notater',
	        placeholder: 'Notater'
	      }
	    },
	    license: {
	      organizationNumber: {
	        label: 'Organisasjonsnummer',
	        placeholder: ''
	      },
	      licenseTypeId: {
	        label: 'Lisenstype',
	        placeholder: ''
	      },
	      licensePermitTypeId: {
	        label: 'Tillatelsestype',
	        placeholder: ''
	      },
	      licenseGroupIds: {
	        label: 'Varegrupper',
	        placeholder: ''
	      },
	      validFrom: {
	        label: 'Gyldig fra',
	        placeholder: ''
	      },
	      validTo: {
	        label: 'Gyldig til',
	        placeholder: ''
	      },
	      licenseFile: {
	        label: 'Lisensfil',
	        placeholder: ''
	      },
	      licenseNumber: {
	        label: 'Lisensnummer',
	        placeholder: ''
	      },
	      name: {
	        label: 'Navn',
	        placeholder: ''
	      },
	      streetName: {
	        label: 'Adresse',
	        placeholder: ''
	      },
	      postalCode: {
	        label: 'Postnummer',
	        placeholder: ''
	      },
	      city: {
	        label: 'Poststed',
	        placeholder: ''
	      },
	      municipality: {
	        label: 'Kommune',
	        placeholder: ''
	      },
	      municipalityNumber: {
	        label: 'Kommunenummer',
	        placeholder: ''
	      }
	    },
	    bulkSendTurnOver: {
	      from: {
	        label: 'Fra',
	        placeholder: 'Fra'
	      },
	      subject: {
	        label: 'Emne',
	        placeholder: 'Emne',
	        preset: 'Omsetningsoppgave'
	      },
	      message: {
	        label: 'Beskjed',
	        placeholder: 'Beskjed',
	        preset: 'Se vedlegg for omsetningsoppgaven for'
	      }
	    },
	    vmpSync: {
	      syncFields: {
	        placeholder: 'Velg felt å oppdatere',
	        label: 'Velg felt å oppdatere'
	      }
	    },
	    wooCredentialsModal: {
	      routesTitle: 'Følgende adresser må settes i Woocommerce webhooks',
	      title: 'Woocommerce api (Fra Kundan til Woocommerce)',
	      websiteUrl: {
	        placeholder: 'Nettadresse',
	        label: 'Nettadresse'
	      },
	      apiKey: {
	        placeholder: 'API nøkkel',
	        label: 'API nøkkel'
	      },
	      secretKey: {
	        placeholder: 'Sikkerhetsnøkkel',
	        label: 'Sikkerhetsnøkkel'
	      },
	      language: {
	        placeholder: '',
	        label: 'Språk'
	      },
	      productAttributes: {
	        placeholder: '',
	        label: 'Produktegenskaper'
	      },
	      syncProductGroup: {
	        placeholder: '',
	        label: 'Synkroniser produkttypegruppe/undergruppe'
	      },
	      syncSelectedProductsOnly: {
	        placeholder: '',
	        label: 'Synkroniser kun utvalgte produkter'
	      },
	      secret: {
	        title: 'Woocommerce webhooks (Fra Woocommerce til Kundan)',
	        apiOrderCreated: {
	          placeholder: 'Skriv inn hemmelighet',
	          label: 'Ordre opprettet'
	        },
	        apiOrderUpdated: {
	          placeholder: 'Skriv inn hemmelighet',
	          label: 'Ordre oppdatert'
	        },
	        apiOrderDeleted: {
	          placeholder: 'Skriv inn hemmelighet',
	          label: 'Ordre slettet'
	        },
	        apiCustomerCreated: {
	          placeholder: 'Skriv inn hemmelighet',
	          label: 'Kunde opprettet'
	        },
	        apiCustomerUpdated: {
	          placeholder: 'Skriv inn hemmelighet',
	          label: 'Kunde oppdatert'
	        },
	        apiCustomerDeleted: {
	          placeholder: 'Skriv inn hemmelighet',
	          label: 'Kunde slettet'
	        },
	        apiProductCreated: {
	          placeholder: 'Skriv inn hemmelighet',
	          label: 'Produkt opprettet'
	        },
	        apiProductUpdated: {
	          placeholder: 'Skriv inn hemmelighet',
	          label: 'Produkt oppdatert'
	        },
	        apiProductDeleted: {
	          placeholder: 'Skriv inn hemmelighet',
	          label: 'Produkt slettet'
	        }
	      }
	    },
	    wordpressCredentialsModal: {
	      title: 'Wordpress api',
	      kundanWordpressPluginToken: 'Kundan Wordpress Plugin Token',
	      websiteUrl: {
	        placeholder: 'Website url',
	        label: 'Website url'
	      }
	    },
	    orderInternalNote: {
	      internalNote: {
	        placeholder: 'Internal note',
	        label: 'Internal note'
	      }
	    },
	    orderWarehouse: {
	      warehouseId: {
	        placeholder: 'Velg lagersted',
	        label: 'Lagersted'
	      }
	    },
	    module: {
	      email: {
	        placeholder: 'Enter Email',
	        label: 'Email'
	      },
	      password: {
	        placeholder: 'Enter password',
	        label: 'Password'
	      },
	      consumer_token: {
	        placeholder: 'Enter Consumer Token',
	        label: 'Consumer Token'
	      },
	      employee_token: {
	        placeholder: 'Enter Employee Token',
	        label: 'Employee Token'
	      },
	      fiken_email: {
	        placeholder: 'Skriv inn epost',
	        label: 'Epost'
	      },
	      fiken_password: {
	        placeholder: 'Skriv inn passord',
	        label: 'Passord'
	      },
	      poweroffice_application_key: {
	        placeholder: 'Skriv inn applikasjonsnøkkel',
	        label: 'Applikasjonsnøkkel'
	      },
	      poweroffice_client_key: {
	        placeholder: 'Skriv inn klientnøkkel',
	        label: 'Klientnøkkel'
	      },
	      poweroffice_company_slug: {
	        placeholder: 'Skriv inn bedrifts-slug',
	        label: 'Bedrifts-slug'
	      },
	      poweroffice_app_key: {
	        placeholder: 'Skriv inn app-nøkkel',
	        label: 'App-nøkkel'
	      },
	      poweroffice_integration_type: {
	        placeholder: 'Velg type integrasjon',
	        label: 'Integrasjonstype'
	      },
	      tripletex_consumer_token: {
	        placeholder: 'Enter Consumer Token',
	        label: 'Consumer Token'
	      },
	      tripletex_employee_token: {
	        placeholder: 'Enter Employee Token',
	        label: 'Employee Token'
	      },
	      preferred_invoice_sender: {
	        placeholder: 'Select Preferred Invoice Sender',
	        label: 'Send Invoice From'
	      },
	      preferred_send_type: {
	        placeholder: 'Select Preferred Send Type',
	        label: 'Send Type'
	      },
	      vmp_wholesaler_id: {
	        placeholder: 'Skriv inn VMP grossist ID',
	        label: 'VMP Grossist ID'
	      },
	      public_marketplace: {
	        placeholder: 'Aktiver',
	        label: 'Offentlig markedsplass'
	      },
	      marketplaces_enabled: {
	        placeholder: '',
	        label: 'Partnerbutikk'
	      },
	      ongoing_warehouse_warehouse: {
	        placeholder: '',
	        label: 'Ongoing varelager ID'
	      },
	      ongoing_warehouse_username: {
	        placeholder: '',
	        label: 'Ongoing brukernavn'
	      },
	      ongoing_warehouse_password: {
	        placeholder: '',
	        label: 'Ongoing passord'
	      },
	      ongoing_warehouse_goods_owner_id: {
	        placeholder: '',
	        label: 'Ongoing goods owner ID'
	      }
	    },
	    shippingConfirm: {
	      shippingProviderId: {
	        placeholder: 'Fraktleverandør',
	        label: 'Fraktleverandør'
	      },
	      shippingDate: {
	        placeholder: 'Leveringsdato',
	        label: 'Leveringsdato'
	      },
	      importantReminder: {
	        placeholder: 'Viktig påminnelse',
	        label: 'Viktig påminnelse'
	      }
	    },
	    orderConfirm: {
	      confirmDate: {
	        placeholder: 'Dato bekreftet',
	        label: 'Dato bekreftet'
	      },
	      deliveryDate: {
	        placeholder: 'Leveringsdato',
	        label: 'Leveringsdato'
	      },
	      warehouseId: {
	        placeholder: 'Velg lagersted',
	        label: 'Lagersted'
	      },
	      shippingProviderId: {
	        placeholder: 'Fraktleverandør',
	        label: 'Fraktleverandør'
	      },
	      shippingDate: {
	        placeholder: 'Leveringsdato',
	        label: 'Leveringsdato'
	      }
	    },
	    purchaseReceive: {
	      receiveDate: {
	        placeholder: 'Dato mottatt',
	        label: 'Dato mottatt'
	      }
	    },
	    registerBillPayment: {
	      paymentDate: {
	        placeholder: 'Betalingsdato',
	        label: 'Betalingsdato'
	      },
	      paymentInFull: {
	        placeholder: 'Ja',
	        label: 'Betalt i sin helhet?'
	      },
	      paymentAmount: {
	        placeholder: 'Betalingsbeløp',
	        label: 'Betalingsbeløp'
	      }
	    },
	    billConfirm: {
	      paymentDateOption: {
	        placeholder: 'Velg betalingsdato',
	        label: 'Velg betalingsdato'
	      },
	      paymentDate: {
	        placeholder: 'Betalingsdato',
	        label: 'Betalingsdato'
	      },
	      paymentMethod: {
	        label: 'Betalingsmetoder',
	        placeholder: 'Betalingsmetoder'
	      }
	    },
	    registerCreditNoteReason: {
	      creditNoteReasonId: {
	        label: 'Årsak til krediteringen',
	        placeholder: 'Velg en begrunnelse'
	      },
	      reasonNote: {
	        label: 'Beskrivelse',
	        placeholder: 'Beskrivelse'
	      },
	      additionalDescription: {
	        label: 'Tilleggsinformasjon',
	        placeholder: 'Skriv inn tilleggsinfo (ikke nødvendig)'
	      },
	      systemAttributes: {
	        label: '',
	        placeholder: ''
	      }
	    },
	    billPaymentModal: {
	      title: 'Faktura betaling',
	      amountDue: 'Beløp som forfaller',
	      isFullyPaid: {
	        label: 'Fullt betalt',
	        placeholder: 'Fullt betalt'
	      },
	      paymentMethod: {
	        label: 'Betalingsmåte',
	        placeholder: 'Betalingsmåte'
	      },
	      amountPaid: {
	        label: 'Betalt beløp',
	        placeholder: 'Betalt beløp'
	      },
	      paymentDate: {
	        label: 'Betalingsdato',
	        placeholder: 'Betalingsdato'
	      },
	      reference: {
	        label: 'Referanse',
	        placeholder: 'Referanse'
	      },
	      internalNote: {
	        label: 'Internt notat',
	        placeholder: 'Internt notat'
	      }
	    },
	    register: {
	      businessRegistrationNumber: {
	        label: 'Organisasjonsnummer',
	        placeholder: 'Skriv inn organisasjonsnummer'
	      },
	      firstName: {
	        placeholder: 'Fornavn'
	      },
	      lastName: {
	        placeholder: 'Etternavn'
	      },
	      email: {
	        label: 'Epost',
	        placeholder: 'Hva er din epost?'
	      },
	      password: {
	        placeholder: 'Passord'
	      },
	      passwordConfirmation: {
	        placeholder: 'Gjenta passord'
	      },
	      planId: {
	        placeholder: 'Plan'
	      },
	      organizationTypeId: {
	        placeholder: 'Organisasjonstype'
	      },
	      businessName: {
	        placeholder: 'Hva er ditt selskapsnavn?'
	      },
	      mobile: {
	        placeholder: 'Tlf / mobilnummer'
	      },
	      address: {
	        placeholder: 'Adresse'
	      },
	      postalCode: {
	        placeholder: 'Postnummer'
	      },
	      city: {
	        placeholder: 'Poststed'
	      },
	      country: {
	        placeholder: 'Land'
	      },
	      isVatRegistered: {
	        placeholder: 'MVA registrert'
	      },
	      isRegisteredBusinessEnterprise: {
	        placeholder: 'Registrert i foretaksregisteret'
	      },
	      tosAccepted: {
	        placeholder: 'Jeg har lest og aksepterer <a href="http://www.kundan.no/regler/">regler og vilkårene</a>'
	      },
	      marketingAllowed: {
	        placeholder: 'Jeg ønsker å motta nyheter, tilbud og annen relevant info fra Kundan AS via epost. NB! Dine opplysninger deles aldri med noen tredjepart, og du kan velge å melde deg av når som helst.'
	      }
	    },
	
	    supplier: {
	      basicInformation: 'Grunnleggende informasjon',
	      contactInformation: 'Kontakt informasjon',
	      AddressInformation: 'Adresse informasjon',
	      code: {
	        placeholder: 'Kode',
	        label: 'Leverandørkode'
	      },
	      name: {
	        placeholder: 'Navn',
	        label: 'Leverandørnavn'
	      },
	      email: {
	        placeholder: 'Epost',
	        label: 'Epost'
	      },
	      phonenumber: {
	        placeholder: 'Telefon',
	        label: 'Telefon'
	      },
	      mobilenumber: {
	        placeholder: 'Mobil',
	        label: 'Mobil'
	      },
	      streetName1: {
	        placeholder: 'Adresse',
	        label: 'Adresse'
	      },
	      streetName2: {
	        placeholder: 'Adresse 2',
	        label: 'Adresse 2'
	      },
	      city: {
	        placeholder: 'Postested',
	        label: 'Poststed'
	      },
	      countryId: {
	        placeholder: 'Land',
	        label: 'Land'
	      },
	      postalCode: {
	        placeholder: 'Postkode',
	        label: 'Postkode'
	      }
	    },
	
	    warehouse: {
	      basicInformation: 'Grunnleggende informasjon',
	      contactInformation: 'Kontakt',
	      addressInformation: 'Adresse',
	      warehouseInformation: 'Lager',
	      noData: 'Ingen data',
	      location: {
	        placeholder: 'Sted',
	        label: 'Lagerplassering'
	      },
	      name: {
	        placeholder: 'Navn',
	        label: 'Lagernavn'
	      },
	      isActive: {
	        placeholder: '',
	        label: 'Active'
	      },
	      typeName: {
	        placeholder: 'Lagertype',
	        label: 'Lagertype'
	      },
	      isBonded: {
	        label: 'Tollfritt lager',
	        placeholder: 'Aktiver'
	      },
	      shippingProviders: {
	        label: 'Fraktleverandør alternativer',
	        placeholder: ''
	      },
	      contact: {
	        firstName: {
	          label: 'Fornavn',
	          placeholder: ''
	        },
	        lastName: {
	          label: 'Etternavn',
	          placeholder: ''
	        },
	        email: {
	          label: 'Epostadresse',
	          placeholder: ''
	        },
	        phoneNumber: {
	          label: 'Telefonnummer',
	          placeholder: ''
	        }
	      },
	      address: {
	        streetName1: {
	          label: 'Gatenavn',
	          placeholder: ''
	        },
	        streetName2: {
	          label: 'Gatenavn 2',
	          placeholder: ''
	        },
	        postalCode: {
	          label: 'Postnummer',
	          placeholder: ''
	        },
	        city: {
	          label: 'By',
	          placeholder: ''
	        },
	        countryId: {
	          label: 'Land',
	          placeholder: ''
	        }
	      },
	      productTab: {
	        modal: {
	          title: 'Lagerbeholdning',
	          minimumStockLevel: {
	            label: 'Minimum lagernivå',
	            placeholder: 'Minimum lagernivå'
	          }
	        }
	      }
	    },
	
	    unitOfMeasure: {
	      basicInformation: 'Basic Information',
	      code: {
	        placeholder: 'Code',
	        label: 'Unit of Measure Code'
	      },
	      name: {
	        placeholder: 'Name',
	        label: 'Unit of Measure Name'
	      }
	    },
	
	    stock: {
	      basicInformation: 'Generell Informasjon',
	      warehouseId: {
	        placeholder: 'Lagersted',
	        label: 'Lagersted'
	      },
	      name: {
	        placeholder: 'Navn på lagertelling',
	        label: 'Navn på lagertelling'
	      },
	      descriptions: {
	        placeholder: 'Skriv inn ønsket beskrivelse',
	        label: 'Beskrivelse'
	      },
	      transactionDate: {
	        placeholder: '',
	        label: 'Transaksjonsdato'
	      }
	    },
	
	    adjustment: {
	      basicInformation: 'Generell Informasjon',
	      stockId: {
	        placeholder: 'Lagertelling',
	        label: 'Lagertelling'
	      },
	      reason: {
	        placeholder: 'Årsak',
	        label: 'Årsak'
	      },
	      warehouseId: {
	        placeholder: 'Lagersted',
	        label: 'Lagersted'
	      },
	      adjustmentTypeId: {
	        placeholder: 'Justeringstype',
	        label: 'Justeringstype'
	      },
	      adjustmentTypeList: {
	        adjustment: 'Lagerjustering',
	        wastage: 'Manko (avg.kode "99")',
	        destruction: 'Tilintetgjort (avg.kode "40")'
	      },
	      adjustmentStatus: {
	        completed: 'Fullført',
	        draft: 'Kladd',
	        pending: 'Ventende',
	        sent: 'Sendte',
	        cancelled: 'Avbrutt',
	        deviation: 'Avvik / feilet'
	      }
	    },
	
	    purchase: {
	      basicInformation: 'Generell Informasjon',
	      producerId: {
	        placeholder: 'Produsent',
	        label: 'Produsent'
	      },
	      supplierId: {
	        placeholder: 'Velg leverandør',
	        label: 'Leverandør'
	      },
	      comments: {
	        placeholder: 'Kommentar',
	        label: 'Kommentar'
	      },
	      name: {
	        placeholder: 'Navn',
	        label: 'Navn'
	      },
	      purchaseNumber: {
	        placeholder: 'Innkjøpsreferanse',
	        label: 'Innkjøpsreferanse'
	      },
	      warehouseId: {
	        placeholder: 'Velg lagersted',
	        label: 'Lagersted'
	      },
	      status: {
	        placeholder: 'Velg status',
	        label: 'Status'
	      },
	      expectedDeliveryDate: {
	        placeholder: 'Velg dato',
	        label: 'Forventet leveringsdato'
	      },
	      edit: {
	        sendPurchaseSuccess: 'Kjøp ble sendt.',
	        sendPurchaseError: 'Det oppstod en feil med kjøpet. Prøv igjen senere.'
	      }
	    },
	
	    transfer: {
	      basicInformation: 'Overføringsdetaljer',
	      date: {
	        placeholder: 'Overføringdato',
	        label: 'Overføringdato'
	      },
	      transferType: {
	        placeholder: 'Overføringstype',
	        label: 'Overføringstype'
	      },
	      fromWarehouseId: {
	        placeholder: 'Fra lager',
	        label: 'Fra lager'
	      },
	      toWarehouseId: {
	        placeholder: 'Til lager',
	        label: 'Til lager'
	      },
	      batchId: {
	        placeholder: 'Velg batch',
	        label: 'Velg batch'
	      },
	      comments: {
	        placeholder: 'Kommentar',
	        label: 'Kommentar'
	      },
	      products: {
	        placeholder: 'Velg et produkt',
	        label: 'Produkter'
	      },
	      batches: {
	        placeholder: 'Velg en batch',
	        label: 'Batcher'
	      },
	      productId: {
	        label: 'Produktnavn',
	        placeholder: 'Velg produkt'
	      },
	      qty: {
	        label: 'Antall',
	        placeholder: 'Antall'
	      }
	    },
	
	    personalInfo: {
	      phoneNumber: {
	        placeholder: 'Telefonnummer'
	      },
	      streetName: {
	        placeholder: 'Adresse'
	      },
	      secondStreetName: {
	        placeholder: 'Adresse 2'
	      },
	      postalCode: {
	        placeholder: 'Postnummer'
	      },
	      countryId: {
	        placeholder: 'Velg land'
	      },
	      cityName: {
	        placeholder: 'By'
	      }
	    },
	
	    login: {
	      email: {
	        placeholder: 'Epost'
	      },
	      password: {
	        placeholder: 'Passord'
	      }
	    },
	
	    resetPassword: {
	      email: {
	        placeholder: 'Skriv din epost'
	      }
	    },
	
	    twoFactorVerification: {
	      code: {
	        label: 'Skriv inn kode',
	        placeholder: 'Skriv inn kode'
	      },
	      verifyButton: {
	        label: 'Bekrefte'
	      },
	      resendButton: {
	        label: 'Sende'
	      }
	    },
	
	    accountInformation: {
	      email: {
	        label: 'Epost',
	        placeholder: 'Epost'
	      },
	      firstName: {
	        label: 'Fornavn',
	        placeholder: 'Fornavn'
	      },
	      lastName: {
	        label: 'Etternavn',
	        placeholder: 'Etternavn'
	      },
	      userEmail: {
	        label: 'Epost',
	        placeholder: 'Epost'
	      },
	      userFirstName: {
	        label: 'Fornavn',
	        placeholder: 'Fornavn'
	      },
	      userLastName: {
	        label: 'Etternavn',
	        placeholder: 'Etternavn'
	      },
	      bankAccount: {
	        label: 'Bankkonto',
	        placeholder: 'Bankkonto'
	      },
	      smallScaleManufacturer: {
	        label: 'Årlig produksjon over 500.000 liter',
	        placeholder: 'Aktiver'
	      },
	      businessRegistrationNumber: {
	        label: 'Organisasjonsnummer',
	        placeholder: 'Registreringsnummer'
	      },
	      isInternational: {
	        label: 'Utenlandsbetaling',
	        placeholder: 'Aktiver'
	      },
	      bankName: {
	        label: 'Bank navn',
	        placeholder: 'Bank navn'
	      },
	      swift: {
	        label: 'Swift',
	        placeholder: 'Swift'
	      },
	      iban: {
	        label: 'IBAN',
	        placeholder: 'IBAN'
	      },
	      isVatRegistered: {
	        label: 'Registrert i Merverdiavgiftsregisteret',
	        placeholder: 'Aktiver'
	      },
	      isRegisteredBusinessEnterprise: {
	        label: 'Registrert i Foretaksregisteret',
	        placeholder: 'Aktiver'
	      },
	      organizationTypeId: {
	        label: 'Velg organisasjonstype',
	        placeholder: 'Organisasjonstype'
	      },
	      organizationName: {
	        label: 'Selskapsnavn',
	        placeholder: 'Selskapsnavn'
	      },
	      organizationDescription: {
	        label: 'Selskaps beskrivelse',
	        placeholder: 'Selskaps beskrivelse'
	      },
	      organizationProfilePicture: {
	        label: 'Organisasjons profilbilde',
	        placeholder: 'Organisasjons profilbilde'
	      },
	      phoneNumber: {
	        label: 'Telefonnummer',
	        placeholder: 'Telefonnummer'
	      },
	      mobileNumber: {
	        label: 'Mobilnummer',
	        placeholder: 'Mobilnummer'
	      },
	      streetName: {
	        label: 'Adresse',
	        placeholder: 'Adresse'
	      },
	      gs1number: {
	        label: 'GS1 leverandørnummer',
	        placeholder: 'GS1 leverandørnummer'
	      }
	    },
	
	    passwordForm: {
	      currentPassword: {
	        label: 'Nåværende passord',
	        placeholder: 'Nåværende passord'
	      },
	      password: {
	        label: 'Passord',
	        placeholder: 'Passord'
	      },
	      passwordConfirmation: {
	        label: 'Gjenta passord',
	        placeholder: 'Gjenta passord'
	      }
	    },
	
	    contactForm: {
	      email: {
	        label: 'Epost',
	        placeholder: 'Epost'
	      },
	      firstName: {
	        label: 'Fornavn',
	        placeholder: 'Fornavn'
	      },
	      lastName: {
	        label: 'Etternavn',
	        placeholder: 'Etternavn'
	      },
	      phoneNumber: {
	        label: 'Telefonnummer',
	        placeholder: 'Telefonnummer'
	      },
	      mobileNumber: {
	        label: 'Mobilnummer',
	        placeholder: 'Mobilnummer'
	      },
	      streetName: {
	        label: 'Adresse',
	        placeholder: 'Adresse'
	      },
	      secondStreetName: {
	        label: 'Adresse 2',
	        placeholder: 'Adresse 2'
	      },
	      postalCode: {
	        label: 'Postkode',
	        placeholder: 'Postkode'
	      },
	      countryId: {
	        label: 'Land',
	        placeholder: 'Land'
	      },
	      cityName: {
	        label: 'By',
	        placeholder: 'By'
	      },
	      careOf: {
	        label: 'C/O',
	        placeholder: 'C/O'
	      }
	    },
	
	    userSettingForm: {
	      language: {
	        label: 'Språk',
	        placeholder: 'Velg Språk'
	      }
	    },
	
	    profileAddress: {
	      streetName: {
	        label: 'Adresse',
	        placeholder: 'Adresse'
	      },
	      secondStreetName: {
	        label: 'Adresse 2',
	        placeholder: 'Adresse 2'
	      },
	      postalCode: {
	        label: 'Postnummer',
	        placeholder: 'Postnummer'
	      },
	      countryId: {
	        label: 'Velg land',
	        placeholder: 'Velg land'
	      },
	      cityName: {
	        label: 'Velg by',
	        placeholder: 'Velg by'
	      }
	    },
	
	    profileContact: {
	      email: {
	        label: 'Epost',
	        placeholder: 'Epost'
	      },
	      firstName: {
	        label: 'Fornavn',
	        placeholder: 'Fornavn'
	      },
	      lastName: {
	        label: 'Etternavn',
	        placeholder: 'Etternavn'
	      },
	      phoneNumber: {
	        label: 'Telefonnummer',
	        placeholder: 'Telefonnummer'
	      },
	      mobileNumber: {
	        label: 'Mobilnummer',
	        placeholder: 'Mobilnummer'
	      }
	    },
	
	    organizationSettings: {
	      penaltyTypeForDueInvoice: {
	        label: 'Reminder Type for Due Invoice',
	        placeholder: 'Reminder Type for Due Invoice'
	      },
	      penaltyFee: {
	        label: 'Penalty fee',
	        placeholder: 'Penalty fee'
	      },
	      interestPercentage: {
	        label: 'Interest percentage',
	        placeholder: 'Interest percentage'
	      },
	      penaltyAfter: {
	        label: 'After dueDate start penalty in (days)',
	        placeholder: 'No. of days'
	      },
	      tosAccepted: {
	        label: 'Akseptering av regler',
	        placeholder: 'Som bruker av Kundan, har vi lest og akseptert følgende regler og bruksvilkår: http://www.kundan.no/regler/'
	      },
	      marketingAllowed: {
	        label: 'Ønsker info pr. epost',
	        placeholder: 'Vi takker ja til å motta nyheter, tilbud og annen relevant info via epost fra Kundan AS.'
	      },
	      customTos: {
	        label: 'Egne bruksvilkår',
	        placeholder: 'Her kan du spesifisere bruksvilkår for dine egne produkter og tjenester.'
	      },
	      customOrderProductNote: {
	        label: 'Ordrelinje notat',
	        placeholder: 'Her kan du ved bruk av variabler spesifisere om du ønsker ordrelinje notater opprettet automatisk basert på lagrede produkt data.'
	      },
	      facebookPixelId: {
	        label: 'Facebook Piksel ID',
	        placeholder: 'Facebook Piksel ID'
	      },
	      defaultClientGroupId: {
	        label: 'Standard kundegruppe',
	        placeholder: 'Velg kundegruppe som skal være standard'
	      },
	      defaultDueDays: {
	        label: 'Standard forfallsdager',
	        placeholder: 'Standard forfallsdager'
	      },
	      billingNumberDefault: {
	        label: 'Nummerserie faktura',
	        placeholder: 'Nummerserie faktura'
	      },
	      orderNumberDefault: {
	        label: 'Nummerserie ordre',
	        placeholder: 'Nummerserie ordre'
	      },
	      productNumberDefault: {
	        label: 'Nummerserie produkt',
	        placeholder: 'Nummerserie produkt'
	      },
	      productNumberInitial: {
	        label: 'Selskapforkortelse',
	        placeholder: 'Selskapforkortelse (3 bokstaver)'
	      },
	      defaultProductTypeName: {
	        label: 'Standard produkttype',
	        placeholder: 'Standard produkttype'
	      },
	      customerNumberDefault: {
	        label: 'Nummerserie kunde',
	        placeholder: 'Nummerserie kunde'
	      },
	      supplierNumberDefault: {
	        label: 'Nummerserie leverandør',
	        placeholder: 'Nummerserie leverandør'
	      },
	      timeslotGap: {
	        label: 'Bestilling tilgjengelig hvert (minutt)',
	        placeholder: 'Antall minutt'
	      },
	      invoiceNotes: {
	        label: 'Faktura notat',
	        placeholder: 'Notat som vises i faktura.'
	      },
	      billNotes: {
	        label: 'Regningsnotater',
	        placeholder: 'Notater som skal vises i regningen PDF.'
	      },
	      creditNoteNotes: {
	        label: 'Kreditnota notat ',
	        placeholder: 'Notat som vises i kreditnota.'
	      },
	      remindersEnabled: {
	        label: 'Aktiver 24 timers påminnelse',
	        placeholder: 'Aktiver påminnelse'
	      },
	      messageTemplateTypeId: {
	        label: 'Meldingstype',
	        placeholder: 'Velg en type'
	      },
	      smsFrom: {
	        label: 'SMS avsender',
	        placeholder: 'SMS avsender'
	      },
	      roundInvoiceTotal: {
	        label: 'Automatisk øreavrunding',
	        placeholder: 'Aktiver øreavrunding (kan overstyres fra hver faktura)'
	      },
	      invoiceEmailTitle: {
	        label: 'Faktura epost emne',
	        placeholder: 'Faktura epost emne',
	        tooltip: 'Tilgjengelige variabler: <br/><br/>Kundens fulle navn: {customer_name} <br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Fakturanummer: {bill_number}'
	      },
	      invoiceEmailTemplate: {
	        label: 'Faktura epost innhold',
	        placeholder: 'Faktura epost innhold',
	        tooltip: 'Tilgjengelige variabler: <br/><br/>Kundens fulle navn: {customer_name} <br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Fakturanummer: {bill_number}'
	      },
	      creditNoteEmailTitle: {
	        label: 'Kreditnota epost emne',
	        placeholder: 'Kreditnota epost emne'
	      },
	      creditNoteEmailTemplate: {
	        label: 'Kreditnota epost innhold',
	        placeholder: 'Kreditnota epost innhold'
	      },
	      reminderEmailTitle: {
	        label: 'Betalingspåminnelse - epost emne',
	        placeholder: 'Betalingspåminnelse - epost emne',
	        tooltip: 'Tilgjengelige variabler:<br/><br/>Navn på bedrift/individ: {customer_name} <br/>Regningsnummer: {bill_number}<br/>Fakturalink: {link}<br/>Organisasjonsnavn: {organization_name}<br/>Organisasjonskontaktnavn: {organization_contact_name}<br/>Tidsfrist: {due_date}'
	      },
	      reminderEmailTemplate: {
	        label: 'Betalingspåminnelse - epost innhold',
	        placeholder: 'Betalingspåminnelse - epost innhold',
	        tooltip: 'Tilgjengelige variabler:<br/><br/>Navn på bedrift/individ: {customer_name} <br/>Regningsnummer: {bill_number}<br/>Fakturalink: {link}<br/>Organisasjonsnavn: {organization_name}<br/>Organisasjonskontaktnavn: {organization_contact_name}<br/>Tidsfrist: {due_date}'
	      },
	      orderConfirmNotificationEmailTitle: {
	        label: 'Tittel på mal for bestillingsbekreftelse på e-post',
	        placeholder: 'Tittel på mal for bestillingsbekreftelse på e-post',
	        tooltip: 'Variabler tilgjengelig:<br/><br/>Navn på bedrift/individ: {customer_name} <br/>Ordrenummer: {order_number}<br/>Rekkefølge: {order}<br/>Organisasjonsnavn: {organization_name}'
	      },
	      orderConfirmNotificationEmailTemplate: {
	        label: 'E-postmal for bestillingsbekreftelse',
	        placeholder: 'E-postmal for bestillingsbekreftelse',
	        tooltip: 'Variabler tilgjengelig:<br/><br/>Navn på bedrift/individ: {customer_name} <br/>Ordrenummer: {order_number}<br/>Rekkefølge: {order}<br/>Organisasjonsnavn: {organization_name}'
	      },
	      orderTrackingEmailTitle: {
	        label: 'tittel for e-postmal for ordresporing',
	        placeholder: 'Tittel for e-postmal for ordresporing',
	        tooltip: 'Variabler tilgjengelig:<br/><br/>Navn på bedrift/individ: {customer_name} <br/>Ordrenummer: {order_number}<br/>Rekkefølge: {order}<br/>Ordresporingsnummer: {order_tracking_number}<br/>Bestillingssporingslenke: {tracking}<br/>Organisasjonsnavn: {organization_name}'
	      },
	      orderTrackingEmailTemplate: {
	        label: 'E-postmal for ordresporing',
	        placeholder: 'E-postmal for bestillingssporing',
	        tooltip: 'Variabler tilgjengelig:<br/><br/>Navn på bedrift/individ: {customer_name} <br/>Ordrenummer: {order_number}<br/>Rekkefølge: {order}<br/>Ordresporingsnummer: {order_tracking_number}<br/>Bestillingssporingslenke: {tracking}<br/>Organisasjonsnavn: {organization_name}'
	      },
	      accountingProviderId: {
	        label: 'Regnskapssystem',
	        placeholder: 'Velg regnskapsleverandør'
	      },
	      coa1460: {
	        label: 'Innkjøpte varer for videresalg',
	        placeholder: ''
	      },
	      coa1500: {
	        label: 'Kundefordringer',
	        placeholder: ''
	      },
	      coa1610: {
	        label: 'Inngående merverdiavgift',
	        placeholder: ''
	      },
	      coa1910: {
	        label: 'Kasse',
	        placeholder: ''
	      },
	      coa1920: {
	        label: 'Bankinnskudd',
	        placeholder: ''
	      },
	      coa2400: {
	        label: 'Leverandørgjeld',
	        placeholder: ''
	      },
	      coa2700: {
	        label: 'Utgående merverdiavgift',
	        placeholder: ''
	      },
	      coa3010: {
	        label: 'Salgsinntekt egentilv. varer avgiftspl. høy sats',
	        placeholder: ''
	      },
	      coa3020: {
	        label: 'Salgsinntekt tjenester avgiftspl. høy sats',
	        placeholder: ''
	      },
	      coa3060: {
	        label: 'Uttak av varer avgiftspliktig høy sats',
	        placeholder: ''
	      },
	      coa3080: {
	        label: 'Rabatter og annen salgsinntektsred., avgiftspl.',
	        placeholder: ''
	      },
	      ediBillingProcess: {
	        label: 'EDI faktureringsmetode ved varemottak',
	        placeholder: 'EDI faktureringsmetode'
	      },
	      paymentIdentitificationGeneration: {
	        label: 'Aktiver KID generering',
	        placeholder: ''
	      },
	      paymentIdentitificationTemplate: {
	        label: 'KID mal',
	        placeholder: ''
	      },
	      paymentIdentitificationNumberLength: {
	        label: 'KID lengde (kontrollsiffer kommer i tillegg)',
	        placeholder: ''
	      },
	      paymentIdentitificationModulusType: {
	        label: 'Modulus type',
	        placeholder: ''
	      },
	      defaultShippingProvider: {
	        label: 'Standard fraktleverandør',
	        placeholder: ''
	      },
	      defaultWarehouse: {
	        label: 'Standard varelager',
	        placeholder: ''
	      },
	      priceFields: {
	        label: 'Aktive prisfelter',
	        placeholder: ''
	      },
	      visiblePriceFields: {
	        label: 'Synlige prisfelt',
	        placeholder: ''
	      },
	      defaultPriceField: {
	        label: 'Standard prisfelt',
	        placeholder: ''
	      },
	      email_invoice_copy: {
	        label: 'Email',
	        placeholder: 'Email'
	      },
	      percentage: {
	        label: 'Prosentdel (%)',
	        placeholder: 'Prosentdel (%)'
	      },
	      enableRounding: {
	        label: 'Aktiver avrunding',
	        placeholder: 'Aktiver avrunding'
	      },
	      roundingType: {
	        label: 'Avrundingstype',
	        placeholder: 'Avrundingstype',
	        options: {
	          nearest_1: 'Nærmeste 1',
	          nearest_0_50: 'Nærmeste 0,50',
	          nearest_0_25: 'Nærmeste 0,25',
	          nearest_0_99: 'Nærmeste 0,99',
	          round_half_up: 'Rund Av Opp Halvveis',
	          round_half_down: 'Rund Av Ned Halvveis',
	          round_half_even: 'Rund Av Halvveis Til Nærmeste Partall (Bankrunding)',
	          round_towards_zero: 'Rund Mot Null',
	          round_away_from_zero: 'Rund Bort Fra Null'
	        }
	      },
	      priceType: {
	        label: 'Pristype',
	        placeholder: 'Pristype'
	      }
	    },
	
	    emailFormSettings: {
	      emails: {
	        label: 'Emails',
	        placeholder: 'Emails'
	      }
	    },
	
	    checkout: {
	      bookingRequireAddress: {
	        label: 'Adresse påkrevd',
	        placeholder: 'Ja'
	      },
	      bookingRequirePayment: {
	        label: 'Betaling påkrevd',
	        placeholder: 'Ja'
	      }
	    },
	
	    publicProfile: {
	      profileUrl: {
	        label: 'Profil nettside',
	        placeholder: 'Profil nettside'
	      },
	      header: {
	        label: 'Nettside overskrift',
	        placeholder: 'Overskrift'
	      },
	      subheader: {
	        label: 'Nettside undertekst',
	        placeholder: 'Undertekst'
	      },
	      defaultReminderTitle: {
	        label: 'Påminnelses emne',
	        placeholder: 'Påminnelses emne',
	        tooltip: 'Tilgjengelige variabler: <br/><br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Bestilt produkt: {product}<br/>Dato: {date}<br/>Tid: {time}'
	      },
	      defaultReminder: {
	        label: 'Påminnelses beskjed',
	        placeholder: 'Påminnelses beskjed',
	        tooltip: 'Tilgjengelige variabler: <br/><br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Bestilt produkt: {product}<br/>Dato: {date}<br/>Tid: {time}'
	      },
	      defaultCancelMessageTitle: {
	        label: 'Kansellerings emne',
	        placeholder: 'Kansellerings emne',
	        tooltip: 'Tilgjengelige variabler: <br/><br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Bestilt produkt: {product}<br/>Dato: {date}<br/>Tid: {time}'
	      },
	      defaultCancelMessage: {
	        label: 'Kansellerings beskjed',
	        placeholder: 'Kansellerings beskjed',
	        tooltip: 'Tilgjengelige variabler: <br/><br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Bestilt produkt: {product}<br/>Dato: {date}<br/>Tid: {time}'
	      },
	      appointmentConfirmationTitle: {
	        label: 'Bekreftelses emne',
	        placeholder: 'Bekreftelses emne',
	        tooltip: 'Tilgjengelige variabler: <br/><br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Bestilt produkt: {product}<br/>Dato: {date}<br/>Tid: {time}'
	      },
	      appointmentConfirmationTemplate: {
	        label: 'Bekreftelses beskjed',
	        placeholder: 'Bekreftelses beskjed',
	        tooltip: 'Tilgjengelige variabler: <br/><br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Bestilt produkt: {product}<br/>Dato: {date}<br/>Tid: {time}'
	      },
	      backgroundImage: {
	        label: 'Bakgrunnsbilde',
	        placeholder: 'Bakgrunnsbilde',
	        changeImage: 'Endre bilde'
	      }
	    },
	
	    clientGroups: {
	      name: {
	        label: 'Navn',
	        placeholder: 'Navn'
	      },
	      description: {
	        label: 'Beskrivelse',
	        placeholder: 'Beskrivelse'
	      },
	      priceFieldId: {
	        label: 'Prisfelt',
	        placeholder: 'Prisfelt'
	      },
	      receivables_account_id: {
	        label: 'Fordringskonto',
	        placeholder: 'Fordringskonto',
	        help: 'Brukes ved regnskapseksport når en kunde i gruppen ikke har egen fordringskonto.'
	      }
	    },
	
	    clients: {
	      basicInformation: 'Grunnleggende Informasjon',
	      otherInformation: 'Annen informasjon',
	      contacts: 'Kontakt',
	      addresses: 'Adresser',
	      licenses: 'Lisenser',
	      postalAddressError: 'Informasjon om postadresse er obligatorisk.',
	      primaryContactError: 'Primær kontaktinformasjon er obligatorisk.',
	      addContact: 'Legg til kontakt',
	      noContactWarning: 'Ingen kontakter ennå.',
	      isSubClient: {
	        label: 'Er underenhet',
	        placeholder: 'Aktiv'
	      },
	      projectId: {
	        label: 'Prosjekt',
	        placeholder: ''
	      },
	      billMainParent: {
	        label: 'Hovedenhet faktureres',
	        placeholder: ''
	      },
	      dueDays: {
	        label: 'Forfallsdager',
	        placeholder: 'Forfallsdager'
	      },
	      clientTypes: {
	        label: 'Type',
	        placeholder: 'Type'
	      },
	      startBilling: {
	        label: 'Start fakturering',
	        placeholder: 'Start fakturering'
	      },
	      billingInterval: {
	        label: 'Faktureringsintervall',
	        placeholder: 'Faktureringsintervall'
	      },
	      automaticBilling: {
	        label: 'Automatisk fakturering',
	        placeholder: 'Automatisk fakturering'
	      },
	      billingType: {
	        label: 'Faktureringstype',
	        placeholder: 'Faktureringstype'
	      },
	      externalCustomerNumber: {
	        label: 'Eksternt kunde #',
	        placeholder: ''
	      },
	      orderReference: {
	        label: 'Ordrereferanse',
	        placeholder: ''
	      },
	      orderNote: {
	        label: 'Ordrenotat',
	        placeholder: ''
	      },
	      priceFieldId: {
	        label: 'Prisfelt',
	        placeholder: 'Velg prisfelt'
	      },
	      receivables_account_id: {
	        label: 'Regnskapskonto',
	        placeholder: 'Velg regnskapskonto',
	        help: 'Hvis tom brukes kundegruppens fordringskonto (hvis satt) før organisasjonens standard.'
	      },
	      pricePercentageDiscount: {
	        label: 'Kunde rabatt (%)',
	        placeholder: 'Kunde rabatt (%)'
	      },
	      languageId: {
	        label: 'Språk',
	        placeholder: 'Velg språk'
	      },
	      currencyId: {
	        label: 'Valuta',
	        placeholder: 'Valuta'
	      },
	      typeId: {
	        label: 'Type',
	        placeholder: 'Type'
	      },
	      clientGroupId: {
	        label: 'Velg kundegruppe',
	        placeholder: 'Velg kundegruppe'
	      },
	      fullName: {
	        label: 'Fullt navn',
	        placeholder: 'Fornavn'
	      },
	      firstName: {
	        label: 'Fornavn',
	        placeholder: 'Fornavn'
	      },
	      lastName: {
	        label: 'Etternavn',
	        placeholder: 'Etternavn'
	      },
	      clientParent: {
	        label: 'Hovedenhet',
	        placeholder: 'Hovedenhet'
	      },
	      companyName: {
	        label: 'Selskapsnavn',
	        placeholder: 'Selskapsnavn'
	      },
	      clientType: {
	        label: 'Kundetype',
	        placeholder: 'Kundetype'
	      },
	      contactType: {
	        label: 'Kontakttype',
	        placeholder: 'Kontakttype'
	      },
	      email: {
	        label: 'Epost',
	        placeholder: 'Epost'
	      },
	      invoiceSendMethod: {
	        label: 'Fakturametode',
	        placeholder: 'Velg ønsket fakturametode'
	      },
	      phoneNumber: {
	        label: 'Telefonnummer',
	        placeholder: 'Telefonnummer'
	      },
	      mobileNumber: {
	        label: 'Mobilnummer',
	        placeholder: 'Mobilnummer',
	        tooltip: 'Mobilnummeret  må være i formatet 4xx xx xxx or 9xx xx xxx.'
	      },
	      careOf: {
	        label: 'C/O:',
	        placeholder: 'C/O'
	      },
	      streetName: {
	        label: 'Adresse',
	        placeholder: 'Adresse'
	      },
	      secondStreetName: {
	        label: 'Adresse 2',
	        placeholder: 'Adresse 2'
	      },
	      postalCode: {
	        label: 'Postnummer',
	        placeholder: 'Postnummer'
	      },
	      countryId: {
	        label: 'Velg land',
	        placeholder: 'Velg land'
	      },
	      cityId: {
	        label: 'By',
	        placeholder: 'By'
	      },
	      cityName: {
	        label: 'By',
	        placeholder: 'By'
	      },
	      picture: {
	        label: 'Velg bilde',
	        placeholder: 'Velg bilde',
	        placeholder2: 'Klikk for å laste opp',
	        changeImage: 'Endre bilde'
	      },
	      organizationNumber: {
	        label: 'Organisasjonsnummer',
	        placeholder: 'Skriv inn org. nummer'
	      },
	      licenceTypeId: {
	        label: 'Type kunde',
	        placeholder: 'Velg type'
	      },
	      isProducer: {
	        label: 'Er produsent',
	        placeholder: 'Aktiv'
	      },
	      isSupplier: {
	        placeholder: 'Er leverandør',
	        label: 'Aktiv'
	      },
	      isActive: {
	        label: 'Aktiv kunde',
	        placeholder: 'Aktiv'
	      },
	      manualProcessOrder: {
	        label: 'Manuell order godkjenning',
	        placeholder: 'Aktiv'
	      },
	      gln: {
	        label: 'GLN number',
	        placeholder: 'GLN number'
	      },
	      glnXKoord: {
	        label: 'GLN x-coordinates',
	        placeholder: 'GLN x-coordinates'
	      },
	      glnYKoord: {
	        label: 'GLN y-coordinates',
	        placeholder: 'GLN y-coordinates'
	      },
	      syncToWoo: {
	        label: 'Synkroniser til Nettbutikk',
	        placeholder: ''
	      }
	    },
	
	    catalogues: {
	      actionCode: {
	        label: 'Type',
	        placeholder: 'Type'
	      },
	      productGroupId: {
	        label: 'Produktgruppe',
	        placeholder: 'Produktgruppe'
	      },
	      name: {
	        label: 'Katalog navn',
	        placeholder: 'Katalog navn'
	      },
	      issuedAt: {
	        label: 'Dato utstedet',
	        placeholder: 'Dato utstedet'
	      },
	      versionId: {
	        label: 'Versjon',
	        placeholder: 'Versjon'
	      },
	      validFrom: {
	        label: 'Gyldig fra',
	        placeholder: 'Gyldig fra'
	      },
	      validTo: {
	        label: 'Gyldig til',
	        placeholder: 'Gyldig til'
	      },
	      reference: {
	        label: 'Referanse',
	        placeholder: 'Referanse'
	      },
	      note: {
	        label: 'Intern notat',
	        placeholder: 'Intern notat'
	      }
	    },
	
	    producers: {
	      typeId: {
	        label: 'Type',
	        placeholder: 'Type'
	      },
	      name: {
	        label: 'Firmanavn',
	        placeholder: 'Skriv inn firmanavn'
	      }
	    },
	
	    billingTypes: {
	      options: {
	        single: 'Enkeltvis',
	        consolidate: 'Samlet'
	      }
	    },
	
	    automaticBilling: {
	      options: {
	        none: 'Ingen',
	        weekly: 'Ukentlig',
	        monthly: 'Månedlig'
	      }
	    },
	
	    billingInterval: {
	      week: {
	        options: {
	          week1: '1 uke',
	          week2: '2 uker',
	          week3: '3 uker'
	        }
	      },
	      month: {
	        options: {
	          month1: '1 måned',
	          month2: '2 måneder',
	          month3: '3 måneder',
	          month4: '4 måneder',
	          month5: '5 måneder',
	          month6: '6 måneder'
	        }
	      }
	    },
	
	    startBilling: {
	      week: {
	        options: {
	          monday: 'Mandag',
	          tuesday: 'Tirsdag',
	          wednesday: 'Onsdag',
	          thursday: 'Torsdag',
	          friday: 'Fredag',
	          saturday: 'Lørdag',
	          sunday: 'Søndag'
	        }
	      },
	      month: {
	        options: {
	          day: 'Dag'
	        }
	      }
	    },
	
	    addressTypes: {
	      updateActions: 'Oppdater handlinger',
	      options: {
	        postal: 'Postadresse',
	        physicalAddress: 'Besøksadresse',
	        deliveryAddress: 'Leveringsadresse'
	      }
	    },
	
	    contactTypes: {
	      options: {
	        primary: 'Hoved',
	        accounting: 'Regnskap'
	      }
	    },
	
	    productGroups: {
	      parentGroupId: {
	        label: 'Foreldre gruppe',
	        placeholder: 'Velg overordnet gruppe'
	      },
	      name: {
	        label: 'Navn',
	        placeholder: 'Navn'
	      },
	      description: {
	        label: 'Beskrivelse',
	        placeholder: 'Beskrivelse'
	      }
	    },
	
	    productBundles: {
	      name: {
	        label: 'Navn',
	        placeholder: 'Navn'
	      },
	      description: {
	        label: 'Beskrivelse',
	        placeholder: 'Beskrivelse'
	      },
	      price: {
	        label: 'Pakkepris (eks MVA)',
	        placeholder: 'Pris'
	      },
	      groupName: {
	        label: 'Gruppenavn',
	        placeholder: 'Gruppenavn'
	      },
	      groupPrice: {
	        label: 'Gruppepris',
	        placeholder: ''
	      },
	      groupTax: {
	        label: 'MVA %',
	        placeholder: ''
	      }
	    },
	
	    productPackagings: {
	      name: {
	        label: 'Navn',
	        placeholder: 'Navn'
	      },
	      volume: {
	        label: 'Volum (ℓ)',
	        placeholder: 'Volum (ℓ)'
	      },
	      qtyInCrate: {
	        label: 'Antall enheter i kasse',
	        placeholder: 'Antall enheter i kasse'
	      },
	      packagingTypeId: {
	        label: 'Forpakningstype (Brukes i forbindelse med bl.a rapportering til BROD)',
	        placeholder: 'Forpakningstype'
	      },
	      packagingMaterialId: {
	        label: 'Forpakningsmateriale (Brukes i forbindelse med beregning av avgift til Skatteetaten)',
	        placeholder: 'Forpakningsmateriale'
	      },
	      materialId: {
	        label: 'Råvare pr. forpakning brukt under tapping',
	        placeholder: 'Råvare forpaknings materiale'
	      },
	      crateMaterialId: {
	        label: 'Råvare pr. kasse brukt under tapping',
	        placeholder: 'Råvare kasse materiale'
	      },
	      overrideProductsConfirm: {
	        title: 'Overstyr relaterte produkter',
	        description: 'Dette vil oppdatere alle avgifter og innskudd av produkter som tilhører denne pakken.'
	      }
	    },
	    products: {
	      number: {
	        label: 'Produktnummer',
	        placeholder: 'Produktnummer'
	      },
	      name: {
	        label: 'Produktnavn',
	        placeholder: 'Produktnavn'
	      },
	      description: {
	        label: 'Beskrivelse',
	        placeholder: 'Beskrivelse'
	      },
	      subType: {
	        label: 'Subtype',
	        placeholder: 'Velg subtype'
	      },
	      recommendations: {
	        label: 'Passer til',
	        placeholder: 'Passer til'
	      },
	      note: {
	        label: 'Notat',
	        placeholder: 'Notat'
	      },
	      isActive: {
	        label: 'Aktivt produkt',
	        placeholder: 'Aktiver'
	      },
	      containsAlcohol: {
	        label: 'Inneholder alkohol',
	        placeholder: 'Aktiver'
	      },
	      externalId: {
	        label: 'Eksternt produktnr',
	        placeholder: ''
	      },
	      productGroupId: {
	        label: 'Produktgruppe',
	        placeholder: 'Velg produktgruppe'
	      },
	      alcoholPercentage: {
	        label: 'Alkohol %',
	        placeholder: 'ABV'
	      },
	      productPackagingId: {
	        label: 'Produkt forpakning',
	        placeholder: 'Velg forpakning'
	      },
	      productTagId: {
	        label: 'Stikkord',
	        placeholder: 'Velg stikkord'
	      },
	      productTypeId: {
	        label: 'Produkttype',
	        placeholder: 'Velg produkttype'
	      },
	      productSubtype: {
	        label: 'Subtype',
	        placeholder: 'Velg subtype'
	      },
	      productSubtypeId: {
	        label: 'Subtype',
	        placeholder: 'Velg subtype'
	      },
	      productType: {
	        label: 'Produkttype',
	        placeholder: 'Velg produkttype'
	      },
	      taxId: {
	        label: 'Velg MVA prosent',
	        placeholder: 'MVA'
	      },
	      price: {
	        label: 'Salgspris',
	        placeholder: 'Salgspris'
	      },
	      retailPrice: {
	        label: 'Utsalgspris',
	        placeholder: 'Utsalgspris'
	      },
	      duration: {
	        label: 'Varighet',
	        placeholder: 'Varighet'
	      },
	      breaktime: {
	        label: 'Pause',
	        placeholder: 'Pause'
	      },
	      appointable: {
	        label: 'Tilgjengelig for online booking?',
	        placeholder: 'Aktiver'
	      },
	      icon: {
	        label: 'Velg ikon',
	        placeholder: 'Ikon',
	        changeImage: 'Endre bilde',
	        removeImage: 'Slett bilde'
	      },
	      image: {
	        label: 'Velg et bilde',
	        placeholder: 'Bilde',
	        changeImage: 'Endre bilde'
	      },
	      depositCheck: {
	        label: 'Pant på produkt',
	        placeholder: 'Aktiver pant'
	      },
	      deposit: {
	        label: 'Pant',
	        placeholder: 'Aktiver'
	      },
	      productDepositCheckbox: {
	        label: 'Pant på produkt',
	        placeholder: 'Aktiver pant'
	      },
	      productDepositId: {
	        label: 'Pantesats',
	        placeholder: 'Velg pant'
	      },
	      overrideProducts: {
	        label: 'Overstyr produkter',
	        placeholder: ''
	      },
	      purchasePrice: {
	        label: 'Innkjøpspris',
	        placeholder: ''
	      },
	      costPrice: {
	        label: 'Kostpris',
	        placeholder: ''
	      },
	      paidExcise: {
	        label: 'Forhåndsbetalt avgift?',
	        placeholder: ''
	      },
	      excisable: {
	        label: 'Særavgiftspliktig?',
	        placeholder: 'Aktiver særavgiftsberegning'
	      },
	      containSugar: {
	        label: 'Inneholder sukker?',
	        placeholder: 'Aktiver sukkerinnhold'
	      },
	      lowCalorie: {
	        label: 'Lav-kalori?',
	        placeholder: 'Marker hvis produktet er lav-kalori (BROD-rapport)'
	      },
	      exciseGroupId: {
	        label: 'Avgiftsgruppe',
	        placeholder: 'Avgiftsgruppe'
	      },
	      exciseAlcoholGroup: {
	        label: 'Alkoholavgift',
	        placeholder: 'Alkoholavgift'
	      },
	      excisePackagingGroup: {
	        label: 'Miljøavgift',
	        placeholder: 'Miljøavgift'
	      },
	      exciseBasicGroup: {
	        label: 'Basisavgift',
	        placeholder: 'Basisavgift'
	      },
	      chartOfAccounts: {
	        label: 'Regnskapskonto',
	        placeholder: 'Regnskapskonto'
	      },
	      producer: {
	        label: 'Produsentnavn',
	        placeholder: 'Navn på produsent'
	      },
	      region: {
	        label: 'Distrikt',
	        placeholder: ''
	      },
	      subRegion: {
	        label: 'Underdistrikt',
	        placeholder: ''
	      },
	      country: {
	        label: 'Land',
	        placeholder: ''
	      },
	      vintage: {
	        label: 'Årgang',
	        placeholder: ''
	      },
	      alcohol_percentage: {
	        label: 'Alkohol (%)',
	        placeholder: ''
	      },
	      bottle_volume: {
	        label: 'Flaskevolum (ℓ)',
	        placeholder: ''
	      },
	      sugar: {
	        label: 'Sukker (g)',
	        placeholder: ''
	      },
	      acid: {
	        label: 'Syre',
	        placeholder: ''
	      },
	      fullness: {
	        label: 'Fylde',
	        placeholder: ''
	      },
	      freshness: {
	        label: 'Friskhet',
	        placeholder: ''
	      },
	      bitterness: {
	        label: 'Bitterhet',
	        placeholder: ''
	      },
	      sweetness: {
	        label: 'Sødme',
	        placeholder: ''
	      },
	      tannins: {
	        label: 'Garvestoffer',
	        placeholder: ''
	      },
	      colour: {
	        label: 'Farge',
	        placeholder: ''
	      },
	      odour: {
	        label: 'Lukt',
	        placeholder: ''
	      },
	      taste: {
	        label: 'Smak',
	        placeholder: ''
	      },
	      storagePotential: {
	        label: 'Lagringsgrad',
	        placeholder: ''
	      },
	      ingredients: {
	        label: 'Ingredienser',
	        placeholder: ''
	      },
	      organic: {
	        label: 'Økologisk',
	        placeholder: ''
	      },
	      biodynamic: {
	        label: 'Biodynamisk',
	        placeholder: ''
	      },
	      locallyProduced: {
	        label: 'Lokalprodusert',
	        placeholder: ''
	      },
	      environmentallySmart: {
	        label: 'Fairtrade',
	        placeholder: ''
	      },
	      freeOrLowOnGluten: {
	        label: 'Lav på gluten',
	        placeholder: ''
	      },
	      kosher: {
	        label: 'Kosher',
	        placeholder: ''
	      },
	      cork_type: {
	        label: 'Korktype',
	        placeholder: ''
	      },
	      packaging_type: {
	        label: 'Emballasjetype',
	        placeholder: ''
	      },
	      gtin: {
	        label: 'GTIN #',
	        placeholder: 'GTIN nummer'
	      },
	      gtinMultipack: {
	        label: 'GTIN # flerforpakning',
	        placeholder: 'GTIN nummer flerforpakning'
	      },
	      sa: {
	        label: 'SA # ',
	        placeholder: 'Suppliers Article nummer'
	      },
	      nobb: {
	        label: 'NOBB #',
	        placeholder: 'Norsk Byggevarebase nummer'
	      },
	      sourceProductId: {
	        label: 'Produkt å slette',
	        placeholder: 'Produkt å slette'
	      },
	      destinationProductId: {
	        label: 'Slå sammen med',
	        placeholder: 'Slå sammen med'
	      },
	      is_taxable: {
	        label: 'MVA pliktig',
	        placeholder: 'MVA pliktig'
	      },
	      inventoryExclude: {
	        label: 'Ignorer varelager',
	        placeholder: 'Aktiver'
	      },
	      retailPriceVmp: {
	        label: 'Utsalgspris VMP',
	        placeholder: ''
	      },
	      ddpVmp: {
	        label: 'DDP VMP',
	        placeholder: ''
	      },
	      salePriceHoreca: {
	        label: 'Salgspris Horeca',
	        placeholder: ''
	      },
	      salesPriceAsko: {
	        label: 'Salgspris Asko',
	        placeholder: ''
	      },
	      salesPriceVinhuset: {
	        label: 'Salgspris Vinhuset',
	        placeholder: ''
	      },
	      salesPriceWholesale: {
	        label: 'Salgspris grossist',
	        placeholder: ''
	      },
	      salesPriceGrocery: {
	        label: 'Salgspris dagligvare',
	        placeholder: ''
	      },
	      salesPriceBusiness: {
	        label: 'Salgspris bedrift',
	        placeholder: ''
	      },
	      salesPriceSpecialtyStore: {
	        label: 'Salgspris spesialbutikk',
	        placeholder: ''
	      },
	      salesPriceVinhusetAsko: {
	        label: 'Salgspris Vinhuset Asko',
	        placeholder: ''
	      },
	      coop: {
	        label: 'Coop',
	        placeholder: ''
	      },
	      rema1000: {
	        label: 'Rema 1000',
	        placeholder: ''
	      },
	      packaging: {
	        label: 'Forpakning',
	        placeholder: ''
	      },
	      weightUnit: {
	        label: 'Vekt enhet (kg)',
	        placeholder: ''
	      },
	      weightMultipack: {
	        label: 'Vekt flerforpakning (kg)',
	        placeholder: ''
	      },
	      measureUnit: {
	        label: 'Mål enhet (cm)',
	        placeholder: ''
	      },
	      measureMultiPackaging: {
	        label: 'Mål flerforpakning (cm)',
	        placeholder: ''
	      },
	      numberUnitsMultiPackaging: {
	        label: 'Antall enheter i flerforpakning',
	        placeholder: ''
	      },
	      numberUnitsPallet: {
	        label: 'Antall enheter på pall',
	        placeholder: ''
	      },
	      availableVinhuset: {
	        label: 'Tilgjengelig hos Vinhuset',
	        placeholder: 'Aktiver'
	      },
	      availableAsko: {
	        label: 'Tilgjengelig hos Asko',
	        placeholder: 'Aktiver'
	      },
	      epd: {
	        label: 'EPD #',
	        placeholder: 'EPD ID'
	      },
	      sku: {
	        label: 'SKU #',
	        placeholder: ''
	      },
	      vmp: {
	        label: 'VMP #',
	        placeholder: 'VMP produkt ID'
	      },
	      internalNote: {
	        label: 'Notat',
	        placeholder: ''
	      },
	      depositSystemId: {
	        label: 'Innskuddssystem',
	        placeholder: 'Innskuddssystem'
	      },
	      lastChanged: {
	        label: 'Siste endret',
	        placeholder: 'Sist endret'
	      },
	      marketplaceEnabled: {
	        label: 'DrikkeRiket',
	        placeholder: 'Aktivert'
	      },
	      shortDescription: {
	        label: 'Kort beskrivelse',
	        placeholder: 'Kort beskrivelse'
	      },
	      longDescription: {
	        label: 'Detaljert beskrivelse',
	        placeholder: 'Detaljert beskrivelse'
	      },
	      manualProcessOrder: {
	        label: 'Manuell order godkjenning',
	        placeholder: 'Aktiv'
	      },
	      unProductCodeId: {
	        label: 'FNs produktkode',
	        placeholder: 'Søk i FNs produktkode...'
	      },
	      updateSku: {
	        label: 'Oppdatere SKU?',
	        placeholder: ''
	      },
	      minimumOrderQuantity: {
	        label: 'Minimum antall',
	        placeholder: ''
	      },
	      orderableUnitId: {
	        label: 'Bestillbar enhet',
	        placeholder: ''
	      },
	      syncToWoo: {
	        label: 'Synkroniser til Nettbutikk',
	        placeholder: ''
	      },
	      onlineStorePrice: {
	        label: 'Salgspris nettbutikk',
	        placeholder: 'Salgspris eks. mva'
	      },
	      sellInCase: {
	        label: 'Selg kassevis',
	        placeholder: ''
	      },
	      minQty: {
	        label: 'Minimumsmengde',
	        placeholder: ''
	      },
	      groupOf: {
	        label: 'Gruppe av',
	        placeholder: ''
	      },
	      packagingMaterial: {
	        label: 'Forpakningsmateriale',
	        placeholder: ''
	      },
	      packagingMaterialId: {
	        label: 'Forpakningsmateriale ID',
	        placeholder: ''
	      },
	      packagingName: {
	        label: 'Forpakningstype',
	        placeholder: ''
	      },
	      packagingQuantity: {
	        label: 'Antall i forpakning',
	        placeholder: ''
	      }
	    },
	
	    productTags: {
	      tag: {
	        label: 'Stikkord',
	        placeholder: 'Stikkord'
	      }
	    },
	
	    priceFields: {
	      field: {
	        label: 'Field',
	        placeholder: 'Field'
	      }
	    },
	
	    materials: {
	      number: {
	        label: 'Nummer',
	        placeholder: 'Nummer'
	      },
	      materialTypeId: {
	        label: 'Type',
	        placeholder: 'Type'
	      },
	      unitMeasureId: {
	        label: 'Måleenhet',
	        placeholder: 'Måleenhet'
	      },
	      supplierId: {
	        label: 'Leverandør/Produsent',
	        placeholder: 'Leverandør/Produsent'
	      },
	      minimumStockLevel: {
	        label: 'Lagerbehov',
	        placeholder: 'Lagerbehov'
	      },
	      name: {
	        label: 'Navn',
	        placeholder: 'Navn'
	      },
	      description: {
	        label: 'Beskrivelse',
	        placeholder: 'Beskrivelse'
	      }
	    },
	
	    batches: {
	      name: {
	        label: 'Navn',
	        placeholder: 'Navn'
	      },
	      batchNumber: {
	        label: 'Batch #',
	        placeholder: 'Batch #'
	      },
	      priorityNumber: {
	        label: 'Prioritering',
	        placeholder: 'Prioritering'
	      },
	      recipeId: {
	        label: 'Oppskrift',
	        placeholder: 'Oppskrift'
	      },
	      plannedStartingDate: {
	        label: 'Planlagt startdato',
	        placeholder: 'Planlagt startdato'
	      },
	      startDate: {
	        label: 'Startdato',
	        placeholder: 'Startdato'
	      },
	      endDate: {
	        label: 'Sluttdato',
	        placeholder: 'Sluttdato'
	      },
	      bestBeforeDate: {
	        label: 'Best før dato',
	        placeholder: 'Best før dato'
	      },
	      expirationDate: {
	        label: 'Utgått dato',
	        placeholder: 'Utgått dato'
	      },
	      notes: {
	        label: 'Notater',
	        placeholder: 'Notater'
	      },
	      description: {
	        label: 'Beskrivelse',
	        placeholder: 'Beskrivelse'
	      },
	      timestamp: {
	        label: 'Tid',
	        placeholder: 'Tid'
	      },
	      statuses: {
	        planned: 'Planlegg batch',
	        started: 'Start ny batch',
	        completed: 'Registrer fullført batch'
	      }
	    },
	
	    recipes: {
	      recipeTypeId: {
	        label: 'Oppskriftstype',
	        placeholder: 'Oppskriftstype'
	      },
	      name: {
	        label: 'Navn',
	        placeholder: 'Navn'
	      },
	      notes: {
	        label: 'Notat',
	        placeholder: 'Notat'
	      }
	    },
	
	    campaigns: {
	      name: {
	        label: 'Kampanjenavn',
	        placeholder: 'Navn på kampanjen'
	      },
	      description: {
	        label: 'Forklaring',
	        placeholder: 'Hva gjelder kampanjen?'
	      },
	      campaignTypeId: {
	        label: 'Kampanjetype',
	        placeholder: 'Kampanjetype'
	      },
	      newsSubscriberListId: {
	        label: 'Liste',
	        placeholder: 'Liste'
	      }
	    },
	
	    subscriberList: {
	      name: {
	        label: 'Navn',
	        placeholder: 'Navn'
	      },
	      selectDefaultEmail: {
	        label: 'Bruk standard e-post',
	        placeholder: ''
	      },
	      fromEmail: {
	        label: 'Fra e-post',
	        placeholder: 'Fra e-post'
	      },
	      selectDefaultName: {
	        label: 'Bruk standardnavn',
	        placeholder: ''
	      },
	      fromName: {
	        label: 'Fra navn',
	        placeholder: 'Fra navn'
	      },
	      description: {
	        label: 'Beskrivelse',
	        placeholder: 'Beskrivelse'
	      },
	      doubleOptinRequired: {
	        label: 'Dobbeltoptin',
	        placeholder: ''
	      },
	      mailSubject: {
	        label: 'Emne',
	        placeholder: 'Emne'
	      },
	      mailBody: {
	        label: 'Kropp',
	        placeholder: 'Kropp'
	      }
	    },
	
	    news: {
	      subject: {
	        label: 'Emne',
	        placeholder: 'Emne'
	      },
	      body: {
	        label: 'Beskjed',
	        placeholder: 'Beskjed'
	      },
	      sendAfterDate: {
	        label: 'Sendedato',
	        placeholder: 'Velg sendedato'
	      },
	      sendAfterTime: {
	        label: 'Sendetid',
	        placeholder: 'Velg sendetid'
	      },
	      sendAfter: {
	        label: 'Send etter antall (x) timer',
	        placeholder: 'Send etter timer'
	      },
	      testEmail: {
	        label: 'Test email',
	        placeholder: 'mail@mail.com'
	      },
	      testEmailCheck: {
	        label: 'Use custom email',
	        placeholder: ''
	      },
	      status: {
	        label: 'Status'
	      },
	      htmlEmail: {
	        label: 'Use Html Email',
	        placeholder: ''
	      }
	    },
	
	    orders: {
	      createdAt: {
	        label: 'Ordredato',
	        placeholder: 'Ordredato'
	      },
	      orderTypeId: {
	        label: 'Ordretype',
	        placeholder: 'Ordretype'
	      },
	      projectId: {
	        label: 'Prosjekt',
	        placeholder: 'Prosjekt'
	      },
	      productId: {
	        label: 'Velg produktet',
	        placeholder: 'Produkt'
	      },
	      batchId: {
	        label: 'Velg batch',
	        placeholder: 'Velg batch'
	      },
	      available: {
	        label: 'Lagerstatus',
	        placeholder: 'Lagerstatus'
	      },
	      clientId: {
	        label: 'Velg kunde',
	        placeholder: 'Kunde'
	      },
	      referenceNumber: {
	        label: 'Ordre referanse',
	        placeholder: 'Ordre referanse'
	      },
	      internalNote: {
	        label: 'Notat',
	        placeholder: 'Notat'
	      },
	      date: {
	        label: 'Dato',
	        placeholder: 'Dato'
	      },
	      slot: {
	        label: 'Velg tidspunkt',
	        placeholder: 'Time Slots'
	      },
	      timeSlots: {
	        label: 'Starttid'
	      },
	      time: {
	        label: 'Tid',
	        placeholder: 'Tid'
	      },
	      duration: {
	        label: 'Varighet',
	        placeholder: 'Varighet'
	      },
	      details: {
	        label: 'Detaljer',
	        placeholder: 'Detaljer'
	      }
	    },
	
	    ediOrders: {
	      deliveryDate: {
	        label: 'Leveringsdato',
	        placeholder: 'Leveringsdato'
	      },
	      orderNumber: {
	        label: 'Vinmonopolets ordre nummer',
	        placeholder: 'Velg opprinnelig ordre'
	      }
	    },
	
	    bills: {
	      languageId: {
	        label: 'Velg språk',
	        placeholder: 'Språk'
	      },
	      currencyId: {
	        label: 'Velg valuta',
	        placeholder: 'Valuta'
	      },
	      orderId: {
	        label: 'Velg ordre',
	        placeholder: 'Ordre'
	      },
	      billTypeId: {
	        label: 'Velg fakturatype',
	        placeholder: 'Type'
	      },
	      billStatusId: {
	        label: 'Velg fakturastatus',
	        placeholder: 'Status'
	      },
	      dueDate: {
	        label: 'Forfallsdato',
	        placeholder: 'Forfallsdato'
	      },
	      summaryGrouping: {
	        label: 'Sammendrag gruppering',
	        placeholder: ''
	      },
	      date: {
	        label: 'Dato',
	        placeholder: 'Dato'
	      },
	      paymentDate: {
	        label: 'Betalingsdato',
	        placeholder: 'Betalingsdato'
	      },
	      creditNoteValue: {
	        label: 'Kreditnota verdi',
	        placeholder: 'Verdi'
	      },
	      paymentMessage: {
	        label: 'Betalingsreferanse',
	        placeholder: 'Meldingstekst'
	      },
	      kidNumber: {
	        label: 'KID',
	        placeholder: 'KID'
	      },
	      note: {
	        label: 'Notat',
	        placeholder: 'Notat'
	      }
	    },
	
	    addEditPackage: {
	      packageUnitTypeId: {
	        label: 'Enhetstype',
	        placeholder: 'Enhetstype'
	      },
	      sscc: {
	        label: 'SSCC',
	        placeholder: 'Kollinummer (generes automatisk hvis blankt)'
	      },
	      parentId: {
	        label: 'Foreldrepakke',
	        placeholder: 'Foreldrepakke'
	      },
	      packingLevel: {
	        label: 'Pakketype',
	        placeholder: 'Pakketype'
	      }
	    },
	
	    addEditProductToPackage: {
	      productName: {
	        label: 'Produkter',
	        placeholder: 'Produkter'
	      },
	      orderProductId: {
	        label: 'Produkter',
	        placeholder: 'Produkter'
	      },
	      quantity: {
	        label: 'Antall enheter',
	        placeholder: 'Antall enheter'
	      },
	      quantityUnit: {
	        label: 'Målenhet',
	        placeholder: 'Målenhet'
	      },
	      grossWeight: {
	        label: 'Bruttovekt',
	        placeholder: 'Bruttovekt'
	      },
	      netWeight: {
	        label: 'Nettovekt',
	        placeholder: 'Nettovekt'
	      },
	      stackWeight: {
	        label: 'Stablevekt',
	        placeholder: 'Stablevekt'
	      },
	      bestBefore: {
	        label: 'Best før',
	        placeholder: 'Best før'
	      },
	      maxTopLoad: {
	        label: 'Maks topplast',
	        placeholder: 'Maks topplast'
	      },
	      batchLotNumber: {
	        label: 'Batch / Lot nummer',
	        placeholder: 'Batch / Lot nummer'
	      },
	      temperatureRequirement: {
	        label: 'Temperatur (i °C)',
	        placeholder: 'Temperatur (i °C)'
	      }
	    },
	
	    exciseEntry: {
	      product: {
	        placeholder: 'Produkt velg',
	        label: ''
	      },
	      source: {
	        placeholder: 'Kilde velg',
	        label: ''
	      }
	    }
	  },
	
	  table: {
	    noData: 'Ingen data funnet',
	    projects: {
	      name: {
	        label: 'Navn',
	        placeholder: 'Navn'
	      },
	      description: {
	        label: 'Beskrivelse',
	        placeholder: 'Beskrivelse'
	      }
	    },
	    clientReports: {
	      id: 'ID',
	      name: 'Navn',
	      clientNumber: 'Kunde #',
	      balance: 'Balanse',
	      createdAt: 'Opprettet',
	      lastSent: 'Sist sendt',
	      email: 'Epost'
	    },
	    stock: {
	      products: {
	        productId: {
	          label: 'Navn',
	          placeholder: 'Navn'
	        },
	        batchId: {
	          label: 'Batch',
	          placeholder: 'Velg batch'
	        },
	        currentCount: {
	          label: 'System beholdning',
	          placeholder: 'System beholdning'
	        },
	        physicalCount: {
	          label: 'Ny lagerbeholdning',
	          placeholder: 'Ny lagerbeholdning'
	        },
	        variance: {
	          label: 'Forskjell (+/-)',
	          placeholder: 'Forskjell (+/-)'
	        }
	      }
	    },
	    adjustment: {
	      products: {
	        productId: {
	          label: 'Produkt',
	          placeholder: 'Velg produkt'
	        },
	        batchId: {
	          label: 'Batch',
	          placeholder: 'Velg batch'
	        },
	        qty: {
	          label: 'Justering (+/-)',
	          placeholder: 'Justering (+/-)',
	          customDeduct: 'Trekk'
	        },
	        currentAdjustment: {
	          label: 'Systembeholdning',
	          placeholder: 'Systembeholdning'
	        }
	      }
	    },
	    warehouseReports: {
	      productName: 'Produkt',
	      productValue: 'Produktverdi',
	      nameOfWarehouse: 'Varelager',
	      productNumber: 'Produktnr.',
	      vmpNumber: 'VMP nr.',
	      qtyAvailable: 'Antall',
	      crateQtyAvailable: 'Kasser'
	    },
	    products: {
	      productId: {
	        label: 'Navn',
	        placeholder: 'Navn'
	      },
	      qty: {
	        label: 'Antall',
	        placeholder: 'Antall'
	      }
	    },
	    shippingProviders: {
	      name: {
	        label: 'Navn',
	        placeholder: 'Navn'
	      },
	      code: {
	        label: 'Kode',
	        placeholder: 'Kode'
	      }
	    },
	    productBundles: {
	      productId: {
	        label: 'Produkt',
	        placeholder: 'Produkt'
	      },
	      price: {
	        label: 'Pris',
	        placeholder: 'Pris'
	      },
	      qty: {
	        label: 'Antall',
	        placeholder: 'Antall'
	      }
	    },
	    productsCustom: {
	      productId: {
	        label: 'Navn',
	        placeholder: 'Navn'
	      },
	      qty: {
	        label: 'Justering (+/-)',
	        placeholder: 'Justering (+/-)'
	      },
	      currentAdjustment: {
	        label: 'Systembeholdning',
	        placeholder: 'Systembeholdning'
	      },
	      qtyReceive: {
	        label: 'Antall mottatt',
	        placeholder: 'Antall mottatt'
	      },
	      qtyDamage: {
	        label: 'Skadet / manko',
	        placeholder: 'Skadet / manko'
	      },
	      costPrice: {
	        label: 'Kostpris',
	        placeholder: 'Kostpris'
	      },
	      purchasePrice: {
	        label: 'Innkjøpspris',
	        placeholder: 'Innkjøpspris'
	      },
	      notes: {
	        label: 'Notat',
	        placeholder: 'Notat'
	      },
	      batchId: {
	        label: 'Batch',
	        placement: 'Batch'
	      }
	    },
	    orderProducts: {
	      addProductsButton: 'Legg til produkter',
	      addAllBillProductsButton: 'Legg til alle fakturalinjer',
	      addAllBillProductsNothing: 'Alle fakturalinjene er allerede på kreditnotaen.',
	      addAllBillProductsSuccess: 'La til {count} linje(r) på kreditnotaen.',
	      addAllBillProductsError: 'Kunne ikke legge til alle linjer. Prøv enkeltvis.',
	      product: {
	        label: 'Rediger produkt'
	      },
	      name: {
	        label: 'Produkt',
	        placeholder: 'Navn'
	      },
	      taxId: {
	        label: 'MVA (%)',
	        placeholder: 'Velg...'
	      },
	      batchId: {
	        label: 'Batch',
	        placeholder: 'Batch'
	      },
	      available: {
	        label: 'Lagerantall',
	        placeholder: 'Lagerantall'
	      },
	      price: {
	        label: 'Pris',
	        placeholder: 'Pris'
	      },
	      quantity: {
	        label: 'Antall',
	        placeholder: 'Antall'
	      },
	      discount: {
	        label: 'Rabatt (%)'
	      },
	      quantityOrdered: {
	        label: 'Antall bestilt'
	      },
	      quantityConfirmed: {
	        label: 'Antall bekreftet'
	      },
	      quantityReceived: {
	        label: 'Antall mottatt'
	      },
	      quantityUnconfirmed: {
	        label: 'Unconfirmed'
	      },
	      returnCodeDescription: {
	        label: 'Retur Årsak'
	      },
	      unitTypeId: {
	        label: 'Enhet',
	        placeholder: ''
	      },
	      unitQuantity: {
	        label: 'Enhet Antall',
	        placeholder: ''
	      }
	    },
	    billProducts: {
	      billProductId: {
	        label: 'Produkt',
	        placeholder: 'Velg produkt'
	      },
	      orderProductId: {
	        label: 'Produkt',
	        placeholder: 'Velg ordre produkt'
	      },
	      productDepositId: {
	        label: 'Pant',
	        placeholder: 'Velg pant'
	      },
	      taxId: {
	        label: 'MVA (%)',
	        placeholder: 'Velg...'
	      },
	      price: {
	        label: 'Pris',
	        placeholder: 'Pris'
	      },
	      quantity: {
	        label: 'Antall',
	        placeholder: 'Antall'
	      },
	      discount: {
	        label: 'Rabatt (%)',
	        placeholder: 'Rabatt (%)'
	      },
	      ref: {
	        label: 'Ref #',
	        placeholder: 'Ref #'
	      }
	    },
	    businessHours: {
	      addOpeningHours: 'Add Opening Hours',
	      businessDays: {
	        placeholder: 'Dager',
	        label: 'Dager'
	      },
	      start: {
	        placeholder: 'Start tid',
	        label: 'Start tid'
	      },
	      end: {
	        placeholder: 'Avslutt tid',
	        label: 'Avslutt tid'
	      }
	    },
	    businessHourExceptions: {
	      addExceptionalHours: 'Add Exceptional Hours',
	      date: {
	        placeholder: 'Dato',
	        label: 'Dato',
	        placeholderStart: 'Fra dato',
	        placeholderEnd: 'Til dato'
	      },
	      start: {
	        placeholder: 'Start tid',
	        label: 'Start tid'
	      },
	      end: {
	        placeholder: 'Avslutt tid',
	        label: 'Avslutt tid'
	      },
	      message: {
	        placeholder: 'Melding',
	        label: 'Melding'
	      }
	    },
	    recipeIngrediences: {
	      materialId: {
	        label: 'Material',
	        placeholder: 'Material'
	      },
	      amount: {
	        label: 'Mengde',
	        placeholder: 'Mengde'
	      },
	      unitMeasure: {
	        label: 'Måleenhet',
	        placeholder: 'Måleenhet'
	      },
	      deductedAmount: {
	        label: 'Trukket',
	        placeholder: 'Trukket'
	      },
	      noResult: 'Ingen ingredienser lagt til enda.'
	    },
	    ediOrderItems: {
	      name: {
	        label: 'Produkt',
	        placeholder: 'Navn'
	      },
	      price: {
	        label: 'Pris'
	      },
	      quantityOrdered: {
	        label: 'Antall bestilt'
	      },
	      quantityConfirmed: {
	        label: 'Antall bekreftet'
	      },
	      max: {
	        label: 'Maks'
	      }
	    }
	  },
	
	  el: {
	    colorpicker: {
	      confirm: 'OK',
	      clear: 'Fjern'
	    },
	    datepicker: {
	      now: 'Nå',
	      today: 'Idag',
	      cancel: 'Avbryt',
	      clear: 'Fjern',
	      confirm: 'OK',
	      selectDate: 'Velg dato',
	      selectTime: 'Velg tid',
	      startDate: 'Start dato',
	      startTime: 'Start tid',
	      endDate: 'Slutt dato',
	      endTime: 'Slutt tid',
	      prevMonth: 'Forrige måned',
	      nextMonth: 'Neste måned',
	      prevYear: 'Forrige år',
	      nextYear: 'Neste år',
	      year: '',
	      month1: 'Jan',
	      month2: 'Feb',
	      month3: 'Mar',
	      month4: 'Apr',
	      month5: 'Mai',
	      month6: 'Jun',
	      month7: 'Jul',
	      month8: 'Aug',
	      month9: 'Sep',
	      month10: 'Okt',
	      month11: 'Nov',
	      month12: 'Des',
	
	      weeks: {
	        sun: 'Søn',
	        mon: 'Man',
	        tue: 'Tir',
	        wed: 'Ons',
	        thu: 'Tor',
	        fri: 'Fre',
	        sat: 'Lør'
	      },
	      months: {
	        jan: 'Jan',
	        feb: 'Feb',
	        mar: 'Mar',
	        apr: 'Apr',
	        may: 'Mai',
	        jun: 'Jun',
	        jul: 'Jul',
	        aug: 'Aug',
	        sep: 'Sep',
	        oct: 'Okt',
	        nov: 'Nov',
	        dec: 'Des'
	      }
	    },
	    select: {
	      loading: 'Laster',
	      noMatch: 'Ingen matchende data',
	      noData: 'Ingen data',
	      placeholder: 'Velg'
	    },
	    cascader: {
	      noMatch: 'Ingen matchende data',
	      placeholder: 'Velg'
	    },
	    pagination: {
	      goto: 'Gå til',
	      pagesize: '/side',
	      total: 'Total {total}',
	      pageClassifier: ''
	    },
	    messagebox: {
	      title: 'Melding',
	      confirm: 'OK',
	      cancel: 'Avbryt',
	      error: 'Ulovlig input'
	    },
	    upload: {
	      delete: 'Slett',
	      preview: 'Forhåndsvisning',
	      continue: 'Fortsett'
	    },
	    table: {
	      emptyText: 'Ingen data',
	      confirmFilter: 'Bekreft',
	      resetFilter: 'Tilbakestill',
	      clearFilter: 'Alle'
	    },
	    tree: {
	      emptyText: 'Ingen data'
	    }
	  },
	
	  creditNoteWarning: {
	    invoiceInfo: {
	      exciseInventoryActivated: 'Du har særavgift og lagermodul aktivert på din konto. Husk å fullføre kreditnotaen for å registrere evt. returer!',
	      specialChargeActivated: 'Du har særavgift aktivert på din konto. Husk å fullføre kreditnotaen for å registrere evt. returer!',
	      storageModuleEnabled: 'Du har lagermodul aktivert på din konto. Husk å fullføre kreditnotaen for å registrere evt. returer!',
	      noClientEmail: 'Kunden mangler epost. Kreditnota kan ikke sendes på epost før adressen er lagt til kunden.'
	    }
	  },
	
	  warnings: {
	    billReminder: {
	      unableToCreateWithFee: 'Kan ikke opprette påminnelse med gebyrer pga. følgende:',
	      reasons: {
	        max2: 'Maks antall purringer med gebyrer (2 stk) er alt opprettet.',
	        notDue: 'Påminnelse med gebyr kan ikke opprettes før 14 dager etter forfallsdato.',
	        oneReminderFee: 'Forrige påminnelse pågår. Vennligst vent',
	        oneReminderFeeDays: 'dager før du sender ny.'
	      }
	    }
	  }
	};

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    numberFormat: function numberFormat(value, key) {
	      if (isNaN(value)) {
	        return value;
	      }
	      if (typeof value === 'string') {
	        return value;
	      }
	      if (Number.isInteger(value) && key === 'id') {
	        return value;
	      }
	      value = parseFloat(value).toFixed(2);
	
	      return value.replace(/\d(?=(\d{3})+\.)/g, '$&,');
	    }
	  }
	};

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  currency: {
	    style: 'decimal',
	    currency: 'USD',
	    minimumFractionDigits: 2
	  }
	};

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  currency: {
	    style: 'decimal',
	    currency: 'NOK',
	    minimumFractionDigits: 2
	  }
	};

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _googleTwoFactorAuthSetup = __webpack_require__(2711);
	
	var _googleTwoFactorAuthSetup2 = _interopRequireDefault(_googleTwoFactorAuthSetup);
	
	var _smsTwoFactorAuthSetup = __webpack_require__(2739);
	
	var _smsTwoFactorAuthSetup2 = _interopRequireDefault(_smsTwoFactorAuthSetup);
	
	var _accountingSetupTripletex = __webpack_require__(2664);
	
	var _accountingSetupTripletex2 = _interopRequireDefault(_accountingSetupTripletex);
	
	var _marketplaceModuleSetup = __webpack_require__(2716);
	
	var _marketplaceModuleSetup2 = _interopRequireDefault(_marketplaceModuleSetup);
	
	var _vinmonopoletModuleSetup = __webpack_require__(2744);
	
	var _vinmonopoletModuleSetup2 = _interopRequireDefault(_vinmonopoletModuleSetup);
	
	var _accountingSetupVisma = __webpack_require__(2665);
	
	var _accountingSetupVisma2 = _interopRequireDefault(_accountingSetupVisma);
	
	var _accountingSetupFiken = __webpack_require__(2662);
	
	var _accountingSetupFiken2 = _interopRequireDefault(_accountingSetupFiken);
	
	var _accountingSetupPowerOffice = __webpack_require__(2663);
	
	var _accountingSetupPowerOffice2 = _interopRequireDefault(_accountingSetupPowerOffice);
	
	var _ehfModuleSetup = __webpack_require__(770);
	
	var _ehfModuleSetup2 = _interopRequireDefault(_ehfModuleSetup);
	
	var _unimicroModuleSetup = __webpack_require__(2743);
	
	var _unimicroModuleSetup2 = _interopRequireDefault(_unimicroModuleSetup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  googleTwoFactorAuthSetup: _googleTwoFactorAuthSetup2.default,
	  smsTwoFactorAuthSetup: _smsTwoFactorAuthSetup2.default,
	  accountingSetupTripletex: _accountingSetupTripletex2.default,
	  marketplaceModuleSetup: _marketplaceModuleSetup2.default,
	  vinmonopoletModuleSetup: _vinmonopoletModuleSetup2.default,
	  accountingSetupFiken: _accountingSetupFiken2.default,
	  ehfModuleSetup: _ehfModuleSetup2.default,
	  accountingSetupVisma: _accountingSetupVisma2.default,
	  accountingSetupPowerOffice: _accountingSetupPowerOffice2.default,
	  unimicroModuleSetup: _unimicroModuleSetup2.default
	};

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _appVersion = __webpack_require__(444);
	
	var _appVersion2 = _interopRequireDefault(_appVersion);
	
	var _bridgeHandoff = __webpack_require__(956);
	
	var _bridgeHandoff2 = _interopRequireDefault(_bridgeHandoff);
	
	var _locale = __webpack_require__(287);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var checkModules = function checkModules(accountModules) {
	  return function (record) {
	    var hasModules = true;
	    if (record.meta.requiredModules) {
	      record.meta.requiredModules.forEach(function (m) {
	        if (!accountModules.filter(function (module) {
	          return module.name === m;
	        }).length) {
	          hasModules = false;
	        }
	      });
	    }
	
	    return hasModules;
	  };
	};
	
	var inventoryWritesBlocked = function inventoryWritesBlocked() {
	  var state = _store2.default.state.bridgeHandoff.state;
	
	  return !!(state && (state.stock_mutations_handed_off || state.stock_decommissioned));
	};
	
	var getBridgeBlockedToastMessage = function getBridgeBlockedToastMessage() {
	  var locale = _store2.default.state.profile.account && _store2.default.state.profile.account.language || ("no");
	  var fallbackLocale = _locale2.default[locale] ? locale : 'en';
	
	  return _locale2.default[fallbackLocale].static.bridgeHandoff.blockedToast;
	};
	
	var showBridgeBlockedToast = function showBridgeBlockedToast() {
	  if (!_vue2.default.$toast) {
	    return;
	  }
	
	  _vue2.default.$toast.open({
	    message: getBridgeBlockedToastMessage(),
	    type: 'warning',
	    duration: 6000,
	    position: 'top-right',
	    queue: false
	  });
	};
	
	var getInventoryWriteRedirect = function getInventoryWriteRedirect(to) {
	  var matchedRecord = [].concat(_toConsumableArray(to.matched)).reverse().find(function (record) {
	    return record.meta && record.meta.inventoryBridgeFallback;
	  });
	  var fallback = matchedRecord && matchedRecord.meta.inventoryBridgeFallback;
	
	  if (!fallback) {
	    return { path: '/' };
	  }
	
	  var route = {
	    name: fallback.name
	  };
	
	  if (fallback.preserveParams) {
	    route.params = to.params;
	  }
	
	  if (fallback.preserveQuery) {
	    route.query = to.query;
	  }
	
	  return route;
	};
	
	var guardInventoryWriteRoute = function guardInventoryWriteRoute(to, next) {
	  if (!to.matched.some(function (record) {
	    return record.meta && record.meta.inventoryBridgeStockWrite;
	  })) {
	    return false;
	  }
	
	  var continueNavigation = function continueNavigation() {
	    if (!inventoryWritesBlocked()) {
	      next();
	      return true;
	    }
	
	    showBridgeBlockedToast();
	    next(getInventoryWriteRedirect(to));
	    return true;
	  };
	
	  if (_store2.default.state.auth.authenticated && _store2.default.state.bridgeHandoff.state === null) {
	    return _bridgeHandoff2.default.fetch().then(function () {
	      return continueNavigation();
	    });
	  }
	
	  return continueNavigation();
	};
	
	var beforeEach = function beforeEach(to, from, next) {
	  if (to.matched.some(function (record) {
	    return record.meta.auth;
	  })) {
	    if (!_store2.default.state.auth.authenticated) {
	      return next({
	        path: '/home'
	      });
	    }
	
	    if (Object.keys(_store2.default.state.profile.account).length > 0) {
	      var verified = _store2.default.state.profile.account.verified;
	      if (!verified && to.matched.some(function (record) {
	        return record.meta.emailVerificationRequired;
	      })) {
	        return next({
	          path: '/'
	        });
	      }
	
	      if (!to.matched.every(checkModules(_store2.default.state.profile.account.modules))) {
	        return next({
	          path: '/'
	        });
	      }
	    }
	  } else if (to.matched.some(function (record) {
	    return record.meta.guest;
	  })) {
	    if (_store2.default.state.auth.authenticated) {
	      return next({
	        path: '/'
	      });
	    }
	  }
	
	  if (guardInventoryWriteRoute(to, next)) {
	    return;
	  }
	
	  if (_store2.default.state.auth.authenticated) {
	    Promise.all([_appVersion2.default.fetchUserAppVersion()]).then(function () {});
	  }
	
	  return next();
	};
	
	exports.default = {
	  beforeEach: beforeEach
	};

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  path: '/home',
	  name: 'home.index',
	  component: __webpack_require__(2762),
	
	  meta: {
	    guest: true
	  }
	}, {
	  path: '/release-notes',
	  name: 'home.release-notes',
	  component: __webpack_require__(2764)
	}, {
	  path: '/unsubscribed',
	  name: 'home.unsubscribed',
	  component: __webpack_require__(2765)
	}, {
	  path: '/login-using-token/:token',
	  name: 'login.using.token',
	  component: __webpack_require__(2763),
	
	  meta: {
	    guest: true
	  }
	}, {
	  path: '/register/:plan',
	  name: 'register.emailSetup',
	  component: __webpack_require__(2766),
	
	  meta: {
	    guest: true
	  }
	}, {
	  path: '/login',
	  name: 'auth.login',
	  component: __webpack_require__(2759),
	
	  meta: {
	    guest: true
	  }
	}, {
	  path: '/reset-password',
	  name: 'auth.resetPassword',
	  component: __webpack_require__(2760),
	
	  meta: {
	    guest: true
	  }
	}, {
	  path: '/verify-code',
	  name: 'auth.twoFactorVerification',
	  component: __webpack_require__(2761),
	
	  meta: {
	    guest: true
	  }
	}, {
	  path: '',
	  component: __webpack_require__(2808),
	
	  meta: {
	    auth: true
	  },
	  children: [{
	    path: '',
	    name: 'dashboard',
	    component: __webpack_require__(2791)
	  }, {
	    path: '/reports',
	    name: 'reports',
	    component: __webpack_require__(2857),
	    meta: {
	      emailVerificationRequired: true,
	      requiredModules: ['Client', 'Order']
	    }
	  }, {
	    path: '/reports/excise/:id',
	    name: 'exciseMonthlyReport',
	    component: __webpack_require__(2795),
	    meta: {
	      emailVerificationRequired: true
	    }
	  }, {
	    path: '/profile',
	    component: __webpack_require__(2847),
	    children: [{
	      path: 'account',
	      name: 'profile.account',
	      component: __webpack_require__(2844)
	    }, {
	      path: 'address',
	      name: 'profile.address',
	      component: __webpack_require__(2845)
	    }, {
	      path: 'contact',
	      name: 'profile.contact',
	      component: __webpack_require__(2846)
	    }, {
	      path: 'public',
	      name: 'publicProfile',
	      component: __webpack_require__(2848),
	      meta: {
	        requiredModules: ['Order', 'Appointment']
	      }
	    }]
	  }, {
	    path: 'settings',
	    name: 'application.settings',
	    component: __webpack_require__(2849),
	
	    meta: {
	      auth: true
	    }
	  }, {
	    path: '/clients',
	    component: __webpack_require__(2788),
	    meta: {
	      requiredModules: ['Client']
	    },
	    children: [{
	      path: '',
	      name: 'clients.index',
	      component: __webpack_require__(422),
	
	      meta: {
	        auth: true,
	        subMenu: 'all'
	      }
	    }, {
	      path: 'later',
	      name: 'clients.later',
	      component: __webpack_require__(422),
	
	      meta: {
	        auth: true,
	        subMenu: 'later'
	      }
	    }, {
	      path: 'pastMonth',
	      name: 'clients.pastMonth',
	      component: __webpack_require__(422),
	
	      meta: {
	        auth: true,
	        subMenu: 'pastMonth'
	      }
	    }, {
	      path: 'create',
	      name: 'clients.create',
	      component: __webpack_require__(2789)
	    }, {
	      path: ':id/edit',
	      name: 'clients.edit',
	      component: __webpack_require__(2790)
	    }]
	  }, {
	    path: '/pricing-agreements',
	    component: __webpack_require__(2821),
	    meta: {
	      requiredModules: ['Client']
	    },
	    children: [{
	      path: '',
	      name: 'pricingAgreements.index',
	      component: __webpack_require__(2820),
	      meta: { auth: true }
	    }, {
	      path: 'create',
	      name: 'pricingAgreements.create',
	      component: __webpack_require__(2818),
	      meta: { auth: true }
	    }, {
	      path: ':id/edit',
	      name: 'pricingAgreements.edit',
	      component: __webpack_require__(2819),
	      meta: { auth: true }
	    }]
	  }, {
	    path: '/suppliers',
	    component: __webpack_require__(2871),
	    meta: {
	      requiredModules: ['Supplier']
	    },
	    children: [{
	      path: '',
	      name: 'supplier.index',
	      component: __webpack_require__(2869),
	
	      meta: {
	        auth: true,
	        subMenu: 'all'
	      }
	    }, {
	      path: 'create',
	      name: 'supplier.create',
	      component: __webpack_require__(2867)
	    }, {
	      path: ':id/edit',
	      name: 'supplier.edit',
	      component: __webpack_require__(2868)
	    }]
	  }, {
	    path: '/client-groups',
	    component: __webpack_require__(2786),
	    meta: {
	      requiredModules: ['Client']
	    },
	    children: [{
	      path: '',
	      name: 'clientGroups.index',
	      component: __webpack_require__(421)
	    }, {
	      path: 'later',
	      name: 'clientGroups.later',
	      component: __webpack_require__(421),
	
	      meta: {
	        auth: true,
	        subMenu: 'later'
	      }
	    }, {
	      path: 'pastMonth',
	      name: 'clientGroups.pastMonth',
	      component: __webpack_require__(421),
	
	      meta: {
	        auth: true,
	        subMenu: 'pastMonth'
	      }
	    }, {
	      path: 'create',
	      name: 'clientGroups.create',
	      component: __webpack_require__(776)
	    }, {
	      path: ':id/edit',
	      name: 'clientGroups.edit',
	      component: __webpack_require__(2787)
	    }]
	  }, {
	    path: '/production',
	    component: __webpack_require__(2798),
	    meta: {
	      emailVerificationRequired: true
	    },
	    children: [{
	      path: '/production/materials',
	      name: 'production.materials.index',
	      component: __webpack_require__(2797)
	    }, {
	      path: '/production/materials/create',
	      name: 'production.materials.create',
	      component: __webpack_require__(2796)
	    }, {
	      path: '/production/materials/:id/view',
	      name: 'production.materials.view',
	      component: __webpack_require__(778)
	    }, {
	      path: '/production/materials/:id/edit',
	      name: 'production.materials.edit',
	      component: __webpack_require__(778)
	    }, {
	      path: '/production/batches',
	      name: 'production.batches.index',
	      component: __webpack_require__(2775)
	    }, {
	      path: '/production/batches/create',
	      name: 'production.batches.create',
	      component: __webpack_require__(2773),
	      meta: {
	        inventoryBridgeStockWrite: true,
	        inventoryBridgeFallback: {
	          name: 'production.batches.index'
	        }
	      }
	    }, {
	      path: '/production/batches/:id/view',
	      name: 'production.batches.view',
	      component: __webpack_require__(2776)
	    }, {
	      path: '/production/batches/:id/edit',
	      name: 'production.batches.edit',
	      component: __webpack_require__(2774),
	      meta: {
	        inventoryBridgeStockWrite: true,
	        inventoryBridgeFallback: {
	          name: 'production.batches.view',
	          preserveParams: true
	        }
	      }
	    }, {
	      path: '/production/recipes',
	      name: 'production.recipes.index',
	      component: __webpack_require__(2856)
	    }, {
	      path: '/production/recipes/create',
	      name: 'production.recipes.create',
	      component: __webpack_require__(2855)
	    }, {
	      path: '/production/recipes/:id/view',
	      name: 'production.recipes.view',
	      component: __webpack_require__(782)
	    }, {
	      path: '/production/recipes/:id/edit',
	      name: 'production.recipes.edit',
	      component: __webpack_require__(782)
	    }, {
	      path: '/production/equipments',
	      name: 'production.equipments.index',
	      component: __webpack_require__(2793)
	    }, {
	      path: '/production/equipments/create',
	      name: 'production.equipments.create',
	      component: __webpack_require__(2792)
	    }, {
	      path: '/production/equipments/:id/view',
	      name: 'production.equipments.view',
	      component: __webpack_require__(777)
	    }, {
	      path: '/production/equipments/:id/edit',
	      name: 'production.equipments.edit',
	      component: __webpack_require__(777)
	    }]
	  }, {
	    path: '/products',
	    component: __webpack_require__(2842),
	    meta: {
	      emailVerificationRequired: true,
	      requiredModules: ['Product']
	    },
	    children: [{
	      path: '',
	      name: 'products.index',
	      component: __webpack_require__(2841)
	    }, {
	      path: 'create',
	      name: 'products.create',
	      component: __webpack_require__(2839)
	    }, {
	      path: 'syncvmp',
	      name: 'products.syncVmp',
	      component: __webpack_require__(2843)
	    }, {
	      path: ':id/edit',
	      name: 'products.edit',
	      component: __webpack_require__(2840)
	    }, {
	      path: '/productflow',
	      name: 'productFlow.index',
	      component: __webpack_require__(2828),
	
	      meta: {
	        auth: true,
	        subMenu: 'all'
	      }
	    }, {
	      path: '/productflow/create',
	      name: 'productFlow.create',
	      component: __webpack_require__(2826)
	    }, {
	      path: '/productflow/:id/edit',
	      name: 'productFlow.edit',
	      component: __webpack_require__(2827)
	    }, {
	      path: '/exciseentry',
	      name: 'exciseentry.index',
	      component: __webpack_require__(2794)
	    }]
	  }, {
	    path: '/members',
	    name: 'members',
	    component: __webpack_require__(2801),
	
	    children: [{
	      path: '',
	      name: 'members.index',
	      component: __webpack_require__(2800)
	    }, {
	      path: ':id',
	      name: 'members.show',
	      component: __webpack_require__(2802)
	    }],
	
	    meta: {
	      auth: true
	    }
	  }, {
	    path: '/membership',
	    name: 'membership',
	    component: __webpack_require__(2804),
	
	    children: [{
	      path: '',
	      name: 'membership.index',
	      component: __webpack_require__(2803)
	    }, {
	      path: ':id',
	      name: 'membership.show',
	      component: __webpack_require__(2805)
	    }],
	
	    meta: {
	      auth: true
	    }
	  }, {
	    path: '/product-groups',
	    component: __webpack_require__(2831),
	    meta: {
	      emailVerificationRequired: true,
	      requiredModules: ['Product']
	    },
	    children: [{
	      path: '',
	      name: 'productGroups.index',
	      component: __webpack_require__(2830)
	    }, {
	      path: 'create',
	      name: 'productGroups.create',
	      component: __webpack_require__(423)
	    }, {
	      path: ':id/edit',
	      name: 'productGroups.edit',
	      component: __webpack_require__(2829)
	    }]
	  }, {
	    path: '/product-bundles',
	    component: __webpack_require__(2825),
	    meta: {
	      emailVerificationRequired: true,
	      requiredModules: ['Product']
	    },
	    children: [{
	      path: '',
	      name: 'productBundles.index',
	      component: __webpack_require__(2824)
	    }, {
	      path: 'create',
	      name: 'productBundles.create',
	      component: __webpack_require__(2822)
	    }, {
	      path: ':id/edit',
	      name: 'productBundles.edit',
	      component: __webpack_require__(2823)
	    }]
	  }, {
	    path: '/product-packagings',
	    component: __webpack_require__(2834),
	    meta: {
	      emailVerificationRequired: true,
	      requiredModules: ['Product']
	    },
	    children: [{
	      path: '',
	      name: 'productPackagings.index',
	      component: __webpack_require__(2833)
	    }, {
	      path: 'create',
	      name: 'productPackagings.create',
	      component: __webpack_require__(281)
	    }, {
	      path: ':id/edit',
	      name: 'productPackagings.edit',
	      component: __webpack_require__(2832)
	    }]
	  }, {
	    path: '/product-tags',
	    component: __webpack_require__(2838),
	    meta: {
	      emailVerificationRequired: true,
	      requiredModules: ['Product']
	    },
	    children: [{
	      path: '',
	      name: 'productTags.index',
	      component: __webpack_require__(2837)
	    }, {
	      path: 'create',
	      name: 'productTags.create',
	      component: __webpack_require__(2835)
	    }, {
	      path: ':id/edit',
	      name: 'productTags.edit',
	      component: __webpack_require__(2836)
	    }]
	  }, {
	    path: '/price-fields',
	    component: __webpack_require__(2817),
	    meta: {
	      emailVerificationRequired: true,
	      requiredModules: ['Product']
	    },
	    children: [{
	      path: '',
	      name: 'priceFields.index',
	      component: __webpack_require__(2816)
	    }, {
	      path: 'create',
	      name: 'priceFields.create',
	      component: __webpack_require__(2814)
	    }, {
	      path: ':id/edit',
	      name: 'priceFields.edit',
	      component: __webpack_require__(2815)
	    }]
	  }, {
	    path: '/unit-of-measure',
	    component: __webpack_require__(2879),
	    meta: {
	      requiredModules: ['UnitOfMeasure']
	    },
	    children: [{
	      path: '',
	      name: 'unitOfMeasure.index',
	      component: __webpack_require__(2878)
	    }, {
	      path: 'create',
	      name: 'unitOfMeasure.create',
	      component: __webpack_require__(2876)
	    }, {
	      path: ':id/edit',
	      name: 'unitOfMeasure.edit',
	      component: __webpack_require__(2877)
	    }]
	  }, {
	    path: '/inventory',
	    component: __webpack_require__(2861),
	    meta: {
	      requiredModules: ['Inventory']
	    },
	    children: [{
	      path: '/inventory/stocks',
	      name: 'inventory.stock.index',
	      component: __webpack_require__(2860)
	    }, {
	      path: '/inventory/stocks/create',
	      name: 'inventory.stock.create',
	      component: __webpack_require__(2858),
	      meta: {
	        inventoryBridgeStockWrite: true,
	        inventoryBridgeFallback: {
	          name: 'inventory.stock.index'
	        }
	      }
	    }, {
	      path: '/inventory/stocks/:id/view',
	      name: 'inventory.stock.view',
	      component: __webpack_require__(2862)
	    }, {
	      path: '/inventory/stocks/:id/edit',
	      name: 'inventory.stock.edit',
	      component: __webpack_require__(2859),
	      meta: {
	        inventoryBridgeStockWrite: true,
	        inventoryBridgeFallback: {
	          name: 'inventory.stock.view',
	          preserveParams: true
	        }
	      }
	    }, {
	      path: '/inventory/adjustment',
	      name: 'inventory.adjustment.index',
	      component: __webpack_require__(2767)
	    }, {
	      path: '/inventory/adjustment/create/stock',
	      name: 'inventory.adjustment.stock.create',
	      component: __webpack_require__(2768),
	      meta: {
	        inventoryBridgeStockWrite: true,
	        inventoryBridgeFallback: {
	          name: 'inventory.adjustment.index'
	        }
	      }
	    }, {
	      path: '/inventory/adjustment/:id/view',
	      name: 'inventory.adjustment.view',
	      component: __webpack_require__(2770)
	    }, {
	      path: '/inventory/adjustment/stock/:id/edit',
	      name: 'inventory.adjustment.stock.edit',
	      component: __webpack_require__(2769),
	      meta: {
	        inventoryBridgeStockWrite: true,
	        inventoryBridgeFallback: {
	          name: 'inventory.adjustment.view',
	          preserveParams: true
	        }
	      }
	    }, {
	      path: '/inventory/purchase',
	      name: 'inventory.purchase.index',
	      component: __webpack_require__(2852)
	    }, {
	      path: '/inventory/purchase/create',
	      name: 'inventory.purchase.create',
	      component: __webpack_require__(2850),
	      meta: {
	        inventoryBridgeStockWrite: true,
	        inventoryBridgeFallback: {
	          name: 'inventory.purchase.index'
	        }
	      }
	    }, {
	      path: '/inventory/purchase/:id/view',
	      name: 'inventory.purchase.view',
	      component: __webpack_require__(2854)
	    }, {
	      path: '/inventory/purchase/:id/edit',
	      name: 'inventory.purchase.edit',
	      component: __webpack_require__(2851),
	      meta: {
	        inventoryBridgeStockWrite: true,
	        inventoryBridgeFallback: {
	          name: 'inventory.purchase.view',
	          preserveParams: true
	        }
	      }
	    }, {
	      path: '/inventory/purchase/:id/receipt',
	      name: 'inventory.purchase.receipt',
	      component: __webpack_require__(2853),
	      meta: {
	        inventoryBridgeStockWrite: true,
	        inventoryBridgeFallback: {
	          name: 'inventory.purchase.view',
	          preserveParams: true
	        }
	      }
	    }, {
	      path: '/inventory/transfer',
	      name: 'inventory.transfer.index',
	      component: __webpack_require__(2874)
	    }, {
	      path: '/inventory/transfer/create',
	      name: 'inventory.transfer.create',
	      component: __webpack_require__(2873),
	      meta: {
	        inventoryBridgeStockWrite: true,
	        inventoryBridgeFallback: {
	          name: 'inventory.transfer.index'
	        }
	      }
	    }, {
	      path: '/inventory/transfer/:id/view',
	      name: 'inventory.transfer.view',
	      component: __webpack_require__(2875)
	    }, {
	      path: '/inventory/transaction',
	      name: 'inventory.transaction.index',
	      component: __webpack_require__(2872),
	      meta: {
	        inventoryBridgeStockWrite: true,
	        inventoryBridgeFallback: {
	          name: 'inventory.stock.index'
	        }
	      }
	    }, {
	      path: '/inventory/warehouse',
	      name: 'warehouse.index',
	      component: __webpack_require__(2882),
	
	      meta: {
	        auth: true,
	        subMenu: 'all'
	      }
	    }, {
	      path: '/inventory/warehouse/create',
	      name: 'warehouse.create',
	      component: __webpack_require__(2880)
	    }, {
	      path: '/inventory/warehouse/:id/edit',
	      name: 'warehouse.edit',
	      component: __webpack_require__(2881)
	    }]
	  }, {
	    path: '/campaigns',
	    component: __webpack_require__(2782),
	    children: [{
	      path: '',
	      name: 'campaigns.index',
	      component: __webpack_require__(2785),
	
	      meta: {
	        auth: true
	      }
	    }, {
	      path: 'create',
	      name: 'campaigns.create',
	      component: __webpack_require__(2783),
	
	      meta: {
	        auth: true
	      }
	    }, {
	      path: ':id/edit',
	      name: 'campaigns.edit',
	      component: __webpack_require__(2784),
	
	      meta: {
	        auth: true
	      }
	    }, {
	      path: ':id/create-email',
	      name: 'campaigns.createEmail',
	      component: __webpack_require__(2809),
	
	      meta: {
	        auth: true
	      }
	    }, {
	      path: ':id/email/:newsId',
	      name: 'campaigns.editEmail',
	      component: __webpack_require__(2810),
	
	      meta: {
	        auth: true
	      }
	    }]
	  }, {
	    path: '/subscriberList',
	    component: __webpack_require__(2866),
	    children: [{
	      path: '',
	      name: 'subscriberList.index',
	      component: __webpack_require__(2865),
	
	      meta: {
	        auth: true
	      }
	    }, {
	      path: 'create',
	      name: 'subscriberList.create',
	      component: __webpack_require__(2863),
	
	      meta: {
	        auth: true
	      }
	    }, {
	      path: ':id/edit',
	      name: 'subscriberList.edit',
	      component: __webpack_require__(2864),
	
	      meta: {
	        auth: true
	      }
	    }]
	  }, {
	    path: '/orders/order-pickups',
	    component: __webpack_require__(2812),
	    meta: {
	      emailVerificationRequired: true,
	      requiredModules: []
	    },
	    children: [{
	      path: '',
	      name: 'orderPickups.index',
	      component: __webpack_require__(2811)
	    }]
	  }, {
	    path: '/orders',
	    component: __webpack_require__(781),
	    meta: {
	      emailVerificationRequired: true,
	      requiredModules: ['Order']
	    },
	    children: [{
	      path: '',
	      name: 'orders.index',
	      component: __webpack_require__(780)
	    }, {
	      path: 'create',
	      name: 'orders.create',
	      component: __webpack_require__(779)
	    }, {
	      path: ':id/edit',
	      name: 'orders.edit',
	      component: __webpack_require__(2813)
	    }]
	  }, {
	    path: '/appointments',
	    component: __webpack_require__(2771),
	    meta: {
	      emailVerificationRequired: true,
	      requiredModules: ['Order', 'Appointment']
	    },
	    children: [{
	      path: '',
	      name: 'appointments.index',
	      component: __webpack_require__(2772)
	    }]
	  }, {
	    path: '/edi-orders',
	    component: __webpack_require__(781),
	    children: [{
	      path: '',
	      name: 'ediOrders.index',
	      component: __webpack_require__(780),
	
	      meta: {
	        auth: true
	      }
	    }]
	  }, {
	    path: '/modules',
	    component: __webpack_require__(2807),
	    children: [{
	      path: '',
	      name: 'modules.index',
	      component: __webpack_require__(2806),
	
	      meta: {
	        auth: true
	      }
	    }]
	  }, {
	    path: 'bills',
	    component: __webpack_require__(2777),
	    meta: {
	      emailVerificationRequired: true,
	      requiredModules: ['Order']
	    },
	    children: [{
	      path: '',
	      name: 'bills.index',
	      component: __webpack_require__(2780)
	    }, {
	      path: 'create',
	      name: 'bills.create',
	      component: __webpack_require__(2778)
	    }, {
	      path: 'export',
	      name: 'bills.export',
	      component: __webpack_require__(2779)
	    }, {
	      path: ':id/edit',
	      name: 'bills.edit',
	      component: __webpack_require__(775)
	    }, {
	      path: ':id/credit-note',
	      name: 'bills.creditNote',
	      component: __webpack_require__(775)
	    }]
	  }]
	}, {
	  path: '/*',
	  redirect: '/home'
	}];

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _currency = __webpack_require__(1664);
	
	var _currency2 = _interopRequireDefault(_currency);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var currencies = _currency2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchCurrencies', currencies);
	  resolve(currencies);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/account/currencies').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  resolve(data);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/account/default-language-n-currency?' + params).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var appVersionData = data;
	  _store2.default.dispatch('fetchLatestVersion', appVersionData);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('user-app-version').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _language = __webpack_require__(1671);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var languages = _language2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchLanguages', languages);
	  resolve(languages);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/account/languages').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  find();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject('error');
	};
	
	exports.default = function (userId) {
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/account/' + userId + '/off_debug_mode').then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  find();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject('error');
	};
	
	exports.default = function (userId) {
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/account/' + userId + '/on_debug_mode').then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'post';
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    var request = null;
	    if (method === 'post') request = _vue2.default.$http.post('account/set-overview-per-page', params);else request = _vue2.default.$http.get('account/get-overview-per-page/' + params.from);
	    request.then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('account/subscription').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  find();
	  resolve(location.reload());
	};
	
	var failed = function failed(error, reject) {
	  reject('error');
	};
	
	exports.default = function (userId) {
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/account/' + userId + '/switch_organization').then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('account/unpaid-invoice').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _account = __webpack_require__(237);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _find = __webpack_require__(226);
	
	var _find2 = _interopRequireDefault(_find);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  (0, _find2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(_account2.default.fetch(error.response.data));
	};
	
	exports.default = function (account) {
	  var data = new FormData();
	  Object.keys(account).map(function (k) {
	    data.append(k, account[k]);
	    return null;
	  });
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.request({
	      url: '/account',
	      data: data,
	      method: 'post',
	      headers: {
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _find = __webpack_require__(226);
	
	var _find2 = _interopRequireDefault(_find);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  (0, _find2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject('error');
	};
	
	exports.default = function (userId, data) {
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/account/' + userId + '/update_product_index_settings', data).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _account = __webpack_require__(237);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _find = __webpack_require__(226);
	
	var _find2 = _interopRequireDefault(_find);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  (0, _find2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(_account2.default.fetch(error.response.data));
	};
	
	exports.default = function (account) {
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/account/user', account).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (appVersion) {
	  var data = new FormData();
	  data.append('toast_clicked', appVersion);
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.request({
	      url: 'user-app-version/click-toast-msg',
	      data: data,
	      method: 'post'
	    }).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (appVersion) {
	  var data = new FormData();
	  data.append('app_version', appVersion);
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.request({
	      url: 'user-app-version',
	      data: data,
	      method: 'post'
	    }).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/wizard').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('woocommerce').then(function (response) {
	      resolve(response.data.data);
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('woocommerce/generate_token').then(function (response) {
	      success(response.data.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('wordpress').then(function (response) {
	      resolve(response.data.data);
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('wordpress/generate_token').then(function (response) {
	      success(response.data.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _accountingProvider = __webpack_require__(492);
	
	var _accountingProvider2 = _interopRequireDefault(_accountingProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var accountingProviders = _accountingProvider2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllAccountingProviders', accountingProviders);
	  resolve(accountingProviders);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('accounting_providers').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(874);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _additionalCode = __webpack_require__(1651);
	
	var _additionalCode2 = _interopRequireDefault(_additionalCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var exciseAdditionals = _additionalCode2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAdditionalCode', { exciseAdditionals: exciseAdditionals });
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('additional_code').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _show = __webpack_require__(441);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(878);
	
	var _update2 = _interopRequireDefault(_update);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  show: _show2.default,
	  update: _update2.default
	};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _address = __webpack_require__(194);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _show = __webpack_require__(441);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  (0, _show2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(_address2.default.fetch(error.response.data));
	};
	
	exports.default = function (address) {
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/addresses', address).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _addressType = __webpack_require__(1652);
	
	var _addressType2 = _interopRequireDefault(_addressType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var addressTypes = _addressType2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchaddressTypes', addressTypes);
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('address_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data.data);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/adjustments/adjustment-types/all').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _adjustment = __webpack_require__(82);
	
	var _adjustment2 = _interopRequireDefault(_adjustment);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var adjustments = _adjustment2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('FetchAllAdjustments', adjustments);
	  resolve(adjustments);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/adjustments', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _items = __webpack_require__(443);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  (0, _items2.default)(1, 5);
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/adjustments/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (warehouseId) {
	  return window.open(("https://api.kundan.no") + '/adjustments/' + warehouseId + '/download/?token=' + localStorage.getItem('id_token'));
	};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _adjustment = __webpack_require__(82);
	
	var _adjustment2 = _interopRequireDefault(_adjustment);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _store2.default.dispatch('RefreshStockProducts');
	  resolve(_adjustment2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  } else if (errors.message) {
	    reject(errors);
	    return;
	  }
	
	  reject(_adjustment2.default.fetch(errors));
	};
	
	exports.default = function (adjustment) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/adjustments/save-draft', adjustment).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _adjustment = __webpack_require__(82);
	
	var _adjustment2 = _interopRequireDefault(_adjustment);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var adjustment = _adjustment2.default.fetch(data);
	  resolve(adjustment);
	  _store2.default.dispatch('fetchCurrentAdjustment', adjustment);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/adjustments/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _adjustment = __webpack_require__(82);
	
	var _adjustment2 = _interopRequireDefault(_adjustment);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _store2.default.dispatch('RefreshStockProducts');
	  resolve(_adjustment2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  } else if (errors.message) {
	    reject(errors);
	    return;
	  }
	
	  reject(_adjustment2.default.fetch(errors));
	};
	
	exports.default = function (adjustment) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/adjustments', adjustment).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _adjustment = __webpack_require__(82);
	
	var _adjustment2 = _interopRequireDefault(_adjustment);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentAdjustment', _adjustment2.default.fetch(data));
	  resolve(_adjustment2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  } else if (errors.message) {
	    reject(errors);
	    return;
	  }
	
	  reject(_adjustment2.default.fetch(errors));
	};
	
	exports.default = function (id, adjustment) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/adjustments/' + id, adjustment).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _adjustment = __webpack_require__(82);
	
	var _adjustment2 = _interopRequireDefault(_adjustment);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentAdjustment', _adjustment2.default.fetch(data));
	  resolve(_adjustment2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  } else if (errors.message) {
	    reject(errors);
	    return;
	  }
	
	  reject(_adjustment2.default.fetch(errors));
	};
	
	exports.default = function (id, adjustment) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/adjustments/update-draft/' + id, adjustment).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(res, resolve) {
	  resolve(res);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (params) {
	  var data = new FormData();
	  data.append('percentage', params.percentage);
	  data.append('enable_rounding', params.enableRounding);
	  data.append('rounding_type', params.roundingType);
	  data.append('price_type', params.priceType);
	
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.request({
	      url: '/settings/advance/bulk_price_update',
	      data: data,
	      method: 'post'
	    }).then(function (res) {
	      success(res, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bulkPriceUpdate = __webpack_require__(889);
	
	var _bulkPriceUpdate2 = _interopRequireDefault(_bulkPriceUpdate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  bulkPriceUpdate: _bulkPriceUpdate2.default
	};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var appToastData = data;
	  _store2.default.dispatch('fetchToastResp', appToastData);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('user-app-version/toast-msg-resp').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fetchUserAppToast = __webpack_require__(891);
	
	var _fetchUserAppToast2 = _interopRequireDefault(_fetchUserAppToast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetchUserAppToast: _fetchUserAppToast2.default
	};

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var appVersionData = data;
	  _store2.default.dispatch('fetchLatestVersion', appVersionData);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('user-app-version').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(895);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _slots = __webpack_require__(896);
	
	var _slots2 = _interopRequireDefault(_slots);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  items: _items2.default,
	  slots: _slots2.default
	};

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _order = __webpack_require__(57);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var orders = _order2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedOrders', { orders: orders, pagination: pagination });
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var future = arguments[2];
	  var search = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	  return new Promise(function (resolve, reject) {
	    var url = 'orders?filter=appointments';
	
	    if (page && limit) {
	      url = 'orders?filter=appointments&page=' + page + '&limit=' + limit;
	    }
	
	    if (future) {
	      url += '&future_appointments=' + future;
	    }
	
	    if (search) {
	      url += '&search=' + search;
	    }
	
	    return _vue2.default.$http.get(url).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (productId, date) {
	  return new Promise(function (resolve, reject) {
	    return _vue2.default.$http.get('appointments/slots/' + productId + '?now=' + (0, _moment2.default)().format('YYYY-MM-DD HH:mm') + '&date=' + date).then(function (response) {
	      resolve(response);
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _checkBusiness = __webpack_require__(496);
	
	var _checkBusiness2 = _interopRequireDefault(_checkBusiness);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(business, resolve) {
	  resolve(_checkBusiness2.default.fetch(business));
	};
	
	var failed = function failed(errors, reject) {
	  reject(_checkBusiness2.default.fetch(errors));
	};
	
	exports.default = function (business) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('auth/check_business', business).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  if (response.verification) {
	    var token = response.token;
	    var userId = response.user_id;
	    var verificationType = response.verification;
	    var mobileNumber = response.mobile_number;
	    _store2.default.dispatch('twoFactorVerification', {
	      token: token,
	      userId: userId,
	      verificationType: verificationType,
	      mobileNumber: mobileNumber
	    });
	    _vue2.default.router.push({
	      name: 'auth.twoFactorVerification'
	    });
	    resolve();
	  } else {
	    _store2.default.dispatch('login', response.token);
	    _account2.default.find().then(function () {
	      _vue2.default.router.push({
	        name: 'dashboard'
	      });
	      resolve();
	    });
	  }
	};
	
	var failed = function failed(error, reject) {
	  if (!error.response) {
	    var errorMessage = error.message || 'Unable to connect to server. Please check your connection.';
	    return reject({ errors: [errorMessage] });
	  }
	
	  var errorCode = error.response.data && error.response.data.error ? error.response.data.error.code : 0;
	
	  if (error.response.statusText === 'Unauthorized' && errorCode !== 42206 && errorCode !== 42901) {
	    return reject({ errors: ['Invalid credentials'] });
	  }
	
	  if (error.response.data) {
	    return reject(error.response.data);
	  }
	
	  return reject({
	    errors: ['Request failed with status ' + (error.response.status || 'unknown')]
	  });
	};
	
	exports.default = function (user) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/auth', user).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (token) {
	  _store2.default.dispatch('login', token);
	  localStorage.setItem('is_admin', true);
	  _account2.default.find().then(function () {
	    _vue2.default.router.push({
	      name: 'dashboard'
	    });
	  });
	};

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearLocalState = function clearLocalState() {
	  _store2.default.dispatch('logout');
	  _vue2.default.router.push({
	    name: 'auth.login'
	  });
	};
	
	exports.default = function () {
	  _vue2.default.$http.post('/auth/logout').then(function () {
	    clearLocalState();
	  }).catch(function () {
	    clearLocalState();
	  });
	};

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _registerPersonalInfo = __webpack_require__(1665);
	
	var _registerPersonalInfo2 = _interopRequireDefault(_registerPersonalInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  _vue2.default.router.push({
	    name: 'register.done'
	  });
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_registerPersonalInfo2.default.fetch(errors));
	};
	
	exports.default = function (user) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('auth/personal-information', user).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _accountSetup = __webpack_require__(308);
	
	var _accountSetup2 = _interopRequireDefault(_accountSetup);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(token, resolve) {
	  _account2.default.find();
	  _vue2.default.router.push({
	    name: 'dashboard'
	  });
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_accountSetup2.default.fetch(errors));
	};
	
	exports.default = function (user) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('auth/register', user).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _accountSetup = __webpack_require__(308);
	
	var _accountSetup2 = _interopRequireDefault(_accountSetup);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(token, resolve) {
	  _store2.default.dispatch('login', token.token);
	  _account2.default.find();
	  _vue2.default.router.push({
	    name: 'dashboard'
	  });
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_accountSetup2.default.fetch(errors));
	};
	
	exports.default = function (user) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('auth/register_email', user).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function () {
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('auth/resend-confirm').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error.response.data);
	};
	
	exports.default = function (userId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/auth/' + userId + '/resend_sms_2fa_code').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('auth/reset_password', data).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _mutationTypes = __webpack_require__(10);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _auth = __webpack_require__(53);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onRefreshSuccessEvent = document.createEvent('Event');
	onRefreshSuccessEvent.initEvent('onRefreshSuccess', true, true);
	
	var retriesAjaxWhenTokenIsRefreshed = function retriesAjaxWhenTokenIsRefreshed(request) {
	  if (request.config.params !== undefined) {
	    request.config.params.retry = 1;
	  } else {
	    request.config.params = { retry: 1 };
	  }
	  return new Promise(function (resolve, reject) {
	    var resend = function resend(e) {
	      document.removeEventListener(e.type, resend, false);
	      _vue2.default.$http.request(request.config).then(function (response) {
	        return resolve(response);
	      }).catch(function (error) {
	        return reject(error);
	      });
	    };
	    document.addEventListener('onRefreshSuccess', resend);
	  });
	};
	
	var onRefreshSuccess = function onRefreshSuccess(response, request) {
	  document.dispatchEvent(onRefreshSuccessEvent);
	  localStorage.setItem('id_token', response.data.token);
	  _store2.default.dispatch('checkAuthentication');
	  _store2.default.commit(types.UPDATE_REFRESHING, false);
	  return _vue2.default.$http.request(request.config);
	};
	
	var onRefreshError = function onRefreshError(error) {
	  _store2.default.commit(types.UPDATE_REFRESHING, false);
	  if (error.response.data.error.code === 40105) {
	    return _auth2.default.logout();
	  }
	  return Promise.reject(error);
	};
	
	var getRefreshedToken = function getRefreshedToken(request) {
	  if (_store2.default.state.auth.refreshing) {
	    return retriesAjaxWhenTokenIsRefreshed(request);
	  }
	
	  _store2.default.commit(types.UPDATE_REFRESHING, true);
	
	  return _vue2.default.$http.get('refresh_token').then(function (response) {
	    return onRefreshSuccess(response, request);
	  }).catch(onRefreshError);
	};
	
	exports.default = {
	  getRefreshedToken: getRefreshedToken
	};

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response.data.success.message);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('auth/update_password', data).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  var token = localStorage.id_token_saved;
	  _store2.default.dispatch('login', token);
	  _account2.default.find().then(function () {
	    _vue2.default.router.push({
	      name: 'dashboard'
	    });
	    resolve();
	  });
	};
	
	var failed = function failed(error, reject) {
	  if (error.response.statusText === 'Unauthorized') {
	    return reject({ errors: ['Invalid Code'] });
	  }
	  return reject(error.response.data);
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/auth/' + data.user_id + '/verify_google_2fa_code', data).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  var token = localStorage.id_token_saved;
	  _store2.default.dispatch('login', token);
	  _account2.default.find().then(function () {
	    _vue2.default.router.push({
	      name: 'dashboard'
	    });
	    resolve();
	  });
	};
	
	var failed = function failed(error, reject) {
	  if (error.response.statusText === 'Unauthorized') {
	    return reject({ errors: ['Invalid Code'] });
	  }
	  return reject(error.response.data);
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/auth/' + data.user_id + '/verify_sms_2fa_code', data).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _batch = __webpack_require__(49);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var batches = _batch2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllBatches', batches);
	  resolve(batches);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/production/batch', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _batchIngredience = __webpack_require__(67);
	
	var _batchIngredience2 = _interopRequireDefault(_batchIngredience);
	
	var _batch = __webpack_require__(49);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, data) {
	  var batchIngrediences = _batchIngredience2.default.fetchCollection(data.ingrediences);
	  _store2.default.dispatch('fetchAllBatchIngrediences', batchIngrediences);
	  resolve(_batch2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.data.batch) {
	    var batchIngrediences = _batchIngredience2.default.fetchCollection(errors.data.batch.ingrediences);
	    _store2.default.dispatch('fetchAllBatchIngrediences', batchIngrediences);
	  }
	  reject(errors);
	};
	
	exports.default = function (id, data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/batch/' + id + '/complete_batch', data).then(function (response) {
	      success(resolve, response.data);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _batchIngredience = __webpack_require__(67);
	
	var _batchIngredience2 = _interopRequireDefault(_batchIngredience);
	
	var _batch = __webpack_require__(49);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, data) {
	  var batchIngrediences = _batchIngredience2.default.fetchCollection(data.ingrediences);
	  _store2.default.dispatch('fetchAllBatchIngrediences', batchIngrediences);
	  resolve(_batch2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.data.batch) {
	    var batchIngrediences = _batchIngredience2.default.fetchCollection(errors.data.batch.ingrediences);
	    _store2.default.dispatch('fetchAllBatchIngrediences', batchIngrediences);
	  }
	  reject(errors);
	};
	
	exports.default = function (id, data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/batch/' + id + '/deduct_all', data).then(function (response) {
	      success(resolve, response.data);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _batch = __webpack_require__(49);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var batches = _batch2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedBatches', { batches: batches, pagination: pagination });
	  resolve(batches);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('production/batch', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return data.data.next_batch_number;
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    return _vue2.default.$http.get('/production/next_batch_number').then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _batchIngredience = __webpack_require__(67);
	
	var _batchIngredience2 = _interopRequireDefault(_batchIngredience);
	
	var _batch = __webpack_require__(49);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, data) {
	  var batchIngrediences = _batchIngredience2.default.fetchCollection(data.ingrediences);
	  _store2.default.dispatch('fetchAllBatchIngrediences', batchIngrediences);
	  resolve(_batch2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.data.batch) {
	    var batchIngrediences = _batchIngredience2.default.fetchCollection(errors.data.batch.ingrediences);
	    _store2.default.dispatch('fetchAllBatchIngrediences', batchIngrediences);
	  }
	  reject(errors);
	};
	
	exports.default = function (id, batchProcedureStatus) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/batch/' + id + '/set_batch_procedure_status', batchProcedureStatus).then(function (response) {
	      success(resolve, response.data);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _batch = __webpack_require__(49);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return _batch2.default.fetch(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var batchs = _store2.default.state.batch.items.filter(function (p) {
	      return id.toString() === p.id.toString();
	    });
	
	    if (batchs.length > 0) {
	      return resolve(batchs[0]);
	    }
	
	    return _vue2.default.$http.get('/production/batch/' + id).then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _batchIngredience = __webpack_require__(67);
	
	var _batchIngredience2 = _interopRequireDefault(_batchIngredience);
	
	var _batch = __webpack_require__(49);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, data) {
	  var batchIngrediences = _batchIngredience2.default.fetchCollection(data.ingrediences);
	  _store2.default.dispatch('fetchAllBatchIngrediences', batchIngrediences);
	  resolve(_batch2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.data.batch) {
	    var batchIngrediences = _batchIngredience2.default.fetchCollection(errors.data.batch.ingrediences);
	    _store2.default.dispatch('fetchAllBatchIngrediences', batchIngrediences);
	  }
	  reject(errors);
	};
	
	exports.default = function (id, data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/batch/' + id + '/start_batch', data).then(function (response) {
	      success(resolve, response.data);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _batch = __webpack_require__(49);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  resolve(_batch2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  reject(_batch2.default.fetch(errors));
	};
	
	exports.default = function (batch) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/batch', batch).then(function (response) {
	      success(resolve, response.data);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _batch = __webpack_require__(49);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_batch2.default.fetch(errors));
	};
	
	exports.default = function (id, batch) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/production/batch/' + id, batch).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _batch = __webpack_require__(49);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_batch2.default.fetch(errors));
	};
	
	exports.default = function (id, option) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/production/batch/transfer_product/' + id + '/update', option).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _batchIngredience = __webpack_require__(67);
	
	var _batchIngredience2 = _interopRequireDefault(_batchIngredience);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _batchIngredience2.default.fetchCollection(response.data).forEach(function (data) {
	    _store2.default.dispatch('addBatchIngredience', data);
	  });
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_batchIngredience2.default.fetch(errors));
	};
	
	exports.default = function (batchId, batchIngrediences) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/batch/' + batchId + '/batch_ingredience/bulk', { items: _batchIngredience2.default.sendCollection(batchIngrediences) }).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _batchIngredience = __webpack_require__(67);
	
	var _batchIngredience2 = _interopRequireDefault(_batchIngredience);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _store2.default.dispatch('updateBatchIngredience', {
	    batchIngredience: _batchIngredience2.default.fetch(response.data),
	    id: response.data.id
	  });
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (id, data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/batch_ingredience/' + id + '/deduct', data).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _all = __webpack_require__(445);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, id) {
	  _store2.default.dispatch('removeBatchIngredience', id);
	  (0, _all2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/production/batch_ingredience/' + id).then(function () {
	      success(resolve, id);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(445);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(926);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _store = __webpack_require__(928);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _bulkStore = __webpack_require__(922);
	
	var _bulkStore2 = _interopRequireDefault(_bulkStore);
	
	var _show = __webpack_require__(927);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(929);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _destroy = __webpack_require__(924);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _deduct = __webpack_require__(923);
	
	var _deduct2 = _interopRequireDefault(_deduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  items: _items2.default,
	  store: _store2.default,
	  bulkStore: _bulkStore2.default,
	  show: _show2.default,
	  update: _update2.default,
	  destroy: _destroy2.default,
	  deduct: _deduct2.default
	};

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _batchIngredience = __webpack_require__(67);
	
	var _batchIngredience2 = _interopRequireDefault(_batchIngredience);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var batchIngrediences = _batchIngredience2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedMaterials', { batchIngrediences: batchIngrediences, pagination: pagination });
	  resolve(batchIngrediences);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('production/batch_ingredience', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _batchIngredience = __webpack_require__(67);
	
	var _batchIngredience2 = _interopRequireDefault(_batchIngredience);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return _batchIngredience2.default.fetch(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var batchIngrediences = _store2.default.state.batchIngredience.items.filter(function (p) {
	      return id.toString() === p.id.toString();
	    });
	
	    if (batchIngrediences.length > 0) {
	      return resolve(batchIngrediences[0]);
	    }
	
	    return _vue2.default.$http.get('/production/batch_ingredience/' + id).then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _batchIngredience = __webpack_require__(67);
	
	var _batchIngredience2 = _interopRequireDefault(_batchIngredience);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _store2.default.dispatch('addBatchIngredience', _batchIngredience2.default.fetch(response.data));
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_batchIngredience2.default.fetch(errors));
	};
	
	exports.default = function (batchIngredience) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/batch_ingredience', _batchIngredience2.default.send(batchIngredience)).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _batchIngredience = __webpack_require__(67);
	
	var _batchIngredience2 = _interopRequireDefault(_batchIngredience);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _store2.default.dispatch('updateBatchIngredience', {
	    batchIngredience: _batchIngredience2.default.fetch(response.data),
	    id: response.data.id
	  });
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_batchIngredience2.default.fetch(errors));
	};
	
	exports.default = function (id, batchIngredience) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/production/batch_ingredience/' + id, _batchIngredience2.default.send(batchIngredience)).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _batchLog = __webpack_require__(238);
	
	var _batchLog2 = _interopRequireDefault(_batchLog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var batchLogs = _batchLog2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllBatchLogs', batchLogs);
	  resolve(batchLogs);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/production/batch_log').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _batchLog = __webpack_require__(238);
	
	var _batchLog2 = _interopRequireDefault(_batchLog);
	
	var _items = __webpack_require__(447);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, batchId, page, limit) {
	  resolve();
	  (0, _items2.default)({
	    page: page,
	    limit: limit,
	    batch_id: batchId
	  });
	};
	
	var failed = function failed(errors, reject) {
	  reject(_batchLog2.default.fetch(errors));
	};
	
	exports.default = function (batch, page, limit) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/batch_log', batch).then(function () {
	      success(resolve, batch.batch_id, page, limit);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _store2.default.dispatch('setDownloadProviderList', response.data);
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/export-archive').then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'show';
	  var id = arguments[1];
	  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return new Promise(function (resolve, reject) {
	    var request = null;
	    if (type === 'show') {
	      request = _vue2.default.$http.get('/bills/pdf_attachment/' + id + '/load');
	    } else if (type === 'remove') {
	      request = _vue2.default.$http.post('/bills/pdf_attachment/' + id + '/remove', params);
	    } else if (type === 'revert') {
	      request = _vue2.default.$http.post('/bills/pdf_attachment/' + id + '/revert', params);
	    } else if (type === 'generate') {
	      request = _vue2.default.$http.post('/bills/original_pdf_attachment/' + id + '/generate', params);
	    } else if (type === 'exist') {
	      request = _vue2.default.$http.post('/bills/pdf_attachment/' + id + '/exist', params);
	    }
	    request.then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error.response.data);
	    });
	  });
	};

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _bill = __webpack_require__(55);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var result = {
	    errors: data.errors,
	    data: _bill2.default.fetchCollection(data.data)
	  };
	  resolve(result);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (billIds, data) {
	  return new Promise(function (resolve, reject) {
	    var url = '/bills/bulk_mark_as_paid?bill_ids=' + billIds.join(',');
	    _vue2.default.$http.post(url, data).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response, reject);
	    });
	  });
	};

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('bills/create-reminder/' + id, params).then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error.response.data);
	    });
	  });
	};

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/bills/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _bill = __webpack_require__(55);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentBill', _bill2.default.fetch(data));
	  resolve(_bill2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_bill2.default.fetch(errors));
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/bills/' + id + '/generate_kid').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _bill = __webpack_require__(55);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var bills = _bill2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedBills', { bills: bills, pagination: pagination });
	  resolve({ bills: bills, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/bills', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _bill = __webpack_require__(55);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentBill', _bill2.default.fetch(data));
	  resolve(_bill2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_bill2.default.fetch(errors));
	};
	
	exports.default = function (id) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/bills/' + id + '/mark_as_paid', params).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _billPayment = __webpack_require__(1655);
	
	var _billPayment2 = _interopRequireDefault(_billPayment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  if (response.data.data) {
	    var result = {
	      errors: response.data.errors,
	      data: _billPayment2.default.fetchCollection(response.data.data)
	    };
	    resolve(result);
	  } else {
	    resolve(_billPayment2.default.fetch(response.data));
	  }
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_billPayment2.default.fetch(errors));
	};
	
	exports.default = function (billId) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    var data = _billPayment2.default.send(params);
	    _vue2.default.$http.post('/bills/payment/' + billId, data).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('bills/payment_reminder/' + id, params).then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error.response);
	    });
	  });
	};

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('bills/payment_reminder_preview/' + id).then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error.response);
	    });
	  });
	};

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _bill = __webpack_require__(55);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var bill = _bill2.default.fetch(data);
	  _store2.default.dispatch('fetchCurrentBill', bill);
	  resolve(bill);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/bills/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _bill = __webpack_require__(55);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  if (response.data.data) {
	    var result = {
	      errors: response.data.errors,
	      data: _bill2.default.fetchCollection(response.data.data)
	    };
	    resolve(result);
	  } else {
	    resolve(_bill2.default.fetch(response.data));
	  }
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_bill2.default.fetch(errors));
	};
	
	exports.default = function (bill) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/bills', bill).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _bill = __webpack_require__(55);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentBill', _bill2.default.fetch(data));
	
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_bill2.default.fetch(errors));
	};
	
	exports.default = function (id, bill) {
	  return new Promise(function (resolve, reject) {
	    var b = _bill2.default.send(bill);
	    if (_typeof(b.order_id) === 'object') {
	      b.order_id = b.order_id.id;
	    }
	    _vue2.default.$http.put('/bills/' + id, b).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _bill = __webpack_require__(55);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentBill', _bill2.default.fetch(data));
	  resolve(_bill2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_bill2.default.fetch(errors));
	};
	
	exports.default = function (id, roundInvoiceTotal) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/bills/' + id + '/updateRoundInvoiceTotal', _bill2.default.send({ roundInvoiceTotal: roundInvoiceTotal })).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data.data);
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject();
	};
	
	exports.default = function (id, kidNumber) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/bills/' + id + '/validate_kid', { kid_number: kidNumber }).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _creditNoteProduct = __webpack_require__(99);
	
	var _creditNoteProduct2 = _interopRequireDefault(_creditNoteProduct);
	
	var _all = __webpack_require__(290);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, id, resolve) {
	  (0, _all2.default)(id);
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_creditNoteProduct2.default.fetch(errors));
	};
	
	exports.default = function (id, billProducts) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/bills/' + id + '/products/bulk', { items: _creditNoteProduct2.default.sendCollection(billProducts) }).then(function (response) {
	      success(response.data, id, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(id, resolve) {
	  _store2.default.dispatch('removeBillProduct', id);
	  resolve();
	};
	
	var failed = function failed(reject) {
	  return reject();
	};
	
	exports.default = function (billId, billProductId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/bills/' + billId + '/products/' + billProductId).then(function () {
	      success(billProductId, resolve);
	    }).catch(function () {
	      failed(reject);
	    });
	  });
	};

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _creditNoteProduct = __webpack_require__(99);
	
	var _creditNoteProduct2 = _interopRequireDefault(_creditNoteProduct);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var billProducts = _creditNoteProduct2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllBillProducts', billProducts);
	  resolve(billProducts);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/bills/' + id + '/products/search-order-product', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _creditNoteProduct = __webpack_require__(99);
	
	var _creditNoteProduct2 = _interopRequireDefault(_creditNoteProduct);
	
	var _all = __webpack_require__(290);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, id, resolve) {
	  (0, _all2.default)(id);
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_creditNoteProduct2.default.fetch(errors));
	};
	
	exports.default = function (id, billProduct) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/bills/' + id + '/products', _creditNoteProduct2.default.send(billProduct)).then(function (response) {
	      success(response.data, id, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _creditNoteProduct = __webpack_require__(99);
	
	var _creditNoteProduct2 = _interopRequireDefault(_creditNoteProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, id, resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_creditNoteProduct2.default.fetch(errors));
	};
	
	exports.default = function (id, billProduct, billProductId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/bills/' + id + '/products/' + billProductId, _creditNoteProduct2.default.send(billProduct)).then(function (response) {
	      success(response.data, id, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _billStatus = __webpack_require__(1656);
	
	var _billStatus2 = _interopRequireDefault(_billStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var billStatuses = _billStatus2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchBillStatuses', billStatuses);
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('bill_status').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _billType = __webpack_require__(1657);
	
	var _billType2 = _interopRequireDefault(_billType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var billTypes = _billType2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchBillTypes', billTypes);
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('bill_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return new Promise(function (resolve) {
	    _vue2.default.$http.get('/inventory-bridge/handoff-state').then(function (response) {
	      var payload = response && response.data && response.data.data || {};
	      if ((payload.stock_mutations_handed_off || payload.stock_decommissioned) && !payload.inventory_app_url) {
	        console.warn('[bridgeHandoff] org is handed off but INVENTORY_APP_URL is empty in the monolith env — banner will render without an "Open Inventory App" link.');
	      }
	      _store2.default.dispatch('setBridgeHandoff', payload);
	      resolve(payload);
	    }).catch(function () {
	      _store2.default.dispatch('setBridgeHandoff', false);
	      resolve(null);
	    });
	  });
	};

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fetch = __webpack_require__(955);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  fetch: _fetch2.default
	};

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _businessDay = __webpack_require__(1660);
	
	var _businessDay2 = _interopRequireDefault(_businessDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var days = _businessDay2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchBusinessDays', days);
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('business_days').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(957);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _all = __webpack_require__(291);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, id) {
	  _store2.default.dispatch('destroyBusinessHour', id);
	  (0, _all2.default)();
	  resolve();
	};
	
	var failed = function failed(reject) {
	  return reject();
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/business_hours/' + id).then(function () {
	      success(resolve, id);
	    }).catch(function () {
	      failed(reject);
	    });
	  });
	};

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(291);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(961);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _destroy = __webpack_require__(959);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  store: _store2.default,
	  destroy: _destroy2.default
	};

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _businessHour = __webpack_require__(493);
	
	var _businessHour2 = _interopRequireDefault(_businessHour);
	
	var _all = __webpack_require__(291);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, b) {
	  _store2.default.dispatch('storeBusinessHour', b);
	  (0, _all2.default)();
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_businessHour2.default.fetch(errors));
	};
	
	exports.default = function (businessHour) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('business_hours', _businessHour2.default.send(businessHour)).then(function () {
	      success(resolve, businessHour);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _all = __webpack_require__(292);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, id) {
	  _store2.default.dispatch('destroyBusinessHourException', id);
	  (0, _all2.default)();
	  resolve();
	};
	
	var failed = function failed(reject) {
	  return reject();
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/business_hour_exceptions/' + id).then(function () {
	      success(resolve, id);
	    }).catch(function () {
	      failed(reject);
	    });
	  });
	};

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _businessHourException = __webpack_require__(306);
	
	var _businessHourException2 = _interopRequireDefault(_businessHourException);
	
	var _all = __webpack_require__(292);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve, e) {
	  _store2.default.dispatch('storeBusinessHourException', e);
	  (0, _all2.default)();
	  resolve(response);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (businessHour) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('business_hour_exceptions', _businessHourException2.default.send(businessHour)).then(function (response) {
	      success(response, resolve, businessHour);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _items = __webpack_require__(452);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  (0, _items2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('news_campaigns/' + id).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _campaign = __webpack_require__(163);
	
	var _campaign2 = _interopRequireDefault(_campaign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(campaign, resolve) {
	  resolve(_campaign2.default.fetch(campaign));
	};
	
	var failed = function failed(errors, reject) {
	  reject(_campaign2.default.fetch(errors));
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('news_campaigns/' + id).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _campaign = __webpack_require__(163);
	
	var _campaign2 = _interopRequireDefault(_campaign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _vue2.default.router.push({
	    name: 'campaigns.edit',
	    params: { id: data.id }
	  });
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_campaign2.default.fetch(errors));
	};
	
	exports.default = function (campaign) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('news_campaigns', campaign).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _campaign = __webpack_require__(163);
	
	var _campaign2 = _interopRequireDefault(_campaign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(campaign, resolve) {
	  resolve(campaign);
	};
	
	var failed = function failed(errors, reject) {
	  reject(_campaign2.default.fetch(errors));
	};
	
	exports.default = function (id, campaign) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('news_campaigns/' + id, campaign).then(function () {
	      success(campaign, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _campaignType = __webpack_require__(1661);
	
	var _campaignType2 = _interopRequireDefault(_campaignType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var campaignTypes = _campaignType2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchCampaignTypes', campaignTypes);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('campaign_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _chartOfAccounts = __webpack_require__(239);
	
	var _chartOfAccounts2 = _interopRequireDefault(_chartOfAccounts);
	
	var _all = __webpack_require__(293);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  (0, _all2.default)();
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_chartOfAccounts2.default.fetch(errors));
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/chart_of_accounts/create_coa').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(id, resolve) {
	  _store2.default.dispatch('removeChartOfAccountsItem', id);
	  resolve();
	};
	
	var failed = function failed(reject) {
	  return reject();
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/chart_of_accounts/' + id).then(function () {
	      success(id, resolve);
	    }).catch(function () {
	      failed(reject);
	    });
	  });
	};

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _chartOfAccounts = __webpack_require__(239);
	
	var _chartOfAccounts2 = _interopRequireDefault(_chartOfAccounts);
	
	var _all = __webpack_require__(293);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  (0, _all2.default)();
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error && errors.error.code) {
	    reject(errors.error);
	    return;
	  }
	  reject(_chartOfAccounts2.default.fetch(errors));
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/chart_of_accounts', _chartOfAccounts2.default.send(data)).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _chartOfAccounts = __webpack_require__(239);
	
	var _chartOfAccounts2 = _interopRequireDefault(_chartOfAccounts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_chartOfAccounts2.default.fetch(errors));
	};
	
	exports.default = function (id, data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/chart_of_accounts/' + id, _chartOfAccounts2.default.send(data)).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _clientGroup = __webpack_require__(129);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var clientGroups = _clientGroup2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllClientGroups', clientGroups);
	
	  resolve(clientGroups);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(search === null ? 'client_groups' : '/client_groups?search=' + search).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _items = __webpack_require__(454);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  (0, _items2.default)(1, 5);
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/client_groups/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _clientGroup = __webpack_require__(129);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return _clientGroup2.default.fetch(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var clientGroups = _store2.default.state.clientGroup.items.filter(function (c) {
	      return c.id.toString() === id.toString();
	    });
	
	    if (clientGroups.length > 0) {
	      return resolve(clientGroups[0]);
	    }
	
	    return _vue2.default.$http.get('/client_groups/' + id).then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _clientGroup = __webpack_require__(129);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_clientGroup2.default.fetch(errors));
	};
	
	exports.default = function (clientGroup) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('client_groups', clientGroup).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _clientGroup = __webpack_require__(129);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_clientGroup2.default.fetch(errors));
	};
	
	exports.default = function (id, clientGroup) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/client_groups/' + id, clientGroup).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _client = __webpack_require__(56);
	
	var _client2 = _interopRequireDefault(_client);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var clients = _client2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllClients', clients);
	  resolve(clients);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var clientParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(search === null ? '/clients' : '/clients?search=' + search + '&client_parent=' + clientParent).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _client = __webpack_require__(56);
	
	var _client2 = _interopRequireDefault(_client);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var clients = _client2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllClientOptions', clients);
	  resolve(clients);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/clients?basic_fields=1' + params).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _client = __webpack_require__(56);
	
	var _client2 = _interopRequireDefault(_client);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var result = {
	    errors: data.errors,
	    data: _client2.default.fetchCollection(data.data)
	  };
	  resolve(result);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/clients/update/bullkprocess', data).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response, reject);
	    });
	  });
	};

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  resolve(data);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/clients/counts').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error.response.data);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/clients/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	  return resolve(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (organizationNumber) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/clients/ehf_lookup?organization_number=' + organizationNumber).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	  return resolve(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/clients/find/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	  return resolve(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (organizationNumber) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/clients/gln-lookup/' + organizationNumber).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _client = __webpack_require__(56);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var clients = _client2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchClients', { clients: clients, pagination: pagination });
	  resolve({ clients: clients, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/clients', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _catalogue = __webpack_require__(494);
	
	var _catalogue2 = _interopRequireDefault(_catalogue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(_catalogue2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.request({
	      url: '/catalogues',
	      data: data,
	      method: 'post'
	    }).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _client = __webpack_require__(56);
	
	var _client2 = _interopRequireDefault(_client);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	  return resolve(_client2.default.fetch(data));
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/clients/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, _ref) {
	  var data = _ref.data;
	
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (client) {
	  var data = client;
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.request({
	      url: '/clients',
	      data: data,
	      method: 'post',
	      headers: {
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _client = __webpack_require__(56);
	
	var _client2 = _interopRequireDefault(_client);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(client, resolve) {
	  resolve(_client2.default.fetch(client));
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (id, client) {
	  var data = client;
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.request({
	      url: '/clients/' + id,
	      data: data,
	      method: 'post',
	      headers: {
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _client = __webpack_require__(56);
	
	var _client2 = _interopRequireDefault(_client);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(client, resolve) {
	  resolve(_client2.default.fetch(client));
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (id, client) {
	  var data = client;
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.request({
	      url: '/clients/' + id + '/update_address',
	      data: data,
	      method: 'post',
	      headers: {
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (campaignId, id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('news_campaigns/' + campaignId + '/clients/' + id).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(994);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _store = __webpack_require__(995);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _destroy = __webpack_require__(992);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  items: _items2.default,
	  store: _store2.default,
	  destroy: _destroy2.default
	};

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _client = __webpack_require__(56);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var items = _client2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  resolve({ items: items, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (campaignId) {
	  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('news_campaigns/' + campaignId + '/clients?page=' + page + '&limit=' + limit).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (campaignId, clients) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('news_campaigns/' + campaignId + '/clients', clients).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _clientType = __webpack_require__(495);
	
	var _clientType2 = _interopRequireDefault(_clientType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var clientTypes = _clientType2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllClientTypes', clientTypes);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('client_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _show = __webpack_require__(455);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(998);
	
	var _update2 = _interopRequireDefault(_update);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  show: _show2.default,
	  update: _update2.default
	};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _contact = __webpack_require__(240);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _show = __webpack_require__(455);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  (0, _show2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(_contact2.default.fetch(error.response.data));
	};
	
	exports.default = function (contact) {
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/contacts', contact).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _contactType = __webpack_require__(1662);
	
	var _contactType2 = _interopRequireDefault(_contactType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var contactTypes = _contactType2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchcontactTypes', contactTypes);
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('contact_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(999);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _country = __webpack_require__(307);
	
	var _country2 = _interopRequireDefault(_country);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var countries = _country2.default.fetchCollection(data.data);
	  var pagination = _country2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchCountries', { countries: countries, pagination: pagination });
	
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('countries').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (hashid) {
	  return window.open(("https://api.kundan.no") + '/credit_note/' + hashid + '/pdf/download/?token=' + localStorage.getItem('id_token'));
	};

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (hashid) {
	  return window.open(("https://api.kundan.no") + '/credit_note/' + hashid + '/?token=' + localStorage.getItem('id_token'));
	};

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _bill = __webpack_require__(55);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var bill = _bill2.default.fetch(data);
	  _store2.default.dispatch('fetchCurrentBill', bill);
	
	  resolve(bill);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('credit_note', { id: id }).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (errors) {
	      failed(errors, reject);
	    });
	  });
	};

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _bill = __webpack_require__(55);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentBill', _bill2.default.fetch(data));
	  resolve(_bill2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error && errors.error.code === 40120) {
	    reject(errors.error);
	  }
	  reject(_bill2.default.fetch(errors));
	};
	
	exports.default = function (id, bill) {
	  return new Promise(function (resolve, reject) {
	    var b = _bill2.default.send(bill);
	    if (_typeof(b.order_id) === 'object') {
	      b.order_id = b.order_id.id;
	    }
	    _vue2.default.$http.put('/credit_note/' + id, b).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _creditNoteProduct = __webpack_require__(99);
	
	var _creditNoteProduct2 = _interopRequireDefault(_creditNoteProduct);
	
	var _all = __webpack_require__(295);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, id, resolve) {
	  (0, _all2.default)(id);
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (id, creditNoteProducts) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/credit_notes/' + id + '/products/bulk', { items: _creditNoteProduct2.default.sendCollection(creditNoteProducts) }).then(function (response) {
	      success(response.data, id, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(id, resolve) {
	  _store2.default.dispatch('removeCreditNoteProduct', id);
	  resolve();
	};
	
	var failed = function failed(reject) {
	  return reject();
	};
	
	exports.default = function (creditNoteId, creditNoteProductId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/credit_notes/' + creditNoteId + '/products/' + creditNoteProductId).then(function () {
	      success(creditNoteProductId, resolve);
	    }).catch(function () {
	      failed(reject);
	    });
	  });
	};

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(295);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(1009);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _bulkStore = __webpack_require__(1006);
	
	var _bulkStore2 = _interopRequireDefault(_bulkStore);
	
	var _destroy = __webpack_require__(1007);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	var _update = __webpack_require__(1010);
	
	var _update2 = _interopRequireDefault(_update);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  store: _store2.default,
	  bulkStore: _bulkStore2.default,
	  destroy: _destroy2.default,
	  update: _update2.default
	};

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _creditNoteProduct = __webpack_require__(99);
	
	var _creditNoteProduct2 = _interopRequireDefault(_creditNoteProduct);
	
	var _all = __webpack_require__(295);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, id, resolve) {
	  (0, _all2.default)(id);
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_creditNoteProduct2.default.fetch(errors));
	};
	
	exports.default = function (id, creditNoteProduct) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/credit_notes/' + id + '/products', _creditNoteProduct2.default.send(creditNoteProduct)).then(function (response) {
	      success(response.data, id, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _creditNoteProduct = __webpack_require__(99);
	
	var _creditNoteProduct2 = _interopRequireDefault(_creditNoteProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, id, resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_creditNoteProduct2.default.fetch(errors));
	};
	
	exports.default = function (id, creditNoteProduct, creditNoteProductId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/credit_notes/' + id + '/products/' + creditNoteProductId, _creditNoteProduct2.default.send(creditNoteProduct)).then(function (response) {
	      success(response.data, id, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _creditNoteReason = __webpack_require__(1663);
	
	var _creditNoteReason2 = _interopRequireDefault(_creditNoteReason);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var creditNoteReasons = _creditNoteReason2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllCreditNoteReasons', creditNoteReasons);
	  resolve(creditNoteReasons);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('credit_note_reason').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1011);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _update = __webpack_require__(1013);
	
	var _update2 = _interopRequireDefault(_update);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  update: _update2.default
	};

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _bill = __webpack_require__(55);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentBill', _bill2.default.fetch(data));
	  resolve(_bill2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error && errors.error.code === 40120) {
	    reject(errors.error);
	  }
	  reject(_bill2.default.fetch(errors));
	};
	
	exports.default = function (id, bill) {
	  return new Promise(function (resolve, reject) {
	    var b = _bill2.default.send(bill);
	    if (_typeof(b.order_id) === 'object') {
	      b.order_id = b.order_id.id;
	    }
	    _vue2.default.$http.put('/credit_note/reason/' + id, b).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _depositSystem = __webpack_require__(1666);
	
	var _depositSystem2 = _interopRequireDefault(_depositSystem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var depositSystems = _depositSystem2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllDepositSystems', depositSystems);
	  _store2.default.dispatch('setNullDepositSystem');
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('deposit_systems').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _ediOrder = __webpack_require__(61);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var ediOrders = _ediOrder2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllEdiOrders', ediOrders);
	  resolve(ediOrders);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/edi_orders').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ediOrder = __webpack_require__(61);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var result = {
	    errors: data.errors,
	    data: _ediOrder2.default.fetchCollection(data.data)
	  };
	  resolve(result);
	};
	
	exports.default = function (orderIds, ediOrder) {
	  return new Promise(function (resolve, reject) {
	    var url = 'edi_orders/confirm?order_ids=' + orderIds.join(',');
	    _vue2.default.$http.post(url, ediOrder).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      reject(error.response);
	    });
	  });
	};

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ediOrder = __webpack_require__(61);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var result = {
	    errors: data.errors,
	    data: _ediOrder2.default.fetchCollection(data.data)
	  };
	  resolve(result);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (orderIds, order) {
	  return new Promise(function (resolve, reject) {
	    var url = '/edi_orders/confirm-order-shipping?order_ids=' + orderIds.join(',');
	
	    _vue2.default.$http.post(url, order).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response, reject);
	    });
	  });
	};

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ediOrder = __webpack_require__(61);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var result = {
	    errors: data.errors,
	    data: _ediOrder2.default.fetchCollection(data.data)
	  };
	  resolve(result);
	};
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (orderIds, ediOrder) {
	  return new Promise(function (resolve, reject) {
	    var url = 'edi_orders/process?order_ids=' + orderIds.join(',');
	
	    _vue2.default.$http.post(url, ediOrder).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response, reject);
	    });
	  });
	};

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ediOrder = __webpack_require__(61);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentEdiOrder', _ediOrder2.default.fetch(data));
	  resolve(data);
	};
	
	exports.default = function (id, ediOrder) {
	  return new Promise(function (resolve, reject) {
	    var url = 'edi_orders/' + id + '/cancel';
	
	    if (localStorage.getItem('is_admin')) {
	      url = 'edi_orders/' + id + '/cancel?is_admin=true';
	    }
	
	    _vue2.default.$http.post(url, _ediOrder2.default.send(ediOrder)).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function () {
	      reject();
	    });
	  });
	};

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ediOrder = __webpack_require__(61);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentEdiOrder', _ediOrder2.default.fetch(data));
	  resolve(data);
	};
	
	exports.default = function (id, ediOrder) {
	  return new Promise(function (resolve, reject) {
	    var url = 'edi_orders/' + id + '/confirm';
	
	    if (localStorage.getItem('is_admin')) {
	      url = 'edi_orders/' + id + '/confirm?is_admin=true';
	    }
	
	    _vue2.default.$http.post(url, ediOrder).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      reject(error.response);
	    });
	  });
	};

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ediOrder = __webpack_require__(61);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _bill = __webpack_require__(55);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data) {
	  _store2.default.dispatch('fetchCurrentBill', _bill2.default.fetch(data));
	  _vue2.default.router.push({
	    name: 'bills.creditNote',
	    params: {
	      id: data.id
	    }
	  });
	};
	
	exports.default = function (id, ediOrder) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('edi_orders/' + id + '/credit_note', _ediOrder2.default.send(ediOrder)).then(function (response) {
	      success(response.data);
	      resolve();
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ediOrder = __webpack_require__(61);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _order = __webpack_require__(57);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data) {
	  _store2.default.dispatch('fetchCurrentOrder', _order2.default.fetch(data));
	  _vue2.default.router.push({
	    name: 'orders.edit',
	    params: {
	      id: data.id
	    }
	  });
	};
	
	exports.default = function (id, ediOrder) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('edi_orders/' + id + '/invoice', _ediOrder2.default.send(ediOrder)).then(function (response) {
	      success(response.data);
	      resolve();
	    }).catch(function () {
	      reject();
	    });
	  });
	};

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _ediOrder = __webpack_require__(61);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var ediOrders = _ediOrder2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedEdiOrders', { ediOrders: ediOrders, pagination: pagination });
	  resolve({ ediOrders: ediOrders, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var search = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	  var filter = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	  return new Promise(function (resolve, reject) {
	    var url = !page && !limit ? 'edi_orders' : 'edi_orders?page=' + page + '&limit=' + limit;
	
	    if (sort) {
	      url += '&sort=' + sort;
	    }
	    if (search) {
	      url += (url === 'edi_orders' ? '?' : '&') + 'search=' + search;
	    }
	
	    if (filter) {
	      url += '&' + filter;
	    }
	    _vue2.default.$http.get(url).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ediOrder = __webpack_require__(61);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data) {
	  _store2.default.dispatch('fetchCurrentEdiOrder', _ediOrder2.default.fetch(data));
	};
	
	exports.default = function (id, ediOrder) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('edi_orders/' + id + '/link_order', _ediOrder2.default.send(ediOrder)).then(function (response) {
	      success(response.data);
	      resolve();
	    }).catch(function () {
	      reject();
	    });
	  });
	};

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ediOrder = __webpack_require__(61);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentEdiOrder', _ediOrder2.default.fetch(data));
	  resolve(data);
	};
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id, ediOrder) {
	  return new Promise(function (resolve, reject) {
	    var url = 'edi_orders/' + id + '/process';
	
	    if (localStorage.getItem('is_admin')) {
	      url = 'edi_orders/' + id + '/process?is_admin=true';
	    }
	
	    _vue2.default.$http.post(url, ediOrder).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response, reject);
	    });
	  });
	};

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ediOrder = __webpack_require__(61);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  _store2.default.dispatch('fetchCurrentEdiOrder', _ediOrder2.default.fetch(data));
	  resolve(_ediOrder2.default.fetch(data));
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/edi_orders/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _ediOrderItem = __webpack_require__(497);
	
	var _ediOrderItem2 = _interopRequireDefault(_ediOrderItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var ediOrderItems = _ediOrderItem2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllEdiOrderItems', ediOrderItems);
	  resolve(ediOrderItems);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/edi_orders/' + id + '/edi_order_items').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ediOrderItem = __webpack_require__(497);
	
	var _ediOrderItem2 = _interopRequireDefault(_ediOrderItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, id, resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_ediOrderItem2.default.fetch(errors));
	};
	
	exports.default = function (id, ediOrderItem, ediOrderItemId) {
	  return new Promise(function (resolve, reject) {
	    ediOrderItem = _ediOrderItem2.default.send(ediOrderItem);
	    _vue2.default.$http.post('/edi_orders/' + id + '/edi_order_items/' + ediOrderItemId + '/confirm', ediOrderItem).then(function (response) {
	      success(response.data, id, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _equipment = __webpack_require__(130);
	
	var _equipment2 = _interopRequireDefault(_equipment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var equipments = _equipment2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllEquipments', equipments);
	  resolve(equipments);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/production/equipment').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _equipment = __webpack_require__(130);
	
	var _equipment2 = _interopRequireDefault(_equipment);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var equipments = _equipment2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedEquipments', { equipments: equipments, pagination: pagination });
	  resolve(equipments);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('production/equipment', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _equipment = __webpack_require__(130);
	
	var _equipment2 = _interopRequireDefault(_equipment);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return _equipment2.default.fetch(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var equipments = _store2.default.state.equipment.items.filter(function (p) {
	      return id.toString() === p.id.toString();
	    });
	
	    if (equipments.length > 0) {
	      return resolve(equipments[0]);
	    }
	
	    return _vue2.default.$http.get('/production/equipments/' + id).then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _equipment = __webpack_require__(130);
	
	var _equipment2 = _interopRequireDefault(_equipment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_equipment2.default.fetch(errors));
	};
	
	exports.default = function (equipment) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/equipment', equipment).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _equipment = __webpack_require__(130);
	
	var _equipment2 = _interopRequireDefault(_equipment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_equipment2.default.fetch(errors));
	};
	
	exports.default = function (id, equipment) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/production/equipment/' + id, equipment).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var report = data;
	  resolve(report);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/excise_entries/flag', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _exciseEntry = __webpack_require__(499);
	
	var _exciseEntry2 = _interopRequireDefault(_exciseEntry);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var report = _exciseEntry2.default.fetchCollection(data.data);
	  var pagination = {};
	  if (data.pagination) {
	    pagination = _pagination2.default.fetch(data.pagination);
	  }
	  resolve({ report: report, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/excise_entries', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _exciseEntry = __webpack_require__(499);
	
	var _exciseEntry2 = _interopRequireDefault(_exciseEntry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var excise = _exciseEntry2.default.fetch(data);
	  resolve(excise);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id, excise) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/excise_entries/' + id, _exciseEntry2.default.send(excise)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _exciseGroup = __webpack_require__(309);
	
	var _exciseGroup2 = _interopRequireDefault(_exciseGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var exciseGroups = _exciseGroup2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchExciseGroup', { exciseGroups: exciseGroups });
	
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('groups').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _exciseGroup = __webpack_require__(309);
	
	var _exciseGroup2 = _interopRequireDefault(_exciseGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var exciseBasicGroups = _exciseGroup2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchExciseBasicGroup', { exciseBasicGroups: exciseBasicGroups });
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('groups/basic').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _exciseGroup = __webpack_require__(309);
	
	var _exciseGroup2 = _interopRequireDefault(_exciseGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var excisePackagingGroups = _exciseGroup2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchExcisePackagingGroup', { excisePackagingGroups: excisePackagingGroups });
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('groups/packaging').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sync = __webpack_require__(1041);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  sync: _sync2.default
	};

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error.response.data);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/fiken/sync').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productForm = __webpack_require__(1694);
	
	var _productForm2 = _interopRequireDefault(_productForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var fields = _productForm2.default.fetchCollection(data.data);
	
	  resolve(fields);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id, name) {
	  return new Promise(function (resolve, reject) {
	    var query = name ? 'forms/' + id + '?name=' + name : 'forms/' + id;
	    _vue2.default.$http.get(query).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (userId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/google_two_factor_auth/' + userId + '/disable_2fa').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response.data);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/google_two_factor_auth/' + data.user_id + '/enable_2fa', data).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enabledGoogleTwoFactorAuth = __webpack_require__(1044);
	
	var _enabledGoogleTwoFactorAuth2 = _interopRequireDefault(_enabledGoogleTwoFactorAuth);
	
	var _verifyToken = __webpack_require__(1046);
	
	var _verifyToken2 = _interopRequireDefault(_verifyToken);
	
	var _disableGoogleTwoFactorAuth = __webpack_require__(1043);
	
	var _disableGoogleTwoFactorAuth2 = _interopRequireDefault(_disableGoogleTwoFactorAuth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  enabledGoogleTwoFactor: _enabledGoogleTwoFactorAuth2.default,
	  verifyToken: _verifyToken2.default,
	  disableGoogleTwoFactorAuth: _disableGoogleTwoFactorAuth2.default
	};

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/google_two_factor_auth/' + data.user_id + '/verify_token', data).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (hashids) {
	  return window.open(("https://api.kundan.no") + '/invoices/pdfs/download/?bill_ids=' + hashids.join(',') + '&token=' + localStorage.getItem('id_token'));
	};

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (hashids) {
	  return window.open(("https://api.kundan.no") + '/delivery_notes/pdfs/download/?order_ids=' + hashids.join(',') + '&token=' + localStorage.getItem('id_token'));
	};

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (hashid) {
	  return window.open(("https://api.kundan.no") + '/invoices/' + hashid + '/pdf/download/?token=' + localStorage.getItem('id_token'));
	};

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (hashid) {
	  return window.open(("https://api.kundan.no") + '/delivery_notes/' + hashid + '/pdf/download/?token=' + localStorage.getItem('id_token'));
	};

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _invoiceMessage = __webpack_require__(500);
	
	var _invoiceMessage2 = _interopRequireDefault(_invoiceMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id, previewParams) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('invoices/' + id + '/send', _invoiceMessage2.default.send(previewParams)).then(function () {
	      resolve();
	    }).catch(function (error) {
	      reject(error.response);
	    });
	  });
	};

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id, ediOrderId) {
	  return new Promise(function (resolve, reject) {
	    var url = 'invoices/' + id + '/edi_order/' + ediOrderId + '/send';
	
	    if (localStorage.getItem('is_admin')) {
	      url = 'invoices/' + id + '/edi_order/' + ediOrderId + '/send?is_admin=true';
	    }
	
	    _vue2.default.$http.get(url).then(function (response) {
	      resolve(response.data);
	    }).catch(function () {
	      reject();
	    });
	  });
	};

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('invoices/' + id + '/send_ehf').then(function () {
	      resolve();
	    }).catch(function () {
	      reject();
	    });
	  });
	};

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _invoiceMessage = __webpack_require__(500);
	
	var _invoiceMessage2 = _interopRequireDefault(_invoiceMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id, previewParams) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('tripletex/' + id + '/send', _invoiceMessage2.default.send(previewParams)).then(function () {
	      resolve();
	    }).catch(function () {
	      reject();
	    });
	  });
	};

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (hashid) {
	  var reminderFee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var add = reminderFee ? '&with_reminder=' + reminderFee : '';
	  var url = ("https://api.kundan.no") + '/invoices/' + hashid + '/?token=' + localStorage.getItem('id_token') + add;
	  window.open(url);
	};

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _email = __webpack_require__(498);
	
	var _email2 = _interopRequireDefault(_email);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	  return resolve(_email2.default.fetch(data));
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/invoices/' + id + '/showBillEmailInformation').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (hashid) {
	  var url = ("https://api.kundan.no") + '/delivery_notes/' + hashid + '/?token=' + localStorage.getItem('id_token');
	  window.open(url);
	};

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _license = __webpack_require__(311);
	
	var _license2 = _interopRequireDefault(_license);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  if (data.data.length) {
	    var licenses = _license2.default.fetchCollection(data.data);
	    _store2.default.dispatch('fetchAllLicenses', licenses);
	  }
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (clientId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('license?client_id=' + clientId).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _license = __webpack_require__(311);
	
	var _license2 = _interopRequireDefault(_license);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_license2.default.fetch(errors));
	};
	
	exports.default = function (licenseData) {
	  return new Promise(function (resolve, reject) {
	    var data = new FormData();
	    Object.keys(licenseData).map(function (k) {
	      data.append(k, licenseData[k]);
	      return null;
	    });
	    _vue2.default.$http.request({
	      url: 'license',
	      data: data,
	      method: 'post',
	      headers: {
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _licenseGroup = __webpack_require__(1672);
	
	var _licenseGroup2 = _interopRequireDefault(_licenseGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var licenseGroups = _licenseGroup2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllLicenseGroups', licenseGroups);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('license/groups').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1060);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _licensePermitType = __webpack_require__(1674);
	
	var _licensePermitType2 = _interopRequireDefault(_licensePermitType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var licensePermitTypes = _licensePermitType2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllLicensePermitTypes', licensePermitTypes);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('license/permit_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1062);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _licenseType = __webpack_require__(1675);
	
	var _licenseType2 = _interopRequireDefault(_licenseType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var licenseTypes = _licenseType2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllLicenseTypes', licenseTypes);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('license/types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1064);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invite = __webpack_require__(1067);
	
	var _invite2 = _interopRequireDefault(_invite);
	
	var _partners = __webpack_require__(1068);
	
	var _partners2 = _interopRequireDefault(_partners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  invite: _invite2.default,
	  partners: _partners2.default
	};

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (id, params) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/marketplace/invite/' + id, params).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    return _vue2.default.$http.get('/marketplace/partners').then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _marketplaceProduct = __webpack_require__(195);
	
	var _marketplaceProduct2 = _interopRequireDefault(_marketplaceProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var marketplaceProducts = _marketplaceProduct2.default.fetchCollection(data.data);
	  resolve(marketplaceProducts);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/products/marketplace').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (productId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/products/' + productId + '/marketplace').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _marketplaceProduct = __webpack_require__(195);
	
	var _marketplaceProduct2 = _interopRequireDefault(_marketplaceProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return _marketplaceProduct2.default.fetch(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (productId) {
	  return new Promise(function (resolve, reject) {
	    return _vue2.default.$http.get('/products/' + productId + '/marketplace').then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _marketplaceProduct = __webpack_require__(195);
	
	var _marketplaceProduct2 = _interopRequireDefault(_marketplaceProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_marketplaceProduct2.default.fetch(errors));
	};
	
	exports.default = function (productId, marketplaceData) {
	  return new Promise(function (resolve, reject) {
	    var data = new FormData();
	    Object.keys(marketplaceData).map(function (k) {
	      data.append(k, marketplaceData[k]);
	      return null;
	    });
	    _vue2.default.$http.request({
	      url: '/products/' + productId + '/marketplace',
	      data: data,
	      method: 'post',
	      headers: {
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productGroup = __webpack_require__(110);
	
	var _productGroup2 = _interopRequireDefault(_productGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_productGroup2.default.fetch(errors));
	};
	
	exports.default = function (productId, marketplaceData) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/products/' + productId + '/marketplace', marketplaceData).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _material = __webpack_require__(131);
	
	var _material2 = _interopRequireDefault(_material);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var materials = _material2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllMaterials', materials);
	  resolve(materials);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/production/material').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _material = __webpack_require__(131);
	
	var _material2 = _interopRequireDefault(_material);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var materials = _material2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedMaterials', { materials: materials, pagination: pagination });
	  resolve(materials);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('production/material', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _material = __webpack_require__(131);
	
	var _material2 = _interopRequireDefault(_material);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return _material2.default.fetch(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var materials = _store2.default.state.material.items.filter(function (p) {
	      return id.toString() === p.id.toString();
	    });
	
	    if (materials.length > 0) {
	      return resolve(materials[0]);
	    }
	
	    return _vue2.default.$http.get('/production/materials/' + id).then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _material = __webpack_require__(131);
	
	var _material2 = _interopRequireDefault(_material);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_material2.default.fetch(errors));
	};
	
	exports.default = function (material) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/material', material).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _material = __webpack_require__(131);
	
	var _material2 = _interopRequireDefault(_material);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_material2.default.fetch(errors));
	};
	
	exports.default = function (id, material) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/production/material/' + id, material).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _materialType = __webpack_require__(1676);
	
	var _materialType2 = _interopRequireDefault(_materialType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var materialTypes = _materialType2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllMaterialTypes', materialTypes);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('production/material_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _messageTemplateType = __webpack_require__(1677);
	
	var _messageTemplateType2 = _interopRequireDefault(_messageTemplateType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var messageTemplateTypes = _messageTemplateType2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllMessageTemplateTypes', messageTemplateTypes);
	  resolve(messageTemplateTypes);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('message_template_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1080);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _module = __webpack_require__(1678);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var modules = _module2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllModules', modules);
	  resolve(modules);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/module/all').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (id, modul) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/module/subscribe/' + id, modul).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/module/unsubscribe/' + id, {}).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _municipality = __webpack_require__(1679);
	
	var _municipality2 = _interopRequireDefault(_municipality);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var municipalities = _municipality2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchMunicipalities', { municipalities: municipalities });
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('municipality').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('news/' + id).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _news = __webpack_require__(109);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var items = _news2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  resolve({ items: items, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (campaignId) {
	  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('news?campaign_id=' + campaignId + '&page=' + page + '&limit=' + limit).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (newsId, type, dates) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('news/' + newsId + '/' + type + '/' + dates + '/email-trackings').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (report) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('news/send-error-report', report).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _news = __webpack_require__(109);
	
	var _news2 = _interopRequireDefault(_news);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(news, resolve) {
	  resolve(_news2.default.fetch(news));
	};
	
	var failed = function failed(errors, reject) {
	  reject(_news2.default.fetch(errors));
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('news/' + id).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _news = __webpack_require__(109);
	
	var _news2 = _interopRequireDefault(_news);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(news, resolve) {
	  news = _news2.default.fetch(news);
	  _vue2.default.router.push({
	    name: 'campaigns.edit',
	    params: {
	      id: news.newsCampaignId
	    }
	  });
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_news2.default.fetch(errors));
	};
	
	exports.default = function (news) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('news', news).then(function () {
	      success(news, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _news = __webpack_require__(109);
	
	var _news2 = _interopRequireDefault(_news);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_news2.default.fetch(errors));
	};
	
	exports.default = function (news) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('news/test', news).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _news = __webpack_require__(109);
	
	var _news2 = _interopRequireDefault(_news);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(news, resolve) {
	  news = _news2.default.fetch(news);
	  _vue2.default.router.push({
	    name: 'campaigns.edit',
	    params: {
	      id: news.newsCampaignId
	    }
	  });
	  resolve(news);
	};
	
	var failed = function failed(errors, reject) {
	  reject(_news2.default.fetch(errors));
	};
	
	exports.default = function (id, news) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('news/' + id, news).then(function () {
	      success(news, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _newsStatus = __webpack_require__(1680);
	
	var _newsStatus2 = _interopRequireDefault(_newsStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var newsStatuses = _newsStatus2.default.fetchCollection(data.data);
	
	  resolve(newsStatuses);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('news_status').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1094);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _order = __webpack_require__(57);
	
	var _order2 = _interopRequireDefault(_order);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var orders = _order2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllOrders', orders);
	  resolve(orders);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/orders').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var result = {
	    errors: data.errors,
	    data: data
	  };
	  resolve(result);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (ids) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/orders/cancel?order_ids=' + ids).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _order = __webpack_require__(57);
	
	var _order2 = _interopRequireDefault(_order);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var result = {
	    errors: data.errors,
	    data: _order2.default.fetchCollection(data.data)
	  };
	  resolve(result);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (orderIds, order) {
	  return new Promise(function (resolve, reject) {
	    var url = '/orders/confirm?order_ids=' + orderIds.join(',');
	
	    _vue2.default.$http.post(url, order).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response, reject);
	    });
	  });
	};

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _order = __webpack_require__(57);
	
	var _order2 = _interopRequireDefault(_order);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var result = {
	    errors: data.errors,
	    data: _order2.default.fetchCollection(data.data)
	  };
	  resolve(result);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (orderIds, order) {
	  return new Promise(function (resolve, reject) {
	    var url = '/orders/confirm-order-shipping?order_ids=' + orderIds.join(',');
	
	    _vue2.default.$http.post(url, order).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response, reject);
	    });
	  });
	};

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _order = __webpack_require__(57);
	
	var _order2 = _interopRequireDefault(_order);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var result = {
	    errors: data.errors,
	    data: _order2.default.fetchCollection(data.data)
	  };
	  resolve(result);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (ids, order) {
	  return new Promise(function (resolve, reject) {
	    var url = '/orders/confirm-shipping?order_ids=' + ids;
	
	    _vue2.default.$http.post(url, order).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response, reject);
	    });
	  });
	};

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/orders/client-setting/' + id).then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/orders/complete-return/' + id).then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _order = __webpack_require__(57);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentOrder', _order2.default.fetch(data));
	  resolve(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id, order) {
	  return new Promise(function (resolve, reject) {
	    var url = '/orders/confirm/' + id;
	
	    _vue2.default.$http.post(url, order).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response, reject);
	    });
	  });
	};

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _order = __webpack_require__(57);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentOrder', _order2.default.fetch(data));
	  resolve(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var url = '/orders/confirm-as-ordered/' + id;
	
	    _vue2.default.$http.post(url, {}).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response, reject);
	    });
	  });
	};

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _order = __webpack_require__(57);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentOrder', _order2.default.fetch(data));
	  resolve(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id, order) {
	  return new Promise(function (resolve, reject) {
	    var url = '/orders/confirm-shipping/' + id;
	
	    _vue2.default.$http.post(url, order).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response, reject);
	    });
	  });
	};

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  resolve(data);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/orders/counts').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/orders/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (id, paperSize) {
	  return window.open(("https://api.kundan.no") + '/order/' + id + '/download-pallet-label?token=' + localStorage.getItem('id_token') + '&paper_size=' + paperSize);
	};

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (id, paperSize) {
	  return window.open(("https://api.kundan.no") + '/order/' + id + '/download-shipping-label?token=' + localStorage.getItem('id_token') + '&paper_size=' + paperSize);
	};

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _orderEvent = __webpack_require__(1681);
	
	var _orderEvent2 = _interopRequireDefault(_orderEvent);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var events = _orderEvent2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchOrderEvents', events);
	  resolve(events);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/orders/events/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  resolve(data);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('orders/get_next_prev_id/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _order = __webpack_require__(57);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var orders = _order2.default.fetchCollection(data.data);
	
	  var pagination = {};
	  if (data.pagination) {
	    pagination = _pagination2.default.fetch(data.pagination);
	  }
	
	  _store2.default.dispatch('fetchPaginatedOrders', { orders: orders, pagination: pagination });
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    return _vue2.default.$http.get(_helpers2.default.buildUrl('/orders', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/orders/return/' + id).then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _simpleDetailOrder = __webpack_require__(1706);
	
	var _simpleDetailOrder2 = _interopRequireDefault(_simpleDetailOrder);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var simpleOrder = _simpleDetailOrder2.default.fetchCollection(data.data);
	  resolve(simpleOrder);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('orders/list-all-orders/search', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _order = __webpack_require__(57);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  _store2.default.dispatch('fetchCurrentOrder', _order2.default.fetch(data));
	  resolve(_order2.default.fetch(data));
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/orders/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _order = __webpack_require__(57);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  _store2.default.dispatch('fetchCurrentOrder', _order2.default.fetch(data));
	  resolve(_order2.default.fetch(data));
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/orders/simple-order/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _order = __webpack_require__(57);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentOrder', _order2.default.fetch(data));
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(_order2.default.fetch(errors));
	};
	
	exports.default = function (order) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/orders', _order2.default.send(order)).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _order = __webpack_require__(57);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var order = _order2.default.fetch(data);
	
	  _store2.default.dispatch('fetchCurrentOrder', order);
	  resolve(order);
	};
	
	var failed = function failed(errors, reject) {
	  reject(_order2.default.fetch(errors));
	};
	
	exports.default = function (id, order) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/orders/' + id, _order2.default.send(order)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _orderPickup = __webpack_require__(501);
	
	var _orderPickup2 = _interopRequireDefault(_orderPickup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var orderPickups = _orderPickup2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllOrderPickups', orderPickups);
	  resolve(orderPickups);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/orderPickups').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1119);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(1121);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  items: _items2.default
	};

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _orderPickup = __webpack_require__(501);
	
	var _orderPickup2 = _interopRequireDefault(_orderPickup);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var orderPickups = _orderPickup2.default.fetchCollection(data.data);
	
	  var pagination = {};
	  if (data.pagination) {
	    pagination = _pagination2.default.fetch(data.pagination);
	  }
	  _store2.default.dispatch('fetchPaginatedOrderPickups', { orderPickups: orderPickups, pagination: pagination });
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    return _vue2.default.$http.get(_helpers2.default.buildUrl('/orderPickups', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _orderProduct = __webpack_require__(164);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var orderProducts = _orderProduct2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllOrderProducts', orderProducts);
	  resolve(orderProducts);
	};
	
	var failed = function failed() {};
	
	exports.default = function (orderIds) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/order-products?order_ids=' + orderIds.join(',')).then(function (response) {
	      success(response, resolve);
	      console.log(response);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, id, resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (id, orderProduct, orderProductId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/orders/' + id + '/products/' + orderProductId + '/batch-update', orderProduct).then(function (response) {
	      success(response.data, id, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _orderProduct = __webpack_require__(164);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _all = __webpack_require__(299);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, id, resolve) {
	  console.log('[orderProduct/bulkStore] save ok, refetching order products for order id:', id);
	  (0, _all2.default)(id);
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error && errors.error.code) {
	    reject(errors.error);
	    return;
	  }
	  reject(_orderProduct2.default.fetch(errors));
	};
	
	exports.default = function (id, orderProducts) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/orders/' + id + '/products/bulk', { items: _orderProduct2.default.sendCollection(orderProducts) }).then(function (response) {
	      success(response.data, id, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(id, resolve) {
	  _store2.default.dispatch('removeOrderProduct', id);
	  resolve();
	};
	
	var failed = function failed(reject) {
	  return reject();
	};
	
	exports.default = function (orderId, orderProductId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/orders/' + orderId + '/products/' + orderProductId).then(function () {
	      success(orderProductId, resolve);
	    }).catch(function () {
	      failed(reject);
	    });
	  });
	};

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _orderProduct = __webpack_require__(164);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var orderProducts = _orderProduct2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllOrderProducts', orderProducts);
	  resolve(orderProducts);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/orders/' + id + '/products/search-order-product', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _orderProduct = __webpack_require__(164);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _all = __webpack_require__(299);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, id, resolve) {
	  (0, _all2.default)(id);
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error && errors.error.code) {
	    reject(errors.error);
	    return;
	  }
	  reject(_orderProduct2.default.fetch(errors));
	};
	
	exports.default = function (id, orderProduct) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/orders/' + id + '/products', _orderProduct2.default.send(orderProduct)).then(function (response) {
	      success(response.data, id, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _orderProduct = __webpack_require__(164);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, id, resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_orderProduct2.default.fetch(errors));
	};
	
	exports.default = function (id, orderProduct, orderProductId) {
	  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'normal';
	  return new Promise(function (resolve, reject) {
	    var url = '/orders/' + id + '/products/' + orderProductId;
	    if (type === 'bulk') {
	      url += '/bulk';
	    }
	    _vue2.default.$http.put(url, _orderProduct2.default.send(orderProduct)).then(function (response) {
	      success(response.data, id, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _orderType = __webpack_require__(1682);
	
	var _orderType2 = _interopRequireDefault(_orderType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var orderTypes = _orderType2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchOrderTypes', orderTypes);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('order_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _organizationMember = __webpack_require__(312);
	
	var _organizationMember2 = _interopRequireDefault(_organizationMember);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var organizationMembers = _organizationMember2.default.fetchCollection(data);
	  _store2.default.dispatch('fetchAllOrganizationMembers', organizationMembers);
	  resolve(organizationMembers);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/organization_members').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _organizationMember = __webpack_require__(312);
	
	var _organizationMember2 = _interopRequireDefault(_organizationMember);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('addOrganizationMember', _organizationMember2.default.fetch(data));
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(_organizationMember2.default.fetch(errors));
	};
	
	exports.default = function (organizationMember) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/organization_members', _organizationMember2.default.send(organizationMember)).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _organizationMemberBooking = __webpack_require__(313);
	
	var _organizationMemberBooking2 = _interopRequireDefault(_organizationMemberBooking);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var organizationMemberBookings = _organizationMemberBooking2.default.fetchCollection(data);
	  _store2.default.dispatch('fetchAllOrganizationMemberBookings', organizationMemberBookings);
	  resolve(organizationMemberBookings);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  return new Promise(function (resolve, reject) {
	    var date = {
	      end_date: endDate || (0, _moment2.default)().format('YYYY-MM-DD'),
	      start_date: startDate || (0, _moment2.default)().format('YYYY-MM-DD')
	    };
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/organization_member_bookings', date)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _organizationMemberBooking = __webpack_require__(313);
	
	var _organizationMemberBooking2 = _interopRequireDefault(_organizationMemberBooking);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('addOrganizationMemberBooking', _organizationMemberBooking2.default.fetch(data));
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors.message);
	};
	
	exports.default = function (organizationMemberBooking) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/organization_member_bookings', _organizationMemberBooking2.default.send(organizationMemberBooking)).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _organizationMemberBooking = __webpack_require__(313);
	
	var _organizationMemberBooking2 = _interopRequireDefault(_organizationMemberBooking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors.message);
	};
	
	exports.default = function (organizationMemberBooking) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/organization_member_bookings/' + organizationMemberBooking.id, _organizationMemberBooking2.default.send(organizationMemberBooking)).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _organizationMemberProductBusinessHour = __webpack_require__(1683);
	
	var _organizationMemberProductBusinessHour2 = _interopRequireDefault(_organizationMemberProductBusinessHour);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var businesshours = _organizationMemberProductBusinessHour2.default.fetchCollection(data);
	  _store2.default.dispatch('fetchAllOrganizationMemberProductBusinessHours', businesshours);
	  resolve(businesshours);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/organization_member_product_businesshours').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1135);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(1137);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  store: _store2.default
	};

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _organizationMember = __webpack_require__(312);
	
	var _organizationMember2 = _interopRequireDefault(_organizationMember);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('addOrganizationMember', _organizationMember2.default.fetch(data));
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(_organizationMember2.default.fetch(errors));
	};
	
	exports.default = function (organizationMember) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/organization_members', _organizationMember2.default.send(organizationMember)).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/chart_of_accounts/create').then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'create';
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    var request = null;
	    if (type === 'create') {
	      request = _vue2.default.$http.post('organization_settings/edi_notification_recipients', params);
	    } else if (type === 'show') {
	      request = _vue2.default.$http.get('organization_settings/edi_notification_recipients');
	    } else if (type === 'destroy') {
	      request = _vue2.default.$http.delete('organization_settings/edi_notification_recipients/' + params.email);
	    }
	    request.then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error.response.data);
	    });
	  });
	};

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'createOrUpdate';
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    var request = null;
	    if (type === 'createOrUpdate') {
	      request = _vue2.default.$http.post('organization_settings/email_for_invoice_copy', params);
	    } else if (type === 'display') {
	      request = _vue2.default.$http.get('organization_settings/email_for_invoice_copy');
	    }
	    request.then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error.response.data);
	    });
	  });
	};

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'create';
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    var request = null;
	    if (type === 'create') {
	      request = _vue2.default.$http.post('organization_settings/low_stock_notification_recipients', params);
	    } else if (type === 'show') {
	      request = _vue2.default.$http.get('organization_settings/low_stock_notification_recipients');
	    } else if (type === 'destroy') {
	      request = _vue2.default.$http.delete('organization_settings/low_stock_notification_recipients/' + params.email);
	    }
	    request.then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error.response.data);
	    });
	  });
	};

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _organizationSettings = __webpack_require__(83);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _show = __webpack_require__(158);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  (0, _show2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(_organizationSettings2.default.fetch(error.response.data));
	};
	
	exports.default = function (organizationSettings) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/organization_settings', organizationSettings).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _organizationSettings = __webpack_require__(83);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _show = __webpack_require__(158);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  (0, _show2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(_organizationSettings2.default.fetch(error.response.data));
	};
	
	exports.default = function (organizationSettings) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/organization_settings/accounting', organizationSettings).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _organizationSettings = __webpack_require__(83);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _show = __webpack_require__(158);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  (0, _show2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(_organizationSettings2.default.fetch(error.response.data));
	};
	
	exports.default = function (organizationSettings) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/organization_settings/billing', organizationSettings).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _organizationSettings = __webpack_require__(83);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _show = __webpack_require__(158);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  (0, _show2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(_organizationSettings2.default.fetch(error.response.data));
	};
	
	exports.default = function (organizationSettings) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/organization_settings/billing', organizationSettings).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _organizationSettings = __webpack_require__(83);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _show = __webpack_require__(158);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  (0, _show2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(_organizationSettings2.default.fetch(error.response.data));
	};
	
	exports.default = function (organizationSettings) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/organization_settings/templates', organizationSettings).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _organizationType = __webpack_require__(1684);
	
	var _organizationType2 = _interopRequireDefault(_organizationType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var plans = _organizationType2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllOrganizationTypes', plans);
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('organization_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1147);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _package = __webpack_require__(314);
	
	var _package2 = _interopRequireDefault(_package);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var packages = _package2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllPackages', packages);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (orderId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('packages/' + orderId).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/packages/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (id, paperSize) {
	  return window.open(("https://api.kundan.no") + '/package/barcode/' + id + '/?token=' + localStorage.getItem('id_token') + '&paper_size=' + paperSize);
	};

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (id, paperSize) {
	  return window.open(("https://api.kundan.no") + '/package/mix-pallet/barcode/' + id + '/?token=' + localStorage.getItem('id_token') + '&paper_size=' + paperSize);
	};

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _package = __webpack_require__(314);
	
	var _package2 = _interopRequireDefault(_package);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  resolve(_package2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_package2.default.fetch(errors));
	};
	
	exports.default = function (pckg) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/packages', _package2.default.send(pckg)).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _package = __webpack_require__(314);
	
	var _package2 = _interopRequireDefault(_package);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  resolve(_package2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_package2.default.fetch(errors));
	};
	
	exports.default = function (id, pckg) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/packages/' + id, _package2.default.send(pckg)).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _packageOrderProduct = __webpack_require__(315);
	
	var _packageOrderProduct2 = _interopRequireDefault(_packageOrderProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var packages = _packageOrderProduct2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllPackageOrderProducts', packages);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (orderId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('packageOrderProduct/' + orderId).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/packageOrderProduct/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (hashid) {
	  return window.open(("https://api.kundan.no") + '/product/barcode/' + hashid + '/?token=' + localStorage.getItem('id_token'));
	};

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _packageOrderProduct = __webpack_require__(315);
	
	var _packageOrderProduct2 = _interopRequireDefault(_packageOrderProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  resolve(_packageOrderProduct2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_packageOrderProduct2.default.fetch(errors));
	};
	
	exports.default = function (packageOrderProduct) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/packageOrderProduct', _packageOrderProduct2.default.send(packageOrderProduct)).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _packageOrderProduct = __webpack_require__(315);
	
	var _packageOrderProduct2 = _interopRequireDefault(_packageOrderProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  resolve(_packageOrderProduct2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_packageOrderProduct2.default.fetch(errors));
	};
	
	exports.default = function (id, packageOrderProduct) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/packageOrderProduct/' + id, _packageOrderProduct2.default.send(packageOrderProduct)).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _packageUnitType = __webpack_require__(1685);
	
	var _packageUnitType2 = _interopRequireDefault(_packageUnitType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var packageUnitTypes = _packageUnitType2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllPackageUnitTypes', packageUnitTypes);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('package_unit_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1160);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _packagingMaterial = __webpack_require__(1686);
	
	var _packagingMaterial2 = _interopRequireDefault(_packagingMaterial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var packagingMaterials = _packagingMaterial2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchPackagingMaterials', packagingMaterials);
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('packaging_materials').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _packagingType = __webpack_require__(1687);
	
	var _packagingType2 = _interopRequireDefault(_packagingType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var packagingTypes = _packagingType2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchPackagingTypes', packagingTypes);
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('packaging_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _partner = __webpack_require__(1688);
	
	var _partner2 = _interopRequireDefault(_partner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var partners = _partner2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllPartners', partners);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('partners').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _paymentMethod = __webpack_require__(1690);
	
	var _paymentMethod2 = _interopRequireDefault(_paymentMethod);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var paymentMethods = _paymentMethod2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchPaymentMethods', paymentMethods);
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('payment_methods').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _postal = __webpack_require__(316);
	
	var _postal2 = _interopRequireDefault(_postal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var postals = _postal2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchPostals', { postals: postals });
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('postal').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _postal = __webpack_require__(316);
	
	var _postal2 = _interopRequireDefault(_postal);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var postals = _postal2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchPostals', { postals: postals });
	  resolve(postals);
	};
	
	var failed = function failed() {};
	
	exports.default = function (postCode) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('postal/suggestions/' + postCode).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _postal = __webpack_require__(316);
	
	var _postal2 = _interopRequireDefault(_postal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var postal = _postal2.default.fetch(data);
	
	  resolve(postal);
	};
	
	var failed = function failed() {};
	
	exports.default = function (postCode) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('postal/' + postCode).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error.response.data);
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/poweroffice/' + data.user_id + '/authorize', data).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sync = __webpack_require__(1171);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _authorize = __webpack_require__(1169);
	
	var _authorize2 = _interopRequireDefault(_authorize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  sync: _sync2.default,
	  authorize: _authorize2.default
	};

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error.response.data);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/poweroffice/sync').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _priceField = __webpack_require__(132);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var fields = _priceField2.default.fetchCollection(data.data.filter(function (c) {
	    return c.name !== 'Lokalbrygg';
	  }));
	
	  _store2.default.dispatch('fetchAllPriceFields', fields);
	  resolve(fields);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var selectedOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('price_fields?selected=' + selectedOnly).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _priceField = __webpack_require__(132);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var priceFields = _priceField2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedPriceFields', { priceFields: priceFields, pagination: pagination });
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('price_fields', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _priceField = __webpack_require__(132);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return _priceField2.default.fetch(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var priceFields = _store2.default.state.priceField.items.filter(function (p) {
	      return id.toString() === p.id.toString();
	    });
	
	    if (priceFields.length > 0) {
	      return resolve(priceFields[0]);
	    }
	
	    return _vue2.default.$http.get('/price_fields/' + id).then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _priceField = __webpack_require__(132);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_priceField2.default.fetch(errors));
	};
	
	exports.default = function (priceField) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('price_fields', priceField).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _priceField = __webpack_require__(132);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_priceField2.default.fetch(errors));
	};
	
	exports.default = function (id, priceField) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/price_fields/' + id, priceField).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _producer = __webpack_require__(317);
	
	var _producer2 = _interopRequireDefault(_producer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var producers = _producer2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllProducers', producers);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('producers').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _producer = __webpack_require__(317);
	
	var _producer2 = _interopRequireDefault(_producer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_producer2.default.fetch(errors));
	};
	
	exports.default = function (clientGroup) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('producers', clientGroup).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productGroup = __webpack_require__(110);
	
	var _productGroup2 = _interopRequireDefault(_productGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var productGroups = _productGroup2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllProductGroups', productGroups);
	
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('product_groups').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _items = __webpack_require__(468);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  (0, _items2.default)(1, 5);
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/product_groups/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productGroup = __webpack_require__(110);
	
	var _productGroup2 = _interopRequireDefault(_productGroup);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return _productGroup2.default.fetch(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var productGroups = _store2.default.state.productGroup.items.filter(function (p) {
	      return id.toString() === p.id.toString();
	    });
	
	    if (productGroups.length > 0) {
	      return resolve(productGroups[0]);
	    }
	
	    return _vue2.default.$http.get('/product_groups/' + id).then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productGroup = __webpack_require__(110);
	
	var _productGroup2 = _interopRequireDefault(_productGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_productGroup2.default.fetch(errors));
	};
	
	exports.default = function (productGroup) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('product_groups', productGroup).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productGroup = __webpack_require__(110);
	
	var _productGroup2 = _interopRequireDefault(_productGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_productGroup2.default.fetch(errors));
	};
	
	exports.default = function (id, productGroup) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/product_groups/' + id, productGroup).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var products = _product2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllProducts', products);
	  resolve(products);
	};
	
	var failed = function failed() {};
	
	exports.default = function (type) {
	  return new Promise(function (resolve, reject) {
	    var url = '/products';
	    if (type) {
	      url += '?type=' + type;
	    }
	    _vue2.default.$http.get(url).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productBasic = __webpack_require__(1691);
	
	var _productBasic2 = _interopRequireDefault(_productBasic);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var products = _productBasic2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllProductsBasic', products);
	  resolve(products);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('products/basic', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (productIds) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/products/update/bulk-sync-to-woo', { product_ids: productIds }).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response, reject);
	    });
	  });
	};

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var result = {
	    errors: data.errors,
	    data: _product2.default.fetchCollection(data.data)
	  };
	  resolve(result);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/products/update/bullkprocess', data).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response, reject);
	    });
	  });
	};

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  resolve(data);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/products/counts').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error.response.data);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/products/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var products = _product2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedProducts', { products: products, pagination: pagination });
	  resolve(products);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('products', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (product) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('products/merge', _product2.default.sendMerge(product)).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  var data = error.response && error.response.data;
	  reject(data || error);
	};
	
	exports.default = function (id, product) {
	  var data = new FormData();
	  Object.keys(product).map(function (k) {
	    data.append(k, product[k]);
	    return null;
	  });
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.request({
	      url: '/products/' + id + '/quick-update',
	      data: data,
	      method: 'post'
	    }).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('products/' + id + '/remove-image').then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productSearch = __webpack_require__(502);
	
	var _productSearch2 = _interopRequireDefault(_productSearch);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var products = _productSearch2.default.fetchCollection(data.data);
	  resolve(products);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('products/search/all/products', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	  return resolve(_product2.default.fetch(data));
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var products = _store2.default.state.product.items.filter(function (p) {
	      return id.toString() === p.id.toString();
	    });
	
	    if (products.length > 0) {
	      return resolve(products[0]);
	    }
	
	    return _vue2.default.$http.get('/products/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, data) {
	  resolve(_product2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.errors) {
	    reject(_product2.default.fetch(errors.errors));
	  }
	  reject(_product2.default.fetch(errors));
	};
	var getFormData = function getFormData(formData, data, previousKey) {
	  if (data instanceof Object && !Array.isArray(data)) {
	    Object.keys(data).forEach(function (key) {
	      var value = data[key];
	      if (value instanceof Object && !Array.isArray(value)) {
	        return getFormData(formData, value, key);
	      }
	      if (previousKey) {
	        key = previousKey + '[' + key + ']';
	      }
	      if (Array.isArray(value)) {
	        value.forEach(function (val) {
	          formData.append(key + '[]', val);
	          return null;
	        });
	      } else {
	        formData.append(key, value);
	      }
	      return null;
	    });
	  } else if (data instanceof Object && Array.isArray(data)) {
	    data.forEach(function (val, i) {
	      Object.keys(val).forEach(function (key) {
	        formData.append(previousKey + '[' + i + '][' + key + ']', val[key]);
	        return null;
	      });
	      return null;
	    });
	  } else {
	    formData.append(previousKey, data);
	  }
	};
	
	exports.default = function (product) {
	  var data = new FormData();
	  Object.keys(product).map(function (k) {
	    getFormData(data, product[k], k);
	    return null;
	  });
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.request({
	      url: 'products',
	      data: data,
	      method: 'post',
	      headers: {
	        'Content-Type': 'multipart/form-data',
	        'Access-Control-Allow-Origin': '*',
	        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
	        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,OPTIONS'
	      }
	    }).then(function (response) {
	      success(resolve, response.data);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productTransaction = __webpack_require__(1697);
	
	var _productTransaction2 = _interopRequireDefault(_productTransaction);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var transactions = _productTransaction2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllProductTransactions', transactions);
	  resolve(transactions);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('products/' + options.id + '/transactions', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productTransactionV = __webpack_require__(1698);
	
	var _productTransactionV2 = _interopRequireDefault(_productTransactionV);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var transactionsV2 = _productTransactionV2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchProductTransactionsV2', { transactionsV2: transactionsV2, pagination: pagination });
	  resolve(transactionsV2);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('products/' + options.id + '/transactionsV2', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_product2.default.fetch(errors));
	};
	
	exports.default = function (id, product) {
	  var data = new FormData();
	  Object.keys(product).map(function (k) {
	    data.append(k, product[k]);
	    return null;
	  });
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.request({
	      url: '/products/' + id,
	      data: data,
	      method: 'post',
	      headers: {
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _items = __webpack_require__(469);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  (0, _items2.default)(1, 5);
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/product_bundles/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productBundle = __webpack_require__(241);
	
	var _productBundle2 = _interopRequireDefault(_productBundle);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	  return resolve(_productBundle2.default.fetch(data));
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var products = _store2.default.state.product.items.filter(function (p) {
	      return id.toString() === p.id.toString();
	    });
	
	    if (products.length > 0) {
	      return resolve(products[0]);
	    }
	
	    return _vue2.default.$http.get('/product_bundles/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (productBundle) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('product_bundles', productBundle).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (id, productBundle) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/product_bundles/' + id, productBundle).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productDeposit = __webpack_require__(1692);
	
	var _productDeposit2 = _interopRequireDefault(_productDeposit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var productDeposits = _productDeposit2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllProductDeposits', { productDeposits: productDeposits });
	  _store2.default.dispatch('setNullDeposit');
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('product_deposits').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productFlow = __webpack_require__(133);
	
	var _productFlow2 = _interopRequireDefault(_productFlow);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var productFlows = _productFlow2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('FetchAllproductFlows', productFlows);
	  resolve(productFlows);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/productflow', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _items = __webpack_require__(470);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  (0, _items2.default)(1, 5);
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/productflow/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productFlowOrder = __webpack_require__(1693);
	
	var _productFlowOrder2 = _interopRequireDefault(_productFlowOrder);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var orders = _productFlowOrder2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchproductFlowOrders', orders);
	  resolve({ orders: orders });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/productflow/list/orders', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productFlow = __webpack_require__(133);
	
	var _productFlow2 = _interopRequireDefault(_productFlow);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var productFlow = _productFlow2.default.fetch(data);
	  resolve(productFlow);
	  _store2.default.dispatch('fetchCurrentproductFlow', productFlow);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/productflow/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productFlow = __webpack_require__(133);
	
	var _productFlow2 = _interopRequireDefault(_productFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  resolve(response);
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_productFlow2.default.fetch(errors));
	};
	
	exports.default = function (productFlow) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/productflow', productFlow).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productFlow = __webpack_require__(133);
	
	var _productFlow2 = _interopRequireDefault(_productFlow);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentproductFlow', _productFlow2.default.fetch(data));
	  resolve(_productFlow2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_productFlow2.default.fetch(errors));
	};
	
	exports.default = function (id, productFlow) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/productflow/' + id, productFlow).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productPackaging = __webpack_require__(134);
	
	var _productPackaging2 = _interopRequireDefault(_productPackaging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var productPackagings = _productPackaging2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllProductPackagings', productPackagings);
	  _store2.default.dispatch('setNullProductPackagings');
	
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('product_packagings').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _items = __webpack_require__(471);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  (0, _items2.default)(1, 5);
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/product_packagings/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productPackaging = __webpack_require__(134);
	
	var _productPackaging2 = _interopRequireDefault(_productPackaging);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return _productPackaging2.default.fetch(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var productPackagings = _store2.default.state.productPackaging.items.filter(function (p) {
	      return id.toString() === p.id.toString();
	    });
	
	    if (productPackagings.length > 0) {
	      return resolve(productPackagings[0]);
	    }
	
	    return _vue2.default.$http.get('/product_packagings/' + id).then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productPackaging = __webpack_require__(134);
	
	var _productPackaging2 = _interopRequireDefault(_productPackaging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_productPackaging2.default.fetch(errors));
	};
	
	exports.default = function (productPackaging) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('product_packagings', productPackaging).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productPackaging = __webpack_require__(134);
	
	var _productPackaging2 = _interopRequireDefault(_productPackaging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_productPackaging2.default.fetch(errors));
	};
	
	exports.default = function (id, productPackaging) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/product_packagings/' + id, productPackaging).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productRecommendation = __webpack_require__(1695);
	
	var _productRecommendation2 = _interopRequireDefault(_productRecommendation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var productRecommendations = _productRecommendation2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllProductRecommendations', productRecommendations);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('product_recommendations').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productSubtype = __webpack_require__(1696);
	
	var _productSubtype2 = _interopRequireDefault(_productSubtype);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var productSubtypes = _productSubtype2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllProductSubtypes', productSubtypes);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('product_subtypes').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productTag = __webpack_require__(135);
	
	var _productTag2 = _interopRequireDefault(_productTag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var tags = _productTag2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllProductTags', tags);
	  resolve(tags);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('product_tags').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productTag = __webpack_require__(135);
	
	var _productTag2 = _interopRequireDefault(_productTag);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var productTags = _productTag2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedProductTags', { productTags: productTags, pagination: pagination });
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('product_tags', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productTag = __webpack_require__(135);
	
	var _productTag2 = _interopRequireDefault(_productTag);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return _productTag2.default.fetch(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var productTags = _store2.default.state.productTag.items.filter(function (p) {
	      return id.toString() === p.id.toString();
	    });
	
	    if (productTags.length > 0) {
	      return resolve(productTags[0]);
	    }
	
	    return _vue2.default.$http.get('/product_tags/' + id).then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productTag = __webpack_require__(135);
	
	var _productTag2 = _interopRequireDefault(_productTag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_productTag2.default.fetch(errors));
	};
	
	exports.default = function (productTag) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('product_tags', productTag).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productTag = __webpack_require__(135);
	
	var _productTag2 = _interopRequireDefault(_productTag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_productTag2.default.fetch(errors));
	};
	
	exports.default = function (id, productTag) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/product_tags/' + id, productTag).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productType = __webpack_require__(503);
	
	var _productType2 = _interopRequireDefault(_productType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var productTypes = _productType2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllProductTypes', productTypes);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('product_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _search = __webpack_require__(1225);
	
	var _search2 = _interopRequireDefault(_search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  search: _search2.default
	};

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productUnCode = __webpack_require__(1699);
	
	var _productUnCode2 = _interopRequireDefault(_productUnCode);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var products = _productUnCode2.default.fetchCollection(data.data);
	  resolve(products);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('products/search/un_codes', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _project = __webpack_require__(197);
	
	var _project2 = _interopRequireDefault(_project);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var projects = _project2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllProjects', projects);
	  resolve(projects);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/projects').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error.response.data);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/projects/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _project = __webpack_require__(197);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var projects = _project2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchProjects', { projects: projects, pagination: pagination });
	  resolve({ projects: projects, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/projects', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _project = __webpack_require__(197);
	
	var _project2 = _interopRequireDefault(_project);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_project2.default.fetch(errors));
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('projects', data).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _project = __webpack_require__(197);
	
	var _project2 = _interopRequireDefault(_project);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_project2.default.fetch(errors));
	};
	
	exports.default = function (id, data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/projects/' + id, data).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _publicProfile = __webpack_require__(242);
	
	var _publicProfile2 = _interopRequireDefault(_publicProfile);
	
	var _show = __webpack_require__(474);
	
	var _show2 = _interopRequireDefault(_show);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  (0, _show2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(_publicProfile2.default.fetch(error.response.data));
	};
	
	exports.default = function (publicProfile) {
	  var data = new FormData();
	  Object.keys(publicProfile).map(function (k) {
	    data.append(k, publicProfile[k]);
	    return null;
	  });
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.request({
	      url: 'public_profile',
	      data: data,
	      method: 'post',
	      headers: {
	        'Content-Type': 'multipart/form-data'
	      }
	    }).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _purchase = __webpack_require__(58);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var purchases = _purchase2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('FetchAllPurchases', purchases);
	  resolve(purchases);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/purchases', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _items = __webpack_require__(475);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  (0, _items2.default)(1, 5);
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/purchases/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('purchases/unfinished/destroy').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (hashid) {
	  return window.open(("https://api.kundan.no") + '/purchases/' + hashid + '/pdf/download/?token=' + localStorage.getItem('id_token'));
	};

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _purchase = __webpack_require__(58);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  resolve(_purchase2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  } else if (errors.message) {
	    reject(errors);
	    return;
	  }
	
	  reject(_purchase2.default.fetch(errors));
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/purchases/mark-as-cancel/' + id).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _purchase = __webpack_require__(58);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentPurchase', _purchase2.default.fetch(data));
	  resolve(_purchase2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  } else if (errors.message) {
	    reject(errors);
	    return;
	  }
	
	  reject(_purchase2.default.fetch(errors));
	};
	
	exports.default = function (id, purchase) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/purchases/mark_as_done/' + id, purchase).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _purchase = __webpack_require__(58);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentPurchase', _purchase2.default.fetch(data));
	  resolve(_purchase2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_purchase2.default.fetch(errors));
	};
	
	exports.default = function (id, purchase) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/purchases/save-as-draft/' + id, purchase).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _purchaseMessage = __webpack_require__(1701);
	
	var _purchaseMessage2 = _interopRequireDefault(_purchaseMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id, previewParams) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('purchases/' + id + '/send', _purchaseMessage2.default.send(previewParams)).then(function () {
	      resolve();
	    }).catch(function () {
	      reject();
	    });
	  });
	};

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _purchase = __webpack_require__(58);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var purchase = _purchase2.default.fetch(data);
	  resolve(purchase);
	
	  _store2.default.dispatch('RefreshStockProductsCustom');
	  _store2.default.dispatch('fetchCurrentPurchase', purchase);
	  _store2.default.dispatch('allCurrentStockProductsCustom', purchase.products);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/purchases/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (hashid) {
	  var url = ("https://api.kundan.no") + '/purchases/' + hashid + '/pdf/show?token=' + localStorage.getItem('id_token');
	  window.open(url);
	};

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _email = __webpack_require__(498);
	
	var _email2 = _interopRequireDefault(_email);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	  return resolve(_email2.default.fetch(data));
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/purchases/' + id + '/showPurchaseEmailInformation').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _purchase = __webpack_require__(58);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var purchase = _purchase2.default.fetch(data);
	  _store2.default.dispatch('RefreshStockProductsCustom');
	  _store2.default.dispatch('fetchCurrentPurchase', purchase);
	  _store2.default.dispatch('allCurrentStockProductsCustom', purchase.products);
	  resolve(purchase);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/purchases/unfinished/purchase/products').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _purchase = __webpack_require__(58);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _store2.default.dispatch('RefreshStockProductsCustom');
	  resolve(_purchase2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  } else if (errors.message) {
	    reject(errors);
	    return;
	  }
	
	  reject(_purchase2.default.fetch(errors));
	};
	
	exports.default = function (purchase) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/purchases', purchase).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _purchase = __webpack_require__(58);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  resolve(_purchase2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  } else if (errors.message) {
	    reject(errors);
	    return;
	  }
	
	  reject(_purchase2.default.fetch(errors));
	};
	
	exports.default = function (pruchaseProducts) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/purchases/unfinished', pruchaseProducts).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _purchase = __webpack_require__(58);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('RefreshStockProductsCustom');
	  _store2.default.dispatch('fetchCurrentPurchase', _purchase2.default.fetch(data));
	  resolve(_purchase2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  } else if (errors.message) {
	    reject(errors);
	    return;
	  }
	
	  reject(_purchase2.default.fetch(errors));
	};
	
	exports.default = function (id, purchase) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/purchases/' + id, purchase).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _purchase = __webpack_require__(58);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('RefreshStockProductsCustom');
	  _store2.default.dispatch('fetchCurrentPurchase', _purchase2.default.fetch(data));
	  resolve(_purchase2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  } else if (errors.message) {
	    reject(errors);
	    return;
	  }
	
	  reject(_purchase2.default.fetch(errors));
	};
	
	exports.default = function (id, purchase) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/purchases/update-draft/' + id, purchase).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _purchaseStatus = __webpack_require__(505);
	
	var _purchaseStatus2 = _interopRequireDefault(_purchaseStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var purchaseStatuses = _purchaseStatus2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchPurchaseStatuses', purchaseStatuses);
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('purchase_status').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _recipe = __webpack_require__(100);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var recipes = _recipe2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllRecipes', recipes);
	  resolve(recipes);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/production/recipe').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _recipe = __webpack_require__(100);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  var recipe = _recipe2.default.fetch(response.data);
	  _store2.default.dispatch('fetchAllRecipeProducts', recipe.products);
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_recipe2.default.fetch(errors));
	};
	
	exports.default = function (recipeId, products) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/recipe/' + recipeId + '/product/bulk', {
	      items: products
	    }).then(function (response) {
	      success(resolve, response.data);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _store2.default.dispatch('fetchAllRecipeProducts', response.data.products);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (recipeId, productId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/production/recipe/' + recipeId + '/product/' + productId).then(function (response) {
	      success(resolve, response.data);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _recipe = __webpack_require__(100);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var recipes = _recipe2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedRecipes', { recipes: recipes, pagination: pagination });
	  resolve(recipes);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('production/recipe', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _recipe = __webpack_require__(100);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	
	  var recipe = _recipe2.default.fetch(data);
	  _store2.default.dispatch('fetchAllRecipeProducts', recipe.products);
	  return recipe;
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var recipes = _store2.default.state.recipe.items.filter(function (p) {
	      return id.toString() === p.id.toString();
	    });
	
	    if (recipes.length > 0) {
	      return resolve(recipes[0]);
	    }
	
	    return _vue2.default.$http.get('/production/recipe/' + id).then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _recipe = __webpack_require__(100);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  resolve(_recipe2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  reject(_recipe2.default.fetch(errors));
	};
	
	exports.default = function (recipe) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/recipe', recipe).then(function (response) {
	      success(resolve, response.data);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _recipe = __webpack_require__(100);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  var recipe = _recipe2.default.fetch(response.data);
	  _store2.default.dispatch('fetchAllRecipeProducts', recipe.products);
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_recipe2.default.fetch(errors));
	};
	
	exports.default = function (recipeId, data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/recipe/' + recipeId + '/product', {
	      product_id: data.product.id
	    }).then(function (response) {
	      success(resolve, response.data);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _recipe = __webpack_require__(100);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_recipe2.default.fetch(errors));
	};
	
	exports.default = function (id, recipe) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/production/recipe/' + id, recipe).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _recipeIngredience = __webpack_require__(111);
	
	var _recipeIngredience2 = _interopRequireDefault(_recipeIngredience);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _recipeIngredience2.default.fetchCollection(response.data).forEach(function (data) {
	    _store2.default.dispatch('addRecipeIngredience', data);
	  });
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_recipeIngredience2.default.fetch(errors));
	};
	
	exports.default = function (recipeId, ingrediences) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/recipe/' + recipeId + '/recipe_ingredience/bulk', { items: _recipeIngredience2.default.sendCollection(ingrediences) }).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _all = __webpack_require__(477);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, id) {
	  _store2.default.dispatch('removeRecipeIngredience', id);
	  (0, _all2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/production/recipe_ingredience/' + id).then(function () {
	      success(resolve, id);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(477);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _items = __webpack_require__(1260);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _store = __webpack_require__(1262);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _bulkStore = __webpack_require__(1257);
	
	var _bulkStore2 = _interopRequireDefault(_bulkStore);
	
	var _show = __webpack_require__(1261);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1263);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _destroy = __webpack_require__(1258);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  items: _items2.default,
	  store: _store2.default,
	  bulkStore: _bulkStore2.default,
	  show: _show2.default,
	  update: _update2.default,
	  destroy: _destroy2.default
	};

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _recipeIngredience = __webpack_require__(111);
	
	var _recipeIngredience2 = _interopRequireDefault(_recipeIngredience);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var recipeIngrediences = _recipeIngredience2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedMaterials', { recipeIngrediences: recipeIngrediences, pagination: pagination });
	  resolve(recipeIngrediences);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('production/recipe_ingredience', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _recipeIngredience = __webpack_require__(111);
	
	var _recipeIngredience2 = _interopRequireDefault(_recipeIngredience);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return _recipeIngredience2.default.fetch(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var recipeIngrediences = _store2.default.state.recipeIngredience.items.filter(function (p) {
	      return id.toString() === p.id.toString();
	    });
	
	    if (recipeIngrediences.length > 0) {
	      return resolve(recipeIngrediences[0]);
	    }
	
	    return _vue2.default.$http.get('/production/recipe_ingredience/' + id).then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _recipeIngredience = __webpack_require__(111);
	
	var _recipeIngredience2 = _interopRequireDefault(_recipeIngredience);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _store2.default.dispatch('addRecipeIngredience', _recipeIngredience2.default.fetch(response.data));
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_recipeIngredience2.default.fetch(errors));
	};
	
	exports.default = function (recipeIngredience) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/recipe_ingredience', _recipeIngredience2.default.send(recipeIngredience)).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _recipeIngredience = __webpack_require__(111);
	
	var _recipeIngredience2 = _interopRequireDefault(_recipeIngredience);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _store2.default.dispatch('updateRecipeIngredience', {
	    recipeIngredience: _recipeIngredience2.default.fetch(response.data),
	    id: response.data.id
	  });
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_recipeIngredience2.default.fetch(errors));
	};
	
	exports.default = function (id, recipeIngredience) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/production/recipe_ingredience/' + id, _recipeIngredience2.default.send(recipeIngredience)).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _all = __webpack_require__(478);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, id) {
	  _store2.default.dispatch('removeRecipeProcedure', id);
	  (0, _all2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/production/recipe_procedure/' + id).then(function () {
	      success(resolve, id);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(478);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _store = __webpack_require__(1267);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _show = __webpack_require__(1266);
	
	var _show2 = _interopRequireDefault(_show);
	
	var _update = __webpack_require__(1268);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _destroy = __webpack_require__(1264);
	
	var _destroy2 = _interopRequireDefault(_destroy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default,
	  store: _store2.default,
	  show: _show2.default,
	  update: _update2.default,
	  destroy: _destroy2.default
	};

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _recipeProcedure = __webpack_require__(136);
	
	var _recipeProcedure2 = _interopRequireDefault(_recipeProcedure);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return _recipeProcedure2.default.fetch(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var recipeProcedures = _store2.default.state.recipeProcedure.items.filter(function (p) {
	      return id.toString() === p.id.toString();
	    });
	
	    if (recipeProcedures.length > 0) {
	      return resolve(recipeProcedures[0]);
	    }
	
	    return _vue2.default.$http.get('/production/recipe_procedure/' + id).then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _recipeProcedure = __webpack_require__(136);
	
	var _recipeProcedure2 = _interopRequireDefault(_recipeProcedure);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _store2.default.dispatch('addRecipeProcedure', _recipeProcedure2.default.fetch(response.data));
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_recipeProcedure2.default.fetch(errors));
	};
	
	exports.default = function (recipeProcedure) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/production/recipe_procedure', _recipeProcedure2.default.send(recipeProcedure)).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _recipeProcedure = __webpack_require__(136);
	
	var _recipeProcedure2 = _interopRequireDefault(_recipeProcedure);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _store2.default.dispatch('updateRecipeProcedure', {
	    recipeProcedure: _recipeProcedure2.default.fetch(response.data),
	    id: response.data.id
	  });
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_recipeProcedure2.default.fetch(errors));
	};
	
	exports.default = function (id, recipeProcedure) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/production/recipe_procedure/' + id, _recipeProcedure2.default.send(recipeProcedure)).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _recipeType = __webpack_require__(1703);
	
	var _recipeType2 = _interopRequireDefault(_recipeType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var recipeTypes = _recipeType2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllRecipeTypes', recipeTypes);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('production/recipe_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _releaseNote = __webpack_require__(1704);
	
	var _releaseNote2 = _interopRequireDefault(_releaseNote);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var releaseNotes = _releaseNote2.default.fetchCollection(data);
	  resolve(releaseNotes);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/release_notes', params)).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(1270);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  all: _all2.default
	};

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$groupBy = _ref.groupBy,
	      groupBy = _ref$groupBy === undefined ? ['product'] : _ref$groupBy,
	      dateRange = _ref.dateRange,
	      statuses = _ref.statuses,
	      includeCancelled = _ref.includeCancelled,
	      sort = _ref.sort;
	
	  return new Promise(function (resolve, reject) {
	    var params = new URLSearchParams();
	
	    (groupBy || ['product']).forEach(function (g) {
	      return params.append('group_by[]', g);
	    });
	
	    if (statuses && statuses.length) {
	      statuses.forEach(function (s) {
	        return params.append('statuses[]', s);
	      });
	    }
	
	    if (includeCancelled) {
	      params.append('include_cancelled', '1');
	    }
	
	    if (sort) {
	      params.append('sort', sort);
	    }
	
	    if (dateRange && dateRange[0] && dateRange[1]) {
	      params.append('start', (0, _moment2.default)(dateRange[0]).format('YYYY-MM-DD'));
	      params.append('end', (0, _moment2.default)(dateRange[1]).format('YYYY-MM-DD'));
	    }
	
	    _vue2.default.$http.get('/reports/aggregated_sales?' + params.toString()).then(function (_ref2) {
	      var data = _ref2.data;
	
	      resolve({
	        columns: data.data.columns,
	        rows: data.data.rows,
	        summary: data.data.summary,
	        meta: data.data.meta
	      });
	    }).catch(reject);
	  });
	};

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _billsReport = __webpack_require__(1658);
	
	var _billsReport2 = _interopRequireDefault(_billsReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var report = _billsReport2.default.fetchCollection(data.data);
	
	  resolve(report);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (dateRange) {
	  var clientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  return new Promise(function (resolve, reject) {
	    var url = '/reports/bills';
	    var query = [];
	
	    if (clientId !== '') {
	      query.push('client_id=' + clientId);
	    }
	
	    if (limit) {
	      query.push('limit=' + limit);
	    }
	
	    if (dateRange[0] && dateRange[1]) {
	      query.push('start=' + (0, _moment2.default)(dateRange[0]).format('YYYY-MM-DD'));
	      query.push('end=' + (0, _moment2.default)(dateRange[1]).format('YYYY-MM-DD'));
	    }
	
	    if (query.length > 0) {
	      url += '?';
	      query.map(function (q) {
	        url += q + '&';
	        return q;
	      });
	      url = url.substring(0, url.length - 1);
	    }
	
	    _vue2.default.$http.get(url).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var report = data;
	  resolve(report);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (dateRange) {
	  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  return new Promise(function (resolve, reject) {
	    var url = '/reports/excise_entries/export_check';
	    var query = [];
	
	    if (limit) {
	      query.push('limit=' + limit);
	    }
	
	    if (dateRange) {
	      query.push('month=' + (0, _moment2.default)(dateRange).format('YYYY-MM-DD'));
	    }
	
	    if (query.length > 0) {
	      url += '?';
	      query.map(function (q) {
	        url += q + '&';
	        return q;
	      });
	      url = url.substring(0, url.length - 1);
	    }
	
	    _vue2.default.$http.get(url).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _client = __webpack_require__(56);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var clients = _client2.default.fetchCollection(data.data);
	  resolve(clients);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/reports/clients', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _excisePeriod = __webpack_require__(310);
	
	var _excisePeriod2 = _interopRequireDefault(_excisePeriod);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return _excisePeriod2.default.fetch(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('reports/excise_periods/' + id + '/close').then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'single';
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    var request = null;
	    if (type === 'validate') {
	      request = _vue2.default.$http.get(_helpers2.default.buildUrl('/reports/turnover/client/validate/bulk', params));
	    } else if (type === 'multiple') {
	      request = _vue2.default.$http.get(_helpers2.default.buildUrl('/reports/turnover/client/download/bulk', params), { responseType: 'arraybuffer' });
	    } else {
	      request = _vue2.default.$http.get(_helpers2.default.buildUrl('reports/turnover/client/' + params.id, params), { responseType: 'blob' });
	    }
	    request.then(function (response) {
	      resolve(response);
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('reports/excise_calendar').then(function (response) {
	      resolve(response);
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _excisePeriod = __webpack_require__(310);
	
	var _excisePeriod2 = _interopRequireDefault(_excisePeriod);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var excisePeriods = _excisePeriod2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedExcisePeriods', { excisePeriods: excisePeriods, pagination: pagination });
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('reports/excise_periods', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _exciseReport = __webpack_require__(1667);
	
	var _exciseReport2 = _interopRequireDefault(_exciseReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var report = data.map(function (r) {
	    return {
	      period: r.period,
	      entries: _exciseReport2.default.fetchCollection(r.entries)
	    };
	  });
	
	  resolve(report);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (dateRange) {
	  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  return new Promise(function (resolve, reject) {
	    var url = '/reports/excise_entries';
	    var query = [];
	
	    if (limit) {
	      query.push('limit=' + limit);
	    }
	
	    if (dateRange) {
	      query.push('month=' + (0, _moment2.default)(dateRange).format('YYYY-MM-DD'));
	    }
	
	    if (query.length > 0) {
	      url += '?';
	      query.map(function (q) {
	        url += q + '&';
	        return q;
	      });
	      url = url.substring(0, url.length - 1);
	    }
	
	    _vue2.default.$http.get(url).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _feesReport = __webpack_require__(1668);
	
	var _feesReport2 = _interopRequireDefault(_feesReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var report = _feesReport2.default.fetchCollection(data.data);
	
	  resolve(report);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (feesMonth) {
	  var clientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  return new Promise(function (resolve, reject) {
	    var url = '/reports/fees';
	    var query = [];
	
	    if (limit) {
	      query.push('limit=' + limit);
	    }
	
	    if (clientId && clientId !== '') {
	      query.push('client_id=' + clientId);
	    }
	
	    query.push('start=' + (0, _moment2.default)(feesMonth).startOf('month').format('YYYY-MM-DD'));
	    query.push('end=' + (0, _moment2.default)(feesMonth).endOf('month').format('YYYY-MM-DD'));
	
	    if (query.length > 0) {
	      url += '?';
	      query.map(function (q) {
	        url += q + '&';
	        return q;
	      });
	      url = url.substring(0, url.length - 1);
	    }
	
	    _vue2.default.$http.get(url).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  resolve(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (dateRange) {
	  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  return new Promise(function (resolve, reject) {
	    var url = '/reports/helsedir';
	    var query = [];
	
	    if (limit) {
	      query.push('limit=' + limit);
	    }
	
	    if (dateRange) {
	      query.push('month=' + (0, _moment2.default)(dateRange).format('YYYY-MM-DD'));
	    }
	
	    if (query.length > 0) {
	      url += '?';
	      query.map(function (q) {
	        url += q + '&';
	        return q;
	      });
	      url = url.substring(0, url.length - 1);
	    }
	
	    _vue2.default.$http.get(url).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  resolve(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (dateRange) {
	  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  return new Promise(function (resolve, reject) {
	    var url = '/reports/infinitum';
	    var query = [];
	
	    if (limit) {
	      query.push('limit=' + limit);
	    }
	
	    if (dateRange) {
	      query.push('month=' + (0, _moment2.default)(dateRange).format('YYYY-MM-DD'));
	    }
	
	    if (query.length > 0) {
	      url += '?';
	      query.map(function (q) {
	        url += q + '&';
	        return q;
	      });
	      url = url.substring(0, url.length - 1);
	    }
	
	    _vue2.default.$http.get(url).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _salesReport = __webpack_require__(1705);
	
	var _salesReport2 = _interopRequireDefault(_salesReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var report = _salesReport2.default.fetchCollection(data.data);
	
	  resolve(report);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (group, dateRange, filter, type) {
	  return new Promise(function (resolve, reject) {
	    var url = '/reports/sales';
	    var query = [];
	    if (group !== undefined) {
	      query.push('group_by=' + group);
	    }
	
	    if (type !== undefined) {
	      query.push('type=' + type);
	    }
	
	    if (filter !== undefined) {
	      query.push('filter=' + filter);
	    }
	
	    if (dateRange[0] && dateRange[1]) {
	      query.push('start=' + (0, _moment2.default)(dateRange[0]).format('YYYY-MM-DD'));
	      query.push('end=' + (0, _moment2.default)(dateRange[1]).format('YYYY-MM-DD'));
	    }
	
	    if (query.length > 0) {
	      url += '?';
	      query.map(function (q) {
	        url += q + '&';
	        return q;
	      });
	      url = url.substring(0, url.length - 1);
	    }
	
	    _vue2.default.$http.get(url).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/reports/turnover/client/send/bulk', params, {
	      headers: {
	        Accept: 'application/json'
	      }
	    }).then(function (response) {
	      resolve(response);
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _excisePeriod = __webpack_require__(310);
	
	var _excisePeriod2 = _interopRequireDefault(_excisePeriod);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref) {
	  var data = _ref.data;
	  return _excisePeriod2.default.fetch(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    var excisePeriod = _store2.default.state.productGroup.items.find(function (p) {
	      return id.toString() === p.id.toString();
	    });
	
	    if (excisePeriod) {
	      return resolve(excisePeriod);
	    }
	
	    return _vue2.default.$http.get('reports/excise_periods/' + id).then(function (response) {
	      resolve(success(response));
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _warehouseTransactionV = __webpack_require__(318);
	
	var _warehouseTransactionV2 = _interopRequireDefault(_warehouseTransactionV);
	
	var _warehouseReport = __webpack_require__(508);
	
	var _warehouseReport2 = _interopRequireDefault(_warehouseReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve, groupByProduct) {
	  var data = _ref.data;
	
	  var report = null;
	  if (groupByProduct) {
	    report = _warehouseReport2.default.fetchCollection(data.data);
	  } else {
	    report = _warehouseTransactionV2.default.fetchCollection(data.data);
	  }
	
	  resolve(report);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (options) {
	  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  return new Promise(function (resolve, reject) {
	    var url = '/reports/warehouses_transactions';
	    var query = [];
	
	    if (limit) {
	      query.push('limit=' + limit);
	    }
	
	    if (options.warehouseId) {
	      query.push('warehouse_id=' + options.warehouseId);
	    }
	
	    if (options.transactionTypeId) {
	      query.push('transaction_type_id=' + options.transactionTypeId);
	    }
	
	    if (options.dateOption === 'as_of_date') {
	      if (options.asOfDate) {
	        var asOfDate = (0, _moment2.default)(options.asOfDate).format('YYYY-MM-DD');
	        query.push('asOfDate=' + asOfDate);
	      }
	
	      if (options.hideOutOfStock) {
	        query.push('hide_out_of_stock=' + options.hideOutOfStock);
	      }
	    } else {
	      if (options.transactionDateRange.length) {
	        var start = (0, _moment2.default)(options.transactionDateRange[0]).format('YYYY-MM-DD');
	        var end = (0, _moment2.default)(options.transactionDateRange[1]).format('YYYY-MM-DD');
	        query.push('start=' + start);
	        query.push('end=' + end);
	      }
	    }
	
	    if (options.groupByProduct) {
	      query.push('group_by_product=' + options.groupByProduct);
	    }
	
	    if (query.length > 0) {
	      url += '?';
	      query.map(function (q) {
	        url += q + '&';
	        return q;
	      });
	      url = url.substring(0, url.length - 1);
	    }
	
	    _vue2.default.$http.get(url).then(function (response) {
	      success(response, resolve, options.groupByProduct);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _warehouseReport = __webpack_require__(508);
	
	var _warehouseReport2 = _interopRequireDefault(_warehouseReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var report = _warehouseReport2.default.fetchCollection(data.data);
	
	  resolve(report);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var warehouseId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  return new Promise(function (resolve, reject) {
	    var url = '/reports/warehouses';
	    var query = [];
	
	    if (limit) {
	      query.push('limit=' + limit);
	    }
	
	    if (warehouseId && warehouseId !== '') {
	      query.push('warehouse_id=' + warehouseId);
	    }
	
	    if (query.length > 0) {
	      url += '?';
	      query.map(function (q) {
	        url += q + '&';
	        return q;
	      });
	      url = url.substring(0, url.length - 1);
	    }
	
	    _vue2.default.$http.get(url).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _all = __webpack_require__(480);
	
	var _all2 = _interopRequireDefault(_all);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  (0, _all2.default)();
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/shipping_providers/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _shippingProvider = __webpack_require__(199);
	
	var _shippingProvider2 = _interopRequireDefault(_shippingProvider);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var shippingProvider = _shippingProvider2.default.fetch(data);
	  resolve(shippingProvider);
	  _store2.default.dispatch('fetchCurrentShippingProvider', shippingProvider);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/shipping_providers/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _shippingProvider = __webpack_require__(199);
	
	var _shippingProvider2 = _interopRequireDefault(_shippingProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  resolve(_shippingProvider2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_shippingProvider2.default.fetch(errors));
	};
	
	exports.default = function (shippingProvider) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/shipping_providers', shippingProvider).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _shippingProvider = __webpack_require__(199);
	
	var _shippingProvider2 = _interopRequireDefault(_shippingProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(_shippingProvider2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_shippingProvider2.default.fetch(errors));
	};
	
	exports.default = function (id, shippingProvider) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/shipping_providers/' + id, shippingProvider).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var warehouse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/shipping_providers/warehouse_shipping_provider/' + warehouse).then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var siteLanguagesData = data;
	  _store2.default.dispatch('fetchSiteLanguages', { siteLanguagesData: siteLanguagesData });
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('site-language').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (userId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/sms_two_factor_auth/' + userId + '/disable_2fa').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sendVerificationToken = __webpack_require__(1297);
	
	var _sendVerificationToken2 = _interopRequireDefault(_sendVerificationToken);
	
	var _verifyToken = __webpack_require__(1298);
	
	var _verifyToken2 = _interopRequireDefault(_verifyToken);
	
	var _disableSmsTwoFactorAuth = __webpack_require__(1295);
	
	var _disableSmsTwoFactorAuth2 = _interopRequireDefault(_disableSmsTwoFactorAuth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  sendVerificationToken: _sendVerificationToken2.default,
	  verifyToken: _verifyToken2.default,
	  disableSmsTwoFactorAuth: _disableSmsTwoFactorAuth2.default
	};

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/sms_two_factor_auth/' + data.user_id + '/send_verification', data).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/sms_two_factor_auth/' + data.user_id + '/verify_token', data).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _stock = __webpack_require__(68);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var stocks = _stock2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('FetchAllStocks', stocks);
	  resolve(stocks);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/stocks', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _items = __webpack_require__(482);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  (0, _items2.default)(1, 5);
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/stocks/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (warehouseId) {
	  return window.open(("https://api.kundan.no") + '/stocks/' + warehouseId + '/download/?token=' + localStorage.getItem('id_token'));
	};

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _stock = __webpack_require__(68);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentStock', _stock2.default.fetch(data));
	  resolve(_stock2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_stock2.default.fetch(errors));
	};
	
	exports.default = function (stock) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/stocks/save-draft', stock).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _stock = __webpack_require__(68);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var stock = _stock2.default.fetch(data);
	  resolve(stock);
	  _store2.default.dispatch('fetchCurrentStock', stock);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/stocks/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _stock = __webpack_require__(68);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _store2.default.dispatch('RefreshStockProducts');
	  resolve(_stock2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  } else if (errors.message) {
	    reject(errors);
	    return;
	  }
	
	  reject(_stock2.default.fetch(errors));
	};
	
	exports.default = function (stock) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/stocks', stock).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _stock = __webpack_require__(68);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentStock', _stock2.default.fetch(data));
	  resolve(_stock2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_stock2.default.fetch(errors));
	};
	
	exports.default = function (id, stock) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/stocks/' + id, stock).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _stock = __webpack_require__(68);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentStock', _stock2.default.fetch(data));
	  resolve(_stock2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_stock2.default.fetch(errors));
	};
	
	exports.default = function (id, stock) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/stocks/update-draft/' + id, stock).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productWarehouse = __webpack_require__(196);
	
	var _productWarehouse2 = _interopRequireDefault(_productWarehouse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var product = _productWarehouse2.default.fetch(data);
	  resolve(product);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id, warehouseId) {
	  var batchId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/stocks/find-product/' + warehouseId + '/' + id + '/' + batchId).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _productWarehouse = __webpack_require__(196);
	
	var _productWarehouse2 = _interopRequireDefault(_productWarehouse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var product = _productWarehouse2.default.fetchCollection(data);
	  resolve(product);
	};
	
	var failed = function failed() {};
	
	exports.default = function (productIds, warehouseId) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/stocks/find-product/' + warehouseId, {
	      product_ids: productIds
	    }).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchAllSubscriber', data);
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('subscriberList/' + id + '/allSubscriber').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('subscriberList/destroySubscriber/' + id).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _subscriber = __webpack_require__(506);
	
	var _subscriber2 = _interopRequireDefault(_subscriber);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var subscriber = _subscriber2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedSubscriber', { subscriber: subscriber, pagination: pagination });
	  resolve({ subscriber: subscriber, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
	  var filter = arguments[3];
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('subscriberList/' + id + '/indexSubscriber?page=' + page + '&limit=' + limit + '&filter=' + filter).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _subscriber = __webpack_require__(506);
	
	var _subscriber2 = _interopRequireDefault(_subscriber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(_subscriber2.default.fetchCreate(errors));
	};
	
	exports.default = function (subscriberListId, subscriber) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('subscriberList/' + subscriberListId + '/newSubscriber', subscriber).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (subscriberId, action) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('subscriberList/subscriberSwitch/' + subscriberId, action).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  resolve(data);
	};
	
	var failed = function failed(errors, reject) {
	  reject(errors);
	};
	
	exports.default = function (action) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('subscriberList/subscriberSwitch/all', action).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var subscriberList = [];
	  data.forEach(function (item) {
	    subscriberList.push({ id: item.id, name: item.name });
	  });
	  _store2.default.dispatch('fetchAllSubscriberList', subscriberList);
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  return reject(errors);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('subscriberList').then(function (response) {
	      success(response.data.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('subscriberList/' + id).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _subscriberList = __webpack_require__(165);
	
	var _subscriberList2 = _interopRequireDefault(_subscriberList);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var subscriberList = _subscriberList2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedSubscriberList', { subscriberList: subscriberList, pagination: pagination });
	  resolve(data);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('subscriberList?page=' + page + '&limit=' + limit).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _subscriberList = __webpack_require__(165);
	
	var _subscriberList2 = _interopRequireDefault(_subscriberList);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentSubscriberList', _subscriberList2.default.fetch(data));
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_subscriberList2.default.fetch(errors));
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('subscriberList/' + id).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('subscriberList/rules/' + id).then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error.response.data);
	    });
	  });
	};

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _subscriberList = __webpack_require__(165);
	
	var _subscriberList2 = _interopRequireDefault(_subscriberList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _vue2.default.router.push({
	    name: 'subscriberList.edit',
	    params: { id: data.id }
	  });
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_subscriberList2.default.fetch(errors));
	};
	
	exports.default = function (subscriberList) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('subscriberList', subscriberList).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('subscriberList/rules/' + id, params).then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error.response.data);
	    });
	  });
	};

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _subscriberList = __webpack_require__(165);
	
	var _subscriberList2 = _interopRequireDefault(_subscriberList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  resolve();
	};
	
	var failed = function failed(errors, reject) {
	  reject(_subscriberList2.default.fetch(errors));
	};
	
	exports.default = function (id, subscriberList) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('subscriberList/' + id, subscriberList).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _supplier = __webpack_require__(112);
	
	var _supplier2 = _interopRequireDefault(_supplier);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var suppliers = _supplier2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('FetchAllSuppliers', suppliers);
	  resolve(suppliers);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/suppliers', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  resolve(data);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/suppliers/counts').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _items = __webpack_require__(484);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  (0, _items2.default)(1, 5);
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/suppliers/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _supplier = __webpack_require__(112);
	
	var _supplier2 = _interopRequireDefault(_supplier);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var supplier = _supplier2.default.fetch(data);
	  resolve(supplier);
	  _store2.default.dispatch('fetchCurrentSupplier', supplier);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/suppliers/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _supplier = __webpack_require__(112);
	
	var _supplier2 = _interopRequireDefault(_supplier);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  resolve(_supplier2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_supplier2.default.fetch(errors));
	};
	
	exports.default = function (supplier) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/suppliers', supplier).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _supplier = __webpack_require__(112);
	
	var _supplier2 = _interopRequireDefault(_supplier);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentSupplier', _supplier2.default.fetch(data));
	  resolve(_supplier2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_supplier2.default.fetch(errors));
	};
	
	exports.default = function (id, supplier) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/suppliers/' + id, supplier).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _tax = __webpack_require__(1710);
	
	var _tax2 = _interopRequireDefault(_tax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var taxes = _tax2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchTaxes', { taxes: taxes });
	
	  resolve(taxes);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('taxes').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _transactionType = __webpack_require__(507);
	
	var _transactionType2 = _interopRequireDefault(_transactionType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var types = _transactionType2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchAllTransactionTypes', types);
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('transaction_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _transactionType = __webpack_require__(507);
	
	var _transactionType2 = _interopRequireDefault(_transactionType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var types = _transactionType2.default.fetchCollection(data.data);
	
	  resolve(types);
	};
	
	var failed = function failed() {};
	
	exports.default = function (transactionType) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('transaction_types/' + transactionType).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _transfer = __webpack_require__(200);
	
	var _transfer2 = _interopRequireDefault(_transfer);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var transfers = _transfer2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('FetchAllTransfers', transfers);
	  resolve(transfers);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/transfers', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _transfer = __webpack_require__(200);
	
	var _transfer2 = _interopRequireDefault(_transfer);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var transfers = _transfer2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	
	  _store2.default.dispatch('fetchPaginatedTransfers', { transfers: transfers, pagination: pagination });
	  resolve({ transfers: transfers, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/transfers', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _transfer = __webpack_require__(200);
	
	var _transfer2 = _interopRequireDefault(_transfer);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var transfer = _transfer2.default.fetch(data);
	  resolve(transfer);
	  _store2.default.dispatch('fetchCurrentTransfer', transfer);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/transfers/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (transferId) {
	  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	  var url = ("https://api.kundan.no") + '/delivery_notes/warehouse_transfer/' + lang + '/' + transferId + '/?token=' + localStorage.getItem('id_token');
	  window.open(url);
	};

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _transfer = __webpack_require__(200);
	
	var _transfer2 = _interopRequireDefault(_transfer);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  _store2.default.dispatch('RefreshStockProducts');
	  resolve(response.data);
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  } else if (errors.message) {
	    reject(errors);
	    return;
	  }
	
	  reject(_transfer2.default.fetch(errors));
	};
	
	exports.default = function (transfer) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/transfers', transfer).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error.response.data);
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/tripletex/' + data.user_id + '/authorize', data).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _authorize = __webpack_require__(1337);
	
	var _authorize2 = _interopRequireDefault(_authorize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  authorize: _authorize2.default
	};

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = authorize;
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	function authorize(data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/unimicro/auth-url', data).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	}

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = numberSeries;
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	function numberSeries(data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/unimicro/number-series', data).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	}

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = status;
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	function status(data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/unimicro/status', data).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	}

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = token;
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	function token(data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/unimicro/token', data).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	}

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _unitOfMeasure = __webpack_require__(137);
	
	var _unitOfMeasure2 = _interopRequireDefault(_unitOfMeasure);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var unitOfMeasures = _unitOfMeasure2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('FetchAllUnitOfMeasures', unitOfMeasures);
	  resolve(unitOfMeasures);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/unit_of_measures', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _items = __webpack_require__(487);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  (0, _items2.default)(1, 5);
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/unit_of_measures/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _unitOfMeasure = __webpack_require__(137);
	
	var _unitOfMeasure2 = _interopRequireDefault(_unitOfMeasure);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var unitOfMeasure = _unitOfMeasure2.default.fetch(data);
	  resolve(unitOfMeasure);
	  _store2.default.dispatch('fetchCurrentUnitOfMeasure', unitOfMeasure);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/unit_of_measures/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _unitOfMeasure = __webpack_require__(137);
	
	var _unitOfMeasure2 = _interopRequireDefault(_unitOfMeasure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  resolve(_unitOfMeasure2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_unitOfMeasure2.default.fetch(errors));
	};
	
	exports.default = function (unitOfMeasure) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/unit_of_measures', unitOfMeasure).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _unitOfMeasure = __webpack_require__(137);
	
	var _unitOfMeasure2 = _interopRequireDefault(_unitOfMeasure);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentUnitOfMeasure', _unitOfMeasure2.default.fetch(data));
	  resolve(_unitOfMeasure2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_unitOfMeasure2.default.fetch(errors));
	};
	
	exports.default = function (id, unitOfMeasure) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/unit_of_measures/' + id, unitOfMeasure).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _unitType = __webpack_require__(1712);
	
	var _unitType2 = _interopRequireDefault(_unitType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var unitTypes = _unitType2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('fetchUnitTypes', unitTypes);
	  resolve();
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('unit_types').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error.response.data);
	};
	
	exports.default = function (data) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/vinmonopolet/authorize', data).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	  return resolve(data);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    return _vue2.default.$http.post('vinmonopolet/cancel_sync').then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	  return resolve(_product2.default.fetch(data));
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    return _vue2.default.$http.get('vinmonopolet/products/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	  return resolve(data);
	};
	
	var failed = function failed() {};
	
	exports.default = function (options) {
	  return new Promise(function (resolve, reject) {
	    return _vue2.default.$http.post('vinmonopolet/sync', options).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _warehouse = __webpack_require__(62);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var warehouses = _warehouse2.default.fetchCollection(data.data);
	
	  _store2.default.dispatch('FetchAllWarehouses', warehouses);
	  resolve(warehouses);
	};
	
	var failed = function failed() {};
	
	exports.default = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/warehouses', params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _items = __webpack_require__(488);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(response, resolve) {
	  (0, _items2.default)(1, 5);
	  resolve(response);
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.delete('/warehouses/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  resolve(response.data);
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(errors);
	};
	
	exports.default = function (warehouseId, products) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/warehouses/' + warehouseId + '/destroy_products', { products: products }).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _warehouseProduct = __webpack_require__(1715);
	
	var _warehouseProduct2 = _interopRequireDefault(_warehouseProduct);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var products = _warehouseProduct2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedWarehouseProducts', { products: products, pagination: pagination });
	  resolve({ products: products, pagination: pagination });
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/warehouses/products/' + id, params)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('/warehouses/products/' + id + '/search', params)).then(function (response) {
	      resolve(response);
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _warehouse = __webpack_require__(62);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var warehouse = _warehouse2.default.fetch(data);
	  resolve(warehouse);
	  _store2.default.dispatch('fetchCurrentWarehouse', warehouse);
	};
	
	var failed = function failed() {};
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('/warehouses/' + id).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'single';
	  return new Promise(function (resolve, reject) {
	    var url = '';
	    if (type === 'bulk') {
	      url = '/warehouses/stock_management';
	    } else {
	      url = '/warehouses/stock_management/' + id;
	    }
	    _vue2.default.$http.post(url, params).then(function (response) {
	      resolve(response.data);
	    }).catch(function (error) {
	      reject(error.response.data);
	    });
	  });
	};

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _warehouse = __webpack_require__(62);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve, response) {
	  resolve(_warehouse2.default.fetch(response.data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	
	  reject(_warehouse2.default.fetch(errors));
	};
	
	exports.default = function (warehouse) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.post('/warehouses', warehouse).then(function (response) {
	      success(resolve, response);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (id) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('warehouses/' + id + '/transactionsV2/types').then(function (response) {
	      resolve(response);
	    }).catch(function (error) {
	      reject(error);
	    });
	  });
	};

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _warehouseTransaction = __webpack_require__(1716);
	
	var _warehouseTransaction2 = _interopRequireDefault(_warehouseTransaction);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var transactions = _warehouseTransaction2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllWarehouseTransactions', transactions);
	  resolve(transactions);
	};
	
	var failed = function failed(error, reject) {
	  return reject();
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('warehouses/' + options.id + '/transactions', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _warehouseTransactionV = __webpack_require__(318);
	
	var _warehouseTransactionV2 = _interopRequireDefault(_warehouseTransactionV);
	
	var _pagination = __webpack_require__(15);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var transactions = _warehouseTransactionV2.default.fetchCollection(data.data);
	  var pagination = _pagination2.default.fetch(data.pagination);
	  _store2.default.dispatch('fetchPaginatedWarehouseTransactionsV2', { transactions: transactions, pagination: pagination });
	
	  resolve({ transactions: transactions, pagination: pagination });
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('warehouses/' + options.id + '/transactionsV2', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _warehouseTransactionV = __webpack_require__(318);
	
	var _warehouseTransactionV2 = _interopRequireDefault(_warehouseTransactionV);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(_ref, resolve) {
	  var data = _ref.data;
	
	  var transactionsV2All = _warehouseTransactionV2.default.fetchCollection(data.data);
	  _store2.default.dispatch('fetchAllWarehouseTransactionsV2', transactionsV2All);
	  resolve(transactionsV2All);
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get(_helpers2.default.buildUrl('warehouses/' + options.id + '/transactionsV2', options)).then(function (response) {
	      success(response, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _warehouse = __webpack_require__(62);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  _store2.default.dispatch('fetchCurrentWarehouse', _warehouse2.default.fetch(data));
	  resolve(_warehouse2.default.fetch(data));
	};
	
	var failed = function failed(errors, reject) {
	  if (errors.error) {
	    reject(errors.error);
	    return;
	  }
	  reject(_warehouse2.default.fetch(errors));
	};
	
	exports.default = function (id, warehouse) {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.put('/warehouses/' + id, warehouse).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error.response.data, reject);
	    });
	  });
	};

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var avialableWidgetsData = data;
	  _store2.default.dispatch('fetchAvailableWidgets', { avialableWidgetsData: avialableWidgetsData });
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('user-widgets/available').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var bestClientsWidgetsData = data;
	  _store2.default.dispatch('fetchBestClientsDataWidgets', bestClientsWidgetsData);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'last_3_months';
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('user-widgets/best-clients/' + filter).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var orderReceivedWidgetsData = data;
	  _store2.default.dispatch('fetchOrderReceivedDataWidgets', orderReceivedWidgetsData);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('user-widgets/order-received').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var popularProductsWidgetsData = data;
	  _store2.default.dispatch('fetchPopularProductsDataWidgets', popularProductsWidgetsData);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'last_3_months';
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('user-widgets/popular-products/' + filter).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var revenueWidgetsData = data;
	  _store2.default.dispatch('fetchRevenueDataWidgets', revenueWidgetsData);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('user-widgets/revenue').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var soldProductsWidgetsData = data;
	  _store2.default.dispatch('fetchSoldProductsDataWidgets', soldProductsWidgetsData);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'last_3_months';
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('user-widgets/sold-products/' + filter).then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var waitingDeliveredWidgetsData = data;
	  _store2.default.dispatch('fetchWaitingDeiveredDataWidgets', waitingDeliveredWidgetsData);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('user-widgets/waiting-to-be-delivered').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(data, resolve) {
	  var waitingProcessedWidgetsData = data;
	  _store2.default.dispatch('fetchWaitingProcessedDataWidgets', waitingProcessedWidgetsData);
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  return reject(error);
	};
	
	exports.default = function () {
	  return new Promise(function (resolve, reject) {
	    _vue2.default.$http.get('user-widgets/waiting-to-be-processed').then(function (response) {
	      success(response.data, resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	};

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _fetchUserWidgets = __webpack_require__(489);
	
	var _fetchUserWidgets2 = _interopRequireDefault(_fetchUserWidgets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = function success(resolve) {
	  (0, _fetchUserWidgets2.default)();
	  resolve();
	};
	
	var failed = function failed(error, reject) {
	  reject(error);
	};
	
	exports.default = function (value) {
	  var data = new FormData();
	  data.append('widgets', JSON.stringify(Object.assign([], value)).replace(/"([^"]+)":/g, '$1:'));
	  var p = new Promise(function (resolve, reject) {
	    _vue2.default.$http.request({
	      url: 'user-widgets',
	      data: data,
	      method: 'post'
	    }).then(function () {
	      success(resolve);
	    }).catch(function (error) {
	      failed(error, reject);
	    });
	  });
	  return p;
	};

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isAuthenticated = exports.isAuthenticated = function isAuthenticated(state) {
	  return state.auth.authenticated;
	};
	var twoFactorVerification = exports.twoFactorVerification = function twoFactorVerification(state) {
	  return state.auth.twoFactorVerification;
	};
	var isInMaintenance = exports.isInMaintenance = function isInMaintenance(state) {
	  return state.auth.maintenance;
	};
	
	var clients = exports.clients = function clients(state) {
	  return {
	    items: state.client.items,
	    pagination: state.client.pagination
	  };
	};
	
	var allClients = exports.allClients = function allClients(state) {
	  return state.client.all;
	};
	var allClientOptions = exports.allClientOptions = function allClientOptions(state) {
	  return state.client.options;
	};
	var clientQuery = exports.clientQuery = function clientQuery(state) {
	  return state.client.query;
	};
	
	var account = exports.account = function account(state) {
	  return state.profile.account;
	};
	var address = exports.address = function address(state) {
	  return state.profile.address;
	};
	var contact = exports.contact = function contact(state) {
	  return state.profile.contact;
	};
	var organizationSettings = exports.organizationSettings = function organizationSettings(state) {
	  return state.profile.settings;
	};
	var publicProfile = exports.publicProfile = function publicProfile(state) {
	  return state.profile.publicProfile;
	};
	var businessHours = exports.businessHours = function businessHours(state) {
	  return state.profile.businessHours;
	};
	var businessHourExceptions = exports.businessHourExceptions = function businessHourExceptions(state) {
	  return state.profile.businessHourExceptions;
	};
	
	var allPlans = exports.allPlans = function allPlans(state) {
	  return state.plan.plans;
	};
	var chosenPlan = exports.chosenPlan = function chosenPlan(state) {
	  return state.plan.chosenPlan;
	};
	
	var allOrganizationTypes = exports.allOrganizationTypes = function allOrganizationTypes(state) {
	  return state.organizationType.organizationTypes;
	};
	
	var paginatedClientGroups = exports.paginatedClientGroups = function paginatedClientGroups(state) {
	  return {
	    items: state.clientGroup.items,
	    pagination: state.clientGroup.pagination
	  };
	};
	
	var allClientGroups = exports.allClientGroups = function allClientGroups(state) {
	  return {
	    all: state.clientGroup.all
	  };
	};
	
	var allClientTypes = exports.allClientTypes = function allClientTypes(state) {
	  return state.clientTypes.all;
	};
	
	var clientGroupItem = exports.clientGroupItem = function clientGroupItem(state) {
	  return state.clientGroup.item;
	};
	
	var addressTypes = exports.addressTypes = function addressTypes(state) {
	  return state.addressTypes.addressTypes;
	};
	var contactTypes = exports.contactTypes = function contactTypes(state) {
	  return state.contactTypes.contactTypes;
	};
	
	var currentClientContacts = exports.currentClientContacts = function currentClientContacts(state) {
	  return state.client.clientContacts;
	};
	
	var currentClientAddresses = exports.currentClientAddresses = function currentClientAddresses(state) {
	  return state.client.clientAddresses;
	};
	
	var allProviderGroups = exports.allProviderGroups = function allProviderGroups(state) {
	  return {
	    all: state.providerGroup.all
	  };
	};
	
	var setDownloadProviderList = exports.setDownloadProviderList = function setDownloadProviderList(state) {
	  return {
	    downloadExportList: state.providerGroup.downloadExportList
	  };
	};
	
	var setClientProvider = exports.setClientProvider = function setClientProvider(state) {
	  return {
	    clientProvider: state.providerGroup.clientProvider
	  };
	};
	
	var paginatedMaterials = exports.paginatedMaterials = function paginatedMaterials(state) {
	  return {
	    items: state.material.items,
	    pagination: state.material.pagination
	  };
	};
	var allMaterials = exports.allMaterials = function allMaterials(state) {
	  return state.material.all;
	};
	var materialQuery = exports.materialQuery = function materialQuery(state) {
	  return state.material.query;
	};
	
	var allMaterialTypes = exports.allMaterialTypes = function allMaterialTypes(state) {
	  return state.materialType.all;
	};
	
	var paginatedBatches = exports.paginatedBatches = function paginatedBatches(state) {
	  return {
	    items: state.batch.items,
	    pagination: state.batch.pagination
	  };
	};
	var allBatches = exports.allBatches = function allBatches(state) {
	  return state.batch.all;
	};
	var batchQuery = exports.batchQuery = function batchQuery(state) {
	  return state.batch.query;
	};
	
	var paginatedBatchLogs = exports.paginatedBatchLogs = function paginatedBatchLogs(state) {
	  return {
	    items: state.batchLog.items,
	    pagination: state.batchLog.pagination
	  };
	};
	var allBatchLogs = exports.allBatchLogs = function allBatchLogs(state) {
	  return state.batchLog.all;
	};
	var batchLogQuery = exports.batchLogQuery = function batchLogQuery(state) {
	  return state.batchLog.query;
	};
	
	var paginatedRecipes = exports.paginatedRecipes = function paginatedRecipes(state) {
	  return {
	    items: state.recipe.items,
	    pagination: state.recipe.pagination
	  };
	};
	var allRecipes = exports.allRecipes = function allRecipes(state) {
	  return state.recipe.all;
	};
	var recipeQuery = exports.recipeQuery = function recipeQuery(state) {
	  return state.recipe.query;
	};
	
	var allRecipeTypes = exports.allRecipeTypes = function allRecipeTypes(state) {
	  return state.recipeType.all;
	};
	
	var allRecipeIngrediences = exports.allRecipeIngrediences = function allRecipeIngrediences(state) {
	  return state.recipeIngredience.all;
	};
	
	var allBatchIngrediences = exports.allBatchIngrediences = function allBatchIngrediences(state) {
	  return state.batchIngredience.all;
	};
	
	var allRecipeProcedures = exports.allRecipeProcedures = function allRecipeProcedures(state) {
	  return state.recipeProcedure.all;
	};
	
	var allRecipeProducts = exports.allRecipeProducts = function allRecipeProducts(state) {
	  return state.recipeProduct.all;
	};
	
	var paginatedEquipments = exports.paginatedEquipments = function paginatedEquipments(state) {
	  return {
	    items: state.equipment.items,
	    pagination: state.equipment.pagination
	  };
	};
	var allEquipments = exports.allEquipments = function allEquipments(state) {
	  return state.equipment.all;
	};
	var equipmentQuery = exports.equipmentQuery = function equipmentQuery(state) {
	  return state.equipment.query;
	};
	
	var paginatedProducts = exports.paginatedProducts = function paginatedProducts(state) {
	  return {
	    items: state.product.items,
	    pagination: state.product.pagination
	  };
	};
	
	var allProducts = exports.allProducts = function allProducts(state) {
	  return state.product.all;
	};
	var basicProducts = exports.basicProducts = function basicProducts(state) {
	  return state.product.basic;
	};
	var allProductTransactions = exports.allProductTransactions = function allProductTransactions(state) {
	  return state.product.transactions;
	};
	var allProductTransactionsV2 = exports.allProductTransactionsV2 = function allProductTransactionsV2(state) {
	  return state.product.transactionsV2;
	};
	var productTransactionsV2 = exports.productTransactionsV2 = function productTransactionsV2(state) {
	  return {
	    items: state.product.paginateTransactionsV2.items,
	    pagination: state.product.paginateTransactionsV2.pagination
	  };
	};
	
	var allProductPrices = exports.allProductPrices = function allProductPrices(state) {
	  return state.product.productPrices;
	};
	
	var productQuery = exports.productQuery = function productQuery(state) {
	  return state.product.query;
	};
	var productGrouping = exports.productGrouping = function productGrouping(state) {
	  return state.product.query.grouping;
	};
	
	var paginatedProductGroups = exports.paginatedProductGroups = function paginatedProductGroups(state) {
	  return {
	    items: state.productGroup.items,
	    pagination: state.productGroup.pagination
	  };
	};
	
	var allProductGroups = exports.allProductGroups = function allProductGroups(state) {
	  return {
	    all: state.productGroup.all
	  };
	};
	
	var paginatedProductPackagings = exports.paginatedProductPackagings = function paginatedProductPackagings(state) {
	  return {
	    items: state.productPackaging.items,
	    pagination: state.productPackaging.pagination
	  };
	};
	
	var allProductPackagings = exports.allProductPackagings = function allProductPackagings(state) {
	  return {
	    all: state.productPackaging.all
	  };
	};
	
	var allPackagingMaterials = exports.allPackagingMaterials = function allPackagingMaterials(state) {
	  return {
	    all: state.packagingMaterial.all
	  };
	};
	
	var allPackagingTypes = exports.allPackagingTypes = function allPackagingTypes(state) {
	  return {
	    all: state.packagingType.all
	  };
	};
	
	var allUnitTypes = exports.allUnitTypes = function allUnitTypes(state) {
	  return {
	    all: state.unitType.all
	  };
	};
	
	var paginatedProductTags = exports.paginatedProductTags = function paginatedProductTags(state) {
	  return {
	    items: state.productTag.items,
	    pagination: state.productTag.pagination
	  };
	};
	
	var allProductTags = exports.allProductTags = function allProductTags(state) {
	  return {
	    all: state.productTag.all
	  };
	};
	
	var paginatedPriceFields = exports.paginatedPriceFields = function paginatedPriceFields(state) {
	  return {
	    items: state.priceField.items,
	    pagination: state.priceField.pagination
	  };
	};
	
	var allPriceFields = exports.allPriceFields = function allPriceFields(state) {
	  return {
	    all: state.priceField.all
	  };
	};
	
	var allProductTypes = exports.allProductTypes = function allProductTypes(state) {
	  return state.productType.all;
	};
	
	var allProductSubtypes = exports.allProductSubtypes = function allProductSubtypes(state) {
	  return state.productSubtype.all;
	};
	
	var allProductRecommendations = exports.allProductRecommendations = function allProductRecommendations(state) {
	  return state.productRecommendation.all;
	};
	
	var allProducers = exports.allProducers = function allProducers(state) {
	  return state.producer.all;
	};
	
	var allCountries = exports.allCountries = function allCountries(state) {
	  return {
	    items: state.country.all,
	    pagination: state.country.pagination
	  };
	};
	
	var availableWidgets = exports.availableWidgets = function availableWidgets(state) {
	  return {
	    items: state.profile.availableWidgets
	  };
	};
	
	var widgets = exports.widgets = function widgets(state) {
	  return {
	    items: state.profile.userWidgets
	  };
	};
	
	var bestClientsWidgets = exports.bestClientsWidgets = function bestClientsWidgets(state) {
	  return {
	    items: state.profile.bestClientsWidgets
	  };
	};
	
	var waitingProcessedWidgets = exports.waitingProcessedWidgets = function waitingProcessedWidgets(state) {
	  return {
	    items: state.profile.waitingProcessedWidgets
	  };
	};
	
	var waitingDeliveredWidgets = exports.waitingDeliveredWidgets = function waitingDeliveredWidgets(state) {
	  return {
	    items: state.profile.waitingDeliveredWidgets
	  };
	};
	
	var orderReceivedWidgets = exports.orderReceivedWidgets = function orderReceivedWidgets(state) {
	  return {
	    items: state.profile.orderReceivedWidgets
	  };
	};
	
	var revenueWidgets = exports.revenueWidgets = function revenueWidgets(state) {
	  return {
	    items: state.profile.revenueWidgets
	  };
	};
	
	var popularProductsWidgets = exports.popularProductsWidgets = function popularProductsWidgets(state) {
	  return {
	    items: state.profile.popularProductsWidgets
	  };
	};
	
	var soldProductsWidgets = exports.soldProductsWidgets = function soldProductsWidgets(state) {
	  return {
	    items: state.profile.soldProductsWidgets
	  };
	};
	
	var allLanguages = exports.allLanguages = function allLanguages(state) {
	  return {
	    items: state.siteLanguages.all
	  };
	};
	
	var allCities = exports.allCities = function allCities(state) {
	  return {
	    items: state.city.all,
	    pagination: state.city.pagination
	  };
	};
	
	var allMunicipalities = exports.allMunicipalities = function allMunicipalities(state) {
	  return {
	    items: state.municipality.all,
	    pagination: state.municipality.pagination
	  };
	};
	
	var allPostals = exports.allPostals = function allPostals(state) {
	  return {
	    items: state.postal.all,
	    pagination: state.postal.pagination
	  };
	};
	
	var businessDays = exports.businessDays = function businessDays(state) {
	  return state.businessDay.all;
	};
	
	var allTaxes = exports.allTaxes = function allTaxes(state) {
	  return {
	    all: state.tax.all,
	    pagination: state.tax.pagination
	  };
	};
	
	var allProductDeposits = exports.allProductDeposits = function allProductDeposits(state) {
	  return {
	    all: state.productDeposit.all
	  };
	};
	
	var allDepositSystems = exports.allDepositSystems = function allDepositSystems(state) {
	  return {
	    all: state.depositSystem.all
	  };
	};
	
	var paginatedOrders = exports.paginatedOrders = function paginatedOrders(state) {
	  return {
	    items: state.order.items,
	    pagination: state.order.pagination
	  };
	};
	
	var allOrders = exports.allOrders = function allOrders(state) {
	  return {
	    all: state.order.all
	  };
	};
	
	var orderQuery = exports.orderQuery = function orderQuery(state) {
	  return state.order.query;
	};
	
	var currentOrder = exports.currentOrder = function currentOrder(state) {
	  return state.order.currentOrder;
	};
	var orderEvents = exports.orderEvents = function orderEvents(state) {
	  return state.order.events;
	};
	
	var orderTypes = exports.orderTypes = function orderTypes(state) {
	  return state.order.types;
	};
	
	var paginatedBills = exports.paginatedBills = function paginatedBills(state) {
	  return {
	    items: state.bill.items,
	    pagination: state.bill.pagination
	  };
	};
	var billStatuses = exports.billStatuses = function billStatuses(state) {
	  return state.bill.statuses;
	};
	var billTypes = exports.billTypes = function billTypes(state) {
	  return state.bill.types;
	};
	var currentBill = exports.currentBill = function currentBill(state) {
	  return state.bill.currentBill;
	};
	var billQuery = exports.billQuery = function billQuery(state) {
	  return state.bill.query;
	};
	
	var allCreditNoteReasons = exports.allCreditNoteReasons = function allCreditNoteReasons(state) {
	  return state.creditNoteReason.all;
	};
	var currentCreditNoteReason = exports.currentCreditNoteReason = function currentCreditNoteReason(state) {
	  return state.creditNoteReason.current;
	};
	
	var allOrderProducts = exports.allOrderProducts = function allOrderProducts(state) {
	  return state.orderProduct.all;
	};
	
	var allBillProducts = exports.allBillProducts = function allBillProducts(state) {
	  return state.billProduct.all;
	};
	var allCreditNoteProducts = exports.allCreditNoteProducts = function allCreditNoteProducts(state) {
	  return state.creditNoteProduct.all;
	};
	
	exports.default = allClients;
	var paginatedEdiOrders = exports.paginatedEdiOrders = function paginatedEdiOrders(state) {
	  return {
	    items: state.ediOrder.items,
	    pagination: state.ediOrder.pagination
	  };
	};
	
	var allEdiOrders = exports.allEdiOrders = function allEdiOrders(state) {
	  return {
	    all: state.ediOrder.all
	  };
	};
	
	var currentEdiOrder = exports.currentEdiOrder = function currentEdiOrder(state) {
	  return state.ediOrder.currentEdiOrder;
	};
	
	var allEdiOrderItems = exports.allEdiOrderItems = function allEdiOrderItems(state) {
	  return state.ediOrderItem.all;
	};
	
	var allMessageTemplateTypes = exports.allMessageTemplateTypes = function allMessageTemplateTypes(state) {
	  return state.messageTemplateType.types;
	};
	
	var allAccountingProviders = exports.allAccountingProviders = function allAccountingProviders(state) {
	  return state.accountingProvider.all;
	};
	
	var allChartOfAccounts = exports.allChartOfAccounts = function allChartOfAccounts(state) {
	  return {
	    all: state.chartOfAccounts.all
	  };
	};
	
	var paginatedCampaigns = exports.paginatedCampaigns = function paginatedCampaigns(state) {
	  return {
	    items: state.campaign.items,
	    pagination: state.campaign.pagination
	  };
	};
	var campaignTypes = exports.campaignTypes = function campaignTypes(state) {
	  return state.campaign.types;
	};
	
	var innerSidebar = exports.innerSidebar = function innerSidebar(state) {
	  return state.sidebar.innerSidebar;
	};
	var innerSidebarState = exports.innerSidebarState = function innerSidebarState(state) {
	  return state.sidebar.innerSidebarState;
	};
	var innerSidebarDisabled = exports.innerSidebarDisabled = function innerSidebarDisabled(state) {
	  return state.sidebar.innerSidebarDisabled;
	};
	
	var modalState = exports.modalState = function modalState(state) {
	  return state.modal.modalState;
	};
	var modalContent = exports.modalContent = function modalContent(state) {
	  return state.modal.modalContent;
	};
	var modalSize = exports.modalSize = function modalSize(state) {
	  return state.modal.modalSize;
	};
	var modalClass = exports.modalClass = function modalClass(state) {
	  return state.modal.modalClass;
	};
	var modalCloseOnClick = exports.modalCloseOnClick = function modalCloseOnClick(state) {
	  return state.modal.modalCloseOnClick;
	};
	var modalShowClose = exports.modalShowClose = function modalShowClose(state) {
	  return state.modal.modalShowClose;
	};
	var modalCloseOnPressEscape = exports.modalCloseOnPressEscape = function modalCloseOnPressEscape(state) {
	  return state.modal.modalCloseOnPressEscape;
	};
	var modalProps = exports.modalProps = function modalProps(state) {
	  return state.modal.modalProps;
	};
	var modalButtonLoading = exports.modalButtonLoading = function modalButtonLoading(state) {
	  return state.modal.modalButtonLoading;
	};
	
	var allSuppliers = exports.allSuppliers = function allSuppliers(state) {
	  return {
	    items: state.supplier.all,
	    pagination: state.supplier.paginations
	  };
	};
	var paginateSuppliers = exports.paginateSuppliers = function paginateSuppliers(state) {
	  return {
	    items: state.supplier.items,
	    pagination: state.supplier.pagination
	  };
	};
	var currentSupplier = exports.currentSupplier = function currentSupplier(state) {
	  return state.supplier.currentSupplier;
	};
	
	var allWarehouses = exports.allWarehouses = function allWarehouses(state) {
	  return {
	    items: state.warehouse.all,
	    pagination: state.warehouse.paginations
	  };
	};
	var paginateWarehouses = exports.paginateWarehouses = function paginateWarehouses(state) {
	  return {
	    items: state.warehouse.items,
	    pagination: state.warehouse.pagination
	  };
	};
	var currentWarehouse = exports.currentWarehouse = function currentWarehouse(state) {
	  return state.warehouse.currentWarehouse;
	};
	var paginateWarehouseProducts = exports.paginateWarehouseProducts = function paginateWarehouseProducts(state) {
	  return {
	    items: state.warehouse.products.items,
	    pagination: state.warehouse.products.pagination
	  };
	};
	var allWarehouseTransactions = exports.allWarehouseTransactions = function allWarehouseTransactions(state) {
	  return state.warehouse.transactions;
	};
	
	var allWarehouseTransactionsV2 = exports.allWarehouseTransactionsV2 = function allWarehouseTransactionsV2(state) {
	  return state.warehouse.transactionsV2All;
	};
	var paginateWarehouseTransactionsV2 = exports.paginateWarehouseTransactionsV2 = function paginateWarehouseTransactionsV2(state) {
	  return {
	    items: state.warehouse.transactionsV2.items,
	    pagination: state.warehouse.transactionsV2.pagination
	  };
	};
	
	var allUnitOfMeasures = exports.allUnitOfMeasures = function allUnitOfMeasures(state) {
	  return {
	    items: state.unitOfMeasure.all
	  };
	};
	var paginateUnitOfMeasures = exports.paginateUnitOfMeasures = function paginateUnitOfMeasures(state) {
	  return {
	    items: state.unitOfMeasure.items,
	    pagination: state.unitOfMeasure.pagination
	  };
	};
	var currentUnitOfMeasure = exports.currentUnitOfMeasure = function currentUnitOfMeasure(state) {
	  return state.unitOfMeasure.currentUnitOfMeasure;
	};
	
	var allStocks = exports.allStocks = function allStocks(state) {
	  return {
	    items: state.stock.all,
	    pagination: state.stock.paginations
	  };
	};
	var paginateStocks = exports.paginateStocks = function paginateStocks(state) {
	  return {
	    items: state.stock.items,
	    pagination: state.stock.pagination
	  };
	};
	var currentStock = exports.currentStock = function currentStock(state) {
	  return state.stock.currentStock;
	};
	var currentStockProducts = exports.currentStockProducts = function currentStockProducts(state) {
	  return state.stock.stockProducts;
	};
	var currentSelectedWarehouse = exports.currentSelectedWarehouse = function currentSelectedWarehouse(state) {
	  return state.stock.warehouseId;
	};
	var currentStockProductsCustom = exports.currentStockProductsCustom = function currentStockProductsCustom(state) {
	  return state.stock.stockProductsCustom;
	};
	
	var allAdjustments = exports.allAdjustments = function allAdjustments(state) {
	  return {
	    items: state.adjustment.all,
	    pagination: state.adjustment.paginations
	  };
	};
	var paginateAdjustments = exports.paginateAdjustments = function paginateAdjustments(state) {
	  return {
	    items: state.adjustment.items,
	    pagination: state.adjustment.pagination
	  };
	};
	var currentAdjustment = exports.currentAdjustment = function currentAdjustment(state) {
	  return state.adjustment.currentAdjustment;
	};
	
	var allPurchases = exports.allPurchases = function allPurchases(state) {
	  return {
	    items: state.purchase.all,
	    pagination: state.purchase.paginations
	  };
	};
	var paginatePurchases = exports.paginatePurchases = function paginatePurchases(state) {
	  return {
	    items: state.purchase.items,
	    pagination: state.purchase.pagination
	  };
	};
	var currentPurchase = exports.currentPurchase = function currentPurchase(state) {
	  return state.purchase.currentPurchase;
	};
	var purchaseStatuses = exports.purchaseStatuses = function purchaseStatuses(state) {
	  return state.purchase.statuses;
	};
	
	var getView = exports.getView = function getView(state) {
	  return state.view.view;
	};
	var getOrderViewType = exports.getOrderViewType = function getOrderViewType(state) {
	  return state.view.orderViewType;
	};
	
	var allShippingProviders = exports.allShippingProviders = function allShippingProviders(state) {
	  return state.shippingProvider.all;
	};
	var currentShippingProvider = exports.currentShippingProvider = function currentShippingProvider(state) {
	  return state.shippingProvider.currentshippingProvider;
	};
	
	var allproductFlows = exports.allproductFlows = function allproductFlows(state) {
	  return {
	    items: state.productFlow.all,
	    pagination: state.productFlow.paginations
	  };
	};
	var paginateproductFlows = exports.paginateproductFlows = function paginateproductFlows(state) {
	  return {
	    items: state.productFlow.items,
	    pagination: state.productFlow.pagination
	  };
	};
	
	var currentproductFlow = exports.currentproductFlow = function currentproductFlow(state) {
	  return state.productFlow.currentproductFlow;
	};
	var allproductFlowOrders = exports.allproductFlowOrders = function allproductFlowOrders(state) {
	  return state.productFlow.orders;
	};
	
	var allExciseGroups = exports.allExciseGroups = function allExciseGroups(state) {
	  return state.exciseGroup.all;
	};
	var allExcisePackagingGroups = exports.allExcisePackagingGroups = function allExcisePackagingGroups(state) {
	  return state.exciseGroup.packaging;
	};
	var allExciseBasicGroups = exports.allExciseBasicGroups = function allExciseBasicGroups(state) {
	  return state.exciseGroup.basic;
	};
	var allAdditionalCode = exports.allAdditionalCode = function allAdditionalCode(state) {
	  return state.additionalCode.all;
	};
	
	var allOrganizationMembers = exports.allOrganizationMembers = function allOrganizationMembers(state) {
	  return state.organizationMember.all;
	};
	var allOrganizationMemberProductBusinessHours = exports.allOrganizationMemberProductBusinessHours = function allOrganizationMemberProductBusinessHours(state) {
	  return state.organizationMemberProductBusinesshour.all;
	};
	var allOrganizationMemberBookings = exports.allOrganizationMemberBookings = function allOrganizationMemberBookings(state) {
	  return state.organizationMemberBooking.all;
	};
	
	var allModules = exports.allModules = function allModules(state) {
	  return state.modules.all;
	};
	var allTransactionTypes = exports.allTransactionTypes = function allTransactionTypes(state) {
	  return state.transactionType.transactionTypes;
	};
	
	var allTransfers = exports.allTransfers = function allTransfers(state) {
	  return {
	    items: state.transfer.all,
	    pagination: state.transfer.paginations
	  };
	};
	var paginateTransfers = exports.paginateTransfers = function paginateTransfers(state) {
	  return {
	    items: state.transfer.items,
	    pagination: state.transfer.pagination
	  };
	};
	var currentTransfer = exports.currentTransfer = function currentTransfer(state) {
	  return state.transfer.currentTransfer;
	};
	
	var allLicenses = exports.allLicenses = function allLicenses(state) {
	  return state.license.all;
	};
	var allLicenseTypes = exports.allLicenseTypes = function allLicenseTypes(state) {
	  return state.licenseType.all;
	};
	var allLicensePermits = exports.allLicensePermits = function allLicensePermits(state) {
	  return state.licensePermit.all;
	};
	var allLicenseGroups = exports.allLicenseGroups = function allLicenseGroups(state) {
	  return state.licenseGroup.all;
	};
	var allLicensePermitGroups = exports.allLicensePermitGroups = function allLicensePermitGroups(state) {
	  return state.licensePermitGroup.all;
	};
	var allLicensePermitTypes = exports.allLicensePermitTypes = function allLicensePermitTypes(state) {
	  return state.licensePermitType.all;
	};
	
	var paginatedExcisePeriods = exports.paginatedExcisePeriods = function paginatedExcisePeriods(state) {
	  return {
	    items: state.excisePeriod.items,
	    pagination: state.excisePeriod.pagination
	  };
	};
	
	var allExcisePeriods = exports.allExcisePeriods = function allExcisePeriods(state) {
	  return {
	    all: state.excisePeriod.all
	  };
	};
	
	var allSubscriberList = exports.allSubscriberList = function allSubscriberList(state) {
	  return {
	    items: state.subscriberList.all
	  };
	};
	var paginatedSubscriberList = exports.paginatedSubscriberList = function paginatedSubscriberList(state) {
	  return {
	    items: state.subscriberList.items,
	    pagination: state.subscriberList.pagination
	  };
	};
	
	var subscriberList = exports.subscriberList = function subscriberList(state) {
	  return {
	    current: state.subscriberList.current
	  };
	};
	var modifiedClientGroup = exports.modifiedClientGroup = function modifiedClientGroup(state) {
	  return {
	    items: state.subscriberList.modifiedClientGroup
	  };
	};
	var cancelClientGroupAdd = exports.cancelClientGroupAdd = function cancelClientGroupAdd(state) {
	  return {
	    items: state.subscriberList.cancelClientGroupAdd
	  };
	};
	
	var subscriber = exports.subscriber = function subscriber(state) {
	  return {
	    items: state.subscriber.all
	  };
	};
	var paginatedSubscriber = exports.paginatedSubscriber = function paginatedSubscriber(state) {
	  return {
	    items: state.subscriber.items,
	    pagination: state.subscriber.pagination
	  };
	};
	var allPackageUnitTypes = exports.allPackageUnitTypes = function allPackageUnitTypes(state) {
	  return {
	    all: state.packageUnitType.all
	  };
	};
	
	var deliveryPackages = exports.deliveryPackages = function deliveryPackages(state) {
	  return {
	    all: state.pckg.all
	  };
	};
	
	var allPackageOrderProducts = exports.allPackageOrderProducts = function allPackageOrderProducts(state) {
	  return {
	    all: state.packageOrderProduct.all
	  };
	};
	
	var toastResp = exports.toastResp = function toastResp(state) {
	  return {
	    items: state.profile.userAppToast.data
	  };
	};
	
	var latestAppVersion = exports.latestAppVersion = function latestAppVersion(state) {
	  return {
	    items: state.profile.userAppVersion.data
	  };
	};
	
	var allPartners = exports.allPartners = function allPartners(state) {
	  return state.partner.all;
	};
	
	var paginatedOrderPickups = exports.paginatedOrderPickups = function paginatedOrderPickups(state) {
	  return {
	    items: state.orderPickup.items,
	    pagination: state.orderPickup.pagination
	  };
	};
	
	var allOrderPickups = exports.allOrderPickups = function allOrderPickups(state) {
	  return {
	    all: state.orderPickup.all
	  };
	};
	
	var orderPickupQuery = exports.orderPickupQuery = function orderPickupQuery(state) {
	  return state.orderPickup.query;
	};
	
	var currentOrderPickup = exports.currentOrderPickup = function currentOrderPickup(state) {
	  return state.orderPickup.currentOrderPickup;
	};
	var orderPickupEvents = exports.orderPickupEvents = function orderPickupEvents(state) {
	  return state.orderPickup.events;
	};
	
	var orderPickupTypes = exports.orderPickupTypes = function orderPickupTypes(state) {
	  return state.orderPickup.types;
	};
	
	var paymentMethods = exports.paymentMethods = function paymentMethods(state) {
	  return state.paymentMethods.paymentMethods;
	};
	
	var languages = exports.languages = function languages(state) {
	  return {
	    all: state.language.all
	  };
	};
	
	var currencies = exports.currencies = function currencies(state) {
	  return {
	    all: state.currency.all
	  };
	};
	
	var projects = exports.projects = function projects(state) {
	  return {
	    items: state.project.items,
	    pagination: state.project.pagination
	  };
	};
	var allProjects = exports.allProjects = function allProjects(state) {
	  return state.project.all;
	};
	
	var bridgeHandoff = exports.bridgeHandoff = function bridgeHandoff(state) {
	  return state.bridgeHandoff.state;
	};
	var stockMutationsHandedOff = exports.stockMutationsHandedOff = function stockMutationsHandedOff(state) {
	  return !!(state.bridgeHandoff.state && state.bridgeHandoff.state.stock_mutations_handed_off);
	};
	var stockDecommissioned = exports.stockDecommissioned = function stockDecommissioned(state) {
	  return !!(state.bridgeHandoff.state && state.bridgeHandoff.state.stock_decommissioned);
	};
	var inventoryAppUrl = exports.inventoryAppUrl = function inventoryAppUrl(state) {
	  return state.bridgeHandoff.state && state.bridgeHandoff.state.inventory_app_url || '';
	};

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1378);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1377);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_ACCOUNTING_PROVIDERS, function (state, types) {
	  state.all = types;
	});

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1381);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1380);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ADDITIONAL_CODE, function (state, _ref) {
	  var exciseAdditionals = _ref.exciseAdditionals;
	
	  state.all = exciseAdditionals;
	});

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1384);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1383);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ADDRESS_TYPES, function (state, addressTypes) {
	  state.addressTypes = addressTypes;
	});

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  addressTypes: []
	};

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1387);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1386);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_ADJUSTMENT;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_ADJUSTMENT = {}, _defineProperty(_FETCH_ALL_ADJUSTMENT, _mutationTypes.FETCH_ALL_ADJUSTMENTS, function (state, adjustments) {
	  state.all = adjustments;
	}), _defineProperty(_FETCH_ALL_ADJUSTMENT, _mutationTypes.FETCH_PAGINATE_ADJUSTMENTS, function (state, _ref) {
	  var adjustments = _ref.adjustments,
	      pagination = _ref.pagination;
	
	  state.items = adjustments;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_ALL_ADJUSTMENT, _mutationTypes.FETCH_CURRENT_ADJUSTMENT, function (state, adjustment) {
	  state.currentAdjustment = adjustment;
	}), _FETCH_ALL_ADJUSTMENT);

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  currentAdjustment: [],
	  stockProducts: []
	};

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1390);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1389);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CHECK_AUTHENTICATION;
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mutationTypes = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_CHECK_AUTHENTICATION = {}, _defineProperty(_CHECK_AUTHENTICATION, _mutationTypes.CHECK_AUTHENTICATION, function (state) {
	  state.authenticated = !!localStorage.getItem('id_token');
	}), _defineProperty(_CHECK_AUTHENTICATION, _mutationTypes.LOGIN, function (state, token) {
	  state.authenticated = true;
	  localStorage.setItem('id_token', token);
	
	  if (localStorage.getItem('id_token_save')) {
	    localStorage.removeItem('id_token_save');
	  }
	
	  if (localStorage.getItem('user_id')) {
	    localStorage.removeItem('user_id');
	  }
	
	  if (localStorage.getItem('verification_type')) {
	    localStorage.removeItem('verification_type');
	  }
	
	  if (localStorage.getItem('mobile_number')) {
	    localStorage.removeItem('mobile_number');
	  }
	
	  _vue2.default.$http.defaults.headers.common.Authorization = 'Bearer ' + token;
	}), _defineProperty(_CHECK_AUTHENTICATION, _mutationTypes.LOGOUT, function (state) {
	  state.authenticated = false;
	  localStorage.removeItem('id_token');
	
	  if (localStorage.getItem('is_admin')) {
	    localStorage.removeItem('is_admin');
	  }
	
	  _vue2.default.$http.defaults.headers.common.Authorization = '';
	}), _defineProperty(_CHECK_AUTHENTICATION, _mutationTypes.UPDATE_REFRESHING, function (state, value) {
	  state.refreshing = value;
	}), _defineProperty(_CHECK_AUTHENTICATION, _mutationTypes.SET_MAINTENANCE_MODE, function (state, status) {
	  state.maintenance = status;
	}), _defineProperty(_CHECK_AUTHENTICATION, _mutationTypes.TWO_FACTOR_VERIFICATION, function (state, _ref) {
	  var token = _ref.token,
	      userId = _ref.userId,
	      verificationType = _ref.verificationType,
	      mobileNumber = _ref.mobileNumber;
	
	  state.twoFactorVerification = verificationType;
	  localStorage.setItem('id_token_saved', token);
	  localStorage.setItem('verification_type', verificationType);
	  localStorage.setItem('user_id', userId);
	  localStorage.setItem('mobile_number', mobileNumber);
	}), _defineProperty(_CHECK_AUTHENTICATION, _mutationTypes.CHECK_TWO_FACTOR_VERIFICATION, function (state) {
	  state.twoFactorVerification = localStorage.getItem('verification_type');
	}), _CHECK_AUTHENTICATION);

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  maintenance: false,
	  authenticated: false,
	  refreshing: false,
	  twoFactorVerification: false
	};

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1393);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1392);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_BATC;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_BATC = {}, _defineProperty(_FETCH_PAGINATED_BATC, _mutationTypes.FETCH_PAGINATED_BATCHES, function (state, _ref) {
	  var batches = _ref.batches,
	      pagination = _ref.pagination;
	
	  state.items = batches;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_BATC, _mutationTypes.FETCH_ALL_BATCHES, function (state, batch) {
	  state.all = batch;
	}), _defineProperty(_FETCH_PAGINATED_BATC, _mutationTypes.ADD_BATCH, function (state, batch) {
	  state.all.push(batch);
	}), _defineProperty(_FETCH_PAGINATED_BATC, _mutationTypes.BATCH_QUERY, function (state, _ref2) {
	  var page = _ref2.page,
	      limit = _ref2.limit,
	      search = _ref2.search;
	
	  state.query.page = page;
	  state.query.limit = limit;
	  state.query.search = search;
	  state.query.isSet = true;
	}), _FETCH_PAGINATED_BATC);

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  query: {
	    page: 1,
	    limit: 50,
	    search: '',
	    isSet: false
	  }
	};

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1396);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1395);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RESET_BATCH_INGREDIE;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_RESET_BATCH_INGREDIE = {}, _defineProperty(_RESET_BATCH_INGREDIE, _mutationTypes.RESET_BATCH_INGREDIENCES, function (state) {
	  state.all = [];
	}), _defineProperty(_RESET_BATCH_INGREDIE, _mutationTypes.FETCH_ALL_BATCH_INGREDIENCES, function (state, batchIngrediences) {
	  state.all = batchIngrediences;
	}), _defineProperty(_RESET_BATCH_INGREDIE, _mutationTypes.REMOVE_BATCH_INGREDIENCE, function (state, id) {
	  state.all = state.all.filter(function (p) {
	    return p.id !== id;
	  });
	}), _defineProperty(_RESET_BATCH_INGREDIE, _mutationTypes.ADD_BATCH_INGREDIENCE, function (state, batchIngredience) {
	  state.all.push(batchIngredience);
	}), _defineProperty(_RESET_BATCH_INGREDIE, _mutationTypes.UPDATE_BATCH_INGREDIENCE, function (state, _ref) {
	  var batchIngredience = _ref.batchIngredience,
	      id = _ref.id;
	
	  state.all.map(function (p) {
	    if (p.id.toString() === id.toString()) {
	      Object.keys(batchIngredience).map(function (k) {
	        p[k] = batchIngredience[k];
	        return k;
	      });
	    }
	    return p;
	  });
	}), _RESET_BATCH_INGREDIE);

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1399);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1398);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_BATC;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_BATC = {}, _defineProperty(_FETCH_PAGINATED_BATC, _mutationTypes.FETCH_PAGINATED_BATCH_LOGS, function (state, _ref) {
	  var batchLogs = _ref.batchLogs,
	      pagination = _ref.pagination;
	
	  state.items = batchLogs;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_BATC, _mutationTypes.FETCH_ALL_BATCH_LOGS, function (state, batchLogs) {
	  state.all = batchLogs;
	}), _defineProperty(_FETCH_PAGINATED_BATC, _mutationTypes.BATCH_LOG_QUERY, function (state, _ref2) {
	  var page = _ref2.page,
	      limit = _ref2.limit,
	      search = _ref2.search;
	
	  state.query.page = page;
	  state.query.limit = limit;
	  state.query.search = search;
	  state.query.isSet = true;
	}), _FETCH_PAGINATED_BATC);

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  query: {
	    page: 1,
	    limit: 50,
	    search: '',
	    isSet: false
	  }
	};

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1402);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1401);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_BILL;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_BILL = {}, _defineProperty(_FETCH_PAGINATED_BILL, _mutationTypes.FETCH_PAGINATED_BILLS, function (state, _ref) {
	  var bills = _ref.bills,
	      pagination = _ref.pagination;
	
	  state.items = bills;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_BILL, _mutationTypes.FETCH_BILL_STATUSES, function (state, statuses) {
	  state.statuses = statuses;
	}), _defineProperty(_FETCH_PAGINATED_BILL, _mutationTypes.FETCH_BILL_TYPES, function (state, statuses) {
	  state.types = statuses;
	}), _defineProperty(_FETCH_PAGINATED_BILL, _mutationTypes.RESET_BILLS, function (state) {
	  state.all = [];
	  state.items = [];
	  state.pagination = {};
	  state.currentBill = {};
	}), _defineProperty(_FETCH_PAGINATED_BILL, _mutationTypes.FETCH_CURRENT_BILL, function (state, bill) {
	  state.currentBill = bill;
	}), _defineProperty(_FETCH_PAGINATED_BILL, _mutationTypes.BILL_QUERY, function (state, _ref2) {
	  var page = _ref2.page,
	      limit = _ref2.limit,
	      search = _ref2.search;
	
	  state.query.page = page;
	  state.query.limit = limit;
	  state.query.search = search;
	  state.query.isSet = true;
	}), _FETCH_PAGINATED_BILL);

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  currentBill: {},
	  statuses: [],
	  types: [],
	  query: {
	    page: 1,
	    limit: 50,
	    search: '',
	    isSet: false
	  }
	};

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1405);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1404);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RESET_BILL_PRODUCTS$;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_RESET_BILL_PRODUCTS$ = {}, _defineProperty(_RESET_BILL_PRODUCTS$, _mutationTypes.RESET_BILL_PRODUCTS, function (state) {
	  state.all = [];
	}), _defineProperty(_RESET_BILL_PRODUCTS$, _mutationTypes.FETCH_ALL_BILL_PRODUCTS, function (state, billProducts) {
	  state.all = billProducts;
	}), _defineProperty(_RESET_BILL_PRODUCTS$, _mutationTypes.REMOVE_BILL_PRODUCT, function (state, id) {
	  state.all = state.all.filter(function (p) {
	    return p.id !== id;
	  });
	}), _defineProperty(_RESET_BILL_PRODUCTS$, _mutationTypes.ADD_BILL_PRODUCT, function (state, billProduct) {
	  state.all.push(billProduct);
	}), _defineProperty(_RESET_BILL_PRODUCTS$, _mutationTypes.UPDATE_BILL_PRODUCT, function (state, _ref) {
	  var billProduct = _ref.billProduct,
	      id = _ref.id;
	
	  state.all.map(function (p) {
	    if (p.id.toString() === id.toString()) {
	      Object.keys(billProduct).map(function (k) {
	        p[k] = billProduct[k];
	        return k;
	      });
	    }
	    return p;
	  });
	}), _RESET_BILL_PRODUCTS$);

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1408);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1407);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.SET_BRIDGE_HANDOFF, function (state, payload) {
	  state.state = payload;
	});

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  state: null
	};

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1411);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1410);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_BUSINESS_DAYS, function (state, days) {
	  state.all = days;
	});

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1414);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1413);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_CAMP;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_CAMP = {}, _defineProperty(_FETCH_PAGINATED_CAMP, _mutationTypes.FETCH_PAGINATED_CAMPAIGNS, function (state, _ref) {
	  var campaigns = _ref.campaigns,
	      pagination = _ref.pagination;
	
	  state.items = campaigns;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_CAMP, _mutationTypes.FETCH_ALL_CAMPAIGNS, function (state, campaigns) {
	  state.all = campaigns;
	}), _defineProperty(_FETCH_PAGINATED_CAMP, _mutationTypes.FETCH_CAMPAIGN_TYPES, function (state, types) {
	  state.types = types;
	}), _defineProperty(_FETCH_PAGINATED_CAMP, _mutationTypes.RESET_CAMPAIGNS, function (state) {
	  state.all = [];
	  state.items = [];
	  state.pagination = {};
	}), _FETCH_PAGINATED_CAMP);

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  types: []
	};

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1417);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1416);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_CHART_OF_A;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_CHART_OF_A = {}, _defineProperty(_FETCH_ALL_CHART_OF_A, _mutationTypes.FETCH_ALL_CHART_OF_ACCOUNTS, function (state, chartOfAccounts) {
	  state.all = chartOfAccounts;
	}), _defineProperty(_FETCH_ALL_CHART_OF_A, _mutationTypes.REMOVE_CHART_OF_ACCOUNTS_ITEM, function (state, id) {
	  state.all = state.all.filter(function (p) {
	    return p.id !== id;
	  });
	}), _defineProperty(_FETCH_ALL_CHART_OF_A, _mutationTypes.ADD_CHART_OF_ACCOUNTS_ITEM, function (state, chartOfAccountItem) {
	  state.all.push(chartOfAccountItem);
	}), _defineProperty(_FETCH_ALL_CHART_OF_A, _mutationTypes.UPDATE_CHART_OF_ACCOUNTS_ITEM, function (state, _ref) {
	  var chartOfAccountsItem = _ref.chartOfAccountsItem,
	      id = _ref.id;
	
	  state.all = state.all.map(function (p) {
	    if (p.id === id) {
	      return Object.assign({}, p, chartOfAccountsItem);
	    }
	
	    return p;
	  });
	}), _FETCH_ALL_CHART_OF_A);

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1420);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1419);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_CITIES, function (state, _ref) {
	  var cities = _ref.cities;
	
	  state.all = cities;
	});

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1423);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1422);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_CLIENTS$RESET_;
	
	var _mutationTypes = __webpack_require__(10);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_CLIENTS$RESET_ = {}, _defineProperty(_FETCH_CLIENTS$RESET_, _mutationTypes.FETCH_CLIENTS, function (state, _ref) {
	  var clients = _ref.clients,
	      pagination = _ref.pagination;
	
	  state.items = clients;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_CLIENTS$RESET_, _mutationTypes.RESET_CLIENTS, function (state) {
	  state.all = [];
	  state.items = [];
	  state.pagination = {};
	}), _defineProperty(_FETCH_CLIENTS$RESET_, _mutationTypes.FETCH_ALL_CLIENTS, function (state, clients) {
	  state.all = clients;
	}), _defineProperty(_FETCH_CLIENTS$RESET_, _mutationTypes.FETCH_ALL_CLIENT_OPTIONS, function (state, clients) {
	  state.options = clients;
	}), _defineProperty(_FETCH_CLIENTS$RESET_, _mutationTypes.CLIENT_QUERY, function (state, _ref2) {
	  var page = _ref2.page,
	      limit = _ref2.limit,
	      search = _ref2.search;
	
	  state.query.page = page;
	  state.query.limit = limit;
	  state.query.search = search;
	  state.query.isSet = true;
	}), _defineProperty(_FETCH_CLIENTS$RESET_, _mutationTypes.SET_CURRENT_CLIENT_CONTACTS, function (state, contacts) {
	  state.clientContacts = contacts;
	}), _defineProperty(_FETCH_CLIENTS$RESET_, _mutationTypes.ADD_CLIENT_CONTACT, function (state, contact) {
	  state.clientContacts.push(contact);
	}), _defineProperty(_FETCH_CLIENTS$RESET_, _mutationTypes.DELETE_CLIENT_CONTACT, function (state, i) {
	  state.clientContacts.splice(i, 1);
	}), _defineProperty(_FETCH_CLIENTS$RESET_, _mutationTypes.UPDATE_CLIENT_CONTACT, function (state, _ref3) {
	  var data = _ref3.data,
	      i = _ref3.i;
	
	  state.clientContacts.splice(i, 1, data);
	}), _defineProperty(_FETCH_CLIENTS$RESET_, _mutationTypes.SET_CURRENT_CLIENT_ADDRESSES, function (state, addresses) {
	  state.clientAddresses = addresses;
	}), _defineProperty(_FETCH_CLIENTS$RESET_, _mutationTypes.ADD_CLIENT_ADDRESS, function (state, address) {
	  state.clientAddresses.push(address);
	}), _defineProperty(_FETCH_CLIENTS$RESET_, _mutationTypes.DELETE_CLIENT_ADDRESS, function (state, i) {
	  state.clientAddresses.splice(i, 1);
	}), _defineProperty(_FETCH_CLIENTS$RESET_, _mutationTypes.UPDATE_CLIENT_ADDRESS, function (state, _ref4) {
	  var data = _ref4.data,
	      i = _ref4.i;
	
	  _vue2.default.set(state.clientAddresses, i, data);
	}), _FETCH_CLIENTS$RESET_);

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  options: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  query: {
	    page: 1,
	    limit: 50,
	    search: '',
	    isSet: false
	  },
	  clientContacts: [],
	  clientAddresses: []
	};

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1426);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1425);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ADD_CLIENT_GROUP$FET;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_ADD_CLIENT_GROUP$FET = {}, _defineProperty(_ADD_CLIENT_GROUP$FET, _mutationTypes.ADD_CLIENT_GROUP, function (state, clientGroup) {
	  state.all.push(clientGroup);
	}), _defineProperty(_ADD_CLIENT_GROUP$FET, _mutationTypes.FETCH_PAGINATED_CLIENT_GROUPS, function (state, _ref) {
	  var clientGroups = _ref.clientGroups,
	      pagination = _ref.pagination;
	
	  state.items = clientGroups;
	  state.pagination = pagination;
	}), _defineProperty(_ADD_CLIENT_GROUP$FET, _mutationTypes.FETCH_ALL_CLIENT_GROUPS, function (state, clientGroups) {
	  state.all = clientGroups;
	}), _defineProperty(_ADD_CLIENT_GROUP$FET, _mutationTypes.UPDATE_CLIENT_GROUP, function () {}), _defineProperty(_ADD_CLIENT_GROUP$FET, _mutationTypes.RESET_CLIENT_GROUPS, function (state) {
	  state.all = [];
	  state.items = [];
	  state.pagination = {};
	}), _ADD_CLIENT_GROUP$FET);

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1429);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1428);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_CLIENT_TYPES, function (state, clientTypes) {
	  state.all = clientTypes;
	});

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1432);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1431);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_CONTACT_TYPES, function (state, contactTypes) {
	  state.contactTypes = contactTypes;
	});

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  contactTypes: []
	};

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1435);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1434);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_COUNTRIES, function (state, _ref) {
	  var countries = _ref.countries,
	      pagination = _ref.pagination;
	
	  state.all = countries;
	  state.pagination = pagination;
	});

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1438);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1437);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RESET_CREDIT_NOTE_PR;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_RESET_CREDIT_NOTE_PR = {}, _defineProperty(_RESET_CREDIT_NOTE_PR, _mutationTypes.RESET_CREDIT_NOTE_PRODUCTS, function (state) {
	  state.all = [];
	}), _defineProperty(_RESET_CREDIT_NOTE_PR, _mutationTypes.FETCH_ALL_CREDIT_NOTE_PRODUCTS, function (state, creditNoteProducts) {
	  state.all = creditNoteProducts;
	}), _defineProperty(_RESET_CREDIT_NOTE_PR, _mutationTypes.REMOVE_CREDIT_NOTE_PRODUCT, function (state, id) {
	  state.all = state.all.filter(function (p) {
	    return p.id !== id;
	  });
	}), _defineProperty(_RESET_CREDIT_NOTE_PR, _mutationTypes.ADD_CREDIT_NOTE_PRODUCT, function (state, creditNoteProduct) {
	  state.all.push(creditNoteProduct);
	}), _defineProperty(_RESET_CREDIT_NOTE_PR, _mutationTypes.UPDATE_CREDIT_NOTE_PRODUCT, function (state, _ref) {
	  var creditNoteProduct = _ref.creditNoteProduct,
	      id = _ref.id;
	
	  state.all.map(function (p) {
	    if (p.id.toString() === id.toString()) {
	      Object.keys(creditNoteProduct).map(function (k) {
	        p[k] = creditNoteProduct[k];
	        return k;
	      });
	    }
	    return p;
	  });
	}), _RESET_CREDIT_NOTE_PR);

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1441);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1440);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_CREDIT_NOT;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_CREDIT_NOT = {}, _defineProperty(_FETCH_ALL_CREDIT_NOT, _mutationTypes.FETCH_ALL_CREDIT_NOTE_REASONS, function (state, creditNoteReasons) {
	  state.all = creditNoteReasons;
	}), _defineProperty(_FETCH_ALL_CREDIT_NOT, _mutationTypes.FETCH_CURRENT_CREDIT_NOTE_REASON, function (state, creditNoteReason) {
	  state.current = creditNoteReason;
	}), _FETCH_ALL_CREDIT_NOT);

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  current: []
	};

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1444);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1443);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_CURRENCIES, function (state, currencies) {
	  state.all = currencies;
	});

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1447);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1446);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_DEPOSIT_SY;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_DEPOSIT_SY = {}, _defineProperty(_FETCH_ALL_DEPOSIT_SY, _mutationTypes.FETCH_ALL_DEPOSIT_SYSTEMS, function (state, depositSystems) {
	  state.all = depositSystems;
	}), _defineProperty(_FETCH_ALL_DEPOSIT_SY, _mutationTypes.ADD_NULL_DEPOSIT_SYSTEM, function (state) {
	  state.all.splice(0, 0, { id: '', name: '' });
	}), _FETCH_ALL_DEPOSIT_SY);

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1450);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1449);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_EDI_;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_EDI_ = {}, _defineProperty(_FETCH_PAGINATED_EDI_, _mutationTypes.FETCH_PAGINATED_EDI_ORDERS, function (state, _ref) {
	  var ediOrders = _ref.ediOrders,
	      pagination = _ref.pagination;
	
	  state.items = ediOrders;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_EDI_, _mutationTypes.FETCH_ALL_EDI_ORDERS, function (state, ediOrders) {
	  state.all = ediOrders;
	}), _defineProperty(_FETCH_PAGINATED_EDI_, _mutationTypes.FETCH_CURRENT_EDI_ORDER, function (state, ediOrder) {
	  state.currentEdiOrder = ediOrder;
	}), _defineProperty(_FETCH_PAGINATED_EDI_, _mutationTypes.RESET_CURRENT_EDI_ORDER, function (state) {
	  state.currentEdiOrder = {};
	}), _FETCH_PAGINATED_EDI_);

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  currentEdiOrder: {}
	};

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1453);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1452);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_EDI_ORDER_;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_EDI_ORDER_ = {}, _defineProperty(_FETCH_ALL_EDI_ORDER_, _mutationTypes.FETCH_ALL_EDI_ORDER_ITEMS, function (state, ediOrderItems) {
	  state.all = ediOrderItems;
	}), _defineProperty(_FETCH_ALL_EDI_ORDER_, _mutationTypes.UPDATE_EDI_ORDER_ITEM, function (state, _ref) {
	  var ediOrderItem = _ref.ediOrderItem,
	      id = _ref.id;
	
	  state.all.map(function (p) {
	    if (p.id === id) {
	      Object.keys(ediOrderItem).map(function (k) {
	        p[k] = ediOrderItem[k];
	        return k;
	      });
	    }
	    return p;
	  });
	}), _FETCH_ALL_EDI_ORDER_);

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1456);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1455);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_EQUI;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_EQUI = {}, _defineProperty(_FETCH_PAGINATED_EQUI, _mutationTypes.FETCH_PAGINATED_EQUIPMENTS, function (state, _ref) {
	  var equipments = _ref.equipments,
	      pagination = _ref.pagination;
	
	  state.items = equipments;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_EQUI, _mutationTypes.FETCH_ALL_EQUIPMENTS, function (state, equipment) {
	  state.all = equipment;
	}), _defineProperty(_FETCH_PAGINATED_EQUI, _mutationTypes.EQUIPMENT_QUERY, function (state, _ref2) {
	  var page = _ref2.page,
	      limit = _ref2.limit,
	      search = _ref2.search;
	
	  state.query.page = page;
	  state.query.limit = limit;
	  state.query.search = search;
	  state.query.isSet = true;
	}), _FETCH_PAGINATED_EQUI);

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  query: {
	    page: 1,
	    limit: 50,
	    search: '',
	    isSet: false
	  }
	};

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1459);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1458);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_EXCISE_GROUPS$;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_EXCISE_GROUPS$ = {}, _defineProperty(_FETCH_EXCISE_GROUPS$, _mutationTypes.FETCH_EXCISE_GROUPS, function (state, _ref) {
	  var exciseGroups = _ref.exciseGroups;
	
	  state.all = exciseGroups;
	  state.all.splice(0, 0, { id: '', name: '', title: '', description: '' });
	}), _defineProperty(_FETCH_EXCISE_GROUPS$, _mutationTypes.FETCH_EXCISE_PACKAGING_GROUPS, function (state, _ref2) {
	  var excisePackagingGroups = _ref2.excisePackagingGroups;
	
	  state.packaging = excisePackagingGroups;
	  state.packaging.splice(0, 0, { id: '', name: '', title: '', description: '' });
	}), _defineProperty(_FETCH_EXCISE_GROUPS$, _mutationTypes.FETCH_EXCISE_BASIC, function (state, _ref3) {
	  var exciseBasicGroups = _ref3.exciseBasicGroups;
	
	  state.basic = exciseBasicGroups;
	  state.basic.splice(0, 0, { id: '', name: '', title: '', description: '' });
	}), _defineProperty(_FETCH_EXCISE_GROUPS$, _mutationTypes.ADD_NULL_TO_EXCISE_GROUPS_LIST, function (state) {
	  state.all.splice(0, 0, { id: '', name: '', title: '', description: '' });
	}), _FETCH_EXCISE_GROUPS$);

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  packaging: [],
	  basic: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1462);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1461);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_EXCI;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_EXCI = {}, _defineProperty(_FETCH_PAGINATED_EXCI, _mutationTypes.FETCH_PAGINATED_EXCISE_PERIODS, function (state, _ref) {
	  var excisePeriods = _ref.excisePeriods,
	      pagination = _ref.pagination;
	
	  state.items = excisePeriods;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_EXCI, _mutationTypes.FETCH_ALL_EXCISE_PERIODS, function (state, excisePeriods) {
	  state.all = excisePeriods;
	}), _FETCH_PAGINATED_EXCI);

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 10,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1465);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1464);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_LANGUAGES, function (state, languages) {
	  state.all = languages;
	});

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1468);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1467);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_LICENSES, function (state, licenses) {
	  state.all = licenses;
	});

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1471);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1470);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_LICENSE_GROUPS, function (state, licenseGroups) {
	  state.all = licenseGroups;
	});

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1474);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1473);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_LICENSE_PERMIT_GROUPS, function (state, licensePermitGroups) {
	  state.all = licensePermitGroups;
	});

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1477);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1476);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_LICENSE_PERMITS, function (state, licensePermits) {
	  state.all = licensePermits;
	});

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1480);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1479);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_LICENSE_PERMIT_TYPES, function (state, licensePermitTypes) {
	  state.all = licensePermitTypes;
	});

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1483);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1482);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_LICENSE_TY;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_LICENSE_TY = {}, _defineProperty(_FETCH_ALL_LICENSE_TY, _mutationTypes.FETCH_ALL_LICENSE_TYPES, function (state, licenseTypes) {
	  state.all = licenseTypes;
	}), _defineProperty(_FETCH_ALL_LICENSE_TY, _mutationTypes.ADD_NULL_LICENSE_TYPE, function (state) {
	  state.all.splice(0, '', { id: '', name: '' });
	}), _FETCH_ALL_LICENSE_TY);

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1486);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1485);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_MATE;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_MATE = {}, _defineProperty(_FETCH_PAGINATED_MATE, _mutationTypes.FETCH_PAGINATED_MATERIALS, function (state, _ref) {
	  var materials = _ref.materials,
	      pagination = _ref.pagination;
	
	  state.items = materials;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_MATE, _mutationTypes.FETCH_ALL_MATERIALS, function (state, material) {
	  state.all = material;
	}), _defineProperty(_FETCH_PAGINATED_MATE, _mutationTypes.MATERIAL_QUERY, function (state, _ref2) {
	  var page = _ref2.page,
	      limit = _ref2.limit,
	      search = _ref2.search;
	
	  state.query.page = page;
	  state.query.limit = limit;
	  state.query.search = search;
	  state.query.isSet = true;
	}), _FETCH_PAGINATED_MATE);

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  query: {
	    page: 1,
	    limit: 50,
	    search: '',
	    isSet: false
	  }
	};

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1489);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1488);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_MATERIAL_TYPES, function (state, materialTypes) {
	  state.all = materialTypes;
	});

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1492);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1491);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_MESSAGE_TEMPLATE_TYPES, function (state, types) {
	  state.types = types;
	});

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  types: []
	};

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1495);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1494);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TOGGLE_MODAL$SET_MOD;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_TOGGLE_MODAL$SET_MOD = {}, _defineProperty(_TOGGLE_MODAL$SET_MOD, _mutationTypes.TOGGLE_MODAL, function (state) {
	  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  state.modalState = status !== null && status !== undefined ? status : !state.modalState;
	}), _defineProperty(_TOGGLE_MODAL$SET_MOD, _mutationTypes.SET_MODAL_SIZE, function (state) {
	  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '50%';
	
	  state.modalSize = size;
	}), _defineProperty(_TOGGLE_MODAL$SET_MOD, _mutationTypes.SET_MODAL_CLASS, function (state) {
	  var customClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'responsive-modal';
	
	  state.modalClass = customClass;
	}), _defineProperty(_TOGGLE_MODAL$SET_MOD, _mutationTypes.SET_MODAL_CONTENT, function (state, content) {
	  state.modalContent = content;
	}), _defineProperty(_TOGGLE_MODAL$SET_MOD, _mutationTypes.SET_MODAL_CLOSE_ON_CLICK, function (state) {
	  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  state.modalCloseOnClick = value;
	}), _defineProperty(_TOGGLE_MODAL$SET_MOD, _mutationTypes.SET_MODAL_SHOW_CLOSE, function (state) {
	  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  state.modalShowClose = value;
	}), _defineProperty(_TOGGLE_MODAL$SET_MOD, _mutationTypes.SET_MODAL_CLOSE_ON_PRESS_ESCAPE, function (state) {
	  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  state.modalCloseOnPressEscape = value;
	}), _defineProperty(_TOGGLE_MODAL$SET_MOD, _mutationTypes.UNSET_MODAL_CONTENT, function (state) {
	  state.modalContent = {};
	  state.modalProps = {};
	}), _defineProperty(_TOGGLE_MODAL$SET_MOD, _mutationTypes.SET_MODAL_PROPS, function (state, props) {
	  state.modalProps = props;
	}), _defineProperty(_TOGGLE_MODAL$SET_MOD, _mutationTypes.SET_MODAL_BUTTON_LOADING, function (state) {
	  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  state.modalButtonLoading = value;
	}), _defineProperty(_TOGGLE_MODAL$SET_MOD, _mutationTypes.UPDATE_PREVIEW_PARAM, function (state) {
	  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  state.modalProps = _extends({}, state.modalProps, value);
	}), _TOGGLE_MODAL$SET_MOD);

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  modalState: false,
	  modalContent: {},
	  modalProps: {},
	  modalSize: '50%',
	  modalClass: '',
	  modalCloseOnClick: true,
	  modalShowClose: true,
	  modalCloseOnPressEscape: true,
	  modalButtonLoading: false
	};

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1498);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1497);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_MODULES, function (state, modules) {
	  state.all = modules;
	});

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1501);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1500);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_MUNICIPALITIES, function (state, _ref) {
	  var municipalities = _ref.municipalities;
	
	  state.all = municipalities;
	});

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_ORDE;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_ORDE = {}, _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.FETCH_PAGINATED_ORDERS, function (state, _ref) {
	  var orders = _ref.orders,
	      pagination = _ref.pagination;
	
	  state.items = orders;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.FETCH_ALL_ORDERS, function (state, orders) {
	  state.all = orders;
	}), _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.RESET_ORDERS, function (state) {
	  state.all = [];
	  state.items = [];
	  state.types = [];
	  state.pagination = {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  };
	  state.currentOrder = {};
	}), _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.RESET_CURRENT_ORDER, function (state) {
	  state.currentOrder = {};
	}), _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.FETCH_ORDER_TYPES, function (state, orderTypes) {
	  state.types = orderTypes;
	}), _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.FETCH_CURRENT_ORDER, function (state, order) {
	  state.currentOrder = order;
	}), _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.FETCH_ORDER_EVENTS, function (state, events) {
	  state.events = events;
	}), _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.ORDER_QUERY, function (state, _ref2) {
	  var page = _ref2.page,
	      limit = _ref2.limit,
	      search = _ref2.search;
	
	  state.query.page = page;
	  state.query.limit = limit;
	  state.query.search = search;
	  state.query.isSet = true;
	}), _FETCH_PAGINATED_ORDE);

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  types: [],
	  currentOrder: {},
	  events: [],
	  query: {
	    page: 1,
	    limit: 50,
	    search: '',
	    isSet: false
	  }
	};

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1506);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1505);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_ORDE;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_ORDE = {}, _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.FETCH_PAGINATED_ORDER_PICKUPS, function (state, _ref) {
	  var orderPickups = _ref.orderPickups,
	      pagination = _ref.pagination;
	
	  state.items = orderPickups;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.FETCH_ALL_ORDER_PICKUPS, function (state, orderPickups) {
	  state.all = orderPickups;
	}), _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.RESET_ORDER_PICKUPS, function (state) {
	  state.all = [];
	  state.items = [];
	  state.types = [];
	  state.pagination = {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  };
	  state.currentOrderPickup = {};
	}), _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.RESET_CURRENT_ORDER_PICKUP, function (state) {
	  state.currentOrderPickup = {};
	}), _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.FETCH_ORDER_PICKUPS_TYPES, function (state, orderPickupTypes) {
	  state.types = orderPickupTypes;
	}), _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.FETCH_CURRENT_ORDER_PICKUP, function (state, orderPickup) {
	  state.currentOrderPickup = orderPickup;
	}), _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.FETCH_ORDER_PICKUPS_EVENTS, function (state, events) {
	  state.events = events;
	}), _defineProperty(_FETCH_PAGINATED_ORDE, _mutationTypes.ORDER_PICKUPS_QUERY, function (state, _ref2) {
	  var page = _ref2.page,
	      limit = _ref2.limit,
	      search = _ref2.search;
	
	  state.query.page = page;
	  state.query.limit = limit;
	  state.query.search = search;
	  state.query.isSet = true;
	}), _FETCH_PAGINATED_ORDE);

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  types: [],
	  currentOrderPickup: {},
	  events: [],
	  query: {
	    page: 1,
	    limit: 50,
	    search: '',
	    isSet: false
	  }
	};

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1509);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1508);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RESET_ORDER_PRODUCTS;
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _mutationTypes = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_RESET_ORDER_PRODUCTS = {}, _defineProperty(_RESET_ORDER_PRODUCTS, _mutationTypes.RESET_ORDER_PRODUCTS, function (state) {
	  state.all = [];
	}), _defineProperty(_RESET_ORDER_PRODUCTS, _mutationTypes.FETCH_ALL_ORDER_PRODUCTS, function (state, orderProducts) {
	  state.all = orderProducts;
	}), _defineProperty(_RESET_ORDER_PRODUCTS, _mutationTypes.REMOVE_ORDER_PRODUCT, function (state, id) {
	  state.all = state.all.filter(function (p) {
	    return p.id !== id;
	  });
	}), _defineProperty(_RESET_ORDER_PRODUCTS, _mutationTypes.ADD_ORDER_PRODUCT, function (state, orderProduct) {
	  _store2.default.state.tax.all.map(function (t) {
	    if (t.id === orderProduct.taxId) {
	      orderProduct.taxPercentage = t.taxPercentage;
	    }
	    return t;
	  });
	  state.all.push(orderProduct);
	}), _defineProperty(_RESET_ORDER_PRODUCTS, _mutationTypes.UPDATE_ORDER_PRODUCT, function (state, _ref) {
	  var orderProduct = _ref.orderProduct,
	      id = _ref.id;
	
	  _store2.default.state.tax.all.forEach(function (t) {
	    if (t.id.toString() === orderProduct.taxId.toString()) {
	      orderProduct.taxPercentage = t.taxPercentage;
	    }
	  });
	  state.all = state.all.map(function (p) {
	    if (p.id.toString() === id.toString()) {
	      return Object.assign({}, p, orderProduct);
	    }
	
	    return p;
	  });
	}), _RESET_ORDER_PRODUCTS);

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1512);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1511);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_ORGANIZATI;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_ORGANIZATI = {}, _defineProperty(_FETCH_ALL_ORGANIZATI, _mutationTypes.FETCH_ALL_ORGANIZATION_MEMBERS, function (state, organizationMembers) {
	  state.all = organizationMembers;
	}), _defineProperty(_FETCH_ALL_ORGANIZATI, _mutationTypes.ADD_ORGANIZATION_MEMBER, function (state, organizationMember) {
	  state.all.unshift(organizationMember);
	}), _FETCH_ALL_ORGANIZATI);

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1515);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1514);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_ORGANIZATI;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_ORGANIZATI = {}, _defineProperty(_FETCH_ALL_ORGANIZATI, _mutationTypes.FETCH_ALL_ORGANIZATION_MEMBER_BOOKINGS, function (state, organizationMemberBookings) {
	  state.all = organizationMemberBookings;
	}), _defineProperty(_FETCH_ALL_ORGANIZATI, _mutationTypes.ADD_ORGANIZATION_MEMBER_BOOKING, function (state, organizationMemberBooking) {
	  state.all.unshift(organizationMemberBooking);
	}), _FETCH_ALL_ORGANIZATI);

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1518);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1517);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_ORGANIZATION_MEMBER_PRODUCT_BUSINESSHOURS, function (state, organizationMemberProductBusinessHour) {
	  state.all = organizationMemberProductBusinessHour;
	});

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1521);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1520);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_ORGANIZATION_TYPES, function (state, organizationTypes) {
	  state.organizationTypes = organizationTypes;
	});

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  organizationTypes: []
	};

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1524);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1523);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_PACKAGES, function (state, packages) {
	  state.all = packages;
	});

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  currentShippingProvider: []
	};

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1527);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1526);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_PACKAGE_ORDER_PRODUCTS, function (state, packageOrderProduct) {
	  state.all = packageOrderProduct;
	});

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  currentShippingProvider: []
	};

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1530);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1529);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_PACKAGE_UN;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_PACKAGE_UN = {}, _defineProperty(_FETCH_ALL_PACKAGE_UN, _mutationTypes.FETCH_ALL_PACKAGE_UNIT_TYPES, function (state, packageUnitTypes) {
	  state.all = packageUnitTypes;
	}), _defineProperty(_FETCH_ALL_PACKAGE_UN, _mutationTypes.FETCH_CURRENT_PACKAGE_UNIT_TYPE, function (state, packageUnitType) {
	  state.currentpackageUnitType = packageUnitType;
	}), _FETCH_ALL_PACKAGE_UN);

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  currentShippingProvider: []
	};

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1533);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1532);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_PACKAGING_MATERIALS, function (state, packagingMaterials) {
	  state.all = packagingMaterials;
	});

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1536);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1535);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_PACKAGING_TYPES, function (state, packagingTypes) {
	  state.all = packagingTypes;
	});

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1539);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1538);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_PARTNERS, function (state, partners) {
	  state.all = partners;
	});

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1542);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1541);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_PAYMENT_METHODS, function (state, paymentMethods) {
	  state.paymentMethods = paymentMethods;
	});

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  paymentMethods: []
	};

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1545);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1544);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SET_CHOSEN_PLAN$FETC;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_SET_CHOSEN_PLAN$FETC = {}, _defineProperty(_SET_CHOSEN_PLAN$FETC, _mutationTypes.SET_CHOSEN_PLAN, function (state, plan) {
	  state.chosenPlan = plan;
	}), _defineProperty(_SET_CHOSEN_PLAN$FETC, _mutationTypes.FETCH_ALL_PLANS, function (state, plans) {
	  state.plans = plans;
	}), _SET_CHOSEN_PLAN$FETC);

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  plans: [],
	  chosenPlan: {}
	};

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1548);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1547);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_POSTALS, function (state, _ref) {
	  var postals = _ref.postals;
	
	  state.all = postals;
	});

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1551);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1550);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_PRIC;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_PRIC = {}, _defineProperty(_FETCH_PAGINATED_PRIC, _mutationTypes.FETCH_PAGINATED_PRICE_FIELDS, function (state, _ref) {
	  var priceFields = _ref.priceFields,
	      pagination = _ref.pagination;
	
	  state.items = priceFields;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_PRIC, _mutationTypes.FETCH_ALL_PRICE_FIELDS, function (state, priceFields) {
	  state.all = priceFields;
	}), _defineProperty(_FETCH_PAGINATED_PRIC, _mutationTypes.RESET_PRICE_FIELDS, function (state) {
	  state.all = [];
	  state.items = [];
	  state.pagination = {};
	}), _FETCH_PAGINATED_PRIC);

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1554);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1553);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_PRODUCERS, function (state, producers) {
	  state.all = producers;
	});

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1557);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1556);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_PROD;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_PROD = {}, _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.FETCH_PAGINATED_PRODUCTS, function (state, _ref) {
	  var products = _ref.products,
	      pagination = _ref.pagination;
	
	  state.items = products;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.RESET_PRODUCTS, function (state) {
	  state.items = [];
	  state.all = [];
	  state.basic = [];
	  state.pagination = {};
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.FETCH_ALL_PRODUCTS, function (state, products) {
	  state.all = products;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.FETCH_ALL_PRODUCTS_BASIC, function (state, products) {
	  state.basic = products;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.FETCH_ALL_PRODUCT_TRANSACTIONS, function (state, transactions) {
	  state.transactions = transactions;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.FETCH_ALL_PRODUCT_TRANSACTIONSV2, function (state, transactionsV2) {
	  state.transactionsV2 = transactionsV2;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.FETCH_PRODUCT_TRANSACTIONSV2, function (state, _ref2) {
	  var transactionsV2 = _ref2.transactionsV2,
	      pagination = _ref2.pagination;
	
	  state.paginateTransactionsV2.items = transactionsV2;
	  state.paginateTransactionsV2.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.ADD_PRODUCT_PRICE, function (state, productPrice) {
	  state.productPrices.push(productPrice);
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.UPDATE_PRODUCT_PRICE, function (state, _ref3) {
	  var index = _ref3.index,
	      productPrice = _ref3.productPrice;
	
	  state.productPrices[index] = productPrice;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.REMOVE_PRODUCT_PRICE, function (state, index) {
	  state.productPrices.splice(index, 1);
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.FETCH_PRODUCT_PRICES, function (state, productPrices) {
	  state.productPrices = productPrices;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.PRODUCT_QUERY, function (state, _ref4) {
	  var page = _ref4.page,
	      limit = _ref4.limit,
	      search = _ref4.search,
	      grouping = _ref4.grouping;
	
	  state.query.page = page;
	  state.query.limit = limit;
	  state.query.search = search;
	  state.query.grouping = grouping;
	  state.query.isSet = true;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.SET_PRODUCT_GROUPING, function (state, grouping) {
	  state.query.grouping = grouping;
	}), _FETCH_PAGINATED_PROD);

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  basic: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  transactions: [],
	  transactionsV2: [],
	  paginateTransactionsV2: {
	    items: [],
	    pagination: {
	      currentPage: 1,
	      lastPage: 0,
	      limit: 5,
	      totalCount: 0
	    }
	  },
	  productPrices: [],
	  query: {
	    page: 1,
	    limit: 50,
	    search: '',
	    grouping: '',
	    isSet: false
	  }
	};

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1560);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1559);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_PRODUCT_DE;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_PRODUCT_DE = {}, _defineProperty(_FETCH_ALL_PRODUCT_DE, _mutationTypes.FETCH_ALL_PRODUCT_DEPOSITS, function (state, _ref) {
	  var productDeposits = _ref.productDeposits;
	
	  state.all = productDeposits;
	}), _defineProperty(_FETCH_ALL_PRODUCT_DE, _mutationTypes.ADD_NULL_DEPOSIT_LIST, function (state) {
	  state.all.splice(0, 0, { id: '', name: '' });
	}), _FETCH_ALL_PRODUCT_DE);

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1563);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1562);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_PRODUCTFLO;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_PRODUCTFLO = {}, _defineProperty(_FETCH_ALL_PRODUCTFLO, _mutationTypes.FETCH_ALL_PRODUCTFLOWS, function (state, productFlows) {
	  state.all = productFlows;
	}), _defineProperty(_FETCH_ALL_PRODUCTFLO, _mutationTypes.FETCH_PAGINATE_PRODUCTFLOWS, function (state, _ref) {
	  var productFlows = _ref.productFlows,
	      pagination = _ref.pagination;
	
	  state.items = productFlows;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_ALL_PRODUCTFLO, _mutationTypes.FETCH_CURRENT_PRODUCTFLOW, function (state, productFlow) {
	  state.current_PRODUCTFLOW = productFlow;
	}), _defineProperty(_FETCH_ALL_PRODUCTFLO, _mutationTypes.FETCH_ALL_PRODUCTFLOW_ORDERS, function (state, orders) {
	  state.orders = orders;
	}), _FETCH_ALL_PRODUCTFLO);

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  currentproductFlow: [],
	  orders: []
	};

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1566);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1565);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_PROD;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_PROD = {}, _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.FETCH_PAGINATED_PRODUCT_GROUPS, function (state, _ref) {
	  var productGroups = _ref.productGroups,
	      pagination = _ref.pagination;
	
	  state.items = productGroups;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.FETCH_ALL_PRODUCT_GROUPS, function (state, productGroups) {
	  state.all = productGroups;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.RESET_PRODUCT_GROUPS, function (state) {
	  state.all = [];
	  state.items = [];
	  state.pagination = {};
	}), _FETCH_PAGINATED_PROD);

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1569);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1568);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_PROD;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_PROD = {}, _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.FETCH_PAGINATED_PRODUCT_PACKAGINGS, function (state, _ref) {
	  var productPackagings = _ref.productPackagings,
	      pagination = _ref.pagination;
	
	  state.items = productPackagings;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.FETCH_ALL_PRODUCT_PACKAGINGS, function (state, productPackagings) {
	  state.all = productPackagings;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.RESET_PRODUCT_PACKAGINGS, function (state) {
	  state.all = [];
	  state.items = [];
	  state.pagination = {};
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.ADD_NULL_PRODUCT_PACKAGINGS, function (state) {
	  state.all.splice(0, 0, { id: '', name: '' });
	}), _FETCH_PAGINATED_PROD);

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1572);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1571);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_PRODUCT_RECOMMENDATIONS, function (state, productRecommendation) {
	  state.all = productRecommendation;
	});

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1575);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1574);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_PRODUCT_SUBTYPES, function (state, productSubtypes) {
	  state.all = productSubtypes;
	});

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1578);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1577);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_PROD;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_PROD = {}, _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.FETCH_PAGINATED_PRODUCT_TAGS, function (state, _ref) {
	  var productTags = _ref.productTags,
	      pagination = _ref.pagination;
	
	  state.items = productTags;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.FETCH_ALL_PRODUCT_TAGS, function (state, productTags) {
	  state.all = productTags;
	}), _defineProperty(_FETCH_PAGINATED_PROD, _mutationTypes.RESET_PRODUCT_TAGS, function (state) {
	  state.all = [];
	  state.items = [];
	  state.pagination = {};
	}), _FETCH_PAGINATED_PROD);

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1581);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1580);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_PRODUCT_TYPES, function (state, productTypes) {
	  state.all = productTypes;
	});

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1584);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1583);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_USER_APP_VERSI;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_USER_APP_VERSI = {}, _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.FETCH_USER_APP_VERSION, function (state, appVersionData) {
	  state.userAppVersion = appVersionData;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.FETCH_USER_WIDGETS, function (state, widgetsData) {
	  state.userWidgets = widgetsData;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.FETCH_AVAILABLE_WIDGETS, function (state, availableWidgetsData) {
	  state.availableWidgets = availableWidgetsData;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.FETCH_BEST_CLIENTS_WIDGETS, function (state, bestClientsWidgetsData) {
	  state.bestClientsWidgets = bestClientsWidgetsData;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.FETCH_WAITING_PROCESSED_WIDGETS, function (state, waitingProcessedWidgetsData) {
	  state.waitingProcessedWidgets = waitingProcessedWidgetsData;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.FETCH_WAITING_DELIVERED_WIDGETS, function (state, waitingDeliveredWidgetsData) {
	  state.waitingDeliveredWidgets = waitingDeliveredWidgetsData;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.FETCH_ORDER_RECEIVED_WIDGETS, function (state, orderReceivedWidgetsData) {
	  state.orderReceivedWidgets = orderReceivedWidgetsData;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.FETCH_REVENUE_WIDGETS, function (state, revenueWidgetsData) {
	  state.revenueWidgets = revenueWidgetsData;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.FETCH_POPULAR_PRODUCTS_WIDGETS, function (state, popularProductsWidgetsData) {
	  state.popularProductsWidgets = popularProductsWidgetsData;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.FETCH_SOLD_PRODUCTS_WIDGETS, function (state, soldProductsWidgetsData) {
	  state.soldProductsWidgets = soldProductsWidgetsData;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.GET_ACCOUNT, function (state, account) {
	  state.account = account;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.GET_ADDRESS, function (state, address) {
	  state.address = address;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.GET_CONTACT, function (state, contact) {
	  state.contact = contact;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.GET_ORGANIZATION_SETTINGS, function (state, settings) {
	  state.settings = settings;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.GET_PUBLIC_PROFILE, function (state, publicProfile) {
	  state.publicProfile = publicProfile;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.FETCH_BUSINESS_HOURS, function (state, hours) {
	  state.businessHours = hours;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.STORE_BUSINESS_HOUR, function (state, hour) {
	  state.businessHours.push(hour);
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.DESTROY_BUSINESS_HOUR, function (state, id) {
	  state.businessHours = state.businessHours.filter(function (h) {
	    return h.id.toString() !== id.toString();
	  });
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.FETCH_BUSINESS_HOUR_EXCEPTIONS, function (state, hours) {
	  state.businessHourExceptions = hours;
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.STORE_BUSINESS_HOUR_EXCEPTION, function (state, hour) {
	  state.businessHourExceptions.push(hour);
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.DESTROY_BUSINESS_HOUR_EXCEPTION, function (state, id) {
	  state.businessHourExceptions = state.businessHourExceptions.filter(function (e) {
	    return e.id.toString() !== id.toString();
	  });
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.RESET_PROFILE, function (state) {
	  state.account = {};
	  state.address = {};
	  state.contact = {};
	  state.settings = {};
	  state.publicProfile = {};
	  state.businessHours = [];
	  state.businessHourExceptions = [];
	}), _defineProperty(_FETCH_USER_APP_VERSI, _mutationTypes.FETCH_USER_APP_TOAST, function (state, appToastData) {
	  state.userAppToast = appToastData;
	}), _FETCH_USER_APP_VERSI);

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  account: {},
	  address: {},
	  contact: {},
	  settings: {},
	  publicProfile: {},
	  businessHours: [],
	  businessHourExceptions: [],
	  userAppVersion: [],
	  userAppToast: '',
	  userWidgets: [],
	  availableWidgets: [],
	  bestClientsWidgets: [],
	  waitingProcessedWidgets: 0,
	  waitingDeliveredWidgets: 0,
	  orderReceivedWidgets: 0,
	  revenueWidgets: 0.0,
	  popularProductsWidgets: [],
	  soldProductsWidgets: []
	};

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1587);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1586);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PROJECTS$RESET;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PROJECTS$RESET = {}, _defineProperty(_FETCH_PROJECTS$RESET, _mutationTypes.FETCH_PROJECTS, function (state, _ref) {
	  var projects = _ref.projects,
	      pagination = _ref.pagination;
	
	  state.items = projects;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PROJECTS$RESET, _mutationTypes.RESET_PROJECTS, function (state) {
	  state.all = [];
	  state.items = [];
	  state.pagination = {};
	}), _defineProperty(_FETCH_PROJECTS$RESET, _mutationTypes.FETCH_ALL_PROJECTS, function (state, projects) {
	  state.all = projects;
	}), _FETCH_PROJECTS$RESET);

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1590);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1589);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SELECTED_PROVIDER$DO;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_SELECTED_PROVIDER$DO = {}, _defineProperty(_SELECTED_PROVIDER$DO, _mutationTypes.SELECTED_PROVIDER, function (state, selectedId) {
	  state.selectedProvider = selectedId;
	}), _defineProperty(_SELECTED_PROVIDER$DO, _mutationTypes.DOWNLOAD_PROVIDER_LIST, function (state, providerList) {
	  state.downloadExportList = providerList;
	}), _defineProperty(_SELECTED_PROVIDER$DO, _mutationTypes.ADD_NEW_DOWNLOAD_PROVIDER_LIST, function (state, newPproviderList) {
	  state.downloadExportList.push(newPproviderList);
	}), _defineProperty(_SELECTED_PROVIDER$DO, _mutationTypes.CLIENT_PROVIDER, function (state, clientProvider) {
	  state.clientProvider = clientProvider;
	}), _SELECTED_PROVIDER$DO);

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [{
	    id: 'visma',
	    name: 'Visma'
	  }, {
	    id: 'duett',
	    name: 'Duett'
	  }, {
	    id: 'tripletex',
	    name: 'Tripletex'
	  }],
	  selectedProvider: '',
	  clientProvider: false,
	  downloadExportList: []
	};

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1593);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1592);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_PURCHASES$;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_PURCHASES$ = {}, _defineProperty(_FETCH_ALL_PURCHASES$, _mutationTypes.FETCH_ALL_PURCHASES, function (state, purchases) {
	  state.all = purchases;
	}), _defineProperty(_FETCH_ALL_PURCHASES$, _mutationTypes.FETCH_PAGINATE_PURCHASES, function (state, _ref) {
	  var purchases = _ref.purchases,
	      pagination = _ref.pagination;
	
	  state.items = purchases;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_ALL_PURCHASES$, _mutationTypes.FETCH_PURCHASE_STATUSES, function (state, statuses) {
	  state.statuses = statuses;
	}), _defineProperty(_FETCH_ALL_PURCHASES$, _mutationTypes.FETCH_CURRENT_PURCHASE, function (state, purchase) {
	  state.currentPurchase = purchase;
	}), _FETCH_ALL_PURCHASES$);

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  statuses: [],
	  currentPurchase: [],
	  stockProducts: []
	};

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1596);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1595);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_RECI;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_RECI = {}, _defineProperty(_FETCH_PAGINATED_RECI, _mutationTypes.FETCH_PAGINATED_RECIPES, function (state, _ref) {
	  var recipes = _ref.recipes,
	      pagination = _ref.pagination;
	
	  state.items = recipes;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_RECI, _mutationTypes.FETCH_ALL_RECIPES, function (state, recipe) {
	  state.all = recipe;
	}), _defineProperty(_FETCH_PAGINATED_RECI, _mutationTypes.RECIPE_QUERY, function (state, _ref2) {
	  var page = _ref2.page,
	      limit = _ref2.limit,
	      search = _ref2.search;
	
	  state.query.page = page;
	  state.query.limit = limit;
	  state.query.search = search;
	  state.query.isSet = true;
	}), _FETCH_PAGINATED_RECI);

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  query: {
	    page: 1,
	    limit: 50,
	    search: '',
	    isSet: false
	  }
	};

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1599);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1598);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RESET_RECIPE_INGREDI;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_RESET_RECIPE_INGREDI = {}, _defineProperty(_RESET_RECIPE_INGREDI, _mutationTypes.RESET_RECIPE_INGREDIENCES, function (state) {
	  state.all = [];
	}), _defineProperty(_RESET_RECIPE_INGREDI, _mutationTypes.FETCH_ALL_RECIPE_INGREDIENCES, function (state, recipeIngrediences) {
	  state.all = recipeIngrediences;
	}), _defineProperty(_RESET_RECIPE_INGREDI, _mutationTypes.REMOVE_RECIPE_INGREDIENCE, function (state, id) {
	  state.all = state.all.filter(function (p) {
	    return p.id !== id;
	  });
	}), _defineProperty(_RESET_RECIPE_INGREDI, _mutationTypes.ADD_RECIPE_INGREDIENCE, function (state, recipeIngredience) {
	  state.all.push(recipeIngredience);
	}), _defineProperty(_RESET_RECIPE_INGREDI, _mutationTypes.UPDATE_RECIPE_INGREDIENCE, function (state, _ref) {
	  var recipeIngredience = _ref.recipeIngredience,
	      id = _ref.id;
	
	  state.all.map(function (p) {
	    if (p.id.toString() === id.toString()) {
	      Object.keys(recipeIngredience).map(function (k) {
	        p[k] = recipeIngredience[k];
	        return k;
	      });
	    }
	    return p;
	  });
	}), _RESET_RECIPE_INGREDI);

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1602);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1601);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RESET_RECIPE_PROCEDU;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_RESET_RECIPE_PROCEDU = {}, _defineProperty(_RESET_RECIPE_PROCEDU, _mutationTypes.RESET_RECIPE_PROCEDURES, function (state) {
	  state.all = [];
	}), _defineProperty(_RESET_RECIPE_PROCEDU, _mutationTypes.FETCH_ALL_RECIPE_PROCEDURES, function (state, recipeProcedures) {
	  state.all = recipeProcedures;
	}), _defineProperty(_RESET_RECIPE_PROCEDU, _mutationTypes.REMOVE_RECIPE_PROCEDURE, function (state, id) {
	  state.all = state.all.filter(function (p) {
	    return p.id !== id;
	  });
	}), _defineProperty(_RESET_RECIPE_PROCEDU, _mutationTypes.ADD_RECIPE_PROCEDURE, function (state, recipeProcedure) {
	  state.all.push(recipeProcedure);
	}), _defineProperty(_RESET_RECIPE_PROCEDU, _mutationTypes.UPDATE_RECIPE_PROCEDURE, function (state, _ref) {
	  var recipeProcedure = _ref.recipeProcedure,
	      id = _ref.id;
	
	  state.all.map(function (p) {
	    if (p.id.toString() === id.toString()) {
	      Object.keys(recipeProcedure).map(function (k) {
	        p[k] = recipeProcedure[k];
	        return k;
	      });
	    }
	    return p;
	  });
	}), _RESET_RECIPE_PROCEDU);

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1605);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1604);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RESET_RECIPE_PRODUCT;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_RESET_RECIPE_PRODUCT = {}, _defineProperty(_RESET_RECIPE_PRODUCT, _mutationTypes.RESET_RECIPE_PRODUCTS, function (state) {
	  state.all = [];
	}), _defineProperty(_RESET_RECIPE_PRODUCT, _mutationTypes.FETCH_ALL_RECIPE_PRODUCTS, function (state, recipeProducts) {
	  state.all = recipeProducts;
	}), _defineProperty(_RESET_RECIPE_PRODUCT, _mutationTypes.REMOVE_RECIPE_PRODUCT, function (state, id) {
	  state.all = state.all.filter(function (p) {
	    return p.id !== id;
	  });
	}), _defineProperty(_RESET_RECIPE_PRODUCT, _mutationTypes.ADD_RECIPE_PRODUCT, function (state, recipeProduct) {
	  state.all.push(recipeProduct);
	}), _RESET_RECIPE_PRODUCT);

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1608);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1607);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_RECIPE_TYPES, function (state, recipeTypes) {
	  state.all = recipeTypes;
	});

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1611);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1610);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_SHIPPING_P;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_SHIPPING_P = {}, _defineProperty(_FETCH_ALL_SHIPPING_P, _mutationTypes.FETCH_ALL_SHIPPING_PROVIDERS, function (state, shippingProviders) {
	  state.all = shippingProviders;
	}), _defineProperty(_FETCH_ALL_SHIPPING_P, _mutationTypes.FETCH_CURRENT_SHIPPING_PROVIDER, function (state, shippingProvider) {
	  state.currentShippingProvider = shippingProvider;
	}), _FETCH_ALL_SHIPPING_P);

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  currentShippingProvider: []
	};

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1614);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1613);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TOGGLE_INNERSIDEBAR$;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_TOGGLE_INNERSIDEBAR$ = {}, _defineProperty(_TOGGLE_INNERSIDEBAR$, _mutationTypes.TOGGLE_INNERSIDEBAR, function (state) {
	  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  state.innerSidebarState = status !== null && status !== undefined ? status : !state.innerSidebarState;
	}), _defineProperty(_TOGGLE_INNERSIDEBAR$, _mutationTypes.DISABLE_INNERSIDEBAR, function (state) {
	  state.innerSidebarDisabled = true;
	}), _defineProperty(_TOGGLE_INNERSIDEBAR$, _mutationTypes.ENABLE_INNERSIDEBAR, function (state) {
	  state.innerSidebarDisabled = false;
	}), _defineProperty(_TOGGLE_INNERSIDEBAR$, _mutationTypes.SET_INNERSIDEBAR, function (state, content) {
	  state.innerSidebar = content;
	}), _defineProperty(_TOGGLE_INNERSIDEBAR$, _mutationTypes.UNSET_INNERSIDEBAR, function (state) {
	  state.innerSidebar = [];
	}), _TOGGLE_INNERSIDEBAR$);

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  innerSidebarState: false,
	  innerSidebarDisabled: false,
	  innerSidebar: []
	};

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1617);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1616);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_SITELANGUAGES, function (state, _ref) {
	  var siteLanguagesData = _ref.siteLanguagesData;
	
	  state.all = siteLanguagesData;
	});

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1620);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1619);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_STOCKS$FET;
	
	var _mutationTypes = __webpack_require__(10);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_STOCKS$FET = {}, _defineProperty(_FETCH_ALL_STOCKS$FET, _mutationTypes.FETCH_ALL_STOCKS, function (state, stocks) {
	  state.all = stocks;
	}), _defineProperty(_FETCH_ALL_STOCKS$FET, _mutationTypes.FETCH_PAGINATE_STOCKS, function (state, _ref) {
	  var stocks = _ref.stocks,
	      pagination = _ref.pagination;
	
	  state.items = stocks;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_ALL_STOCKS$FET, _mutationTypes.FETCH_CURRENT_STOCK, function (state, stock) {
	  state.currentStock = stock;
	}), _defineProperty(_FETCH_ALL_STOCKS$FET, _mutationTypes.FETCH_CURRENT_STOCK_PRODUCTS, function (state, products) {
	  state.stockProducts = products;
	}), _defineProperty(_FETCH_ALL_STOCKS$FET, _mutationTypes.PUSH_TO_STOCK_PRODUCTS, function (state, product) {
	  state.stockProducts.push(product);
	}), _defineProperty(_FETCH_ALL_STOCKS$FET, _mutationTypes.REFRESH_STOCK_PRODUCTS, function (state) {
	  state.stockProducts = [];
	}), _defineProperty(_FETCH_ALL_STOCKS$FET, _mutationTypes.EDIT_TO_STOCK_PRODUCTS, function (state, _ref2) {
	  var data = _ref2.data,
	      i = _ref2.i;
	
	  state.stockProducts[i] = data;
	}), _defineProperty(_FETCH_ALL_STOCKS$FET, _mutationTypes.REFRESH_STOCK_PRODUCTS_CUSTOM, function (state) {
	  state.stockProductsCustom = [];
	}), _defineProperty(_FETCH_ALL_STOCKS$FET, _mutationTypes.FETCH_CURRENT_STOCK_PRODUCTS_CUSTOM, function (state, products) {
	  state.stockProductsCustom = products;
	}), _defineProperty(_FETCH_ALL_STOCKS$FET, _mutationTypes.UPDATE_TO_STOCK_PRODUCTS, function (state, _ref3) {
	  var data = _ref3.data,
	      i = _ref3.i;
	
	  _vue2.default.set(state.stockProductsCustom, i, data);
	}), _defineProperty(_FETCH_ALL_STOCKS$FET, _mutationTypes.DELETE_TO_STOCK_PRODUCTS, function (state, i) {
	  state.stockProducts.splice(i, 1);
	}), _defineProperty(_FETCH_ALL_STOCKS$FET, _mutationTypes.PUSH_TO_STOCK_PRODUCTS_CUSTOM, function (state, product) {
	  state.stockProductsCustom.push(product);
	}), _defineProperty(_FETCH_ALL_STOCKS$FET, _mutationTypes.DELETE_FROM_STOCK_PRODUCTS_CUSTOM, function (state, i) {
	  state.stockProductsCustom.splice(i, 1);
	}), _defineProperty(_FETCH_ALL_STOCKS$FET, _mutationTypes.SET_STOCK_SELECTED_WAREHOUSE, function (state, warehouseId) {
	  state.warehouseId = warehouseId;
	}), _FETCH_ALL_STOCKS$FET);

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  currentStock: [],
	  stockProducts: [],
	  stockProductsCustom: [],
	  warehouseId: 0
	};

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1623);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1622);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_SUBSCRIBER;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_SUBSCRIBER = {}, _defineProperty(_FETCH_ALL_SUBSCRIBER, _mutationTypes.FETCH_ALL_SUBSCRIBER, function (state, subscriber) {
	  state.all = subscriber;
	}), _defineProperty(_FETCH_ALL_SUBSCRIBER, _mutationTypes.FETCH_PAGINATED_SUBSCRIBER, function (state, _ref) {
	  var subscriber = _ref.subscriber,
	      pagination = _ref.pagination;
	
	  state.items = subscriber;
	  state.pagination = pagination;
	}), _FETCH_ALL_SUBSCRIBER);

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1626);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1625);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_PAGINATED_SUBS;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_PAGINATED_SUBS = {}, _defineProperty(_FETCH_PAGINATED_SUBS, _mutationTypes.FETCH_PAGINATED_SUBSCRIBER_LIST, function (state, _ref) {
	  var subscriberList = _ref.subscriberList,
	      pagination = _ref.pagination;
	
	  state.items = subscriberList;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_PAGINATED_SUBS, _mutationTypes.FETCH_ALL_SUBSCRIBER_LIST, function (state, subscriberList) {
	  state.all = subscriberList;
	}), _defineProperty(_FETCH_PAGINATED_SUBS, _mutationTypes.FETCH_CURRENT_SUBSCRIBER_LIST, function (state, subscriberList) {
	  state.current = subscriberList;
	}), _defineProperty(_FETCH_PAGINATED_SUBS, _mutationTypes.SET_MODIFIED_CLIENT_GROUP, function (state, modifiedClientGroup) {
	  state.modifiedClientGroup = modifiedClientGroup;
	}), _defineProperty(_FETCH_PAGINATED_SUBS, _mutationTypes.SET_CANCEL_CLIENT_GROUP_ADD, function (state, cancelClientGroupAdd) {
	  state.cancelClientGroupAdd = cancelClientGroupAdd;
	}), _FETCH_PAGINATED_SUBS);

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  current: [],
	  currentClientGroup: 0,
	  modifiedClientGroup: [],
	  cancelClientGroupAdd: false
	};

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1629);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1628);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_SUPPLIERS$;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_SUPPLIERS$ = {}, _defineProperty(_FETCH_ALL_SUPPLIERS$, _mutationTypes.FETCH_ALL_SUPPLIERS, function (state, suppliers) {
	  state.all = suppliers;
	}), _defineProperty(_FETCH_ALL_SUPPLIERS$, _mutationTypes.FETCH_PAGINATE_SUPPLIERS, function (state, _ref) {
	  var suppliers = _ref.suppliers,
	      pagination = _ref.pagination;
	
	  state.items = suppliers;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_ALL_SUPPLIERS$, _mutationTypes.FETCH_CURRENT_SUPPLIER, function (state, supplier) {
	  state.currentSupplier = supplier;
	}), _FETCH_ALL_SUPPLIERS$);

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  currentSupplier: []
	};

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1632);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1631);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_TAXES, function (state, _ref) {
	  var taxes = _ref.taxes;
	
	  state.all = taxes;
	});

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  }
	};

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1635);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1634);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_ALL_TRANSACTION_TYPES, function (state, transactionTypes) {
	  state.transactionTypes = transactionTypes;
	});

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  transactionTypes: []
	};

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1638);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1637);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_TRANSFERS$;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_TRANSFERS$ = {}, _defineProperty(_FETCH_ALL_TRANSFERS$, _mutationTypes.FETCH_ALL_TRANSFERS, function (state, transfers) {
	  state.all = transfers;
	}), _defineProperty(_FETCH_ALL_TRANSFERS$, _mutationTypes.FETCH_PAGINATE_TRANSFERS, function (state, _ref) {
	  var transfers = _ref.transfers,
	      pagination = _ref.pagination;
	
	  state.items = transfers;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_ALL_TRANSFERS$, _mutationTypes.FETCH_CURRENT_TRANSFER, function (state, transfer) {
	  state.currentTransfer = transfer;
	}), _FETCH_ALL_TRANSFERS$);

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  currentTransfer: [],
	  stockProducts: []
	};

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1641);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1640);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_UNIT_OF_ME;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_UNIT_OF_ME = {}, _defineProperty(_FETCH_ALL_UNIT_OF_ME, _mutationTypes.FETCH_ALL_UNIT_OF_MEASURES, function (state, unitOfMeasures) {
	  state.all = unitOfMeasures;
	}), _defineProperty(_FETCH_ALL_UNIT_OF_ME, _mutationTypes.FETCH_PAGINATE_UNIT_OF_MEASURES, function (state, _ref) {
	  var unitOfMeasures = _ref.unitOfMeasures,
	      pagination = _ref.pagination;
	
	  state.items = unitOfMeasures;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_ALL_UNIT_OF_ME, _mutationTypes.FETCH_CURRENT_UNIT_OF_MEASURES, function (state, unitOfMeasure) {
	  state.currentUnitOfMeasure = unitOfMeasure;
	}), _FETCH_ALL_UNIT_OF_ME);

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  currentUnitOfMeasure: []
	};

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1644);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1643);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _defineProperty({}, _mutationTypes.FETCH_UNIT_TYPES, function (state, unitTypes) {
	  state.all = unitTypes;
	});

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: []
	};

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1647);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1646);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TYPE_OF_VIEW$TYPE_OF;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_TYPE_OF_VIEW$TYPE_OF = {}, _defineProperty(_TYPE_OF_VIEW$TYPE_OF, _mutationTypes.TYPE_OF_VIEW, function (state, view) {
	  state.view = view;
	}), _defineProperty(_TYPE_OF_VIEW$TYPE_OF, _mutationTypes.TYPE_OF_ORDER_VIEW, function (state, orderViewType) {
	  state.orderViewType = orderViewType;
	}), _TYPE_OF_VIEW$TYPE_OF);

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  view: 'card',
	  orderViewType: 'all'
	};

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(1650);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(1649);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  state: _state2.default,
	  mutations: _mutations2.default
	};

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FETCH_ALL_WAREHOUSES;
	
	var _mutationTypes = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_FETCH_ALL_WAREHOUSES = {}, _defineProperty(_FETCH_ALL_WAREHOUSES, _mutationTypes.FETCH_ALL_WAREHOUSES, function (state, warehouses) {
	  state.all = warehouses;
	}), _defineProperty(_FETCH_ALL_WAREHOUSES, _mutationTypes.FETCH_PAGINATE_WAREHOUSES, function (state, _ref) {
	  var warehouses = _ref.warehouses,
	      pagination = _ref.pagination;
	
	  state.items = warehouses;
	  state.pagination = pagination;
	}), _defineProperty(_FETCH_ALL_WAREHOUSES, _mutationTypes.FETCH_CURRENT_WAREHOUSE, function (state, warehouse) {
	  state.currentWarehouse = warehouse;
	}), _defineProperty(_FETCH_ALL_WAREHOUSES, _mutationTypes.FETCH_PAGINATE_WAREHOUSE_PRODUCTS, function (state, _ref2) {
	  var products = _ref2.products,
	      pagination = _ref2.pagination;
	
	  state.products.items = products;
	  state.products.pagination = pagination;
	}), _defineProperty(_FETCH_ALL_WAREHOUSES, _mutationTypes.FETCH_ALL_WAREHOUSE_TRANSACTIONS, function (state, transactions) {
	  state.transactions = transactions;
	}), _defineProperty(_FETCH_ALL_WAREHOUSES, _mutationTypes.FETCH_ALL_WAREHOUSE_TRANSACTIONSV2, function (state, transactionsV2All) {
	  state.transactionsV2All = transactionsV2All;
	}), _defineProperty(_FETCH_ALL_WAREHOUSES, _mutationTypes.FETCH_PAGINATE_WAREHOUSE_TRANSACTIONSV2, function (state, _ref3) {
	  var transactions = _ref3.transactions,
	      pagination = _ref3.pagination;
	
	  state.transactionsV2.items = transactions;
	  state.transactionsV2.pagination = pagination;
	}), _FETCH_ALL_WAREHOUSES);

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  all: [],
	  items: [],
	  pagination: {
	    currentPage: 1,
	    lastPage: 0,
	    limit: 5,
	    totalCount: 0
	  },
	  currentWarehouse: [],
	
	  products: {
	    items: [],
	    pagination: {
	      currentPage: 1,
	      lastPage: 0,
	      limit: 5,
	      totalCount: 0
	    }
	  },
	  transactions: [],
	  transactionsV2All: [],
	  transactionsV2: {
	    items: [],
	    pagination: {
	      currentPage: 1,
	      lastPage: 0,
	      limit: 5,
	      totalCount: 0
	    }
	  }
	};

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdditionalCodeTransformer = function (_Transformer) {
	  _inherits(AdditionalCodeTransformer, _Transformer);
	
	  function AdditionalCodeTransformer() {
	    _classCallCheck(this, AdditionalCodeTransformer);
	
	    return _possibleConstructorReturn(this, (AdditionalCodeTransformer.__proto__ || Object.getPrototypeOf(AdditionalCodeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(AdditionalCodeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(code) {
	      return {
	        id: code.id,
	        code: code.code,
	        factor: code.factor,
	        description: code.description,
	        vatable: code.vatable,
	        excisable: code.excisable
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(code) {
	      return {
	        id: code.id
	      };
	    }
	  }]);
	
	  return AdditionalCodeTransformer;
	}(_transformer2.default);
	
	exports.default = AdditionalCodeTransformer;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addressTypeTransformer = function (_Transformer) {
	  _inherits(addressTypeTransformer, _Transformer);
	
	  function addressTypeTransformer() {
	    _classCallCheck(this, addressTypeTransformer);
	
	    return _possibleConstructorReturn(this, (addressTypeTransformer.__proto__ || Object.getPrototypeOf(addressTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(addressTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(addressType) {
	      return {
	        id: addressType.id,
	        name: addressType.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(addressType) {
	      return {
	        id: addressType.id,
	        name: addressType.name
	      };
	    }
	  }]);
	
	  return addressTypeTransformer;
	}(_transformer2.default);
	
	exports.default = addressTypeTransformer;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdjustmentProductTransformer = function (_Transformer) {
	  _inherits(AdjustmentProductTransformer, _Transformer);
	
	  function AdjustmentProductTransformer() {
	    _classCallCheck(this, AdjustmentProductTransformer);
	
	    return _possibleConstructorReturn(this, (AdjustmentProductTransformer.__proto__ || Object.getPrototypeOf(AdjustmentProductTransformer)).apply(this, arguments));
	  }
	
	  _createClass(AdjustmentProductTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(adjustment) {
	      return {
	        id: adjustment.id,
	        qty: adjustment.qty,
	        batchId: adjustment.batch_id,
	        product_id: adjustment.product_id,
	        adjustment_id: adjustment.adjustment_id,
	        exciseAdditionalCode: adjustment.excise_additional_code,
	        product: adjustment.product !== undefined ? _product2.default.fetch(adjustment.product) : []
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(adjustment) {
	      var productId = _typeof(adjustment.productId) === 'object' ? adjustment.productId.id : adjustment.productId;
	      return {
	        qty: adjustment.qty,
	        batch_id: adjustment.batchId,
	        id: productId
	      };
	    }
	  }]);
	
	  return AdjustmentProductTransformer;
	}(_transformer2.default);
	
	exports.default = AdjustmentProductTransformer;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AggregatedSalesReportTransformer = function (_Transformer) {
	  _inherits(AggregatedSalesReportTransformer, _Transformer);
	
	  function AggregatedSalesReportTransformer() {
	    _classCallCheck(this, AggregatedSalesReportTransformer);
	
	    return _possibleConstructorReturn(this, (AggregatedSalesReportTransformer.__proto__ || Object.getPrototypeOf(AggregatedSalesReportTransformer)).apply(this, arguments));
	  }
	
	  _createClass(AggregatedSalesReportTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(row) {
	      return {
	        productId: row.product_id || null,
	        productName: row.product_name || null,
	        productNumber: row.product_number || null,
	        clientId: row.client_id || null,
	        clientName: row.client_name || null,
	        clientNumber: row.client_number || null,
	        clientTypeId: row.client_type_id || null,
	        clientTypeName: row.client_type_name || null,
	        period: row.period || null,
	        totalVolumeLiters: parseFloat(row.total_volume_liters) || 0,
	        totalRevenueNet: parseFloat(row.total_revenue_net) || 0,
	        totalRevenueGross: parseFloat(row.total_revenue_gross) || 0,
	        orderCount: parseInt(row.order_count, 10) || 0,
	        totalQuantityUnits: parseFloat(row.total_quantity_units) || 0
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send() {
	      return {};
	    }
	  }]);
	
	  return AggregatedSalesReportTransformer;
	}(_transformer2.default);
	
	exports.default = AggregatedSalesReportTransformer;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BillPaymentTransformer = function (_Transformer) {
	  _inherits(BillPaymentTransformer, _Transformer);
	
	  function BillPaymentTransformer() {
	    _classCallCheck(this, BillPaymentTransformer);
	
	    return _possibleConstructorReturn(this, (BillPaymentTransformer.__proto__ || Object.getPrototypeOf(BillPaymentTransformer)).apply(this, arguments));
	  }
	
	  _createClass(BillPaymentTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(billPayment) {
	      return {
	        billId: billPayment.bill_id,
	        paymentMethod: billPayment.payment_method,
	        amountPaid: billPayment.amount_paid,
	        paymentDate: billPayment.payment_date,
	        reference: billPayment.reference,
	        internalNote: billPayment.internal_note
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(billPayment) {
	      return {
	        id: billPayment.id,
	        is_fully_paid: billPayment.isFullyPaid,
	        payment_method: billPayment.paymentMethod,
	        amount_paid: billPayment.amountPaid,
	        payment_date: billPayment.paymentDate,
	        reference: billPayment.reference,
	        internal_note: billPayment.internalNote
	      };
	    }
	  }]);
	
	  return BillPaymentTransformer;
	}(_transformer2.default);
	
	exports.default = BillPaymentTransformer;

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var billStatusesTransformer = function (_Transformer) {
	  _inherits(billStatusesTransformer, _Transformer);
	
	  function billStatusesTransformer() {
	    _classCallCheck(this, billStatusesTransformer);
	
	    return _possibleConstructorReturn(this, (billStatusesTransformer.__proto__ || Object.getPrototypeOf(billStatusesTransformer)).apply(this, arguments));
	  }
	
	  _createClass(billStatusesTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(billStatuses) {
	      return {
	        id: billStatuses.id,
	        status: billStatuses.status
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(billStatuses) {
	      return {
	        id: billStatuses.id,
	        status: billStatuses.status
	      };
	    }
	  }]);
	
	  return billStatusesTransformer;
	}(_transformer2.default);
	
	exports.default = billStatusesTransformer;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var billTypeTransformer = function (_Transformer) {
	  _inherits(billTypeTransformer, _Transformer);
	
	  function billTypeTransformer() {
	    _classCallCheck(this, billTypeTransformer);
	
	    return _possibleConstructorReturn(this, (billTypeTransformer.__proto__ || Object.getPrototypeOf(billTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(billTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(billTypes) {
	      return {
	        id: billTypes.id,
	        name: billTypes.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(billTypes) {
	      return {
	        id: billTypes.id,
	        name: billTypes.name
	      };
	    }
	  }]);
	
	  return billTypeTransformer;
	}(_transformer2.default);
	
	exports.default = billTypeTransformer;

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BillsReportTransformer = function (_Transformer) {
	  _inherits(BillsReportTransformer, _Transformer);
	
	  function BillsReportTransformer() {
	    _classCallCheck(this, BillsReportTransformer);
	
	    return _possibleConstructorReturn(this, (BillsReportTransformer.__proto__ || Object.getPrototypeOf(BillsReportTransformer)).apply(this, arguments));
	  }
	
	  _createClass(BillsReportTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(item) {
	      return {
	        invoiceNumber: item.billing_number,
	        billTypeName: item.bill_type_name,
	        status: item.status,
	        invoiceDate: item.bill_date,
	        dueDate: item.due_date,
	        customer: item.customer,
	        email: item.email,
	        address: item.address,
	        sum: item.sum ? item.sum : 0,
	        vat: item.vat ? item.vat : 0,
	        invoiceAmount: item.invoice_amount ? item.invoice_amount : 0,
	        balance: item.balance ? item.balance : 0,
	        id: item.id
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send() {
	      return {};
	    }
	  }]);
	
	  return BillsReportTransformer;
	}(_transformer2.default);
	
	exports.default = BillsReportTransformer;

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookingTransformer = function (_Transformer) {
	  _inherits(BookingTransformer, _Transformer);
	
	  function BookingTransformer() {
	    _classCallCheck(this, BookingTransformer);
	
	    return _possibleConstructorReturn(this, (BookingTransformer.__proto__ || Object.getPrototypeOf(BookingTransformer)).apply(this, arguments));
	  }
	
	  _createClass(BookingTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(item) {
	      return {
	        id: item.id,
	        orderId: item.order_id,
	        date: item.date,
	        endTime: item.end_time,
	        startTime: item.start_time,
	        durations: item.durations
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(item) {
	      return {
	        id: item.id
	      };
	    }
	  }]);
	
	  return BookingTransformer;
	}(_transformer2.default);
	
	exports.default = BookingTransformer;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var businessDaysTransformer = function (_Transformer) {
	  _inherits(businessDaysTransformer, _Transformer);
	
	  function businessDaysTransformer() {
	    _classCallCheck(this, businessDaysTransformer);
	
	    return _possibleConstructorReturn(this, (businessDaysTransformer.__proto__ || Object.getPrototypeOf(businessDaysTransformer)).apply(this, arguments));
	  }
	
	  _createClass(businessDaysTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(businessDay) {
	      return {
	        id: businessDay.id,
	        day: businessDay.day
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(businessDay) {
	      return {
	        id: businessDay.id,
	        day: businessDay.day
	      };
	    }
	  }]);
	
	  return businessDaysTransformer;
	}(_transformer2.default);
	
	exports.default = businessDaysTransformer;

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var campaignTypeTransformer = function (_Transformer) {
	  _inherits(campaignTypeTransformer, _Transformer);
	
	  function campaignTypeTransformer() {
	    _classCallCheck(this, campaignTypeTransformer);
	
	    return _possibleConstructorReturn(this, (campaignTypeTransformer.__proto__ || Object.getPrototypeOf(campaignTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(campaignTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(campaignTypes) {
	      return {
	        id: campaignTypes.id,
	        name: campaignTypes.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(campaignTypes) {
	      return {
	        id: campaignTypes.id,
	        name: campaignTypes.name
	      };
	    }
	  }]);
	
	  return campaignTypeTransformer;
	}(_transformer2.default);
	
	exports.default = campaignTypeTransformer;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var contactTypeTransformer = function (_Transformer) {
	  _inherits(contactTypeTransformer, _Transformer);
	
	  function contactTypeTransformer() {
	    _classCallCheck(this, contactTypeTransformer);
	
	    return _possibleConstructorReturn(this, (contactTypeTransformer.__proto__ || Object.getPrototypeOf(contactTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(contactTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(contactType) {
	      return {
	        id: contactType.id,
	        name: contactType.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(contactType) {
	      return {
	        id: contactType.id,
	        name: contactType.name
	      };
	    }
	  }]);
	
	  return contactTypeTransformer;
	}(_transformer2.default);
	
	exports.default = contactTypeTransformer;

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var creditNoteReasonTransformer = function (_Transformer) {
	  _inherits(creditNoteReasonTransformer, _Transformer);
	
	  function creditNoteReasonTransformer() {
	    _classCallCheck(this, creditNoteReasonTransformer);
	
	    return _possibleConstructorReturn(this, (creditNoteReasonTransformer.__proto__ || Object.getPrototypeOf(creditNoteReasonTransformer)).apply(this, arguments));
	  }
	
	  _createClass(creditNoteReasonTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(creditNoteReasons) {
	      return {
	        creditNoteReasonId: creditNoteReasons.id,
	        creditNoteReasonType: creditNoteReasons.type,
	        creditNoteReasonAttributes: creditNoteReasons.attributes,
	        creditNoteReasonExclusiveToPlans: creditNoteReasons.exclusive_to_plans,
	        creditNoteReasonDescription: creditNoteReasons.description
	      };
	    }
	  }]);
	
	  return creditNoteReasonTransformer;
	}(_transformer2.default);
	
	exports.default = creditNoteReasonTransformer;

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var currencyTransformer = function (_Transformer) {
	  _inherits(currencyTransformer, _Transformer);
	
	  function currencyTransformer() {
	    _classCallCheck(this, currencyTransformer);
	
	    return _possibleConstructorReturn(this, (currencyTransformer.__proto__ || Object.getPrototypeOf(currencyTransformer)).apply(this, arguments));
	  }
	
	  _createClass(currencyTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(currency) {
	      return {
	        id: currency.id,
	        name: currency.name,
	        code: currency.code
	      };
	    }
	  }]);
	
	  return currencyTransformer;
	}(_transformer2.default);
	
	exports.default = currencyTransformer;

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PersonalInfoTransformer = function (_Transformer) {
	  _inherits(PersonalInfoTransformer, _Transformer);
	
	  function PersonalInfoTransformer() {
	    _classCallCheck(this, PersonalInfoTransformer);
	
	    return _possibleConstructorReturn(this, (PersonalInfoTransformer.__proto__ || Object.getPrototypeOf(PersonalInfoTransformer)).apply(this, arguments));
	  }
	
	  _createClass(PersonalInfoTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(personalInfo) {
	      return {
	        phoneNumber: personalInfo.phone_number,
	        streetName: personalInfo.street_name,
	        secondStreetName: personalInfo.second_street_name,
	        postalCode: personalInfo.postal_code,
	        cityName: personalInfo.city_name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(personalInfo) {
	      return {
	        phone_number: personalInfo.phoneNumber,
	        street_name: personalInfo.streetName,
	        second_street_name: personalInfo.secondStreetName,
	        postal_code: personalInfo.postalCode
	      };
	    }
	  }]);
	
	  return PersonalInfoTransformer;
	}(_transformer2.default);
	
	exports.default = PersonalInfoTransformer;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DepositSystemTransformer = function (_Transformer) {
	  _inherits(DepositSystemTransformer, _Transformer);
	
	  function DepositSystemTransformer() {
	    _classCallCheck(this, DepositSystemTransformer);
	
	    return _possibleConstructorReturn(this, (DepositSystemTransformer.__proto__ || Object.getPrototypeOf(DepositSystemTransformer)).apply(this, arguments));
	  }
	
	  _createClass(DepositSystemTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(item) {
	      return {
	        id: item.id,
	        name: item.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(item) {
	      return {
	        id: item.id,
	        name: item.name
	      };
	    }
	  }]);
	
	  return DepositSystemTransformer;
	}(_transformer2.default);
	
	exports.default = DepositSystemTransformer;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExciseReportTransformer = function (_Transformer) {
	  _inherits(ExciseReportTransformer, _Transformer);
	
	  function ExciseReportTransformer() {
	    _classCallCheck(this, ExciseReportTransformer);
	
	    return _possibleConstructorReturn(this, (ExciseReportTransformer.__proto__ || Object.getPrototypeOf(ExciseReportTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ExciseReportTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(entry) {
	      return {
	        group: entry.title,
	        description: entry.description,
	        totalQuantity: entry.total_quantity,
	        unitType: entry.unit_type,
	        totalVolume: entry.total_volume,
	        exciseEntries: entry.excise_entries
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(entry) {
	      return {
	        id: entry.id
	      };
	    }
	  }]);
	
	  return ExciseReportTransformer;
	}(_transformer2.default);
	
	exports.default = ExciseReportTransformer;

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeesReportTransformer = function (_Transformer) {
	  _inherits(FeesReportTransformer, _Transformer);
	
	  function FeesReportTransformer() {
	    _classCallCheck(this, FeesReportTransformer);
	
	    return _possibleConstructorReturn(this, (FeesReportTransformer.__proto__ || Object.getPrototypeOf(FeesReportTransformer)).apply(this, arguments));
	  }
	
	  _createClass(FeesReportTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(item) {
	      return {
	        productType: item.product_type,
	        internalItemNumber: item.internal_item_number,
	        externalItemNumber: item.external_item_number,
	        productName: item.product_name,
	        producerName: item.producer_name,
	        vintage: item.vintage,
	        alcoholPercentage: item.alcohol_percentage,
	        bottleVolume: item.bottle_volume,
	        packagingType: item.packaging_type,
	        corkType: item.cork_type,
	        excisable: item.excisable,
	        numberOfBottlesSold: item.number_of_bottles_sold,
	        numberOfLitersSold: item.number_of_liters_sold,
	        id: item.id,
	        productId: item.product_id,
	        orderProducts: item.order_products,
	        number: item.number
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send() {
	      return {};
	    }
	  }]);
	
	  return FeesReportTransformer;
	}(_transformer2.default);
	
	exports.default = FeesReportTransformer;

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _fieldType = __webpack_require__(1670);
	
	var _fieldType2 = _interopRequireDefault(_fieldType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FieldTransformer = function (_Transformer) {
	  _inherits(FieldTransformer, _Transformer);
	
	  function FieldTransformer() {
	    _classCallCheck(this, FieldTransformer);
	
	    return _possibleConstructorReturn(this, (FieldTransformer.__proto__ || Object.getPrototypeOf(FieldTransformer)).apply(this, arguments));
	  }
	
	  _createClass(FieldTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(model) {
	      return {
	        id: model.id,
	        name: model.name,
	        fieldType: model.field_type !== undefined ? _fieldType2.default.fetch(model.field_type) : [],
	        isRequired: model.is_required,
	        defaultValue: model.default_value,
	        createdAt: model.created_at,
	        options: model.options
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(model) {
	      return {
	        id: model.id,
	        name: model.name
	      };
	    }
	  }]);
	
	  return FieldTransformer;
	}(_transformer2.default);
	
	exports.default = FieldTransformer;

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FieldTypeTransformer = function (_Transformer) {
	  _inherits(FieldTypeTransformer, _Transformer);
	
	  function FieldTypeTransformer() {
	    _classCallCheck(this, FieldTypeTransformer);
	
	    return _possibleConstructorReturn(this, (FieldTypeTransformer.__proto__ || Object.getPrototypeOf(FieldTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(FieldTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(model) {
	      return {
	        id: model.id,
	        name: model.name,
	        type: model.type
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(model) {
	      return {
	        id: model.id,
	        name: model.name
	      };
	    }
	  }]);
	
	  return FieldTypeTransformer;
	}(_transformer2.default);
	
	exports.default = FieldTypeTransformer;

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var languageTransformer = function (_Transformer) {
	  _inherits(languageTransformer, _Transformer);
	
	  function languageTransformer() {
	    _classCallCheck(this, languageTransformer);
	
	    return _possibleConstructorReturn(this, (languageTransformer.__proto__ || Object.getPrototypeOf(languageTransformer)).apply(this, arguments));
	  }
	
	  _createClass(languageTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(language) {
	      return {
	        id: language.id,
	        name: language.name,
	        nationality: language.nationality
	      };
	    }
	  }]);
	
	  return languageTransformer;
	}(_transformer2.default);
	
	exports.default = languageTransformer;

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var licenseGroupTransformer = function (_Transformer) {
	  _inherits(licenseGroupTransformer, _Transformer);
	
	  function licenseGroupTransformer() {
	    _classCallCheck(this, licenseGroupTransformer);
	
	    return _possibleConstructorReturn(this, (licenseGroupTransformer.__proto__ || Object.getPrototypeOf(licenseGroupTransformer)).apply(this, arguments));
	  }
	
	  _createClass(licenseGroupTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(licenseGroup) {
	      return {
	        id: licenseGroup.id,
	        licenseTypeId: licenseGroup.license_type_id,
	        code: licenseGroup.code,
	        name: licenseGroup.name,
	        description: licenseGroup.description
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(licenseGroup) {
	      return {
	        id: licenseGroup.id,
	        name: licenseGroup.name,
	        description: licenseGroup.description
	      };
	    }
	  }]);
	
	  return licenseGroupTransformer;
	}(_transformer2.default);
	
	exports.default = licenseGroupTransformer;

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var licensePermitGroupTransformer = function (_Transformer) {
	  _inherits(licensePermitGroupTransformer, _Transformer);
	
	  function licensePermitGroupTransformer() {
	    _classCallCheck(this, licensePermitGroupTransformer);
	
	    return _possibleConstructorReturn(this, (licensePermitGroupTransformer.__proto__ || Object.getPrototypeOf(licensePermitGroupTransformer)).apply(this, arguments));
	  }
	
	  _createClass(licensePermitGroupTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(licensePermitGroup) {
	      return {
	        id: licensePermitGroup.id,
	        licensePermitId: licensePermitGroup.license_permit_id,
	        licenseGroupId: licensePermitGroup.license_group_id,
	        licenseGroup: licensePermitGroup.license_group
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(licensePermitGroup) {
	      return {
	        id: licensePermitGroup.id,
	        license_permit_id: licensePermitGroup.licensePermitId,
	        license_group_id: licensePermitGroup.licenseGroupId
	      };
	    }
	  }]);
	
	  return licensePermitGroupTransformer;
	}(_transformer2.default);
	
	exports.default = licensePermitGroupTransformer;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var licensePermitTypeTransformer = function (_Transformer) {
	  _inherits(licensePermitTypeTransformer, _Transformer);
	
	  function licensePermitTypeTransformer() {
	    _classCallCheck(this, licensePermitTypeTransformer);
	
	    return _possibleConstructorReturn(this, (licensePermitTypeTransformer.__proto__ || Object.getPrototypeOf(licensePermitTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(licensePermitTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(licensePermitType) {
	      return {
	        id: licensePermitType.id,
	        licenseTypeId: licensePermitType.license_type_id,
	        code: licensePermitType.code,
	        name: licensePermitType.name,
	        description: licensePermitType.description
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(licensePermitType) {
	      return {
	        id: licensePermitType.id,
	        name: licensePermitType.name,
	        description: licensePermitType.description
	      };
	    }
	  }]);
	
	  return licensePermitTypeTransformer;
	}(_transformer2.default);
	
	exports.default = licensePermitTypeTransformer;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var licenseTypeTransformer = function (_Transformer) {
	  _inherits(licenseTypeTransformer, _Transformer);
	
	  function licenseTypeTransformer() {
	    _classCallCheck(this, licenseTypeTransformer);
	
	    return _possibleConstructorReturn(this, (licenseTypeTransformer.__proto__ || Object.getPrototypeOf(licenseTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(licenseTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(licenseTypes) {
	      return {
	        id: licenseTypes.id,
	        name: licenseTypes.name,
	        code: licenseTypes.code
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(licenseTypes) {
	      return {
	        id: licenseTypes.id,
	        name: licenseTypes.name,
	        code: licenseTypes.code
	      };
	    }
	  }]);
	
	  return licenseTypeTransformer;
	}(_transformer2.default);
	
	exports.default = licenseTypeTransformer;

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MaterialTypeTransformer = function (_Transformer) {
	  _inherits(MaterialTypeTransformer, _Transformer);
	
	  function MaterialTypeTransformer() {
	    _classCallCheck(this, MaterialTypeTransformer);
	
	    return _possibleConstructorReturn(this, (MaterialTypeTransformer.__proto__ || Object.getPrototypeOf(MaterialTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(MaterialTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(materialType) {
	      return {
	        id: materialType.id,
	        name: materialType.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(materialType) {
	      return {
	        id: materialType.id,
	        name: materialType.name
	      };
	    }
	  }]);
	
	  return MaterialTypeTransformer;
	}(_transformer2.default);
	
	exports.default = MaterialTypeTransformer;

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageTemplateTypeTransformer = function (_Transformer) {
	  _inherits(MessageTemplateTypeTransformer, _Transformer);
	
	  function MessageTemplateTypeTransformer() {
	    _classCallCheck(this, MessageTemplateTypeTransformer);
	
	    return _possibleConstructorReturn(this, (MessageTemplateTypeTransformer.__proto__ || Object.getPrototypeOf(MessageTemplateTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(MessageTemplateTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(messageTemplateType) {
	      return {
	        id: messageTemplateType.id,
	        name: messageTemplateType.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(messageTemplateType) {
	      return {
	        id: messageTemplateType.id,
	        name: messageTemplateType.name
	      };
	    }
	  }]);
	
	  return MessageTemplateTypeTransformer;
	}(_transformer2.default);
	
	exports.default = MessageTemplateTypeTransformer;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModuleTransformer = function (_Transformer) {
	  _inherits(ModuleTransformer, _Transformer);
	
	  function ModuleTransformer() {
	    _classCallCheck(this, ModuleTransformer);
	
	    return _possibleConstructorReturn(this, (ModuleTransformer.__proto__ || Object.getPrototypeOf(ModuleTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ModuleTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(module) {
	      return {
	        id: module.id,
	        name: module.name,
	        group: module.group,
	        type: module.type,
	        subscribe: module.subscribe,
	        fields: module.fields,
	        component: module.component,
	        price: module.price,
	        description: module.description,
	        requested: module.requested,
	        disabled: module.disabled,
	        allowUpdate: module.allowUpdate
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(module) {
	      return {
	        id: module.id,
	        name: module.name
	      };
	    }
	  }]);
	
	  return ModuleTransformer;
	}(_transformer2.default);
	
	exports.default = ModuleTransformer;

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MunicipalityTransformer = function (_Transformer) {
	  _inherits(MunicipalityTransformer, _Transformer);
	
	  function MunicipalityTransformer() {
	    _classCallCheck(this, MunicipalityTransformer);
	
	    return _possibleConstructorReturn(this, (MunicipalityTransformer.__proto__ || Object.getPrototypeOf(MunicipalityTransformer)).apply(this, arguments));
	  }
	
	  _createClass(MunicipalityTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(item) {
	      return {
	        id: item.id,
	        countryId: item.country_id,
	        municipalityId: item.municipalityId,
	        name: item.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(item) {
	      return {
	        id: item.id,
	        country_id: item.countryId,
	        municipalityId: item.municipalityId,
	        name: item.name
	      };
	    }
	  }]);
	
	  return MunicipalityTransformer;
	}(_transformer2.default);
	
	exports.default = MunicipalityTransformer;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var newsStatusesTransformer = function (_Transformer) {
	  _inherits(newsStatusesTransformer, _Transformer);
	
	  function newsStatusesTransformer() {
	    _classCallCheck(this, newsStatusesTransformer);
	
	    return _possibleConstructorReturn(this, (newsStatusesTransformer.__proto__ || Object.getPrototypeOf(newsStatusesTransformer)).apply(this, arguments));
	  }
	
	  _createClass(newsStatusesTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(newsStatuses) {
	      return {
	        id: newsStatuses.id,
	        name: newsStatuses.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(newsStatuses) {
	      return {
	        id: newsStatuses.id,
	        name: newsStatuses.name
	      };
	    }
	  }]);
	
	  return newsStatusesTransformer;
	}(_transformer2.default);
	
	exports.default = newsStatusesTransformer;

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderEventTransformer = function (_Transformer) {
	  _inherits(OrderEventTransformer, _Transformer);
	
	  function OrderEventTransformer() {
	    _classCallCheck(this, OrderEventTransformer);
	
	    return _possibleConstructorReturn(this, (OrderEventTransformer.__proto__ || Object.getPrototypeOf(OrderEventTransformer)).apply(this, arguments));
	  }
	
	  _createClass(OrderEventTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(e) {
	      return {
	        id: e.id,
	        events: e.events,
	        orderId: e.order_id,
	        descriptions: e.descriptions,
	        status: e.status,
	        order: e.order,
	        createdAt: e.created_at
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(e) {
	      return {
	        id: e.id
	      };
	    }
	  }]);
	
	  return OrderEventTransformer;
	}(_transformer2.default);
	
	exports.default = OrderEventTransformer;

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderTransformer = function (_Transformer) {
	  _inherits(OrderTransformer, _Transformer);
	
	  function OrderTransformer() {
	    _classCallCheck(this, OrderTransformer);
	
	    return _possibleConstructorReturn(this, (OrderTransformer.__proto__ || Object.getPrototypeOf(OrderTransformer)).apply(this, arguments));
	  }
	
	  _createClass(OrderTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(orderType) {
	      return {
	        id: orderType.id,
	        name: orderType.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(orderType) {
	      return {
	        id: orderType.id,
	        name: orderType.name
	      };
	    }
	  }]);
	
	  return OrderTransformer;
	}(_transformer2.default);
	
	exports.default = OrderTransformer;

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrganizationMemberProductBusinessHourTransformer = function (_Transformer) {
	  _inherits(OrganizationMemberProductBusinessHourTransformer, _Transformer);
	
	  function OrganizationMemberProductBusinessHourTransformer() {
	    _classCallCheck(this, OrganizationMemberProductBusinessHourTransformer);
	
	    return _possibleConstructorReturn(this, (OrganizationMemberProductBusinessHourTransformer.__proto__ || Object.getPrototypeOf(OrganizationMemberProductBusinessHourTransformer)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationMemberProductBusinessHourTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(organizationMemberProductBusinessHour) {
	      return {
	        id: organizationMemberProductBusinessHour.id,
	        day: organizationMemberProductBusinessHour.day,
	        startTime: organizationMemberProductBusinessHour.start_time,
	        endTime: organizationMemberProductBusinessHour.end_time,
	        organizationMemberProduct: organizationMemberProductBusinessHour.organization_member_product
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(organizationMemberProductBusinessHour) {
	      return {
	        day: organizationMemberProductBusinessHour.day,
	        start_time: organizationMemberProductBusinessHour.startTime,
	        end_time: organizationMemberProductBusinessHour.endTime
	      };
	    }
	  }]);
	
	  return OrganizationMemberProductBusinessHourTransformer;
	}(_transformer2.default);
	
	exports.default = OrganizationMemberProductBusinessHourTransformer;

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrganizationTypeTransformer = function (_Transformer) {
	  _inherits(OrganizationTypeTransformer, _Transformer);
	
	  function OrganizationTypeTransformer() {
	    _classCallCheck(this, OrganizationTypeTransformer);
	
	    return _possibleConstructorReturn(this, (OrganizationTypeTransformer.__proto__ || Object.getPrototypeOf(OrganizationTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(organizationType) {
	      return {
	        id: organizationType.id,
	        name: organizationType.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(organizationType) {
	      return {
	        id: organizationType.id,
	        name: organizationType.name
	      };
	    }
	  }]);
	
	  return OrganizationTypeTransformer;
	}(_transformer2.default);
	
	exports.default = OrganizationTypeTransformer;

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var packageUnitTypeTransformer = function (_Transformer) {
	  _inherits(packageUnitTypeTransformer, _Transformer);
	
	  function packageUnitTypeTransformer() {
	    _classCallCheck(this, packageUnitTypeTransformer);
	
	    return _possibleConstructorReturn(this, (packageUnitTypeTransformer.__proto__ || Object.getPrototypeOf(packageUnitTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(packageUnitTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(packageUnitTypes) {
	      return {
	        id: packageUnitTypes.id,
	        name: packageUnitTypes.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(packageUnitTypes) {
	      return {
	        id: packageUnitTypes.id,
	        name: packageUnitTypes.name
	      };
	    }
	  }]);
	
	  return packageUnitTypeTransformer;
	}(_transformer2.default);
	
	exports.default = packageUnitTypeTransformer;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PackagingMaterialTransformer = function (_Transformer) {
	  _inherits(PackagingMaterialTransformer, _Transformer);
	
	  function PackagingMaterialTransformer() {
	    _classCallCheck(this, PackagingMaterialTransformer);
	
	    return _possibleConstructorReturn(this, (PackagingMaterialTransformer.__proto__ || Object.getPrototypeOf(PackagingMaterialTransformer)).apply(this, arguments));
	  }
	
	  _createClass(PackagingMaterialTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(packagingMaterial) {
	      return {
	        id: packagingMaterial.id,
	        name: packagingMaterial.name,
	        environmentExciseCodeId: packagingMaterial.environment_excise_code_id,
	        baseExciseCodeId: packagingMaterial.base_excise_code_id
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(packagingMaterial) {
	      return {
	        id: packagingMaterial.id,
	        name: packagingMaterial.name,
	        environment_excise_code_id: packagingMaterial.environmentExciseCodeId,
	        base_excise_code_id: packagingMaterial.baseExciseCodeId
	      };
	    }
	  }]);
	
	  return PackagingMaterialTransformer;
	}(_transformer2.default);
	
	exports.default = PackagingMaterialTransformer;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PackagingTypeTransformer = function (_Transformer) {
	  _inherits(PackagingTypeTransformer, _Transformer);
	
	  function PackagingTypeTransformer() {
	    _classCallCheck(this, PackagingTypeTransformer);
	
	    return _possibleConstructorReturn(this, (PackagingTypeTransformer.__proto__ || Object.getPrototypeOf(PackagingTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(PackagingTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(packagingType) {
	      return {
	        id: packagingType.id,
	        name: packagingType.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(packagingType) {
	      return {
	        id: packagingType.id,
	        name: packagingType.name
	      };
	    }
	  }]);
	
	  return PackagingTypeTransformer;
	}(_transformer2.default);
	
	exports.default = PackagingTypeTransformer;

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnerTransformer = function (_Transformer) {
	  _inherits(PartnerTransformer, _Transformer);
	
	  function PartnerTransformer() {
	    _classCallCheck(this, PartnerTransformer);
	
	    return _possibleConstructorReturn(this, (PartnerTransformer.__proto__ || Object.getPrototypeOf(PartnerTransformer)).apply(this, arguments));
	  }
	
	  _createClass(PartnerTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(partner) {
	      return {
	        id: partner.id,
	        name: partner.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(partner) {
	      return {
	        id: partner.id,
	        name: partner.name
	      };
	    }
	  }]);
	
	  return PartnerTransformer;
	}(_transformer2.default);
	
	exports.default = PartnerTransformer;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PasswordTransformer = function (_Transformer) {
	  _inherits(PasswordTransformer, _Transformer);
	
	  function PasswordTransformer() {
	    _classCallCheck(this, PasswordTransformer);
	
	    return _possibleConstructorReturn(this, (PasswordTransformer.__proto__ || Object.getPrototypeOf(PasswordTransformer)).apply(this, arguments));
	  }
	
	  _createClass(PasswordTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(password) {
	      return {
	        currentPassword: password.current_password,
	        password: password.password
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(password) {
	      return {
	        current_password: password.currentPassword,
	        password: password.password,
	        password_confirmation: password.passwordConfirmation
	      };
	    }
	  }]);
	
	  return PasswordTransformer;
	}(_transformer2.default);
	
	exports.default = PasswordTransformer;

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var paymentMethodTransformer = function (_Transformer) {
	  _inherits(paymentMethodTransformer, _Transformer);
	
	  function paymentMethodTransformer() {
	    _classCallCheck(this, paymentMethodTransformer);
	
	    return _possibleConstructorReturn(this, (paymentMethodTransformer.__proto__ || Object.getPrototypeOf(paymentMethodTransformer)).apply(this, arguments));
	  }
	
	  _createClass(paymentMethodTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(paymentMethod) {
	      return {
	        id: paymentMethod.id,
	        name: paymentMethod.name,
	        type: paymentMethod.type
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(paymentMethod) {
	      return {
	        id: paymentMethod.id,
	        name: paymentMethod.name,
	        type: paymentMethod.type
	      };
	    }
	  }]);
	
	  return paymentMethodTransformer;
	}(_transformer2.default);
	
	exports.default = paymentMethodTransformer;

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _productWarehouse = __webpack_require__(196);
	
	var _productWarehouse2 = _interopRequireDefault(_productWarehouse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductBasicTransformer = function (_Transformer) {
	  _inherits(ProductBasicTransformer, _Transformer);
	
	  function ProductBasicTransformer() {
	    _classCallCheck(this, ProductBasicTransformer);
	
	    return _possibleConstructorReturn(this, (ProductBasicTransformer.__proto__ || Object.getPrototypeOf(ProductBasicTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductBasicTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(product) {
	      return {
	        id: product.id,
	        name: product.name,
	        price: product.price,
	        qty: product.qty,
	        taxId: product.tax_id,
	        tax_perc: product.tax_perc,
	        productDepositId: product.product_deposit_id,
	        info: product.info,
	        stockable: product.stockable,
	        productTypeGroup: product.product_type_group,
	        productType: product.product_type,
	        warehouses: product.warehouses !== undefined ? _productWarehouse2.default.fetchCollection(product.warehouses) : []
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(product) {
	      return {
	        id: product.id,
	        name: product.name,
	        price: product.price,
	        tax_id: product.taxId,
	        product_deposit_id: product.productDepositId
	      };
	    }
	  }]);
	
	  return ProductBasicTransformer;
	}(_transformer2.default);
	
	exports.default = ProductBasicTransformer;

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductDepositTransformer = function (_Transformer) {
	  _inherits(ProductDepositTransformer, _Transformer);
	
	  function ProductDepositTransformer() {
	    _classCallCheck(this, ProductDepositTransformer);
	
	    return _possibleConstructorReturn(this, (ProductDepositTransformer.__proto__ || Object.getPrototypeOf(ProductDepositTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductDepositTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(item) {
	      return {
	        id: item.id,
	        name: item.name,
	        amount: item.amount,
	        externalId: item.external_id
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(item) {
	      return {
	        id: item.id,
	        name: item.name,
	        amount: item.amount,
	        external_id: item.externalId
	      };
	    }
	  }]);
	
	  return ProductDepositTransformer;
	}(_transformer2.default);
	
	exports.default = ProductDepositTransformer;

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductFlowOrderTransformer = function (_Transformer) {
	  _inherits(ProductFlowOrderTransformer, _Transformer);
	
	  function ProductFlowOrderTransformer() {
	    _classCallCheck(this, ProductFlowOrderTransformer);
	
	    return _possibleConstructorReturn(this, (ProductFlowOrderTransformer.__proto__ || Object.getPrototypeOf(ProductFlowOrderTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductFlowOrderTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(order) {
	      return {
	        id: order.id,
	        name: order.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(order) {
	      return {
	        id: order.id,
	        name: order.name
	      };
	    }
	  }]);
	
	  return ProductFlowOrderTransformer;
	}(_transformer2.default);
	
	exports.default = ProductFlowOrderTransformer;

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _productType = __webpack_require__(503);
	
	var _productType2 = _interopRequireDefault(_productType);
	
	var _field = __webpack_require__(1669);
	
	var _field2 = _interopRequireDefault(_field);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductFormTransformer = function (_Transformer) {
	  _inherits(ProductFormTransformer, _Transformer);
	
	  function ProductFormTransformer() {
	    _classCallCheck(this, ProductFormTransformer);
	
	    return _possibleConstructorReturn(this, (ProductFormTransformer.__proto__ || Object.getPrototypeOf(ProductFormTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductFormTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(model) {
	      return {
	        id: model.id,
	        name: model.name,
	        formType: model.form_type,
	        productType: model.product_type !== undefined ? _productType2.default.fetch(model.product_type) : [],
	        fields: model.fields !== undefined ? _field2.default.fetchCollection(model.fields) : [],
	        information: model.information,
	        createdAt: model.created_at
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(model) {
	      return {
	        id: model.id,
	        name: model.name
	      };
	    }
	  }]);
	
	  return ProductFormTransformer;
	}(_transformer2.default);
	
	exports.default = ProductFormTransformer;

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductRecommendationTransformer = function (_Transformer) {
	  _inherits(ProductRecommendationTransformer, _Transformer);
	
	  function ProductRecommendationTransformer() {
	    _classCallCheck(this, ProductRecommendationTransformer);
	
	    return _possibleConstructorReturn(this, (ProductRecommendationTransformer.__proto__ || Object.getPrototypeOf(ProductRecommendationTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductRecommendationTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(recommendation) {
	      return {
	        id: recommendation.id,
	        name: recommendation.name,
	        type: recommendation.type
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(recommendation) {
	      return {
	        id: recommendation.id,
	        name: recommendation.name,
	        type: recommendation.type
	      };
	    }
	  }]);
	
	  return ProductRecommendationTransformer;
	}(_transformer2.default);
	
	exports.default = ProductRecommendationTransformer;

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductSubtypeTransformer = function (_Transformer) {
	  _inherits(ProductSubtypeTransformer, _Transformer);
	
	  function ProductSubtypeTransformer() {
	    _classCallCheck(this, ProductSubtypeTransformer);
	
	    return _possibleConstructorReturn(this, (ProductSubtypeTransformer.__proto__ || Object.getPrototypeOf(ProductSubtypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductSubtypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(productSubtype) {
	      return {
	        id: productSubtype.id,
	        name: productSubtype.name,
	        type: productSubtype.type,
	        productType: productSubtype.product_type,
	        productTypeId: productSubtype.product_type_id
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(productSubtype) {
	      return {
	        id: productSubtype.id,
	        name: productSubtype.name,
	        type: productSubtype.type,
	        product_type: productSubtype.productType,
	        product_type_id: productSubtype.productTypeId
	      };
	    }
	  }]);
	
	  return ProductSubtypeTransformer;
	}(_transformer2.default);
	
	exports.default = ProductSubtypeTransformer;

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductTransactionTransformer = function (_Transformer) {
	  _inherits(ProductTransactionTransformer, _Transformer);
	
	  function ProductTransactionTransformer() {
	    _classCallCheck(this, ProductTransactionTransformer);
	
	    return _possibleConstructorReturn(this, (ProductTransactionTransformer.__proto__ || Object.getPrototypeOf(ProductTransactionTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductTransactionTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(transaction) {
	      return {
	        id: transaction.id,
	        transactionId: transaction.transaction_id,
	        code: transaction.code,
	        via: transaction.via,
	        qty: transaction.qty,
	        status: transaction.status,
	        createdAt: transaction.created_at,
	        warehouse: transaction.warehouse,
	        billingNumber: transaction.billing_number,
	        client: transaction.client
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(transaction) {
	      return {
	        id: transaction.id
	      };
	    }
	  }]);
	
	  return ProductTransactionTransformer;
	}(_transformer2.default);
	
	exports.default = ProductTransactionTransformer;

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductTransactionTransformer = function (_Transformer) {
	  _inherits(ProductTransactionTransformer, _Transformer);
	
	  function ProductTransactionTransformer() {
	    _classCallCheck(this, ProductTransactionTransformer);
	
	    return _possibleConstructorReturn(this, (ProductTransactionTransformer.__proto__ || Object.getPrototypeOf(ProductTransactionTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductTransactionTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(transaction) {
	      return {
	        id: transaction.id,
	        transactionId: transaction.transaction_id,
	        code: transaction.code,
	        via: transaction.via,
	        parentModelId: transaction.parent_model_id,
	        customerName: transaction.customer_name,
	        beforeQty: transaction.before_qty,
	        adjustmentQty: transaction.adjustment_qty,
	        afterQty: transaction.after_qty,
	        status: transaction.status,
	        createdAt: transaction.created_at,
	        warehouse: transaction.warehouse,
	        billingNumber: transaction.billing_number,
	        client: transaction.client,
	        batchName: transaction.batch_name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(transaction) {
	      return {
	        id: transaction.id
	      };
	    }
	  }]);
	
	  return ProductTransactionTransformer;
	}(_transformer2.default);
	
	exports.default = ProductTransactionTransformer;

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductUnCodeTransformer = function (_Transformer) {
	  _inherits(ProductUnCodeTransformer, _Transformer);
	
	  function ProductUnCodeTransformer() {
	    _classCallCheck(this, ProductUnCodeTransformer);
	
	    return _possibleConstructorReturn(this, (ProductUnCodeTransformer.__proto__ || Object.getPrototypeOf(ProductUnCodeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductUnCodeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(productUnCode) {
	      var name = productUnCode.code + ' - ' + productUnCode.title_translation_no;
	      return {
	        id: productUnCode.id,
	        key: productUnCode.key,
	        code: productUnCode.code,
	        name: name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(productUnCode) {
	      return {
	        id: productUnCode.id,
	        key: productUnCode.key,
	        code: productUnCode.code,
	        title_translation_no: productUnCode.value
	      };
	    }
	  }]);
	
	  return ProductUnCodeTransformer;
	}(_transformer2.default);
	
	exports.default = ProductUnCodeTransformer;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductVmpSyncTransformer = function (_Transformer) {
	  _inherits(ProductVmpSyncTransformer, _Transformer);
	
	  function ProductVmpSyncTransformer() {
	    _classCallCheck(this, ProductVmpSyncTransformer);
	
	    return _possibleConstructorReturn(this, (ProductVmpSyncTransformer.__proto__ || Object.getPrototypeOf(ProductVmpSyncTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ProductVmpSyncTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(product) {
	      return {
	        id: product.id,
	        name: product.name,
	        productPackagingId: product.product_packaging_id,
	        productPackagingName: product.product_packaging_name,
	        alcoholPercentage: product.alcohol_percentage,
	        ddpVmp: product.ddpVmp,
	        retailPriceVmp: product.retailPriceVmp,
	        gtin: product.gtin,
	        vmp: product.vmp,
	        country: product.country,
	        vintage: product.vintage,
	        producer: product.producer,
	        bottleVolume: product.bottle_volume,
	        packagingMaterial: product.packaging_material,
	        packagingMaterialId: product.packaging_material_id,
	        packagingName: product.packaging_name,
	        packagingQuantity: product.packaging_quantity,
	        corkType: product.cork_type,
	        lastChanged: product.last_changed,
	        syncDate: product.sync_date
	      };
	    }
	  }]);
	
	  return ProductVmpSyncTransformer;
	}(_transformer2.default);
	
	exports.default = ProductVmpSyncTransformer;

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var purchaseTransformer = function (_Transformer) {
	  _inherits(purchaseTransformer, _Transformer);
	
	  function purchaseTransformer() {
	    _classCallCheck(this, purchaseTransformer);
	
	    return _possibleConstructorReturn(this, (purchaseTransformer.__proto__ || Object.getPrototypeOf(purchaseTransformer)).apply(this, arguments));
	  }
	
	  _createClass(purchaseTransformer, null, [{
	    key: 'send',
	    value: function send(previewParams) {
	      return {
	        email_to: previewParams.email_to,
	        email_cc: previewParams.email_cc,
	        message: previewParams.message,
	        subject: previewParams.subject,
	
	        test: previewParams.test,
	        notes: previewParams.notes
	      };
	    }
	  }]);
	
	  return purchaseTransformer;
	}(_transformer2.default);
	
	exports.default = purchaseTransformer;

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _purchaseProduct = __webpack_require__(504);
	
	var _purchaseProduct2 = _interopRequireDefault(_purchaseProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PurchaseReceiveTransformer = function (_Transformer) {
	  _inherits(PurchaseReceiveTransformer, _Transformer);
	
	  function PurchaseReceiveTransformer() {
	    _classCallCheck(this, PurchaseReceiveTransformer);
	
	    return _possibleConstructorReturn(this, (PurchaseReceiveTransformer.__proto__ || Object.getPrototypeOf(PurchaseReceiveTransformer)).apply(this, arguments));
	  }
	
	  _createClass(PurchaseReceiveTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(receive) {
	      return {
	        quantity: receive.quantity,
	        qtyReceived: receive.quatity_received,
	        shortage: receive.shortage,
	        notes: receive.notes
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(receive) {
	      return {
	        receive_date: receive.receiveDate,
	        products: _purchaseProduct2.default.sendCollection(receive.products)
	      };
	    }
	  }]);
	
	  return PurchaseReceiveTransformer;
	}(_transformer2.default);
	
	exports.default = PurchaseReceiveTransformer;

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecipeTypeTransformer = function (_Transformer) {
	  _inherits(RecipeTypeTransformer, _Transformer);
	
	  function RecipeTypeTransformer() {
	    _classCallCheck(this, RecipeTypeTransformer);
	
	    return _possibleConstructorReturn(this, (RecipeTypeTransformer.__proto__ || Object.getPrototypeOf(RecipeTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(RecipeTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(recipeType) {
	      return {
	        id: recipeType.id,
	        name: recipeType.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(recipeType) {
	      return {
	        id: recipeType.id,
	        name: recipeType.name
	      };
	    }
	  }]);
	
	  return RecipeTypeTransformer;
	}(_transformer2.default);
	
	exports.default = RecipeTypeTransformer;

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReleaseNotesTransformer = function (_Transformer) {
	  _inherits(ReleaseNotesTransformer, _Transformer);
	
	  function ReleaseNotesTransformer() {
	    _classCallCheck(this, ReleaseNotesTransformer);
	
	    return _possibleConstructorReturn(this, (ReleaseNotesTransformer.__proto__ || Object.getPrototypeOf(ReleaseNotesTransformer)).apply(this, arguments));
	  }
	
	  _createClass(ReleaseNotesTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(releaseNote) {
	      return {
	        id: releaseNote.id,
	        title: releaseNote.title,
	        description: releaseNote.description,
	        module: releaseNote.module,
	        version: releaseNote.version,
	        commit: releaseNote.commit,
	        releaseSilent: releaseNote.release_silent,
	        createdAt: releaseNote.created_at
	      };
	    }
	  }]);
	
	  return ReleaseNotesTransformer;
	}(_transformer2.default);
	
	exports.default = ReleaseNotesTransformer;

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SalesReportTransformer = function (_Transformer) {
	  _inherits(SalesReportTransformer, _Transformer);
	
	  function SalesReportTransformer() {
	    _classCallCheck(this, SalesReportTransformer);
	
	    return _possibleConstructorReturn(this, (SalesReportTransformer.__proto__ || Object.getPrototypeOf(SalesReportTransformer)).apply(this, arguments));
	  }
	
	  _createClass(SalesReportTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(salesReport) {
	      return {
	        id: salesReport.id,
	        status: salesReport.status,
	        name: salesReport.name,
	        clearedInvoices: salesReport.cleared_invoices,
	        clearedCredit: salesReport.cleared_credit
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send() {
	      return {};
	    }
	  }]);
	
	  return SalesReportTransformer;
	}(_transformer2.default);
	
	exports.default = SalesReportTransformer;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimpleDetailOrderTransformer = function (_Transformer) {
	  _inherits(SimpleDetailOrderTransformer, _Transformer);
	
	  function SimpleDetailOrderTransformer() {
	    _classCallCheck(this, SimpleDetailOrderTransformer);
	
	    return _possibleConstructorReturn(this, (SimpleDetailOrderTransformer.__proto__ || Object.getPrototypeOf(SimpleDetailOrderTransformer)).apply(this, arguments));
	  }
	
	  _createClass(SimpleDetailOrderTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(item) {
	      return {
	        id: item.id,
	        name: item.number,
	        number: item.number
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(item) {
	      return {
	        id: item.id,
	        name: item.name
	      };
	    }
	  }]);
	
	  return SimpleDetailOrderTransformer;
	}(_transformer2.default);
	
	exports.default = SimpleDetailOrderTransformer;

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StockProductTransformer = function (_Transformer) {
	  _inherits(StockProductTransformer, _Transformer);
	
	  function StockProductTransformer() {
	    _classCallCheck(this, StockProductTransformer);
	
	    return _possibleConstructorReturn(this, (StockProductTransformer.__proto__ || Object.getPrototypeOf(StockProductTransformer)).apply(this, arguments));
	  }
	
	  _createClass(StockProductTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(stock) {
	      return {
	        id: stock.id,
	        qty: stock.qty,
	        product_id: stock.product_id,
	        batchId: stock.batch_id,
	        physicalCount: stock.physical_count,
	        currentCount: stock.current_count,
	        variance: stock.variance,
	        stock_id: stock.stock_id,
	        product: stock.product !== undefined ? _product2.default.fetch(stock.product) : []
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(stock) {
	      var productId = _typeof(stock.productId) === 'object' ? stock.productId.id : stock.productId;
	      return {
	        qty: stock.qty,
	        id: productId,
	        batch_id: stock.batchId,
	        variance: stock.variance,
	        physical_count: stock.physicalCount,
	        current_count: stock.currentCount
	      };
	    }
	  }]);
	
	  return StockProductTransformer;
	}(_transformer2.default);
	
	exports.default = StockProductTransformer;

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _country = __webpack_require__(307);
	
	var _country2 = _interopRequireDefault(_country);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SupplierAddressTransformer = function (_Transformer) {
	  _inherits(SupplierAddressTransformer, _Transformer);
	
	  function SupplierAddressTransformer() {
	    _classCallCheck(this, SupplierAddressTransformer);
	
	    return _possibleConstructorReturn(this, (SupplierAddressTransformer.__proto__ || Object.getPrototypeOf(SupplierAddressTransformer)).apply(this, arguments));
	  }
	
	  _createClass(SupplierAddressTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(address) {
	      return {
	        id: address.id,
	        streetName1: address.street_name_1,
	        streetName2: address.street_name_2,
	        countryId: address.country_id,
	        city: address.city,
	        postalCode: address.postal_code,
	        country: address.country !== undefined ? _country2.default.fetch(address.country) : []
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(item) {
	      return {
	        street_name_1: item.streetName1,
	        street_name_2: item.streetName2,
	        country_id: item.countryId,
	        city: item.city,
	        postal_code: item.postalCode
	      };
	    }
	  }]);
	
	  return SupplierAddressTransformer;
	}(_transformer2.default);
	
	exports.default = SupplierAddressTransformer;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SupplierContactTransformer = function (_Transformer) {
	  _inherits(SupplierContactTransformer, _Transformer);
	
	  function SupplierContactTransformer() {
	    _classCallCheck(this, SupplierContactTransformer);
	
	    return _possibleConstructorReturn(this, (SupplierContactTransformer.__proto__ || Object.getPrototypeOf(SupplierContactTransformer)).apply(this, arguments));
	  }
	
	  _createClass(SupplierContactTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(item) {
	      return {
	        id: item.id,
	        email: item.email,
	        phonenumber: item.phonenumber,
	        mobilenumber: item.mobilenumber,
	        supplierId: item.supplier_id
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(item) {
	      return {
	        phonenumber: item.phonenumber,
	        mobilenumber: item.mobilenumber,
	        supplier_id: item.supplierId,
	        email: item.email
	      };
	    }
	  }]);
	
	  return SupplierContactTransformer;
	}(_transformer2.default);
	
	exports.default = SupplierContactTransformer;

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TaxTransformer = function (_Transformer) {
	  _inherits(TaxTransformer, _Transformer);
	
	  function TaxTransformer() {
	    _classCallCheck(this, TaxTransformer);
	
	    return _possibleConstructorReturn(this, (TaxTransformer.__proto__ || Object.getPrototypeOf(TaxTransformer)).apply(this, arguments));
	  }
	
	  _createClass(TaxTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(tax) {
	      return {
	        id: tax.id,
	        taxPercentage: tax.tax_percentage
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(tax) {
	      return {
	        id: tax.id,
	        tax_percentage: tax.taxPercentage
	      };
	    }
	  }]);
	
	  return TaxTransformer;
	}(_transformer2.default);
	
	exports.default = TaxTransformer;

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TransferProductTransformer = function (_Transformer) {
	  _inherits(TransferProductTransformer, _Transformer);
	
	  function TransferProductTransformer() {
	    _classCallCheck(this, TransferProductTransformer);
	
	    return _possibleConstructorReturn(this, (TransferProductTransformer.__proto__ || Object.getPrototypeOf(TransferProductTransformer)).apply(this, arguments));
	  }
	
	  _createClass(TransferProductTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(transfer) {
	      return {
	        id: transfer.id,
	        batchId: transfer.batch_id,
	        qty: transfer.qty,
	        productId: transfer.product_id,
	        productName: transfer.product_name,
	        productSku: transfer.product_sku,
	        transferId: transfer.transfer_id,
	        batch: transfer.batch,
	        transfer: transfer.transfer
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(transfer) {
	      var productId = _typeof(transfer.productId) === 'object' ? transfer.productId.id : transfer.productId;
	      return {
	        batch_id: transfer.batchId,
	        qty: transfer.qty,
	        id: productId,
	        name: transfer.name
	      };
	    }
	  }]);
	
	  return TransferProductTransformer;
	}(_transformer2.default);
	
	exports.default = TransferProductTransformer;

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnitTypeTransformer = function (_Transformer) {
	  _inherits(UnitTypeTransformer, _Transformer);
	
	  function UnitTypeTransformer() {
	    _classCallCheck(this, UnitTypeTransformer);
	
	    return _possibleConstructorReturn(this, (UnitTypeTransformer.__proto__ || Object.getPrototypeOf(UnitTypeTransformer)).apply(this, arguments));
	  }
	
	  _createClass(UnitTypeTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(unitType) {
	      return {
	        id: unitType.id,
	        name: unitType.name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(unitType) {
	      return {
	        id: unitType.id,
	        name: unitType.name
	      };
	    }
	  }]);
	
	  return UnitTypeTransformer;
	}(_transformer2.default);
	
	exports.default = UnitTypeTransformer;

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _country = __webpack_require__(307);
	
	var _country2 = _interopRequireDefault(_country);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarehouseAddressTransformer = function (_Transformer) {
	  _inherits(WarehouseAddressTransformer, _Transformer);
	
	  function WarehouseAddressTransformer() {
	    _classCallCheck(this, WarehouseAddressTransformer);
	
	    return _possibleConstructorReturn(this, (WarehouseAddressTransformer.__proto__ || Object.getPrototypeOf(WarehouseAddressTransformer)).apply(this, arguments));
	  }
	
	  _createClass(WarehouseAddressTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(address) {
	      return {
	        id: address.id,
	        streetName1: address.street_name_1,
	        streetName2: address.street_name_2,
	        countryId: address.country_id,
	        city: address.city,
	        postalCode: address.postal_code,
	        country: address.country !== undefined ? _country2.default.fetch(address.country) : []
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(item) {
	      return {
	        street_name_1: item.streetName1,
	        street_name_2: item.streetName2,
	        country_id: item.countryId,
	        city: item.city,
	        postal_code: item.postalCode
	      };
	    }
	  }]);
	
	  return WarehouseAddressTransformer;
	}(_transformer2.default);
	
	exports.default = WarehouseAddressTransformer;

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarehouseContactTransformer = function (_Transformer) {
	  _inherits(WarehouseContactTransformer, _Transformer);
	
	  function WarehouseContactTransformer() {
	    _classCallCheck(this, WarehouseContactTransformer);
	
	    return _possibleConstructorReturn(this, (WarehouseContactTransformer.__proto__ || Object.getPrototypeOf(WarehouseContactTransformer)).apply(this, arguments));
	  }
	
	  _createClass(WarehouseContactTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(item) {
	      return {
	        id: item.id,
	        firstName: item.firstName,
	        lastName: item.lastName,
	        email: item.email,
	        phoneNumber: item.phoneNumber,
	        warehouseId: item.warehouse_id
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(item) {
	      return {
	        first_name: item.firstName,
	        last_name: item.lastName,
	        email: item.email,
	        phone_number: item.phoneNumber,
	        warehouse_id: item.warehouseId
	      };
	    }
	  }]);
	
	  return WarehouseContactTransformer;
	}(_transformer2.default);
	
	exports.default = WarehouseContactTransformer;

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	var _product = __webpack_require__(39);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarehouseProductTransformer = function (_Transformer) {
	  _inherits(WarehouseProductTransformer, _Transformer);
	
	  function WarehouseProductTransformer() {
	    _classCallCheck(this, WarehouseProductTransformer);
	
	    return _possibleConstructorReturn(this, (WarehouseProductTransformer.__proto__ || Object.getPrototypeOf(WarehouseProductTransformer)).apply(this, arguments));
	  }
	
	  _createClass(WarehouseProductTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(transaction) {
	      return {
	        id: transaction.id,
	        warehouseId: transaction.warehouse_id,
	        productId: transaction.product_id,
	        batchName: transaction.batch_name,
	        product: transaction.product !== undefined ? _product2.default.fetch(transaction.product) : [],
	        qty: transaction.qty,
	        qtyNumber: transaction.qty_number,
	        minimumStockLevel: transaction.minimum_stock_level,
	        name: transaction.name,
	        supplierName: transaction.supplier_name
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(transaction) {
	      return {
	        id: transaction.id
	      };
	    }
	  }]);
	
	  return WarehouseProductTransformer;
	}(_transformer2.default);
	
	exports.default = WarehouseProductTransformer;

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformer = __webpack_require__(6);
	
	var _transformer2 = _interopRequireDefault(_transformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WarehouseTransactionTransformer = function (_Transformer) {
	  _inherits(WarehouseTransactionTransformer, _Transformer);
	
	  function WarehouseTransactionTransformer() {
	    _classCallCheck(this, WarehouseTransactionTransformer);
	
	    return _possibleConstructorReturn(this, (WarehouseTransactionTransformer.__proto__ || Object.getPrototypeOf(WarehouseTransactionTransformer)).apply(this, arguments));
	  }
	
	  _createClass(WarehouseTransactionTransformer, null, [{
	    key: 'fetch',
	    value: function fetch(transaction) {
	      return {
	        id: transaction.id,
	        transactionId: transaction.transaction_id,
	        code: transaction.code,
	        via: transaction.via,
	        createdAt: transaction.created_at,
	        totalQty: transaction.total_qty,
	        status: transaction.status
	      };
	    }
	  }, {
	    key: 'send',
	    value: function send(transaction) {
	      return {
	        id: transaction.id
	      };
	    }
	  }]);
	
	  return WarehouseTransactionTransformer;
	}(_transformer2.default);
	
	exports.default = WarehouseTransactionTransformer;

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Errors = function () {
	  function Errors() {
	    _classCallCheck(this, Errors);
	
	    this.errors = {};
	    this.record = this.record.bind(this);
	    this.clear = this.clear.bind(this);
	  }
	
	  _createClass(Errors, [{
	    key: 'get',
	    value: function get(field) {
	      if (field === 'error' && this.errors[field]) {
	        return this.errors[field].message;
	      }
	
	      if (this.errors[field]) {
	        return this.errors[field][0];
	      }
	
	      return null;
	    }
	  }, {
	    key: 'record',
	    value: function record(errors) {
	      var _this = this;
	
	      this.errors = errors;
	      Object.keys(this.errors).forEach(function (key) {
	        if (_this.errors[key] === undefined && key !== 'error') {
	          delete _this.errors[key];
	        }
	      });
	    }
	  }, {
	    key: 'clear',
	    value: function clear(field) {
	      if (field.endsWith('Confirmation')) {
	        field = field.slice(0, field.length - 'Confirmation'.length);
	      }
	      delete this.errors[field];
	      delete this.errors.error;
	    }
	  }, {
	    key: 'has',
	    value: function has(field) {
	      return Object.prototype.hasOwnProperty.call(this.errors, field);
	    }
	  }, {
	    key: 'any',
	    value: function any() {
	      return Object.keys(this.errors).length > 0;
	    }
	  }]);
	
	  return Errors;
	}();
	
	exports.default = Errors;

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2623);
	
	__webpack_require__(2259);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _app = __webpack_require__(2758);
	
	var App = _interopRequireWildcard(_app);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(509);
	
	new _vue2.default(App).$mount('#app');

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _bootstrap = __webpack_require__(509);
	
	var _account2 = __webpack_require__(12);
	
	var _account3 = _interopRequireDefault(_account2);
	
	var _vueI18n = __webpack_require__(764);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _locale = __webpack_require__(287);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _numberFormats = __webpack_require__(440);
	
	var _numberFormats2 = _interopRequireDefault(_numberFormats);
	
	var _appVersion = __webpack_require__(444);
	
	var _appVersion2 = _interopRequireDefault(_appVersion);
	
	var _appToast = __webpack_require__(892);
	
	var _appToast2 = _interopRequireDefault(_appToast);
	
	var _newReleaseVersion = __webpack_require__(2719);
	
	var _newReleaseVersion2 = _interopRequireDefault(_newReleaseVersion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var i18n = new _vueI18n2.default({
	  locale: ("no"),
	  messages: _locale2.default,
	  numberFormats: _numberFormats2.default,
	  fallbackLocale: 'en'
	});
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false,
	      isModalShow: false,
	      latestApp: [],
	      toastSetup: {
	        config: {
	          message: this.$t('static.releaseNote.toast.message'),
	          dismissible: true,
	          duration: 10000,
	          type: 'info',
	          queue: true,
	          onClick: this.onclick,
	          container: null
	        }
	      }
	    };
	  },
	
	  store: _store2.default,
	
	  router: _bootstrap.router,
	
	  i18n: i18n,
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    toastResp: 'toastResp',
	    latestAppVersion: 'latestAppVersion'
	  })),
	
	  watch: {
	    account: function account(_account) {
	      if (_account.language) i18n.locale = _account.language;
	    },
	    latestAppVersion: function latestAppVersion(_latestAppVersion) {
	      this.latestApp = _latestAppVersion.items;
	      if (this.toastResp.items === false) this.isModalShow = false;
	      this.checkToastShow(this.latestApp);
	    },
	    toastResp: function toastResp(_toastResp) {
	      if (_toastResp.items === true) {
	        this.isModalShow = true;
	        this.modalReleaseNote();
	      }
	    },
	    $route: function $route(to, from) {
	      if (to.name !== 'auth.login' || to.path !== '/login') {
	        if (from.name === 'auth.login' || from.path === '/login') {
	          this.modalReleaseNote(false, true);
	        }
	      } else {
	        this.$toast.clear();
	      }
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    activateModal: function activateModal() {
	      this.setModalContent(function () {
	        return _newReleaseVersion2.default;
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    onclick: function onclick() {
	      this.$toast.clear();
	      Promise.resolve(_account3.default.updateUserAppToast('true')).then(function () {
	        location.reload(true);
	      });
	    },
	    modalReleaseNote: function modalReleaseNote() {
	      var _this = this;
	
	      var showModal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var onLogin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      Promise.all([_appVersion2.default.fetchUserAppVersion()]).then(function () {
	        if (_this.latestApp !== 'updated' && showModal === true) {
	          _this.isModalShow = false;
	          setTimeout(function () {
	            return _this.activateModal();
	          }, 1500);
	        }
	        if (onLogin === true && _this.latestApp !== 'updated') {
	          _this.$toast.open(_this.toastSetup.config);
	        }
	      });
	    },
	    taostResponse: function taostResponse() {
	      Promise.all([_appToast2.default.fetchUserAppToast()]).then(function () {});
	    },
	    checkToastShow: function checkToastShow(latestAppVersion) {
	      if (this.isModalShow === false && latestAppVersion !== 'updated' && this.$store.state.auth.authenticated === true) {
	        if (this.latestAppVersion.items.data.release_silent === 0) {
	          this.$toast.open(this.toastSetup.config);
	        }
	      }
	    }
	  }),
	
	  created: function created() {
	    var _this2 = this;
	
	    if (!this.$store.state.auth.authenticated) return;
	
	    this.taostResponse();
	    this.loading = true;
	    _account3.default.find().then(function () {
	      _this2.loading = false;
	    }).catch(function () {
	      _this2.loading = false;
	    });
	  }
	};

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  computed: {
	    message: function message() {
	      return this.$route.query.status && this.$route.query.status === 'success' ? this.$t('static.unsubscribed.success') : this.$t('static.unsubscribed.error');
	    }
	  }
	};

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _organizationSettings = __webpack_require__(83);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _organizationSettings3 = __webpack_require__(27);
	
	var _organizationSettings4 = _interopRequireDefault(_organizationSettings3);
	
	var _vuex = __webpack_require__(5);
	
	var _bill = __webpack_require__(92);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _date = __webpack_require__(107);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        billsDateRange: {
	          value: [(0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()],
	          type: 'dateRange'
	        },
	        description: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    providerList: 'setDownloadProviderList',
	    settings: 'organizationSettings'
	  })),
	
	  mounted: function mounted() {
	    this.getResources();
	  },
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    getResources: function getResources() {
	      var _this = this;
	
	      var requests = [];
	      if (Object.keys(this.settings).length === 0) {
	        requests.push(_organizationSettings4.default.show());
	      }
	      this.loading = true;
	      Promise.all(requests).then(function () {
	        _this.loading = false;
	      });
	    },
	    store: function store() {
	      var _this2 = this;
	
	      this.loading = false;
	      this.form.loading = true;
	      var me = this;
	
	
	      var params = {};
	
	      if (this.settings.accountingProvider) {
	        if (this.form.data().billsDateRange[0] && this.form.data().billsDateRange[1]) {
	          params.token = localStorage.getItem('id_token');
	          params.date_start = (0, _moment2.default)(this.form.data().billsDateRange[0]).format('YYYY-MM-DD');
	          params.date_stop = (0, _moment2.default)(this.form.data().billsDateRange[1]).format('YYYY-MM-DD');
	          params.provider = this.settings.accountingProvider.slug;
	          params.description = this.form.data().description;
	        }
	
	        console.log(params);
	
	        this.selectedProvider = true;
	        return new Promise(function (resolve, reject) {
	          _vue2.default.$http.post('export-create-record', params).then(function () {
	            _bill2.default.archiveReport().then(function () {
	              me.loading = false;
	              me.form.loading = false;
	              me.$message({
	                showClose: true,
	                message: me.$t('static.bills.exportBill.confirmSuccess'),
	                customClass: 'success'
	              });
	              me.closeModal();
	            });
	          }).catch(function () {
	            _this2.$message({
	              showClose: true,
	              message: _this2.$t('static.bills.exportBill.error'),
	              customClass: 'error'
	            });
	          });;
	        });
	      } else {
	        this.$message({
	          showClose: true,
	          message: this.$t('static.bills.exportBill.providerNotSet'),
	          customClass: 'error'
	        });
	      }
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13),
	    VDateRange: __webpack_require__(156)
	  },
	  mixins: [_date2.default]
	};

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _fiken = __webpack_require__(1040);
	
	var _fiken2 = _interopRequireDefault(_fiken);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({}),
	      loading: false,
	      companySlug: ''
	    };
	  },
	
	
	  props: {
	    module: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    settings: 'organizationSettings'
	  }), {
	    companies: function companies() {
	      if (this.settings.fikenCompanies) {
	        return JSON.parse(this.settings.fikenCompanies).map(function (o) {
	          return {
	            id: o.slug,
	            name: o.name
	          };
	        });
	      }
	      return [];
	    }
	  }),
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    var fields = {};
	    for (var i = 0; i < this.module.fields.length; i++) {
	      var newField = {
	        type: this.module.fields[i].type || 'text',
	        value: ''
	      };
	      fields[this.module.fields[i].name] = newField;
	    }
	
	    this.form = new _forms2.default(fields);
	    _organizationSettings2.default.show().then(function () {
	      _this.form.setOptions('fiken_company_slug', _this.companies);
	      _this.loading = false;
	    }).catch(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    authorize: function authorize() {
	      if (!this.settings.hasFikenToken) {
	        window.location.href = ("https://api.kundan.no") + '/fiken/authenticate?token=' + localStorage.getItem('id_token');
	      } else {
	        this.subscribe();
	      }
	    },
	    getResources: function getResources() {},
	    subscribe: function subscribe() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var obj = Object.assign({ module_id: this.module.id }, this.form.data());
	      _modules2.default.subscribe(this.module.id, obj).then(function () {
	        Promise.all([_fiken2.default.sync(), _modules2.default.items()]).then(function () {
	          _this2.closeModal();
	        });
	      }).catch(function (error) {
	        var message = error.data ? error.data.message : 'Field Required';
	        _this2.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	        _this2.form.recordErrors(error);
	        _this2.form.loading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _poweroffice = __webpack_require__(1170);
	
	var _poweroffice2 = _interopRequireDefault(_poweroffice);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({}),
	      loading: false,
	      integrationType: ''
	    };
	  },
	
	
	  props: {
	    module: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    settings: 'organizationSettings'
	  })),
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    var fields = {};
	    var hasOptions = false;
	    for (var i = 0; i < this.module.fields.length; i++) {
	      var field = this.module.fields[i];
	      if (field.hidden) continue;
	
	      var newField = {
	        type: this.module.fields[i].type || 'text',
	        value: ''
	      };
	      if (this.module.fields[i].options) {
	        hasOptions = true;
	
	        if (Object.prototype.hasOwnProperty.call(field.options, 'standard')) {
	          newField.value = 'standard';
	        }
	      }
	      fields[this.module.fields[i].name] = newField;
	    }
	
	    this.form = new _forms2.default(fields);
	    if (hasOptions) {
	      for (var _i = 0; _i < this.module.fields.length; _i++) {
	        if (this.module.fields[_i].options) {
	          (function () {
	            var options = _this.module.fields[_i].options;
	            _this.form.setOptions(_this.module.fields[_i].name, Object.keys(options).map(function (key) {
	              return {
	                id: key,
	                name: options[key]
	              };
	            }));
	          })();
	        }
	      }
	    }
	    this.loading = false;
	  },
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    authorize: function authorize() {
	      var _this2 = this;
	
	      this.form.loading = true;
	
	      var data = Object.assign({
	        user_id: this.account.userId
	      }, this.form.data());
	
	      _poweroffice2.default.authorize(data).then(function () {
	        _this2.subscribe();
	        _this2.$message({
	          showClose: true,
	          message: 'PowerOffice connected successfully!',
	          type: 'success'
	        });
	      }).catch(function (error) {
	        var message = error.data ? error.data.message : 'Field Required';
	        _this2.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	        _this2.form.loading = false;
	        _this2.form.recordErrors(error);
	      });
	    },
	    getResources: function getResources() {},
	    subscribe: function subscribe() {
	      var _this3 = this;
	
	      this.form.loading = true;
	      var obj = Object.assign({ module_id: this.module.id }, this.form.data());
	      _modules2.default.subscribe(this.module.id, obj).then(function () {
	        Promise.all([_poweroffice2.default.sync(), _modules2.default.items()]).then(function () {
	          _this3.closeModal();
	        });
	      }).catch(function (error) {
	        var message = error.data ? error.data.message : 'Field Required';
	        _this3.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	        _this3.form.recordErrors(error);
	        _this3.form.loading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _tripletex = __webpack_require__(1338);
	
	var _tripletex2 = _interopRequireDefault(_tripletex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({}),
	      loading: false
	    };
	  },
	
	
	  props: {
	    module: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    modules: 'allModules'
	  })),
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    var fields = {};
	    var hasOptions = false;
	    for (var i = 0; i < this.module.fields.length; i++) {
	      var newField = {
	        type: this.module.fields[i].type || 'text',
	        value: ''
	      };
	      if (this.module.fields[i].options) {
	        hasOptions = true;
	      }
	      fields[this.module.fields[i].name] = newField;
	    }
	
	    this.form = new _forms2.default(fields);
	    if (hasOptions) {
	      for (var _i = 0; _i < this.module.fields.length; _i++) {
	        if (this.module.fields[_i].options) {
	          (function () {
	            var options = _this.module.fields[_i].options;
	            _this.form.setOptions(_this.module.fields[_i].name, Object.keys(options).map(function (key) {
	              return {
	                id: key,
	                name: options[key]
	              };
	            }));
	          })();
	        }
	      }
	    }
	    this.loading = false;
	  },
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    getResources: function getResources() {},
	    authorize: function authorize() {
	      var _this2 = this;
	
	      this.form.loading = true;
	
	      var data = Object.assign({
	        user_id: this.account.userId
	      }, this.form.data());
	
	      _tripletex2.default.authorize(data).then(function () {
	        _this2.subscribe();
	      }).catch(function (error) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(error);
	      });
	    },
	    subscribe: function subscribe() {
	      var _this3 = this;
	
	      this.form.loading = true;
	      var obj = Object.assign({ module_id: this.module.id }, this.form.data());
	      _modules2.default.subscribe(this.module.id, obj).then(function () {
	        _modules2.default.items().then(function (data) {
	          _this3.closeModal();
	        });
	      }).catch(function (error) {
	        var message = error.data ? error.data.message : 'Field Required';
	        _this3.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	        _this3.form.recordErrors(error);
	        _this3.form.loading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({}),
	      loading: false
	    };
	  },
	
	
	  props: {
	    module: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    settings: 'organizationSettings'
	  })),
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    var fields = {};
	    for (var i = 0; i < this.module.fields.length; i++) {
	      var newField = {
	        type: this.module.fields[i].type || 'text',
	        value: ''
	      };
	      fields[this.module.fields[i].name] = newField;
	    }
	
	    this.form = new _forms2.default(fields);
	    _organizationSettings2.default.show().then(function () {
	      _this.loading = false;
	    }).catch(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    authorize: function authorize() {
	      if (!this.settings.hasVismaToken) {
	        window.location.href = ("https://api.kundan.no") + '/visma/authenticate?token=' + localStorage.getItem('id_token');
	      } else {
	        this.subscribe();
	      }
	    },
	    getResources: function getResources() {},
	    subscribe: function subscribe() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var obj = Object.assign({ module_id: this.module.id }, this.form.data());
	      _modules2.default.subscribe(this.module.id, obj).then(function () {
	        _modules2.default.items().then(function () {
	          _this2.closeModal();
	        });
	      }).catch(function (error) {
	        var message = error.data ? error.data.message : 'Field Required';
	        _this2.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	        _this2.form.recordErrors(error);
	        _this2.form.loading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	
	  props: {
	    alert: {
	      required: false,
	      type: Object,
	      default: {
	        title: '',
	        message: '',
	        type: ''
	      }
	    },
	    buttons: {
	      required: true,
	      type: Array,
	      default: [{
	        name: 'sample',
	        text: 'Sample',
	        action: function action() {}
	      }]
	    }
	  },
	
	  created: function created() {},
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    addMore: function addMore() {
	      this.closeModal();
	      this.$router.push({
	        name: 'products.create'
	      });
	    },
	    edit: function edit() {
	      this.closeModal();
	      this.$router.push({
	        name: 'products.edit',
	        params: {
	          id: this.productId
	        }
	      });
	    },
	    gotoIndex: function gotoIndex() {
	      this.closeModal();
	      this.$router.push({
	        name: 'products.index'
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _vuex = __webpack_require__(5);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _appointment = __webpack_require__(894);
	
	var _appointment2 = _interopRequireDefault(_appointment);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        clientId: {
	          type: 'select',
	          value: ''
	        },
	        productId: {
	          type: 'select',
	          value: ''
	        },
	        date: {
	          type: 'date',
	          value: ''
	        },
	        slot: {
	          type: 'select',
	          value: ''
	        },
	        details: {
	          type: 'textarea',
	          value: ''
	        }
	      }),
	      originalSlot: ''
	    };
	  },
	
	
	  props: {
	    create: {
	      type: Function,
	      required: true
	    },
	
	    destroy: {
	      type: Function,
	      required: false
	    },
	
	    date: {
	      type: Object,
	      required: true
	    },
	
	    appointment: {
	      type: Object,
	      required: false
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    clients: 'allClients',
	    products: 'allProducts'
	  })),
	
	  watch: {
	    clients: function clients() {
	      this.form.setOptions('clientId', this.clients.map(function (c) {
	        return { id: c.id, name: c.name || c.firstName + ' ' + c.lastName };
	      }));
	    },
	    products: function products() {
	      this.form.setOptions('productId', this.products);
	    },
	
	
	    'form.productId': function formProductId() {
	      if (this.form.productId && this.form.date) {
	        this.getSlots(this.form.productId);
	      }
	    },
	
	    'form.date': function formDate() {
	      if (this.form.productId && this.form.date) {
	        this.getSlots(this.form.productId);
	      }
	    }
	  },
	
	  methods: {
	    getSlots: function getSlots(productId) {
	      var _this = this;
	
	      _appointment2.default.slots(productId, (0, _moment2.default)(this.form.date).format('YYYY-MM-DD')).then(function (r) {
	        if (r.data.exceptions && r.data.exceptions.length) {
	          var message = r.data.exceptions[0].message.length ? r.data.exceptions[0].message : _this.$t('static.appointments.index.noSlots');
	          _this.$message({
	            showClose: true,
	            customClass: 'error',
	            message: message
	          });
	          return;
	        } else if (r.data.slots) {
	          _this.form.setOptions('slot', r.data.slots.map(function (s) {
	            return { id: s, name: s };
	          }));
	          _this.form.slot = _this.originalSlot;
	          _this.form.showField('slot');
	          return;
	        }
	
	        _this.$message({
	          showClose: true,
	          customClass: 'error',
	          message: _this.$t('static.appointments.index.noSlots')
	        });
	      }).catch(function (e) {
	        return console.log(e);
	      });
	    },
	    createAppointment: function createAppointment() {
	      var _this2 = this;
	
	      var data = this.form.data();
	      data.orderTypeId = 2;
	      data.date = (0, _moment2.default)(data.date).format('YYYY-MM-DD');
	      data.time = data.slot;
	      this.form.loading = true;
	      this.create(data, this.appointment ? this.appointment.id : undefined).then(function () {
	        _this2.form.loading = false;
	        _this2.$emit('close');
	      }).catch(function (e) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(e);
	      });
	    },
	    cancel: function cancel() {
	      this.$emit('close');
	    },
	    goToOverviewPage: function goToOverviewPage() {
	      this.$router.push({ name: 'orders.edit', params: { id: this.appointment.id } });
	      this.$emit('close');
	    },
	    destroyAppointment: function destroyAppointment(id) {
	      var _this3 = this;
	
	      this.destroy(id).then(function () {
	        _this3.$emit('close');
	      }).catch(function () {
	        _this3.$message({
	          message: _this3.$t('static.appointments.edit.destroyError'),
	          customClass: 'error',
	          showClose: true
	        });
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.form.date = (0, _moment2.default)(this.date).toString();
	    this.form.hideField('slot');
	    Promise.all([_client2.default.all(), _product2.default.all()]).then(function () {
	      if (_this4.appointment) {
	        _this4.originalSlot = _this4.appointment.time;
	        var product = _this4.products.filter(function (p) {
	          return p.name === _this4.appointment.serviceName;
	        });
	        _this4.form.assignData(Object.assign({}, _this4.appointment, {
	          productId: product.length ? product[0].id : ''
	        }));
	      }
	    });
	  },
	
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _batchLog = __webpack_require__(446);
	
	var _batchLog2 = _interopRequireDefault(_batchLog);
	
	var _batchLog3 = __webpack_require__(238);
	
	var _batchLog4 = _interopRequireDefault(_batchLog3);
	
	var _vuex = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        timestamp: {
	          value: '',
	          type: 'date'
	        },
	        description: {
	          value: '',
	          type: 'textarea'
	        }
	      })
	    };
	  },
	
	
	  props: {
	    batchId: {
	      required: true,
	      type: Number
	    },
	    page: {
	      required: true,
	      type: Number
	    },
	    limit: {
	      required: true,
	      type: Number
	    }
	  },
	
	  created: function created() {},
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    save: function save() {
	      var _this = this;
	
	      this.form.loading = true;
	      var log = _batchLog4.default.send(this.form.data());
	      _batchLog2.default.store(Object.assign({}, log, { batch_id: this.batchId }), this.page, this.limit).then(function () {
	        return _this.closeModal();
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _newsStatus = __webpack_require__(1095);
	
	var _newsStatus2 = _interopRequireDefault(_newsStatus);
	
	var _news = __webpack_require__(109);
	
	var _news2 = _interopRequireDefault(_news);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        subject: {
	          type: 'text',
	          value: ''
	        },
	        sendAfterDate: {
	          type: 'date',
	          value: ''
	        },
	        sendAfterTime: {
	          type: 'time',
	          value: ''
	        },
	        sendAfter: {
	          type: 'number',
	          value: ''
	        },
	        htmlEmail: {
	          type: 'switch',
	          value: 0
	        },
	        body: {
	          type: 'editor',
	          value: ''
	        },
	        newsCampaignId: {
	          type: 'hidden',
	          value: ''
	        },
	        campaignType: {
	          type: 'hidden',
	          value: ''
	        },
	        testEmail: {
	          type: 'text',
	          value: ''
	        },
	        testEmailCheck: {
	          type: 'switch',
	          value: 0
	        }
	      }),
	      testLoading: false,
	      statuses: []
	    };
	  },
	
	
	  props: {
	    create: {
	      type: Function,
	      required: true
	    },
	
	    test: {
	      type: Function,
	      required: true
	    },
	
	    campaign: {
	      type: Object,
	      required: true
	    },
	
	    email: {
	      type: Object,
	      required: false
	    },
	
	    listMessage: {
	      type: String,
	      required: false
	    }
	  },
	
	  watch: {
	    'form.testEmailCheck': function formTestEmailCheck(value) {
	      if (value) {
	        this.form.showField('testEmail');
	      } else {
	        this.form.hideField('testEmail');
	      }
	    },
	    'form.htmlEmail': function formHtmlEmail(value) {
	      if (value) {
	        this.form.setField('body', 'textarea');
	      } else {
	        this.form.setField('body', 'editor');
	      }
	    }
	  },
	
	  methods: {
	    createEmail: function createEmail(draft) {
	      var _this = this;
	
	      var data = this.form.data();
	      var elem = document.querySelector('.ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-blurred.ck-editor__editable_inline');
	      data.sendAfterDate = data.sendAfterDate ? (0, _moment2.default)(data.sendAfterDate).format('YYYY-MM-DD') + ' ' + data.sendAfterTime : '';
	
	      var status = draft ? 'draft' : 'ready';
	      data.newsStatusId = this.statuses.filter(function (s) {
	        return s.name === status;
	      })[0].id;
	      data.body = this.form.body;
	      var news = _news2.default.send(data);
	
	      this.form.loading = status;
	      this.create(news, this.email ? this.email.id : undefined).then(function () {
	        _this.form.loading = false;
	        var message = _this.email ? _this.$t('static.news.edit.updateSucess') : _this.$t('static.news.create.createSucess');
	        _this.$message({
	          showClose: true,
	          message: message,
	          type: 'success'
	        });
	        _this.$emit('close');
	      }).catch(function (e) {
	        _this.form.loading = false;
	        _this.form.recordErrors(e);
	      });
	    },
	    testEmail: function testEmail() {
	      var _this2 = this;
	
	      this.testLoading = true;
	      var data = this.form.data();
	      data.sendAfterDate = data.sendAfterDate ? (0, _moment2.default)(data.sendAfterDate).format('YYYY-MM-DD') + ' ' + data.sendAfterTime : '';
	      this.test(_news2.default.send(data)).then(function () {
	        _this2.testLoading = false;
	        _this2.$message({
	          showClose: true,
	          message: _this2.$t('static.news.create.sendTestSucess'),
	          type: 'success'
	        });
	      }).catch(function (e) {
	        _this2.testLoading = false;
	        _this2.form.recordErrors(e);
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    var _this3 = this;
	
	    _newsStatus2.default.all().then(function (r) {
	      _this3.statuses = r;
	    });
	    if (this.campaign.campaignType === 'Sequence') {
	      this.form.hideField('sendAfterDate');
	      this.form.hideField('sendAfterTime');
	    } else {
	      this.form.hideField('sendAfter');
	    }
	    this.form.setTooltip('body', this.$t('static.campaigns.edit.emailBodyTooltip'));
	    if (this.email) {
	      var data = Object.assign({}, this.email);
	      if ((0, _moment2.default)(this.email.sendAfterDate).isValid()) {
	        data.sendAfterTime = (0, _moment2.default)(this.email.sendAfterDate).format('HH:mm');
	      } else {
	        data.sendAfterDate = '';
	        data.sendAfterTime = '';
	      }
	      if (data.htmlEmail) {
	        this.form.setField('body', 'textarea');
	      }
	      this.form.assignData(data);
	    }
	    this.form.campaignType = this.campaign.campaignType;
	    this.form.newsCampaignId = this.campaign.id;
	    this.form.hideField('testEmail');
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _license = __webpack_require__(459);
	
	var _license2 = _interopRequireDefault(_license);
	
	var _licenseType = __webpack_require__(1065);
	
	var _licenseType2 = _interopRequireDefault(_licenseType);
	
	var _licensePermitType = __webpack_require__(1063);
	
	var _licensePermitType2 = _interopRequireDefault(_licensePermitType);
	
	var _licenseGroup = __webpack_require__(1061);
	
	var _licenseGroup2 = _interopRequireDefault(_licenseGroup);
	
	var _license3 = __webpack_require__(311);
	
	var _license4 = _interopRequireDefault(_license3);
	
	var _vuex = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        licenseTypeId: {
	          value: '',
	          type: 'select'
	        },
	        licensePermitTypeId: {
	          value: '',
	          type: 'select'
	        },
	        licenseGroupIds: {
	          value: [],
	          type: 'checkboxGroup'
	        },
	        licenseNumber: {
	          value: '',
	          type: 'text'
	        },
	        organizationNumber: {
	          value: '',
	          type: 'text'
	        },
	        name: {
	          value: '',
	          type: 'text'
	        },
	        streetName: {
	          value: '',
	          type: 'text'
	        },
	        postalCode: {
	          value: '',
	          type: 'text'
	        },
	        city: {
	          value: '',
	          type: 'text'
	        },
	        municipality: {
	          value: '',
	          type: 'text'
	        },
	        municipalityNumber: {
	          value: '',
	          type: 'text'
	        },
	        validFrom: {
	          value: '',
	          type: 'date'
	        },
	        validTo: {
	          value: '',
	          type: 'date'
	        },
	        licenseFile: {
	          value: '',
	          type: 'file'
	        }
	      }),
	      loading: false
	    };
	  },
	
	  props: {
	    clientId: {
	      type: Number,
	      required: true
	    },
	    orgNumber: {
	      type: String,
	      required: false
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    Promise.all([_licenseType2.default.all(), _licensePermitType2.default.all(), _licenseGroup2.default.all()]).then(function () {
	      _this.loading = false;
	    }).catch(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    licenseTypes: 'allLicenseTypes',
	    licensePermitTypes: 'allLicensePermitTypes',
	    licenseGroups: 'allLicenseGroups'
	  })),
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    save: function save() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var formData = this.form.data();
	      var licenseGroupIds = [];
	      this.form.licenseGroupIds.forEach(function (m) {
	        var licenseGroup = _this2.licenseGroups.find(function (p) {
	          return p.name === m;
	        });
	        licenseGroupIds.push(licenseGroup.id);
	      });
	      formData.licenseGroupIds = licenseGroupIds;
	      formData.ownerOrganizationNumber = this.orgNumber;
	      var license = _license4.default.send(formData);
	      _license2.default.store(license).then(function () {
	        _license2.default.all(_this2.clientId);
	        _this2.form.loading = false;
	        _this2.closeModal();
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	
	  watch: {
	    licenseTypes: function licenseTypes(_licenseTypes) {
	      this.form.setOptions('licenseTypeId', _licenseTypes.map(function (l) {
	        return { id: l.id, name: l.name };
	      }));
	    },
	    licensePermitTypes: function licensePermitTypes(_licensePermitTypes) {
	      this.form.setOptions('licensePermitTypeId', _licensePermitTypes.map(function (l) {
	        return { id: l.id, name: l.name + ' (' + l.code + ')' };
	      }));
	    },
	    licenseGroups: function licenseGroups(_licenseGroups) {
	      this.form.setOptions('licenseGroupIds', _licenseGroups.map(function (l) {
	        return { id: l.id, name: l.name };
	      }));
	    },
	
	    'form.licenseTypeId': function formLicenseTypeId(value) {
	      if (value) {
	        this.form.setOptions('licensePermitTypeId', this.licensePermitTypes.filter(function (l) {
	          return +l.licenseTypeId === +value;
	        }).map(function (l) {
	          return { id: l.id, name: l.name + ' (' + l.code + ')' };
	        }));
	        this.form.setOptions('licenseGroupIds', this.licenseGroups.filter(function (l) {
	          return +l.licenseTypeId === +value;
	        }).map(function (l) {
	          return { id: l.id, name: l.name };
	        }));
	      }
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _package = __webpack_require__(188);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _packageOrderProduct = __webpack_require__(189);
	
	var _packageOrderProduct2 = _interopRequireDefault(_packageOrderProduct);
	
	var _orderProduct = __webpack_require__(48);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        orderProductId: {
	          value: '',
	          type: 'select'
	        },
	        quantity: {
	          value: '',
	          type: 'text'
	        },
	        quantityUnit: {
	          value: '',
	          type: 'select'
	        },
	        grossWeight: {
	          value: '',
	          type: 'text'
	        },
	        netWeight: {
	          value: '',
	          type: 'text'
	        },
	        stackWeight: {
	          value: '',
	          type: 'text'
	        },
	        bestBefore: {
	          value: new Date().toISOString().slice(0, 10),
	          type: 'date'
	        },
	        maxTopLoad: {
	          value: '',
	          type: 'text'
	        },
	        batchLotNumber: {
	          value: '',
	          type: 'text'
	        },
	        temperatureRequirement: {
	          value: '',
	          type: 'text'
	        },
	        packageId: {
	          value: '',
	          type: 'hidden'
	        }
	      }),
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentOrder: 'currentOrder',
	    orderProducts: 'allOrderProducts'
	  }), {
	    loadForms: function loadForms() {
	      this.form.setOptions('orderProductId', this.orderProducts.filter(function (op) {
	        return op.quantityConfirmed != op.quantityPacked;
	      }));
	      var qtyUnitOptions = [{ "id": "PCE", "name": "Piece" }, { "id": "KGM", "name": "Kilo" }, { "id": "LTR", "name": "Litre" }, { "id": "MTR", "name": "Metre" }];
	
	      this.form.setOptions('quantityUnit', qtyUnitOptions);
	      this.form.setFieldValue('packageId', this.$store.state.modal.modalProps.packageId);
	    }
	  }),
	
	  created: function created() {
	    this.loadForms;
	  },
	
	
	  watch: {
	    'form.orderProductId': function formOrderProductId(val) {
	      if (val != '') {
	        var currentOrderProduct = this.orderProducts.filter(function (op) {
	          return op.id == val;
	        });
	
	        this.form.setFieldValue('quantity', currentOrderProduct[0].quantityUnpacked.toString());
	        this.form.setFieldValue('quantityUnit', 'PCE');
	        var previousOrderProductPackage = currentOrderProduct[0].prevOrderProductPackage;
	        if (previousOrderProductPackage) {
	          this.form.setFieldValue('quantityUnit', previousOrderProductPackage.quantity_unit.toString());
	          this.form.setFieldValue('grossWeight', previousOrderProductPackage.gross_weight.toString());
	          this.form.setFieldValue('netWeight', previousOrderProductPackage.net_weight.toString());
	          this.form.setFieldValue('stackWeight', previousOrderProductPackage.stack_weight.toString());
	          if (previousOrderProductPackage.best_before) {
	            this.form.setFieldValue('bestBefore', previousOrderProductPackage.best_before);
	          }
	          this.form.setFieldValue('maxTopLoad', previousOrderProductPackage.max_top_load.toString());
	          this.form.setFieldValue('batchLotNumber', previousOrderProductPackage.batch_lot_number);
	          this.form.setFieldValue('temperatureRequirement', previousOrderProductPackage.temperature_requirement);
	        } else if (currentOrderProduct[0].fieldsJSON && currentOrderProduct[0].fieldsJSON.weightMultipack != null) {
	          var weightMultipackStr = String(currentOrderProduct[0].fieldsJSON.weightMultipack);
	          var weight = (parseFloat(weightMultipackStr.replace(',', '.')) * currentOrderProduct[0].quantityUnpacked).toFixed(0);
	          this.form.setFieldValue('grossWeight', weight.toString());
	          this.form.setFieldValue('netWeight', weight.toString());
	          this.form.setFieldValue('stackWeight', weight.toString());
	        }
	      }
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    modalProps: 'SET_MODAL_PROPS'
	  }), {
	    store: function store() {
	      var _this = this;
	
	      _packageOrderProduct2.default.store(this.form.data()).then(function (data) {
	        _orderProduct2.default.all(_this.currentOrder.id);
	        _packageOrderProduct2.default.all(_this.currentOrder.id);
	        _package2.default.all(_this.currentOrder.id);
	        _this.$message({
	          showClose: true,
	          message: _this.$t('static.packageOrderProduct.add.success'),
	          customClass: 'success'
	        });
	        _this.closeModal();
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	        var message = _this.$t('static.packageOrderProduct.add.error');
	        if (errors.quantityExceedError) {
	          message = _this.$t('static.packageOrderProduct.add.quantityExceedError');
	        }
	        _this.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _producer = __webpack_require__(302);
	
	var _producer2 = _interopRequireDefault(_producer);
	
	var _producer3 = __webpack_require__(317);
	
	var _producer4 = _interopRequireDefault(_producer3);
	
	var _clientType = __webpack_require__(294);
	
	var _clientType2 = _interopRequireDefault(_clientType);
	
	var _vuex = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        typeId: {
	          value: '',
	          type: 'select'
	        },
	        name: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      loading: false
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.loading = true;
	    Promise.all([_clientType2.default.all()]).then(function () {
	      _this.loading = false;
	    }).catch(function () {
	      _this.loading = true;
	    });
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    types: 'allClientTypes'
	  })),
	
	  methods: {
	    save: function save() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var producer = _producer4.default.send(this.form.data());
	      _producer2.default.store(producer).then(function () {
	        _producer2.default.all();
	        _this2.$emit('close');
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    }
	  },
	  watch: {
	    types: function types(_types) {
	      if (_types) {
	        this.form.setOptions('typeId', _types.map(function (type) {
	          return {
	            id: +type.id,
	            name: type.name
	          };
	        }));
	        this.form.typeId = 2;
	      }
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    appointment: {
	      type: Object,
	      required: true
	    },
	
	    edit: {
	      type: Function,
	      required: false
	    },
	
	    fade: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  methods: {
	    getTimeRange: function getTimeRange(appointment) {
	      var start = (0, _moment2.default)(appointment.start, 'DD/MM/YYYY HH:mm').format('HH:mm');
	      var end = (0, _moment2.default)(appointment.start, 'DD/MM/YYYY HH:mm').add(appointment.duration, 'minute').format('HH:mm');
	
	      return start + ' - ' + end;
	    }
	  }
	};

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _orderProduct = __webpack_require__(48);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _batch = __webpack_require__(60);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _batchOptions = __webpack_require__(201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    order: {
	      type: Object,
	      required: true
	    },
	    orderProduct: {
	      type: Array,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      products: [],
	      loading: true
	    };
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    batches: 'allBatches'
	  }), {
	    list: function list() {
	      var _this = this;
	
	      return this.products.map(function (item) {
	        var batches = _this.getProductBatches(item);
	        return { id: item.id, name: item.name, batches: batches, batchId: item.batchId.toString() };
	      });
	    }
	  }),
	  mounted: function mounted() {
	    this.getResources();
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    updateBatch: function updateBatch(orderProductId, value) {
	      _orderProduct2.default.batchUpdate(this.order.id, { batchId: value }, orderProductId);
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    },
	    proceedToCreateBill: function proceedToCreateBill() {
	      this.$router.push({
	        name: 'bills.create',
	        query: {
	          order: this.order.id
	        }
	      });
	      this.closeModal();
	    },
	    getProductBatches: function getProductBatches(item) {
	      var _this2 = this;
	
	      var productWarehouses = item.warehouses;
	      if (this.order.warehouse.id && productWarehouses) {
	        productWarehouses = productWarehouses.filter(function (p) {
	          return parseInt(p.warehouseId) === parseInt(_this2.order.warehouse.id);
	        });
	      }
	
	      var batchIds = productWarehouses.map(function (p) {
	        return +p.batchId;
	      });
	      var batches = this.batches.filter(function (b) {
	        return batchIds.includes(+b.id);
	      }).map(function (batch) {
	        var batchProduct = productWarehouses.find(function (p) {
	          return +p.batchId === +batch.id;
	        });
	        return Object.assign({}, {
	          id: batch.id,
	          name: _this2.order.warehouse.id ? batch.code + ' | ' + _this2.$t('static.orders.edit.availableQty') + ': ' + batchProduct.qty : batch.code,
	          qtyNumber: batchProduct.qtyNumber,
	          available: batchProduct.qtyNumber
	        });
	      });
	      var nonBatchProduct = productWarehouses.find(function (p) {
	        return p.batchId === 0;
	      });
	      if (nonBatchProduct) {
	        batches.unshift({
	          id: '0',
	          name: this.$t('static.orders.edit.nonBatch') + ' | ' + this.$t('static.orders.edit.availableQty') + ': ' + nonBatchProduct.qty,
	          qtyNumber: nonBatchProduct.qtyNumber,
	          available: nonBatchProduct.qtyNumber
	        });
	      }
	
	      return this.order.warehouse.id ? (0, _batchOptions.sortBatchOptions)(batches) : batches;
	    },
	    getResources: function getResources() {
	      var _this3 = this;
	
	      this.loading = true;
	      Promise.all([_batch2.default.all({ warehouse_id: this.order.warehouseId, for_select: 1 }), _orderProduct2.default.all(this.order.id)]).then(function (res) {
	        _this3.products = res[1];
	        _this3.checkIfBatchIsPresent();
	        _this3.loading = false;
	      });
	    },
	    checkIfBatchIsPresent: function checkIfBatchIsPresent() {
	      var hasBatch = false;
	      this.list.forEach(function (item) {
	        if (item.batches.filter(function (b) {
	          return +b.id !== 0;
	        }).length > 0) {
	          hasBatch = true;
	        }
	      });
	      if (!hasBatch) {
	        this.proceedToCreateBill();
	      }
	    }
	  })
	};

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	
	  props: {
	    materials: {
	      required: true,
	      type: Array
	    },
	    batchId: {
	      required: true,
	      type: Number
	    },
	    message: {
	      required: true,
	      type: String
	    },
	
	    buttons: {
	      type: Array,
	      required: false
	    }
	  },
	
	  created: function created() {},
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    adjustQty: function adjustQty() {
	      this.closeModal();
	      this.$router.push({
	        name: 'products.edit',
	        params: {
	          id: this.productId
	        }
	      });
	    },
	    addNew: function addNew() {
	      this.closeModal();
	      this.$router.push({
	        name: 'products.edit',
	        params: {
	          id: this.productId
	        }
	      });
	    },
	    purchaseOrder: function purchaseOrder() {
	      this.closeModal();
	      this.$router.push({
	        name: 'products.edit',
	        params: {
	          id: this.productId
	        }
	      });
	    },
	    stockAdjustment: function stockAdjustment() {
	      this.closeModal();
	      this.$router.push({
	        name: 'products.edit',
	        params: {
	          id: this.productId
	        }
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  })
	};

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _paymentMethods = __webpack_require__(467);
	
	var _paymentMethods2 = _interopRequireDefault(_paymentMethods);
	
	var _bill = __webpack_require__(92);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        isFullyPaid: {
	          value: false,
	          type: 'checkbox'
	        },
	        amountPaid: {
	          value: '',
	          type: 'float'
	        },
	        paymentMethod: {
	          value: '',
	          type: 'select'
	        },
	        paymentDate: {
	          value: new Date(),
	          type: 'date'
	        },
	        reference: {
	          value: '',
	          type: 'text'
	        },
	        internalNote: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    paymentMethods: 'paymentMethods'
	  }), {
	    listPaymentMethods: function listPaymentMethods() {
	      var _this = this;
	
	      return this.paymentMethods.map(function (item) {
	        return {
	          id: item.id,
	          name: _this.$t('static.reports.bills.' + item.name.replace(/\s+/g, '').toLowerCase())
	        };
	      });
	    }
	  }),
	
	  watch: {
	    'form.isFullyPaid': function formIsFullyPaid(value) {
	      if (value === true) {
	        this.form.setFieldValue('amountPaid', this.additionalData.due);
	        this.form.disableField('amountPaid');
	      } else {
	        this.form.enableField('amountPaid');
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.loading = true;
	    this.form.setFieldValue('amountPaid', this.additionalData.due);
	    Promise.all([_paymentMethods2.default.all()]).then(function () {
	      _this2.form.setOptions('paymentMethod', _this2.listPaymentMethods);
	      var defaultMethod = _this2.listPaymentMethods.filter(function (obj) {
	        return obj.name === _this2.$t('static.reports.bills.banktransfer');
	      });
	      _this2.form.paymentMethod = defaultMethod[0].id;
	      _this2.loading = true;
	    }).catch(function (error) {
	      _this2.loading = true;
	    });
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    complete: function complete() {
	      var _this3 = this;
	
	      this.form.loading = true;
	      _bill2.default.payment(this.billId, this.form.data()).then(function () {
	        _this3.form.loading = false;
	        _this3.onSave('Cleared', _this3.form.data());
	        _this3.closeModal();
	      }).catch(function (errors) {
	        _this3.form.loading = false;
	        _this3.form.recordErrors(errors);
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	      this.onClose();
	    }
	  }),
	
	  props: {
	    billId: {
	      type: Number,
	      required: true
	    },
	    onSave: {
	      type: Function,
	      required: true,
	      default: function _default() {}
	    },
	    onClose: {
	      type: Function,
	      required: false,
	      default: function _default() {}
	    },
	    billingNumber: {
	      type: String,
	      required: true
	    },
	    additionalData: {
	      type: Object,
	      required: true
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _vuex = __webpack_require__(5);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _orderProduct = __webpack_require__(48);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _billProduct = __webpack_require__(448);
	
	var _billProduct2 = _interopRequireDefault(_billProduct);
	
	var _tax = __webpack_require__(128);
	
	var _tax2 = _interopRequireDefault(_tax);
	
	var _productDeposit = __webpack_require__(96);
	
	var _productDeposit2 = _interopRequireDefault(_productDeposit);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _quickProductEdit = __webpack_require__(278);
	
	var _quickProductEdit2 = _interopRequireDefault(_quickProductEdit);
	
	var _bundleProductPreview = __webpack_require__(2684);
	
	var _bundleProductPreview2 = _interopRequireDefault(_bundleProductPreview);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _bulkAddProductModal = __webpack_require__(122);
	
	var _bulkAddProductModal2 = _interopRequireDefault(_bulkAddProductModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        ref: {
	          value: '',
	          type: 'link',
	          attributes: {
	            href: '',
	            target: '',
	            fieldClass: ''
	          }
	        },
	        orderProductId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        id: {
	          value: '',
	          type: 'text'
	        },
	        price: {
	          value: '',
	          type: 'float'
	        },
	        productDepositName: {
	          value: '',
	          type: 'plaintext'
	        },
	        quantity: {
	          value: '',
	          type: 'float'
	        },
	        discount: {
	          value: '',
	          type: 'number'
	        },
	        taxId: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      hiddenFields: [],
	      destroyLoading: false,
	      addingProduct: false,
	      editingProduct: false,
	      error: false,
	      ready: false,
	      columnWidths: { ref: '150px' },
	      additionalButtons: [{
	        text: this.$t('table.orderProducts.addProductsButton'),
	        action: this.showBulkAddProductModal
	      }]
	    };
	  },
	
	
	  props: {
	    order: {
	      type: Object,
	      required: true
	    },
	
	    bill: {
	      type: Object,
	      required: true
	    },
	
	    billRoundInvoiceTotal: {
	      type: Boolean,
	      required: false
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    products: 'allProducts',
	    orderProducts: 'allOrderProducts',
	    billProducts: 'allBillProducts',
	    taxes: 'allTaxes',
	    productDeposits: 'allProductDeposits'
	  }), {
	    billProductsList: function billProductsList() {
	      var _this = this;
	
	      var links = {};
	      var products = this.billProducts.map(function (p) {
	        var deposit = [];
	        if (p.productDepositId) {
	          deposit = _this.productDeposits.all.filter(function (d) {
	            return p.productDepositId.toString() === d.id.toString();
	          });
	        }
	
	        var value = '';
	        if (deposit.length) {
	          value = 'Deposit: ' + deposit[0].name;
	        }
	
	        var addClass = 'link-table-' + p.refNumber + '-' + p.refId;
	        var linkDisable = false;
	        if (p.refNumber === '--') linkDisable = true;
	
	        links[p.id] = '#/orders/' + p.refId + '/edit';
	        _this.form.setExtraAttr('ref', {
	          href: links[p.id],
	          hrefs: links,
	          target: '_blank',
	          fieldClass: addClass,
	          fieldDisable: linkDisable });
	        var base = {
	          valueNote: p.note,
	          productDepositName: value,
	          orderProductId: p.orderProductId,
	          orderProductDeposit: p.productDeposit,
	          ref: p.refNumber === '--' ? '--' : _this.$t('static.referenceSign.order') + '-' + p.refNumber
	        };
	        if (p.taxPercentage !== undefined && p.taxPercentage !== null) {
	          base.taxIdDisplay = p.taxPercentage;
	        }
	        return Object.assign(base, p);
	      });
	
	      return products;
	    },
	    totalsTableList: function totalsTableList() {
	      var fmt = function fmt(val) {
	        return Number(val).toLocaleString('nb-NO', {
	          minimumFractionDigits: 2,
	          maximumFractionDigits: 2
	        });
	      };
	
	      var result = [{
	        name: this.$t('static.orders.edit.subtotal'),
	        value: fmt(this.subtotal)
	      }, {
	        name: this.$t('static.orders.edit.tax'),
	        value: fmt(this.tax)
	      }];
	
	      if (this.discount > 0) {
	        result.push({
	          name: this.$t('static.orders.edit.discount'),
	          value: fmt(this.discount)
	        });
	      }
	
	      if (this.deposit > 0) {
	        result.push({
	          name: this.$t('static.orders.edit.deposit'),
	          value: fmt(this.deposit)
	        });
	      }
	
	      if (this.penaltyFee > 0) {
	        result.push({
	          name: 'Penalty fee',
	          value: fmt(this.penaltyFee)
	        });
	      }
	
	      result.push({
	        name: this.$t('static.orders.edit.total'),
	        value: fmt(this.total)
	      });
	
	      return result;
	    },
	    isBillSent: function isBillSent() {
	      return this.bill.billStatus !== 'Draft' && this.bill.billStatus !== 'Pending';
	    },
	    isShownOnBill: function isShownOnBill() {
	      return this.billRoundInvoiceTotal;
	    },
	    showTable: function showTable() {
	      if (this.billProductsList.length > 0 || this.addingProduct || this.editingProduct) {
	        return true;
	      }
	
	      return false;
	    },
	    subtotal: function subtotal() {
	      return this.billProductsList.map(function (p) {
	        return p.price * p.quantity;
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    discount: function discount() {
	      var _this2 = this;
	
	      return this.billProductsList.map(function (p) {
	        var op = _this2.getOrderProduct(p.orderProductId);
	        return (p.price ? p.price : op.price) * p.quantity * (p.discount / 100);
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    penaltyFee: function penaltyFee() {
	      return this.bill.reminderFeesTotalAmount.toFixed(2);
	    },
	    tax: function tax() {
	      var _this3 = this;
	
	      return this.billProductsList.map(function (p) {
	        var op = _this3.getOrderProduct(p.orderProductId);
	        return (p.price ? p.price : op.price) * p.quantity * (1 - p.discount / 100) * ((p.taxId ? p.taxPercentage : op.taxPercentage) / 100);
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    deposit: function deposit() {
	      return this.billProductsList.map(function (p) {
	        return p.orderProductDeposit * p.quantity;
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    total: function total() {
	      var total = Number(this.subtotal) + Number(this.deposit) - Number(this.discount) + Number(this.penaltyFee);
	      var totalTax = total + Number(this.tax);
	
	      if (this.isShownOnBill) {
	        return Math.round(totalTax).toFixed(2);
	      }
	
	      return totalTax.toFixed(2);
	    },
	    rounding: function rounding() {
	      var total = Number(this.subtotal - this.discount);
	      var totalTax = total + Number(this.tax);
	      var roundedDecimal = (totalTax % 1).toFixed(2);
	
	      if (roundedDecimal < 0.50) {
	        return -roundedDecimal;
	      }
	
	      return roundedDecimal;
	    }
	  }),
	
	  watch: {
	    'form.orderProductId': function formOrderProductId() {
	      var _this4 = this;
	
	      var productId = typeof this.form.orderProductId.id !== 'undefined' ? this.form.orderProductId.id : this.form.orderProductId;
	      if (productId > 0) {
	        var orderProduct = this.getOrderProduct(productId);
	        var billProduct = this.billProducts.find(function (p) {
	          return +p.id === +_this4.form.id;
	        });
	        if (typeof orderProduct !== 'undefined') {
	          var tax = this.taxes.all.filter(function (t) {
	            return t.id === orderProduct.taxId;
	          });
	
	          if (tax.length > 0) {
	            this.form.taxId = tax[0].id;
	          }
	          this.form.price = orderProduct.price;
	          this.form.quantity = billProduct.quantity || orderProduct.quantity;
	        }
	      }
	    },
	
	    orderProducts: function orderProducts(products) {
	      this.form.setOptions('orderProductId', products);
	      if (this.order.client.clientType.id === 11) {
	        this.hiddenFields.push('taxId');
	      }
	    },
	    productDeposits: function productDeposits(deposits) {
	      this.form.setOptions('productDepositId', deposits.all);
	    },
	    taxes: function taxes(_taxes) {
	      this.form.setOptions('taxId', _taxes.all.map(function (tax) {
	        return { id: tax.id, name: tax.taxPercentage };
	      }));
	    }
	  },
	  created: function created() {
	    var _this5 = this;
	
	    this.hiddenFields.push('id');
	    Promise.all([_organizationSettings2.default.show()]).then(function (data) {
	      _this5.form.setDisplays('orderProductId', data[0].productInfoDisplay);
	    }).catch(function (errors) {});
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    showBulkAddProductModal: function showBulkAddProductModal() {
	      this.setModalContent(function () {
	        return _bulkAddProductModal2.default;
	      });
	      this.setModalProps({
	        fetchProductsMethod: this.searchMethod,
	        onSave: this.handleBulkProductSave
	      });
	      this.toggleModal(true);
	    },
	    handleBulkProductSave: function handleBulkProductSave(orderProducts) {
	      var _this6 = this;
	
	      var id = this.bill.id;
	      var data = orderProducts.map(function (p) {
	        return {
	          orderProductId: p.id,
	          quantity: p.qty,
	          price: p.price
	        };
	      });
	
	      return _billProduct2.default.bulkStore(id, data).then(function () {
	        _this6.form.loading = false;
	      });
	    },
	    getDepositValue: function getDepositValue(id) {
	      var deposits = this.productDeposits.all.filter(function (d) {
	        return d.id.toString() === id.toString();
	      });
	      return deposits.length ? deposits[0].amount : 0;
	    },
	    getOrderProduct: function getOrderProduct(productId) {
	      return this.orderProducts.filter(function (p) {
	        return p.id.toString() === productId.toString();
	      })[0];
	    },
	    onFormChange: function onFormChange(name, value) {
	      this.form.clearSuccess(name, value);
	      this.form.clearErrors(name);
	      this.form[name] = value;
	      this.$forceUpdate();
	    },
	    addProduct: function addProduct() {
	      this.cancelForm();
	      this.addingProduct = true;
	    },
	    edit: function edit(product) {
	      this.cancelForm();
	      this.editingProduct = product.id;
	      this.form.assignData(product);
	    },
	    cancelForm: function cancelForm() {
	      this.form.orderProductId = '';
	      this.form.quantity = '';
	      this.addingProduct = false;
	      this.editingProduct = false;
	    },
	    updateOrderProduct: function updateOrderProduct(orderProductId, data) {
	      var _this7 = this;
	
	      data.orderProductId = typeof data.orderProductId.id !== 'undefined' ? data.orderProductId.id : data.orderProductId;
	
	      return _orderProduct2.default.update(this.order.id, data, orderProductId).then(function () {
	        _orderProduct2.default.all(_this7.order.id);
	        _billProduct2.default.all(_this7.bill.id);
	      }).catch(function (errors) {
	        var errorsKeys = Object.keys(_this7.form.errors.errors);
	        _this7.$message({
	          showClose: true,
	          message: errors[errorsKeys[0]][0],
	          customClass: 'error'
	        });
	      });
	    },
	    onQuickProductEditMounted: function onQuickProductEditMounted() {
	      var that = this;
	      return function () {
	        var _this8 = this;
	
	        this.$once('close', function () {
	          _product2.default.all().then(function () {
	            var filteredProducts = that.products.filter(function (p) {
	              return p.id.toString() === _this8.orderProduct.productId.toString();
	            });
	            if (filteredProducts.length) {
	              that.form.assignData(_this8.orderProduct);
	              that.form.assignData(filteredProducts[0]);
	              that.updateOrderProduct(_this8.orderProduct.id, Object.assign({}, _this8.orderProduct, filteredProducts[0])).then(function () {
	                that.form.resetValues();
	              });
	            }
	          });
	        });
	      };
	    },
	    tableClickHandler: function tableClickHandler(item, name) {
	      var _this9 = this;
	
	      var ops = this.orderProducts.filter(function (op) {
	        return op.id.toString() === item.orderProductId.toString();
	      });
	      if (!this.order.sent && ops.length && ops[0].productId && name === 'orderProductId') {
	        return function () {
	          if (item.productType === 'Bundle') {
	            _this9.setModalProps({
	              productId: ops[0].productId,
	              orderProduct: ops[0]
	            });
	            _this9.setModalContent(function () {
	              return _bundleProductPreview2.default;
	            });
	          } else {
	            _this9.setModalProps({
	              productId: ops[0].productId,
	              orderProduct: ops[0],
	              onMounted: _this9.onQuickProductEditMounted()
	            });
	            _this9.setModalContent(function () {
	              return _quickProductEdit2.default;
	            });
	          }
	          _this9.toggleModal(true);
	        };
	      }
	
	      return false;
	    },
	    save: function save() {
	      var _this10 = this;
	
	      var me = this;
	      me.form.loading = true;
	      var id = this.bill.id;
	      var data = this.form.data();
	      data.orderProductId = typeof data.orderProductId.id !== 'undefined' ? data.orderProductId.id : data.orderProductId;
	
	      if (data.quantity.toString() === '0') {
	        me.form.loading = false;
	        me.$message({
	          showClose: true,
	          message: me.$t('static.orders.edit.quantityError'),
	          type: 'error'
	        });
	        return Promise.all();
	      }
	
	      if (data.orderProductId.toString() === '') {
	        me.form.loading = false;
	        me.$message({
	          showClose: true,
	          message: me.$t('static.orders.edit.productErrorMessage'),
	          type: 'error'
	        });
	        return Promise.all();
	      }
	
	      return _billProduct2.default.store(id, data).then(function () {
	        me.form.loading = false;
	        data.orderProduct = _this10.orderProducts.filter(function (p) {
	          return p.id.toString() === data.orderProductId.toString();
	        })[0].name;
	        _store2.default.dispatch('addBillProduct', data);
	        me.cancelForm();
	      }).catch(function (errors) {
	        me.form.loading = false;
	        me.form.recordErrors(errors);
	        var errorsKeys = Object.keys(_this10.form.errors.errors);
	        me.$message({
	          showClose: true,
	          message: errors[errorsKeys[0]][0],
	          type: 'error'
	        });
	      });
	    },
	    update: function update(orderProductId) {
	      var _this11 = this;
	
	      var me = this;
	      this.form.loading = true;
	      var id = this.bill.id;
	      var data = this.form.data();
	      data.orderProductId = typeof data.orderProductId.id !== 'undefined' ? data.orderProductId.id : data.orderProductId;
	
	      if (data.quantity.toString() === '0') {
	        me.form.loading = false;
	        me.$message({
	          showClose: true,
	          message: me.$t('static.orders.edit.quantityError'),
	          type: 'error'
	        });
	        return Promise.all();
	      }
	
	      if (data.orderProductId.toString() === '') {
	        me.form.loading = false;
	        me.$message({
	          showClose: true,
	          message: me.$t('static.orders.edit.productErrorMessage'),
	          type: 'error'
	        });
	        return Promise.all();
	      }
	      return _billProduct2.default.update(id, data, orderProductId).then(function () {
	        me.form.loading = false;
	        _billProduct2.default.all(id);
	        data.orderProduct = me.orderProducts.filter(function (p) {
	          return p.id.toString() === data.orderProductId.toString();
	        })[0].name;
	        _store2.default.dispatch('updateBillProduct', { billProduct: data, id: _this11.editingProduct });
	        me.cancelForm();
	      }).catch(function (errors) {
	        _this11.form.loading = false;
	        _this11.form.recordErrors(errors);
	        var errorsKeys = Object.keys(_this11.form.errors.errors);
	        _this11.$message({
	          showClose: true,
	          message: errors[errorsKeys[0]][0],
	          type: 'error'
	        });
	      });
	    },
	    destroy: function destroy(billProductId) {
	      var _this12 = this;
	
	      this.destroyLoading = billProductId;
	      _billProduct2.default.destroy(this.bill.id, billProductId).then(function () {
	        _this12.destroyLoading = false;
	      }).catch(function () {
	        _this12.destroyLoading = false;
	      });
	    },
	    getResources: function getResources() {
	      var _this13 = this;
	
	      this.ready = false;
	      Promise.all([_orderProduct2.default.all(this.bill.orderId), _billProduct2.default.all(this.bill.id), _tax2.default.all(), _productDeposit2.default.all()]).then(function () {
	        _this13.ready = true;
	      }).catch(function (error) {
	        _this13.ready = true;
	      });
	    },
	    searchMethod: function searchMethod(search, field) {
	      return Promise.all([_orderProduct2.default.search(this.order.id, { search: search })]);
	    }
	  }),
	
	  mounted: function mounted() {
	    this.getResources();
	  },
	
	
	  components: {
	    VFormTable: __webpack_require__(46),
	    VTotalsTable: __webpack_require__(279)
	  }
	};

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _bill = __webpack_require__(92);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        reminderType: {
	          value: '',
	          type: 'select'
	        },
	        penaltyFee: {
	          value: '',
	          type: 'select'
	        },
	        feeAmount: {
	          value: '',
	          type: 'text'
	        },
	        notes: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      loading: false
	    };
	  },
	
	
	  computed: {
	    billingNumber: function billingNumber() {
	      return '#' + this.bill.billingNumber;
	    },
	    penaltyFees: function penaltyFees() {
	      return this.bill.penaltyFees;
	    },
	    canCreateWithFee: function canCreateWithFee() {
	      return this.bill.canCreateReminderWithFee;
	    },
	    disableSaveButton: function disableSaveButton() {
	      return this.form.reminderType === '' || !this.form.isHidden('penaltyFee') && this.form.penaltyFee === '';
	    },
	    currency: function currency() {
	      return this.bill.currency ? this.bill.currency.code : '';
	    },
	    reminderWarning: function reminderWarning() {
	      return this.bill.reminderWithFeeWarning ? this.bill.reminderWithFeeWarning : [];
	    }
	  },
	
	  watch: {
	    'form.reminderType': function formReminderType(value) {
	      var _this = this;
	
	      this.form.showField('penaltyFee');
	      this.form.showField('feeAmount');
	      if (value === 'withFees') {
	        if (this.penaltyFees.length > 0) {
	          this.form.hideField('feeAmount');
	          this.form.setOptions('penaltyFee', this.penaltyFees.map(function (item) {
	            return {
	              id: item.id,
	              name: item.fee_rate + ' ' + (item.type === 'fixed' ? _this.currency : '%')
	            };
	          }));
	        } else {
	          this.form.hideField('penaltyFee');
	        }
	      } else {
	        this.form.hideField('penaltyFee');
	        this.form.hideField('feeAmount');
	      }
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    save: function save() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      _bill2.default.createReminder(this.bill.id, this.form.data()).then(function () {
	        _this2.onComplete();
	        _this2.closeModal();
	        _this2.$message({
	          showClose: true,
	          message: 'Successful',
	          customClass: 'success'
	        });
	        _this2.form.loading = false;
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      this.loading = true;
	      this.form.hideField('penaltyFee');
	      this.form.hideField('feeAmount');
	
	      var reminderOptions = [{ id: 'noFees', name: this.$t('form.billReminderModal.penaltyFee.options.withoutFees') }];
	      if (this.canCreateWithFee) {
	        reminderOptions.push({ id: 'withFees', name: this.$t('form.billReminderModal.penaltyFee.options.withFees') });
	      }
	      this.form.setOptions('reminderType', reminderOptions);
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	      this.onClose();
	    }
	  }),
	
	  mounted: function mounted() {
	    this.show();
	  },
	
	
	  props: {
	    bill: {
	      type: Object,
	      required: true
	    },
	    onComplete: {
	      type: Function,
	      required: false
	    },
	    onClose: {
	      type: Function,
	      required: false
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _unitType = __webpack_require__(235);
	
	var _unitType2 = _interopRequireDefault(_unitType);
	
	var _batch = __webpack_require__(60);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _batch3 = __webpack_require__(49);
	
	var _batch4 = _interopRequireDefault(_batch3);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      search: '',
	      selected: [],
	      loading: false,
	      submitLoading: false,
	      allProducts: [],
	      batchOptions: []
	    };
	  },
	
	  props: {
	    isOrderPage: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	    enableCustomBatch: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	    disableQuantity: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	    batches: {
	      type: Array,
	      required: false,
	      default: function _default() {
	        return [];
	      }
	    },
	    warehouseId: {
	      type: Number,
	      required: false,
	      default: 0
	    },
	    warehouseIdForBatch: {
	      type: Number,
	      required: false,
	      default: 0
	    },
	    fetchProductsMethod: {
	      type: Function,
	      required: true,
	      default: function _default() {}
	    },
	    onSave: {
	      type: Function,
	      required: true,
	      default: function _default() {}
	    },
	    selectedProducts: {
	      type: Array,
	      required: false,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  created: function created() {
	    if (this.batches.length) {
	      this.batchOptions = [].concat(_toConsumableArray(this.batches));
	    }
	    if (this.selectedProducts.length) {
	      this.selected = [].concat(_toConsumableArray(this.selectedProducts));
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    settings: 'organizationSettings',
	    unitTypes: 'allUnitTypes',
	    account: 'account'
	  }), {
	    products: function products() {
	      var selectedIds = this.selected ? this.selected.map(function (s) {
	        return s.id;
	      }) : [];
	      return this.allProductOptions.filter(function (p) {
	        return !selectedIds.includes(p.id);
	      });
	    },
	    allProductOptions: function allProductOptions() {
	      var _this = this;
	
	      return this.allProducts.map(function (p) {
	        var selectWarehouseQty = p.warehouses.find(function (p2) {
	          return p2.warehouseId === _this.warehouseId;
	        });
	        var currentQty = selectWarehouseQty ? selectWarehouseQty.qtyNumber : 0;
	
	        var isDisabled = false;
	        if (_this.warehouseId !== 0) {
	          isDisabled = !(!p.stockable || p.warehouses.find(function (pw) {
	            return +pw.warehouseId === +_this.warehouseId;
	          }));
	        }
	
	        if (p.productType.name === 'Bundle') {
	          isDisabled = false;
	          currentQty = 1;
	        }
	
	        if (_this.batchOptions) {
	          var batches = _this.getProductBatches(p);
	          if (batches.length) {
	            currentQty = batches.map(function (item) {
	              return item.qtyNumber || 0;
	            }).reduce(function (total, qtyNumber) {
	              return total + qtyNumber;
	            });
	          }
	
	          var defaultBatchId = '';
	          if (batches.length === 1) defaultBatchId = batches[0].id;else if (batches.length > 1) defaultBatchId = batches[1].id;
	
	          var batchesWithStocks = batches.filter(function (b) {
	            return b.qtyNumber > 0;
	          });
	          if (batchesWithStocks.length === 1) {
	            defaultBatchId = batchesWithStocks[0].id;
	          }
	          return Object.assign({}, p, {
	            qty: 1,
	            currentQty: currentQty,
	            productType: p.productType.name,
	            info: 'info' in p ? p.info : _this.getProductInfo(p),
	            batchId: defaultBatchId,
	            batches: batches,
	            disabled: isDisabled,
	            productTypeGroup: p.productTypeGroup,
	            unitQty: p.productTypeGroup === 'Beverage' ? 1 : '',
	            unitTypeId: p.productTypeGroup === 'Beverage' ? 1 : ''
	          });
	        }
	        return Object.assign({}, p, {
	          qty: 1,
	          currentQty: currentQty,
	          productType: p.productType.name,
	          info: 'info' in p ? p.info : _this.getProductInfo(p),
	          disabled: isDisabled,
	          productTypeGroup: p.productTypeGroup,
	          unitQty: p.productTypeGroup === 'Beverage' ? 1 : '',
	          unitTypeId: p.productTypeGroup === 'Beverage' ? 1 : ''
	        });
	      });
	    }
	  }),
	
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.loading = true;
	    Promise.all([_unitType2.default.all()]).then(function () {
	      _this2.ready = true;
	    });
	    this.fetchProducts();
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS'
	  }), {
	    fetchProducts: function fetchProducts() {
	      var _this3 = this;
	
	      this.fetchProductsMethod().then(function (data) {
	        _this3.allProducts = data[0];
	        if (_this3.selected.length) {
	          var selectedIds = _this3.selected.map(function (s) {
	            return +s.id;
	          });
	          _this3.selected = _this3.allProductOptions.filter(function (p) {
	            return selectedIds.includes(+p.id);
	          });
	        }
	        _this3.loading = false;
	      });
	    },
	    getProductInfo: function getProductInfo(item) {
	      var tags = this.$i18n.messages[this.$i18n.locale].form.products;
	      var details = [];
	      this.settings.productInfoDisplay.forEach(function (field) {
	        if (item[field] !== undefined) {
	          details.push(tags[field].label + ': ' + item[field]);
	        } else if (item.fieldsJSON[field] !== undefined) {
	          details.push(tags[field].label + ': ' + item.fieldsJSON[field]);
	        }
	      });
	      return details.join(' | ');
	    },
	    getProductBatches: function getProductBatches(item) {
	      var _this4 = this;
	
	      var productWarehouses = item.warehouses;
	      if (this.warehouseId) {
	        productWarehouses = productWarehouses.filter(function (p) {
	          return +p.warehouseId === +_this4.warehouseId;
	        });
	      }
	      var batchIds = productWarehouses.map(function (p) {
	        return +p.batchId;
	      });
	      var batches = this.batchOptions.filter(function (b) {
	        return batchIds.includes(+b.id);
	      }).map(function (batch) {
	        var batchProduct = productWarehouses.find(function (p) {
	          return +p.batchId === +batch.id;
	        });
	        return Object.assign({}, {
	          id: batch.id,
	          name: _this4.warehouseId ? batch.code + ' | ' + _this4.$t('static.orders.edit.availableQty') + ': ' + batchProduct.qty : batch.code,
	          qtyNumber: batchProduct.qtyNumber
	        });
	      });
	      batches = batches.reverse();
	
	      if (this.$route.name === 'orders.edit') {
	        batches = batches.filter(function (batch) {
	          return batch.qtyNumber > 0;
	        });
	        batches.sort(function (a, b) {
	          return b.id - a.id;
	        });
	      }
	
	      var nonBatchProduct = productWarehouses.find(function (p) {
	        return p.batchId === 0;
	      });
	      if (nonBatchProduct) {
	        batches.unshift({
	          id: '0',
	          name: this.$t('static.orders.edit.nonBatch') + ' | ' + this.$t('static.orders.edit.availableQty') + ': ' + nonBatchProduct.qty,
	          qtyNumber: nonBatchProduct.qtyNumber
	        });
	      }
	
	      return batches;
	    },
	    handleCurrentChange: function handleCurrentChange(selected) {
	      if (!selected || selected.disabled) return;
	      this.selected.push(selected);
	    },
	    handleRemove: function handleRemove(index) {
	      this.selected.splice(index, 1);
	    },
	    handleSubmit: function handleSubmit() {
	      var _this5 = this;
	
	      this.submitLoading = true;
	      this.onSave(this.selected).then(function () {
	        _this5.submitLoading = false;
	        _this5.closeModal();
	      }).catch(function (errors) {
	        _this5.submitLoading = false;
	        if (errors && errors.items) {
	          _this5.$message({
	            showClose: true,
	            message: _this5.$t('static.bulkProductAdd.emptySelectionError'),
	            type: 'error',
	            customClass: 'bulk-add-product-modal-message'
	          });
	          return;
	        }
	        var msg = _this5.extractBulkSaveErrorMessage(errors);
	        if (msg) {
	          _this5.$message({
	            showClose: true,
	            message: msg,
	            type: 'error',
	            customClass: 'bulk-add-product-modal-message'
	          });
	        }
	      });
	    },
	    extractBulkSaveErrorMessage: function extractBulkSaveErrorMessage(errors) {
	      if (!errors) {
	        return null;
	      }
	      if (typeof errors === 'string') {
	        return errors;
	      }
	      if ((typeof errors === 'undefined' ? 'undefined' : _typeof(errors)) !== 'object') {
	        return null;
	      }
	      if (errors.exceed_creditnote_amount && errors.exceed_creditnote_amount[0]) {
	        return errors.exceed_creditnote_amount[0];
	      }
	      if (errors.exceedCreditnoteAmount && errors.exceedCreditnoteAmount[0]) {
	        return errors.exceedCreditnoteAmount[0];
	      }
	      if (errors.errors && _typeof(errors.errors) === 'object') {
	        var firstKey = Object.keys(errors.errors)[0];
	        var arr = firstKey ? errors.errors[firstKey] : null;
	        if (Array.isArray(arr) && arr[0]) {
	          return arr[0];
	        }
	      }
	      if (errors.message && typeof errors.message === 'string') {
	        return errors.message;
	      }
	      var keys = Object.keys(errors);
	      for (var i = 0; i < keys.length; i += 1) {
	        var val = errors[keys[i]];
	        if (Array.isArray(val) && val[0] && typeof val[0] === 'string') {
	          return val[0];
	        }
	      }
	      return this.$t('static.bulkProductAdd.saveError');
	    },
	    searchTableRowClassName: function searchTableRowClassName(_ref) {
	      var row = _ref.row;
	
	      if (row.disabled) {
	        return 'disabled';
	      }
	    },
	    disableSubmit: function disableSubmit() {
	      return Boolean(!this.loading && !this.selected.length > 0);
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    },
	    addBatch: function addBatch(product) {
	      var _this6 = this;
	
	      this.$prompt('' + this.$t('form.batches.batchNumber.label'), this.$t('static.batches.create.title'), {
	        confirmButtonText: this.$t('button.save'),
	        cancelButtonText: this.$t('button.cancel')
	      }).then(function (_ref2) {
	        var value = _ref2.value;
	
	        _this6.batchLoading = true;
	        var batch = _batch4.default.send({
	          batchNumber: value,
	          status: 'completed',
	          custom: 1,
	          productId: product.id,
	          warehouseId: _this6.warehouseIdForBatch
	        });
	        _batch2.default.store(batch).then(function (data) {
	          _store2.default.dispatch('addBatch', data);
	          _this6.batchOptions.push(data);
	          _this6.fetchProducts();
	          _this6.batchLoading = false;
	          _this6.$message({
	            message: _this6.$t('static.batches.create.success'),
	            type: 'success'
	          });
	        }).catch(function () {
	          _this6.batchLoading = false;
	          _this6.$message({
	            message: _this6.$t('static.batches.create.error'),
	            type: 'error'
	          });
	        });
	      });
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      search: '',
	      selected: [],
	      loading: false,
	      submitLoading: false
	    };
	  },
	
	  props: {
	    selectedProducts: {
	      type: Array,
	      required: true,
	      default: []
	    },
	    warehouseId: {
	      type: Number,
	      required: false,
	      default: 0
	    },
	    onSave: {
	      type: Function,
	      required: true,
	      default: function _default() {}
	    },
	    onClose: {
	      type: Function,
	      required: true,
	      default: function _default() {}
	    }
	  },
	  computed: _extends({}, (0, _vuex.mapGetters)({})),
	
	  mounted: function mounted() {
	    this.selected = [].concat(_toConsumableArray(this.selectedProducts)).map(function (p) {
	      return Object.assign({}, p, { selectedQty: p.qtyNumber });
	    });
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    handleSubmit: function handleSubmit() {
	      var _this = this;
	
	      this.submitLoading = true;
	      this.onSave(this.selected).then(function () {
	        _this.submitLoading = false;
	        _this.closeModal();
	      }).catch(function (errors) {
	        if (errors.items) {
	          _this.$message({
	            showClose: true,
	            message: _this.$t('static.bulkDestroyProducts.emptySelectionError'),
	            type: 'error'
	          });
	        }
	        _this.submitLoading = false;
	      });
	    },
	    disableSubmit: function disableSubmit() {
	      return Boolean(!this.loading && !this.selected.length > 0);
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	      this.onClose();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false
	    };
	  },
	
	
	  props: {
	    onSubmit: {
	      type: Function,
	      required: true,
	      default: function _default() {}
	    },
	    info: {
	      type: Object,
	      required: false,
	      default: function _default() {}
	    }
	  },
	
	  computed: {},
	
	  mounted: function mounted() {},
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    run: function run() {
	      var _this = this;
	
	      this.loading = true;
	      this.onSubmit().then(function () {
	        _this.loading = false;
	        _this.$message({
	          showClose: true,
	          message: _this.$t('static.organizationSettings.bulk_price_update_success'),
	          type: 'success'
	        });
	        _this.closeModal();
	      }).catch(function () {
	        _this.loading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	      this.onClose();
	    }
	  })
	};

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _bill = __webpack_require__(92);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _paymentMethods = __webpack_require__(467);
	
	var _paymentMethods2 = _interopRequireDefault(_paymentMethods);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        paymentDateOption: {
	          value: '',
	          type: 'select'
	        },
	        paymentDate: {
	          value: '',
	          type: 'date'
	        },
	        paymentMethod: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      bills: [],
	      showForm: true,
	      loading: false,
	      submitLoading: false,
	      submitted: false,
	      errors: []
	    };
	  },
	
	  props: {
	    operation: {
	      type: String,
	      required: true,
	      default: ''
	    },
	    selectedBills: {
	      type: Array,
	      required: true,
	      default: function _default() {
	        return [];
	      }
	    },
	    onSubmit: {
	      type: Function,
	      required: true,
	      default: function _default() {}
	    }
	  },
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    settings: 'organizationSettings',
	    account: 'account',
	    paymentMethods: 'paymentMethods'
	  }), {
	    listPaymentMethods: function listPaymentMethods() {
	      var _this = this;
	
	      return this.paymentMethods.map(function (item) {
	        return {
	          id: item.id,
	          name: _this.$t('static.reports.bills.' + item.name.replace(/\s+/g, '').toLowerCase())
	        };
	      });
	    },
	    successStatus: function successStatus() {
	      var statuses = {
	        confirmOrder: 'Confirmed',
	        confirmShipping: 'Confirmed Shipping',
	        confirmOrderAndShipping: 'Confirmed Order & Shipping',
	        createInvoice: 'Invoiced',
	        cancelOrder: 'Cancelled'
	      };
	
	      return statuses[this.operation];
	    },
	    errorsByBill: function errorsByBill() {
	      return this.errors.length ? this.errors.reduce(function (errors, item) {
	        var bill = errors[item.bill_id] || [];
	        bill.push(item);
	        errors[item.bill_id] = bill;
	        return errors;
	      }, {}) : [];
	    },
	    selectedBillIds: function selectedBillIds() {
	      return this.selectedBills.map(function (item) {
	        return item.id;
	      });
	    }
	  }),
	
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.bills = this.selectedBills;
	    this.form.setOptions('paymentDateOption', [{ id: 'payment_date', name: this.$t('static.bulkProcessBill.payment_date_options.selectDate') }, { id: 'due_date', name: this.$t('static.bulkProcessBill.payment_date_options.dueDate') }]);
	    this.form.hideField('paymentDate');
	    this.form.paymentDate = (0, _moment2.default)().format('YYYY-MM-DD');
	    this.loading = true;
	    Promise.all([_organizationSettings2.default.show(), _paymentMethods2.default.all()]).then(function () {
	      _this2.form.setOptions('paymentMethod', _this2.listPaymentMethods);
	      _this2.loading = false;
	    });
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    getBill: function getBill(id) {
	      return this.selectedBills.find(function (o) {
	        return o.id === +id;
	      });
	    },
	    handleSubmit: function handleSubmit() {
	      var _this3 = this;
	
	      this.submitLoading = true;
	      this.onSubmit(this.selected).then(function () {
	        _this3.submitLoading = false;
	        _this3.closeModal();
	      }).catch(function (errors) {
	        if (errors.items) {
	          _this3.$message({
	            showClose: true,
	            message: _this3.$t('static.bulkProductAdd.emptySelectionError'),
	            type: 'error'
	          });
	        }
	        _this3.submitLoading = false;
	      });
	    },
	    confirm: function confirm() {
	      var _this4 = this;
	
	      this.$confirm(this.$t('static.bills.index.confirmAction1') + ' ' + this.$t('static.bills.index.action.' + this.operation) + ' ' + this.$t('static.bills.index.confirmAction2') + ' ' + this.bills.length + ' ' + this.$t('static.bills.index.confirmAction3'), this.$t('static.bills.index.confirmActionTitle'), {
	        confirmButtonText: this.$t('button.yes'),
	        cancelButtonText: this.$t('button.no'),
	        type: 'warning'
	      }).then(function () {
	        if (_this4.operation === 'markBilledAsPaid') {
	          _this4.markBilledAsPaid();
	        }
	      }).catch(function () {});
	    },
	    markBilledAsPaid: function markBilledAsPaid() {
	      var _this5 = this;
	
	      this.submitLoading = true;
	
	      var paymentDates = this.bills.reduce(function (c, _ref) {
	        var id = _ref.id,
	            paymentDate = _ref.paymentDate;
	
	        c[id] = paymentDate;
	        return c;
	      }, {});
	
	      var amountPaids = this.bills.reduce(function (c, _ref2) {
	        var id = _ref2.id,
	            amountDue = _ref2.amountDue,
	            amountDueNum = _ref2.amountDueNum;
	
	        c[id] = amountDue !== '-' && !amountDue.includes('kr') ? amountDue : amountDueNum;
	        return c;
	      }, {});
	
	      return _bill2.default.bulkMarkAsPaid(this.selectedBillIds, {
	        payment_date_option: this.form.paymentDateOption,
	        payment_date: this.form.paymentDate,
	        payment_dates: paymentDates,
	        amount_paids: amountPaids,
	        payment_method: this.form.paymentMethod
	      }).then(function (data) {
	        _this5.showResult(data);
	      }).catch(function (errors) {
	        _this5.submitLoading = false;
	        var message = errors.data.message || '';
	        if (errors.data.payment_date_option) {
	          message = errors.data.payment_date_option[0];
	        }
	        if (errors.data.payment_date) {
	          message = errors.data.payment_date[0];
	        }
	        if (message) {
	          _this5.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    showResult: function showResult(data) {
	      this.submitted = true;
	      this.submitLoading = false;
	      if (data.errors.length) {
	        this.errors = data.errors;
	      }
	    },
	    closeModal: function closeModal() {
	      if (this.submitted) {
	        this.onSubmit();
	      }
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  watch: {
	    'form.paymentDateOption': function formPaymentDateOption(paymentDateOption) {
	      if (paymentDateOption === 'payment_date') {
	        this.form.showField('paymentDate');
	        this.form.paymentDate = '';
	      } else {
	        this.bills = this.bills.map(function (p) {
	          return _extends({}, p, { paymentDate: p.dueDate });
	        });
	        this.form.hideField('paymentDate');
	      }
	    },
	    'form.paymentDate': function formPaymentDate(paymentDate) {
	      this.bills = this.bills.map(function (p) {
	        return _extends({}, p, { paymentDate: paymentDate });
	      });
	    }
	  },
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _vuex = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      clients: [],
	      clientOptions: [],
	      optionsLoading: false,
	      subTitle: '',
	      submitLoading: false
	    };
	  },
	
	  props: {
	    selectedClients: {
	      type: Array,
	      required: true,
	      default: function _default() {
	        return [];
	      }
	    },
	    onSubmit: {
	      type: Function,
	      required: true,
	      default: function _default() {}
	    },
	    type: {
	      type: String,
	      required: true,
	      default: ''
	    }
	  },
	
	  computed: {},
	
	  mounted: function mounted() {
	    this.clients = JSON.parse(JSON.stringify(this.selectedClients));
	    if (this.type === 'activateClient') {
	      this.subTitle = 'Activate Client';
	    } else if (this.type === 'deactivateClient') {
	      this.subTitle = 'Deactivate Client';
	    } else if (this.type === 'isProducer') {
	      this.subTitle = 'Producer';
	    } else if (this.type === 'isSubClient') {
	      this.subTitle = 'Sub Client';
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    proceed: function proceed() {
	      var _this = this;
	
	      var data = this.clients.map(function (item) {
	        return item.id;
	      });
	      if (this.type === 'isSubClient') {
	        data = this.clients.map(function (item) {
	          return {
	            id: item.id,
	            bill_main_parent: item.billMainParent,
	            client_parent_id: item.clientParentId
	          };
	        });
	      }
	
	      this.submitLoading = true;
	      _client2.default.bulkUpdate({ client_ids: Object.assign({}, data), type: this.type }).then(function () {
	        _this.submitLoading = false;
	        _this.$message({
	          message: 'Selected client successfully update',
	          type: 'success'
	        });
	        _this.handleSubmit();
	      });
	    },
	    onBillMainParent: function onBillMainParent(value, id) {
	      var objIndex = this.clients.findIndex(function (obj) {
	        return obj.id === id;
	      });
	      this.clients[objIndex].billMainParent = !!value;
	    },
	    onClientParent: function onClientParent(value, id) {
	      var objIndex = this.clients.findIndex(function (obj) {
	        return obj.id === id;
	      });
	      this.clients[objIndex].clientParentId = value;
	    },
	    searchMethod: function searchMethod(search, id) {
	      var _this2 = this;
	
	      if (search !== '') {
	        this.optionsLoading = true;
	        _client2.default.all(search, id).then(function (response) {
	          _this2.clientOptions = response.map(function (c) {
	            return { value: c.id, label: c.name };
	          });
	          _this2.optionsLoading = false;
	        });
	      }
	    },
	    handleSubmit: function handleSubmit() {
	      this.closeModal();
	      this.onSubmit();
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {}
	};

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _orderProduct = __webpack_require__(48);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _shippingProvider = __webpack_require__(97);
	
	var _shippingProvider2 = _interopRequireDefault(_shippingProvider);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _shippingConfirm = __webpack_require__(198);
	
	var _shippingConfirm2 = _interopRequireDefault(_shippingConfirm);
	
	var _bill = __webpack_require__(92);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _order = __webpack_require__(54);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _ediOrder = __webpack_require__(187);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _batchOptions = __webpack_require__(201);
	
	var _quickProductEditExcise = __webpack_require__(419);
	
	var _quickProductEditExcise2 = _interopRequireDefault(_quickProductEditExcise);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _batch = __webpack_require__(60);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      warehouseList: [],
	      batcheList: [],
	      form: new _forms2.default({
	        confirmDate: {
	          value: '',
	          type: 'date'
	        },
	        deliveryDate: {
	          value: '',
	          type: 'date'
	        },
	        warehouseId: {
	          type: 'select',
	          value: ''
	        },
	        shippingProviderId: {
	          value: '',
	          type: 'select'
	        },
	        shippingDate: {
	          value: '',
	          type: 'date'
	        }
	      }),
	      loading: false,
	      submitLoading: false,
	      submitted: false,
	      errors: [],
	      options: [{
	        value: 'Option1',
	        label: 'Option1'
	      }, {
	        value: 'Option2',
	        label: 'Option2'
	      }, {
	        value: 'Option3',
	        label: 'Option3'
	      }, {
	        value: 'Option4',
	        label: 'Option4'
	      }, {
	        value: 'Option5',
	        label: 'Option5'
	      }],
	      value1: [],
	      selectedBatchProduct: []
	    };
	  },
	
	  props: {
	    operation: {
	      type: String,
	      required: true,
	      default: ''
	    },
	    selectedOrders: {
	      type: Array,
	      required: true,
	      default: function _default() {
	        return [];
	      }
	    },
	    onSubmit: {
	      type: Function,
	      required: true,
	      default: function _default() {}
	    }
	  },
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    orderProducts: 'allOrderProducts',
	    warehouses: 'allWarehouses',
	    settings: 'organizationSettings',
	    account: 'account',
	    shippingProviders: 'allShippingProviders',
	    batches: 'allBatches'
	  }), {
	    successStatus: function successStatus() {
	      var statuses = {
	        confirmOrder: 'Confirmed',
	        confirmShipping: 'Confirmed Shipping',
	        confirmOrderAndShipping: 'Confirmed Order & Shipping',
	        createInvoice: 'Invoiced',
	        cancelOrder: 'Cancelled'
	      };
	
	      return statuses[this.operation];
	    },
	    showForm: function showForm() {
	      return !['cancelOrder', 'createInvoice'].includes(this.operation);
	    },
	    orders: function orders() {
	      return this.selectedOrders;
	    },
	    nonEdiOrders: function nonEdiOrders() {
	      return this.selectedOrders.filter(function (item) {
	        return !item.isEdi;
	      });
	    },
	    ediOrders: function ediOrders() {
	      return this.selectedOrders.filter(function (item) {
	        return item.isEdi;
	      });
	    },
	    errorsByOrder: function errorsByOrder() {
	      return this.errors.length ? this.errors.reduce(function (errors, item) {
	        var order = errors[item.order_id] || [];
	        order.push(item);
	        errors[item.order_id] = order;
	        return errors;
	      }, {}) : [];
	    },
	    selectedOrderIds: function selectedOrderIds() {
	      return this.selectedOrders.map(function (item) {
	        return item.id;
	      });
	    },
	    selectedNonEdiOrderIds: function selectedNonEdiOrderIds() {
	      return this.nonEdiOrders.map(function (item) {
	        return item.id;
	      });
	    },
	    selectedEdiOrderIds: function selectedEdiOrderIds() {
	      return this.ediOrders.map(function (item) {
	        return item.ediOrderId;
	      });
	    },
	    batchProducts: function batchProducts() {
	      return this.batcheList;
	    },
	    bevearageProducts: function bevearageProducts() {
	      return this.orderProducts.filter(function (p) {
	        return p.productType === 'Beverage' || p.productTypeGroup === 'Beverage';
	      }).map(function (item) {
	        var excise = [];
	        if (item.exciseAlcoholGroup) {
	          excise.push(item.exciseAlcoholGroupName);
	        }
	        if (item.excisePackagingGroup) {
	          excise.push(item.excisePackagingGroupName);
	        }
	        if (item.exciseBasicGroup) {
	          excise.push(item.exciseBasicGroupName);
	        }
	
	        return {
	          id: item.id,
	          name: item.name,
	          beverage: item.exciseAlcoholGroupName || '-',
	          packaging: item.excisePackagingGroupName || '-',
	          basic: item.exciseBasicGroupName || '-',
	          excisable: item.excisable,
	          bottleVolume: item.fieldsJSON.bottle_volume,
	          alcoholPercentage: item.fieldsJSON.alcohol_percentage,
	          noExcise: !item.excisable || excise.length === 0 || !item.fieldsJSON.bottle_volume || !item.fieldsJSON.alcohol_percentage
	        };
	      });
	    },
	    hasNoExcise: function hasNoExcise() {
	      return this.bevearageProducts.filter(function (p) {
	        return p.noExcise;
	      }).length !== 0 && this.hasExciseModule;
	    },
	    hasExciseModule: function hasExciseModule() {
	      var hasExciseModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Excise') {
	            hasExciseModule = true;
	          }
	        }
	      }
	      return hasExciseModule;
	    }
	  }),
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.configureFieldVisibility();
	    this.form.confirmDate = (0, _moment2.default)().format('YYYY-MM-DD');
	    this.loading = true;
	    Promise.all([_warehouse2.default.all(), _organizationSettings2.default.show(), _shippingProvider2.default.all(), _orderProduct2.default.allBulk(this.selectedOrderIds), _batch2.default.all({
	      has_warehouse_transaction: 1,
	      for_select: 1
	    })]).then(function () {
	      _this.loading = false;
	      _this.warehouseList = _this.warehouses.items.filter(function (obj) {
	        return obj.isActive === true;
	      });
	      _this.form.warehouseId = _this.settings.defaultWarehouse;
	      _this.form.shippingProviderId = +_this.settings.defaultShippingProvider;
	      _this.selectedBatchProduct = _this.batchProducts.map(function (c) {
	        return { batchIds: c.selectedBatch, productId: c.productId, id: c.id, orderId: c.orderId };
	      });
	    });
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    updateBatchProduct: function updateBatchProduct(value) {
	      this.selectedBatchProduct = this.selectedBatchProduct.filter(function (obj) {
	        return obj.productId !== value.productId;
	      });
	      this.selectedBatchProduct.push([value].map(function (c) {
	        return { batchIds: c.selectedBatch, productId: c.productId, id: c.id, orderId: c.orderId };
	      })[0]);
	    },
	    getOrder: function getOrder(id) {
	      return this.selectedOrders.find(function (o) {
	        return o.id === +id;
	      });
	    },
	    configureFieldVisibility: function configureFieldVisibility() {
	      if (!this.ediOrders.length) {
	        this.form.hideField('deliveryDate');
	      }
	      if (this.operation === 'confirmOrder') {
	        this.form.hideField('shippingProviderId');
	        this.form.hideField('shippingDate');
	      }
	      if (this.operation === 'confirmShipping') {
	        this.form.hideField('confirmDate');
	        this.form.hideField('warehouseId');
	        this.form.hideField('deliveryDate');
	      }
	    },
	    handleSubmit: function handleSubmit() {
	      var _this2 = this;
	
	      this.submitLoading = true;
	      this.onSubmit(this.selected).then(function () {
	        _this2.submitLoading = false;
	        _this2.closeModal();
	      }).catch(function (errors) {
	        if (errors.items) {
	          _this2.$message({
	            showClose: true,
	            message: _this2.$t('static.bulkProductAdd.emptySelectionError'),
	            type: 'error'
	          });
	        }
	        _this2.submitLoading = false;
	      });
	    },
	    transform: function transform(data) {
	      return {
	        confirmDate: data.confirm_date,
	        deliveryDate: data.delivery_date,
	        warehouseId: data.warehouse_id,
	        shippingProviderId: data.shipping_provider_id,
	        shippingDate: data.shipping_date
	      };
	    },
	    confirm: function confirm() {
	      var _this3 = this;
	
	      this.$confirm(this.$t('static.ediOrders.index.confirmAction1') + ' ' + this.$t('static.ediOrders.index.action.' + this.operation) + ' ' + this.$t('static.ediOrders.index.confirmAction2') + ' ' + this.selectedOrders.length + ' ' + this.$t('static.ediOrders.index.confirmAction3'), this.$t('static.ediOrders.index.confirmActionTitle'), {
	        confirmButtonText: this.$t('button.yes'),
	        cancelButtonText: this.$t('button.no'),
	        type: 'warning'
	      }).then(function () {
	        if (_this3.operation === 'confirmOrder') {
	          _this3.confirmOrder();
	        } else if (_this3.operation === 'confirmShipping') {
	          _this3.confirmShipping();
	        } else if (_this3.operation === 'confirmOrderAndShipping') {
	          _this3.confirmOrderAndShipping();
	        }
	      }).catch(function () {});
	    },
	    confirmOrder: function confirmOrder() {
	      var _this4 = this;
	
	      this.submitLoading = true;
	      var client = _shippingConfirm2.default.send(Object.assign({}, this.form.data()));
	
	      var resources = [];
	      if (this.nonEdiOrders.length) {
	        resources.push(_order2.default.bulkConfirm(this.selectedNonEdiOrderIds, client));
	      }
	      if (this.ediOrders.length) {
	        resources.push(_ediOrder2.default.bulkConfirm(this.selectedEdiOrderIds, client));
	      }
	
	      return Promise.all(resources).then(function (data) {
	        _this4.showResult(data);
	      }).catch(function (errors) {
	        _this4.submitLoading = false;
	        _this4.form.recordErrors(_this4.transform(errors.data));
	        var message = errors.data.message;
	        if (message) {
	          _this4.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    confirmShipping: function confirmShipping() {
	      var _this5 = this;
	
	      this.submitLoading = true;
	      var formData = _shippingConfirm2.default.send(Object.assign({}, this.form.data()));
	      var resources = [];
	      if (this.nonEdiOrders.length) {
	        resources.push(_order2.default.bulkConfirmShipping(this.selectedNonEdiOrderIds, formData));
	      }
	      if (this.ediOrders.length) {
	        resources.push(_ediOrder2.default.bulkProcess(this.selectedEdiOrderIds, formData));
	      }
	
	      return Promise.all(resources).then(function (data) {
	        _this5.showResult(data);
	      }).catch(function (errors) {
	        _this5.submitLoading = false;
	        _this5.form.recordErrors(_this5.transform(errors.data));
	        var message = _this5.$t('static.ediOrders.edit.confirmError');
	        if (message) {
	          _this5.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    confirmOrderAndShipping: function confirmOrderAndShipping() {
	      var _this6 = this;
	
	      this.submitLoading = true;
	      var formData = _shippingConfirm2.default.send(Object.assign({}, this.form.data()));
	
	      this.selectedBatchProduct.forEach(function (item) {
	        _orderProduct2.default.update(item.orderId, item, item.id, 'bulk');
	      });
	
	      var resources = [];
	      if (this.nonEdiOrders.length) {
	        resources.push(_order2.default.bulkConfirmAndShipping(this.selectedNonEdiOrderIds, formData));
	      }
	      if (this.ediOrders.length) {
	        resources.push(_ediOrder2.default.bulkConfirmAndShipping(this.selectedEdiOrderIds, formData));
	      }
	
	      return Promise.all(resources).then(function (data) {
	        _this6.showResult(data);
	      }).catch(function (errors) {
	        _this6.submitLoading = false;
	        _this6.form.recordErrors(_this6.transform(errors.data));
	        var message = _this6.$t('static.ediOrders.edit.confirmError');
	        if (message) {
	          _this6.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    cancelOrder: function cancelOrder() {
	      var _this7 = this;
	
	      Promise.all([_order2.default.bulkCancel(this.selectedOrderIds)]).then(function (data) {
	        _this7.showResult(data);
	      }).catch(function () {
	        _this7.$message({
	          showClose: true,
	          message: _this7.$t('static.orders.edit.cancelError'),
	          type: 'error'
	        });
	      });
	    },
	    createInvoices: function createInvoices() {
	      var _this8 = this;
	
	      this.submitLoading = true;
	      Promise.all([_bill2.default.store({ order_ids: this.selectedOrderIds })]).then(function (data) {
	        _this8.showResult(data);
	      }).catch(function (errors) {
	        if (errors.code === 40116) {
	          errors = {
	            orderId: [_this8.$t('static.bills.create.orderError')]
	          };
	        }
	
	        _this8.form.recordErrors(errors);
	      });
	    },
	    showResult: function showResult(data) {
	      this.submitted = true;
	      this.submitLoading = false;
	
	      var errors = [];
	      data.forEach(function (item) {
	        errors = [].concat(errors, item.errors);
	      });
	      if (errors.length) {
	        this.errors = errors;
	      }
	    },
	    quickProductEdit: function quickProductEdit(id) {
	      var _this9 = this;
	
	      var item = this.orderProducts.find(function (p) {
	        return +p.id === +id;
	      });
	      if (item) {
	        this.setModalProps({
	          productId: item.productId,
	          productName: item.name,
	          orderProduct: item,
	          isEdi: false,
	          destination: function destination() {
	            return __webpack_require__(766);
	          },
	          destinationProps: {
	            operation: this.operation,
	            selectedOrders: this.selectedOrders,
	            onSubmit: function onSubmit() {
	              return _this9.onSubmit;
	            }
	          }
	        });
	        this.toggle(true);
	        this.setModalContent(function () {
	          return _quickProductEditExcise2.default;
	        });
	      }
	    },
	    closeModal: function closeModal() {
	      if (this.submitted) {
	        this.onSubmit();
	      }
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  watch: {
	    warehouseList: function warehouseList(warehouses) {
	      var hasModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            hasModule = true;
	            this.form.setOptions('warehouseId', warehouses);
	          }
	        }
	      }
	    },
	
	
	    'form.warehouseId': function formWarehouseId(value) {
	      var _this10 = this;
	
	      var orderProducts = [].concat(_toConsumableArray(new Map(this.orderProducts.map(function (v) {
	        return [v.productId, v];
	      })).values()));
	      this.batcheList = orderProducts.filter(function (p) {
	        return p.productType === 'Beverage' || p.productTypeGroup === 'Beverage';
	      }).map(function (item) {
	        var products = item.warehouses;
	
	        var options = [];
	        if (products.length) {
	          var batchIds = products.map(function (p) {
	            return p.batchId.toString();
	          });
	          var nonBatchProduct = products.find(function (p) {
	            return p.batchId === 0 && parseInt(value) === parseInt(p.warehouseId);
	          });
	          options = nonBatchProduct ? [{
	            id: '0',
	            name: _this10.$t('static.orders.edit.nonBatch') + ' | ' + _this10.$t('static.orders.edit.availableQty') + ': ' + nonBatchProduct.qtyNumber,
	            available: nonBatchProduct.qtyNumber
	          }] : [];
	
	          options = options.concat(_this10.batches.filter(function (b) {
	            return batchIds.indexOf(b.id) !== -1;
	          }).map(function (batch) {
	            var batchProduct = products.find(function (p) {
	              return p.batchId.toString() === batch.id.toString() && parseInt(value) === parseInt(p.warehouseId);
	            });
	            if (batchProduct) {
	              return Object.assign({}, {
	                id: batch.id.toString(),
	                name: batch.code + ' | ' + _this10.$t('static.orders.edit.availableQty') + ': ' + batchProduct.qtyNumber,
	                available: batchProduct.qtyNumber
	              });
	            }
	            return [];
	          }));
	        }
	
	        options = (0, _batchOptions.sortBatchOptions)(options, { hideEmpty: true });
	        var selectedBatch = options.length > 0 ? [(0, _batchOptions.defaultBatchId)(options)] : [];
	        options = options.map(function (c) {
	          return { value: c.id, label: c.name };
	        });
	        return {
	          id: item.id,
	          name: item.name,
	          batchOptions: options,
	          selectedBatch: selectedBatch,
	          productId: item.productId,
	          orderId: item.orderId
	        };
	      });
	    },
	
	    shippingProviders: function shippingProviders(_shippingProviders) {
	      var hasModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Shipping Provider') {
	            hasModule = true;
	          }
	        }
	      }
	      if (hasModule) {
	        this.form.setOptions('shippingProviderId', _shippingProviders.map(function (c) {
	          return { id: c.id, name: c.name + ' ' };
	        }));
	      } else {
	        this.form.hideField('shippingProviderId');
	      }
	    }
	  },
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _vuex = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      products: [],
	      optionsLoading: false,
	      subTitle: '',
	      submitLoading: false
	    };
	  },
	
	  props: {
	    selectedProducts: {
	      type: Array,
	      required: true,
	      default: function _default() {
	        return [];
	      }
	    },
	    onSubmit: {
	      type: Function,
	      required: true,
	      default: function _default() {}
	    },
	    type: {
	      type: String,
	      required: true,
	      default: ''
	    }
	  },
	
	  mounted: function mounted() {
	    this.products = JSON.parse(JSON.stringify(this.selectedProducts));
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    proceed: function proceed() {
	      var _this = this;
	
	      this.submitLoading = true;
	      if (this.type === 'syncToWoo') {
	        _product2.default.bulkSyncToWoo(this.selectedProducts.map(function (item) {
	          return item.id;
	        })).then(function () {
	          _this.submitLoading = false;
	          _this.$message({
	            message: 'Selected product successfully Synced',
	            type: 'success'
	          });
	          _this.handleSubmit();
	        }).catch(function () {
	          _this.submitLoading = false;
	        });
	        return;
	      }
	      _product2.default.bulkUpdate({ product_ids: this.selectedProducts.map(function (item) {
	          return item.id;
	        }), type: this.type }).then(function () {
	        _this.submitLoading = false;
	        _this.$message({
	          message: 'Selected product successfully update',
	          type: 'success'
	        });
	        _this.handleSubmit();
	      });
	    },
	    handleSubmit: function handleSubmit() {
	      this.closeModal();
	      this.onSubmit();
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {}
	};

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _report = __webpack_require__(305);
	
	var _report2 = _interopRequireDefault(_report);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    selected: {
	      type: Array,
	      required: true,
	      default: function _default() {
	        return [];
	      }
	    },
	    emailData: {
	      type: Object,
	      required: true,
	      default: function _default() {
	        return [];
	      }
	    },
	    noData: {
	      type: Array,
	      required: false,
	      default: function _default() {
	        return [];
	      }
	    },
	    noDataAllSelected: {
	      type: Boolean,
	      required: false,
	      default: function _default() {
	        return false;
	      }
	    },
	    period: {
	      type: String,
	      required: false,
	      default: function _default() {
	        return '';
	      }
	    },
	    additionalData: {
	      type: Object,
	      required: false,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        from: {
	          value: '',
	          type: 'select'
	        },
	        subject: {
	          value: this.emailData.subject,
	          type: 'text'
	        },
	        message: {
	          value: this.emailData.message,
	          type: 'textarea'
	        }
	      }),
	      selectedClients: [],
	      loading: false,
	      submitLoading: false,
	      submitted: false,
	      errors: [],
	      result: []
	    };
	  },
	
	  computed: {},
	
	  mounted: function mounted() {
	    if (this.noData.length === 0) {
	      this.form.setOptions('from', [{
	        id: { email: this.emailData.from.id, name: this.emailData.from.name },
	        name: this.emailData.from.name + '(' + this.emailData.from.id + ')'
	      }]);
	      this.form.setFieldValue('from', { email: this.emailData.from.id, name: this.emailData.from.name });
	
	      this.selectedClients = this.selected.map(function (c) {
	        return {
	          id: c.id,
	          name: c.name,
	          emails: c.emails,
	          email: c.emails.split(',')[0] || '',
	          lastSent: c.turnoverLastSent
	        };
	      });
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    handleSend: function handleSend() {
	      var _this = this;
	
	      this.submitLoading = true;
	      _report2.default.sendTurnOverPdf({
	        clients: this.selectedClients.map(function (c) {
	          return { id: c.id, email: c.email };
	        }),
	        from_email: this.form.from.email,
	        from_name: this.form.from.name,
	        subject: this.form.subject,
	        message: this.form.message,
	        sendTurnOver: 1,
	        selectedYear: this.emailData.selectedYear
	      }).then(function (response) {
	        _this.submitted = true;
	        _this.result = response.data.statuses;
	        _this.submitLoading = false;
	      }).catch(function () {
	        _this.submitLoading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  watch: {},
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _productBundle = __webpack_require__(230);
	
	var _productBundle2 = _interopRequireDefault(_productBundle);
	
	var _productBundle3 = __webpack_require__(241);
	
	var _productBundle4 = _interopRequireDefault(_productBundle3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        price: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      name: '',
	      products: [],
	      product: {}
	    };
	  },
	
	
	  components: {
	    VForm: __webpack_require__(9)
	  },
	
	  props: {
	    productId: {
	      type: Number,
	      required: true
	    },
	    orderProduct: {
	      type: Object,
	      required: false
	    },
	    updated: {
	      type: Function,
	      required: false
	    }
	  },
	
	  computed: {},
	
	  methods: {
	    show: function show() {
	      var _this = this;
	
	      _productBundle2.default.show(this.productId).then(function (res) {
	        _this.product = res;
	        _this.name = res.name;
	        _this.form.assignData(res);
	        _this.products = res.products.map(function (p) {
	          return { qty: p.pivot.qty, name: p.name, sku: p.sku_number, id: p.id };
	        });
	      });
	    },
	    save: function save() {
	      var _this2 = this;
	
	      var self = this;
	      var data = Object.assign({}, this.product, this.form.data());
	      var product = _productBundle4.default.send(this.form.data());
	      Promise.all([_productBundle2.default.update(this.productId, product)]).then(function () {
	        _this2.show();
	        if (self.updated !== undefined) {
	          self.updated(data, self.orderProduct).then(function () {
	            self.$emit('close');
	          }).catch(function () {
	            self.$emit('close');
	          });
	        } else {
	          self.$emit('close');
	        }
	
	        _this2.$message({
	          message: _this2.$t('static.products.edit.success'),
	          type: 'success'
	        });
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    this.show();
	  }
	};

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mediaQuery = __webpack_require__(288);
	
	var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      timeframeHeight: 0
	    };
	  },
	
	
	  props: {
	    day: {
	      required: true,
	      type: Object
	    },
	
	    displayWeekends: {
	      required: true,
	      type: Boolean
	    },
	
	    list: {
	      required: true,
	      type: Array
	    },
	
	    exceptions: {
	      required: true,
	      type: Array
	    },
	
	    create: {
	      required: false,
	      type: Function
	    },
	
	    edit: {
	      required: false,
	      type: Function
	    },
	
	    startTime: {
	      required: false,
	      type: String,
	      default: '00:00'
	    },
	
	    endTime: {
	      required: false,
	      type: String,
	      default: '23:59'
	    }
	  },
	
	  computed: {
	    timeframes: function timeframes() {
	      var frames = [];
	      var framesLength = (0, _moment2.default)(this.endTime, 'HH:mm').diff((0, _moment2.default)(this.startTime, 'HH:mm'), 'minutes');
	      for (var i = 0; i < framesLength; i += 1) {
	        var time = (0, _moment2.default)(this.startTime, 'HH:mm').add(i, 'minutes').format('HH:mm');
	        if (time.split(':')[1] === '00') {
	          frames.push(time);
	        }
	      }
	
	      return frames;
	    }
	  },
	
	  mounted: function mounted() {
	    this.timeframeHeight = this.$refs.timeframes.children[0].offsetHeight;
	    var now = (0, _moment2.default)().format('HH:mm');
	    document.querySelector('.main').scrollTop = this.offsetTop(now);
	  },
	  destroyed: function destroyed() {
	    document.querySelector('.main').scrollTop = 0;
	  },
	
	
	  methods: {
	    daysArray: function daysArray() {
	      var c = 1;
	      if (!this.isDesktop()) {
	        return [0];
	      }
	
	      c = this.displayWeekends ? 7 : 5;
	      return [].concat(_toConsumableArray(Array(c).keys()));
	    },
	    onEdit: function onEdit(date) {
	      var _this = this;
	
	      if (!this.edit) return false;
	
	      return function (o) {
	        _this.edit(date, o);
	      };
	    },
	    changeDay: function changeDay(day) {
	      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'add';
	      var quantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	      return (0, _moment2.default)(day)[method](quantity, 'days');
	    },
	    exceptionsList: function exceptionsList(day) {
	      return this.exceptions.filter(function (e) {
	        return (0, _moment2.default)(e.start).format('DD') === (0, _moment2.default)(day).format('DD') || (0, _moment2.default)(e.end).format('DD') === (0, _moment2.default)(day).format('DD') || (0, _moment2.default)(e.start).isBefore((0, _moment2.default)(day)) && (0, _moment2.default)(e.end).isAfter((0, _moment2.default)(day));
	      }).map(function (e) {
	        var duration = 0;
	        var start = (0, _moment2.default)(e.start, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm');
	        var end = (0, _moment2.default)(e.end, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm');
	        var time = (0, _moment2.default)(e.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
	        if ((0, _moment2.default)(e.start).format('DD') === (0, _moment2.default)(day).format('DD') && (0, _moment2.default)(e.end).format('DD') === (0, _moment2.default)(day).format('DD')) {
	          duration = (0, _moment2.default)(e.end).diff((0, _moment2.default)(e.start), 'minutes');
	        } else if ((0, _moment2.default)(e.start).format('DD') === (0, _moment2.default)(day).format('DD')) {
	          end = (0, _moment2.default)(day).endOf('day').format('DD/MM/YYYY HH:mm');
	          duration = (0, _moment2.default)(day).endOf('day').diff((0, _moment2.default)(e.start), 'minutes');
	        } else if ((0, _moment2.default)(e.end).format('DD') === (0, _moment2.default)(day).format('DD')) {
	          time = (0, _moment2.default)(day).startOf('day').format('HH:mm');
	          start = (0, _moment2.default)(day).startOf('day').format('DD/MM/YYYY HH:mm');
	          duration = (0, _moment2.default)(e.end).diff((0, _moment2.default)(day).startOf('day'), 'minutes');
	        } else {
	          start = (0, _moment2.default)(day).startOf('day').format('DD/MM/YYYY HH:mm');
	          time = (0, _moment2.default)(day).startOf('day').format('HH:mm');
	          end = (0, _moment2.default)(day).endOf('day').format('DD/MM/YYYY HH:mm');
	          duration = (0, _moment2.default)(day).endOf('day').diff((0, _moment2.default)(day).startOf('day'), 'minutes');
	        }
	        return Object.assign({}, e, {
	          start: start,
	          end: end,
	          time: time,
	          duration: duration,
	          exception: true
	        });
	      });
	    },
	    appointments: function appointments(day) {
	      var _this2 = this;
	
	      if (!this.timeframeHeight) return [];
	
	      var appointments = [];
	
	      var list = this.list.filter(function (a) {
	        return (0, _moment2.default)(a.date).format('DD') === (0, _moment2.default)(day).format('DD') && a.orderStatus !== 'cancelled';
	      }).map(function (a) {
	        return Object.assign({}, a, {
	          end: (0, _moment2.default)(a.start, 'DD/MM/YYYY HH:mm').add(a.duration, 'minutes')
	        });
	      });
	
	      var finalList = [].concat(_toConsumableArray(list), _toConsumableArray(this.exceptionsList(day))).sort(function (a, b) {
	        return (0, _moment2.default)(a.start, 'DD/MM/YYYY HH:mm').diff((0, _moment2.default)(b.start, 'DD/MM/YYYY HH:mm'));
	      });
	
	      var isToday = (0, _moment2.default)(day).startOf('day').diff((0, _moment2.default)().startOf('day'), 'days');
	      finalList.forEach(function (a) {
	        var appointment = Object.assign({}, a, {
	          offsetTop: _this2.offsetTop(a.time),
	          height: _this2.height(a.time, a.duration)
	        });
	        appointments.push(appointment);
	      });
	
	      var freeSpots = [];
	      if (isToday >= 0) {
	        var start = isToday === 0 ? (0, _moment2.default)() : (0, _moment2.default)(day).startOf('day');
	        var end = (0, _moment2.default)(day).endOf('day');
	        freeSpots.push({
	          slot: true,
	          start: (0, _moment2.default)(start).format('DD/MM/YYYY HH:mm'),
	          duration: end.diff(start, 'minutes')
	        });
	      }
	      var adjustFreeSpots = function adjustFreeSpots(spots) {
	        var newSpots = [];
	        var everySpotIsOk = spots.every(function (spot) {
	          var conflictFree = appointments.every(function (a) {
	            if ((0, _moment2.default)(a.start, 'DD/MM/YYYY HH:mm').isAfter((0, _moment2.default)(spot.start, 'DD/MM/YYYY HH:mm')) && (0, _moment2.default)(a.start, 'DD/MM/YYYY HH:mm').isBefore((0, _moment2.default)(spot.start, 'DD/MM/YYYY HH:mm').add(spot.duration, 'minutes')) && (0, _moment2.default)(a.end, 'DD/MM/YYYY HH:mm').isAfter((0, _moment2.default)(spot.start, 'DD/MM/YYYY HH:mm')) && (0, _moment2.default)(a.end, 'DD/MM/YYYY HH:mm').isBefore((0, _moment2.default)(spot.start, 'DD/MM/YYYY HH:mm').add(spot.duration, 'minutes'))) {
	              newSpots.push(Object.assign({}, spot, {
	                duration: (0, _moment2.default)(a.start, 'DD/MM/YYYY HH:mm').diff((0, _moment2.default)(spot.start, 'DD/MM/YYYY HH:mm'), 'minutes')
	              }));
	              newSpots.push(Object.assign({}, spot, {
	                start: a.end,
	                duration: (0, _moment2.default)(spot.start, 'DD/MM/YYYY HH:mm').add(spot.duration, 'minutes').diff((0, _moment2.default)(a.end, 'DD/MM/YYYY HH:mm'), 'minutes')
	              }));
	              return false;
	            } else if ((0, _moment2.default)(a.start, 'DD/MM/YYYY HH:mm').isAfter((0, _moment2.default)(spot.start, 'DD/MM/YYYY HH:mm')) && (0, _moment2.default)(a.start, 'DD/MM/YYYY HH:mm').isBefore((0, _moment2.default)(spot.start, 'DD/MM/YYYY HH:mm').add(spot.duration, 'minutes'))) {
	              newSpots.push(Object.assign({}, spot, {
	                duration: (0, _moment2.default)(a.start, 'DD/MM/YYYY HH:mm').diff((0, _moment2.default)(spot.start, 'DD/MM/YYYY HH:mm'), 'minutes')
	              }));
	              return false;
	            } else if ((0, _moment2.default)(a.end, 'DD/MM/YYYY HH:mm').isAfter((0, _moment2.default)(spot.start, 'DD/MM/YYYY HH:mm')) && (0, _moment2.default)(a.end, 'DD/MM/YYYY HH:mm').isBefore((0, _moment2.default)(spot.start, 'DD/MM/YYYY HH:mm').add(spot.duration, 'minutes'))) {
	              newSpots.push(Object.assign({}, spot, {
	                start: a.end,
	                duration: (0, _moment2.default)(spot.start, 'DD/MM/YYYY HH:mm').add(spot.duration, 'minutes').diff((0, _moment2.default)(a.end, 'DD/MM/YYYY HH:mm'), 'minutes')
	              }));
	              return false;
	            } else if ((0, _moment2.default)(a.start, 'DD/MM/YYYY HH:mm').isSameOrBefore((0, _moment2.default)(spot.start, 'DD/MM/YYYY HH:mm')) && (0, _moment2.default)(a.end, 'DD/MM/YYYY HH:mm').isSameOrAfter((0, _moment2.default)(spot.start, 'DD/MM/YYYY HH:mm').add(spot.duration, 'minutes'))) {
	              return false;
	            }
	
	            return true;
	          });
	
	          if (conflictFree) {
	            newSpots.push(spot);
	          }
	
	          return conflictFree;
	        });
	
	        if (everySpotIsOk) {
	          return newSpots;
	        }
	
	        return adjustFreeSpots(newSpots);
	      };
	
	      return [].concat(appointments, _toConsumableArray(adjustFreeSpots(freeSpots).map(function (s) {
	        return Object.assign({}, s, {
	          offsetTop: _this2.offsetTop((0, _moment2.default)(s.start, 'DD/MM/YYYY HH:mm').format('HH:mm')),
	          height: _this2.height((0, _moment2.default)(s.start, 'DD/MM/YYYY HH:mm').format('HH:mm'), s.duration)
	        });
	      })));
	    },
	    offsetTop: function offsetTop(time) {
	      var H = this.timeframeHeight;
	      var offset = (Number(time.split(':')[0]) - Number(this.startTime.split(':')[0])) * H + time.split(':')[1] * (H / 60);
	
	      return offset >= 0 ? offset : 0;
	    },
	    height: function height(time, duration) {
	      var H = this.timeframeHeight;
	      var diff = (0, _moment2.default)(time, 'HH:mm').diff((0, _moment2.default)(this.startTime, 'HH:mm'), 'minutes');
	      if (diff < 0) {
	        duration = Number(duration) + diff;
	      }
	
	      return duration * (H / 60) - 3;
	    }
	  },
	
	  components: {
	    VCalendarDay: __webpack_require__(2686)
	  },
	
	  mixins: [_mediaQuery2.default]
	};

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    day: {
	      type: Object,
	      required: true
	    },
	
	    list: {
	      type: Function,
	      required: true
	    },
	
	    create: {
	      type: Function,
	      required: true
	    },
	
	    edit: {
	      type: Function,
	      required: true
	    }
	  },
	
	  components: {
	    VAppointmentCard: __webpack_require__(765)
	  }
	};

/***/ }),
/* 1760 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    wide: {
	      type: Boolean,
	      default: false
	    }
	  }
	};

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _chartOfAccounts = __webpack_require__(186);
	
	var _chartOfAccounts2 = _interopRequireDefault(_chartOfAccounts);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _organizationSettings3 = __webpack_require__(83);
	
	var _organizationSettings4 = _interopRequireDefault(_organizationSettings3);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            sortField: 'code',
	            sortDirection: 'asc',
	            savingOrgDefault: false,
	            form: new _forms2.default({
	                code: {
	                    value: '',
	                    type: 'text'
	                },
	                name: {
	                    value: '',
	                    type: 'text'
	                },
	                description: {
	                    value: '',
	                    type: 'text'
	                }
	            }),
	            ready: false
	        };
	    },
	
	
	    props: {},
	
	    computed: _extends({}, (0, _vuex.mapGetters)({
	        chartOfAccounts: 'allChartOfAccounts',
	        organizationSettings: 'organizationSettings'
	    }), {
	        coaList: function coaList() {
	            var all = this.chartOfAccounts && this.chartOfAccounts.all;
	            return Array.isArray(all) ? all : [];
	        },
	        sortedCoaList: function sortedCoaList() {
	            var list = this.coaList.slice();
	            var key = this.sortField;
	            var dir = this.sortDirection === 'asc' ? 1 : -1;
	            list.sort(function (a, b) {
	                var va = (a[key] != null ? String(a[key]) : '').toLowerCase();
	                var vb = (b[key] != null ? String(b[key]) : '').toLowerCase();
	                if (va < vb) return -1 * dir;
	                if (va > vb) return 1 * dir;
	                return 0;
	            });
	            return list;
	        }
	    }),
	
	    methods: {
	        onSort: function onSort(field) {
	            if (this.sortField === field) {
	                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
	            } else {
	                this.sortField = field;
	                this.sortDirection = 'asc';
	            }
	        },
	        orgDefaultRoleFor: function orgDefaultRoleFor(item) {
	            var s = this.organizationSettings;
	            if (!s || !item) return '';
	            if (s.receivablesAccountDefaultId === item.id) return 'receivables';
	            if (s.incomeAccountDefaultId === item.id) return 'income';
	            if (s.vatAccountDefaultId === item.id) return 'vat';
	            if (s.depositAccountDefaultId === item.id) return 'deposit';
	            return '';
	        },
	        onOrgDefaultChange: function onOrgDefaultChange(item, newRole) {
	            var _this = this;
	
	            var s = this.organizationSettings || {};
	            var payload = {
	                receivablesAccountDefaultId: s.receivablesAccountDefaultId != null ? s.receivablesAccountDefaultId : null,
	                incomeAccountDefaultId: s.incomeAccountDefaultId != null ? s.incomeAccountDefaultId : null,
	                vatAccountDefaultId: s.vatAccountDefaultId != null ? s.vatAccountDefaultId : null,
	                depositAccountDefaultId: s.depositAccountDefaultId != null ? s.depositAccountDefaultId : null
	            };
	
	            var keys = ['receivablesAccountDefaultId', 'incomeAccountDefaultId', 'vatAccountDefaultId', 'depositAccountDefaultId'];
	            keys.forEach(function (k) {
	                if (payload[k] === item.id) {
	                    payload[k] = null;
	                }
	            });
	
	            var roleToKey = {
	                receivables: 'receivablesAccountDefaultId',
	                income: 'incomeAccountDefaultId',
	                vat: 'vatAccountDefaultId',
	                deposit: 'depositAccountDefaultId'
	            };
	
	            if (newRole && roleToKey[newRole]) {
	                payload[roleToKey[newRole]] = item.id;
	            }
	
	            this.savingOrgDefault = true;
	            var body = _organizationSettings4.default.sendAccountingAccountDefaults(payload);
	
	            _organizationSettings2.default.updateAccounting(body).then(function () {
	                _this.savingOrgDefault = false;
	                _this.$message({
	                    showClose: true,
	                    message: _this.$t('static.organizationSettings.settingsSaveSuccess')
	                });
	            }).catch(function (errors) {
	                _this.savingOrgDefault = false;
	                var message = _this.$t('static.organizationSettings.settingsSaveError');
	                if (errors && (typeof errors === 'undefined' ? 'undefined' : _typeof(errors)) === 'object') {
	                    var first = Object.keys(errors)[0];
	                    if (first && errors[first] && errors[first][0]) {
	                        message = errors[first][0];
	                    }
	                }
	                _this.$message({
	                    showClose: true,
	                    customClass: 'error',
	                    message: message
	                });
	            });
	        },
	        createCoa: function createCoa() {
	            var _this2 = this;
	
	            this.ready = false;
	            _chartOfAccounts2.default.createCoa().then(function (data) {
	                _this2.ready = true;
	            }).catch(function (errors) {
	                _this2.ready = true;
	            });
	        },
	        save: function save() {
	            var _this3 = this;
	
	            this.form.ready = false;
	
	            var data = this.form.data();
	
	            return new Promise(function (resolve, reject) {
	                _chartOfAccounts2.default.store(data).then(function () {
	                    _chartOfAccounts2.default.all();
	                    _this3.form.ready = true;
	                    _store2.default.dispatch('addChartOfAccountsItem', data);
	                    resolve();
	                }).catch(function (errors) {
	                    _this3.form.ready = true;
	                    var message = '';
	                    if (errors.code) {
	                        message = errors.message;
	                    } else {
	                        _this3.form.recordErrors(errors);
	                        var errorsKeys = Object.keys(_this3.form.errors.errors);
	                        message = errors[errorsKeys[0]][0];
	                    }
	                    _this3.$message({
	                        showClose: true,
	                        customClass: 'error',
	                        message: message
	                    });
	                    reject();
	                });
	            });
	        },
	        update: function update(id) {
	            var _this4 = this;
	
	            this.form.ready = false;
	            var data = this.form.data();
	
	            return new Promise(function (resolve, reject) {
	                _chartOfAccounts2.default.update(id, data).then(function () {
	                    _chartOfAccounts2.default.all();
	                    _this4.form.ready = true;
	                    _store2.default.dispatch('updateChartOfAccountsItem', { data: data, id: id });
	                    resolve();
	                }).catch(function (errors) {
	                    _this4.form.ready = true;
	                    _this4.form.recordErrors(errors);
	                    var errorsKeys = Object.keys(_this4.form.errors.errors);
	                    _this4.$message({
	                        showClose: true,
	                        message: errors[errorsKeys[0]][0],
	                        customClass: 'error'
	                    });
	                    reject();
	                });
	            });
	        },
	        destroy: function destroy(id) {
	            return new Promise(function (resolve, reject) {
	                _chartOfAccounts2.default.destroy(id).then(function () {
	                    _organizationSettings2.default.show();
	                    resolve();
	                }).catch(function () {
	                    reject();
	                });
	            });
	        },
	        getResources: function getResources() {
	            var _this5 = this;
	
	            this.ready = false;
	            Promise.all([_chartOfAccounts2.default.all(), _organizationSettings2.default.show()]).then(function () {
	                _this5.ready = true;
	            }).catch(function (error) {
	                _this5.ready = true;
	            });
	        }
	    },
	
	    mounted: function mounted() {
	        this.getResources();
	    },
	
	
	    components: {
	        VFormTable: __webpack_require__(46),
	        VMessage: __webpack_require__(13)
	    }
	};

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _vuex = __webpack_require__(5);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _postal = __webpack_require__(159);
	
	var _postal2 = _interopRequireDefault(_postal);
	
	var _stringFormat = __webpack_require__(108);
	
	var _stringFormat2 = _interopRequireDefault(_stringFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    id: {
	      type: Number,
	      required: false
	    },
	    data: {
	      type: Object,
	      required: false
	    },
	    name: {
	      type: String,
	      required: false
	    },
	    errors: {
	      type: Object,
	      required: false
	    },
	    countries: {
	      type: Array,
	      required: true
	    },
	    municipalities: {
	      type: Array,
	      required: false
	    }
	  },
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        id: {
	          value: null,
	          type: 'hidden'
	        },
	        name: {
	          value: null,
	          type: 'hidden'
	        },
	        addressId: {
	          value: null,
	          type: 'hidden'
	        },
	        addressType: {
	          value: this.id,
	          type: 'hidden'
	        },
	        careOf: {
	          value: '',
	          type: 'text'
	        },
	        streetName: {
	          value: '',
	          type: 'text'
	        },
	        secondStreetName: {
	          value: '',
	          type: 'text'
	        },
	        postalCode: {
	          value: '',
	          type: 'text'
	        },
	        cityName: {
	          value: '',
	          type: 'text'
	        },
	        countryId: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      show: false
	    };
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    postals: 'allPostals'
	  })),
	  created: function created() {
	    var _this = this;
	
	    this.loading = true;
	    this.form.setTooltip('mobileNumber', this.$t('form.clients.mobileNumber.tooltip'));
	
	    this.form.setOptions('countryId', this.countries.map(function (c) {
	      return { id: c.id, name: _this.$t('country.translated.' + c.code) };
	    }));
	
	    if (this.data) {
	      this.form.assignData(this.data);
	      if (this.data.streetName) {
	        this.show = true;
	      }
	    }
	  },
	
	  watch: {
	    errors: function errors(_errors) {
	      this.form.recordErrors(_errors);
	    },
	
	    form: {
	      handler: function handler(newValue) {
	        this.$emit('update', newValue);
	      },
	
	      deep: true
	    },
	    'form.streetName': function formStreetName(streetName) {
	      if (streetName && this.show === false) {
	        this.show = true;
	      }
	    }
	
	  },
	
	  methods: {
	    destroy: function destroy() {
	      this.form.streetName = '';
	      this.form.secondStreetName = '';
	      this.form.countryId = '';
	      this.form.postalCode = '';
	      this.form.cityName = '';
	      this.form.careOf = '';
	      this.show = false;
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  },
	  mixins: [_stringFormat2.default]
	};

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _stringFormat = __webpack_require__(108);
	
	var _stringFormat2 = _interopRequireDefault(_stringFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      addressResult1: [],
	      addressResult2: [],
	      addressResult3: [],
	      thirdPartyAddress: '',
	      loading: false,
	      addresses: {}
	    };
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentClientAddresses: 'currentClientAddresses'
	  }), {
	    displayPostalAddress: function displayPostalAddress() {
	      return this.addresses.postalAddress;
	    },
	    displayBusinessAddress: function displayBusinessAddress() {
	      return this.addresses.businessAddress;
	    },
	    displayLocationAddress: function displayLocationAddress() {
	      return this.addresses.locationAddress;
	    }
	  }),
	  methods: {
	    update: function update() {
	
	      var data = {};
	
	      if (this.displayPostalAddress) {
	        data.address_postal = {
	          address_type_ids: this.addressResult1,
	          street_name: this.displayPostalAddress.street_name,
	          second_street_name: this.displayPostalAddress.street_name_2,
	          postal_code: this.displayPostalAddress.postal,
	          city: this.displayPostalAddress.city
	        };
	      }
	
	      if (this.displayBusinessAddress) {
	        data.address_business = {
	          address_type_ids: this.addressResult2,
	          street_name: this.displayBusinessAddress.street_name,
	          second_street_name: this.displayBusinessAddress.street_name_2,
	          postal_code: this.displayBusinessAddress.postal,
	          city: this.displayBusinessAddress.city
	        };
	      }
	
	      if (this.displayLocationAddress) {
	        data.address_location = {
	          address_type_ids: this.addressResult3,
	          street_name: this.displayLocationAddress.street_name,
	          second_street_name: this.displayLocationAddress.street_name_2,
	          postal_code: this.displayLocationAddress.postal,
	          city: this.displayLocationAddress.city
	        };
	      }
	
	      this.onSubmit(data);
	
	      this.$emit('close');
	    },
	    cancel: function cancel() {
	      this.$emit('close');
	    },
	    typesUnchecked: function typesUnchecked(event, result1, result2) {
	      event.forEach(function (item) {
	        var index = result1.indexOf(item);
	        if (index >= 0) result1.splice(index, 1);
	
	        index = result2.indexOf(item);
	        if (index >= 0) result2.splice(index, 1);
	      });
	    },
	    addressEvent1: function addressEvent1(event) {
	      this.typesUnchecked(event, this.addressResult2, this.addressResult3);
	    },
	    addressEvent2: function addressEvent2(event) {
	      this.typesUnchecked(event, this.addressResult1, this.addressResult3);
	    },
	    addressEvent3: function addressEvent3(event) {
	      this.typesUnchecked(event, this.addressResult1, this.addressResult2);
	    }
	  },
	
	  created: function created() {
	    this.addresses['postalAddress'] = this.orgData.postalAddress;
	    this.addresses['businessAddress'] = this.orgData.businessAddress;
	    this.addresses['locationAddress'] = this.orgData.locationAddress;
	    if (this.addresses.postalAddress) {
	      this.thirdPartyAddress = 'postalAddress';
	    } else if (this.addresses.businessAddress) {
	      this.thirdPartyAddress = 'businessAddress';
	    } else if (this.addresses.locationAddress) {
	      this.thirdPartyAddress = 'locationAddress';
	    }
	  },
	
	
	  props: {
	    orgNumberInput: {
	      type: String,
	      required: true
	    },
	
	    addressTypes: {
	      type: Array,
	      required: true
	    },
	
	    orgData: {
	      type: Object,
	      required: true
	    },
	
	    onSubmit: {
	      type: Function,
	      required: true,
	      default: function _default() {}
	    }
	  },
	
	  mixins: [_stringFormat2.default]
	};

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _addressType = __webpack_require__(442);
	
	var _addressType2 = _interopRequireDefault(_addressType);
	
	var _address = __webpack_require__(194);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _stringFormat = __webpack_require__(108);
	
	var _stringFormat2 = _interopRequireDefault(_stringFormat);
	
	var _country = __webpack_require__(66);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _municipality = __webpack_require__(462);
	
	var _municipality2 = _interopRequireDefault(_municipality);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({}),
	      client: {},
	      loading: false,
	      clientAddressNames: null,
	      clientAddresses: [],
	      addressFormErrors: {
	        postal: null,
	        fields: []
	      }
	    };
	  },
	
	
	  props: {
	    clientId: {
	      type: [String, Number],
	      required: true
	    },
	    billId: {
	      type: [String, Number],
	      required: false
	    },
	    onClose: {
	      type: Function,
	      default: function _default() {}
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentBill: 'currentBill',
	    addressTypes: 'addressTypes',
	    countries: 'allCountries',
	    municipalities: 'allMunicipalities'
	  })),
	
	  watch: {},
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    Promise.all([_client2.default.show(this.clientId), _addressType2.default.all(), _country2.default.all(), _municipality2.default.all()]).then(function (data) {
	      _this.loading = false;
	      _this.client = data[0];
	      _this.clientAddressNames = ['Postal'];
	      _this.setCurrentAddresses(_this.client.addresses);
	    });
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    setCurrentAddresses: function setCurrentAddresses(addresses) {
	      var _this2 = this;
	
	      this.addressTypes.forEach(function (type) {
	        var address = addresses.find(function (a) {
	          return type.id === a.address_type.id;
	        }) || {};
	        if (address) {
	          address = _address2.default.fetch(address);
	        }
	        _this2.clientAddresses.push(Object.assign({}, {
	          id: type.id,
	          addressType: type.id,
	          name: type.name
	        }, address));
	      });
	    },
	    save: function save() {
	      var _this3 = this;
	
	      this.form.loading = true;
	      var formData = new FormData();
	      if (this.billId) {
	        formData.append('bill_id', this.billId);
	      }
	      this.clearAddressErrors();
	      this.clientAddresses.forEach(function (clientAddress) {
	        var data = _address2.default.send(clientAddress);
	        var formKey = 'addresses[' + clientAddress.addressType + ']';
	        if (clientAddress.addressId) {
	          formData.append(formKey + '[id]', clientAddress.addressId);
	        }
	        formData.append(formKey + '[type]', clientAddress.addressType);
	        Object.keys(data).map(function (k) {
	          var key = formKey + '[' + k + ']';
	          formData.append(key, data[k]);
	          return null;
	        });
	      });
	
	      _client2.default.updateAddress(this.client.id, formData).then(function (client) {
	        _this3.close();
	        _this3.$message({
	          message: _this3.$t('static.clients.edit.success'),
	          type: 'success'
	        });
	        _this3.onClose(client).then(function () {
	          _this3.postalAddressError = false;
	          _this3.form.loading = false;
	          _this3.setAddressFieldErrors([]);
	        }).catch(function () {});
	      }).catch(function (errors) {
	        _this3.setAddressFieldErrors(errors);
	        _this3.form.loading = false;
	      });
	    },
	    clearAddressErrors: function clearAddressErrors() {
	      var _this4 = this;
	
	      this.addressTypes.forEach(function (t) {
	        _this4.addressFormErrors.fields[t.id] = [];
	      });
	    },
	    setAddressFieldErrors: function setAddressFieldErrors(errors) {
	      var _this5 = this;
	
	      if ('addresses' in errors) {
	        this.addressFormErrors.postal = true;
	      } else {
	        this.addressFormErrors.postal = false;
	        this.clearAddressErrors();
	      }
	      Object.keys(errors).filter(function (key) {
	        return key.indexOf('addresses.') !== -1;
	      }).map(function (key) {
	        var _key$split = key.split('.'),
	            _key$split2 = _slicedToArray(_key$split, 3),
	            name = _key$split2[0],
	            addressTypeId = _key$split2[1],
	            field = _key$split2[2];
	
	        if (typeof errors[key][0] !== 'undefined') {
	          if (typeof _this5.addressFormErrors.fields[addressTypeId] === 'undefined') {
	            _this5.addressFormErrors.fields[addressTypeId] = [];
	            _this5.addressFormErrors.fields[addressTypeId][field] = [];
	          }
	          var message = errors[key][0].replace(key, field);
	          _this5.addressFormErrors.fields[addressTypeId][field] = [message];
	        }
	        return null;
	      });
	    },
	    getAddressFieldErrors: function getAddressFieldErrors(addressTypeId) {
	      if (addressTypeId in this.addressFormErrors.fields) {
	        return _address2.default.fetch(this.addressFormErrors.fields[addressTypeId]);
	      }
	      return null;
	    },
	    close: function close() {
	      this.toggle(false);
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9),
	    VClientAddress: __webpack_require__(409)
	  },
	  mixins: [_stringFormat2.default]
	};

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _contactType = __webpack_require__(1000);
	
	var _contactType2 = _interopRequireDefault(_contactType);
	
	var _clientContactFormTable = __webpack_require__(2690);
	
	var _clientContactFormTable2 = _interopRequireDefault(_clientContactFormTable);
	
	var _stringFormat = __webpack_require__(108);
	
	var _stringFormat2 = _interopRequireDefault(_stringFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    primaryContactError: {
	      type: Boolean,
	      required: false
	    }
	  },
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        id: {
	          value: null,
	          type: 'plaintext'
	        },
	        contactId: {
	          value: null,
	          type: 'plaintext'
	        },
	        type: {
	          value: null,
	          type: 'plaintext'
	        },
	        contactType: {
	          value: [],
	          type: 'select'
	        },
	        firstName: {
	          value: '',
	          type: 'text'
	        },
	        lastName: {
	          value: '',
	          type: 'text'
	        },
	        email: {
	          value: '',
	          type: 'text'
	        },
	        phoneNumber: {
	          value: '',
	          type: 'text'
	        }
	      })
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.loading = true;
	    this.form.setTooltip('mobileNumber', this.$t('form.clients.mobileNumber.tooltip'));
	    Promise.all([_contactType2.default.all()]).then(function () {
	      _this.loading = false;
	      _this.form.setExtraAttr('contactType', {
	        filterable: true,
	        multiple: true
	      });
	    });
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentClientContacts: 'currentClientContacts',
	    contactTypes: 'contactTypes'
	  }), {
	    hiddenFields: function hiddenFields() {
	      return ['id', 'contactId', 'type'];
	    }
	  }),
	  watch: {
	    contactTypes: function contactTypes(_contactTypes) {
	      var _this2 = this;
	
	      var contactTypeOptions = _contactTypes.map(function (item) {
	        return {
	          id: item.id,
	          name: _this2.$t('form.contactTypes.options.' + _this2.camelize(item.name))
	        };
	      });
	      this.form.setOptions('contactType', contactTypeOptions);
	    }
	  },
	  methods: {
	    save: function save() {
	      var data = this.form.data();
	      data.id = data.contactType.join();
	      var hasDuplicate = this.currentClientContacts.find(function (x) {
	        return x.id === data.id;
	      });
	      if (!hasDuplicate) {
	        _store2.default.dispatch('addClientContact', data);
	      } else {
	        this.$message({
	          showClose: true,
	          customClass: 'error',
	          message: 'Contact type duplicate found'
	        });
	        return Promise.reject();
	      }
	
	      return Promise.all([]);
	    },
	    update: function update(id) {
	      var data = this.form.data();
	      var i = this.currentClientContacts.findIndex(function (x) {
	        return x.id === id;
	      });
	      _store2.default.dispatch('updateClientContact', {
	        data: data,
	        i: i
	      });
	      return Promise.all([]);
	    },
	    destroy: function destroy(index, item) {
	      var id = item.contactType.join();
	      var i = this.currentClientContacts.findIndex(function (x) {
	        return x.id === id;
	      });
	      _store2.default.dispatch('deleteClientContact', i);
	      return Promise.all([]);
	    },
	    camelize: function camelize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  },
	
	  components: {
	    VFormTable: _clientContactFormTable2.default
	  },
	
	  mixins: [_stringFormat2.default]
	};

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _babelHelperVueJsxMergeProps = __webpack_require__(225);
	
	var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _formTable = __webpack_require__(46);
	
	var _formTable2 = _interopRequireDefault(_formTable);
	
	var _text = __webpack_require__(182);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _autocomplete = __webpack_require__(411);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _number = __webpack_require__(414);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _float = __webpack_require__(413);
	
	var _float2 = _interopRequireDefault(_float);
	
	var _date = __webpack_require__(412);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _time = __webpack_require__(416);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _dateRange = __webpack_require__(156);
	
	var _dateRange2 = _interopRequireDefault(_dateRange);
	
	var _plaintext = __webpack_require__(415);
	
	var _plaintext2 = _interopRequireDefault(_plaintext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var components = {
	  text: _text2.default,
	  email: _text2.default,
	  autocomplete: _autocomplete2.default,
	  date: _date2.default,
	  dateRange: _dateRange2.default,
	  time: _time2.default,
	  number: _number2.default,
	  select: _select2.default,
	  plaintext: _plaintext2.default,
	  float: _float2.default,
	  default: _plaintext2.default
	};
	
	exports.default = {
	  extends: _formTable2.default,
	  data: function data() {
	    return {
	      mergeThisProperty: 'Hello'
	    };
	  },
	
	  props: {
	    primaryContactError: {
	      type: Boolean,
	      required: false
	    }
	  },
	  methods: {
	    renderTableRow: function renderTableRow() {
	      var _this = this;
	
	      var h = this.$createElement;
	
	      return this.list.map(function (item, index) {
	        if (item.id === _this.editingItem) {
	          return _this.renderForm(item);
	        }
	
	        var currentItem = item;
	
	        return h(
	          'tr',
	          { 'class': 'tablerow' },
	          [Object.keys(_this.form.fields).map(function (field) {
	            if (_this.hiddenFields.indexOf(field) > -1 || _this.isStacked(field)) {
	              return null;
	            }
	
	            var content = _this.renderColumnContent(item, field);
	
	            var stackContent = _this.renderColumnContent(item, _this.stack[field]);
	
	            var stacked = _this.stack[field] && item[_this.stack[field]] ? h(
	              'div',
	              { 'class': 'tableCol--stacked' },
	              [stackContent]
	            ) : null;
	
	            return h(
	              'td',
	              { 'class': 'tableCol' },
	              [h(
	                'div',
	                { 'class': 'full-w' },
	                [h(
	                  'span',
	                  { 'class': 'tableCol--label' },
	                  [_this.$t(_this.translation ? _this.translation + '.' + field + '.label' : null) || field, ':', ' ']
	                ), content, stacked]
	              )]
	            );
	          }), (_this.update || _this.destroy) && !_this.disableForm ? h(
	            'td',
	            { 'class': 'tableCol', style: 'min-width:100px;width:100px;' },
	            [_this.update && !_this.disableForm ? h('el-button', {
	              'class': 'small',
	              on: {
	                'click': function click() {
	                  return _this.editItem(item, index);
	                }
	              },
	              attrs: {
	                icon: 'el-icon-edit'
	              }
	            }) : null, _this.destroy && !_this.disableForm && currentItem.type !== 'primary' ? h('el-button', {
	              'class': 'small',
	              on: {
	                'click': function click() {
	                  return _this.removeItem(item);
	                }
	              },
	              attrs: {
	                icon: 'el-icon-delete'
	              }
	            }) : null]
	          ) : null]
	        );
	      });
	    },
	    renderForm: function renderForm(item) {
	      var _this2 = this;
	
	      var h = this.$createElement;
	
	      if (!this.create && !this.update || this.disableForm) {
	        return null;
	      }
	
	      return h(
	        'tr',
	        { 'class': 'tablerow' },
	        [Object.keys(this.form.fields).map(function (field) {
	          if (_this2.hiddenFields.indexOf(field) > -1 || _this2.isStacked(field)) {
	            return null;
	          }
	          var StackedComponent = _this2.stack[field] ? _this2.renderFormInput(_this2.stack[field], item) : null;
	
	          var stacked = StackedComponent ? h(
	            'div',
	            { 'class': 'tableCol--stacked' },
	            [StackedComponent]
	          ) : null;
	
	          return h(
	            'td',
	            { 'class': 'tableCol' },
	            [_this2.renderFormInput(field, item), stacked]
	          );
	        }), h(
	          'td',
	          { 'class': 'tableCol', style: 'min-width:100px' },
	          [h('el-button', {
	            'class': 'small icon-check',
	            on: {
	              'click': this.save
	            },
	            attrs: {
	              icon: 'el-icon-check'
	            }
	          }), h('el-button', {
	            'class': 'small',
	            on: {
	              'click': this.closeForm
	            },
	            attrs: {
	              icon: 'el-icon-close'
	            }
	          })]
	        )]
	      );
	    },
	    renderColumnContent: function renderColumnContent(item, field) {
	      var h = this.$createElement;
	
	      if (item.type === 'primary' && field === 'contactType') {
	        if (this.primaryContactError) {
	          return h('div', [this.$t('form.contactTypes.options.primary'), ' ', h('br'), h(
	            'span',
	            { 'class': 'text-danger' },
	            [' ', this.$t('form.clients.primaryContactError'), ' ']
	          )]);
	        } else {
	          return this.$t('form.contactTypes.options.primary');
	        }
	      }
	      var content = null;
	      if (this.form.fields[field] === 'select') {
	        var filteredOptions = this.form.options[field].filter(function (o) {
	          if (_typeof(item[field]) === 'object') {
	            return item[field].map(function (i) {
	              return i.id ? i.id : Number(i);
	            }).indexOf(o.id) > -1;
	          }
	
	          return o.id.toString() === item[field].toString();
	        });
	
	        if (filteredOptions.length === 1) {
	          content = filteredOptions[0].name;
	        } else if (filteredOptions.length > 1) {
	          content = filteredOptions.map(function (o) {
	            return h(
	              'div',
	              { 'class': 'full-w' },
	              [o.name]
	            );
	          });
	        } else if (_typeof(item[field]) === 'object') {
	          content = item[field].name;
	        }
	      } else if (this.form.fields[field] === 'autocomplete') {
	        var _filteredOptions = this.form.options[field].filter(function (o) {
	          if (_typeof(item[field]) === 'object') {
	            return item[field].id.toString() === o.id.toString();
	          }
	
	          return o.id.toString() === item[field].toString();
	        });
	
	        if (_filteredOptions.length === 1) {
	          content = _filteredOptions[0].name;
	        } else if (_filteredOptions.length > 1) {
	          content = _filteredOptions.map(function (o) {
	            return h(
	              'div',
	              { 'class': 'full-w' },
	              [o.name]
	            );
	          });
	        } else if (_typeof(item[field]) === 'object') {
	          content = item[field].name;
	        } else if (item.name) {
	          content = item.name;
	        } else {
	          content = item[field];
	        }
	      } else {
	        content = item[field];
	      }
	
	      var clickHandler = this.clickHandler(item, field);
	      if (clickHandler) {
	        return h(
	          'a',
	          { style: 'cursor:pointer;', on: {
	              'click': clickHandler
	            }
	          },
	          [h('span', { 'class': 'fa fa-pencil-square-o' }), '\xA0 ', content]
	        );
	      }
	
	      var tagType = this.tagHandler(item, field);
	      if (tagType) {
	        return h(
	          'el-tag',
	          {
	            attrs: { type: tagType }
	          },
	          [content]
	        );
	      }
	
	      return content;
	    },
	    renderFormInput: function renderFormInput(field, item) {
	      var h = this.$createElement;
	
	      if (item && item.type === 'primary' && field === 'contactType') return this.$t('form.contactTypes.options.primary');
	
	      if (!this.form[field] && this.form.fields[field] === 'plaintext') {
	        return null;
	      }
	
	      if (this.form[field] == undefined && item && item[field]) {
	        return item[field];
	      }
	      var Component = components[this.form.fields[field]];
	      var props = this.form.getExtraAttr(field);
	      var value = this.form[field];
	      if (this.form.fields[field] === 'autocomplete' && item) {
	        value = _typeof(this.form[field]) === 'object' ? this.form[field].name : item.name;
	      }
	
	      return h(Component, (0, _babelHelperVueJsxMergeProps2.default)([{
	        attrs: {
	          name: field,
	          value: value,
	          type: this.form.fields[field],
	          info: this.form.displays[field],
	          controls: false,
	          options: this.form.options[field],
	          disabled: this.form.isDisabled(field),
	
	          translation: this.translation + '.' + field
	        },
	        on: {
	          'change': this.onInputChange,
	          'keydown': this.onInputChange
	        }
	      }, { props: props }]));
	    },
	    render: function render(h) {
	      var createBtn = this.create && !this.disableForm ? h(
	        'el-button',
	        { 'class': 'small', on: {
	            'click': this.addNewItem
	          }
	        },
	        [this.$t('form.clients.addContact')]
	      ) : null;
	      var exportBtn = this.isExport && !this.disableForm ? h(
	        'el-button',
	        { 'class': 'small', on: {
	            'click': this.exportClickHandler
	          }
	        },
	        [this.$t('button.export')]
	      ) : null;
	      var table = this.list.length || this.addingItem ? this.renderTable() : null;
	      var message = !this.list.length && !this.addingItem ? h('v-message', {
	        attrs: { warning: this.$t('form.clients.noContactWarning') }
	      }) : null;
	      var fileUploader = this.isImport && !this.disableForm ? h('file-pond', {
	        attrs: { name: 'import_excel', 'label-idle': this.$t('button.dragAndDropImport'), 'allow-multiple': 'false', server: this.server },
	        ref: 'pond' }) : null;
	      return h(
	        'div',
	        { 'class': 'form-table--parent' },
	        [h('el-row', [h(
	          'el-col',
	          { 'class': 'el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-4 el-col-lg-4' },
	          [createBtn, exportBtn]
	        ), h(
	          'el-col',
	          { 'class': 'el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-18 el-col-lg-18' },
	          [fileUploader]
	        ), h('el-col', [table])]), message]
	      );
	    }
	  }
	};

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _clientGroup = __webpack_require__(93);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	var _subscriber = __webpack_require__(483);
	
	var _subscriber2 = _interopRequireDefault(_subscriber);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        orgId: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      clients: [],
	      selectedContact: [],
	      groupName: 'Group Name',
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    subscriberList: 'subscriberList',
	    subscriber: 'subscriber'
	  })),
	
	  mounted: function mounted() {
	    _store2.default.dispatch('setCancelClientGroupAdd', false);
	    this.fetchAllClientGroups();
	  },
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    save: function save() {
	      var tempData = [];
	      this.selectedContact.forEach(function (item, key) {
	        tempData.push({ id: key, status: item });
	      });
	      _store2.default.dispatch('setchModifiedClientGroup', tempData);
	      this.closeModal();
	    },
	    fetchAllClientGroups: function fetchAllClientGroups() {
	      var _this = this;
	
	      this.loading = true;
	      _clientGroup2.default.all().then(function (groups) {
	        var self = _this;
	        groups.forEach(function (item) {
	          if (item.id.toString() === self.subscriberList.currentClientGroup) {
	            self.groupName = item.name;
	            return;
	          }
	        });
	        _this.fetchAllSubscriber();
	      });
	    },
	    fetchAllSubscriber: function fetchAllSubscriber() {
	      var _this2 = this;
	
	      Promise.all([_subscriber2.default.all(this.$route.params.id)]).then(function () {
	        _this2.fetchClients();
	      });
	    },
	    fetchClients: function fetchClients() {
	      var _this3 = this;
	
	      _client2.default.all().then(function (clients) {
	        var self = _this3;
	        clients.forEach(function (item) {
	          if (self.subscriberList.currentClientGroup === item.clientGroupId) {
	            item.contacts.forEach(function (item2) {
	              self.subscriber.items.forEach(function (item3) {
	                if (item2.id === item3.contact_id) {
	                  item2['exist'] = true;
	                }
	              });
	            });
	            self.clients.push(item);
	          }
	        });
	        _this3.loading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    },
	    cancel: function cancel() {
	      _store2.default.dispatch('setCancelClientGroupAdd', true);
	      this.closeModal();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	
	  props: {
	    errors: {
	      type: Array,
	      default: []
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  })
	};

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _clientImportExportErrorReportPopup = __webpack_require__(2692);
	
	var _clientImportExportErrorReportPopup2 = _interopRequireDefault(_clientImportExportErrorReportPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      server: {
	        url: _helpers2.default.buildUrl(("https://api.kundan.no") + '/clients/import', {
	          token: localStorage.getItem('id_token')
	        }),
	        process: {
	          onload: this.import,
	          onerror: this.error
	        }
	      }
	    };
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalContent: 'SET_MODAL_CONTENT'
	  }), {
	    downloadAllClients: function downloadAllClients() {
	      window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/clients/download', {
	        token: localStorage.getItem('id_token')
	      }));
	    },
	    import: function _import(response) {
	      var _this = this;
	
	      var result = JSON.parse(response);
	      if (!result.errors.length && result.data.length) {
	        var params = {
	          page: 1,
	          limit: 50
	        };
	        _store2.default.dispatch('setClientQuery', params);
	        _client2.default.items(params).then(function () {
	          _this.$message({
	            showClose: true,
	            message: 'Successfully imported products.',
	            type: 'success'
	          });
	          _this.closeModal();
	        });
	      } else if (result.errors.length) {
	        this.setModalProps({
	          errors: result.errors
	        });
	        this.toggle(true);
	        this.setModalContent(function () {
	          return _clientImportExportErrorReportPopup2.default;
	        });
	      } else {
	        var message = result.error || this.$t('static.products.index.importProductsErrorMessage');
	        this.$message({
	          showClose: true,
	          message: message,
	          type: 'error'
	        });
	      }
	    },
	    error: function error(response) {
	      var result = JSON.parse(response);
	      var message = result.message || this.$t('static.products.index.importProductsErrorMessage');
	      this.$message({
	        showClose: true,
	        message: message,
	        type: 'error'
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _clientAddressPopup = __webpack_require__(2689);
	
	var _clientAddressPopup2 = _interopRequireDefault(_clientAddressPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    client: {
	      required: true,
	      type: Object
	    },
	    billId: {
	      type: [String, Number],
	      required: false
	    },
	    currentEdiOrder: {
	      required: false,
	      type: Object
	    }
	  },
	
	  data: function data() {
	    return {
	      currentClient: null,
	      isBillAddressMissing: false,
	      isBillEdit: false,
	      billAddress: ''
	    };
	  },
	  created: function created() {
	    this.currentClient = this.client;
	    if (this.$route.name === 'bills.edit' || this.$route.name === 'bills.creditNote') {
	      this.isBillEdit = true;
	      this.billAddress = this.currentClient.billAddressData.billAddress;
	      this.isBillAddressMissing = this.currentClient.billAddressData.billAddresMissing;
	    }
	  },
	
	
	  computed: {
	    clientName: function clientName() {
	      return this.currentClient.companyName || this.currentClient.firstName + '\n      ' + this.currentClient.lastName;
	    },
	    clientAddress: function clientAddress() {
	      return this.currentClient.streetName + ',\n      ' + this.currentClient.postalCode + '\n      ' + this.currentClient.cityName + ', Norway';
	    },
	    clientPhone: function clientPhone() {
	      return this.currentClient.mobileNumber || this.currentClient.phoneNumber ? this.currentClient.mobileNumber || this.currentClient.phoneNumber : '-';
	    },
	    clientEmail: function clientEmail() {
	      return this.currentClient.email ? this.currentClient.email : '-';
	    },
	    billingAddressMissing: function billingAddressMissing() {
	      return this.isBillAddressMissing;
	    },
	    displayBillAddress: function displayBillAddress() {
	      var address = '';
	      if (this.billAddress) {
	        if (this.billAddress.street_name) {
	          address += this.billAddress.street_name;
	        }
	
	        if (this.billAddress.second_street_name) {
	          address += ', ' + this.billAddress.second_street_name;
	        }
	
	        if (this.billAddress.postal) {
	          if (this.billAddress.postal.postal_code) {
	            address += ', ' + this.billAddress.postal.postal_code;
	          }
	
	          if (this.billAddress.postal.city) {
	            if (this.billAddress.postal.city.name) {
	              address += ', ' + this.billAddress.postal.city.name;
	            }
	
	            if (this.billAddress.postal.city.country) {
	              if (this.billAddress.postal.city.country.name) {
	                address += ', ' + this.billAddress.postal.city.country.name;
	              }
	            }
	          }
	        }
	      }
	
	      return address;
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalClass: 'SET_MODAL_CLASS'
	  }), {
	    editClientAddress: function editClientAddress() {
	      this.setModalContent(function () {
	        return _clientAddressPopup2.default;
	      });
	      this.setModalShowClose(true);
	      this.setModalProps({
	        billId: this.billId,
	        clientId: this.client.id,
	        onClose: this.handleClientAddressSave
	      });
	      this.toggleModal(true);
	    },
	    handleClientAddressSave: function handleClientAddressSave(client) {
	      this.currentClient = client;
	    }
	  }),
	
	  components: {}
	};

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _vuex = __webpack_require__(5);
	
	var _orderProduct = __webpack_require__(48);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _billProduct = __webpack_require__(448);
	
	var _billProduct2 = _interopRequireDefault(_billProduct);
	
	var _tax = __webpack_require__(128);
	
	var _tax2 = _interopRequireDefault(_tax);
	
	var _creditNoteProduct = __webpack_require__(1008);
	
	var _creditNoteProduct2 = _interopRequireDefault(_creditNoteProduct);
	
	var _productDeposit = __webpack_require__(96);
	
	var _productDeposit2 = _interopRequireDefault(_productDeposit);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _bulkAddProductModal = __webpack_require__(122);
	
	var _bulkAddProductModal2 = _interopRequireDefault(_bulkAddProductModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        ref: {
	          value: '',
	          type: 'link',
	          attributes: {
	            href: '',
	            target: '',
	            fieldClass: ''
	          }
	        },
	        billProductId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        price: {
	          value: '',
	          type: 'number'
	        },
	        productDepositName: {
	          value: '',
	          type: 'plaintext'
	        },
	        quantity: {
	          value: '',
	          type: 'number'
	        },
	        discount: {
	          value: '',
	          type: 'number'
	        },
	        taxId: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      destroyLoading: false,
	      addingProduct: false,
	      editingProduct: false,
	      error: false,
	      ready: false,
	      columnWidths: { ref: '150px' }
	    };
	  },
	
	
	  props: {
	    order: {
	      type: Object,
	      required: true
	    },
	
	    bill: {
	      type: Object,
	      required: true
	    },
	
	    billRoundInvoiceTotal: {
	      type: Boolean,
	      required: false
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    products: 'allProducts',
	    orderProducts: 'allOrderProducts',
	    billProducts: 'allBillProducts',
	    creditNoteProducts: 'allCreditNoteProducts',
	    taxes: 'allTaxes',
	    productDeposits: 'allProductDeposits'
	  }), {
	    additionalButtons: function additionalButtons() {
	      var buttons = [{
	        text: this.$t('table.orderProducts.addProductsButton'),
	        action: this.showBulkAddProductModal
	      }];
	      if (this.bill && this.bill.creditNoteSource) {
	        buttons.push({
	          text: this.$t('table.orderProducts.addAllBillProductsButton'),
	          action: this.addAllBillProductsFromBill
	        });
	      }
	      return buttons;
	    },
	    creditProductsList: function creditProductsList() {
	      var _this = this;
	
	      var links = {};
	      var products = this.creditNoteProducts.map(function (p) {
	        var deposit = [];
	        if (p.productDepositId) {
	          deposit = _this.productDeposits.all.filter(function (d) {
	            return p.productDepositId.toString() === d.id.toString();
	          });
	        }
	
	        var value = '';
	        if (deposit.length) {
	          value = 'Deposit: ' + deposit[0].name;
	        }
	        var billProduct = _this.billProducts.filter(function (product) {
	          return p.billProductId !== undefined && product.id.toString() === p.billProductId.toString();
	        })[0] || {};
	
	        var addClass = 'link-table-' + p.refNumber + '-' + p.refId;
	        var linkDisable = false;
	        if (billProduct.refNumber === '--') linkDisable = true;
	
	        links[p.id] = p.refType === 'bill' ? '#/bills/' + p.refId + '/edit' : '#/orders/' + p.refId + '/edit';
	
	        _this.form.setExtraAttr('ref', {
	          href: links[p.id],
	          hrefs: links,
	          target: '_blank',
	          fieldClass: addClass,
	          fieldDisable: linkDisable
	        });
	        var label = p.refType === 'bill' ? _this.$t('static.referenceSign.invoice') : _this.$t('static.referenceSign.order');
	
	        var row = {
	          productDepositName: value,
	          price: billProduct.price,
	          quantity: billProduct.quantity,
	          taxId: billProduct.taxId,
	          discount: billProduct.discount,
	          ref: p.refNumber === '--' ? '--' : label + '-' + p.refNumber
	        };
	
	        var taxDisplayPct = void 0;
	        if (p.taxPercentage !== undefined && p.taxPercentage !== null) {
	          taxDisplayPct = p.taxPercentage;
	        } else if (billProduct.taxPercentage !== undefined && billProduct.taxPercentage !== null) {
	          taxDisplayPct = billProduct.taxPercentage;
	        }
	        if (taxDisplayPct !== undefined && taxDisplayPct !== null) {
	          row.taxIdDisplay = taxDisplayPct;
	        }
	        return Object.assign(row, p);
	      });
	
	      return products;
	    },
	    totalsTableList: function totalsTableList() {
	      var fmt = function fmt(val) {
	        return Number(val).toLocaleString('nb-NO', {
	          minimumFractionDigits: 2,
	          maximumFractionDigits: 2
	        });
	      };
	
	      var result = [{
	        name: this.$t('static.orders.edit.subtotal'),
	        value: fmt(this.subtotal)
	      }, {
	        name: this.$t('static.orders.edit.tax'),
	        value: fmt(this.tax)
	      }];
	
	      if (this.discount > 0) {
	        result.push({
	          name: this.$t('static.orders.edit.discount'),
	          value: fmt(this.discount)
	        });
	      }
	
	      if (this.deposit > 0) {
	        result.push({
	          name: this.$t('static.orders.edit.deposit'),
	          value: fmt(this.deposit)
	        });
	      }
	
	      result.push({
	        name: this.$t('static.orders.edit.total'),
	        value: fmt(this.total)
	      });
	
	      return result;
	    },
	    isBillSent: function isBillSent() {
	      return this.bill.billStatus !== 'Draft' && this.bill.billStatus !== 'Pending';
	    },
	    isShownOnBill: function isShownOnBill() {
	      return this.billRoundInvoiceTotal;
	    },
	    showTable: function showTable() {
	      if (this.creditProductsList.length > 0 || this.addingProduct || this.editingProduct) {
	        return true;
	      }
	
	      return false;
	    },
	    subtotal: function subtotal() {
	      return this.creditProductsList.map(function (p) {
	        return p.price * p.quantity;
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    discount: function discount() {
	      var _this2 = this;
	
	      return this.creditProductsList.map(function (p) {
	        var bp = _this2.getBillProduct(p.billProductId);
	        if (bp == null) {
	          return 0;
	        }
	        return (p.price ? p.price : bp.price) * p.quantity * (bp.discount / 100);
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    tax: function tax() {
	      var _this3 = this;
	
	      return this.creditProductsList.map(function (p) {
	        var bp = _this3.getBillProduct(p.billProductId);
	
	        var orderProductId = bp ? bp.orderProductId : p.orderProductId;
	        if (bp == null && !orderProductId) {
	          return 0;
	        }
	        var op = _this3.getOrderProduct(orderProductId);
	        var discount = bp ? bp.discount : op.discount;
	        var taxPercentage = bp && bp.taxId ? bp.taxPercentage : op.taxPercentage;
	        return (p.price ? p.price : bp.price) * p.quantity * (1 - discount / 100) * (taxPercentage / 100);
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    deposit: function deposit() {
	      return this.creditProductsList.map(function (p) {
	        return p.orderProductDeposit * p.quantity;
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    total: function total() {
	      var total = Number(this.subtotal) + Number(this.deposit) - Number(this.discount);
	      var totalTax = total + Number(this.tax);
	
	      if (this.isShownOnBill) {
	        return Math.round(totalTax);
	      }
	
	      return totalTax.toFixed(2);
	    },
	    rounding: function rounding() {
	      var total = Number(this.subtotal - this.discount);
	      var totalTax = total + Number(this.tax);
	      var roundedDecimal = (totalTax % 1).toFixed(2);
	
	      if (roundedDecimal < 0.50) {
	        return -roundedDecimal;
	      }
	
	      return roundedDecimal;
	    }
	  }),
	  created: function created() {
	    var _this4 = this;
	
	    Promise.all([_organizationSettings2.default.show()]).then(function (data) {
	      _this4.form.setDisplays('billProductId', data[0].productInfoDisplay);
	    });
	  },
	
	  watch: {
	    'form.billProductId': function formBillProductId() {
	      var billProduct = this.form.billProductId;
	      var productId = typeof this.form.billProductId.id !== 'undefined' ? this.form.billProductId.id : this.form.billProductId;
	
	      if ((typeof billProduct === 'undefined' ? 'undefined' : _typeof(billProduct)) !== 'object') {
	        return '';
	      }
	      if (productId > 0) {
	        var tax = this.taxes.all.filter(function (t) {
	          return t.id === billProduct.taxId;
	        });
	
	        if (tax.length > 0) {
	          this.form.taxId = tax[0].id;
	        }
	
	        this.form.price = billProduct.price;
	        if (this.form.quantity <= 0) {
	          this.form.quantity = billProduct.quantity;
	        }
	      }
	    },
	
	    billProducts: function billProducts(products) {
	      this.form.setOptions('billProductId', products);
	    },
	    creditNoteProducts: function creditNoteProducts(products) {},
	    productDeposits: function productDeposits(deposits) {
	      this.form.setOptions('productDepositId', deposits.all);
	    },
	    taxes: function taxes(_taxes) {
	      this.form.setOptions('taxId', _taxes.all.map(function (tax) {
	        return { id: tax.id, name: tax.taxPercentage };
	      }));
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    showBulkAddProductModal: function showBulkAddProductModal() {
	      this.setModalContent(function () {
	        return _bulkAddProductModal2.default;
	      });
	      this.setModalProps({
	        fetchProductsMethod: this.searchMethod,
	        onSave: this.handleBulkProductSave
	      });
	      this.toggleModal(true);
	    },
	    handleBulkProductSave: function handleBulkProductSave(creditNoteProducts) {
	      var _this5 = this;
	
	      var id = this.bill.id;
	      var data = creditNoteProducts.map(function (p) {
	        return {
	          billProductId: p.id,
	          quantity: p.qty,
	          price: p.price
	        };
	      });
	      return _creditNoteProduct2.default.bulkStore(id, data).then(function () {
	        _this5.form.loading = false;
	      });
	    },
	    addAllBillProductsFromBill: function addAllBillProductsFromBill() {
	      var _this6 = this;
	
	      if (!this.bill.creditNoteSource) {
	        return;
	      }
	      var existingIds = new Set(this.creditNoteProducts.map(function (p) {
	        return p.billProductId;
	      }).filter(function (id) {
	        return id != null && id !== '';
	      }).map(function (id) {
	        return String(id);
	      }));
	      var toAdd = this.billProducts.filter(function (bp) {
	        return !existingIds.has(String(bp.id));
	      });
	      if (toAdd.length === 0) {
	        this.$message({
	          showClose: true,
	          message: this.$t('table.orderProducts.addAllBillProductsNothing'),
	          type: 'info'
	        });
	        return;
	      }
	      this.form.loading = true;
	      var data = toAdd.map(function (p) {
	        return {
	          billProductId: p.id,
	          quantity: p.quantity,
	          price: p.price
	        };
	      });
	      _creditNoteProduct2.default.bulkStore(this.bill.id, data).then(function () {
	        _this6.form.loading = false;
	        _this6.$message({
	          showClose: true,
	          message: _this6.$t('table.orderProducts.addAllBillProductsSuccess', { count: toAdd.length }),
	          type: 'success'
	        });
	      }).catch(function (errors) {
	        _this6.form.loading = false;
	        var msg = _this6.$t('table.orderProducts.addAllBillProductsError');
	        if (errors && errors.exceed_creditnote_amount && errors.exceed_creditnote_amount[0]) {
	          msg = errors.exceed_creditnote_amount[0];
	        } else if (errors && errors.exceedCreditnoteAmount && errors.exceedCreditnoteAmount[0]) {
	          msg = errors.exceedCreditnoteAmount[0];
	        } else if (errors && errors.message) {
	          msg = errors.message;
	        }
	        _this6.$message({
	          showClose: true,
	          message: msg,
	          type: 'error'
	        });
	      });
	    },
	    getDepositValue: function getDepositValue(id) {
	      var deposits = this.productDeposits.all.filter(function (d) {
	        return d.id.toString() === id.toString();
	      });
	      return deposits.length ? deposits[0].amount : 0;
	    },
	    getBillProduct: function getBillProduct(productId) {
	      if (this.billProducts.length <= 0) {
	        var _p = this.orderProducts.filter(function (p) {
	          return p.id.toString() === productId.toString();
	        });
	
	        if (_p.length > 0) {
	          return _p[0];
	        }
	        return null;
	      }
	      var p = this.billProducts.filter(function (p) {
	        return p.id.toString() === productId.toString();
	      });
	
	      if (p.length > 0) {
	        return p[0];
	      }
	      return null;
	    },
	    getOrderProduct: function getOrderProduct(productId) {
	      return this.orderProducts.filter(function (p) {
	        return p.id.toString() === productId.toString();
	      })[0];
	    },
	    onFormChange: function onFormChange(name, value) {
	      this.form.clearSuccess(name, value);
	      this.form.clearErrors(name);
	      this.form[name] = value;
	      this.$forceUpdate();
	    },
	    addProduct: function addProduct() {
	      this.cancelForm();
	      this.addingProduct = true;
	    },
	    edit: function edit(product) {
	      this.cancelForm();
	      this.editingProduct = product.id;
	      this.form.assignData(product);
	    },
	    cancelForm: function cancelForm() {
	      this.form.billProductId = '';
	      this.form.quantity = '';
	      this.addingProduct = false;
	      this.editingProduct = false;
	    },
	    update: function update(billProductId) {
	      var me = this;
	      this.form.loading = true;
	      var id = this.bill.id;
	      var data = this.form.data();
	      data.billProductId = typeof data.billProductId.id !== 'undefined' ? data.billProductId.id : data.billProductId;
	
	      if (data.quantity.toString() === '0') {
	        me.form.loading = false;
	        me.$message({
	          showClose: true,
	          message: me.$t('static.orders.edit.quantityError'),
	          type: 'error'
	        });
	        return Promise.all();
	      }
	
	      if (data.price.toString() === '0') {
	        me.form.loading = false;
	        me.$message({
	          showClose: true,
	          message: me.$t('static.orders.edit.priceError'),
	          type: 'error'
	        });
	        return Promise.all();
	      }
	
	      if (data.billProductId.toString() === '') {
	        me.form.loading = false;
	        me.$message({
	          showClose: true,
	          message: me.$t('static.orders.edit.productErrorMessage'),
	          type: 'error'
	        });
	        return Promise.all();
	      }
	
	      var creditNoteData = _creditNoteProduct2.default.update(id, data, billProductId).then(function () {
	        me.form.loading = false;
	        _creditNoteProduct2.default.all(id);
	        data.billProduct = me.billProducts.filter(function (p) {
	          return p.id.toString() === data.billProductId.toString();
	        })[0].name;
	        _store2.default.dispatch('updateCreditNoteProduct', { creditNoteProduct: data, id: me.editingProduct });
	        me.cancelForm();
	      }).catch(function (errors) {
	        if (errors.exceedCreditnoteAmount) {
	          me.$message({
	            showClose: true,
	            message: errors.exceedCreditnoteAmount[0],
	            type: 'error'
	          });
	        }
	
	        me.form.loading = false;
	        me.form.recordErrors(errors);
	        var errorsKeys = Object.keys(me.form.errors.errors);
	        me.$message({
	          showClose: true,
	          message: errors[errorsKeys[0]][0],
	          type: 'error'
	        });
	      });
	
	      return creditNoteData;
	    },
	    destroy: function destroy(creditNoteProductId) {
	      var _this7 = this;
	
	      this.destroyLoading = creditNoteProductId;
	      _creditNoteProduct2.default.destroy(this.bill.id, creditNoteProductId).then(function () {
	        _this7.destroyLoading = false;
	      }).catch(function () {
	        _this7.destroyLoading = false;
	      });
	    },
	    getResources: function getResources() {
	      var _this8 = this;
	
	      this.ready = false;
	      Promise.all([_creditNoteProduct2.default.all(this.bill.id), _tax2.default.all(), _productDeposit2.default.all(), _billProduct2.default.all(this.bill.creditNoteSource), _orderProduct2.default.all(this.order.id)]).then(function (data) {
	        _this8.ready = true;
	      }).catch(function (error) {
	        _this8.ready = true;
	      });
	    },
	    searchMethod: function searchMethod(search, field) {
	      if (this.bill.creditNoteSource <= 0) {
	        return Promise.all([_orderProduct2.default.search(this.order.id, { search: search })]);
	      }
	      return Promise.all([_billProduct2.default.search(this.bill.creditNoteSource, { search: search })]);
	    }
	  }),
	
	  mounted: function mounted() {
	    var _this9 = this;
	
	    this.getResources();
	    Object.keys(this.form.fields).forEach(function (field) {
	      if (field !== 'quantity' && field !== 'billProductId') {
	        _this9.form.disableField(field);
	      }
	      if (_this9.order.orderType !== 'EDI' && field === 'price') {
	        _this9.form.enableField(field);
	      }
	    });
	  },
	
	
	  components: {
	    VFormTable: __webpack_require__(46),
	    VTotalsTable: __webpack_require__(279)
	  }
	};

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _creditNoteReason = __webpack_require__(1012);
	
	var _creditNoteReason2 = _interopRequireDefault(_creditNoteReason);
	
	var _creditNote = __webpack_require__(456);
	
	var _creditNote2 = _interopRequireDefault(_creditNote);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        creditNoteReasonId: {
	          value: '',
	          type: 'select'
	        },
	        reasonNote: {
	          value: '',
	          type: 'div'
	        },
	        additionalDescription: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      successMessage: '',
	      loading: false,
	      errors: []
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    creditNoteReasons: 'allCreditNoteReasons',
	    currentCreditNoteReason: 'currentCreditNoteReason'
	  })),
	
	  mounted: function mounted() {
	    this.form.hideField('reasonNote');
	    this.getResources();
	  },
	
	
	  watch: {
	    creditNoteReasons: function creditNoteReasons(_creditNoteReasons) {
	      this.form.setOptions('creditNoteReasonId', _creditNoteReasons.map(function (c) {
	        return { id: c.creditNoteReasonId, name: '' + c.creditNoteReasonType, description: '' + c };
	      }));
	    },
	
	    'form.creditNoteReasonId': function formCreditNoteReasonId() {
	      this.form.hideField('reasonNote');
	      if (this.creditNoteReasons[this.form.creditNoteReasonId - 1].creditNoteReasonDescription != '') {
	        this.form.reasonNote = this.creditNoteReasons[this.form.creditNoteReasonId - 1].creditNoteReasonDescription;
	        this.form.showField('reasonNote');
	      }
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    getResources: function getResources() {
	      var _this = this;
	
	      this.loading = true;
	      Promise.all([_creditNoteReason2.default.all()]).then(function () {
	        _this.loading = false;
	      });
	    },
	    complete: function complete() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var creditNoteReasondata = Object.assign({}, this.form.data(), {
	        billStatusId: this.billStatusId,
	        orderId: this.orderId,
	        date: this.date
	      });
	
	      _creditNoteReason2.default.update(_store2.default.state.route.params.id, creditNoteReasondata).then(function () {
	        _this2.successMessage = _this2.$t('static.bills.edit.updateSuccess');
	        setTimeout(function () {
	          _this2.successMessage = '';
	        }, 3000);
	        _this2.loading = false;
	        _this2.form.loading = false;
	        _this2.closeModal();
	      }).catch(function (errors) {
	        _this2.errors = [errors].filter(function (item) {
	          return typeof item !== 'undefined';
	        });
	        _this2.$message({
	          showClose: true,
	          message: _this2.errors,
	          type: 'error'
	        });
	        if (errors.code === 40116) {
	          errors = {
	            orderId: [_this2.$t('static.bills.create.orderError')]
	          };
	        }
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	      this.onClose();
	    }
	  }),
	
	  props: {
	    billId: {
	      type: Number,
	      required: true
	    },
	
	    billStatusId: {
	      type: Number,
	      required: true
	    },
	
	    orderId: {
	      type: Number,
	      required: true
	    },
	
	    creditNoteSource: {
	      type: Number,
	      required: true
	    },
	
	    date: {
	      type: String,
	      required: true
	    },
	
	    dueDate: {
	      type: String,
	      required: true
	    },
	
	    onClose: {
	      type: Function,
	      required: false,
	      default: function _default() {}
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mediaQuery = __webpack_require__(288);
	
	var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    day: {
	      required: true,
	      type: Object
	    },
	
	    displayWeekends: {
	      required: true,
	      type: Boolean
	    },
	
	    changeDay: {
	      required: true,
	      type: Function
	    },
	
	    toggleWeekends: {
	      required: true,
	      type: Function
	    }
	  },
	
	  computed: {
	    finalDay: function finalDay() {
	      var n = this.displayWeekends ? 6 : 4;
	      return (0, _moment2.default)(this.initialDay()).add(n, 'days');
	    }
	  },
	
	  methods: {
	    daysToSkip: function daysToSkip() {
	      if (!this.$refs.days) return 1;
	
	      return !this.isDesktop() ? 1 : 7;
	    },
	    initialDay: function initialDay() {
	      return (0, _moment2.default)(this.day);
	    }
	  },
	
	  mixins: [_mediaQuery2.default]
	};

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _auth = __webpack_require__(53);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _orderProduct = __webpack_require__(48);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _order = __webpack_require__(54);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _ediOrder = __webpack_require__(187);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _shippingProvider = __webpack_require__(97);
	
	var _shippingProvider2 = _interopRequireDefault(_shippingProvider);
	
	var _vuex = __webpack_require__(5);
	
	var _shippingConfirm = __webpack_require__(198);
	
	var _shippingConfirm2 = _interopRequireDefault(_shippingConfirm);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _quickProductEditExcise = __webpack_require__(419);
	
	var _quickProductEditExcise2 = _interopRequireDefault(_quickProductEditExcise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        confirmDate: {
	          value: (0, _moment2.default)().format('Y-MM-DD HH:mm:ss'),
	          type: 'date'
	        },
	        deliveryDate: {
	          value: '',
	          type: 'date'
	        },
	        warehouseId: {
	          type: 'select',
	          value: ''
	        }
	      }),
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentOrder: 'currentOrder',
	    orderProducts: 'allOrderProducts',
	    warehouses: 'allWarehouses',
	    account: 'account',
	    currentEdiOrder: 'currentEdiOrder',
	    settings: 'organizationSettings'
	  }), {
	    isZNB: function isZNB() {
	      return this.currentEdiOrder && this.currentEdiOrder.ediOrderTypeName === 'ZNB';
	    },
	    bevearageProducts: function bevearageProducts() {
	      return this.orderProducts.filter(function (p) {
	        return p.productType === 'Beverage' || p.productTypeGroup === 'Beverage';
	      }).map(function (item) {
	        var excise = [];
	        if (item.exciseAlcoholGroup) {
	          excise.push(item.exciseAlcoholGroupName);
	        }
	        if (item.excisePackagingGroup) {
	          excise.push(item.excisePackagingGroupName);
	        }
	        if (item.exciseBasicGroup) {
	          excise.push(item.exciseBasicGroupName);
	        }
	        return {
	          id: item.id,
	          name: item.name,
	          beverage: item.exciseAlcoholGroupName || '-',
	          packaging: item.excisePackagingGroupName || '-',
	          basic: item.exciseBasicGroupName || '-',
	          excisable: item.excisable,
	          bottleVolume: item.fieldsJSON.bottle_volume,
	          alcoholPercentage: item.fieldsJSON.alcohol_percentage,
	          productPackaging: item.productPackagingId || '',
	          noExcise: !item.excisable || excise.length === 0 || !item.fieldsJSON.bottle_volume || !item.fieldsJSON.alcohol_percentage
	        };
	      });
	    },
	    hasNoExcise: function hasNoExcise() {
	      return this.bevearageProducts.filter(function (p) {
	        return p.noExcise;
	      }).length !== 0 && this.hasExciseModule;
	    },
	    hasMissingPackaging: function hasMissingPackaging() {
	      var hasInventory = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            hasInventory = true;
	            return this.bevearageProducts.length && this.bevearageProducts.filter(function (p) {
	              return !p.productPackaging;
	            }).length !== 0;
	          }
	        }
	      }
	      return hasInventory;
	    },
	    hasExciseModule: function hasExciseModule() {
	      var hasExciseModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Excise') {
	            hasExciseModule = true;
	          }
	        }
	      }
	      return hasExciseModule;
	    }
	  }),
	
	  mounted: function mounted() {
	    this.getResources();
	  },
	
	
	  watch: {
	    shippingProviders: function shippingProviders(_shippingProviders) {
	      var hasModule = false;
	      this.form.setOptions('shippingProviderId', _shippingProviders.map(function (c) {
	        return { id: c.id, name: c.name + ' ' };
	      }));
	    },
	    warehouses: function warehouses(_warehouses) {
	      var hasModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            hasModule = true;
	            this.form.setOptions('warehouseId', _warehouses.items);
	          }
	        }
	      }
	
	      if (!hasModule) {
	        this.form.hideField('warehouseId');
	      }
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    quickProductEdit: function quickProductEdit(id) {
	      var item = this.orderProducts.find(function (p) {
	        return +p.id === +id;
	      });
	      if (item) {
	        this.setModalProps({
	          productId: item.productId,
	          productName: item.name,
	          orderProduct: item,
	          isEdi: true
	        });
	        this.toggle(true);
	        this.setModalContent(function () {
	          return _quickProductEditExcise2.default;
	        });
	      }
	    },
	    getResources: function getResources() {
	      var _this = this;
	
	      this.loading = true;
	      Promise.all([_shippingProvider2.default.all(), _warehouse2.default.all(), _orderProduct2.default.all(this.currentOrder.id), _organizationSettings2.default.show()]).then(function () {
	        _this.loading = false;
	        _this.form.assignData({ deliveryDate: (0, _moment2.default)(_this.currentEdiOrder.requestedDeliveryDate.split('.').join('-'), 'DD-M-Y').format('Y-MM-DD') });
	        _this.form.warehouseId = _this.currentOrder.warehouseId || _this.settings.defaultWarehouse;
	      });
	    },
	    store: function store() {
	      var _this2 = this;
	
	      this.loading = false;
	      this.form.loading = true;
	      var client = _shippingConfirm2.default.send(Object.assign({}, this.form.data()));
	
	      return _ediOrder2.default.confirm(this.currentEdiOrder.id, client).then(function (data) {
	        _this2.loading = false;
	        if (data.xml) {
	          _this2.$msgbox({
	            title: 'XML',
	            message: data.xml,
	            customClass: 'xmlModalCustomClass'
	          });
	        } else {
	          _this2.$message({
	            showClose: true,
	            message: _this2.$t('static.ediOrders.edit.confirmSuccess'),
	            customClass: 'success'
	          });
	        }
	        _order2.default.show(_this2.currentOrder.id);
	        _this2.closeModal();
	      }).catch(function (errors) {
	        _this2.loading = false;
	        _this2.form.loading = false;
	        var message = errors.data.message || '';
	        if (errors.data.confirm_date) {
	          message = errors.data.confirm_date[0];
	        } else if (errors.data.delivery_date) {
	          message = errors.data.delivery_date[0];
	        }
	
	        _this2.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	      });
	    },
	    nextProcess: function nextProcess() {
	      this.setModalContent(function () {
	        return __webpack_require__(2673);
	      });
	      this.setModalProps({
	        order: this.currentOrder,
	        orderProduct: this.orderProducts
	      });
	      this.setModalShowClose(true);
	      this.setModalCloseOnPressEscape(true);
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _auth = __webpack_require__(53);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _orderProduct = __webpack_require__(48);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _ediOrder = __webpack_require__(187);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _order = __webpack_require__(54);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _shippingProvider = __webpack_require__(97);
	
	var _shippingProvider2 = _interopRequireDefault(_shippingProvider);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _vuex = __webpack_require__(5);
	
	var _shippingConfirm = __webpack_require__(198);
	
	var _shippingConfirm2 = _interopRequireDefault(_shippingConfirm);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    warehouseId: {
	      Type: Number,
	      required: true
	    }
	  },
	
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        shippingProviderId: {
	          value: '',
	          type: 'select'
	        },
	        shippingDate: {
	          value: '',
	          type: 'date'
	        }
	      }),
	      loading: false,
	      displayError: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentOrder: 'currentOrder',
	    shippingProviders: 'allShippingProviders',
	    currentEdiOrder: 'currentEdiOrder',
	    account: 'account',
	    settings: 'organizationSettings',
	    orderProducts: 'allOrderProducts'
	  }), {
	    unassignedProducts: function unassignedProducts() {
	      return this.orderProducts.filter(function (op) {
	        return op.quantityConfirmed != op.quantityPacked;
	      });
	    }
	  }),
	
	  mounted: function mounted() {
	    this.getResources();
	  },
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    setShippingProviders: function setShippingProviders(shippingProviders) {
	      var hasModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Shipping Provider') {
	            hasModule = true;
	          }
	        }
	      }
	      if (hasModule) {
	        this.form.setOptions('shippingProviderId', shippingProviders.map(function (c) {
	          return { id: c.id, name: c.name + ' ' };
	        }));
	        if (this.form.options.shippingProviderId.length > 0) this.displayError = false;
	      } else {
	        this.displayError = false;
	        this.form.hideField('shippingProviderId');
	      }
	    },
	    getResources: function getResources() {
	      var _this = this;
	
	      this.loading = true;
	      Promise.all([_shippingProvider2.default.warehouseShippingProvider(this.warehouseId), _organizationSettings2.default.show()]).then(function (data) {
	        _this.loading = false;
	        if (data[0].length == 0) {
	          _this.displayError = true;
	          _this.loading = false;
	        } else {
	          _this.loading = false;
	          _this.form.shippingProviderId = data[0][0].id;
	        }
	        _this.setShippingProviders(data[0]);
	        _this.form.assignData({ shippingDate: (0, _moment2.default)(_this.currentEdiOrder.requestedDeliveryDate.split('.').join('-'), 'DD-M-Y').format('Y-MM-DD') });
	      });
	    },
	    store: function store() {
	      var _this2 = this;
	
	      this.loading = false;
	      this.form.loading = true;
	      var client = _shippingConfirm2.default.send(Object.assign({}, this.form.data()));
	      return _ediOrder2.default.process(this.currentEdiOrder.id, client).then(function (data) {
	        _this2.loading = false;
	        if (data.xml) {
	          _this2.$msgbox({
	            title: 'XML',
	            message: data.xml,
	            customClass: 'xmlModalCustomClass'
	          });
	        } else {
	          _this2.$message({
	            showClose: true,
	            message: _this2.$t('static.ediOrders.edit.processSuccess'),
	            type: 'success'
	          });
	        }
	        _this2.closeModal();
	      }).catch(function (errors) {
	        _this2.loading = false;
	        _this2.form.loading = false;
	        var message = _this2.$t('static.ediOrders.edit.confirmError');
	        if (errors.data.shipping_provider_id) {
	          message = errors.data.shipping_provider_id[0];
	        }
	        if (errors.data.shipping_date) {
	          message = _this2.$t('static.ediOrders.edit.invalidDeliveryDate');
	        }
	
	        if (errors.data.shipping_provider_id) {
	          message = errors.data.shipping_provider_id[0];
	        }
	        _this2.form.recordErrors(_shippingConfirm2.default.fetch(errors.data));
	        _this2.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _batchOptions = __webpack_require__(201);
	
	var _vuex = __webpack_require__(5);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _batch = __webpack_require__(60);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _tax = __webpack_require__(128);
	
	var _tax2 = _interopRequireDefault(_tax);
	
	var _orderProduct = __webpack_require__(48);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _unitType = __webpack_require__(235);
	
	var _unitType2 = _interopRequireDefault(_unitType);
	
	var _ediOrderItem = __webpack_require__(457);
	
	var _ediOrderItem2 = _interopRequireDefault(_ediOrderItem);
	
	var _productDeposit = __webpack_require__(96);
	
	var _productDeposit2 = _interopRequireDefault(_productDeposit);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _quickProductEdit = __webpack_require__(278);
	
	var _quickProductEdit2 = _interopRequireDefault(_quickProductEdit);
	
	var _orderWarehousePopup = __webpack_require__(417);
	
	var _orderWarehousePopup2 = _interopRequireDefault(_orderWarehousePopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        id: {
	          value: '',
	          type: 'text'
	        },
	        name: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        batchIds: {
	          value: [],
	          type: 'select'
	        },
	        transactions: {
	          value: '',
	          type: 'plaintext'
	        },
	        available: {
	          value: '',
	          type: 'plaintext'
	        },
	        price: {
	          value: '',
	          type: 'number'
	        },
	        productDepositName: {
	          value: '',
	          type: 'plaintext'
	        },
	        unitTypeId: {
	          value: '',
	          type: 'select'
	        },
	        quantityOrdered: {
	          value: '',
	          type: 'number'
	        },
	        quantityConfirmed: {
	          value: '',
	          type: 'number'
	        },
	        quantityReceived: {
	          value: '',
	          type: 'number'
	        },
	        taxId: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      hiddenFields: ['id'],
	      ready: false
	    };
	  },
	
	
	  props: {
	    order: {
	      type: Object,
	      required: true
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    products: 'allProducts',
	    orderProducts: 'allOrderProducts',
	    currentEdiOrder: 'currentEdiOrder',
	    taxes: 'allTaxes',
	    batches: 'allBatches',
	    productDeposits: 'allProductDeposits',
	    account: 'account',
	    currentOrder: 'currentOrder',
	    unitTypes: 'allUnitTypes'
	  }), {
	    checkHasInventory: function checkHasInventory() {
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    },
	    hasProduction: function hasProduction() {
	      if (this.account.modules.length > 0) {
	        return this.account.modules.find(function (module) {
	          return module.name === 'Production';
	        });
	      }
	      if (this.account.allowProducerBatches) return true;
	      return false;
	    },
	    list: function list() {
	      var _this = this;
	
	      return this.orderProducts.map(function (p) {
	        var deposit = [];
	        if (p.productDepositId) {
	          deposit = _this.productDeposits.all.filter(function (d) {
	            return p.productDepositId.toString() === d.id.toString();
	          });
	        }
	
	        if (p.returnCode != 0) {
	          _this.form.initialAssign({
	            returnCodeDescription: {
	              value: '',
	              type: 'string'
	            }
	          });
	        } else {
	          _this.form.removeField('returnCodeDescription');
	        }
	
	        if (!_this.checkHasInventory) {
	          _this.form.removeField('available');
	        }
	
	        var value = '';
	        if (deposit.length) {
	          value = _this.$t('static.orders.edit.deposit') + ': ' + deposit[0].name;
	        }
	
	        var nonBatchProduct = p.warehouses.filter(function (p) {
	          return p.warehouseId === _this.order.warehouseId.toString();
	        }).find(function (p) {
	          return p.batchId === 0;
	        });
	        var batchIds = [];
	        if (p.batchIds.length) {
	          batchIds = batchIds.concat(p.batchIds.map(function (id) {
	            return id.toString();
	          }));
	        } else if (nonBatchProduct) {
	          batchIds = ['0'];
	        }
	
	        var transactions = p.warehouseTransactions.map(function (t) {
	          var batchObj = t.batch_id ? _this.batches.find(function (b) {
	            return +b.id === +t.batch_id;
	          }) : '';
	          var batch = batchObj ? batchObj.code : '' + _this.$t('static.orders.edit.nonBatch');
	          return batch + ' ( qty: ' + t.adjustment_qty + ' )';
	        });
	
	        var row = {
	          batchIds: batchIds,
	          transactions: transactions ? transactions.join(', ') : '',
	          productDepositName: value,
	          quantityConfirmed: _this.is220 && p.quantityConfirmed === null ? _this.$t('static.orders.edit.unconfirmed') : p.quantityConfirmed
	        };
	        if (p.taxPercentage !== undefined && p.taxPercentage !== null) {
	          row.taxIdDisplay = p.taxPercentage;
	        }
	        return Object.assign({}, p, row);
	      });
	    },
	    totalsTableList: function totalsTableList() {
	      var fmt = function fmt(val) {
	        return Number(val).toLocaleString('nb-NO', {
	          minimumFractionDigits: 2,
	          maximumFractionDigits: 2
	        });
	      };
	
	      var result = [{
	        name: this.$t('static.orders.edit.subtotal'),
	        value: fmt(this.subtotal)
	      }, {
	        name: this.$t('static.orders.edit.tax'),
	        value: fmt(this.tax)
	      }];
	
	      if (this.discount > 0) {
	        result.push({
	          name: this.$t('static.orders.edit.discount'),
	          value: fmt(this.discount)
	        });
	      }
	
	      if (this.deposit > 0) {
	        result.push({
	          name: this.$t('static.orders.edit.deposit'),
	          value: fmt(this.deposit)
	        });
	      }
	
	      result.push({
	        name: this.$t('static.orders.edit.total'),
	        value: fmt(this.total)
	      });
	
	      return result;
	    },
	    showTable: function showTable() {
	      if (this.orderProducts.length > 0 || this.addingProduct || this.editingProduct) {
	        return true;
	      }
	
	      return false;
	    },
	    subtotal: function subtotal() {
	      return this.orderProducts.map(function (p) {
	        return p.price * p.quantity;
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    discount: function discount() {
	      return this.orderProducts.map(function (p) {
	        return p.price * p.quantity * (p.discount / 100);
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    tax: function tax() {
	      return this.orderProducts.map(function (p) {
	        return p.price * p.quantity * (1 - p.discount / 100) * (p.taxPercentage / 100);
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    deposit: function deposit() {
	      return this.orderProducts.map(function (p) {
	        return p.productDeposit * p.quantity;
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    total: function total() {
	      var total = Number(this.subtotal - this.discount);
	      var totalTax = Number(this.deposit) + total + Number(this.tax);
	      return totalTax.toFixed(2);
	    },
	    isZRE: function isZRE() {
	      return this.currentEdiOrder.ediOrderTypeName === 'ZRE';
	    },
	    isZKA: function isZKA() {
	      return this.currentEdiOrder.ediOrderTypeName === 'ZKA';
	    },
	    isZNB: function isZNB() {
	      return this.currentEdiOrder.ediOrderTypeName === 'ZNB';
	    },
	    is220: function is220() {
	      return this.currentEdiOrder.ediOrderTypeName === '220';
	    },
	    toBeConfirmed: function toBeConfirmed() {
	      return this.is220 && this.currentEdiOrder.ediOrderStatusName === 'created';
	    },
	    isReceived: function isReceived() {
	      return this.is220 && this.currentEdiOrder.ediOrderStatusName === 'received';
	    },
	    isCreated: function isCreated() {
	      return this.is220 && this.currentEdiOrder.ediOrderStatusName === 'created';
	    },
	    isProcessed: function isProcessed() {
	      return this.is220 && this.currentEdiOrder.ediOrderStatusName === 'processed';
	    },
	    isConfirmed: function isConfirmed() {
	      return this.is220 && this.currentEdiOrder.ediOrderStatusName === 'confirmed';
	    },
	    isCancelled: function isCancelled() {
	      return this.is220 && this.currentEdiOrder.ediOrderStatusName === 'cancelled';
	    },
	    canBeConfirmed: function canBeConfirmed() {
	      if (['created', 'pending', 'out_of_stock'].includes(this.currentEdiOrder.ediOrderStatusName) && this.is220) {
	        return true;
	      }
	
	      if (this.checkHasInventory && this.is220 && this.currentEdiOrder.ediOrderStatusName === 'received' && !this.hasOrderConfirmation) {
	        return true;
	      }
	
	      return false;
	    }
	  }),
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalClass: 'SET_MODAL_CLASS'
	  }), {
	    activateWarehouseModal: function activateWarehouseModal() {
	      this.setModalContent(function () {
	        return _orderWarehousePopup2.default;
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    searchMethod: function searchMethod(search, field) {
	      return Promise.all([_product2.default.search({ search: search, warehouse_id: '' })]);
	    },
	    onQuickProductEditMounted: function onQuickProductEditMounted() {
	      var that = this;
	    },
	    updated: function updated(product, orderProduct) {
	      this.form.assignData(orderProduct);
	      this.form.assignData(product);
	      return this.update(orderProduct.id, product);
	    },
	    tableClickHandler: function tableClickHandler(item, name) {
	
	      return false;
	    },
	    tableTagHandler: function tableTagHandler(item, name) {
	      if (this.is220 && name === 'quantityConfirmed' && isNaN(item.quantityConfirmed)) {
	        return 'warning';
	      }
	
	      return false;
	    },
	    update: function update(orderProductId, product) {
	      var _this2 = this;
	
	      this.form.loading = true;
	
	      var id = this.order.id;
	      var data = this.form.data();
	
	      delete data.productId;
	      data.name = _typeof(data.name) === 'object' ? data.name.name : data.name;
	      data.productDepositId = product.productDepositId ? product.productDepositId : null;
	      data.discount = 0;
	      data.quantity = data.quantityOrdered;
	
	      return new Promise(function (resolve, reject) {
	        _orderProduct2.default.update(id, data, orderProductId).then(function () {
	          _orderProduct2.default.all(_this2.order.id);
	          _this2.form.loading = false;
	          _store2.default.dispatch('updateOrderProduct', { orderProduct: data, id: orderProductId });
	          resolve();
	        }).catch(function (errors) {
	          _this2.form.loading = false;
	          _this2.form.recordErrors(errors);
	          var errorsKeys = Object.keys(_this2.form.errors.errors);
	          _this2.$message({
	            showClose: true,
	            message: errors[errorsKeys[0]][0],
	            customClass: 'error'
	          });
	          reject();
	        });
	      });
	    },
	    confirm: function confirm(itemId) {
	      var _this3 = this;
	
	      var id = this.currentEdiOrder.id;
	      var ediItemId = this.orderProducts.filter(function (p) {
	        return itemId.toString() === p.id.toString();
	      })[0].ediOrderItemId;
	      var data = this.form.data();
	
	      if (data.quantityConfirmed === this.$t('static.orders.edit.unconfirmed')) {
	        data.quantityConfirmed = 0;
	      }
	
	      if (data.quantityConfirmed > data.quantityOrdered) {
	        return this.$message({
	          showClose: true,
	          message: this.$t('static.orders.edit.quantityMustNotBeGreaterThanQuantityOrdered'),
	          type: 'error'
	        });
	      }
	
	      return _ediOrderItem2.default.confirm(id, data, ediItemId).then(function () {
	        _orderProduct2.default.all(_this3.order.id);
	      }).catch(function (errors) {
	        _this3.form.recordErrors(errors);
	        var errorsKeys = Object.keys(_this3.form.errors.errors);
	        _this3.$message({
	          showClose: true,
	          message: errors[errorsKeys[0]][0],
	          type: 'error'
	        });
	      });
	    },
	    setMax: function setMax() {
	      this.form.quantityConfirmed = this.form.quantityOrdered;
	    },
	    destroy: function destroy(orderProductId) {
	      _orderProduct2.default.destroy(this.order.id, orderProductId);
	    },
	    getResources: function getResources() {
	      var _this4 = this;
	
	      this.ready = false;
	      var resources = [_tax2.default.all(), _orderProduct2.default.all(this.order.id), _productDeposit2.default.all(), _unitType2.default.all()];
	      if (this.hasProduction) {
	        resources.push(_batch2.default.all({
	          warehouse_id: this.order.warehouseId,
	          has_warehouse_transaction: 1,
	          for_select: 1
	        }));
	      }
	      Promise.all(resources).then(function () {
	        _this4.ready = true;
	      }).catch(function () {
	        _this4.ready = true;
	      });
	    },
	    onFormChange: function onFormChange(name, value) {
	      this.form.clearSuccess(name, value);
	      this.form.clearErrors(name);
	      this.form[name] = value;
	      if (name === 'quantityConfirmed' && value > this.form.quantityOrdered) {
	        this.form[name] = this.form.quantityOrdered;
	      }
	      this.$forceUpdate();
	    },
	    configFieldVisibility: function configFieldVisibility() {
	      if (!this.hasProduction) {
	        this.hiddenFields = ['id', 'batchIds', 'transactions'];
	      } else {
	        this.hiddenFields = ['id'];
	        if (this.toBeConfirmed || this.canBeConfirmed) {
	          this.hiddenFields.push('transactions');
	        } else {
	          this.hiddenFields.push('available');
	          this.hiddenFields.push('batchIds');
	        }
	      }
	    }
	  }),
	
	  watch: {
	    order: function order() {
	      this.getResources();
	    },
	    taxes: function taxes(_taxes) {
	      this.form.setOptions('taxId', _taxes.all.map(function (t) {
	        return { id: t.id, name: t.taxPercentage };
	      }));
	    },
	    productDeposits: function productDeposits(deposits) {
	      this.form.setOptions('productDepositId', deposits.all);
	    },
	    orderProducts: function orderProducts(_orderProducts) {
	      this.configFieldVisibility();
	    },
	    unitTypes: function unitTypes(_unitTypes) {
	      this.form.setOptions('unitTypeId', _unitTypes.all.map(function (item) {
	        return {
	          id: item.id.toString(),
	          name: item.name
	        };
	      }));
	    },
	
	
	    'form.id': function formId(id) {
	      var _this5 = this;
	
	      if (id && this.hasProduction) {
	        if (+this.$refs.formTable.$data.editingItem === +id) {
	          if (this.checkHasInventory) {
	            if (!this.currentOrder.warehouseId && this.currentOrder.orderStatus !== 'cancelled') {
	              this.$refs.formTable.closeForm();
	              this.activateWarehouseModal();
	              return;
	            }
	          }
	        }
	
	        var orderProduct = this.list.find(function (item) {
	          return item.id === id;
	        });
	
	        if (!orderProduct && _typeof(this.form.name) === 'object') {
	          orderProduct = this.form.name;
	        }
	
	        if (orderProduct && orderProduct.warehouses) {
	          var products = orderProduct.warehouses;
	          if (products.length) {
	            if (this.currentOrder.warehouseId) {
	              products = products.filter(function (p) {
	                return p.warehouseId === _this5.currentOrder.warehouseId.toString();
	              });
	            }
	
	            var batchIds = products.map(function (p) {
	              return p.batchId.toString();
	            });
	
	            var options = [];
	            options = options.concat(this.batches.filter(function (b) {
	              return batchIds.indexOf(b.id) !== -1;
	            }).map(function (batch) {
	              var batchProduct = products.find(function (p) {
	                return p.batchId.toString() === batch.id.toString();
	              });
	              return Object.assign({}, {
	                id: batch.id.toString(),
	                name: _this5.currentOrder.warehouseId ? batch.code + ' | ' + _this5.$t('static.orders.edit.availableQty') + ': ' + batchProduct.qtyNumber : batch.code,
	                available: batchProduct.qtyNumber
	              });
	            }));
	            options = options.reverse();
	
	            var nonBatchProduct = products.find(function (p) {
	              return p.batchId === 0;
	            });
	            if (nonBatchProduct) {
	              options.unshift({
	                id: '0',
	                name: this.$t('static.orders.edit.nonBatch') + ' | ' + this.$t('static.orders.edit.availableQty') + ': ' + nonBatchProduct.qtyNumber,
	                available: nonBatchProduct.qtyNumber
	              });
	            }
	
	            if (this.currentOrder.warehouseId) {
	              options = (0, _batchOptions.sortBatchOptions)(options, { hideEmpty: true, keepId: this.form.batchId });
	            }
	
	            this.form.setOverrideOptions('batchIds', options);
	            if (!this.form.batchId && batchIds.length) {
	              this.form.batchId = this.currentOrder.warehouseId ? (0, _batchOptions.defaultBatchId)(options) : batchIds[0];
	            }
	          } else {
	            this.form.batchId = '';
	            this.form.setOverrideOptions('batchIds', []);
	          }
	        } else {
	          this.form.batchId = '';
	          this.form.setOverrideOptions('batchIds', []);
	        }
	      }
	    },
	
	    batches: function batches(_batches) {
	      var options = _batches.map(function (batch) {
	        return {
	          id: +batch.id,
	          name: batch.code
	        };
	      });
	      this.form.setOptions('batchIds', [{
	        id: 0,
	        name: '' + this.$t('static.orders.edit.nonBatch')
	      }].concat(_toConsumableArray(options)));
	    },
	
	
	    'form.batchIds': function formBatchIds(batchIds) {
	      var _this6 = this;
	
	      if (this.hasProduction) {
	        var orderProduct = this.list.find(function (item) {
	          return item.id === _this6.form.id;
	        });
	        if (!orderProduct && _typeof(this.form.name) === 'object') {
	          orderProduct = this.form.name;
	        }
	        if (orderProduct) {
	          var products = orderProduct.warehouses;
	          if (this.order.warehouseId) {
	            products = products.filter(function (p) {
	              return p.warehouseId === _this6.order.warehouseId.toString();
	            });
	          }
	          var batchProducts = products.filter(function (p) {
	            return batchIds.includes(p.batchId.toString());
	          });
	          var available = 0;
	          if (batchProducts.length) {
	            available = batchProducts.map(function (item) {
	              return item.qtyNumber;
	            }).reduce(function (total, qtyNumber) {
	              return total + qtyNumber;
	            });
	          }
	          this.form.available = available.toString();
	        }
	      }
	    }
	
	  },
	
	  mounted: function mounted() {
	    var _this7 = this;
	
	    this.getResources();
	    Object.keys(this.form.fields).forEach(function (field) {
	      if (field !== 'batchIds' && field !== 'quantityConfirmed') {
	        _this7.form.disableField(field);
	      }
	    });
	    this.configFieldVisibility();
	    this.form.setExtraAttr('batchIds', {
	      multiple: true
	    });
	  },
	
	
	  components: {
	    VFormTable: __webpack_require__(46),
	    VTotalsTable: __webpack_require__(279)
	  }
	};

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _package = __webpack_require__(188);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _packageOrderProduct = __webpack_require__(189);
	
	var _packageOrderProduct2 = _interopRequireDefault(_packageOrderProduct);
	
	var _orderProduct = __webpack_require__(48);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        packageUnitTypeId: {
	          value: '',
	          type: 'select'
	        },
	        packingLevel: {
	          value: '',
	          type: 'select'
	        },
	        parentId: {
	          value: '',
	          type: 'select'
	        },
	        sscc: {
	          value: '',
	          type: 'text'
	        },
	        id: {
	          value: '',
	          type: 'hidden'
	        }
	      }),
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentOrder: 'currentOrder',
	    orderProducts: 'allOrderProducts',
	    parentIds: 'deliveryPackages',
	    packageUnitTypes: 'allPackageUnitTypes'
	  }), {
	    loadForms: function loadForms() {
	      var element = this;
	      var type = [{ "id": "2", "name": "Pallet" }, { "id": "3", "name": "Box" }];
	      this.form.setOptions('packingLevel', type);
	      this.form.setOptions('parentId', this.parentIds.all.filter(function (p) {
	        return p.packingLevel == 2 && p.id != element.$store.state.modal.modalProps.id;
	      }));
	      this.form.setOptions('packageUnitTypeId', this.packageUnitTypes.all);
	      this.form.hideField('parentId');
	      this.form.assignData(this.$store.state.modal.modalProps);
	      this.form.setFieldValue('parentId', '');
	    }
	  }),
	
	  created: function created() {
	    this.loadForms;
	    this.form.disableField('orderProductId');
	  },
	
	
	  watch: {
	    'form.packingLevel': function formPackingLevel(typeId) {
	      if (typeId.toString() == 2) {
	        this.form.hideField('parentId');
	      } else if (typeId.toString() == 3) {
	        this.form.showField('parentId');
	      }
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    modalProps: 'SET_MODAL_PROPS'
	  }), {
	    update: function update() {
	      var _this = this;
	
	      this.form.loading = true;
	      _package2.default.update(this.form.id, this.form.data()).then(function (data) {
	        _orderProduct2.default.all(_this.currentOrder.id);
	        _packageOrderProduct2.default.all(_this.currentOrder.id);
	        _package2.default.all(_this.currentOrder.id);
	        _this.$message({
	          showClose: true,
	          message: _this.$t('static.packageOrderProduct.edit.success'),
	          customClass: 'success'
	        });
	        _this.closeModal();
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	        var message = _this.$t('static.packageOrderProduct.edit.error');
	        if (errors.quantityExceedError) {
	          message = _this.$t('static.packageOrderProduct.edit.quantityExceedError');
	        }
	        _this.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _package = __webpack_require__(188);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _packageOrderProduct = __webpack_require__(189);
	
	var _packageOrderProduct2 = _interopRequireDefault(_packageOrderProduct);
	
	var _orderProduct = __webpack_require__(48);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        productName: {
	          value: '',
	          type: 'text'
	        },
	        quantity: {
	          value: '',
	          type: 'text'
	        },
	        quantityUnit: {
	          value: '',
	          type: 'select'
	        },
	        grossWeight: {
	          value: '',
	          type: 'text'
	        },
	        netWeight: {
	          value: '',
	          type: 'text'
	        },
	        stackWeight: {
	          value: '',
	          type: 'text'
	        },
	        bestBefore: {
	          value: new Date().toISOString().slice(0, 10),
	          type: 'date'
	        },
	        maxTopLoad: {
	          value: '',
	          type: 'text'
	        },
	        batchLotNumber: {
	          value: '',
	          type: 'text'
	        },
	        temperatureRequirement: {
	          value: '',
	          type: 'text'
	        },
	        id: {
	          value: '',
	          type: 'hidden'
	        }
	      }),
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentOrder: 'currentOrder',
	    orderProducts: 'allOrderProducts'
	  }), {
	    loadForms: function loadForms() {
	      var qtyUnitOptions = [{ "id": "PCE", "name": "Piece" }, { "id": "KGM", "name": "Kilo" }, { "id": "LTR", "name": "Litre" }, { "id": "MTR", "name": "Metre" }];
	      this.form.setOptions('quantityUnit', qtyUnitOptions);
	      this.form.assignData(this.$store.state.modal.modalProps);
	    }
	  }),
	
	  created: function created() {
	    this.loadForms;
	    this.form.disableField('orderProductId');
	  },
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    modalProps: 'SET_MODAL_PROPS'
	  }), {
	    update: function update() {
	      var _this = this;
	
	      this.form.loading = true;
	      var packageOrderProductUpdate = _packageOrderProduct2.default.update(this.form.id, this.form.data()).then(function (data) {
	        _orderProduct2.default.all(_this.currentOrder.id);
	        _packageOrderProduct2.default.all(_this.currentOrder.id);
	        _package2.default.all(_this.currentOrder.id);
	        _this.$message({
	          showClose: true,
	          message: _this.$t('static.packageOrderProduct.edit.success'),
	          customClass: 'success'
	        });
	        _this.closeModal();
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	        var message = _this.$t('static.packageOrderProduct.edit.error');
	        if (errors.quantityExceedError) {
	          message = _this.$t('static.packageOrderProduct.edit.quantityExceedError');
	        }
	        _this.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({}),
	      loading: false
	    };
	  },
	
	
	  props: {
	    module: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    modules: 'allModules'
	  })),
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    var fields = {};
	    var hasOptions = false;
	    if (this.module.fields) {
	      for (var i = 0; i < this.module.fields.length; i++) {
	        var newField = {
	          type: this.module.fields[i].type || 'text',
	          value: ''
	        };
	        if (this.module.fields[i].options) {
	          hasOptions = true;
	        }
	        fields[this.module.fields[i].name] = newField;
	      }
	
	      this.form = new _forms2.default(fields);
	      if (hasOptions) {
	        for (var _i = 0; _i < this.module.fields.length; _i++) {
	          if (this.module.fields[_i].options) {
	            (function () {
	              var options = _this.module.fields[_i].options;
	              _this.form.setOptions(_this.module.fields[_i].name, Object.keys(options).map(function (key) {
	                return {
	                  id: key,
	                  name: options[key]
	                };
	              }));
	            })();
	          }
	        }
	      }
	    }
	    this.loading = false;
	  },
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    getResources: function getResources() {},
	    subscribe: function subscribe() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var obj = Object.assign({ module_id: this.module.id }, this.form.data());
	      _modules2.default.subscribe(this.module.id, obj).then(function () {
	        Promise.all([_modules2.default.items(), _account2.default.find()]).then(function () {
	          _this2.closeModal();
	        });
	      }).catch(function (error) {
	        var message = error.data ? error.data.message : 'Field Required';
	        _this2.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	        _this2.form.recordErrors(error);
	        _this2.form.loading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	  data: function data() {
	    return {
	      id: 0,
	      subject: '',
	      failed: 0,
	      success: 0,
	      activeNames: ['1'],
	      successContainer: [],
	      failedContainer: [],
	      loadingSend: false
	    };
	  },
	
	
	  props: {
	    emailId: {
	      type: Number,
	      required: true
	    },
	
	    emailSendTracking: {
	      type: Array,
	      required: true
	    },
	
	    emailSubject: {
	      type: String,
	      required: true
	    },
	
	    emailSuccesCount: {
	      type: Number,
	      required: true
	    },
	
	    emailFailedCount: {
	      type: Number,
	      required: true
	    },
	
	    emailSendReport: {
	      type: Function,
	      required: true
	    }
	  },
	
	  computed: {},
	
	  mounted: function mounted() {
	    this.id = this.emailId;
	    this.subject = this.emailSubject;
	    this.failed = this.emailFailedCount;
	    this.success = this.emailSuccesCount;
	    this.successContainer = this.emailSendTracking.filter(function (item) {
	      return item.status === 1;
	    });
	    this.failedContainer = this.emailSendTracking.filter(function (item) {
	      return item.status === 0;
	    });
	    if (this.failedContainer.length > 0) {
	      this.activeNames = ['2'];
	    }
	    console.log(this.successContainer);
	  },
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    handleChange: function handleChange(val) {
	      console.log(val);
	    },
	    sendReport: function sendReport() {
	      var _this = this;
	
	      this.loadingSend = true;
	      var data = [];
	      this.failedContainer.forEach(function (item) {
	        data.push({
	          'email': item.client_contact.email,
	          'name': item.client_contact.first_name + ' ' + item.client_contact.last_name,
	          'Client group': item.client_group.client.client_group.name,
	          'List': item.news_subscriber_list.name,
	          'Date attempt to sent': item.created_at,
	          'error': item.result
	        });
	      });
	      this.emailSendReport({ newsId: this.id, emailErrors: data }).then(function () {
	        var message = 'Your report is successfully sent';
	        _this.$message({
	          message: message,
	          type: 'success'
	        });
	        _this.loadingSend = false;
	      }).catch(function (e) {
	        _this.loadingSend = false;
	        console.log(e);
	      });
	    }
	  })
	};

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _vuex = __webpack_require__(5);
	
	var _businessHourException = __webpack_require__(451);
	
	var _businessHourException2 = _interopRequireDefault(_businessHourException);
	
	var _businessHourException3 = __webpack_require__(306);
	
	var _businessHourException4 = _interopRequireDefault(_businessHourException3);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        date: {
	          value: [],
	          type: 'dateRange'
	        },
	        start: {
	          value: '',
	          type: 'time'
	        },
	        end: {
	          value: '',
	          type: 'time'
	        },
	        message: {
	          value: '',
	          type: 'text'
	        }
	      })
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    hours: 'businessHourExceptions'
	  }), {
	    exceptionList: function exceptionList() {
	      return this.hours.map(function (o) {
	        return Object.assign({}, o, {
	          date: (0, _moment2.default)(o.start).format('DD-MM-YYYY') + ' - ' + (0, _moment2.default)(o.end).format('DD-MM-YYYY'),
	          start: (0, _moment2.default)(o.start).format('HH:mm'),
	          end: (0, _moment2.default)(o.end).format('HH:mm')
	        });
	      });
	    }
	  }),
	
	  mounted: function mounted() {
	    _businessHourException2.default.all();
	  },
	
	
	  methods: {
	    onFormChange: function onFormChange(name, value) {
	      this.form.clearSuccess(name, value);
	      this.form.clearErrors(name);
	      this.form[name] = value;
	      this.$forceUpdate();
	    },
	    save: function save() {
	      var _this = this;
	
	      var onSuccess = function onSuccess(_ref) {
	        var data = _ref.data;
	
	        _this.form.loading = false;
	        _this.$message({
	          showClose: true,
	          message: data.success.message,
	          type: 'success'
	        });
	        _this.showForm = false;
	      };
	
	      var onError = function onError(errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(_businessHourException4.default.fetch(errors));
	        var errorsKeys = Object.keys(_this.form.errors.errors);
	        _this.$message({
	          showClose: true,
	          message: errors[errorsKeys[0]][0],
	          type: 'error'
	        });
	      };
	
	      var prepareData = function prepareData(data) {
	        var confirmed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
	        var startDate = (0, _moment2.default)(data.date[0]).format('YYYY-MM-DD');
	        var endDate = (0, _moment2.default)(data.date[1]).format('YYYY-MM-DD');
	        var result = {
	          start: startDate + ' ' + data.start,
	          end: endDate + ' ' + data.end,
	          message: data.message
	        };
	        result.confirmed = confirmed;
	        return result;
	      };
	      var data = this.form.data();
	      this.form.loading = true;
	      return _businessHourException2.default.store(prepareData(data)).then(onSuccess).catch(function (errors) {
	        if (errors.error && errors.error.code === 42201) {
	          _this.$confirm(errors.error.message, _this.$t('messages.warning'), {
	            confirmButtonText: _this.$t('static.businessHours.exceptionalHoursSaveKeep'),
	            cancelButtonText: _this.$t('static.businessHours.exceptionalHoursSaveCancel'),
	            type: 'warning'
	          }).then(function () {
	            _businessHourException2.default.store(prepareData(data, 1)).then(onSuccess).catch(onError);
	          }).catch(function () {
	            _businessHourException2.default.store(prepareData(data, 0)).then(onSuccess).catch(onError);
	          });
	          return;
	        }
	        onError(errors);
	        return;
	      });
	    },
	    destroy: function destroy(id) {
	      var _this2 = this;
	
	      this.destroyLoading = true;
	      _businessHourException2.default.destroy(id).then(function () {
	        _this2.destroyLoading = false;
	      }).catch(function () {
	        _this2.destroyLoading = false;
	      });
	    }
	  },
	
	  components: {
	    VFormTable: __webpack_require__(46)
	  }
	};

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(5);
	
	var _exciseEntry = __webpack_require__(297);
	
	var _exciseEntry2 = _interopRequireDefault(_exciseEntry);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _exciseGroup = __webpack_require__(94);
	
	var _exciseGroup2 = _interopRequireDefault(_exciseGroup);
	
	var _additionalCode = __webpack_require__(289);
	
	var _additionalCode2 = _interopRequireDefault(_additionalCode);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    exciseDate: {
	      type: String,
	      required: true
	    }
	  },
	
	  data: function data() {
	    return {
	      loading: true,
	      sortValue: '',
	      entries: [],
	      filter: {
	        product: '',
	        month: this.exciseDate
	      },
	      form: new _forms2.default({
	        product: {
	          type: 'autocomplete',
	          value: '',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        source: {
	          type: 'select',
	          value: ''
	        }
	      }),
	      dateRange: [(0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()],
	      pagination: {},
	      page: 1,
	      limit: 25,
	      flag: ''
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    warehouses: 'paginateWarehouses',
	    products: 'allProducts'
	  }), {
	    warehousesList: function warehousesList() {
	      return this.warehouses.items.map(function (b) {
	        return b;
	      });
	    }
	  }),
	
	  watch: {
	    $route: function $route() {},
	
	
	    'form.product': function formProduct(val) {
	      if (val.id > 0) this.loading = true;
	      this.all(this.page, this.limit);
	    },
	
	    'form.source': function formSource(val) {
	      this.loading = true;
	      this.all(this.page, this.limit);
	    }
	  },
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19),
	    VTable: __webpack_require__(33),
	    VExciseTable: __webpack_require__(410),
	    VForm: __webpack_require__(9)
	  },
	
	  mixins: [_search2.default],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.form.setOptions('source', [{ id: 'all', name: this.$t('static.exciseEntry.filters.source.all') }, { id: 'order', name: this.$t('static.exciseEntry.filters.source.order') }, { id: 'credit_note', name: this.$t('static.exciseEntry.filters.source.creditNote') }]);
	
	    var productId = '';
	    if (this.form.product !== '') {
	      productId = this.form.product.id;
	    }
	    var month = '';
	
	    if (this.filter.month != null) {
	      month = this.filter.month;
	    }
	    var params = {
	      page: 1,
	      limit: 50,
	      month: month,
	      product: productId,
	      source: this.form.source,
	      flag: this.flag
	    };
	    Promise.all([_exciseEntry2.default.entries(params), _exciseGroup2.default.all(), _exciseGroup2.default.packaging(), _exciseGroup2.default.basic(), _additionalCode2.default.all()]).then(function (data) {
	      _this.entries = data[0].report;
	      _this.pagination = data[0].pagination;
	      _this.loading = false;
	    });
	
	    _account2.default.rememberPerPage('get', { from: 'exciseEntry' }).then(function (data) {
	      _this.limit = data.size;
	      _this.all(_this.page, _this.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	
	    this.form.setOptions('source', [{ id: 'all', name: this.$t('static.exciseEntry.filters.source.all') }, { id: 'order', name: this.$t('static.exciseEntry.filters.source.order') }, { id: 'credit_note', name: this.$t('static.exciseEntry.filters.source.creditNote') }]);
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'exciseEntry', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this3 = this;
	
	      this.loading = true;
	      this.page = page;
	      this.limit = limit;
	
	      var productId = '';
	      if (this.form.product !== '') {
	        productId = this.form.product.id;
	      }
	      var month = '';
	
	      if (this.filter.month != null) {
	        month = this.filter.month;
	      }
	      _exciseEntry2.default.entries({
	        page: page,
	        limit: limit,
	        month: month,
	        product: productId,
	        source: this.form.source,
	        flag: this.flag
	      }).then(function (data) {
	        _this3.entries = data.report;
	        _this3.pagination = data.pagination;
	        _this3.loading = false;
	      }).catch(function () {
	        _this3.loading = false;
	      });
	    }, 800),
	
	    searchMethod: function searchMethod(search, field) {
	      this.form.setAttrValue('product', 'loading', true);
	
	
	      return Promise.all([_product2.default.search({ search: search, warehouse_id: this.form.warehouseId })]);
	    },
	    updateList: function updateList(index, data) {
	
	      this.all(this.page, this.limit);
	    },
	    changeData: function changeData() {
	      this.loading = true;
	      this.all(this.page, this.limit);
	    },
	    openLink: function openLink(row, key) {
	      console.log(row);
	      if (row.excisable.includes('order')) {
	        this.$router.push({
	          name: 'orders.edit',
	          params: { id: row.linkId }
	        });
	      } else if (row.excisable.includes('creditnote')) {
	        this.$router.push({
	          name: 'bills.creditNote',
	          params: { id: row.linkId }
	        });
	      } else if (row.excisable.includes('transfer')) {
	        this.$router.push({
	          name: 'inventory.transfer.view',
	          params: { id: row.linkId }
	        });
	      } else if (row.excisable.includes('adjustment')) {
	        this.$router.push({
	          name: 'inventory.adjustment.view',
	          params: { id: row.linkId }
	        });
	      } else {
	        this.$router.push({
	          name: 'inventory.purchase.view',
	          params: { id: row.linkId }
	        });
	      }
	    },
	    exportData: function exportData() {
	      var _this4 = this;
	
	      var month = '';
	      if (this.filter.month != null) {
	        month = this.filter.month;
	      }
	
	      var params = {
	        page: this.page,
	        limit: this.limit,
	        month: month,
	        product: this.filter.product,
	        flag: this.flag
	      };
	
	      Promise.all([_exciseEntry2.default.checkFlag(params)]).then(function (data) {
	        params.flag = true;
	        _this4.flag = true;
	        if (data[0].data > 0) {
	          _this4.$message({
	            showClose: true,
	            message: data[0].message,
	            customClass: 'error'
	          });
	          _this4.loading = true;
	          _exciseEntry2.default.entries(params).then(function (data) {
	            _this4.entries = data.report;
	            _this4.pagination = data.pagination;
	            _this4.loading = false;
	          }).catch(function () {
	            _this4.loading = false;
	          });
	        } else {
	          window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/excise_entries/export/', _extends({
	            token: localStorage.getItem('id_token')
	          }, params)));
	        }
	      });
	    },
	    editWarehouse: function editWarehouse(warehouse) {
	      var name = 'warehouse.edit';
	      this.$router.push({
	        name: name,
	        params: { id: warehouse.id }
	      });
	    }
	  })
	};

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(5);
	
	var _exciseEntry = __webpack_require__(297);
	
	var _exciseEntry2 = _interopRequireDefault(_exciseEntry);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _exciseGroup = __webpack_require__(94);
	
	var _exciseGroup2 = _interopRequireDefault(_exciseGroup);
	
	var _additionalCode = __webpack_require__(289);
	
	var _additionalCode2 = _interopRequireDefault(_additionalCode);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sortValue: '',
	      entries: [],
	      pagination: {},
	      page: 1,
	      limit: 5,
	      flag: ''
	    };
	  },
	
	
	  computed: {},
	
	  props: {
	    month: {
	      type: [String],
	      required: true
	    }
	  },
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19),
	    VTable: __webpack_require__(33),
	    VExciseTable: __webpack_require__(410)
	  },
	
	  mixins: [_search2.default],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var params = {
	      page: 1,
	      limit: 5,
	      month: this.month,
	      flag: true
	    };
	    Promise.all([_exciseEntry2.default.entries(params), _exciseGroup2.default.packaging(), _exciseGroup2.default.basic(), _exciseGroup2.default.all(), _additionalCode2.default.all()]).then(function (data) {
	      console.log(data);
	      _this.entries = data[0].report;
	      _this.pagination = data[0].pagination;
	      _this.loading = false;
	    });
	  },
	
	
	  methods: {
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this2 = this;
	
	      this.page = page;
	      this.limit = limit;
	      this.loading = true;
	      _exciseEntry2.default.entries({
	        page: page,
	        limit: limit,
	        month: this.month,
	        flag: true
	      }).then(function (data) {
	        _this2.entries = data.report;
	        _this2.pagination = data.pagination;
	        _this2.loading = false;
	      }).catch(function () {
	        _this2.loading = false;
	      });
	    }, 800),
	
	    updateList: function updateList(index, data) {
	
	      this.all(this.page, this.limit);
	    },
	    changeData: function changeData() {
	      this.all(this.page, this.limit);
	    },
	    openLink: function openLink(row, key) {
	
	      if (row.excisable == 'order') {
	        this.$router.push({
	          name: 'orders.edit',
	          params: { id: row.excisableId }
	        });
	      } else if (row.excisable == 'creditnote') {
	        this.$router.push({
	          name: 'bills.creditNote',
	          params: { id: row.excisableId }
	        });
	      } else {
	        this.$router.push({
	          name: 'inventory.purchase.view',
	          params: { id: row.excisableId }
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	  data: function data() {
	    return {
	      additionalCodes: []
	    };
	  },
	
	  props: {
	    list: {
	      type: Array,
	      required: true
	    },
	    translation: {
	      type: String,
	      required: false
	    },
	    noDataMessage: {
	      type: String,
	      required: false
	    },
	    link: {
	      type: Function,
	      required: false
	    },
	
	    buttons: {
	      type: Array,
	      required: false
	    },
	
	    loading: {
	      type: Boolean,
	      required: false
	    },
	
	    update_list: {
	      type: Function,
	      required: true
	    }
	
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    groups: 'allExciseGroups',
	    codes: 'allAdditionalCode',
	    excisePackagingGroups: 'allExcisePackagingGroups',
	    exciseBasicGroups: 'allExciseBasicGroups'
	  })),
	
	  watch: {},
	
	  methods: {
	    html: function html(data) {
	      return data;
	    },
	    rowClicked: function rowClicked(row) {
	      this.$refs.tableData.toggleRowExpansion(row);
	    }
	  },
	
	  mounted: function mounted() {
	    console.log(this.list);
	  },
	
	
	  components: {
	    VPagination: __webpack_require__(16)
	  }
	};

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _vuex = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      fetching: false,
	      field: ''
	    };
	  },
	
	  computed: {
	    setName: function setName() {
	      return this.name;
	    },
	    getValueData: function getValueData() {
	      if (_typeof(this.value) === 'object') {
	        return this.value.name.toString().toLowerCase();
	      }
	      return this.value.toString();
	    },
	    showLable: function showLable() {
	      return this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	  },
	  props: {
	    name: {
	      type: [String, Number],
	      required: true
	    },
	
	    value: {
	      type: [String, Object, Number],
	      required: false,
	      default: ''
	    },
	
	    options: {
	      type: Array,
	      required: false,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    info: {
	      type: [Array, Object],
	      required: false,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    insideForm: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    remote: {
	      type: Object,
	      required: false,
	      default: function _default() {}
	    },
	
	    isSearch: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    searchMethod: {
	      type: Function,
	      required: false,
	      default: function _default() {}
	    },
	
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	
	    quickForm: {
	      type: Object,
	      required: false
	    }
	  },
	  mounted: function mounted() {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    onInput: function onInput(name) {
	      var _this = this;
	
	      return function (value) {
	        _this.$emit('change', name, value);
	      };
	    },
	    onQuickFormClick: function onQuickFormClick() {
	      this.setModalContent(this.quickForm);
	      this.toggleModal(true);
	    },
	    getValue: function getValue() {
	      if (_typeof(this.value) === 'object') {
	        return this.value.name.toString().toLowerCase();
	      }
	      return this.value;
	    },
	    showHtml: function showHtml(item) {
	      var html = '';
	
	      if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
	        if (item.options !== undefined) {
	          var details = this.showDetails(item);
	          html = '<div class="name"> ' + item.name + ' </div>';
	          html += '<span class="details"> ' + details + ' </span>';
	        } else if (item.fieldsJSON !== undefined) {
	          var _details = this.showDetails(item);
	          html = '<div class="name"> ' + item.name + ' </div>';
	          html += '<span class="details"> ' + _details + ' </span>';
	        } else {
	          html = '<div class="item"> ' + item.name + ' </div>';
	        }
	      } else {
	        html = '<div class="item"> ' + item + ' </div>';
	      }
	
	      return html;
	    },
	    showDetails: function showDetails(item) {
	      var details = '';
	      var tagsOptions = this.$i18n.messages[this.$i18n.locale].form.products;
	
	      for (var i = 0; i < this.info.length; i++) {
	        if (item[this.info[i]] !== undefined) {
	          details += tagsOptions[this.info[i]].label + ": " + item[this.info[i]];
	        } else {
	          if (item.options !== undefined) {
	            if (item.options.fieldsJSON[this.info[i]] !== undefined) {
	              details += tagsOptions[this.info[i]].label + ": " + item.options.fieldsJSON[this.info[i]];
	            } else {
	              details += tagsOptions[this.info[i]].label + ": ";
	            }
	          } else if (item.fieldsJSON !== undefined) {
	            if (item.fieldsJSON[this.info[i]] !== undefined) {
	              details += tagsOptions[this.info[i]].label + ": " + item.fieldsJSON[this.info[i]];
	            } else {
	              details += tagsOptions[this.info[i]].label + ": ";
	            }
	          }
	        }
	
	        if (i < this.info.length - 1) {
	          details += " | ";
	        }
	      }
	
	      return details;
	    },
	    handleSelect: function handleSelect(item) {
	      this.$emit('keydown', this.name, item);
	    },
	    changeData: function changeData(string) {
	      this.$emit('keydown', this.name, { name: '', id: 0 });
	    },
	    fetchLocal: function fetchLocal(queryString, cb) {
	      var _this2 = this;
	
	      if (this.remote === undefined || !Object.keys(this.remote).length) {
	        var options = this.options.map(function (o) {
	          o.value = o.name.toString().toLowerCase();
	          return o;
	        });
	        var createFilter = function createFilter(option) {
	          return option.value.indexOf(queryString.toLowerCase()) === 0;
	        };
	        var results = queryString ? options.filter(createFilter) : options;
	        cb(results);
	        return;
	      }
	
	      if (this.fetching) return;
	
	      this.fetching = true;
	
	      if (queryString === '') {
	        queryString = 0;
	      }
	
	      this.remote.fetchSuggestions(queryString).then(function (suggestions) {
	        _this2.fetching = false;
	
	        var opts = suggestions.map(function (o) {
	          return { name: o.postalCode };
	        });
	
	        var options = opts.map(function (o) {
	          o.value = o.name.toString().toLowerCase();
	          return o;
	        });
	
	        var createFilter = function createFilter(option) {
	          return option.value.indexOf(queryString.toLowerCase()) === 0;
	        };
	        var results = queryString ? options.filter(createFilter) : options;
	        cb(results);
	      });
	    },
	    fetchServer: function fetchServer(queryString, cb) {
	      var _this3 = this;
	
	      this.fetching = true;
	      this.searchMethod(queryString).then(function (data) {
	        _this3.fetching = false;
	
	        var options = data[0].map(function (o) {
	          o.value = o.name.toString().toLowerCase();
	          return o;
	        });
	
	        cb(options);
	      });
	    },
	
	    fetchSuggestions: (0, _debounce2.default)(function (queryString, cb) {
	      if (this.isSearch) {
	        this.fetchServer(queryString, cb);
	      } else {
	        this.fetchLocal(queryString, cb);
	      }
	    }, 800)
	  })
	};

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    value: {
	      required: false,
	      default: ''
	    },
	
	    options: {
	      type: Array,
	      required: false,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    separator: {
	      type: String,
	      required: false
	    },
	
	    expandTrigger: {
	      type: String,
	      required: false
	    },
	
	    debounce: {
	      type: Number,
	      required: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    insideForm: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	
	    multiple: {
	      type: Boolean,
	      default: false
	    },
	
	    filterable: {
	      type: Boolean,
	      default: true
	    },
	
	    loading: {
	      type: Boolean,
	      default: false
	    },
	
	    quickForm: {
	      type: Object,
	      required: false
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    onInput: function onInput(name) {
	      var _this = this;
	
	      return function (value) {
	        _this.$emit('change', name, value);
	      };
	    }
	  }),
	
	  render: function render(h) {
	    var value = this.value;
	    if (typeof this.value === 'string' && this.value === '') {
	      value = [];
	    }
	    var props = {
	      multiple: this.multiple,
	      expandTrigger: this.expandTrigger
	    };
	    var cascader = h('el-cascader', {
	      attrs: {
	        value: value,
	        loading: this.loading,
	        filterable: this.filterable,
	        disabled: this.disabled,
	
	        options: this.options,
	        props: props,
	        name: this.name,
	        placeholder: this.translation ? this.$t(this.translation + '.placeholder') : this.name
	      },
	      on: {
	        'input': this.onInput(this.name)
	      }
	    });
	
	    if (!this.insideForm) {
	      return cascader;
	    }
	
	    var label = null;
	    if (this.hasLabel) {
	      label = this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	
	    return h(
	      'el-form-item',
	      {
	        attrs: { error: this.error, label: label }
	      },
	      [cascader]
	    );
	  }
	};

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    type: {
	      type: String,
	      required: false
	    },
	
	    value: {
	      required: false,
	      default: false
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    insideForm: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  methods: {
	    onChange: function onChange(name) {
	      var _this = this;
	
	      return function (checked) {
	        _this.$emit('change', name, checked);
	      };
	    }
	  },
	
	  render: function render(h) {
	    var label = this.translation ? this.$t(this.translation + '.placeholder') : this.name;
	    if (label !== this.name && this.type === 'term') {
	      var openAnchorStart = label.search('<a');
	      var openAnchorEnd = label.search('>');
	      var closingAnchor = label.search('</a>');
	      var hrefStart = label.indexOf('href="');
	      var hrefEnd = label.indexOf('"', hrefStart + 6);
	      label = [label.slice(0, openAnchorStart), h(
	        'a',
	        {
	          attrs: { target: '_blank', href: label.slice(hrefStart + 6, hrefEnd) }
	        },
	        [label.slice(openAnchorEnd + 1, closingAnchor)]
	      ), label.slice(closingAnchor + 4)];
	    }
	
	    var input = [h('el-checkbox', {
	      attrs: {
	        value: !!this.value,
	
	        name: this.name,
	        disabled: this.disabled
	      },
	      on: {
	        'change': this.onChange(this.name)
	      }
	    }), h('span', ['\xA0', label])];
	
	    if (!this.insideForm) {
	      return input;
	    }
	
	    var groupLabel = null;
	    if (this.hasLabel) {
	      groupLabel = this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	
	    return h(
	      'el-form-item',
	      {
	        attrs: {
	          error: this.error,
	          label: groupLabel
	        }
	      },
	      [input]
	    );
	  }
	};

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      val: []
	    };
	  },
	
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    type: {
	      type: String,
	      required: false
	    },
	
	    value: {
	      required: false,
	      default: []
	    },
	
	    options: {
	      type: Array,
	      required: false,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    insideForm: {
	      type: Boolean,
	      required: false,
	      default: false
	    }
	  },
	
	  methods: {
	    onInput: function onInput(name) {
	      var _this = this;
	
	      return function (value) {
	        _this.$emit("change", name, value);
	      };
	    }
	  },
	
	  render: function render(h) {
	    var _this2 = this;
	
	    var value = this.value;
	    if (typeof this.value === "string" && this.value === "") {
	      value = [];
	    }
	    var options = Object.keys(this.options).map(function (k) {
	      return h("el-checkbox", {
	        attrs: {
	          value: _this2.options[k].id.toString(),
	          label: _this2.options[k].name.toString()
	        }
	      });
	    });
	
	    var checkboxGroup = h(
	      "el-checkbox-group",
	      {
	        attrs: {
	          value: value,
	          loading: this.loading,
	          disabled: this.disabled
	        },
	        on: {
	          "input": this.onInput(this.name)
	        }
	      },
	      [options]
	    );
	
	    if (!this.insideForm) {
	      return checkboxGroup;
	    }
	
	    var label = null;
	    if (this.hasLabel) {
	      label = this.translation ? this.$t(this.translation + ".label") : this.name;
	    }
	
	    return h(
	      "el-form-item",
	      {
	        attrs: { error: this.error, label: label }
	      },
	      [checkboxGroup]
	    );
	  }
	};

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    value: {
	      type: [String, Date],
	      required: false,
	      default: ''
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    insideForm: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	
	    datePickerOptions: {
	      type: Object,
	      required: false,
	      default: function _default() {}
	    }
	
	  },
	
	  methods: {
	    onInput: function onInput(name) {
	      var _this = this;
	
	      return function (value) {
	        _this.$emit('change', name, value);
	      };
	    }
	  },
	
	  render: function render(h) {
	    var datePickerOptions = this.datePickerOptions || {};
	    datePickerOptions.firstDayOfWeek = 1;
	    var input = h('el-date-picker', {
	      attrs: {
	        value: this.value,
	
	        editable: false,
	        type: 'date',
	        disabled: this.disabled,
	        placeholder: this.translation ? this.$t(this.translation + '.placeholder') : this.name,
	        name: this.name,
	        format: 'dd-MM-yyyy',
	        'value-format': 'yyyy-MM-dd',
	        'picker-options': datePickerOptions
	      },
	      on: {
	        'input': this.onInput(this.name)
	      }
	    });
	
	    if (!this.insideForm) {
	      return input;
	    }
	
	    var label = null;
	    if (this.hasLabel) {
	      label = this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	
	    return h(
	      'el-form-item',
	      {
	        attrs: {
	          error: this.error,
	          label: label
	        }
	      },
	      [input]
	    );
	  }
	};

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    value: {
	      type: Array,
	      required: false,
	      default: ''
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    insideForm: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  methods: {
	    onInput: function onInput(name) {
	      var _this = this;
	
	      return function (value) {
	        _this.$emit('change', name, value);
	      };
	    }
	  },
	
	  render: function render(h) {
	    var input = h('el-date-picker', {
	      attrs: {
	        value: this.value,
	
	        editable: false,
	        type: 'daterange',
	        disabled: this.disabled,
	        'start-placeholder': this.translation ? this.$t(this.translation + '.placeholderStart') : this.name,
	        'end-placeholder': this.translation ? this.$t(this.translation + '.placeholderEnd') : this.name,
	        name: this.name,
	        format: 'dd-MM-yyyy',
	        'unlink-panels': true
	      },
	      on: {
	        'input': this.onInput(this.name)
	      }
	    });
	
	    if (!this.insideForm) {
	      return input;
	    }
	
	    var label = null;
	    if (this.hasLabel) {
	      label = this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	
	    return h(
	      'el-form-item',
	      {
	        attrs: {
	          error: this.error,
	          label: label
	        }
	      },
	      [input]
	    );
	  }
	};

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue2Editor = __webpack_require__(3147);
	
	var DirectionAttribute = _vue2Editor.Quill.import('attributors/attribute/direction');
	var AlignClass = _vue2Editor.Quill.import('attributors/class/align');
	var BackgroundClass = _vue2Editor.Quill.import('attributors/class/background');
	var ColorClass = _vue2Editor.Quill.import('attributors/class/color');
	var DirectionClass = _vue2Editor.Quill.import('attributors/class/direction');
	var FontClass = _vue2Editor.Quill.import('attributors/class/font');
	var SizeClass = _vue2Editor.Quill.import('attributors/class/size');
	var AlignStyle = _vue2Editor.Quill.import('attributors/style/align');
	var BackgroundStyle = _vue2Editor.Quill.import('attributors/style/background');
	var ColorStyle = _vue2Editor.Quill.import('attributors/style/color');
	var DirectionStyle = _vue2Editor.Quill.import('attributors/style/direction');
	var FontStyle = _vue2Editor.Quill.import('attributors/style/font');
	var SizeStyle = _vue2Editor.Quill.import('attributors/style/size');
	
	_vue2Editor.Quill.register(DirectionAttribute, true);
	_vue2Editor.Quill.register(AlignClass, true);
	_vue2Editor.Quill.register(BackgroundClass, true);
	_vue2Editor.Quill.register(ColorClass, true);
	_vue2Editor.Quill.register(DirectionClass, true);
	_vue2Editor.Quill.register(FontClass, true);
	_vue2Editor.Quill.register(SizeClass, true);
	_vue2Editor.Quill.register(AlignStyle, true);
	_vue2Editor.Quill.register(BackgroundStyle, true);
	_vue2Editor.Quill.register(ColorStyle, true);
	_vue2Editor.Quill.register(DirectionStyle, true);
	_vue2Editor.Quill.register(FontStyle, true);
	_vue2Editor.Quill.register(SizeStyle, true);
	
	exports.default = {
	  components: {
	    VueEditor: _vue2Editor.VueEditor
	  },
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    value: {
	      type: [String],
	      required: false,
	      default: ''
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	
	    clearable: {
	      type: Boolean,
	      default: false
	    }
	
	  },
	
	  methods: {
	    onInput: function onInput(name) {
	      var _this = this;
	
	      return function (value) {
	        _this.$emit('keydown', name, value);
	      };
	    }
	  },
	
	  render: function render(h) {
	    var editor = h('vue-editor', {
	      attrs: {
	        value: this.value ? this.value.toString() : '',
	
	        disabled: this.disabled,
	        placeholder: this.translation ? this.$t(this.translation + '.placeholder') : this.name,
	        name: this.name },
	      on: {
	        'input': this.onInput(this.name)
	      }
	    });
	
	    var label = null;
	    if (this.hasLabel) {
	      label = this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	
	    return h(
	      'el-form-item',
	      {
	        attrs: {
	          error: this.error,
	          label: label
	        },
	        'class': this.name
	      },
	      [editor]
	    );
	  }
	};

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    value: {
	      type: [String, Number],
	      required: false,
	      default: ''
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    insideForm: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  methods: {
	    onInput: function onInput(name) {
	      var _this = this;
	
	      return function (value) {
	        _this.$emit('keydown', name, value);
	      };
	    },
	    toFloat: function toFloat(number) {
	      return parseFloat(number.replace(/\s/g, '').replace(/,(\d+)$/, '.$1'));
	    },
	    formatOnDecimalInput: function formatOnDecimalInput(e) {
	      var name = e.target.name;
	      var value = e.target.value.toString();
	
	      var newValue = value.replace(/[^-?0-9,.]/g, '');
	      var count = (newValue.match(/,/g) || []).length;
	
	      var finalValue = newValue;
	      for (var i = 0; i < count - 1; i += 1) {
	        finalValue = finalValue.replace(/,/, '');
	      }
	
	      e.target.value = finalValue;
	      this.$emit('keydown', name, finalValue.replace(/,/g, '.'));
	    }
	  },
	
	  render: function render(h) {
	    this.$emit('keydown', this.name, this.value.toString().replace(/,/g, '.'));
	    var input = h(
	      'div',
	      {
	        style: { width: '100%' },
	        on: {
	          'keyup': this.formatOnDecimalInput
	        }
	      },
	      [h('el-input', {
	        attrs: {
	          value: this.value.toString().replace(/\./g, ','),
	          disabled: this.disabled,
	          type: 'text',
	          placeholder: this.translation ? this.$t(this.translation + '.placeholder') : this.name,
	          name: this.name
	        }
	      })]
	    );
	
	    if (!this.insideForm) {
	      return input;
	    }
	
	    var label = null;
	    if (this.hasLabel) {
	      label = this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	
	    return h(
	      'el-form-item',
	      {
	        attrs: {
	          error: this.error,
	          label: label
	        }
	      },
	      [input]
	    );
	  }
	};

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _babelHelperVueJsxMergeProps = __webpack_require__(225);
	
	var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);
	
	var _text = __webpack_require__(182);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _number = __webpack_require__(414);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _cascader = __webpack_require__(2703);
	
	var _cascader2 = _interopRequireDefault(_cascader);
	
	var _checkbox = __webpack_require__(2704);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _image = __webpack_require__(2707);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _message = __webpack_require__(13);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _date = __webpack_require__(412);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _dateRange = __webpack_require__(156);
	
	var _dateRange2 = _interopRequireDefault(_dateRange);
	
	var _time = __webpack_require__(416);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _autocomplete = __webpack_require__(411);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _plaintext = __webpack_require__(415);
	
	var _plaintext2 = _interopRequireDefault(_plaintext);
	
	var _editor = __webpack_require__(2706);
	
	var _editor2 = _interopRequireDefault(_editor);
	
	var _float = __webpack_require__(413);
	
	var _float2 = _interopRequireDefault(_float);
	
	var _switch = __webpack_require__(2710);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _checkboxGroup = __webpack_require__(2705);
	
	var _checkboxGroup2 = _interopRequireDefault(_checkboxGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inputs = ['text', 'textarea', 'email', 'password'];
	
	exports.default = {
	  props: {
	    form: {
	      type: Object,
	      required: true
	    },
	
	    save: {
	      type: Function,
	      required: false
	    },
	
	    btnText: {
	      type: String,
	      required: false,
	      default: 'button.save'
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    labelPosition: {
	      type: String,
	      required: false,
	      default: 'left'
	    },
	
	    labelWidth: {
	      type: String,
	      required: false,
	      default: '180px'
	    },
	
	    inline: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    information: {
	      type: String,
	      required: false
	    },
	
	    imageRemove: {
	      type: Function,
	      required: false
	    }
	  },
	
	  methods: {
	    onFormChange: function onFormChange(name, value) {
	      this.form.clearSuccess(name, value);
	      this.form.clearErrors(name);
	      this.form[name] = value;
	      this.$emit('form-change', name);
	    },
	    onFormKeydown: function onFormKeydown(name, value) {
	      this.form.clearSuccess(name, value);
	      this.form.clearErrors(name);
	      this.form[name] = value;
	      this.$emit('form-keydown', name);
	    },
	    submit: function submit(e) {
	      e.preventDefault();
	      this.save();
	    }
	  },
	
	  render: function render(h) {
	    var _this = this;
	
	    var fields = Object.keys(this.form.fields).map(function (field) {
	      var formInput = null;
	      var props = {
	        error: _this.form.errors.get(field),
	        hasLabel: _this.hasLabel,
	        value: _this.form[field],
	        insideForm: true,
	        name: field,
	        displays: _this.form.displays[field],
	        disabled: _this.form.isDisabled(field),
	        translation: _this.translation ? _this.translation + '.' + field : null
	      };
	      props = Object.assign(props, _this.form.getExtraAttr(field));
	
	      if (_this.form.isHidden(field)) {
	        return null;
	      }
	
	      if (inputs.indexOf(_this.form.fields[field]) >= 0) {
	        formInput = h(_text2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          on: {
	            'keydown': _this.onFormKeydown
	          },
	          attrs: {
	            type: _this.form.fields[field]
	          }
	        }, { props: props }]));
	      } else if (_this.form.fields[field] === 'number') {
	        formInput = h(_number2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          on: {
	            'keydown': _this.onFormKeydown
	          },
	          attrs: {
	            type: _this.form.fields[field]
	          }
	        }, { props: props }]));
	      } else if (_this.form.fields[field] === 'float') {
	        formInput = h(_float2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          on: {
	            'keydown': _this.onFormKeydown
	          },
	          attrs: {
	            type: _this.form.fields[field]
	          }
	        }, { props: props }]));
	      } else if (_this.form.fields[field] === 'select') {
	        formInput = h(_select2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          ref: field,
	          attrs: { quickForm: _this.form.quickForms[field],
	
	            options: _this.form.options[field]
	          },
	          on: {
	            'change': _this.onFormChange
	          }
	        }, { props: props }]));
	      } else if (_this.form.fields[field] === 'checkboxGroup') {
	        formInput = h(_checkboxGroup2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          on: {
	            'change': _this.onFormChange
	          },
	          attrs: {
	            options: _this.form.options[field]
	          }
	        }, { props: props }]));
	      } else if (_this.form.fields[field] === 'cascader') {
	        formInput = h(_cascader2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          on: {
	            'change': _this.onFormChange
	          },
	          attrs: {
	            options: _this.form.options[field]
	          }
	        }, { props: props }]));
	      } else if (_this.form.fields[field] === 'checkbox' || _this.form.fields[field] === 'term') {
	        formInput = h(_checkbox2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          on: {
	            'change': _this.onFormChange
	          },
	          attrs: {
	            type: _this.form.fields[field]
	          }
	        }, { props: props }]));
	      } else if (_this.form.fields[field] === 'switch') {
	        formInput = h(_switch2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          on: {
	            'change': _this.onFormChange
	          },
	          attrs: {
	            type: _this.form.fields[field]
	          }
	        }, { props: props }]));
	      } else if (_this.form.fields[field] === 'file') {
	        formInput = h(_image2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          on: {
	            'imageCreated': _this.onFormChange,
	            'imageChanged': _this.onFormChange
	          },
	          attrs: {
	            imageRemove: _this.imageRemove
	          }
	        }, { props: props }]));
	      } else if (_this.form.fields[field] === 'date') {
	        formInput = h(_date2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          on: {
	            'change': _this.onFormKeydown
	          }
	        }, { props: props }]));
	      } else if (_this.form.fields[field] === 'dateRange') {
	        formInput = h(_dateRange2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          on: {
	            'change': _this.onFormKeydown
	          }
	        }, { props: props }]));
	      } else if (_this.form.fields[field] === 'time') {
	        formInput = h(_time2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          on: {
	            'keydown': _this.onFormKeydown
	          }
	        }, { props: props }]));
	      } else if (_this.form.fields[field] === 'autocomplete') {
	        formInput = h(_autocomplete2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          attrs: {
	            quickForm: _this.form.quickForms[field],
	
	            info: _this.form.displays[field],
	            options: _this.form.options[field]
	          },
	          on: {
	            'keydown': _this.onFormKeydown
	          }
	        }, { props: props }]));
	      } else if (_this.form.fields[field] === 'plaintext') {
	        formInput = h(_plaintext2.default, {
	          attrs: { name: field, value: _this.form[field] }
	        });
	      } else if (_this.form.fields[field] === 'editor') {
	        formInput = h(_editor2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          on: {
	            'keydown': _this.onFormKeydown
	          },
	          attrs: {
	            name: field,
	            value: _this.form[field]
	          }
	        }, { props: props }]));
	      } else if (_this.form.fields[field] === 'div') {
	        formInput = h(
	          'el-form-item',
	          {
	            attrs: {
	              label: _this.$t(props.translation + '.label')
	            },
	            'class': field },
	          [h(
	            'div',
	            { 'class': field + '-inner' },
	            [_this.form[field]]
	          )]
	        );
	      }
	      if (_this.form.tooltips[field]) {
	        var tooltipTextLines = _this.form.tooltips[field].text.split('<br/>');
	        var tooltipText = [];
	        tooltipTextLines.map(function (l) {
	          tooltipText.push(l);
	          tooltipText.push(h('br'));
	          return l;
	        });
	        formInput = h(
	          'el-tooltip',
	          {
	            attrs: { placement: _this.form.tooltips[field].placement }
	          },
	          [h(
	            'div',
	            { slot: 'content' },
	            [tooltipText]
	          ), formInput]
	        );
	      }
	      return formInput;
	    });
	    fields = fields.filter(function (f) {
	      return f;
	    });
	
	    var labelWidth = null;
	    if (this.hasLabel && (this.labelPosition === 'right' || this.labelPosition === 'left')) {
	      labelWidth = this.labelWidth;
	    }
	
	    var information = this.information ? h(
	      'el-alert',
	      {
	        attrs: { title: '', type: 'info', closable: false, 'show-icon': true },
	        'class': 'margin-20' },
	      [h('slot', {
	        attrs: { name: 'title' },
	        domProps: {
	          'innerHTML': this.information
	        }
	      })]
	    ) : '';
	
	    var btn = this.save ? h(
	      'el-button',
	      {
	        on: {
	          'click': this.submit
	        },
	        attrs: {
	          disabled: this.form.loading,
	          loading: this.form.loading
	        }
	      },
	      [this.$t(this.btnText)]
	    ) : null;
	
	    return h(
	      'el-form',
	      {
	        attrs: {
	          labelPosition: this.labelPosition,
	          labelWidth: labelWidth,
	          inline: this.inline
	        }
	      },
	      [information, fields, btn, h(_message2.default, {
	        attrs: {
	          success: this.form.successMessage,
	          error: this.form.errors.get('error')
	        }
	      })]
	    );
	  }
	};

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    value: {
	      type: Object,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    insideForm: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    imageRemove: {
	      type: Function,
	      required: false
	    }
	
	  },
	
	  methods: {
	    onFileChange: function onFileChange(e) {
	      var files = e;
	      if (!files) {
	        return;
	      }
	      this.$set(this.value, 'file', files);
	
	      this.createImage(files);
	    },
	    createImage: function createImage(file) {
	      var _this = this;
	
	      var reader = new FileReader();
	      reader.onload = function (e) {
	        _this.$set(_this.value, 'url', e.target.result);
	      };
	
	      reader.readAsDataURL(file);
	      this.$emit('images-created', this.name, this.value);
	    },
	    removeImage: function removeImage(e) {
	      var _this2 = this;
	
	      this.$confirm(this.$t('static.products.delete.imageConfirm'), this.$t('static.products.delete.title'), {
	        confirmButtonText: 'OK',
	        cancelButtonText: 'Cancel',
	        type: 'warning'
	      }).then(function () {
	        e.preventDefault();
	        _this2.value.url = '';
	        delete _this2.value.file;
	        _this2.imageRemove();
	      }).catch(function () {});
	    },
	    changeImage: function changeImage(e) {
	      e.preventDefault();
	      this.value.url = '';
	      delete this.value.file;
	      this.$emit('image-changed', this.name, this.value);
	    },
	    previewImage: function previewImage(e) {
	      e.preventDefault();
	      window.open(this.value.url, '_blank');
	    }
	  },
	
	  render: function render(h) {
	    var input = void 0;
	    if (!this.value.url) {
	      input = h(
	        'div',
	        { 'class': 'el-form-item' },
	        [h(
	          'el-upload',
	          {
	            attrs: { drag: true, action: '#', beforeUpload: this.onFileChange }
	          },
	          [h('i', { 'class': 'el-icon-upload' }), h(
	            'div',
	            { 'class': 'el-upload__text' },
	            [this.translation ? this.$t(this.translation + '.placeholder') : this.name]
	          ), h(
	            'div',
	            { 'class': 'el-upload__tip', slot: 'tip' },
	            ['jpg/png files with a size less than 500kb']
	          )]
	        )]
	      );
	    } else {
	      input = h(
	        'div',
	        { 'class': 'flex end wrap' },
	        [h(
	          'div',
	          { 'class': 'imageWrapper', on: {
	              'click': this.previewImage
	            }
	          },
	          [h('img', {
	            attrs: { src: this.value.url || this.value.file }
	          })]
	        ), h(
	          'div',
	          { style: 'display:flex;flex-direction:column;' },
	          [this.imageRemove ? h(
	            'el-button',
	            {
	              style: 'margin-left: 10px;',
	              'class': 'el-button--default small imageInputButton',
	              on: {
	                'click': this.removeImage
	              }
	            },
	            [this.translation ? this.$t(this.translation + '.removeImage') : this.name]
	          ) : '', h(
	            'el-button',
	            {
	              'class': 'el-button--default small imageInputButton',
	              on: {
	                'click': this.changeImage
	              }
	            },
	            [this.translation ? this.$t(this.translation + '.changeImage') : this.name]
	          )]
	        )]
	      );
	    }
	
	    if (!this.insideForm) {
	      return input;
	    }
	
	    var label = null;
	    if (this.hasLabel) {
	      label = this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	
	    return h(
	      'el-form-item',
	      {
	        attrs: { error: this.error, label: label }
	      },
	      [input]
	    );
	  }
	};

/***/ }),
/* 1795 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    value: {
	      type: String,
	      required: false,
	      default: ''
	    },
	
	    href: {
	      type: String,
	      required: true,
	      default: '#'
	    },
	
	    target: {
	      type: String,
	      required: false,
	      default: '_self'
	    },
	
	    fieldClass: {
	      type: String,
	      required: false,
	      default: 'link-in-table'
	    },
	
	    linkIcon: {
	      type: String,
	      required: false,
	      default: 'fa fa-link'
	    },
	
	    fieldDisable: {
	      type: Boolean,
	      required: false,
	      default: false
	    }
	
	  },
	
	  render: function render(h) {
	    if (this.fieldDisable === true) return h(
	      'p',
	      { style: 'cursor:context-menu;', 'class': this.fieldClass },
	      [h('i', { 'class': this.linkIcon }), ' ', this.value]
	    );else return h(
	      'a',
	      { style: 'cursor:cursor;', attrs: { href: this.href, target: this.target },
	        'class': this.fieldClass },
	      [h('i', { 'class': this.linkIcon }), ' ', this.value]
	    );
	  }
	};

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    success: {
	      type: String,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    warning: {
	      type: String,
	      required: false
	    },
	
	    info: {
	      type: String,
	      required: false
	    },
	
	    customClass: {
	      type: String,
	      required: false
	    }
	  },
	
	  computed: {
	    type: function type() {
	      if (this.success) {
	        return 'success';
	      } else if (this.error) {
	        return 'error';
	      }if (this.info) {
	        return 'info';
	      }
	      return 'warning';
	    }
	  }
	};

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    value: {
	      required: false,
	      default: ''
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    insideForm: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	
	    placeholder: {
	      type: String,
	      default: ''
	    }
	  },
	
	  methods: {
	    onInput: function onInput(name) {
	      var _this = this;
	
	      return function (value) {
	        _this.$emit('change', name, value);
	      };
	    }
	  },
	
	  render: function render(h) {
	    var input = h('el-date-picker', {
	      attrs: {
	        value: this.value,
	
	        editable: false,
	        type: 'month',
	        disabled: this.disabled,
	        name: this.name,
	        'unlink-panels': true,
	        placeholder: this.$t('' + this.placeholder)
	      },
	      on: {
	        'input': this.onInput(this.name)
	      }
	    });
	
	    if (!this.insideForm) {
	      return input;
	    }
	
	    var label = null;
	    if (this.hasLabel) {
	      label = this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	
	    return h(
	      'el-form-item',
	      {
	        attrs: {
	          error: this.error,
	          label: label
	        }
	      },
	      [input]
	    );
	  }
	};

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    value: {
	      required: false,
	      default: ''
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    insideForm: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    controls: {
	      type: Boolean,
	      required: false,
	      default: true
	    },
	
	    max: {
	      type: Number,
	      required: false,
	      default: undefined
	    },
	
	    min: {
	      type: Number,
	      required: false,
	      default: undefined
	    },
	
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  methods: {
	    onInput: function onInput(name) {
	      var _this = this;
	
	      return function (value) {
	        _this.$emit('keydown', name, value);
	      };
	    }
	  },
	
	  render: function render(h) {
	    var input = h('el-input-number', {
	      attrs: {
	        value: this.value,
	        step: 1.00,
	        controls: this.controls,
	        disabled: this.disabled,
	
	        placeholder: this.translation ? this.$t(this.translation + '.placeholder') : this.name,
	        name: this.name,
	        min: this.min,
	        max: this.max
	      },
	      on: {
	        'input': this.onInput(this.name)
	      }
	    });
	
	    if (!this.insideForm) {
	      return input;
	    }
	
	    var label = null;
	    if (this.hasLabel) {
	      label = this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	
	    return h(
	      'el-form-item',
	      {
	        attrs: {
	          error: this.error,
	          label: label
	        }
	      },
	      [input]
	    );
	  }
	};

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    value: {
	      type: String,
	      required: false,
	      default: ''
	    }
	  },
	
	  render: function render(h) {
	    return h('p', [this.value]);
	  }
	};

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    value: {
	      required: false,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    options: {
	      type: Array,
	      required: false,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    insideForm: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    multiple: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	
	    filterable: {
	      type: Boolean,
	      default: true
	    },
	
	    remote: {
	      type: Boolean,
	      default: false
	    },
	
	    remoteMethod: {
	      type: Function,
	      required: false,
	      default: function _default() {}
	    },
	
	    loading: {
	      type: Boolean,
	      default: false
	    },
	
	    quickForm: {
	      type: Object,
	      required: false
	    },
	    hasButton: {
	      type: Boolean,
	      default: false,
	      required: false
	    },
	    buttonHandler: {
	      type: Function,
	      default: function _default() {},
	      required: false
	    },
	    buttonLabel: {
	      type: String,
	      required: false
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    onInput: function onInput(name) {
	      var _this = this;
	
	      return function (value) {
	        _this.$emit('change', name, value);
	      };
	    },
	    onQuickFormClick: function onQuickFormClick() {
	      this.setModalContent(this.quickForm);
	      this.toggleModal(true);
	    }
	  }),
	
	  render: function render(h) {
	    var _this2 = this;
	
	    var value = this.multiple === true && this.value === '' ? [] : this.value;
	    if (_typeof(this.value) !== 'object' && this.value !== '') {
	      value = value.toString();
	    }
	
	    var options = Object.keys(this.options).map(function (k) {
	      return h('el-option', {
	        attrs: {
	          value: _this2.options[k].id.toString(),
	          label: _this2.options[k].name.toString(),
	          disabled: _this2.options[k].disabled
	        },
	        key: _this2.options[k].id
	      });
	    });
	
	    var select = h(
	      'el-select',
	      {
	        ref: this.name,
	        attrs: { value: value,
	          loading: this.loading,
	          filterable: this.filterable,
	          disabled: this.disabled,
	
	          name: this.name,
	          multiple: this.multiple,
	          remote: this.remote,
	          remoteMethod: this.remoteMethod,
	          placeholder: this.translation ? this.$t(this.translation + '.placeholder') : this.name
	        },
	        on: {
	          'input': this.onInput(this.name)
	        }
	      },
	      [options]
	    );
	
	    if (!this.insideForm) {
	      return select;
	    }
	
	    var label = null;
	    if (this.label) {
	      label = this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	    if (this.hasLabel) {
	      label = this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	
	    return h(
	      'el-form-item',
	      {
	        attrs: {
	          error: this.error,
	          label: label
	        }
	      },
	      [select, this.hasButton ? h(
	        'el-button',
	        {
	          on: {
	            'click': this.buttonHandler
	          },
	          'class': 'small', style: 'margin-left:5px' },
	        [this.buttonLabel]
	      ) : null, this.quickForm ? h('el-button', {
	        on: {
	          'click': this.onQuickFormClick
	        },
	        attrs: {
	          icon: 'el-icon-plus'
	        },
	        'class': 'small',
	        style: 'margin-left:5px'
	      }) : null]
	    );
	  }
	};

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    type: {
	      type: String,
	      required: false
	    },
	
	    value: {
	      required: false,
	      default: false
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    insideForm: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	
	  },
	
	  methods: {
	    onChange: function onChange(name) {
	      var _this = this;
	
	      return function (checked) {
	        _this.$emit('change', name, checked);
	      };
	    }
	  },
	
	  render: function render(h) {
	    var label = this.translation ? this.$t(this.translation + '.placeholder') : this.name;
	    if (label !== this.name && this.type === 'term') {
	      var openAnchorStart = label.search('<a');
	      var openAnchorEnd = label.search('>');
	      var closingAnchor = label.search('</a>');
	      var hrefStart = label.indexOf('href="');
	      var hrefEnd = label.indexOf('"', hrefStart + 6);
	      label = [label.slice(0, openAnchorStart), h(
	        'a',
	        {
	          attrs: { target: '_blank', href: label.slice(hrefStart + 6, hrefEnd) }
	        },
	        [label.slice(openAnchorEnd + 1, closingAnchor)]
	      ), label.slice(closingAnchor + 4)];
	    }
	
	    var input = [h('el-switch', {
	      attrs: {
	        value: !!this.value,
	
	        name: this.name,
	        disabled: this.disabled
	      },
	      on: {
	        'change': this.onChange(this.name)
	      }
	    }), h('span', ['\xA0', label])];
	
	    if (!this.insideForm) {
	      return input;
	    }
	
	    var groupLabel = null;
	    if (this.hasLabel) {
	      groupLabel = this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	
	    return h(
	      'el-form-item',
	      {
	        attrs: {
	          error: this.error,
	          label: groupLabel
	        },
	        'class': this.name
	      },
	      [input]
	    );
	  }
	};

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    type: {
	      type: String,
	      required: true
	    },
	
	    value: {
	      type: [String, Number],
	      required: false,
	      default: ''
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    insideForm: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	
	    clearable: {
	      type: Boolean,
	      default: false
	    },
	
	    maxlength: {
	      type: Number,
	      required: false,
	      default: undefined
	    },
	    hasButton: {
	      type: Boolean,
	      default: false,
	      required: false
	    },
	    buttonHandler: {
	      type: Function,
	      default: function _default() {},
	      required: false
	    },
	    buttonLabel: {
	      type: String,
	      required: false
	    },
	    hasButton2: {
	      type: Boolean,
	      default: false,
	      required: false
	    },
	    buttonHandler2: {
	      type: Function,
	      default: function _default() {},
	      required: false
	    },
	    buttonLabel2: {
	      type: String,
	      required: false
	    }
	  },
	
	  methods: {
	    onInput: function onInput(name) {
	      var _this = this;
	
	      return function (value) {
	        _this.$emit('keydown', name, value);
	      };
	    }
	  },
	
	  render: function render(h) {
	    var autosize = null;
	    if (this.type === 'textarea') {
	      autosize = { minRows: 4 };
	    }
	
	    var input = h('el-input', {
	      attrs: {
	        value: this.value ? this.value.toString() : '',
	        autosize: autosize,
	        disabled: this.disabled,
	
	        type: this.type,
	        placeholder: this.translation ? this.$t(this.translation + '.placeholder') : this.name,
	        name: this.name,
	        maxlength: this.maxlength,
	        clearable: this.clearable
	
	      },
	      on: {
	        'input': this.onInput(this.name)
	      }
	    });
	    var button = '';
	    var button2 = '';
	
	    if (this.hasButton) {
	      button = h(
	        'el-button',
	        {
	          on: {
	            'click': this.buttonHandler
	          },
	          'class': 'small', style: 'margin-left:5px' },
	        [' ', this.buttonLabel]
	      );
	    }
	    if (this.hasButton2) {
	      button2 = h(
	        'el-button',
	        {
	          on: {
	            'click': this.buttonHandler2
	          },
	          'class': 'small', style: 'margin-left:5px' },
	        [' ', this.buttonLabel2]
	      );
	    }
	    if (!this.insideForm) {
	      return input;
	    }
	
	    var label = null;
	    if (this.hasLabel) {
	      label = this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	
	    return h(
	      'el-form-item',
	      {
	        attrs: {
	          error: this.error,
	          label: label
	        },
	        'class': this.name
	      },
	      [input, button, button2]
	    );
	  }
	};

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	
	    value: {
	      type: String,
	      required: false,
	      default: ''
	    },
	
	    translation: {
	      type: String,
	      required: false
	    },
	
	    hasLabel: {
	      type: Boolean,
	      required: false
	    },
	
	    error: {
	      type: String,
	      required: false
	    },
	
	    insideForm: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    minTime: {
	      type: String,
	      required: false,
	      default: ''
	    },
	
	    isRange: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  methods: {
	    onInput: function onInput(name) {
	      var _this = this;
	
	      return function (value) {
	        _this.$emit('keydown', name, value);
	      };
	    }
	  },
	
	  render: function render(h) {
	    var input = h('el-time-select', {
	      attrs: {
	        value: this.value,
	
	        editable: false,
	        disabled: this.disabled,
	
	        placeholder: this.translation ? this.$t(this.translation + '.placeholder') : this.name,
	        name: this.name,
	        isRange: this.isRange,
	        pickerOptions: {
	          start: '07:00',
	          step: '00:10',
	          end: '23:50',
	          minTime: this.minTime
	        }
	      },
	      style: { width: 'auto' }, on: {
	        'input': this.onInput(this.name)
	      }
	    });
	
	    if (!this.insideForm) {
	      return input;
	    }
	
	    var label = null;
	    if (this.hasLabel) {
	      label = this.translation ? this.$t(this.translation + '.label') : this.name;
	    }
	
	    return h(
	      'el-form-item',
	      {
	        attrs: {
	          error: this.error,
	          label: label
	        }
	      },
	      [input]
	    );
	  }
	};

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _babelHelperVueJsxMergeProps = __webpack_require__(225);
	
	var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _vuex = __webpack_require__(5);
	
	var _text = __webpack_require__(182);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _autocomplete = __webpack_require__(411);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _number = __webpack_require__(414);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _float = __webpack_require__(413);
	
	var _float2 = _interopRequireDefault(_float);
	
	var _date = __webpack_require__(412);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _time = __webpack_require__(416);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _select = __webpack_require__(51);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _dateRange = __webpack_require__(156);
	
	var _dateRange2 = _interopRequireDefault(_dateRange);
	
	var _plaintext = __webpack_require__(415);
	
	var _plaintext2 = _interopRequireDefault(_plaintext);
	
	var _link = __webpack_require__(2708);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _vueFilepond = __webpack_require__(2660);
	
	var _vueFilepond2 = _interopRequireDefault(_vueFilepond);
	
	__webpack_require__(2262);
	
	__webpack_require__(2261);
	
	var _filepondPluginFileValidateType = __webpack_require__(2407);
	
	var _filepondPluginFileValidateType2 = _interopRequireDefault(_filepondPluginFileValidateType);
	
	var _filepondPluginFileValidateSize = __webpack_require__(2406);
	
	var _filepondPluginFileValidateSize2 = _interopRequireDefault(_filepondPluginFileValidateSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilePond = (0, _vueFilepond2.default)(_filepondPluginFileValidateType2.default, _filepondPluginFileValidateSize2.default);
	var components = {
	  text: _text2.default,
	  autocomplete: _autocomplete2.default,
	  date: _date2.default,
	  dateRange: _dateRange2.default,
	  time: _time2.default,
	  number: _number2.default,
	  select: _select2.default,
	  plaintext: _plaintext2.default,
	  float: _float2.default,
	  link: _link2.default,
	  default: _plaintext2.default
	};
	
	exports.default = {
	  data: function data() {
	    return {
	      addingItem: false,
	      editingItem: 0,
	      currentIndex: null
	    };
	  },
	
	
	  props: {
	    list: {
	      type: Array,
	      required: true
	    },
	
	    form: {
	      type: Object,
	      required: true
	    },
	
	    create: {
	      type: Function,
	      required: false
	    },
	
	    update: {
	      type: Function,
	      required: false
	    },
	
	    destroy: {
	      type: Function,
	      required: false
	    },
	
	    translation: {
	      type: String,
	      required: true
	    },
	
	    noResultWarningText: {
	      type: String,
	      required: false
	    },
	
	    hiddenFields: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    columnWidths: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	
	    disabledRows: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    disableForm: {
	      type: Boolean,
	      default: false
	    },
	
	    stack: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	
	    clickHandler: {
	      type: Function,
	      default: function _default() {
	        return false;
	      }
	    },
	
	    clickHandlerIcon: {
	      type: String,
	      default: 'fa fa-pencil-square-o'
	    },
	
	    additionalButtons: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    tagHandler: {
	      type: Function,
	      default: function _default() {
	        return false;
	      }
	    },
	
	    isEdi: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    additionalInfos: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    isImport: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	    importClickHandler: {
	      type: Function,
	      default: function _default() {
	        return false;
	      }
	    },
	    isExport: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    exportClickHandler: {
	      type: Function,
	      default: function _default() {
	        return false;
	      }
	    },
	
	    server: {
	      type: Object,
	      required: false,
	      default: function _default() {
	        return {};
	      }
	    },
	
	    sortableFields: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    sortField: {
	      type: String,
	      default: ''
	    },
	
	    sortDirection: {
	      type: String,
	      default: 'asc'
	    },
	
	    extraColumnHeaderLabel: {
	      type: String,
	      default: ''
	    }
	  },
	
	  methods: {
	    isStacked: function isStacked(field) {
	      var _this = this;
	
	      return Object.keys(this.stack).filter(function (k) {
	        return _this.stack[k] === field;
	      }).length;
	    },
	    addNewItem: function addNewItem() {
	      this.closeEditForm();
	      this.addingItem = true;
	    },
	    editItem: function editItem(item, index) {
	      this.currentIndex = index;
	      this.closeAddForm();
	      this.editingItem = item.id;
	      this.form.assignData(item);
	      if (this.isEdi) {
	        this.form.setFieldValue('quantityConfirmed', item.quantityOrdered);
	      }
	    },
	    closeEditForm: function closeEditForm() {
	      this.editingItem = 0;
	      this.form.resetValues();
	    },
	    closeAddForm: function closeAddForm() {
	      this.addingItem = false;
	      this.form.resetValues();
	    },
	    closeForm: function closeForm() {
	      this.currentIndex = null;
	      this.addingItem = false;
	      this.editingItem = 0;
	      this.form.resetValues();
	    },
	    save: function save() {
	      var _this2 = this;
	
	      var method = this.addingItem ? this.create : this.update;
	
	      method(this.editingItem, this.currentIndex).then(function () {
	        _this2.closeForm();
	      }).catch(function () {});
	    },
	    removeItem: function removeItem(item) {
	      this.destroy(item.id, item);
	    },
	    onInputChange: function onInputChange(name, value) {
	      if (this.form.fields[name] === 'autocomplete' && value.name || this.form.fields[name] !== 'autocomplete') {
	        this.form[name] = value;
	      }
	    },
	    renderFormInput: function renderFormInput(field, item) {
	      var h = this.$createElement;
	
	      if (!this.form[field] && (this.form.fields[field] === 'plaintext' || this.form.fields[field] === 'link')) {
	        return null;
	      }
	
	      if (this.form[field] === undefined && item && item[field]) {
	        return item[field];
	      }
	      var Component = components[this.form.fields[field]];
	      var props = this.form.getExtraAttr(field);
	      var value = this.form[field];
	      if (this.form.fields[field] === 'autocomplete' && item) {
	        value = _typeof(this.form[field]) === 'object' ? this.form[field].name : item.name;
	      }
	
	      return h(Component, (0, _babelHelperVueJsxMergeProps2.default)([{
	        attrs: {
	          name: field,
	          value: value,
	          type: this.form.fields[field],
	          info: this.form.displays[field],
	          controls: false,
	          options: this.form.overrideOptions[field] ? this.form.overrideOptions[field] : this.form.options[field],
	          disabled: this.form.isDisabled(field),
	
	          translation: this.translation + '.' + field
	        },
	        on: {
	          'change': this.onInputChange,
	          'keydown': this.onInputChange
	        }
	      }, { props: props }]));
	    },
	    renderForm: function renderForm(item) {
	      var _this3 = this;
	
	      var h = this.$createElement;
	
	      if (!this.create && !this.update || this.disableForm) {
	        return null;
	      }
	
	      return h(
	        'tr',
	        { 'class': 'tablerow' },
	        [Object.keys(this.form.fields).map(function (field) {
	          if (_this3.hiddenFields.indexOf(field) > -1 || _this3.isStacked(field)) {
	            return null;
	          }
	          var StackedComponent = _this3.stack[field] ? _this3.renderFormInput(_this3.stack[field], item) : null;
	
	          var stacked = StackedComponent ? h(
	            'div',
	            { 'class': 'tableCol--stacked' },
	            [StackedComponent]
	          ) : null;
	
	          return h(
	            'td',
	            { 'class': 'tableCol' },
	            [_this3.renderFormInput(field, item), stacked]
	          );
	        }), this.$scopedSlots.extraColumn ? h(
	          'td',
	          { 'class': 'tableCol' },
	          [item && item.id ? this.$scopedSlots.extraColumn({ item: item }) : h(
	            'span',
	            { 'class': 'tableCol--label' },
	            ['\xA0']
	          )]
	        ) : null, h(
	          'td',
	          { 'class': 'tableCol' },
	          [h('el-button', {
	            'class': 'small icon-check',
	            on: {
	              'click': this.save
	            },
	            attrs: {
	              icon: 'el-icon-check'
	            }
	          }), h('el-button', {
	            'class': 'small',
	            on: {
	              'click': this.closeForm
	            },
	            attrs: {
	              icon: 'el-icon-close'
	            }
	          })]
	        )]
	      );
	    },
	    renderTableHeader: function renderTableHeader() {
	      var _this4 = this;
	
	      var h = this.$createElement;
	
	      return h(
	        'tr',
	        { 'class': 'tablerow' },
	        [Object.keys(this.form.fields).map(function (field) {
	          if (_this4.hiddenFields.indexOf(field) > -1 || _this4.isStacked(field)) {
	            return null;
	          }
	
	          var sortable = _this4.sortableFields.indexOf(field) > -1;
	          var sortActive = sortable && _this4.sortField === field;
	          var sortArrow = sortActive && _this4.sortDirection === 'asc' ? ' \u2191' : sortActive && _this4.sortDirection === 'desc' ? ' \u2193' : '';
	
	          return h(
	            'th',
	            {
	              'class': 'tableCol colHeading th-' + field + (sortable ? ' sortable-th' : ''),
	              on: {
	                'click': function click() {
	                  if (sortable) {
	                    _this4.$emit('sort', field);
	                  }
	                }
	              }
	            },
	            [_this4.$t(_this4.translation ? _this4.translation + '.' + field + '.label' : null) || field, sortArrow]
	          );
	        }), this.$scopedSlots.extraColumn ? h(
	          'th',
	          { 'class': 'tableCol colHeading' },
	          [this.extraColumnHeaderLabel || '\xA0']
	        ) : null, (this.update || this.destroy) && !this.disableForm ? h(
	          'th',
	          { 'class': 'tableCol colHeading' },
	          ['\xA0']
	        ) : null]
	      );
	    },
	    renderColumnContent: function renderColumnContent(item, field) {
	      var h = this.$createElement;
	
	      var content = null;
	      if (this.form.fields[field] === 'select') {
	        var displayKey = field + 'Display';
	        if (Object.prototype.hasOwnProperty.call(item, displayKey)) {
	          content = String(item[displayKey]);
	        } else {
	          var filteredOptions = this.form.options[field].filter(function (o) {
	            if (_typeof(item[field]) === 'object') {
	              return item[field].map(function (i) {
	                return i.id ? i.id : Number(i);
	              }).indexOf(o.id) > -1;
	            }
	
	            return o.id.toString() === item[field].toString();
	          });
	
	          if (filteredOptions.length === 1) {
	            content = filteredOptions[0].name;
	          } else {
	            content = filteredOptions.map(function (o) {
	              return h(
	                'div',
	                { 'class': 'full-w' },
	                [o.name]
	              );
	            });
	          }
	        }
	      } else if (this.form.fields[field] === 'autocomplete') {
	        var _filteredOptions = this.form.options[field].filter(function (o) {
	          if (_typeof(item[field]) === 'object') {
	            return item[field].id.toString() === o.id.toString();
	          }
	
	          return o.id.toString() === item[field].toString();
	        });
	
	        if (_filteredOptions.length === 1) {
	          content = _filteredOptions[0].name;
	        } else if (_filteredOptions.length > 1) {
	          content = _filteredOptions.map(function (o) {
	            return h(
	              'div',
	              { 'class': 'full-w' },
	              [o.name]
	            );
	          });
	        } else if (_typeof(item[field]) === 'object') {
	          content = item[field].name;
	        } else if (item.name) {
	          var props = Object.assign({}, this.form.getExtraAttr(field));
	
	          if (props.href && props.href.indexOf('_') > -1) {
	            var targetId = item.id;
	            if (props.targetId) targetId = item[props.targetId];
	            var link = '/' + props.href.split('_')[0] + targetId + props.href.split('_')[1];
	            content = h(
	              'router-link',
	              {
	                attrs: { to: link, target: '_blank' }
	              },
	              [item.name]
	            );
	          } else {
	            content = item.name;
	          }
	        } else {
	          content = item[field];
	        }
	      } else if (this.form.fields[field] === 'link') {
	        var _props = Object.assign({}, this.form.getExtraAttr(field));
	        _props.href = _props.hrefs[item.id] || _props.href;
	        var value = item[field].toString();
	        delete _props.hrefs;
	        content = h(_link2.default, (0, _babelHelperVueJsxMergeProps2.default)([{
	          attrs: { name: field, value: value }
	        }, { props: _props }]));
	      } else {
	        content = item[field];
	      }
	
	      var clickHandler = this.clickHandler(item, field);
	      if (clickHandler) {
	        return h(
	          'a',
	          { style: 'cursor:pointer;', on: {
	              'click': clickHandler
	            }
	          },
	          [h('span', { 'class': item.productType === 'Bundle' ? 'fa fa-gift' : this.clickHandlerIcon }), '\xA0 ', content]
	        );
	      }
	
	      var tagType = this.tagHandler(item, field);
	      if (tagType) {
	        return h(
	          'el-tag',
	          {
	            attrs: { type: tagType }
	          },
	          [content]
	        );
	      }
	
	      return content;
	    },
	    renderTableRow: function renderTableRow() {
	      var _this5 = this;
	
	      var h = this.$createElement;
	
	      return this.list.map(function (item, index) {
	        if (item.id === _this5.editingItem) {
	          return _this5.renderForm(item);
	        }
	        return h(
	          'tr',
	          { 'class': 'tablerow' },
	          [Object.keys(_this5.form.fields).map(function (field) {
	            if (_this5.hiddenFields.indexOf(field) > -1 || _this5.isStacked(field)) {
	              return null;
	            }
	
	            var content = _this5.renderColumnContent(item, field);
	
	            var stackContent = _this5.renderColumnContent(item, _this5.stack[field]);
	
	            var stacked = _this5.stack[field] && item[_this5.stack[field]] ? h(
	              'div',
	              { 'class': 'tableCol--stacked' },
	              [stackContent]
	            ) : null;
	
	            var width = _this5.columnWidths[field] || '';
	
	            return h(
	              'td',
	              { 'class': 'tableCol', style: 'width:' + width },
	              [h(
	                'div',
	                { 'class': 'full-w' },
	                [h(
	                  'span',
	                  { 'class': 'tableCol--label' },
	                  [_this5.$t(_this5.translation ? _this5.translation + '.' + field + '.label' : null) || field, ':', ' ']
	                ), content, stacked]
	              )]
	            );
	          }), _this5.$scopedSlots.extraColumn ? h(
	            'td',
	            { 'class': 'tableCol' },
	            [_this5.$scopedSlots.extraColumn({ item: item })]
	          ) : null, (_this5.update || _this5.destroy) && !_this5.disableForm && !_this5.disabledRows.includes(item.id) ? h(
	            'td',
	            { 'class': 'tableCol' },
	            [_this5.update && !_this5.disableForm ? h('el-button', {
	              'class': 'small',
	              on: {
	                'click': function click() {
	                  return _this5.editItem(item, index);
	                }
	              },
	              attrs: {
	                icon: 'el-icon-edit'
	              }
	            }) : null, _this5.destroy && !_this5.disableForm ? h('el-button', {
	              'class': 'small',
	              on: {
	                'click': function click() {
	                  return _this5.removeItem(item);
	                }
	              },
	              attrs: {
	                icon: 'el-icon-delete'
	              }
	            }) : null]
	          ) : null]
	        );
	      });
	    },
	    renderTable: function renderTable() {
	      var h = this.$createElement;
	
	      return h(
	        'table',
	        { 'class': 'tableContainer' },
	        [this.renderTableHeader(), this.renderTableRow(), this.addingItem ? this.renderForm() : null]
	      );
	    }
	  },
	
	  render: function render(h) {
	
	    var createBtn = this.create && !this.disableForm ? h(
	      'el-button',
	      { 'class': 'small', on: {
	          'click': this.addNewItem
	        }
	      },
	      [this.$t('button.add')]
	    ) : null;
	
	    var additionalButtons = this.additionalButtons && !this.disableForm ? this.additionalButtons.map(function (item) {
	      return h(
	        'el-button',
	        { 'class': 'small', on: {
	            'click': item.action
	          }
	        },
	        [item.text]
	      );
	    }) : null;
	
	    var exportBtn = this.isExport && !this.disableForm ? h(
	      'el-button',
	      { 'class': 'small', on: {
	          'click': this.exportClickHandler
	        }
	      },
	      [this.$t('button.export')]
	    ) : null;
	    var table = this.list.length || this.addingItem ? this.renderTable() : null;
	    var message = !this.list.length && !this.addingItem ? h('v-message', {
	      attrs: {
	        warning: this.noResultWarningText ? this.noResultWarningText : this.$t('static.orders.edit.noProductWarning')
	      }
	    }) : null;
	    var fileUploader = this.isImport && !this.disableForm ? h('file-pond', {
	      attrs: {
	        name: 'import_excel',
	
	        'label-idle': this.$t('button.dragAndDropImport'),
	        'allow-multiple': 'false',
	        server: this.server
	      },
	      ref: 'pond' }) : null;
	    return h(
	      'div',
	      { 'class': 'form-table--parent' },
	      [h('el-row', [h(
	        'el-col',
	        { 'class': 'el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-18 el-col-lg-18' },
	        [fileUploader, exportBtn]
	      ), h('el-col', [table]), h(
	        'el-col',
	        { 'class': 'el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-16 el-col-lg-16' },
	        [createBtn, additionalButtons]
	      )]), message]
	    );
	  },
	
	
	  components: {
	    VMessage: __webpack_require__(13),
	    FilePond: FilePond
	  }
	};

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _googleTwoFactorAuthSetup = __webpack_require__(1045);
	
	var _googleTwoFactorAuthSetup2 = _interopRequireDefault(_googleTwoFactorAuthSetup);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      google2faEnabled: false,
	      verificationSent: false,
	      twoFactorAuthToken: null,
	      verified: false,
	      qrCodeImage: null,
	      secretKey: null,
	      loading: false,
	      verifyLoading: false
	    };
	  },
	
	
	  props: {
	    module: {
	      type: Object,
	      required: true
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    modules: 'allModules'
	  }), {
	    isSms2faEnabled: function isSms2faEnabled() {
	      return this.modules.find(function (module) {
	        return module.name === 'Sms Two-Factor Authentication' && module.subscribe;
	      });
	    }
	  }),
	
	  created: function created() {
	    if (!this.isSms2faEnabled) {
	      this.twoFactorAuthToken = null;
	      this.enable2FA();
	    }
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    enable2FA: function enable2FA() {
	      var _this = this;
	
	      this.loading = true;
	      var data = {
	        user_id: this.account.userId,
	        module_id: this.module.id
	      };
	      Promise.resolve(_googleTwoFactorAuthSetup2.default.enabledGoogleTwoFactor(data)).then(function (response) {
	        _this.qrCodeImage = response.data.image;
	        _this.loading = false;
	      }).catch(function () {
	        _this.google2faEnabled = true;
	        _this.loading = false;
	      });
	    },
	    verifyToken: function verifyToken() {
	      var _this2 = this;
	
	      if (!this.twoFactorAuthToken) {
	        this.$message({
	          message: this.$t('static.googleTwoFactorVerification.verificationCodeIncorrect'),
	          type: 'error'
	        });
	        return;
	      }
	
	      this.verifyLoading = true;
	      var data = {
	        code: this.twoFactorAuthToken,
	        user_id: this.account.userId,
	        module_id: this.module.id
	      };
	      Promise.resolve(_googleTwoFactorAuthSetup2.default.verifyToken(data)).then(function () {
	        _modules2.default.items().then(function () {
	          _this2.verifyLoading = false;
	          _this2.$message({
	            message: _this2.$t('static.googleTwoFactorVerification.smsTwoFactorAuthEnabled'),
	            type: 'success'
	          });
	          _this2.closeModal();
	        });
	      }).catch(function () {
	        _this2.verifyLoading = false;
	        _this2.$message({
	          message: _this2.$t('static.googleTwoFactorVerification.verificationCodeIncorrect'),
	          type: 'error'
	        });
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  })
	};

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _auth = __webpack_require__(53);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _vuex = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      gridData: [{
	        date: '2016-05-02',
	        summary: 'Lorem Ipsum Dolor'
	
	      }, {
	        date: '2016-05-04',
	        summary: 'Lorem Ipsum Dolor'
	
	      }, {
	        date: '2016-05-01',
	        summary: 'Lorem Ipsum Dolor'
	
	      }],
	      gridData2: [{
	        date: '2016-05-02',
	        item: 'Lorem Ipsum Dolor'
	
	      }, {
	        date: '2016-05-04',
	        item: 'Lorem Ipsum Dolor'
	
	      }, {
	        date: '2016-05-01',
	        item: 'Lorem Ipsum Dolor'
	
	      }, {
	        date: '2016-05-03',
	        item: 'Lorem Ipsum Dolor'
	      }],
	      debugMode: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account'
	  }), {
	    organization: function organization() {
	      return this.account;
	    },
	    organizations: function organizations() {
	      var _this = this;
	
	      if (this.account.organizations) {
	        var hasMultipleOrganizations = this.account.organizations.filter(function (o) {
	          return o.name !== _this.organizationName;
	        });
	        if (hasMultipleOrganizations.length > 0) {
	          return hasMultipleOrganizations;
	        }
	      }
	      return false;
	    },
	    username: function username() {
	      return this.organizationName ? '' + this.organizationName : '' + this.name;
	    },
	    organizationName: function organizationName() {
	      return this.account.organizationName ? '' + this.account.organizationName : '';
	    },
	    name: function name() {
	      return this.account.firstName && this.account.lastName ? this.account.firstName + ' ' + this.account.lastName : this.account.userFirstName + ' ' + this.account.userLastName;
	    },
	    organizationType: function organizationType() {
	      return this.$t('layouts.header.' + this.account.organizationType.toLowerCase());
	    },
	    email: function email() {
	      return this.account.email;
	    },
	    avatar: function avatar() {
	      var avatar = this.account.organizationProfilePicture;
	      if (avatar !== undefined && avatar.url !== undefined) {
	        return avatar.url;
	      }
	      return false;
	    },
	    isAdmin: function isAdmin() {
	      if (localStorage.getItem('is_admin')) {
	        return true;
	      }
	
	      return false;
	    }
	  }),
	
	  mounted: function mounted() {
	    this.debugMode = this.account.debugMode;
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleSidebar: 'TOGGLE_INNERSIDEBAR'
	  }), {
	    logout: function logout() {
	      _auth2.default.logout();
	    },
	    toggleDebugMode: function toggleDebugMode() {
	      var _this2 = this;
	
	      this.$confirm(this.$t('static.account.confirmDebugMode'), this.$t('static.account.toggleDebugMode'), {
	        confirmButtonText: this.$t('button.yes'),
	        cancelButtonText: this.$t('button.no'),
	        type: 'warning'
	      }).then(function () {
	        if (_this2.debugMode) {
	          _account2.default.onDebugMode(_this2.account.userId).then(function () {
	            _this2.$message({
	              showClose: true,
	              message: _this2.$t('static.account.onDebugMode'),
	              type: 'success'
	            });
	          });
	        } else {
	          _account2.default.offDebugMode(_this2.account.userId).then(function () {
	            _this2.$message({
	              showClose: true,
	              message: _this2.$t('static.account.offDebugMode'),
	              type: 'success'
	            });
	          });
	        }
	      }).catch(function () {
	        _this2.debugMode = !_this2.debugMode;
	      });
	    },
	    switchOrganization: function switchOrganization() {
	      var _this3 = this;
	
	      this.$confirm(this.$t('static.account.confirmSwitchOrganization'), this.$t('static.account.switchOrganization'), {
	        confirmButtonText: this.$t('button.yes'),
	        cancelButtonText: this.$t('button.no'),
	        type: 'warning'
	      }).then(function () {
	        _account2.default.switchOrganization(_this3.account.userId).then(function () {
	          _this3.$message({
	            showClose: true,
	            message: _this3.$t('static.account.switchingOrganizationMessage'),
	            type: 'success'
	          });
	        });
	      }).catch(function () {
	        console.log('error switching organization');
	      });
	    },
	    hasModule: function hasModule(name) {
	      if (this.account.modules) {
	        var hasModule = this.account.modules.filter(function (m) {
	          return m.name === name;
	        });
	        if (hasModule.length > 0) {
	          return true;
	        }
	      }
	      return false;
	    }
	  })
	};

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _order = __webpack_require__(54);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _store2 = __webpack_require__(2);
	
	var _store3 = _interopRequireDefault(_store2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        internalNote: {
	          type: 'textarea',
	          value: ''
	        }
	      }),
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentOrder: 'currentOrder'
	  })),
	
	  mounted: function mounted() {},
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    store: function store() {
	      var _this = this;
	
	      this.loading = false;
	      this.form.loading = true;
	      var data = Object.assign({}, this.currentOrder, { invoiceExternal: true, internalNote: this.form.internalNote });
	      return _order2.default.update(_store3.default.state.route.params.id, data).then(function () {
	        _this.loading = false;
	        _this.$message({
	          showClose: true,
	          message: 'Success',
	          customClass: 'success'
	        });
	        _this.closeModal();
	      }).catch(function (errors) {
	        _this.loading = false;
	        _this.form.loading = false;
	        var message = errors.data.message;
	        if (errors.data.confirm_date) {
	          message = errors.data.confirm_date[0];
	        }
	
	        _this.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _data$props$computed$;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _addPackageOrderProduct = __webpack_require__(2671);
	
	var _addPackageOrderProduct2 = _interopRequireDefault(_addPackageOrderProduct);
	
	var _editPackageOrderProduct = __webpack_require__(2699);
	
	var _editPackageOrderProduct2 = _interopRequireDefault(_editPackageOrderProduct);
	
	var _editPackage = __webpack_require__(2698);
	
	var _editPackage2 = _interopRequireDefault(_editPackage);
	
	var _packageOrderProduct = __webpack_require__(189);
	
	var _packageOrderProduct2 = _interopRequireDefault(_packageOrderProduct);
	
	var _orderProduct = __webpack_require__(48);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _package = __webpack_require__(188);
	
	var _package2 = _interopRequireDefault(_package);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_data$props$computed$ = {
	  data: function data() {
	    return {
	      pallet_number: 0,
	      activeNames: [],
	      packageIdIterator: 0,
	      selectedPaperSize: '102x192mm',
	      paperSizes: [{ value: '102x192mm', name: '102x192mm' }, { value: 'A4', name: 'A4' }, { value: 'A5', name: 'A5' }, { value: 'A6', name: 'A6' }]
	    };
	  },
	
	
	  props: {
	    order: {
	      type: Object,
	      required: true
	    },
	
	    packages: {
	      type: Object,
	      required: true
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    products: 'allProducts',
	    orderProducts: 'allOrderProducts',
	    currentEdiOrder: 'currentEdiOrder',
	    taxes: 'allTaxes',
	    productDeposits: 'allProductDeposits',
	    packageOrderProducts: 'allPackageOrderProducts',
	    currentOrder: 'currentOrder'
	  })),
	
	  watch: {},
	
	  created: function created() {
	    var allPackages = this.packages.all;
	    for (var i = 0; i <= allPackages.length; i++) {
	      this.activeNames.push(i);
	    };
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    activateAddProductToPackageModal: function activateAddProductToPackageModal(id) {
	      var palletDetails = { packageId: id };
	      this.setModalContent(function () {
	        return _addPackageOrderProduct2.default;
	      });
	      this.setModalProps(palletDetails);
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(true);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    activateEditProductToPackageModal: function activateEditProductToPackageModal(selectedPackageOrderProduct) {
	      this.setModalContent(function () {
	        return _editPackageOrderProduct2.default;
	      });
	      this.setModalProps(selectedPackageOrderProduct);
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(true);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    activateEditPacakge: function activateEditPacakge(pckg) {
	      this.setModalContent(function () {
	        return _editPackage2.default;
	      });
	      this.setModalProps(pckg);
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(true);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    getPackageOrderProductById: function getPackageOrderProductById(id) {
	      return this.packageOrderProducts.all.filter(function (p) {
	        return p.packageId == id;
	      });
	    },
	    editpackageOrderProduct: function editpackageOrderProduct(selectedPackageOrderProduct) {
	      this.activateEditProductToPackageModal(selectedPackageOrderProduct);
	    },
	    confirmToRemovePackage: function confirmToRemovePackage(selectedPackageOrderProduct) {
	      var _this = this;
	
	      this.$confirm(this.$t("static.packageOrderProduct.destroy.confirm"), 'Confirm', {
	        confirmButtonText: 'OK',
	        cancelButtonText: 'Cancel',
	        type: 'warning'
	      }).then(function () {
	        _this.removeProductFromPackage(selectedPackageOrderProduct.id);
	      }).catch(function () {});
	    },
	    confirmDeletePackage: function confirmDeletePackage(packageId) {
	      var _this2 = this;
	
	      this.$confirm(this.$t("static.package.destroy.confirm"), 'Confirm', {
	        confirmButtonText: 'OK',
	        cancelButtonText: 'Cancel',
	        type: 'warning'
	      }).then(function () {
	        _this2.deletePackage(packageId);
	      }).catch(function () {});
	    },
	    removeProductFromPackage: function removeProductFromPackage(id) {
	      var _this3 = this;
	
	      var packageOrderProductDestroy = _packageOrderProduct2.default.destroy(id).then(function () {
	        _orderProduct2.default.all(_this3.currentOrder.id);
	        _packageOrderProduct2.default.all(_this3.currentOrder.id);
	        _package2.default.all(_this3.currentOrder.id);
	        _this3.$message({
	          showClose: true,
	          message: _this3.$t('static.packageOrderProduct.destroy.success'),
	          customClass: 'success'
	        });
	      }).catch(function () {
	        var message = _this3.$t('static.packageOrderProduct.destroy.error');
	        _this3.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	      });
	    },
	    deletePackage: function deletePackage(id) {
	      var _this4 = this;
	
	      var packageOrderProductDestroy = _package2.default.destroy(id).then(function () {
	        _orderProduct2.default.all(_this4.currentOrder.id);
	        _packageOrderProduct2.default.all(_this4.currentOrder.id);
	        _package2.default.all(_this4.currentOrder.id);
	        _this4.$message({
	          showClose: true,
	          message: _this4.$t('static.package.destroy.success'),
	          customClass: 'success'
	        });
	      }).catch(function () {
	        var message = _this4.$t('static.package.destroy.error');
	        _this4.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	      });
	    },
	    viewProductBarcode: function viewProductBarcode(packageOrderProduct) {
	      _packageOrderProduct2.default.show(packageOrderProduct.hashid);
	    },
	    viewPackageBarcode: function viewPackageBarcode(packageId) {
	      _package2.default.show(packageId, this.selectedPaperSize);
	    },
	    viewMixPalletPackageBarcode: function viewMixPalletPackageBarcode(packageId) {
	      _package2.default.showMixPallet(packageId, this.selectedPaperSize);
	    }
	  })
	
	}, _defineProperty(_data$props$computed$, 'watch', {}), _defineProperty(_data$props$computed$, 'mounted', function mounted() {}), _data$props$computed$);

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _geocoder = __webpack_require__(2411);
	
	var _geocoder2 = _interopRequireDefault(_geocoder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      currentLocation: {
	        lat: 59.922011,
	        lng: 10.752838
	      }
	    };
	  },
	
	
	  props: {
	    streetName: {
	      type: String,
	      required: true
	    }
	  },
	
	  watch: {
	    streetName: function streetName() {
	      this.geolocation();
	    }
	  },
	
	  mounted: function mounted() {
	    this.geolocation();
	  },
	
	
	  methods: {
	    geolocation: function geolocation() {
	      var _this = this;
	
	      _geocoder2.default.geocode(this.streetName, function (err, data) {
	        if (err === null) {
	          if (data.results.length) {
	            _this.currentLocation.lat = data.results[0].geometry.location.lat;
	            _this.currentLocation.lng = data.results[0].geometry.location.lng;
	          } else {
	            console.log('No results for address.');
	          }
	        } else {
	          console.log(err);
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _partner = __webpack_require__(301);
	
	var _partner2 = _interopRequireDefault(_partner);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        public_marketplace: {
	          value: 0,
	          type: 'switch'
	        },
	        marketplaces_enabled: {
	          value: [],
	          type: 'checkboxGroup'
	        }
	      }),
	      loading: false
	    };
	  },
	
	
	  props: {
	    module: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    modules: 'allModules',
	    partners: 'allPartners'
	  })),
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    Promise.all([_partner2.default.all()]).then(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  watch: {
	    partners: function partners(allPartners) {
	      if (allPartners) {
	        this.form.setOptions('marketplaces_enabled', allPartners);
	      }
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    getResources: function getResources() {},
	    subscribe: function subscribe() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var data = this.form.data();
	      var partnerIds = [];
	      this.form.marketplaces_enabled.forEach(function (m) {
	        var partner = _this2.partners.find(function (p) {
	          return p.name === m;
	        });
	        partnerIds.push(partner.id);
	      });
	      data.marketplaces_enabled = partnerIds;
	      var obj = Object.assign({ module_id: this.module.id }, data);
	      _modules2.default.subscribe(this.module.id, obj).then(function () {
	        Promise.all([_modules2.default.items(), _account2.default.find()]).then(function () {
	          _this2.closeModal();
	        });
	      }).catch(function (error) {
	        var message = error.data ? error.data.message : 'Field Required';
	        _this2.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	        _this2.form.recordErrors(error);
	        _this2.form.loading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _marketplaceProduct = __webpack_require__(195);
	
	var _marketplaceProduct2 = _interopRequireDefault(_marketplaceProduct);
	
	var _marketplaceProduct3 = __webpack_require__(460);
	
	var _marketplaceProduct4 = _interopRequireDefault(_marketplaceProduct3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  props: {
	    product: {
	      required: true,
	      type: Object
	    },
	    data: {
	      type: Object,
	      required: false
	    },
	    disabled: {
	      type: Boolean,
	      required: false,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        productTypeId: {
	          value: '',
	          type: 'text'
	        },
	        image: {
	          value: {},
	          type: 'file'
	        },
	        price: {
	          value: '',
	          type: 'float'
	        },
	        shortDescription: {
	          value: '',
	          type: 'textarea'
	        },
	        longDescription: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      loading: false,
	      productMarketplace: null
	    };
	  },
	  created: function created() {
	    this.form.hideField('productTypeId');
	    this.form.productTypeId = this.product.productTypeId;
	    this.show();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    show: function show() {
	      var _this = this;
	
	      this.loading = true;
	      _marketplaceProduct4.default.show(this.product.id).then(function (data) {
	        _this.productMarketplace = data;
	        _this.loading = false;
	        if (data.status) {
	          _this.form.assignData(data);
	          return;
	        }
	        _this.form.image = _this.product.icon || {};
	        _this.form.name = _this.product.name;
	        _this.form.shortDescription = _this.product.description;
	        _this.form.price = _this.product.price;
	      }).catch(function () {
	        _this.loading = false;
	      });
	    }
	  }),
	  watch: {
	    'form.productType': function formProductType(arrayValue) {
	      var _arrayValue$slice = arrayValue.slice(-1),
	          _arrayValue$slice2 = _slicedToArray(_arrayValue$slice, 1),
	          productyTypeId = _arrayValue$slice2[0];
	
	      this.form.productTypeId = productyTypeId;
	    },
	
	    'form.price': function formPrice(price) {
	      this.$emit('priceUpdate', price);
	    },
	
	    product: function product(_product) {
	      this.form.price = _product.marketplace || this.product.price;
	    },
	
	
	    disabled: {
	      immediate: true,
	      handler: function handler(disabled) {
	        var _this2 = this;
	
	        Object.keys(this.form.fields).forEach(function (field) {
	          if (disabled) {
	            _this2.form.disableField(field);
	          } else {
	            _this2.form.enableField(field);
	          }
	        });
	      }
	    },
	    form: {
	      handler: function handler(newValue) {
	        this.$emit('update', newValue);
	      },
	
	      deep: true
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _vuex = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    type: {
	      type: String,
	      required: false
	    },
	    entries: {
	      type: Object,
	      required: false
	    },
	    queryProductWarehouse: {
	      type: Function,
	      required: false
	    }
	
	  },
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        minimumStockLevel: {
	          value: '',
	          type: 'number'
	        }
	      }),
	      loading: false
	    };
	  },
	  mounted: function mounted() {
	    console.log(this.entries);
	    this.form.minimumStockLevel = this.type === 'bulk' ? 0 : this.entries.minimumStockLevel;
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    update: function update() {
	      var _this = this;
	
	      this.loading = true;
	      var data = { minimumStock: this.form.minimumStockLevel };
	      if (this.type === 'bulk') {
	        data.warehouse_product_ids = this.entries.selected.map(function (item) {
	          return item.id;
	        });
	      }
	      _warehouse2.default.stockManagement(this.entries.id, data, this.type).then(function () {
	        _this.loading = false;
	        _this.unsetModalContent();
	        _this.toggleModal(false);
	        _this.queryProductWarehouse();
	      }).catch(function () {
	        _this.loading = false;
	      });
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	  computed: _extends({}, (0, _vuex.mapGetters)(['modalState', 'modalContent', 'modalCloseOnClick', 'modalShowClose', 'modalCloseOnPressEscape', 'modalProps', 'modalSize', 'modalClass']), {
	    content: function content() {
	      return typeof this.modalContent === 'function' ? this.modalContent() : this.modalContent;
	    },
	
	
	    active: {
	      get: function get() {
	        return this.modalState;
	      },
	      set: function set(value) {
	        this.toggle(value);
	      }
	    }
	  }),
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    onClose: function onClose() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  })
	};

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _vuex = __webpack_require__(5);
	
	var _vueSlickCarousel = __webpack_require__(3144);
	
	var _vueSlickCarousel2 = _interopRequireDefault(_vueSlickCarousel);
	
	__webpack_require__(2403);
	
	__webpack_require__(2402);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      backendUrl: ("https://api.kundan.no"),
	      latestVersions: [],
	      btnNextDisabled: false,
	      btnPrevDisabled: true,
	      maxDescLength: 250,
	      releasePagination: '0 ' + this.$t('static.releaseNote.modal.pageOf') + ' 0',
	      settings: {
	        arrows: false,
	        dots: false,
	        infinite: false
	      }
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)(['latestAppVersion'])),
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL'
	  }), {
	    closeModal: function closeModal() {
	      this.toggleModal(false);
	      Promise.resolve(_account2.default.updateUserAppVersion(this.latestVersions.version)).then(function () {});
	    },
	    rShowNext: function rShowNext() {
	      this.$refs.carousel.next();
	    },
	    rShowPrev: function rShowPrev() {
	      this.$refs.carousel.prev();
	    },
	    handleAfterChange: function handleAfterChange(event, slick, currentSlide) {
	      if (event === 0) this.btnPrevDisabled = true;else this.btnPrevDisabled = false;
	      if (event < this.latestVersions.release_modules_note.length) this.btnNextDisabled = false;else this.btnNextDisabled = true;
	      this.releasePagination = event + 1 + ' ' + this.$t('static.releaseNote.modal.pageOf') + ' ' + (this.latestVersions.release_modules_note.length + 1);
	    }
	  }),
	
	  mounted: function mounted() {
	    this.latestVersions = this.latestAppVersion.items.data;
	    this.releasePagination = this.latestVersions != '' ? '1 ' + ' ' + this.$t('static.releaseNote.modal.pageOf') + ' ' + (this.latestVersions.release_modules_note.length + 1) : '0 of 0';
	  },
	
	
	  components: { VueSlickCarousel: _vueSlickCarousel2.default }
	};

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  mounted: function mounted() {
	    console.log('NoData component has been mounted!');
	  }
	};

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _vuex = __webpack_require__(5);
	
	var _businessDay = __webpack_require__(958);
	
	var _businessDay2 = _interopRequireDefault(_businessDay);
	
	var _businessHour = __webpack_require__(960);
	
	var _businessHour2 = _interopRequireDefault(_businessHour);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        businessDays: {
	          value: [],
	          type: 'select'
	        },
	        start: {
	          value: '',
	          type: 'time'
	        },
	        end: {
	          value: '',
	          type: 'time'
	        }
	      })
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    days: 'businessDays',
	    hours: 'businessHours'
	  })),
	
	  watch: {
	    days: function days(_days) {
	      this.form.setOptions('businessDays', _days.map(function (d) {
	        return { id: d.id, name: d.day };
	      }));
	    }
	  },
	
	  mounted: function mounted() {
	    _businessDay2.default.all();
	    _businessHour2.default.all();
	    this.form.setExtraAttr('businessDays', {
	      multiple: true
	    });
	  },
	
	
	  methods: {
	    onFormChange: function onFormChange(name, value) {
	      this.form.clearSuccess(name, value);
	      this.form.clearErrors(name);
	      this.form[name] = value;
	      this.$forceUpdate();
	    },
	    save: function save() {
	      var _this = this;
	
	      this.form.loading = true;
	      return _businessHour2.default.store(this.form.data()).then(function () {
	        _this.form.loading = false;
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	        var errorsKeys = Object.keys(_this.form.errors.errors);
	        _this.$message({
	          showClose: true,
	          message: errors[errorsKeys[0]][0],
	          type: 'error'
	        });
	      });
	    },
	    destroy: function destroy(id) {
	      var _this2 = this;
	
	      this.destroyLoading = true;
	      _businessHour2.default.destroy(id).then(function () {
	        _this2.destroyLoading = false;
	      }).catch(function () {
	        _this2.destroyLoading = false;
	      });
	    }
	  },
	
	  components: {
	    VFormTable: __webpack_require__(46)
	  }
	};

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _orderProduct = __webpack_require__(48);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _order = __webpack_require__(54);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _shippingProvider = __webpack_require__(97);
	
	var _shippingProvider2 = _interopRequireDefault(_shippingProvider);
	
	var _vuex = __webpack_require__(5);
	
	var _shippingConfirm = __webpack_require__(198);
	
	var _shippingConfirm2 = _interopRequireDefault(_shippingConfirm);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _quickProductEditExcise = __webpack_require__(419);
	
	var _quickProductEditExcise2 = _interopRequireDefault(_quickProductEditExcise);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        confirmDate: {
	          value: '',
	          type: 'date'
	        },
	        warehouseId: {
	          type: 'select',
	          value: ''
	        }
	      }),
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentOrder: 'currentOrder',
	    orderProducts: 'allOrderProducts',
	    account: 'account',
	    warehouses: 'allWarehouses',
	    settings: 'organizationSettings'
	  }), {
	    bevearageProducts: function bevearageProducts() {
	      return this.orderProducts.filter(function (p) {
	        return p.productType === 'Beverage' || p.productTypeGroup === 'Beverage';
	      }).map(function (item) {
	        var excise = [];
	        if (item.exciseAlcoholGroup) {
	          excise.push(item.exciseAlcoholGroupName);
	        }
	        if (item.excisePackagingGroup) {
	          excise.push(item.excisePackagingGroupName);
	        }
	        if (item.exciseBasicGroup) {
	          excise.push(item.exciseBasicGroupName);
	        }
	        return {
	          id: item.id,
	          name: item.name,
	          beverage: item.exciseAlcoholGroupName || '-',
	          packaging: item.excisePackagingGroupName || '-',
	          basic: item.exciseBasicGroupName || '-',
	          excisable: item.excisable,
	          paidExcise: item.paidExcise,
	          bottleVolume: item.fieldsJSON.bottle_volume,
	          alcoholPercentage: item.fieldsJSON.alcohol_percentage,
	          productPackaging: item.productPackagingId || '',
	          noExcise: item.containsAlcohol && (!item.excisable || excise.length === 0 || !item.fieldsJSON.bottle_volume)
	        };
	      });
	    },
	    hasNoExcise: function hasNoExcise() {
	      return this.bevearageProducts.filter(function (p) {
	        return p.noExcise;
	      }).length !== 0 && this.hasExciseModule;
	    },
	    hasMissingPackaging: function hasMissingPackaging() {
	      var hasInventory = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            hasInventory = true;
	            return this.bevearageProducts.length && this.bevearageProducts.filter(function (p) {
	              return !p.productPackaging;
	            }).length !== 0;
	          }
	        }
	      }
	      return hasInventory;
	    },
	    hasExciseModule: function hasExciseModule() {
	      var hasExciseModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Excise') {
	            hasExciseModule = true;
	          }
	        }
	      }
	      return hasExciseModule;
	    }
	  }),
	
	  mounted: function mounted() {
	    this.form.confirmDate = (0, _moment2.default)().format('YYYY-MM-DD');
	    this.getResources();
	  },
	
	
	  watch: {
	    shippingProviders: function shippingProviders(_shippingProviders) {
	      var hasModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Shipping Provider') {
	            hasModule = true;
	          }
	        }
	      }
	      if (hasModule) {
	        this.form.setOptions('shippingProviderId', _shippingProviders.map(function (c) {
	          return { id: c.id, name: c.name + ' ' };
	        }));
	      } else {
	        this.form.hideField('shippingProviderId');
	      }
	    },
	    warehouses: function warehouses(_warehouses) {
	      var hasModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            hasModule = true;
	            this.form.setOptions('warehouseId', _warehouses.items);
	          }
	        }
	      }
	
	      if (!hasModule) {
	        this.form.hideField('warehouseId');
	      } else if (this.currentOrder.warehouseId == 0) {
	        this.form.showField('warehouseId');
	      } else {
	        this.form.hideField('warehouseId');
	      }
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    quickProductEdit: function quickProductEdit(id) {
	      var item = this.orderProducts.find(function (p) {
	        return +p.id === +id;
	      });
	      if (item) {
	        this.setModalProps({
	          productId: item.productId,
	          productName: item.name,
	          orderProduct: item,
	          isEdi: false
	        });
	        this.toggle(true);
	        this.setModalContent(function () {
	          return _quickProductEditExcise2.default;
	        });
	      }
	    },
	    getResources: function getResources() {
	      var _this = this;
	
	      this.loading = true;
	      Promise.all([_shippingProvider2.default.all(), _warehouse2.default.all(), _orderProduct2.default.all(this.currentOrder.id), _organizationSettings2.default.show()]).then(function () {
	        _this.loading = false;
	        _this.form.warehouseId = _this.settings.defaultWarehouse;
	      });
	    },
	    store: function store() {
	      var _this2 = this;
	
	      this.loading = false;
	      this.form.loading = true;
	      var client = _shippingConfirm2.default.send(Object.assign({}, this.form.data()));
	
	      return _order2.default.confirm(this.currentOrder.id, client).then(function (data) {
	        _this2.loading = false;
	        if (data.order_status === 'vipps_processing') {
	          _this2.$confirm(_this2.$t('static.ediOrders.edit.vippsProcessing'), _this2.$t('static.ediOrders.edit.vippsProcessingTitle'), {
	            confirmButtonText: _this2.$t('button.reload'),
	            cancelButtonText: _this2.$t('button.close')
	          }).then(function () {
	            location.reload();
	          }).catch(function () {});
	        } else {
	          _this2.$message({
	            showClose: true,
	            message: _this2.$t('static.ediOrders.edit.confirmSuccess'),
	            customClass: 'success'
	          });
	        }
	
	        _this2.closeModal();
	      }).catch(function (errors) {
	        _this2.loading = false;
	        _this2.form.loading = false;
	        var message = errors.data.message;
	        if (errors.data.confirm_date) {
	          message = errors.data.confirm_date[0];
	        }
	
	        _this2.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _ediOrder = __webpack_require__(187);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _order = __webpack_require__(54);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _shippingProvider = __webpack_require__(97);
	
	var _shippingProvider2 = _interopRequireDefault(_shippingProvider);
	
	var _vuex = __webpack_require__(5);
	
	var _shippingConfirm = __webpack_require__(198);
	
	var _shippingConfirm2 = _interopRequireDefault(_shippingConfirm);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    warehouseId: {
	      Type: Number,
	      required: true
	    },
	    orderConfirmNotification: {
	      type: Boolean,
	      required: false,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        shippingProviderId: {
	          value: '',
	          type: 'select'
	        },
	        shippingDate: {
	          value: (0, _moment2.default)().format('YYYY-MM-DD'),
	          type: 'date'
	        }
	      }),
	      shippingProviders: [],
	      showReminder: false,
	      loading: false,
	      displayError: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentOrder: 'currentOrder',
	    account: 'account',
	    settings: 'organizationSettings',
	    orderProducts: 'allOrderProducts'
	  }), {
	    unassignedProducts: function unassignedProducts() {
	      return this.orderProducts.filter(function (op) {
	        return op.quantityConfirmed != op.quantityPacked;
	      });
	    }
	  }),
	
	  mounted: function mounted() {
	    this.getResources();
	  },
	
	
	  watch: {
	    'form.shippingProviderId': function formShippingProviderId(newValue) {
	      console.log(this.currentOrder.internalNote);
	      var provider = this.shippingProviders.find(function (p) {
	        return p.id === parseInt(newValue);
	      }) || null;
	      if (provider.code === 'CCNO_STK') {
	        this.showReminder = true;
	      } else {
	        this.showReminder = false;
	      }
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    setShippingProviders: function setShippingProviders(shippingProviders) {
	      var hasModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Shipping Provider') {
	            hasModule = true;
	          }
	        }
	      }
	      if (hasModule) {
	        this.form.setOptions('shippingProviderId', shippingProviders.map(function (c) {
	          return { id: c.id, name: c.name + ' ' };
	        }));
	        if (this.form.options.shippingProviderId.length > 0) this.displayError = false;
	      } else {
	        this.displayError = false;
	        this.form.hideField('shippingProviderId');
	      }
	    },
	    getResources: function getResources() {
	      var _this = this;
	
	      this.loading = true;
	      Promise.all([_shippingProvider2.default.warehouseShippingProvider(this.warehouseId), _organizationSettings2.default.show()]).then(function (data) {
	        _this.loading = false;
	        if (data[0].length == 0) {
	          _this.displayError = true;
	          _this.loading = false;
	        } else {
	          _this.loading = false;
	          _this.form.shippingProviderId = data[0][0].id;
	        }
	        _this.shippingProviders = data[0];
	        _this.setShippingProviders(_this.shippingProviders);
	      });
	    },
	    store: function store() {
	      var _this2 = this;
	
	      this.loading = false;
	      this.form.loading = true;
	      var client = _shippingConfirm2.default.send(Object.assign({}, this.form.data()));
	
	      client.order_confirm_notification = this.orderConfirmNotification;
	
	      return _order2.default.confirmShipping(this.currentOrder.id, client).then(function (data) {
	        _this2.loading = false;
	        _this2.$message({
	          showClose: true,
	          message: _this2.$t('static.ediOrders.edit.confirmSuccess'),
	          customClass: 'success'
	        });
	        if (_this2.currentOrder.orderType === 'EDI') {
	          _ediOrder2.default.show(_this2.currentOrder.ediOrderId);
	        }
	        _this2.closeModal();
	      }).catch(function (errors) {
	        _this2.loading = false;
	        _this2.form.loading = false;
	        var message = _this2.$t('static.ediOrders.edit.confirmError');
	        if (errors.data.delivery_date) {
	          message = errors.data.delivery_date[0];
	        }
	
	        if (errors.data.shipping_date) {
	          message = errors.data.shipping_date[0];
	        }
	
	        if (errors.data.shipping_provider_id) {
	          message = errors.data.shipping_provider_id[0];
	        }
	
	        if (errors.data.data.warehouse === 'inactive') {
	          message = errors.data.message;
	        }
	
	        _this2.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _batchOptions = __webpack_require__(201);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _batch = __webpack_require__(60);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _tax = __webpack_require__(128);
	
	var _tax2 = _interopRequireDefault(_tax);
	
	var _orderProduct2 = __webpack_require__(48);
	
	var _orderProduct3 = _interopRequireDefault(_orderProduct2);
	
	var _unitType = __webpack_require__(235);
	
	var _unitType2 = _interopRequireDefault(_unitType);
	
	var _productDeposit = __webpack_require__(96);
	
	var _productDeposit2 = _interopRequireDefault(_productDeposit);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _quickProductEdit = __webpack_require__(278);
	
	var _quickProductEdit2 = _interopRequireDefault(_quickProductEdit);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _bulkAddProductModal = __webpack_require__(122);
	
	var _bulkAddProductModal2 = _interopRequireDefault(_bulkAddProductModal);
	
	var _orderWarehousePopup = __webpack_require__(417);
	
	var _orderWarehousePopup2 = _interopRequireDefault(_orderWarehousePopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        id: {
	          value: '',
	          type: 'text'
	        },
	        name: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        note: {
	          value: '',
	          type: 'text'
	        },
	        batchIds: {
	          value: [],
	          type: 'select'
	        },
	        transactions: {
	          value: '',
	          type: 'plaintext'
	        },
	        available: {
	          value: '',
	          type: 'plaintext'
	        },
	        price: {
	          value: '',
	          type: 'float'
	        },
	        productDepositName: {
	          value: '',
	          type: 'plaintext'
	        },
	        unitTypeId: {
	          value: '',
	          type: 'select'
	        },
	        unitQuantity: {
	          value: '0',
	          type: 'float'
	        },
	        quantity: {
	          value: '0',
	          type: 'float'
	        },
	        discount: {
	          value: '',
	          type: 'number'
	        },
	        taxId: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      hiddenFields: ['id'],
	      additionalButtons: [{
	        text: this.$t('table.orderProducts.addProductsButton'),
	        action: this.showBulkAddProductModal
	      }],
	      linesLoading: true
	    };
	  },
	
	
	  props: {
	    order: {
	      type: Object,
	      required: true
	    },
	
	    billRoundInvoiceTotal: {
	      type: Boolean,
	      required: false
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    taxes: 'allTaxes',
	    orderProducts: 'allOrderProducts',
	    productDeposits: 'allProductDeposits',
	    account: 'account',
	    settings: 'organizationSettings',
	    batches: 'allBatches',
	    currentOrder: 'currentOrder',
	    unitTypes: 'allUnitTypes'
	  }), {
	    checkHasInventory: function checkHasInventory() {
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    },
	    hasProduction: function hasProduction() {
	      if (this.account.modules.length > 0) {
	        return this.account.modules.find(function (module) {
	          return module.name === 'Production';
	        });
	      }
	      if (this.account.allowProducerBatches) return true;
	      return false;
	    },
	    list: function list() {
	      var _this = this;
	
	      return this.orderProducts.map(function (p) {
	        var deposit = [];
	        if (p.productDepositId) {
	          deposit = _this.productDeposits.all.filter(function (d) {
	            return p.productDepositId.toString() === d.id.toString();
	          });
	        }
	
	        var value = '';
	        if (deposit.length) {
	          value = _this.$t('static.orders.edit.deposit') + ': ' + deposit[0].name;
	        }
	
	        if (!_this.checkHasInventory) {
	          _this.form.removeField('available');
	        }
	
	        var nonBatchProduct = p.warehouses.filter(function (p) {
	          return p.warehouseId === _this.order.warehouseId.toString();
	        }).find(function (p) {
	          return p.batchId === 0;
	        });
	        var batchIds = [];
	        if (p.batchIds.length) {
	          batchIds = batchIds.concat(p.batchIds.map(function (id) {
	            return id.toString();
	          }));
	        } else if (nonBatchProduct) {
	          batchIds = ['0'];
	        }
	
	        var transactions = p.warehouseTransactions.map(function (t) {
	          var batchObj = t.batch_id ? _this.batches.find(function (b) {
	            return +b.id === +t.batch_id;
	          }) : '';
	          var batch = batchObj ? batchObj.code : '' + _this.$t('static.orders.edit.nonBatch');
	          return batch + ' ( qty: ' + t.adjustment_qty + ' )';
	        });
	
	        var row = {
	          batchIds: batchIds,
	          transactions: transactions ? transactions.join(', ') : '',
	          productDepositName: value,
	          price: p.price.toString().replace(/\./g, ',')
	        };
	        if (p.taxPercentage !== undefined && p.taxPercentage !== null) {
	          row.taxIdDisplay = p.taxPercentage;
	        }
	        return Object.assign({}, p, row);
	      });
	    },
	    totalsTableList: function totalsTableList() {
	      var fmt = function fmt(val) {
	        return Number(val).toLocaleString('nb-NO', {
	          minimumFractionDigits: 2,
	          maximumFractionDigits: 2
	        });
	      };
	
	      var result = [{
	        name: this.$t('static.orders.edit.subtotal'),
	        value: fmt(this.subtotal)
	      }, {
	        name: this.$t('static.orders.edit.tax'),
	        value: fmt(this.tax)
	      }];
	
	      if (this.discount > 0) {
	        result.push({
	          name: this.$t('static.orders.edit.discount'),
	          value: fmt(this.discount)
	        });
	      }
	
	      if (this.deposit > 0) {
	        result.push({
	          name: this.$t('static.orders.edit.deposit'),
	          value: fmt(this.deposit)
	        });
	      }
	
	      result.push({
	        name: this.$t('static.orders.edit.total'),
	        value: fmt(this.total)
	      });
	
	      return result;
	    },
	    isShownOnBill: function isShownOnBill() {
	      if (this.$route.name === 'bills.create') {
	        return this.order.roundInvoiceTotal;
	      }
	
	      return this.billRoundInvoiceTotal;
	    },
	    subtotal: function subtotal() {
	      return this.orderProducts.map(function (p) {
	        return p.price * p.quantity;
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    discount: function discount() {
	      return this.orderProducts.map(function (p) {
	        return p.price * p.quantity * (p.discount / 100);
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    tax: function tax() {
	      return this.orderProducts.map(function (p) {
	        return p.price * p.quantity * (1 - p.discount / 100) * (p.taxPercentage / 100);
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    deposit: function deposit() {
	      return this.orderProducts.map(function (p) {
	        return p.productDeposit * p.quantity;
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0).toFixed(2);
	    },
	    total: function total() {
	      var total = Number(this.subtotal - this.discount);
	      var totalTax = Number(this.deposit) + total + Number(this.tax);
	
	      if (this.isShownOnBill) {
	        return Math.round(totalTax);
	      }
	
	      return totalTax.toFixed(2);
	    },
	    rounding: function rounding() {
	      var total = Number(this.subtotal - this.discount);
	      var totalTax = total + Number(this.tax);
	      var roundedDecimal = (totalTax % 1).toFixed(2);
	
	      if (roundedDecimal < 0.50) {
	        return -roundedDecimal;
	      }
	
	      return roundedDecimal;
	    }
	  }),
	
	  watch: {
	    order: function order() {
	      this.getResources();
	    },
	    currentOrder: function currentOrder(_currentOrder) {
	      if (_currentOrder.orderStatus !== 'created') {
	        this.hiddenFields.push('available');
	      }
	
	      if (_currentOrder.orderStatus === 'confirmed' || _currentOrder.orderStatus === 'shipping_confirmed') {
	        this.additionalButtons = [];
	      }
	    },
	    orderProducts: function orderProducts(_orderProducts) {
	      this.configFieldVisibility();
	      var beverageProducts = _orderProducts.filter(function (p) {
	        return p.productType === 'Beverage' || p.productTypeGroup === 'Beverage';
	      });
	      if (!beverageProducts.length) {
	        this.hiddenFields.push('unitTypeId');
	        this.hiddenFields.push('unitQuantity');
	        this.form.enableField('quantity');
	      } else if (this.hiddenFields.indexOf('unitTypeId') !== -1) {
	        this.hiddenFields.splice(this.hiddenFields.indexOf('unitTypeId'), 1);
	        this.hiddenFields.splice(this.hiddenFields.indexOf('unitQuantity'), 1);
	        this.form.disableField('quantity');
	      }
	
	      if (this.order.client.clientType.id === 11) {
	        this.hiddenFields.push('taxId');
	      }
	    },
	    unitTypes: function unitTypes(_unitTypes) {
	      this.form.setOptions('unitTypeId', _unitTypes.all.map(function (item) {
	        return {
	          id: item.id.toString(),
	          name: item.name
	        };
	      }));
	    },
	
	    'form.name': function formName() {
	      var _this2 = this;
	
	      if (_typeof(this.form.name) === 'object') {
	        var tax = this.taxes.all.filter(function (t) {
	          return t.taxPercentage === _this2.form.name.taxPercentage;
	        });
	        if (tax.length > 0) {
	          this.form.taxId = tax[0].id;
	        }
	        if (_typeof(this.form.name.options) === 'object') {
	          this.form.price = this.getPriceByClientType(this.form.name.options);
	        } else {
	          this.form.price = this.getPriceByClientType(this.form.name);
	        }
	
	        this.form.note = this.form.name.orderProductNote;
	        this.form.id = this.form.name.id;
	      }
	    },
	
	    'form.id': function formId(id) {
	      var _this3 = this;
	
	      if (id && this.hasProduction) {
	        if (+this.$refs.formTable.$data.editingItem === +id) {
	          if (this.checkHasInventory) {
	            if (!this.currentOrder.warehouseId && this.currentOrder.orderStatus !== 'cancelled') {
	              this.$refs.formTable.closeForm();
	              this.activateWarehouseModal();
	              return;
	            }
	          }
	        }
	
	        var orderProduct = this.list.find(function (item) {
	          return item.id === id;
	        });
	
	        if (!orderProduct && _typeof(this.form.name) === 'object') {
	          orderProduct = this.form.name;
	        }
	
	        if (orderProduct && orderProduct.warehouses) {
	          var products = orderProduct.warehouses;
	          if (products.length) {
	            if (this.currentOrder.warehouseId) {
	              products = products.filter(function (p) {
	                return p.warehouseId === _this3.currentOrder.warehouseId.toString();
	              });
	            }
	
	            var batchIds = products.map(function (p) {
	              return p.batchId.toString();
	            });
	
	            var options = [];
	            options = options.concat(this.batches.filter(function (b) {
	              return batchIds.indexOf(b.id) !== -1;
	            }).map(function (batch) {
	              var batchProduct = products.find(function (p) {
	                return p.batchId.toString() === batch.id.toString();
	              });
	              return Object.assign({}, {
	                id: batch.id.toString(),
	                name: _this3.currentOrder.warehouseId ? batch.code + ' | ' + _this3.$t('static.orders.edit.availableQty') + ': ' + batchProduct.qtyNumber : batch.code,
	                available: batchProduct.qtyNumber
	              });
	            }));
	            options = options.reverse();
	
	            var nonBatchProduct = products.find(function (p) {
	              return p.batchId === 0;
	            });
	            if (nonBatchProduct) {
	              options.unshift({
	                id: '0',
	                name: this.$t('static.orders.edit.nonBatch') + ' | ' + this.$t('static.orders.edit.availableQty') + ': ' + nonBatchProduct.qtyNumber,
	                available: nonBatchProduct.qtyNumber
	              });
	            }
	
	            if (this.currentOrder.warehouseId) {
	              options = (0, _batchOptions.sortBatchOptions)(options, { hideEmpty: true, keepId: this.form.batchId });
	            }
	
	            this.form.setOverrideOptions('batchIds', options);
	            if (!this.form.batchId && batchIds.length) {
	              this.form.batchId = this.currentOrder.warehouseId ? (0, _batchOptions.defaultBatchId)(options) : batchIds[0];
	            }
	          } else {
	            this.form.batchId = '';
	            this.form.setOverrideOptions('batchIds', []);
	          }
	        } else {
	          this.form.batchId = '';
	          this.form.setOverrideOptions('batchIds', []);
	        }
	      }
	      if (id) {
	        var _orderProduct = this.list.find(function (item) {
	          return item.id === id;
	        });
	
	        if (!_orderProduct && _typeof(this.form.name) === 'object') {
	          _orderProduct = this.form.name;
	        }
	        if (this.order.orderStatus === 'created') {
	          if (_orderProduct && _orderProduct.productTypeGroup != 'Beverage') {
	            this.form.disableField('unitTypeId');
	            this.form.disableField('unitQuantity');
	            this.form.enableField('quantity');
	          } else {
	            this.form.enableField('unitTypeId');
	            this.form.enableField('unitQuantity');
	            this.form.disableField('quantity');
	          }
	        }
	      }
	    },
	
	    batches: function batches(_batches) {
	      var options = _batches.map(function (batch) {
	        return {
	          id: +batch.id,
	          name: batch.code
	        };
	      });
	      this.form.setOptions('batchIds', [{
	        id: 0,
	        name: '' + this.$t('static.orders.edit.nonBatch')
	      }].concat(_toConsumableArray(options)));
	    },
	
	
	    'form.batchIds': function formBatchIds(batchIds) {
	      var _this4 = this;
	
	      if (this.hasProduction) {
	        var orderProduct = this.list.find(function (item) {
	          return item.id === _this4.form.id;
	        });
	        if (!orderProduct && _typeof(this.form.name) === 'object') {
	          orderProduct = this.form.name;
	        }
	        if (orderProduct) {
	          var products = orderProduct.warehouses;
	          if (this.order.warehouseId) {
	            products = products.filter(function (p) {
	              return p.warehouseId === _this4.order.warehouseId.toString();
	            });
	          }
	          var batchProducts = products.filter(function (p) {
	            return batchIds.includes(p.batchId.toString());
	          });
	          var available = 0;
	          if (batchProducts.length) {
	            available = batchProducts.map(function (item) {
	              return item.qtyNumber;
	            }).reduce(function (total, qtyNumber) {
	              return total + qtyNumber;
	            });
	          }
	          this.form.available = available.toString();
	        }
	      }
	    },
	
	    taxes: function taxes(_taxes) {
	      this.form.setOptions('taxId', _taxes.all.map(function (tax) {
	        return { id: tax.id, name: tax.taxPercentage.toString() };
	      }));
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalClass: 'SET_MODAL_CLASS'
	  }), {
	    activateWarehouseModal: function activateWarehouseModal() {
	      this.setModalContent(function () {
	        return _orderWarehousePopup2.default;
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    configFieldVisibility: function configFieldVisibility() {
	      var _this5 = this;
	
	      if (!this.hasProduction) {
	        this.hiddenFields = ['id', 'batchIds', 'transactions'];
	      } else {
	        this.hiddenFields = ['id'];
	        if (this.order.orderStatus !== 'created') {
	          this.hiddenFields.push('available');
	          this.hiddenFields.push('batchIds');
	        } else {
	          this.hiddenFields.push('transactions');
	        }
	      }
	
	      if (this.order.orderStatus !== 'created') {
	        Object.keys(this.form.fields).forEach(function (field) {
	          if (field !== 'price') {
	            _this5.form.disableField(field);
	          }
	        });
	      }
	    },
	    getPriceByClientType: function getPriceByClientType(item) {
	      if (!this.order.client.clientType.name.includes('vinmonopolet')) {
	        return item.salePriceHoreca || item.price;
	      }
	      return item.ddpVmp || item.price;
	    },
	    toFloat: function toFloat(number) {
	      return parseFloat(number.replace(/\s/g, '').replace(/,(\d+)$/, '.$1'));
	    },
	    showBulkAddProductModal: function showBulkAddProductModal() {
	      if (this.hasProduction && this.checkHasInventory) {
	        if (!this.currentOrder.warehouseId && this.currentOrder.orderStatus !== 'cancelled') {
	          this.$refs.formTable.closeForm();
	          this.activateWarehouseModal();
	          return;
	        }
	      }
	      this.setModalContent(function () {
	        return _bulkAddProductModal2.default;
	      });
	      this.setModalProps({
	        isOrderPage: true,
	        warehouseId: this.order.warehouseId,
	        batches: this.batches,
	        fetchProductsMethod: this.fetchAllProductsBasic,
	        onSave: this.handleBulkProductSave
	      });
	      this.toggleModal(true);
	    },
	    fetchAllProductsBasic: function fetchAllProductsBasic() {
	      return Promise.all([_product2.default.allBasic({ filter: 'active', include: 'warehouses' })]);
	    },
	    searchMethod: function searchMethod(search) {
	      return Promise.all([_product2.default.search({ search: search, filter: 'active', warehouse_id: this.order.warehouseId })]);
	    },
	    handleBulkProductSave: function handleBulkProductSave(selectedProducts) {
	      var _this6 = this;
	
	      var id = this.order.id;
	      var data = selectedProducts.map(function (p) {
	        return {
	          productId: p.id,
	          name: p.name,
	          quantity: p.qty,
	          unitQuantity: p.unitQty,
	          unitTypeId: p.unitTypeId.toString(),
	          productDepositId: p.productDepositId,
	          taxId: p.taxId,
	          price: p.price,
	          discount: 0,
	          note: '',
	          batchId: p.batchId || ''
	        };
	      });
	
	      return _orderProduct3.default.bulkStore(id, data).then(function () {
	        _this6.form.loading = false;
	      });
	    },
	    onQuickProductEditMounted: function onQuickProductEditMounted() {
	      var that = this;
	      return function () {
	        var _this7 = this;
	
	        this.$once('close', function () {
	          _product2.default.show(_this7.orderProduct.productId).then(function (data) {
	            that.form.assignData(_this7.orderProduct);
	            that.form.assignData(data);
	            that.update(_this7.orderProduct.id).then(function () {
	              that.form.resetValues();
	            });
	          });
	        });
	      };
	    },
	    updated: function updated(product, orderProduct) {
	      this.form.assignData(orderProduct);
	      this.form.assignData(product);
	      return this.quickUpdateProduct(orderProduct.id, product);
	    },
	    tableClickHandler: function tableClickHandler(item, name) {
	      var _this8 = this;
	
	      if (!this.order.sent && item.productId && name === 'name' && !item.bundleGroupId) {
	        return function () {
	          _this8.setModalProps({
	            productId: item.productId,
	            orderProduct: item,
	            onMounted: _this8.onQuickProductEditMounted(),
	            updated: _this8.updated
	          });
	          _this8.setModalContent(function () {
	            return _quickProductEdit2.default;
	          });
	          _this8.toggleModal(true);
	        };
	      }
	
	      return false;
	    },
	    save: function save() {
	      var _this9 = this;
	
	      this.form.loading = true;
	
	      var id = this.order.id;
	      var data = this.form.data();
	
	      if (data.name.id === undefined) {
	        this.$message({
	          showClose: true,
	          customClass: 'error',
	          message: this.$t('static.orders.orderTable.productErrorMessage')
	        });
	        return Promise.all([]);
	      }
	
	      var selectedProduct = data.name;
	
	      data.name = selectedProduct.name;
	      data.productId = selectedProduct.id;
	      data.productDepositId = selectedProduct.productDepositId;
	
	      return new Promise(function (resolve, reject) {
	        _orderProduct3.default.store(id, data).then(function () {
	          _orderProduct3.default.all(_this9.order.id);
	          _this9.form.loading = false;
	          _store2.default.dispatch('addOrderProduct', data);
	          resolve();
	        }).catch(function (errors) {
	          _this9.form.loading = false;
	          var message = '';
	          if (errors.code) {
	            message = errors.message;
	          } else {
	            _this9.form.recordErrors(errors);
	            var errorsKeys = Object.keys(_this9.form.errors.errors);
	            message = errors[errorsKeys[0]][0];
	          }
	          _this9.$message({
	            showClose: true,
	            customClass: 'error',
	            message: message
	          });
	          reject();
	        });
	      });
	    },
	    quickUpdateProduct: function quickUpdateProduct(orderProductId, product) {
	      var _this10 = this;
	
	      this.form.loading = true;
	
	      var id = this.order.id;
	      var data = this.form.data();
	      var selected = data.name;
	
	      var new_product = [];
	
	      data.name = _typeof(data.name) === 'object' ? data.name.name : data.name;
	      data.productDepositId = product.productDepositId ? product.productDepositId : null;
	
	      return new Promise(function (resolve, reject) {
	        _orderProduct3.default.update(id, data, orderProductId).then(function () {
	          _orderProduct3.default.all(_this10.order.id);
	          _this10.form.loading = false;
	          _store2.default.dispatch('updateOrderProduct', { orderProduct: data, id: orderProductId });
	          resolve();
	        }).catch(function (errors) {
	          _this10.form.loading = false;
	          _this10.form.recordErrors(errors);
	          var errorsKeys = Object.keys(_this10.form.errors.errors);
	          _this10.$message({
	            showClose: true,
	            message: errors[errorsKeys[0]][0],
	            customClass: 'error'
	          });
	          reject();
	        });
	      });
	    },
	    update: function update(orderProductId) {
	      var _this11 = this;
	
	      this.form.loading = true;
	
	      var id = this.order.id;
	      var data = this.form.data();
	      var selectedProduct = data.name;
	
	      if ((typeof selectedProduct === 'undefined' ? 'undefined' : _typeof(selectedProduct)) === 'object') {
	        data.name = selectedProduct.name;
	        data.productId = selectedProduct.id;
	        data.productDepositId = selectedProduct.productDepositId;
	      } else {
	        var orderProduct = this.orderProducts.find(function (op) {
	          return +op.id === +orderProductId;
	        });
	        data.name = orderProduct.name;
	        data.productId = orderProduct.productId;
	        data.productDepositId = orderProduct.productDepositId;
	      }
	
	      return new Promise(function (resolve, reject) {
	        _orderProduct3.default.update(id, data, orderProductId).then(function () {
	          _orderProduct3.default.all(_this11.order.id);
	          _this11.form.loading = false;
	          _store2.default.dispatch('updateOrderProduct', { orderProduct: data, id: orderProductId });
	          resolve();
	        }).catch(function (errors) {
	          _this11.form.loading = false;
	          _this11.form.recordErrors(errors);
	          var errorsKeys = Object.keys(_this11.form.errors.errors);
	          _this11.$message({
	            showClose: true,
	            message: errors[errorsKeys[0]][0],
	            customClass: 'error'
	          });
	          reject();
	        });
	      });
	    },
	    destroy: function destroy(orderProductId) {
	      var _this12 = this;
	
	      return new Promise(function (resolve, reject) {
	        _orderProduct3.default.destroy(_this12.order.id, orderProductId).then(function () {
	          resolve();
	        }).catch(function () {
	          reject();
	        });
	      });
	    },
	    getResources: function getResources() {
	      var _this13 = this;
	
	      this.linesLoading = true;
	      var resources = [_tax2.default.all(), _orderProduct3.default.all(this.order.id), _productDeposit2.default.all(), _unitType2.default.all()];
	      if (this.hasProduction) {
	        resources.push(_batch2.default.all({
	          warehouse_id: this.order.warehouseId,
	          has_warehouse_transaction: 1,
	          for_select: 1
	        }));
	      }
	      Promise.all(resources).then(function () {
	        _this13.linesLoading = false;
	      }).catch(function () {
	        _this13.linesLoading = false;
	      });
	    }
	  }),
	
	  mounted: function mounted() {
	    var _this14 = this;
	
	    this.getResources();
	    Promise.all([_organizationSettings2.default.show()]).then(function (data) {
	      _this14.form.setDisplays('name', data[0].productInfoDisplay);
	    });
	    this.configFieldVisibility();
	    this.form.setExtraAttr('batchIds', {
	      multiple: true
	    });
	    if (this.order.sent || this.order.orderStatus !== 'created') {
	      this.additionalButtons = [];
	    }
	  },
	
	
	  components: {
	    VFormTable: __webpack_require__(46),
	    VTotalsTable: __webpack_require__(279)
	  }
	};

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _order = __webpack_require__(54);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _store2 = __webpack_require__(2);
	
	var _store3 = _interopRequireDefault(_store2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        warehouseId: {
	          type: 'select',
	          value: ''
	        }
	      }),
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    warehouses: 'allWarehouses',
	    account: 'account',
	    currentOrder: 'currentOrder',
	    currentEdiOrder: 'currentEdiOrder',
	    settings: 'organizationSettings'
	  }), {
	    isZNB: function isZNB() {
	      return this.currentEdiOrder && this.currentEdiOrder.ediOrderTypeName === 'ZNB';
	    }
	  }),
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    Promise.all([_warehouse2.default.all(), _organizationSettings2.default.show()]).then(function () {
	      _this.loading = false;
	      if (_this.currentOrder.warehouse.isActive === true) {
	        _this.form.warehouseId = _this.currentOrder.warehouseId || _this.settings.defaultWarehouse;
	      }
	    });
	  },
	
	
	  watch: {
	    warehouses: function warehouses(_warehouses) {
	      var result = _warehouses.items.filter(function (obj) {
	        return obj.isActive === true;
	      });
	      var hasModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            hasModule = true;
	            this.form.setOptions('warehouseId', result);
	          }
	        }
	      }
	
	      if (!hasModule) {
	        this.form.hideField('warehouseId');
	      }
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    store: function store() {
	      var _this2 = this;
	
	      this.loading = false;
	      this.form.loading = true;
	      var data = Object.assign({}, this.currentOrder, {
	        warehouseId: this.form.warehouseId
	      });
	      return _order2.default.update(_store3.default.state.route.params.id, data).then(function () {
	        _this2.loading = false;
	        _this2.$message({
	          showClose: true,
	          message: _this2.$t('static.ediOrders.edit.warehouseChanged'),
	          customClass: 'success'
	        });
	        if (_this2.isZNB) {
	          _this2.setModalContent(function () {
	            return __webpack_require__(277);
	          });
	        } else {
	          _this2.closeModal();
	        }
	      }).catch(function (errors) {
	        _this2.loading = false;
	        _this2.form.loading = false;
	        var message = errors.data.message;
	        if (errors.data.confirm_date) {
	          message = errors.data.confirm_date[0];
	        }
	
	        _this2.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	      });
	    },
	    activateModalEdi: function activateModalEdi() {
	      this.setModalClass('order-confirm');
	      this.setModalContent(function () {
	        return __webpack_require__(277);
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(true);
	      this.setModalCloseOnPressEscape(false);
	    },
	    closeModal: function closeModal() {
	      if (this.currentOrder.warehouseId) {
	        this.toggle(false);
	        this.unsetModalContent();
	      } else {
	        this.$router.push({
	          name: 'orders.index'
	        });
	        this.toggle(false);
	        this.unsetModalContent();
	      }
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _ediOrderItem = __webpack_require__(457);
	
	var _ediOrderItem2 = _interopRequireDefault(_ediOrderItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      ready: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    ediOrderItems: 'allEdiOrderItems'
	  }), {
	    showTable: function showTable() {
	      if (this.ediOrderItems.length > 0) {
	        return true;
	      }
	
	      return false;
	    }
	  }),
	
	  props: {
	    order: {
	      type: Object,
	      required: true
	    }
	  },
	
	  methods: {
	    getResources: function getResources() {
	      var _this = this;
	
	      Promise.all([_ediOrderItem2.default.all(this.order.ediOrderId)]).then(function () {
	        _this.ready = true;
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    this.getResources();
	    return;
	  },
	
	
	  components: {
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _widgets = __webpack_require__(98);
	
	var _widgets2 = _interopRequireDefault(_widgets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            cardItems: [],
	            allWidgets: []
	        };
	    },
	
	
	    computed: _extends({}, (0, _vuex.mapGetters)(['widgets', 'availableWidgets'])),
	
	    methods: _extends({}, (0, _vuex.mapMutations)({
	        toggleModal: 'TOGGLE_MODAL'
	    }), {
	        addWidget: function addWidget(widget, index) {
	            var _this = this;
	
	            if (this.widgets.items != 'no_widget' && this.widgets.items.length > 0) this.cardItems = this.readSerialize(this.widgets.items);
	            this.cardItems.push({ title: widget.title, sub: widget.subtitle, desc: widget.desc, key: widget.key });
	            _widgets2.default.updateUserWidgets(this.cardItems).then(function () {
	                _this.allWidgets[index].disable = true;
	            });
	        },
	        closeModal: function closeModal() {
	            this.toggleModal(false);
	        },
	        readSerialize: function readSerialize(value) {
	            var newJson = value.replace(/([a-zA-Z0-9]+?):/g, '"$1":');
	            newJson = newJson.replace(/'/g, '"');
	            return JSON.parse(newJson);
	        },
	        filterDisable: function filterDisable() {
	            if (this.$store.getters.widgets.items != 'no_widget' && this.$store.getters.widgets.items.length > 0) {
	                var self = this;
	                this.readSerialize(this.$store.getters.widgets.items).forEach(function (item) {
	                    self.allWidgets.forEach(function (item2) {
	                        if (item.key === item2.key) item2.disable = true;
	                    });
	                });
	            }
	        },
	        initializeWidgets: function initializeWidgets() {
	            var _this2 = this;
	
	            Promise.all([_widgets2.default.fetchAvailableWidgets()]).then(function () {
	                var self = _this2;
	                _this2.availableWidgets.items.avialableWidgetsData.forEach(function (item, key) {
	                    self.allWidgets.push({ 'title': item.title, 'desc': item.desc, 'subtitle': item.subtitle, 'key': item.key, 'disable': false });
	                });
	                _this2.filterDisable();
	            });
	        }
	    }),
	
	    created: function created() {
	        this.initializeWidgets();
	    }
	};

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    switchFunction: {
	      type: Function,
	      required: true
	    },
	
	    pagination: {
	      type: Object,
	      required: true
	    }
	  },
	
	  computed: {
	    previousDisabled: function previousDisabled() {
	      return this.pagination.currentPage <= 1;
	    },
	    nextDisabled: function nextDisabled() {
	      return this.pagination.currentPage >= this.pagination.lastPage;
	    }
	  },
	
	  methods: {
	    goToPage: function goToPage(page) {
	      this.switchFunction(page, this.pagination.limit);
	    },
	    previousPage: function previousPage() {
	      if (!this.previousDisabled) {
	        this.goToPage(this.pagination.currentPage - 1);
	      }
	    },
	    nextPage: function nextPage() {
	      if (!this.nextDisabled) {
	        this.goToPage(this.pagination.currentPage + 1);
	      }
	    }
	  }
	};

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    switchFunction: {
	      type: Function,
	      required: true
	    },
	
	    totalSizeOfItem: {
	      type: Number,
	      required: false
	    },
	
	    sizePerPage: {
	      type: Function,
	      required: false
	    },
	
	    pagination: {
	      type: Object,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      pageSizes: [],
	      defaultPageSize: 25
	    };
	  },
	
	  methods: {
	    handleSizeChange: function handleSizeChange(val) {
	      this.switchFunction(this.pagination.currentPage, val);
	      if (typeof this.sizePerPage !== 'undefined') this.sizePerPage(val);
	    },
	    handleCurrentChange: function handleCurrentChange(val) {
	      this.switchFunction(val, this.pagination.limit);
	    },
	    sortLimits: function sortLimits(value) {
	      value.sort(function (a, b) {
	        return a - b;
	      });
	    }
	  },
	
	  created: function created() {
	
	    this.pageSizes = [5, 10, 25, 50, 100, 150, 300];
	    if (this.totalSizeOfItem) {
	      this.pageSizes.push(this.totalSizeOfItem);
	      this.sortLimits(this.pageSizes);
	      this.defaultPageSize = this.totalSizeOfItem;
	    }
	  }
	};

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    mod: {
	      type: Object,
	      required: true
	    }
	  },
	
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        poweroffice_client_key: { type: 'text', value: '' },
	        poweroffice_company_slug: { type: 'text', value: '' },
	        poweroffice_integration_type: { type: 'select', value: '' }
	      }),
	
	      loading: false
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	
	    Promise.all([this.loadSettings()]).finally(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    loadSettings: function loadSettings() {
	      var _this2 = this;
	
	      return _organizationSettings2.default.show().then(function (settings) {
	        console.log('[PowerOffice] Raw organization settings:', settings);
	
	        settings = settings || {};
	
	        var norm = function norm(obj, key) {
	          if (obj[key] !== undefined && obj[key] !== null) {
	            return obj[key];
	          }
	          var snake = key.replace(/([A-Z])/g, '_$1').toLowerCase();
	          if (obj[snake] !== undefined && obj[snake] !== null) {
	            return obj[snake];
	          }
	          return '';
	        };
	
	        var clientKey = norm(settings, 'powerofficeClientKey');
	        var companySlug = norm(settings, 'powerofficeCompanySlug');
	        var appKey = norm(settings, 'powerofficeAppKey');
	        var integrationType = norm(settings, 'powerofficeIntegrationType');
	
	        console.log('[PowerOffice] Normalized values:', {
	          powerofficeClientKey: clientKey,
	          powerofficeCompanySlug: companySlug,
	          powerofficeAppKey: appKey,
	          powerofficeIntegrationType: integrationType
	        });
	
	        if (typeof _this2.form.set === 'function') {
	          _this2.form.set('poweroffice_client_key', String(clientKey).trim());
	          _this2.form.set('poweroffice_company_slug', String(companySlug).trim());
	          _this2.form.set('poweroffice_integration_type', String(integrationType).trim());
	        } else {
	          _this2.form.fields.poweroffice_client_key = {
	            type: 'text',
	            value: String(clientKey).trim()
	          };
	          _this2.form.fields.poweroffice_company_slug = {
	            type: 'text',
	            value: String(companySlug).trim()
	          };
	          _this2.form.fields.poweroffice_integration_type = {
	            type: 'select',
	            value: String(integrationType).trim()
	          };
	        }
	
	        return true;
	      }).catch(function (err) {
	        console.error('[PowerOffice] Failed to load settings:', err);
	        _this2.$message({
	          showClose: true,
	          message: 'Failed to load PowerOffice settings.',
	          customClass: 'error'
	        });
	      });
	    },
	    saveSettings: function saveSettings() {
	      var _this3 = this;
	
	      this.loading = true;
	
	      var payload = {
	        module_id: this.mod.id,
	        poweroffice_client_key: this.form.fields.poweroffice_client_key.value,
	        poweroffice_company_slug: this.form.fields.poweroffice_company_slug.value,
	        poweroffice_integration_type: this.form.fields.poweroffice_integration_type.value
	      };
	
	      _modules2.default.subscribe(this.mod.id, payload).then(function () {
	        _this3.$message({
	          showClose: true,
	          message: 'PowerOffice settings updated successfully.',
	          type: 'success'
	        });
	
	        return Promise.all([_modules2.default.items(), _organizationSettings2.default.show()]);
	      }).catch(function () {
	        _this3.$message({
	          showClose: true,
	          message: 'Failed to update PowerOffice settings.',
	          customClass: 'error'
	        });
	      }).finally(function () {
	        _this3.loading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggleModal(false);
	      this.unsetModalContent();
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	  data: function data() {
	    return {
	      emailTo: [],
	      emailcc: this.ccEmail,
	      previewMessage: this.message,
	      previewSubject: this.subject,
	
	      previewNotes: this.notes,
	      attachmentServer: this.server,
	      attachmentInit: this.initFiles
	    };
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    modalButtonLoading: 'modalButtonLoading'
	  }), {
	    ccOptions: function ccOptions() {
	      if (this.ccEmail) {
	        return this.ccEmail.map(function (item) {
	          return {
	            id: item,
	            email: item,
	            name: item
	          };
	        });
	      }
	    },
	    contactOptions: function contactOptions() {
	      if (this.contacts) {
	        return this.contacts.map(function (contact) {
	          return Object.assign({}, {
	            id: contact.id,
	            email: contact.email,
	            name: contact.first_name + ' ' + contact.last_name + ' <' + contact.email + '>'
	          });
	        });
	      }
	    }
	  }),
	  mounted: function mounted() {
	    if (this.server) {
	      this.modifyFilepondView('addfile');
	      this.modifyFilepondView('processfile');
	    }
	  },
	  created: function created() {
	    if (this.contacts) {
	      var accountingContact = this.contacts.find(function (contact) {
	        return contact.contact_types.some(function (type) {
	          return type.name === 'Accounting';
	        });
	      });
	      var primaryContact = this.contacts.find(function (contact) {
	        return contact.contact_types.some(function (type) {
	          return type.name === 'Primary';
	        });
	      });
	      if (this.isMultiSelected) {
	        var tempContact = [];
	        this.contacts.forEach(function (item) {
	          if (typeof item.email !== 'undefined' && item.email !== '') {
	            tempContact.push(item.email);
	          }
	        });
	
	        this.emailTo = tempContact;
	      } else if (accountingContact) {
	        this.emailTo = [accountingContact.email];
	      } else if (primaryContact) {
	        this.emailTo = [primaryContact.email];
	      }
	    }
	    this.updatePreviewParam({ email_cc: this.emailcc });
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    updatePreviewParam: 'UPDATE_PREVIEW_PARAM'
	  }), {
	    ccOptionFilter: function ccOptionFilter(filterValue, allOptions) {
	      if (filterValue !== '') {
	        if (this.validateEmail(filterValue)) jQuery('.ccEmail').removeClass('hidden');else jQuery('.ccEmail').addClass('hidden');
	      }
	    },
	    modifyFilepondView: function modifyFilepondView(type) {
	      var pond = document.querySelector('.filepond--root');
	      pond.addEventListener('FilePond:' + type, function (e) {
	        var url = e.detail.file.serverId;
	        if (type === 'processfile') {
	          url = url.substring(1, url.length - 1);
	          url = url.replace(/\\\//g, '/');
	        }
	        if (url) {
	          var newName = url.split('/').pop();
	          jQuery('#custom_' + e.detail.file.id).remove();
	          jQuery('#filepond--item-' + e.detail.file.id + ' .filepond--file').append('<a id="custom_' + e.detail.file.id + '" href="' + url + '" target="_blank" style="color:white;font-size:16px;"><i class="fa fa-2x fa-external-link-square" aria-hidden="true"></i></a>');
	          jQuery('#filepond--item-' + e.detail.file.id + ' .filepond--file-info .filepond--file-info-main').text(newName);
	        }
	      });
	    },
	    validateEmail: function validateEmail(email) {
	      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      return re.test(String(email).toLowerCase());
	    }
	  }),
	
	  props: {
	    headerTexts: {
	      type: Array,
	      required: false
	    },
	
	    message: {
	      type: String,
	      required: true
	    },
	
	    subject: {
	      type: String,
	      required: true
	    },
	
	    buttons: {
	      type: Array,
	      required: false
	    },
	
	    links: {
	      type: Array,
	      required: false
	    },
	
	    attachments: {
	      type: Array,
	      required: false
	    },
	
	    notes: {
	      type: String,
	      required: false
	    },
	
	    contacts: {
	      type: Array,
	      required: false
	    },
	
	    isEmailInput: {
	      type: Boolean,
	      required: false
	    },
	
	    isMultiSelected: {
	      type: Boolean,
	      required: false
	    },
	
	    server: {
	      type: Object,
	      required: false
	    },
	
	    initFiles: {
	      type: Array,
	      required: false
	    },
	
	    ccEmail: {
	      type: Array,
	      required: false
	    }
	  },
	
	  watch: {
	    previewMessage: function previewMessage() {
	      this.updatePreviewParam({ message: this.previewMessage });
	    },
	    previewSubject: function previewSubject() {
	      this.updatePreviewParam({ subject: this.previewSubject });
	    },
	    previewNotes: function previewNotes() {
	      this.updatePreviewParam({ notes: this.previewNotes });
	    },
	    emailTo: function emailTo() {
	      this.updatePreviewParam({ email_to: this.emailTo });
	    },
	    emailcc: function emailcc() {
	      this.updatePreviewParam({ email_cc: this.emailcc });
	    }
	  }
	};

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      previewMessage: this.message,
	      previewSubject: this.subject,
	      previewEmailTo: this.to,
	      previewEmailCC: this.cc,
	      previewEmailBCC: []
	    };
	  },
	
	  computed: {},
	  mounted: function mounted() {},
	  created: function created() {},
	
	  methods: {},
	
	  props: {
	    message: {
	      type: String,
	      required: true
	    },
	
	    subject: {
	      type: String,
	      required: true
	    },
	
	    to: {
	      type: Array,
	      required: false
	    },
	
	    cc: {
	      type: Array,
	      required: false
	    },
	
	    bcc: {
	      type: Array,
	      required: false
	    }
	  },
	
	  watch: {}
	};

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	  data: function data() {
	    return {
	      previewMessage: this.message,
	      previewSubject: this.subject,
	      previewEmailTo: this.to,
	      previewEmailCC: this.cc
	    };
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    modalButtonLoading: 'modalButtonLoading'
	  })),
	
	  mounted: function mounted() {},
	
	
	  methods: {
	    optionFilter: function optionFilter(filterValue, allOptions) {
	      if (filterValue != '') {
	        if (this.validateEmail(filterValue)) jQuery('.ccEmail').removeClass('hidden');else jQuery('.ccEmail').addClass('hidden');
	      } else {
	        jQuery('.ccEmail').removeClass('hidden');
	      }
	    },
	    validateEmail: function validateEmail(email) {
	      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      return re.test(String(email).toLowerCase());
	    },
	    sendReminder: function sendReminder() {
	      var data = {
	        message: this.previewMessage,
	        subject: this.previewSubject,
	        to: this.previewEmailTo,
	        cc: this.previewEmailCC
	      };
	      this.buttons[1].action(data);
	    }
	  },
	
	  props: {
	    message: {
	      type: String,
	      required: true
	    },
	
	    subject: {
	      type: String,
	      required: true
	    },
	
	    to: {
	      type: Array,
	      required: false
	    },
	
	    cc: {
	      type: Array,
	      required: false
	    },
	
	    buttons: {
	      type: Array,
	      required: false
	    }
	
	  },
	
	  watch: {}
	};

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	
	  props: {
	    productId: {
	      required: true,
	      type: Number
	    }
	  },
	
	  created: function created() {},
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    addMore: function addMore() {
	      this.closeModal();
	      this.$router.push({
	        name: 'products.create'
	      });
	    },
	    edit: function edit() {
	      this.closeModal();
	      this.$router.push({
	        name: 'products.edit',
	        params: {
	          id: this.productId
	        }
	      });
	    },
	    gotoIndex: function gotoIndex() {
	      this.closeModal();
	      this.$router.push({
	        name: 'products.index'
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	
	  props: {
	    errors: {
	      type: Array,
	      default: []
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  })
	};

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _productImportExportErrorReportPopup = __webpack_require__(2729);
	
	var _productImportExportErrorReportPopup2 = _interopRequireDefault(_productImportExportErrorReportPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      server: {
	        url: _helpers2.default.buildUrl(("https://api.kundan.no") + '/products/import', {
	          token: localStorage.getItem('id_token')
	        }),
	        process: {
	          onload: this.import,
	          onerror: this.error
	        }
	      }
	    };
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS'
	  }), {
	    downloadAllProducts: function downloadAllProducts() {
	      window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/products/download', {
	        token: localStorage.getItem('id_token')
	      }));
	    },
	    import: function _import(response) {
	      var _this = this;
	
	      var result = JSON.parse(response);
	      if (result.errors.length === 0) {
	          var params = {
	            page: 1,
	            limit: 50
	          };
	          _store2.default.dispatch('setProductQuery', params);
	          _product2.default.items(params).then(function () {
	            _this.$message({
	              showClose: true,
	              message: _this.$t('static.products.index.importProductsSuccessMessage'),
	              type: 'success'
	            });
	            _this.closeModal();
	          });
	        } else if (result.errors.length) {
	        this.setModalProps({
	          errors: result.errors
	        });
	        this.toggle(true);
	        this.setModalContent(function () {
	          return _productImportExportErrorReportPopup2.default;
	        });
	      } else {
	        var message = result.errors || this.$t('static.products.index.importProductsErrorMessage');
	        if (result.errors) {
	          this.$message({
	            showClose: true,
	            message: message,
	            type: 'error'
	          });
	        }
	      }
	    },
	    error: function error(response) {
	      var result = JSON.parse(response);
	      var message = result.message || this.$t('static.products.index.importProductsErrorMessage');
	      this.$message({
	        showClose: true,
	        message: message,
	        type: 'error'
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      info: 'info',
	      primary: 'primary',
	      group: 'None'
	    };
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    searchQuery: 'productQuery',
	    view: 'getView'
	  })),
	  created: function created() {
	    this.group = this.account.productGrouping;
	    _store2.default.dispatch('setProductGrouping', this.account.productGrouping);
	    if (this.view == 'card') {
	      this.info = 'info';
	      this.primary = 'primary';
	    } else {
	      this.primary = 'info';
	      this.info = 'primary';
	    }
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalClass: 'SET_MODAL_CLASS'
	  }), {
	    handleGroupByChange: function handleGroupByChange(filter) {
	      var value = filter !== 'None' ? filter : '';
	      var query = { page: 1, limit: 50, search: this.searchQuery.search, grouping: value };
	      _store2.default.dispatch('setProductQuery', query);
	      _account2.default.updateProductIndexSettings(this.account.userId, { field: 'product_grouping', value: value });
	    },
	    changeView: function changeView(view) {
	      if (this.info != view) {
	        this.primary = this.info;
	        this.info = view;
	        if (this.info == 'info') {
	          _store2.default.dispatch('setView', 'card');
	        } else {
	          _store2.default.dispatch('setView', 'list');
	        }
	      }
	      _account2.default.updateProductIndexSettings(this.account.userId, {
	        field: 'product_display',
	        value: this.info == 'info' ? 'card' : 'list'
	      });
	    },
	    closeModal: function closeModal() {
	      this.setModalClass('default');
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  })
	
	};

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	
	  props: {
	    form: {
	      type: Object,
	      require: true
	    }
	
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    prices: 'allProductPrices'
	  })),
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    tableClickHandler: function tableClickHandler(item, name) {},
	    save: function save() {
	      var data = this.form.data();
	      var self = this;
	      var price = [];
	      if (data.priceField) {
	        price = this.prices.filter(function (p) {
	          return p.priceField.toString() === data.priceField.toString();
	        });
	
	        if (price.length > 0) {
	          this.$message({
	            showClose: true,
	            customClass: 'error',
	            message: 'Price field already added'
	          });
	          return Promise.reject();
	        }
	      } else {
	        this.$message({
	          showClose: true,
	          customClass: 'error',
	          message: 'Price field not found'
	        });
	        return Promise.reject();
	      }
	
	      _store2.default.dispatch('addProductPrice', data);
	      return Promise.all([]);
	    },
	    update: function update(orderProductId) {
	      var data = this.form.data();
	      var i = -1;
	      for (var index = 0; index < this.prices.length; index++) {
	        if (data.priceField.toString() === this.prices[index].priceField.toString()) {
	          i = index;
	        }
	      }
	
	      _store2.default.dispatch('updateProductPrice', { data: data, i: i });
	      return Promise.all([]);
	    },
	    destroy: function destroy(orderProductId, item) {
	      console.log(item);
	      var i = -1;
	      for (var index = 0; index < this.prices.length; index++) {
	        if (item.priceField.toString() === this.prices[index].priceField.toString()) {
	          i = index;
	        }
	      }
	      _store2.default.dispatch('removeProductPrice', i);
	      return Promise.all([]);
	    }
	  }),
	
	  mounted: function mounted() {},
	
	
	  components: {
	    VFormTable: __webpack_require__(46)
	  }
	};

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _batchOptions = __webpack_require__(201);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _batch = __webpack_require__(60);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _stock = __webpack_require__(162);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _bulkAddProductModal = __webpack_require__(122);
	
	var _bulkAddProductModal2 = _interopRequireDefault(_bulkAddProductModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        productId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        qty: {
	          value: '0',
	          type: 'text'
	        }
	      }),
	      additionalButtons: [{
	        text: this.$t('table.orderProducts.addProductsButton'),
	        action: this.showBulkAddProductModal
	      }],
	      hiddenFields: []
	    };
	  },
	
	
	  props: {
	    fields: {
	      type: Object,
	      required: true
	    },
	    translation: {
	      type: String,
	      required: false,
	      default: 'table.productsCustom'
	    },
	    page: {
	      type: String,
	      required: true
	    },
	    transferType: {
	      type: String,
	      required: false,
	      default: ''
	    },
	    isImport: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	    isExport: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	
	    exportClickHandler: {
	      type: Function,
	      default: function _default() {
	        return false;
	      }
	    },
	    server: {
	      type: Object,
	      default: function _default() {
	        return {};
	      },
	      required: false
	    },
	
	    additionalData: {
	      type: Object,
	      default: function _default() {
	        return {};
	      },
	      required: false
	    },
	
	    disableForm: {
	      type: Boolean,
	      default: function _default() {
	        return false;
	      },
	      required: false
	    }
	
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    products: 'allProducts',
	    currentStockProducts: 'currentStockProductsCustom',
	    currentSelectedWarehouse: 'currentSelectedWarehouse',
	    account: 'account',
	    settings: 'organizationSettings',
	    batches: 'allBatches',
	    transactionTypes: 'allTransactionTypes'
	  }), {
	    transferTypeCode: function transferTypeCode() {
	      var _this = this;
	
	      if (!this.transactionTypes) {
	        return;
	      }
	      var type = this.transactionTypes.find(function (item) {
	        return +item.id === +_this.transferType;
	      });
	      return type ? type.code : '';
	    },
	    isBatchTransferPage: function isBatchTransferPage() {
	      return this.page === 'transfer' && this.transferType && this.transferTypeCode === 'TB';
	    },
	    isTransferToBatchPage: function isTransferToBatchPage() {
	      return this.page === 'transfer' && this.transferType && this.transferTypeCode === 'TTB';
	    },
	    hasProduction: function hasProduction() {
	      if (this.account.allowProducerBatches) return true;
	      if (this.account.modules.length > 0) {
	        return this.account.modules.find(function (m) {
	          return m.name.toString() === 'Production';
	        });
	      }
	      return false;
	    },
	    list: function list() {
	      return [];
	    },
	    checkWarehouse: function checkWarehouse() {
	      if (this.disableForm) return true;
	      return this.currentSelectedWarehouse <= 0;
	    },
	    showImport: function showImport() {
	      return this.isImport;
	    }
	  }),
	
	  watch: {
	    'form.productId': function formProductId(product) {
	      var me = this;
	      if (product.id != undefined) {
	        this.setBatchOptions(product);
	      }
	
	      if (this.page == 'adjustment') {
	        if (this.currentSelectedWarehouse > 0) {
	          if (product.id != undefined) {
	            Promise.all([_stock2.default.warehouseProduct(product.id, this.currentSelectedWarehouse, this.form.batchId)]).then(function (data) {
	              me.form.currentAdjustment = data[0].currentQty;
	            });
	          }
	        }
	      }
	
	      if (this.page == 'stock') {
	        if (this.currentSelectedWarehouse > 0) {
	          if (product.id != undefined) {
	            Promise.all([_stock2.default.warehouseProduct(product.id, this.currentSelectedWarehouse, this.form.batchId)]).then(function (data) {
	              if (!isNaN(me.form.physicalCount)) {
	                me.form.variance = (me.form.physicalCount - data[0].qtyNumber).toFixed(2).replace(/[.,]00$/, '');
	                me.form.currentCount = data[0].qtyNumber;
	              }
	            });
	          }
	        }
	      }
	    },
	
	    'form.batchId': function formBatchId(batchId) {
	      var _this2 = this;
	
	      if (batchId && this.hasProduction) {
	        if (this.page === 'transfer' && this.transferType && this.transferTypeCode === 'TB') {
	          return;
	        }
	        var stockProduct = this.currentStockProducts.find(function (item) {
	          return +item.productId.id === +_this2.form.productId.id;
	        });
	        var currentProduct = stockProduct.product;
	        if (!currentProduct && _typeof(this.form.productId) === 'object') {
	          currentProduct = this.form.productId;
	        }
	        if (currentProduct) {
	          var products = currentProduct.warehouses;
	          if (this.currentSelectedWarehouse) {
	            products = products.filter(function (p) {
	              return p.warehouseId.toString() === _this2.currentSelectedWarehouse.toString();
	            });
	          }
	          var batchProduct = products.find(function (p) {
	            return batchId.toString() === p.batchId.toString();
	          });
	          if (this.page == 'adjustment') {
	            this.form.currentAdjustment = batchProduct.qtyNumber;
	          }
	          if (this.page == 'stock') {
	            this.form.currentCount = batchProduct.qtyNumber;
	          }
	        }
	      }
	    },
	
	    transferType: function transferType(_transferType) {
	      if (this.page === 'transfer' && _transferType && this.transferTypeCode === 'TB') {
	        this.hiddenFields.push('batchId');
	      } else if (this.hiddenFields.indexOf('batchId') !== -1) {
	        this.hiddenFields.splice(this.hiddenFields.indexOf('batchId'));
	      }
	
	      if (this.isTransferToBatchPage) {
	        this.getResources();
	      }
	    },
	    batches: function batches(_batches) {
	      if (_batches) {
	        var options = _batches.map(function (batch) {
	          return {
	            id: +batch.id,
	            name: batch.code
	          };
	        });
	        this.form.setOptions('batchId', [{
	          id: 0,
	          name: '' + this.$t('static.orders.edit.nonBatch')
	        }].concat(_toConsumableArray(options)));
	      }
	    },
	
	
	    'form.physicalCount': function formPhysicalCount(val) {
	      if (!isNaN(val)) {
	        this.form.variance = (parseFloat(val) - this.form.currentCount).toFixed(2).replace(/[.,]00$/, '');
	      } else {
	        this.form.variance = 9;
	      }
	    },
	    currentStockProducts: function currentStockProducts(_currentStockProducts) {},
	    products: function products(_products) {}
	  },
	
	  created: function created() {
	    var _this3 = this;
	
	    Promise.all([_organizationSettings2.default.show()]).then(function (data) {
	      _this3.form.setDisplays('productId', data[0].productInfoDisplay);
	    });
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    setBatchOptions: function setBatchOptions(selectedProduct) {
	      var _this4 = this;
	
	      if (selectedProduct && selectedProduct.warehouses) {
	        var products = selectedProduct.warehouses;
	        if (products.length) {
	          if (this.currentSelectedWarehouse) {
	            products = products.filter(function (p) {
	              return p.warehouseId === _this4.currentSelectedWarehouse.toString();
	            });
	          }
	
	          var batchIds = products.map(function (p) {
	            return p.batchId.toString();
	          });
	
	          var options = [];
	          options = options.concat(this.batches.filter(function (b) {
	            return batchIds.indexOf(b.id) !== -1;
	          }).map(function (batch) {
	            var batchProduct = products.find(function (p) {
	              return p.batchId.toString() === batch.id.toString();
	            });
	            return Object.assign({}, {
	              id: batch.id.toString(),
	              name: _this4.currentSelectedWarehouse ? batch.code + ' | ' + _this4.$t('static.orders.edit.availableQty') + ': ' + batchProduct.qtyNumber : batch.code,
	              available: batchProduct.qtyNumber
	            });
	          }));
	          options = options.reverse();
	
	          var nonBatchProduct = products.find(function (p) {
	            return p.batchId === 0;
	          });
	          if (nonBatchProduct) {
	            options.unshift({
	              id: '0',
	              name: this.$t('static.orders.edit.nonBatch') + ' | ' + this.$t('static.orders.edit.availableQty') + ': ' + nonBatchProduct.qtyNumber,
	              available: nonBatchProduct.qtyNumber
	            });
	          }
	
	          if (this.currentSelectedWarehouse) {
	            options = (0, _batchOptions.sortBatchOptions)(options);
	          }
	
	          this.form.setOverrideOptions('batchId', options);
	          if (!this.form.batchId && batchIds.length) {
	            this.form.batchId = this.currentSelectedWarehouse ? (0, _batchOptions.defaultBatchId)(options) : batchIds[0];
	          }
	        } else {
	          this.form.batchId = '';
	          this.form.setOverrideOptions('batchId', []);
	        }
	      } else {
	        this.form.batchId = '';
	        this.form.setOverrideOptions('batchId', []);
	      }
	    },
	    showBulkAddProductModal: function showBulkAddProductModal() {
	      this.setModalContent(function () {
	        return _bulkAddProductModal2.default;
	      });
	      var warehouseId = 0;
	      var warehouseIdForBatch = null;
	      if (this.page === 'transfer' && this.transferTypeCode === 'TW') {
	        warehouseId = this.additionalData && this.additionalData.fromWarehouseId ? +this.additionalData.fromWarehouseId : '';
	      }
	      if (this.page === 'purchase') {
	        warehouseIdForBatch = +this.additionalData.warehouseId;
	      }
	      if (['adjustment', 'stock'].includes(this.page)) {
	        warehouseIdForBatch = +this.currentSelectedWarehouse;
	      }
	      this.setModalProps({
	        warehouseId: warehouseId,
	        fetchProductsMethod: this.fetchAllProductsBasic,
	        batches: this.hasProduction && !this.isBatchTransferPage ? this.batches : [],
	        onSave: this.handleBulkProductSave,
	        warehouseIdForBatch: warehouseIdForBatch || null,
	        enableCustomBatch: ['purchase', 'stock', 'adjustment'].includes(this.page)
	      });
	      this.toggleModal(true);
	    },
	    fetchAllProductsBasic: function fetchAllProductsBasic() {
	      var fromWarehouseId = '';
	      if (this.page === 'transfer' && this.transferTypeCode === 'TW') {
	        fromWarehouseId = this.additionalData && this.additionalData.fromWarehouseId ? this.additionalData.fromWarehouseId : '';
	      }
	
	      return Promise.all([_product2.default.allBasic({
	        filter: 'active',
	        warehouse_id: fromWarehouseId,
	        include: 'warehouses'
	      })]);
	    },
	    handleBulkProductSave: function handleBulkProductSave(selectedProducts) {
	      var _this5 = this;
	
	      if (this.page === 'stock') {
	        if (this.currentSelectedWarehouse > 0) {
	          return Promise.all([_stock2.default.warehouseProducts(selectedProducts.map(function (p) {
	            return p.id;
	          }), this.currentSelectedWarehouse)]).then(function (response) {
	            selectedProducts.forEach(function (p) {
	              var warehouseProduct = _this5.getWarehouseProduct(response[0], p);
	              var data = {
	                id: _this5.currentStockProducts.length ? _this5.currentStockProducts[_this5.currentStockProducts.length - 1].id + 1 : 1,
	                name: p.name,
	                physicalCount: p.qty,
	                variance: warehouseProduct ? (p.qty - warehouseProduct.qtyNumber).toFixed(2).replace(/[.,]00$/, '') : p.qty,
	                currentCount: warehouseProduct ? warehouseProduct.qtyNumber : 0,
	                qty: p.qty,
	                productId: p,
	                product: p,
	                batchId: p.batchId
	              };
	              _store2.default.dispatch('PushToStockProductsCustom', data);
	            });
	          });
	        }
	        return Promise.reject();
	      }
	
	      if (this.page === 'adjustment') {
	        if (this.currentSelectedWarehouse > 0) {
	          return Promise.all([_stock2.default.warehouseProducts(selectedProducts.map(function (p) {
	            return p.id;
	          }), this.currentSelectedWarehouse)]).then(function (response) {
	            selectedProducts.forEach(function (p) {
	              var warehouseProduct = _this5.getWarehouseProduct(response[0], p);
	              var data = {
	                id: _this5.currentStockProducts.length ? _this5.currentStockProducts[_this5.currentStockProducts.length - 1].id + 1 : 1,
	                name: p.name,
	                qty: p.qty,
	                productId: p,
	                product: p,
	                purchasePrice: 0,
	                costPrice: 0,
	                currentAdjustment: warehouseProduct ? warehouseProduct.currentQty : 0,
	                batchId: p.batchId
	              };
	              _store2.default.dispatch('PushToStockProductsCustom', data);
	            });
	          });
	        }
	        return Promise.reject();
	      }
	
	      selectedProducts.forEach(function (p) {
	        var data = {
	          id: _this5.currentStockProducts.length ? _this5.currentStockProducts[_this5.currentStockProducts.length - 1].id + 1 : 1,
	          name: p.name,
	          qty: p.qty,
	          productId: p,
	          product: p,
	          purchasePrice: 0,
	          costPrice: 0,
	          batchId: p.batchId
	        };
	        _store2.default.dispatch('PushToStockProductsCustom', data);
	      });
	      return Promise.resolve();
	    },
	    getWarehouseProduct: function getWarehouseProduct(products, selected) {
	      var warehouseProduct = null;
	      if (products) {
	        if (selected.batchId) {
	          warehouseProduct = products.find(function (wp) {
	            return +wp.productId === +selected.id && +wp.batchId === +selected.batchId;
	          });
	        } else {
	          warehouseProduct = products.find(function (wp) {
	            return +wp.productId === +selected.id;
	          });
	        }
	      }
	      return warehouseProduct;
	    },
	    toFloat: function toFloat(number) {
	      return parseFloat(number.replace(/\s/g, '').replace(/,(\d+)$/, '.$1'));
	    },
	    searchMethod: function searchMethod(search, field) {
	      return Promise.all([_product2.default.search({ search: search, warehouse_id: '' })]);
	    },
	    onQuickProductEditMounted: function onQuickProductEditMounted() {
	      var that = this;
	      return function () {
	        var _this6 = this;
	
	        this.$once('close', function () {
	          _product2.default.all().then(function () {
	            var filteredProducts = that.products.filter(function (p) {
	              return p.id.toString() === _this6.orderProduct.productId.toString();
	            });
	            if (filteredProducts.length) {
	              that.form.assignData(_this6.orderProduct);
	              that.form.assignData(filteredProducts[0]);
	              that.update(_this6.orderProduct.id).then(function () {
	                that.form.resetValues();
	              });
	            }
	          });
	        });
	      };
	    },
	    tableClickHandler: function tableClickHandler(item, name) {},
	    save: function save() {
	      var data = this.form.data();
	      var self = this;
	      var product = data.productId;
	
	      if (product) {
	        var hasDuplicate = self.currentStockProducts.find(function (x) {
	          return x.productId == data.productId.id;
	        });
	        if (!hasDuplicate) {
	          data.id = self.currentStockProducts.length ? self.currentStockProducts[self.currentStockProducts.length - 1].id + 1 : 1;
	          data.name = product.name;
	          data.product = product;
	          _store2.default.dispatch('PushToStockProductsCustom', data);
	        } else {
	          this.$message({
	            showClose: true,
	            customClass: 'error',
	            message: 'Product duplicate found'
	          });
	          return Promise.reject();
	        }
	      } else {
	        this.$message({
	          showClose: true,
	          customClass: 'error',
	          message: 'Product not found'
	        });
	
	        return Promise.reject();
	      }
	
	      return Promise.all([]);
	    },
	    update: function update(item, index) {
	      var data = this.form.data();
	      var self = this;
	      var product = data.productId;
	
	      if (product) {
	        var currentId = self.currentStockProducts[index].id;
	        var hasDuplicate = self.currentStockProducts.find(function (x) {
	          return x.productId == product.id && x.id != currentId;
	        });
	
	        if (!hasDuplicate) {
	          data.id = currentId;
	          data.name = product.name;
	          data.product = product;
	          var i = index;
	
	          _store2.default.dispatch('UpdateToStockProducts', { data: data, i: i });
	        } else {
	          this.$message({
	            showClose: true,
	            customClass: 'error',
	            message: 'Product duplicate found'
	          });
	          return Promise.reject();
	        }
	      } else {
	        this.$message({
	          showClose: true,
	          customClass: 'error',
	          message: 'Product not found'
	        });
	        return Promise.reject();
	      }
	      return Promise.all([]);
	    },
	    destroy: function destroy(orderProductId) {
	      var i = this.currentStockProducts.findIndex(function (x) {
	        return x.id == orderProductId;
	      });
	      _store2.default.dispatch('DeleteFromStockProductsCustom', i);
	      return Promise.all([]);
	    },
	    getResources: function getResources() {
	      var _this7 = this;
	
	      var resources = [_organizationSettings2.default.show()];
	      if (this.hasProduction) {
	        var params = {
	          warehouse_id: this.currentSelectedWarehouse || ''
	        };
	        if (!this.isTransferToBatchPage) {
	          params.has_warehouse_transaction = 1;
	        }
	        resources.push(_batch2.default.all(_extends({}, params, { for_select: 1 })));
	      }
	      Promise.all(resources).then(function () {
	        _this7.ready = true;
	      });
	    }
	  }),
	
	  mounted: function mounted() {
	    var fields = this.fields;
	    if (!this.hasProduction) {
	      delete fields.batchId;
	    }
	    this.form = new _forms2.default(fields);
	    for (var key in this.fields) {
	      if (this.fields[key].disabled) {
	        this.form.disableField(key);
	      }
	    }
	    if (this.isBatchTransferPage) {
	      this.hiddenFields.push('batchId');
	    }
	    this.getResources();
	  },
	
	
	  components: {
	    VFormTable: __webpack_require__(46)
	  }
	};

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _project = __webpack_require__(190);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _project3 = __webpack_require__(197);
	
	var _project4 = _interopRequireDefault(_project3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        description: {
	          value: '',
	          type: 'text'
	        }
	      })
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    allProjects: 'allProjects'
	  })),
	
	  watch: {
	    allProjects: function allProjects() {}
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({}), {
	    save: function save() {
	      var _this = this;
	
	      this.form.loading = true;
	      var project = _project4.default.send(Object.assign({}, this.form.data()));
	      _project2.default.store(project).then(function () {
	        _this.form.loading = false;
	        _project2.default.all();
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	      });
	      return Promise.all([]);
	    },
	    update: function update(projectId) {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var project = _project4.default.send(Object.assign({}, this.form.data()));
	      _project2.default.update(projectId, project).then(function () {
	        _this2.form.loading = false;
	        _project2.default.all();
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	      return Promise.all([]);
	    },
	    destroy: function destroy(projectId) {
	      var _this3 = this;
	
	      _project2.default.destroy(projectId).then(function () {
	        _this3.form.loading = false;
	        _project2.default.all();
	      }).catch(function (errors) {
	        _this3.form.loading = false;
	        _this3.form.recordErrors(errors);
	      });
	    },
	    getResources: function getResources() {
	      Promise.all([_project2.default.all()]);
	    }
	  }),
	
	  mounted: function mounted() {
	    this.getResources();
	  },
	
	
	  components: {
	    VFormTable: __webpack_require__(46)
	  }
	};

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _purchase = __webpack_require__(161);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _vuex = __webpack_require__(5);
	
	var _purchaseReceive = __webpack_require__(1702);
	
	var _purchaseReceive2 = _interopRequireDefault(_purchaseReceive);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        receiveDate: {
	          value: new Date(),
	          type: 'date'
	        }
	      }),
	      fields: {
	        productId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        batchId: {
	          value: '',
	          type: 'select'
	        },
	        qty: {
	          value: '0',
	          type: 'number'
	        },
	        qtyReceive: {
	          value: '0',
	          type: 'number'
	        },
	        qtyDamage: {
	          value: '0',
	          type: 'number'
	        },
	        purchasePrice: {
	          value: '0',
	          type: 'number'
	        },
	        costPrice: {
	          value: '0',
	          type: 'number'
	        },
	        notes: {
	          value: '',
	          type: 'text'
	        }
	      },
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentPurchase: 'currentPurchase',
	    currentStockProducts: 'currentStockProductsCustom'
	  })),
	
	  mounted: function mounted() {
	    this.getResources();
	  },
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    getResources: function getResources() {
	      this.loading = false;
	      this.defaulCostAndPurchasePrice(false);
	    },
	    defaulCostAndPurchasePrice: function defaulCostAndPurchasePrice(backToZero) {
	      this.currentStockProducts.forEach(function (item, i) {
	        var update = false;
	        var data = {};
	
	        if (backToZero === false) {
	          if (item.costPrice === '0') {
	            data.costPrice = item.product.costPrice;
	            data.originCostPrice = '0';
	            update = true;
	          }
	          if (item.purchasePrice === '0') {
	            data.purchasePrice = item.product.purchasePrice;
	            data.originPurchasePrice = '0';
	            update = true;
	          }
	        } else {
	          if (item.hasOwnProperty('originCostPrice') && item.originCostPrice === '0') {
	            data.costPrice = item.originCostPrice;
	            update = true;
	          }
	
	          if (item.hasOwnProperty('originPurchasePrice') && item.originPurchasePrice === '0') {
	            data.purchasePrice = item.originPurchasePrice;
	            update = true;
	          }
	        }
	
	        if (update === true) {
	          data.batchId = item.batchId;
	          data.id = item.id;
	          data.name = item.name;
	          data.notes = item.notes;
	          data.product = item.product;
	          data.productId = item.productId;
	          data.purchaseId = item.purchaseId;
	          data.qty = item.qty;
	          data.qtyDamage = item.qtyDamage;
	          data.qtyReceive = item.qtyReceive;
	
	          _store2.default.dispatch('UpdateToStockProducts', { data: data, i: i });
	        }
	      });
	    },
	    searchMethod: function searchMethod(search, field) {
	      return Promise.all([_product2.default.search({ search: search, warehouse_id: '' })]);
	    },
	    store: function store() {
	      var _this = this;
	
	      this.loading = false;
	      this.form.loading = true;
	
	      this.form.receiveDate = (0, _moment2.default)(this.form.receiveDate).format();
	
	      var data = this.form.data();
	
	      var client = _purchaseReceive2.default.send(Object.assign({}, data, { products: this.currentStockProducts }));
	
	      return _purchase2.default.markAsDone(this.currentPurchase.id, client).then(function (data) {
	        _this.form.loading = false;
	        _this.$message({
	          showClose: true,
	          message: _this.$t('static.purchase.update.success'),
	          customClass: 'success'
	        });
	        _this.closeModal();
	        _this.$router.push({
	          name: 'inventory.purchase.index'
	        });
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	        var message = _this.$t('static.purchase.update.error');
	
	        if (errors.message) {
	          message = errors.message;
	        }
	        _this.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	      });
	    },
	    closeModal: function closeModal() {
	      this.defaulCostAndPurchasePrice(true);
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13),
	    VProductsTable: __webpack_require__(123)
	  }
	};

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _productDeposit = __webpack_require__(96);
	
	var _productDeposit2 = _interopRequireDefault(_productDeposit);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _tax = __webpack_require__(128);
	
	var _tax2 = _interopRequireDefault(_tax);
	
	var _product3 = __webpack_require__(39);
	
	var _product4 = _interopRequireDefault(_product3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        number: {
	          type: 'text',
	          value: ''
	        },
	        externalId: {
	          type: '',
	          value: ''
	        },
	        name: {
	          type: 'text',
	          value: ''
	        },
	        description: {
	          type: 'textarea',
	          value: ''
	        },
	        price: {
	          type: 'number',
	          value: ''
	        },
	        taxId: {
	          type: 'select',
	          value: ''
	        },
	        productDepositCheckbox: {
	          type: 'checkbox',
	          value: ''
	        },
	        productDepositId: {
	          type: 'select',
	          value: ''
	        },
	        vintage: {
	          value: '',
	          type: 'text'
	        },
	        bottle_volume: {
	          value: '',
	          type: 'number'
	        },
	        packaging_type: {
	          value: '',
	          type: 'text'
	        },
	        gtin: {
	          value: '',
	          type: 'text'
	        }
	
	      }),
	      product: {},
	      loading: false
	    };
	  },
	
	
	  props: {
	    productId: {
	      type: [String, Number],
	      required: true
	    },
	
	    orderProduct: {
	      type: Object,
	      required: false
	    },
	
	    isEdi: {
	      type: Boolean,
	      default: false
	    },
	
	    onMounted: {
	      type: Function,
	      default: function _default() {}
	    },
	
	    updated: {
	      type: Function,
	      required: false
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    deposits: 'allProductDeposits',
	    taxes: 'allTaxes'
	  })),
	
	  watch: {
	    deposits: function deposits(_deposits) {
	      this.form.setOptions('productDepositId', _deposits.all);
	    },
	
	    'form.productDepositCheckbox': function formProductDepositCheckbox(value) {
	      if (value) {
	        this.form.showField('productDepositId');
	      } else {
	        this.form.hideField('productDepositId');
	      }
	    },
	
	    taxes: function taxes(_taxes) {
	      this.form.setOptions('taxId', _taxes.all.map(function (tax) {
	        return { id: tax.id, name: tax.taxPercentage };
	      }));
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.isEdi) {
	      this.form.disableField('name');
	      this.form.disableField('price');
	      this.form.disableField('taxId');
	    }
	
	    this.form.disableField('description');
	    this.form.disableField('gtin');
	    this.form.disableField('packaging_type');
	    this.form.disableField('bottle_volume');
	    this.form.disableField('vintage');
	    this.form.disableField('number');
	    this.form.disableField('externalId');
	
	    _productDeposit2.default.all();
	    _tax2.default.all();
	    this.loading = true;
	
	    _product2.default.show(this.productId).then(function (product) {
	      _this.loading = false;
	      if (product.productDepositId) {
	        _this.form.productDepositCheckbox = true;
	      } else {
	        _this.form.productDepositCheckbox = false;
	        _this.form.hideField('productDepositId');
	      }
	      _this.product = product;
	      _this.form.assignData(product);
	    });
	  },
	
	
	  methods: {
	    onSubmit: function onSubmit() {
	      var _this2 = this;
	
	      var that = this;
	      var data = Object.assign({}, this.product, this.form.data());
	      _product2.default.quickUpdate(this.productId, _product4.default.send(data)).then(function () {
	        if (_this2.updated != undefined) {
	
	          that.updated(data, that.orderProduct).then(function () {
	            that.$emit('close');
	          }).catch(function () {
	            that.$emit('close');
	          });
	        } else {
	          that.$emit('close');
	        }
	      }).catch(function (error) {
	        _this2.form.recordErrors(error);
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _form = __webpack_require__(458);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _exciseGroup = __webpack_require__(94);
	
	var _exciseGroup2 = _interopRequireDefault(_exciseGroup);
	
	var _product3 = __webpack_require__(39);
	
	var _product4 = _interopRequireDefault(_product3);
	
	var _productPackaging = __webpack_require__(126);
	
	var _productPackaging2 = _interopRequireDefault(_productPackaging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({}),
	      product: {},
	      loading: false
	    };
	  },
	
	
	  props: {
	    productId: {
	      type: [String, Number],
	      required: true
	    },
	    productName: {
	      type: String,
	      required: true
	    },
	    updated: {
	      type: Function,
	      required: false
	    },
	    onClose: {
	      type: Function,
	      default: function _default() {}
	    },
	    isEdi: {
	      type: Boolean,
	      required: false,
	      default: false
	    },
	    destination: {
	      type: Function,
	      required: false,
	      default: null
	    },
	    destinationProps: {
	      type: Object,
	      required: false,
	      default: null
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentOrder: 'currentOrder',
	    groups: 'allExciseGroups',
	    excisePackagingGroups: 'allExcisePackagingGroups',
	    exciseBasicGroups: 'allExciseBasicGroups',
	    productPackagings: 'allProductPackagings'
	  })),
	
	  watch: {},
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    _product2.default.show(this.productId).then(function (product) {
	      _this.loading = false;
	      _this.product = product;
	      _this.processForm(product.productTypeId, 'exciseForm');
	    });
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    showOrderConfirm: function showOrderConfirm() {
	      if (this.destination) {
	        if (this.destinationProps) {
	          this.setModalProps(this.destinationProps);
	        }
	        this.setModalContent(this.destination);
	        return;
	      }
	      if (this.isEdi) {
	        this.setModalContent(function () {
	          return __webpack_require__(277);
	        });
	        return;
	      }
	      this.setModalContent(function () {
	        return __webpack_require__(774);
	      });
	    },
	    onSubmit: function onSubmit() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var data = Object.assign({}, this.product, this.form.data());
	      _product2.default.quickUpdate(this.productId, Object.assign({}, _product4.default.send(data), { is_excise_form: true })).then(function () {
	        _this2.showOrderConfirm();
	      }).catch(function (error) {
	        _this2.form.recordErrors(error);
	        _this2.form.loading = false;
	      });
	    },
	    processForm: function processForm(typeId, name) {
	      var _this3 = this;
	
	      var self = this;
	      self.loading = true;
	      self.forms = [];
	      Promise.all([_form2.default.fields(typeId, name), _exciseGroup2.default.all(), _exciseGroup2.default.packaging(), _exciseGroup2.default.basic(), _productPackaging2.default.all()]).then(function (data) {
	        var _loop = function _loop(i) {
	          var fields = {};
	          for (var f = 0; f < data[0][i].fields.length; f++) {
	            var field = data[0][i].fields[f];
	
	            var new_field = {
	              type: field.fieldType.type,
	              value: field.defaultValue
	            };
	
	            fields[field.name] = new_field;
	          }
	          fields.alcoholPercentage = {
	            type: 'text',
	            value: ''
	          };
	          fields.bottleVolume = {
	            type: 'text',
	            value: _this3.product.fieldsJSON.bottleVolume
	          };
	          fields.productPackagingId = {
	            type: 'select',
	            value: _this3.product.productPackagingId
	          };
	          var form = new _forms2.default(fields);
	          form.setOptions('productPackagingId', _this3.productPackagings.all);
	          Object.keys(fields).map(function (value, key) {
	            if (value == 'exciseAlcoholGroup') {
	              form.setOptions('exciseAlcoholGroup', self.groups.map(function (c) {
	                return {
	                  id: c.id,
	                  name: '' + c.description
	                };
	              }));
	            } else if (value == 'excisePackagingGroup') {
	              form.setOptions('excisePackagingGroup', self.excisePackagingGroups.map(function (c) {
	                return {
	                  id: c.id,
	                  name: '' + c.description
	                };
	              }));
	            } else if (value == 'exciseBasicGroup') {
	              form.setOptions('exciseBasicGroup', self.exciseBasicGroups.map(function (c) {
	                return {
	                  id: c.id,
	                  name: '' + c.description
	                };
	              }));
	            }
	          });
	          self.form = form;
	          self.form.assignData(self.product);
	          self.form.alcoholPercentage = _this3.product.fieldsJSON.alcohol_percentage || '';
	          self.form.bottleVolume = _this3.product.fieldsJSON.bottle_volume || '';
	        };
	
	        for (var i = 0; i < data[0].length; i++) {
	          _loop(i);
	        }
	        self.loading = false;
	      });
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _recipeProcedure = __webpack_require__(1265);
	
	var _recipeProcedure2 = _interopRequireDefault(_recipeProcedure);
	
	var _recipeProcedure3 = __webpack_require__(136);
	
	var _recipeProcedure4 = _interopRequireDefault(_recipeProcedure3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        recipeId: {
	          value: this.recipeId,
	          type: 'hidden'
	        },
	        name: {
	          value: '',
	          type: 'text'
	        },
	        step: {
	          value: '',
	          type: 'number'
	        },
	        equipmentId: {
	          value: '',
	          type: 'select',
	          filterable: true
	        },
	        ingredienceIds: {
	          value: '',
	          type: 'select',
	          filterable: true
	        },
	        notes: {
	          value: '',
	          type: 'textarea'
	        }
	      })
	    };
	  },
	
	
	  props: {
	    recipeId: {
	      required: true,
	      type: String
	    },
	    procedure: {
	      required: false,
	      type: Object
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    ingrediences: 'allRecipeIngrediences',
	    equipments: 'allEquipments'
	  })),
	
	  created: function created() {
	    this.form.setOptions('ingredienceIds', this.ingrediences.map(function (ingredience) {
	      return {
	        id: ingredience.id,
	        name: ingredience.materialName + ' - ' + ingredience.amount + ' ' + ingredience.unitMeasure
	      };
	    }));
	    this.form.setOptions('equipmentId', this.equipments.map(function (equipment) {
	      return {
	        id: equipment.id,
	        name: equipment.name
	      };
	    }));
	    this.form.setExtraAttr('ingredienceIds', {
	      multiple: true
	    });
	    if (this.procedure) {
	      var procedure = Object.assign({}, this.procedure);
	      this.form.assignData(this.procedure);
	      if (procedure.ingrediences) {
	        this.form.ingredienceIds = procedure.ingrediences.map(function (ingredience) {
	          return ingredience.id.toString();
	        });
	      }
	    }
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    save: function save() {
	      var _this = this;
	
	      this.form.loading = true;
	      this.form.loading = true;
	      var data = Object.assign(this.form.data(), {
	        recipeId: this.recipeId
	      });
	      if (this.procedure) {
	        return _recipeProcedure2.default.update(this.procedure.id, data).then(function () {
	          return _this.closeModal();
	        }).catch(function (errors) {
	          _this.form.loading = false;
	          _this.form.recordErrors(errors);
	          var errorsKeys = Object.keys(_this.form.errors.errors);
	          _this.$message({
	            showClose: true,
	            message: errors[errorsKeys[0]][0],
	            type: 'error'
	          });
	        });
	      }
	
	      return _recipeProcedure2.default.store(data).then(function () {
	        return _this.closeModal();
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	        var errorsKeys = Object.keys(_this.form.errors.errors);
	        _this.$message({
	          showClose: true,
	          message: errors[errorsKeys[0]][0],
	          type: 'error'
	        });
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _vuex = __webpack_require__(5);
	
	var _productGroup = __webpack_require__(160);
	
	var _productGroup2 = _interopRequireDefault(_productGroup);
	
	var _catalogue = __webpack_require__(494);
	
	var _catalogue2 = _interopRequireDefault(_catalogue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false,
	      form: new _forms2.default({
	        productGroupId: {
	          value: '',
	          type: 'select'
	        },
	        actionCode: {
	          value: '',
	          type: 'select'
	        },
	        name: {
	          value: '',
	          type: 'text'
	        },
	        versionId: {
	          value: '',
	          type: 'text'
	        },
	        issuedAt: {
	          value: '',
	          type: 'date'
	        },
	        validFrom: {
	          value: '',
	          type: 'date'
	        },
	        validTo: {
	          value: '',
	          type: 'date'
	        },
	        reference: {
	          value: '',
	          type: 'textarea'
	        },
	        note: {
	          value: '',
	          type: 'textarea'
	        }
	      })
	    };
	  },
	
	
	  props: {
	    clientId: {
	      required: true,
	      type: Number
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    productGroups: 'allProductGroups'
	  })),
	  created: function created() {
	    var _this = this;
	
	    this.loading = true;
	    _productGroup2.default.all().then(function () {
	      _this.loading = false;
	    }).catch(function () {
	      _this.loading = false;
	    });
	  },
	  mounted: function mounted() {
	    var actionCodes = [{ id: 'Add', name: this.$t('static.clients.catalogues.actionCodes.add') }, { id: 'Update', name: this.$t('static.clients.catalogues.actionCodes.update') }, { id: 'Replace', name: this.$t('static.clients.catalogues.actionCodes.replace') }, { id: 'Delete', name: this.$t('static.clients.catalogues.actionCodes.delete') }];
	    this.form.setOptions('actionCode', actionCodes);
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    save: function save() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var data = Object.assign({}, this.form.data(), { clientId: this.clientId });
	      _client2.default.sendCatalogue(_catalogue2.default.send(data)).then(function () {
	        return _this2.closeModal();
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	
	  watch: {
	    productGroups: function productGroups() {
	      this.form.setOptions('productGroupId', this.productGroups.all);
	    },
	
	    'form.productGroupId': function formProductGroupId(value) {
	      var productGroup = this.productGroups.all.find(function (group) {
	        return +group.id === +value;
	      });
	      console.log(productGroup);
	      this.form.name = productGroup.name || '';
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _shippingProvider = __webpack_require__(97);
	
	var _shippingProvider2 = _interopRequireDefault(_shippingProvider);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _quickProductEdit = __webpack_require__(278);
	
	var _quickProductEdit2 = _interopRequireDefault(_quickProductEdit);
	
	var _shippingProvider3 = __webpack_require__(199);
	
	var _shippingProvider4 = _interopRequireDefault(_shippingProvider3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        code: {
	          value: '',
	          type: 'text'
	        }
	
	      })
	    };
	  },
	
	
	  props: {},
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    shippingProviders: 'allShippingProviders'
	  }), {
	    list: function list() {
	      return [];
	    }
	  }),
	
	  watch: {
	    'form.name': function formName() {}
	
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    toFloat: function toFloat(number) {
	      return parseFloat(number.replace(/\s/g, '').replace(/,(\d+)$/, '.$1'));
	    },
	    onQuickProductEditMounted: function onQuickProductEditMounted() {
	      var that = this;
	    },
	    tableClickHandler: function tableClickHandler(item, name) {},
	    save: function save() {
	      var _this = this;
	
	      var data = this.form.data();
	      this.form.loading = true;
	      var shipping = _shippingProvider4.default.send(Object.assign({}, this.form.data()));
	      _shippingProvider2.default.store(shipping).then(function () {
	        _this.form.loading = false;
	        _shippingProvider2.default.all();
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	      });
	
	      return Promise.all([]);
	    },
	    update: function update(orderProductId) {
	      var _this2 = this;
	
	      console.log(orderProductId);
	      var data = this.form.data();
	      this.form.loading = true;
	      var shipping = _shippingProvider4.default.send(Object.assign({}, this.form.data()));
	      _shippingProvider2.default.update(orderProductId, shipping).then(function () {
	        _this2.form.loading = false;
	        _shippingProvider2.default.all();
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	      return Promise.all([]);
	    },
	    destroy: function destroy(orderProductId) {
	      var _this3 = this;
	
	      _shippingProvider2.default.destroy(orderProductId).then(function () {
	        _this3.form.loading = false;
	        _shippingProvider2.default.all();
	      }).catch(function (errors) {
	        _this3.form.loading = false;
	        _this3.form.recordErrors(errors);
	      });
	    },
	    getResources: function getResources() {
	      var _this4 = this;
	
	      Promise.all([_shippingProvider2.default.all()]).then(function () {
	        _this4.ready = true;
	      });
	    }
	  }),
	
	  mounted: function mounted() {
	    this.getResources();
	  },
	
	
	  components: {
	    VFormTable: __webpack_require__(46)
	  }
	};

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _auth = __webpack_require__(53);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _vuex = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: _extends({}, (0, _vuex.mapGetters)(['account', 'innerSidebarState', 'innerSidebar', 'innerSidebarDisabled']), {
	    isVerified: function isVerified() {
	      return this.account.verified;
	    },
	    activeMenu: function activeMenu() {
	      if (this.$route.name === 'profile.account') {
	        return '3';
	      }
	      return '2';
	    },
	    routeQuery: function routeQuery() {
	      return JSON.stringify(this.$route.query) || JSON.stringify({});
	    }
	  }),
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var checkParentForAnchor = function checkParentForAnchor(el) {
	      while (el && el.tagName !== 'A') {
	        el = el.parentElement;
	      }
	
	      return el && el.tagName === 'A';
	    };
	
	    this.$refs.sidebar.addEventListener('click', function (e) {
	      if (checkParentForAnchor(e.target)) {
	        _this.toggleSidebar(false);
	      }
	    });
	    document.querySelector('.main').addEventListener('click', function (e) {
	      if (_this.innerSidebarState && !checkParentForAnchor(e.target)) {
	        _this.toggleSidebar(false);
	      }
	    });
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleSidebar: 'TOGGLE_INNERSIDEBAR'
	  }), {
	    hasModule: function hasModule(name) {
	      if (this.account.modules !== undefined) {
	        var hasModule = this.account.modules.filter(function (m) {
	          return m.name === name;
	        });
	        if (hasModule.length > 0) {
	          return true;
	        }
	      }
	      return false;
	    },
	    logout: function logout() {
	      _auth2.default.logout();
	    }
	  })
	};

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _smsTwoFactorAuthSetup = __webpack_require__(1296);
	
	var _smsTwoFactorAuthSetup2 = _interopRequireDefault(_smsTwoFactorAuthSetup);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    module: {
	      type: Object,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      sms2faEnabled: false,
	      verificationSent: false,
	      mobileNumber: null,
	      twoFactorAuthToken: null,
	      twoFactorTimerCount: null,
	      verified: false,
	      loading: false,
	      sendLoading: false,
	      verifyLoading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    modules: 'allModules'
	  }), {
	    isGoogle2faEnabled: function isGoogle2faEnabled() {
	      return this.modules.find(function (module) {
	        return module.name === 'Google Two-Factor Authentication' && module.subscribe;
	      });
	    }
	  }),
	
	  watch: {
	    twoFactorTimerCount: {
	      handler: function handler(value) {
	        var _this = this;
	
	        if (value > 0) {
	          setTimeout(function () {
	            _this.twoFactorTimerCount--;
	          }, 1000);
	        }
	      },
	
	      immediate: true }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    sendVerificationToken: function sendVerificationToken() {
	      var _this2 = this;
	
	      var mobile = '+47' + this.mobileNumber;
	      if (!this.verifyMobileNumber(mobile)) {
	        this.$message({
	          message: this.$t('static.smsTwoFactorVerification.invalidMobileNumber'),
	          type: 'error'
	        });
	        return;
	      }
	
	      this.sendLoading = true;
	      var data = {
	        mobile_number: mobile,
	        user_id: this.account.userId,
	        module_id: this.module.id
	      };
	      Promise.resolve(_smsTwoFactorAuthSetup2.default.sendVerificationToken(data)).then(function () {
	        _this2.sendLoading = false;
	        _this2.verificationSent = true;
	        _this2.twoFactorTimerCount = 30;
	        _this2.$message({
	          message: _this2.$t('static.smsTwoFactorVerification.verificationCodeSent'),
	          type: 'success'
	        });
	      }).catch(function (errors) {
	        if ('mobile_number' in errors) {
	          _this2.$message({
	            message: _this2.$t('static.smsTwoFactorVerification.invalidMobileNumber'),
	            type: 'error'
	          });
	        }
	        _this2.$message({
	          message: _this2.$t('static.smsTwoFactorVerification.unableToSendVerification'),
	          type: 'error'
	        });
	        _this2.twoFactorTimerCount = 0;
	        _this2.sendLoading = false;
	      });
	    },
	    verifyToken: function verifyToken() {
	      var _this3 = this;
	
	      if (!this.twoFactorAuthToken) {
	        this.$message({
	          message: this.$t('static.smsTwoFactorVerification.verificationCodeIncorrect'),
	          type: 'error'
	        });
	        return;
	      }
	      this.verifyLoading = true;
	      var data = {
	        code: this.twoFactorAuthToken,
	        user_id: this.account.userId,
	        module_id: this.module.id
	      };
	      Promise.resolve(_smsTwoFactorAuthSetup2.default.verifyToken(data)).then(function () {
	        _this3.verifyLoading = false;
	        _this3.verified = true;
	        _modules2.default.items().then(function () {
	          _this3.$message({
	            message: _this3.$t('static.smsTwoFactorVerification.smsTwoFactorAuthEnabled'),
	            type: 'success'
	          });
	          _this3.closeModal();
	        });
	      }).catch(function (errors) {
	        _this3.verifyLoading = false;
	        if ('mobile_number' in errors) {
	          _this3.$message({
	            message: _this3.$t('static.smsTwoFactorVerification.requiredMobileNumber'),
	            type: 'error'
	          });
	          _this3.twoFactorTimerCount = 0;
	        }
	        _this3.$message({
	          message: _this3.$t('static.smsTwoFactorVerification.verificationCodeIncorrect'),
	          type: 'error'
	        });
	      });
	    },
	    verifyMobileNumber: function verifyMobileNumber(mobile) {
	      var regex = /^(0047|\+47|47)?[2-9]\d{7}$/;
	      return regex.test(mobile);
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  })
	};

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({}),
	      loading: false
	    };
	  },
	
	
	  props: {
	    module: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: {},
	
	  mounted: function mounted() {
	    var me = this;
	    me.loading = true;
	    var fields = {};
	    for (var i = 0; i < me.module.fields.length; i++) {
	      var new_field = {
	        type: me.module.fields[i].type || 'text',
	        value: ''
	      };
	      fields[me.module.fields[i].name] = new_field;
	    }
	
	    me.form = new _forms2.default(fields);
	    me.loading = false;
	  },
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    getResources: function getResources() {},
	    store: function store() {
	      var _this = this;
	
	      this.form.loading = true;
	      var obj = Object.assign({ module_id: this.module.id }, this.form.data());
	      _modules2.default.subscribe(this.module.id, obj).then(function () {
	        _modules2.default.items().then(function (data) {
	          _this.closeModal();
	        });
	      }).catch(function (error) {
	        var message = error.data ? error.data.message : 'Field Required';
	        _this.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	        _this.form.recordErrors(error);
	        _this.form.loading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _numberFormat = __webpack_require__(848);
	
	var _numberFormat2 = _interopRequireDefault(_numberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    list: {
	      type: Array,
	      required: true
	    },
	    translation: {
	      type: String,
	      required: false
	    },
	    noDataMessage: {
	      type: String,
	      required: false
	    },
	    link: {
	      type: Function,
	      required: false
	    },
	    linkKey: {
	      type: String,
	      required: false
	    },
	    rowKey: {
	      type: String,
	      required: false
	    },
	    buttons: {
	      type: Array,
	      required: false
	    },
	    expandableKey: {
	      type: String,
	      required: false
	    },
	    expandableRows: {
	      type: String,
	      required: false
	    }
	  },
	
	  methods: {
	    html: function html(data, key) {
	      return this.numberFormat(data, key);
	    },
	    inArray: function inArray(needle, haystack) {
	      if (haystack !== undefined) {
	        var arr = haystack.split(',');
	      } else {
	        var arr = new Array();
	      }
	
	      for (var i in arr) {
	        if (arr[i] == needle) return true;
	      }
	      return false;
	    },
	    convertToArray: function convertToArray(s) {
	      if (s !== undefined) {
	        return s.split(',');
	      }
	      return [];
	    }
	  },
	
	  mixins: [_numberFormat2.default]
	};

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'timeline',
	  props: {
	    list: {
	      type: Array,
	      required: true
	    },
	
	    direction: {
	      type: String,
	      default: 'future'
	    },
	
	    dateRange: {
	      type: Array,
	      required: false
	    },
	
	    create: {
	      type: Function,
	      required: true
	    },
	
	    edit: {
	      type: Function,
	      required: false
	    }
	  },
	
	  computed: {
	    points: function points() {
	      var points = [];
	      var daysAhead = 14;
	
	      var start = this.dateRange.length && (0, _moment2.default)(this.dateRange[0]).isValid() ? (0, _moment2.default)(this.dateRange[0]) : (0, _moment2.default)();
	      start.startOf('day');
	
	      if (this.dateRange.length && (0, _moment2.default)(this.dateRange[1]).isValid()) {
	        daysAhead = (0, _moment2.default)(this.dateRange[1]).startOf('day').diff(start, 'days') + 1;
	      } else if (this.list.length) {
	        var diff = (0, _moment2.default)(this.list[this.list.length - 1].start, 'DD/MM/YYYY HH:mm').diff(start, 'days');
	        daysAhead = diff > daysAhead ? diff + 1 : daysAhead;
	      }
	
	      for (var i = 0; i < daysAhead; i += 1) {
	        var date = (0, _moment2.default)(start);
	        if (this.direction === 'future') {
	          date.add(i, 'days');
	        } else {
	          date.subtract(i, 'days');
	        }
	
	        points.push({
	          date: date,
	          day: date.format('DD'),
	          month: date.format('MMMM'),
	          year: date.format('YYYY')
	        });
	      }
	
	      return points;
	    }
	  },
	
	  methods: {
	    isWeekend: function isWeekend(date) {
	      return date.format('dddd') === 'Saturday' || date.format('dddd') === 'Sunday';
	    },
	    getDayOrders: function getDayOrders(date) {
	      date = date.startOf('day');
	      return this.list.filter(function (o) {
	        return (0, _moment2.default)(o.start, 'DD/MM/YYYY HH:mm').startOf('day').diff(date, 'day') === 0;
	      });
	    },
	    onEdit: function onEdit(date) {
	      var _this = this;
	
	      if (!this.edit) return false;
	
	      return function (o) {
	        _this.edit(date, o);
	      };
	    }
	  },
	
	  components: {
	    VAppointmentCard: __webpack_require__(765)
	  }
	};

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    list: {
	      type: Array,
	      required: true
	    }
	  }
	};

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _unimicro = __webpack_require__(486);
	
	var _unimicro2 = _interopRequireDefault(_unimicro);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    mod: {
	      type: Object,
	      required: true
	    }
	  },
	
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        unimicro_environment: { type: 'select', value: '' },
	        unimicro_invoice_series_id: { type: 'select', value: '' }
	      }),
	
	      numberSeriesOptions: [],
	      savedSeriesId: null,
	      loading: false
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	
	    Promise.all([this.loadEnvironment(), this.loadNumberSeries()]).finally(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    loadEnvironment: function loadEnvironment() {
	      var _this2 = this;
	
	      return _organizationSettings2.default.show().then(function (settings) {
	        settings = settings || {};
	        console.log('[UniMicro] Raw settings:', settings);
	
	        var norm = function norm(obj, key) {
	          if (obj[key] !== undefined && obj[key] !== null) return obj[key];
	          var snake = key.replace(/([A-Z])/g, '_$1').toLowerCase();
	          if (obj[snake] !== undefined && obj[snake] !== null) return obj[snake];
	          return '';
	        };
	
	        var env = norm(settings, 'unimicroEnvironment');
	        env = String(env).trim();
	
	        if (typeof _this2.form.set === 'function') {
	          _this2.form.set('unimicro_environment', env);
	        } else {
	          _this2.form.fields.unimicro_environment = { type: 'select', value: env };
	        }
	
	        _this2.savedSeriesId = norm(settings, 'unimicroInvoiceSeriesId');
	
	        _this2.form.fields.unimicro_invoice_series_id = { type: 'select', value: '' };
	
	        return true;
	      }).catch(function (err) {
	        console.error('[UniMicro] Failed to load settings:', err);
	        _this2.$message({
	          showClose: true,
	          message: 'Failed to load UniMicro settings.',
	          customClass: 'error'
	        });
	      });
	    },
	    loadNumberSeries: function loadNumberSeries() {
	      var _this3 = this;
	
	      return _unimicro2.default.numberSeries().then(function (res) {
	        var apiData = res.data || {};
	        var series = apiData.series || [];
	
	        _this3.numberSeriesOptions = series.map(function (s) {
	          return {
	            label: s.display + ' (Next: ' + s.next_number + ')',
	            value: s.id
	          };
	        });
	
	        console.log('[UniMicro] Loaded Invoice Series:', _this3.numberSeriesOptions);
	
	        if (_this3.savedSeriesId && _this3.numberSeriesOptions.some(function (o) {
	          return o.value == _this3.savedSeriesId;
	        })) {
	          _this3.form.fields.unimicro_invoice_series_id.value = Number(_this3.savedSeriesId);
	        }
	      }).catch(function (err) {
	        console.error('[UniMicro] Failed to fetch number series:', err);
	        _this3.$message({
	          showClose: true,
	          message: 'Failed to fetch UniMicro number series.',
	          customClass: 'error'
	        });
	      });
	    },
	    saveEnvironment: function saveEnvironment() {
	      var _this4 = this;
	
	      this.loading = true;
	
	      var payload = {
	        module_id: this.mod.id,
	        unimicro_environment: this.form.fields.unimicro_environment.value,
	        unimicro_invoice_series_id: this.form.fields.unimicro_invoice_series_id.value
	      };
	
	      _modules2.default.subscribe(this.mod.id, payload).then(function () {
	        _this4.$message({
	          showClose: true,
	          message: 'Settings updated successfully.',
	          type: 'success'
	        });
	
	        return Promise.all([_modules2.default.items(), _organizationSettings2.default.show()]);
	      }).catch(function () {
	        _this4.$message({
	          showClose: true,
	          message: 'Failed to update UniMicro settings.',
	          customClass: 'error'
	        });
	      }).finally(function () {
	        _this4.loading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggleModal(false);
	      this.unsetModalContent();
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _unimicro = __webpack_require__(486);
	
	var _unimicro2 = _interopRequireDefault(_unimicro);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({}),
	      loading: false,
	      pollingInterval: null,
	      statusLocked: false,
	      activationConfirmed: false
	    };
	  },
	
	
	  props: {
	    module: {
	      type: Object,
	      required: true
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    settings: 'organizationSettings'
	  })),
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    this.statusLocked = false;
	
	    var fields = {};
	    var fieldList = this.module.required_fields || this.module.fields || [];
	    var hasOptions = false;
	
	    for (var i = 0; i < fieldList.length; i++) {
	      var field = fieldList[i];
	      if (field.hidden) continue;
	
	      var newField = {
	        type: field.type || 'text',
	        value: '',
	        label: field.label || field.name,
	        placeholder: field.placeholder || '',
	        required: field.required || field.requred || false
	      };
	
	      if (field.options) hasOptions = true;
	
	      fields[field.name] = newField;
	    }
	
	    this.form = new _forms2.default(fields);
	
	    if (hasOptions) {
	      var _loop = function _loop(_i) {
	        var field = fieldList[_i];
	        if (field.hidden || !field.options) return 'continue';
	
	        var options = field.options;
	        _this.form.setOptions(field.name, Object.keys(options).map(function (k) {
	          return {
	            id: k,
	            name: options[k]
	          };
	        }));
	      };
	
	      for (var _i = 0; _i < fieldList.length; _i++) {
	        var _ret = _loop(_i);
	
	        if (_ret === 'continue') continue;
	      }
	    }
	
	    _organizationSettings2.default.show().finally(function () {
	      return _this.loading = false;
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.pollingInterval) clearInterval(this.pollingInterval);
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    authorize: function authorize() {
	      var _this2 = this;
	
	      this.statusLocked = true;
	      this.form.loading = true;
	
	      var payload = Object.assign({ module_id: this.module.id }, this.form.data());
	
	      _modules2.default.subscribe(this.module.id, payload).then(function () {
	        _this2.$message({
	          showClose: true,
	          message: 'Connecting to UniMicro…',
	          type: 'info'
	        });
	
	        _this2.callStatus(payload.unimicro_environment);
	      }).catch(function (err) {
	        _this2.statusLocked = false;
	
	        var msg = 'Failed to start UniMicro setup. Please check your input.';
	        if (err && err.data && err.data.message) {
	          msg = err.data.message;
	        }
	
	        _this2.$message({
	          showClose: true,
	          message: msg,
	          customClass: 'error'
	        });
	
	        _this2.form.recordErrors(err);
	        _this2.form.loading = false;
	      });
	    },
	    callStatus: function callStatus(environment) {
	      var _this3 = this;
	
	      _unimicro2.default.status({ environment: environment }).then(function (res) {
	        var data = res.data || {};
	
	        if (!data.success) {
	          _this3.statusLocked = false;
	          _this3.unsubscribeAfterFailure('UniMicro setup failed, Please Follow the instructions.');
	          return;
	        }
	
	        if (!data.has_access_token || !data.has_company_key) {
	          _this3.pollForCertificateReady(environment);
	          return;
	        }
	
	        _this3.onSetupComplete();
	      }).catch(function (err) {
	        console.error('[UniMicro] status error', err);
	        _this3.statusLocked = false;
	        _this3.unsubscribeAfterFailure('Failed to communicate with UniMicro. Setup cancelled.');
	      });
	    },
	    pollForCertificateReady: function pollForCertificateReady(environment) {
	      var _this4 = this;
	
	      var attempts = 0;
	      var maxAttempts = 20;
	      var interval = 3000;
	
	      this.$message({
	        showClose: true,
	        message: 'Verifying UniMicro setup…',
	        type: 'info'
	      });
	
	      this.pollingInterval = setInterval(function () {
	        attempts++;
	        _unimicro2.default.status({ environment: environment }).then(function (res) {
	          var data = res.data || {};
	
	          if (data.has_access_token && data.has_company_key) {
	            clearInterval(_this4.pollingInterval);
	            _this4.onSetupComplete();
	          }
	
	          if (attempts >= maxAttempts) {
	            clearInterval(_this4.pollingInterval);
	            _this4.statusLocked = false;
	
	            _this4.unsubscribeAfterFailure('UniMicro setup timed out. Please try again.');
	          }
	        }).catch(function () {});
	      }, interval);
	    },
	    onSetupComplete: function onSetupComplete() {
	      this.form.loading = false;
	      this.statusLocked = false;
	
	      Promise.all([_modules2.default.items(), _organizationSettings2.default.show()]);
	
	      this.$message({
	        showClose: true,
	        message: 'UniMicro connected successfully!',
	        type: 'success'
	      });
	
	      this.toggle(false);
	      this.unsetModalContent();
	    },
	    unsubscribeAfterFailure: function unsubscribeAfterFailure(message) {
	      var _this5 = this;
	
	      if (this.pollingInterval) clearInterval(this.pollingInterval);
	
	      _modules2.default.unsubscribe(this.module.id).then(function () {
	        _this5.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	      }).finally(function () {
	        _this5.form.loading = false;
	        _this5.toggle(false);
	        _this5.unsetModalContent();
	      });
	    },
	    closeModal: function closeModal() {
	      var _this6 = this;
	
	      var shouldUnsubscribe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (this.statusLocked) {
	        this.$message({
	          showClose: true,
	          message: 'Please wait — UniMicro setup in progress…',
	          type: 'warning'
	        });
	        return;
	      }
	
	      this.form.loading = true;
	      _modules2.default.unsubscribe(this.module.id).finally(function () {
	        _this6.form.loading = false;
	        _this6.toggle(false);
	        _this6.unsetModalContent();
	      });
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _vinmonopolet = __webpack_require__(236);
	
	var _vinmonopolet2 = _interopRequireDefault(_vinmonopolet);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({}),
	      loading: false
	    };
	  },
	
	
	  props: {
	    module: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    modules: 'allModules'
	  })),
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    var fields = {};
	    var hasOptions = false;
	    for (var i = 0; i < this.module.fields.length; i++) {
	      var newField = {
	        type: this.module.fields[i].type || 'text',
	        value: ''
	      };
	      if (this.module.fields[i].options) {
	        hasOptions = true;
	      }
	      fields[this.module.fields[i].name] = newField;
	    }
	
	    this.form = new _forms2.default(fields);
	    if (hasOptions) {
	      for (var _i = 0; _i < this.module.fields.length; _i++) {
	        if (this.module.fields[_i].options) {
	          (function () {
	            var options = _this.module.fields[_i].options;
	            _this.form.setOptions(_this.module.fields[_i].name, Object.keys(options).map(function (key) {
	              return {
	                id: key,
	                name: options[key]
	              };
	            }));
	          })();
	        }
	      }
	    }
	    this.loading = false;
	  },
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    getResources: function getResources() {},
	    authorize: function authorize() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      _vinmonopolet2.default.authorize(this.form.data()).then(function () {
	        _this2.subscribe();
	      }).catch(function (error) {
	        _this2.$message({
	          showClose: true,
	          message: _this2.$t('static.module.error.vmpError'),
	          customClass: 'error'
	        });
	        _this2.form.loading = false;
	      });
	    },
	    subscribe: function subscribe() {
	      var _this3 = this;
	
	      this.form.loading = true;
	      var obj = Object.assign({ module_id: this.module.id }, this.form.data());
	      _modules2.default.subscribe(this.module.id, obj).then(function () {
	        Promise.all([_modules2.default.items(), _account2.default.find()]).then(function () {
	          _this3.closeModal();
	        });
	      }).catch(function (error) {
	        var message = error.data ? error.data.message : 'Field Required';
	        _this3.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	        _this3.form.recordErrors(error);
	        _this3.form.loading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _vuex = __webpack_require__(5);
	
	exports.default = {
	
	  props: {
	    vmpData: {
	      required: true,
	      type: Object
	    },
	    onConfirm: {
	      required: true,
	      type: Function,
	      default: function _default() {}
	    }
	  },
	
	  computed: {
	    vmpDataList: function vmpDataList() {
	      var _this = this;
	
	      return Object.entries(this.vmpData).filter(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            key = _ref2[0],
	            value = _ref2[1];
	
	        return value && !Array.isArray(value);
	      }).map(function (_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 2),
	            key = _ref4[0],
	            value = _ref4[1];
	
	        return {
	          label: _this.$t('form.products.' + key + '.label'),
	          value: value
	        };
	      });
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    confirmSync: function confirmSync() {
	      this.onConfirm(this.vmpData);
	      this.closeModal();
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  })
	};

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    onClose: {
	      required: false,
	      type: Function,
	      default: function _default() {}
	    },
	    onConfirm: {
	      required: true,
	      type: Function,
	      default: function _default() {}
	    },
	    selectedFields: {
	      required: false,
	      type: Array,
	      default: []
	    },
	    result: {
	      required: true,
	      type: Array,
	      default: []
	    },
	    hasNewSelection: {
	      required: false,
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        syncFields: {
	          value: [],
	          type: "checkboxGroup"
	        }
	      }),
	      loading: false,
	      fields: []
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({})),
	
	  created: function created() {
	    var _this = this;
	
	    this.fields = this.$i18n.messages[this.$i18n.locale].static.products.syncVmp.fields;
	    this.form.setOptions("syncFields", Object.keys(this.fields).map(function (key) {
	      return {
	        id: key,
	        name: _this.fields[key]
	      };
	    }));
	    this.form.syncFields = this.selectedFields.map(function (f) {
	      return _this.fields[f];
	    }) || [];
	  },
	  mounted: function mounted() {
	    this.loading = false;
	  },
	
	
	  watch: {
	    result: function result() {
	      this.loading = false;
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: "TOGGLE_MODAL",
	    unsetModalContent: "UNSET_MODAL_CONTENT"
	  }), {
	    confirm: function confirm() {
	      this.loading = true;
	      var fields = Object.fromEntries(Object.entries(this.fields).map(function (a) {
	        return a.reverse();
	      }));
	      this.onConfirm(this.form.syncFields.map(function (f) {
	        return fields[f];
	      }));
	    },
	    closeModal: function closeModal() {
	      this.onClose();
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _productPackaging = __webpack_require__(126);
	
	var _productPackaging2 = _interopRequireDefault(_productPackaging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    productsNoPackaging: {
	      required: true,
	      type: Array,
	      default: []
	    },
	    onConfirm: {
	      required: true,
	      type: Function,
	      default: function _default() {}
	    },
	    onUpdatePackaging: {
	      required: true,
	      type: Function,
	      default: function _default() {}
	    },
	    onPackagingCreate: {
	      required: true,
	      type: Function,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      loading: false,
	      products: []
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    productPackagings: 'allProductPackagings'
	  }), {
	    hasProductWithNoPackaging: function hasProductWithNoPackaging() {
	      return this.products.filter(function (p) {
	        return !p.productPackagingId;
	      }).length;
	    }
	  }),
	
	  created: function created() {
	    var _this = this;
	
	    this.loading = true;
	    _productPackaging2.default.all().then(function () {
	      _this.loading = false;
	    }).catch(function () {
	      _this.loading = false;
	    });
	    this.products = this.productsNoPackaging.map(function (p) {
	      return Object.assign({}, p);
	    });
	  },
	
	
	  watch: {},
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalClass: 'SET_MODAL_CLASS'
	  }), {
	    addNewPackaging: function addNewPackaging(product) {
	      this.setModalContent(function () {
	        return __webpack_require__(281);
	      });
	      this.setModalSize('full');
	      this.setModalClass('');
	      this.setModalProps({
	        onClose: this.onPackagingCreate,
	        suggestedData: product
	      });
	    },
	    confirm: function confirm() {
	      this.loading = false;
	      this.onConfirm();
	      this.closeModal();
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _widgets = __webpack_require__(98);
	
	var _widgets2 = _interopRequireDefault(_widgets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      number: 0,
	      loaded: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    orderReceivedWidgets: 'orderReceivedWidgets'
	  })),
	
	  watch: {
	    orderReceivedWidgets: function orderReceivedWidgets(_orderReceivedWidgets) {
	      this.number = _orderReceivedWidgets.items;
	      this.loaded = true;
	    }
	  },
	
	  methods: {
	    initializeWidgets: function initializeWidgets() {
	      var _this = this;
	
	      Promise.all([_widgets2.default.fetchOrderReceivedWidgets()]).then(function () {
	        _this.number = _this.orderReceivedWidgets.items;
	        _this.loaded = true;
	      });
	    }
	  },
	
	  created: function created() {
	    this.initializeWidgets();
	  }
	};

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _widgets = __webpack_require__(98);
	
	var _widgets2 = _interopRequireDefault(_widgets);
	
	var _line = __webpack_require__(420);
	
	var _line2 = _interopRequireDefault(_line);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LineChart: _line2.default
	  },
	
	  data: function data() {
	    return {
	      lineColor: ['#3B82F6', '#10B981', '#F59E0B', '#8B5CF6', '#EF4444'],
	      options: {
	        plugins: {
	          datalabels: {
	            display: false
	          }
	        },
	        responsive: true,
	        maintainAspectRatio: false,
	        layout: {
	          padding: {
	            left: 0, right: 0, top: 0, bottom: 0
	          }
	        },
	        legend: {
	          display: true,
	          position: 'left',
	          labels: {
	            boxWidth: 4,
	            fontColor: '#64748B'
	          }
	        },
	        scales: {
	          xAxes: [{
	            gridLines: { color: '#E5E7EB', zeroLineColor: '#E5E7EB' },
	            ticks: { fontColor: '#94A3B8', fontSize: 11 }
	          }],
	          yAxes: [{
	            gridLines: { color: '#E5E7EB', zeroLineColor: '#E5E7EB' },
	            ticks: { fontColor: '#94A3B8', fontSize: 11 }
	          }]
	        },
	        tooltips: {
	          enabled: true,
	          backgroundColor: '#1e293b',
	          titleFontColor: '#fff',
	          bodyFontColor: '#94A3B8',
	          callbacks: {
	            label: function label(tooltipItem, data) {
	              return data.datasets[tooltipItem.datasetIndex].tooltip + ' - ' + tooltipItem.yLabel;
	            }
	          }
	        }
	      },
	      chartdata: {
	        labels: [],
	        datasets: []
	      },
	      loaded: false,
	      filterBy: [{ label: this.$t('static.widgets.soldProduct.filters.last3Months'), value: 'last_3_months' }, { label: this.$t('static.widgets.soldProduct.filters.last6Months'), value: 'last_6_months' }, { label: this.$t('static.widgets.soldProduct.filters.thisYear'), value: 'this_year' }],
	      filterBySelected: 'last_3_months',
	      monthNumber: 3,
	      monthStart: 1
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    popularProductsWidgets: 'popularProductsWidgets'
	  })),
	
	  methods: {
	    updateChart: function updateChart(value) {
	      this.monthStart = 1;
	      if (value === 'last_3_months') {
	        this.monthNumber = 3;
	      } else if (value === 'last_6_months') {
	        this.monthNumber = 6;
	      } else {
	        this.monthStart = 0;
	        this.monthNumber = parseInt(new Date().getMonth());
	      }
	      this.initializeWidgets(value);
	    },
	    popularProd: function popularProd(popularProdWidgets) {
	      var _this = this;
	
	      var self = this;
	      var tempData = [];
	      var tempData2 = [];
	      var tempData5 = [];
	      var tempDataLabels = [];
	      this.chartdata.labels = [];
	      this.chartdata.datasets = [];
	
	      this.getFilterBy(this.monthNumber).forEach(function (item) {
	        tempData5[new Date(Date.parse(item + ' 1, 2020')).getMonth() + 1] = item;
	      });
	
	      this.chartdata.labels = [];
	      tempData5.forEach(function (item) {
	        tempDataLabels.push(item);
	      });
	      tempDataLabels.forEach(function (item) {
	        tempData2[item] = 0;
	      });
	
	      popularProdWidgets.top.forEach(function (item, key) {
	        var tempData3 = [];
	        var tempData4 = [];
	
	        for (var i = 0; i <= self.monthNumber; i++) {
	          tempData2[self.getFilterBy(self.monthNumber)[i]] = 0;
	        }
	
	        popularProdWidgets.data.forEach(function (item2) {
	          if (item.name === item2.name) tempData2[item2.month] += 1;
	        });
	
	        tempData3.push(tempData2);
	        var values = Object.entries(tempData3[0]);
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var value = _step.value;
	            tempData4.push(value[1]);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        if (tempData4.length > 0) {
	          tempData.push({
	            tooltip: item.name,
	            label: item.name.length <= 9 ? item.name : item.name.substring(0, 6) + '...',
	            borderColor: self.lineColor[key],
	            backgroundColor: self.colorOpacity(self.lineColor[key], 0.5),
	            data: tempData4
	          });
	        }
	      });
	
	      this.chartdata = {
	        labels: tempDataLabels.map(function (m) {
	          return _this.toNorwegianMonth(m);
	        }),
	        datasets: tempData
	      };
	
	      this.loaded = true;
	    },
	    initializeWidgets: function initializeWidgets(filter) {
	      var _this2 = this;
	
	      this.loaded = false;
	      Promise.all([_widgets2.default.fetchPopularProductsWidgets(filter)]).then(function () {
	        _this2.popularProd(_this2.popularProductsWidgets.items);
	      });
	    },
	    toNorwegianMonth: function toNorwegianMonth(englishMonth) {
	      var date = new Date(Date.parse(englishMonth + ' 1, 2020'));
	      return date.toLocaleDateString('nb-NO', { month: 'long' });
	    },
	    getFilterBy: function getFilterBy(value) {
	      var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	      var today = new Date();
	      var filterBy = [];
	
	      for (var i = this.monthStart; i <= value; i++) {
	        var month = today.getMonth() - i;
	        if (month <= 0) {
	          month += 12;
	        }
	        filterBy.push(monthNames[month]);
	      }
	      return filterBy;
	    },
	    colorOpacity: function colorOpacity(color, opacity) {
	      var opacityy = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
	      return color + opacityy.toString(16).toUpperCase();
	    },
	    onResize: function onResize() {
	      if (window.innerWidth <= 1270) {
	        this.options = this.chartOptions('top', 8);
	      } else {
	        this.options = this.chartOptions('left', 4);
	      }
	      if (this.loaded === true) {
	        this.initializeWidgets(this.filterBySelected);
	      }
	    },
	    chartOptions: function chartOptions() {
	      var legendPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'left';
	      var lengendBoxWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
	
	      return {
	        plugins: {
	          datalabels: { display: false }
	        },
	        responsive: true,
	        maintainAspectRatio: false,
	        layout: {
	          padding: { left: 0, right: 0, top: 0, bottom: 0 }
	        },
	        legend: {
	          display: true,
	          position: legendPos,
	          labels: { boxWidth: lengendBoxWidth, fontColor: '#64748B' }
	        },
	        scales: {
	          xAxes: [{
	            gridLines: { color: '#E5E7EB', zeroLineColor: '#E5E7EB' },
	            ticks: { fontColor: '#94A3B8', fontSize: 11 }
	          }],
	          yAxes: [{
	            gridLines: { color: '#E5E7EB', zeroLineColor: '#E5E7EB' },
	            ticks: { fontColor: '#94A3B8', fontSize: 11 }
	          }]
	        },
	        tooltips: {
	          enabled: true,
	          backgroundColor: '#1e293b',
	          titleFontColor: '#fff',
	          bodyFontColor: '#94A3B8',
	          callbacks: {
	            label: function label(tooltipItem, data) {
	              return data.datasets[tooltipItem.datasetIndex].tooltip + ' - ' + tooltipItem.yLabel;
	            }
	          }
	        }
	      };
	    }
	  },
	
	  created: function created() {
	    window.addEventListener('resize', this.onResize);
	    this.initializeWidgets();
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.onResize);
	  }
	};

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _widgets = __webpack_require__(98);
	
	var _widgets2 = _interopRequireDefault(_widgets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      number: 0,
	      loaded: false,
	      currencyCode: 'no-NO',
	      currencySymbol: 'Kr.'
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    revenueWidgets: 'revenueWidgets'
	  })),
	
	  watch: {
	    revenueWidgets: function revenueWidgets(_revenueWidgets) {
	      this.number = _revenueWidgets.items;
	      this.loaded = true;
	    }
	  },
	
	  methods: {
	    initializeWidgets: function initializeWidgets() {
	      var _this = this;
	
	      Promise.all([_widgets2.default.fetchRevenueWidgets()]).then(function () {
	        _this.number = _this.revenueWidgets.items;
	        _this.loaded = true;
	      });
	    },
	    initializeCurrency: function initializeCurrency() {
	      if (this.currencyCode === 'no-NO') {
	        this.currencySymbol = 'Kr.';
	      }
	    }
	  },
	
	  created: function created() {
	    this.initializeCurrency();
	    this.initializeWidgets();
	  }
	};

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _widgets = __webpack_require__(98);
	
	var _widgets2 = _interopRequireDefault(_widgets);
	
	var _line = __webpack_require__(420);
	
	var _line2 = _interopRequireDefault(_line);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LineChart: _line2.default
	  },
	
	  data: function data() {
	    return {
	      lineColor: ['#073b4c', '#118ab2', '#06d6a0', '#ffd166', '#ef476f'],
	      options: {
	        plugins: {
	          datalabels: {
	            display: true,
	            align: 'center',
	            anchor: 'center'
	          }
	        },
	        responsive: true,
	        maintainAspectRatio: false,
	        layout: {
	          padding: {
	            left: 0, right: 0, top: 0, bottom: 0
	          }
	        },
	        legend: {
	          display: true,
	          position: 'left',
	          labels: {
	            boxWidth: 4
	          }
	        },
	        tooltips: {
	          enabled: true,
	          callbacks: {
	            label: function label(tooltipItem, data) {
	              return data.datasets[tooltipItem.datasetIndex].tooltip + ' - ' + tooltipItem.yLabel;
	            }
	          }
	        }
	      },
	      chartdata: {
	        labels: [],
	        datasets: []
	      },
	      loaded: false,
	      filterBy: [{ label: this.$t('static.widgets.soldProduct.filters.last3Months'), value: 'last_3_months' }, { label: this.$t('static.widgets.soldProduct.filters.last6Months'), value: 'last_6_months' }, { label: this.$t('static.widgets.soldProduct.filters.thisYear'), value: 'this_year' }],
	      filterBySelected: 'last_3_months',
	      monthNumber: 3,
	      monthStart: 1
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    soldProductsWidgets: 'soldProductsWidgets'
	  })),
	
	  methods: {
	    updateChart: function updateChart(value) {
	      this.monthStart = 1;
	      if (value === 'last_3_months') {
	        this.monthNumber = 3;
	      } else if (value === 'last_6_months') {
	        this.monthNumber = 6;
	      } else {
	        this.monthStart = 0;
	        this.monthNumber = parseInt(new Date().getMonth());
	      }
	      this.initializeWidgets(value);
	    },
	    soldProd: function soldProd(soldProdWidgets) {
	      var _this = this;
	
	      var self = this;
	      var tempData = [];
	      var tempData2 = [];
	      var tempData5 = [];
	      var tempDataLabels = [];
	      this.chartdata.labels = [];
	      this.chartdata.datasets = [];
	
	      this.getFilterBy(this.monthNumber).forEach(function (item) {
	        tempData5[new Date(Date.parse(item + ' 1, 2020')).getMonth() + 1] = item;
	      });
	
	      tempData5.forEach(function (item) {
	        tempDataLabels.push(item);
	      });
	      tempDataLabels.forEach(function (item) {
	        tempData2[item] = 0;
	      });
	
	      soldProdWidgets.top.forEach(function (item, key) {
	        var tempData3 = [];
	        var tempData4 = [];
	
	        for (var i = 0; i <= self.monthNumber; i++) {
	          tempData2[self.getFilterBy(self.monthNumber)[i]] = 0;
	        }
	
	        soldProdWidgets.data.forEach(function (item2) {
	          if (item.product_id === item2.product_id) tempData2[item2.month] += item2.qty;
	        });
	
	        tempData3.push(tempData2);
	        var values = Object.entries(tempData3[0]);
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var value = _step.value;
	            tempData4.push(value[1]);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        if (tempData4.length > 0) {
	          tempData.push({
	            tooltip: item.name,
	            label: item.name.length <= 9 ? item.name : item.name.substring(0, 6) + '...',
	            borderColor: self.lineColor[key],
	            backgroundColor: self.colorOpacity(self.lineColor[key], 0.5),
	            data: tempData4
	          });
	        }
	      });
	
	      this.chartdata = {
	        labels: tempDataLabels.map(function (m) {
	          return _this.toNorwegianMonth(m);
	        }),
	        datasets: tempData
	      };
	
	      this.loaded = true;
	    },
	    initializeWidgets: function initializeWidgets(filter) {
	      var _this2 = this;
	
	      this.loaded = false;
	      Promise.all([_widgets2.default.fetchSoldProductsWidgets(filter)]).then(function () {
	        _this2.soldProd(_this2.soldProductsWidgets.items);
	      });
	    },
	    toNorwegianMonth: function toNorwegianMonth(englishMonth) {
	      var date = new Date(Date.parse(englishMonth + ' 1, 2020'));
	      return date.toLocaleDateString('nb-NO', { month: 'long' });
	    },
	    getFilterBy: function getFilterBy(value) {
	      var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	      var today = new Date();
	      var filterBy = [];
	
	      for (var i = this.monthStart; i <= value; i++) {
	        var month = today.getMonth() - i;
	        if (month <= 0) {
	          month += 12;
	        }
	        filterBy.push(monthNames[month]);
	      }
	      return filterBy;
	    },
	    colorOpacity: function colorOpacity(color, opacity) {
	      var opacityy = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
	      return color + opacityy.toString(16).toUpperCase();
	    },
	    onResize: function onResize() {
	      if (window.innerWidth <= 1270) {
	        this.options = this.chartOptions('top', 8);
	      } else {
	        this.options = this.chartOptions('left', 4);
	      }
	      if (this.loaded === true) {
	        this.initializeWidgets(this.filterBySelected);
	      }
	    },
	    chartOptions: function chartOptions() {
	      var legendPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'left';
	      var lengendBoxWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
	
	      return {
	        plugins: {
	          datalabels: {
	            display: true,
	            align: 'center',
	            anchor: 'center'
	          }
	        },
	        responsive: true,
	        maintainAspectRatio: false,
	        layout: {
	          padding: {
	            left: 0, right: 0, top: 0, bottom: 0
	          }
	        },
	        legend: {
	          display: true,
	          position: legendPos,
	          labels: {
	            boxWidth: lengendBoxWidth
	          }
	        },
	        tooltips: {
	          enabled: true,
	          callbacks: {
	            label: function label(tooltipItem, data) {
	              return data.datasets[tooltipItem.datasetIndex].tooltip + ' - ' + tooltipItem.yLabel;
	            }
	          }
	        }
	      };
	    }
	  },
	
	  mounted: function mounted() {
	    this.initializeWidgets();
	  },
	  created: function created() {
	    window.addEventListener('resize', this.onResize);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.onResize);
	  }
	};

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _widgets = __webpack_require__(98);
	
	var _widgets2 = _interopRequireDefault(_widgets);
	
	var _horizontalBar = __webpack_require__(2755);
	
	var _horizontalBar2 = _interopRequireDefault(_horizontalBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BarChart: _horizontalBar2.default
	  },
	
	  data: function data() {
	    return {
	      options: {
	        plugins: {
	          datalabels: {
	            display: true,
	            align: 'center',
	            anchor: 'center'
	          }
	        },
	        responsive: true,
	        maintainAspectRatio: false,
	        layout: {
	          padding: {
	            left: 0, right: 0, top: 0, bottom: 0
	          }
	        },
	        legend: {
	          display: false,
	          position: 'left',
	          labels: {
	            boxWidth: 0
	          }
	        },
	        tooltips: {
	          enabled: false
	        }
	      },
	      chartdata: {
	        labels: [],
	        datasets: [{
	          backgroundColor: ['#3B82F6', '#8B5CF6', '#3B82F6', '#8B5CF6', '#3B82F6', '#8B5CF6', '#3B82F6', '#8B5CF6', '#3B82F6', '#8B5CF6'],
	          data: []
	        }]
	      },
	      loaded: false,
	      filterBy: [{ label: this.$t('static.widgets.soldProduct.filters.last3Months'), value: 'last_3_months' }, { label: this.$t('static.widgets.soldProduct.filters.last6Months'), value: 'last_6_months' }, { label: this.$t('static.widgets.soldProduct.filters.thisYear'), value: 'this_year' }],
	      filterBySelected: 'last_3_months',
	      monthNumber: 3,
	      monthStart: 1
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    bestClientsWidgets: 'bestClientsWidgets'
	  })),
	
	  watch: {
	    bestClientsWidgets: function bestClientsWidgets(_bestClientsWidgets) {
	      this.topClients(_bestClientsWidgets.items);
	    }
	  },
	
	  methods: {
	    updateChart: function updateChart(value) {
	      this.monthStart = 1;
	      if (value === 'last_3_months') {
	        this.monthNumber = 3;
	      } else if (value === 'last_6_months') {
	        this.monthNumber = 6;
	      } else {
	        this.monthStart = 0;
	        this.monthNumber = parseInt(new Date().getMonth());
	      }
	      this.initializeWidgets(value);
	    },
	    topClients: function topClients(bestClientsWidgets) {
	      var self = this;
	      this.chartdata.labels = [];
	      this.chartdata.datasets[0].data = [];
	      var values = Object.entries(bestClientsWidgets);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var value = _step.value;
	
	          self.chartdata.labels.push(value[0] + ' (' + value[1] + ')');
	          self.chartdata.datasets[0].data.push(value[1]);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this.loaded = true;
	    },
	    initializeWidgets: function initializeWidgets(filter) {
	      var _this = this;
	
	      this.loaded = false;
	      Promise.all([_widgets2.default.fetchBestClientsWidgets(filter)]).then(function () {
	        _this.topClients(_this.bestClientsWidgets.items);
	      });
	    }
	  },
	
	  created: function created() {
	    this.initializeWidgets();
	  }
	};

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _widgets = __webpack_require__(98);
	
	var _widgets2 = _interopRequireDefault(_widgets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            number: 0,
	            loaded: false
	        };
	    },
	
	
	    computed: _extends({}, (0, _vuex.mapGetters)({
	        waitingDeliveredWidgets: 'waitingDeliveredWidgets'
	    })),
	
	    watch: {
	        waitingDeliveredWidgets: function waitingDeliveredWidgets(_waitingDeliveredWidgets) {
	            this.number = _waitingDeliveredWidgets.items;
	            this.loaded = true;
	        }
	    },
	
	    methods: {
	        initializeWidgets: function initializeWidgets() {
	            var _this = this;
	
	            Promise.all([_widgets2.default.fetchWaitingDeliveredWidgets()]).then(function () {
	                _this.number = _this.waitingDeliveredWidgets.items;
	                _this.loaded = true;
	            });
	        }
	    },
	
	    created: function created() {
	        this.initializeWidgets();
	    }
	};

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _widgets = __webpack_require__(98);
	
	var _widgets2 = _interopRequireDefault(_widgets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            number: 0,
	            loaded: false
	        };
	    },
	
	
	    computed: _extends({}, (0, _vuex.mapGetters)({
	        waitingProcessedWidgets: 'waitingProcessedWidgets'
	    })),
	
	    watch: {
	        waitingProcessedWidgets: function waitingProcessedWidgets(_waitingProcessedWidgets) {
	            this.number = _waitingProcessedWidgets.items;
	            this.loaded = true;
	        }
	    },
	
	    methods: {
	        initializeWidgets: function initializeWidgets() {
	            var _this = this;
	
	            Promise.all([_widgets2.default.fetchWaitingProcessedWidgets()]).then(function () {
	                _this.number = _this.waitingProcessedWidgets.items;
	                _this.loaded = true;
	            });
	        }
	    },
	
	    created: function created() {
	        this.initializeWidgets();
	    }
	};

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueChartjs = __webpack_require__(763);
	
	exports.default = {
	  extends: _vueChartjs.HorizontalBar,
	  props: {
	    chartdata: {
	      type: Object,
	      default: null
	    },
	    options: {
	      type: Object,
	      default: null
	    }
	  },
	  mounted: function mounted() {
	    this.renderChart(this.chartdata, this.options);
	  }
	};

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueChartjs = __webpack_require__(763);
	
	var reactiveProp = _vueChartjs.mixins.reactiveProp;
	exports.default = {
	  extends: _vueChartjs.Line,
	  mixins: [reactiveProp],
	  props: ['chartData', 'options'],
	  mounted: function mounted() {
	    this.renderChart(this.chartData, this.options);
	  }
	};

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _account2 = __webpack_require__(12);
	
	var _account3 = _interopRequireDefault(_account2);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  props: {
	    mod: {
	      type: Object,
	      required: true
	    }
	  },
	
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        websiteUrl: {
	          type: 'text',
	          value: ''
	        },
	        apiKey: {
	          type: 'text',
	          value: ''
	        },
	        secretKey: {
	          type: 'text',
	          value: ''
	        },
	        language: {
	          type: 'select',
	          value: 'en'
	        },
	        warehouseId: {
	          type: 'select',
	          value: ''
	        },
	        syncProductGroup: {
	          type: 'switch',
	          value: ''
	        },
	        syncSelectedProductsOnly: {
	          type: 'switch',
	          value: ''
	        },
	        productAttributes: {
	          type: 'checkboxGroup',
	          value: []
	        }
	      }),
	      token: '',
	      loading: false,
	      generateTokenLoading: false,
	      backendUrl: ("https://api.kundan.no")
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    warehouses: 'allWarehouses',
	    account: 'account'
	  }), {
	    productAttributesOptions: function productAttributesOptions() {
	      var attributes = this.$i18n.messages[this.$i18n.locale].static.wooProducts.attributes;
	      return Object.entries(attributes).reduce(function (obj, item) {
	        return [].concat(_toConsumableArray(obj), [{ id: item[0], name: item[1] }]);
	      }, []);
	    }
	  }),
	
	  mounted: function mounted() {
	    this.form.setOptions('language', [{ id: 'en', name: 'English' }, { id: 'nb', name: 'Norwegian' }]);
	    this.form.setOptions('productAttributes', this.productAttributesOptions);
	    this.show();
	  },
	
	
	  watch: {
	    warehouses: function warehouses(_warehouses) {
	      this.form.setOptions('warehouseId', _warehouses.items);
	    },
	    account: function account(_account) {
	      if (_account && _account.isPartner) {
	        this.form.hideField('warehouseId');
	      }
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalClass: 'SET_MODAL_CLASS'
	  }), {
	    show: function show() {
	      var _this = this;
	
	      Promise.all([_account3.default.wooCredentials(), _warehouse2.default.all(), _account3.default.find()]).then(function (data) {
	        _this.form.websiteUrl = data[0].websiteUrl;
	        _this.form.apiKey = data[0].apiKey;
	        _this.form.secretKey = data[0].secretKey;
	        _this.form.warehouseId = data[0].warehouseId;
	        _this.form.language = data[0].language;
	        _this.form.syncProductGroup = data[0].syncProductGroup;
	        _this.form.syncSelectedProductsOnly = data[0].syncSelectedProductsOnly;
	        _this.token = data[0].token;
	        if (data[0].productAttributes) {
	          var productAttributes = [];
	          data[0].productAttributes.forEach(function (m) {
	            var attr = _this.productAttributesOptions.find(function (p) {
	              return p.id === m;
	            });
	            productAttributes.push(attr.name);
	          });
	          _this.form.productAttributes = productAttributes;
	        }
	      });
	    },
	    store: function store() {
	      var _this2 = this;
	
	      var productAttributes = [];
	      this.form.productAttributes.forEach(function (m) {
	        var attr = _this2.productAttributesOptions.find(function (p) {
	          return p.name === m;
	        });
	        productAttributes.push(attr.id);
	      });
	
	      var params = {
	        module_id: this.mod.id,
	        is_woo_api: true,
	        website_url: this.form.websiteUrl,
	        api_key: this.form.apiKey,
	        secret_key: this.form.secretKey,
	        warehouse_id: this.form.warehouseId,
	        language: this.form.language,
	        sync_product_group: this.form.syncProductGroup,
	        product_attributes: productAttributes,
	        sync_selected_products_only: this.form.syncSelectedProductsOnly
	      };
	      _modules2.default.subscribe(this.mod.id, params).then(function () {
	        Promise.all([_modules2.default.items(), _account3.default.find()]);
	        _this2.closeModal();
	      });
	    },
	    copyToken: function copyToken() {
	      var tokenInput = this.$refs.tokenInput;
	      tokenInput.select();
	      document.execCommand('copy');
	    },
	    generateToken: function generateToken() {
	      var _this3 = this;
	
	      this.generateTokenLoading = true;
	      _account3.default.wooGenerateToken().then(function (result) {
	        _this3.token = result.token;
	        _this3.generateTokenLoading = false;
	      }).catch(function (err) {
	        _this3.generateTokenLoading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggleModal(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    mod: {
	      type: Object,
	      required: true
	    }
	  },
	
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        websiteUrl: {
	          type: 'text',
	          value: ''
	        }
	      }),
	      token: '',
	      loading: false,
	      generateTokenLoading: false,
	      backendUrl: ("https://api.kundan.no")
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account'
	  })),
	
	  mounted: function mounted() {
	    this.show();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalClass: 'SET_MODAL_CLASS'
	  }), {
	    show: function show() {
	      var _this = this;
	
	      Promise.all([_account2.default.wordpressCredentials(), _account2.default.find()]).then(function (data) {
	        _this.form.websiteUrl = data[0].websiteUrl;
	        _this.token = data[0].token;
	      });
	    },
	    store: function store() {
	      var _this2 = this;
	
	      var params = {
	        module_id: this.mod.id,
	        is_wordpress_api: true,
	        website_url: this.form.websiteUrl
	      };
	      _modules2.default.subscribe(this.mod.id, params).then(function () {
	        Promise.all([_modules2.default.items(), _account2.default.find()]);
	        _this2.closeModal();
	      });
	    },
	    copyToken: function copyToken() {
	      var tokenInput = this.$refs.tokenInput;
	      tokenInput.select();
	      document.execCommand('copy');
	    },
	    generateToken: function generateToken() {
	      var _this3 = this;
	
	      this.generateTokenLoading = true;
	      _account2.default.wordpressGenerateToken().then(function (result) {
	        _this3.token = result.token;
	        _this3.generateTokenLoading = false;
	      }).catch(function () {
	        _this3.generateTokenLoading = false;
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggleModal(false);
	      this.unsetModalContent();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _auth = __webpack_require__(53);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      sideMenuActive: false,
	      expanded: false,
	      index: 0,
	      activeItemSubMenu: null,
	      alertWarning: '',
	      hasUnpaidInvoice: false,
	      unpaidInvoicePollId: null
	    };
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)(['innerSidebarState', 'innerSidebar', 'stockMutationsHandedOff', 'stockDecommissioned', 'inventoryAppUrl']), {
	    bridgeHandoffMessage: function bridgeHandoffMessage() {
	      if (this.stockDecommissioned) {
	        return this.$t('static.bridgeHandoff.decommissioned');
	      }
	      if (this.stockMutationsHandedOff) {
	        return this.$t('static.bridgeHandoff.handedOff');
	      }
	      return '';
	    }
	  }),
	  methods: {
	    toggleInnerSideMenuAndRoute: function toggleInnerSideMenuAndRoute(event, route) {
	      var scopeIndexes = [2, 5, 7, 8, 9];
	      this.index = Number(event.index);
	      if (this.$route.name === route) {
	        if (scopeIndexes.includes(Number(event.index))) return;
	
	        this.expanded = !this.expanded;
	        return;
	      }
	
	      if (!scopeIndexes.includes(Number(event.index))) {
	        this.expanded = true;
	      } else {
	        this.expanded = false;
	      }
	
	      this.$router.push({
	        name: route
	      });
	    },
	    closeInnerSideMenu: function closeInnerSideMenu() {
	      this.expanded = false;
	    },
	    toggleMenu: function toggleMenu() {
	      this.sideMenuActive = !this.sideMenuActive;
	    },
	    logout: function logout() {
	      _auth2.default.logout();
	    },
	    checkUnpaidInvoice: function checkUnpaidInvoice() {
	      var _this = this;
	
	      _account2.default.unpaidInvoice().then(function (data) {
	        _this.hasUnpaidInvoice = data !== 'noShow' && data && data.hasUnpaidInvoice === true;
	      }).catch(function (errors) {
	        console.log(errors);
	      });
	    },
	    handleVisibilityChange: function handleVisibilityChange() {
	      if (!document.hidden) {
	        this.checkUnpaidInvoice();
	      }
	    }
	  },
	  watch: {
	    $route: function $route() {
	      this.checkUnpaidInvoice();
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    Promise.all([_account2.default.subscription()]).then(function (data) {
	      if (data[0] !== 'noShow') {
	        var transRoot = 'static.accountAlert';
	        var endedOrEnding = data[0]['dateDiff'] > 0 ? _this2.$t(transRoot + '.msgPart2Ending') : _this2.$t(transRoot + '.msgPart2Ended');
	        var dayWithS = data[0]['dateDiff'] === 1 ? _this2.$t(transRoot + '.partial.day') : _this2.$t(transRoot + '.partial.days');
	        var days = data[0]['dateDiff'] > 0 ? _this2.$t(transRoot + '.partial.willEndIn') + ' ' + data[0]['dateDiff'] + ' ' + dayWithS + ', ' : '';
	        _this2.alertWarning = _this2.$t(transRoot + '.greetings') + ', ' + days + ' ' + endedOrEnding;
	      }
	    }).catch(function (errors) {
	      console.log(errors);
	    });
	
	    this.checkUnpaidInvoice();
	
	    this.unpaidInvoicePollId = setInterval(this.checkUnpaidInvoice, 60000);
	    document.addEventListener('visibilitychange', this.handleVisibilityChange);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.unpaidInvoicePollId) {
	      clearInterval(this.unpaidInvoicePollId);
	      this.unpaidInvoicePollId = null;
	    }
	    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
	  },
	
	  components: {
	    VSidebar: __webpack_require__(2738),
	    VHeader: __webpack_require__(2712),
	    VDialog: __webpack_require__(772)
	  }
	};

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _auth = __webpack_require__(53);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        email: {
	          value: '',
	          type: 'email'
	        },
	        password: {
	          value: '',
	          type: 'password'
	        }
	      })
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    maintenance: 'isInMaintenance'
	  })),
	
	  created: function created() {},
	
	
	  methods: {
	    login: function login() {
	      var _this = this;
	
	      this.form.loading = true;
	      this.form.errorBox = false;
	      _auth2.default.login(this.form.data()).catch(function (errors) {
	        if (errors.error && errors.error.code === 42206) {
	          _this.form.errorBoxTitle = _this.$t('static.login.inactiveAccount');
	        } else if (errors.error && errors.error.code === 42901) {
	          _this.form.errorBoxTitle = errors.error.message || 'Too many login attempts. Please try again later.';
	        }
	        _this.form.loading = false;
	        _this.form.errorBox = true;
	        _this.form.recordErrors(errors);
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9),
	    VLayout: __webpack_require__(280)
	  }
	};

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(53);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        email: {
	          value: '',
	          type: 'email'
	        }
	      })
	    };
	  },
	
	
	  methods: {
	    send: function send() {
	      var _this = this;
	
	      this.form.loading = true;
	      _auth2.default.resetPassword(this.form.data()).then(function () {
	        _this.form.loading = false;
	        _this.form.email = '';
	        _this.form.successMessage = _this.$t('static.resetPassword.successMessage');
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9),
	    VLayout: __webpack_require__(280)
	  }
	};

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _auth = __webpack_require__(53);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        code: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      twoFactorTimerCount: null,
	      resendLoading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    twoFactorVerificationType: 'twoFactorVerification'
	  }), {
	    isSms: function isSms() {
	      return this.twoFactorVerificationType === 'sms';
	    },
	    isGoogle: function isGoogle() {
	      return this.twoFactorVerificationType === 'google';
	    },
	    mobileNumber: function mobileNumber() {
	      var last3Mobile = localStorage.getItem('mobile_number');
	      return '+47*****' + last3Mobile;
	    }
	  }),
	
	  watch: {
	    twoFactorTimerCount: {
	      handler: function handler(value) {
	        var _this = this;
	
	        if (value > 0) {
	          setTimeout(function () {
	            _this.twoFactorTimerCount--;
	          }, 1000);
	        }
	      },
	
	      immediate: true }
	  },
	
	  created: function created() {
	    this.twoFactorTimerCount = 30;
	    _store2.default.dispatch('checkTwoFactorVerification');
	  },
	
	
	  methods: {
	    resend: function resend() {
	      var _this2 = this;
	
	      this.resendLoading = true;
	      _auth2.default.resendSmsTwoFactorCode(localStorage.user_id).then(function () {
	        _this2.resendLoading = false;
	        _this2.$message({
	          message: _this2.$t('static.smsTwoFactorVerification.verificationCodeSent'),
	          type: 'success'
	        });
	        _this2.twoFactorTimerCount = 30;
	      }).catch(function (errors) {
	        _this2.resendLoading = false;
	        _this2.form.errorBox = true;
	        _this2.form.recordErrors(errors);
	      });
	    },
	    verify: function verify() {
	      var _this3 = this;
	
	      this.form.loading = true;
	      var data = this.form.data();
	      data.user_id = localStorage.user_id;
	      if (this.isSms) {
	        _auth2.default.verifySmsTwoFactorCode(data).catch(function (errors) {
	          _this3.handleError(errors);
	        });
	      } else {
	        _auth2.default.verifyGoogleTwoFactorCode(data).catch(function (errors) {
	          _this3.handleError(errors);
	        });
	      }
	    },
	    handleError: function handleError(errors) {
	      this.form.loading = false;
	      this.form.errorBox = true;
	      this.form.recordErrors(errors);
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9),
	    VLayout: __webpack_require__(280)
	  }
	};

/***/ }),
/* 1869 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(53);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    _auth2.default.loginUsingToken(_store2.default.state.route.params.token);
	  }
	};

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _releaseNote = __webpack_require__(1271);
	
	var _releaseNote2 = _interopRequireDefault(_releaseNote);
	
	var _date = __webpack_require__(107);
	
	var _date2 = _interopRequireDefault(_date);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      releaseNotes: []
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _releaseNote2.default.all().then(function (data) {
	      _this.releaseNotes = data;
	    });
	  },
	
	
	  mixins: [_date2.default]
	
	};

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _accountSetup = __webpack_require__(308);
	
	var _accountSetup2 = _interopRequireDefault(_accountSetup);
	
	var _checkBusiness = __webpack_require__(496);
	
	var _checkBusiness2 = _interopRequireDefault(_checkBusiness);
	
	var _auth = __webpack_require__(53);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        email: {
	          value: '',
	          type: 'email',
	          required: true,
	          maxlength: 10
	        },
	        businessRegistrationNumber: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      finalStep: new _forms2.default({
	        businessRegistrationNumber: {
	          value: '',
	          type: 'text'
	        },
	        businessName: {
	          value: '',
	          type: 'text'
	        },
	        email: {
	          value: '',
	          type: 'email'
	        },
	        mobile: {
	          value: '',
	          type: 'float'
	        },
	        address: {
	          value: '',
	          type: 'text'
	        },
	        postalCode: {
	          value: '',
	          type: 'float'
	        },
	        city: {
	          value: '',
	          type: 'text'
	        },
	        isVatRegistered: {
	          value: false,
	          type: 'checkbox'
	        },
	        isRegisteredBusinessEnterprise: {
	          value: false,
	          type: 'checkbox'
	        },
	        marketingAllowed: {
	          value: false,
	          type: 'checkbox'
	        },
	        tosAccepted: {
	          value: false,
	          type: 'term'
	        }
	      }),
	      step: 1
	    };
	  },
	  mounted: function mounted() {
	    console.log(this.$route.params.plan);
	    if (this.$route.params.plan !== 'edi' && this.$route.params.plan !== 'booking') {
	      this.form.hideField('businessRegistrationNumber');
	    }
	    if (this.$route.params.plan === 'edi' && this.$route.params.plan !== 'booking') {
	      this.finalStep.disableField('businessRegistrationNumber');
	    }
	  },
	
	
	  computed: {
	    headerMessage1: function headerMessage1() {
	      return this.$t('static.emailSetup.headerMessage1') + '\n      ' + this.$t('static.emailSetup.' + this.$route.params.plan);
	    },
	    headerMessage2: function headerMessage2() {
	      return '' + this.$t('static.emailSetup.headerMessage2');
	    },
	    loginInstead: function loginInstead() {
	      if (this.form.errors.errors && this.form.errors.errors.email && (this.form.errors.errors.email[0] === 'email er allerede i bruk.' || this.form.errors.errors.email[0] === 'email has already been taken.')) {
	        return true;
	      }
	
	      return false;
	    }
	  },
	
	  watch: {
	    'form.email': function formEmail(value) {
	      this.form.email = value.replace(/\s+/g, '');
	    }
	  },
	
	  methods: {
	    next: function next() {
	      var _this = this;
	
	      this.form.loading = true;
	
	      var business = _checkBusiness2.default.send(this.form.data());
	      _auth2.default.checkBusiness(business).then(function (response) {
	        _this.form.loading = false;
	        _this.finalStep.businessRegistrationNumber = _this.form.businessRegistrationNumber;
	        _this.finalStep.businessName = response.businessName;
	        _this.finalStep.email = _this.form.email;
	        _this.finalStep.address = response.address;
	        _this.finalStep.postalCode = response.postalCode;
	        _this.finalStep.city = response.city;
	        _this.finalStep.country = response.country;
	        _this.finalStep.isVatRegistered = response.isVatRegistered;
	        _this.finalStep.isRegisteredBusinessEnterprise = response.isRegisteredBusinessEnterprise;
	        _this.step = 2;
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	      });
	    },
	    register: function register() {
	      var _this2 = this;
	
	      if (!this.finalStep.tosAccepted) {
	        this.$alert('' + this.$t('static.accountSetup.termsError'));
	        return false;
	      }
	      this.finalStep.loading = true;
	      this.finalStep.plan = this.$route.params.plan;
	      this.finalStep.type = this.$route.query.type;
	      var account = _accountSetup2.default.send(this.finalStep.data());
	      _auth2.default.registerEmail(account).catch(function (errors) {
	        _this2.finalStep.loading = false;
	        _this2.finalStep.recordErrors(errors);
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(5);
	
	var _adjustment = __webpack_require__(227);
	
	var _adjustment2 = _interopRequireDefault(_adjustment);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _bridgeHandoff = __webpack_require__(81);
	
	var _bridgeHandoff2 = _interopRequireDefault(_bridgeHandoff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sortValue: '',
	      limit: 25
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    adjustments: 'paginateAdjustments'
	  }), {
	    adjustmentsList: function adjustmentsList() {
	      return this.adjustments.items.map(function (b) {
	        return b;
	      });
	    }
	  }),
	
	  watch: {
	
	    adjustments: function adjustments(_adjustments) {},
	    $route: function $route() {
	      this.all(1, 25);
	    }
	  },
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19)
	  },
	
	  mixins: [_search2.default, _bridgeHandoff2.default],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.setInnerSidebar([{
	      title: this.$t('static.inventory.transaction.title'),
	      options: [{
	        title: this.$t('static.stock.filters.title'),
	        route: {
	          name: 'inventory.stock.index'
	        }
	      }, {
	        title: this.$t('static.adjustment.filters.title'),
	        route: {
	          name: 'inventory.adjustment.index'
	        }
	      }, {
	        title: this.$t('static.purchase.filters.title'),
	        route: {
	          name: 'inventory.purchase.index'
	        }
	      }, {
	        title: this.$t('static.transfer.filters.title'),
	        route: {
	          name: 'inventory.transfer.index'
	        }
	      }],
	      button: this.bridgeStockWriteBlocked ? null : {
	        title: '+ ' + this.$t('static.warehouse.addTransaction.title'),
	        route: {
	          name: 'inventory.transaction.index'
	        }
	      }
	    }, {
	      title: this.$t('static.warehouse.filters.title'),
	      options: [{
	        title: this.$t('static.warehouse.filters.view'),
	        route: {
	          name: 'warehouse.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.warehouse.create.title'),
	        route: {
	          name: 'warehouse.create'
	        }
	      }
	    }]);
	
	    _account2.default.rememberPerPage('get', { from: 'adjustment' }).then(function (data) {
	      _this.limit = data.size;
	      _this.all(1, _this.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    formatDate: function formatDate(value) {
	      var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';
	
	      if (!value) {
	        return '-';
	      }
	      var m = (0, _moment2.default)(value);
	      return m.isValid() ? m.format(pattern) : '-';
	    },
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'adjustment', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this3 = this;
	
	      this.loading = true;
	      _adjustment2.default.items({
	        page: page,
	        limit: limit,
	        search: this.getSearch(this.limit),
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this3.loading = false;
	      }).catch(function () {
	        _this3.loadProductsing = false;
	      });
	    }, 800),
	
	    editAdjustment: function editAdjustment(adjustment) {
	      var name = 'inventory.adjustment.view';
	      if (adjustment.status === 'draft' || adjustment.status === 'pending') {
	        name = 'inventory.adjustment.stock.edit';
	      }
	      this.$router.push({
	        name: name,
	        params: { id: adjustment.id }
	      });
	    }
	  })
	};

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _adjustment = __webpack_require__(227);
	
	var _adjustment2 = _interopRequireDefault(_adjustment);
	
	var _adjustment3 = __webpack_require__(82);
	
	var _adjustment4 = _interopRequireDefault(_adjustment3);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        warehouseId: {
	          value: '',
	          type: 'select'
	        },
	        adjustmentTypeId: {
	          value: '',
	          type: 'select'
	        },
	        reason: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      loading: true,
	      tabIndex: 'first',
	      fields: {
	        productId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        batchId: {
	          value: '',
	          type: 'select'
	        },
	        currentAdjustment: {
	          value: '0',
	          type: 'text',
	          disabled: true
	        },
	        qty: {
	          value: '0',
	          type: 'text'
	        }
	      },
	
	      isImport: true,
	      isExport: true,
	      download: this.downloadProduct,
	      server: {
	        url: ''
	      },
	      adjustmentTypeOptions: []
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentStockProducts: 'currentStockProductsCustom',
	    warehouses: 'allWarehouses'
	  })),
	
	  watch: {
	    $route: function $route() {
	      this.warehouseTarget();
	    },
	
	
	    'formBasicInformation.adjustmentTypeId': function formBasicInformationAdjustmentTypeId(adjustmentTypeId) {
	      this.renameLabel(adjustmentTypeId);
	    },
	
	    warehouses: function warehouses(_warehouses) {
	      var _this = this;
	
	      var data = _warehouses.items.filter(function (item) {
	        return !item.isSharedToYou;
	      });
	      this.formBasicInformation.setOptions('warehouseId', data.map(function (item) {
	        return { id: item.id, name: item.name + (item.isLocked ? _this.$t('static.warehouse.info.locked') : ''), disabled: item.isLocked };
	      }));
	    },
	
	    'formBasicInformation.warehouseId': function formBasicInformationWarehouseId(warehouseId) {
	      var _this2 = this;
	
	      this.server = {
	        url: ("https://api.kundan.no") + '/adjustments/' + this.formBasicInformation.warehouseId + '/import-product?token=' + localStorage.getItem('id_token'),
	        process: {
	          onload: function onload(res) {
	            var name = 'inventory.adjustment.stock.edit';
	
	            var obj = JSON.parse(res);
	            _this2.$router.push({
	              name: name,
	              params: { id: obj.id }
	            });
	          }
	        }
	      };
	      _store2.default.dispatch('setStockSelectedWarehouse', warehouseId);
	    },
	    stocks: function stocks(_stocks) {
	      this.formBasicInformation.setOptions('stockId', _stocks.items.map(function (c) {
	        return { id: c.id, name: c.code };
	      }));
	    },
	
	    'formBasicInformation.stockId': function formBasicInformationStockId(stockId) {
	      var stock = this.stocks.items.filter(function (p) {
	        return p.id.toString() === stockId;
	      });
	    }
	  },
	
	  created: function created() {
	    this.loading = false;
	  },
	
	
	  methods: {
	    warehouseTarget: function warehouseTarget() {
	      var warehouseIds = this.warehouses.items.map(function (item) {
	        return item.id;
	      });
	      var targeId = this.$router.currentRoute.hash.substring(1);
	      if (warehouseIds.indexOf(parseInt(targeId)) !== -1) {
	        this.formBasicInformation.setFieldValue('warehouseId', targeId);
	      }
	    },
	    renameLabel: function renameLabel(adjustmentTypeId) {
	      var type = '';
	      this.adjustmentTypeOptions.forEach(function (item) {
	        if (parseInt(item.id) === parseInt(adjustmentTypeId)) {
	          type = item.name;
	          return;
	        }
	      });
	
	      if (type === 'Wastage' || type === 'Destruction') {
	        jQuery('.th-qty').text(this.$t('table.adjustment.products.qty.customDeduct'));
	      } else {
	        jQuery('.th-qty').text(this.$t('table.adjustment.products.qty.label'));
	      }
	    },
	    store: function store() {
	      var _this3 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _adjustment4.default.send(Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts, type: 4 }));
	      _adjustment2.default.store(client).then(function () {
	        _this3.$message({
	          message: _this3.$t('static.adjustment.create.success'),
	          type: 'success'
	        });
	        _this3.$router.push({
	          name: 'inventory.adjustment.index'
	        });
	      }).catch(function (errors) {
	        var message = errors.message;
	        _this3.formBasicInformation.loading = false;
	        _this3.formBasicInformation.recordErrors(errors);
	        if (errors.message) {
	          _this3.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    saveDraft: function saveDraft() {
	      var _this4 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _adjustment4.default.send(Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts, type: 1 }));
	      _adjustment2.default.saveDraft(client).then(function () {
	        _this4.$message({
	          message: _this4.$t('static.adjustment.draft.success'),
	          type: 'success'
	        });
	        _this4.$router.push({
	          name: 'inventory.adjustment.index'
	        });
	      }).catch(function (errors) {
	        var message = errors.message;
	        _this4.formBasicInformation.loading = false;
	        _this4.formBasicInformation.recordErrors(errors);
	        if (errors.message) {
	          _this4.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    searchMethod: function searchMethod(search, field) {
	      return Promise.all([_product2.default.searchAll({ search: search })]);
	    },
	    downloadProduct: function downloadProduct() {
	      _adjustment2.default.downloadProduct(this.formBasicInformation.warehouseId);
	    }
	  },
	  mounted: function mounted() {
	    var _this5 = this;
	
	    _store2.default.dispatch('allCurrentStockProductsCustom', []);
	    Promise.all([_warehouse2.default.all(), _adjustment2.default.adjustmentType()]).then(function (data) {
	      _store2.default.dispatch('setStockSelectedWarehouse', 0);
	      _this5.adjustmentTypeOptions = data[1].map(function (item) {
	        return {
	          id: item.id,
	          name: _this5.$t('form.adjustment.adjustmentTypeList.' + item.name.toLowerCase())
	        };
	      });
	      _this5.formBasicInformation.setOptions('adjustmentTypeId', _this5.adjustmentTypeOptions);
	      _this5.formBasicInformation.setFieldValue('adjustmentTypeId', _this5.$t('form.adjustment.adjustmentTypeList.adjustment'));
	      _this5.warehouseTarget();
	    });
	  },
	
	
	  components: {
	    VForm: __webpack_require__(9),
	    VProductsTable: __webpack_require__(123),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _adjustment = __webpack_require__(227);
	
	var _adjustment2 = _interopRequireDefault(_adjustment);
	
	var _adjustment3 = __webpack_require__(82);
	
	var _adjustment4 = _interopRequireDefault(_adjustment3);
	
	var _stock = __webpack_require__(162);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        warehouseId: {
	          value: '',
	          type: 'select'
	        },
	        adjustmentTypeId: {
	          value: '',
	          type: 'select'
	        },
	        reason: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      loading: true,
	      tabIndex: 'first',
	      fields: {
	        productId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        batchId: {
	          value: '',
	          type: 'select'
	        },
	        currentAdjustment: {
	          value: '0',
	          type: 'text',
	          disabled: true
	        },
	        qty: {
	          value: '0',
	          type: 'text'
	        }
	      },
	
	      isImport: true,
	      isExport: true,
	      download: this.downloadProduct,
	      server: {
	        url: ''
	
	      },
	      adjustmentTypeOptions: []
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentStockProducts: 'currentStockProductsCustom',
	
	    warehouses: 'allWarehouses',
	    currentAdjustment: 'currentAdjustment'
	  }), {
	    isSharedToYou: function isSharedToYou() {
	      var _this = this;
	
	      var data = this.warehouses.items.filter(function (item) {
	        return item.id === _this.formBasicInformation.warehouseId;
	      });
	      if (data.length > 0) {
	        return data[0].isSharedToYou;
	      }
	      return false;
	    }
	  }),
	
	  watch: {
	
	    'formBasicInformation.adjustmentTypeId': function formBasicInformationAdjustmentTypeId(adjustmentTypeId) {
	      this.renameLabel(adjustmentTypeId);
	    },
	
	    warehouses: function warehouses(_warehouses) {
	      var _this2 = this;
	
	      this.formBasicInformation.setOptions('warehouseId', _warehouses.items.map(function (item) {
	        return { id: item.id, name: item.name + (item.isLocked ? _this2.$t('static.warehouse.info.locked') : ''), disabled: item.isLocked };
	      }));
	    },
	
	    'formBasicInformation.warehouseId': function formBasicInformationWarehouseId(warehouseId) {
	      this.server = {
	        url: ("https://api.kundan.no") + '/adjustments/' + this.formBasicInformation.warehouseId + '/import-product?token=' + localStorage.getItem('id_token'),
	        process: {
	          onload: function onload(res) {
	            var name = 'inventory.stock.edit';
	
	            var obj = JSON.parse(res);
	            console.log(obj);
	          }
	        }
	      };
	      _store2.default.dispatch('setStockSelectedWarehouse', warehouseId);
	      this.initCurrentAdjustment(this.currentAdjustment);
	    },
	    currentAdjustment: function currentAdjustment(_currentAdjustment) {
	      this.initCurrentAdjustment(_currentAdjustment);
	    }
	  },
	  created: function created() {
	    this.loading = false;
	  },
	
	
	  methods: {
	    renameLabel: function renameLabel(adjustmentTypeId) {
	      var type = '';
	      this.adjustmentTypeOptions.forEach(function (item) {
	        if (parseInt(item.id) === parseInt(adjustmentTypeId)) {
	          type = item.name;
	          return;
	        }
	      });
	
	      if (type === 'Wastage' || type === 'Destruction') {
	        jQuery('.th-qty').text(this.$t('table.adjustment.products.qty.customDeduct'));
	      } else {
	        jQuery('.th-qty').text(this.$t('table.adjustment.products.qty.label'));
	      }
	    },
	    initCurrentAdjustment: function initCurrentAdjustment(currentAdjustment) {
	      var me = this;
	      var currentQty = 0;
	      var data = this.currentAdjustment.products.map(function (c) {
	        c.product.warehouses.forEach(function (item) {
	          if (parseInt(me.formBasicInformation.warehouseId) === parseInt(item.warehouseId)) {
	            currentQty = item.currentQty;
	            return;
	          }
	        });
	
	        return {
	          currentAdjustment: currentQty,
	          qty: c.qty,
	          id: c.product.id,
	          productId: c.product,
	          batchId: c.batchId
	        };
	      });
	
	      console.log(currentAdjustment.products);
	      _store2.default.dispatch('allCurrentStockProductsCustom', data);
	    },
	    store: function store() {
	      var _this3 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _adjustment4.default.send(Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts, type: 1 }));
	      _adjustment2.default.update(this.$route.params.id, client).then(function () {
	        _this3.$message({
	          message: _this3.$t('static.adjustment.create.success'),
	          type: 'success'
	        });
	        _this3.$router.push({
	          name: 'inventory.adjustment.index'
	        });
	      }).catch(function (errors) {
	        _this3.formBasicInformation.loading = false;
	        _this3.formBasicInformation.recordErrors(errors);
	        var message = errors.message;
	        if (errors.message) {
	          _this3.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    saveDraft: function saveDraft() {
	      var _this4 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _adjustment4.default.send(Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts, type: 1 }));
	      _adjustment2.default.updateDraft(this.$route.params.id, client).then(function () {
	        _this4.$message({
	          message: _this4.$t('static.adjustment.draft.success'),
	          type: 'success'
	        });
	        _this4.$router.push({
	          name: 'inventory.adjustment.index'
	        });
	      }).catch(function (errors) {
	        _this4.formBasicInformation.loading = false;
	        _this4.formBasicInformation.recordErrors(errors);
	        var message = errors.message;
	        if (errors.message) {
	          _this4.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    searchMethod: function searchMethod(search, field) {
	      return Promise.all([_product2.default.searchAll({ search: search })]);
	    },
	    downloadProduct: function downloadProduct() {
	      _adjustment2.default.downloadProduct(this.formBasicInformation.warehouseId);
	    },
	    deleteDraft: function deleteDraft() {
	      var _this5 = this;
	
	      var me = this;
	      this.$confirm(this.$t('static.adjustment.draft.deleteMessage'), 'Warning', {
	        confirmButtonText: 'OK',
	        cancelButtonText: 'Cancel',
	        type: 'warning'
	      }).then(function () {
	        me.formBasicInformation.loading = true;
	        _adjustment2.default.destroy(_this5.$route.params.id).then(function () {
	          me.$router.push({
	            name: 'inventory.adjustment.index'
	          });
	        });
	      }).catch(function () {});
	    }
	  },
	  mounted: function mounted() {
	    var _this6 = this;
	
	    this.loading = true;
	    _store2.default.dispatch('allCurrentStockProductsCustom', []);
	    Promise.all([_warehouse2.default.all(), _adjustment2.default.show(this.$route.params.id), _adjustment2.default.adjustmentType()]).then(function (data) {
	      _store2.default.dispatch('setStockSelectedWarehouse', 0);
	      _this6.formBasicInformation.assignData(data[1]);
	      _this6.adjustmentTypeOptions = data[2].map(function (item) {
	        return {
	          id: item.id,
	          name: _this6.$t('form.adjustment.adjustmentTypeList.' + item.name.toLowerCase())
	        };
	      });
	      _this6.formBasicInformation.setOptions('adjustmentTypeId', _this6.adjustmentTypeOptions);
	      var self = _this6;
	      setTimeout(function () {
	        self.renameLabel(data[1].adjustmentTypeId);
	      }, 500);
	      _this6.loading = false;
	    });
	  },
	
	  components: {
	    VForm: __webpack_require__(9),
	    VProductsTable: __webpack_require__(123),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(5);
	
	var _adjustment = __webpack_require__(227);
	
	var _adjustment2 = _interopRequireDefault(_adjustment);
	
	var _adjustment3 = __webpack_require__(82);
	
	var _adjustment4 = _interopRequireDefault(_adjustment3);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      tabIndex: 'first',
	      currentAdjustment: {
	        products: [],
	        warehouse: {
	          name: ''
	        },
	        stock: {
	          name: ''
	        }
	      }
	    };
	  },
	
	
	  computed: {
	    productList: function productList() {
	      return this.currentAdjustment.products.map(function (c) {
	        return {
	          sku: c.product.sku,
	          name: c.product.name,
	          qty: c.qty,
	          exciseAdditionalCode: c.exciseAdditionalCode ? c.exciseAdditionalCode.code + ' (' + c.exciseAdditionalCode.description + ')' : ''
	        };
	      });
	    }
	  },
	
	  watch: {
	    currentAdjustment: function currentAdjustment(_currentAdjustment) {
	      console.log(_currentAdjustment);
	    }
	  },
	
	  created: function created() {
	    this.loading = false;
	  },
	
	
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    Promise.all([_adjustment2.default.show(this.$route.params.id)]).then(function (data) {
	      _this.currentAdjustment = data[0];
	    });
	  },
	
	  components: {
	    VTable: __webpack_require__(33)
	  }
	};

/***/ }),
/* 1877 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _order = __webpack_require__(54);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _businessHourException = __webpack_require__(451);
	
	var _businessHourException2 = _interopRequireDefault(_businessHourException);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _addAppointment = __webpack_require__(2667);
	
	var _addAppointment2 = _interopRequireDefault(_addAppointment);
	
	var _mediaQuery = __webpack_require__(288);
	
	var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false,
	      dateRange: [],
	      calendarDay: (0, _moment2.default)(),
	      displayWeekends: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    orders: 'paginatedOrders',
	    exceptions: 'businessHourExceptions'
	  }), {
	    ordersList: function ordersList() {
	      return this.orders.items.map(function (o) {
	        return Object.assign({
	          start: o.orderType === 'Appointment' ? (0, _moment2.default)(o.date).format('DD/MM/YYYY') + ' ' + o.time : false
	        }, o);
	      });
	    },
	    timelineDirection: function timelineDirection() {
	      return this.$route.query.appointment === 'done' ? 'past' : 'future';
	    },
	    isTimeline: function isTimeline() {
	      return this.$route.query.appointment !== 'calendar';
	    },
	    weekdays: function weekdays() {
	      var result = [];
	      var limit = this.displayWeekends ? 7 : 5;
	      for (var i = 0; i < limit; i += 1) {
	        result.push((0, _moment2.default)(this.calendarDay).add(i, 'days').format('dddd, DD'));
	      }
	      return result;
	    }
	  }),
	
	  watch: {
	    $route: function $route() {
	      if (this.$route.query.appointment !== 'calendar') {
	        this.setSidebar();
	      } else {
	        this.unsetInnerSidebar();
	      }
	      this.dateRange = [];
	      this.all();
	    },
	    calendarDay: function calendarDay() {
	      this.all();
	    }
	  },
	
	  mounted: function mounted() {
	    this.calendarDay = !this.isDesktop() ? (0, _moment2.default)() : (0, _moment2.default)().startOf('isoweek');
	
	    this.all();
	
	    if (this.$route.query.appointment !== 'calendar') {
	      this.setSidebar();
	    }
	  },
	  destroyed: function destroyed() {
	    _store2.default.dispatch('resetOrders');
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    onMqChange: function onMqChange() {
	      this.calendarDay = !this.isDesktop() ? (0, _moment2.default)() : (0, _moment2.default)().startOf('isoweek');
	    },
	    toggleWeekends: function toggleWeekends() {
	      this.displayWeekends = !this.displayWeekends;
	    },
	    setSidebar: function setSidebar() {
	      var sidebar = [{
	        title: this.$t('layouts.sidebar.orders'),
	        options: [{
	          title: this.$t('layouts.sidebar.products'),
	          route: {
	            name: 'orders.index',
	            query: {
	              filter: 'Product'
	            }
	          }
	        }, {
	          title: this.$t('layouts.sidebar.services'),
	          route: {
	            name: 'orders.index',
	            query: {
	              filter: 'Service'
	            }
	          }
	        }, {
	          title: this.$t('layouts.sidebar.all'),
	          route: {
	            name: 'orders.index'
	          }
	        }],
	        button: {
	          title: '+ ' + this.$t('static.orders.create.title'),
	          route: {
	            name: 'orders.create'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.booking'),
	        options: [{
	          title: this.$t('layouts.sidebar.upcoming'),
	          route: {
	            name: 'appointments.index',
	            query: {
	              appointment: 'upcoming'
	            }
	          }
	        }, {
	          title: this.$t('layouts.sidebar.done'),
	          route: {
	            name: 'appointments.index',
	            query: {
	              appointment: 'done'
	            }
	          }
	        }, {
	          title: this.$t('layouts.sidebar.calendar'),
	          route: {
	            name: 'appointments.index',
	            query: {
	              appointment: 'calendar'
	            }
	          }
	        }],
	        button: {
	          title: '+ ' + this.$t('static.appointments.create.title'),
	          route: {
	            name: 'orders.create'
	          }
	        }
	      }];
	
	      this.setInnerSidebar(sidebar);
	    },
	    changeCalendarDay: function changeCalendarDay(add) {
	      var days = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	      if (add) {
	        this.calendarDay = (0, _moment2.default)(this.calendarDay.add(days, 'days'));
	      } else {
	        this.calendarDay = (0, _moment2.default)(this.calendarDay.subtract(days, 'days'));
	      }
	    },
	    onRangeChange: function onRangeChange(name, value) {
	      this[name] = value;
	      this.$router.push({
	        name: 'appointments.index'
	      });
	    },
	    onDateAdd: function onDateAdd(date) {
	      this.setModalContent(function () {
	        return _addAppointment2.default;
	      });
	      this.setModalProps({
	        create: this.saveAppointment,
	        date: date
	      });
	      this.toggleModal(true);
	    },
	    onDateEdit: function onDateEdit(date, order) {
	      this.setModalContent(function () {
	        return _addAppointment2.default;
	      });
	      this.setModalProps({
	        create: this.updateAppointment,
	        date: date,
	        appointment: order,
	        destroy: this.deleteAppointment
	      });
	      this.toggleModal(true);
	    },
	    saveAppointment: function saveAppointment(data) {
	      var _this = this;
	
	      return _order2.default.store(data).then(function () {
	        _this.all();
	      });
	    },
	    updateAppointment: function updateAppointment(data, id) {
	      var _this2 = this;
	
	      return _order2.default.update(id, data).then(function () {
	        _this2.all();
	      });
	    },
	    deleteAppointment: function deleteAppointment(id) {
	      var _this3 = this;
	
	      return _order2.default.destroy(id).then(function () {
	        _this3.all();
	      });
	    },
	    getOrderStatus: function getOrderStatus(order) {
	      if (order.orderStatus === 'cancelled') {
	        return this.$t('static.appointments.index.cancelled');
	      }
	
	      var now = (0, _moment2.default)();
	      var start = (0, _moment2.default)(order.date + ' ' + order.time);
	      var end = (0, _moment2.default)(order.date + ' ' + order.time).add(order.duration, 'minutes');
	      if (now.isAfter(end)) {
	        return this.$t('static.appointments.index.completed');
	      }
	
	      if (now.isBefore(start)) {
	        return this.$t('static.appointments.index.created');
	      }
	
	      return this.$t('static.appointments.index.ongoing');
	    },
	    all: function all(page, limit) {
	      var _this4 = this;
	
	      if (!this.loading) {
	        var appointment = this.$route.query.appointment;
	        if (this.$route.query.appointment !== 'calendar' && this.dateRange.length && (0, _moment2.default)(this.dateRange[0]).isValid() && (0, _moment2.default)(this.dateRange[1]).isValid()) {
	          appointment = (0, _moment2.default)(this.dateRange[0]).format('DD-MM-YYYY') + '|' + (0, _moment2.default)(this.dateRange[1]).format('DD-MM-YYYY');
	        } else if (this.$route.query.appointment === 'calendar') {
	          appointment = (0, _moment2.default)(this.calendarDay).format('DD-MM-YYYY') + '|' + (0, _moment2.default)(this.calendarDay).add(7, 'days').format('DD-MM-YYYY');
	        }
	        this.loading = true;
	        var params = {
	          page: page,
	          limit: limit,
	          search: this.getSearch(),
	          appointment: appointment,
	          now: (0, _moment2.default)().format('DD-MM-YYYY HH:mm')
	        };
	        Promise.all([_order2.default.items(params), _businessHourException2.default.all()]).then(function () {
	          _this4.loading = false;
	        }).catch(function () {
	          _this4.loading = false;
	        });
	      }
	    },
	    editOrder: function editOrder(order) {
	      this.$router.push({
	        name: 'orders.edit',
	        params: { id: order.id }
	      });
	    }
	  }),
	
	  components: {
	    VDateRange: __webpack_require__(156),
	    VTimeline: __webpack_require__(2741),
	    VCalendar: __webpack_require__(2685),
	    VDateBar: __webpack_require__(2696)
	  },
	
	  mixins: [_mediaQuery2.default, _search2.default]
	};

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _batch = __webpack_require__(60);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _recipe = __webpack_require__(191);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	var _batch3 = __webpack_require__(49);
	
	var _batch4 = _interopRequireDefault(_batch3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        recipeId: {
	          value: '',
	          type: 'select'
	        },
	        batchNumber: {
	          value: '',
	          type: 'number'
	        },
	        status: {
	          value: '',
	          type: 'hidden'
	        },
	        plannedStartingDate: {
	          type: 'date',
	          value: ''
	        },
	        startDate: {
	          type: 'date',
	          value: ''
	        },
	        endDate: {
	          type: 'date',
	          value: ''
	        },
	        bestBeforeDate: {
	          type: 'date',
	          value: ''
	        },
	        notes: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      loading: false
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (!this.form.status) {
	      Object.keys(this.form.fields).forEach(function (field) {
	        _this.form.hideField(field);
	      });
	    }
	    this.loading = true;
	
	    Promise.all([_recipe2.default.all().then(function () {
	      _this.loading = false;
	    }), _batch2.default.nextBatchNumber()]).then(function (data) {
	      _this.loading = false;
	      _this.form.batchNumber = data[1];
	    }).catch(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    recipes: 'allRecipes'
	  })),
	
	  watch: {
	    recipes: function recipes(_recipes) {
	      this.form.setOptions('recipeId', _recipes.map(function (c) {
	        return {
	          id: c.id,
	          name: c.name
	        };
	      }));
	    }
	  },
	
	  methods: {
	    handleStatusChange: function handleStatusChange(status) {
	      this.form.showField('recipeId');
	      this.form.showField('notes');
	      switch (status) {
	        case 'planned':
	          this.form.showField('startDate');
	          this.form.showField('endDate');
	          this.form.hideField('batchNumber');
	          this.form.hideField('bestBeforeDate');
	          this.form.showField('plannedStartingDate');
	          break;
	        case 'started':
	          this.form.showField('batchNumber');
	          this.form.hideField('bestBeforeDate');
	          this.form.hideField('startDate');
	          this.form.hideField('endDate');
	          this.form.hideField('plannedStartingDate');
	          break;
	        default:
	          this.form.showField('batchNumber');
	          this.form.showField('startDate');
	          this.form.showField('endDate');
	          this.form.showField('bestBeforeDate');
	          this.form.hideField('plannedStartingDate');
	          break;
	      }
	    },
	    store: function store() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var batch = _batch4.default.send(this.form.data());
	      _batch2.default.store(batch).then(function (response) {
	        _this2.form.loading = false;
	        _this2.$message({
	          message: _this2.$t('static.batches.create.success'),
	          type: 'success'
	        });
	        _this2.$router.push({
	          name: 'production.batches.view',
	          params: {
	            id: response.id
	          }
	        });
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _batch = __webpack_require__(60);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _recipe = __webpack_require__(191);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	var _batch3 = __webpack_require__(49);
	
	var _batch4 = _interopRequireDefault(_batch3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        recipeId: {
	          value: '',
	          type: 'select'
	        },
	        batchNumber: {
	          value: '',
	          type: 'number'
	        },
	        status: {
	          value: '',
	          type: 'hidden'
	        },
	        startDate: {
	          type: 'date',
	          value: ''
	        },
	        endDate: {
	          type: 'date',
	          value: ''
	        },
	        bestBeforeDate: {
	          type: 'date',
	          value: ''
	        },
	        notes: {
	          value: '',
	          type: 'textarea'
	        }
	      })
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (!this.form.status) {
	      Object.keys(this.form.fields).forEach(function (field) {
	        _this.form.hideField(field);
	      });
	    }
	    Promise.all([_recipe2.default.all()]).then(function () {
	      _this.loading = false;
	    });
	    this.show();
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    recipes: 'allRecipes'
	  })),
	
	  methods: {
	    handleStatusChange: function handleStatusChange(status) {
	      this.form.showField('name');
	      this.form.showField('recipeId');
	      this.form.showField('notes');
	      switch (status) {
	        case 'planned':
	          this.form.showField('startDate');
	          this.form.showField('endDate');
	          this.form.hideField('batchNumber');
	          this.form.hideField('bestBeforeDate');
	          break;
	        case 'started':
	          this.form.showField('batchNumber');
	          this.form.hideField('bestBeforeDate');
	          this.form.hideField('startDate');
	          this.form.hideField('endDate');
	          break;
	        default:
	          this.form.showField('batchNumber');
	          this.form.showField('startDate');
	          this.form.showField('endDate');
	          this.form.showField('bestBeforeDate');
	          break;
	      }
	    },
	    update: function update() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var batch = _batch4.default.send(this.form.data());
	      _batch2.default.update(_store2.default.state.route.params.id, batch).then(function () {
	        _this2.form.loading = false;
	        _this2.$message({
	          message: _this2.$t('static.batches.edit.success'),
	          type: 'success'
	        });
	        _this2.$router.push({
	          name: 'production.batches.index'
	        });
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      var _this3 = this;
	
	      this.loading = true;
	      _batch2.default.show(_store2.default.state.route.params.id).then(function (batch) {
	        _this3.form.assignData(batch);
	        _this3.handleStatusChange(batch.status);
	        _this3.loading = false;
	      });
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  },
	
	  watch: {
	    recipes: function recipes(_recipes) {
	      this.form.setOptions('recipeId', _recipes.map(function (c) {
	        return {
	          id: c.id,
	          name: c.name
	        };
	      }));
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _batch = __webpack_require__(60);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _bridgeHandoff = __webpack_require__(81);
	
	var _bridgeHandoff2 = _interopRequireDefault(_bridgeHandoff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sort: '',
	      info: 'info',
	      primary: 'primary',
	      search: ''
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    batches: 'paginatedBatches',
	    allBatches: 'allBatches',
	    view: 'getView',
	    searchQuery: 'batchQuery',
	    account: 'account'
	  }), {
	    batchesListView: function batchesListView() {
	      var _this = this;
	
	      return this.batches.items.map(function (batch) {
	        return {
	          id: batch.id,
	          name: batch.name,
	          batchNumber: batch.batchNumber.toString(),
	          status: _this.$t('static.batches.statuses.' + batch.status)
	        };
	      });
	    }
	  }),
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19),
	    VTable: __webpack_require__(33)
	  },
	
	  mixins: [_search2.default, _bridgeHandoff2.default],
	
	  watch: {
	    $route: function $route() {
	      this.all(1, 25);
	    },
	    view: function view(_view) {
	      if (_view == 'card') {
	        this.info = 'info';
	        this.primary = 'primary';
	      } else {
	        this.primary = 'info';
	        this.info = 'primary';
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    this.setInnerSidebar([{
	      title: this.$t('static.materials.filters.title'),
	      options: [{
	        title: this.$t('static.materials.filters.active'),
	        route: {
	          name: 'production.materials.index',
	          query: {
	            filter: 'active'
	          }
	        }
	      }, {
	        title: this.$t('static.materials.filters.deactivated'),
	        route: {
	          name: 'production.materials.index',
	          query: {
	            filter: 'deactivated'
	          }
	        }
	      }, {
	        title: this.$t('static.materials.filters.all'),
	        route: {
	          name: 'production.materials.index',
	          query: {
	            filter: 'all'
	          }
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.materials.create.title'),
	        route: {
	          name: 'production.materials.create'
	        }
	      }
	    }, {
	      title: this.$t('static.batches.filters.title'),
	      options: [{
	        title: this.$t('static.batches.filters.upcoming'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'upcoming'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.ongoing'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'ongoing'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.completed'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'completed'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.all'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'all'
	          }
	        }
	      }],
	      button: this.bridgeStockWriteBlocked ? null : {
	        title: '+ ' + this.$t('static.batches.create.title'),
	        route: {
	          name: 'production.batches.create'
	        }
	      }
	    }, {
	      title: this.$t('static.recipes.filters.title'),
	      options: [{
	        title: this.$t('static.recipes.filters.all'),
	        route: {
	          name: 'production.recipes.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.recipes.create.title'),
	        route: {
	          name: 'production.recipes.create'
	        }
	      }
	    }, {
	      title: this.$t('static.equipments.title'),
	      options: [{
	        title: this.$t('static.equipments.filters.all'),
	        route: {
	          name: 'production.equipments.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.equipments.create.title'),
	        route: {
	          name: 'production.equipments.create'
	        }
	      }
	    }]);
	
	    this.all(this.searchQuery.page, this.searchQuery.limit);
	    if (this.view == 'card') {
	      this.info = 'info';
	      this.primary = 'primary';
	    } else {
	      this.primary = 'info';
	      this.info = 'primary';
	    }
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    changeView: function changeView(view) {
	      if (this.info != view) {
	        this.primary = this.info;
	        this.info = view;
	        if (this.info == 'info') {
	          _store2.default.dispatch('setView', 'card');
	        } else {
	          _store2.default.dispatch('setView', 'list');
	        }
	      }
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this2 = this;
	
	      this.loading = true;
	
	      var query = { page: page, limit: limit, search: this.searchQuery.search };
	      _store2.default.dispatch('setBatchQuery', query);
	      this.search = this.searchQuery.search;
	      _batch2.default.items({
	        page: page,
	        limit: limit,
	        search: this.searchQuery.search,
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this2.loading = false;
	      }).catch(function () {
	        _this2.loading = false;
	      });
	    }, 800),
	
	    onChangeSearch: function onChangeSearch(name, value) {
	      _store2.default.dispatch('setBatchQuery', { page: 1, limit: 25, search: value });
	      this.all(1, 25);
	    },
	    viewBatch: function viewBatch(batch) {
	      this.$router.push({
	        name: 'production.batches.view',
	        params: { id: batch.id }
	      });
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  })
	};

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _recipeIngredience = __webpack_require__(111);
	
	var _recipeIngredience2 = _interopRequireDefault(_recipeIngredience);
	
	var _recipeProcedure = __webpack_require__(136);
	
	var _recipeProcedure2 = _interopRequireDefault(_recipeProcedure);
	
	var _batchIngredience = __webpack_require__(67);
	
	var _batchIngredience2 = _interopRequireDefault(_batchIngredience);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _batch = __webpack_require__(60);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _material = __webpack_require__(125);
	
	var _material2 = _interopRequireDefault(_material);
	
	var _batchIngredience3 = __webpack_require__(925);
	
	var _batchIngredience4 = _interopRequireDefault(_batchIngredience3);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _transfer = __webpack_require__(234);
	
	var _transfer2 = _interopRequireDefault(_transfer);
	
	var _batchLog = __webpack_require__(446);
	
	var _batchLog2 = _interopRequireDefault(_batchLog);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _addBatchLog2 = __webpack_require__(2668);
	
	var _addBatchLog3 = _interopRequireDefault(_addBatchLog2);
	
	var _batchStartPopup = __webpack_require__(2674);
	
	var _batchStartPopup2 = _interopRequireDefault(_batchStartPopup);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _bulkAddProductModal = __webpack_require__(122);
	
	var _bulkAddProductModal2 = _interopRequireDefault(_bulkAddProductModal);
	
	var _batch3 = __webpack_require__(49);
	
	var _batch4 = _interopRequireDefault(_batch3);
	
	var _bridgeHandoff = __webpack_require__(81);
	
	var _bridgeHandoff2 = _interopRequireDefault(_bridgeHandoff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      batch: {},
	      loading: false,
	      form: new _forms2.default({
	        id: {
	          value: '',
	          type: 'text'
	        },
	        transferDate: {
	          value: '',
	          type: 'plaintext'
	        },
	        productName: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            disabled: true,
	            href: 'products/_/edit#productInfo',
	            targetId: 'productId' }
	        },
	        qty: {
	          value: 0,
	          type: 'number'
	        },
	        warehouse: {
	          value: '',
	          type: 'plaintext'
	        }
	      }),
	      formIngredience: new _forms2.default({
	        batchId: {
	          value: '',
	          type: 'text'
	        },
	        recipeId: {
	          value: '',
	          type: 'text'
	        },
	        materialId: {
	          value: '',
	          type: 'select'
	        },
	        unitMeasure: {
	          value: '',
	          type: 'text'
	        },
	        amount: {
	          value: '',
	          type: 'text'
	        },
	        deductedAmount: {
	          value: '',
	          type: 'number'
	        }
	      }),
	      formBatchEdit: new _forms2.default({
	        batchNumber: {
	          value: '',
	          type: 'number'
	        },
	        plannedStartingDate: {
	          type: 'date',
	          value: ''
	        },
	        bestBeforeDate: {
	          type: 'date',
	          value: ''
	        },
	        recipeId: {
	          value: '',
	          type: 'hidden'
	        },
	        status: {
	          value: '',
	          type: 'hidden'
	        }
	      }),
	      hiddenFields: ['batchId', 'recipeId'],
	      additionalButtons: [{
	        text: this.$t('static.recipeIngrediences.index.addIngrediences'),
	        action: this.showBulkAddIngredienceModal
	      }, {
	        text: this.$t('static.batches.view.deductIngredience.deductAll.button'),
	        action: this.deductAll()
	      }],
	      tabIndex: '1',
	      materialsLoading: false,
	      startBatchloading: false,
	      completeBatchloading: false
	    };
	  },
	  created: function created() {
	    this.show();
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    allMaterials: 'allMaterials',
	    recipes: 'allRecipes',
	    transfers: 'allTransfers',
	    logs: 'paginatedBatchLogs',
	    logQuery: 'batchLogQuery',
	    ingrediences: 'allBatchIngrediences'
	  }), {
	    upcomingProcedures: function upcomingProcedures() {
	      if (this.batch.recipe && this.batch.recipe.procedures) {
	        return this.batch.recipe.procedures.filter(function (p) {
	          return !p.status;
	        }).map(function (procedure) {
	          return Object.assign({}, _recipeProcedure2.default.fetch(procedure), {
	            ingrediences: _recipeIngredience2.default.fetchCollection(procedure.ingrediences)
	          });
	        });
	      }
	      return [];
	    },
	    ongoingProcedures: function ongoingProcedures() {
	      if (this.batch.recipe && this.batch.recipe.procedures) {
	        return this.batch.recipe.procedures.filter(function (p) {
	          return p.status === 'started';
	        }).map(function (procedure) {
	          return Object.assign({}, _recipeProcedure2.default.fetch(procedure), {
	            ingrediences: _recipeIngredience2.default.fetchCollection(procedure.ingrediences)
	          });
	        });
	      }
	      return [];
	    },
	    completedProcedures: function completedProcedures() {
	      if (this.batch.recipe && this.batch.recipe.procedures) {
	        return this.batch.recipe.procedures.filter(function (p) {
	          return p.status === 'completed';
	        }).map(function (procedure) {
	          return Object.assign({}, _recipeProcedure2.default.fetch(procedure), {
	            ingrediences: _recipeIngredience2.default.fetchCollection(procedure.ingrediences)
	          });
	        });
	      }
	      return [];
	    },
	    tranferProducts: function tranferProducts() {
	      var products = [];
	      this.transfers.items.forEach(function (transfer) {
	        if (transfer.products) {
	          transfer.products.forEach(function (tranferProduct) {
	            products.push(Object.assign({}, {
	              name: tranferProduct.productName,
	              productId: tranferProduct.productId,
	              transferDate: transfer.date,
	              warehouse: transfer.toWarehouseName
	            }, tranferProduct));
	          });
	        }
	      });
	      return products;
	    },
	    ingredienceList: function ingredienceList() {
	      return this.ingrediences.map(function (ingredience) {
	        return Object.assign({}, ingredience);
	      });
	    },
	    disabledItems: function disabledItems() {
	      return this.ingrediences.filter(function (item) {
	        return item.deductedAmount >= item.amount;
	      }).map(function (ingredience) {
	        return ingredience.id;
	      });
	    },
	    allIngredienceDeducted: function allIngredienceDeducted() {
	      return this.ingrediences.filter(function (item) {
	        return item.deductedAmount < item.amount;
	      }).length === 0;
	    },
	    disableForm: function disableForm() {
	      var disabled = false;
	      if (this.batch.ingredienceDeductionType === 'all' && (this.batch.status === 'planned' || this.batch.status === 'started')) {
	        disabled = true;
	      }
	      if (this.allIngredienceDeducted) {
	        disabled = true;
	      }
	      return disabled;
	    }
	  }),
	
	  mixins: [_bridgeHandoff2.default],
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalButtonLoading: 'SET_MODAL_BUTTON_LOADING'
	  }), {
	    showBulkAddIngredienceModal: function showBulkAddIngredienceModal() {
	      this.setModalContent(function () {
	        return _bulkAddProductModal2.default;
	      });
	      this.setModalProps({
	        fetchProductsMethod: this.fetchAllMaterialsBasic,
	        onSave: this.handleBulkIngrediencesSave
	      });
	      this.toggleModal(true);
	    },
	    update: function update() {
	      var _this = this;
	
	      var option = Object.assign(this.form.data());
	      _batch2.default.updateBatchTransfer(option.id, { qty: option.qty }).then(function () {
	        _transfer2.default.all({ batch_id: _store2.default.state.route.params.id, transfer_history: true }).then(function () {
	          _this.$message({
	            showClose: true,
	            message: 'Successfully Update',
	            type: 'success'
	          });
	        });
	      });
	      return Promise.all([]);
	    },
	    fetchAllMaterialsBasic: function fetchAllMaterialsBasic() {
	      return Promise.all([_product2.default.allBasic({
	        filter: 'active',
	        type: 'material'
	      })]);
	    },
	    handleBulkIngrediencesSave: function handleBulkIngrediencesSave(selectedProducts) {
	      var _this2 = this;
	
	      var products = selectedProducts.map(function (p) {
	        return {
	          materialId: p.id,
	          amount: p.qty
	        };
	      });
	      this.formIngredience.loading = true;
	      return _batchIngredience4.default.bulkStore(this.batch.id, products).then(function () {
	        _this2.formIngredience.loading = false;
	      });
	    },
	    show: function show() {
	      var _this3 = this;
	
	      this.loading = true;
	      this.formIngredience.disableField('unitMeasure');
	      this.formIngredience.disableField('deductedAmount');
	      this.formBatchEdit.hideField('plannedStartingDate');
	      Promise.all([_batch2.default.show(_store2.default.state.route.params.id), _transfer2.default.all({ batch_id: _store2.default.state.route.params.id, transfer_history: true }), _material2.default.all()]).then(function (data) {
	        if (data[0].ingrediences) {
	          var batchIngrediences = _batchIngredience2.default.fetchCollection(data[0].ingrediences);
	          _store2.default.dispatch('fetchAllBatchIngrediences', batchIngrediences);
	        }
	
	        _this3.loading = false;
	        _this3.batch = data[0];
	        _this3.formBatchEdit.assignData(Object.assign({}, _this3.batch));
	
	        if (_this3.batch.startDate === '' && _this3.batch.status === 'planned') _this3.formBatchEdit.showField('plannedStartingDate');
	      });
	      this.fetchBatchLogs(this.logQuery.page, this.logQuery.limit);
	    },
	
	    fetchBatchLogs: (0, _debounce2.default)(function (page, limit) {
	      var _this4 = this;
	
	      this.loading = true;
	      var query = {
	        page: page,
	        limit: limit,
	        batch_id: _store2.default.state.route.params.id
	      };
	      _store2.default.dispatch('setBatchLogQuery', query);
	      this.search = this.logQuery.search;
	      _batchLog2.default.items({
	        page: page,
	        limit: limit,
	        batch_id: _store2.default.state.route.params.id
	      }).then(function () {
	        _this4.loading = false;
	      }).catch(function () {
	        _this4.loading = false;
	      });
	    }, 800),
	
	    addBatchLog: function addBatchLog() {
	      this.setModalContent(function () {
	        return _addBatchLog3.default;
	      });
	      this.setModalSize('full');
	      this.toggleModal(true);
	      this.setModalProps({
	        batchId: +_store2.default.state.route.params.id,
	        page: this.logQuery.page,
	        limit: this.logQuery.limit
	      });
	    },
	    confirmProcedureStart: function confirmProcedureStart(recipeProcedureId, status) {
	      var _this5 = this;
	
	      this.$confirm(this.$t('static.batches.view.startProcedure.confirm'), this.$t('static.batches.view.startBatch.title'), {
	        confirmButtonText: this.$t('static.batches.view.deductIngredience.confirmButton'),
	        cancelButtonText: this.$t('static.batches.view.deductIngredience.cancelButton'),
	        distinguishCancelAndClose: true,
	        type: 'warning'
	      }).then(function () {
	        _this5.setProcedureStatus(recipeProcedureId, status, 'all');
	      }).catch(function (action) {
	        if (action === 'cancel') {
	          _this5.setProcedureStatus(recipeProcedureId, status, 'by_procedure');
	        }
	      });
	    },
	    setProcedureStatus: function setProcedureStatus(recipeProcedureId, status, deductIngredience) {
	      var _this6 = this;
	
	      this.loading = true;
	      var data = {
	        procedure_id: recipeProcedureId,
	        ingredience_deduction_type: deductIngredience,
	        status: status
	      };
	      _batch2.default.setProcedureStatus(this.batch.id, data).then(function (response) {
	        _this6.loading = false;
	        _this6.batch = response;
	        _this6.fetchBatchLogs(_this6.logQuery.page, _this6.logQuery.limit);
	      }).catch(function (errors) {
	        _this6.loading = false;
	        if (errors.data.not_enough_stock_materials) {
	          _this6.showStartBatchNotEnoughStockPopup(errors.data.not_enough_stock_materials);
	        }
	      });
	    },
	    startBatch: function startBatch(status) {
	      var _this7 = this;
	
	      this.formBatchEdit.hideField('plannedStartingDate');
	      this.startBatchloading = true;
	      this.$confirm(this.$t('static.batches.view.startBatch.confirm'), this.$t('static.batches.view.startBatch.title'), {
	        confirmButtonText: this.$t('static.batches.view.deductIngredience.confirmButton'),
	        cancelButtonText: this.$t('static.batches.view.deductIngredience.cancelButton'),
	        distinguishCancelAndClose: true,
	        type: 'warning'
	      }).then(function () {
	        _batch2.default.startBatch(_this7.batch.id, {
	          status: status,
	          ingredience_deduction_type: 'all'
	        }).then(function (data) {
	          _this7.batch = data;
	          _this7.startBatchloading = false;
	          _this7.fetchBatchLogs(_this7.logQuery.page, _this7.logQuery.limit);
	        }).catch(function (errors) {
	          if (errors.data.not_enough_stock_materials) {
	            _this7.showStartBatchNotEnoughStockPopup(errors.data.not_enough_stock_materials);
	          }
	          _this7.startBatchloading = false;
	        });
	      }).catch(function (action) {
	        if (action === 'cancel') {
	          _batch2.default.startBatch(_this7.batch.id, {
	            status: status,
	            ingredience_deduction_type: 'by_procedure'
	          }).then(function (data) {
	            _this7.batch = data;
	            _this7.startBatchloading = false;
	            _this7.fetchBatchLogs(_this7.logQuery.page, _this7.logQuery.limit);
	          }).catch(function () {
	            _this7.startBatchloading = false;
	          });
	        }
	      });
	    },
	    showStartBatchNotEnoughStockPopup: function showStartBatchNotEnoughStockPopup(materials) {
	      this.setModalContent(function () {
	        return _batchStartPopup2.default;
	      });
	      this.setModalSize('full');
	      this.toggleModal(true);
	      this.setModalProps({
	        materials: materials,
	        batchId: +this.batch.id,
	        message: this.$t('static.batches.view.startBatch.stockError'),
	        buttons: [{
	          name: this.$t('static.batches.view.startBatch.stockErrorOptions.adjustQty'),
	          action: this.gotoMaterialTab,
	          title: this.$t('static.batches.view.startBatch.stockErrorOptions.adjustQty')
	        }, {
	          name: this.$t('static.batches.view.startBatch.stockErrorOptions.addNew'),
	          action: this.gotoMaterialTab,
	          title: this.$t('static.batches.view.startBatch.stockErrorOptions.addNew')
	        }, {
	          name: this.$t('static.batches.view.startBatch.stockErrorOptions.purchaseOrder'),
	          action: this.gotoPurchaseOrder,
	          title: this.$t('static.batches.view.startBatch.stockErrorOptions.purchaseOrder')
	        }, {
	          name: this.$t('static.batches.view.startBatch.stockErrorOptions.stockAdjustment'),
	          action: this.gotoStockAdjustment,
	          title: this.$t('static.batches.view.startBatch.stockErrorOptions.stockAdjustment')
	        }]
	      });
	    },
	    completeBatch: function completeBatch() {
	      var _this8 = this;
	
	      this.$confirm(this.$t('static.batches.view.completeBatch.confirm'), this.$t('static.batches.view.completeBatch.title'), {
	        confirmButtonText: this.$t('static.batches.view.completeBatch.confirmButton'),
	        cancelButtonText: this.$t('button.cancel'),
	        distinguishCancelAndClose: true,
	        type: 'warning'
	      }).then(function () {
	        _this8.completeBatchloading = true;
	        _batch2.default.completeBatch(_this8.batch.id, {
	          status: status
	        }).then(function (data) {
	          _this8.batch = data;
	          _this8.completeBatchloading = false;
	          _this8.fetchBatchLogs(_this8.logQuery.page, _this8.logQuery.limit);
	        }).catch(function (errors) {
	          _this8.completeBatchloading = false;
	          if (errors.data.not_enough_stock_materials) {
	            _this8.showDeductNotEnoughStockPopup(errors.data.not_enough_stock_materials);
	          }
	          if (errors.data.batch) {
	            _this8.batch = errors.data.batch;
	          }
	        });
	      }).catch(function () {});
	    },
	    tableClickHandler: function tableClickHandler(item, name) {
	      var _this9 = this;
	
	      if (name === 'deductedAmount' && item.deductedAmount < item.amount) {
	        var material = this.ingrediences.find(function (m) {
	          return m.materialId === item.materialId;
	        });
	        return function () {
	          _this9.$prompt(_this9.$t('static.batches.view.deductIngredience.text') + ' "' + material.materialName + '"', _this9.$t('static.batches.view.deductIngredience.title'), {
	            confirmButtonText: _this9.$t('static.batches.view.deductIngredience.confirmButton'),
	            cancelButtonText: _this9.$t('button.cancel'),
	            inputValue: +item.amount - +item.deductedAmount,
	            inputPattern: /^\$?[0-9]?((\.[0-9]+)|([0-9]+(\.[0-9]+)?))$/,
	            inputErrorMessage: _this9.$t('static.batches.view.deductIngredience.invalidDeductionAmount')
	          }).then(function (_ref) {
	            var value = _ref.value;
	
	            _this9.materialsLoading = true;
	            _batchIngredience4.default.deduct(item.id, {
	              deduction: value
	            }).then(function () {
	              _this9.materialsLoading = false;
	            }).catch(function (errors) {
	              _this9.materialsLoading = false;
	              if (errors.data.not_enough_stock_materials) {
	                _this9.showDeductNotEnoughStockPopup(errors.data.not_enough_stock_materials);
	              } else {
	                _this9.$message({
	                  showClose: true,
	                  message: _this9.$t('static.batches.view.deductIngredience.generalError'),
	                  type: 'error'
	                });
	              }
	            });
	          }).catch(function () {});
	        };
	      }
	
	      return false;
	    },
	    deductAll: function deductAll() {
	      var _this10 = this;
	
	      return function () {
	        _this10.$confirm(_this10.$t('static.batches.view.deductIngredience.deductAll.message'), _this10.$t('static.batches.view.deductIngredience.deductAll.title'), {
	          confirmButtonText: _this10.$t('static.batches.view.deductIngredience.deductAll.confirmButton'),
	          type: 'warning'
	        }).then(function () {
	          _this10.materialsLoading = true;
	          _batch2.default.deductAllIngredience(_this10.batch.id).then(function () {
	            _this10.materialsLoading = false;
	          }).catch(function (errors) {
	            if (errors.data.not_enough_stock_materials) {
	              _this10.showDeductNotEnoughStockPopup(errors.data.not_enough_stock_materials);
	            }
	            if (errors.data.batch) {
	              _this10.batch = errors.data.batch;
	            }
	            _this10.materialsLoading = false;
	          });
	        }).catch(function () {});
	      };
	    },
	    showDeductNotEnoughStockPopup: function showDeductNotEnoughStockPopup(materials) {
	      this.setModalContent(function () {
	        return _batchStartPopup2.default;
	      });
	      this.setModalSize('full');
	      this.toggleModal(true);
	      this.setModalProps({
	        materials: materials,
	        batchId: +this.batch.id,
	        message: this.$t('static.batches.view.deductIngredience.stockError'),
	        buttons: [{
	          name: this.$t('static.batches.view.startBatch.stockErrorOptions.adjustQty'),
	          action: this.gotoMaterialTab,
	          title: this.$t('static.batches.view.startBatch.stockErrorOptions.adjustQty')
	        }, {
	          name: this.$t('static.batches.view.startBatch.stockErrorOptions.purchaseOrder'),
	          action: this.gotoPurchaseOrder,
	          title: this.$t('static.batches.view.startBatch.stockErrorOptions.purchaseOrder')
	        }, {
	          name: this.$t('static.batches.view.startBatch.stockErrorOptions.stockAdjustment'),
	          action: this.gotoStockAdjustment,
	          title: this.$t('static.batches.view.startBatch.stockErrorOptions.stockAdjustment')
	        }]
	      });
	    },
	    gotoMaterialTab: function gotoMaterialTab() {
	      this.toggleModal(false);
	      this.tabIndex = '2';
	    },
	    gotoPurchaseOrder: function gotoPurchaseOrder() {
	      this.toggleModal(false);
	      this.$router.push({
	        name: 'inventory.purchase.create'
	      });
	    },
	    gotoStockAdjustment: function gotoStockAdjustment() {
	      this.toggleModal(false);
	      this.$router.push({
	        name: 'inventory.adjustment.stock.create'
	      });
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    },
	    saveLog: function saveLog() {
	      var _this11 = this;
	
	      this.formLog.loading = true;
	      return _batch2.default.storeLog(this.batch.id, this.formLog.data()).then(function () {
	        _this11.formLog.loading = false;
	      }).catch(function (errors) {
	        _this11.formLog.loading = false;
	        _this11.formLog.recordErrors(errors);
	        var errorsKeys = Object.keys(_this11.formLog.errors.errors);
	        _this11.$message({
	          showClose: true,
	          message: errors[errorsKeys[0]][0],
	          type: 'error'
	        });
	      });
	    },
	    saveIngredience: function saveIngredience() {
	      var _this12 = this;
	
	      this.formIngredience.loading = true;
	      var data = Object.assign(this.formIngredience.data(), {
	        recipeId: this.batch.recipe.id,
	        batchId: this.batch.id
	      });
	      return _batchIngredience4.default.store(data).then(function () {
	        _this12.formIngredience.loading = false;
	      }).catch(function (errors) {
	        _this12.formIngredience.loading = false;
	        _this12.formIngredience.recordErrors(errors);
	        var errorsKeys = Object.keys(_this12.formIngredience.errors.errors);
	        _this12.$message({
	          showClose: true,
	          message: errors[errorsKeys[0]][0],
	          type: 'error'
	        });
	      });
	    },
	    updateIngredience: function updateIngredience(ingredienceId) {
	      var _this13 = this;
	
	      this.formIngredience.loading = true;
	      var data = Object.assign(this.formIngredience.data(), {
	        recipeId: this.batch.recipe.id,
	        batchId: this.batch.id
	      });
	      return _batchIngredience4.default.update(ingredienceId, data).then(function () {
	        _this13.formIngredience.loading = false;
	      }).catch(function (errors) {
	        _this13.formIngredience.loading = false;
	        _this13.formIngredience.recordErrors(errors);
	        var errorsKeys = Object.keys(_this13.formIngredience.errors.errors);
	        _this13.$message({
	          showClose: true,
	          message: errors[errorsKeys[0]][0],
	          type: 'error'
	        });
	      });
	    },
	    destroyIngredience: function destroyIngredience(id) {
	      var _this14 = this;
	
	      this.$confirm(this.$t('static.recipeIngrediences.index.confirmDelete'), this.$t('static.recipeIngrediences.index.confirmDeleteTitle'), {
	        confirmButtonText: this.$t('button.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _this14.destroyLoading = true;
	        _batchIngredience4.default.destroy(id).then(function () {
	          _this14.destroyLoading = false;
	        }).catch(function () {
	          _this14.destroyLoading = false;
	        });
	      }).catch(function () {});
	    },
	    updateBatch: function updateBatch() {
	      var _this15 = this;
	
	      this.formBatchEdit.loading = true;
	      var batch = _batch4.default.send(this.formBatchEdit.data());
	      _batch2.default.update(_store2.default.state.route.params.id, batch).then(function () {
	        _this15.show();
	        _this15.formBatchEdit.loading = false;
	        _this15.$message({
	          message: _this15.$t('static.batches.edit.success'),
	          type: 'success'
	        });
	      }).catch(function (errors) {
	        _this15.formBatchEdit.loading = false;
	        _this15.formBatchEdit.recordErrors(errors);
	      });
	    }
	  }),
	
	  watch: {
	    allMaterials: function allMaterials(_allMaterials) {
	      this.formIngredience.setOptions('materialId', _allMaterials.map(function (c) {
	        return {
	          id: c.id,
	          name: c.name + ' ' + (c.unitMeasure !== '' ? '(' + c.unitMeasure + ')' : '') + ' - ID: ' + c.id
	        };
	      }));
	      this.formIngredience.setOverrideOptions('materialId', _allMaterials.map(function (c) {
	        return {
	          id: c.id,
	          name: c.name + ' ' + (c.unitMeasure !== '' ? '(' + c.unitMeasure + ')' : '') + ' - ID: ' + c.id
	        };
	      }));
	    }
	  },
	  components: {
	    VPagination: __webpack_require__(16),
	    VForm: __webpack_require__(9),
	    VFormTable: __webpack_require__(46)
	  }
	};

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(5);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _billType = __webpack_require__(450);
	
	var _billType2 = _interopRequireDefault(_billType);
	
	var _billStatus = __webpack_require__(449);
	
	var _billStatus2 = _interopRequireDefault(_billStatus);
	
	var _order = __webpack_require__(54);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _bill = __webpack_require__(92);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _bill3 = __webpack_require__(55);
	
	var _bill4 = _interopRequireDefault(_bill3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _create = __webpack_require__(779);
	
	var _create2 = _interopRequireDefault(_create);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        orderId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        billStatusId: {
	          value: '',
	          type: 'hidden'
	        },
	        date: {
	          value: '',
	          type: 'date',
	          attributes: {
	            datePickerOptions: {
	              disabledDate: this.disabledDate
	            }
	          }
	        },
	        dueDate: {
	          value: '',
	          type: 'date'
	        },
	        languageId: {
	          value: '',
	          type: 'select'
	        },
	        currencyId: {
	          value: '',
	          type: 'select'
	        },
	        paymentMessage: {
	          value: '',
	          type: 'textarea'
	        },
	        note: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      loading: false,
	      clientDueDays: null,
	      invoiceEdiOrder: true
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    orders: 'allOrders',
	    billTypes: 'billTypes',
	    billStatuses: 'billStatuses',
	    settings: 'organizationSettings',
	    currentOrder: 'currentOrder',
	    languages: 'languages',
	    currencies: 'currencies'
	  })),
	
	  watch: {
	    billTypes: function billTypes(_billTypes) {
	      this.form.setOptions('billTypeId', _billTypes);
	    },
	    orders: function orders(_orders) {
	      this.form.setOptions('orderId', _orders.all.map(function (o) {
	        return { id: o.id, name: o.number };
	      }));
	    },
	
	    'form.date': function formDate(date) {
	      this.form.dueDate = (0, _moment2.default)(date).add(this.clientDueDays !== null ? this.clientDueDays : this.settings.defaultDueDays, 'days').format();
	    },
	
	    clientDueDays: function clientDueDays(value) {
	      this.form.dueDate = (0, _moment2.default)(this.form.date).add(this.clientDueDays !== null ? value : this.settings.defaultDueDays, 'days').format();
	    },
	    languages: function languages(value) {
	      this.form.setOptions('languageId', value.all.map(function (item) {
	        return {
	          id: item.id,
	          name: item.name
	        };
	      }));
	    },
	    currencies: function currencies(value) {
	      this.form.setOptions('currencyId', value.all.map(function (item) {
	        return {
	          id: item.id,
	          name: item.name
	        };
	      }));
	    },
	
	
	    'form.orderId': function formOrderId(value) {
	      var _this = this;
	
	      var id = 0;
	      if (value.id !== undefined) {
	        id = value.id;
	      } else {
	        id = value;
	      }
	      if (id && id !== 0) {
	        _account2.default.defaultLanguageNCurrency('order_id=' + id).then(function (data) {
	          _this.form.setFieldValue('languageId', data.language_id);
	          _this.form.setFieldValue('currencyId', data.currency_id);
	        });
	        _order2.default.show(id);
	      }
	    },
	
	    currentOrder: function currentOrder(value) {
	      if (value && value.client) {
	        this.clientDueDays = value.client.dueDays;
	        this.form.setFieldValue('note', value.referenceNumber || value.client.orderReference);
	      }
	    }
	  },
	
	  created: function created() {
	    var _this2 = this;
	
	    if (this.$route.query.order) {
	      this.invoiceEdiOrder = true;
	    } else {
	      this.invoiceEdiOrder = false;
	    }
	    this.form.setQuickForm('orderId', _create2.default);
	    var services = [_billType2.default.all(), _billStatus2.default.all(), _account2.default.languages(), _account2.default.currencies()];
	
	    if (this.$route.query.order !== undefined) {
	      services.push(_order2.default.clientSetting(this.$route.query.order));
	    }
	
	    if (Object.keys(this.settings).length === 0) {
	      services.push(_organizationSettings2.default.show());
	    }
	    this.loading = true;
	    Promise.all(services).then(function () {
	      if (_this2.$route.query.order !== undefined) {
	        _this2.form.orderId = _this2.$route.query.order;
	      }
	      _this2.form.date = (0, _moment2.default)().format();
	      _this2.form.dueDate = (0, _moment2.default)().add(_this2.settings.defaultDueDays, 'days').format();
	      _this2.loading = false;
	    });
	  },
	
	
	  methods: {
	    save: function save(name) {
	      var status = this.billStatuses.filter(function (s) {
	        return s.status === name;
	      })[0];
	
	      this.form.billStatusId = status.id;
	
	      this.store();
	    },
	    store: function store() {
	      var _this3 = this;
	
	      this.form.loading = true;
	      var bill = _bill4.default.send(this.form.data());
	      if (_typeof(bill.order_id) === 'object') {
	        bill.order_id = bill.order_id.id;
	      }
	
	      _bill2.default.store(bill).then(function (data) {
	        _this3.$message({
	          message: _this3.$t('static.bills.create.success'),
	          type: 'success'
	        });
	        _this3.$router.push({
	          name: 'bills.edit',
	          params: {
	            id: data.id
	          }
	        });
	      }).catch(function (errors) {
	        if (errors.code === 40116) {
	          errors = {
	            orderId: [_this3.$t('static.bills.create.orderError')]
	          };
	        } else if (errors.ediOrderError) {
	          _this3.$message({
	            message: errors.ediOrderError[0],
	            type: 'error'
	          });
	        }
	
	        _this3.form.loading = false;
	        _this3.form.recordErrors(errors);
	      });
	    },
	    searchMethod: function searchMethod(search, field) {
	      var obj = {
	        type: 'createBill',
	        search: search,
	        limit: 10
	      };
	      if (!this.invoiceEdiOrder) {
	        obj.orderType = 'normal';
	      }
	      return Promise.all([_order2.default.search(obj)]);
	    },
	    disabledDate: function disabledDate(date) {
	      date.setDate(date.getDate() + 15);
	      return date < new Date();
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(5);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _billType = __webpack_require__(450);
	
	var _billType2 = _interopRequireDefault(_billType);
	
	var _billStatus = __webpack_require__(449);
	
	var _billStatus2 = _interopRequireDefault(_billStatus);
	
	var _orderProduct = __webpack_require__(48);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _order = __webpack_require__(54);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _bill = __webpack_require__(92);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _invoice = __webpack_require__(229);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	var _creditNote = __webpack_require__(456);
	
	var _creditNote2 = _interopRequireDefault(_creditNote);
	
	var _country = __webpack_require__(66);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _date = __webpack_require__(107);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _previewMessage = __webpack_require__(418);
	
	var _previewMessage2 = _interopRequireDefault(_previewMessage);
	
	var _previewMessageCopy = __webpack_require__(2726);
	
	var _previewMessageCopy2 = _interopRequireDefault(_previewMessageCopy);
	
	var _previewMessageReminder = __webpack_require__(2727);
	
	var _previewMessageReminder2 = _interopRequireDefault(_previewMessageReminder);
	
	var _creditNoteReason = __webpack_require__(2695);
	
	var _creditNoteReason2 = _interopRequireDefault(_creditNoteReason);
	
	var _ehfModuleSetup = __webpack_require__(770);
	
	var _ehfModuleSetup2 = _interopRequireDefault(_ehfModuleSetup);
	
	var _billPayment2 = __webpack_require__(2675);
	
	var _billPayment3 = _interopRequireDefault(_billPayment2);
	
	var _billReminderModal = __webpack_require__(2677);
	
	var _billReminderModal2 = _interopRequireDefault(_billReminderModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        orderId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        billStatusId: {
	          value: '',
	          type: 'hidden'
	        },
	        date: {
	          value: '',
	          type: 'date',
	          attributes: {
	            datePickerOptions: {
	              disabledDate: this.disabledDate
	            }
	          }
	        },
	        dueDate: {
	          value: '',
	          type: 'date'
	        },
	        languageId: {
	          value: '',
	          type: 'select'
	        },
	        currencyId: {
	          value: '',
	          type: 'select'
	        },
	        paymentDate: {
	          value: '',
	          type: 'date'
	        },
	        summaryGrouping: {
	          value: '',
	          type: 'checkbox'
	        },
	        creditNoteSource: {
	          value: '',
	          type: 'hidden'
	        },
	        kidNumber: {
	          value: '',
	          type: 'text'
	        },
	        paymentMessage: {
	          value: '',
	          type: 'textarea'
	        },
	        note: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      successMessage: '',
	      loadingCreditNote: false,
	      sendLoading: false,
	      sendEHFLoading: false,
	      kidLoading: false,
	      loading: false,
	      hashid: '',
	      roundInvoiceTotal: true,
	      tabIndex: '1',
	      dropdownState: false,
	      invoiceSentAt: '',
	      creditNotes: [],
	      attachmentFiles: [],
	      billType: '',
	      previewWait: '',
	      billAddressData: [],
	      emailTrackingRecipients: [],
	      emailCopy: [],
	      emailCopyClass: ['active'],
	      submitLoading: false,
	      sendReminderPreviewLoading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    orders: 'allOrders',
	    billTypes: 'billTypes',
	    billStatuses: 'billStatuses',
	    currentBill: 'currentBill',
	    account: 'account',
	    orderProducts: 'allOrderProducts',
	    billProducts: 'allBillProducts',
	    currentOrder: 'currentOrder',
	    settings: 'organizationSettings',
	    modules: 'allModules',
	    countries: 'allCountries',
	    languages: 'languages',
	    currencies: 'currencies'
	  }), {
	    currency: function currency() {
	      return this.currentBill.currency ? this.currentBill.currency.code : '';
	    },
	    billReminders: function billReminders() {
	      return this.currentBill.billReminders;
	    },
	    billReminderTotalAmount: function billReminderTotalAmount() {
	      return this.currentBill.reminderFeesTotalAmount;
	    },
	    showCreateReminderButton: function showCreateReminderButton() {
	      return !this.isCreditNote && this.showOverdueInvoiceNotice && this.canSendPaymentReminderByEmail && this.billProducts.length > 0 && typeof this.currentOrder !== 'undefined' && !this.isEdiOrder;
	    },
	    emailCopies: function emailCopies() {
	      return this.emailCopy;
	    },
	    hasEHFModule: function hasEHFModule() {
	      if (this.account.modules.length > 0) {
	        return this.account.modules.find(function (module) {
	          return module.name === 'EHF';
	        });
	      }
	      return false;
	    },
	    invoiceSendMethodNormalized: function invoiceSendMethodNormalized() {
	      var m = this.currentBill && this.currentBill.client && this.currentBill.client.invoiceSendMethod;
	      if (m === undefined || m === null || m === '') {
	        return 'EMAIL';
	      }
	      return String(m).toUpperCase();
	    },
	    invoiceSendMethodIsEmail: function invoiceSendMethodIsEmail() {
	      return this.invoiceSendMethodNormalized === 'EMAIL';
	    },
	    invoiceSendMethodIsEhf: function invoiceSendMethodIsEhf() {
	      return this.invoiceSendMethodNormalized === 'EHF';
	    },
	    canSendPaymentReminderByEmail: function canSendPaymentReminderByEmail() {
	      if (!this.currentClient || !this.currentClient.email) return false;
	      return this.invoiceSendMethodIsEmail || this.invoiceSendMethodIsEhf;
	    },
	    ehfInvoicePreferredButNotVerified: function ehfInvoicePreferredButNotVerified() {
	      return this.invoiceSendMethodIsEhf && !this.currentClient.ehfBilling3_0;
	    },
	    showEhfPendingVerificationBanner: function showEhfPendingVerificationBanner() {
	      if (!this.hasEHFModule) return false;
	      if (typeof this.currentOrder === 'undefined') return false;
	      if (this.isEdiOrder) return false;
	      if (!this.isPending) return false;
	      return this.ehfInvoicePreferredButNotVerified;
	    },
	    showEhfPreferredOverEmailBanner: function showEhfPreferredOverEmailBanner() {
	      if (!this.hasEHFModule) return false;
	      if (typeof this.currentOrder === 'undefined') return false;
	      if (this.isEdiOrder) return false;
	      if (!this.isPending) return false;
	      return this.invoiceSendMethodIsEmail && !!this.currentClient.ehfBilling3_0;
	    },
	    showEhfModuleUpsellBanner: function showEhfModuleUpsellBanner() {
	      if (this.hasEHFModule) return false;
	      if (!this.currentClient) return false;
	      if (typeof this.currentOrder === 'undefined') return false;
	      if (this.isEdiOrder) return false;
	      if (!this.isPending) return false;
	      return !!(this.currentClient.ehfBilling3_0 || this.invoiceSendMethodIsEhf);
	    },
	    ehfModuleUpsellCustomerVerified: function ehfModuleUpsellCustomerVerified() {
	      return !!(this.currentClient && this.currentClient.ehfBilling3_0);
	    },
	    showSendInvoiceEmailFallbackForEhf: function showSendInvoiceEmailFallbackForEhf() {
	      return this.ehfInvoicePreferredButNotVerified && !!this.currentClient.email && !this.isEdiOrder;
	    },
	    returnWarning: function returnWarning() {
	      var hasExciseModule = false;
	      var hasInventoryModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i += 1) {
	          if (this.account.modules[i].name === 'Excise') {
	            hasExciseModule = true;
	          }
	          if (this.account.modules[i].name === 'Inventory') {
	            hasInventoryModule = true;
	          }
	        }
	        var message = '';
	        if (hasExciseModule && hasInventoryModule && !this.isCleared) {
	          message = '<p>&#8226;&nbsp;' + this.$t('creditNoteWarning.invoiceInfo.exciseInventoryActivated') + '</p>';
	        } else if (hasExciseModule && !this.isCleared) {
	          message = '<p>&#8226;&nbsp;' + this.$t('creditNoteWarning.invoiceInfo.specialChargeActivated') + '</p>';
	        } else if (hasInventoryModule && !this.isCleared) {
	          message = '<p>&#8226;&nbsp;' + this.$t('creditNoteWarning.invoiceInfo.storageModuleEnabled') + '</p>';
	        }
	        if (!this.currentClient.email && !this.isEdiOrder) {
	          message += '<p>&#8226;&nbsp;' + this.$t('creditNoteWarning.invoiceInfo.noClientEmail') + '</p>';
	        }
	        if (message !== '') {
	          return message;
	        }
	      }
	      return false;
	    },
	    isCreditNote: function isCreditNote() {
	      return this.$route.name === 'bills.creditNote';
	    },
	    isDraft: function isDraft() {
	      return this.currentBill.billStatus === 'Draft';
	    },
	    isPending: function isPending() {
	      return this.currentBill.billStatus === 'Pending';
	    },
	    isSent: function isSent() {
	      return this.currentBill.billStatus === 'Sent';
	    },
	    isCleared: function isCleared() {
	      return this.currentBill.billStatus === 'Cleared';
	    },
	    currentEdiOrder: function currentEdiOrder() {
	      if (this.currentOrder.ediOrder) {
	        return this.currentOrder.ediOrder;
	      }
	
	      return {};
	    },
	    isPartlyPaid: function isPartlyPaid() {
	      return this.currentBill.billStatus === 'Partly Paid';
	    },
	    isPastDueDate: function isPastDueDate() {
	      if (!this.currentBill || !this.currentBill.dueDate) return false;
	      if (!(0, _moment2.default)(this.currentBill.dueDate).isValid()) return false;
	      return (0, _moment2.default)().isAfter((0, _moment2.default)(this.currentBill.dueDate).startOf('day'));
	    },
	    billStatusAllowsPaymentReminder: function billStatusAllowsPaymentReminder() {
	      var s = this.currentBill.billStatus;
	      return ['Sent', 'Overdue', 'Partly Paid'].includes(s);
	    },
	    showOverdueInvoiceNotice: function showOverdueInvoiceNotice() {
	      return !this.isCreditNote && this.isPastDueDate && this.billStatusAllowsPaymentReminder && !this.isCleared;
	    },
	    invoiceDueDateIsOverdue: function invoiceDueDateIsOverdue() {
	      return this.showOverdueInvoiceNotice;
	    },
	    canSendPaymentReminderActions: function canSendPaymentReminderActions() {
	      return this.showOverdueInvoiceNotice && this.canSendPaymentReminderByEmail && typeof this.currentOrder !== 'undefined' && !this.isEdiOrder;
	    },
	    hasCreditNoteReason: function hasCreditNoteReason() {
	      return this.currentBill.creditNoteReason;
	    },
	    currentClient: function currentClient() {
	      var client = this.currentBill.client;
	      if (this.currentOrder.orderType === 'EDI') {
	        client.streetName = this.currentEdiOrder.ediStoreStreet || client.streetName;
	        client.postalCode = this.currentEdiOrder.ediStorePostCode || client.postalCode;
	        client.billAddressData = this.billAddressData[0];
	        return client;
	      }
	      client.billAddressData = this.billAddressData[0];
	      return client;
	    },
	    curentOrderType: function curentOrderType() {
	      if (typeof this.currentOrder.orderType === 'undefined') {
	        return '';
	      }
	      return this.currentOrder.orderType;
	    },
	    isEdiOrder: function isEdiOrder() {
	      if (typeof this.currentOrder === 'undefined' || !this.currentOrder) {
	        return false;
	      }
	      var orderTypeNorm = String(this.currentOrder.orderType || '').trim().toLowerCase();
	      if (orderTypeNorm === 'edi') {
	        return true;
	      }
	      var ediOrderIdNum = Number(this.currentOrder.ediOrderId);
	      if (ediOrderIdNum > 0) {
	        return true;
	      }
	
	      if (String(this.currentOrder.ediType || '').trim() !== '') {
	        return true;
	      }
	      if (String(this.currentOrder.ediStore || '').trim() !== '') {
	        return true;
	      }
	      if (String(this.currentOrder.ediStatus || '').trim() !== '') {
	        return true;
	      }
	      var eo = this.currentOrder.ediOrder;
	      if (eo && (typeof eo === 'undefined' ? 'undefined' : _typeof(eo)) === 'object' && !Array.isArray(eo) && eo.id) {
	        return true;
	      }
	      if (Array.isArray(eo) && eo.length > 0) {
	        return true;
	      }
	      return false;
	    },
	    currentOrdeStatus: function currentOrdeStatus() {
	      if (typeof this.currentBill.billStatus === 'undefined') {
	        return '';
	      }
	      return this.currentBill.billStatus;
	    },
	    noCreditNoteSource: function noCreditNoteSource() {
	      var eo = this.currentEdiOrder;
	      if (eo && (eo.ediOrderTypeId === 2 || eo.ediOrderTypeId === 3)) {
	        return false;
	      }
	
	      if (this.currentBill.creditNoteSource > 0 && (this.currentOrder.orderTypeId === 1 || eo && eo.ediOrderTypeId === 1)) {
	        return true;
	      }
	
	      return false;
	    },
	    isClientContactEmailMissing: function isClientContactEmailMissing() {
	      if (this.invoiceSendMethodIsEhf) {
	        return false;
	      }
	      if (!this.isEdiOrder && (this.currentClient.email === null || this.currentClient.email === '')) {
	        return true;
	      }
	      return false;
	    },
	    isInvoice: function isInvoice() {
	      return this.$route.name === 'bills.edit';
	    },
	    hasTripletexModule: function hasTripletexModule() {
	      if (this.account.modules.length > 0) {
	        if (this.account.modules.find(function (module) {
	          return module.name === 'Tripletex';
	        })) return true;
	      }
	      return false;
	    }
	  }),
	
	  watch: {
	    $route: function $route() {
	      this.toggleDueDate();
	      this.togglePaymentDate();
	      this.show();
	      this.urlCurrentTab();
	    },
	    tabIndex: function tabIndex(value) {
	      this.assignTab(value);
	    },
	    currentOrder: function currentOrder(_currentOrder) {},
	    billTypes: function billTypes(_billTypes) {
	      this.form.setOptions('billTypeId', _billTypes);
	    },
	    billStatuses: function billStatuses(_billStatuses) {
	      this.form.setOptions('billStatusId', _billStatuses.map(function (s) {
	        return { id: s.id, name: s.status };
	      }));
	    },
	    orders: function orders(_orders) {
	      this.form.setOptions('orderId', _orders.all.map(function (o) {
	        return { id: o.id, name: o.number };
	      }));
	    },
	    currentBill: function currentBill(_currentBill) {
	      this.form.assignData(_currentBill);
	      this.disableIfSent();
	      this.togglePaymentDate();
	
	      if (_currentBill.billStatus !== 'Pending' && _currentBill.billStatus !== 'Draft') {
	        this.form.disableField('languageId');
	        this.form.disableField('currencyId');
	      }
	    },
	    settings: function settings(_settings) {
	      if (!_settings.paymentIdentitificationGeneration) {
	        this.form.hideField('kidNumber');
	      } else {
	        this.form.showField('kidNumber');
	      }
	    },
	
	
	    'form.kidNumber': function formKidNumber(kidNumber) {
	      if (this.currentBill.billStatus == 'Draft') {
	        this.form.setExtraAttr('kidNumber', {});
	        return;
	      }
	      if (kidNumber) {
	        this.form.setExtraAttr('kidNumber', {
	          hasButton: true,
	          buttonLabel: this.$t('static.bills.edit.validateKidNumber'),
	          buttonHandler: this.validateKidNumber
	        });
	      } else {
	        this.form.setExtraAttr('kidNumber', {
	          hasButton: true,
	          buttonLabel: this.$t('static.bills.edit.generateKidNumber'),
	          buttonHandler: this.generateKidNumber
	        });
	      }
	    },
	
	    languages: function languages(value) {
	      this.form.setOptions('languageId', value.all.map(function (item) {
	        return {
	          id: item.id,
	          name: item.name
	        };
	      }));
	    },
	    currencies: function currencies(value) {
	      this.form.setOptions('currencyId', value.all.map(function (item) {
	        return {
	          id: item.id,
	          name: item.name
	        };
	      }));
	    }
	  },
	
	  mounted: function mounted() {
	    this.urlCurrentTab();
	    this.assignTab(this.tabIndex);
	  },
	  created: function created() {
	    var self = this;
	    window.addEventListener('click', function (e) {
	      if (_helpers2.default.closeDropdown(e, self.dropdownState) === false) self.dropdownState = false;
	    });
	    this.toggleDueDate();
	    this.togglePaymentDate();
	    this.show();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalButtonLoading: 'SET_MODAL_BUTTON_LOADING'
	  }), {
	    sendReminderPreview: function sendReminderPreview() {
	      var _this = this;
	
	      this.sendReminderPreviewLoading = true;
	      _bill2.default.sendReminderPreview(_store2.default.state.route.params.id).then(function (response) {
	        _this.setModalContent(function () {
	          return _previewMessageReminder2.default;
	        });
	        _this.setModalSize('full');
	        _this.setModalProps({
	          message: response.message,
	          subject: response.subject,
	          to: [response.to],
	          cc: [],
	          buttons: [{
	            name: _this.$t('button.cancel'),
	            action: _this.cancelModal,
	            title: _this.$t('button.cancel')
	          }, {
	            name: _this.$t('static.bills.edit.sendReminder'),
	            action: _this.sendReminder,
	            title: _this.$t('static.bills.edit.sendReminder')
	          }]
	
	        });
	        _this.sendReminderPreviewLoading = false;
	        _this.toggleModal(true);
	      }).catch(function (error) {
	        _this.sendReminderPreviewLoading = false;
	        console.log(error);
	      });
	    },
	    sendReminder: function sendReminder(data) {
	      var _this2 = this;
	
	      this.toggleModal(false);
	      this.previewWait = 'Sending reminder';
	      _bill2.default.sendReminder(_store2.default.state.route.params.id, data).then(function (response) {
	        if (response.success) {
	          _this2.$message({
	            showClose: true,
	            message: 'Successfully sent',
	            type: 'success'
	          });
	        } else {
	          _this2.$message({
	            showClose: true,
	            message: response.errors[0].message,
	            type: 'error'
	          });
	        }
	        _this2.previewWait = '';
	        _this2.sendLoading = false;
	      }).catch(function () {
	        _this2.$message({
	          showClose: true,
	          message: 'Something went wrong!',
	          type: 'error'
	        });
	        _this2.previewWait = '';
	        _this2.sendLoading = false;
	      });
	    },
	    createBillReminder: function createBillReminder() {
	      this.setModalContent(function () {
	        return _billReminderModal2.default;
	      });
	      this.setModalSize('full');
	      this.setModalProps({
	        bill: this.currentBill,
	        onComplete: this.refreshBill,
	        onClose: this.closeModal
	      });
	      this.toggleModal(true);
	    },
	    refreshBill: function refreshBill() {
	      var _this3 = this;
	
	      _bill2.default.show(_store2.default.state.route.params.id);
	      _order2.default.all();
	      setTimeout(function () {
	        _this3.tabIndex = '4';
	      }, 1500);
	    },
	    closeModal: function closeModal() {
	      this.form.loading = '';
	    },
	    billPayment: function billPayment() {
	      this.setModalContent(function () {
	        return _billPayment3.default;
	      });
	      this.setModalSize('full');
	      this.setModalProps({
	        billId: this.currentBill.id,
	        onSave: this.save,
	        onClose: this.closeModal(),
	        billingNumber: this.currentBill.billingNumber ? '#' + this.currentBill.billingNumber : '',
	        additionalData: {
	          due_date: this.isValidDate(this.currentBill.dueDate) ? this.formatDate(this.currentBill.dueDate) : '-',
	          total: this.currentBill.totalGross,
	          paid: this.currentBill.amountPaid,
	          due: this.currentBill.amountDue.toFixed(2)
	        }
	      });
	      this.toggleModal(true);
	    },
	    previewMailTracking: function previewMailTracking(value) {
	      var arrayTo = [];
	      var arrayCc = [];
	      value.recipient.forEach(function (item) {
	        if (item.email_recipient_type.type === 'to') {
	          arrayTo.push(item.email_address);
	        } else if (item.email_recipient_type.type === 'cc') {
	          arrayCc.push(item.email_address);
	        }
	      });
	      this.setModalContent(function () {
	        return _previewMessageCopy2.default;
	      });
	      this.setModalSize('full');
	      this.setModalProps({
	        message: value.body,
	        subject: value.subject,
	        to: arrayTo,
	        cc: arrayCc
	      });
	      this.toggleModal(true);
	    },
	    recipients: function recipients(value, key) {
	      this.emailCopyClass = [];
	      this.emailCopyClass[key] = 'active';
	      this.emailTrackingRecipients = value;
	    },
	    assignTab: function assignTab(value) {
	      var _this4 = this;
	
	      var tab = '';
	      if (value === '4') {
	        tab = '#reminders';
	      } else if (value === '3') {
	        tab = '#emails';
	        _bill2.default.show(_store2.default.state.route.params.id).then(function (data) {
	          _this4.emailCopy = data.emailCopy;
	        });
	      } else if (value === '2') {
	        tab = '#editInvoice';
	      } else {
	        tab = '#invoiceInformation';
	      }
	      history.pushState({}, null, '/#' + this.$route.path + tab);
	    },
	    urlCurrentTab: function urlCurrentTab() {
	      if (this.$router.currentRoute.hash === '#reminders') {
	        this.tabIndex = '4';
	      } else if (this.$router.currentRoute.hash === '#emails') {
	        this.tabIndex = '3';
	      } else if (this.$router.currentRoute.hash === '#editInvoice') {
	        this.tabIndex = '2';
	      } else {
	        this.tabIndex = '1';
	      }
	    },
	    toggleDueDate: function toggleDueDate() {
	      if (this.isCreditNote) {
	        this.form.hideField('dueDate');
	      } else {
	        this.form.showField('dueDate');
	      }
	    },
	    togglePaymentDate: function togglePaymentDate() {
	      if (!this.isCreditNote && this.isCleared) {
	        this.form.showField('paymentDate');
	      } else {
	        this.form.hideField('paymentDate');
	      }
	    },
	    submitCreditNoteReason: function submitCreditNoteReason() {
	      this.setModalContent(function () {
	        return _creditNoteReason2.default;
	      });
	      this.setModalSize('full');
	      this.setModalProps({
	        onClose: this.closeModal(),
	        billId: this.currentBill.id,
	        billStatusId: this.form.billStatusId,
	        orderId: this.currentBill.orderId,
	        date: this.currentBill.date,
	        dueDate: this.currentBill.dueDate,
	        creditNoteSource: this.currentBill.creditNoteSource
	      });
	      this.toggleModal(true);
	    },
	    markAsCleared: function markAsCleared() {
	      this.form.paymentDate = (0, _moment2.default)().add(1, 'h').format();
	      if (this.isCreditNote) {
	        this.save('Cleared');
	      } else {
	        this.billPayment();
	      }
	    },
	    save: function save(name) {
	      var _this5 = this;
	
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.submitLoading = true;
	      this.form.loading = name;
	      var status = this.billStatuses.filter(function (s) {
	        return s.status === name;
	      })[0];
	      this.form.billStatusId = status.id;
	      if (!this.isCreditNote && name === 'Cleared') {
	        _bill2.default.markAsPaid(_store2.default.state.route.params.id, { order_id: this.currentBill.orderId, payment_date: data ? data.paymentDate : this.form.paymentDate }).then(function () {
	          _this5.form.loading = '';
	        });
	      } else {
	        this.update();
	      }
	    },
	    update: function update() {
	      var _this6 = this;
	
	      if (this.isCreditNote) {
	        this.form.setFieldValue('orderId', this.currentOrder.id);
	      }
	
	      var service = this.isCreditNote ? _creditNote2.default : _bill2.default;
	      service.update(_store2.default.state.route.params.id, this.form.data()).then(function () {
	        _this6.successMessage = _this6.$t('static.bills.edit.updateSuccess');
	        setTimeout(function () {
	          _this6.successMessage = '';
	        }, 2000);
	        _this6.form.loading = '';
	        _this6.submitLoading = false;
	      }).catch(function (errors) {
	        if (errors.code === 40120) {
	          _this6.$message({
	            showClose: true,
	            message: errors.message,
	            customClass: 'error'
	          });
	        }
	        if (errors.code === 40116) {
	          errors = {
	            orderId: [_this6.$t('static.bills.create.orderError')]
	          };
	        }
	        _this6.submitLoading = false;
	        _this6.form.loading = '';
	        _this6.form.recordErrors(errors);
	      });
	    },
	    disableIfSent: function disableIfSent() {
	      var _this7 = this;
	
	      var fields = Object.keys(this.form.fields).filter(function (k) {
	        return k !== 'paymentDate';
	      });
	      if (this.isDraft || this.isPending) {
	        fields.map(function (f) {
	          return _this7.form.enableField(f);
	        });
	        return;
	      }
	
	      fields.map(function (f) {
	        return _this7.form.disableField(f);
	      });
	    },
	    show: function show() {
	      var _this8 = this;
	
	      this.loading = true;
	      var me = this;
	      var requests = [_bill2.default.show(_store2.default.state.route.params.id), _billType2.default.all(), _billStatus2.default.all(), _bill2.default.attachmentPdf('show', _store2.default.state.route.params.id, {}), _country2.default.all(), _account2.default.languages(), _account2.default.currencies()];
	      if (!this.modules.length) {
	        requests.push(_modules2.default.items());
	      }
	      Promise.all(requests).then(function (data) {
	        _this8.billType = data[0].billType;
	        _this8.creditNotes = data[0].creditNotes;
	        _this8.hashid = data[0].hashid;
	        _this8.roundInvoiceTotal = data[0].roundInvoiceTotal;
	        _this8.invoiceSentAt = data[0].billSentAt;
	        _this8.attachmentFiles = data[4];
	        _this8.billAddressData.push({ billAddresMissing: data[0].billAddressMissing, billAddress: data[0].billAddress });
	        _this8.emailCopy = data[0].emailCopy;
	        _this8.emailTrackingRecipients = _this8.emailCopy[0] && _this8.emailCopy[0].tracking ? _this8.emailCopy[0].tracking.email_tracking_recipients : [];
	
	        if (data[0].orderId !== null) {
	          Promise.all([_orderProduct2.default.all(data[0].orderId), _order2.default.simpleOrder(data[0].orderId)]).then(function () {
	            _this8.form.setFieldValue('orderId', { id: _this8.currentOrder.id, name: _this8.currentOrder.number });
	            me.loading = false;
	          });
	        } else {
	          _this8.form.removeField('orderId');
	          me.loading = false;
	        }
	      });
	    },
	    previewSendInvoice: function previewSendInvoice() {
	      var _this9 = this;
	
	      this.previewWait = this.$t('static.bills.edit.sendPreviewInfo');
	      this.sendLoading = true;
	      Promise.all([_bill2.default.attachmentPdf('generate', _store2.default.state.route.params.id, { billType: this.billType })]).then(function () {
	        Promise.all([_bill2.default.attachmentPdf('show', _store2.default.state.route.params.id, {})]).then(function (data) {
	          _this9.attachmentFiles = data[0];
	          _this9.previewData();
	
	          _this9.sendLoading = false;
	        }).catch(function (errors) {
	          _this9.sendLoading = false;
	        });
	      }).catch(function (errors) {});
	    },
	    previewData: function previewData() {
	      var _this10 = this;
	
	      _invoice2.default.showBillEmailInformation(this.currentBill.id).then(function (billEmailInformation) {
	        var cc = [billEmailInformation.userEmail];
	        if (billEmailInformation.commonEmail !== null) {
	          cc.push(billEmailInformation.commonEmail);
	        }
	        _this10.setModalContent(function () {
	          return _previewMessage2.default;
	        });
	        _this10.setModalSize('full');
	        _this10.setModalProps({
	          contacts: _this10.currentClient.contacts,
	          message: billEmailInformation.message,
	          subject: billEmailInformation.title,
	          ccEmail: cc,
	          notes: '',
	
	          server: _this10.attachmentServer(),
	          initFiles: _this10.attachmentFiles,
	
	          headerTexts: [_this10.$t('static.bills.edit.from') + ': ' + billEmailInformation.fromName + ' <' + billEmailInformation.fromEmail + '>'],
	          attachments: [{
	            attachmentName: billEmailInformation.attachmentName,
	            action: _this10.showInvoice
	          }],
	          buttons: [{
	            name: _this10.$t('button.cancel'),
	            action: _this10.cancelModal,
	            title: _this10.$t('button.cancel')
	          }, {
	            name: _this10.$t('button.editText'),
	            action: _this10.editSettings,
	            title: _this10.$t('button.editText')
	          }, {
	            name: _this10.isPending ? _this10.$t('button.send') : _this10.$t('button.resend'),
	            action: _this10.sendInvoice,
	            title: _this10.isPending ? _this10.$t('button.send') : _this10.$t('button.resend')
	          }],
	          links: [{
	            name: _this10.$t('button.testEmailTitle'),
	            action: _this10.sendTestInvoice
	          }]
	        });
	        _this10.toggleModal(true);
	        _this10.previewWait = '';
	      }).catch(function () {});
	    },
	    attachmentServer: function attachmentServer() {
	      var _this11 = this;
	
	      return {
	        process: function (_process) {
	          function process(_x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9, _x10) {
	            return _process.apply(this, arguments);
	          }
	
	          process.toString = function () {
	            return _process.toString();
	          };
	
	          return process;
	        }(function (fieldName, file, metadata, load, error, progress, _abort, transfer, options) {
	          jQuery('#origAttach').remove();
	          Promise.all([_bill2.default.attachmentPdf('exist', _store2.default.state.route.params.id, { source: file.name })]).then(function () {
	            var formData = new FormData();
	            formData.append(fieldName, file, file.name);
	            var request = new XMLHttpRequest();
	            request.open('POST', ("https://api.kundan.no") + '/bills/pdf_attachment/' + _this11.currentBill.id + '/store');
	            request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('id_token'));
	            request.upload.onprogress = function (e) {
	              progress(e.lengthComputable, e.loaded, e.total);
	            };
	            request.onload = function () {
	              if (request.status >= 200 && request.status < 300) {
	                load();
	                load(request.responseText);
	              } else {
	                error('oh no');
	              }
	            };
	            request.send(formData);
	            return {
	              abort: function abort() {
	                request.abort();
	                _abort();
	              }
	            };
	          }).catch(function (errors) {
	            console.log(errors);
	            jQuery('.errors.filepond div').html('<span id="origAttach">' + errors.pdfAttachment[0] + '</span>');
	            error(errors.pdfAttachment[0]);
	          });
	        }),
	        revert: function revert(uniqueFileId, load, error) {
	          jQuery('#origAttach').remove();
	          Promise.all([_bill2.default.attachmentPdf('revert', _store2.default.state.route.params.id, { source: uniqueFileId })]).then(function () {
	            load();
	          }).catch(function (errors) {
	            console.log(errors);
	          });
	        },
	        remove: function remove(uniqueFileId, load, error) {
	          jQuery('#origAttach').remove();
	          Promise.all([_bill2.default.attachmentPdf('remove', _store2.default.state.route.params.id, { source: uniqueFileId })]).then(function (data) {
	            load();
	          }).catch(function (errors) {
	            error(errors.pdfAttachment[0]);
	            jQuery('.errors.filepond div').html('<span id="origAttach">' + errors.pdfAttachment[0] + '</span>');
	            console.log(errors.pdfAttachment[0]);
	          });
	        }
	      };
	    },
	    cancelModal: function cancelModal() {
	      this.toggleModal(false);
	    },
	    editSettings: function editSettings() {
	      this.toggleModal(false);
	      this.$router.push({
	        name: 'application.settings',
	        params: { tab: 'email' }
	      });
	    },
	    sendInvoice: function sendInvoice(ev) {
	      var _this12 = this;
	
	      var test = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      this.sendLoading = true;
	      this.setModalButtonLoading(true);
	      _invoice2.default.send(_store2.default.state.route.params.id, {
	        email_to: _store2.default.state.modal.modalProps.email_to,
	        email_cc: _store2.default.state.modal.modalProps.email_cc,
	        message: _store2.default.state.modal.modalProps.message,
	        subject: _store2.default.state.modal.modalProps.subject,
	
	        notes: _store2.default.state.modal.modalProps.notes,
	        test: test
	      }).then(function () {
	        _this12.toggleModal(false);
	        _this12.sendLoading = false;
	        _this12.setModalButtonLoading(false);
	        _bill2.default.show(_store2.default.state.route.params.id).then(function (response) {
	          _this12.emailCopy = response.emailCopy;
	          _this12.emailTrackingRecipients = _this12.emailCopy[0] ? _this12.emailCopy[0].tracking.email_tracking_recipients : [];
	        });
	        _order2.default.all();
	        _this12.$message({
	          showClose: true,
	          message: _this12.$t('static.bills.edit.sendInvoiceSuccess'),
	          type: 'success'
	        });
	      }).catch(function (response) {
	        _this12.toggleModal(false);
	        _this12.sendLoading = false;
	        _this12.setModalButtonLoading(false);
	        _this12.$message({
	          showClose: true,
	          message: response.data.message || response.data.error.message || _this12.$t('static.bills.edit.sendInvoiceError'),
	          type: 'error'
	        });
	      });
	    },
	    sendEHFInvoice: function sendEHFInvoice() {
	      var _this13 = this;
	
	      this.sendEHFLoading = true;
	      this.setModalContent(function () {
	        return component;
	      });
	
	      if (!this.hasEHFModule) {
	        this.showEHFModuleModal();
	        this.sendEHFLoading = false;
	        return;
	      }
	      _invoice2.default.sendEHF(_store2.default.state.route.params.id).then(function () {
	        _this13.sendEHFLoading = false;
	        _bill2.default.show(_store2.default.state.route.params.id);
	        _order2.default.all();
	        _this13.$message({
	          showClose: true,
	          message: _this13.$t('static.bills.edit.sendInvoiceSuccess'),
	          type: 'success'
	        });
	      }).catch(function (response) {
	        _this13.sendEHFLoading = false;
	        _this13.$message({
	          showClose: true,
	          message: _this13.$t('static.bills.edit.sendInvoiceError'),
	          type: 'error'
	        });
	      });
	    },
	    showEHFModuleModal: function showEHFModuleModal() {
	      var module = this.modules.find(function (m) {
	        return m.name === 'EHF';
	      });
	      if (!module) {
	        this.$message({
	          showClose: true,
	          message: this.$t('static.bills.edit.ehfModuleUpsellUnavailable'),
	          type: 'warning'
	        });
	        return;
	      }
	      this.setModalProps({ module: module });
	      this.toggleModal(true);
	      this.setModalContent(function () {
	        return _ehfModuleSetup2.default;
	      });
	    },
	    sendTestInvoice: function sendTestInvoice(ev) {
	      this.sendInvoice(ev, true);
	    },
	    sendBillEDI: function sendBillEDI() {
	      var _this14 = this;
	
	      var eo = this.currentOrder.ediOrder;
	      var nestedId = eo && (typeof eo === 'undefined' ? 'undefined' : _typeof(eo)) === 'object' && !Array.isArray(eo) && eo.id ? Number(eo.id) : 0;
	      var ediId = Number(this.currentOrder.ediOrderId) || nestedId;
	      if (!ediId || ediId <= 0) {
	        this.$message({
	          showClose: true,
	          message: this.$t('static.bills.edit.sendInvoiceError'),
	          customClass: 'error'
	        });
	        return;
	      }
	      this.sendLoading = true;
	      _invoice2.default.sendEDI(_store2.default.state.route.params.id, ediId).then(function (data) {
	        if (data.xml) {
	          _this14.$msgbox({
	            title: 'XML',
	            message: data.xml,
	            customClass: 'xmlModalCustomClass'
	          });
	        } else {
	          _this14.$message({
	            showClose: true,
	            message: _this14.$t('static.bills.edit.sendInvoiceSuccess'),
	            type: 'success'
	          });
	        }
	        _bill2.default.show(_store2.default.state.route.params.id);
	      }).catch(function () {
	        _this14.sendLoading = false;
	        _this14.$message({
	          showClose: true,
	          message: _this14.$t('static.bills.edit.sendInvoiceError'),
	          customClass: 'error'
	        });
	      });
	    },
	    showInvoice: function showInvoice() {
	      var reminderFee = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.isCreditNote) {
	        _creditNote2.default.show(this.hashid);
	        return;
	      }
	      _invoice2.default.show(this.hashid, reminderFee);
	    },
	    downloadInvoice: function downloadInvoice() {
	      if (this.isCreditNote) {
	        _creditNote2.default.download(this.hashid);
	        return;
	      }
	      _invoice2.default.download(this.hashid);
	    },
	    createCreditNote: function createCreditNote() {
	      var _this15 = this;
	
	      this.loadingCreditNote = true;
	      _creditNote2.default.store(_store2.default.state.route.params.id).then(function (bill) {
	        _this15.$router.replace({
	          name: 'bills.creditNote',
	          params: {
	            id: bill.id
	          }
	        });
	        window.scrollTo(0, 0);
	        _this15.loadingCreditNote = false;
	      }).catch(function () {
	        _this15.$message({
	          showClose: true,
	          message: _this15.$t('static.bills.edit.createNoteError'),
	          type: 'error'
	        });
	        _this15.loadingCreditNote = false;
	      });
	    },
	    roundInvoice: function roundInvoice() {
	      var _this16 = this;
	
	      _bill2.default.updateRoundInvoiceTotal(_store2.default.state.route.params.id, this.roundInvoiceTotal).then(function () {
	        _this16.successMessage = _this16.$t('static.bills.edit.updateSuccess');
	        setTimeout(function () {
	          _this16.successMessage = '';
	        }, 3000);
	      }).catch(function () {});
	    },
	    deleteBill: function deleteBill(bill) {
	      var _this17 = this;
	
	      this.$confirm(this.$t('static.bills.index.confirmDelete'), this.$t('static.bills.index.confirmDeleteTitle'), {
	        confirmButtonText: this.$t('button.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _bill2.default.destroy(bill.id).then(function () {
	          return _this17.$router.push({ name: 'bills.index' });
	        }).catch(function (_ref) {
	          var response = _ref.response;
	
	          var message = _this17.$t('static.bills.index.deleteError');
	          if (response.data.error && response.data.error.code === 40117) {
	            message = _this17.$t('static.bills.index.deleteNotDraftError');
	          }
	          _this17.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        });
	      }).catch(function () {});
	    },
	    toggleDropdown: function toggleDropdown() {
	      this.dropdownState = !this.dropdownState;
	    },
	    searchMethod: function searchMethod() {
	      var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      return Promise.all([_order2.default.search({ search: search, limit: 10 })]);
	    },
	    validateKidNumber: function validateKidNumber() {
	      var _this18 = this;
	
	      this.kidLoading = true;
	      _bill2.default.validateKID(this.currentBill.id, this.form.kidNumber).then(function () {
	        _this18.kidLoading = false;
	        _this18.$message({
	          showClose: true,
	          message: _this18.$t('static.bills.edit.validKID')
	        });
	      }).catch(function () {
	        _this18.kidLoading = false;
	        _this18.$message({
	          showClose: true,
	          message: _this18.$t('static.bills.edit.invalidKID'),
	          customClass: 'error'
	        });
	      });
	    },
	    generateKidNumber: function generateKidNumber() {
	      var _this19 = this;
	
	      this.kidLoading = true;
	      _bill2.default.generateKID(this.currentBill.id).then(function () {
	        _this19.kidLoading = false;
	        _this19.$message({
	          showClose: true,
	          message: _this19.$t('static.bills.edit.kidGenerateSuccess')
	        });
	      }).catch(function () {
	        _this19.kidLoading = false;
	        _this19.$message({
	          showClose: true,
	          message: _this19.$t('static.bills.edit.invalidKID'),
	          customClass: 'error'
	        });
	      });
	    },
	    disabledDate: function disabledDate(date) {
	      date.setDate(date.getDate() + 15);
	      return date < new Date();
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13),
	    VProductsTable: __webpack_require__(2676),
	    VEdiOrderItemsTable: __webpack_require__(769),
	    VFormTable: __webpack_require__(46),
	    VCreditNoteTable: __webpack_require__(2694),
	    VClientInfo: __webpack_require__(768)
	  },
	
	  mixins: [_date2.default]
	};

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _organizationSettings = __webpack_require__(83);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _organizationSettings3 = __webpack_require__(27);
	
	var _organizationSettings4 = _interopRequireDefault(_organizationSettings3);
	
	var _vuex = __webpack_require__(5);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _date = __webpack_require__(107);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _ExportHistory = __webpack_require__(2661);
	
	var _ExportHistory2 = _interopRequireDefault(_ExportHistory);
	
	var _bill = __webpack_require__(92);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      archiveList: [],
	      description: new _forms2.default({
	        description: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      selectedProvider: false,
	      cliked: false,
	      dialogVisible: false,
	      dialogDisabled: false,
	      salesData: [],
	      selectedArchive: null,
	      salesDateRange: [(0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()],
	      billsDateRange: [(0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()]
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    providerList: 'setDownloadProviderList',
	    settings: 'organizationSettings'
	  }), {
	    dataList: function dataList() {
	      var _this = this;
	
	      return this.archiveList.map(function (c, index) {
	        return {
	          periode: _this.formatDate(c.date_start) + ' - ' + _this.formatDate(c.date_stop),
	          description: c.description,
	          provider: c.provider,
	          download: _this.$t('static.bills.exportBill.download.download'),
	          id: c.id,
	          date_start: _this.formatDate(c.date_start),
	          date_stop: _this.formatDate(c.date_stop)
	        };
	      });
	    },
	    buttons: function buttons() {
	      return [{
	        class: 'btn mall el-button--danger',
	        label: this.$t('button.delete'),
	        click: this.deleteItem
	      }];
	    }
	  }),
	  created: function created() {
	    var _this2 = this;
	
	    var requests = [];
	    if (Object.keys(this.settings).length === 0) {
	      requests.push(_organizationSettings4.default.show());
	    }
	
	    requests.push(_bill2.default.archiveReport());
	    this.loading = true;
	    Promise.all(requests).then(function (data) {
	      _this2.loading = false;
	    });
	  },
	
	  watch: {
	    providerList: function providerList(_providerList) {
	      this.archiveList = _providerList.downloadExportList;
	      this.archiveList.length ? this.selectedProvider = true : this.selectedProvider = false;
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    onSalesFilterChange: function onSalesFilterChange(name, value) {
	      if ((name === 'billsDateRange' || name === 'salesDateRange') && value === undefined) {
	        this[name] = [(0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()];
	      } else {
	        this[name] = value;
	      }
	    },
	    CreateDownloadList: function CreateDownloadList() {
	      var params = {};
	
	      if (this.rowLimit > 0) {
	        params.limit = this.rowLimit;
	      }
	
	      console.log(this.settings);
	      if (this.settings.accountingProvider) {
	        if (this.billsDateRange[0] && this.billsDateRange[1]) {
	          params.token = localStorage.getItem('id_token');
	          params.date_start = (0, _moment2.default)(this.billsDateRange[0]).format('YYYY-MM-DD');
	          params.date_stop = (0, _moment2.default)(this.billsDateRange[1]).format('YYYY-MM-DD');
	          params.provider = this.settings.accountingProvider.slug;
	          params.description = this.description.description;
	        }
	
	        _store2.default.dispatch('setNewProviderItemList', params);
	        this.selectedProvider = true;
	        this.description.description = '';
	        this.cliked = false;
	
	        return new Promise(function (resolve, reject) {
	          _vue2.default.$http.post('export-create-record', params);
	        });
	      } else {
	        this.cliked = true;
	      }
	    },
	    downloadBillReport: function downloadBillReport(item) {
	
	      var params = {};
	
	      if (this.rowLimit > 0) {
	        params.limit = this.rowLimit;
	      }
	
	      if (this.billsDateRange[0] && this.billsDateRange[1]) {
	        params.date_start = item.date_start;
	        params.date_stop = item.date_stop;
	        params.provider = this.settings.accountingProvider.slug;
	        params.description = item.description;
	      }
	
	      window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/export-download/', _extends({
	        token: localStorage.getItem('id_token')
	      }, params)));
	    },
	    deleteItem: function deleteItem(scope) {
	      this.selectedArchive = scope;
	
	      this.dialogVisible = true;
	    },
	    handleClose: function handleClose() {
	      this.selectedArchive = null;
	    },
	    deleted: function deleted() {
	      var me = this;
	
	      _vue2.default.$http.delete('export-delete-record/' + me.selectedArchive.row.id).then(function (data) {
	        me.dataList.splice(me.selectedArchive.$index, 1);
	        me.dialogVisible = false;
	      });
	    },
	    activateModalExport: function activateModalExport() {
	      this.setModalContent(function () {
	        return _ExportHistory2.default;
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(true);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    showExportModal: function showExportModal() {
	      this.activateModalExport();
	    }
	  }),
	
	  components: {
	    VDateRange: __webpack_require__(156),
	    VMessage: __webpack_require__(13),
	    VForm: __webpack_require__(9),
	    VTable: __webpack_require__(33)
	  },
	  mixins: [_date2.default]
	};

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(5);
	
	var _bill = __webpack_require__(92);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	var _invoice = __webpack_require__(229);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _bulkProcessBillModal = __webpack_require__(2680);
	
	var _bulkProcessBillModal2 = _interopRequireDefault(_bulkProcessBillModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function billIsOverdueForDisplay(b) {
	  if (!b.dueDate || !(0, _moment2.default)(b.dueDate).isValid()) return false;
	  if (b.billType === 'Credit Note') return false;
	  var blocked = ['Cleared', 'Cancelled', 'Draft', 'Pending'];
	  if (blocked.includes(b.billStatus)) return false;
	  return (0, _moment2.default)().isAfter((0, _moment2.default)(b.dueDate).startOf('day'));
	}
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sortValue: '',
	      info: 'info',
	      primary: 'primary',
	      search: '',
	      limit: 25,
	      multipleSelection: [],
	      bulkSelectionLimit: 25,
	      showAction: false,
	      action: null
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    bills: 'paginatedBills',
	    view: 'getView',
	    searchQuery: 'billQuery'
	  }), {
	    billsListView: function billsListView() {
	      var _this = this;
	
	      return this.bills.items.map(function (c) {
	        var amountDue = typeof c.amountDue !== 'undefined' ? '' + new Intl.NumberFormat('no-NO', { style: 'currency', currency: 'NOK' }).format(c.amountDue) : '';
	        var overdue = billIsOverdueForDisplay(c);
	        return {
	          name: '#' + c.billingNumber,
	          type: _this.$t('static.bills.edit.' + c.billType.replace(/\s+/g, '').toLowerCase()),
	          status: _this.$t('static.reports.bills.' + c.billStatus.replace(/\s+/g, '').toLowerCase()),
	          client: c.client,
	          billType: c.billType,
	          totalValue: typeof c.totalValue !== 'undefined' ? c.totalValue.toFixed(2) + ' NOK' : '',
	          totalQuantity: typeof c.totalValue !== 'undefined' ? c.totalQuantity + ' ' + _this.$t('static.orders.index.qty') : '',
	          id: c.id,
	          billProducts: c.billProducts,
	          hashid: c.hashid,
	          paymentDate: c.paymentDate || _moment2.default.now(),
	          dueDate: (0, _moment2.default)(c.dueDate).isValid() ? (0, _moment2.default)(c.dueDate).format('DD-MM-YYYY') : '-',
	          invoiceDate: (0, _moment2.default)(c.date).isValid() ? (0, _moment2.default)(c.date).format('DD-MM-YYYY') : '-',
	          amountDue: c.billStatus === 'Partly Paid' ? amountDue : '-',
	          amountDueNum: c.amountDue,
	          amountPaid: typeof c.amountPaid !== 'undefined' ? '' + new Intl.NumberFormat('no-NO', { style: 'currency', currency: 'NOK' }).format(c.amountPaid) : 0,
	          totalGross: typeof c.totalGross !== 'undefined' ? '' + new Intl.NumberFormat('no-NO', { style: 'currency', currency: 'NOK' }).format(c.totalGross) : '',
	          overdue: overdue
	        };
	      });
	    },
	    billsList: function billsList() {
	      var _this2 = this;
	
	      return this.bills.items.map(function (b) {
	        var cardClass = '';
	        var overdue = billIsOverdueForDisplay(b);
	
	        if (b.billStatus === 'Overdue' || overdue) {
	          cardClass = 'card-red';
	        } else if (b.billStatus === 'Cleared') {
	          cardClass = 'card-green';
	        } else if (b.billStatus === 'Sent') {
	          cardClass = 'card-yellow';
	        } else if (b.billStatus === 'Cancelled') {
	          cardClass = 'card-green';
	        }
	
	        Object.assign(b, {
	          number: b.billingNumber ? '#' + b.billingNumber : 'Draft',
	          value: b.totalValue.toFixed(2) + ' NOK',
	          amount: '(' + b.totalQuantity + ' ' + _this2.$t('static.bills.index.quantities') + ')',
	          dueDateFormated: (0, _moment2.default)(b.dueDate).isValid() ? (0, _moment2.default)(b.dueDate).format('DD-MM-YYYY') : '-',
	          invoiceDateFormated: (0, _moment2.default)(b.date).isValid() ? (0, _moment2.default)(b.date).format('DD-MM-YYYY') : '-',
	          cardTotalGross: typeof b.totalGross !== 'undefined' ? '' + new Intl.NumberFormat('no-NO', { style: 'currency', currency: 'NOK' }).format(b.totalGross) : '',
	          cardAmountDue: typeof b.amountDue !== 'undefined' ? '' + new Intl.NumberFormat('no-NO', { style: 'currency', currency: 'NOK' }).format(b.amountDue) : '',
	          cardClass: cardClass,
	          overdue: overdue
	        });
	
	        return b;
	      });
	    },
	    selectedCount: function selectedCount() {
	      return this.multipleSelection.length || 0;
	    }
	  }),
	
	  watch: {
	    $route: function $route() {
	      this.all(this.searchQuery.page, this.limit);
	    },
	    multipleSelection: function multipleSelection(_multipleSelection) {
	      this.showAction = false;
	      if (_multipleSelection.length) {
	        this.showAction = true;
	      }
	    },
	    view: function view(_view) {
	      if (_view == 'card') {
	        this.info = 'info';
	        this.primary = 'primary';
	      } else {
	        this.primary = 'info';
	        this.info = 'primary';
	      }
	    },
	    loading: function loading(_loading) {
	      if (_loading) {
	        this.disableInnerSidebar();
	      } else {
	        this.enableInnerSidebar();
	      }
	    }
	  },
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19),
	    VTable: __webpack_require__(33)
	  },
	
	  mixins: [_search2.default],
	
	  mounted: function mounted() {
	    var _this3 = this;
	
	    _account2.default.rememberPerPage('get', { from: 'bill' }).then(function (data) {
	      _this3.limit = data.size;
	      _this3.all(_this3.searchQuery.page, _this3.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	
	    this.setInnerSidebar([{
	      title: this.$t('static.bills.filters.title'),
	      options: [{
	        title: this.$t('static.bills.filters.today'),
	        route: {
	          name: 'bills.index',
	          query: {
	            filter: 'today'
	          }
	        }
	      }, {
	        title: this.$t('static.bills.filters.pending'),
	        route: {
	          name: 'bills.index',
	          query: {
	            filter: 'pending'
	          }
	        }
	      }, {
	        title: this.$t('static.bills.filters.sent'),
	        route: {
	          name: 'bills.index',
	          query: {
	            filter: 'sent'
	          }
	        }
	      }, {
	        title: this.$t('static.bills.filters.overdue'),
	        route: {
	          name: 'bills.index',
	          query: {
	            filter: 'overdue'
	          }
	        }
	      }, {
	        title: this.$t('static.bills.filters.cancelled'),
	        route: {
	          name: 'bills.index',
	          query: {
	            filter: 'cancelled'
	          }
	        }
	      }, {
	        title: this.$t('static.bills.filters.paid'),
	        route: {
	          name: 'bills.index',
	          query: {
	            filter: 'paid'
	          }
	        }
	      }, {
	        title: this.$t('static.bills.filters.partlyPaid'),
	        route: {
	          name: 'bills.index',
	          query: {
	            filter: 'partlyPaid'
	          }
	        }
	      }, {
	        title: this.$t('static.bills.filters.creditNote'),
	        route: {
	          name: 'bills.index',
	          query: {
	            filter: 'credit-note'
	          }
	        }
	      }, {
	        title: this.$t('static.bills.filters.invoice'),
	        route: {
	          name: 'bills.index',
	          query: {
	            filter: 'invoice'
	          }
	        }
	      }, {
	        title: this.$t('static.bills.filters.all'),
	        route: {
	          name: 'bills.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.bills.create.title'),
	        route: {
	          name: 'bills.create'
	        }
	      }
	
	    }, {
	      title: this.$t('layouts.sidebar.billExport'),
	      button: {
	        title: this.$t('static.bills.exportBill.title'),
	        route: {
	          name: 'bills.export'
	        }
	      }
	    }]);
	
	    if (this.view == 'card') {
	      this.info = 'info';
	      this.primary = 'primary';
	    } else {
	      this.primary = 'info';
	      this.info = 'primary';
	    }
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
	    disableInnerSidebar: 'DISABLE_INNERSIDEBAR',
	    enableInnerSidebar: 'ENABLE_INNERSIDEBAR',
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    onSelectAction: function onSelectAction(value) {
	      if (this.multipleSelection.length > this.bulkSelectionLimit) {
	        var message = this.$t('static.bills.index.bulkMaxLimitExceededError') + ' ' + this.bulkSelectionLimit;
	        this.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	        return;
	      }
	
	      if (value === 'downloadInvoicePdf') {
	        _invoice2.default.bulkDownload(this.multipleSelection.map(function (item) {
	          return item.hashid;
	        }));
	        return;
	      }
	      if (value) {
	        this.setModalContent(function () {
	          return _bulkProcessBillModal2.default;
	        });
	        this.setModalProps({
	          selectedBills: this.multipleSelection,
	          operation: value,
	          onSubmit: this.handleBulkBillActionSubmit
	        });
	        this.setModalCloseOnClick(false);
	        this.setModalShowClose(false);
	        this.setModalCloseOnPressEscape(false);
	        this.toggleModal(true);
	      }
	    },
	    handleBulkBillActionSubmit: function handleBulkBillActionSubmit() {
	      this.multipleSelection = [];
	      this.all(1, 25);
	    },
	    perPage: function perPage(size) {
	      var _this4 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'bill', perPage: size }).then(function (data) {
	        _this4.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    changeView: function changeView(view) {
	      if (this.info != view) {
	        this.primary = this.info;
	        this.info = view;
	        if (this.info == 'info') {
	          _store2.default.dispatch('setView', 'card');
	        } else {
	          _store2.default.dispatch('setView', 'list');
	        }
	      }
	    },
	    onChangeSearch: function onChangeSearch(name, value) {
	      _store2.default.dispatch('setBillQuery', { page: 1, limit: this.limit, search: value });
	      this.all(1, this.limit);
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this5 = this;
	
	      this.loading = true;
	      var query = { page: page, limit: limit, search: this.searchQuery.search };
	      _store2.default.dispatch('setBillQuery', query);
	      this.search = this.searchQuery.search;
	      _bill2.default.items({
	        page: page,
	        limit: limit,
	        search: this.searchQuery.search,
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this5.loading = false;
	      }).catch(function () {
	        _this5.loadProductsing = false;
	      });
	    }, 800),
	
	    editBill: function editBill(bill) {
	      var name = bill.billType !== 'Credit Note' ? 'bills.edit' : 'bills.creditNote';
	      this.$router.push({
	        name: name,
	        params: { id: bill.id }
	      });
	    },
	    editBillNewTab: function editBillNewTab(bill) {
	      var name = bill.billType !== 'Credit Note' ? 'bills.edit' : 'bills.creditNote';
	      var route = this.$router.resolve({
	        name: name,
	        params: { id: bill.id }
	      });
	      window.open(route.href, '_blank');
	    },
	    billRowClassName: function billRowClassName(_ref) {
	      var row = _ref.row;
	
	      return row.overdue ? 'bill-row-overdue' : '';
	    }
	  })
	};

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _organizationMemberBooking = __webpack_require__(464);
	
	var _organizationMemberBooking2 = _interopRequireDefault(_organizationMemberBooking);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = {
	  props: {
	    date: {
	      required: true,
	      type: Date
	    },
	
	    action: {
	      required: true,
	      type: String,
	      default: 'ADD'
	    },
	
	    event: {
	      type: [Object, Array],
	      default: function _default() {}
	    },
	
	    onStore: {
	      type: Function,
	      default: function _default() {}
	    },
	
	    onUpdate: {
	      type: Function,
	      default: function _default() {}
	    }
	  },
	
	  data: function data() {
	    return {
	      newBookingForm: {
	        id: '',
	        product_id: '',
	        member_id: '',
	        client_id: '',
	        date: '',
	        start_time: '',
	        end_time: '',
	        order_id: '',
	        order_number: ''
	      },
	      newBookingRules: {
	        product_id: [{ required: true, trigger: 'blur' }],
	        client_id: [{ required: true, trigger: 'blur' }]
	      }
	    };
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    clients: 'allClients',
	    account: 'account',
	    organization_members: 'allOrganizationMembers'
	  }), {
	    memberProducts: function memberProducts() {
	      var member_products = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.organization_members[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var om = _step.value;
	
	          om.organizationMemberProducts.forEach(function (omp) {
	            if (member_products.findIndex(function (x) {
	              return x.product_id == omp.product_id;
	            }) == -1) {
	              member_products.push(omp);
	            }
	          });
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      ;
	
	      return member_products;
	    },
	    productMembers: function productMembers() {
	      var organization = {
	        id: '',
	        user: {
	          full_name: this.account.firstName + ' ' + this.account.lastName + ' (Organization)'
	        }
	      };
	      var product_members = [organization];
	
	      if (this.newBookingForm.product_id) {
	        var $this = this;
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = this.organization_members[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var om = _step2.value;
	
	            if (om.organizationMemberProducts.findIndex(function (x) {
	              return x.product_id == $this.newBookingForm.product_id;
	            }) > -1) {
	              product_members.push(om);
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        ;
	      }
	
	      return product_members;
	    }
	  }),
	
	  created: function created() {
	    console.log(this.event);
	    _client2.default.all();
	    this.newBookingForm.date = (0, _moment2.default)(this.date).format('YYYY-MM-DD');
	    if (this.action == 'ADD') {
	      this.newBookingForm.start_time = (0, _moment2.default)(this.date).format('HH:mm');
	    } else if (this.action == 'EDIT' && this.event) {
	      this.newBookingForm.id = this.event.id;
	      this.newBookingForm.product_id = this.event.product_id;
	      this.newBookingForm.member_id = this.event.member_id;
	      this.newBookingForm.client_id = this.event.client_id;
	      this.newBookingForm.start_time = this.event.start_time;
	      this.newBookingForm.end_time = this.event.end_time;
	      this.newBookingForm.order_id = this.event.order_id;
	      this.newBookingForm.order_number = this.event.order_number;
	      this.newBookingForm.order_status = this.event.order_status;
	    }
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    updateEndTime: function updateEndTime() {
	      var _this = this;
	
	      if (this.newBookingForm.product_id) {
	        var member_product = this.memberProducts.find(function (x) {
	          return x.product_id == _this.newBookingForm.product_id;
	        });
	        if (member_product) {
	          this.newBookingForm.end_time = (0, _moment2.default)(this.newBookingForm.start_time, 'H:mm').add(member_product.product.product_configuration.duration, 'minutes').format('HH:mm');
	        }
	      }
	    },
	    store: function store() {
	      var _this2 = this;
	
	      this.$refs['newBookingForm'].validate(function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(valid) {
	          var loading, response, event;
	          return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  if (!valid) {
	                    _context.next = 14;
	                    break;
	                  }
	
	                  loading = _this2.$loading({
	                    target: '.el-dialog'
	                  });
	
	                  if (!(_this2.action == 'ADD')) {
	                    _context.next = 8;
	                    break;
	                  }
	
	                  _context.next = 5;
	                  return _organizationMemberBooking2.default.store(_this2.newBookingForm).catch(function (error) {
	                    _this2.$message({
	                      message: error,
	                      type: 'error'
	                    });
	                  });
	
	                case 5:
	                  response = _context.sent;
	                  _context.next = 12;
	                  break;
	
	                case 8:
	                  if (!(_this2.action == 'EDIT')) {
	                    _context.next = 12;
	                    break;
	                  }
	
	                  _context.next = 11;
	                  return _organizationMemberBooking2.default.update(_this2.newBookingForm).catch(function (error) {
	                    _this2.$message({
	                      message: error,
	                      type: 'error'
	                    });
	                  });
	
	                case 11:
	                  response = _context.sent;
	
	                case 12:
	
	                  loading.close();
	
	                  if (response) {
	                    event = {
	                      id: response.id,
	                      product_id: response.order.order_products.length > 0 ? response.order.order_products[0].product_id : '',
	                      member_id: response.organization_member_product ? response.organization_member_product.organization_member_id : '',
	                      client_id: response.order.client_id,
	                      data_date: response.date,
	                      start_time: response.start_time,
	                      end_time: response.end_time,
	                      order_id: response.order.id,
	                      order_number: response.order.number,
	                      title: response.order.client.name || response.order.client.client_contact.email,
	                      productName: response.order.order_products.length > 0 ? response.order.order_products[0].name : '',
	                      memberName: response.organization_member_product ? response.organization_member_product.organization_member.user.full_name : response.order.organization.name,
	                      start: response.date + ' ' + response.start_time,
	                      end: response.date + ' ' + response.end_time,
	                      backgroundColor: response.organization_member_product ? response.organization_member_product.organization_member.color : '#777777',
	                      borderColor: response.organization_member_product ? response.organization_member_product.organization_member.color : '#777777'
	                    };
	
	
	                    if (_this2.action == 'ADD') {
	                      _this2.onStore(event);
	                    } else if (_this2.action == 'EDIT') {
	                      _this2.onUpdate(event);
	                    }
	
	                    _this2.closeModal();
	                  }
	
	                case 14:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this2);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }());
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    },
	    formatDate: function formatDate(date) {
	      if (!date) return '';
	      return (0, _moment2.default)(date).format('MMM DD, YYYY');
	    }
	  })
	};

/***/ }),
/* 1888 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _campaign = __webpack_require__(185);
	
	var _campaign2 = _interopRequireDefault(_campaign);
	
	var _campaignType = __webpack_require__(453);
	
	var _campaignType2 = _interopRequireDefault(_campaignType);
	
	var _subscriberList = __webpack_require__(192);
	
	var _subscriberList2 = _interopRequireDefault(_subscriberList);
	
	var _campaign3 = __webpack_require__(163);
	
	var _campaign4 = _interopRequireDefault(_campaign3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        description: {
	          value: '',
	          type: 'textarea'
	        },
	        campaignTypeId: {
	          value: '',
	          type: 'select'
	        },
	        newsSubscriberListId: {
	          value: '',
	          type: 'select'
	        }
	      })
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    campaignTypes: 'campaignTypes',
	    allSubscriberList: 'allSubscriberList'
	  })),
	
	  watch: {
	    campaignTypes: function campaignTypes(_campaignTypes) {
	      this.form.setOptions('campaignTypeId', _campaignTypes);
	    },
	    allSubscriberList: function allSubscriberList(_allSubscriberList) {
	      this.form.setOptions('newsSubscriberListId', _allSubscriberList.items);
	    }
	  },
	
	  created: function created() {
	    _subscriberList2.default.all();
	    _campaignType2.default.all();
	    this.form.setTooltip('campaignTypeId', this.$t('static.campaigns.create.campaignTypeTooltip'));
	  },
	
	
	  methods: {
	    store: function store() {
	      var _this = this;
	
	      this.form.loading = true;
	      var campaign = _campaign4.default.send(this.form.data());
	      _campaign2.default.store(campaign).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _campaign = __webpack_require__(185);
	
	var _campaign2 = _interopRequireDefault(_campaign);
	
	var _news = __webpack_require__(298);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _clientCampaign = __webpack_require__(993);
	
	var _clientCampaign2 = _interopRequireDefault(_clientCampaign);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _clientGroup = __webpack_require__(93);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	var _campaignType = __webpack_require__(453);
	
	var _campaignType2 = _interopRequireDefault(_campaignType);
	
	var _subscriberList = __webpack_require__(192);
	
	var _subscriberList2 = _interopRequireDefault(_subscriberList);
	
	var _campaign3 = __webpack_require__(163);
	
	var _campaign4 = _interopRequireDefault(_campaign3);
	
	var _addEmail = __webpack_require__(2669);
	
	var _addEmail2 = _interopRequireDefault(_addEmail);
	
	var _emailSendTracking = __webpack_require__(2700);
	
	var _emailSendTracking2 = _interopRequireDefault(_emailSendTracking);
	
	var _line = __webpack_require__(420);
	
	var _line2 = _interopRequireDefault(_line);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        description: {
	          value: '',
	          type: 'textarea'
	        },
	        campaignTypeId: {
	          value: '',
	          type: 'select'
	        },
	        newsSubscriberListId: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      emails: {},
	      clients: {},
	      allClients: [],
	      allClientGroups: [],
	      selectedClients: [],
	      selectedClientGroups: [],
	      selectClientError: '',
	      selectClientGroupError: '',
	      addingClients: false,
	      addingClientGroups: false,
	      currentCampaign: {},
	      loading: false,
	      loadingEmails: true,
	      loadingClients: true,
	      activeName: 'overview',
	      emailTracking: {
	        defaultDate: new Date(),
	        emailTrackingRecipients: [],
	        emailSubject: [],
	        selectNewsId: 0,
	        selectEmailSubject: '',
	        countType: 'opened',
	        datesFromTwoDates: [],
	        lineChartLabel: this.$t('static.campaigns.edit.emailTracking.countLabel.opened'),
	        iconCountData: {
	          opened: 0,
	          delivered: 0,
	          clicked: 0,
	          dropped: 0,
	          bounced: 0,
	          complained: 0,
	          failed: 0,
	          unsubscribed: 0
	        },
	        iconActive: {
	          opened: '',
	          delivered: '',
	          clicked: '',
	          dropped: '',
	          bounced: '',
	          complained: '',
	          failed: '',
	          unsubscribed: ''
	        },
	        dateRangDisplay: '',
	        selectedDayOrRangeText: '',
	        selectDayOrRange: {},
	        selectDayOrRangeVisble: false,
	        selectDayOrRangeOption: [{
	          group: this.$t('static.campaigns.edit.emailTracking.dateRangDropDown.group1'),
	          item: { today: this.$t('static.campaigns.edit.emailTracking.dateRangDropDown.today'), all: this.$t('static.campaigns.edit.emailTracking.dateRangDropDown.all') }
	        }, {
	          group: this.$t('static.campaigns.edit.emailTracking.dateRangDropDown.group2'),
	          item: { date_range: this.$t('static.campaigns.edit.emailTracking.dateRangDropDown.dateRange') }
	        }],
	        pickerOptions: {
	          shortcuts: [{
	            text: this.$t('static.campaigns.edit.emailTracking.datePicker.shortcut.last3Days'),
	            onClick: function onClick(picker) {
	              var end = new Date();
	              var start = new Date();
	              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
	              picker.$emit('pick', [start, end]);
	            }
	          }, {
	            text: this.$t('static.campaigns.edit.emailTracking.datePicker.shortcut.lastWeek'),
	            onClick: function onClick(picker) {
	              var end = new Date();
	              var start = new Date();
	              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
	              picker.$emit('pick', [start, end]);
	            }
	          }, {
	            text: this.$t('static.campaigns.edit.emailTracking.datePicker.shortcut.lastMonth'),
	            onClick: function onClick(picker) {
	              var end = new Date();
	              var start = new Date();
	              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
	              picker.$emit('pick', [start, end]);
	            }
	          }, {
	            text: this.$t('static.campaigns.edit.emailTracking.datePicker.shortcut.last3Month'),
	            onClick: function onClick(picker) {
	              var end = new Date();
	              var start = new Date();
	              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
	              picker.$emit('pick', [start, end]);
	            }
	          }]
	        },
	        selectRange: '',
	        countDataSet: {
	          opened: [],
	          delivered: [],
	          clicked: [],
	          dropped: [],
	          bounced: [],
	          complained: [],
	          failed: [],
	          unsubscribed: []
	        },
	        lineChart: {
	          options: {
	            plugins: {
	              datalabels: {
	                display: true,
	                align: 'center',
	                anchor: 'center'
	              }
	            },
	            responsive: true,
	            maintainAspectRatio: false,
	            layout: {
	              padding: {
	                left: 0, right: 0, top: 0, bottom: 0
	              }
	            },
	            legend: {
	              display: true,
	              position: 'left',
	              labels: {
	                boxWidth: 4
	              }
	            },
	            tooltips: {
	              enabled: true
	            }
	          },
	          chartData: {
	            labels: [],
	            datasets: [{
	              label: '',
	              data: []
	            }]
	          }
	        },
	        loaded: false
	      },
	      ifListNotSet: null
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    campaignTypes: 'campaignTypes',
	    allSubscriberList: 'allSubscriberList'
	  }), {
	    allClientsList: function allClientsList() {
	      return this.allClients.map(function (c) {
	        return { id: c.id, name: c.name || c.firstName + ' ' + c.lastName };
	      });
	    }
	  }),
	
	  watch: {
	    campaignTypes: function campaignTypes(_campaignTypes) {
	      this.form.setOptions('campaignTypeId', _campaignTypes);
	    },
	    allSubscriberList: function allSubscriberList(_allSubscriberList) {
	      this.form.setOptions('newsSubscriberListId', _allSubscriberList.items);
	    }
	  },
	
	  created: function created() {
	    this.form.setTooltip('campaignTypeId', this.$t('static.campaigns.create.campaignTypeTooltip'));
	    this.show();
	    this.showEmailTracking();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    redirectEditCampaign: function redirectEditCampaign() {
	      this.activeName = 'editcampaign';
	    },
	    update: function update() {
	      var _this = this;
	
	      this.form.loading = true;
	      var campaign = _campaign4.default.send(this.form.data());
	      _campaign2.default.update(this.$route.params.id, campaign).then(function () {
	        _this.form.loading = false;
	        _this.form.successMessage = _this.$t('static.campaigns.edit.updateSuccess');
	        _campaign2.default.show(_this.$route.params.id).then(function (c) {
	          _this.currentCampaign = c;
	        });
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      var _this2 = this;
	
	      this.loading = true;
	      Promise.all([_campaign2.default.show(this.$route.params.id), _campaignType2.default.all(), _subscriberList2.default.all()]).then(function (data) {
	        _this2.fetchEmails();
	        _this2.fetchClients();
	        _this2.fetchAllClients();
	        _this2.fetchAllClientGroups();
	        _this2.currentCampaign = data[0];
	        var campaign = data[0];
	        _this2.loading = false;
	        _this2.form.assignData(campaign);
	        if (_this2.form.newsSubscriberListId === 0) {
	          _this2.form.setFieldValue('newsSubscriberListId', '');
	          _this2.ifListNotSet = _this2.$t('static.campaigns.listNotSetup');
	          _this2.form.recordErrors({ newsSubscriberListId: [_this2.ifListNotSet] });
	        }
	      });
	    },
	    fetchEmails: function fetchEmails(page) {
	      var _this3 = this;
	
	      this.loadingEmails = true;
	      _news2.default.items(this.$route.params.id, page).then(function (emails) {
	        _this3.loadingEmails = false;
	        _this3.emails = emails;
	        var self = _this3;
	        emails.items.forEach(function (item) {
	          self.emailTracking.emailSubject.push({ label: item.subject, value: item.id });
	        });
	
	        _this3.emailTracking.selectEmailSubject = emails.items[0].id;
	        _this3.emailTracking.selectDayOrRange = { value: 'today', label: 'Today' };
	        _this3.onSelectEmailSubject(_this3.emailTracking.selectEmailSubject);
	      });
	    },
	    fetchClients: function fetchClients(page) {
	      var _this4 = this;
	
	      this.loadingClients = true;
	      _clientCampaign2.default.items(this.$route.params.id, page).then(function (clients) {
	        _this4.loadingClients = false;
	        _this4.clients = clients;
	      });
	    },
	    fetchAllClients: function fetchAllClients() {
	      var _this5 = this;
	
	      _client2.default.all().then(function (clients) {
	        _this5.allClients = clients;
	      });
	    },
	    fetchAllClientGroups: function fetchAllClientGroups() {
	      var _this6 = this;
	
	      _clientGroup2.default.all().then(function (groups) {
	        _this6.allClientGroups = groups;
	      });
	    },
	    openAddEmail: function openAddEmail() {
	      this.setModalContent(function () {
	        return _addEmail2.default;
	      });
	      this.setModalProps({
	        create: this.addEmail,
	        test: this.testEmail,
	        campaign: this.currentCampaign,
	        listMessage: this.ifListNotSet
	      });
	      this.toggleModal(true);
	    },
	    addEmail: function addEmail(data) {
	      var _this7 = this;
	
	      return _news2.default.store(data).then(function () {
	        _this7.fetchEmails();
	      });
	    },
	    openEditEmail: function openEditEmail(email) {
	      this.setModalContent(function () {
	        return _addEmail2.default;
	      });
	      this.setModalProps({
	        create: this.editEmail,
	        test: this.testEmail,
	        campaign: this.currentCampaign,
	        email: email,
	        listMessage: this.ifListNotSet
	      });
	      this.toggleModal(true);
	    },
	    editEmail: function editEmail(data, id) {
	      var _this8 = this;
	
	      return _news2.default.update(id, data).then(function () {
	        _this8.fetchEmails();
	      });
	    },
	    testEmail: function testEmail(data) {
	      return _news2.default.test(data);
	    },
	    addClients: function addClients() {
	      var _this9 = this;
	
	      var groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var data = !groups ? { clients: this.selectedClients } : { groups: this.selectedClientGroups };
	      if (!groups) {
	        this.addingClients = true;
	      } else {
	        this.addingClientGroups = true;
	      }
	      _clientCampaign2.default.store(this.$route.params.id, data).then(function () {
	        _this9.fetchClients(_this9.clients.pagination.currentPage);
	        _this9.addingClients = false;
	        _this9.addingClientGroups = false;
	        _this9.selectedClients = [];
	        _this9.selectedClientGroups = [];
	      }).catch(function (errors) {
	        _this9.addingClients = false;
	        _this9.addingClientGroups = false;
	        if (errors.clients) {
	          _this9.$message({
	            showClose: true,
	            message: errors.clients[0],
	            type: 'error'
	          });
	        } else if (errors.groups) {
	          _this9.$message({
	            showClose: true,
	            message: errors.groups[0],
	            type: 'error'
	          });
	        }
	      });
	    },
	    deleteEmail: function deleteEmail(email) {
	      var _this10 = this;
	
	      this.$confirm(this.$t('static.news.index.confirmDelete'), this.$t('static.news.index.confirmDeleteTitle'), {
	        confirmButtonText: this.$t('button.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _news2.default.destroy(email.id).then(function () {
	          return _this10.fetchEmails();
	        }).catch(function () {
	          var message = _this10.$t('static.news.index.deleteError');
	          _this10.$message({
	            showClose: true,
	            message: message,
	            type: 'error'
	          });
	        });
	      }).catch(function () {});
	    },
	    deleteClient: function deleteClient(client) {
	      var _this11 = this;
	
	      _clientCampaign2.default.destroy(this.$route.params.id, client.id).then(function () {
	        return _this11.fetchClients(_this11.clients.pagination.currentPage);
	      }).catch(function () {
	        var message = _this11.$t('static.campaigns.edit.removeClientError');
	        _this11.$message({
	          showClose: true,
	          message: message,
	          type: 'error'
	        });
	      });
	    },
	    activate: function activate(name) {
	      this.activeName = name;
	    },
	    onChange: function onChange(name, value) {
	      this[name] = value;
	    },
	    sentStatusTracking: function sentStatusTracking(e) {
	      this.setModalContent(function () {
	        return _emailSendTracking2.default;
	      });
	      this.setModalProps({
	        emailId: parseInt(e.id),
	        emailSendTracking: e.emailSendTracking,
	        emailSubject: e.subject,
	        emailSuccesCount: e.sentSuccess,
	        emailFailedCount: e.sentFailed,
	        emailSendReport: this.sendReport
	      });
	      this.toggleModal(true);
	    },
	    sendReport: function sendReport(data) {
	      return _news2.default.sendReport(data).then(function () {});
	    },
	    showEmailTracking: function showEmailTracking() {
	      var start = new Date();
	      var end = new Date();
	      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
	      this.emailTracking.selectRange = [start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate(), end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate()];
	    },
	    onSelectDayOrRange: function onSelectDayOrRange(value) {
	      this.emailTracking.selectedDayOrRangeText = value.label;
	      if (value.value === 'date_range') {
	        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.opened');
	        this.emailTracking.selectDayOrRangeVisble = true;
	      } else {
	        this.emailTracking.selectDayOrRangeVisble = false;
	      }
	      this.reQueryEmailTracking();
	    },
	    getDatesFromTwoDates: function getDatesFromTwoDates(startDateVal, stopDateVal) {
	      var dateArray = [];
	      var currentDate = (0, _moment2.default)(startDateVal);
	      var stopDate = (0, _moment2.default)(stopDateVal);
	      while (currentDate <= stopDate) {
	        dateArray.push((0, _moment2.default)(currentDate.toString()).format('MMM Do YYYY'));
	        currentDate = (0, _moment2.default)(currentDate).add(1, 'days');
	      }
	      this.emailTracking.datesFromTwoDates = dateArray;
	    },
	    onChangeDate: function onChangeDate(value) {
	      this.getDatesFromTwoDates(new Date(value[0]), new Date(value[1]));
	      this.reQueryEmailTracking();
	    },
	    showChartOf: function showChartOf(type) {
	      this.emailTracking.countType = type;
	      this.clearActiveIcon();
	      this.updateLineChart();
	    },
	    updateLineChart: function updateLineChart() {
	      if (this.emailTracking.countType === 'opened') {
	        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.opened');
	        this.emailTracking.iconActive.opened = 'active-icon';
	        this.lineChartReInitialize(this.emailTracking.countDataSet.opened);
	      } else if (this.emailTracking.countType === 'delivered') {
	        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.delivered');
	        this.emailTracking.iconActive.delivered = 'active-icon';
	        this.lineChartReInitialize(this.emailTracking.countDataSet.delivered);
	      } else if (this.emailTracking.countType === 'clicked') {
	        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.clicked');
	        this.emailTracking.iconActive.clicked = 'active-icon';
	        this.lineChartReInitialize(this.emailTracking.countDataSet.clicked);
	      } else if (this.emailTracking.countType === 'dropped') {
	        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.dropped');
	        this.emailTracking.iconActive.dropped = 'active-icon';
	        this.lineChartReInitialize(this.emailTracking.countDataSet.dropped);
	      } else if (this.emailTracking.countType === 'bounced') {
	        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.bounced');
	        this.emailTracking.iconActive.bounced = 'active-icon';
	        this.lineChartReInitialize(this.emailTracking.countDataSet.bounced);
	      } else if (this.emailTracking.countType === 'complained') {
	        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.complained');
	        this.emailTracking.iconActive.complained = 'active-icon';
	        this.lineChartReInitialize(this.emailTracking.countDataSet.complained);
	      } else if (this.emailTracking.countType === 'failed') {
	        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.failed');
	        this.emailTracking.iconActive.failed = 'active-icon';
	        this.lineChartReInitialize(this.emailTracking.countDataSet.failed);
	      } else if (this.emailTracking.countType === 'unsubscribed') {
	        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.unsubscribed');
	        this.emailTracking.iconActive.unsubscribed = 'active-icon';
	        this.lineChartReInitialize(this.emailTracking.countDataSet.unsubscribed);
	      }
	    },
	    lineChartReInitialize: function lineChartReInitialize(dataSet) {
	      this.emailTracking.lineChart.chartData = {
	        labels: this.emailTracking.datesFromTwoDates,
	        datasets: [{
	          label: this.emailTracking.lineChartLabel,
	          backgroundColor: '#1bbc9b',
	          data: dataSet
	        }]
	      };
	    },
	    clearActiveIcon: function clearActiveIcon() {
	      this.emailTracking.iconActive = {
	        opened: '',
	        delivered: '',
	        clicked: '',
	        dropped: '',
	        bounced: '',
	        complained: '',
	        failed: '',
	        unsubscribed: ''
	      };
	    },
	    clearCountIcon: function clearCountIcon() {
	      this.emailTracking.iconCountData = {
	        opened: 0,
	        delivered: 0,
	        clicked: 0,
	        dropped: 0,
	        bounced: 0,
	        complained: 0,
	        failed: 0,
	        unsubscribed: 0
	      };
	    },
	    clearCountDataSet: function clearCountDataSet() {
	      this.emailTracking.countDataSet = {
	        opened: [],
	        delivered: [],
	        clicked: [],
	        dropped: [],
	        bounced: [],
	        complained: [],
	        failed: [],
	        unsubscribed: []
	      };
	    },
	    onSelectEmailSubject: function onSelectEmailSubject(newsId) {
	      this.emailTracking.selectNewsId = newsId;
	      this.reQueryEmailTracking();
	    },
	    reQueryEmailTracking: function reQueryEmailTracking() {
	      var _this12 = this;
	
	      this.clearCountIcon();
	      this.clearCountDataSet();
	      this.emailTracking.datesFromTwoDates = [];
	      this.emailTracking.emailTrackingRecipients = [];
	      _news2.default.newsEmailTrackings(this.emailTracking.selectNewsId, this.emailTracking.selectDayOrRange.value, this.emailTracking.selectRange).then(function (data) {
	        _this12.emailTracking.loaded = true;
	        _this12.emailTracking.emailTrackingRecipients = data.email_tracking_recipients;
	
	        if (_this12.emailTracking.selectDayOrRange.value === 'today') {
	          _this12.loopingIconCount(data);
	        } else if (_this12.emailTracking.selectDayOrRange.value === 'all') {
	            _this12.emailTracking.dateRangDisplay = (0, _moment2.default)(data[data.length - 2]).format('MMM Do YYYY') + ' - ' + (0, _moment2.default)(data[data.length - 1]).format('MMM Do YYYY');
	            _this12.loopingIconCount(data);
	          } else if (_this12.emailTracking.selectDayOrRange.value === 'date_range') {
	              _this12.emailTracking.dateRangDisplay = (0, _moment2.default)(_this12.emailTracking.selectRange[0]).format('MMM Do YYYY') + ' - ' + (0, _moment2.default)(_this12.emailTracking.selectRange[1]).format('MMM Do YYYY');
	              _this12.updateLineChart();
	              _this12.loopingIconCount(data);
	            }
	        _this12.updateLineChart();
	        _this12.emailTracking.loaded = false;
	      });
	    },
	    loopingIconCount: function loopingIconCount(dataFrom) {
	      var data = dataFrom.email_tracking_recipients;
	      var self = this;
	
	      data.forEach(function (item2) {
	        var eventTimestamp = (0, _moment2.default)(item2.event_timestamp).format('MMM Do YYYY');
	        self.emailTracking.datesFromTwoDates.push(eventTimestamp);
	
	        if (item2.email_event_type.name === 'Opened') {
	          self.isExistAdd(self.emailTracking.countDataSet.opened, eventTimestamp, item2.count);
	        }
	
	        if (item2.email_event_type.name === 'Delivered') {
	          self.isExistAdd(self.emailTracking.countDataSet.delivered, eventTimestamp, item2.count);
	        }
	
	        if (item2.email_event_type.name === 'Clicked') {
	          self.isExistAdd(self.emailTracking.countDataSet.clicked, eventTimestamp, item2.count);
	        }
	
	        if (item2.email_event_type.name === 'Dropped') {
	          self.isExistAdd(self.emailTracking.countDataSet.dropped, eventTimestamp, item2.count);
	        }
	
	        if (item2.email_event_type.name === 'Bounced') {
	          self.isExistAdd(self.emailTracking.countDataSet.bounced, eventTimestamp, item2.count);
	        }
	
	        if (item2.email_event_type.name === 'Complained') {
	          self.isExistAdd(self.emailTracking.countDataSet.complained, eventTimestamp, item2.count);
	        }
	
	        if (item2.email_event_type.name === 'Failed') {
	          self.isExistAdd(self.emailTracking.countDataSet.failed, eventTimestamp, item2.count);
	        }
	
	        if (item2.email_event_type.name === 'Unsubscribed') {
	          self.isExistAdd(self.emailTracking.countDataSet.unsubscribed, eventTimestamp, item2.count);
	        }
	
	        self.emailTracking.iconCountData.opened += item2.email_event_type.name === 'Opened' ? parseInt(item2.count) : 0;
	        self.emailTracking.iconCountData.delivered += item2.email_event_type.name === 'Delivered' ? parseInt(item2.count) : 0;
	        self.emailTracking.iconCountData.clicked += item2.email_event_type.name === 'Clicked' ? parseInt(item2.count) : 0;
	        self.emailTracking.iconCountData.dropped += item2.email_event_type.name === 'Dropped' ? parseInt(item2.count) : 0;
	        self.emailTracking.iconCountData.bounced += item2.email_event_type.name === 'Bounced' ? parseInt(item2.count) : 0;
	        self.emailTracking.iconCountData.complained += item2.email_event_type.name === 'Complained' ? parseInt(item2.count) : 0;
	        self.emailTracking.iconCountData.failed += item2.email_event_type.name === 'Failed' ? parseInt(item2.count) : 0;
	        self.emailTracking.iconCountData.unsubscribed += item2.email_event_type.name === 'Unsubscribed' ? parseInt(item2.count) : 0;
	      });
	
	      this.emailTracking.datesFromTwoDates = [].concat(_toConsumableArray(new Set(this.emailTracking.datesFromTwoDates)));
	      this.emailTracking.countDataSet.opened = this.emailTracking.countDataSet.opened.reverse();
	      this.emailTracking.countDataSet.clicked = this.emailTracking.countDataSet.clicked.reverse();
	      this.emailTracking.countDataSet.dropped = this.emailTracking.countDataSet.dropped.reverse();
	      this.emailTracking.countDataSet.bounced = this.emailTracking.countDataSet.bounced.reverse();
	      this.emailTracking.countDataSet.complained = this.emailTracking.countDataSet.complained.reverse();
	      this.emailTracking.countDataSet.failed = this.emailTracking.countDataSet.failed.reverse();
	      this.emailTracking.countDataSet.unsubscribed = this.emailTracking.countDataSet.unsubscribed.reverse();
	    },
	    isExistAdd: function isExistAdd(data, timestamp, count) {
	      var isExist = data.filter(function (element) {
	        return element.t === timestamp;
	      });
	
	      if (isExist.length < 1) data.push({ t: timestamp, y: count });else data[0].y = parseInt(data[0].y) + parseInt(count);
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9),
	    VSelect: __webpack_require__(51),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19),
	    LineChart: _line2.default
	  }
	};

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _campaign = __webpack_require__(185);
	
	var _campaign2 = _interopRequireDefault(_campaign);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _date = __webpack_require__(107);
	
	var _date2 = _interopRequireDefault(_date);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    campaigns: 'paginatedCampaigns'
	  })),
	
	  mounted: function mounted() {
	    this.setInnerSidebar([{
	      title: this.$t('layouts.sidebar.newsletter'),
	      options: [{
	        title: this.$t('layouts.sidebar.all'),
	        route: {
	          name: 'campaigns.index'
	        }
	      }],
	      button: {
	        title: this.$t('button.addCampaign'),
	        route: {
	          name: 'campaigns.create'
	        }
	      }
	    }, {
	      title: this.$t('layouts.sidebar.subscriberList'),
	      options: [{
	        title: this.$t('layouts.sidebar.all'),
	        route: {
	          name: 'subscriberList.index'
	        }
	      }],
	      button: {
	        title: this.$t('button.addSubscriberList'),
	        route: {
	          name: 'subscriberList.create'
	        }
	      }
	    }]);
	    this.all(1, 15);
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    all: function all(page, limit) {
	      var _this = this;
	
	      this.loading = true;
	      _campaign2.default.items(page, limit).then(function () {
	        _this.loading = false;
	      }).catch(function () {
	        _this.loading = false;
	      });
	    },
	    deleteCampaign: function deleteCampaign(campaign) {
	      var _this2 = this;
	
	      this.$confirm(this.$t('static.campaigns.index.confirmDelete'), this.$t('static.campaigns.index.confirmDeleteTitle'), {
	        confirmButtonText: this.$t('button.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _campaign2.default.destroy(campaign.id).catch(function (_ref) {
	          var response = _ref.response;
	
	          var message = response.data.error.code === 40114 ? _this2.$t('static.campaigns.index.deleteHasClientsError') : _this2.$t('static.campaigns.index.deleteError');
	          _this2.$message({
	            showClose: true,
	            message: message,
	            type: 'error'
	          });
	        });
	      }).catch(function () {});
	    },
	    edit: function edit(campaign) {
	      this.$router.push({
	        name: 'campaigns.edit',
	        params: { id: campaign.id }
	      });
	    }
	  }),
	
	  mixins: [_search2.default, _date2.default],
	
	  components: {
	    VPagination: __webpack_require__(16),
	    VSelect: __webpack_require__(51),
	    VCard: __webpack_require__(21),
	    VNoData: __webpack_require__(19)
	  }
	};

/***/ }),
/* 1892 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _clientGroup = __webpack_require__(93);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	var _clientGroup3 = __webpack_require__(129);
	
	var _clientGroup4 = _interopRequireDefault(_clientGroup3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _priceField = __webpack_require__(95);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	var _chartOfAccounts2 = __webpack_require__(186);
	
	var _chartOfAccounts3 = _interopRequireDefault(_chartOfAccounts2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text',
	          label: this.$t('form.clientGroups.name.label')
	        },
	        description: {
	          value: '',
	          type: 'textarea',
	          label: this.$t('form.clientGroups.description.label')
	        },
	        priceFieldId: {
	          value: '',
	          type: 'select'
	        },
	        receivables_account_id: {
	          value: '',
	          type: 'select'
	        }
	      })
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.loading = true;
	    Promise.all([_priceField2.default.all(1), _chartOfAccounts3.default.all()]).then(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    priceFields: 'allPriceFields',
	    chartOfAccounts: 'allChartOfAccounts'
	  }), {
	    isInOwnRoute: function isInOwnRoute() {
	      return this.$route.name === 'clientGroups.create';
	    }
	  }),
	
	  methods: {
	    store: function store() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var clientGroup = _clientGroup4.default.send(this.form.data());
	      _clientGroup2.default.store(clientGroup).then(function () {
	        _this2.form.loading = false;
	        if (_this2.isInOwnRoute) {
	          _this2.$message({
	            message: _this2.$t('static.clientGroups.create.success'),
	            type: 'success'
	          });
	          _this2.$router.push({
	            name: 'clientGroups.index'
	          });
	        } else {
	          _this2.$emit('close');
	          _clientGroup2.default.all();
	        }
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    }
	  },
	
	  watch: {
	    priceFields: function priceFields(_priceFields) {
	      var options = _priceFields.all.map(function (type) {
	        return {
	          id: type.id,
	          name: type.name
	        };
	      });
	      options.splice(0, 0, { id: '', name: '' });
	      this.form.setOptions('priceFieldId', options);
	    },
	    chartOfAccounts: function chartOfAccounts(_chartOfAccounts) {
	      if (_chartOfAccounts && _chartOfAccounts.all && _chartOfAccounts.all.length > 0) {
	        var options = _chartOfAccounts.all.map(function (account) {
	          return {
	            id: account.id,
	            name: account.code + ' - ' + account.name
	          };
	        });
	        options.splice(0, 0, { id: '', name: '' });
	        this.form.setOptions('receivables_account_id', options);
	      }
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _clientGroup = __webpack_require__(93);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	var _priceField = __webpack_require__(95);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	var _chartOfAccounts2 = __webpack_require__(186);
	
	var _chartOfAccounts3 = _interopRequireDefault(_chartOfAccounts2);
	
	var _clientGroup3 = __webpack_require__(129);
	
	var _clientGroup4 = _interopRequireDefault(_clientGroup3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text',
	          label: this.$t('form.clientGroups.name.label')
	        },
	        description: {
	          value: '',
	          type: 'textarea',
	          label: this.$t('form.clientGroups.description.label')
	        },
	        priceFieldId: {
	          value: '',
	          type: 'select'
	        },
	        receivables_account_id: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      loading: false,
	      fetchedClientGroup: {}
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    priceFields: 'allPriceFields',
	    chartOfAccounts: 'allChartOfAccounts'
	  })),
	
	  created: function created() {
	    this.show();
	  },
	
	
	  methods: {
	    update: function update() {
	      var _this = this;
	
	      this.form.loading = true;
	      var clientGroup = _clientGroup4.default.send(this.form.data());
	      _clientGroup2.default.update(_store2.default.state.route.params.id, clientGroup).then(function () {
	        _this.$message({
	          message: _this.$t('static.clientGroups.edit.success'),
	          type: 'success'
	        });
	        _this.$router.push({
	          name: 'clientGroups.index'
	        });
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      var _this2 = this;
	
	      this.loading = true;
	      Promise.all([_clientGroup2.default.show(_store2.default.state.route.params.id), _priceField2.default.all(1), _chartOfAccounts3.default.all()]).then(function (data) {
	        _this2.fetchedClientGroup = data[0];
	        _this2.form.assignData(data[0]);
	        _this2.loading = false;
	      });
	    }
	  },
	
	  watch: {
	    priceFields: function priceFields(_priceFields) {
	      var options = _priceFields.all.map(function (type) {
	        return {
	          id: type.id,
	          name: type.name
	        };
	      });
	      options.splice(0, 0, { id: '', name: '' });
	      this.form.setOptions('priceFieldId', options);
	    },
	    chartOfAccounts: function chartOfAccounts(_chartOfAccounts) {
	      if (_chartOfAccounts && _chartOfAccounts.all && _chartOfAccounts.all.length > 0) {
	        var options = _chartOfAccounts.all.map(function (account) {
	          return {
	            id: account.id,
	            name: account.code + ' - ' + account.name
	          };
	        });
	        options.splice(0, 0, { id: '', name: '' });
	        this.form.setOptions('receivables_account_id', options);
	        if (this.fetchedClientGroup && this.fetchedClientGroup.receivables_account_id) {
	          this.form.setFieldValue('receivables_account_id', this.fetchedClientGroup.receivables_account_id);
	        }
	      }
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _clientGroup = __webpack_require__(93);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false,
	      sort: 'clients_count|desc',
	      sortTypes: [{
	        id: 'clients_count|desc',
	        name: this.$t('sort.clientsCountDesc')
	      }, {
	        id: 'clients_count|asc',
	        name: this.$t('sort.clientsCountAsc')
	      }, {
	        id: 'client_groups.name|asc',
	        name: this.$t('sort.name') + ' (A -> Z)'
	      }, {
	        id: 'client_groups.name|desc',
	        name: this.$t('sort.name') + ' (Z -> A)'
	      }],
	      limit: 25
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    clientGroups: 'paginatedClientGroups'
	  })),
	
	  watch: {
	    $route: function $route() {
	      this.all(1, this.limit);
	    }
	  },
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VSelect: __webpack_require__(51),
	    VNoData: __webpack_require__(19)
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.setInnerSidebar([{
	      title: this.$t('layouts.sidebar.clients'),
	      options: [{
	        title: this.$t('layouts.sidebar.active'),
	        route: {
	          name: 'clients.index',
	          query: {
	            filter: 'active'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.inActive'),
	        route: {
	          name: 'clients.index',
	          query: {
	            filter: 'inActive'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.orderedPastWeek'),
	        route: {
	          name: 'clients.index',
	          query: {
	            filter: 'orderedPastWeek'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.orderedPastMonth'),
	        route: {
	          name: 'clients.index',
	          query: {
	            filter: 'orderedPastMonth'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.neverOrdered'),
	        route: {
	          name: 'clients.index',
	          query: {
	            filter: 'neverOrdered'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.storeSynced'),
	        route: {
	          name: 'clients.index',
	          query: {
	            filter: 'storeSynced'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.all'),
	        route: {
	          name: 'clients.index'
	        }
	      }],
	      button: {
	        title: this.$t('button.addClient'),
	        route: {
	          name: 'clients.create'
	        }
	      }
	    }, {
	      title: this.$t('layouts.sidebar.clientGroup'),
	      options: [{
	        title: this.$t('layouts.sidebar.latest'),
	        route: {
	          name: 'clientGroups.index',
	          query: {
	            filter: 'latest'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.pastMonth'),
	        route: {
	          name: 'clientGroups.index',
	          query: {
	            filter: 'pastMonth'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.all'),
	        route: {
	          name: 'clientGroups.index'
	        }
	      }],
	      button: {
	        title: this.$t('button.addClientGroup'),
	        route: {
	          name: 'clientGroups.create'
	        }
	      }
	    }, {
	      title: this.$t('layouts.sidebar.clientAgreements'),
	      options: [{ title: this.$t('layouts.sidebar.all'), route: { name: 'pricingAgreements.index' } }, { title: this.$t('layouts.sidebar.importAgreement'), route: { name: 'pricingAgreements.index', query: { import: '1' } } }],
	      button: {
	        title: this.$t('layouts.sidebar.newAgreement'),
	        route: { name: 'pricingAgreements.create' }
	      }
	    }]);
	
	    _account2.default.rememberPerPage('get', { from: 'client_group' }).then(function (data) {
	      _this.limit = data.size;
	      _this.all(1, _this.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'client_group', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    all: function all(page, limit) {
	      var _this3 = this;
	
	      this.loading = true;
	      _clientGroup2.default.items({
	        page: page,
	        limit: limit,
	        sort: this.sort,
	        search: this.getSearch(this.limit),
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this3.loading = false;
	      }).catch(function () {
	        _this3.loading = false;
	      });
	    },
	    deleteClientGroup: function deleteClientGroup(clientGroup) {
	      var _this4 = this;
	
	      this.$confirm(this.$t('static.clientGroups.index.confirmDelete'), this.$t('static.clientGroups.index.confirmDeleteTitle'), {
	        confirmButtonText: this.$t('button.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _clientGroup2.default.destroy(clientGroup.id).catch(function (_ref) {
	          var response = _ref.response;
	
	          var message = response.data.error.code === 40114 ? _this4.$t('static.clientGroups.index.deleteHasClientsError') : _this4.$t('static.clientGroups.index.deleteError');
	          _this4.$message({
	            showClose: true,
	            message: message,
	            type: 'error'
	          });
	        });
	      }).catch(function () {});
	    },
	    editClientGroup: function editClientGroup(clientGroup) {
	      this.$router.push({
	        name: 'clientGroups.edit',
	        params: { id: clientGroup.id }
	      });
	    },
	    goToClients: function goToClients(id, e) {
	      e.stopPropagation();
	      this.$router.push({ name: 'clients.index', query: { filter: 'clientGroup,' + id } });
	    }
	  }),
	
	  mixins: [_search2.default]
	
	};

/***/ }),
/* 1896 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _create = __webpack_require__(776);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _clientGroup = __webpack_require__(93);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _clientType = __webpack_require__(294);
	
	var _clientType2 = _interopRequireDefault(_clientType);
	
	var _priceField = __webpack_require__(95);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	var _project = __webpack_require__(190);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _client3 = __webpack_require__(56);
	
	var _client4 = _interopRequireDefault(_client3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _stringFormat = __webpack_require__(108);
	
	var _stringFormat2 = _interopRequireDefault(_stringFormat);
	
	var _actionButtonsPopup = __webpack_require__(2666);
	
	var _actionButtonsPopup2 = _interopRequireDefault(_actionButtonsPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        clientGroupId: {
	          value: '',
	          type: 'select'
	        },
	        isProducer: {
	          value: 0,
	          type: 'switch'
	        },
	        isSupplier: {
	          value: 0,
	          type: 'switch'
	        },
	        typeId: {
	          value: '',
	          type: 'select'
	        },
	        firstName: {
	          value: '',
	          type: 'text'
	        },
	        lastName: {
	          value: '',
	          type: 'text'
	        },
	        organizationNumber: {
	          type: 'text',
	          value: '',
	          attributes: {
	            hasButton: true,
	            buttonLabel: this.$t('static.clients.organizationNumber'),
	            buttonHandler: this.buttonHandler,
	            hasButton2: true,
	            buttonLabel2: this.$t('button.glnLookup'),
	            buttonHandler2: this.buttonHandler2
	          }
	        },
	        companyName: {
	          value: '',
	          type: 'text'
	        },
	        email: {
	          value: '',
	          type: 'email'
	        },
	        invoiceSendMethod: {
	          value: '',
	          type: 'select'
	        },
	        languageId: {
	          value: '',
	          type: 'select'
	        },
	        currencyId: {
	          value: '',
	          type: 'select'
	        },
	        projectId: {
	          value: '',
	          type: 'select'
	        },
	        externalCustomerNumber: {
	          value: '',
	          type: 'text'
	        },
	        orderReference: {
	          value: '',
	          type: 'text'
	        },
	        gln: {
	          value: '',
	          type: 'text',
	          attributes: {
	            disabled: true
	          }
	        },
	        glnXKoord: {
	          value: '',
	          type: 'text',
	          attributes: {
	            disabled: true
	          }
	        },
	        glnYKoord: {
	          value: '',
	          type: 'text',
	          attributes: {
	            disabled: true
	          }
	        },
	        billingType: {
	          value: '',
	          type: 'select'
	        },
	        automaticBilling: {
	          value: '',
	          type: 'select'
	        },
	        billingInterval: {
	          value: '',
	          type: 'select'
	        },
	        startBilling: {
	          value: '',
	          type: 'select'
	        },
	        priceFieldId: {
	          value: '',
	          type: 'select'
	        },
	        dueDays: {
	          value: 14,
	          type: 'number'
	        },
	        pricePercentageDiscount: {
	          value: '',
	          type: 'number'
	        },
	        picture: {
	          value: '',
	          type: 'file'
	        },
	        isSubClient: {
	          value: 0,
	          type: 'switch'
	        },
	        clientParent: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        billMainParent: {
	          value: 0,
	          type: 'checkbox'
	        }
	      }),
	      addressFormErrors: {
	        postal: null,
	        fields: []
	      },
	      contactFormErrors: {
	        primary: null
	      },
	      clientAddressNames: null,
	      loading: true,
	      tabIndex: 'first'
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    clientGroups: 'allClientGroups',
	    types: 'allClientTypes',
	    priceFields: 'allPriceFields',
	    currencies: 'currencies',
	    languages: 'languages',
	    allProjects: 'allProjects',
	    account: 'account',
	    organizationSettings: 'organizationSettings'
	  })),
	
	  watch: {
	
	    'formBasicInformation.email': function formBasicInformationEmail(value) {
	      this.formBasicInformation.email = value.replace(/\s+/g, '');
	    },
	
	    'formBasicInformation.isSubClient': function formBasicInformationIsSubClient(value) {
	      if (value == 1) {
	        this.formBasicInformation.showField('billMainParent');
	        this.formBasicInformation.showField('clientParent');
	      } else {
	        this.formBasicInformation.hideField('billMainParent');
	        this.formBasicInformation.hideField('clientParent');
	      }
	    },
	
	    'formBasicInformation.automaticBilling': function formBasicInformationAutomaticBilling(automaticBilling) {
	      if (automaticBilling !== 'none') {
	        var feedData = automaticBilling === 'weekly' ? [{ id: '1_week', name: this.$t('form.billingInterval.week.options.week1') }, { id: '2_week', name: this.$t('form.billingInterval.week.options.week2') }, { id: '3_week', name: this.$t('form.billingInterval.week.options.week3') }] : [{ id: '1_month', name: this.$t('form.billingInterval.month.options.month1') }, { id: '2_month', name: this.$t('form.billingInterval.month.options.month2') }, { id: '3_month', name: this.$t('form.billingInterval.month.options.month3') }, { id: '4_month', name: this.$t('form.billingInterval.month.options.month4') }, { id: '5_month', name: this.$t('form.billingInterval.month.options.month5') }, { id: '6_month', name: this.$t('form.billingInterval.month.options.month6') }];
	        this.formBasicInformation.setOptions('billingInterval', feedData);
	        this.formBasicInformation.setFieldValue('billingInterval', feedData[0].id);
	        this.formBasicInformation.showField('billingInterval');
	
	        feedData = automaticBilling === 'weekly' ? this.daysInWeek() : this.daysInMonth();
	        this.formBasicInformation.setOptions('startBilling', feedData);
	        this.formBasicInformation.setFieldValue('startBilling', feedData[0].id);
	        this.formBasicInformation.showField('startBilling');
	      } else {
	        this.formBasicInformation.hideField('billingInterval');
	        this.formBasicInformation.hideField('startBilling');
	      }
	    },
	
	    allProjects: function allProjects(_allProjects) {
	      var options = _allProjects.map(function (project) {
	        return {
	          id: project.id,
	          name: project.name
	        };
	      });
	      this.formBasicInformation.setOptions('projectId', [{ id: '', name: '' }].concat(_toConsumableArray(options)));
	    },
	    clientGroups: function clientGroups(_clientGroups) {
	      this.formBasicInformation.setOptions('clientGroupId', [{ id: '', name: '' }].concat(_toConsumableArray(_clientGroups.all)));
	    },
	    types: function types(_types) {
	      this.formBasicInformation.setOptions('typeId', _types.map(function (type) {
	        return {
	          id: type.id,
	          name: type.name
	        };
	      }));
	    },
	    priceFields: function priceFields(_priceFields) {
	      var options = _priceFields.all.map(function (type) {
	        return {
	          id: type.id,
	          name: type.name
	        };
	      });
	      options.splice(0, 0, { id: '', name: '' });
	      this.formBasicInformation.setOptions('priceFieldId', options);
	    },
	    languages: function languages(value) {
	      this.formBasicInformation.setOptions('languageId', value.all.map(function (item) {
	        return {
	          id: item.id,
	          name: item.name
	        };
	      }));
	    },
	    currencies: function currencies(value) {
	      this.formBasicInformation.setOptions('currencyId', value.all.map(function (item) {
	        return {
	          id: item.id,
	          name: item.name
	        };
	      }));
	    },
	
	    'formBasicInformation.typeId': function formBasicInformationTypeId(typeId) {
	      if (typeId.toString() === '1') {
	        this.formBasicInformation.hideField('companyName');
	        this.formBasicInformation.hideField('organizationNumber');
	        if (this.formBasicInformation.isHidden('firstName') && this.formBasicInformation.isHidden('firstName')) {
	          this.formBasicInformation.showField('firstName');
	          this.formBasicInformation.showField('lastName');
	        }
	      }
	
	      if (typeId.toString() !== '1') {
	        this.formBasicInformation.hideField('firstName');
	        this.formBasicInformation.hideField('lastName');
	
	        if (this.formBasicInformation.isHidden('companyName')) {
	          this.formBasicInformation.showField('companyName');
	          this.formBasicInformation.showField('organizationNumber');
	        }
	      }
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.loading = true;
	    this.formBasicInformation.setQuickForm('clientGroupId', _create2.default);
	    Promise.all([_clientGroup2.default.all(), _clientType2.default.all(), _priceField2.default.all(1), _account2.default.currencies(), _account2.default.languages(), _project2.default.all(), _organizationSettings2.default.show()]).then(function (results) {
	      var settings = results[6];
	      var defaultDueDays = settings && settings.defaultDueDays != null ? Number(settings.defaultDueDays) : 14;
	      _this.formBasicInformation.setFieldValue('dueDays', defaultDueDays);
	      _this.loading = false;
	      _this.checkProjectModule();
	    });
	
	    this.formBasicInformation.setOptions('invoiceSendMethod', [{ id: 'EHF', name: 'EHF' }, { id: 'EMAIL', name: 'Email' }]);
	
	    this.formBasicInformation.setOptions('billingType', [{ id: 'single', name: this.$t('form.billingTypes.options.single') }, { id: 'consolidate', name: this.$t('form.billingTypes.options.consolidate') }]);
	    this.formBasicInformation.setFieldValue('billingType', 'single');
	
	    this.formBasicInformation.setOptions('automaticBilling', [{ id: 'none', name: this.$t('form.automaticBilling.options.none') }, { id: 'weekly', name: this.$t('form.automaticBilling.options.weekly') }, { id: 'monthly', name: this.$t('form.automaticBilling.options.monthly') }]);
	    this.formBasicInformation.setFieldValue('automaticBilling', 'none');
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalProps: 'SET_MODAL_PROPS'
	  }), {
	    checkProjectModule: function checkProjectModule() {
	      this.formBasicInformation.hideField('projectId');
	      var hasProject = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name === 'Project') {
	            hasProject = true;
	          }
	        }
	      }
	      if (hasProject) {
	        this.formBasicInformation.showField('projectId');
	      }
	    },
	    daysInWeek: function daysInWeek() {
	      return [{ id: 'monday', name: this.$t('form.startBilling.week.options.monday') }, { id: 'tuesday', name: this.$t('form.startBilling.week.options.tuesday') }, { id: 'wednesday', name: this.$t('form.startBilling.week.options.wednesday') }, { id: 'thursday', name: this.$t('form.startBilling.week.options.thursday') }, { id: 'friday', name: this.$t('form.startBilling.week.options.friday') }, { id: 'saturday', name: this.$t('form.startBilling.week.options.saturday') }, { id: 'sunday', name: this.$t('form.startBilling.week.options.sunday') }];
	    },
	    daysInMonth: function daysInMonth() {
	      return [{ id: '1', name: '1st ' + this.$t('form.startBilling.month.options.day') }, { id: '2', name: '2nd ' + this.$t('form.startBilling.month.options.day') }, { id: '3', name: '3rd ' + this.$t('form.startBilling.month.options.day') }, { id: '4', name: '4th ' + this.$t('form.startBilling.month.options.day') }, { id: '5', name: '5th ' + this.$t('form.startBilling.month.options.day') }, { id: '6', name: '6th ' + this.$t('form.startBilling.month.options.day') }, { id: '7', name: '7th ' + this.$t('form.startBilling.month.options.day') }, { id: '8', name: '8th ' + this.$t('form.startBilling.month.options.day') }, { id: '9', name: '9th ' + this.$t('form.startBilling.month.options.day') }, { id: '10', name: '10th ' + this.$t('form.startBilling.month.options.day') }, { id: '11', name: '11th ' + this.$t('form.startBilling.month.options.day') }, { id: '12', name: '12th ' + this.$t('form.startBilling.month.options.day') }, { id: '13', name: '13th ' + this.$t('form.startBilling.month.options.day') }, { id: '14', name: '14th ' + this.$t('form.startBilling.month.options.day') }, { id: '15', name: '15th ' + this.$t('form.startBilling.month.options.day') }, { id: '16', name: '16th ' + this.$t('form.startBilling.month.options.day') }, { id: '17', name: '17th ' + this.$t('form.startBilling.month.options.day') }, { id: '18', name: '18th ' + this.$t('form.startBilling.month.options.day') }, { id: '19', name: '19th ' + this.$t('form.startBilling.month.options.day') }, { id: '20', name: '20th ' + this.$t('form.startBilling.month.options.day') }, { id: '21', name: '21st ' + this.$t('form.startBilling.month.options.day') }, { id: '22', name: '22nd ' + this.$t('form.startBilling.month.options.day') }, { id: '23', name: '23rd ' + this.$t('form.startBilling.month.options.day') }, { id: '24', name: '24th ' + this.$t('form.startBilling.month.options.day') }, { id: '25', name: '25th ' + this.$t('form.startBilling.month.options.day') }, { id: '26', name: '26th ' + this.$t('form.startBilling.month.options.day') }, { id: '27', name: '27th ' + this.$t('form.startBilling.month.options.day') }, { id: '28', name: '28th ' + this.$t('form.startBilling.month.options.day') }];
	    },
	    store: function store() {
	      var _this2 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var formData = new FormData();
	      var client = _client4.default.send(this.formBasicInformation.data());
	      Object.keys(client).map(function (k) {
	        formData.append(k, client[k]);
	        return null;
	      });
	      _client2.default.store(formData).then(function (data) {
	        _this2.clientAddressesTabError = null;
	        _this2.showOptionsModal(data);
	        _this2.formBasicInformation.loading = false;
	      }).catch(function (errors) {
	        var formErrors = _client4.default.fetch(errors);
	        _this2.formBasicInformation.loading = false;
	        _this2.formBasicInformation.recordErrors(formErrors);
	        if (_this2.formBasicInformation.errors.any()) {
	          _this2.tabIndex = 'first';
	        }
	      });
	    },
	    showOptionsModal: function showOptionsModal(data) {
	      var _this3 = this;
	
	      this.setModalContent(function () {
	        return _actionButtonsPopup2.default;
	      });
	      this.setModalSize('full');
	      this.toggleModal(true);
	      this.setModalProps({
	        alert: {
	          title: this.$t('static.clients.create.success'),
	          type: 'success'
	        },
	        buttons: [{
	          name: 'create',
	          text: this.$t('static.clients.create.addMore'),
	          action: function action() {
	            return _this3.goTo('create');
	          }
	        }, {
	          name: 'edit',
	          text: this.$t('static.clients.create.gotoEdit'),
	          action: function action() {
	            return _this3.goTo('edit', data);
	          }
	        }, {
	          name: 'index',
	          text: this.$t('static.clients.create.gotoIndex'),
	          action: function action() {
	            return _this3.goTo('index');
	          }
	        }]
	      });
	    },
	    goTo: function goTo(page, data) {
	      this.toggleModal(false);
	      if (page === 'create') {
	        this.formBasicInformation.showField('companyName');
	        this.formBasicInformation.showField('organizationNumber');
	        this.formBasicInformation.showField('firstName');
	        this.formBasicInformation.showField('lastName');
	        this.formBasicInformation.resetValues();
	      } else if (page === 'edit') {
	        this.$router.push({
	          name: 'clients.edit',
	          params: { id: data.id }
	        });
	      } else {
	        this.$router.push({
	          name: 'clients.index'
	        });
	      }
	    },
	    buttonHandler: function buttonHandler() {
	      var _this4 = this;
	
	      this.formBasicInformation.loading = true;
	      var organizationNumber = this.formBasicInformation.organizationNumber;
	      this.formBasicInformation.disableField('organizationNumber');
	
	      _client2.default.findBusiness(organizationNumber).then(function (data) {
	        _this4.formBasicInformation.loading = false;
	        _this4.formBasicInformation.enableField('organizationNumber');
	        _this4.formBasicInformation.companyName = data.name;
	      }).catch(function () {
	        _this4.$message({
	          message: _this4.$t('static.clients.create.brrig.warning'),
	          type: 'error'
	        });
	        _this4.formBasicInformation.enableField('organizationNumber');
	        _this4.formBasicInformation.loading = false;
	      });
	    },
	    buttonHandler2: function buttonHandler2() {
	      var _this5 = this;
	
	      var organizationNumber = this.formBasicInformation.organizationNumber;
	      this.formBasicInformation.loading = true;
	      this.formBasicInformation.disableField('organizationNumber');
	      _client2.default.glnLookup(organizationNumber).then(function (res) {
	        _this5.formBasicInformation.setFieldValue('gln', res.gln);
	        _this5.formBasicInformation.setFieldValue('glnXKoord', res.xKoord);
	        _this5.formBasicInformation.setFieldValue('glnYKoord', res.yKoord);
	        _this5.formBasicInformation.enableField('organizationNumber');
	        _this5.formBasicInformation.loading = false;
	      }).catch(function (error) {
	        console.log(error);
	        _this5.formBasicInformation.enableField('organizationNumber');
	        _this5.formBasicInformation.loading = false;
	      });
	    },
	    searchMethod: function searchMethod(search, field) {
	      return Promise.all([_client2.default.all(search)]);
	    }
	  }),
	
	  mounted: function mounted() {
	    this.formBasicInformation.setFieldValue('isSubClient', 0);
	    this.formBasicInformation.hideField('billMainParent');
	    this.formBasicInformation.hideField('clientParent');
	  },
	
	
	  components: {
	    VForm: __webpack_require__(9),
	    VClientAddress: __webpack_require__(409),
	    VClientContact: __webpack_require__(767)
	  },
	
	  mixins: [_stringFormat2.default]
	};

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _clientGroup = __webpack_require__(93);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	var _client3 = __webpack_require__(56);
	
	var _client4 = _interopRequireDefault(_client3);
	
	var _clientType = __webpack_require__(294);
	
	var _clientType2 = _interopRequireDefault(_clientType);
	
	var _priceField = __webpack_require__(95);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	var _chartOfAccounts2 = __webpack_require__(186);
	
	var _chartOfAccounts3 = _interopRequireDefault(_chartOfAccounts2);
	
	var _addressType = __webpack_require__(442);
	
	var _addressType2 = _interopRequireDefault(_addressType);
	
	var _address = __webpack_require__(194);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _contact = __webpack_require__(240);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _country = __webpack_require__(66);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _municipality = __webpack_require__(462);
	
	var _municipality2 = _interopRequireDefault(_municipality);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _stringFormat = __webpack_require__(108);
	
	var _stringFormat2 = _interopRequireDefault(_stringFormat);
	
	var _clientAddressBrreg = __webpack_require__(2688);
	
	var _clientAddressBrreg2 = _interopRequireDefault(_clientAddressBrreg);
	
	var _sendCatalogue2 = __webpack_require__(2736);
	
	var _sendCatalogue3 = _interopRequireDefault(_sendCatalogue2);
	
	var _siteLanguages = __webpack_require__(481);
	
	var _siteLanguages2 = _interopRequireDefault(_siteLanguages);
	
	var _marketplaceCustomer = __webpack_require__(1066);
	
	var _marketplaceCustomer2 = _interopRequireDefault(_marketplaceCustomer);
	
	var _license = __webpack_require__(459);
	
	var _license2 = _interopRequireDefault(_license);
	
	var _project = __webpack_require__(190);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _addLicense2 = __webpack_require__(2670);
	
	var _addLicense3 = _interopRequireDefault(_addLicense2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        clientGroupId: {
	          value: '',
	          type: 'select'
	        },
	        typeId: {
	          value: '',
	          type: 'select'
	        },
	        firstName: {
	          value: '',
	          type: 'text'
	        },
	        lastName: {
	          value: '',
	          type: 'text'
	        },
	        organizationNumber: {
	          type: 'text',
	          value: '',
	          attributes: {
	            hasButton: true,
	            buttonLabel: this.$t('static.clients.organizationNumber'),
	            buttonHandler: this.buttonHandler,
	            hasButton2: true,
	            buttonLabel2: this.$t('button.glnLookup'),
	            buttonHandler2: this.buttonHandler2
	          }
	        },
	        companyName: {
	          value: '',
	          type: 'text'
	        },
	        email: {
	          value: '',
	          type: 'email'
	        },
	        invoiceSendMethod: {
	          value: '',
	          type: 'select'
	        },
	        languageId: {
	          value: '',
	          type: 'select'
	        },
	        currencyId: {
	          value: '',
	          type: 'select'
	        },
	        projectId: {
	          value: '',
	          type: 'select'
	        },
	        externalCustomerNumber: {
	          value: '',
	          type: 'text'
	        },
	        orderReference: {
	          value: '',
	          type: 'text'
	        },
	        orderNote: {
	          value: '',
	          type: 'textarea'
	        },
	        gln: {
	          value: '',
	          type: 'text',
	          attributes: {
	            disabled: true
	          }
	        },
	        glnXKoord: {
	          value: '',
	          type: 'text',
	          attributes: {
	            disabled: true
	          }
	        },
	        glnYKoord: {
	          value: '',
	          type: 'text',
	          attributes: {
	            disabled: true
	          }
	        },
	        billingType: {
	          value: '',
	          type: 'select'
	        },
	        automaticBilling: {
	          value: '',
	          type: 'select'
	        },
	        billingInterval: {
	          value: '',
	          type: 'select'
	        },
	        startBilling: {
	          value: '',
	          type: 'select'
	        },
	        priceFieldId: {
	          value: '',
	          type: 'select'
	        },
	        receivables_account_id: {
	          value: '',
	          type: 'select'
	        },
	        dueDays: {
	          value: 14,
	          type: 'number'
	        },
	        pricePercentageDiscount: {
	          value: '',
	          type: 'number'
	        },
	        isSubClient: {
	          value: 0,
	          type: 'switch'
	        },
	        clientParent: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        billMainParent: {
	          value: 0,
	          type: 'checkbox'
	        },
	        isProducer: {
	          value: 0,
	          type: 'switch'
	        },
	        isSupplier: {
	          value: 0,
	          type: 'switch'
	        },
	        isActive: {
	          value: 1,
	          type: 'switch'
	        },
	        manualProcessOrder: {
	          value: 1,
	          type: 'switch'
	        },
	        syncToWoo: {
	          value: 1,
	          type: 'switch'
	        }
	      }),
	      clientAddressNames: null,
	      addressFormErrors: {
	        postal: null,
	        fields: []
	      },
	      contactFormErrors: {
	        primary: null
	      },
	      currentClient: {},
	      loading: false,
	      tabIndex: '1',
	      fetchedClient: {},
	      clientAddresses: [],
	      marketplaces: [],
	      runOnceforAutoBill: true
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    clientGroups: 'allClientGroups',
	    addressTypes: 'addressTypes',
	    currentClientContacts: 'currentClientContacts',
	    currentClientAddresses: 'currentClientAddresses',
	    types: 'allClientTypes',
	    countries: 'allCountries',
	    municipalities: 'allMunicipalities',
	    priceFields: 'allPriceFields',
	    chartOfAccounts: 'allChartOfAccounts',
	    account: 'account',
	    licenses: 'allLicenses',
	    currencies: 'currencies',
	    languages: 'languages',
	    allProjects: 'allProjects'
	  }), {
	    hasEHFModule: function hasEHFModule() {
	      if (this.account.modules.length > 0) {
	        return this.account.modules.find(function (module) {
	          return module.name === 'EHF';
	        });
	      }
	      return false;
	    },
	    hasMarketplaceModule: function hasMarketplaceModule() {
	      if (this.account.modules.length > 0) {
	        return this.account.modules.find(function (module) {
	          return module.name === 'Marketplace';
	        });
	      }
	      return false;
	    },
	    client: function client() {
	      return Object.assign({}, this.fetchedClient, this.formBasicInformation.data());
	    },
	    currentType: function currentType() {
	      var _this = this;
	
	      return this.formBasicInformation.options.typeId.filter(function (t) {
	        return t.id.toString() === _this.client.typeId.toString();
	      })[0] || {};
	    },
	    currentGroup: function currentGroup() {
	      var _this2 = this;
	
	      return this.formBasicInformation.options.clientGroupId.filter(function (g) {
	        return g.id.toString() === _this2.client.clientGroupId.toString();
	      })[0] || {};
	    },
	    ehfSupportStatusText: function ehfSupportStatusText() {
	      if (!this.client.organizationNumber) {
	        return this.$t('static.clients.info.ehfSupport.needsOrgNumber');
	      }
	      if (this.client.ehfBilling3_0) {
	        return this.$t('static.clients.info.ehfSupport.yes');
	      }
	      return this.$t('static.clients.info.ehfSupport.no');
	    }
	  }),
	
	  watch: {
	    'formBasicInformation.isSubClient': function formBasicInformationIsSubClient(value) {
	      if (value == 1) {
	        this.formBasicInformation.showField('billMainParent');
	        this.formBasicInformation.showField('clientParent');
	      } else {
	        this.formBasicInformation.hideField('billMainParent');
	        this.formBasicInformation.hideField('clientParent');
	      }
	    },
	
	    tabIndex: function tabIndex(value) {
	      this.assignTab(value);
	    },
	    $route: function $route() {
	      this.urlCurrentTab();
	    },
	
	
	    'formBasicInformation.automaticBilling': function formBasicInformationAutomaticBilling(automaticBilling) {
	      if (automaticBilling !== 'none') {
	        var feedData = automaticBilling === 'weekly' ? [{ id: '1_week', name: this.$t('form.billingInterval.week.options.week1') }, { id: '2_week', name: this.$t('form.billingInterval.week.options.week2') }, { id: '3_week', name: this.$t('form.billingInterval.week.options.week3') }] : [{ id: '1_month', name: this.$t('form.billingInterval.month.options.month1') }, { id: '2_month', name: this.$t('form.billingInterval.month.options.month2') }, { id: '3_month', name: this.$t('form.billingInterval.month.options.month3') }, { id: '4_month', name: this.$t('form.billingInterval.month.options.month4') }, { id: '5_month', name: this.$t('form.billingInterval.month.options.month5') }, { id: '6_month', name: this.$t('form.billingInterval.month.options.month6') }];
	        this.formBasicInformation.setOptions('billingInterval', feedData);
	        if (this.runOnceforAutoBill === false || !this.formBasicInformation.billingInterval) {
	          this.formBasicInformation.setFieldValue('billingInterval', feedData[0].id);
	        }
	        this.formBasicInformation.showField('billingInterval');
	
	        feedData = automaticBilling === 'weekly' ? this.daysInWeek() : this.daysInMonth();
	        this.formBasicInformation.setOptions('startBilling', feedData);
	        if (this.runOnceforAutoBill === false || !this.formBasicInformation.startBilling) {
	          this.formBasicInformation.setFieldValue('startBilling', feedData[0].id);
	        }
	        this.formBasicInformation.showField('startBilling');
	        this.runOnceforAutoBill = false;
	      } else {
	        this.formBasicInformation.hideField('billingInterval');
	        this.formBasicInformation.hideField('startBilling');
	        this.formBasicInformation.setFieldValue('automaticBilling', 'none');
	      }
	    },
	
	    allProjects: function allProjects(_allProjects) {
	      var options = _allProjects.map(function (project) {
	        return {
	          id: project.id,
	          name: project.name
	        };
	      });
	      this.formBasicInformation.setOptions('projectId', [{ id: 0, name: ' ' }].concat(_toConsumableArray(options)));
	    },
	    clientGroups: function clientGroups(_clientGroups) {
	      this.formBasicInformation.setOptions('clientGroupId', [{ id: '', name: '' }].concat(_toConsumableArray(_clientGroups.all)));
	    },
	    types: function types(_types) {
	      this.formBasicInformation.setOptions('typeId', _types.map(function (type) {
	        return {
	          id: type.id,
	          name: type.name
	        };
	      }));
	    },
	    languages: function languages(value) {
	      this.formBasicInformation.setOptions('languageId', value.all.map(function (item) {
	        return {
	          id: item.id,
	          name: item.name
	        };
	      }));
	    },
	    currencies: function currencies(value) {
	      this.formBasicInformation.setOptions('currencyId', value.all.map(function (item) {
	        return {
	          id: item.id,
	          name: item.name
	        };
	      }));
	    },
	
	    'formBasicInformation.typeId': function formBasicInformationTypeId(typeId) {
	      if (typeId.toString() === '1') {
	        this.formBasicInformation.hideField('companyName');
	        this.formBasicInformation.hideField('organizationNumber');
	        if (this.formBasicInformation.isHidden('firstName') && this.formBasicInformation.isHidden('firstName')) {
	          this.formBasicInformation.showField('firstName');
	          this.formBasicInformation.showField('lastName');
	        }
	
	        this.formBasicInformation.clearErrors('companyName');
	      }
	
	      if (typeId.toString() !== '1') {
	        this.formBasicInformation.hideField('firstName');
	        this.formBasicInformation.hideField('lastName');
	
	        this.formBasicInformation.clearErrors('firstName');
	        this.formBasicInformation.clearErrors('lastName');
	
	        if (this.formBasicInformation.isHidden('companyName')) {
	          this.formBasicInformation.showField('companyName');
	          this.formBasicInformation.showField('organizationNumber');
	        }
	      }
	    },
	
	    'formBasicInformation.email': function formBasicInformationEmail(email) {
	      if (email) {
	        var primaryContact = this.currentClientContacts.find(function (x) {
	          return x.type === 'primary';
	        });
	        if (primaryContact) {
	          var data = Object.assign({}, primaryContact);
	          data.email = email;
	          var i = this.currentClientContacts.findIndex(function (x) {
	            return x.id === primaryContact.id;
	          });
	          _store2.default.dispatch('updateClientContact', {
	            data: data,
	            i: i
	          });
	        }
	      }
	    },
	
	    'formBasicInformation.invoiceSendMethod': function formBasicInformationInvoiceSendMethod(sendMethod) {
	      if (sendMethod == 'EHF') {
	        if (!this.formBasicInformation.organizationNumber) {
	          this.$message({
	            message: this.$t('static.clients.edit.ehf.organizationNumberRequired'),
	            type: 'error'
	          });
	        }
	      }
	    },
	
	    priceFields: function priceFields(_priceFields) {
	      var options = _priceFields.all.map(function (type) {
	        return {
	          id: type.id,
	          name: type.name
	        };
	      });
	      options.splice(0, 0, { id: '', name: '' });
	      this.formBasicInformation.setOptions('priceFieldId', options);
	    },
	    chartOfAccounts: function chartOfAccounts(_chartOfAccounts) {
	      if (_chartOfAccounts && _chartOfAccounts.all && _chartOfAccounts.all.length > 0) {
	        var options = _chartOfAccounts.all.map(function (account) {
	          return {
	            id: account.id,
	            name: account.code + ' - ' + account.name
	          };
	        });
	        options.splice(0, 0, { id: '', name: '' });
	        this.formBasicInformation.setOptions('receivables_account_id', options);
	
	        if (this.fetchedClient && this.fetchedClient.receivables_account_id) {
	          this.formBasicInformation.setFieldValue('receivables_account_id', this.fetchedClient.receivables_account_id);
	        }
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    this.urlCurrentTab();
	    this.assignTab(this.tabIndex);
	  },
	  created: function created() {
	    var invoiceSendMethods = [{ id: 'EMAIL', name: 'Email' }];
	    if (this.hasEHFModule) {
	      invoiceSendMethods.push({ id: 'EHF', name: 'EHF' });
	    }
	
	    this.formBasicInformation.setOptions('invoiceSendMethod', invoiceSendMethods);
	    this.formBasicInformation.hideField('billMainParent');
	    this.formBasicInformation.hideField('clientParent');
	
	    this.formBasicInformation.setOptions('billingType', [{ id: 'single', name: this.$t('form.billingTypes.options.single') }, { id: 'consolidate', name: this.$t('form.billingTypes.options.consolidate') }]);
	    this.formBasicInformation.setFieldValue('billingType', 'single');
	
	    this.formBasicInformation.setOptions('automaticBilling', [{ id: 'none', name: this.$t('form.automaticBilling.options.none') }, { id: 'weekly', name: this.$t('form.automaticBilling.options.weekly') }, { id: 'monthly', name: this.$t('form.automaticBilling.options.monthly') }]);
	    this.show();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalClass: 'SET_MODAL_CLASS',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalButtonLoading: 'SET_MODAL_BUTTON_LOADING'
	  }), {
	    getInitials: function getInitials(client) {
	      var name = client.companyName || (client.firstName || '') + ' ' + (client.lastName || '');
	      var words = name.trim().split(/\s+/).filter(Boolean);
	      if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
	      return words[0] ? words[0].slice(0, 2).toUpperCase() : '?';
	    },
	    getAvatarColor: function getAvatarColor(client) {
	      var name = client.companyName || (client.firstName || '') + ' ' + (client.lastName || '');
	      var colors = ['#3B82F6', '#8B5CF6', '#10B981', '#F59E0B', '#EF4444', '#06B6D4', '#EC4899'];
	      var hash = 0;
	      for (var i = 0; i < name.length; i++) {
	        hash = name.charCodeAt(i) + ((hash << 5) - hash);
	      }
	      return colors[Math.abs(hash) % colors.length];
	    },
	    checkProjectModule: function checkProjectModule() {
	      this.formBasicInformation.hideField('projectId');
	      var hasProject = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name === 'Project') {
	            hasProject = true;
	          }
	        }
	      }
	      if (hasProject) {
	        this.formBasicInformation.showField('projectId');
	      }
	    },
	    glnOverviewShow: function glnOverviewShow(type) {
	      if (type === 'gln_number') {
	        return this.formBasicInformation.gln !== '';
	      }
	      if (type === 'gln_x_koord') {
	        return this.formBasicInformation.glnXKoord !== '';
	      }
	
	      if (type === 'gln_y_koord') {
	        return this.formBasicInformation.glnYKoord !== '';
	      }
	      if (type === 'gln') {
	        return this.formBasicInformation.glnYKoord !== '' || this.formBasicInformation.glnXKoord !== '' || this.formBasicInformation.gln !== '';
	      }
	      return false;
	    },
	    assignTab: function assignTab(value) {
	      var tab = '';
	      if (value == '4') {
	        tab = '#addresses';
	      } else if (value == '3') {
	        tab = '#contacts';
	      } else if (value == '2') {
	        tab = '#basics';
	      } else {
	        tab = '#overview';
	      }
	      history.pushState({}, null, '/#' + this.$route.path + tab);
	    },
	    urlCurrentTab: function urlCurrentTab() {
	      if (this.$router.currentRoute.hash == '#addresses') {
	        this.tabIndex = '4';
	      } else if (this.$router.currentRoute.hash == '#contacts') {
	        this.tabIndex = '3';
	      } else if (this.$router.currentRoute.hash == '#basics') {
	        this.tabIndex = '2';
	      } else {
	        this.tabIndex = '1';
	      }
	    },
	    daysInWeek: function daysInWeek() {
	      return [{ id: 'monday', name: this.$t('form.startBilling.week.options.monday') }, { id: 'tuesday', name: this.$t('form.startBilling.week.options.tuesday') }, { id: 'wednesday', name: this.$t('form.startBilling.week.options.wednesday') }, { id: 'thursday', name: this.$t('form.startBilling.week.options.thursday') }, { id: 'friday', name: this.$t('form.startBilling.week.options.friday') }, { id: 'saturday', name: this.$t('form.startBilling.week.options.saturday') }, { id: 'sunday', name: this.$t('form.startBilling.week.options.sunday') }];
	    },
	    daysInMonth: function daysInMonth() {
	      return [{ id: '1', name: '1st ' + this.$t('form.startBilling.month.options.day') }, { id: '2', name: '2nd ' + this.$t('form.startBilling.month.options.day') }, { id: '3', name: '3rd ' + this.$t('form.startBilling.month.options.day') }, { id: '4', name: '4th ' + this.$t('form.startBilling.month.options.day') }, { id: '5', name: '5th ' + this.$t('form.startBilling.month.options.day') }, { id: '6', name: '6th ' + this.$t('form.startBilling.month.options.day') }, { id: '7', name: '7th ' + this.$t('form.startBilling.month.options.day') }, { id: '8', name: '8th ' + this.$t('form.startBilling.month.options.day') }, { id: '9', name: '9th ' + this.$t('form.startBilling.month.options.day') }, { id: '10', name: '10th ' + this.$t('form.startBilling.month.options.day') }, { id: '11', name: '11th ' + this.$t('form.startBilling.month.options.day') }, { id: '12', name: '12th ' + this.$t('form.startBilling.month.options.day') }, { id: '13', name: '13th ' + this.$t('form.startBilling.month.options.day') }, { id: '14', name: '14th ' + this.$t('form.startBilling.month.options.day') }, { id: '15', name: '15th ' + this.$t('form.startBilling.month.options.day') }, { id: '16', name: '16th ' + this.$t('form.startBilling.month.options.day') }, { id: '17', name: '17th ' + this.$t('form.startBilling.month.options.day') }, { id: '18', name: '18th ' + this.$t('form.startBilling.month.options.day') }, { id: '19', name: '19th ' + this.$t('form.startBilling.month.options.day') }, { id: '20', name: '20th ' + this.$t('form.startBilling.month.options.day') }, { id: '21', name: '21st ' + this.$t('form.startBilling.month.options.day') }, { id: '22', name: '22nd ' + this.$t('form.startBilling.month.options.day') }, { id: '23', name: '23rd ' + this.$t('form.startBilling.month.options.day') }, { id: '24', name: '24th ' + this.$t('form.startBilling.month.options.day') }, { id: '25', name: '25th ' + this.$t('form.startBilling.month.options.day') }, { id: '26', name: '26th ' + this.$t('form.startBilling.month.options.day') }, { id: '27', name: '27th ' + this.$t('form.startBilling.month.options.day') }, { id: '28', name: '28th ' + this.$t('form.startBilling.month.options.day') }];
	    },
	    update: function update() {
	      var _this3 = this;
	
	      this.formBasicInformation.loading = true;
	      var formData = new FormData();
	      this.clearAddressErrors();
	      this.clientAddresses.forEach(function (clientAddress) {
	        var data = _address2.default.send(clientAddress);
	        var formKey = 'addresses[' + clientAddress.addressType + ']';
	        if (clientAddress.addressId) {
	          formData.append(formKey + '[id]', clientAddress.addressId);
	        }
	        formData.append(formKey + '[type]', clientAddress.addressType);
	        Object.keys(data).map(function (k) {
	          var key = formKey + '[' + k + ']';
	          formData.append(key, data[k]);
	          return null;
	        });
	      });
	
	      this.currentClientContacts.forEach(function (clientContact, index) {
	        var data = _contact2.default.send(clientContact);
	        var formKey = 'contacts[' + index + ']';
	        if (clientContact.contactId) {
	          formData.append(formKey + '[id]', clientContact.contactId);
	        }
	        clientContact.contactType.forEach(function (contactType, contactTypeIndex) {
	          formData.append(formKey + '[type][' + contactTypeIndex + ']', contactType);
	        });
	        Object.keys(data).map(function (k) {
	          var key = formKey + '[' + k + ']';
	          formData.append(key, data[k]);
	          return null;
	        });
	      });
	
	      var client = _client4.default.send(this.formBasicInformation.data());
	      Object.keys(client).map(function (k) {
	        formData.append(k, client[k]);
	        return null;
	      });
	
	      _client2.default.update(this.$route.params.id, formData).then(function (data) {
	        _this3.$message({
	          message: _this3.$t('static.clients.edit.success'),
	          type: 'success'
	        });
	        _this3.postalAddressError = false;
	        _this3.formBasicInformation.loading = false;
	        if (data.contacts.length && !_this3.currentClientContacts.length) {
	          _this3.setCurrentContacts(data.contacts);
	        }
	        _this3.setAddressFieldErrors([]);
	        _this3.setContactFieldErrors([]);
	      }).catch(function (errors) {
	        if (errors.system_generated_error) {
	          _this3.$message({
	            message: errors.system_generated_error[0],
	            type: 'error'
	          });
	        }
	        _this3.setAddressFieldErrors(errors);
	        _this3.setContactFieldErrors(errors);
	        _this3.formBasicInformation.loading = false;
	        _this3.formBasicInformation.recordErrors(_client4.default.fetch(errors));
	
	        if (_this3.formBasicInformation.errors.any()) {
	          _this3.tabIndex = '2';
	        } else if ('contacts' in errors) {
	          _this3.tabIndex = '3';
	        } else if ('addresses' in errors) {
	          _this3.tabIndex = '4';
	        }
	      });
	    },
	    inviteToMarketplace: function inviteToMarketplace(id) {
	      var _this4 = this;
	
	      _marketplaceCustomer2.default.invite(this.fetchedClient.id, { partner_id: id }).then(function (data) {
	        console.log(data);
	      }).catch(function () {
	        _this4.$message({
	          message: _this4.$t('static.clients.inviteToMarketplaceError'),
	          type: 'error'
	        });
	      });
	    },
	    show: function show() {
	      var _this5 = this;
	
	      this.loading = true;
	      Promise.all([_client2.default.show(this.$route.params.id), _clientGroup2.default.all(), _clientType2.default.all(), _addressType2.default.all(), _siteLanguages2.default.all(), _priceField2.default.all(1), _chartOfAccounts3.default.all(), _country2.default.all(), _municipality2.default.all(), _marketplaceCustomer2.default.partners(), _license2.default.all(this.$route.params.id), _account2.default.currencies(), _account2.default.languages(), _project2.default.all()]).then(function (data) {
	        _this5.currentClient = data[0];
	        var client = data[0];
	        _this5.fetchedClient = client;
	        _this5.loading = false;
	        _this5.clientAddressNames = ['Postal'];
	        _this5.formBasicInformation.assignData(client);
	
	        if (client.receivables_account_id) {
	          _this5.formBasicInformation.setFieldValue('receivables_account_id', client.receivables_account_id);
	        } else {
	          _this5.formBasicInformation.setFieldValue('receivables_account_id', '');
	        }
	
	        var contacts = client.contacts.length ? client.contacts : [];
	        _this5.setCurrentContacts(contacts);
	        _this5.setCurrentAddresses(client.addresses);
	        _this5.lockedFields(client.billingMethodLocked, client.automateBillingMethodLocked);
	        if (client.clientParent != '') {
	          _this5.formBasicInformation.setFieldValue('isSubClient', 1);
	        }
	        if (data[8]) {
	          _this5.marketplaces = data[8].data;
	        }
	        _this5.checkProjectModule();
	      });
	    },
	    lockedFields: function lockedFields(billing, automaticBilling) {
	      if (automaticBilling === 'unlock') {
	        this.formBasicInformation.enableField('automaticBilling');
	        this.formBasicInformation.enableField('billingInterval');
	        this.formBasicInformation.enableField('startBilling');
	      }
	      if (automaticBilling !== 'unlock') {
	        this.formBasicInformation.disableField('automaticBilling');
	        this.formBasicInformation.disableField('billingInterval');
	        this.formBasicInformation.disableField('startBilling');
	      }
	
	      if (billing === 'unlock') {
	        this.formBasicInformation.enableField('billingType');
	      }
	      if (billing !== 'unlock') {
	        this.formBasicInformation.disableField('billingType');
	      }
	    },
	    setCurrentContacts: function setCurrentContacts(contacts) {
	      var currentContacts = [];
	      contacts.forEach(function (contact) {
	        var data = _contact2.default.fetch(contact);
	        data.contactId = contact.id;
	        var contactTypes = [];
	        contact.contact_types.forEach(function (type) {
	          if (type.name === 'Primary') data.type = 'primary';
	          contactTypes.push(type.id.toString());
	        });
	        data.contactType = contactTypes;
	        data.id = contactTypes.join();
	        currentContacts.push(data);
	      });
	      _store2.default.dispatch('setCurrentClientContacts', currentContacts);
	    },
	    setCurrentAddresses: function setCurrentAddresses(addresses) {
	      var _this6 = this;
	
	      this.addressTypes.forEach(function (type) {
	        var address = addresses.find(function (a) {
	          return type.id === a.address_type.id;
	        }) || {};
	        if (address) {
	          address = _address2.default.fetch(address);
	        }
	        _this6.clientAddresses.push(Object.assign({}, { id: type.id, addressType: type.id, name: type.name }, address));
	      });
	    },
	    buttonHandler: function buttonHandler() {
	      var _this7 = this;
	
	      this.formBasicInformation.loading = true;
	      var organizationNumber = this.formBasicInformation.organizationNumber;
	      this.formBasicInformation.disableField('organizationNumber');
	
	      _client2.default.findBusiness(organizationNumber).then(function (data) {
	        _this7.formBasicInformation.loading = false;
	
	        _this7.formBasicInformation.enableField('organizationNumber');
	        _this7.formBasicInformation.companyName = data.name;
	        _this7.setModalContent(function () {
	          return _clientAddressBrreg2.default;
	        });
	        _this7.setModalSize('30%');
	        _this7.setModalClass('third-party-result-addresses');
	        _this7.setModalProps({
	          orgNumberInput: organizationNumber,
	          addressTypes: _this7.addressTypes,
	          orgData: data,
	          onSubmit: _this7.onBreggSubmit
	        });
	        _this7.toggleModal(true);
	      }).catch(function (errors) {
	        _this7.$message({
	          message: _this7.$t('static.clients.create.brrig.warning'),
	          type: 'error'
	        });
	        _this7.formBasicInformation.enableField('organizationNumber');
	        _this7.formBasicInformation.loading = false;
	      });
	    },
	    buttonHandler2: function buttonHandler2() {
	      var _this8 = this;
	
	      var organizationNumber = this.formBasicInformation.organizationNumber;
	      this.formBasicInformation.loading = true;
	      this.formBasicInformation.disableField('organizationNumber');
	      _client2.default.glnLookup(organizationNumber).then(function (res) {
	        if (res.gln !== '' && res.xKoord !== '' && res.yKoord !== '') {
	          _this8.formBasicInformation.setFieldValue('gln', res.gln);
	          _this8.formBasicInformation.setFieldValue('glnXKoord', res.xKoord);
	          _this8.formBasicInformation.setFieldValue('glnYKoord', res.yKoord);
	          _this8.formBasicInformation.enableField('organizationNumber');
	          _this8.formBasicInformation.loading = false;
	          _this8.$message({
	            message: _this8.$t('static.clients.edit.glnSuccess'),
	            type: 'success'
	          });
	        } else {
	          _this8.formBasicInformation.enableField('organizationNumber');
	          _this8.formBasicInformation.setFieldValue('gln', '');
	          _this8.formBasicInformation.setFieldValue('glnXKoord', '');
	          _this8.formBasicInformation.setFieldValue('glnYKoord', '');
	          _this8.formBasicInformation.loading = false;
	          _this8.$message({
	            message: _this8.$t('static.clients.edit.glnError'),
	            type: 'error'
	          });
	        }
	      }).catch(function (error) {
	        console.log(error);
	        _this8.formBasicInformation.enableField('organizationNumber');
	        _this8.formBasicInformation.setFieldValue('gln', '');
	        _this8.formBasicInformation.setFieldValue('glnXKoord', '');
	        _this8.formBasicInformation.setFieldValue('glnYKoord', '');
	        _this8.formBasicInformation.loading = false;
	        _this8.$message({
	          message: _this8.$t('static.clients.edit.glnError'),
	          type: 'error'
	        });
	      });
	    },
	    onBreggSubmit: function onBreggSubmit(data) {
	      var _this9 = this;
	
	      var postal = data.address_postal;
	      if (postal) {
	        if (postal.address_type_ids) {
	          postal.address_type_ids.forEach(function (item) {
	            var i = _this9.clientAddresses.findIndex(function (item2) {
	              return item2.addressType === item;
	            });
	            _this9.clientAddresses[i].streetName = postal.street_name;
	            _this9.clientAddresses[i].secondStreetName = postal.second_street_name;
	            _this9.clientAddresses[i].postalCode = postal.postal_code;
	            _this9.clientAddresses[i].cityName = postal.city;
	            _this9.clientAddresses[i].countryId = _this9.countries.items.find(function (item2) {
	              return item2.name === 'Norway';
	            }).id;
	          });
	        }
	      }
	
	      var business = data.address_business;
	      if (business) {
	        if (business.address_type_ids) {
	          business.address_type_ids.forEach(function (item) {
	            var i = _this9.clientAddresses.findIndex(function (item2) {
	              return item2.addressType === item;
	            });
	            _this9.clientAddresses[i].streetName = business.street_name;
	            _this9.clientAddresses[i].secondStreetName = business.second_street_name;
	            _this9.clientAddresses[i].postalCode = business.postal_code;
	            _this9.clientAddresses[i].cityName = business.city;
	            _this9.clientAddresses[i].countryId = _this9.countries.items.find(function (item2) {
	              return item2.name === 'Norway';
	            }).id;
	          });
	        }
	      }
	
	      var location = data.address_location;
	      if (location) {
	        if (location.address_type_ids) {
	          location.address_type_ids.forEach(function (item) {
	            var i = _this9.clientAddresses.findIndex(function (item2) {
	              return item2.addressType === item;
	            });
	            _this9.clientAddresses[i].streetName = location.street_name;
	            _this9.clientAddresses[i].secondStreetName = location.second_street_name;
	            _this9.clientAddresses[i].postalCode = location.postal_code;
	            _this9.clientAddresses[i].cityName = location.city;
	            _this9.clientAddresses[i].countryId = _this9.countries.items.find(function (item2) {
	              return item2.name === 'Norway';
	            }).id;
	          });
	        }
	      }
	
	      this.update();
	    },
	    destroy: function destroy() {
	      var _this10 = this;
	
	      this.$confirm(this.$t('static.clients.delete.confirm'), this.$t('static.clients.delete.title'), {
	        confirmButtonText: this.$t('button.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _client2.default.destroy(_this10.$route.params.id).then(function () {
	          _this10.$message({
	            message: _this10.$t('static.clients.delete.success'),
	            type: 'success'
	          });
	          _this10.$router.push({
	            name: 'clients.index'
	          });
	        }).catch(function (errors) {
	          if (errors.system_generated_error) {
	            _this10.$message({
	              message: errors.system_generated_error[0],
	              type: 'error'
	            });
	          } else {
	            _this10.$message({
	              message: errors.message,
	              type: 'error'
	            });
	          }
	        });
	      }).catch(function () {});
	    },
	    setContactFieldErrors: function setContactFieldErrors(errors) {
	      if ('contacts' in errors) {
	        this.contactFormErrors.primary = true;
	      } else {
	        this.contactFormErrors.primary = false;
	      }
	    },
	    clearAddressErrors: function clearAddressErrors() {
	      var _this11 = this;
	
	      this.addressTypes.forEach(function (t) {
	        _this11.addressFormErrors.fields[t.id] = [];
	      });
	    },
	    setAddressFieldErrors: function setAddressFieldErrors(errors) {
	      var _this12 = this;
	
	      if ('addresses' in errors) {
	        this.addressFormErrors.postal = true;
	      } else {
	        this.addressFormErrors.postal = false;
	        this.clearAddressErrors();
	      }
	      Object.keys(errors).filter(function (key) {
	        return key.indexOf('addresses.') !== -1;
	      }).map(function (key) {
	        var _key$split = key.split('.'),
	            _key$split2 = _slicedToArray(_key$split, 3),
	            name = _key$split2[0],
	            addressTypeId = _key$split2[1],
	            field = _key$split2[2];
	
	        if (typeof errors[key][0] !== 'undefined') {
	          if (typeof _this12.addressFormErrors.fields[addressTypeId] === 'undefined') {
	            _this12.addressFormErrors.fields[addressTypeId] = [];
	            _this12.addressFormErrors.fields[addressTypeId][field] = [];
	          }
	          var message = errors[key][0].replace(key, field);
	          _this12.addressFormErrors.fields[addressTypeId][field] = [message];
	        }
	        return null;
	      });
	    },
	    getAddressFieldErrors: function getAddressFieldErrors(addressTypeId) {
	      if (addressTypeId in this.addressFormErrors.fields) {
	        return _address2.default.fetch(this.addressFormErrors.fields[addressTypeId]);
	      }
	      return null;
	    },
	    searchMethod: function searchMethod(search, field) {
	      return Promise.all([_client2.default.all(search, this.$route.params.id)]);
	    },
	    addLicense: function addLicense() {
	      if (!this.formBasicInformation.organizationNumber) {
	        var message = this.$t('static.license.organizationNumberRequired');
	        this.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	      } else {
	        this.setModalContent(function () {
	          return _addLicense3.default;
	        });
	        this.setModalSize('full');
	        this.toggleModal(true);
	        this.setModalProps({ orgNumber: this.currentClient.organizationNumber, clientId: this.currentClient.id });
	      }
	    },
	    sendCatalogue: function sendCatalogue() {
	      this.setModalContent(function () {
	        return _sendCatalogue3.default;
	      });
	      this.setModalProps({
	        clientId: this.currentClient.id
	      });
	      this.toggleModal(true);
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9),
	    VMap: __webpack_require__(2715),
	    VClientAddress: __webpack_require__(409),
	    VClientContact: __webpack_require__(767)
	  },
	
	  mixins: [_stringFormat2.default]
	};

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _clientImportExportPopup = __webpack_require__(2693);
	
	var _clientImportExportPopup2 = _interopRequireDefault(_clientImportExportPopup);
	
	var _bulkProcessClientModal = __webpack_require__(2681);
	
	var _bulkProcessClientModal2 = _interopRequireDefault(_bulkProcessClientModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sort: 'bestPaying',
	      info: 'info',
	      primary: 'primary',
	      search: '',
	      sortTypes: [{
	        id: 'bestPaying',
	        name: this.$t('sort.bestPaying')
	      }, {
	        id: 'worstPaying',
	        name: this.$t('sort.worstPaying')
	      }, {
	        id: 'biggestDebtors',
	        name: this.$t('sort.biggestDebtors')
	      }, {
	        id: 'name|asc',
	        name: this.$t('sort.name') + ' (A -> Z)'
	      }, {
	        id: 'name|desc',
	        name: this.$t('sort.name') + ' (Z -> A)'
	      }],
	      limit: 25,
	      multipleSelection: [],
	      bulkSelectionLimit: 25,
	      showAction: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    clients: 'clients',
	    view: 'getView',
	    searchQuery: 'clientQuery',
	    account: 'account'
	  }), {
	    hasEHFModule: function hasEHFModule() {
	      if (this.account && this.account.modules && this.account.modules.length > 0) {
	        return !!this.account.modules.find(function (module) {
	          return module.name === 'EHF';
	        });
	      }
	      return false;
	    },
	    clientsListView: function clientsListView() {
	      return this.clients.items.map(function (c) {
	        return {
	          name: c.name,
	          organizationNumber: c.organizationNumber || '–',
	          phone: (c.phoneNumber ? 'tel: ' + c.phoneNumber : '') + (c.mobileNumber ? ' mob: ' + c.mobileNumber : ''),
	          email: c.email,
	          custNo: c.custNo || '-',
	          ordersCount: c.ordersCount,
	          createdAt: '' + (0, _moment2.default)(c.createdAt).format('DD-MM-YYYY'),
	          id: c.id,
	          billMainParent: c.billMainParent === 1,
	          clientParentId: c.clientParentId,
	          clientParent: c.clientParent,
	          ehfBilling3_0: !!c.ehfBilling3_0,
	          ehfSort: c.ehfBilling3_0 ? 1 : 0
	        };
	      });
	    },
	    selectedCount: function selectedCount() {
	      return this.multipleSelection.length || 0;
	    }
	  }),
	
	  watch: {
	    view: function view(_view) {
	      this.showAction = false;
	      if (_view == 'card') {
	        this.info = 'info';
	        this.primary = 'primary';
	      } else {
	        this.primary = 'info';
	        this.info = 'primary';
	      }
	    },
	    multipleSelection: function multipleSelection(_multipleSelection) {
	      this.showAction = false;
	      if (_multipleSelection.length) {
	        this.showAction = true;
	      }
	    },
	    $route: function $route() {
	      this.multipleSelection = [];
	      this.all(this.searchQuery.page, this.limit);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    _account2.default.rememberPerPage('get', { from: 'client' }).then(function (data) {
	      _this.limit = data.size;
	      _this.all(_this.searchQuery.page, _this.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	
	    this.setInnerSidebar([{
	      title: this.$t('layouts.sidebar.clients'),
	      options: [{
	        title: this.$t('layouts.sidebar.active'),
	        route: {
	          name: 'clients.index',
	          query: {
	            filter: 'active'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.inActive'),
	        route: {
	          name: 'clients.index',
	          query: {
	            filter: 'inActive'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.orderedPastWeek'),
	        route: {
	          name: 'clients.index',
	          query: {
	            filter: 'orderedPastWeek'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.orderedPastMonth'),
	        route: {
	          name: 'clients.index',
	          query: {
	            filter: 'orderedPastMonth'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.neverOrdered'),
	        route: {
	          name: 'clients.index',
	          query: {
	            filter: 'neverOrdered'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.storeSynced'),
	        route: {
	          name: 'clients.index',
	          query: {
	            filter: 'storeSynced'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.all'),
	        route: {
	          name: 'clients.index'
	        }
	      }],
	      button: {
	        title: this.$t('button.addClient'),
	        route: {
	          name: 'clients.create'
	        }
	      }
	    }, {
	      title: this.$t('layouts.sidebar.clientGroup'),
	      options: [{
	        title: this.$t('layouts.sidebar.active'),
	        route: {
	          name: 'clientGroups.index',
	          query: {
	            filter: 'active'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.inActive'),
	        route: {
	          name: 'clientGroups.index',
	          query: {
	            filter: 'inActive'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.newOrders'),
	        route: {
	          name: 'clientGroups.index',
	          query: {
	            filter: 'new'
	          }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.all'),
	        route: {
	          name: 'clientGroups.index'
	        }
	      }],
	      button: {
	        title: this.$t('button.addClientGroup'),
	        route: {
	          name: 'clientGroups.create'
	        }
	      }
	    }, {
	      title: this.$t('layouts.sidebar.clientAgreements'),
	      options: [{
	        title: this.$t('layouts.sidebar.active'),
	        route: {
	          name: 'pricingAgreements.index',
	          query: { filter: 'active' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.inActive'),
	        route: {
	          name: 'pricingAgreements.index',
	          query: { filter: 'inactive' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.all'),
	        route: {
	          name: 'pricingAgreements.index',
	          query: { filter: 'all' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.importAgreement'),
	        route: {
	          name: 'pricingAgreements.index',
	          query: { import: '1' }
	        }
	      }],
	      button: {
	        title: this.$t('layouts.sidebar.newAgreement'),
	        route: { name: 'pricingAgreements.create' }
	      }
	    }]);
	
	    if (this.view == 'card') {
	      this.info = 'info';
	      this.primary = 'primary';
	    } else {
	      this.primary = 'info';
	      this.info = 'primary';
	    }
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	    _store2.default.dispatch('resetClients');
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    onSelectAction: function onSelectAction(value) {
	      if (this.multipleSelection.length > this.bulkSelectionLimit) {
	        var message = this.$t('static.clients.index.bulkMaxLimitExceededError') + ' ' + this.bulkSelectionLimit;
	        this.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	        return;
	      }
	      if (value) {
	        this.setModalContent(function () {
	          return _bulkProcessClientModal2.default;
	        });
	        this.setModalProps({
	          selectedClients: this.multipleSelection,
	          onSubmit: this.handleBulkClientActionSubmit,
	          type: value
	        });
	        this.setModalCloseOnClick(false);
	        this.setModalShowClose(false);
	        this.setModalCloseOnPressEscape(false);
	        this.toggleModal(true);
	      }
	    },
	    handleBulkClientActionSubmit: function handleBulkClientActionSubmit() {
	      this.multipleSelection = [];
	      this.all(1, 25);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    showImportDownloadModal: function showImportDownloadModal() {
	      this.setModalContent(function () {
	        return _clientImportExportPopup2.default;
	      });
	      this.setModalSize('full');
	      this.toggleModal(true);
	    },
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'client', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this3 = this;
	
	      this.loading = true;
	      var query = { page: page, limit: limit, search: this.searchQuery.search };
	      _store2.default.dispatch('setClientQuery', query);
	      this.search = this.searchQuery.search;
	      _client2.default.items({
	        page: page,
	        limit: limit,
	        sort: this.sort,
	        search: this.searchQuery.search,
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this3.loading = false;
	      }).catch(function () {
	        _this3.loading = false;
	      });
	    }, 800),
	
	    changeView: function changeView(view) {
	      if (this.info != view) {
	        this.primary = this.info;
	        this.info = view;
	        if (this.info == 'info') {
	          _store2.default.dispatch('setView', 'card');
	        } else {
	          _store2.default.dispatch('setView', 'list');
	        }
	      }
	    },
	    onChangeSearch: function onChangeSearch(name, value) {
	      _store2.default.dispatch('setClientQuery', { page: 1, limit: this.limit, search: value });
	      this.all(1, this.limit);
	    },
	    deleteClient: function deleteClient(client) {
	      this.$confirm(this.$t('static.clients.index.confirmDelete'), this.$t('static.clients.index.confirmDeleteTitle'), {
	        confirmButtonText: this.$t('button.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _client2.default.destroy(client.id);
	      }).catch(function () {});
	    },
	    editClient: function editClient(client) {
	      this.$router.push({
	        name: 'clients.edit',
	        params: { id: client.id }
	      });
	    },
	    editClientNewTab: function editClientNewTab(client) {
	      var route = this.$router.resolve({
	        name: 'clients.edit',
	        params: { id: client.id }
	      });
	      window.open(route.href, '_blank');
	    },
	    getInitials: function getInitials(client) {
	      var name = client.companyName || (client.firstName || '') + ' ' + (client.lastName || '');
	      var words = name.trim().split(/\s+/).filter(Boolean);
	      if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
	      return words[0] ? words[0].slice(0, 2).toUpperCase() : '?';
	    },
	    getAvatarColor: function getAvatarColor(client) {
	      var name = client.companyName || (client.firstName || '') + ' ' + (client.lastName || '');
	      var colors = ['#3B82F6', '#8B5CF6', '#10B981', '#F59E0B', '#EF4444', '#06B6D4', '#EC4899'];
	      var hash = 0;
	      for (var i = 0; i < name.length; i++) {
	        hash = name.charCodeAt(i) + ((hash << 5) - hash);
	      }
	      return colors[Math.abs(hash) % colors.length];
	    }
	  }),
	
	  mixins: [_search2.default],
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VSelect: __webpack_require__(51),
	    VNoData: __webpack_require__(19),
	    VTable: __webpack_require__(33)
	  }
	};

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _auth = __webpack_require__(53);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _overviewWidgets = __webpack_require__(2723);
	
	var _overviewWidgets2 = _interopRequireDefault(_overviewWidgets);
	
	var _widgets2 = __webpack_require__(98);
	
	var _widgets3 = _interopRequireDefault(_widgets2);
	
	var _topClients = __webpack_require__(2752);
	
	var _topClients2 = _interopRequireDefault(_topClients);
	
	var _waitingProcessed = __webpack_require__(2754);
	
	var _waitingProcessed2 = _interopRequireDefault(_waitingProcessed);
	
	var _waitingDelivered = __webpack_require__(2753);
	
	var _waitingDelivered2 = _interopRequireDefault(_waitingDelivered);
	
	var _orderReceived = __webpack_require__(2748);
	
	var _orderReceived2 = _interopRequireDefault(_orderReceived);
	
	var _revenue = __webpack_require__(2750);
	
	var _revenue2 = _interopRequireDefault(_revenue);
	
	var _popularProducts = __webpack_require__(2749);
	
	var _popularProducts2 = _interopRequireDefault(_popularProducts);
	
	var _soldProducts = __webpack_require__(2751);
	
	var _soldProducts2 = _interopRequireDefault(_soldProducts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    WaitingProcessed: _waitingProcessed2.default,
	    WaitingDelivered: _waitingDelivered2.default,
	    OrderReceived: _orderReceived2.default,
	    TopClients: _topClients2.default,
	    AmountRevenue: _revenue2.default,
	    PopularProduct: _popularProducts2.default,
	    soldProduct: _soldProducts2.default
	  },
	  data: function data() {
	    return {
	      confirmationResent: false,
	      confirmationResentError: false,
	      loadComponent: false,
	      cardItems: [],
	      cardCurrentOrder: []
	    };
	  },
	  created: function created() {
	    if (!this.account.organizationName) {
	      this.$router.push('/profile/account');
	    }
	
	    if (this.account.firstName && this.account.lastName || this.account.organizationName) {
	      this.loadComponent = true;
	    }
	
	    if ((!this.account.organizationName || this.account.organizationName === '') && this.account.organizationMembers == 0 && (!this.account.firstName || this.account.firstName === '' || !this.account.lastName || this.account.lastName === '')) {
	      this.activateModal();
	    }
	
	    this.initializeWidgets();
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    widgets: 'widgets',
	    availableWidgets: 'availableWidgets'
	  })),
	
	  watch: {
	    widgets: function widgets(_widgets) {
	      if (_widgets.items !== 'no_widget' && _widgets.items.length > 0) {
	        this.cardItems = this.readSerialize(_widgets.items);
	        var self = this;
	        this.cardItems.forEach(function (item, i) {
	          self.cardCurrentOrder[i] = i;
	        });
	      }
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleSidebar: 'TOGGLE_INNERSIDEBAR',
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    activateModal: function activateModal() {
	      this.setModalContent(function () {
	        return profileCompleteness;
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    resendConfirmation: function resendConfirmation() {
	      var _this = this;
	
	      Promise.resolve(_auth2.default.resendConfirmation()).then(function () {
	        _this.confirmationResent = true;
	      }).catch(function () {
	        _this.confirmationResentError = true;
	      });
	    },
	    widgetsRemove: function widgetsRemove(index) {
	      this.cardItems.splice(index, 1);
	      this.saveWidgets(this.cardItems);
	    },
	    widgetsAdd: function widgetsAdd() {
	      this.overviewWidgetsModal();
	    },
	    overviewWidgetsModal: function overviewWidgetsModal() {
	      this.setModalContent(function () {
	        return _overviewWidgets2.default;
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    initializeWidgets: function initializeWidgets() {
	      var _this2 = this;
	
	      Promise.all([_widgets3.default.fetchAvailableWidgets(), _widgets3.default.fetchUserWidgets()]).then(function () {
	        if (_this2.widgets.items !== 'no_widget' && _this2.widgets.items.length > 0) {
	          _this2.cardItems = _this2.readSerialize(_this2.widgets.items);
	          var self = _this2;
	          _this2.cardItems.forEach(function (item, i) {
	            self.cardCurrentOrder[i] = i;
	            self.availableWidgets.items.avialableWidgetsData.forEach(function (item2, n) {
	              if (item2.key === item.key) {
	                item.title = item2.title;item.sub = item2.subtitle;item.desc = item2.desc;
	              }
	            });
	          });
	        }
	      });
	    },
	    saveWidgets: function saveWidgets(value) {
	      _widgets3.default.updateUserWidgets(value).then(function () {});
	    },
	    readSerialize: function readSerialize(value) {
	      var newJson = value.replace(/([a-zA-Z0-9]+?):/g, '"$1":');
	      newJson = newJson.replace(/'/g, '"');
	      return JSON.parse(newJson);
	    },
	    onChangePos: function onChangePos(to, from) {
	      this.insertAndShift(this.cardItems, from, to);
	      this.saveWidgets(this.cardItems);
	      this.cardCurrentOrder[from] = from;
	    },
	    insertAndShift: function insertAndShift(arr, from, to) {
	      var cutOut = arr.splice(from, 1)[0];
	      arr.splice(to, 0, cutOut);
	    }
	  })
	
	};

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _equipment = __webpack_require__(228);
	
	var _equipment2 = _interopRequireDefault(_equipment);
	
	var _equipment3 = __webpack_require__(130);
	
	var _equipment4 = _interopRequireDefault(_equipment3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        isActive: {
	          value: '',
	          type: 'checkbox'
	        }
	      })
	    };
	  },
	  created: function created() {},
	
	
	  methods: {
	    store: function store() {
	      var _this = this;
	
	      this.form.loading = true;
	      var equipment = _equipment4.default.send(this.form.data());
	      _equipment2.default.store(equipment).then(function () {
	        _this.form.loading = false;
	        _this.$message({
	          message: _this.$t('static.equipments.create.success'),
	          type: 'success'
	        });
	        _this.$router.push({
	          name: 'production.equipments.index'
	        });
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	      });
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _equipment = __webpack_require__(228);
	
	var _equipment2 = _interopRequireDefault(_equipment);
	
	var _equipment3 = __webpack_require__(130);
	
	var _equipment4 = _interopRequireDefault(_equipment3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        isActive: {
	          value: '',
	          type: 'checkbox'
	        }
	      }),
	      loading: false
	    };
	  },
	  created: function created() {
	    this.show();
	  },
	
	
	  methods: {
	    update: function update() {
	      var _this = this;
	
	      this.form.loading = true;
	      var equipment = _equipment4.default.send(this.form.data());
	      _equipment2.default.update(_store2.default.state.route.params.id, equipment).then(function () {
	        _this.form.loading = false;
	        _this.$message({
	          message: _this.$t('static.equipments.edit.success'),
	          type: 'success'
	        });
	        _this.$router.push({
	          name: 'production.equipments.index'
	        });
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      var _this2 = this;
	
	      this.loading = true;
	      _equipment2.default.show(_store2.default.state.route.params.id).then(function (equipment) {
	        _this2.form.assignData(equipment);
	        _this2.loading = false;
	      });
	    }
	  },
	
	  watch: {},
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _equipment = __webpack_require__(228);
	
	var _equipment2 = _interopRequireDefault(_equipment);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _bridgeHandoff = __webpack_require__(81);
	
	var _bridgeHandoff2 = _interopRequireDefault(_bridgeHandoff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sort: '',
	      info: 'info',
	      primary: 'primary',
	      search: ''
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    equipments: 'paginatedEquipments',
	    allEquipments: 'allEquipments',
	    view: 'getView',
	    searchQuery: 'equipmentQuery',
	    account: 'account'
	  }), {
	    equipmentsListView: function equipmentsListView() {
	      return this.equipments.items.map(function (equipment) {
	        return {
	          id: equipment.id,
	          name: equipment.name,
	          status: equipment.isActive ? 'Active' : 'Inactive'
	        };
	      });
	    }
	  }),
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19),
	    VTable: __webpack_require__(33)
	  },
	
	  mixins: [_search2.default, _bridgeHandoff2.default],
	
	  watch: {
	    $route: function $route() {
	      this.all(1, 50);
	    },
	    view: function view(_view) {
	      if (_view == 'card') {
	        this.info = 'info';
	        this.primary = 'primary';
	      } else {
	        this.primary = 'info';
	        this.info = 'primary';
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    this.setInnerSidebar([{
	      title: this.$t('static.materials.filters.title'),
	      options: [{
	        title: this.$t('static.materials.filters.active'),
	        route: {
	          name: 'production.materials.index',
	          query: {
	            filter: 'active'
	          }
	        }
	      }, {
	        title: this.$t('static.materials.filters.deactivated'),
	        route: {
	          name: 'production.materials.index',
	          query: {
	            filter: 'deactivated'
	          }
	        }
	      }, {
	        title: this.$t('static.materials.filters.all'),
	        route: {
	          name: 'production.materials.index',
	          query: {
	            filter: 'all'
	          }
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.materials.create.title'),
	        route: {
	          name: 'production.materials.create'
	        }
	      }
	    }, {
	      title: this.$t('static.batches.filters.title'),
	      options: [{
	        title: this.$t('static.batches.filters.notStarted'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'notStarted'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.upcoming'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'upcoming'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.ongoing'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'ongoing'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.completed'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'completed'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.all'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'all'
	          }
	        }
	      }],
	      button: this.bridgeStockWriteBlocked ? null : {
	        title: '+ ' + this.$t('static.batches.create.title'),
	        route: {
	          name: 'production.batches.create'
	        }
	      }
	    }, {
	      title: this.$t('static.recipes.filters.title'),
	      options: [{
	        title: this.$t('static.recipes.filters.all'),
	        route: {
	          name: 'production.recipes.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.recipes.create.title'),
	        route: {
	          name: 'production.recipes.create'
	        }
	      }
	    }, {
	      title: this.$t('static.equipments.title'),
	      options: [{
	        title: this.$t('static.equipments.filters.all'),
	        route: {
	          name: 'production.equipments.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.equipments.create.title'),
	        route: {
	          name: 'production.equipments.create'
	        }
	      }
	    }]);
	
	    this.all(this.searchQuery.page, this.searchQuery.limit);
	    if (this.view == 'card') {
	      this.info = 'info';
	      this.primary = 'primary';
	    } else {
	      this.primary = 'info';
	      this.info = 'primary';
	    }
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    changeView: function changeView(view) {
	      if (this.info != view) {
	        this.primary = this.info;
	        this.info = view;
	        if (this.info == 'info') {
	          _store2.default.dispatch('setView', 'card');
	        } else {
	          _store2.default.dispatch('setView', 'list');
	        }
	      }
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this = this;
	
	      this.loading = true;
	
	      var query = { page: page, limit: limit, search: this.searchQuery.search };
	      _store2.default.dispatch('setEquipmentQuery', query);
	      this.search = this.searchQuery.search;
	      _equipment2.default.items({
	        page: page,
	        limit: limit,
	        search: this.searchQuery.search,
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this.loading = false;
	      }).catch(function () {
	        _this.loading = false;
	      });
	    }, 800),
	
	    onChangeSearch: function onChangeSearch(name, value) {
	      _store2.default.dispatch('setEquipmentQuery', { page: 1, limit: 50, search: value });
	      this.all(1, 50);
	    },
	    editEquipment: function editEquipment(equipment) {
	      this.$router.push({
	        name: 'production.equipments.edit',
	        params: { id: equipment.id }
	      });
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  })
	};

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(5);
	
	var _exciseEntry = __webpack_require__(297);
	
	var _exciseEntry2 = _interopRequireDefault(_exciseEntry);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _exciseGroup = __webpack_require__(94);
	
	var _exciseGroup2 = _interopRequireDefault(_exciseGroup);
	
	var _additionalCode = __webpack_require__(289);
	
	var _additionalCode2 = _interopRequireDefault(_additionalCode);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sortValue: '',
	      entries: [],
	      filter: {
	        product: '',
	        month: (0, _moment2.default)().subtract(1, 'months')
	      },
	      form: new _forms2.default({
	        product: {
	          type: 'autocomplete',
	          value: '',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        }
	      }),
	      dateRange: [(0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()],
	      pagination: {},
	      page: 1,
	      limit: 25,
	      flag: ''
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    warehouses: 'paginateWarehouses',
	    products: 'allProducts'
	  }), {
	    warehousesList: function warehousesList() {
	      return this.warehouses.items.map(function (b) {
	        return b;
	      });
	    }
	  }),
	
	  watch: {
	    $route: function $route() {},
	
	
	    'form.product': function formProduct(val) {
	      this.all(this.page, this.limit);
	    }
	  },
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19),
	    VTable: __webpack_require__(33),
	    VExciseTable: __webpack_require__(410),
	    VForm: __webpack_require__(9)
	  },
	
	  mixins: [_search2.default],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var product_id = '';
	    if (this.form.product != '') {
	      product_id = this.form.product.id;
	    }
	    var month = '';
	
	    if (this.filter.month != null) {
	      month = (0, _moment2.default)(this.filter.month).format('YYYY-MM');
	    }
	    var params = {
	      page: 1,
	      limit: 50,
	      month: month,
	      product: product_id,
	      flag: this.flag
	    };
	    Promise.all([_exciseEntry2.default.entries(params), _exciseGroup2.default.all(), _exciseGroup2.default.packaging(), _exciseGroup2.default.basic(), _additionalCode2.default.all()]).then(function (data) {
	      _this.entries = data[0].report;
	
	      _this.loading = false;
	    });
	
	    _account2.default.rememberPerPage('get', { from: 'excise_entry' }).then(function (data) {
	      _this.limit = data.size;
	      _this.all(1, _this.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'excise_entry', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this3 = this;
	
	      this.loading = true;
	      this.page = page;
	      this.limit = limit;
	
	      var productId = '';
	      if (this.form.product !== '') {
	        productId = this.form.product.id;
	      }
	      var month = '';
	
	      if (this.filter.month != null) {
	        month = (0, _moment2.default)(this.filter.month).format('YYYY-MM');
	      }
	      _exciseEntry2.default.entries({
	        page: page,
	        limit: limit,
	        month: month,
	        product: productId,
	        flag: this.flag
	      }).then(function (data) {
	        _this3.entries = data.report;
	        _this3.pagination = data.pagination;
	        _this3.loading = false;
	      }).catch(function () {
	        _this3.loading = false;
	      });
	    }, 800),
	
	    searchMethod: function searchMethod(search, field) {
	      this.form.setAttrValue('product', 'loading', true);
	
	
	      return Promise.all([_product2.default.search({ search: search, warehouse_id: this.form.warehouseId })]);
	    },
	    updateList: function updateList(index, data) {
	
	      this.all(this.page, this.limit);
	    },
	    changeData: function changeData() {
	      this.loading = true;
	      this.all(this.page, this.limit);
	    },
	    openLink: function openLink(row) {
	      if (row.excisable == 'order') {
	        this.$router.push({
	          name: 'orders.edit',
	          params: { id: row.excisableId }
	        });
	      } else if (row.excisable == 'creditnote') {
	        this.$router.push({
	          name: 'bills.creditNote',
	          params: { id: row.excisableId }
	        });
	      } else {
	        this.$router.push({
	          name: 'inventory.purchase.view',
	          params: { id: row.excisableId }
	        });
	      }
	    },
	    exportData: function exportData() {
	      var _this4 = this;
	
	      var month = '';
	      if (this.filter.month != null) {
	        month = (0, _moment2.default)(this.filter.month).format('YYYY-MM');
	      }
	
	      var params = {
	        page: this.page,
	        limit: this.limit,
	        month: month,
	        product: this.filter.product,
	        flag: this.flag
	      };
	
	      Promise.all([_exciseEntry2.default.checkFlag(params)]).then(function (data) {
	        params.flag = true;
	        _this4.flag = true;
	        if (data[0].data > 0) {
	          _this4.$message({
	            showClose: true,
	            message: data[0].message,
	            customClass: 'error'
	          });
	          _this4.loading = true;
	          _exciseEntry2.default.entries(params).then(function (data) {
	            _this4.entries = data.report;
	            _this4.pagination = data.pagination;
	            _this4.loading = false;
	          }).catch(function () {
	            _this4.loading = false;
	          });
	        } else {
	          window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/excise_entries/export/', _extends({
	            token: localStorage.getItem('id_token')
	          }, params)));
	        }
	      });
	    },
	    editWarehouse: function editWarehouse(warehouse) {
	      var name = 'warehouse.edit';
	      this.$router.push({
	        name: name,
	        params: { id: warehouse.id }
	      });
	    }
	  })
	};

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _report = __webpack_require__(305);
	
	var _report2 = _interopRequireDefault(_report);
	
	var _exciseEntryModal = __webpack_require__(2702);
	
	var _exciseEntryModal2 = _interopRequireDefault(_exciseEntryModal);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      excisePeriod: {
	        monthName: 'MM/YYYY'
	      },
	      exciseReports: [],
	      helsedirReport: [],
	      infinitumReport: [],
	      exciseDateRange: (0, _moment2.default)(),
	      loadingExcise: false,
	      loading: false,
	      closeLoading: false,
	      activeNames: [0],
	      exciseEntryDate: null,
	      tabIndex: '1'
	    };
	  },
	  created: function created() {
	    this.show();
	  },
	  mounted: function mounted() {
	    this.urlCurrentTab();
	    this.assignTab(this.tabIndex);
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    excisePeriods: 'paginatedExcisePeriods'
	  }), {
	    hasExcise: function hasExcise() {
	      var hasModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name === 'Excise') {
	            hasModule = true;
	          }
	        }
	      }
	      return hasModule;
	    }
	  }),
	
	  watch: {
	    excisePeriod: function excisePeriod(_excisePeriod) {
	      var date = new Date(_excisePeriod.calendarMonth);
	      this.exciseEntryDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2);
	    },
	    $route: function $route() {
	      this.urlCurrentTab();
	    },
	    tabIndex: function tabIndex(value) {
	      this.assignTab(value);
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalSize: 'SET_MODAL_SIZE'
	  }), {
	    assignTab: function assignTab(value) {
	      var tab = '';
	      if (value === '2') {
	        tab = '#entries';
	      } else {
	        tab = '#info';
	      }
	      history.pushState({}, null, '/#' + this.$route.path + tab);
	    },
	    urlCurrentTab: function urlCurrentTab() {
	      if (this.$router.currentRoute.hash === '#entries') {
	        this.tabIndex = '2';
	      } else {
	        this.tabIndex = '1';
	      }
	    },
	    show: function show() {
	      var _this = this;
	
	      this.loading = true;
	      _report2.default.showExcisePeriod(_store2.default.state.route.params.id).then(function (excisePeriod) {
	        _this.excisePeriod = excisePeriod;
	        _this.showReports();
	      });
	    },
	    showReports: function showReports() {
	      var _this2 = this;
	
	      if (this.excisePeriod.calendarMonth != null) {
	        this.exciseReports = [];
	        Promise.all([_report2.default.checkExportFlag(this.excisePeriod.calendarMonth)]).then(function (data) {
	          if (data[0].data > 0) {
	            _this2.loading = false;
	            _this2.$confirm(data[0].message, 'Warning', {
	              confirmButtonText: 'OK',
	              cancelButtonText: 'Cancel',
	              type: 'warning'
	            }).then(function () {
	              _this2.showExciseModal((0, _moment2.default)(_this2.excisePeriod.calendarMonth).format('YYYY-MM'));
	            }).catch(function () {});
	          } else {
	            _this2.showExcise();
	          }
	        }).catch(function () {
	          _this2.loading = false;
	        });
	      } else {
	        this.exciseReports = [];
	        this.loading = false;
	      }
	    },
	    showExcise: function showExcise() {
	      var _this3 = this;
	
	      this.loading = true;
	      Promise.all([_report2.default.excises(this.excisePeriod.calendarMonth), _report2.default.helsedir(this.excisePeriod.calendarMonth), _report2.default.infinitum(this.excisePeriod.calendarMonth)]).then(function (data) {
	        _this3.exciseReports = data[0];
	        _this3.helsedirReport = data[1];
	        _this3.infinitumReport = _typeof(data[2]) === 'object' ? Object.values(data[2]) : [];
	        _this3.loading = false;
	      });
	    },
	    getHelsedirReportByPeriod: function getHelsedirReportByPeriod(period) {
	      var data = this.helsedirReport.find(function (h) {
	        return h.period === period;
	      });
	      return data.entries || null;
	    },
	    getInfinitumReportByPeriod: function getInfinitumReportByPeriod(period) {
	      var data = this.infinitumReport.find(function (h) {
	        return h.period === period;
	      });
	      return data.entries || null;
	    },
	    showExciseModal: function showExciseModal(month) {
	      this.setModalProps({
	        month: month
	      });
	      this.setModalSize('100%');
	      this.toggleModal(true);
	      this.setModalContent(function () {
	        return _exciseEntryModal2.default;
	      });
	    },
	    closePeriod: function closePeriod() {
	      var _this4 = this;
	
	      this.$confirm(this.$t('static.reports.fees.confirm.message'), this.$t('static.reports.fees.confirm.title'), {
	        confirmButtonText: this.$t('static.reports.fees.confirm.button'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _this4.closeLoading = true;
	        _report2.default.closeExcisePeriod(_store2.default.state.route.params.id).then(function (excisePeriod) {
	          _this4.excisePeriod = excisePeriod;
	          _this4.showExcise();
	          _this4.closeLoading = false;
	          _this4.$message({
	            message: _this4.$t('static.reports.fees.closeSuccessMessage'),
	            type: 'success'
	          });
	        });
	      }).catch(function () {});
	    },
	    downloadBrodReport: function downloadBrodReport(closedAt) {
	      var params = {};
	      if (this.excisePeriod.calendarMonth) {
	        params.month = (0, _moment2.default)(this.excisePeriod.calendarMonth).format('YYYY-MM-DD');
	      }
	      params.closed_at = closedAt;
	
	      window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/reports/brod/export/', _extends({
	        token: localStorage.getItem('id_token')
	      }, params)));
	    },
	    downloadExciseReport: function downloadExciseReport(closedAt) {
	      var _this5 = this;
	
	      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'excel';
	
	      var params = {};
	      params.type = type;
	      if (this.excisePeriod.calendarMonth) {
	        params.month = (0, _moment2.default)(this.excisePeriod.calendarMonth).format('YYYY-MM-DD');
	      }
	      params.closed_at = closedAt;
	
	      Promise.all([_report2.default.checkExportFlag(this.excisePeriod.calendarMonth)]).then(function (data) {
	        if (data[0].data > 0) {
	          _this5.showExciseModal((0, _moment2.default)(_this5.excisePeriod.calendarMonth).format('YYYY-MM'));
	        } else {
	          window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/reports/excise_entries/export/', _extends({
	            token: localStorage.getItem('id_token')
	          }, params)));
	        }
	      });
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  }),
	
	  components: {
	    VExciseEntry: __webpack_require__(2701)
	  }
	};

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _material = __webpack_require__(125);
	
	var _material2 = _interopRequireDefault(_material);
	
	var _quickCreate = __webpack_require__(2870);
	
	var _quickCreate2 = _interopRequireDefault(_quickCreate);
	
	var _materialType = __webpack_require__(461);
	
	var _materialType2 = _interopRequireDefault(_materialType);
	
	var _supplier = __webpack_require__(127);
	
	var _supplier2 = _interopRequireDefault(_supplier);
	
	var _unitOfMeasure = __webpack_require__(193);
	
	var _unitOfMeasure2 = _interopRequireDefault(_unitOfMeasure);
	
	var _material3 = __webpack_require__(131);
	
	var _material4 = _interopRequireDefault(_material3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        description: {
	          value: '',
	          type: 'textarea'
	        },
	        materialTypeId: {
	          value: '',
	          type: 'select'
	        },
	        unitMeasureId: {
	          value: '',
	          type: 'select'
	        },
	        supplierId: {
	          value: '',
	          type: 'select'
	        },
	        minimumStockLevel: {
	          value: '',
	          type: 'number'
	        }
	      })
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.form.setQuickForm('supplierId', _quickCreate2.default);
	
	    Promise.all([_materialType2.default.all(), _supplier2.default.all(), _unitOfMeasure2.default.all()]).then(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    materialTypes: 'allMaterialTypes',
	    unitOfMeasures: 'allUnitOfMeasures',
	    suppliers: 'allSuppliers'
	  })),
	
	  methods: {
	    store: function store() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var material = _material4.default.send(this.form.data());
	      _material2.default.store(material).then(function () {
	        _this2.form.loading = false;
	        _this2.$message({
	          message: _this2.$t('static.materials.create.success'),
	          type: 'success'
	        });
	        _this2.$router.push({
	          name: 'production.materials.index'
	        });
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  },
	
	  watch: {
	    materialTypes: function materialTypes(types) {
	      var _this3 = this;
	
	      this.form.setOptions('materialTypeId', types.map(function (c) {
	        return {
	          id: c.id,
	          name: _this3.$t('static.materials.types.' + _this3.camalize(c.name))
	        };
	      }));
	    },
	    unitOfMeasures: function unitOfMeasures(units) {
	      var _this4 = this;
	
	      this.form.setOptions('unitMeasureId', units.items.map(function (c) {
	        return {
	          id: c.id,
	          name: _this4.$t('static.materials.unitOfMeasures.' + _this4.camalize(c.name))
	        };
	      }));
	    },
	    suppliers: function suppliers(_suppliers) {
	      this.form.setOptions('supplierId', _suppliers.items);
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _material = __webpack_require__(125);
	
	var _material2 = _interopRequireDefault(_material);
	
	var _supplier = __webpack_require__(127);
	
	var _supplier2 = _interopRequireDefault(_supplier);
	
	var _material3 = __webpack_require__(131);
	
	var _material4 = _interopRequireDefault(_material3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _materialType = __webpack_require__(461);
	
	var _materialType2 = _interopRequireDefault(_materialType);
	
	var _unitOfMeasure = __webpack_require__(193);
	
	var _unitOfMeasure2 = _interopRequireDefault(_unitOfMeasure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        description: {
	          value: '',
	          type: 'textarea'
	        },
	        materialTypeId: {
	          value: '',
	          type: 'select'
	        },
	        unitMeasureId: {
	          value: '',
	          type: 'select'
	        },
	        supplierId: {
	          value: '',
	          type: 'select'
	        },
	        minimumStockLevel: {
	          value: '',
	          type: 'number'
	        }
	      }),
	      loading: false
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    Promise.all([_materialType2.default.all(), _supplier2.default.all(), _unitOfMeasure2.default.all()]).then(function () {
	      _this.loading = false;
	    });
	    this.show();
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    materials: 'allProductGroups',
	    materialTypes: 'allMaterialTypes',
	    unitOfMeasures: 'allUnitOfMeasures',
	    suppliers: 'allSuppliers'
	  })),
	
	  methods: {
	    update: function update() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var material = _material4.default.send(this.form.data());
	      _material2.default.update(_store2.default.state.route.params.id, material).then(function () {
	        _this2.form.loading = false;
	        _this2.$message({
	          message: _this2.$t('static.materials.edit.success'),
	          type: 'success'
	        });
	        _this2.$router.push({
	          name: 'production.materials.index'
	        });
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      var _this3 = this;
	
	      this.loading = true;
	      _material2.default.show(_store2.default.state.route.params.id).then(function (material) {
	        _this3.form.assignData(material);
	        _this3.loading = false;
	      });
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  },
	
	  watch: {
	    materialTypes: function materialTypes(types) {
	      var _this4 = this;
	
	      this.form.setOptions('materialTypeId', types.map(function (c) {
	        return {
	          id: c.id,
	          name: _this4.$t('static.materials.types.' + _this4.camalize(c.name))
	        };
	      }));
	    },
	    unitOfMeasures: function unitOfMeasures(units) {
	      var _this5 = this;
	
	      this.form.setOptions('unitMeasureId', units.items.map(function (c) {
	        return {
	          id: c.id,
	          name: _this5.$t('static.materials.unitOfMeasures.' + _this5.camalize(c.name))
	        };
	      }));
	    },
	    suppliers: function suppliers(_suppliers) {
	      this.form.setOptions('supplierId', _suppliers.items);
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _material = __webpack_require__(125);
	
	var _material2 = _interopRequireDefault(_material);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _bridgeHandoff = __webpack_require__(81);
	
	var _bridgeHandoff2 = _interopRequireDefault(_bridgeHandoff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sort: '',
	      info: 'info',
	      primary: 'primary',
	      search: ''
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    materials: 'paginatedMaterials',
	    allMaterials: 'allMaterials',
	    view: 'getView',
	    searchQuery: 'materialQuery',
	    account: 'account'
	  }), {
	    materialsListView: function materialsListView() {
	      return this.materials.items.map(function (material) {
	        return {
	          id: material.id,
	          name: material.name + ' - #' + material.id,
	          description: material.description,
	          materialType: material.materialType
	        };
	      });
	    }
	  }),
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19),
	    VTable: __webpack_require__(33)
	  },
	
	  mixins: [_search2.default, _bridgeHandoff2.default],
	
	  watch: {
	    $route: function $route() {
	      this.all(1, 50);
	    },
	    view: function view(_view) {
	      if (_view == 'card') {
	        this.info = 'info';
	        this.primary = 'primary';
	      } else {
	        this.primary = 'info';
	        this.info = 'primary';
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    this.setInnerSidebar([{
	      title: this.$t('static.materials.filters.title'),
	      options: [{
	        title: this.$t('static.materials.filters.active'),
	        route: {
	          name: 'production.materials.index',
	          query: {
	            filter: 'active'
	          }
	        }
	      }, {
	        title: this.$t('static.materials.filters.deactivated'),
	        route: {
	          name: 'production.materials.index',
	          query: {
	            filter: 'deactivated'
	          }
	        }
	      }, {
	        title: this.$t('static.materials.filters.all'),
	        route: {
	          name: 'production.materials.index',
	          query: {
	            filter: 'all'
	          }
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.materials.create.title'),
	        route: {
	          name: 'production.materials.create'
	        }
	      }
	    }, {
	      title: this.$t('static.batches.filters.title'),
	      options: [{
	        title: this.$t('static.batches.filters.notStarted'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'notStarted'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.upcoming'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'upcoming'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.ongoing'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'ongoing'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.completed'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'completed'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.all'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'all'
	          }
	        }
	      }],
	      button: this.bridgeStockWriteBlocked ? null : {
	        title: '+ ' + this.$t('static.batches.create.title'),
	        route: {
	          name: 'production.batches.create'
	        }
	      }
	    }, {
	      title: this.$t('static.recipes.filters.title'),
	      options: [{
	        title: this.$t('static.recipes.filters.all'),
	        route: {
	          name: 'production.recipes.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.recipes.create.title'),
	        route: {
	          name: 'production.recipes.create'
	        }
	      }
	    }, {
	      title: this.$t('static.equipments.title'),
	      options: [{
	        title: this.$t('static.equipments.filters.all'),
	        route: {
	          name: 'production.equipments.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.equipments.create.title'),
	        route: {
	          name: 'production.equipments.create'
	        }
	      }
	    }]);
	
	    this.all(this.searchQuery.page, this.searchQuery.limit);
	    if (this.view == 'card') {
	      this.info = 'info';
	      this.primary = 'primary';
	    } else {
	      this.primary = 'info';
	      this.info = 'primary';
	    }
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    changeView: function changeView(view) {
	      if (this.info != view) {
	        this.primary = this.info;
	        this.info = view;
	        if (this.info == 'info') {
	          _store2.default.dispatch('setView', 'card');
	        } else {
	          _store2.default.dispatch('setView', 'list');
	        }
	      }
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this = this;
	
	      this.loading = true;
	
	      var query = { page: page, limit: limit, search: this.searchQuery.search };
	      _store2.default.dispatch('setMaterialQuery', query);
	      this.search = this.searchQuery.search;
	      _material2.default.items({
	        page: page,
	        limit: limit,
	        search: this.searchQuery.search,
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this.loading = false;
	      }).catch(function () {
	        _this.loading = false;
	      });
	    }, 800),
	
	    onChangeSearch: function onChangeSearch(name, value) {
	      _store2.default.dispatch('setMaterialQuery', { page: 1, limit: 50, search: value });
	      this.all(1, 50);
	    },
	    editMaterial: function editMaterial(material) {
	      this.$router.push({
	        name: 'production.materials.edit',
	        params: { id: material.id }
	      });
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  })
	};

/***/ }),
/* 1909 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _organizationMember = __webpack_require__(463);
	
	var _organizationMember2 = _interopRequireDefault(_organizationMember);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      newMemberForm: {
	        firstname: '',
	        lastname: '',
	        email: ''
	      },
	      newMemberRules: {
	        firstname: [{ required: true, trigger: 'blur' }],
	        lastname: [{ required: true, trigger: 'blur' }],
	        email: [{ required: true, trigger: 'blur' }, { type: 'email', trigger: 'blur' }]
	      }
	    };
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    organization_members: 'allOrganizationMembers'
	  })),
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggle: 'TOGGLE_MODAL',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    addMember: function addMember() {
	      var _this = this;
	
	      this.$refs['newMemberForm'].validate(function (valid) {
	        if (valid) {
	          var exists = _this.organization_members.findIndex(function (x) {
	            return x.user.email == _this.newMemberForm.email.trim();
	          });
	          if (exists > -1) {
	            _this.$message({
	              message: 'Member already exists',
	              type: 'error'
	            });
	          } else {
	            _organizationMember2.default.store(_this.newMemberForm).then(function () {});
	            _this.closeModal();
	          }
	        }
	      });
	    },
	    closeModal: function closeModal() {
	      this.toggle(false);
	      this.unsetModalContent();
	    }
	  })
	};

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vue3 = __webpack_require__(430);
	
	var _vue4 = _interopRequireDefault(_vue3);
	
	var _daygrid = __webpack_require__(284);
	
	var _daygrid2 = _interopRequireDefault(_daygrid);
	
	var _timegrid = __webpack_require__(429);
	
	var _timegrid2 = _interopRequireDefault(_timegrid);
	
	var _interaction = __webpack_require__(795);
	
	var _interaction2 = _interopRequireDefault(_interaction);
	
	var _nb = __webpack_require__(794);
	
	var _nb2 = _interopRequireDefault(_nb);
	
	var _tooltip = __webpack_require__(758);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _create = __webpack_require__(2799);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _create3 = __webpack_require__(2781);
	
	var _create4 = _interopRequireDefault(_create3);
	
	var _organizationMemberProductBusinesshour = __webpack_require__(1136);
	
	var _organizationMemberProductBusinesshour2 = _interopRequireDefault(_organizationMemberProductBusinesshour);
	
	var _organizationMemberBooking = __webpack_require__(464);
	
	var _organizationMemberBooking2 = _interopRequireDefault(_organizationMemberBooking);
	
	var _vuex = __webpack_require__(5);
	
	var _organizationMember = __webpack_require__(463);
	
	var _organizationMember2 = _interopRequireDefault(_organizationMember);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.jQuery = __webpack_require__(578);
	
	exports.default = {
	  components: {
	    FullCalendar: _vue4.default
	  },
	
	  data: function data() {
	    return {
	      calendarPlugins: [_daygrid2.default, _timegrid2.default, _interaction2.default],
	      membersLoading: true,
	      calendarLoading: true,
	      addBooking: false,
	      modalLoading: true,
	      clients: [],
	      events: [],
	      header: {
	        right: 'toggle_view today prev,next '
	      },
	
	      current_tab: 'members',
	      calendar_data_type: 'businesshours',
	      min_time: '06:00',
	      default_view: 'timeGridWeek',
	      start_date: null,
	      end_date: null
	    };
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    organization_settings: 'organizationSettings',
	    organization_members: 'allOrganizationMembers',
	    organization_member_product_businesshours: 'allOrganizationMemberProductBusinessHours',
	    organization_member_bookings: 'allOrganizationMemberBookings'
	  }), {
	    customButtons: function customButtons() {
	      var $this = this;
	      return {
	        toggle_view: {
	          text: this.default_view == 'timeGridWeek' ? 'Vis dag' : 'Vis uke',
	          click: function click() {
	            $this.default_view = $this.default_view == 'timeGridWeek' ? 'timeGridDay' : 'timeGridWeek';
	            $this.$refs.fullCalendar.getApi().changeView($this.default_view);
	          }
	        }
	      };
	    },
	    timeslot_gap: function timeslot_gap() {
	      var timeslot_gap = '00:15';
	      if (this.default_view == 'timeGridDay') {
	        timeslot_gap = '00:10';
	      }
	
	
	      return timeslot_gap;
	    },
	    productMembers: function productMembers() {
	      var organization = {
	        id: '',
	        user: {
	          full_name: this.account.firstName + ' ' + this.account.lastName + ' (Organization)'
	        }
	      };
	      var product_members = [organization];
	      return product_members;
	
	      if (this.newBookingForm.product_id) {
	        var $this = this;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = this.organization_members[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var om = _step.value;
	
	            if (om.organization_member_products.findIndex(function (x) {
	              return x.product_id == $this.newBookingForm.product_id;
	            }) > -1) {
	              product_members.push(om);
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        ;
	      }
	
	      return product_members;
	    },
	    memberProducts: function memberProducts() {
	      var member_products = [];
	      return member_products;
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = this.organization_members[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var om = _step2.value;
	
	          om.organization_member_products.forEach(function (omp) {
	            if (member_products.findIndex(function (x) {
	              return x.product_id == omp.product_id;
	            }) == -1) {
	              member_products.push(omp);
	            }
	          });
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      ;
	
	      return member_products;
	    }
	  }),
	
	  watch: {
	    current_tab: function current_tab(tab) {
	      switch (tab) {
	        case 'members':
	          this.membersLoading = true;
	          this.getMembers();
	          window.history.pushState('', '', '/#/members/');
	          this.$route.query.tab = this.$route.query.data = '';
	          break;
	
	        case 'calendar_schedule':
	          this.calendar_data_type = this.$route.query.data || 'businesshours';
	          this.calendarLoading = true;
	          this.getSchedule();
	          break;
	      }
	    },
	
	    calendar_data_type: function calendar_data_type(type) {
	      this.calendarLoading = true;
	      this.getSchedule();
	    },
	
	    '$route': function $route(route) {
	      if (route.query.tab == 'calendar' && route.query.data == 'bookings') {
	        this.current_tab = 'calendar_schedule';
	        this.calendar_data_type = 'bookings';
	      }
	    }
	  },
	
	  created: function created() {
	    this.start_date = (0, _moment2.default)().day('monday').format('YYYY-MM-DD');
	    this.end_date = (0, _moment2.default)((0, _moment2.default)().day('monday').toDate()).add(6, 'days').format('YYYY-MM-DD');
	
	    if (this.mobilecheck()) {
	      this.default_view = 'timeGridDay';
	    }
	    if (this.$route.query.tab == 'calendar' && this.$route.query.data == 'bookings') {
	      this.current_tab = 'calendar_schedule';
	      this.calendar_data_type = 'bookings';
	    }
	  },
	  mounted: function mounted() {
	    this.getMembers();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    updateBookingEvents: function updateBookingEvents() {
	      if (this.current_tab == 'calendar_schedule' && this.calendar_data_type == 'bookings') {
	        var calendarApi = this.$refs.fullCalendar.getApi();
	
	        var start_date = (0, _moment2.default)(calendarApi.state.dateProfile.activeRange.start).format('YYYY-MM-DD');
	        var end_date = (0, _moment2.default)(calendarApi.state.dateProfile.activeRange.end).format('YYYY-MM-DD');
	
	        if (start_date != this.start_date || end_date != this.end_date) {
	          this.start_date = start_date;
	          this.end_date = end_date;
	
	          this.getSchedule();
	        }
	      }
	    },
	    mobilecheck: function mobilecheck() {
	      var check = false;
	      (function (a) {
	        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
	      })(navigator.userAgent || navigator.vendor || window.opera);
	      return check;
	    },
	    handleEventClick: function handleEventClick(e) {
	      if (this.current_tab == 'calendar_schedule' && this.calendar_data_type == 'bookings') {
	
	        var $this = this;
	        console.log(e);
	        var event = {
	          id: e.event.id,
	          product_id: e.event.extendedProps.product_id,
	          member_id: e.event.extendedProps.member_id,
	          client_id: e.event.extendedProps.client_id,
	          date: e.event.extendedProps.data_date,
	          start_time: e.event.extendedProps.start_time,
	          end_time: e.event.extendedProps.end_time,
	          order_id: e.event.extendedProps.order_id,
	          order_number: e.event.extendedProps.order_number,
	          order_status: e.event.extendedProps.order_status
	
	        };
	        this.setModalProps({
	          action: 'EDIT',
	          date: e.event.start,
	          event: event,
	          onUpdate: function onUpdate(event) {
	            var index = $this.events.findIndex(function (x) {
	              return x.id == event.id;
	            });
	            if (index > -1) {
	              for (var key in event) {
	                $this.events[index][key] = event[key];
	              }
	            }
	          }
	        });
	        this.setModalContent(function () {
	          return _create4.default;
	        });
	        this.setModalCloseOnClick(false);
	        this.setModalShowClose(true);
	        this.setModalCloseOnPressEscape(false);
	        this.toggleModal(true);
	        window.jQuery('.tooltip').css('visibility', 'hidden');
	      }
	    },
	    handleSlotClick: function handleSlotClick(e) {
	      if (this.current_tab == 'calendar_schedule' && this.calendar_data_type == 'bookings') {
	        var $this = this;
	        this.setModalProps({
	          date: e.date,
	          action: 'ADD',
	          onStore: function onStore(event) {
	            $this.events.push(event);
	          }
	        });
	        this.setModalContent(function () {
	          return _create4.default;
	        });
	        this.setModalCloseOnClick(false);
	        this.setModalShowClose(true);
	        this.setModalCloseOnPressEscape(false);
	        this.toggleModal(true);
	      }
	    },
	    resetForm: function resetForm(form) {
	      for (var key in this[form]) {
	        this[form][key] = '';
	      }
	    },
	    selectAllow: function selectAllow(e) {
	      if ((0, _moment2.default)(e.end).diff(e.start, 'minutes') > 30) {
	        return false;
	      }
	      return true;
	    },
	    showToolTip: function showToolTip(info) {
	      var time = (0, _moment2.default)(info.event.start).format('H:mm') + ' - ' + (0, _moment2.default)(info.event.end).format('H:mm');
	      var template = '';
	      if (this.calendar_data_type == 'businesshours') {
	        template = '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div>' + time + '</div>';
	      } else if (this.calendar_data_type == 'bookings') {
	        var product = 'Product: ' + info.event.extendedProps.productName;
	        var member = 'Practitioner: ' + info.event.extendedProps.memberName;
	        var status = 'Status: ' + info.event.extendedProps.status;
	        template = '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div>' + time + '<div><small>' + product + '</small></div><div><small>' + member + '</small></div><div><small>' + status + '</small></div></div>';
	      }
	      var tooltip = new _tooltip2.default(info.el, {
	        title: info.event.title,
	        placement: 'top',
	        trigger: 'hover',
	        container: 'body',
	        html: true,
	        template: template
	      });
	    },
	    resetFields: function resetFields() {
	      this.$refs['newMemberForm'].resetFields();
	      this.member_firstname = this.member_lastname = this.member_email = '';
	    },
	    addMember: function addMember() {
	      this.setModalContent(function () {
	        return _create2.default;
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(true);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    getMembers: function getMembers() {
	      var _this = this;
	
	      _organizationMember2.default.all().then(function () {
	        _this.membersLoading = false;
	      });
	    },
	    getSchedule: function getSchedule() {
	      var _this2 = this;
	
	      var events = [];
	      switch (this.calendar_data_type) {
	        case 'businesshours':
	          _organizationMemberProductBusinesshour2.default.all().then(function () {
	            _this2.calendarLoading = false;
	            _this2.organization_member_product_businesshours.forEach(function (s) {
	              events.push({
	                title: s.organizationMemberProduct.organization_member.user.full_name,
	                daysOfWeek: (0, _moment2.default)().locale('en').day(s.day).format('d'),
	                startTime: s.startTime,
	                endTime: s.endTime,
	                backgroundColor: s.organizationMemberProduct.organization_member.color,
	                borderColor: s.organizationMemberProduct.organization_member.color
	              });
	            });
	            _this2.events = events;
	          });
	          break;
	        case 'bookings':
	
	          _organizationMemberBooking2.default.all(this.start_date, this.end_date).then(function () {
	            _this2.calendarLoading = false;
	            _this2.organization_member_bookings.forEach(function (s) {
	
	              events.push({
	                id: s.id,
	                product_id: s.order.order_products.length > 0 ? s.order.order_products[0].product_id : '',
	                member_id: s.organizationMemberProduct ? s.organizationMemberProduct.organization_member_id : '',
	                client_id: s.order.client_id,
	                data_date: s.date,
	                start_time: s.startTime,
	                end_time: s.endTime,
	                status: s.status,
	                order_id: s.order.id,
	                order_number: s.order.number,
	                order_status: s.order.order_status.name,
	                title: s.order.client.name || s.order.client.client_contact.email,
	                productName: s.order.order_products.length > 0 ? s.order.order_products[0].name : '',
	                memberName: s.organizationMemberProduct ? s.organizationMemberProduct.organization_member.user.full_name : s.order.organization.name,
	                start: s.date + ' ' + s.startTime,
	                end: s.date + ' ' + s.endTime,
	                backgroundColor: s.organizationMemberProduct ? s.organizationMemberProduct.organization_member.color : '#777777',
	                borderColor: s.organizationMemberProduct ? s.organizationMemberProduct.organization_member.color : '#777777'
	              });
	            });
	            _this2.events = events;
	          });
	
	          break;
	      }
	    },
	    navigateTab: function navigateTab(tab) {
	      var new_tab = tab.label.toLowerCase();
	
	      if (new_tab != this.current_tab) {
	        switch (new_tab) {
	          case 'members':
	            this.membersLoading = true;
	            this.getMembers();
	            break;
	
	          case 'schedule':
	            break;
	        }
	      }
	    },
	    acceptStatus: function acceptStatus(member) {
	      var status = '';
	
	      if (member.isAccepted == 1) {
	        status = 'ACTIVE';
	      } else {
	        status = 'PENDING';
	      }
	      return status;
	    },
	    formatDate: function formatDate(date) {
	      if (!date) return '';
	      return (0, _moment2.default)(date).format('MMM DD, YYYY');
	    }
	  })
	};

/***/ }),
/* 1912 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      organization_products: [],
	      member: null,
	      timeslot_gap: '00:10',
	
	      addProduct: false,
	      new_product_id: null,
	      deleteMemberProduct: false,
	      product_delete_id: '',
	
	      deleteMember: false,
	
	      addTimeVisible: false,
	      day: '',
	      start_time: '',
	      end_time: '',
	
	      selected_product: null,
	
	      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
	    };
	  },
	
	  computed: {
	    acceptStatus: function acceptStatus() {
	      var status = '';
	      if (this.member.is_accepted) {
	        status = 'ACTIVE';
	      } else {
	        status = 'PENDING';
	      }
	      return status;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    _vue2.default.$http.get('/organization_members/' + this.$route.params.id).then(function (data) {
	      _this.member = data.data.organization_member;
	      _this.organization_products = data.data.organization_products;
	      _this.timeslot_gap = '00:' + data.data.organization.organization_settings.timeslot_gap;
	      _this.loading = false;
	    });
	  },
	
	
	  methods: {
	    confirmDeleteMemberProduct: function confirmDeleteMemberProduct() {
	      var _this2 = this;
	
	      if (this.product_delete_id) {
	        var index = this.member.organization_member_products.findIndex(function (x) {
	          return x.id === _this2.product_delete_id;
	        });
	        if (index > -1) {
	          this.selected_product = null;
	          this.member.organization_member_products.splice(index, 1);
	          this.deleteMemberProduct = false;
	
	          _vue2.default.$http.delete('organization_member_products/' + this.product_delete_id).then(function (data) {
	            _this2.product_delete_id = '';
	            _this2.$message({
	              message: 'Product has been deleted',
	              type: 'success'
	            });
	          });
	        }
	      }
	    },
	    confirmDeleteMember: function confirmDeleteMember() {
	      var _this3 = this;
	
	      _vue2.default.$http.delete('organization_members/' + this.member.id).then(function (data) {
	        _this3.$router.push('/members');
	      });
	    },
	    setDay: function setDay(day) {
	      this.day = day;
	    },
	    removeHour: function removeHour(id) {
	      var _this4 = this;
	
	      _vue2.default.$http.delete('organization_member_product_businesshours/' + id).then(function (data) {
	        _this4.selected_product.business_hours.splice(_this4.selected_product.business_hours.findIndex(function (x) {
	          return x.id == id;
	        }), 1);
	      });
	    },
	    confirmAddTime: function confirmAddTime() {
	      var _this5 = this;
	
	      if (this.start_time && this.end_time) {
	        _vue2.default.$http.post('organization_member_product_businesshours', {
	          'organization_member_product_id': this.selected_product.id,
	          'day': this.day,
	          'start_time': this.start_time,
	          'end_time': this.end_time
	        }).then(function (data) {
	          _this5.selected_product.business_hours.push(data.data);
	        });
	        this.addTimeVisible = false;
	        this.start_time = this.end_time = '';
	      }
	    },
	    showAddHour: function showAddHour(index) {
	      var _this6 = this;
	
	      this.addTimeVisible = true;
	      this.$nextTick(function (_) {
	        _this6.$refs.saveTagInput[index].$refs.reference.focus();
	      });
	    },
	    getHours: function getHours(product, day) {
	      return product.business_hours.filter(function (x) {
	        return x.day == day;
	      });
	    },
	    selectProduct: function selectProduct(product) {
	      this.day = '';
	      this.selected_product = product;
	    },
	    addNewProduct: function addNewProduct() {
	      var _this7 = this;
	
	      if (this.new_product_id) {
	        if (this.member.organization_member_products.findIndex(function (x) {
	          return x.product_id == _this7.new_product_id;
	        }) > -1) {
	          this.$message({
	            message: 'Product already exists',
	            type: 'error'
	          });
	        } else {
	          this.addProduct = false;
	          _vue2.default.$http.post('/organization_member_products', {
	            organization_member_id: this.member.id,
	            product_id: this.new_product_id
	          }).then(function (data) {
	            _this7.member.organization_member_products.push(data.data);
	          });
	        }
	      }
	    },
	    updateColor: function updateColor(color) {
	      var _this8 = this;
	
	      this.$message({
	        message: 'Color updated successfully',
	        type: 'success'
	      });
	      this.update().then(function (data) {
	        _this8.member.color = data.color;
	      });
	    },
	    update: function update() {
	      var _this9 = this;
	
	      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt('return', _vue2.default.$http.put('/organization_members/' + _this9.$route.params.id, _this9.member).then(function (data) {
	                  _this9.loading = false;
	                  return data.data;
	                }));
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this9);
	      }))();
	    }
	  }
	};

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vue3 = __webpack_require__(430);
	
	var _vue4 = _interopRequireDefault(_vue3);
	
	var _daygrid = __webpack_require__(284);
	
	var _daygrid2 = _interopRequireDefault(_daygrid);
	
	var _timegrid = __webpack_require__(429);
	
	var _timegrid2 = _interopRequireDefault(_timegrid);
	
	var _tooltip = __webpack_require__(758);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _vuex = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.jQuery = __webpack_require__(578);
	
	exports.default = {
	  components: {
	    FullCalendar: _vue4.default
	  },
	
	  data: function data() {
	    return {
	      calendarPlugins: [_timegrid2.default],
	      organizationsLoading: true,
	      calendarLoading: true,
	      organizations: [],
	      organization_settings: null,
	      events: [],
	
	      current_tab: 'organizations',
	      calendar_data_type: 'businesshours',
	      api_location: '',
	      min_time: '06:00'
	    };
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)(['account']), {
	    timeslot_gap: function timeslot_gap() {
	      var timeslot_gap = '00:15';
	
	
	      return timeslot_gap;
	    }
	  }),
	
	  watch: {
	    current_tab: function current_tab(tab) {
	      switch (tab) {
	        case 'organizations':
	          this.organizationsLoading = true;
	          this.getMembers();
	          break;
	
	        case 'calendar_schedule':
	          this.calendar_data_type = 'businesshours';
	          this.calendarLoading = true;
	          this.getSchedule();
	          break;
	      }
	    },
	
	    calendar_data_type: function calendar_data_type(type) {
	      this.calendarLoading = true;
	      this.getSchedule();
	    }
	  },
	
	  mounted: function mounted() {
	    this.api_location = ("https://api.kundan.no") + '/';
	    this.getMembers();
	  },
	
	
	  methods: {
	    getMembers: function getMembers() {
	      var _this = this;
	
	      _vue2.default.$http.get('/membership/organization_members').then(function (data) {
	        _this.organization_members = data.data;
	        _this.organizationsLoading = false;
	      });
	    },
	    showToolTip: function showToolTip(info) {
	      var time = (0, _moment2.default)(info.event.start).format('H:mm') + ' - ' + (0, _moment2.default)(info.event.end).format('H:mm');
	      var template = '';
	      if (this.calendar_data_type == 'businesshours') {
	        template = '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div>' + time + '</div>';
	      } else if (this.calendar_data_type == 'bookings') {
	        var product = 'Product: ' + info.event.extendedProps.productName;
	        var organization = 'Organization: ' + info.event.extendedProps.organizationName;
	        template = '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div>' + time + '<div><small>' + product + '</small></div><div><small>' + organization + '</small></div></div>';
	      }
	      var tooltip = new _tooltip2.default(info.el, {
	        title: info.event.title,
	        placement: 'top',
	        trigger: 'hover',
	        container: 'body',
	        html: true,
	        template: template
	      });
	    },
	    getSchedule: function getSchedule() {
	      var _this2 = this;
	
	      _vue2.default.$http.get('/membership/calendar?type=' + this.calendar_data_type).then(function (data) {
	        var events = [];
	        var min_time = '00:00';
	        data.data.forEach(function (s) {
	          switch (_this2.calendar_data_type) {
	            case 'businesshours':
	              events.push({
	                title: s.organization_member_product.organization_member.organization.name,
	                daysOfWeek: (0, _moment2.default)().day(s.day).format('d'),
	                startTime: s.start_time,
	                endTime: s.end_time,
	                backgroundColor: s.organization_member_product.organization_member.color,
	                borderColor: s.organization_member_product.organization_member.color
	              });
	              break;
	
	            case 'bookings':
	              events.push({
	                id: s.id,
	                product_id: s.organization_member_product.product_id,
	                member_id: s.organization_member_product.organization_member_id,
	                client_id: s.client_id,
	                data_date: s.date,
	                start_time: s.start_time,
	                end_time: s.end_time,
	
	                title: s.client.name,
	                productName: s.organization_member_product.product.name,
	                organizationName: s.organization_member_product.organization_member.organization.name,
	                start: s.date + ' ' + s.start_time,
	                end: s.date + ' ' + s.end_time,
	                backgroundColor: s.organization_member_product.organization_member.color,
	                borderColor: s.organization_member_product.organization_member.color
	              });
	              break;
	          }
	        });
	
	        _this2.events = events;
	        _this2.calendarLoading = false;
	      });
	    },
	    navigateTab: function navigateTab(tab) {
	      var new_tab = tab.label.toLowerCase();
	
	      if (new_tab != this.current_tab) {
	        switch (new_tab) {
	          case 'members':
	            this.organizationsLoading = true;
	            this.getMembers();
	            break;
	
	          case 'schedule':
	            break;
	        }
	      }
	    },
	    formatDate: function formatDate(date) {
	      if (!date) return '';
	      return (0, _moment2.default)(date).format('MMM DD, YYYY');
	    }
	  }
	};

/***/ }),
/* 1915 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      organization_products: [],
	      member: null,
	      timeslot_gap: '00:10',
	
	      addProduct: false,
	      new_product_id: null,
	      deleteMemberProduct: false,
	      product_delete_id: '',
	
	      deleteMember: false,
	
	      addTimeVisible: false,
	      day: '',
	      start_time: '',
	      end_time: '',
	
	      selected_product: null,
	
	      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
	    };
	  },
	
	  computed: {
	    acceptStatus: function acceptStatus() {
	      var status = '';
	      if (this.member.is_accepted) {
	        status = 'ACTIVE';
	      } else {
	        status = 'PENDING';
	      }
	      return status;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    _vue2.default.$http.get('/membership/member/' + this.$route.params.id).then(function (data) {
	      _this.member = data.data.organization_member;
	      _this.organization_products = data.data.organization_products;
	      _this.timeslot_gap = '00:' + data.data.organization_member.organization.organization_settings.timeslot_gap;
	      _this.loading = false;
	    });
	  },
	
	
	  methods: {
	    formatDate: function formatDate(date) {
	      if (!date) return '';
	      return (0, _moment2.default)(date).format('MMM DD, YYYY');
	    },
	    setDay: function setDay(day) {
	      this.day = day;
	    },
	    removeHour: function removeHour(id) {
	      var _this2 = this;
	
	      _vue2.default.$http.delete('/membership/member/business_hours/' + id).then(function (data) {
	        _this2.selected_product.business_hours.splice(_this2.selected_product.business_hours.findIndex(function (x) {
	          return x.id == id;
	        }), 1);
	      });
	    },
	    confirmAddTime: function confirmAddTime() {
	      var _this3 = this;
	
	      if (this.start_time && this.end_time) {
	        _vue2.default.$http.post('/membership/member/' + this.member.id + '/business_hours', {
	          'organization_member_product_id': this.selected_product.id,
	          'day': this.day,
	          'start_time': this.start_time,
	          'end_time': this.end_time
	        }).then(function (data) {
	          _this3.selected_product.business_hours.push(data.data);
	        });
	        this.addTimeVisible = false;
	        this.start_time = this.end_time = '';
	      }
	    },
	    showAddHour: function showAddHour(index) {
	      var _this4 = this;
	
	      this.addTimeVisible = true;
	      this.$nextTick(function (_) {
	        _this4.$refs.saveTagInput[index].$refs.reference.focus();
	      });
	    },
	    getHours: function getHours(product, day) {
	      return product.business_hours.filter(function (x) {
	        return x.day == day;
	      });
	    },
	    selectProduct: function selectProduct(product) {
	      this.day = '';
	      this.selected_product = product;
	    }
	  }
	};

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _modules = __webpack_require__(44);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _subscribeModal = __webpack_require__(2740);
	
	var _subscribeModal2 = _interopRequireDefault(_subscribeModal);
	
	var _components = __webpack_require__(851);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _wooCredentialsModal = __webpack_require__(2756);
	
	var _wooCredentialsModal2 = _interopRequireDefault(_wooCredentialsModal);
	
	var _wordpressCredentialsModal2 = __webpack_require__(2757);
	
	var _wordpressCredentialsModal3 = _interopRequireDefault(_wordpressCredentialsModal2);
	
	var _unimicroCredentialsModal2 = __webpack_require__(2742);
	
	var _unimicroCredentialsModal3 = _interopRequireDefault(_unimicroCredentialsModal2);
	
	var _powerofficeCredentialsModal2 = __webpack_require__(2725);
	
	var _powerofficeCredentialsModal3 = _interopRequireDefault(_powerofficeCredentialsModal2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sortValue: ''
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    modules: 'allModules'
	  }), {
	    modulesList: function modulesList() {
	      var listM = [];
	
	      for (var i = 0; i < this.modules.length; i++) {
	        var flag = false;
	        var index = 0;
	        for (var c = 0; c < listM.length; c++) {
	          if (listM[c].group === this.modules[i].group) {
	            flag = true;
	            index = c;
	          }
	        }
	
	        if (!flag) {
	          listM.push({
	            group: this.modules[i].group,
	            modules: [this.modules[i]]
	          });
	        } else {
	          listM[index].modules.push(this.modules[i]);
	        }
	      }
	
	      return listM;
	    }
	  }),
	
	  mounted: function mounted() {
	    var _this = this;
	
	    _modules2.default.items().then(function () {
	      _this.loading = false;
	      if (_this.$route.query.name) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this.modulesList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var m = _step.value;
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	              for (var _iterator2 = m.modules[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var mdl = _step2.value;
	
	                if (mdl.name === _this.$route.query.name) {
	                  _this.subscribe(mdl);
	                  break;
	                }
	              }
	            } catch (err) {
	              _didIteratorError2 = true;
	              _iteratorError2 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	              } finally {
	                if (_didIteratorError2) {
	                  throw _iteratorError2;
	                }
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	    });
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    updateFields: function updateFields(mod) {
	      if (mod.name === 'WordPress') {
	        this.wordpressCredentialsModal(mod);
	      } else if (mod.name === 'WordPress WooCommerce') {
	        this.woocommerceCredentialsModal(mod);
	      } else if (mod.name === 'UniMicro') {
	        this.unimicroCredentialsModal(mod);
	      } else if (mod.name === 'PowerOffice') {
	        this.powerofficeCredentialsModal(mod);
	      } else if (mod.fields !== null && mod.fields.length > 0 || mod.component) {
	        this.showSubscribeModal(mod);
	      }
	    },
	    subscribe: function subscribe(mod) {
	      console.log(mod.name);
	      if (mod.fields !== null && mod.fields.length > 0 || mod.component) {
	        this.showSubscribeModal(mod);
	      } else if (mod.name === 'WordPress') {
	        this.wordpressCredentialsModal(mod);
	      } else if (mod.name === 'WordPress WooCommerce') {
	        this.woocommerceCredentialsModal(mod);
	      } else {
	        this.$confirm(this.$t('static.module.warning.subscribe'), 'Warning', {
	          confirmButtonText: 'OK',
	          cancelButtonText: 'Cancel',
	          type: 'warning'
	        }).then(function () {
	          _modules2.default.subscribe(mod.id, { module_id: mod.id }).then(function () {
	            Promise.all([_modules2.default.items(), _account2.default.find()]);
	          });
	        }).catch(function () {});
	      }
	    },
	    showSubscribeModal: function showSubscribeModal(module) {
	      this.setModalProps({ module: module });
	
	      this.setModalCloseOnClick(false);
	      this.setModalCloseOnPressEscape(false);
	
	      var component = _subscribeModal2.default;
	      if (module.component) {
	        component = _components2.default[module.component];
	      }
	
	      this.setModalContent(function () {
	        return component;
	      });
	      this.toggleModal(true);
	    },
	    unsubscribe: function unsubscribe(id) {
	      this.$confirm(this.$t('static.module.warning.unsubscribe'), 'Warning', {
	        confirmButtonText: 'OK',
	        cancelButtonText: 'Cancel',
	        type: 'warning'
	      }).then(function () {
	        _modules2.default.unsubscribe(id).then(function () {
	          Promise.all([_modules2.default.items(), _account2.default.find()]);
	        });
	      }).catch(function () {});
	    },
	    woocommerceCredentialsModal: function woocommerceCredentialsModal(value) {
	      this.setModalContent(function () {
	        return _wooCredentialsModal2.default;
	      });
	      this.setModalProps({ mod: value });
	      this.setModalCloseOnClick(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    wordpressCredentialsModal: function wordpressCredentialsModal(value) {
	      this.setModalContent(function () {
	        return _wordpressCredentialsModal3.default;
	      });
	      this.setModalProps({ mod: value });
	      this.setModalCloseOnClick(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    unimicroCredentialsModal: function unimicroCredentialsModal(value) {
	      this.setModalContent(function () {
	        return _unimicroCredentialsModal3.default;
	      });
	      this.setModalProps({ mod: value });
	      this.setModalCloseOnClick(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    powerofficeCredentialsModal: function powerofficeCredentialsModal(value) {
	      this.setModalContent(function () {
	        return _powerofficeCredentialsModal3.default;
	      });
	      this.setModalProps({ mod: value });
	      this.setModalCloseOnClick(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    }
	  }),
	
	  mixins: [_search2.default],
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19)
	  }
	};

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  components: {
	    VLayout: __webpack_require__(280)
	  }
	};

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _news = __webpack_require__(298);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _campaign = __webpack_require__(185);
	
	var _campaign2 = _interopRequireDefault(_campaign);
	
	var _news3 = __webpack_require__(109);
	
	var _news4 = _interopRequireDefault(_news3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        subject: {
	          value: '',
	          type: 'text'
	        },
	        sendAfterDate: {
	          value: '',
	          type: 'date'
	        },
	        sendAfterTime: {
	          value: '',
	          type: 'time'
	        },
	        sendAfter: {
	          value: '',
	          type: 'number'
	        },
	        body: {
	          value: '',
	          type: 'editor'
	        },
	        newsCampaignId: {
	          value: this.$route.params.id,
	          type: 'hidden'
	        }
	      }),
	      campaign: {},
	      loading: true,
	      sending: false
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _campaign2.default.show(this.$route.params.id).then(function (campaign) {
	      _this.loading = false;
	      _this.campaign = campaign;
	      if (campaign.campaignType === 'Sequence') {
	        _this.form.hideField('sendAfterDate');
	        _this.form.hideField('sendAfterTime');
	      } else {
	        _this.form.hideField('sendAfter');
	      }
	    });
	  },
	
	
	  methods: {
	    store: function store() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var data = this.form.data();
	      data.sendAfterDate = data.sendAfterDate ? (0, _moment2.default)(data.sendAfterDate).format('YYYY-MM-DD') + ' ' + data.sendAfterTime : '';
	      var news = _news4.default.send(data);
	      _news2.default.store(news).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    },
	    test: function test() {
	      var _this3 = this;
	
	      this.sending = true;
	      _news2.default.test(_news4.default.send(this.form.data())).then(function () {
	        _this3.sending = false;
	        _this3.$message({
	          showClose: true,
	          message: _this3.$t('static.news.create.sendTestSucess'),
	          type: 'success'
	        });
	      }).catch(function (error) {
	        _this3.sending = false;
	        if (error.response.data) {
	          _this3.form.recordErrors(_news4.default.fetch(error.response.data));
	        }
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _news = __webpack_require__(298);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _campaign = __webpack_require__(185);
	
	var _campaign2 = _interopRequireDefault(_campaign);
	
	var _news3 = __webpack_require__(109);
	
	var _news4 = _interopRequireDefault(_news3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        subject: {
	          value: '',
	          type: 'text'
	        },
	        sendAfterDate: {
	          value: '',
	          type: 'date'
	        },
	        sendAfterTime: {
	          value: '',
	          type: 'time'
	        },
	        sendAfter: {
	          value: '',
	          type: 'number'
	        },
	        body: {
	          value: '',
	          type: 'editor'
	        },
	        newsCampaignId: {
	          value: this.$route.params.id,
	          type: 'hidden'
	        }
	      }),
	      campaign: {},
	      loading: true,
	      sending: false
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    Promise.all([_news2.default.show(this.$route.params.newsId), _campaign2.default.show(this.$route.params.id)]).then(function (data) {
	      _this.loading = false;
	      _this.form.assignData(Object.assign(data[0], {
	        sendAfterTime: (0, _moment2.default)(data[0].sendAfterDate).format('HH:mm')
	      }));
	      _this.form.newsCampaignId = _this.$route.params.id;
	      _this.campaign = data[1];
	      if (_this.campaign.campaignType === 'Sequence') {
	        _this.form.hideField('sendAfterDate');
	        _this.form.hideField('sendAfterTime');
	      } else {
	        _this.form.hideField('sendAfter');
	      }
	    });
	  },
	
	
	  methods: {
	    update: function update() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var data = this.form.data();
	      data.sendAfterDate = data.sendAfterDate ? (0, _moment2.default)((0, _moment2.default)(data.sendAfterDate).format('YYYY-MM-DD') + ' ' + data.sendAfterTime).format() : '';
	      var news = _news4.default.send(data);
	      _news2.default.update(this.$route.params.newsId, news).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    },
	    test: function test() {
	      var _this3 = this;
	
	      this.sending = true;
	      _news2.default.test(_news4.default.send(this.form.data())).then(function () {
	        _this3.sending = false;
	        _this3.$message({
	          showClose: true,
	          message: _this3.$t('static.news.create.sendTestSucess'),
	          type: 'success'
	        });
	      }).catch(function (error) {
	        _this3.sending = false;
	        if (error.response.data) {
	          _this3.form.recordErrors(_news4.default.fetch(error.response.data));
	        }
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _orderPickup = __webpack_require__(1120);
	
	var _orderPickup2 = _interopRequireDefault(_orderPickup);
	
	var _shippingProvider = __webpack_require__(97);
	
	var _shippingProvider2 = _interopRequireDefault(_shippingProvider);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = {
	  data: function data() {
	    return {
	      shippingProviderOptions: [],
	      shippingProvider: 'All',
	      statusOptions: [{
	        id: 'All',
	        name: this.$t('static.orderPickups.index.shippingStatuses.all')
	      }, {
	        id: 'New',
	        name: this.$t('static.orderPickups.index.shippingStatuses.new')
	      }, {
	        id: 'Picked',
	        name: this.$t('static.orderPickups.index.shippingStatuses.picked')
	      }, {
	        id: 'In Transit',
	        name: this.$t('static.orderPickups.index.shippingStatuses.inTransit')
	      }, {
	        id: 'Delivered',
	        name: this.$t('static.orderPickups.index.shippingStatuses.delivered')
	      }, {
	        id: 'Cancelled',
	        name: this.$t('static.orderPickups.index.shippingStatuses.cancelled')
	      }],
	      status: 'All',
	      search: '',
	      defaulExpand: false,
	      loading: true,
	      limit: 25
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    orderPickups: 'paginatedOrderPickups'
	  }), {
	    orderPickupTable: function orderPickupTable() {
	      var _this = this;
	
	      return this.orderPickups.items.map(function (item) {
	        return {
	          id: item.id,
	          orderId: item.orderId,
	          organizationId: item.organizationId,
	          shippingProviderId: item.shippingProviderId,
	          shippingStatusId: item.shippingStatusId,
	          number: item.number,
	          organization: item.organization,
	          shippingProvider: item.shippingProvider,
	          shippingStatus: item.shippingStatus === 'In Transit' ? _this.$t('static.orderPickups.index.shippingStatuses.inTransit') : _this.$t('static.orderPickups.index.shippingStatuses.' + item.shippingStatus.toLowerCase()),
	          pickupPriority: item.pickupPriority,
	          note: item.note,
	          pickupBy: item.pickupBy,
	          pickupDate: item.pickupDate ? (0, _moment2.default)(item.pickupDate).format('D/M/Y') : null,
	          shippingDate: item.shippingDate ? (0, _moment2.default)(item.shippingDate).format('D/M/Y') : null,
	          deliveryDate: item.deliveryDate ? (0, _moment2.default)(item.deliveryDate).format('D/M/Y') : null,
	          createdAt: (0, _moment2.default)(item.createdAt).format('D/M/Y'),
	          trackingUrl: item.trackingUrl,
	          customerName: item.customerName
	        };
	      });
	    },
	    hasEdiModule: function hasEdiModule() {
	      var modules = this.account.modules.map(function (m) {
	        return m.name;
	      });
	      return modules.indexOf('EDI') > -1;
	    },
	    hasAppointmentModule: function hasAppointmentModule() {
	      var modules = this.account.modules.map(function (m) {
	        return m.name;
	      });
	      return modules.indexOf('Appointment') > -1;
	    }
	  }),
	
	  watch: {
	    $route: function $route() {
	      this.all(1, this.limit);
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), (_extends2 = {
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'order_pickups', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    buildInnerSidebar: function buildInnerSidebar() {
	      var sidebar = [{
	        title: this.$t('layouts.sidebar.orders'),
	        options: [{
	          title: this.$t('layouts.sidebar.products'),
	          route: {
	            name: 'orders.index',
	            query: {
	              filter: 'Product'
	            }
	          }
	        }, {
	          title: this.$t('layouts.sidebar.services'),
	          route: {
	            name: 'orders.index',
	            query: {
	              filter: 'Service'
	            }
	          }
	        }, {
	          title: this.$t('layouts.sidebar.all'),
	          route: {
	            name: 'orders.index'
	          }
	        }],
	        button: {
	          title: '+ ' + this.$t('static.orders.create.title'),
	          route: {
	            name: 'orders.create'
	          }
	        }
	      }];
	
	      if (this.hasAppointmentModule) {
	        sidebar.push({
	          title: this.$t('layouts.sidebar.booking'),
	          options: [{
	            title: this.$t('layouts.sidebar.upcoming'),
	            route: {
	              name: 'appointments.index',
	              query: {
	                appointment: 'upcoming'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.done'),
	            route: {
	              name: 'appointments.index',
	              query: {
	                appointment: 'done'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.calendar'),
	            route: {
	              name: 'appointments.index',
	              query: {
	                appointment: 'calendar'
	              }
	            }
	          }],
	          button: {
	            title: '+ ' + this.$t('static.appointments.create.title'),
	            route: {
	              name: 'orders.create'
	            }
	          }
	        });
	      }
	
	      if (this.hasEdiModule) {
	        sidebar.push({
	          title: this.$t('layouts.sidebar.orderFilter'),
	          options: [{
	            title: this.$t('layouts.sidebar.newOrders'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'created'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.confirmed'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'confirmed'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.inTransit'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'processed'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.recieved'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'received'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.invoiced'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'invoiced'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.credited'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'credited'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.cancelled'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'cancelled'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.complete'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'completed'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.all'),
	            route: {
	              name: 'orders.index'
	            }
	          }]
	        });
	      }
	
	      sidebar.push({
	        title: this.$t('layouts.sidebar.orderPickups.title'),
	        options: [{
	          title: this.$t('layouts.sidebar.orderPickups.viewAll'),
	          route: {
	            name: 'orderPickups.index',
	            query: {
	              filter: 'all'
	            }
	          }
	        }]
	      });
	
	      this.setInnerSidebar(sidebar);
	    },
	    destroyed: function destroyed() {
	      this.unsetInnerSidebar();
	      _store2.default.dispatch('resetOrders');
	    },
	
	
	    onChangeSearch: function onChangeSearch(name, value) {
	      _store2.default.dispatch('setOrderPickupQuery', { page: 1, limit: this.limit, search: value });
	      this.all(1, this.limit);
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this3 = this;
	
	      this.defaulExpand = false;
	      this.loading = true;
	
	      var params = {
	        page: page,
	        limit: limit,
	        search: this.search,
	        status: this.status,
	        shippingProvider: this.shippingProvider
	      };
	      _orderPickup2.default.items(params).then(function () {
	        _this3.loading = false;
	        if (_this3.$route.params.number) {
	          _this3.defaulExpand = true;
	          _this3.$route.params.number = null;
	        } else {
	          _this3.defaulExpand = false;
	        }
	      }).catch(function () {
	        _this3.loading = false;
	      });
	    }, 800)
	
	  }, _defineProperty(_extends2, 'onChangeSearch', function onChangeSearch(name, value) {
	    this.search = value;
	    this.all(1, this.limit);
	  }), _defineProperty(_extends2, 'providerList', function providerList() {
	    var _this4 = this;
	
	    Promise.all([_shippingProvider2.default.all({})]).then(function (data) {
	      console.log(data[0]);
	      _this4.shippingProviderOptions = data[0].map(function (item) {
	        return { id: item.id, name: item.name };
	      });
	      _this4.shippingProviderOptions.unshift({ id: 'All', name: _this4.$t('static.shippingProviderAll') });
	    }).catch(function (error) {
	      console.log(error);
	    });
	  }), _defineProperty(_extends2, 'rowClicked', function rowClicked(row) {
	    this.$refs.orderPickupData.toggleRowExpansion(row);
	  }), _extends2)),
	
	  created: function created() {
	    var _this5 = this;
	
	    this.buildInnerSidebar();
	    this.providerList();
	
	    _account2.default.rememberPerPage('get', { from: 'order_pickups' }).then(function (data) {
	      _this5.limit = data.size;
	      _this5.all(1, _this5.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	
	    if (this.$route.params.number) {
	      this.search = this.$route.params.number;
	    }
	  },
	
	
	  components: {
	    VPagination: __webpack_require__(16),
	    VSelect: __webpack_require__(51)
	  },
	
	  mixins: [_search2.default]
	
	};

/***/ }),
/* 1922 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _vuex = __webpack_require__(5);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _orderType = __webpack_require__(300);
	
	var _orderType2 = _interopRequireDefault(_orderType);
	
	var _order = __webpack_require__(54);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _batch = __webpack_require__(60);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _project = __webpack_require__(190);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        clientId: {
	          type: 'select',
	          value: ''
	        },
	        orderTypeId: {
	          value: '',
	          type: 'select'
	        },
	        projectId: {
	          type: 'select',
	          value: ''
	        },
	        createdAt: {
	          type: 'date',
	          value: ''
	        },
	        date: {
	          type: 'date',
	          value: ''
	        },
	        time: {
	          type: 'time',
	          value: ''
	        },
	        duration: {
	          type: 'number',
	          value: ''
	        },
	        details: {
	          type: 'textarea',
	          value: ''
	        }
	      }),
	      loading: true,
	      contentLoading: false,
	      hasProduction: false,
	      errors: []
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    clients: 'allClientOptions',
	    products: 'allProducts',
	    orderTypes: 'orderTypes',
	    warehouses: 'allWarehouses',
	    batches: 'allBatches',
	    account: 'account',
	    settings: 'organizationSettings',
	    allProjects: 'allProjects'
	  })),
	
	  watch: {
	    allProjects: function allProjects(_allProjects) {
	      var options = _allProjects.map(function (project) {
	        return {
	          id: project.id,
	          name: project.name
	        };
	      });
	      this.form.setOptions('projectId', [{ id: 0, name: ' ' }].concat(_toConsumableArray(options)));
	    },
	
	
	    'form.clientId': function formClientId(clientId) {
	      var client = this.clients.find(function (item) {
	        return item.id === parseInt(clientId);
	      });
	      if (typeof client !== 'undefined') {
	        this.form.setFieldValue('projectId', client.projectId);
	      } else {
	        this.form.setFieldValue('projectId', 0);
	      }
	    },
	
	    clients: function clients(_clients) {
	      this.form.setOptions('clientId', _clients.map(function (c) {
	        return { id: c.id, name: c.companyName || c.firstName + ' ' + c.lastName };
	      }));
	    },
	    account: function account(_account) {
	      var hasInventory = false;
	      if (_account.modules.length > 0) {
	        for (var i = 0; i < _account.modules.length; i++) {
	          if (_account.modules[i].name === 'Inventory') {
	            hasInventory = true;
	          }
	        }
	      }
	      if (hasInventory) {
	        this.form.hideField('warehouseId');
	      }
	    },
	    products: function products(_products) {
	      var hasInventory = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            hasInventory = true;
	          }
	        }
	      }
	
	      this.form.setOptions('productId', _products.map(function (c) {
	        return { id: c.id, name: c.name + ' ' };
	      }));
	    },
	    batches: function batches(_batches) {
	      this.form.setOptions('batchId', _batches.map(function (c) {
	        return {
	          id: c.id,
	          name: c.code
	        };
	      }));
	    },
	    warehouses: function warehouses(_warehouses) {
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            this.form.setOptions('warehouseId', _warehouses.items);
	          }
	        }
	      }
	    },
	    orderTypes: function orderTypes(_orderTypes) {
	      var _this = this;
	
	      if (!_orderTypes.length) return;
	
	      var types = _orderTypes.filter(function (t) {
	        return t.name !== 'EDI';
	      });
	      if (types.length === 1) {
	        this.form.hideField('orderTypeId');
	        this.form.orderTypeId = types[0].id;
	        return;
	      }
	
	      types = types.map(function (allowedType) {
	        return {
	          id: allowedType.id,
	          name: _this.$t('static.orders.types.' + allowedType.name.toLowerCase())
	        };
	      });
	      this.form.orderTypeId = types[0].id;
	      this.form.setOptions('orderTypeId', types);
	    },
	
	    'form.orderTypeId': function formOrderTypeId(typeId) {
	      var type = this.orderTypes.filter(function (t) {
	        return typeId.toString() === t.id.toString();
	      })[0];
	
	      if (type.name === 'Appointment') {
	        this.showAppointmentConfig();
	        Promise.all([_product2.default.all()]).then(function () {});
	      } else {}
	    },
	
	    'form.warehouseId': function formWarehouseId(warehouseId) {
	      var _this2 = this;
	
	      this.contentLoading = true;
	      if (this.hasProduction) {
	        Promise.all([_batch2.default.all({ warehouse_id: warehouseId, for_select: 1 })]).then(function () {
	          _this2.contentLoading = false;
	        });
	      }
	    },
	
	    'form.productId': function formProductId(product) {
	      var _this3 = this;
	
	      if (product.id && this.hasProduction) {
	        this.contentLoading = true;
	        Promise.all([_batch2.default.all({
	          warehouse_id: this.form.warehouseId,
	          product_id: product.id,
	          for_select: 1
	        })]).then(function () {
	          if (_this3.batches.length) {
	            _this3.form.batchId = _this3.batches[0].id;
	          } else {
	            _this3.form.batchId = null;
	          }
	          _this3.contentLoading = false;
	        });
	      }
	    }
	  },
	
	  created: function created() {
	    var _this4 = this;
	
	    this.hideAppointmentConfig();
	    this.loading = true;
	    this.form.createdAt = (0, _moment2.default)().format('YYYY-MM-DD');
	
	    Promise.all([_organizationSettings2.default.show(), _client2.default.allOptions(), _warehouse2.default.all(), _orderType2.default.all(), _batch2.default.all({ has_warehouse_transaction: 1, for_select: 1 }), _project2.default.all()]).then(function (data) {
	      _this4.loading = false;
	      _this4.form.setDisplays('productId', data[0].productInfoDisplay);
	      _this4.form.warehouseId = _this4.settings.defaultWarehouse;
	      var self = _this4;
	      _this4.$nextTick(function () {
	        self.$refs.form.$refs.clientId.$refs.clientId.$el.click();
	      });
	      _this4.checkProjectModule();
	    });
	  },
	
	
	  methods: {
	    checkProjectModule: function checkProjectModule() {
	      this.form.hideField('projectId');
	      var hasProject = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name === 'Project') {
	            hasProject = true;
	          }
	        }
	      }
	      if (hasProject) {
	        this.form.showField('projectId');
	      }
	    },
	    showAppointmentConfig: function showAppointmentConfig() {
	      this.form.showField('date');
	      this.form.showField('time');
	      this.form.showField('duration');
	      this.form.showField('details');
	      this.form.hideField('warehouseId');
	      this.form.hideField('projectId');
	    },
	    searchMethod: function searchMethod(search, field) {
	      this.form.setAttrValue('productId', 'loading', true);
	
	
	      return Promise.all([_product2.default.search({ search: search, filter: 'active', warehouse_id: this.form.warehouseId })]);
	    },
	    hideAppointmentConfig: function hideAppointmentConfig() {
	      this.form.hideField('date');
	      this.form.hideField('time');
	      this.form.hideField('duration');
	      this.form.hideField('details');
	
	      var hasInventory = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            hasInventory = true;
	          }
	          if (this.account.modules[i].name === 'Production') {
	            this.hasProduction = true;
	          }
	        }
	      }
	      if (this.account.allowProducerBatches) {
	        this.hasProduction = true;
	      }
	
	      if (!hasInventory) {
	        this.form.hideField('warehouseId');
	      }
	      if (!this.hasProduction) {
	        this.form.hideField('batchId');
	      }
	    },
	    store: function store() {
	      var _this5 = this;
	
	      this.form.loading = true;
	      var data = this.form.data();
	      _order2.default.store(data).then(function (r) {
	        _this5.$router.push({
	          name: 'orders.edit',
	          params: {
	            id: r.id
	          }
	        });
	      }).catch(function (errors) {
	        _this5.form.recordErrors(errors);
	        _this5.form.loading = false;
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _vuex = __webpack_require__(5);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _orderType = __webpack_require__(300);
	
	var _orderType2 = _interopRequireDefault(_orderType);
	
	var _order = __webpack_require__(54);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _store2 = __webpack_require__(2);
	
	var _store3 = _interopRequireDefault(_store2);
	
	var _invoice = __webpack_require__(229);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	var _ediOrder = __webpack_require__(187);
	
	var _ediOrder2 = _interopRequireDefault(_ediOrder);
	
	var _orderProduct = __webpack_require__(48);
	
	var _orderProduct2 = _interopRequireDefault(_orderProduct);
	
	var _packageUnitType = __webpack_require__(1161);
	
	var _packageUnitType2 = _interopRequireDefault(_packageUnitType);
	
	var _package = __webpack_require__(188);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _packageOrderProduct = __webpack_require__(189);
	
	var _packageOrderProduct2 = _interopRequireDefault(_packageOrderProduct);
	
	var _country = __webpack_require__(66);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _project = __webpack_require__(190);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _date = __webpack_require__(107);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _orderConfirmShipping = __webpack_require__(2720);
	
	var _orderConfirmShipping2 = _interopRequireDefault(_orderConfirmShipping);
	
	var _ediOrderConfirmShipping = __webpack_require__(2697);
	
	var _ediOrderConfirmShipping2 = _interopRequireDefault(_ediOrderConfirmShipping);
	
	var _orderConfirm = __webpack_require__(774);
	
	var _orderConfirm2 = _interopRequireDefault(_orderConfirm);
	
	var _ediOrderConfirm = __webpack_require__(277);
	
	var _ediOrderConfirm2 = _interopRequireDefault(_ediOrderConfirm);
	
	var _orderWarehousePopup = __webpack_require__(417);
	
	var _orderWarehousePopup2 = _interopRequireDefault(_orderWarehousePopup);
	
	var _invoiceExternalPopup = __webpack_require__(2713);
	
	var _invoiceExternalPopup2 = _interopRequireDefault(_invoiceExternalPopup);
	
	var _order3 = __webpack_require__(491);
	
	var _order4 = _interopRequireDefault(_order3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        orderTypeId: {
	          value: '',
	          type: 'select'
	        },
	        projectId: {
	          value: '',
	          type: 'select'
	        },
	        clientId: {
	          value: '',
	          type: 'select'
	        },
	        date: {
	          value: '',
	          type: 'date'
	        },
	        time: {
	          value: '',
	          type: 'time'
	        },
	        duration: {
	          value: '',
	          type: 'number'
	        },
	        details: {
	          value: '',
	          type: 'textarea'
	        },
	        referenceNumber: {
	          value: '',
	          type: 'text'
	        },
	        internalNote: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      ediForm: new _forms2.default({
	        deliveryDate: {
	          value: '',
	          type: 'date'
	        }
	      }),
	      ediNon220Form: new _forms2.default({
	        orderNumber: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      packageForm: new _forms2.default({
	        packageUnitTypeId: {
	          value: '',
	          type: 'select'
	        },
	        packingLevel: {
	          value: '',
	          type: 'select'
	        },
	        parentId: {
	          value: '',
	          type: 'select'
	        },
	        sscc: {
	          value: '',
	          type: 'text'
	        },
	        orderId: {
	          value: '',
	          type: 'hidden'
	        }
	      }),
	      successMessage: '',
	      showModal: false,
	      loading: false,
	      loadingConfirm: false,
	      loadingProcess: false,
	      cancelLoading: false,
	      isEDIOrder: false,
	      loadingClient: false,
	      tabIndex: '1',
	      hasInventory: false,
	      dropdownState: false,
	      dropdownStateDelivery: false,
	      dropdownStateInvoice: false,
	      hasProduction: false,
	      nextOrderId: null,
	      previousOrderId: null,
	      trackingUrl: '#',
	      orderType: '',
	      orderConfirmNotification: false,
	      selectedPaperSize: '102x192mm',
	      paperSizes: [{ value: '102x192mm', name: '102x192mm' }, { value: 'A4', name: 'A4' }, { value: 'A5', name: 'A5' }, { value: 'A6', name: 'A6' }]
	    };
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    clients: 'allClientOptions',
	    orders: 'allOrders',
	    orderTypes: 'orderTypes',
	    currentOrder: 'currentOrder',
	    currentEdiOrder: 'currentEdiOrder',
	    orderProducts: 'allOrderProducts',
	    packageUnitTypes: 'allPackageUnitTypes',
	    parentIds: 'deliveryPackages',
	    packages: 'deliveryPackages',
	    packageOrderProducts: 'allPackageOrderProducts',
	    account: 'account',
	    orderEvents: 'orderEvents',
	    countries: 'allCountries',
	    allProjects: 'allProjects'
	  }), {
	    warehouseOption: function warehouseOption() {
	      if (this.currentOrder.orderType !== 'Wordpress' && (this.currentOrder.orderStatus === 'created' || this.currentOrder.orderStatus === 'out_of_stock' || this.currentOrder.orderStatus === 'received')) {
	        return true;
	      }
	      if (this.currentOrder.warehouseId === 0) {
	        return true;
	      }
	      return false;
	    },
	    currentWarehouse: function currentWarehouse() {
	      if (this.currentOrder.warehouse.name !== 'undefined' && this.currentOrder.warehouse.isActive === true) {
	        return this.currentOrder.warehouse.name;
	      }
	      return '';
	    },
	    bill: function bill() {
	      return this.currentOrder.bills.filter(function (b) {
	        return b.billTypeId === 1;
	      })[0] || {};
	    },
	    bills: function bills() {
	      return this.currentOrder.bills.filter(function (b) {
	        return b.billTypeId === 1;
	      });
	    },
	    creditNotes: function creditNotes() {
	      return this.currentOrder.bills.filter(function (b) {
	        return b.billTypeId === 2;
	      });
	    },
	    isConsideredEDICreditNote: function isConsideredEDICreditNote() {
	      return this.currentOrder.orderType === 'EDI' && (this.currentEdiOrder.ediOrderTypeName === 'ZKA' || this.currentEdiOrder.ediOrderTypeName === 'ZRE');
	    },
	    canCancelOrder: function canCancelOrder() {
	      if (this.currentOrder.orderType === 'EDI') {
	        return !this.isReadyToBeConfirmed;
	      }
	      if (this.currentOrder.orderType === 'Wordpress') {
	        return false;
	      }
	      return ['created', 'pending', 'out_of_stock', 'confirmed', 'shipping_confirmed'].includes(this.currentOrder.orderStatus);
	    },
	    canCancelEdiOrder: function canCancelEdiOrder() {
	      return ['received', 'created', 'pending', 'out_of_stock', 'confirmed', 'processed', 'shipping_confirmed'].includes(this.currentEdiOrder.ediOrderStatusName);
	    },
	    isEdiConfirmed: function isEdiConfirmed() {
	      return this.currentEdiOrder.ediOrderStatusName === 'confirmed' || this.currentEdiOrder.ediOrderStatusName === 'shipping_confirmed';
	    },
	    isEdiProcessed: function isEdiProcessed() {
	      return this.currentEdiOrder.ediOrderStatusName === 'processed';
	    },
	    canConfirmOrder: function canConfirmOrder() {
	      if (['created', 'pending', 'out_of_stock'].includes(this.currentOrder.orderStatus) && !['EDI', 'Wordpress'].includes(this.currentOrder.orderType)) {
	        return true;
	      }
	
	      return false;
	    },
	    canConfirmAsOrdered: function canConfirmAsOrdered() {
	      if (this.currentOrder.orderType === 'EDI') {
	        if (['created', 'pending', 'out_of_stock'].includes(this.currentEdiOrder.ediOrderStatusName) && this.currentOrder.orderType === 'EDI' && this.is220 && (this.isReadyToBeConfirmed || this.hasUnconfirmedOrderProduct)) {
	          return true;
	        }
	
	        if (this.checkHasInventory && this.is220 && this.currentEdiOrder.ediOrderStatusName === 'received' && !this.currentEdiOrder.hasOrderConfirmation) {
	          return true;
	        }
	      }
	
	      return false;
	    },
	    ediOrderHasPodButNotConfirmed: function ediOrderHasPodButNotConfirmed() {
	      if (this.checkHasInventory && this.is220 && this.currentEdiOrder.ediOrderStatusName === 'received' && !this.currentEdiOrder.hasOrderConfirmation) {
	        return true;
	      }
	      return false;
	    },
	    canCreateInvoice: function canCreateInvoice() {
	      if (this.currentOrder.ediOrderId) {
	        if (this.currentOrder.isAsko || this.currentOrder.isRema || this.currentOrder.isCoop) {
	          return this.currentEdiOrder.ediOrderStatusName === 'shipping_confirmed';
	        }
	
	        if (this.checkHasInventory && !this.currentEdiOrder.hasOrderConfirmation && this.is220 && this.currentEdiOrder.ediOrderStatusName === 'received') {
	          return false;
	        }
	
	        return this.isZNB || this.is220 && this.currentEdiOrder.ediOrderStatusName === 'received';
	      }
	
	      if (['Transfer'].includes(this.currentOrder.orderType)) {
	        return false;
	      }
	
	      return this.currentOrder.orderStatus !== 'cancelled';
	    },
	    canCreateCreditNote: function canCreateCreditNote() {
	      if (this.currentOrder.ediOrderId) {
	        return (this.isZRE || this.isZKA) && !this.currentOrder.isBilled && !this.isEdiOrderCancelled;
	      }
	
	      return false;
	    },
	    isCancelled: function isCancelled() {
	      return this.currentOrder.orderStatus === 'cancelled';
	    },
	    isEdiOrderCancelled: function isEdiOrderCancelled() {
	      return this.currentEdiOrder.ediOrderStatusName === 'cancelled';
	    },
	    isAskoAndBilled: function isAskoAndBilled() {
	      return this.currentOrder.isAsko && this.currentOrder.isBilled;
	    },
	    isAppointmentCompleted: function isAppointmentCompleted() {
	      var order = this.currentOrder;
	      if (order.orderType !== 'Appointment') return false;
	      var now = (0, _moment2.default)();
	      var end = (0, _moment2.default)(order.date + ' ' + order.time).add(order.duration, 'minutes');
	      return now.isAfter(end);
	    },
	    currentClient: function currentClient() {
	      var client = Object.assign({}, this.currentOrder.client);
	      if (this.currentOrder.orderType === 'EDI') {
	        client.streetName = this.currentEdiOrder.ediStoreStreet || client.streetName;
	        client.postalCode = this.currentEdiOrder.ediStorePostCode || client.postalCode;
	      }
	      if (client.countryId) {
	        client.country = this.countries.items.find(function (item) {
	          return item.id === client.countryId;
	        }).name;
	      }
	
	      return client;
	    },
	    isZRE: function isZRE() {
	      return this.currentEdiOrder.ediOrderTypeName === 'ZRE';
	    },
	    isZKA: function isZKA() {
	      return this.currentEdiOrder.ediOrderTypeName === 'ZKA';
	    },
	    isZNB: function isZNB() {
	      return this.currentEdiOrder.ediOrderTypeName === 'ZNB';
	    },
	    is220: function is220() {
	      return this.currentEdiOrder.ediOrderTypeName === '220';
	    },
	    checkHasInventory: function checkHasInventory() {
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    },
	    isReadyToBeConfirmed: function isReadyToBeConfirmed() {
	      if (this.orderProducts.some(function (orderProduct) {
	        return orderProduct.quantityConfirmed > 0;
	      })) {
	        return ['created', 'pending', 'out_of_stock'].includes(this.currentEdiOrder.ediOrderStatusName);
	      }
	
	      return false;
	    },
	    hasUnconfirmedOrderProduct: function hasUnconfirmedOrderProduct() {
	      if (this.currentOrder.orderType == 'EDI') {
	        if (this.orderProducts.some(function (orderProduct) {
	          return orderProduct.quantityConfirmed === null;
	        })) {
	          return true;
	        }
	      }
	
	      return false;
	    },
	    hasCancelledOrderProduct: function hasCancelledOrderProduct() {
	      if (this.orderProducts.some(function (orderProduct) {
	        return orderProduct.quantityConfirmed === 0;
	      })) {
	        return true;
	      }
	
	      return false;
	    },
	    hasEdiOrderSource: function hasEdiOrderSource() {
	      return this.currentEdiOrder.ediOrderSource > 0;
	    },
	    unassignedProducts: function unassignedProducts() {
	      return this.orderProducts.filter(function (op) {
	        return op.quantityConfirmed != op.quantityPacked;
	      });
	    },
	    hasExciseModule: function hasExciseModule() {
	      var hasExciseModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Excise') {
	            hasExciseModule = true;
	          }
	        }
	      }
	      return hasExciseModule;
	    },
	    hasBevearageProducts: function hasBevearageProducts() {
	      return this.orderProducts.filter(function (p) {
	        return p.productType === 'Beverage' || p.productTypeGroup === 'Beverage';
	      }).length > 0;
	    }
	  }),
	
	  watch: {
	    allProjects: function allProjects(_allProjects) {
	      var options = _allProjects.map(function (project) {
	        return {
	          id: project.id,
	          name: project.name
	        };
	      });
	      this.form.setOptions('projectId', [{ id: 0, name: ' ' }].concat(_toConsumableArray(options)));
	    },
	
	    '$route.params.id': function $routeParamsId() {
	      this.show();
	    },
	
	    orderTypes: function orderTypes() {
	      this.manageOrderTypes();
	      this.toggleAppointmentConfig();
	    },
	
	    'form.orderTypeId': function formOrderTypeId() {
	      this.toggleAppointmentConfig();
	    },
	
	    currentOrder: function currentOrder() {
	      var _this = this;
	
	      this.orderType = this.currentOrder.orderType ? this.currentOrder.orderType.toLowerCase() : '';
	      this.manageOrderTypes();
	      if (this.currentOrder.orderType && this.currentOrder.orderType.toLowerCase() === 'edi') {
	        this.hideAppointmentConfig();
	        this.form.hideField('clientId');
	        this.form.hideField('orderTypeId');
	        this.isEDIOrder = true;
	        if (this.currentOrder.ediOrderId > 0) {
	          Promise.all([_ediOrder2.default.show(this.currentOrder.ediOrderId), _package2.default.all(this.currentOrder.id), _packageOrderProduct2.default.all(this.currentOrder.id)]).then(function () {
	            _this.ediForm.deliveryDate = _this.currentEdiOrder.requestedDeliveryDate ? new Date((0, _moment2.default)(_this.currentEdiOrder.requestedDeliveryDate).format('D/M/Y')) : new Date();
	          });
	        }
	      }
	    },
	    clients: function clients(_clients) {
	      this.form.setOptions('clientId', _clients.map(function (c) {
	        return { name: c.companyName || c.firstName + ' ' + c.lastName, id: c.id };
	      }));
	    },
	
	
	    packageUnitTypes: {
	      handler: function handler(packageUnitTypes) {
	        this.packageForm.setOptions('packageUnitTypeId', packageUnitTypes.all || []);
	      },
	
	      immediate: true
	    },
	
	    parentIds: function parentIds(_parentIds) {
	      this.packageForm.setOptions('parentId', _parentIds.all.filter(function (p) {
	        return p.packingLevel == 2;
	      }));
	    },
	
	    'packageForm.packingLevel': function packageFormPackingLevel(typeId) {
	      if (typeId.toString() == 2) {
	        this.packageForm.hideField('parentId');
	      } else if (typeId.toString() == 3) {
	        this.packageForm.showField('parentId');
	      }
	    }
	  },
	
	  created: function created() {
	    var self = this;
	    window.addEventListener('click', function (e) {
	      if (_helpers2.default.closeDropdown(e, self.dropdownState) === false) self.dropdownState = false;
	      if (_helpers2.default.closeDropdown(e, self.dropdownStateDelivery) === false) self.dropdownStateDelivery = false;
	      if (_helpers2.default.closeDropdown(e, self.dropdownStateInvoice) === false) self.dropdownStateInvoice = false;
	    });
	
	    this.show();
	    this.initializePackageForm();
	  },
	  destroyed: function destroyed() {
	    this.resetEdiOrder();
	    this.resetOrder();
	  },
	
	
	  methods: _extends({
	    checkProjectModule: function checkProjectModule() {
	      this.form.hideField('projectId');
	      var hasProject = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name === 'Project') {
	            hasProject = true;
	          }
	        }
	      }
	      if (hasProject) {
	        this.form.showField('projectId');
	      }
	    },
	    completeReturnOrder: function completeReturnOrder() {
	      var _this2 = this;
	
	      _order2.default.completeReturnOrder(this.currentOrder.id).then(function () {
	        _this2.$message({
	          showClose: true,
	          message: _this2.$t('static.ediOrders.edit.returnSuccess'),
	          type: 'success'
	        });
	        Promise.all([_order2.default.show(_store3.default.state.route.params.id)]);
	      });
	    },
	    createReturnOrder: function createReturnOrder() {
	      var _this3 = this;
	
	      _order2.default.returnOrder(this.currentOrder.id).then(function (response) {
	        _this3.$router.push({
	          name: 'orders.edit',
	          params: {
	            id: response.id
	          }
	        });
	      });
	    }
	  }, (0, _vuex.mapMutations)({
	    resetEdiOrder: 'RESET_CURRENT_EDI_ORDER',
	    resetOrder: 'RESET_CURRENT_ORDER',
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalClass: 'SET_MODAL_CLASS',
	    setModalProps: 'SET_MODAL_PROPS'
	  }), {
	    activateInvoiceExternalModal: function activateInvoiceExternalModal() {
	      this.setModalContent(function () {
	        return _invoiceExternalPopup2.default;
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    activateWarehouseModal: function activateWarehouseModal() {
	      this.setModalContent(function () {
	        return _orderWarehousePopup2.default;
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    activateModal: function activateModal() {
	      this.setModalContent(function () {
	        return _orderConfirmShipping2.default;
	      });
	      this.setModalProps({
	        warehouseId: this.currentOrder.warehouse.id,
	        orderConfirmNotification: this.orderConfirmNotification
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(true);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    activateModalEDI: function activateModalEDI() {
	      this.setModalContent(function () {
	        return _ediOrderConfirmShipping2.default;
	      });
	      this.setModalProps({
	        warehouseId: this.currentOrder.warehouse.id
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(true);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    showConfirmModalShipping: function showConfirmModalShipping() {
	      if (this.currentOrder.orderType != 'EDI') {
	        this.activateModal();
	      } else {
	        this.activateModalEDI();
	      }
	    },
	    activateModalEdi: function activateModalEdi() {
	      this.setModalClass('order-confirm');
	      this.setModalContent(function () {
	        return _ediOrderConfirm2.default;
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(true);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    activateModalConfirm: function activateModalConfirm() {
	      this.setModalClass('order-confirm');
	      this.setModalContent(function () {
	        return _orderConfirm2.default;
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(true);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    showShippingOrder: function showShippingOrder(value) {
	      var routeData = this.$router.resolve({ name: 'orderPickups.index', query: { number: value } });
	      window.open(routeData.href, '_blank');
	    },
	    scrollWindow: function scrollWindow() {
	      var container = this.$el.querySelector('.main-body');
	      container.scrollTop = container.scrollHeight;
	    },
	    toggleAppointmentConfig: function toggleAppointmentConfig() {
	      var _this4 = this;
	
	      var type = this.orderTypes.filter(function (t) {
	        return _this4.form.orderTypeId.toString() === t.id.toString();
	      });
	
	      if (type.length === 0) {
	        return;
	      }
	
	      if (type[0].name === 'Appointment') {
	        this.showAppointmentConfig();
	      } else {
	        this.hideAppointmentConfig();
	      }
	
	      return;
	    },
	    manageOrderTypes: function manageOrderTypes() {
	      var _this5 = this;
	
	      if (Object.keys(this.currentOrder).length === 0 || this.orderTypes.length === 0) {
	        return;
	      }
	
	      var type = this.orderTypes.filter(function (t) {
	        return _this5.currentOrder.orderTypeId.toString() === t.id.toString();
	      });
	
	      if (type.length > 0 && type[0].name === 'EDI') {
	        this.form.hideField('orderTypeId');
	        this.form.orderTypeId = type[0].id;
	        return;
	      }
	
	      var allowedTypes = this.orderTypes.filter(function (t) {
	        return t.name !== 'EDI';
	      });
	      if (allowedTypes.length === 1) {
	        this.form.hideField('orderTypeId');
	        this.form.orderTypeId = allowedTypes[0].id;
	        return;
	      }
	
	      allowedTypes = allowedTypes.map(function (allowedType) {
	        return {
	          id: allowedType.id,
	          name: _this5.$t('static.orders.types.' + allowedType.name.toLowerCase())
	        };
	      });
	
	      this.form.setOptions('orderTypeId', allowedTypes);
	    },
	    showAppointmentConfig: function showAppointmentConfig() {
	      this.form.showField('date');
	      this.form.showField('time');
	      this.form.showField('duration');
	      this.form.showField('details');
	      this.form.hideField('projectId');
	    },
	    hideAppointmentConfig: function hideAppointmentConfig() {
	      this.form.hideField('date');
	      this.form.hideField('time');
	      this.form.hideField('duration');
	      this.form.hideField('details');
	    },
	    store: function store() {
	      var _this6 = this;
	
	      this.form.loading = true;
	      _order2.default.update(_store3.default.state.route.params.id, this.form.data()).then(function () {
	        _this6.form.loading = false;
	        _this6.successMessage = _this6.$t('static.orders.edit.successMessage');
	        setTimeout(function () {
	          _this6.successMessage = '';
	        }, 3000);
	      }).catch(function (errors) {
	        _this6.form.loading = false;
	        _this6.form.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      var _this7 = this;
	
	      this.loading = true;
	      var requests = [_order2.default.show(_store3.default.state.route.params.id), _order2.default.getNextPreviousId(_store3.default.state.route.params.id), _order2.default.events(_store3.default.state.route.params.id), _project2.default.all()];
	      if (!this.countries || this.countries && !this.countries.items.length) {
	        requests.push(_country2.default.all());
	      }
	      if (!this.packageUnitTypes.all.length) {
	        requests.push(_packageUnitType2.default.all());
	      }
	      if (!this.orderTypes.length) {
	        requests.push(_orderType2.default.all());
	      }
	      if (!this.clients.length) {
	        requests.push(_client2.default.allOptions());
	      }
	      Promise.all(requests).then(function (data) {
	        _this7.form.assignData(data[0]);
	        _this7.nextOrderId = data[1].next;
	        _this7.previousOrderId = data[1].previous;
	        _this7.loading = false;
	        _this7.checkProjectModule();
	      });
	    },
	    confirm: function confirm() {
	      if (this.currentOrder.orderType != 'EDI') {
	        this.activateModalConfirm();
	      } else {
	        this.activateModalEdi();
	      }
	    },
	    cancel: function cancel() {
	      var _this8 = this;
	
	      this.$confirm(this.$t('static.ediOrders.edit.confirmCancel'), this.$t('static.orders.index.confirmCancelTitle'), {
	        confirmButtonText: this.$t('button.yes'),
	        cancelButtonText: this.$t('button.no'),
	        type: 'warning'
	      }).then(function () {
	        _this8.cancelLoading = true;
	        _ediOrder2.default.cancel(_this8.currentEdiOrder.id, _this8.form.data()).then(function (data) {
	          _this8.cancelLoading = false;
	          if (data.xml) {
	            _this8.$msgbox({
	              title: 'XML',
	              message: data.xml,
	              customClass: 'xmlModalCustomClass'
	            });
	          } else {
	            _this8.$message({
	              showClose: true,
	              message: _this8.$t('static.ediOrders.edit.cancelSuccess'),
	              type: 'success'
	            });
	          }
	          _orderProduct2.default.all(_this8.currentOrder.id);
	        }).catch(function () {
	          _this8.cancelLoading = false;
	          _this8.$message({
	            showClose: true,
	            message: _this8.$t('static.ediOrders.edit.cancelError'),
	            customClass: 'error'
	          });
	        });
	      }).catch(function () {});
	    },
	    process: function process() {
	      var _this9 = this;
	
	      this.loadingProcess = true;
	      _ediOrder2.default.process(this.currentEdiOrder.id, this.form.data()).then(function (data) {
	        _this9.loadingProcess = false;
	        if (data.xml) {
	          _this9.$msgbox({
	            title: 'XML',
	            message: data.xml,
	            customClass: 'xmlModalCustomClass'
	          });
	        } else {
	          _this9.$message({
	            showClose: true,
	            message: _this9.$t('static.ediOrders.edit.processSuccess'),
	            type: 'success'
	          });
	        }
	      }).catch(function () {
	        _this9.loadingProcess = false;
	        _this9.$message({
	          showClose: true,
	          message: _this9.$t('static.ediOrders.edit.processError'),
	          type: 'error'
	        });
	      });
	    },
	    showPrintableDeliveryNote: function showPrintableDeliveryNote() {
	      _invoice2.default.showDeliveryNote(this.currentOrder.hashid);
	    },
	    downloadPrintableDeliveryNote: function downloadPrintableDeliveryNote() {
	      _invoice2.default.downloadDeliveryNote(this.currentOrder.hashid);
	    },
	    createInvoice: function createInvoice() {
	      var _this10 = this;
	
	      _ediOrder2.default.invoice(this.currentEdiOrder.id, this.form.data()).then(function () {
	        _this10.$message({
	          showClose: true,
	          message: _this10.$t('static.ediOrders.edit.invoiceSuccess'),
	          type: 'success'
	        });
	      }).catch(function () {
	        _this10.$message({
	          showClose: true,
	          message: _this10.$t('static.ediOrders.edit.invoiceError'),
	          type: 'error'
	        });
	      });
	    },
	    createCreditNote: function createCreditNote() {
	      var _this11 = this;
	
	      if (this.checkHasInventory && !this.currentOrder.warehouseId && (this.isZRE || this.isZKA)) {
	        this.activateWarehouseModal();
	        return;
	      }
	      _ediOrder2.default.creditNote(this.currentEdiOrder.id, this.form.data()).then(function () {
	        _this11.$message({
	          showClose: true,
	          message: _this11.$t('static.ediOrders.edit.creditSuccess'),
	          type: 'success'
	        });
	      }).catch(function (_ref) {
	        var response = _ref.response;
	
	        _this11.$message({
	          showClose: true,
	          message: response.data.error ? response.data.error.message : _this11.$t('static.ediOrders.edit.invoiceError'),
	          customClass: 'error'
	        });
	      });
	    },
	    createBill: function createBill() {
	      if (this.isZNB && this.hasBevearageProducts && this.hasExciseModule) {
	        if (!this.currentOrder.warehouseId) {
	          this.activateWarehouseModal();
	        } else {
	          this.activateModalEdi();
	        }
	        return;
	      }
	
	      this.$router.push({
	        name: 'bills.create',
	        query: {
	          order: _store3.default.state.route.params.id
	        }
	      });
	    },
	    cancelOrder: function cancelOrder() {
	      var _this12 = this;
	
	      this.$confirm(this.$t('static.ediOrders.edit.confirmCancel'), this.$t('static.orders.index.confirmCancelTitle'), {
	        confirmButtonText: this.$t('button.yes'),
	        cancelButtonText: this.$t('button.no'),
	        type: 'warning'
	      }).then(function () {
	        _this12.cancelLoading = true;
	        _order2.default.destroy(_store3.default.state.route.params.id).then(function () {
	          _this12.$router.push({
	            name: 'orders.index'
	          });
	          _this12.cancelLoading = false;
	        }).catch(function () {
	          _this12.$message({
	            showClose: true,
	            message: _this12.$t('static.orders.edit.cancelError'),
	            type: 'error'
	          });
	          _this12.cancelLoading = false;
	        });
	      });
	    },
	    toggleDropdown: function toggleDropdown() {
	      this.dropdownState = !this.dropdownState;
	    },
	    toggleDropdownDelivery: function toggleDropdownDelivery() {
	      this.dropdownStateDelivery = !this.dropdownStateDelivery;
	    },
	    toggleDropdownInvoice: function toggleDropdownInvoice() {
	      this.dropdownStateInvoice = !this.dropdownStateInvoice;
	    },
	    confirmAsOrdered: function confirmAsOrdered() {
	      this.dropdownState = !this.dropdownState;
	      var me = this;
	      Promise.all([_order2.default.confirmAsOrdered(this.currentOrder.id)]).then(function (data) {
	        me.confirm();
	      });
	    },
	    nextOrder: function nextOrder() {
	      if (!this.nextOrderId) {
	        return;
	      }
	      this.navigate(this.nextOrderId);
	    },
	    previousOrder: function previousOrder() {
	      if (!this.previousOrderId) {
	        return;
	      }
	      this.navigate(this.previousOrderId);
	    },
	    navigate: function navigate(id) {
	      this.$router.push({
	        name: 'orders.edit',
	        params: {
	          id: id
	        }
	      });
	    },
	    initializePackageForm: function initializePackageForm() {
	      var type = [{ id: '2', name: 'Pallet' }, { id: '3', name: 'Box' }];
	      this.packageForm.setOptions('packingLevel', type);
	      this.packageForm.hideField('parentId');
	    },
	    createPackage: function createPackage() {
	      this.packageForm.loading = true;
	      this.packageForm.orderId = this.currentOrder.id;
	      this.savePackage();
	    },
	    savePackage: function savePackage() {
	      var _this13 = this;
	
	      _package2.default.store(this.packageForm.data()).then(function () {
	        _this13.successMessage = _this13.$t('static.orders.package.created');
	        setTimeout(function () {
	          _this13.successMessage = '';
	        }, 3000);
	        _this13.packageForm.loading = false;
	        _package2.default.all(_this13.currentOrder.id);
	      }).catch(function (errors) {
	        _this13.packageForm.loading = false;
	        _this13.packageForm.recordErrors(errors);
	        _this13.$message({
	          showClose: true,
	          message: _this13.$t('static.orders.package.error'),
	          customClass: 'error'
	        });
	      });
	    },
	    downloadShippingLabel: function downloadShippingLabel() {
	      _order2.default.downloadShippingLabel(this.currentOrder.id, this.selectedPaperSize);
	    },
	    downloadPalletLabel: function downloadPalletLabel() {
	      _order2.default.downloadPalletLabel(this.currentOrder.id, this.selectedPaperSize);
	    },
	    invoiceExternal: function invoiceExternal() {
	      this.activateInvoiceExternalModal();
	    }
	  }),
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13),
	    VProductsTable: __webpack_require__(2721),
	    VEdiOrderItemsTable: __webpack_require__(769),
	    VManagePackage: __webpack_require__(2714),
	    VOriginalOrderItemsTable: __webpack_require__(2722),
	    VSelect: __webpack_require__(51),
	    VClientInfo: __webpack_require__(768)
	  },
	
	  mixins: [_date2.default]
	
	};

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _order = __webpack_require__(54);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _invoice = __webpack_require__(229);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _date = __webpack_require__(107);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _bulkProcessOrderModal = __webpack_require__(766);
	
	var _bulkProcessOrderModal2 = _interopRequireDefault(_bulkProcessOrderModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      sortTypes: [{
	        id: 'number|desc',
	        name: this.$t('sort.newer')
	      }, {
	        id: 'created_at|asc',
	        name: this.$t('sort.older')
	      }, {
	        id: 'last_week',
	        name: this.$t('sort.lastWeek')
	      }, {
	        id: 'last_14days',
	        name: this.$t('sort.last14Days')
	      }, {
	        id: 'last_21days',
	        name: this.$t('sort.last21Days')
	      }, {
	        id: 'last_month',
	        name: this.$t('sort.lastMonth')
	      }],
	      listTypes: [{
	        id: 'all',
	        name: this.$t('listType.all')
	      }, {
	        id: 'order',
	        name: this.$t('listType.order')
	      }, {
	        id: 'edi',
	        name: this.$t('listType.edi')
	      }],
	      loading: true,
	      sort: 'number|desc',
	      info: 'info',
	      primary: 'primary',
	      allType: 'all',
	      search: '',
	      multipleSelection: [],
	      bulkSelectionLimit: 25,
	      showAction: false,
	      action: null,
	      limit: 25
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    orders: 'paginatedOrders',
	    view: 'getView',
	    orderViewType: 'getOrderViewType',
	    searchQuery: 'orderQuery'
	  }), {
	    ordersListView: function ordersListView() {
	      var _this = this;
	
	      return this.orders.items.map(function (c) {
	        return {
	          name: '#' + c.number,
	          hashid: c.hashid,
	          isEdi: c.orderType === 'EDI',
	          ediOrderId: c.ediOrderId,
	          type: _this.$t('static.orders.types.' + c.orderType.toLowerCase()),
	          status: c.sent ? _this.$t('static.ediOrders.index.bill_sent') : c.ediOrderId ? _this.$t('static.ediOrders.index.' + c.ediStatus.toLowerCase()) : _this.$t('static.orders.status.' + c.orderStatus.toLowerCase()),
	          clientName: c.orderType == 'EDI' ? c.clientName + ' ' + c.ediStore : c.clientName,
	          totalValue: typeof c.totalValue !== 'undefined' ? _this.formatCurrencyAmount(c.totalValue) + ' kr' : '',
	          totalQuantity: typeof c.totalValue !== 'undefined' ? c.totalQuantity + ' ' + _this.$t('static.orders.index.qty') : '',
	          createdDate: '' + (0, _moment2.default)(c.createdDate).format('DD-MM-YYYY'),
	          orderProducts: c.orderProducts,
	          id: c.id
	        };
	      });
	    },
	    isEdiOverview: function isEdiOverview() {
	      return this.$route.name === 'ediOrders.index';
	    },
	    isOrderOverview: function isOrderOverview() {
	      return this.$route.name === 'orders.index';
	    },
	    ordersList: function ordersList() {
	      var _this2 = this;
	
	      return this.orders.items.map(function (o) {
	        return Object.assign({}, o, {
	          hashnumber: o.orderStatus === 'cancelled' ? '#' + o.number + ' (' + _this2.$t('static.orders.index.cancelled') + ')' : '#' + o.number,
	          service: o.orderType === 'Appointment' && o.serviceName ? o.serviceName : '',
	          value: typeof o.totalValue !== 'undefined' ? _this2.formatCurrencyAmount(o.totalValue) + ' kr' : '',
	          amount: typeof o.totalValue !== 'undefined' ? '(' + o.totalQuantity + ' ' + _this2.$t('static.orders.index.qty') + ')' : '',
	          start: o.orderType === 'Appointment' ? (0, _moment2.default)(o.date).format('DD/MM/YYYY') + ' ' + o.time : false,
	          orderStatus: o.sent ? 'bill_sent' : o.orderStatus || 'created',
	          ediStatus: o.sent && o.orderStatus !== 'cancelled' ? 'bill_sent' : o.ediStatus
	        });
	      });
	    },
	    hasEdiModule: function hasEdiModule() {
	      var modules = this.account.modules.map(function (m) {
	        return m.name;
	      });
	      return modules.indexOf('EDI') > -1;
	    },
	    hasAppointmentModule: function hasAppointmentModule() {
	      var modules = this.account.modules.map(function (m) {
	        return m.name;
	      });
	      return modules.indexOf('Appointment') > -1;
	    },
	    selectedCount: function selectedCount() {
	      return this.multipleSelection.length || 0;
	    }
	  }),
	
	  mixins: [_search2.default, _date2.default],
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VSelect: __webpack_require__(51),
	    VNoData: __webpack_require__(19),
	    VTable: __webpack_require__(33)
	  },
	
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.buildInnerSidebar();
	    this.allType = this.orderViewType;
	    this.all(1, 25);
	
	    _account2.default.rememberPerPage('get', { from: 'order' }).then(function (data) {
	      _this3.limit = data.size;
	      _this3.all(1, _this3.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	
	    if (this.view == 'card') {
	      this.info = 'info';
	      this.primary = 'primary';
	    } else {
	      this.primary = 'info';
	      this.info = 'primary';
	    }
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	    _store2.default.dispatch('resetOrders');
	  },
	
	  watch: {
	    $route: function $route() {
	      this.all(1, this.limit);
	      this.multipleSelection = [];
	    },
	    multipleSelection: function multipleSelection(_multipleSelection) {
	      this.showAction = false;
	      if (_multipleSelection.length) {
	        this.showAction = true;
	      }
	    },
	    view: function view(_view) {
	      this.showAction = false;
	      if (_view == 'card') {
	        this.info = 'info';
	        this.primary = 'primary';
	      } else {
	        this.primary = 'info';
	        this.info = 'primary';
	      }
	    },
	    orderViewType: function orderViewType(_orderViewType) {},
	    loading: function loading(_loading) {
	      if (_loading) {
	        this.disableInnerSidebar();
	      } else {
	        this.enableInnerSidebar();
	      }
	    }
	  },
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
	    disableInnerSidebar: 'DISABLE_INNERSIDEBAR',
	    enableInnerSidebar: 'ENABLE_INNERSIDEBAR',
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    formatCurrencyAmount: function formatCurrencyAmount(value) {
	      if (value === undefined || value === null || value === '') {
	        return '';
	      }
	      var n = Number(value);
	      if (Number.isNaN(n)) {
	        return '';
	      }
	      return n.toLocaleString('nb-NO', {
	        minimumFractionDigits: 2,
	        maximumFractionDigits: 2
	      });
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    onSelectAction: function onSelectAction(value) {
	      if (this.multipleSelection.length > this.bulkSelectionLimit) {
	        var message = this.$t('static.orders.index.bulkMaxLimitExceededError') + ' ' + this.bulkSelectionLimit;
	        this.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	        return;
	      }
	      if (value === 'dowloadDeliverySlip') {
	        _invoice2.default.bulkDownloadDeliveryNote(this.multipleSelection.map(function (item) {
	          return item.hashid;
	        }));
	        return;
	      }
	      if (value) {
	        this.setModalContent(function () {
	          return _bulkProcessOrderModal2.default;
	        });
	        this.setModalProps({
	          selectedOrders: this.multipleSelection,
	          operation: value,
	          onSubmit: this.handleBulkOrderActionSubmit
	        });
	        this.setModalCloseOnClick(false);
	        this.setModalShowClose(false);
	        this.setModalCloseOnPressEscape(false);
	        this.toggleModal(true);
	      }
	    },
	    handleBulkOrderActionSubmit: function handleBulkOrderActionSubmit() {
	      this.multipleSelection = [];
	      this.all(1, this.limit);
	    },
	    changeView: function changeView(view) {
	      if (this.info != view) {
	        this.primary = this.info;
	        this.info = view;
	        if (this.info == 'info') {
	          _store2.default.dispatch('setView', 'card');
	        } else {
	          _store2.default.dispatch('setView', 'list');
	        }
	      }
	    },
	    perPage: function perPage(size) {
	      var _this4 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'order', perPage: size }).then(function (data) {
	        _this4.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    buildInnerSidebar: function buildInnerSidebar() {
	      var sidebar = [{
	        title: this.$t('layouts.sidebar.orders'),
	        options: [{
	          title: this.$t('layouts.sidebar.products'),
	          route: {
	            name: 'orders.index',
	            query: {
	              filter: 'Product'
	            }
	          }
	        }, {
	          title: this.$t('layouts.sidebar.services'),
	          route: {
	            name: 'orders.index',
	            query: {
	              filter: 'Service'
	            }
	          }
	        }, {
	          title: this.$t('layouts.sidebar.wordpress'),
	          route: {
	            name: 'orders.index',
	            query: {
	              filter: 'Wordpress'
	            }
	          }
	        }, {
	          title: this.$t('layouts.sidebar.all'),
	          route: {
	            name: 'orders.index'
	          }
	        }],
	        button: {
	          title: '+ ' + this.$t('static.orders.create.title'),
	          route: {
	            name: 'orders.create'
	          }
	        }
	      }];
	
	      if (this.hasAppointmentModule) {
	        sidebar.push({
	          title: this.$t('layouts.sidebar.booking'),
	          options: [{
	            title: this.$t('layouts.sidebar.upcoming'),
	            route: {
	              name: 'appointments.index',
	              query: {
	                appointment: 'upcoming'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.done'),
	            route: {
	              name: 'appointments.index',
	              query: {
	                appointment: 'done'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.calendar'),
	            route: {
	              name: 'appointments.index',
	              query: {
	                appointment: 'calendar'
	              }
	            }
	          }],
	          button: {
	            title: '+ ' + this.$t('static.appointments.create.title'),
	            route: {
	              name: 'orders.create'
	            }
	          }
	        });
	      }
	
	      if (this.hasEdiModule) {
	        sidebar.push({
	          title: this.$t('layouts.sidebar.orderFilter'),
	          options: [{
	            title: this.$t('layouts.sidebar.newOrders'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'created'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.outOfStock'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'out_of_stock'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.confirmed'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'confirmed'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.inTransit'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'processed'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.recieved'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'received'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.notInvoiced'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'notInvoiced'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.invoiced'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'invoiced'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.credited'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'credited'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.cancelled'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'cancelled'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.complete'),
	            route: {
	              name: 'orders.index',
	              query: {
	                filter: 'completed'
	              }
	            }
	          }, {
	            title: this.$t('layouts.sidebar.all'),
	            route: {
	              name: 'orders.index'
	            }
	          }]
	        });
	      }
	
	      sidebar.push({
	        title: this.$t('layouts.sidebar.orderPickups.title'),
	        options: [{
	          title: this.$t('layouts.sidebar.orderPickups.viewAll'),
	          route: {
	            name: 'orderPickups.index',
	            query: {
	              filter: 'all'
	            }
	          }
	        }]
	      });
	
	      this.setInnerSidebar(sidebar);
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this5 = this;
	
	      _store2.default.dispatch('setOrderTypeView', this.allType);
	      this.loading = true;
	      var query = { page: page, limit: limit, search: this.searchQuery.search };
	      _store2.default.dispatch('setOrderQuery', query);
	      this.search = this.searchQuery.search;
	      var params = {
	        page: page,
	        limit: limit,
	        search: this.searchQuery.search,
	        edi: this.$route.name === 'ediOrders.index',
	        sort: this.sort,
	        filter: this.$route.query.filter,
	        listtype: this.allType
	      };
	      _order2.default.items(params).then(function () {
	        _this5.loading = false;
	      }).catch(function () {
	        _this5.loading = false;
	      });
	    }, 800),
	
	    onChangeSearch: function onChangeSearch(name, value) {
	      _store2.default.dispatch('setOrderQuery', { page: 1, limit: 25, search: value });
	      this.all(this.searchQuery.page, 25);
	    },
	    deleteOrder: function deleteOrder(order) {
	      this.$confirm(this.$t('static.orders.index.confirmDelete'), this.$t('static.orders.index.confirmDeleteTitle'), {
	        confirmButtonText: this.$t('button.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _order2.default.destroy(order.id);
	      }).catch(function () {});
	    },
	    editOrder: function editOrder(order) {
	      this.$router.push({
	        name: 'orders.edit',
	        params: { id: order.id }
	      });
	    },
	    editOrderNewTab: function editOrderNewTab(order) {
	      var route = this.$router.resolve({
	        name: 'orders.edit',
	        params: { id: order.id }
	      });
	      window.open(route.href, '_blank');
	    }
	  })
	};

/***/ }),
/* 1926 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(5);
	
	var _priceField = __webpack_require__(95);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	var _priceField3 = __webpack_require__(132);
	
	var _priceField4 = _interopRequireDefault(_priceField3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        field: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      tabIndex: '1'
	    };
	  },
	  created: function created() {},
	
	
	  computed: {},
	
	  methods: {
	    store: function store() {
	      var _this = this;
	
	      this.form.loading = true;
	      var priceField = _priceField4.default.send(this.form.data());
	      _priceField2.default.store(priceField).then(function () {
	        _this.form.loading = false;
	        _this.$message({
	          message: _this.$t('static.priceFields.create.success'),
	          type: 'success'
	        });
	        _this.$router.push({
	          name: 'priceFields.index'
	        });
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	      });
	    }
	  },
	
	  watch: {},
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(5);
	
	var _priceField = __webpack_require__(95);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	var _priceField3 = __webpack_require__(132);
	
	var _priceField4 = _interopRequireDefault(_priceField3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        field: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      loading: false
	    };
	  },
	  created: function created() {
	    this.show();
	  },
	
	
	  computed: {},
	
	  methods: {
	    update: function update() {
	      var _this = this;
	
	      this.form.loading = true;
	      var priceField = _priceField4.default.send(this.form.data());
	      _priceField2.default.update(_store2.default.state.route.params.id, priceField).then(function () {
	        _this.form.loading = false;
	        _this.$message({
	          message: _this.$t('static.priceFields.edit.success'),
	          type: 'success'
	        });
	        _this.$router.push({
	          name: 'priceFields.index'
	        });
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      var _this2 = this;
	
	      this.loading = true;
	      _priceField2.default.show(_store2.default.state.route.params.id).then(function (priceField) {
	        _this2.form.assignData(priceField);
	        _this2.loading = false;
	      });
	    }
	  },
	
	  watch: {},
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _priceField = __webpack_require__(95);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false,
	      sort: ''
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    priceFields: 'paginatedPriceFields'
	  })),
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19)
	  },
	
	  mounted: function mounted() {
	    this.setInnerSidebar([{
	      title: this.$t('static.products.filters.title'),
	      options: [{
	        title: this.$t('static.products.filters.latest'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'latest'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.pastMonth'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'pastMonth'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.all'),
	        route: {
	          name: 'products.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.products.create.title'),
	        route: {
	          name: 'products.create'
	        }
	      }
	    }, {
	      title: this.$t('static.productGroups.filters.title'),
	      options: [{
	        title: this.$t('static.productGroups.filters.latest'),
	        route: {
	          name: 'productGroups.index',
	          query: {
	            filter: 'latest'
	          }
	        }
	      }, {
	        title: this.$t('static.productGroups.filters.pastMonth'),
	        route: {
	          name: 'productGroups.index',
	          query: {
	            filter: 'pastMonth'
	          }
	        }
	      }, {
	        title: this.$t('static.productGroups.filters.all'),
	        route: {
	          name: 'productGroups.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productGroups.create.title'),
	        route: {
	          name: 'productGroups.create'
	        }
	      }
	    }, {
	      title: this.$t('static.unitOfMeasure.filters.title'),
	      options: [{
	        title: this.$t('static.unitOfMeasure.filters.all'),
	        route: {
	          name: 'unitOfMeasure.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.unitOfMeasure.create.title'),
	        route: {
	          name: 'unitOfMeasure.create'
	        }
	      }
	    }, {
	      title: this.$t('static.priceFields.filters.title'),
	      options: [{
	        title: this.$t('static.priceFields.filters.all'),
	        route: {
	          name: 'priceFields.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.priceFields.create.title'),
	        route: {
	          name: 'priceFields.create'
	        }
	      }
	    }]);
	    this.all(1, 10);
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  watch: {
	    $route: function $route() {
	      this.all(1, 50);
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    all: (0, _debounce2.default)(function (page) {
	      var _this = this;
	
	      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	      this.loading = true;
	      _priceField2.default.items({
	        page: page,
	        limit: limit,
	        search: this.getSearch(),
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this.loading = false;
	      }).catch(function () {
	        _this.loading = false;
	      });
	    }, 800),
	
	    deletepriceField: function deletepriceField(priceField) {
	      var _this2 = this;
	
	      this.$confirm(this.$t('static.priceFields.index.confirmDelete'), this.$t('static.priceFields.index.confirmDeleteTitle'), {
	        confirmButtonText: this.$t('button.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _priceField2.default.destroy(priceField.id).catch(function (_ref) {
	          var response = _ref.response;
	
	          var message = response.data.error.code === 40114 ? _this2.$t('static.priceFields.index.deleteHasProductError') : _this2.$t('static.priceFields.index.deleteError');
	          _this2.$message({
	            showClose: true,
	            message: message,
	            type: 'error'
	          });
	        });
	      }).catch(function () {});
	    },
	    editpriceField: function editpriceField(priceField) {
	      this.$router.push({
	        name: 'priceFields.edit',
	        params: { id: priceField.id }
	      });
	    },
	    goToProducts: function goToProducts(id, e) {
	      e.stopPropagation();
	      this.$router.push({ name: 'products.index', query: { filter: 'priceField,' + id } });
	    }
	  }),
	
	  mixins: [_search2.default]
	};

/***/ }),
/* 1930 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      saving: false,
	      clients: [],
	      form: {
	        client_id: null,
	        name: '',
	        valid_from: null,
	        valid_to: null,
	        is_active: true
	      }
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _vue2.default.$http.get('clients?basic_fields=1').then(function (_ref) {
	      var data = _ref.data;
	
	      _this.clients = data.data || [];
	      _this.loading = false;
	    }).catch(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  methods: {
	    store: function store() {
	      var _this2 = this;
	
	      if (!this.form.client_id || !this.form.name || !this.form.valid_from || !this.form.valid_to) {
	        this.$message({ message: 'Please fill required fields', type: 'warning' });
	        return;
	      }
	      this.saving = true;
	      _vue2.default.$http.post('pricing_agreements', this.form).then(function () {
	        _this2.$message({ message: 'Pricing agreement created', type: 'success' });
	        _this2.$router.push({ name: 'pricingAgreements.index', query: { filter: 'active' } });
	      }).catch(function (err) {
	        _this2.saving = false;
	        var data = err.response && err.response.data ? err.response.data : null;
	        var msg = null;
	        var validationField = null;
	        if (data && data.error && data.error.message) {
	          msg = data.error.message;
	        } else if (data && data.message) {
	          msg = data.message;
	        } else if (data && data.errors && _typeof(data.errors) === 'object') {
	          var keys = Object.keys(data.errors);
	          if (keys.length && Array.isArray(data.errors[keys[0]]) && data.errors[keys[0]][0]) {
	            validationField = keys[0];
	            msg = data.errors[keys[0]][0];
	          }
	        } else if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
	          var key = Object.keys(data).find(function (k) {
	            return Array.isArray(data[k]) && data[k][0];
	          });
	          if (key) {
	            validationField = key;
	            msg = data[key][0];
	          }
	        }
	        if (validationField === 'name' && msg) {
	          msg = _this2.$t('pricingAgreements.validationNameAlreadyExists');
	        }
	        _this2.$message({ message: msg || _this2.$t('pricingAgreements.errorCreatingAgreement'), type: 'error' });
	      });
	    }
	  }
	};

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _search = __webpack_require__(303);
	
	var _search2 = _interopRequireDefault(_search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  components: {
	    VCard: __webpack_require__(21),
	    VNoData: __webpack_require__(19),
	    VPagination: __webpack_require__(16),
	    VSelect: __webpack_require__(51)
	  },
	
	  data: function data() {
	    return {
	      loading: true,
	      saving: false,
	      addingLine: false,
	      savingLine: false,
	      currentPage: 1,
	      perPage: 50,
	      agreement: { client: null, lines: [] },
	      form: {
	        name: '',
	        valid_from: null,
	        valid_to: null,
	        is_active: true
	      },
	      newLine: {
	        product_id: null,
	        min_qty_or_pack_qty: 1,
	        discount_percent: null,
	        discount_amount: null,
	        comment: null
	      },
	      productOptions: [],
	      productSearchLoading: false,
	      editingLineId: null,
	      editingForm: {
	        min_qty_or_pack_qty: 1,
	        discount_percent: null,
	        discount_amount: null,
	        comment: null
	      },
	      productSearchQuery: '',
	      viewLineMode: 'info',
	      viewLineModePrimary: 'primary',
	      sortLine: 'productName|asc',
	      sortLineIds: ['productName|asc', 'productName|desc', 'minQty|asc', 'minQty|desc'],
	      showTableEditDialog: false,
	      editingLineRow: null
	    };
	  },
	
	
	  computed: {
	    agreementLines: function agreementLines() {
	      return Array.isArray(this.agreement.lines) ? this.agreement.lines : [];
	    },
	    filteredAgreementLines: function filteredAgreementLines() {
	      var q = (this.productSearchQuery || '').trim().toLowerCase();
	      if (!q) return this.agreementLines;
	      return this.agreementLines.filter(function (line) {
	        var name = line.product && line.product.name ? String(line.product.name).toLowerCase() : '';
	        var number = line.product && line.product.number ? String(line.product.number).toLowerCase() : '';
	        return name.indexOf(q) !== -1 || number.indexOf(q) !== -1;
	      });
	    },
	    sortedFilteredAgreementLines: function sortedFilteredAgreementLines() {
	      var list = [].concat(_toConsumableArray(this.filteredAgreementLines));
	
	      var _split = (this.sortLine || 'productName|asc').split('|'),
	          _split2 = _slicedToArray(_split, 2),
	          field = _split2[0],
	          dir = _split2[1];
	
	      var mult = dir === 'desc' ? -1 : 1;
	      list.sort(function (a, b) {
	        var va = void 0;var vb = void 0;
	        if (field === 'productName') {
	          va = (a.product && a.product.name ? a.product.name : '').toLowerCase();
	          vb = (b.product && b.product.name ? b.product.name : '').toLowerCase();
	        } else if (field === 'minQty') {
	          va = a.min_qty_or_pack_qty != null ? Number(a.min_qty_or_pack_qty) : 0;
	          vb = b.min_qty_or_pack_qty != null ? Number(b.min_qty_or_pack_qty) : 0;
	        } else {
	          va = (a.product && a.product.name ? a.product.name : '').toLowerCase();
	          vb = (b.product && b.product.name ? b.product.name : '').toLowerCase();
	        }
	        if (va < vb) return -1 * mult;
	        if (va > vb) return 1 * mult;
	        return 0;
	      });
	      return list;
	    },
	    pagination: function pagination() {
	      var total = this.sortedFilteredAgreementLines.length;
	      var limit = this.perPage;
	      return {
	        currentPage: this.currentPage,
	        lastPage: Math.max(1, Math.ceil(total / limit)),
	        limit: limit,
	        totalCount: total
	      };
	    },
	    paginatedAgreementLines: function paginatedAgreementLines() {
	      var start = (this.currentPage - 1) * this.perPage;
	      return this.sortedFilteredAgreementLines.slice(start, start + this.perPage);
	    },
	    sortLineTypes: function sortLineTypes() {
	      var _this = this;
	
	      var keys = {
	        'productName|asc': 'pricingAgreements.sortProductNameAsc',
	        'productName|desc': 'pricingAgreements.sortProductNameDesc',
	        'minQty|asc': 'pricingAgreements.sortMinQtyAsc',
	        'minQty|desc': 'pricingAgreements.sortMinQtyDesc'
	      };
	      return this.sortLineIds.map(function (id) {
	        return { id: id, name: _this.$t(keys[id] || id) };
	      });
	    }
	  },
	
	  watch: {
	    '$route.params.id': function $routeParamsId(id) {
	      if (id) this.fetch();
	    },
	    productSearchQuery: function productSearchQuery() {
	      this.currentPage = 1;
	    },
	    editingLineId: function editingLineId(val) {
	      if (val == null) {
	        this.showTableEditDialog = false;
	        this.editingLineRow = null;
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    this.fetch();
	  },
	
	
	  methods: {
	    isEditingLine: function isEditingLine(line) {
	      if (this.editingLineId == null) return false;
	      return Number(this.editingLineId) === Number(line.id);
	    },
	    fetch: function fetch() {
	      var _this2 = this;
	
	      var id = this.$route.params.id;
	      if (!id) return;
	      this.loading = true;
	      _vue2.default.$http.get('pricing_agreements/' + id).then(function (_ref) {
	        var data = _ref.data;
	
	        var payload = data && data.data !== undefined ? data.data : data;
	        if (payload && (typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.data !== undefined && payload.id === undefined) {
	          payload = payload.data;
	        }
	        _this2.agreement = payload && (typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' ? _extends({}, payload) : { client: null, lines: [] };
	        if (!Array.isArray(_this2.agreement.lines)) {
	          _this2.agreement.lines = [];
	        }
	        _this2.form.name = _this2.agreement.name;
	        _this2.form.valid_from = _this2.agreement.valid_from;
	        _this2.form.valid_to = _this2.agreement.valid_to;
	        _this2.form.is_active = _this2.agreement.is_active;
	        _this2.currentPage = 1;
	        _this2.loading = false;
	      }).catch(function () {
	        _this2.loading = false;
	      });
	    },
	    update: function update() {
	      var _this3 = this;
	
	      this.saving = true;
	      _vue2.default.$http.put('pricing_agreements/' + this.$route.params.id, this.form).then(function () {
	        _this3.$message({ message: _this3.$t('pricingAgreements.agreementUpdated'), type: 'success' });
	        _this3.saving = false;
	        _this3.fetch();
	      }).catch(function () {
	        _this3.saving = false;
	        _this3.$message({ message: _this3.$t('pricingAgreements.errorUpdatingAgreement'), type: 'error' });
	      });
	    },
	    remoteProductSearch: function remoteProductSearch(query) {
	      var _this4 = this;
	
	      this.productSearchLoading = true;
	      (0, _search2.default)({ search: query || '', filter: 'active' }).then(function (products) {
	        _this4.productOptions = products || [];
	        _this4.productSearchLoading = false;
	      }).catch(function () {
	        _this4.productSearchLoading = false;
	      });
	    },
	    addLine: function addLine() {
	      var _this5 = this;
	
	      if (!this.newLine.product_id || !this.newLine.min_qty_or_pack_qty) {
	        this.$message({ message: this.$t('pricingAgreements.productAndMinQtyRequired'), type: 'warning' });
	        return;
	      }
	      if (this.newLine.discount_percent == null && this.newLine.discount_amount == null) {
	        this.$message({ message: this.$t('pricingAgreements.setDiscountOrAmount'), type: 'warning' });
	        return;
	      }
	      this.addingLine = true;
	      var payload = {
	        product_id: this.newLine.product_id,
	        min_qty_or_pack_qty: this.newLine.min_qty_or_pack_qty,
	        discount_percent: this.newLine.discount_percent,
	        discount_amount: this.newLine.discount_amount,
	        comment: this.newLine.comment || null
	      };
	      _vue2.default.$http.post('pricing_agreements/' + this.$route.params.id + '/lines', payload).then(function () {
	        _this5.$message({ message: _this5.$t('pricingAgreements.productAdded'), type: 'success' });
	        _this5.addingLine = false;
	        _this5.newLine = { product_id: null, min_qty_or_pack_qty: 1, discount_percent: null, discount_amount: null, comment: null };
	        _this5.productOptions = [];
	        _this5.fetch();
	      }).catch(function () {
	        _this5.addingLine = false;
	        _this5.$message({ message: _this5.$t('pricingAgreements.errorAddingProduct'), type: 'error' });
	      });
	    },
	    startEditLine: function startEditLine(line) {
	      this.editingLineId = Number(line.id);
	      this.editingLineRow = line;
	      this.editingForm = {
	        min_qty_or_pack_qty: line.min_qty_or_pack_qty,
	        discount_percent: line.discount_percent,
	        discount_amount: line.discount_amount,
	        comment: line.comment || ''
	      };
	      if (this.viewLineMode === 'primary') {
	        this.showTableEditDialog = true;
	      }
	    },
	    cancelEditLine: function cancelEditLine() {
	      this.editingLineId = null;
	      this.showTableEditDialog = false;
	      this.editingLineRow = null;
	    },
	    closeTableEditDialog: function closeTableEditDialog() {
	      this.showTableEditDialog = false;
	      this.cancelEditLine();
	    },
	    saveLine: function saveLine(line) {
	      var _this6 = this;
	
	      var minQty = this.editingForm.min_qty_or_pack_qty;
	      if (!minQty || minQty < 1) {
	        this.$message({ message: this.$t('pricingAgreements.minQtyAtLeast1'), type: 'warning' });
	        return;
	      }
	      if (this.editingForm.discount_percent == null && this.editingForm.discount_amount == null) {
	        this.$message({ message: this.$t('pricingAgreements.setDiscountOrAmount'), type: 'warning' });
	        return;
	      }
	      var discountPercent = this.editingForm.discount_percent;
	      var discountAmount = this.editingForm.discount_amount;
	      if (discountPercent !== '' && discountPercent != null && discountAmount !== '' && discountAmount != null) {
	        discountAmount = null;
	      }
	      this.savingLine = true;
	      var payload = {
	        min_qty_or_pack_qty: minQty,
	        discount_percent: discountPercent === '' || discountPercent == null ? null : Number(discountPercent),
	        discount_amount: discountAmount === '' || discountAmount == null ? null : Number(discountAmount),
	        comment: this.editingForm.comment || null
	      };
	      _vue2.default.$http.put('pricing_agreements/' + this.$route.params.id + '/lines/' + line.id, payload).then(function (_ref2) {
	        var data = _ref2.data;
	
	        var updated = data && data.data !== undefined ? data.data : data;
	        var idx = _this6.agreement.lines.findIndex(function (l) {
	          return Number(l.id) === Number(line.id);
	        });
	        if (idx !== -1 && updated && (typeof updated === 'undefined' ? 'undefined' : _typeof(updated)) === 'object') {
	          _this6.$set(_this6.agreement.lines, idx, _extends({}, _this6.agreement.lines[idx], updated));
	        } else {
	          _this6.fetch();
	        }
	        _this6.$message({ message: _this6.$t('pricingAgreements.productUpdated'), type: 'success' });
	        _this6.savingLine = false;
	        _this6.editingLineId = null;
	        _this6.showTableEditDialog = false;
	        _this6.editingLineRow = null;
	      }).catch(function () {
	        _this6.savingLine = false;
	        _this6.$message({ message: _this6.$t('pricingAgreements.errorUpdatingProduct'), type: 'error' });
	      });
	    },
	    deleteLine: function deleteLine(line) {
	      var _this7 = this;
	
	      this.$confirm(this.$t('pricingAgreements.deleteProductConfirm'), this.$t('pricingAgreements.confirm'), { type: 'warning' }).then(function () {
	        _vue2.default.$http.delete('pricing_agreements/' + _this7.$route.params.id + '/lines/' + line.id).then(function () {
	          _this7.$message({ message: _this7.$t('pricingAgreements.productRemoved'), type: 'success' });
	          _this7.fetch();
	        }).catch(function () {
	          return _this7.$message({ message: _this7.$t('pricingAgreements.errorRemovingProduct'), type: 'error' });
	        });
	      }).catch(function () {});
	    },
	    onPageChange: function onPageChange(page, limit) {
	      this.currentPage = page;
	      this.perPage = limit;
	    },
	    changeLineView: function changeLineView(mode) {
	      if (this.viewLineMode !== mode) {
	        this.viewLineModePrimary = this.viewLineMode;
	        this.viewLineMode = mode;
	      }
	    },
	    onChangeLineSort: function onChangeLineSort(val) {
	      this.sortLine = val;
	      this.currentPage = 1;
	    }
	  }
	};

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _search = __webpack_require__(303);
	
	var _search2 = _interopRequireDefault(_search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  components: {
	    VCard: __webpack_require__(21),
	    VNoData: __webpack_require__(19),
	    VPagination: __webpack_require__(16),
	    VText: __webpack_require__(182),
	    VSelect: __webpack_require__(51)
	  },
	
	  data: function data() {
	    return {
	      loading: true,
	      items: [],
	      clients: [],
	      showImportDialog: false,
	      importing: false,
	      importForm: {
	        client_id: null,
	        name: ''
	      },
	      importFile: null,
	
	      importResult: null,
	
	      unmatchedSelections: {},
	      currentPage: 1,
	      perPage: 25,
	      unmatchedPerPage: 20,
	      currentUnmatchedPage: 1,
	      searchQuery: '',
	
	      activeFilter: 'inactive',
	      deletingId: null,
	
	      info: 'info',
	      primary: 'primary',
	      sort: 'name|asc',
	      sortTypeIds: ['name|asc', 'name|desc', 'client|asc', 'client|desc', 'validFrom|desc', 'validFrom|asc']
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    view: 'getView'
	  }), {
	    filteredItems: function filteredItems() {
	      var list = this.items;
	      var q = (this.searchQuery || '').trim().toLowerCase();
	      if (q) {
	        list = list.filter(function (a) {
	          var name = (a.name || '').toLowerCase();
	          var clientName = a.client && a.client.name ? a.client.name.toLowerCase() : '';
	          return name.indexOf(q) !== -1 || clientName.indexOf(q) !== -1;
	        });
	      }
	      if (this.activeFilter === 'active') {
	        list = list.filter(function (a) {
	          return a.is_active === true;
	        });
	      } else if (this.activeFilter === 'inactive') {
	        list = list.filter(function (a) {
	          return a.is_active !== true;
	        });
	      }
	      return list;
	    },
	    sortedFilteredItems: function sortedFilteredItems() {
	      var list = [].concat(_toConsumableArray(this.filteredItems));
	
	      var _split = (this.sort || 'name|asc').split('|'),
	          _split2 = _slicedToArray(_split, 2),
	          field = _split2[0],
	          dir = _split2[1];
	
	      var mult = dir === 'desc' ? -1 : 1;
	      list.sort(function (a, b) {
	        var va = void 0;var vb = void 0;
	        if (field === 'name') {
	          va = (a.name || '').toLowerCase();
	          vb = (b.name || '').toLowerCase();
	        } else if (field === 'client') {
	          va = (a.client && a.client.name ? a.client.name : '').toLowerCase();
	          vb = (b.client && b.client.name ? b.client.name : '').toLowerCase();
	        } else if (field === 'validFrom') {
	          va = a.valid_from || '';
	          vb = b.valid_from || '';
	        } else {
	          va = (a.name || '').toLowerCase();
	          vb = (b.name || '').toLowerCase();
	        }
	        if (va < vb) return -1 * mult;
	        if (va > vb) return 1 * mult;
	        return 0;
	      });
	      return list;
	    },
	    pagination: function pagination() {
	      var total = this.sortedFilteredItems.length;
	      var limit = this.perPage;
	      return {
	        currentPage: this.currentPage,
	        lastPage: Math.max(1, Math.ceil(total / limit)),
	        limit: limit,
	        totalCount: total
	      };
	    },
	    paginatedItems: function paginatedItems() {
	      var start = (this.currentPage - 1) * this.perPage;
	      return this.sortedFilteredItems.slice(start, start + this.perPage);
	    },
	    sortTypes: function sortTypes() {
	      var _this = this;
	
	      var keys = {
	        'name|asc': 'pricingAgreements.sortNameAsc',
	        'name|desc': 'pricingAgreements.sortNameDesc',
	        'client|asc': 'pricingAgreements.sortCustomerAsc',
	        'client|desc': 'pricingAgreements.sortCustomerDesc',
	        'validFrom|desc': 'pricingAgreements.sortValidFromDesc',
	        'validFrom|asc': 'pricingAgreements.sortValidFromAsc'
	      };
	      return this.sortTypeIds.map(function (id) {
	        return { id: id, name: _this.$t(keys[id] || id) };
	      });
	    },
	    templateDownloadUrl: function templateDownloadUrl() {
	      var base = ("https://api.kundan.no") || '';
	      return base.replace(/\/$/, '') + '/docs/pricing-agreement-template.xlsx';
	    },
	    hasUnmatched: function hasUnmatched() {
	      return this.importResult && this.importResult.unmatched && this.importResult.unmatched.length > 0;
	    },
	    unmatchedRows: function unmatchedRows() {
	      return this.hasUnmatched ? this.importResult.unmatched : [];
	    },
	    unmatchedPagination: function unmatchedPagination() {
	      var total = this.unmatchedRows.length;
	      var limit = this.unmatchedPerPage;
	      return {
	        currentPage: this.currentUnmatchedPage,
	        lastPage: Math.max(1, Math.ceil(total / limit)),
	        limit: limit,
	        totalCount: total
	      };
	    },
	    paginatedUnmatchedRows: function paginatedUnmatchedRows() {
	      if (!this.hasUnmatched) return [];
	      var start = (this.currentUnmatchedPage - 1) * this.unmatchedPerPage;
	      return this.unmatchedRows.slice(start, start + this.unmatchedPerPage);
	    }
	  }),
	
	  watch: {
	    '$route.query.import': function $routeQueryImport(val) {
	      this.showImportDialog = val === '1';
	    },
	    '$route.query.filter': function $routeQueryFilter(val) {
	      this.activeFilter = val === 'active' || val === 'inactive' || val === 'all' ? val : 'inactive';
	    },
	    searchQuery: function searchQuery() {
	      this.currentPage = 1;
	    },
	    showImportDialog: function showImportDialog(val) {
	      if (!val) {
	        this.importResult = null;
	        this.unmatchedSelections = {};
	      }
	    },
	    view: function view(_view) {
	      if (_view === 'card') {
	        this.info = 'info';
	        this.primary = 'primary';
	      } else {
	        this.primary = 'info';
	        this.info = 'primary';
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.setInnerSidebar([{
	      title: this.$t('layouts.sidebar.clients'),
	      options: [{
	        title: this.$t('layouts.sidebar.active'),
	        route: {
	          name: 'clients.index',
	          query: { filter: 'active' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.inActive'),
	        route: {
	          name: 'clients.index',
	          query: { filter: 'inActive' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.orderedPastWeek'),
	        route: {
	          name: 'clients.index',
	          query: { filter: 'orderedPastWeek' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.orderedPastMonth'),
	        route: {
	          name: 'clients.index',
	          query: { filter: 'orderedPastMonth' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.neverOrdered'),
	        route: {
	          name: 'clients.index',
	          query: { filter: 'neverOrdered' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.storeSynced'),
	        route: {
	          name: 'clients.index',
	          query: { filter: 'storeSynced' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.all'),
	        route: { name: 'clients.index' }
	      }],
	      button: {
	        title: this.$t('button.addClient'),
	        route: { name: 'clients.create' }
	      }
	    }, {
	      title: this.$t('layouts.sidebar.clientGroup'),
	      options: [{
	        title: this.$t('layouts.sidebar.active'),
	        route: {
	          name: 'clientGroups.index',
	          query: { filter: 'active' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.inActive'),
	        route: {
	          name: 'clientGroups.index',
	          query: { filter: 'inActive' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.newOrders'),
	        route: {
	          name: 'clientGroups.index',
	          query: { filter: 'new' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.all'),
	        route: { name: 'clientGroups.index' }
	      }],
	      button: {
	        title: this.$t('button.addClientGroup'),
	        route: { name: 'clientGroups.create' }
	      }
	    }, {
	      title: this.$t('layouts.sidebar.clientAgreements'),
	      options: [{
	        title: this.$t('layouts.sidebar.active'),
	        route: {
	          name: 'pricingAgreements.index',
	          query: { filter: 'active' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.inActive'),
	        route: {
	          name: 'pricingAgreements.index',
	          query: { filter: 'inactive' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.all'),
	        route: {
	          name: 'pricingAgreements.index',
	          query: { filter: 'all' }
	        }
	      }, {
	        title: this.$t('layouts.sidebar.importAgreement'),
	        route: {
	          name: 'pricingAgreements.index',
	          query: { import: '1' }
	        }
	      }],
	      button: {
	        title: this.$t('layouts.sidebar.newAgreement'),
	        route: { name: 'pricingAgreements.create' }
	      }
	    }]);
	    var filter = this.$route.query.filter;
	    this.activeFilter = filter === 'active' || filter === 'inactive' || filter === 'all' ? filter : 'inactive';
	    if (!this.$route.query.filter && this.$route.name === 'pricingAgreements.index') {
	      this.$router.replace({ name: 'pricingAgreements.index', query: _extends({}, this.$route.query, { filter: 'inactive' }) }).catch(function () {});
	    }
	    if (this.$route.query.import === '1') {
	      this.showImportDialog = true;
	    }
	    if (this.view === 'card') {
	      this.info = 'info';
	      this.primary = 'primary';
	    } else {
	      this.primary = 'info';
	      this.info = 'primary';
	    }
	    this.fetch();
	    _vue2.default.$http.get('clients?basic_fields=1').then(function (_ref) {
	      var data = _ref.data;
	
	      _this2.clients = data.data || [];
	    }).catch(function () {});
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    fetch: function fetch() {
	      var _this3 = this;
	
	      this.loading = true;
	      var clientId = this.$route.query.client_id;
	      var url = clientId ? 'pricing_agreements?client_id=' + clientId : 'pricing_agreements';
	      _vue2.default.$http.get(url).then(function (_ref2) {
	        var data = _ref2.data;
	
	        var raw = data && data.data !== undefined ? data.data : data;
	        _this3.items = Array.isArray(raw) ? raw : Array.isArray(raw && raw.data) ? raw.data : [];
	        _this3.currentPage = 1;
	        _this3.loading = false;
	      }).catch(function () {
	        _this3.loading = false;
	      });
	    },
	    onPageChange: function onPageChange(page, limit) {
	      this.currentPage = page;
	      this.perPage = limit;
	    },
	    changeView: function changeView(view) {
	      if (this.info !== view) {
	        this.primary = this.info;
	        this.info = view;
	        if (this.info === 'info') {
	          _store2.default.dispatch('setView', 'card');
	        } else {
	          _store2.default.dispatch('setView', 'list');
	        }
	      }
	    },
	    onChangeSearch: function onChangeSearch(name, value) {
	      this.searchQuery = value;
	      this.currentPage = 1;
	    },
	    onChangeSort: function onChangeSort(name, value) {
	      this.sort = value;
	      this.currentPage = 1;
	    },
	    onUnmatchedPageChange: function onUnmatchedPageChange(page) {
	      this.currentUnmatchedPage = page;
	    },
	    goToEdit: function goToEdit(agreement) {
	      this.$router.push({ name: 'pricingAgreements.edit', params: { id: agreement.id } });
	    },
	    editInNewTab: function editInNewTab(agreement) {
	      var route = this.$router.resolve({ name: 'pricingAgreements.edit', params: { id: agreement.id } });
	      window.open(route.href, '_blank');
	    },
	    deleteAgreement: function deleteAgreement(agreement) {
	      var _this4 = this;
	
	      this.$confirm(this.$t('pricingAgreements.deleteAgreementConfirm'), this.$t('pricingAgreements.confirm'), { type: 'warning' }).then(function () {
	        _this4.deletingId = agreement.id;
	        _vue2.default.$http.delete('pricing_agreements/' + agreement.id).then(function () {
	          _this4.$message({ message: _this4.$t('pricingAgreements.agreementDeleted'), type: 'success' });
	          _this4.deletingId = null;
	          _this4.fetch();
	        }).catch(function () {
	          _this4.deletingId = null;
	          _this4.$message({ message: _this4.$t('pricingAgreements.errorDeletingAgreement'), type: 'error' });
	        });
	      }).catch(function () {});
	    },
	    onImportFileChange: function onImportFileChange(file) {
	      this.importFile = file.raw;
	    },
	    onImportFileRemove: function onImportFileRemove() {
	      this.importFile = null;
	    },
	    ensureUnmatchedSelection: function ensureUnmatchedSelection(row) {
	      var key = row.row_index;
	      if (!this.unmatchedSelections[key]) {
	        this.$set(this.unmatchedSelections, key, {
	          productId: row.product_id || null,
	          productOptions: [],
	          loading: false,
	          discountPercent: row.discount_percent != null ? row.discount_percent : null,
	          discountAmount: row.discount_amount != null ? row.discount_amount : null
	        });
	      }
	      return this.unmatchedSelections[key];
	    },
	    remoteProductSearchForUnmatched: function remoteProductSearchForUnmatched(query, row) {
	      var sel = this.ensureUnmatchedSelection(row);
	      var searchTerm = typeof query === 'string' && query.trim() ? query.trim() : (row.product_name || '').trim();
	      if (!searchTerm) {
	        sel.loading = false;
	        sel.productOptions = [];
	        return;
	      }
	      sel.loading = true;
	      (0, _search2.default)({ search: searchTerm, filter: 'active' }).then(function (products) {
	        var list = products || [];
	        var term = searchTerm.trim().toLowerCase();
	        sel.productOptions = list.filter(function (p) {
	          var name = p.name ? String(p.name).trim().toLowerCase() : '';
	          return name && name.indexOf(term) !== -1;
	        });
	        sel.loading = false;
	      }).catch(function () {
	        sel.loading = false;
	      });
	    },
	    addUnmatchedLine: function addUnmatchedLine(row) {
	      var _this5 = this;
	
	      var key = row.row_index;
	      var sel = this.unmatchedSelections[key];
	      var productId = sel && sel.productId || row.product_id;
	      var discountPercent = sel && sel.discountPercent !== undefined && sel.discountPercent !== null && sel.discountPercent !== '' ? Number(sel.discountPercent) : row.discount_percent != null ? row.discount_percent : null;
	      var discountAmount = sel && sel.discountAmount !== undefined && sel.discountAmount !== null && sel.discountAmount !== '' ? Number(sel.discountAmount) : row.discount_amount != null ? row.discount_amount : null;
	      if (!sel || !productId) {
	        this.$message({ message: this.$t('pricingAgreements.productAndMinQtyRequired'), type: 'warning' });
	        return;
	      }
	      if (discountPercent == null && discountAmount == null) {
	        this.$message({ message: this.$t('pricingAgreements.setDiscountOrAmount'), type: 'warning' });
	        return;
	      }
	      var agreementId = this.importResult.agreement && this.importResult.agreement.id;
	      if (!agreementId) return;
	      var payload = {
	        product_id: productId,
	        min_qty_or_pack_qty: row.min_qty,
	        discount_percent: discountPercent,
	        discount_amount: discountAmount,
	        comment: row.comment
	      };
	      _vue2.default.$http.post('pricing_agreements/' + agreementId + '/lines', payload).then(function () {
	        _this5.$message({ message: _this5.$t('pricingAgreements.lineAdded'), type: 'success' });
	        var idx = _this5.importResult.unmatched.findIndex(function (r) {
	          return r.row_index === key;
	        });
	        if (idx !== -1) _this5.importResult.unmatched.splice(idx, 1);
	        _this5.$delete(_this5.unmatchedSelections, key);
	        var total = _this5.importResult.unmatched.length;
	        var maxPage = Math.max(1, Math.ceil(total / _this5.unmatchedPerPage));
	        if (_this5.currentUnmatchedPage > maxPage) {
	          _this5.currentUnmatchedPage = maxPage;
	        }
	        if (total === 0) {
	          _this5.closeUnmatchedAndGoToEdit();
	        }
	      }).catch(function () {
	        _this5.$message({ message: _this5.$t('pricingAgreements.errorAddingProduct'), type: 'error' });
	      });
	    },
	    closeUnmatchedAndGoToEdit: function closeUnmatchedAndGoToEdit() {
	      var id = this.importResult && this.importResult.agreement && this.importResult.agreement.id;
	      this.showImportDialog = false;
	      this.importResult = null;
	      this.unmatchedSelections = {};
	      if (id) {
	        this.$router.push({ name: 'pricingAgreements.edit', params: { id: id } });
	      }
	    },
	    doImport: function doImport() {
	      var _this6 = this;
	
	      if (!this.importForm.client_id) {
	        this.$message({ message: 'Select a customer', type: 'warning' });
	        return;
	      }
	      if (!this.importFile) {
	        this.$message({ message: 'Choose a CSV or XLSX file', type: 'warning' });
	        return;
	      }
	      var clientId = Number(this.importForm.client_id);
	      var customerHasAgreement = this.items.some(function (a) {
	        return (a.client_id || a.client && a.client.id) === clientId;
	      });
	      if (customerHasAgreement) {
	        this.$confirm(this.$t('pricingAgreements.customerHasAgreementConfirm'), this.$t('pricingAgreements.confirm'), { type: 'warning' }).then(function () {
	          return _this6.submitImport();
	        }).catch(function () {});
	        return;
	      }
	      this.submitImport();
	    },
	    submitImport: function submitImport() {
	      var _this7 = this;
	
	      var formData = new FormData();
	      formData.append('client_id', this.importForm.client_id);
	      if (this.importForm.name) formData.append('name', this.importForm.name);
	      formData.append('file', this.importFile);
	      this.importing = true;
	      _vue2.default.$http.post('pricing_agreements/import', formData, {
	        headers: { 'Content-Type': 'multipart/form-data' }
	      }).then(function (_ref3) {
	        var data = _ref3.data;
	
	        _this7.importing = false;
	        var d = data.data || {};
	        var linesCreated = d.lines_created || 0;
	        var linesSkipped = d.lines_skipped || [];
	        var skipCount = (d.lines_skipped || []).length;
	        var unmatched = d.unmatched || [];
	        var msg = _this7.$t('pricingAgreements.importCreated', { count: linesCreated });
	        if (skipCount > 0) {
	          msg += ' ' + _this7.$t('pricingAgreements.importSkipped', { count: skipCount });
	        }
	        if (unmatched.length > 0) {
	          msg += ' ' + _this7.$t('pricingAgreements.needToMatch', { count: unmatched.length });
	        }
	        _this7.$message({
	          message: msg,
	          type: 'success',
	          duration: skipCount > 0 || unmatched.length > 0 ? 8000 : 3000
	        });
	        _this7.fetch();
	        if (unmatched.length > 0 && d.agreement && d.agreement.id) {
	          _this7.importResult = d;
	          _this7.unmatchedSelections = {};
	          _this7.currentUnmatchedPage = 1;
	          unmatched.forEach(function (row) {
	            _this7.$set(_this7.unmatchedSelections, row.row_index, {
	              productId: row.product_id || null,
	              productOptions: [],
	              loading: false,
	              discountPercent: row.discount_percent != null ? row.discount_percent : null,
	              discountAmount: row.discount_amount != null ? row.discount_amount : null
	            });
	          });
	          _this7.importForm = { client_id: null, name: '' };
	          _this7.importFile = null;
	          if (_this7.$refs.importUpload) _this7.$refs.importUpload.clearFiles();
	          return;
	        }
	        _this7.showImportDialog = false;
	        _this7.importResult = null;
	        _this7.unmatchedSelections = {};
	        _this7.importForm = { client_id: null, name: '' };
	        _this7.importFile = null;
	        if (_this7.$refs.importUpload) _this7.$refs.importUpload.clearFiles();
	        if (d.agreement && d.agreement.id) {
	          _this7.$router.push({ name: 'pricingAgreements.edit', params: { id: d.agreement.id } });
	        }
	      }).catch(function (err) {
	        _this7.importing = false;
	        var msg = err.response && err.response.data && err.response.data.error && err.response.data.error.message || err.response && err.response.data && err.response.data.message || _this7.$t('pricingAgreements.importFailed');
	        _this7.$message({ message: msg, type: 'error' });
	      });
	    }
	  })
	};

/***/ }),
/* 1934 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _productBundle = __webpack_require__(230);
	
	var _productBundle2 = _interopRequireDefault(_productBundle);
	
	var _productBundle3 = __webpack_require__(241);
	
	var _productBundle4 = _interopRequireDefault(_productBundle3);
	
	var _bulkAddProductModal = __webpack_require__(122);
	
	var _bulkAddProductModal2 = _interopRequireDefault(_bulkAddProductModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        description: {
	          value: '',
	          type: 'textarea'
	        },
	        price: {
	          value: '',
	          type: 'text',
	          attributes: {
	            disabled: true
	          }
	        }
	      }),
	      formTable: new _forms2.default({
	        productId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            disabled: true,
	            href: 'products/_/edit#productInfo'
	          }
	        },
	        price: {
	          value: '',
	          type: 'text'
	        },
	        qty: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      tableData: [],
	      groupErrors: []
	    };
	  },
	
	
	  watch: {
	    tableData: {
	      handler: function handler(value) {
	        var _this = this;
	
	        var price = 0;
	        value.forEach(function (p, key) {
	          price += parseFloat(p.price);
	          _this.tableData[key].price = p.items.reduce(function (accumulator, object) {
	            return accumulator + parseFloat(object.price) * object.qty;
	          }, 0);
	        });
	        this.form.price = price;
	      },
	
	      deep: true
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    products: 'basicProducts'
	  }), {
	    isInOwnRoute: function isInOwnRoute() {
	      return this.$route.name === 'productBundles.create';
	    },
	    list: function list() {
	      return this.tableData;
	    }
	  }),
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalButtonLoading: 'SET_MODAL_BUTTON_LOADING'
	  }), {
	    numberOnly: function numberOnly(e) {
	      if (!/^\d+$/.test(e.key)) {
	        e.preventDefault();
	      }
	    },
	    showBulkAddModal: function showBulkAddModal() {
	      this.setModalContent(function () {
	        return _bulkAddProductModal2.default;
	      });
	      this.setModalProps({
	        fetchProductsMethod: this.fetchAllProductBasic,
	        onSave: this.handleBulkSave
	      });
	      this.toggleModal(true);
	    },
	    fetchAllProductBasic: function fetchAllProductBasic() {
	      return Promise.all([_product2.default.allBasic({
	        filter: 'active',
	        type: 'product'
	      })]);
	    },
	    handleBulkSave: function handleBulkSave(selectedProducts) {
	      var _this2 = this;
	
	      var products = selectedProducts.map(function (p) {
	        return {
	          id: p.id,
	          name: p.name,
	          qty: p.qty,
	          taxId: p.taxId,
	          price: 0,
	
	          taxPerc: p.tax_perc
	        };
	      });
	      return Promise.all([]).then(function () {
	        products.forEach(function (item) {
	          var index = _this2.tableData.findIndex(function (obj) {
	            return obj.taxId === item.taxId;
	          });
	          if (index > -1) {
	            _this2.tableData[index].items.push(item);
	          } else {
	            _this2.tableData.push({
	              taxPerc: item.taxPerc,
	              taxId: item.taxId,
	              price: 0,
	              items: [item]
	            });
	          }
	        });
	      });
	    },
	    destroyTable: function destroyTable(id) {
	      var _this3 = this;
	
	      return Promise.all([]).then(function () {
	        _this3.tableData.forEach(function (obj, key) {
	          var index = obj.items.findIndex(function (p) {
	            return p.id === id;
	          });
	          if (index > -1) {
	            _this3.tableData[key].items.splice(index, 1);
	            if (_this3.tableData[key].items.length === 0) {
	              _this3.tableData.splice(key, 1);
	            }
	            return;
	          }
	        });
	      });
	    },
	    updateTable: function updateTable(id) {
	      var _this4 = this;
	
	      return Promise.all([]).then(function () {
	        _this4.tableData.forEach(function (obj, key) {
	          var index = obj.items.findIndex(function (p) {
	            return p.id === id;
	          });
	          if (index > -1) {
	            _this4.tableData[key].items[index].qty = _this4.formTable.qty;
	            _this4.tableData[key].items[index].price = _this4.formTable.price;
	            return;
	          }
	        });
	      });
	    },
	    store: function store() {
	      var _this5 = this;
	
	      this.form.loading = true;
	      this.groupErrors = [];
	      var product = _productBundle4.default.send(this.form.data());
	      product.bundles = this.tableData;
	      Promise.all([_productBundle2.default.store(product)]).then(function () {
	        _this5.form.loading = false;
	        _this5.$router.push({
	          name: 'productBundles.index'
	        });
	      }).catch(function (errors) {
	        _this5.form.recordErrors(errors);
	        _this5.form.loading = false;
	        _this5.groupErrors = errors;
	      });
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9),
	    VFormTable: __webpack_require__(46)
	  }
	};

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _productBundle = __webpack_require__(230);
	
	var _productBundle2 = _interopRequireDefault(_productBundle);
	
	var _productBundle3 = __webpack_require__(241);
	
	var _productBundle4 = _interopRequireDefault(_productBundle3);
	
	var _bulkAddProductModal = __webpack_require__(122);
	
	var _bulkAddProductModal2 = _interopRequireDefault(_bulkAddProductModal);
	
	var _productDeposit = __webpack_require__(96);
	
	var _productDeposit2 = _interopRequireDefault(_productDeposit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        description: {
	          value: '',
	          type: 'textarea'
	        },
	        price: {
	          value: '',
	          type: 'text',
	          attributes: {
	            disabled: true
	          }
	        }
	      }),
	      formTable: new _forms2.default({
	        productId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            disabled: true,
	            href: 'products/_/edit#productInfo'
	          }
	        },
	        price: {
	          value: '',
	          type: 'text'
	        },
	        productDepositName: {
	          value: '',
	          type: 'plaintext'
	        },
	        qty: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      tableData: [],
	      groupErrors: []
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    Promise.all([_productBundle2.default.show(_store2.default.state.route.params.id), _productDeposit2.default.all()]).then(function (res) {
	      _this.form.assignData(Object.assign({}, res[0], { productTypeId: null }));
	      _this.tableData = res[0].productBundleGroup.map(function (p) {
	        return {
	          group_id: p.id,
	          name: p.name,
	          taxId: p.tax_id,
	          taxPerc: p.tax_perc,
	          bundleId: p.bundle_id,
	          price: 0,
	          items: []
	        };
	      });
	      res[0].products.forEach(function (p) {
	        var deposit = _this.productDeposits.all.find(function (d) {
	          return +p.product_deposit_id === +d.id;
	        });
	        var index = _this.tableData.findIndex(function (p2) {
	          return p2.group_id === p.pivot.group_id;
	        });
	        _this.tableData[index].items.push({ price: p.pivot.price, qty: p.pivot.qty, id: p.id, name: p.name, depositAmount: deposit.amount || 0, productDepositName: deposit.amount ? _this.$t('static.orders.edit.deposit') + ': ' + deposit.name : '' });
	        _this.tableData[index].price = _this.tableData[index].items.reduce(function (accumulator, object) {
	          return accumulator + parseFloat(object.price) * object.qty + object.depositAmount * object.qty;
	        }, 0);
	      });
	    });
	  },
	
	
	  watch: {
	    tableData: {
	      handler: function handler(value) {
	        var _this2 = this;
	
	        var price = 0;
	        value.forEach(function (p, key) {
	          price += parseFloat(p.price);
	          _this2.tableData[key].price = p.items.reduce(function (accumulator, object) {
	            return accumulator + parseFloat(object.price) * object.qty + object.depositAmount * object.qty;
	          }, 0);
	        });
	        this.form.price = price;
	      },
	
	      deep: true
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    products: 'basicProducts',
	    productDeposits: 'allProductDeposits'
	  }), {
	    isInOwnRoute: function isInOwnRoute() {
	      return this.$route.name === 'productBundles.edit';
	    },
	    list: function list() {
	      return this.tableData;
	    }
	  }),
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalButtonLoading: 'SET_MODAL_BUTTON_LOADING'
	  }), {
	    numberOnly: function numberOnly(e) {
	      if (!/^\d+$/.test(e.key)) {
	        e.preventDefault();
	      }
	    },
	    showBulkAddModal: function showBulkAddModal() {
	      this.setModalContent(function () {
	        return _bulkAddProductModal2.default;
	      });
	      this.setModalProps({
	        fetchProductsMethod: this.fetchAllProductBasic,
	        onSave: this.handleBulkSave
	      });
	      this.toggleModal(true);
	    },
	    fetchAllProductBasic: function fetchAllProductBasic() {
	      return Promise.all([_product2.default.allBasic({
	        filter: 'active',
	        type: 'product'
	      })]);
	    },
	    handleBulkSave: function handleBulkSave(selectedProducts) {
	      var _this3 = this;
	
	      var products = selectedProducts.map(function (p) {
	        var deposit = _this3.productDeposits.all.find(function (d) {
	          return +p.productDepositId === +d.id;
	        });
	        return {
	          id: p.id,
	          productId: p.id,
	          name: p.name,
	          qty: p.qty,
	          taxId: p.taxId,
	          price: 0,
	          depositAmount: deposit.amount || 0,
	          productDepositName: deposit.amount ? _this3.$t('static.orders.edit.deposit') + ': ' + deposit.name : '',
	
	          taxPerc: p.tax_perc
	        };
	      });
	      return Promise.all([]).then(function () {
	        products.forEach(function (item) {
	          var index = _this3.tableData.findIndex(function (obj) {
	            return obj.taxId === item.taxId;
	          });
	          if (index > -1) {
	            _this3.tableData[index].items.push(item);
	          } else {
	            _this3.tableData.push({
	              group_id: 0,
	              taxPerc: item.taxPerc,
	              taxId: item.taxId,
	              price: 0,
	              items: [item]
	            });
	          }
	        });
	      });
	    },
	    destroyTable: function destroyTable(id) {
	      var _this4 = this;
	
	      return Promise.all([]).then(function () {
	        _this4.tableData.forEach(function (obj, key) {
	          var index = obj.items.findIndex(function (p) {
	            return p.id === id;
	          });
	          if (index > -1) {
	            _this4.tableData[key].items.splice(index, 1);
	            if (_this4.tableData[key].items.length === 0) {
	              _this4.tableData.splice(key, 1);
	            }
	            return;
	          }
	        });
	      });
	    },
	    updateTable: function updateTable(id) {
	      var _this5 = this;
	
	      return Promise.all([]).then(function () {
	        _this5.tableData.forEach(function (obj, key) {
	          var index = obj.items.findIndex(function (p) {
	            return p.id === id;
	          });
	          if (index > -1) {
	            _this5.tableData[key].items[index].qty = _this5.formTable.qty;
	            _this5.tableData[key].items[index].price = _this5.formTable.price;
	            return;
	          }
	        });
	      });
	    },
	    update: function update() {
	      var _this6 = this;
	
	      this.form.loading = true;
	      this.groupErrors = [];
	      var product = _productBundle4.default.send(this.form.data());
	      product.bundles = this.tableData;
	      Promise.all([_productBundle2.default.update(_store2.default.state.route.params.id, product)]).then(function () {
	        _this6.form.loading = false;
	        _this6.$message({
	          message: _this6.$t('static.products.edit.success'),
	          type: 'success'
	        });
	      }).catch(function (errors) {
	        _this6.form.recordErrors(errors);
	        _this6.form.loading = false;
	        _this6.groupErrors = errors;
	      });
	    },
	    destroy: function destroy() {
	      var _this7 = this;
	
	      Promise.all([_productBundle2.default.destroy(_store2.default.state.route.params.id)]).then(function () {
	        _this7.$router.push({
	          name: 'productBundles.index'
	        });
	      });
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9),
	    VFormTable: __webpack_require__(46)
	  }
	};

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _productBundle = __webpack_require__(230);
	
	var _productBundle2 = _interopRequireDefault(_productBundle);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _stringFormat = __webpack_require__(108);
	
	var _stringFormat2 = _interopRequireDefault(_stringFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      info: 'info',
	      loading: true,
	      search: '',
	      limit: 25
	    };
	  },
	
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19)
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    products: 'paginatedProducts',
	    account: 'account',
	    searchQuery: 'productQuery'
	  }), {
	    hasInventory: function hasInventory() {
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name === 'Inventory') {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	  }),
	
	  watch: {
	    $route: function $route() {
	      this.all(this.searchQuery.page, this.limit);
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this = this;
	
	      this.loading = true;
	      var query = { page: page, limit: limit, search: this.searchQuery.search };
	      _store2.default.dispatch('setProductQuery', query);
	      this.search = this.searchQuery.search;
	      _productBundle2.default.items({
	        page: page,
	        limit: limit,
	        search: this.searchQuery.search
	      }).then(function () {
	        _this.loading = false;
	      }).catch(function () {
	        _this.loading = false;
	      });
	    }, 800),
	
	    onChangeSearch: function onChangeSearch(name, value) {
	      _store2.default.dispatch('setProductQuery', { page: 1, limit: this.limit, search: value });
	      this.all(1, this.limit);
	    },
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'product', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    sidebar: function sidebar() {
	      var productFilter = {
	        title: this.$t('static.products.filters.title'),
	        options: [{
	          title: this.$t('static.products.filters.withDeposit'),
	          route: {
	            name: 'products.index',
	            query: {
	              filter: 'withDeposit'
	            }
	          }
	        }, {
	          title: this.$t('static.products.filters.active'),
	          route: {
	            name: 'products.index',
	            query: {
	              filter: 'active'
	            }
	          }
	        }, {
	          title: this.$t('static.products.filters.deactivated'),
	          route: {
	            name: 'products.index',
	            query: {
	              filter: 'deactivated'
	            }
	          }
	        }, {
	          title: this.$t('static.products.filters.materials'),
	          route: {
	            name: 'products.index',
	            query: {
	              type: 'Material'
	            }
	          }
	        }, {
	          title: this.$t('static.products.filters.all'),
	          route: {
	            name: 'products.index'
	          }
	        }],
	        button: {
	          title: '+ ' + this.$t('static.products.create.title'),
	          route: {
	            name: 'products.create'
	          }
	        }
	      };
	      var vmpSyncMenu = {};
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name === 'EDI') {
	            productFilter = {
	              title: this.$t('static.products.filters.title'),
	              options: [{
	                title: this.$t('static.products.filters.active'),
	                route: {
	                  name: 'products.index',
	                  query: {
	                    filter: 'active'
	                  }
	                }
	              }, {
	                title: this.$t('static.products.filters.deactivated'),
	                route: {
	                  name: 'products.index',
	                  query: {
	                    filter: 'deactivated'
	                  }
	                }
	              }, {
	                title: this.$t('static.products.filters.withDeposit'),
	                route: {
	                  name: 'products.index',
	                  query: {
	                    filter: 'withDeposit'
	                  }
	                }
	              }, {
	                title: this.$t('static.products.filters.materials'),
	                route: {
	                  name: 'products.index',
	                  query: {
	                    type: 'Material'
	                  }
	                }
	              }, {
	                title: this.$t('static.products.filters.asko'),
	                route: {
	                  name: 'products.index',
	                  query: {
	                    filter: 'asko'
	                  }
	                }
	              }, {
	                title: this.$t('static.products.filters.vinhuset'),
	                route: {
	                  name: 'products.index',
	                  query: {
	                    filter: 'vinhuset'
	                  }
	                }
	              }, {
	                title: this.$t('static.products.filters.marketplace'),
	                route: {
	                  name: 'products.index',
	                  query: {
	                    filter: 'marketplace'
	                  }
	                }
	              }, {
	                title: this.$t('static.products.filters.onlineStore'),
	                route: {
	                  name: 'products.index',
	                  query: {
	                    filter: 'onlineStore'
	                  }
	                }
	              }, {
	                title: this.$t('static.products.filters.alcohol'),
	                route: {
	                  name: 'products.index',
	                  query: {
	                    filter: 'alcohol'
	                  }
	                }
	              }, {
	                title: this.$t('static.products.filters.alcoholFree'),
	                route: {
	                  name: 'products.index',
	                  query: {
	                    filter: 'alcoholFree'
	                  }
	                }
	              }, {
	                title: this.$t('static.products.filters.all'),
	                route: {
	                  name: 'products.index'
	                }
	              }],
	              button: {
	                title: '+ ' + this.$t('static.products.create.title'),
	                route: {
	                  name: 'products.create'
	                }
	              }
	            };
	          }
	          if (this.account.modules[i].name == 'Vinmonopolet') {
	            vmpSyncMenu = {
	              title: this.$t('static.products.syncVmp.title'),
	              button: {
	                title: '+ ' + this.$t('static.products.syncVmp.title'),
	                route: {
	                  name: 'products.syncVmp'
	                }
	              }
	            };
	          }
	        }
	      }
	
	      var productBundle = {
	        title: this.$t('static.productBundles.filters.title'),
	        options: [{
	          title: this.$t('static.productBundles.filters.all'),
	          route: {
	            name: 'productBundles.index'
	          }
	        }],
	        button: {
	          title: '+ ' + this.$t('static.productBundles.create.title'),
	          route: {
	            name: 'productBundles.create'
	          }
	        }
	      };
	
	      this.setInnerSidebar([productFilter, productBundle, vmpSyncMenu, {
	        title: this.$t('static.productPackagings.filters.title'),
	        options: [{
	          title: this.$t('static.productPackagings.filters.all'),
	          route: {
	            name: 'productPackagings.index'
	          }
	        }],
	        button: {
	          title: '+ ' + this.$t('static.productPackagings.create.title'),
	          route: {
	            name: 'productPackagings.create'
	          }
	        }
	      }, {
	        title: this.$t('static.productGroups.filters.title'),
	        options: [{
	          title: this.$t('static.productGroups.filters.all'),
	          route: {
	            name: 'productGroups.index'
	          }
	        }],
	        button: {
	          title: '+ ' + this.$t('static.productGroups.create.title'),
	          route: {
	            name: 'productGroups.create'
	          }
	        }
	      }, {
	        title: this.$t('static.productTags.filters.title'),
	        options: [{
	          title: this.$t('static.productTags.filters.all'),
	          route: {
	            name: 'productTags.index'
	          }
	        }],
	        button: {
	          title: '+ ' + this.$t('static.productTags.create.title'),
	          route: {
	            name: 'productTags.create'
	          }
	        }
	      }]);
	    },
	    editProduct: function editProduct(product) {
	      this.$router.push({
	        name: 'productBundles.edit',
	        params: { id: product.id }
	      });
	    },
	    editProductNewTab: function editProductNewTab(product) {
	      var route = this.$router.resolve({
	        name: 'productBundles.edit',
	        params: { id: product.id }
	      });
	      window.open(route.href, '_blank');
	    }
	  }),
	
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.sidebar();
	
	    _account2.default.rememberPerPage('get', { from: 'product' }).then(function (data) {
	      _this3.limit = data.size;
	      _this3.all(_this3.searchQuery.page, _this3.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	    _store2.default.dispatch('resetProducts');
	  },
	
	
	  mixins: [_search2.default, _stringFormat2.default]
	};

/***/ }),
/* 1938 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _productFlow = __webpack_require__(304);
	
	var _productFlow2 = _interopRequireDefault(_productFlow);
	
	var _productFlow3 = __webpack_require__(133);
	
	var _productFlow4 = _interopRequireDefault(_productFlow3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        title: {
	          value: '',
	          type: 'text'
	        },
	        descriptions: {
	          value: '',
	          type: 'textarea'
	        },
	        orderId: {
	          value: '',
	          type: 'select'
	        },
	        productId: {
	          value: '',
	          type: 'select'
	        },
	        qty: {
	          value: '',
	          type: 'number'
	        }
	      }),
	      loading: true,
	      tabIndex: 'first'
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    products: 'allProducts',
	    orders: 'allproductFlowOrders'
	  })),
	
	  watch: {
	    products: function products(_products) {
	      this.formBasicInformation.setOptions('productId', _products.map(function (c) {
	        return { id: c.id, name: '' + c.name };
	      }));
	    },
	    orders: function orders(_orders) {
	      console.log(_orders);
	      this.formBasicInformation.setOptions('orderId', _orders.map(function (c) {
	        return { id: c.id, name: '' + c.name };
	      }));
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.loading = true;
	    Promise.all([_product2.default.all(), _productFlow2.default.orders()]).then(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  methods: {
	    store: function store() {
	      var _this2 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _productFlow4.default.send(Object.assign({}, this.formBasicInformation.data()));
	      _productFlow2.default.store(client).then(function () {
	        _this2.$message({
	          message: _this2.$t('static.productFlow.create.success'),
	          type: 'success'
	        });
	        _this2.$router.push({
	          name: 'productFlow.index'
	        });
	      }).catch(function (errors) {
	        _this2.formBasicInformation.loading = false;
	        _this2.loading = false;
	        _this2.formBasicInformation.recordErrors(errors);
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _productFlow = __webpack_require__(304);
	
	var _productFlow2 = _interopRequireDefault(_productFlow);
	
	var _productFlow3 = __webpack_require__(133);
	
	var _productFlow4 = _interopRequireDefault(_productFlow3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        title: {
	          value: '',
	          type: 'text'
	        },
	        descriptions: {
	          value: '',
	          type: 'textarea'
	        },
	        orderId: {
	          value: '',
	          type: 'select'
	        },
	        productId: {
	          value: '',
	          type: 'select'
	        },
	        qty: {
	          value: '',
	          type: 'number'
	        }
	      }),
	      loading: true,
	      tabIndex: 'first'
	
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    productFlow: 'currentproductFlow',
	    products: 'allProducts',
	    orders: 'allproductFlowOrders'
	  })),
	
	  watch: {
	    products: function products(_products) {
	      this.formBasicInformation.setOptions('productId', _products.map(function (c) {
	        return { id: c.id, name: '' + c.name };
	      }));
	    },
	    orders: function orders(_orders) {
	      console.log(_orders);
	      this.formBasicInformation.setOptions('orderId', _orders.map(function (c) {
	        return { id: c.id, name: '' + c.name };
	      }));
	    }
	  },
	
	  created: function created() {
	    this.show();
	  },
	
	
	  methods: {
	    update: function update() {
	      var _this = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var supp = _productFlow4.default.send(Object.assign({}, this.formBasicInformation.data()));
	      console.log(supp);
	      _productFlow2.default.update(this.$route.params.id, supp).then(function () {
	        _this.$message({
	          message: _this.$t('static.productFlow.update.success'),
	          type: 'success'
	        });
	        _this.$router.push({
	          name: 'productFlow.index'
	        });
	      }).catch(function (errors) {
	        _this.formBasicInformation.loading = false;
	        _this.formBasicInformation.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      var _this2 = this;
	
	      this.loading = true;
	      Promise.all([_productFlow2.default.show(this.$route.params.id), _product2.default.all(), _productFlow2.default.orders()]).then(function (data) {
	        _this2.loading = false;
	        var ware = data[0];
	        _this2.formBasicInformation.assignData(ware);
	        _this2.formBasicInformation.disableField('orderId');
	
	        console.log(_this2.productList);
	      });
	    },
	    link: function link(productFlow) {
	      var routeData = this.$router.resolve({
	        params: { id: productFlow.productFlowId },
	        name: 'productFlow.edit'
	      });
	      window.open(routeData.href, '_blank');
	    },
	    transactionLink: function transactionLink(trans) {
	      var name = '';
	      if (trans.via == 'Stock count') {
	        name = 'inventory.stock.view';
	      } else if (trans.via == 'Stock Adjustment') {
	        name = 'inventory.adjustment.view';
	      } else if (trans.via == 'Order') {
	        name = 'orders.edit';
	      } else if (trans.via == 'Purchase') {
	        name = 'inventory.purchase.view';
	      }
	      console.log(name);
	      var routeData = this.$router.resolve({
	        params: { id: trans.id },
	        name: name
	      });
	      window.open(routeData.href, '_blank');
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9),
	    VTable: __webpack_require__(33)
	  }
	};

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(5);
	
	var _productFlow = __webpack_require__(304);
	
	var _productFlow2 = _interopRequireDefault(_productFlow);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sortValue: ''
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    productFlows: 'paginateproductFlows'
	  }), {
	    productFlowsList: function productFlowsList() {
	      return this.productFlows.items.map(function (b) {
	
	        return b;
	      });
	    }
	  }),
	
	  watch: {
	    $route: function $route() {
	      this.all(1, 50);
	    }
	  },
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(2724),
	    VNoData: __webpack_require__(19)
	  },
	
	  mixins: [_search2.default],
	
	  mounted: function mounted() {
	    this.setInnerSidebar([{
	      title: this.$t('static.inventory.title'),
	      options: [{
	        title: this.$t('static.inventory.products.view'),
	        route: {
	          name: 'products.index'
	        }
	      }, {
	        title: this.$t('static.inventory.products.create'),
	        route: {
	          name: 'products.create'
	        }
	      }]
	
	    }, {
	      title: this.$t('static.productGroups.filters.title'),
	      options: [{
	        title: this.$t('static.productGroups.filters.latest'),
	        route: {
	          name: 'productGroups.index',
	          query: {
	            filter: 'latest'
	          }
	        }
	      }, {
	        title: this.$t('static.productGroups.filters.pastMonth'),
	        route: {
	          name: 'productGroups.index',
	          query: {
	            filter: 'pastMonth'
	          }
	        }
	      }, {
	        title: this.$t('static.productGroups.filters.all'),
	        route: {
	          name: 'productGroups.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productGroups.create.title'),
	        route: {
	          name: 'productGroups.create'
	        }
	      }
	    }, {
	      title: this.$t('static.productFlow.title'),
	      options: [{
	        title: this.$t('static.productFlow.filters.all'),
	        route: {
	          name: 'productFlow.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productFlow.create.title'),
	        route: {
	          name: 'productFlow.create'
	        }
	      }
	    }]);
	    this.all(1, 50);
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this = this;
	
	      this.loading = true;
	      _productFlow2.default.items({
	        page: page,
	        limit: limit,
	        search: this.getSearch(),
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this.loading = false;
	      }).catch(function () {
	        _this.loading = false;
	      });
	    }, 800),
	
	    editproductFlow: function editproductFlow(productFlow) {
	      var name = 'productFlow.edit';
	      this.$router.push({
	        name: name,
	        params: { id: productFlow.id }
	      });
	    }
	  })
	};

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _productGroup = __webpack_require__(160);
	
	var _productGroup2 = _interopRequireDefault(_productGroup);
	
	var _exciseGroup = __webpack_require__(94);
	
	var _exciseGroup2 = _interopRequireDefault(_exciseGroup);
	
	var _productGroup3 = __webpack_require__(110);
	
	var _productGroup4 = _interopRequireDefault(_productGroup3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        description: {
	          value: '',
	          type: 'textarea'
	        },
	        parentGroupId: {
	          value: '',
	          type: 'select'
	        }
	      })
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    Promise.all([_productGroup2.default.all(), _exciseGroup2.default.all()]).then(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  computed: _extends({
	    isInOwnRoute: function isInOwnRoute() {
	      return this.$route.name === 'productGroups.create';
	    }
	  }, (0, _vuex.mapGetters)({
	    productGroups: 'allProductGroups',
	    groups: 'allExciseGroups'
	  })),
	
	  methods: {
	    store: function store() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var productGroup = _productGroup4.default.send(this.form.data());
	      _productGroup2.default.store(productGroup).then(function () {
	        _this2.form.loading = false;
	        if (_this2.isInOwnRoute) {
	          _this2.$message({
	            message: _this2.$t('static.productGroups.create.success'),
	            type: 'success'
	          });
	          _this2.$router.push({
	            name: 'productGroups.index'
	          });
	        } else {
	          _this2.$emit('close');
	          _productGroup2.default.all();
	        }
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    }
	  },
	
	  watch: {
	    productGroups: function productGroups(_productGroups) {
	      this.form.setOptions('parentGroupId', _productGroups.all);
	    },
	    duties: function duties(_duties) {
	      this.form.setOptions('exciseDutyId', _duties.map(function (c) {
	        return { id: c.id, name: '' + c.title };
	      }));
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _productGroup = __webpack_require__(160);
	
	var _productGroup2 = _interopRequireDefault(_productGroup);
	
	var _productGroup3 = __webpack_require__(110);
	
	var _productGroup4 = _interopRequireDefault(_productGroup3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _exciseGroup = __webpack_require__(94);
	
	var _exciseGroup2 = _interopRequireDefault(_exciseGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        description: {
	          value: '',
	          type: 'textarea'
	        },
	        parentGroupId: {
	          value: '',
	          type: 'select'
	        },
	        exciseDutyId: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      loading: false
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    Promise.all([_productGroup2.default.all(), _exciseGroup2.default.all()]).then(function () {
	      _this.loading = false;
	    });
	    this.show();
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    productGroups: 'allProductGroups'
	  })),
	
	  methods: {
	    update: function update() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var productGroup = _productGroup4.default.send(this.form.data());
	      _productGroup2.default.update(_store2.default.state.route.params.id, productGroup).then(function () {
	        _this2.form.loading = false;
	        _this2.$message({
	          message: _this2.$t('static.productGroups.edit.success'),
	          type: 'success'
	        });
	        _this2.$router.push({
	          name: 'productGroups.index'
	        });
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      var _this3 = this;
	
	      this.loading = true;
	      _productGroup2.default.show(_store2.default.state.route.params.id).then(function (productGroup) {
	        _this3.form.assignData(productGroup);
	        _this3.loading = false;
	      });
	    }
	  },
	
	  watch: {
	    productGroups: function productGroups(_productGroups) {
	      this.form.setOptions('parentGroupId', _productGroups.all);
	    },
	    duties: function duties(_duties) {
	      console.log(_duties);
	      this.form.setOptions('exciseDutyId', _duties.map(function (c) {
	        return { id: c.id, name: '' + c.title };
	      }));
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _productGroup = __webpack_require__(160);
	
	var _productGroup2 = _interopRequireDefault(_productGroup);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false,
	      sort: '',
	      limit: 25
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    productGroups: 'paginatedProductGroups',
	    account: 'account'
	  })),
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19)
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var productFilter = {
	      title: this.$t('static.products.filters.title'),
	      options: [{
	        title: this.$t('static.products.filters.withDeposit'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'withDeposit'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.deactivated'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'deactivated'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.materials'),
	        route: {
	          name: 'products.index',
	          query: {
	            type: 'Material'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.all'),
	        route: {
	          name: 'products.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.products.create.title'),
	        route: {
	          name: 'products.create'
	        }
	      }
	    };
	    var productBundle = {
	      title: this.$t('static.productBundles.filters.title'),
	      options: [{
	        title: this.$t('static.productBundles.filters.all'),
	        route: {
	          name: 'productBundles.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productBundles.create.title'),
	        route: {
	          name: 'productBundles.create'
	        }
	      }
	    };
	    var vmpSyncMenu = {};
	    if (this.account.modules.length > 0) {
	      for (var i = 0; i < this.account.modules.length; i++) {
	        if (this.account.modules[i].name == 'EDI') {
	          productFilter = {
	            title: this.$t('static.products.filters.title'),
	            options: [{
	              title: this.$t('static.products.filters.active'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'active'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.deactivated'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'deactivated'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.withDeposit'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'withDeposit'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.materials'),
	              route: {
	                name: 'products.index',
	                query: {
	                  type: 'Material'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.asko'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'asko'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.vinhuset'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'vinhuset'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.marketplace'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'marketplace'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.onlineStore'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'onlineStore'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.alcohol'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'alcohol'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.alcoholFree'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'alcoholFree'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.all'),
	              route: {
	                name: 'products.index'
	              }
	            }],
	            button: {
	              title: '+ ' + this.$t('static.products.create.title'),
	              route: {
	                name: 'products.create'
	              }
	            }
	          };
	        }
	        if (this.account.modules[i].name == 'Vinmonopolet') {
	          vmpSyncMenu = {
	            title: this.$t('static.products.syncVmp.title'),
	            button: {
	              title: '+ ' + this.$t('static.products.syncVmp.title'),
	              route: {
	                name: 'products.syncVmp'
	              }
	            }
	          };
	        }
	      }
	    }
	
	    this.setInnerSidebar([productFilter, productBundle, vmpSyncMenu, {
	      title: this.$t('static.productPackagings.filters.title'),
	      options: [{
	        title: this.$t('static.productPackagings.filters.all'),
	        route: {
	          name: 'productPackagings.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productPackagings.create.title'),
	        route: {
	          name: 'productPackagings.create'
	        }
	      }
	    }, {
	      title: this.$t('static.productGroups.filters.title'),
	      options: [{
	        title: this.$t('static.productGroups.filters.all'),
	        route: {
	          name: 'productGroups.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productGroups.create.title'),
	        route: {
	          name: 'productGroups.create'
	        }
	      }
	    }, {
	      title: this.$t('static.productTags.filters.title'),
	      options: [{
	        title: this.$t('static.productTags.filters.all'),
	        route: {
	          name: 'productTags.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productTags.create.title'),
	        route: {
	          name: 'productTags.create'
	        }
	      }
	    }, {
	      title: this.$t('static.exciseEntry.title'),
	      options: [{
	        title: this.$t('static.exciseEntry.filters.all'),
	        route: {
	          name: 'exciseentry.index'
	        }
	      }]
	    }]);
	
	    _account2.default.rememberPerPage('get', { from: 'product_group' }).then(function (data) {
	      _this.limit = data.size;
	      _this.all(1, _this.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  watch: {
	    $route: function $route() {
	      this.all(1, this.limit);
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'product_group', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    all: (0, _debounce2.default)(function (page) {
	      var _this3 = this;
	
	      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	      this.loading = true;
	      _productGroup2.default.items({
	        page: page,
	        limit: limit,
	        search: this.getSearch(this.limit),
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this3.loading = false;
	      }).catch(function () {
	        _this3.loading = false;
	      });
	    }, 800),
	
	    deleteProductGroup: function deleteProductGroup(productGroup) {
	      var _this4 = this;
	
	      this.$confirm(this.$t('static.productGroups.index.confirmDelete'), this.$t('static.productGroups.index.confirmDeleteTitle'), {
	        confirmButtonText: this.$t('button.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _productGroup2.default.destroy(productGroup.id).catch(function (_ref) {
	          var response = _ref.response;
	
	          var message = response.data.error.code === 40114 ? _this4.$t('static.productGroups.index.deleteHasProductError') : _this4.$t('static.productGroups.index.deleteError');
	          _this4.$message({
	            showClose: true,
	            message: message,
	            type: 'error'
	          });
	        });
	      }).catch(function () {});
	    },
	    editProductGroup: function editProductGroup(productGroup) {
	      this.$router.push({
	        name: 'productGroups.edit',
	        params: { id: productGroup.id }
	      });
	    },
	    goToProducts: function goToProducts(id, e) {
	      e.stopPropagation();
	      this.$router.push({ name: 'products.index', query: { filter: 'productGroup,' + id } });
	    }
	  }),
	
	  mixins: [_search2.default]
	};

/***/ }),
/* 1945 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _productPackaging = __webpack_require__(126);
	
	var _productPackaging2 = _interopRequireDefault(_productPackaging);
	
	var _packagingMaterial = __webpack_require__(465);
	
	var _packagingMaterial2 = _interopRequireDefault(_packagingMaterial);
	
	var _packagingType = __webpack_require__(466);
	
	var _packagingType2 = _interopRequireDefault(_packagingType);
	
	var _material = __webpack_require__(125);
	
	var _material2 = _interopRequireDefault(_material);
	
	var _exciseGroup = __webpack_require__(94);
	
	var _exciseGroup2 = _interopRequireDefault(_exciseGroup);
	
	var _productPackaging3 = __webpack_require__(134);
	
	var _productPackaging4 = _interopRequireDefault(_productPackaging3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    onClose: {
	      required: false,
	      type: Function,
	      default: null
	    },
	    suggestedData: {
	      required: false,
	      type: Object,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        volume: {
	          value: '',
	          type: 'text'
	        },
	        qtyInCrate: {
	          value: '',
	          type: 'number'
	        },
	        packagingTypeId: {
	          value: '',
	          type: 'select'
	        },
	        packagingMaterialId: {
	          value: '',
	          type: 'select'
	        },
	        materialId: {
	          value: '',
	          type: 'select'
	        },
	        crateMaterialId: {
	          value: '',
	          type: 'select'
	        }
	      })
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    Promise.all([_productPackaging2.default.all(), _packagingMaterial2.default.all(), _packagingType2.default.all(), _exciseGroup2.default.all(), _material2.default.all()]).then(function () {
	      _this.loading = false;
	      if (!_this.hasProduction) {
	        _this.form.hideField('materialId');
	        _this.form.hideField('crateMaterialId');
	      }
	    });
	    if (this.suggestedData) {
	      this.form.assignData({
	        name: this.suggestedData.packagingName + ' - ' + this.suggestedData.bottleVolume,
	        volume: this.suggestedData.bottleVolume,
	        qtyInCrate: this.suggestedData.packagingQuantity,
	        packagingMaterialId: this.suggestedData.packagingMaterialId
	      });
	    }
	  },
	
	
	  computed: _extends({
	    isInOwnRoute: function isInOwnRoute() {
	      return this.$route.name === 'productPackagings.create';
	    }
	  }, (0, _vuex.mapGetters)({
	    productPackagings: 'allProductPackagings',
	    packagingMaterials: 'allPackagingMaterials',
	    packagingTypes: 'allPackagingTypes',
	    groups: 'allExciseGroups',
	    materials: 'allMaterials',
	    account: 'account'
	  }), {
	    hasProduction: function hasProduction() {
	      if (this.account.modules.length > 0) {
	        return this.account.modules.find(function (module) {
	          return module.name === 'Production';
	        });
	      }
	      if (this.account.allowProducerBatches) return true;
	
	      return false;
	    }
	  }),
	
	  watch: {
	    packagingMaterials: function packagingMaterials() {
	      this.form.setOptions('packagingMaterialId', this.packagingMaterials.all);
	    },
	    packagingTypes: function packagingTypes() {
	      this.form.setOptions('packagingTypeId', this.packagingTypes.all);
	    },
	    materials: function materials() {
	      this.form.setOptions('materialId', this.materials.filter(function (m) {
	        return m.materialType === 'Packaging';
	      }).map(function (item) {
	        return { id: item.id, name: item.name };
	      }));
	      this.form.setOptions('crateMaterialId', this.materials.filter(function (m) {
	        return m.materialType === 'Crates and boxes';
	      }).map(function (item) {
	        return { id: item.id, name: item.name };
	      }));
	    }
	  },
	
	  methods: {
	    store: function store() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var productPackaging = _productPackaging4.default.send(this.form.data());
	      _productPackaging2.default.store(productPackaging).then(function () {
	        _this2.form.loading = false;
	        if (_this2.isInOwnRoute) {
	          _this2.$message({
	            message: _this2.$t('static.productPackagings.create.success'),
	            type: 'success'
	          });
	          _this2.$router.push({
	            name: 'productPackagings.index'
	          });
	        } else {
	          if (typeof _this2.onClose === 'function') {
	            _this2.onClose();
	          } else {
	            _this2.$emit('close');
	          }
	          _productPackaging2.default.all();
	        }
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _productPackaging = __webpack_require__(126);
	
	var _productPackaging2 = _interopRequireDefault(_productPackaging);
	
	var _packagingMaterial = __webpack_require__(465);
	
	var _packagingMaterial2 = _interopRequireDefault(_packagingMaterial);
	
	var _packagingType = __webpack_require__(466);
	
	var _packagingType2 = _interopRequireDefault(_packagingType);
	
	var _productPackaging3 = __webpack_require__(134);
	
	var _productPackaging4 = _interopRequireDefault(_productPackaging3);
	
	var _material = __webpack_require__(125);
	
	var _material2 = _interopRequireDefault(_material);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _exciseGroup = __webpack_require__(94);
	
	var _exciseGroup2 = _interopRequireDefault(_exciseGroup);
	
	var _depositSystem = __webpack_require__(296);
	
	var _depositSystem2 = _interopRequireDefault(_depositSystem);
	
	var _productDeposit = __webpack_require__(96);
	
	var _productDeposit2 = _interopRequireDefault(_productDeposit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      productsCount: 0,
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        volume: {
	          value: '',
	          type: 'text'
	        },
	        qtyInCrate: {
	          value: '',
	          type: 'number'
	        },
	        packagingTypeId: {
	          value: '',
	          type: 'select'
	        },
	        packagingMaterialId: {
	          value: '',
	          type: 'select'
	        },
	        materialId: {
	          value: '',
	          type: 'select'
	        },
	        crateMaterialId: {
	          value: '',
	          type: 'select'
	        }
	      }),
	
	      inheritFieldsform: new _forms2.default({
	        excisePackagingGroup: {
	          value: '',
	          type: 'select'
	        },
	        exciseBasicGroup: {
	          value: '',
	          type: 'select'
	        },
	        depositSystemId: {
	          value: '',
	          type: 'select'
	        },
	        productDepositId: {
	          value: '',
	          type: 'select'
	        },
	        overrideProducts: {
	          value: false,
	          type: 'checkbox'
	        }
	      }),
	      loading: false,
	      initLoad: false
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    Promise.all([_exciseGroup2.default.basic(), _exciseGroup2.default.packaging(), _depositSystem2.default.all(), _productDeposit2.default.all(), _productPackaging2.default.all(), _packagingMaterial2.default.all(), _packagingType2.default.all(), _exciseGroup2.default.all(), _material2.default.all()]).then(function () {
	      _this.loading = false;
	      if (!_this.hasProduction) {
	        _this.form.hideField('materialId');
	        _this.form.hideField('crateMaterialId');
	      }
	      _this.inheritFieldsform.setOptions('depositSystemId', _this.depositSystems.all.map(function (depositSystem) {
	        return { id: depositSystem.id, name: depositSystem.name };
	      }));
	      _this.inheritFieldsform.setOptions('productDepositId', _this.productDeposits.all.map(function (deposit) {
	        return { id: deposit.id, name: deposit.name };
	      }));
	      _this.show();
	    });
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    productPackagings: 'allProductPackagings',
	    packagingMaterials: 'allPackagingMaterials',
	    packagingTypes: 'allPackagingTypes',
	    materials: 'allMaterials',
	    account: 'account',
	    exciseBasicGroups: 'allExciseBasicGroups',
	    excisePackagingGroups: 'allExcisePackagingGroups',
	    depositSystems: 'allDepositSystems',
	    productDeposits: 'allProductDeposits'
	  }), {
	    hasProduction: function hasProduction() {
	      if (this.account.modules.length > 0) {
	        return this.account.modules.find(function (module) {
	          return module.name === 'Production';
	        });
	      }
	      if (this.account.allowProducerBatches) return true;
	      return false;
	    }
	  }),
	
	  watch: {
	    packagingMaterials: function packagingMaterials() {
	      this.form.setOptions('packagingMaterialId', this.packagingMaterials.all);
	    },
	    packagingTypes: function packagingTypes() {
	      this.form.setOptions('packagingTypeId', this.packagingTypes.all);
	    },
	    materials: function materials() {
	      this.form.setOptions('materialId', this.materials.filter(function (m) {
	        return m.materialType === 'Packaging';
	      }).map(function (item) {
	        return { id: item.id, name: item.name };
	      }));
	      this.form.setOptions('crateMaterialId', this.materials.filter(function (m) {
	        return m.materialType === 'Crates and boxes';
	      }).map(function (item) {
	        return { id: item.id, name: item.name };
	      }));
	    },
	
	
	    'form.packagingMaterialId': function formPackagingMaterialId(value) {
	      this.assignExcise(value);
	    },
	
	    'inheritFieldsform.depositSystemId': function inheritFieldsformDepositSystemId(value) {
	      if (value != '') {
	        this.inheritFieldsform.showField('productDepositId');
	      } else {
	        this.inheritFieldsform.hideField('productDepositId');
	      }
	    }
	  },
	
	  methods: {
	    assignExcise: function assignExcise(value) {
	      var result = this.packagingMaterials.all.filter(function (item) {
	        return item.id === parseInt(value);
	      });
	      if (result.length != 0) {
	        if (!this.initLoad) {
	          this.inheritFieldsform.setFieldValue('exciseBasicGroup', '');
	          this.inheritFieldsform.setFieldValue('excisePackagingGroup', '');
	        } else {
	          this.initLoad = false;
	        }
	        var basic = this.exciseBasicGroups.filter(function (item) {
	          return item.codeId === result[0].baseExciseCodeId;
	        });
	        var packaging = this.excisePackagingGroups.filter(function (item) {
	          return item.codeId === result[0].environmentExciseCodeId;
	        });
	        basic = basic.map(function (c) {
	          return { id: c.id, name: '' + c.description };
	        });
	        packaging = packaging.map(function (c) {
	          return { id: c.id, name: '' + c.description };
	        });
	        basic.unshift({ id: '', name: '' });
	        packaging.unshift({ id: '', name: '' });
	        this.inheritFieldsform.setOptions('exciseBasicGroup', basic);
	        this.inheritFieldsform.setOptions('excisePackagingGroup', packaging);
	      }
	    },
	    update: function update() {
	      var _this2 = this;
	
	      if (this.inheritFieldsform.overrideProducts) {
	        this.$confirm(this.$t('form.productPackagings.overrideProductsConfirm.description'), this.$t('form.productPackagings.overrideProductsConfirm.title'), {
	          confirmButtonText: 'I Accept',
	          cancelButtonText: 'Cancel',
	          type: 'danger'
	        }).then(function () {
	          _this2.updatePackaging();
	        }).catch(function () {});
	      } else {
	        this.updatePackaging();
	      }
	    },
	    updatePackaging: function updatePackaging() {
	      var _this3 = this;
	
	      this.form.loading = true;
	      var data = _extends({}, this.form.data(), this.inheritFieldsform.data());
	      var productPackaging = _productPackaging4.default.send(data);
	      _productPackaging2.default.update(_store2.default.state.route.params.id, productPackaging).then(function () {
	        _this3.form.loading = false;
	        _this3.$message({
	          message: _this3.$t('static.productPackagings.edit.success'),
	          type: 'success'
	        });
	        _this3.$router.push({
	          name: 'productPackagings.index'
	        });
	      }).catch(function (errors) {
	        _this3.form.loading = false;
	        _this3.form.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      var _this4 = this;
	
	      this.loading = true;
	      _productPackaging2.default.show(_store2.default.state.route.params.id).then(function (productPackaging) {
	        _this4.initLoad = true;
	        _this4.form.assignData(productPackaging);
	        _this4.inheritFieldsform.assignData(productPackaging);
	        _this4.productsCount = productPackaging.productsCount;
	        _this4.loading = false;
	      });
	    },
	    destroy: function destroy() {
	      var _this5 = this;
	
	      _productPackaging2.default.destroy(_store2.default.state.route.params.id).then(function () {
	        _this5.$message({
	          message: _this5.$t('static.productPackagings.edit.delete'),
	          type: 'success'
	        });
	        _this5.$router.push({
	          name: 'productPackagings.index'
	        });
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _productPackaging = __webpack_require__(126);
	
	var _productPackaging2 = _interopRequireDefault(_productPackaging);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false,
	      sort: '',
	      limit: 25
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    productPackagings: 'paginatedProductPackagings',
	    account: 'account'
	  })),
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19)
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var productFilter = {
	      title: this.$t('static.products.filters.title'),
	      options: [{
	        title: this.$t('static.products.filters.active'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'active'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.deactivated'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'deactivated'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.withDeposit'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'withDeposit'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.materials'),
	        route: {
	          name: 'products.index',
	          query: {
	            type: 'Material'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.all'),
	        route: {
	          name: 'products.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.products.create.title'),
	        route: {
	          name: 'products.create'
	        }
	      }
	    };
	    var productBundle = {
	      title: this.$t('static.productBundles.filters.title'),
	      options: [{
	        title: this.$t('static.productBundles.filters.all'),
	        route: {
	          name: 'productBundles.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productBundles.create.title'),
	        route: {
	          name: 'productBundles.create'
	        }
	      }
	    };
	    var vmpSyncMenu = {};
	
	    if (this.account.modules.length > 0) {
	      for (var i = 0; i < this.account.modules.length; i++) {
	        if (this.account.modules[i].name == 'EDI') {
	          productFilter = {
	            title: this.$t('static.products.filters.title'),
	            options: [{
	              title: this.$t('static.products.filters.active'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'active'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.deactivated'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'deactivated'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.withDeposit'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'withDeposit'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.materials'),
	              route: {
	                name: 'products.index',
	                query: {
	                  type: 'Material'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.asko'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'asko'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.vinhuset'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'vinhuset'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.marketplace'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'marketplace'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.onlineStore'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'onlineStore'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.alcohol'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'alcohol'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.alcoholFree'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'alcoholFree'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.all'),
	              route: {
	                name: 'products.index'
	              }
	            }],
	            button: {
	              title: '+ ' + this.$t('static.products.create.title'),
	              route: {
	                name: 'products.create'
	              }
	            }
	          };
	        }
	        if (this.account.modules[i].name == 'Vinmonopolet') {
	          vmpSyncMenu = {
	            title: this.$t('static.products.syncVmp.title'),
	            button: {
	              title: '+ ' + this.$t('static.products.syncVmp.title'),
	              route: {
	                name: 'products.syncVmp'
	              }
	            }
	          };
	        }
	      }
	    }
	
	    this.setInnerSidebar([productFilter, productBundle, vmpSyncMenu, {
	      title: this.$t('static.productPackagings.filters.title'),
	      options: [{
	        title: this.$t('static.productPackagings.filters.all'),
	        route: {
	          name: 'productPackagings.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productPackagings.create.title'),
	        route: {
	          name: 'productPackagings.create'
	        }
	      }
	    }, {
	      title: this.$t('static.productGroups.filters.title'),
	      options: [{
	        title: this.$t('static.productGroups.filters.all'),
	        route: {
	          name: 'productGroups.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productGroups.create.title'),
	        route: {
	          name: 'productGroups.create'
	        }
	      }
	    }, {
	      title: this.$t('static.productTags.filters.title'),
	      options: [{
	        title: this.$t('static.productTags.filters.all'),
	        route: {
	          name: 'productTags.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productTags.create.title'),
	        route: {
	          name: 'productTags.create'
	        }
	      }
	    }, {
	      title: this.$t('static.exciseEntry.title'),
	      options: [{
	        title: this.$t('static.exciseEntry.filters.all'),
	        route: {
	          name: 'exciseentry.index'
	        }
	      }]
	    }]);
	
	    _account2.default.rememberPerPage('get', { from: 'product_packaging' }).then(function (data) {
	      _this.limit = data.size;
	      _this.all(1, _this.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  watch: {
	    $route: function $route() {
	      this.all(1, this.limit);
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'product_packaging', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    all: (0, _debounce2.default)(function (page) {
	      var _this3 = this;
	
	      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	      this.loading = true;
	      _productPackaging2.default.items({
	        page: page,
	        limit: limit,
	        search: this.getSearch(this.limit),
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this3.loading = false;
	      }).catch(function () {
	        _this3.loading = false;
	      });
	    }, 800),
	
	    deleteProductPackaging: function deleteProductPackaging(productPackaging) {
	      var _this4 = this;
	
	      this.$confirm(this.$t('static.productPackagings.index.confirmDelete'), this.$t('static.productPackagings.index.confirmDeleteTitle'), {
	        confirmButtonText: this.$t('button.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _productPackaging2.default.destroy(productPackaging.id).catch(function (_ref) {
	          var response = _ref.response;
	
	          var message = response.data.error.code === 40114 ? _this4.$t('static.productPackagings.index.deleteHasProductError') : _this4.$t('static.productPackagings.index.deleteError');
	          _this4.$message({
	            showClose: true,
	            message: message,
	            type: 'error'
	          });
	        });
	      }).catch(function () {});
	    },
	    editProductPackaging: function editProductPackaging(productPackaging) {
	      this.$router.push({
	        name: 'productPackagings.edit',
	        params: { id: productPackaging.id }
	      });
	    },
	    goToProducts: function goToProducts(id, e) {
	      e.stopPropagation();
	      this.$router.push({ name: 'products.index', query: { packaging: [id] } });
	    }
	  }),
	
	  mixins: [_search2.default]
	};

/***/ }),
/* 1949 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(5);
	
	var _productTag = __webpack_require__(231);
	
	var _productTag2 = _interopRequireDefault(_productTag);
	
	var _productTag3 = __webpack_require__(135);
	
	var _productTag4 = _interopRequireDefault(_productTag3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        tag: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      tabIndex: '1'
	    };
	  },
	  created: function created() {},
	
	
	  computed: {},
	
	  methods: {
	    store: function store() {
	      var _this = this;
	
	      this.form.loading = true;
	      var productTag = _productTag4.default.send(this.form.data());
	      _productTag2.default.store(productTag).then(function () {
	        _this.form.loading = false;
	        _this.$message({
	          message: _this.$t('static.productTags.create.success'),
	          type: 'success'
	        });
	        _this.$router.push({
	          name: 'productTags.index'
	        });
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	      });
	    }
	  },
	
	  watch: {},
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(5);
	
	var _productTag = __webpack_require__(231);
	
	var _productTag2 = _interopRequireDefault(_productTag);
	
	var _productTag3 = __webpack_require__(135);
	
	var _productTag4 = _interopRequireDefault(_productTag3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        tag: {
	          value: '',
	          type: 'text'
	        }
	
	      }),
	      loading: false
	    };
	  },
	  created: function created() {
	    this.show();
	  },
	
	
	  computed: {},
	
	  methods: {
	    update: function update() {
	      var _this = this;
	
	      this.form.loading = true;
	      var productTag = _productTag4.default.send(this.form.data());
	      _productTag2.default.update(_store2.default.state.route.params.id, productTag).then(function () {
	        _this.form.loading = false;
	        _this.$message({
	          message: _this.$t('static.productTags.edit.success'),
	          type: 'success'
	        });
	        _this.$router.push({
	          name: 'productTags.index'
	        });
	      }).catch(function (errors) {
	        _this.form.loading = false;
	        _this.form.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      var _this2 = this;
	
	      this.loading = true;
	      _productTag2.default.show(_store2.default.state.route.params.id).then(function (productTag) {
	        _this2.form.assignData(productTag);
	        _this2.loading = false;
	      });
	    }
	  },
	
	  watch: {},
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _productTag = __webpack_require__(231);
	
	var _productTag2 = _interopRequireDefault(_productTag);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false,
	      sort: '',
	      limit: 25
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    productTags: 'paginatedProductTags',
	    account: 'account'
	  })),
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19)
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var productFilter = {
	      title: this.$t('static.products.filters.title'),
	      options: [{
	        title: this.$t('static.products.filters.active'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'active'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.deactivated'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'deactivated'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.withDeposit'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'withDeposit'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.materials'),
	        route: {
	          name: 'products.index',
	          query: {
	            type: 'Material'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.all'),
	        route: {
	          name: 'products.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.products.create.title'),
	        route: {
	          name: 'products.create'
	        }
	      }
	    };
	    var productBundle = {
	      title: this.$t('static.productBundles.filters.title'),
	      options: [{
	        title: this.$t('static.productBundles.filters.all'),
	        route: {
	          name: 'productBundles.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productBundles.create.title'),
	        route: {
	          name: 'productBundles.create'
	        }
	      }
	    };
	    var vmpSyncMenu = {};
	    if (this.account.modules.length > 0) {
	      for (var i = 0; i < this.account.modules.length; i++) {
	        if (this.account.modules[i].name == 'EDI') {
	          productFilter = {
	            title: this.$t('static.products.filters.title'),
	            options: [{
	              title: this.$t('static.products.filters.active'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'active'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.deactivated'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'deactivated'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.withDeposit'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'withDeposit'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.materials'),
	              route: {
	                name: 'products.index',
	                query: {
	                  type: 'Material'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.asko'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'asko'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.vinhuset'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'vinhuset'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.marketplace'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'marketplace'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.onlineStore'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'onlineStore'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.alcohol'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'alcohol'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.alcoholFree'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'alcoholFree'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.all'),
	              route: {
	                name: 'products.index'
	              }
	            }],
	            button: {
	              title: '+ ' + this.$t('static.products.create.title'),
	              route: {
	                name: 'products.create'
	              }
	            }
	          };
	        }
	        if (this.account.modules[i].name == 'Vinmonopolet') {
	          vmpSyncMenu = {
	            title: this.$t('static.products.syncVmp.title'),
	            button: {
	              title: '+ ' + this.$t('static.products.syncVmp.title'),
	              route: {
	                name: 'products.syncVmp'
	              }
	            }
	          };
	        }
	      }
	    }
	
	    this.setInnerSidebar([productFilter, productBundle, vmpSyncMenu, {
	      title: this.$t('static.productPackagings.filters.title'),
	      options: [{
	        title: this.$t('static.productPackagings.filters.all'),
	        route: {
	          name: 'productPackagings.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productPackagings.create.title'),
	        route: {
	          name: 'productPackagings.create'
	        }
	      }
	    }, {
	      title: this.$t('static.productGroups.filters.title'),
	      options: [{
	        title: this.$t('static.productGroups.filters.all'),
	        route: {
	          name: 'productGroups.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productGroups.create.title'),
	        route: {
	          name: 'productGroups.create'
	        }
	      }
	    }, {
	      title: this.$t('static.productTags.filters.title'),
	      options: [{
	        title: this.$t('static.productTags.filters.all'),
	        route: {
	          name: 'productTags.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productTags.create.title'),
	        route: {
	          name: 'productTags.create'
	        }
	      }
	    }, {
	      title: this.$t('static.exciseEntry.title'),
	      options: [{
	        title: this.$t('static.exciseEntry.filters.all'),
	        route: {
	          name: 'exciseentry.index'
	        }
	      }]
	    }]);
	
	    _account2.default.rememberPerPage('get', { from: 'product_tag' }).then(function (data) {
	      _this.limit = data.size;
	      _this.all(1, _this.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  watch: {
	    $route: function $route() {
	      this.all(1, this.limit);
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'product_tag', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    all: (0, _debounce2.default)(function (page) {
	      var _this3 = this;
	
	      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	      this.loading = true;
	      _productTag2.default.items({
	        page: page,
	        limit: limit,
	        search: this.getSearch(this.limit),
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this3.loading = false;
	      }).catch(function () {
	        _this3.loading = false;
	      });
	    }, 800),
	
	    deleteproductTag: function deleteproductTag(productTag) {
	      var _this4 = this;
	
	      this.$confirm(this.$t('static.productTags.index.confirmDelete'), this.$t('static.productTags.index.confirmDeleteTitle'), {
	        confirmButtonText: this.$t('button.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _productTag2.default.destroy(productTag.id).catch(function (_ref) {
	          var response = _ref.response;
	
	          var message = response.data.error.code === 40114 ? _this4.$t('static.productTags.index.deleteHasProductError') : _this4.$t('static.productTags.index.deleteError');
	          _this4.$message({
	            showClose: true,
	            message: message,
	            type: 'error'
	          });
	        });
	      }).catch(function () {});
	    },
	    editproductTag: function editproductTag(productTag) {
	      this.$router.push({
	        name: 'productTags.edit',
	        params: { id: productTag.id }
	      });
	    },
	    goToProducts: function goToProducts(id, e) {
	      e.stopPropagation();
	      this.$router.push({ name: 'products.index', query: { filter: 'productTag,' + id } });
	    }
	  }),
	
	  mixins: [_search2.default]
	};

/***/ }),
/* 1953 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _create = __webpack_require__(423);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _productGroup = __webpack_require__(160);
	
	var _productGroup2 = _interopRequireDefault(_productGroup);
	
	var _productType = __webpack_require__(232);
	
	var _productType2 = _interopRequireDefault(_productType);
	
	var _productSubtype = __webpack_require__(473);
	
	var _productSubtype2 = _interopRequireDefault(_productSubtype);
	
	var _productDeposit = __webpack_require__(96);
	
	var _productDeposit2 = _interopRequireDefault(_productDeposit);
	
	var _depositSystem = __webpack_require__(296);
	
	var _depositSystem2 = _interopRequireDefault(_depositSystem);
	
	var _country = __webpack_require__(66);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _productPackaging = __webpack_require__(126);
	
	var _productPackaging2 = _interopRequireDefault(_productPackaging);
	
	var _productRecommendation = __webpack_require__(472);
	
	var _productRecommendation2 = _interopRequireDefault(_productRecommendation);
	
	var _tax = __webpack_require__(128);
	
	var _tax2 = _interopRequireDefault(_tax);
	
	var _vinmonopolet = __webpack_require__(236);
	
	var _vinmonopolet2 = _interopRequireDefault(_vinmonopolet);
	
	var _product3 = __webpack_require__(39);
	
	var _product4 = _interopRequireDefault(_product3);
	
	var _productCreatePopup = __webpack_require__(2728);
	
	var _productCreatePopup2 = _interopRequireDefault(_productCreatePopup);
	
	var _create3 = __webpack_require__(281);
	
	var _create4 = _interopRequireDefault(_create3);
	
	var _organizationSettings2 = __webpack_require__(27);
	
	var _organizationSettings3 = _interopRequireDefault(_organizationSettings2);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _vuex = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        productTypeId: {
	          value: '',
	          type: 'hidden'
	        },
	        productType: {
	          value: '',
	          type: 'cascader'
	        },
	        productSubtypeId: {
	          value: '',
	          type: 'hidden'
	        },
	        productSubtype: {
	          value: '',
	          type: 'cascader'
	        }
	      }),
	      childProductForm: new _forms2.default({
	        productParentId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        }
	      }),
	      productInfoForm: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        price: {
	          value: '',
	          type: 'float'
	        },
	        productPackagingId: {
	          value: '',
	          type: 'select'
	        },
	        country: {
	          value: '',
	          type: 'select'
	        },
	        containsAlcohol: {
	          value: '',
	          type: 'switch'
	        },
	        alcoholPercentage: {
	          value: '',
	          type: 'float'
	        },
	        vmp: {
	          value: '',
	          type: 'text',
	          attributes: {
	            hasButton: true,
	            buttonLabel: this.$t('static.products.create.vmp.fetch'),
	            buttonHandler: this.vmpImportHandler
	          }
	        },
	        taxId: {
	          value: '',
	          type: 'select'
	        },
	        deposit: {
	          value: '',
	          type: 'switch'
	        },
	        depositSystemId: {
	          value: '',
	          type: 'select'
	        },
	        productDepositId: {
	          value: '',
	          type: 'select'
	        },
	        duration: {
	          value: '',
	          type: 'number'
	        },
	        breaktime: {
	          value: '',
	          type: 'number'
	        },
	        isActive: {
	          value: '',
	          type: 'switch'
	        },
	        recommendations: {
	          value: '',
	          type: 'select'
	        },
	        gtin: {
	          value: '',
	          type: 'text'
	        },
	        syncToWoo: {
	          value: '',
	          type: 'switch'
	        }
	      }),
	      product: {
	        fieldsJSON: {}
	      },
	      defaultProductTypeName: '',
	      loading: false,
	      tabIndex: '1'
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    productGroups: 'allProductGroups',
	    allProductTypes: 'allProductTypes',
	    allProductSubtypes: 'allProductSubtypes',
	    productPackagings: 'allProductPackagings',
	    productDeposits: 'allProductDeposits',
	    depositSystems: 'allDepositSystems',
	    productRecommendations: 'allProductRecommendations',
	    taxes: 'allTaxes',
	    account: 'account',
	    organizationSettings: 'organizationSettings',
	    countries: 'allCountries'
	  }), {
	    productTypes: function productTypes() {
	      var maxId = Math.max.apply(Math, _toConsumableArray(this.allProductTypes.map(function (p) {
	        return p.id;
	      })));
	      var productTypes = [].concat(_toConsumableArray(this.allProductTypes));
	      productTypes.push({
	        id: maxId + 1,
	        name: 'Child',
	        group: '',
	        subGroup: ''
	      });
	      return productTypes;
	    },
	    productType: function productType() {
	      var _this = this;
	
	      if (typeof this.form.productTypeId !== 'undefined') {
	        return this.productTypes.find(function (type) {
	          return type.id.toString() === _this.form.productTypeId.toString();
	        });
	      }
	      return null;
	    },
	    productTypeName: function productTypeName() {
	      var _this2 = this;
	
	      if (typeof this.form.productTypeId !== 'undefined') {
	        var productType = this.productTypes.find(function (type) {
	          return type.id.toString() === _this2.form.productTypeId.toString();
	        });
	        if (productType) {
	          return productType.name;
	        }
	      }
	      return null;
	    },
	    productTypeValue: function productTypeValue() {
	      var productTypeValue = [];
	      if (this.productType) {
	        if (this.productType.group) {
	          productTypeValue.push(this.productType.group);
	        }
	        productTypeValue.push(this.productType.id);
	      }
	      return productTypeValue;
	    },
	    userHasVinmonopolet: function userHasVinmonopolet() {
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Vinmonopolet') {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    },
	    hasWooModule: function hasWooModule() {
	      if (this.account.modules.length > 0) {
	        if (this.account.modules.find(function (module) {
	          return module.name === 'WordPress WooCommerce';
	        })) return true;
	      }
	      return false;
	    }
	  }),
	
	  watch: {
	
	    'productInfoForm.alcoholPercentage': function productInfoFormAlcoholPercentage(value) {
	      if (value >= 0.7) {
	        this.productInfoForm.containsAlcohol = true;
	      } else {
	        this.productInfoForm.containsAlcohol = false;
	      }
	    },
	
	    'productInfoForm.depositSystemId': function productInfoFormDepositSystemId(value) {
	      var _this3 = this;
	
	      if (value) {
	        this.productInfoForm.showField('productDepositId');
	      } else {
	        this.productInfoForm.hideField('productDepositId');
	      }
	
	      var productType = this.productTypes.find(function (type) {
	        return type.id.toString() === _this3.form.productTypeId.toString();
	      });
	      if (productType.name !== 'Service') {
	        this.productInfoForm.hideField('duration');
	        this.productInfoForm.hideField('breaktime');
	      }
	    },
	
	    'productInfoForm.productPackagingId': function productInfoFormProductPackagingId(value) {
	      var packaging = this.productPackagings.all.find(function (x) {
	        return x.id === parseInt(value);
	      });
	      if (packaging) {
	        this.productInfoForm.setFieldValue('depositSystemId', packaging.depositSystemId);
	        this.productInfoForm.setFieldValue('productDepositId', packaging.productDepositId);
	        this.productInfoForm.setFieldValue('deposit', true);
	      }
	
	      if (!packaging || !packaging.depositSystemId || packaging.depositSystemId === '') {
	        this.productInfoForm.setFieldValue('depositSystemId', '');
	        this.productInfoForm.setFieldValue('productDepositId', '');
	        this.productInfoForm.setFieldValue('deposit', false);
	      }
	    },
	
	    account: function account() {
	      this.toogleProductConfig(this.form.productTypeId);
	      if (!this.hasWooModule) {
	        this.form.hideField('syncToWoo');
	      }
	    },
	    organizationSettings: function organizationSettings(_organizationSettings) {
	      if (_organizationSettings.defaultProductTypeName) {
	        this.defaultProductTypeName = _organizationSettings.defaultProductTypeName;
	        this.setDefaultProductType();
	      }
	    },
	    allProductTypes: function allProductTypes() {
	      var _this4 = this;
	
	      var productTypes = this.productTypes;
	      if (productTypes) {
	        var options = productTypes.reduce(function (groups, item) {
	          var group = groups[item.group] || {
	            label: _this4.$t('static.products.types.' + _this4.camalize(item.group)),
	            value: item.group,
	            children: []
	          };
	          if (item.group) {
	            group.children.push({
	              label: _this4.$t('static.products.types.' + _this4.camalize(item.name)),
	              value: item.id
	            });
	            groups[item.group] = group;
	          } else {
	            groups[item.id] = {
	              label: _this4.$t('static.products.types.' + _this4.camalize(item.name)),
	              value: item.id
	            };
	          }
	          return groups;
	        }, {});
	        var opt = Object.keys(options).map(function (option) {
	          var item = options[option];
	          if (item.children) {
	            item.children = Object.keys(item.children).map(function (child) {
	              var c = item.children[child];
	              if (c.children) {
	                c.children = Object.keys(c.children).map(function (t) {
	                  return c.children[t];
	                });
	              }
	              return c;
	            });
	          }
	          return item;
	        });
	
	        this.form.setOptions('productType', opt.filter(function (pt) {
	          return pt.label !== _this4.$t('static.products.types.bundle');
	        }).sort(function (a, b) {
	          return a.label > b.label ? 1 : -1;
	        }));
	      }
	    },
	    productGroups: function productGroups() {
	      this.productInfoForm.setOptions('productGroupId', this.productGroups.all);
	      this.productInfoForm.setExtraAttr('productGroupId', {
	        multiple: true
	      });
	    },
	    productRecommendations: function productRecommendations(recommendations) {
	      this.productInfoForm.setOptions('recommendations', recommendations);
	      this.productInfoForm.setExtraAttr('recommendations', {
	        multiple: true
	      });
	    },
	    productPackagings: function productPackagings() {
	      this.productInfoForm.setOptions('productPackagingId', this.productPackagings.all);
	    },
	    countries: function countries(_countries) {
	      var _this5 = this;
	
	      this.productInfoForm.setOptions('country', _countries.items.map(function (c) {
	        return { id: c.name, name: _this5.$t('country.translated.' + c.code) };
	      }));
	    },
	    taxes: function taxes() {
	      this.productInfoForm.setOptions('taxId', this.taxes.all.map(function (tax) {
	        return {
	          id: tax.id,
	          name: tax.taxPercentage
	        };
	      }));
	    },
	
	    'form.productTypeId': function formProductTypeId(typeId) {
	      this.setOptionsForProductSubtype();
	
	      if (typeof typeId !== 'undefined') {
	        var productType = this.productTypes.find(function (type) {
	          return type.id.toString() === typeId.toString();
	        });
	        this.productInfoForm.hideField('duration');
	        this.productInfoForm.hideField('breaktime');
	        this.productInfoForm.hideField('alcoholPercentage');
	        this.productInfoForm.hideField('productPackagingId');
	        this.productInfoForm.hideField('vmp');
	        this.productInfoForm.hideField('country');
	        this.productInfoForm.hideField('deposit');
	        this.productInfoForm.hideField('productDepositId');
	        this.productInfoForm.hideField('depositSystemId');
	        this.productInfoForm.hideField('containsAlcohol');
	        this.productInfoForm.hideField('recommendations');
	
	        if (productType) {
	          if (productType.name === 'Child') {
	            this.childProductForm.showField('productParentId');
	            return;
	          }
	          if (productType.name === 'Service') {
	            this.productInfoForm.showField('duration');
	            this.productInfoForm.showField('breaktime');
	          }
	          if (productType.group === 'Beverage') {
	            this.productInfoForm.showField('productPackagingId');
	            this.productInfoForm.setQuickForm('productPackagingId', _create4.default);
	            this.productInfoForm.showField('country');
	            this.productInfoForm.showField('deposit');
	            this.productInfoForm.showField('containsAlcohol');
	            this.productInfoForm.setOptions('productDepositId', this.productDeposits.all.map(function (deposit) {
	              return { id: deposit.id, name: deposit.name };
	            }));
	            this.productInfoForm.setOptions('depositSystemId', this.depositSystems.all.map(function (depositSystem) {
	              return { id: depositSystem.id, name: depositSystem.name };
	            }));
	          }
	          if (productType.subGroup === 'Alcohol') {
	            this.productInfoForm.showField('alcoholPercentage');
	            this.productInfoForm.showField('vmp');
	          }
	        }
	      }
	    },
	
	    'form.productType': function formProductType(arrayValue) {
	      var _arrayValue$slice = arrayValue.slice(-1),
	          _arrayValue$slice2 = _slicedToArray(_arrayValue$slice, 1),
	          productyTypeId = _arrayValue$slice2[0];
	
	      this.form.productTypeId = productyTypeId;
	    },
	
	    'form.productSubtype': function formProductSubtype(arrayValue) {
	      var _arrayValue$slice3 = arrayValue.slice(-1),
	          _arrayValue$slice4 = _slicedToArray(_arrayValue$slice3, 1),
	          productSubtypeId = _arrayValue$slice4[0];
	
	      this.form.productSubtypeId = productSubtypeId;
	    },
	
	    'productInfoForm.deposit': function productInfoFormDeposit(deposit) {
	      if (deposit) {
	        this.productInfoForm.showField('depositSystemId');
	      } else {
	        this.productInfoForm.hideField('productDepositId');
	        this.productInfoForm.hideField('depositSystemId');
	      }
	    },
	    allProductSubtypes: function allProductSubtypes() {
	      this.setOptionsForProductSubtype();
	    }
	  },
	
	  mounted: function mounted() {
	    this.form.setExtraAttr('productGroupId', {
	      multiple: true
	    });
	    this.form.setExtraAttr('recommendations', {
	      multiple: true
	    });
	    this.form.hideField('productTypeId');
	    this.productInfoForm.hideField('productDepositId');
	  },
	  created: function created() {
	    var _this6 = this;
	
	    this.form.setQuickForm('productGroupId', _create2.default);
	    this.hideProductConfig();
	    this.loading = true;
	    Promise.all([_productGroup2.default.all(), _productType2.default.all(), _productSubtype2.default.all(), _country2.default.all(), _productDeposit2.default.all(), _depositSystem2.default.all(), _tax2.default.all(), _productPackaging2.default.all(), _productRecommendation2.default.all(), _organizationSettings3.default.show()]).then(function () {
	      _this6.productInfoForm.taxId = 4;
	      _this6.productInfoForm.isActive = true;
	      _this6.loading = false;
	    });
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalProps: 'SET_MODAL_PROPS'
	  }), {
	    vmpImportHandler: function vmpImportHandler() {
	      var _this7 = this;
	
	      if (!this.userHasVinmonopolet) {
	        this.$alert(this.$t('static.products.syncVmp.noModuleWarning'), 'Warning', {
	          dangerouslyUseHTMLString: true
	        });
	        return;
	      }
	      this.productInfoForm.loading = true;
	      var vmp = this.productInfoForm.vmp;
	      if (!vmp) {
	        this.$message({
	          message: this.$t('static.products.syncVmp.inputRequired'),
	          type: 'error'
	        });
	        return;
	      }
	
	      this.productInfoForm.disableField('vmp');
	      var self = this;
	
	      _vinmonopolet2.default.findProduct(vmp).then(function (data) {
	        _this7.productInfoForm.loading = false;
	        if (data) {
	          _this7.setDefaultProductType(data.productType);
	          _this7.$nextTick(function () {
	            self.productInfoForm.enableField('vmp');
	            self.productInfoForm.name = data.name;
	            self.productInfoForm.price = data.ddpVmp;
	            self.productInfoForm.alcoholPercentage = data.alcoholPercentage;
	            self.productInfoForm.country = data.country;
	            self.productInfoForm.vmp = data.vmp;
	            self.productInfoForm.containsAlcohol = +(data.alcoholPercentage > 0);
	          });
	        }
	      }).catch(function () {
	        _this7.$message({
	          message: _this7.$t('static.product.create.vmp.warning'),
	          type: 'error'
	        });
	        _this7.productInfoForm.enableField('vmp');
	        _this7.productInfoForm.loading = false;
	      });
	    },
	    searchMethod: function searchMethod(search) {
	      return Promise.all([_product2.default.search({
	        search: search
	      })]);
	    },
	    toogleProductConfig: function toogleProductConfig(typeId) {
	      var hasAppointment = this.account.modules !== undefined ? this.account.modules.filter(function (m) {
	        return m.name === 'Appointment';
	      }).length > 0 : false;
	      if (typeId) {
	        var type = this.productTypes.filter(function (t) {
	          return typeId.toString() === t.id.toString();
	        })[0];
	
	        if (type.name === 'Service' && hasAppointment) {
	          this.showProductConfig();
	        } else {
	          this.hideProductConfig();
	        }
	      }
	    },
	    createChildProduct: function createChildProduct() {
	      var _this8 = this;
	
	      if (!this.childProductForm.productParentId.id) {
	        this.childProductForm.recordErrors({
	          productParentId: ['Parent product is required.']
	        });
	        return;
	      }
	      this.childProductForm.loading = true;
	      _product2.default.show(this.childProductForm.productParentId.id).then(function (product) {
	        _this8.product = product;
	        _this8.form.productTypeId = product.productTypeId;
	        _this8.form.productType = _this8.productTypeValue;
	        _this8.productInfoForm.assignData(_this8.product);
	        var childProductCount = product.childProducts.length + 1;
	        _this8.productInfoForm.name = _this8.product.name + ' - Child(' + childProductCount + ')';
	        _this8.childProductForm.loading = false;
	      });
	    },
	    setOptionsForProductSubtype: function setOptionsForProductSubtype() {
	      if (!this.allProductSubtypes.length) {
	        this.form.hideField('productSubtype');
	        return;
	      }
	      this.form.showField('productSubtype');
	      if (this.form.productType.length) {
	        var typeId = this.form.productType[this.form.productType.length - 1];
	
	        var options = [].concat(_toConsumableArray(this.allProductSubtypes)).filter(function (s) {
	          return +s.productTypeId === +typeId;
	        }).reduce(function (groups, item) {
	          var group = groups[item.type] || {
	            label: item.type,
	            value: item.type,
	            children: []
	          };
	          if (item.type) {
	            group.children.push({
	              label: item.name,
	              value: item.id
	            });
	            groups[item.type] = group;
	          } else {
	            groups[item.id] = {
	              label: item.name,
	              value: item.id
	            };
	          }
	          return groups;
	        }, {});
	        var opt = Object.keys(options).map(function (option) {
	          var item = options[option];
	          if (item.children) {
	            item.children = Object.keys(item.children).map(function (child) {
	              var c = item.children[child];
	              if (c.children) {
	                c.children = Object.keys(c.children).map(function (t) {
	                  return c.children[t];
	                });
	              }
	              return c;
	            });
	          }
	          return item;
	        });
	        if (opt.length) {
	          this.form.setOptions('productSubtype', opt.sort(function (a, b) {
	            return a.label > b.label ? 1 : -1;
	          }));
	          return;
	        }
	        this.form.hideField('productSubtype');
	        return;
	      }
	    },
	    hideProductConfig: function hideProductConfig() {},
	    showProductConfig: function showProductConfig() {},
	    store: function store() {
	      var _this9 = this;
	
	      this.form.loading = true;
	      var obj = {};
	      if (this.product && this.product.id) {
	        this.product.fieldsJSON = null;
	        var productData = _product4.default.send(this.product);
	        obj = Object.assign({}, productData, this.form.data(), this.productInfoForm.data());
	        obj.productParentId = this.product.id;
	        obj.id = null;
	      } else {
	        obj = Object.assign({}, this.form.data(), this.productInfoForm.data());
	      }
	
	      obj.appointable = false;
	
	      var product = _product4.default.send(obj);
	
	      _product2.default.store(product).then(function (data) {
	        _this9.productInfoForm.resetValues();
	        _this9.form.productTypeId = '';
	        _this9.form.productType = '';
	        _this9.form.productSubtype = '';
	        _this9.form.productSubtypeId = '';
	        _this9.product = {
	          fieldsJSON: {}
	        };
	        _this9.form.loading = false;
	        _this9.setDefaultProductType();
	        _this9.productInfoForm.isActive = true;
	        _this9.setModalContent(function () {
	          return _productCreatePopup2.default;
	        });
	        _this9.setModalSize('full');
	        _this9.toggleModal(true);
	        _this9.setModalProps({
	          productId: data.id
	        });
	      }).catch(function (errors) {
	        if (errors.productSubtypeId) {
	          errors.productSubtype = errors.productSubtypeId;
	        }
	        _this9.productInfoForm.recordErrors(errors);
	        _this9.form.recordErrors(errors);
	        _this9.form.loading = false;
	      });
	    },
	    setDefaultProductType: function setDefaultProductType(productTypeName) {
	      var typeName = productTypeName || this.defaultProductTypeName;
	      var productType = this.productTypes.find(function (type) {
	        return type.name.toString() === typeName.toString();
	      });
	      var productTypeValue = [];
	      if (productType) {
	        if (productType.group) {
	          productTypeValue.push(productType.group);
	        }
	        if (productType.subGroup) {
	          productTypeValue.push(productType.subGroup);
	        }
	        productTypeValue.push(productType.id);
	      }
	      this.form.productType = productTypeValue;
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9),
	    VProductPriceTable: __webpack_require__(2732)
	  }
	};

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _create = __webpack_require__(423);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _productTag = __webpack_require__(231);
	
	var _productTag2 = _interopRequireDefault(_productTag);
	
	var _form = __webpack_require__(458);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _productGroup = __webpack_require__(160);
	
	var _productGroup2 = _interopRequireDefault(_productGroup);
	
	var _productPackaging = __webpack_require__(126);
	
	var _productPackaging2 = _interopRequireDefault(_productPackaging);
	
	var _create3 = __webpack_require__(281);
	
	var _create4 = _interopRequireDefault(_create3);
	
	var _addProducer = __webpack_require__(2672);
	
	var _addProducer2 = _interopRequireDefault(_addProducer);
	
	var _vmpSyncConfirmPopup = __webpack_require__(2745);
	
	var _vmpSyncConfirmPopup2 = _interopRequireDefault(_vmpSyncConfirmPopup);
	
	var _productType = __webpack_require__(232);
	
	var _productType2 = _interopRequireDefault(_productType);
	
	var _productSubtype = __webpack_require__(473);
	
	var _productSubtype2 = _interopRequireDefault(_productSubtype);
	
	var _priceField = __webpack_require__(95);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	var _productDeposit = __webpack_require__(96);
	
	var _productDeposit2 = _interopRequireDefault(_productDeposit);
	
	var _depositSystem = __webpack_require__(296);
	
	var _depositSystem2 = _interopRequireDefault(_depositSystem);
	
	var _tax = __webpack_require__(128);
	
	var _tax2 = _interopRequireDefault(_tax);
	
	var _vinmonopolet = __webpack_require__(236);
	
	var _vinmonopolet2 = _interopRequireDefault(_vinmonopolet);
	
	var _product3 = __webpack_require__(39);
	
	var _product4 = _interopRequireDefault(_product3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _exciseGroup = __webpack_require__(94);
	
	var _exciseGroup2 = _interopRequireDefault(_exciseGroup);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _organizationSettings = __webpack_require__(27);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _country = __webpack_require__(66);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _producer = __webpack_require__(302);
	
	var _producer2 = _interopRequireDefault(_producer);
	
	var _marketplaceProduct = __webpack_require__(195);
	
	var _marketplaceProduct2 = _interopRequireDefault(_marketplaceProduct);
	
	var _marketplaceProduct3 = __webpack_require__(460);
	
	var _marketplaceProduct4 = _interopRequireDefault(_marketplaceProduct3);
	
	var _productUNCode = __webpack_require__(1224);
	
	var _productUNCode2 = _interopRequireDefault(_productUNCode);
	
	var _productRecommendation = __webpack_require__(472);
	
	var _productRecommendation2 = _interopRequireDefault(_productRecommendation);
	
	var _chartOfAccounts = __webpack_require__(186);
	
	var _chartOfAccounts2 = _interopRequireDefault(_chartOfAccounts);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _unitType = __webpack_require__(235);
	
	var _unitType2 = _interopRequireDefault(_unitType);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _vuex = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        productTypeId: {
	          value: '',
	          type: 'hidden'
	        },
	        productType: {
	          value: '',
	          type: 'cascader'
	        },
	        productSubtypeId: {
	          value: '',
	          type: 'hidden'
	        },
	        productSubtype: {
	          value: '',
	          type: 'cascader'
	        },
	        containsAlcohol: {
	          value: '',
	          type: 'switch'
	        }
	      }),
	      forms: [],
	      product: {
	        fieldsJSON: {}
	      },
	      productMergeForm: new _forms2.default({
	        sourceProductId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        destinationProductId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        }
	      }),
	      loading: false,
	      tabIndex: '1',
	      warehouses: [],
	      initial: '',
	      customSkuform: {
	        update_sku: false,
	        sku_initial: false,
	        custom_sku: '',
	        custom_sk_error: ''
	      },
	      transactionPerPage: 10,
	      transactionLoading: true,
	      batchFilter: {
	        options: [],
	        value: [],
	        list: [],
	        loading: true,
	        batchDisplay: ''
	      },
	      warehouseFilter: {
	        options: [],
	        value: [],
	        list: [],
	        loading: true,
	        warehouseDisplay: ''
	      },
	      showMarketplaceForm: false,
	      marketplaceData: null,
	      productDepositAmount: null
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    productGroups: 'allProductGroups',
	
	    transactionsV2: 'productTransactionsV2',
	    productTypes: 'allProductTypes',
	    allProducers: 'allProducers',
	    productDeposits: 'allProductDeposits',
	    depositSystems: 'allDepositSystems',
	    taxes: 'allTaxes',
	    account: 'account',
	
	    groups: 'allExciseGroups',
	    excisePackagingGroups: 'allExcisePackagingGroups',
	    exciseBasicGroups: 'allExciseBasicGroups',
	    products: 'allProducts',
	    allProductTypes: 'allProductTypes',
	    allProductSubtypes: 'allProductSubtypes',
	    productTags: 'allProductTags',
	    productPackagings: 'allProductPackagings',
	    countries: 'allCountries',
	    chartOfAccounts: 'allChartOfAccounts',
	    priceFields: 'allPriceFields',
	    productRecommendations: 'allProductRecommendations',
	    unitTypes: 'allUnitTypes'
	  }), {
	    sharedWarehouseNotice: function sharedWarehouseNotice() {
	      if (this.product.isSharedWarehouse) return this.$t('static.sharedWarehouseProduct');
	      return false;
	    },
	    hasSkuInitial: function hasSkuInitial() {
	      return this.customSkuform.custom_sku.includes(this.initial);
	    },
	    producers: function producers() {
	      return [{ id: '', name: '' }].concat(_toConsumableArray(this.allProducers));
	    },
	    productType: function productType() {
	      var _this = this;
	
	      if (typeof this.form.productTypeId !== 'undefined') {
	        return this.productTypes.find(function (type) {
	          return type.id.toString() === _this.form.productTypeId.toString();
	        });
	      }
	      return null;
	    },
	    ediGrapesMoving: function ediGrapesMoving() {
	      return this.account.plan === 'EDI Grapsmoving';
	    },
	    warehouseList: function warehouseList() {
	      var _this2 = this;
	
	      return this.warehouses.map(function (c) {
	        var data = {
	          warehouseId: c.warehouseId,
	          name: c.warehouse.name,
	          batchName: c.batchName,
	          qty: c.qty
	        };
	        if (_this2.hasProduction === false) {
	          var _data = data,
	              batchName = _data.batchName,
	              newData = _objectWithoutProperties(_data, ['batchName']);
	
	          data = newData;
	        }
	        return data;
	      });
	    },
	    transactionListNew: function transactionListNew() {
	      var _this3 = this;
	
	      var newData = this.transactionsV2.items.map(function (c) {
	        var data = {
	          via: c.via + ' #' + c.code,
	          client: c.customerName,
	          batchName: c.batchName,
	          id: c.parentModelId,
	          key: c.via + ' ' + c.code,
	          beforeqty: c.beforeQty,
	          qty: c.adjustmentQty,
	          afterqty: c.afterQty,
	          warehouse: c.warehouse,
	          createdAt: c.createdAt
	        };
	        if (_this3.hasProduction === false) {
	          var _data2 = data,
	              batchName = _data2.batchName,
	              _newData = _objectWithoutProperties(_data2, ['batchName']);
	
	          data = _newData;
	        }
	        return data;
	      });
	
	      var self = this;
	      return newData.filter(function (obj) {
	        if (self.batchFilter.batchDisplay !== '' && self.warehouseFilter.warehouseDisplay === '') {
	          return self.batchFilter.batchDisplay === obj.batchName;
	        } else if (self.batchFilter.batchDisplay === '' && self.warehouseFilter.warehouseDisplay !== '') {
	          return self.warehouseFilter.warehouseDisplay === obj.warehouse;
	        } else if (self.batchFilter.batchDisplay !== '' && self.warehouseFilter.warehouseDisplay !== '') {
	          return self.batchFilter.batchDisplay === obj.batchName && self.warehouseFilter.warehouseDisplay === obj.warehouse;
	        }
	        return obj;
	      });
	    },
	    checkHasInventory: function checkHasInventory() {
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    },
	    userHasMarketplace: function userHasMarketplace() {
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Marketplace') {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    },
	    userHasVinmonopolet: function userHasVinmonopolet() {
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Vinmonopolet') {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    },
	    hasEHFModule: function hasEHFModule() {
	      if (this.account.modules.length > 0) {
	        return this.account.modules.find(function (module) {
	          return module.name === 'EHF Catalogue';
	        });
	      }
	      return false;
	    },
	    hasProduction: function hasProduction() {
	      if (this.account.modules.length > 0) {
	        if (this.account.modules.find(function (module) {
	          return module.name === 'Production';
	        })) return true;
	      }
	      if (this.account.allowProducerBatches) return true;
	      return false;
	    },
	    hasWooModule: function hasWooModule() {
	      if (this.account.modules.length > 0) {
	        if (this.account.modules.find(function (module) {
	          return module.name === 'WordPress WooCommerce';
	        })) return true;
	      }
	      return false;
	    }
	  }),
	
	  watch: {
	
	    'customSkuform.update_sku': function customSkuformUpdate_sku(value) {
	      if (value === true) {
	        this.customSkuform.update_sku = true;
	      } else {
	        this.customSkuform.update_sku = false;
	      }
	    },
	
	    'customSkuform.custom_sku': function customSkuformCustom_sku(value) {
	      if (value.includes(this.initial)) {
	        this.customSkuform.sku_initial = true;
	      } else {
	        this.customSkuform.sku_initial = false;
	      }
	    },
	
	    warehouses: function warehouses(_warehouses) {
	      this.onUpdateWarehouseFilter(_warehouses);
	      this.onUpdateBatchFilter(_warehouses);
	    },
	    $route: function $route() {
	      this.show();
	      this.all(1, this.transactionPerPage);
	      this.form.setQuickForm('productGroupId', _create2.default);
	      this.hideProductConfig();
	      this.hideProductDeposit();
	      this.urlCurrentTab();
	    },
	    account: function account() {
	      this.toogleProductConfig(this.form.productTypeId);
	      if (this.hasWooModule === false) {
	        this.form.hideField('syncToWoo');
	      }
	    },
	    productGroups: function productGroups(_productGroups) {
	      this.form.setOptions('productGroupId', _productGroups.all);
	    },
	    allProductTypes: function allProductTypes() {
	      var _this4 = this;
	
	      var productTypes = this.productTypes;
	      if (productTypes) {
	        var options = productTypes.reduce(function (groups, item) {
	          var group = groups[item.group] || {
	            label: _this4.$t('static.products.types.' + _this4.camalize(item.group)),
	            value: item.group,
	            children: []
	          };
	          if (item.group) {
	            group.children.push({
	              label: _this4.$t('static.products.types.' + _this4.camalize(item.name)),
	              value: item.id
	            });
	            groups[item.group] = group;
	          } else {
	            groups[item.id] = {
	              label: _this4.$t('static.products.types.' + _this4.camalize(item.name)),
	              value: item.id
	            };
	          }
	          return groups;
	        }, {});
	        var opt = Object.keys(options).map(function (option) {
	          var item = options[option];
	          if (item.children) {
	            item.children = Object.keys(item.children).map(function (child) {
	              var c = item.children[child];
	              if (c.children) {
	                c.children = Object.keys(c.children).map(function (t) {
	                  return c.children[t];
	                });
	              }
	              return c;
	            });
	          }
	          return item;
	        });
	        this.form.setOptions('productType', opt.filter(function (pt) {
	          return pt.label !== _this4.$t('static.products.types.bundle');
	        }).sort(function (a, b) {
	          return a.label > b.label ? 1 : -1;
	        }));
	      }
	    },
	    allProductSubtypes: function allProductSubtypes() {
	      this.setOptionsForProductSubtype();
	      this.getProductSubTypeValue(this.product);
	    },
	    productDeposits: function productDeposits(_productDeposits) {},
	    producers: function producers(_producers) {
	      var form = this.forms.find(function (f) {
	        return f.name === 'detailsForm';
	      });
	      if (form) {
	        form.form.setOptions('producer', this.producers);
	        form.form.producer = this.product.producer ? this.product.producer.toString() : '';
	      }
	    },
	    productPackagings: function productPackagings(_productPackagings) {
	      var form = this.forms.find(function (f) {
	        return f.name === 'packagingForm';
	      });
	      if (form) {
	        form.form.setOptions('productPackagingId', _productPackagings.all);
	      }
	    },
	    productRecommendations: function productRecommendations(_productRecommendations) {
	      var form = this.forms.find(function (f) {
	        return f.name === 'productInformation';
	      });
	      if (form) {
	        form.form.setOptions('recommendations', _productRecommendations);
	        form.form.setExtraAttr('recommendations', {
	          multiple: true
	        });
	      }
	    },
	    taxes: function taxes(_taxes) {},
	
	    'form.productTypeId': function formProductTypeId(typeId) {
	      if (this.form.productType && this.form.productType[0] == 'Beverage') {
	        this.form.setField('containsAlcohol', 'switch');
	      } else {
	        this.form.setField('containsAlcohol', 'hidden');
	      }
	      if (typeId) {
	        this.processForm(typeId);
	        this.setOptionsForProductSubtype();
	      }
	    },
	
	    'form.productDepositId': function formProductDepositId(depositId) {
	      if (depositId > 0) {
	        this.form.depositCheck = true;
	      }
	    },
	
	    'form.productType': function formProductType(arrayValue) {
	      var _arrayValue$slice = arrayValue.slice(-1),
	          _arrayValue$slice2 = _slicedToArray(_arrayValue$slice, 1),
	          productyTypeId = _arrayValue$slice2[0];
	
	      this.form.productTypeId = productyTypeId;
	    },
	
	    'form.productSubtype': function formProductSubtype(arrayValue) {
	      var _arrayValue$slice3 = arrayValue.slice(-1),
	          _arrayValue$slice4 = _slicedToArray(_arrayValue$slice3, 1),
	          productSubtypeId = _arrayValue$slice4[0];
	
	      this.form.productSubtypeId = productSubtypeId;
	    },
	
	    forms: {
	      handler: function handler(value) {
	        var _this5 = this;
	
	        var self = this;
	        var exciseForm = self.forms.find(function (f) {
	          return f.name === 'exciseForm';
	        });
	        var packagingForm = self.forms.find(function (f) {
	          return f.name === 'packagingForm';
	        });
	        var detailsForm = self.forms.find(function (f) {
	          return f.name === 'detailsForm';
	        });
	        var onlineStoreForm = self.forms.find(function (f) {
	          return f.name === 'onlineStore';
	        });
	        value.forEach(function (value2) {
	          if (value2.name === 'packagingForm') {
	            if (value2.form.productPackagingId) {
	              if (exciseForm) {
	                var packaging = self.productPackagings.all.find(function (f) {
	                  return f.id === parseInt(value2.form.productPackagingId);
	                });
	                if (packaging && packaging.excisePackagingGroup !== null) {
	                  exciseForm.form.excisePackagingGroup = packaging.excisePackagingGroup;
	                }
	                if (packaging && packaging.exciseBasicGroup !== null) {
	                  exciseForm.form.exciseBasicGroup = packaging.exciseBasicGroup;
	                }
	                if (packaging && packaging.overrideProducts && packaging.overrideProducts === 1 || _this5.sharedWarehouseNotice) {
	                  if (packaging && packaging.excisePackagingGroup !== null) {
	                    exciseForm.form.disableField('excisePackagingGroup');
	                  }
	                  if (packaging && packaging.exciseBasicGroup !== null) {
	                    exciseForm.form.disableField('exciseBasicGroup');
	                  }
	                } else {
	                  exciseForm.form.enableField('exciseBasicGroup');
	                  exciseForm.form.enableField('excisePackagingGroup');
	                }
	              }
	            } else {
	              onlineStoreForm.form.hideField('sellInCase');
	            }
	
	            if (value2.form.depositSystemId) {
	              if (packagingForm) packagingForm.form.enableField('productDepositId');
	            } else if (!value2.form.depositSystemId) {
	              if (packagingForm) packagingForm.form.disableField('productDepositId');
	            }
	          }
	
	          if (detailsForm && detailsForm.form.alcohol_percentage >= 0.7 || exciseForm && exciseForm.form.exciseAlcoholGroup !== '') {
	            self.form.containsAlcohol = true;
	          } else {
	            self.form.containsAlcohol = false;
	          }
	
	          if (value2.name === 'onlineStore') {
	            if (value2.form.sellInCase === true) {
	              var currentPackaging = self.productPackagings.all.filter(function (obj) {
	                return obj.id === packagingForm.form.productPackagingId;
	              });
	              if (currentPackaging !== undefined && currentPackaging.length != 0) {
	                onlineStoreForm.form.minQty = currentPackaging[0].qtyInCrate;
	                onlineStoreForm.form.groupOf = currentPackaging[0].qtyInCrate;
	                onlineStoreForm.form.disableField('minQty');
	                onlineStoreForm.form.disableField('groupOf');
	              }
	            } else {
	              onlineStoreForm.form.enableField('minQty');
	              onlineStoreForm.form.minQty = 1;
	              onlineStoreForm.form.enableField('groupOf');
	              onlineStoreForm.form.groupOf = 1;
	            }
	          }
	        });
	      },
	
	      deep: true
	    },
	
	    tabIndex: function tabIndex(value) {
	      this.assignTab(value);
	    }
	  },
	
	  mounted: function mounted() {
	    this.form.setQuickForm('productGroupId', _create2.default);
	    this.hideProductConfig();
	    this.hideProductDeposit();
	    this.show();
	    this.form.setExtraAttr('productGroupId', {
	      multiple: true
	    });
	    this.form.hideField('productTypeId');
	    this.urlCurrentTab();
	    this.assignTab(this.tabIndex);
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    onImageRemove: function onImageRemove() {
	      var _this6 = this;
	
	      _product2.default.removeImage(_store2.default.state.route.params.id).then(function () {
	        _this6.$message({
	          message: _this6.$t('static.products.delete.imageSuccess'),
	          type: 'success'
	        });
	      });
	    },
	    customSkuKeydown: function customSkuKeydown(e) {
	      if (!/^[a-zA-Z0-9-_]+$/.test(e.key)) {
	        e.preventDefault();
	      }
	    },
	    addSkuInitial: function addSkuInitial(value) {
	      if (value === true) {
	        this.customSkuform.custom_sku = '' + this.initial + this.customSkuform.custom_sku;
	      } else {
	        this.customSkuform.custom_sku = this.customSkuform.custom_sku.replace('' + this.initial, '');
	      }
	    },
	    perPage: function perPage(size) {
	      var _this7 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'bill', perPage: size }).then(function (data) {
	        _this7.transactionPerPage = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    assignTab: function assignTab(value) {
	      var tab = '';
	      if (value == '5') {
	        tab = '#childProduct';
	      } else if (value == '4') {
	        tab = '#mergeProduct';
	      } else if (value == '3') {
	        tab = '#transactions';
	      } else if (value == '2') {
	        tab = '#inventory';
	      } else {
	        tab = '#productInfo';
	      }
	      history.pushState({}, null, '/#' + this.$route.path + tab);
	    },
	    urlCurrentTab: function urlCurrentTab() {
	      if (this.$router.currentRoute.hash == '#childProduct') {
	        this.tabIndex = '5';
	      } else if (this.$router.currentRoute.hash == '#mergeProduct') {
	        this.tabIndex = '4';
	      } else if (this.$router.currentRoute.hash == '#transactions') {
	        this.tabIndex = '3';
	      } else if (this.$router.currentRoute.hash == '#inventory') {
	        this.tabIndex = '2';
	      } else {
	        this.tabIndex = '1';
	      }
	    },
	    informationTextOverrides: function informationTextOverrides(formName) {
	      if (formName === 'marketplace') {
	        if (this.product.marketplaceStatus === 'Pending') {
	          return 'Your product is still under review by the admin.';
	        } else if (this.product.marketplaceStatus === 'Active' && this.product.marketplaceHasPending) {
	          return 'Your product details update is still under review by the admin.';
	        }
	        return '';
	      }
	      return '';
	    },
	    vmpImportHandler: function vmpImportHandler() {
	      var _this8 = this;
	
	      if (!this.userHasVinmonopolet) {
	        this.$alert(this.$t('static.products.syncVmp.noModuleWarning'), 'Warning', {
	          dangerouslyUseHTMLString: true
	        });
	        return;
	      }
	      var formIndex = this.forms.findIndex(function (f) {
	        return f.name === 'productIndentification';
	      });
	      var vmp = this.forms[formIndex].form.vmp;
	      if (!vmp) {
	        this.$message({
	          message: this.$t('static.products.syncVmp.inputRequired'),
	          type: 'error'
	        });
	        return;
	      }
	
	
	      _vinmonopolet2.default.findProduct(vmp).then(function (data) {
	        _this8.forms[formIndex].form.loading = false;
	        if (data) {
	          _this8.setModalContent(function () {
	            return _vmpSyncConfirmPopup2.default;
	          });
	          _this8.setModalSize('full');
	          _this8.toggleModal(true);
	          _this8.setModalProps({
	            vmpData: data,
	            onConfirm: _this8.populateVmpData
	          });
	        }
	      }).catch(function () {
	        _this8.$message({
	          message: _this8.$t('static.product.create.vmp.warning'),
	          type: 'error'
	        });
	
	        _this8.forms[formIndex].form.loading = false;
	      });
	    },
	    setOptionsForProductSubtype: function setOptionsForProductSubtype() {
	      if (!this.allProductSubtypes.length) {
	        this.form.hideField('productSubtype');
	        return;
	      }
	      this.form.showField('productSubtype');
	      if (this.form.productType.length) {
	        var typeId = this.form.productType[this.form.productType.length - 1];
	
	        var options = [].concat(_toConsumableArray(this.allProductSubtypes)).filter(function (s) {
	          return +s.productTypeId === +typeId;
	        }).reduce(function (groups, item) {
	          var group = groups[item.type] || {
	            label: item.type,
	            value: item.type,
	            children: []
	          };
	          if (item.type) {
	            group.children.push({
	              label: item.name,
	              value: item.id
	            });
	            groups[item.type] = group;
	          } else {
	            groups[item.id] = {
	              label: item.name,
	              value: item.id
	            };
	          }
	          return groups;
	        }, {});
	        var opt = Object.keys(options).map(function (option) {
	          var item = options[option];
	          if (item.children) {
	            item.children = Object.keys(item.children).map(function (child) {
	              var c = item.children[child];
	              if (c.children) {
	                c.children = Object.keys(c.children).map(function (t) {
	                  return c.children[t];
	                });
	              }
	              return c;
	            });
	          }
	          return item;
	        });
	        if (opt.length) {
	          this.form.setOptions('productSubtype', opt.sort(function (a, b) {
	            return a.label > b.label ? 1 : -1;
	          }));
	          return;
	        }
	        this.form.hideField('productSubtype');
	        return;
	      }
	    },
	    populateVmpData: function populateVmpData(data) {
	      this.forms.find(function (f) {
	        return f.name === 'productInformation';
	      }).form.assignData({
	        name: data.name
	      });
	      this.forms.find(function (f) {
	        return f.name === 'productIndentification';
	      }).form.assignData({
	        vmp: data.vmp,
	        gtin: data.gtin
	      });
	      this.forms.find(function (f) {
	        return f.name === 'detailsForm';
	      }).form.assignData({
	        producer: data.producer,
	        country: data.country,
	        region: data.region,
	        subRegion: data.subRegion,
	        vintage: data.vintage,
	        containsAlcohol: +(data.alcoholPercentage > 0),
	        alcohol_percentage: data.alcoholPercentage,
	        bottle_volume: data.bottleVolume,
	        cork_type: data.corkType,
	        packaging_type: data.packagingType,
	        weightMultipack: data.weightMultipack,
	        sugar: data.sugar,
	        acid: data.acid,
	        fullness: data.fullness,
	        freshness: data.freshness,
	        bitterness: data.bitterness,
	        tannins: data.tannins,
	        colour: data.colour,
	        odour: data.odour,
	        taste: data.taste,
	        storagePorential: data.storagePorential,
	        organic: data.organic,
	        biodynamic: data.biodynamic,
	        locallyProduced: data.locallyProduced,
	        environmentallySmart: data.environmentallySmart,
	        freeOrLowOnGluten: data.freeOrLowOnGluten,
	        kosher: data.kosher,
	        storagePotential: data.storagePotential,
	        ingredients: data.ingredients
	      });
	      this.forms.find(function (f) {
	        return f.name === 'priceForm';
	      }).form.assignData({
	        retailPriceVmp: data.retailPriceVmp,
	        ddpVmp: data.ddpVmp
	      });
	    },
	    getProductTypeValue: function getProductTypeValue(product) {
	      var productTypeValue = [];
	      var productType = this.productTypes.find(function (type) {
	        return type.id.toString() === product.productTypeId.toString();
	      });
	
	      if (productType) {
	        if (productType.group) {
	          productTypeValue.push(productType.group);
	        }
	        productTypeValue.push(productType.id);
	      }
	      return productTypeValue;
	    },
	    getProductSubTypeValue: function getProductSubTypeValue(product) {
	      var productSubtypeValue = [];
	      var productSubtype = this.allProductSubtypes.find(function (type) {
	        return +type.id === +product.productSubtypeId;
	      });
	
	      if (productSubtype) {
	        if (productSubtype.type) {
	          productSubtypeValue.push(productSubtype.type);
	        }
	        productSubtypeValue.push(productSubtype.id);
	      }
	      return productSubtypeValue;
	    },
	    toogleProductConfig: function toogleProductConfig(typeId) {
	      var hasAppointment = this.account.modules !== undefined ? this.account.modules.filter(function (m) {
	        return m.name === 'Appointment';
	      }).length > 0 : false;
	      if (typeId) {
	        var type = this.productTypes.filter(function (t) {
	          return typeId.toString() === t.id.toString();
	        });
	
	        if (type.length > 0 && type[0].name === 'Service' && hasAppointment) {
	          this.showProductConfig();
	        } else {
	          this.hideProductConfig();
	        }
	      }
	    },
	    searchMethod: function searchMethod(search, field) {
	      return Promise.all([_product2.default.searchAll({ search: search })]);
	    },
	    hideProductConfig: function hideProductConfig() {
	      this.form.hideField('breaktime');
	      this.form.hideField('duration');
	      this.form.hideField('appointable');
	    },
	    showProductConfig: function showProductConfig() {
	      this.form.showField('breaktime');
	      this.form.showField('duration');
	      this.form.showField('appointable');
	    },
	    toggleProductDeposit: function toggleProductDeposit(depositCheck) {
	      if (depositCheck) {
	        this.showProductDeposit();
	      }
	
	      if (!depositCheck) {
	        this.hideProductDeposit();
	      }
	    },
	    hideProductDeposit: function hideProductDeposit() {
	      this.form.hideField('productDepositId');
	    },
	    showProductDeposit: function showProductDeposit() {
	      this.form.showField('productDepositId');
	    },
	    update: function update() {
	      var _this9 = this;
	
	      var me = this;
	      this.form.loading = true;
	      var obj = Object.assign({}, this.form.data());
	      var priceFieldValues = {};
	      for (var i = 0; i < this.forms.length; i++) {
	        obj = Object.assign(obj, this.forms[i].form.data());
	        this.forms[i].form.loading = true;
	      }
	      obj = Object.assign(obj, { custom_sku: me.customSkuform.custom_sku, update_sku: me.customSkuform.update_sku });
	
	      var product = _product4.default.send(obj);
	
	      this.priceFields.all.forEach(function (price) {
	        product[price.field] = obj[price.field];
	      });
	      _product2.default.update(_store2.default.state.route.params.id, product).then(function () {
	        if (product.marketplace_enabled) {
	          _this9.submitPartner(product);
	        } else {
	          _this9.$message({
	            message: _this9.$t('static.products.edit.success'),
	            type: 'success'
	          });
	          _this9.$router.push({
	            name: 'products.index'
	          });
	        }
	      }).catch(function (errors) {
	        if ('icon' in errors) {
	          if (errors.icon) {
	            errors.icon = errors.icon.url;
	          }
	        }
	        for (var _i = 0; _i < me.forms.length; _i++) {
	          me.forms[_i].form.recordErrors(errors);
	          me.forms[_i].form.loading = false;
	        }
	        if (errors.custom_sku != undefined && errors.custom_sku.length > 0) {
	          me.customSkuform.custom_sk_error = errors.custom_sku[0];
	        }
	        if (errors.productSubtypeId) {
	          errors.productSubtype = errors.productSubtypeId;
	        }
	        console.log(errors);
	        _this9.form.recordErrors(errors);
	        _this9.form.loading = false;
	        _this9.$message({
	          message: _this9.$t('static.products.edit.error'),
	          type: 'error',
	          duration: 15000,
	          dismissible: true,
	          showClose: true
	        });
	      });
	    },
	    submitPartner: function submitPartner(product) {
	      var _this10 = this;
	
	      var resources = [];
	      if (product.marketplace_enabled) {
	        var marketplaceProduct = _marketplaceProduct2.default.send(this.marketplaceData.data());
	        resources.push(_marketplaceProduct4.default.store(this.product.id, marketplaceProduct));
	      }
	      Promise.all(resources).then(function () {
	        _this10.form.loading = false;
	        _this10.$message({
	          message: _this10.$t('static.products.edit.success'),
	          type: 'success'
	        });
	        _this10.$router.push({
	          name: 'products.index'
	        });
	      }).catch(function (errors) {
	        _this10.form.loading = false;
	        if ('image' in errors) {
	          if (errors.image) {
	            errors.image = errors.image.url;
	            if (errors.image[0] && errors.image[0] === 'Invalid Image') {
	              errors.image[0] = _this10.$t('static.products.lokalbrygg.messages.imageError');
	            }
	          }
	        }
	        if (product.marketplace_enabled) {
	          _this10.marketplaceData.recordErrors(errors);
	        }
	        _this10.$message({
	          message: _this10.$t('static.products.edit.error'),
	          type: 'error',
	          showClose: true,
	          duration: 15000
	        });
	      });
	    },
	    destroy: function destroy() {
	      var _this11 = this;
	
	      this.$confirm(this.$t('static.products.delete.confirm'), this.$t('static.products.delete.title'), {
	        confirmButtonText: 'OK',
	        cancelButtonText: 'Cancel',
	        type: 'warning'
	      }).then(function () {
	        _product2.default.destroy(_store2.default.state.route.params.id).then(function () {
	          _this11.$message({
	            message: _this11.$t('static.products.delete.success'),
	            type: 'success'
	          });
	          _this11.$router.push({
	            name: 'products.index'
	          });
	        }).catch(function (errors) {
	          _this11.$message({
	            message: errors.message,
	            type: 'error'
	          });
	        });
	      }).catch(function () {});
	    },
	    show: function show() {
	      var _this12 = this;
	
	      this.loading = true;
	      Promise.all([_product2.default.show(_store2.default.state.route.params.id), _productGroup2.default.all(), _productType2.default.all(), _productSubtype2.default.all(), _productDeposit2.default.all(), _depositSystem2.default.all(), _tax2.default.all(), _organizationSettings2.default.show(), _productTag2.default.all(), _exciseGroup2.default.all(), _exciseGroup2.default.packaging(), _exciseGroup2.default.basic(), _productPackaging2.default.all(), _producer2.default.all(), _country2.default.all(), _chartOfAccounts2.default.all(), _priceField2.default.all(1), _productRecommendation2.default.all(), _unitType2.default.all()]).then(function (data) {
	        _this12.loading = false;
	        _this12.product = data[0];
	        if (_this12.product.marketplaceEnabled) {
	          _this12.showMarketplaceForm = true;
	        }
	        if (_this12.product.fieldsJSON.containsAlcohol) {
	          _this12.form.containsAlcohol = true;
	        }
	
	        _this12.form.assignData(Object.assign({}, data[0], { productTypeId: null }));
	        _this12.form.productType = _this12.getProductTypeValue(_this12.product);
	        _this12.form.productSubtype = _this12.getProductSubTypeValue(_this12.product);
	        _this12.customSkuform.custom_sku = data[0].number;
	        _this12.initial = data[0].initial;
	        _this12.form.disableField('sku');
	
	        _this12.warehouses = data[0].warehouses;
	
	        _this12.productMergeForm.setFieldValue('destinationProductId', data[0]);
	        _this12.productMergeForm.setDisplays('sourceProductId', data[6].productInfoDisplay);
	        _this12.productMergeForm.setDisplays('destinationProductId', data[6].productInfoDisplay);
	        _this12.all(1, _this12.transactionPerPage);
	
	        if (_this12.sharedWarehouseNotice) {
	          _this12.form.disableField('productType');
	          _this12.form.disableField('productSubtype');
	          _this12.form.disableField('containsAlcohol');
	        }
	      });
	    },
	    link: function link(warehouse) {
	      var routeData = this.$router.resolve({
	        params: { id: warehouse.warehouseId },
	        name: 'warehouse.edit'
	      });
	      window.open(routeData.href, '_blank');
	    },
	    transactionLink: function transactionLink(trans) {
	      var name = '';
	      if (trans.via.indexOf('Stock count') !== -1) {
	        name = 'inventory.stock.view';
	      } else if (trans.via.indexOf('Stock Adjustment') !== -1) {
	        name = 'inventory.adjustment.view';
	      } else if (trans.via.indexOf('Order') !== -1) {
	        name = 'orders.edit';
	      } else if (trans.via.indexOf('Purchase') !== -1) {
	        name = 'inventory.purchase.view';
	      } else if (trans.via.indexOf('SO') !== -1) {
	        name = 'orders.edit';
	      } else if (trans.via.indexOf('OC') !== -1) {
	        name = 'orders.edit';
	      } else if (trans.via.indexOf('PO') !== -1) {
	        name = 'inventory.purchase.view';
	      } else if (trans.via.indexOf('AJ') !== -1) {
	        name = 'inventory.adjustment.view';
	      } else if (trans.via.indexOf('SC') !== -1) {
	        name = 'inventory.stock.view';
	      } else if (trans.via.indexOf('TW') !== -1) {
	        name = 'inventory.transfer.view';
	      } else if (trans.via.indexOf('RS') !== -1) {
	        name = 'bills.creditNote';
	      } else if (trans.via.indexOf('TC') !== -1) {
	        name = 'orders.edit';
	      }
	      var routeData = this.$router.resolve({
	        params: { id: trans.id },
	        name: name
	      });
	      window.open(routeData.href, '_blank');
	    },
	    editProduct: function editProduct(product) {
	      this.$router.push({
	        name: 'products.edit',
	        params: {
	          id: product.id
	        }
	      });
	    },
	    mergeProduct: function mergeProduct() {
	      var _this13 = this;
	
	      var productMergeData = [];
	      var productMergeFormData = this.productMergeForm.data();
	
	      this.productMergeForm.loading = true;
	      Object.keys(this.productMergeForm.fields).map(function (field) {
	        productMergeData[field] = productMergeFormData[field].id;
	      });
	
	      _product2.default.merge(productMergeData).then(function () {
	        _this13.$message({
	          message: _this13.$t('static.products.merge.success'),
	          type: 'success'
	        });
	        _this13.$router.push({
	          name: 'products.index'
	        });
	      }).catch(function (errors) {
	        _this13.$message({
	          message: errors.message,
	          type: 'error'
	        });
	        _this13.productMergeForm.loading = false;
	      });
	    },
	    processForm: function processForm(typeId) {
	      var _this14 = this;
	
	      var me = this;
	      me.loading = true;
	
	      Promise.all([_form2.default.fields(typeId)]).then(function (data) {
	        me.forms = [];
	
	        var _loop = function _loop(i) {
	          var fields = {};
	          for (var f = 0; f < data[0][i].fields.length; f++) {
	            var field = data[0][i].fields[f];
	
	            var new_field = {
	              type: field.fieldType.type,
	              value: field.defaultValue
	            };
	
	            fields[field.name] = new_field;
	          }
	          var infoOverride = _this14.informationTextOverrides(data[0][i].name);
	          var form = {
	            name: data[0][i].name,
	            information: infoOverride || data[0][i].information,
	            form: new _forms2.default(fields)
	          };
	
	          if (data[0][i].name !== 'onlineStore' && _this14.sharedWarehouseNotice) {
	            form.form.disabled = Object.keys(form.form.fields);
	          }
	
	          Object.keys(fields).map(function (value, key) {
	            if (value === 'taxId') {
	              form.form.setOptions('taxId', me.taxes.all.map(function (tax) {
	                return { id: tax.id, name: tax.taxPercentage };
	              }));
	            } else if (value === 'productGroupId') {
	              form.form.setOptions('productGroupId', me.productGroups.all);
	              form.form.setExtraAttr('productGroupId', {
	                multiple: true
	              });
	            } else if (value === 'productTagId') {
	              form.form.setOptions('productTagId', me.productTags.all.map(function (tag) {
	                return {
	                  id: tag.id,
	                  name: tag.tag
	                };
	              }));
	              form.form.setExtraAttr('productTagId', {
	                multiple: true
	              });
	            } else if (value === 'productPackagingId') {
	              form.form.setOptions('productPackagingId', _this14.productPackagings.all);
	              form.form.setQuickForm('productPackagingId', _create4.default);
	            } else if (value === 'recommendations') {
	              form.form.setOptions('recommendations', _this14.productRecommendations);
	              form.form.setExtraAttr('recommendations', {
	                multiple: true
	              });
	            } else if (value === 'sku') {
	              form.form.hideField('sku');
	            } else if (value === 'vmp') {
	              form.form.setExtraAttr('vmp', {
	                hasButton: true,
	                buttonLabel: _this14.$t('static.products.create.vmp.fetch'),
	                buttonHandler: _this14.vmpImportHandler
	              });
	            } else if (value === 'productDepositId') {
	              form.form.setOptions('productDepositId', me.productDeposits.all.map(function (deposit) {
	                return { id: deposit.id, name: deposit.name };
	              }));
	            } else if (value === 'depositSystemId') {
	              form.form.setOptions('depositSystemId', me.depositSystems.all.map(function (depositSystem) {
	                return { id: depositSystem.id, name: depositSystem.name };
	              }));
	            } else if (value === 'exciseAlcoholGroup') {
	              form.form.setOptions('exciseAlcoholGroup', me.groups.map(function (c) {
	                return { id: c.id, name: '' + c.description };
	              }));
	            } else if (value === 'excisePackagingGroup') {
	              form.form.setOptions('excisePackagingGroup', me.excisePackagingGroups.map(function (c) {
	                return { id: c.id, name: '' + c.description };
	              }));
	            } else if (value === 'producer') {
	              form.form.setOptions('producer', _this14.producers);
	              form.form.setQuickForm('producer', _addProducer2.default);
	            } else if (value === 'country') {
	              form.form.setOptions('country', me.countries.items.map(function (c) {
	                return { id: c.name, name: _this14.$t('country.translated.' + c.code) };
	              }));
	            } else if (value === 'exciseBasicGroup') {
	              form.form.setOptions('exciseBasicGroup', me.exciseBasicGroups.map(function (c) {
	                return { id: c.id, name: '' + c.description };
	              }));
	            } else if (value === 'subType') {
	              if (me.productType.subTypes) {
	                form.form.setOptions('subType', me.productType.subTypes.map(function (subType) {
	                  var options = [];
	                  var subTypes = subType.types.map(function (type) {
	                    return {
	                      label: type,
	                      value: type
	                    };
	                  });
	                  if (subType.group) {
	                    options = {
	                      value: subType.group,
	                      label: subType.group,
	                      children: subTypes
	                    };
	                  } else {
	                    options = subTypes;
	                  }
	                  return options;
	                }));
	              } else {
	                form.form.hideField('subType');
	              }
	            } else if (value === 'chartOfAccounts') {
	              if (me.chartOfAccounts && me.chartOfAccounts.all && Array.isArray(me.chartOfAccounts.all)) {
	                var options = me.chartOfAccounts.all.map(function (c) {
	                  return { id: c.id, name: '' + c.name };
	                });
	                options.unshift({ id: 0, name: 'None' });
	                form.form.setOptions('chartOfAccounts', options);
	              }
	            } else if (value == 'unProductCodeId') {
	              if (!me.hasEHFModule) {
	                form.form.hideField('unProductCodeId');
	              } else {
	                form.form.setExtraAttr('unProductCodeId', {
	                  isSearch: true,
	                  searchMethod: _this14.unProductCodeSearch,
	                  loading: true
	                });
	              }
	            } else if (value == 'orderableUnitId') {
	              var _options = me.unitTypes.all.map(function (c) {
	                return { id: c.id, name: '' + c.name };
	              });
	              form.form.setOptions('orderableUnitId', _options);
	            }
	          });
	
	          if (form.name === 'detailsForm') {
	            form.form.assignData(me.product.fieldsJSON);
	            form.form.recommendations = me.product.recommendations;
	            form.form.producer = me.product.producer || '';
	          } else {
	            form.form.assignData(me.product);
	          }
	
	          if (form.name === 'priceForm') {
	            _this14.priceFields.all.forEach(function (price) {
	              if (price.field === me.product[price.field]) {
	                form.form[price.field] = me.product[price.field] || '';
	              }
	            });
	          }
	
	          if (['marketplace'].includes(form.name)) {
	            if (form.name === 'marketplace' && _this14.userHasMarketplace) {
	              me.forms.push(form);
	              var marketplaceIndex = me.forms.findIndex(function (f) {
	                return f.name === 'marketplace';
	              });
	              _this14.$watch('forms.' + marketplaceIndex + '.form.marketplaceEnabled', _this14.isMarketplaceEnabled, { deep: true });
	            }
	          } else {
	            me.forms.push(form);
	          }
	        };
	
	        for (var i = 0; i < data[0].length; i++) {
	          _loop(i);
	        }
	
	        me.loading = false;
	      });
	    },
	    isMarketplaceEnabled: function isMarketplaceEnabled(active) {
	      this.showMarketplaceForm = !!active;
	    },
	    productDepositUpdate: function productDepositUpdate(productDepositId) {
	      var productDeposit = this.productDeposits.all.find(function (pd) {
	        return +pd.id === +productDepositId;
	      });
	      if (productDeposit) {
	        this.productDepositAmount = productDeposit.amount;
	      }
	    },
	    showMarketplaceModal: function showMarketplaceModal() {
	      var _this15 = this;
	
	      this.setModalProps({
	        product: this.product,
	        onSave: function onSave(status, price) {
	          if (!status) {
	            var marketplaceIndex = _this15.forms.findIndex(function (f) {
	              return f.name === 'marketplace';
	            });
	            _this15.forms[marketplaceIndex].form.marketplaceEnabled = false;
	          }
	          if (price) {
	            var priceFormIndex = _this15.forms.findIndex(function (f) {
	              return f.name === 'priceForm';
	            });
	            _this15.forms[priceFormIndex].form.marketplace = price;
	          }
	          _this15.setModalCloseOnClick(true);
	          _this15.setModalShowClose(true);
	          _this15.setModalCloseOnEscape(true);
	        }
	      });
	    },
	    marketplacePriceUpdated: function marketplacePriceUpdated(price) {
	      var priceFormIndex = this.forms.findIndex(function (f) {
	        return f.name === 'priceForm';
	      });
	      this.forms[priceFormIndex].form.marketplace = price;
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this16 = this;
	
	      if (this.transactionLoading === false) this.transactionLoading = true;
	      var filters = {
	        batchDisplay: this.batchFilter.batchDisplay,
	        warehouseDisplay: this.warehouseFilter.warehouseDisplay
	      };
	      var params = {
	        id: this.$route.params.id,
	        page: page,
	        limit: limit,
	        filter: JSON.stringify(filters)
	      };
	      _product2.default.transactionsV2(params).then(function () {
	        setTimeout(function () {
	          if (_this16.transactionLoading === true) _this16.transactionLoading = false;
	        }, 500);
	      }).catch(function () {
	        setTimeout(function () {
	          if (_this16.transactionLoading === true) _this16.transactionLoading = false;
	        }, 500);
	      });
	    }, 800),
	
	    clearBatchFilter: function clearBatchFilter() {
	      this.batchFilter.batchDisplay = '';
	      this.all(1, this.transactionPerPage);
	    },
	    focusBatchFilter: function focusBatchFilter() {},
	    getFilterBatches: function getFilterBatches(query) {
	      var _this17 = this;
	
	      this.batchFilter.loading = true;
	      if (query !== '') {
	        setTimeout(function () {
	          _this17.batchFilter.options = _this17.batchFilter.list.filter(function (item) {
	            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
	          });
	          _this17.batchFilter.loading = false;
	        }, 200);
	      } else {
	        this.batchFilter.options = [];
	        this.batchFilter.loading = false;
	      }
	    },
	    onUpdateBatchFilter: function onUpdateBatchFilter(value) {
	      var unique = value.filter(function (set) {
	        return function (f) {
	          return !set.has(f.batchName) && set.add(f.batchName);
	        };
	      }(new Set()));
	      return this.batchFilter.list = unique.map(function (item) {
	        return { value: '' + item.batchName, label: '' + item.batchName };
	      });
	    },
	    eventBatchFilter: function eventBatchFilter(value) {
	      this.transactionLoading = true;
	      this.batchFilter.batchDisplay = value;
	      this.all(1, this.transactionPerPage);
	    },
	    clearWarehouseFilter: function clearWarehouseFilter() {
	      this.warehouseFilter.warehouseDisplay = '';
	      this.all(1, this.transactionPerPage);
	    },
	    focusWarehouseFilter: function focusWarehouseFilter() {},
	    getFilterWarehouse: function getFilterWarehouse(query) {
	      var _this18 = this;
	
	      this.warehouseFilter.loading = true;
	      if (query !== '') {
	        setTimeout(function () {
	          _this18.warehouseFilter.options = _this18.warehouseFilter.list.filter(function (item) {
	            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
	          });
	          _this18.warehouseFilter.loading = false;
	        }, 200);
	      } else {
	        this.warehouseFilter.options = [];
	        this.warehouseFilter.loading = false;
	      }
	    },
	    onUpdateWarehouseFilter: function onUpdateWarehouseFilter(value) {
	      var unique = value.filter(function (set) {
	        return function (f) {
	          return !set.has(f.warehouseId) && set.add(f.warehouseId);
	        };
	      }(new Set()));
	      return this.warehouseFilter.list = unique.map(function (item) {
	        return { value: '' + item.warehouse.name, label: '' + item.warehouse.name };
	      });
	    },
	    eventWarehouseFilter: function eventWarehouseFilter(value) {
	      this.transactionLoading = true;
	      this.warehouseFilter.warehouseDisplay = value;
	      this.all(1, this.transactionPerPage);
	    },
	    unProductCodeSearch: function unProductCodeSearch(search) {
	      return Promise.all([_productUNCode2.default.search({ search: search })]);
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9),
	    VTable: __webpack_require__(33),
	    VMarketplace: __webpack_require__(2717),
	    VPagination: __webpack_require__(16)
	  }
	};

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _productImportExportPopup = __webpack_require__(2730);
	
	var _productImportExportPopup2 = _interopRequireDefault(_productImportExportPopup);
	
	var _stringFormat = __webpack_require__(108);
	
	var _stringFormat2 = _interopRequireDefault(_stringFormat);
	
	var _productType = __webpack_require__(232);
	
	var _productType2 = _interopRequireDefault(_productType);
	
	var _producer = __webpack_require__(302);
	
	var _producer2 = _interopRequireDefault(_producer);
	
	var _productIndexSettingsPopup = __webpack_require__(2731);
	
	var _productIndexSettingsPopup2 = _interopRequireDefault(_productIndexSettingsPopup);
	
	var _bulkProcessProductModal = __webpack_require__(2682);
	
	var _bulkProcessProductModal2 = _interopRequireDefault(_bulkProcessProductModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      filterValue: [],
	      loading: true,
	      sort: '',
	      info: 'info',
	      primary: 'primary',
	      search: '',
	      limit: 25,
	      multipleSelection: [],
	      bulkSelectionLimit: 25,
	      showAction: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    products: 'paginatedProducts',
	    view: 'getView',
	    grouping: 'productGrouping',
	    searchQuery: 'productQuery',
	    account: 'account',
	    productTypes: 'allProductTypes',
	    producers: 'allProducers'
	  }), {
	    hasInventory: function hasInventory() {
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    },
	    productGroupedCardView: function productGroupedCardView() {
	      var _this = this;
	
	      return this.products.items.reduce(function (groups, item) {
	        var group = groups[(_this.grouping === 'Producer' ? item.fieldsJSON.producer : item.productType) || 'none'] || [];
	        group.push(item);
	        groups[(_this.grouping === 'Producer' ? item.fieldsJSON.producer : item.productType) || 'none'] = group;
	        return groups;
	      }, {});
	    },
	    productGroupedListView: function productGroupedListView() {
	      var _this2 = this;
	
	      return this.products.items.reduce(function (groups, item) {
	        var group = groups[(_this2.grouping === 'Producer' ? item.fieldsJSON.producer : item.productType) || 'none'] || [];
	        group.push(item);
	        groups[(_this2.grouping === 'Producer' ? item.fieldsJSON.producer : item.productType) || 'none'] = group.map(function (c) {
	          var product = _this2.products.items.find(function (p) {
	            return p.id === c.id;
	          });
	          var priceList = _this2.priceView(product.prices[0]);
	          var data = {
	            number: c.number,
	            name: c.name,
	            price: priceList,
	            warehouses: _this2.displayWarehouse(product.warehouses),
	            id: c.id
	          };
	          return data;
	        });
	        return groups;
	      }, {});
	    },
	    productsListView: function productsListView() {
	      var _this3 = this;
	
	      return this.products.items.map(function (c) {
	        var priceList = _this3.priceView(c.prices[0]);
	        var data = { number: c.number,
	          name: c.name,
	          price: priceList,
	          warehouses: _this3.displayWarehouse(c.warehouses),
	          id: c.id
	        };
	        return data;
	      });
	    },
	    filters: function filters() {
	      var filters = [{ value: 'type', label: this.$t('static.products.filters.type'), children: [] }, { value: 'producer', label: this.$t('static.products.filters.producer'), children: [] }];
	      filters[0].children = this.productyTypeOptions.filter(function (item) {
	        return item.value !== 'Bundle';
	      });
	      filters[1].children = this.producers.map(function (item) {
	        return { value: item.id, label: item.name };
	      });
	      return filters;
	    },
	    productyTypeOptions: function productyTypeOptions() {
	      var _this4 = this;
	
	      var options = this.productTypes.reduce(function (groups, item) {
	        var group = groups[item.group] || {
	          label: _this4.$t('static.products.types.' + _this4.camelize(item.group)),
	          value: item.group,
	          children: []
	        };
	        if (item.group && item.subGroup) {
	          var subGroup = group.children[item.subGroup] || {
	            label: _this4.$t('static.products.types.' + _this4.camelize(item.subGroup)),
	            value: item.subGroup,
	            children: []
	          };
	          subGroup.children.push({
	            label: _this4.$t('static.products.types.' + _this4.camelize(item.name)),
	            value: item.name
	          });
	          groups[item.group] = group;
	          groups[item.group].children[item.subGroup] = subGroup;
	        } else if (item.group) {
	          group.children.push({
	            label: _this4.$t('static.products.types.' + _this4.camelize(item.name)),
	            value: item.name
	          });
	          groups[item.group] = group;
	        } else {
	          groups[item.id] = {
	            label: _this4.$t('static.products.types.' + _this4.camelize(item.name)),
	            value: item.name
	          };
	        }
	        return groups;
	      }, {});
	      var opt = Object.keys(options).map(function (option) {
	        var item = options[option];
	        if (item.children) {
	          item.children = Object.keys(item.children).map(function (child) {
	            var c = item.children[child];
	            if (c.children) {
	              c.children = Object.keys(c.children).map(function (t) {
	                return c.children[t];
	              });
	            }
	            return c;
	          });
	        }
	        return item;
	      });
	      return opt.sort(function (a, b) {
	        return a.label > b.label ? 1 : -1;
	      });
	    },
	    selectedCount: function selectedCount() {
	      return this.multipleSelection.length || 0;
	    },
	    hasWooModule: function hasWooModule() {
	      if (this.account.modules.length > 0) {
	        if (this.account.modules.find(function (module) {
	          return module.name === 'WordPress WooCommerce';
	        })) return true;
	      }
	      return false;
	    }
	  }),
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19),
	    VTable: __webpack_require__(33)
	  },
	
	  watch: {
	    $route: function $route() {
	      this.multipleSelection = [];
	      this.all(this.searchQuery.page, this.limit);
	    },
	    filterValue: function filterValue(_filterValue) {
	      var params = Object.assign({}, this.$route.query);
	      var field = '';
	      if (_filterValue.length) {
	        field = _filterValue[0];
	        var value = _filterValue[_filterValue.length - 1];
	        params[field] = value;
	      }
	      if (field !== 'producer') {
	        delete params.producer;
	      }
	      if (field !== 'type') {
	        delete params.type;
	      }
	      this.$router.push({ query: params });
	    },
	    view: function view(_view) {
	      this.showAction = false;
	      if (_view == 'card') {
	        this.info = 'info';
	        this.primary = 'primary';
	      } else {
	        this.primary = 'info';
	        this.info = 'primary';
	      }
	    },
	    grouping: function grouping() {
	      this.all(1, this.limit);
	    },
	    multipleSelection: function multipleSelection(_multipleSelection) {
	      this.showAction = false;
	      if (_multipleSelection.length) {
	        this.showAction = true;
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    var _this5 = this;
	
	    var productFilter = {
	      title: this.$t('static.products.filters.title'),
	      options: [{
	        title: this.$t('static.products.filters.withDeposit'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'withDeposit'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.active'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'active'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.deactivated'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'deactivated'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.materials'),
	        route: {
	          name: 'products.index',
	          query: {
	            type: 'Material'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.all'),
	        route: {
	          name: 'products.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.products.create.title'),
	        route: {
	          name: 'products.create'
	        }
	      }
	    };
	    var vmpSyncMenu = {};
	    if (this.account.modules.length > 0) {
	      for (var i = 0; i < this.account.modules.length; i++) {
	        if (this.account.modules[i].name == 'EDI') {
	          productFilter = {
	            title: this.$t('static.products.filters.title'),
	            options: [{
	              title: this.$t('static.products.filters.active'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'active'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.deactivated'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'deactivated'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.withDeposit'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'withDeposit'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.materials'),
	              route: {
	                name: 'products.index',
	                query: {
	                  type: 'Material'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.asko'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'asko'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.vinhuset'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'vinhuset'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.marketplace'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'marketplace'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.onlineStore'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'onlineStore'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.alcohol'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'alcohol'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.alcoholFree'),
	              route: {
	                name: 'products.index',
	                query: {
	                  filter: 'alcoholFree'
	                }
	              }
	            }, {
	              title: this.$t('static.products.filters.all'),
	              route: {
	                name: 'products.index'
	              }
	            }],
	            button: {
	              title: '+ ' + this.$t('static.products.create.title'),
	              route: {
	                name: 'products.create'
	              }
	            }
	          };
	        }
	        if (this.account.modules[i].name == 'Vinmonopolet') {
	          vmpSyncMenu = {
	            title: this.$t('static.products.syncVmp.title'),
	            button: {
	              title: '+ ' + this.$t('static.products.syncVmp.title'),
	              route: {
	                name: 'products.syncVmp'
	              }
	            }
	          };
	        }
	      }
	    }
	
	    var productBundle = {
	      title: this.$t('static.productBundles.filters.title'),
	      options: [{
	        title: this.$t('static.productBundles.filters.all'),
	        route: {
	          name: 'productBundles.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productBundles.create.title'),
	        route: {
	          name: 'productBundles.create'
	        }
	      }
	    };
	
	    this.setInnerSidebar([productFilter, productBundle, vmpSyncMenu, {
	      title: this.$t('static.productPackagings.filters.title'),
	      options: [{
	        title: this.$t('static.productPackagings.filters.all'),
	        route: {
	          name: 'productPackagings.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productPackagings.create.title'),
	        route: {
	          name: 'productPackagings.create'
	        }
	      }
	    }, {
	      title: this.$t('static.productGroups.filters.title'),
	      options: [{
	        title: this.$t('static.productGroups.filters.all'),
	        route: {
	          name: 'productGroups.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productGroups.create.title'),
	        route: {
	          name: 'productGroups.create'
	        }
	      }
	    }, {
	      title: this.$t('static.productTags.filters.title'),
	      options: [{
	        title: this.$t('static.productTags.filters.all'),
	        route: {
	          name: 'productTags.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productTags.create.title'),
	        route: {
	          name: 'productTags.create'
	        }
	      }
	    }]);
	
	    Promise.all([_productType2.default.all(), _producer2.default.all()]).then(function () {
	      _this5.loading = false;
	    });
	    _store2.default.dispatch('setProductGrouping', this.account.productGrouping);
	
	    _account2.default.rememberPerPage('get', { from: 'product' }).then(function (data) {
	      _this5.limit = data.size;
	      _this5.all(_this5.searchQuery.page, _this5.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	
	    if (this.account.productDisplay) {
	      _store2.default.dispatch('setView', this.account.productDisplay);
	    }
	    if (this.view == 'card') {
	      this.info = 'info';
	      this.primary = 'primary';
	    } else {
	      this.primary = 'info';
	      this.info = 'primary';
	    }
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	    _store2.default.dispatch('resetProducts');
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    setModalClass: 'SET_MODAL_CLASS'
	  }), {
	    onSelectAction: function onSelectAction(value) {
	      if (this.multipleSelection.length > this.bulkSelectionLimit) {
	        var message = this.$t('static.products.index.bulkMaxLimitExceededError') + ' ' + this.bulkSelectionLimit;
	        this.$message({
	          showClose: true,
	          message: message,
	          customClass: 'error'
	        });
	        return;
	      }
	
	      if (value) {
	        var type = 'Active';
	        if (value === 'deactivateProduct') {
	          type = 'Inactive';
	        }
	
	        this.setModalContent(function () {
	          return _bulkProcessProductModal2.default;
	        });
	        this.setModalProps({
	          selectedProducts: this.multipleSelection,
	          onSubmit: this.handleBulkProductActionSubmit,
	          type: value
	        });
	        this.setModalCloseOnClick(false);
	        this.setModalShowClose(false);
	        this.setModalCloseOnPressEscape(false);
	        this.toggleModal(true);
	      }
	    },
	    handleBulkProductActionSubmit: function handleBulkProductActionSubmit() {
	      this.multipleSelection = [];
	      this.all(this.searchQuery.page, this.limit);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    priceView: function priceView(prices) {
	      var priceList = '';
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = Object.entries(prices)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _slicedToArray(_step.value, 2),
	              key = _step$value[0],
	              value = _step$value[1];
	
	          var labelPrice = key !== 'price' ? '(' + this.$t('form.products.' + key + '.label') + ')' : '';
	          priceList += typeof value !== 'undefined' ? 'NOK ' + value.toFixed(2) + ' ' + labelPrice : '';
	          priceList += '<br />';
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return priceList;
	    },
	    perPage: function perPage(size) {
	      var _this6 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'product', perPage: size }).then(function (data) {
	        _this6.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    handleFilterChange: function handleFilterChange() {},
	    showImportDownloadModal: function showImportDownloadModal() {
	      this.setModalContent(function () {
	        return _productImportExportPopup2.default;
	      });
	      this.setModalSize('full');
	      this.toggleModal(true);
	    },
	    showProductIndexSettingsModal: function showProductIndexSettingsModal() {
	      this.setModalClass('product-settings');
	      this.setModalContent(function () {
	        return _productIndexSettingsPopup2.default;
	      });
	      this.setModalSize('full');
	      this.toggleModal(true);
	    },
	    displayWarehouse: function displayWarehouse(allWarehouses) {
	      var map = {};
	      var warehouses = allWarehouses.reduce(function (warehouse, val) {
	        var _val$warehouse = val.warehouse,
	            id = _val$warehouse.id,
	            name = _val$warehouse.name,
	            totalItemQty = val.totalItemQty,
	            totalCrateQty = val.totalCrateQty,
	            totalLooseQty = val.totalLooseQty;
	        var l = warehouse.length;
	
	        if (map.hasOwnProperty(id)) {
	          warehouse[map[id]].totalItemQty += +totalItemQty;
	          warehouse[map[id]].totalCrateQty += +totalCrateQty;
	          warehouse[map[id]].totalLooseQty += +totalLooseQty;
	        } else {
	          map[id] = l;
	          warehouse.push({
	            id: id,
	            name: name,
	            totalItemQty: +totalItemQty,
	            totalCrateQty: +totalCrateQty,
	            totalLooseQty: +totalLooseQty
	          });
	        }
	        return warehouse;
	      }, []);
	
	      if (warehouses.length > 0) {
	        var html = '';
	        for (var i = 0; i < warehouses.length; i++) {
	          if (warehouses[i].id) {
	            var text = warehouses[i].name + ' (' + warehouses[i].totalItemQty + ' : ' + warehouses[i].totalCrateQty + ' kasse(r), ' + warehouses[i].totalLooseQty + ' l\xF8se )';
	            html += '<a title="' + text + '" href="#/inventory/warehouse/' + warehouses[i].id + '/edit">' + text + '</a><br>';
	          }
	        }
	        return html;
	      }
	      return '';
	    },
	    changeView: function changeView(view) {
	      if (this.info != view) {
	        this.primary = this.info;
	        this.info = view;
	        if (this.info == 'info') {
	          _store2.default.dispatch('setView', 'card');
	        } else {
	          _store2.default.dispatch('setView', 'list');
	        }
	      }
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this7 = this;
	
	      this.loading = true;
	
	      var query = { page: page, limit: limit, search: this.searchQuery.search, grouping: this.searchQuery.grouping };
	      _store2.default.dispatch('setProductQuery', query);
	      this.search = this.searchQuery.search;
	      _product2.default.items({
	        page: page,
	        limit: limit,
	        search: this.searchQuery.search,
	        grouping: this.searchQuery.grouping,
	        filter: this.$route.query.filter,
	        type: this.$route.query.type,
	        producer: this.$route.query.producer,
	        packaging: JSON.stringify(this.$route.query.packaging)
	      }).then(function () {
	        _this7.loading = false;
	      }).catch(function () {
	        _this7.loading = false;
	      });
	    }, 800),
	
	    onChangeSearch: function onChangeSearch(name, value) {
	      _store2.default.dispatch('setProductQuery', { page: 1, limit: this.limit, search: value, grouping: this.searchQuery.grouping });
	      this.all(1, this.limit);
	    },
	    editProduct: function editProduct(product) {
	      this.$router.push({
	        name: 'products.edit',
	        params: { id: product.id }
	      });
	    },
	    editProductNewTab: function editProductNewTab(product) {
	      var route = this.$router.resolve({
	        name: 'products.edit',
	        params: { id: product.id }
	      });
	      window.open(route.href, '_blank');
	    }
	  }),
	
	  mixins: [_search2.default, _stringFormat2.default]
	};

/***/ }),
/* 1957 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _productVmpSync = __webpack_require__(1700);
	
	var _productVmpSync2 = _interopRequireDefault(_productVmpSync);
	
	var _vinmonopolet = __webpack_require__(236);
	
	var _vinmonopolet2 = _interopRequireDefault(_vinmonopolet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  data: function data() {
	    return {
	      products: {
	        forUpdate: [],
	        forInsert: []
	      },
	      newProductsSelection: [],
	      existingProductsSelection: [],
	      defaultProductTypeName: '',
	      loading: false,
	      syncLoading: false,
	      prechecked: 0,
	      tabIndex: '1',
	      selectedFields: [],
	      productsPackaging: [],
	      results: []
	    };
	  },
	
	  computed: {
	    newProducts: function newProducts() {
	      var _this = this;
	
	      return this.newProductsSelection.map(function (p) {
	        return _this.getPackaging(p);
	      });
	    },
	    existingProducts: function existingProducts() {
	      var _this2 = this;
	
	      return this.existingProductsSelection.map(function (p) {
	        return _this2.getPackaging(p);
	      });
	    },
	    syncDate: function syncDate() {
	      if (this.products.forInsert.length) {
	        return this.products.forInsert[0].syncDate;
	      }
	      if (this.products.forUpdate.length) {
	        return this.products.forUpdate[0].syncDate;
	      }
	      return '';
	    }
	  },
	  created: function created() {
	    this.startSync(false);
	  },
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalButtonLoading: 'SET_MODAL_BUTTON_LOADING',
	    setModalClass: 'SET_MODAL_CLASS'
	  }), {
	    startSync: function startSync(isVmpSync) {
	      var _this3 = this;
	
	      this.syncLoading = true;
	      this.results = [];
	      this.newProductsSelection = [];
	      this.existingProductsSelection = [];
	      _vinmonopolet2.default.syncSelected({ precheck: 1, vmp_sync: isVmpSync }).then(function (data) {
	        _this3.products.forInsert = _productVmpSync2.default.fetchCollection(data.for_insert);
	        _this3.products.forUpdate = _productVmpSync2.default.fetchCollection(data.for_update);
	        if (!_this3.products.forInsert.length && !_this3.products.forUpdate.length) {
	          if (isVmpSync) {
	            _this3.$message({
	              message: _this3.$t('static.products.syncVmp.noDataToBeSynced'),
	              type: 'error'
	            });
	          }
	        } else {
	          _this3.prechecked = 1;
	        }
	        _this3.syncLoading = false;
	      }).catch(function () {
	        _this3.syncLoading = false;
	      });
	    },
	    processSync: function processSync() {
	      if (!this.existingProductsSelection.length) {
	        this.confirmSync();
	        return;
	      }
	      this.showFieldsModal();
	    },
	    showFieldsModal: function showFieldsModal() {
	      var _this4 = this;
	
	      this.setModalContent(function () {
	        return __webpack_require__(2746);
	      });
	      this.setModalSize('full');
	      this.toggleModal(true);
	      this.setModalShowClose(false);
	      this.setModalProps({
	        selectedFields: this.selectedFields,
	        onConfirm: this.saveFields,
	        result: this.results,
	        hasNewSelection: !!this.newProductsSelection.length,
	        onClose: function onClose() {
	          return _this4.startSync(false);
	        }
	      });
	      this.setModalClass('');
	    },
	    showPackagingModal: function showPackagingModal(productsNoPackaging) {
	      var _this5 = this;
	
	      this.setModalContent(function () {
	        return __webpack_require__(2747);
	      });
	      this.setModalSize('100%');
	      this.setModalClass('vmp-packaging');
	      this.toggleModal(true);
	      this.setModalProps({
	        productsNoPackaging: productsNoPackaging,
	        onConfirm: this.confirmSync,
	        onUpdatePackaging: this.updatePackaging,
	        onPackagingCreate: function onPackagingCreate() {
	          return _this5.checkMissingPackaging(true);
	        }
	      });
	    },
	    saveFields: function saveFields(fields) {
	      this.selectedFields = fields;
	      this.confirmSync();
	    },
	    updatePackaging: function updatePackaging(product) {
	      if (!product) return;
	      var index = this.productsPackaging.findIndex(function (p) {
	        return +p.id === product.id;
	      });
	      if (index !== -1) {
	        this.productsPackaging[index].productPackagingId = product.productPackagingId;
	      } else {
	        this.productsPackaging.push({
	          id: product.id,
	          productPackagingId: product.productPackagingId
	        });
	      }
	    },
	    getPackaging: function getPackaging(product) {
	      var packagingId = product.productPackagingId;
	      if (!packagingId) {
	        var p = this.productsPackaging.find(function (packaging) {
	          return +packaging.id === +product.id;
	        });
	        if (p) {
	          packagingId = p.productPackagingId;
	        }
	      }
	      return {
	        id: product.id,
	        productPackagingId: packagingId,
	        vmp: product.vmp,
	        name: product.name,
	        alcoholPercentage: product.alcoholPercentage,
	        bottleVolume: product.bottleVolume,
	        packagingMaterialId: product.packagingMaterialId,
	        packagingName: product.packagingName,
	        packagingQuantity: product.packagingQuantity
	      };
	    },
	    checkMissingPackaging: function checkMissingPackaging() {
	      var _this6 = this;
	
	      var forceShowModal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var products = [].concat(_toConsumableArray(this.newProducts), _toConsumableArray(this.existingProducts));
	      var productsNoPackaging = products.filter(function (p) {
	        return !p.productPackagingId || forceShowModal && _this6.productsPackaging.find(function (pp) {
	          return +pp.id === +p.id;
	        });
	      });
	      if (productsNoPackaging.length || forceShowModal) {
	        this.showPackagingModal(productsNoPackaging);
	        return true;
	      }
	      return false;
	    },
	    confirmSync: function confirmSync() {
	      var _this7 = this;
	
	      if (this.checkMissingPackaging()) return;
	
	      this.syncLoading = true;
	      var params = {
	        selected: {
	          new: this.newProducts.map(function (p) {
	            return { id: p.id, product_packaging_id: p.productPackagingId };
	          }),
	          existing: this.existingProducts.map(function (p) {
	            return { id: p.id, product_packaging_id: p.productPackagingId };
	          })
	        },
	        fields: this.selectedFields
	      };
	      _vinmonopolet2.default.syncSelected(params).then(function (data) {
	        _this7.prechecked = 1;
	        _this7.syncLoading = false;
	
	        if (data.result.length) {
	          _this7.results = data.result;
	          _this7.showFieldsModal();
	          return;
	        }
	      }).catch(function () {
	        _this7.syncLoading = false;
	        _this7.$message({
	          message: _this7.$t('static.products.syncVmp.syncError'),
	          type: 'error'
	        });
	      });
	    },
	    cancelSync: function cancelSync() {
	      this.products.forInsert = [];
	      this.products.forUpdate = [];
	      this.prechecked = 0;
	      this.syncLoading = false;
	      this.results = [];
	    },
	    restartSync: function restartSync() {
	      this.results = [];
	      this.startSync(false);
	    },
	    handleNewProductsSelectionChange: function handleNewProductsSelectionChange(val) {
	      this.newProductsSelection = val;
	    },
	    handleExistingProductsSelectionChange: function handleExistingProductsSelectionChange(val) {
	      this.existingProductsSelection = val;
	    }
	  })
	};

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _account2 = __webpack_require__(12);
	
	var _account3 = _interopRequireDefault(_account2);
	
	var _account4 = __webpack_require__(237);
	
	var _account5 = _interopRequireDefault(_account4);
	
	var _auth = __webpack_require__(53);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _country = __webpack_require__(66);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _siteLanguages2 = __webpack_require__(481);
	
	var _siteLanguages3 = _interopRequireDefault(_siteLanguages2);
	
	var _organizationType = __webpack_require__(1148);
	
	var _organizationType2 = _interopRequireDefault(_organizationType);
	
	var _password = __webpack_require__(1689);
	
	var _password2 = _interopRequireDefault(_password);
	
	var _postal = __webpack_require__(159);
	
	var _postal2 = _interopRequireDefault(_postal);
	
	var _publicProfile2 = __webpack_require__(233);
	
	var _publicProfile3 = _interopRequireDefault(_publicProfile2);
	
	var _publicProfile4 = __webpack_require__(242);
	
	var _publicProfile5 = _interopRequireDefault(_publicProfile4);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      organizationForm: new _forms2.default({
	        organizationTypeId: {
	          value: '',
	          type: 'select'
	        },
	        organizationName: {
	          value: '',
	          type: 'text'
	        },
	        firstName: {
	          value: '',
	          type: 'text'
	        },
	        lastName: {
	          value: '',
	          type: 'text'
	        },
	        organizationDescription: {
	          value: '',
	          type: 'textarea'
	        },
	        organizationProfilePicture: {
	          value: '',
	          type: 'file'
	        }
	      }),
	      contactInformationForm: new _forms2.default({
	        email: {
	          value: '',
	          type: 'email'
	        },
	        phoneNumber: {
	          value: '',
	          type: 'text'
	        },
	        mobileNumber: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      userSettingForm: new _forms2.default({
	        language: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      businessInformation: new _forms2.default({
	        businessRegistrationNumber: {
	          value: '',
	          type: 'text'
	        },
	        bankAccount: {
	          value: '',
	          type: 'text'
	        },
	        isInternational: {
	          value: '',
	          type: 'switch'
	        },
	        bankName: {
	          value: '',
	          type: 'text'
	        },
	        swift: {
	          value: '',
	          type: 'text'
	        },
	        iban: {
	          value: '',
	          type: 'text'
	        },
	        isVatRegistered: {
	          value: '',
	          type: 'switch'
	        },
	        isRegisteredBusinessEnterprise: {
	          value: '',
	          type: 'switch'
	        },
	        smallScaleManufacturer: {
	          value: '',
	          type: 'switch'
	        },
	        gs1number: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      userInformationForm: new _forms2.default({
	        userEmail: {
	          value: '',
	          type: 'email'
	        },
	        userFirstName: {
	          value: '',
	          type: 'text'
	        },
	        userLastName: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      passwordForm: new _forms2.default({
	        currentPassword: {
	          value: '',
	          type: 'password'
	        },
	        password: {
	          value: '',
	          type: 'password'
	        },
	        passwordConfirmation: {
	          value: '',
	          type: 'password'
	        }
	      }),
	      addressForm: new _forms2.default({
	        careOf: {
	          value: '',
	          type: 'text'
	        },
	        streetName: {
	          value: '',
	          type: 'text'
	        },
	        secondStreetName: {
	          value: '',
	          type: 'text'
	        },
	        postalCode: {
	          value: '',
	          type: 'text' },
	        cityName: {
	          value: '',
	          type: 'text'
	        },
	        countryId: {
	          value: 1,
	          type: 'select'
	        }
	      }),
	      mainPublicProfileForm: new _forms2.default({
	        profileUrl: {
	          value: '',
	          type: 'text'
	        },
	        header: {
	          value: '',
	          type: 'text'
	        },
	        subheader: {
	          value: '',
	          type: 'text'
	        },
	        backgroundImage: {
	          value: '',
	          type: 'file'
	        }
	      }),
	      defaultsPublicProfileForm: new _forms2.default({
	        appointmentConfirmationTitle: {
	          value: '',
	          type: 'text'
	        },
	        appointmentConfirmationTemplate: {
	          value: '',
	          type: 'textarea'
	        },
	        defaultReminderTitle: {
	          value: '',
	          type: 'text'
	        },
	        defaultReminder: {
	          value: '',
	          type: 'textarea'
	        },
	        defaultCancelMessageTitle: {
	          value: '',
	          type: 'text'
	        },
	        defaultCancelMessage: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      checkoutSettingsForm: new _forms2.default({
	        bookingRequirePayment: {
	          value: '',
	          type: 'checkbox'
	        },
	        bookingRequireAddress: {
	          value: '',
	          type: 'checkbox'
	        }
	      }),
	      tabIndex: '1',
	      activeNames: ['1', '2', '3'],
	      activeProfileInformationName: ['11', '12', '13', '14', '15'],
	      loading: false,
	      stripe_sk: '',
	      stripe_code: '',
	      stripe_client_id: '',
	      stripeButtonLoading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    countries: 'allCountries',
	    siteLanguages: 'allLanguages',
	    municipalities: 'allMunicipalities',
	    organizationTypes: 'allOrganizationTypes',
	    postals: 'allPostals',
	    publicProfile: 'publicProfile'
	  }), {
	    publicPageDomain: function publicPageDomain() {
	      return ("kundan.no");
	    },
	    isOnlineBooking: function isOnlineBooking() {
	      return this.account.plan === 'Online Booking' || this.account.plan === 'Booking Pro';
	    }
	  }),
	
	  watch: {
	
	    'businessInformation.isInternational': function businessInformationIsInternational(value) {
	      if (value === true) {
	        this.businessInformation.showField('bankName');
	        this.businessInformation.showField('swift');
	        this.businessInformation.showField('iban');
	      } else {
	        this.businessInformation.hideField('bankName');
	        this.businessInformation.hideField('swift');
	        this.businessInformation.hideField('iban');
	      }
	    },
	    publicProfile: function publicProfile(_publicProfile) {
	      this.mainPublicProfileForm.assignData(_publicProfile);
	      this.defaultsPublicProfileForm.assignData(_publicProfile);
	      this.checkoutSettingsForm.assignData(_publicProfile);
	      this.updateProfileUrl(_publicProfile);
	    },
	    postals: function postals(_postals) {
	      this.addressForm.setOptions('postalCode', _postals.items.map(function (o) {
	        return { name: o.postalCode };
	      }));
	    },
	
	    'addressForm.postalCode': function addressFormPostalCode(postalCode) {
	      if (typeof postalCode === 'string') {
	        if (postalCode.length > 3) {
	          this.showCityByPostalCode(postalCode);
	        }
	      }
	
	      if ((typeof postalCode === 'undefined' ? 'undefined' : _typeof(postalCode)) === 'object') {
	        this.showCityByPostalCode(postalCode.name.toString());
	        this.addressForm.postalCode = postalCode.name.toString();
	      }
	    },
	
	    countries: function countries(_countries) {
	      this.addressForm.setOptions('countryId', _countries.items);
	    },
	    siteLanguages: function siteLanguages(_siteLanguages) {
	      this.userSettingForm.setOptions('language', _siteLanguages.items.map(function (lng) {
	        return {
	          id: lng.code,
	          name: lng.name
	        };
	      }));
	    },
	    organizationTypes: function organizationTypes(_organizationTypes) {
	      var _this = this;
	
	      this.organizationForm.setOptions('organizationTypeId', _organizationTypes.map(function (organizationType) {
	        return {
	          id: organizationType.id,
	          name: _this.$t('layouts.header.' + organizationType.name.toLowerCase())
	        };
	      }));
	    },
	    account: function account(_account) {
	      this.businessInformation.assignData(_account);
	      this.contactInformationForm.assignData(_account);
	      this.userSettingForm.assignData(_account);
	      this.organizationForm.assignData(_account);
	      this.userInformationForm.assignData(_account);
	      this.assignOrganizationType();
	      this.$i18n.locale = _account.language;
	    },
	
	    'organizationForm.organizationTypeId': function organizationFormOrganizationTypeId(typeId) {
	      var type = this.organizationTypes.filter(function (t) {
	        return typeId.toString() === t.id.toString();
	      })[0];
	
	      if (type.name === 'Company') {
	        this.organizationForm.organizationDescription = this.account.organizationDescription;
	        this.organizationForm.organizationName = this.account.organizationName;
	        this.organizationForm.showField('organizationDescription');
	        this.organizationForm.hideField('firstName');
	        this.organizationForm.hideField('lastName');
	      }
	
	      if (type.name === 'Individual') {
	        this.organizationForm.firstName = this.account.firstName;
	        this.organizationForm.lastName = this.account.lastName;
	        this.organizationForm.showField('firstName');
	        this.organizationForm.showField('lastName');
	        this.organizationForm.hideField('organizationDescription');
	      }
	    }
	  },
	
	  created: function created() {
	    var _this2 = this;
	
	    this.businessInformation.hideField('bankName');
	    this.businessInformation.hideField('swift');
	    this.businessInformation.hideField('iban');
	
	    if (!this.account.organizationName) {
	      this.tabIndex = '2';
	    }
	    this.addressForm.setExtraAttr('postalCode', {
	      remote: _postal2.default
	    });
	
	    this.mainPublicProfileForm.assignData(this.publicProfile);
	    this.defaultsPublicProfileForm.assignData(this.publicProfile);
	    this.checkoutSettingsForm.assignData(this.publicProfile);
	    this.addressForm.assignData(this.account);
	    this.businessInformation.assignData(this.account);
	    this.contactInformationForm.assignData(this.account);
	    this.userSettingForm.assignData(this.account);
	    this.organizationForm.assignData(this.account);
	    this.userInformationForm.assignData(this.account);
	
	    Promise.all([_country2.default.all(), _siteLanguages3.default.all(), _organizationType2.default.all()]).then(function () {
	      _this2.assignOrganizationType();
	
	
	      if (_this2.isOnlineBooking) {
	        console.log('it is an online booking');
	        if (Object.keys(_this2.publicProfile).length === 0) {
	          console.log('there is a public profile');
	          _this2.loading = true;
	          _publicProfile3.default.show().then(function (profile) {
	            console.log('fetched the public profile');
	            _this2.updateProfileUrl(profile);
	            _this2.loading = false;
	          }).catch(function (err) {
	            console.log('the error');
	            console.log(err);
	          });
	        } else {
	          _this2.updateProfileUrl(_this2.publicProfile);
	        }
	      }
	    });
	
	    _vue2.default.$http.get('/settings', {
	      params: {
	        settings: ['stripe_sk', 'stripe_client_id']
	      }
	    }).then(function (data) {
	      _this2.stripe_sk = data.data.stripe_sk;
	      _this2.stripe_client_id = data.data.stripe_client_id;
	      if (_this2.$route.query.code && !_this2.publicProfile.stripeConnect) {
	        _this2.stripeButtonLoading = true;
	        _this2.tabIndex = '6';
	        _this2.stripe_code = _this2.$route.query.code;
	        _this2.stripeUserGet();
	      }
	    });
	  },
	
	
	  methods: {
	    stripeUserGet: function stripeUserGet() {
	      var _this3 = this;
	
	      this.stripeButtonLoading = true;
	      var href = window.location.href;
	      href = href.substring(0, href.indexOf('?'));
	
	      _vue2.default.$http.post('/organization_settings/stripe_connect', {
	        client_secret: this.stripe_sk,
	        code: this.stripe_code,
	        grant_type: 'authorization_code'
	      }).then(function (data) {
	        _this3.publicProfile.stripeConnect = data.data;
	        _this3.stripeButtonLoading = false;
	        window.history.pushState({}, document.title, href);
	        _this3.$message({
	          message: 'Stripe successfully connected',
	          type: 'success'
	        });
	      }).catch(function (error) {
	        _this3.stripeButtonLoading = false;
	        window.history.pushState({}, document.title, href);
	        _this3.$message({
	          message: error.response.data.message,
	          type: 'error'
	        });
	      });
	    },
	    updateProfileUrl: function updateProfileUrl(profile) {
	      if (profile.profileUrl.length > 0) {
	        this.mainPublicProfileForm.fields.profileUrl = 'hide';
	        this.profileUrl = profile.profileUrl;
	        this.$forceUpdate();
	      }
	    },
	    assignOrganizationType: function assignOrganizationType() {
	      var _this4 = this;
	
	      var type = this.organizationTypes.filter(function (organizationType) {
	        return organizationType.name === _this4.account.organizationType;
	      });
	      if (type.length === 1) {
	        this.organizationForm.organizationTypeId = type[0].id;
	      }
	    },
	    showCityByPostalCode: function showCityByPostalCode(postalCode) {
	      if (this.postals.items.length > 0) {
	        var postal = this.postals.items.filter(function (p) {
	          return postalCode === p.postalCode.toString();
	        })[0];
	
	        this.addressForm.cityName = postal.cityName;
	      }
	    },
	    saveUserInformation: function saveUserInformation() {
	      var _this5 = this;
	
	      this.userInformationForm.loading = true;
	      var account = _account5.default.send(this.userInformationForm.data());
	      _account3.default.updateUser(account).then(function () {
	        _this5.userInformationForm.loading = false;
	        _this5.$message({
	          message: _this5.$t('static.accountInformation.accountSaveSuccess'),
	          type: 'success'
	        });
	      }).catch(function (errors) {
	        _this5.userInformationForm.loading = false;
	        _this5.userInformationForm.recordErrors(errors);
	      });
	    },
	    save: function save() {
	      var _this6 = this;
	
	      this.addressForm.loading = true;
	      this.businessInformation.loading = true;
	      this.contactInformationForm.loading = true;
	      this.userSettingForm.loading = true;
	      this.organizationForm.loading = true;
	
	      var account = _account5.default.send(Object.assign({}, this.addressForm.data(), this.businessInformation.data(), this.contactInformationForm.data(), this.userSettingForm.data(), this.organizationForm.data()));
	
	      _account3.default.update(account).then(function () {
	        _this6.addressForm.loading = false;
	        _this6.businessInformation.loading = false;
	        _this6.contactInformationForm.loading = false;
	        _this6.userSettingForm.loading = false;
	        _this6.organizationForm.loading = false;
	
	        _this6.$message({
	          message: _this6.$t('static.accountInformation.accountSaveSuccess'),
	          type: 'success'
	        });
	      }).catch(function (errors) {
	        _this6.addressForm.loading = false;
	        _this6.businessInformation.loading = false;
	        _this6.contactInformationForm.loading = false;
	        _this6.userSettingForm.loading = false;
	        _this6.organizationForm.loading = false;
	
	        _this6.addressForm.recordErrors(errors);
	        _this6.businessInformation.recordErrors(errors);
	        _this6.contactInformationForm.recordErrors(errors);
	        _this6.userSettingForm.loading = false;
	        _this6.organizationForm.recordErrors(errors);
	      });
	    },
	    changePassword: function changePassword() {
	      var _this7 = this;
	
	      this.passwordForm.loading = true;
	      _auth2.default.updatePassword(_password2.default.send(this.passwordForm.data())).then(function () {
	        _this7.passwordForm.loading = false;
	        _this7.passwordForm.currentPassword = '';
	        _this7.passwordForm.password = '';
	        _this7.passwordForm.passwordConfirmation = '';
	        _this7.$message({
	          message: _this7.$t('static.accountInformation.passwordSaveSuccess'),
	          type: 'success'
	        });
	      }).catch(function (errors) {
	        _this7.passwordForm.loading = false;
	        _this7.passwordForm.recordErrors(_password2.default.fetch(errors));
	      });
	    },
	    savePublicProfile: function savePublicProfile() {
	      var _this8 = this;
	
	      this.defaultsPublicProfileForm.loading = true;
	      this.mainPublicProfileForm.loading = true;
	      this.checkoutSettingsForm.loading = true;
	      var publicProfile = _publicProfile5.default.send(Object.assign({}, this.mainPublicProfileForm.data(), this.defaultsPublicProfileForm.data(), this.checkoutSettingsForm.data()));
	      _publicProfile3.default.update(publicProfile).then(function () {
	        _this8.defaultsPublicProfileForm.loading = false;
	        _this8.mainPublicProfileForm.loading = false;
	        _this8.checkoutSettingsForm.loading = false;
	        _this8.$message({
	          message: _this8.$t('static.accountInformation.accountSaveSuccess'),
	          type: 'success'
	        });
	      }).catch(function (errors) {
	        _this8.defaultsPublicProfileForm.loading = false;
	        _this8.mainPublicProfileForm.loading = false;
	        _this8.checkoutSettingsForm.loading = false;
	        _this8.defaultsPublicProfileForm.recordErrors(errors);
	        _this8.mainPublicProfileForm.recordErrors(errors);
	        _this8.checkoutSettingsForm.recordErrors(errors);
	      });
	    },
	    saveGeneralInformation: function saveGeneralInformation() {
	      this.generalInformationForm.loading = true;
	      var generalInformation = generalInformationTransformer.send();
	    }
	  },
	
	  components: {
	    VModal: __webpack_require__(772),
	    VForm: __webpack_require__(9),
	    VOpenHours: __webpack_require__(773),
	    VExceptionalHours: __webpack_require__(771)
	  }
	};

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _country = __webpack_require__(66);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _address2 = __webpack_require__(194);
	
	var _address3 = _interopRequireDefault(_address2);
	
	var _address4 = __webpack_require__(877);
	
	var _address5 = _interopRequireDefault(_address4);
	
	var _postal = __webpack_require__(159);
	
	var _postal2 = _interopRequireDefault(_postal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        streetName: {
	          value: '',
	          type: 'text'
	        },
	        secondStreetName: {
	          value: '',
	          type: 'text'
	        },
	        countryId: {
	          value: 1,
	          type: 'select'
	        },
	        postalCode: {
	          value: '',
	          type: 'autocomplete'
	        },
	        cityName: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    address: 'address',
	    municipalities: 'allMunicipalities',
	    countries: 'allCountries',
	    postals: 'allPostals'
	  })),
	
	  watch: {
	    postals: function postals(_postals) {
	      this.form.setOptions('postalCode', _postals.items.map(function (o) {
	        return { name: o.postalCode };
	      }));
	    },
	
	    'form.postalCode': function formPostalCode(postalCode) {
	      if (typeof postalCode === 'string') {
	        if (postalCode.length > 3) {
	          this.showCityByPostalCode(postalCode);
	        }
	      }
	
	      if ((typeof postalCode === 'undefined' ? 'undefined' : _typeof(postalCode)) === 'object') {
	        this.showCityByPostalCode(postalCode.name.toString());
	        this.form.postalCode = postalCode.name.toString();
	      }
	    },
	
	    countries: function countries(_countries) {
	      this.form.setOptions('countryId', _countries.items);
	    },
	    address: function address(_address) {
	      this.form.assignData(_address);
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.form.setOptions('countryId', this.countries.items);
	    this.form.setExtraAttr('postalCode', {
	      remote: _postal2.default
	    });
	    this.form.disableField('cityName');
	    var requests = [];
	
	    if (Object.keys(this.address).length === 0) {
	      requests.push(_address5.default.show());
	    }
	
	    if (this.countries.items.length === 0) {
	      requests.push(_country2.default.all());
	    }
	
	    this.loading = true;
	    Promise.all(requests).then(function () {
	      _this.form.assignData(_this.address);
	      _this.loading = false;
	    });
	  },
	
	
	  methods: {
	    save: function save() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var address = _address3.default.send(this.form.data());
	      Promise.resolve(_address5.default.update(address)).then(function () {
	        _this2.form.loading = false;
	        _this2.form.successMessage = _this2.$t('static.profileAddress.addressSaveSuccess');
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    },
	    showCityByPostalCode: function showCityByPostalCode(postalCode) {
	      if (this.postals.items.length > 0) {
	        var postal = this.postals.items.filter(function (p) {
	          return postalCode === p.postalCode.toString();
	        })[0];
	
	        this.form.cityName = postal.cityName;
	      }
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _contact2 = __webpack_require__(240);
	
	var _contact3 = _interopRequireDefault(_contact2);
	
	var _contact4 = __webpack_require__(997);
	
	var _contact5 = _interopRequireDefault(_contact4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        firstName: {
	          value: '',
	          type: 'text'
	        },
	        lastName: {
	          value: '',
	          type: 'text'
	        },
	        email: {
	          value: '',
	          type: 'text'
	        },
	        phoneNumber: {
	          value: '',
	          type: 'text'
	        },
	        mobileNumber: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    contact: 'contact'
	  })),
	
	  watch: {
	    contact: function contact(_contact) {
	      this.form.assignData(_contact);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var requests = [];
	    this.form.assignData(this.contact);
	
	    if (Object.keys(this.contact).length === 0) {
	      requests.push(_contact5.default.show());
	    }
	
	    this.loading = true;
	    Promise.all(requests).then(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  methods: {
	    save: function save() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var contact = _contact3.default.send(this.form.data());
	      Promise.resolve(_contact5.default.update(contact)).then(function () {
	        _this2.form.loading = false;
	        _this2.form.successMessage = _this2.$t('static.profileContact.addressSaveSuccess');
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1962 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _publicProfile2 = __webpack_require__(242);
	
	var _publicProfile3 = _interopRequireDefault(_publicProfile2);
	
	var _publicProfile4 = __webpack_require__(233);
	
	var _publicProfile5 = _interopRequireDefault(_publicProfile4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        profileUrl: {
	          value: '',
	          type: 'text'
	        },
	        header: {
	          value: '',
	          type: 'text'
	        },
	        subheader: {
	          value: '',
	          type: 'text'
	        },
	        appointmentConfirmationTitle: {
	          value: '',
	          type: 'text'
	        },
	        appointmentConfirmationTemplate: {
	          value: '',
	          type: 'textarea'
	        },
	        defaultReminderTitle: {
	          value: '',
	          type: 'text'
	        },
	        defaultReminder: {
	          value: '',
	          type: 'textarea'
	        },
	        defaultCancelMessageTitle: {
	          value: '',
	          type: 'text'
	        },
	        defaultCancelMessage: {
	          value: '',
	          type: 'textarea'
	        },
	        backgroundImage: {
	          value: '',
	          type: 'file'
	        }
	      }),
	      profileUrl: '',
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    publicProfile: 'publicProfile'
	  })),
	
	  watch: {
	    publicProfile: function publicProfile(_publicProfile) {
	      this.form.assignData(_publicProfile);
	      this.updateProfileUrl(_publicProfile);
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.form.setTooltip('defaultReminderTitle', this.$t('form.publicProfile.defaultReminder.tooltip'));
	    this.form.setTooltip('defaultReminder', this.$t('form.publicProfile.defaultReminder.tooltip'));
	    this.form.setTooltip('defaultCancelMessageTitle', this.$t('form.publicProfile.defaultCancelMessage.tooltip'));
	    this.form.setTooltip('defaultCancelMessage', this.$t('form.publicProfile.defaultCancelMessage.tooltip'));
	    this.form.setTooltip('appointmentConfirmationTitle', this.$t('form.publicProfile.appointmentConfirmationTemplate.tooltip'));
	    this.form.setTooltip('appointmentConfirmationTemplate', this.$t('form.publicProfile.appointmentConfirmationTemplate.tooltip'));
	    this.form.assignData(this.publicProfile);
	
	    if (Object.keys(this.publicProfile).length === 0) {
	      this.loading = true;
	      _publicProfile5.default.show().then(function (profile) {
	        _this.updateProfileUrl(profile);
	        _this.loading = false;
	      });
	    } else {
	      this.updateProfileUrl(this.publicProfile);
	    }
	  },
	
	
	  methods: {
	    updateProfileUrl: function updateProfileUrl(profile) {
	      if (profile.profileUrl.length > 0) {
	        this.form.fields.profileUrl = 'hide';
	        this.profileUrl = profile.profileUrl;
	        this.$forceUpdate();
	      }
	    },
	    save: function save() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var publicProfile = _publicProfile3.default.send(this.form.data());
	      _publicProfile5.default.update(publicProfile).then(function () {
	        _this2.form.loading = false;
	        _this2.form.successMessage = _this2.$t('static.publicProfile.updateSucess');
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9),
	    VOpenHours: __webpack_require__(773),
	    VExceptionalHours: __webpack_require__(771)
	  }
	};

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _organizationSettings = __webpack_require__(83);
	
	var _organizationSettings2 = _interopRequireDefault(_organizationSettings);
	
	var _order = __webpack_require__(54);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _organizationSettings3 = __webpack_require__(27);
	
	var _organizationSettings4 = _interopRequireDefault(_organizationSettings3);
	
	var _messageTemplateType = __webpack_require__(1081);
	
	var _messageTemplateType2 = _interopRequireDefault(_messageTemplateType);
	
	var _clientGroup = __webpack_require__(93);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	var _accountingProvider = __webpack_require__(875);
	
	var _accountingProvider2 = _interopRequireDefault(_accountingProvider);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _shippingProvider = __webpack_require__(97);
	
	var _shippingProvider2 = _interopRequireDefault(_shippingProvider);
	
	var _supplier = __webpack_require__(127);
	
	var _supplier2 = _interopRequireDefault(_supplier);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _productType = __webpack_require__(232);
	
	var _productType2 = _interopRequireDefault(_productType);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _priceField = __webpack_require__(95);
	
	var _priceField2 = _interopRequireDefault(_priceField);
	
	var _advance = __webpack_require__(890);
	
	var _advance2 = _interopRequireDefault(_advance);
	
	var _bulkPriceUpdatePopup = __webpack_require__(2679);
	
	var _bulkPriceUpdatePopup2 = _interopRequireDefault(_bulkPriceUpdatePopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      dynamicTags: [],
	      inputVisible: false,
	      inputValue: '',
	      tagsOptions: [],
	      ediBillingProcessOptions: [{
	        id: 'auto',
	        name: this.$t('static.organizationSettings.ediBillingMethod.options.auto')
	      }, {
	        id: 'half-auto',
	        name: this.$t('static.organizationSettings.ediBillingMethod.options.halfAuto')
	      }, {
	        id: 'manual',
	        name: this.$t('static.organizationSettings.ediBillingMethod.options.manuel')
	      }],
	      generalSettingsFormSet1: new _forms2.default({
	        tosAccepted: {
	          value: '',
	          type: 'checkbox'
	        },
	        marketingAllowed: {
	          value: '',
	          type: 'checkbox'
	        },
	        facebookPixelId: {
	          value: '',
	          type: 'text'
	        },
	        defaultClientGroupId: {
	          value: '',
	          type: 'select'
	        },
	        billingNumberDefault: {
	          value: '',
	          type: 'number'
	        },
	        customerNumberDefault: {
	          value: '',
	          type: 'number'
	        },
	        supplierNumberDefault: {
	          value: '',
	          type: 'number'
	        },
	        orderNumberDefault: {
	          value: '',
	          type: 'number'
	        },
	        productNumberInitial: {
	          value: '',
	          type: 'text',
	          maxlength: 3
	        },
	        productNumberDefault: {
	          value: '',
	          type: 'number'
	        },
	        defaultDueDays: {
	          value: '',
	          type: 'number'
	        },
	        penaltyAfter: {
	          value: 14,
	          type: 'number',
	          min: 14
	        },
	        roundInvoiceTotal: {
	          value: '',
	          type: 'checkbox'
	        },
	        ediBillingProcess: {
	          value: '',
	          type: 'select'
	        },
	        defaultProductTypeName: {
	          value: '',
	          type: 'select'
	        },
	
	        defaultWarehouse: {
	          value: '',
	          type: 'select'
	        },
	        priceFields: {
	          value: [],
	          type: 'checkboxGroup'
	        },
	        visiblePriceFields: {
	          value: [],
	          type: 'select',
	          attributes: {
	            multiple: true
	          }
	        },
	        defaultPriceField: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      generalSettingsFormSet2: new _forms2.default({
	        invoiceNotes: {
	          value: '',
	          type: 'textarea'
	        },
	        creditNoteNotes: {
	          value: '',
	          type: 'textarea',
	          required: true
	        },
	        customTos: {
	          value: '',
	          type: 'textarea'
	        },
	        customOrderProductNote: {
	          value: '',
	          type: 'textarea'
	        },
	        billNotes: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      messagesFormSet1: new _forms2.default({
	        invoiceEmailTitle: {
	          value: '',
	          type: 'text'
	        },
	        invoiceEmailTemplate: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      messagesFormSet2: new _forms2.default({
	        creditNoteEmailTitle: {
	          value: '',
	          type: 'text'
	        },
	        creditNoteEmailTemplate: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      messagesFormSet3: new _forms2.default({
	        reminderEmailTitle: {
	          value: '',
	          type: 'text'
	        },
	        reminderEmailTemplate: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      messagesFormSet4: new _forms2.default({
	        orderConfirmNotificationEmailTitle: {
	          value: '',
	          type: 'text'
	        },
	        orderConfirmNotificationEmailTemplate: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      messagesFormSet5: new _forms2.default({
	        orderTrackingEmailTitle: {
	          value: '',
	          type: 'text'
	        },
	        orderTrackingEmailTemplate: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      bookingSettingsSet1: new _forms2.default({
	        timeslotGap: {
	          value: '',
	          type: 'number'
	        },
	        remindersEnabled: {
	          value: '',
	          type: 'checkbox'
	        },
	        messageTemplateTypeId: {
	          value: '',
	          type: 'select'
	        },
	        smsFrom: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      accountingFormSet2: new _forms2.default({
	        paymentIdentitificationGeneration: {
	          value: '',
	          type: 'checkbox'
	        },
	        paymentIdentitificationTemplate: {
	          value: '',
	          type: 'text'
	        },
	        paymentIdentitificationNumberLength: {
	          value: 10,
	          type: 'number'
	        },
	        paymentIdentitificationModulusType: {
	          value: 'Modulus 10',
	          type: 'select'
	        }
	      }),
	      accountingFormSet1: new _forms2.default({
	        accountingProviderId: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      emailInvoiceCopyForm: new _forms2.default({
	        email_invoice_copy: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      advanceFormSet: new _forms2.default({
	        percentage: {
	          value: 3,
	          type: 'number'
	        },
	        enableRounding: {
	          value: '',
	          type: 'checkbox'
	        },
	        roundingType: {
	          value: '',
	          type: 'select'
	        },
	        priceType: {
	          value: '',
	          type: 'select',
	          attributes: {
	            multiple: true
	          }
	        }
	      }),
	      ediNotificationRecipients: [],
	      ediNotifyRecipInputVisible: false,
	      ediNotifyRecipInputValue: '',
	      ediNotifyRecipInvalidValue: '',
	      lowStockNotificationRecipients: [],
	      lowStockNotifyRecipInputVisible: false,
	      lowStockNotifyRecipInvalidValue: '',
	      lowStockNotifyRecipInputValue: '',
	      loading: false,
	      tabIndex: '1',
	      bulkPriceUpdateStatus: 'open',
	      bulkPriceUpdateEntries: []
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    orders: 'allOrders',
	    settings: 'organizationSettings',
	    templateTypes: 'allMessageTemplateTypes',
	    clientGroups: 'allClientGroups',
	    accountingProviders: 'allAccountingProviders',
	    clients: 'clients',
	    suppliers: 'allSuppliers',
	    products: 'allProducts',
	    productTypes: 'allProductTypes',
	    shippingProviders: 'allShippingProviders',
	    warehouses: 'allWarehouses',
	    priceFields: 'allPriceFields'
	  }), {
	    checkProjectModule: function checkProjectModule() {
	      var show = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name === 'Project') {
	            show = true;
	          }
	        }
	      }
	      return show;
	    },
	    isOnlineBooking: function isOnlineBooking() {
	      return this.account.plan === 'Online Booking' || this.account.plan === 'Booking Pro';
	    },
	    isEDI: function isEDI() {
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'EDI') {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    },
	    productInfoDisplay: function productInfoDisplay() {
	      return this.settings.productInfoDisplay;
	    },
	    checkHasInventory: function checkHasInventory() {
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name == 'Inventory') {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    }
	  }),
	
	  watch: {
	    $route: function $route() {
	      this.urlCurrentTab();
	    },
	    tabIndex: function tabIndex(value) {
	      this.assignTab(value);
	    },
	
	
	    'advanceFormSet.enableRounding': function advanceFormSetEnableRounding(value) {
	      if (value === true) {
	        this.advanceFormSet.enableField('roundingType');
	      } else {
	        this.advanceFormSet.disableField('roundingType');
	      }
	    },
	
	    productTypes: function productTypes(_productTypes) {
	      var _this = this;
	
	      if (_productTypes) {
	        this.generalSettingsFormSet1.setOptions('defaultProductTypeName', _productTypes.map(function (type) {
	          return {
	            id: type.name,
	            name: _this.$t('static.products.types.' + _this.camalize(type.name))
	          };
	        }));
	      }
	    },
	    shippingProviders: function shippingProviders(_shippingProviders) {
	      this.generalSettingsFormSet1.setOptions('defaultShippingProvider', _shippingProviders.map(function (item) {
	        return {
	          id: +item.id,
	          name: item.name
	        };
	      }));
	    },
	    warehouses: function warehouses(_warehouses) {
	      this.generalSettingsFormSet1.setOptions('defaultWarehouse', _warehouses.items.map(function (item) {
	        return {
	          id: +item.id,
	          name: item.name
	        };
	      }));
	    },
	    priceFields: function priceFields(_priceFields) {
	      this.generalSettingsFormSet1.setOptions('priceFields', _priceFields.all.map(function (item) {
	        return {
	          id: +item.id,
	          name: item.name
	        };
	      }));
	      this.generalSettingsFormSet1.setOptions('defaultPriceField', _priceFields.all.map(function (item) {
	        return {
	          id: +item.id,
	          name: item.name
	        };
	      }));
	    },
	
	
	    'generalSettingsFormSet1.priceFields': function generalSettingsFormSet1PriceFields(selectedPriceFields) {
	      if (selectedPriceFields) {
	        this.generalSettingsFormSet1.setOptions('defaultPriceField', this.priceFields.all.filter(function (item) {
	          return selectedPriceFields.includes(item.name);
	        }).map(function (item) {
	          return {
	            id: +item.id,
	            name: item.name
	          };
	        }));
	
	        this.visiblePrices();
	        this.priceTypes();
	      }
	    },
	    accountingProviders: function accountingProviders(_accountingProviders) {
	      this.accountingFormSet1.setOptions('accountingProviderId', _accountingProviders);
	    },
	    clientGroups: function clientGroups(_clientGroups) {
	      this.generalSettingsFormSet1.setOptions('defaultClientGroupId', _clientGroups.all);
	    },
	    settings: function settings(_settings) {
	      this.generalSettingsFormSet1.assignData(_settings);
	      this.generalSettingsFormSet1.priceFields = this.priceFields.all.filter(function (item) {
	        return _settings.priceFields.includes(item.id);
	      }).map(function (item) {
	        return item.name;
	      });
	      this.generalSettingsFormSet2.assignData(_settings);
	      this.messagesFormSet1.assignData(_settings);
	      this.messagesFormSet2.assignData(_settings);
	      this.messagesFormSet3.assignData(_settings);
	      this.messagesFormSet4.assignData(_settings);
	      this.messagesFormSet5.assignData(_settings);
	      this.bookingSettingsSet1.assignData(_settings);
	      this.accountingFormSet1.assignData(_settings);
	      this.accountingFormSet2.assignData(_settings);
	      if (_settings.paymentIdentitificationNumberLength) {
	        this.accountingFormSet2.disableField('paymentIdentitificationGeneration');
	        this.accountingFormSet2.disableField('paymentIdentitificationModulusType');
	        this.accountingFormSet2.disableField('paymentIdentitificationNumberLength');
	        this.accountingFormSet2.disableField('paymentIdentitificationTemplate');
	      }
	    },
	    templateTypes: function templateTypes(_templateTypes) {
	      this.generalSettingsFormSet2.setOptions('messageTemplateTypeId', _templateTypes);
	    },
	    inputValue: function inputValue(_inputValue) {
	      this.handleInputConfirm();
	    }
	  },
	
	  mounted: function mounted() {
	    this.disableDefaultsNumbers();
	    this.generalSettingsFormSet1.setExtraAttr('productNumberInitial', {
	      maxlength: 3
	    });
	    this.urlCurrentTab();
	    this.assignTab(this.tabIndex);
	  },
	  created: function created() {
	    var _this2 = this;
	
	    var tags = ['sugar', 'alcohol_percentage', 'bottle_volume', 'producer', 'country', 'vintage', 'productPackagingName', 'sku', 'vmp', 'gtin'];
	    var allTags = this.$i18n.messages[this.$i18n.locale].form.products;
	    this.tagsOptions = Object.keys(allTags).filter(function (key) {
	      return tags.includes(key);
	    }).reduce(function (obj, key) {
	      obj[key] = allTags[key];
	      return obj;
	    }, {});
	
	    if (this.$route.params.tab && this.$route.params.tab === 'email') {
	      this.tabIndex = '2';
	    }
	
	    var requests = [];
	
	    requests.push(_clientGroup2.default.all());
	
	    this.generalSettingsFormSet1.assignData(this.settings);
	    this.generalSettingsFormSet2.assignData(this.settings);
	    this.messagesFormSet1.assignData(this.settings);
	    this.messagesFormSet2.assignData(this.settings);
	    this.messagesFormSet3.assignData(this.settings);
	    this.messagesFormSet4.assignData(this.settings);
	    this.messagesFormSet5.assignData(this.settings);
	    this.bookingSettingsSet1.assignData(this.settings);
	    this.accountingFormSet1.assignData(this.settings);
	    this.accountingFormSet2.assignData(this.settings);
	    this.messagesFormSet1.setTooltip('invoiceEmailTitle', this.$t('form.organizationSettings.invoiceEmailTemplate.tooltip'));
	    this.messagesFormSet1.setTooltip('invoiceEmailTemplate', this.$t('form.organizationSettings.invoiceEmailTemplate.tooltip'));
	    this.messagesFormSet2.setTooltip('creditNoteEmailTitle', this.$t('form.organizationSettings.invoiceEmailTemplate.tooltip'));
	    this.messagesFormSet2.setTooltip('creditNoteEmailTemplate', this.$t('form.organizationSettings.invoiceEmailTemplate.tooltip'));
	    this.messagesFormSet3.setTooltip('reminderEmailTitle', this.$t('form.organizationSettings.reminderEmailTemplate.tooltip'));
	    this.messagesFormSet3.setTooltip('reminderEmailTemplate', this.$t('form.organizationSettings.reminderEmailTemplate.tooltip'));
	    this.messagesFormSet4.setTooltip('orderConfirmNotificationEmailTitle', this.$t('form.organizationSettings.orderConfirmNotificationEmailTemplate.tooltip'));
	    this.messagesFormSet4.setTooltip('orderConfirmNotificationEmailTemplate', this.$t('form.organizationSettings.orderConfirmNotificationEmailTemplate.tooltip'));
	    this.messagesFormSet5.setTooltip('orderTrackingEmailTitle', this.$t('form.organizationSettings.orderTrackingEmailTemplate.tooltip'));
	    this.messagesFormSet5.setTooltip('orderTrackingEmailTemplate', this.$t('form.organizationSettings.orderTrackingEmailTemplate.tooltip'));
	
	    this.generalSettingsFormSet1.hideField('ediBillingProcess');
	
	    this.loading = true;
	    if (Object.keys(this.settings).length === 0) {}
	
	    if (!this.checkHasInventory) {
	      this.generalSettingsFormSet1.hideField('productNumberInitial');
	      this.generalSettingsFormSet1.hideField('productNumberDefault');
	    }
	    requests.push(_productType2.default.all());
	    requests.push(_shippingProvider2.default.all());
	    requests.push(_warehouse2.default.all());
	    requests.push(_priceField2.default.all());
	
	    if (Object.keys(this.templateTypes).length === 0) {
	      requests.push(_messageTemplateType2.default.all());
	    } else {
	      this.bookingSettingsSet1.setOptions('messageTemplateTypeId', this.templateTypes);
	    }
	
	    if (Object.keys(this.accountingProviders).length === 0) {
	      requests.push(_accountingProvider2.default.all());
	    } else {
	      this.accountingFormSet1.setOptions('accountingProviderId', this.accountingProviders);
	    }
	
	    Promise.all([_order2.default.counts(), _client2.default.counts(), _supplier2.default.counts(), _product2.default.counts()]).then(function (data) {
	      if (data[0].count === 0) {
	        _this2.enableDefaultsNumbers();
	      }
	
	      if (data[1].count > 0) {
	        _this2.generalSettingsFormSet1.disableField('customerNumberDefault');
	      }
	
	      if (data[2].count === 0) {
	        _this2.generalSettingsFormSet1.enableField('supplierNumberDefault');
	      }
	
	      if (data[3].count === 0) {
	        _this2.generalSettingsFormSet1.enableField('productNumberDefault');
	        _this2.generalSettingsFormSet1.enableField('productNumberInitial');
	      }
	    });
	    Promise.all([_organizationSettings4.default.show()]).then(function (data) {
	      _this2.setTags(data[0].productInfoDisplay);
	      _this2.generalSettingsFormSet1.priceFields = _this2.priceFields.all.filter(function (item) {
	        return _this2.settings.priceFields.includes(item.id);
	      }).map(function (item) {
	        return item.name;
	      });
	      _this2.visiblePrices();
	      _this2.priceTypes();
	      _this2.bulkPriceUpdateStatus = _this2.settings.bulkPriceUpdateStatus;
	      _this2.bulkPriceUpdateStatusChange(_this2.bulkPriceUpdateStatus);
	      _this2.bulkPriceUpdateEntries = _this2.settings.bulkPriceUpdateEntries;
	      console.log(_this2.bulkPriceUpdateEntries);
	    });
	
	    Promise.all(requests).then(function () {
	      _this2.loading = false;
	    });
	
	    this.advanceFormSet.disableField('roundingType');
	    this.generalSettingsFormSet1.setExtraAttr('penaltyAfter', { min: 14 });
	    this.penaltyTypes();
	    this.roundingTypes();
	    this.showEmailInvoiceCopy();
	    this.showEdiNotifyRecip();
	    this.showLowStockNotifyRecip();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalClass: 'SET_MODAL_CLASS',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), {
	    getPriceTypes: function getPriceTypes(priceTypes) {
	      var priceList = Object.values(priceTypes);
	      var formattedPriceList = priceList.map(this.camelCaseToReadable);
	      var wrappedPriceList = formattedPriceList.map(function (item) {
	        return '\xAB' + item + '\xBB';
	      });
	      return wrappedPriceList.join('<br>');
	    },
	    camelCaseToReadable: function camelCaseToReadable(str) {
	      return str.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase();
	    },
	    penaltyTypes: function penaltyTypes() {
	      var options = [{ id: 'none', name: 'None' }, { id: 'penalty_fee', name: 'Penalty Fee' }, { id: 'default_interest', name: 'Default Interest' }];
	      this.generalSettingsFormSet1.setOptions('penaltyTypeForDueInvoice', options);
	    },
	    roundingTypes: function roundingTypes() {
	      var options = [{ id: 'nearest-1', name: this.$t('form.organizationSettings.roundingType.options.nearest_1') }, { id: 'nearest-0.50', name: this.$t('form.organizationSettings.roundingType.options.nearest_0_50') }, { id: 'nearest-0.25', name: this.$t('form.organizationSettings.roundingType.options.nearest_0_25') }, { id: 'nearest-0.99', name: this.$t('form.organizationSettings.roundingType.options.nearest_0_99') }, { id: 'round-half-up', name: this.$t('form.organizationSettings.roundingType.options.round_half_up') }, { id: 'round-half-down', name: this.$t('form.organizationSettings.roundingType.options.round_half_down') }, { id: 'round-half-even', name: this.$t('form.organizationSettings.roundingType.options.round_half_even') }, { id: 'round-towards-zero', name: this.$t('form.organizationSettings.roundingType.options.round_towards_zero') }, { id: 'round-away-from-zero', name: this.$t('form.organizationSettings.roundingType.options.round_away_from_zero') }];
	      this.advanceFormSet.setOptions('roundingType', options);
	      this.advanceFormSet.setFieldValue('roundingType', 'nearest-1');
	    },
	    priceTypes: function priceTypes() {
	      var _this3 = this;
	
	      var options = this.priceFields.all.filter(function (item) {
	        return _this3.settings.priceFields.includes(item.id);
	      }).map(function (item) {
	        return {
	          id: +item.id,
	          name: item.name
	        };
	      });
	      this.advanceFormSet.setOptions('priceType', options);
	    },
	    bulkPriceUpdateStatusChange: function bulkPriceUpdateStatusChange(status) {
	      if (status === 'running' || status === 'failed') {
	        this.advanceFormSet.disableField('percentage');
	        this.advanceFormSet.disableField('enableRounding');
	        this.advanceFormSet.disableField('roundingType');
	        this.advanceFormSet.disableField('priceType');
	      }
	    },
	    onBulkPriceUpdate: function onBulkPriceUpdate() {
	      var _this4 = this;
	
	      return _advance2.default.bulkPriceUpdate(this.advanceFormSet.data()).then(function (res) {
	        _this4.bulkPriceUpdateStatus = res.data.status;
	        _this4.bulkPriceUpdateStatusChange(_this4.bulkPriceUpdateStatus);
	      }).catch(function () {});
	    },
	    bulkPriceUpdateModal: function bulkPriceUpdateModal() {
	      var priceType = this.advanceFormSet.data().priceType;
	      var selectedPriceType = this.priceFields.all.filter(function (obj) {
	        return priceType.includes(String(obj.id));
	      }).map(function (obj) {
	        return obj.name;
	      });
	
	      this.setModalContent(function () {
	        return _bulkPriceUpdatePopup2.default;
	      });
	      this.setModalProps({
	        info: {
	          percentage: this.advanceFormSet.data().percentage,
	          enableRounding: this.advanceFormSet.data().enableRounding,
	          roundingType: this.advanceFormSet.data().roundingType,
	          priceType: selectedPriceType
	        },
	        onSubmit: this.onBulkPriceUpdate
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(true);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    visiblePrices: function visiblePrices() {
	      var _this5 = this;
	
	      var priceFieldsList = this.priceFields.all.filter(function (item) {
	        return _this5.settings.priceFields.includes(item.id);
	      }).map(function (item) {
	        return {
	          id: +item.id,
	          name: item.name
	        };
	      });
	      this.generalSettingsFormSet1.setOptions('visiblePriceFields', priceFieldsList);
	    },
	    assignTab: function assignTab(value) {
	      var tab = '';
	      if (value === '7') {
	        tab = '#advance';
	      } else if (value === '6' && this.checkProjectModule === true) {
	        tab = '#projects';
	      } else if (value === '5') {
	        tab = '#shippingProviders';
	      } else if (value === '4') {
	        tab = '#accounting';
	      } else if (value === '3') {
	        tab = '#booking';
	      } else if (value === '2') {
	        tab = '#email';
	      } else {
	        tab = '#general';
	      }
	      history.pushState({}, null, '/#' + this.$route.path + tab);
	    },
	    urlCurrentTab: function urlCurrentTab() {
	      if (this.$router.currentRoute.hash === '#advance') {
	        this.tabIndex = '7';
	      } else if (this.$router.currentRoute.hash === '#projects' && this.checkProjectModule === true) {
	        this.tabIndex = '6';
	      } else if (this.$router.currentRoute.hash === '#shippingProviders') {
	        this.tabIndex = '5';
	      } else if (this.$router.currentRoute.hash === '#accounting') {
	        this.tabIndex = '4';
	      } else if (this.$router.currentRoute.hash === '#booking') {
	        this.tabIndex = '3';
	      } else if (this.$router.currentRoute.hash === '#email') {
	        this.tabIndex = '2';
	      } else {
	        this.tabIndex = '1';
	      }
	    },
	    ediNotifyRecipHandleClose: function ediNotifyRecipHandleClose(email) {
	      var _this6 = this;
	
	      Promise.all([_organizationSettings4.default.ediNotificationRecipients('destroy', { email: email })]).then(function (data) {
	        _this6.ediNotificationRecipients = data[0];
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    ediNotifyRecipShowInput: function ediNotifyRecipShowInput() {
	      var _this7 = this;
	
	      this.ediNotifyRecipInputVisible = true;
	      this.$nextTick(function (_) {
	        _this7.$refs.saveEmailInput.$refs.input.focus();
	      });
	    },
	    ediNotifyRecipHandleInputConfirm: function ediNotifyRecipHandleInputConfirm() {
	      var _this8 = this;
	
	      this.ediNotifyRecipInvalidValue = '';
	      var inputValue = this.ediNotifyRecipInputValue;
	      if (inputValue) {
	        Promise.all([_organizationSettings4.default.ediNotificationRecipients('create', { email: inputValue })]).then(function (data) {
	          _this8.ediNotificationRecipients = data[0];
	          _this8.ediNotifyRecipInputVisible = false;
	          _this8.ediNotifyRecipInputValue = '';
	        }).catch(function (error) {
	          _this8.ediNotifyRecipInvalidValue = error.email[0];
	          console.log(error);
	        });
	      }
	    },
	    showEdiNotifyRecip: function showEdiNotifyRecip() {
	      var _this9 = this;
	
	      Promise.all([_organizationSettings4.default.ediNotificationRecipients('show', {})]).then(function (data) {
	        _this9.ediNotificationRecipients = data[0];
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    lowStockNotifyRecipHandleClose: function lowStockNotifyRecipHandleClose(email) {
	      var _this10 = this;
	
	      Promise.all([_organizationSettings4.default.lowStockNotificationRecipients('destroy', { email: email })]).then(function (data) {
	        _this10.lowStockNotificationRecipients = data[0];
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    lowStockNotifyRecipShowInput: function lowStockNotifyRecipShowInput() {
	      var _this11 = this;
	
	      this.lowStockNotifyRecipInputVisible = true;
	      this.$nextTick(function (_) {
	        _this11.$refs.saveEmailInputLowStock.$refs.input.focus();
	      });
	    },
	    lowStockNotifyRecipHandleInputConfirm: function lowStockNotifyRecipHandleInputConfirm() {
	      var _this12 = this;
	
	      this.lowStockNotifyRecipInvalidValue = '';
	      var inputValue = this.lowStockNotifyRecipInputValue;
	      if (inputValue) {
	        Promise.all([_organizationSettings4.default.lowStockNotificationRecipients('create', { email: inputValue })]).then(function (data) {
	          _this12.lowStockNotificationRecipients = data[0];
	          _this12.lowStockNotifyRecipInputVisible = false;
	          _this12.lowStockNotifyRecipInputValue = '';
	        }).catch(function (error) {
	          _this12.lowStockNotifyRecipInvalidValue = error.email[0];
	          console.log(error);
	        });
	      }
	    },
	    showLowStockNotifyRecip: function showLowStockNotifyRecip() {
	      var _this13 = this;
	
	      Promise.all([_organizationSettings4.default.lowStockNotificationRecipients('show', {})]).then(function (data) {
	        _this13.lowStockNotificationRecipients = data[0];
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    saveEmailInvoiceCopy: function saveEmailInvoiceCopy() {
	      var _this14 = this;
	
	      this.emailInvoiceCopyForm.loading = true;
	      var data = this.emailInvoiceCopyForm.data();
	      return new Promise(function (resolve, reject) {
	        _organizationSettings4.default.emailInvoiceCopy('createOrUpdate', { email_invoice_copy: data.email_invoice_copy }).then(function (data) {
	          _this14.emailInvoiceCopyForm.loading = false;
	          resolve();
	        }).catch(function (errors) {
	          _this14.emailInvoiceCopyForm.recordErrors(errors);
	          _this14.emailInvoiceCopyForm.loading = false;
	          reject();
	        });
	      });
	    },
	    showEmailInvoiceCopy: function showEmailInvoiceCopy() {
	      var _this15 = this;
	
	      return new Promise(function (resolve, reject) {
	        _organizationSettings4.default.emailInvoiceCopy('display', {}).then(function (data) {
	          _this15.emailInvoiceCopyForm.setFieldValue('email_invoice_copy', data.data[0]);
	          resolve();
	        }).catch(function (error) {
	          reject();
	        });
	      });
	    },
	    handleClose: function handleClose(tag) {
	      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
	    },
	    setTags: function setTags(tag) {
	      for (var i = tag.length - 1; i >= 0; i--) {
	        this.dynamicTags.push(tag[i]);
	      }
	    },
	    showInput: function showInput() {
	      this.inputVisible = true;
	    },
	    handleInputConfirm: function handleInputConfirm() {
	      var inputValue = this.inputValue;
	      if (inputValue && !this.dynamicTags.includes(inputValue)) {
	        this.dynamicTags.push(inputValue);
	      }
	      this.inputVisible = false;
	      this.inputValue = '';
	    },
	    enableDefaultsNumbers: function enableDefaultsNumbers() {
	      this.generalSettingsFormSet1.enableField('billingNumberDefault');
	      this.generalSettingsFormSet1.enableField('customerNumberDefault');
	      this.generalSettingsFormSet1.enableField('orderNumberDefault');
	    },
	    disableDefaultsNumbers: function disableDefaultsNumbers() {
	      this.generalSettingsFormSet1.disableField('billingNumberDefault');
	      this.generalSettingsFormSet1.disableField('customerNumberDefault');
	      this.generalSettingsFormSet1.disableField('supplierNumberDefault');
	      this.generalSettingsFormSet1.disableField('orderNumberDefault');
	      this.generalSettingsFormSet1.disableField('productNumberDefault');
	      this.generalSettingsFormSet1.disableField('productNumberInitial');
	      this.generalSettingsFormSet1.setTooltip('billingNumberDefault', this.$t('static.organizationSettings.disabledFieldTooltips'));
	      this.generalSettingsFormSet1.setTooltip('customerNumberDefault', this.$t('static.organizationSettings.disabledFieldTooltips'));
	      this.generalSettingsFormSet1.setTooltip('orderNumberDefault', this.$t('static.organizationSettings.disabledFieldTooltips'));
	      this.generalSettingsFormSet1.setTooltip('productNumberDefault', this.$t('static.organizationSettings.disabledProductFieldTooltips'));
	      this.generalSettingsFormSet1.setTooltip('productNumberInitial', this.$t('static.organizationSettings.disabledProductFieldTooltips'));
	    },
	    save: function save() {
	      var _this16 = this;
	
	      this.generalSettingsFormSet1.loading = true;
	      this.generalSettingsFormSet2.loading = true;
	      var generalSettingsFormSet1Data = this.generalSettingsFormSet1.data();
	      generalSettingsFormSet1Data.priceFields = this.priceFields.all.filter(function (item) {
	        return generalSettingsFormSet1Data.priceFields.includes(item.name);
	      }).map(function (item) {
	        return item.id;
	      });
	      var organizationSettings = _organizationSettings2.default.send(Object.assign({
	        productInfoDisplay: this.dynamicTags
	      }, generalSettingsFormSet1Data, this.generalSettingsFormSet2.data()));
	      _organizationSettings4.default.update(organizationSettings).then(function () {
	        _this16.generalSettingsFormSet1.loading = false;
	        _this16.generalSettingsFormSet2.loading = false;
	        _this16.generalSettingsFormSet1.successMessage = _this16.$t('static.organizationSettings.settingsSaveSuccess');
	      }).catch(function (errors) {
	        _this16.generalSettingsFormSet1.loading = false;
	        _this16.generalSettingsFormSet2.loading = false;
	        _this16.generalSettingsFormSet1.recordErrors(errors);
	        _this16.generalSettingsFormSet2.recordErrors(errors);
	      });
	    },
	    saveMessages: function saveMessages() {
	      var _this17 = this;
	
	      this.messagesFormSet1.loading = true;
	      this.messagesFormSet2.loading = true;
	      this.messagesFormSet3.loading = true;
	      this.messagesFormSet4.loading = true;
	      this.messagesFormSet5.loading = true;
	      var organizationSettings = _organizationSettings2.default.send(Object.assign({}, this.messagesFormSet1.data(), this.messagesFormSet2.data(), this.messagesFormSet3.data(), this.messagesFormSet4.data(), this.messagesFormSet5.data()));
	      _organizationSettings4.default.updateMessages(organizationSettings).then(function () {
	        _this17.messagesFormSet1.loading = false;
	        _this17.messagesFormSet2.loading = false;
	        _this17.messagesFormSet3.loading = false;
	        _this17.messagesFormSet4.loading = false;
	        _this17.messagesFormSet5.loading = false;
	        _this17.messagesFormSet5.successMessage = _this17.$t('static.organizationSettings.settingsSaveSuccess');
	      }).catch(function (errors) {
	        _this17.messagesFormSet1.loading = false;
	        _this17.messagesFormSet2.loading = false;
	        _this17.messagesFormSet3.loading = false;
	        _this17.messagesFormSet4.loading = false;
	        _this17.messagesFormSet5.loading = false;
	        _this17.messagesFormSet1.recordErrors(errors);
	        _this17.messagesFormSet2.recordErrors(errors);
	        _this17.messagesFormSet3.recordErrors(errors);
	        _this17.messagesFormSet4.recordErrors(errors);
	        _this17.messagesFormSet5.recordErrors(errors);
	      });
	    },
	    saveBooking: function saveBooking() {
	      var _this18 = this;
	
	      this.bookingSettingsSet1.loading = true;
	      var organizationSettings = _organizationSettings2.default.send(Object.assign({}, this.bookingSettingsSet1.data()));
	      _organizationSettings4.default.updateBooking(organizationSettings).then(function () {
	        _this18.bookingSettingsSet1.loading = false;
	        _this18.bookingSettingsSet1.successMessage = _this18.$t('static.organizationSettings.settingsSaveSuccess');
	      }).catch(function (errors) {
	        _this18.bookingSettingsSet1.loading = false;
	        _this18.bookingSettingsSet1.recordErrors(errors);
	      });
	    },
	    saveAccounting: function saveAccounting() {
	      var _this19 = this;
	
	      this.accountingFormSet1.loading = true;
	      var organizationSettings = _organizationSettings2.default.send(Object.assign({}, this.accountingFormSet1.data()));
	      _organizationSettings4.default.updateAccounting(organizationSettings).then(function () {
	        _this19.accountingFormSet1.loading = false;
	        _this19.accountingFormSet1.successMessage = _this19.$t('static.organizationSettings.settingsSaveSuccess');
	      }).catch(function (errors) {
	        _this19.accountingFormSet1.loading = false;
	        _this19.accountingFormSet1.recordErrors(errors);
	      });
	    },
	    saveBilling: function saveBilling() {
	      var _this20 = this;
	
	      this.accountingFormSet2.loading = true;
	      var organizationSettings = _organizationSettings2.default.send(Object.assign({}, this.accountingFormSet2.data()));
	      _organizationSettings4.default.updateBilling(organizationSettings).then(function () {
	        _this20.accountingFormSet2.loading = false;
	        _this20.accountingFormSet2.successMessage = _this20.$t('static.organizationSettings.settingsSaveSuccess');
	      }).catch(function (errors) {
	        _this20.accountingFormSet2.loading = false;
	        _this20.accountingFormSet2.recordErrors(errors);
	      });
	    },
	    showTagOptions: function showTagOptions(tag) {
	      return '{' + tag + '} , ';
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9),
	    ShippingProviderTable: __webpack_require__(2737),
	    ChartOfAccounts: __webpack_require__(2687),
	    ProjectTable: __webpack_require__(2733)
	  }
	};

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _purchase = __webpack_require__(161);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _purchaseStatus = __webpack_require__(476);
	
	var _purchaseStatus2 = _interopRequireDefault(_purchaseStatus);
	
	var _purchase3 = __webpack_require__(58);
	
	var _purchase4 = _interopRequireDefault(_purchase3);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        purchaseNumber: {
	          value: '',
	          type: 'text'
	        },
	        comments: {
	          value: '',
	          type: 'text'
	        },
	        warehouseId: {
	          value: '',
	          type: 'select'
	        },
	        supplierId: {
	          value: '',
	          type: 'select'
	        },
	        expectedDeliveryDate: {
	          value: '',
	          type: 'date'
	        }
	      }),
	      loading: true,
	      tabIndex: 'first',
	      fields: {
	        productId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        batchId: {
	          value: '',
	          type: 'select'
	        },
	        qty: {
	          value: '0',
	          type: 'text'
	        },
	        purchasePrice: {
	          value: '0',
	          type: 'text'
	        },
	        costPrice: {
	          value: '0',
	          type: 'text'
	        }
	      }
	
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentStockProducts: 'currentStockProductsCustom',
	    warehouses: 'allWarehouses',
	    status: 'purchaseStatuses',
	    suppliers: 'allClientOptions'
	  }), {
	    additionalData: function additionalData() {
	      var Obj = Object.create({});
	      Obj.warehouseId = this.formBasicInformation.warehouseId;
	      return Obj;
	    }
	  }),
	
	  watch: {
	    $route: function $route() {
	      this.warehouseTarget();
	    },
	    suppliers: function suppliers(_suppliers) {
	      this.formBasicInformation.setOptions('supplierId', _suppliers.map(function (c) {
	        return { id: c.id, name: c.companyName || c.firstName + ' ' + c.lastName };
	      }));
	    },
	    warehouses: function warehouses(_warehouses) {
	      var data = _warehouses.items.filter(function (item) {
	        return !item.isSharedToYou;
	      });
	      this.formBasicInformation.setOptions('warehouseId', data);
	    },
	    status: function status(_status) {
	      this.formBasicInformation.setOptions('status', _status);
	    },
	
	    'formBasicInformation.warehouseId': function formBasicInformationWarehouseId(warehouseId) {
	      _store2.default.dispatch('setStockSelectedWarehouse', warehouseId);
	    },
	    currentStockProducts: {
	      handler: function handler(value, oldValue) {
	        if (oldValue.length > 0 && value.length > 0) {
	          var pruchaseProducts = _purchase4.default.send(Object.assign({}, this.formBasicInformation.data(), { products: value }));
	          _purchase2.default.unfinished(pruchaseProducts).then(function () {}).catch(function () {});
	        }
	      },
	
	      deep: true
	    }
	  },
	
	  created: function created() {
	    this.loading = false;
	  },
	
	
	  methods: {
	    destroy: function destroy() {
	      var _this = this;
	
	      _purchase2.default.destroyUnfinished().then(function () {
	        _this.$router.push({ name: 'inventory.transaction.index' });
	      }).catch(function () {});
	    },
	    warehouseTarget: function warehouseTarget() {
	      var warehouseIds = this.warehouses.items.map(function (item) {
	        return item.id;
	      });
	      var targeId = this.$router.currentRoute.hash.substring(1);
	      if (warehouseIds.indexOf(parseInt(targeId)) !== -1) {
	        this.formBasicInformation.setFieldValue('warehouseId', targeId);
	      }
	    },
	    store: function store() {
	      var _this2 = this;
	
	      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'progress';
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _purchase4.default.send(Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts }));
	      client.status = status;
	      _purchase2.default.store(client).then(function () {
	        _this2.$message({
	          message: _this2.$t('static.purchase.create.success'),
	          type: 'success'
	        });
	        _this2.$router.push({
	          name: 'inventory.purchase.index'
	        });
	      }).catch(function (errors) {
	        _this2.formBasicInformation.loading = false;
	        _this2.formBasicInformation.recordErrors(errors);
	        var message = errors.message;
	        if (errors.message) {
	          _this2.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    searchMethod: function searchMethod(search, field) {
	      return Promise.all([_product2.default.searchAll({ search: search })]);
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    _store2.default.dispatch('allCurrentStockProductsCustom', []);
	    _store2.default.dispatch('setStockSelectedWarehouse', 0);
	    Promise.all([_warehouse2.default.all(), _purchaseStatus2.default.all(), _purchase2.default.showUnfinished(), _client2.default.allOptions('&filter=supplier')]).then(function (data) {
	      var pur = data[2];
	      _this3.currentPurchase = pur;
	      _this3.formBasicInformation.assignData(pur);
	      _this3.warehouseTarget();
	    });
	  },
	
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13),
	    VProductsTable: __webpack_require__(123)
	  }
	};

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _vuex = __webpack_require__(5);
	
	var _purchase = __webpack_require__(161);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _purchaseStatus = __webpack_require__(476);
	
	var _purchaseStatus2 = _interopRequireDefault(_purchaseStatus);
	
	var _purchase3 = __webpack_require__(58);
	
	var _purchase4 = _interopRequireDefault(_purchase3);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _previewMessage = __webpack_require__(418);
	
	var _previewMessage2 = _interopRequireDefault(_previewMessage);
	
	var _purchaseRecieve = __webpack_require__(2734);
	
	var _purchaseRecieve2 = _interopRequireDefault(_purchaseRecieve);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        purchaseNumber: {
	          value: '',
	          type: 'text'
	        },
	        comments: {
	          value: '',
	          type: 'text'
	        },
	        warehouseId: {
	          value: '',
	          type: 'select'
	        },
	        supplierId: {
	          value: '',
	          type: 'select'
	        },
	        expectedDeliveryDate: {
	          value: '',
	          type: 'date'
	        }
	      }),
	      loading: true,
	      tabIndex: 'first',
	      fields: {
	        productId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        batchId: {
	          value: '',
	          type: 'select'
	        },
	        qty: {
	          value: '0',
	          type: 'text'
	        },
	        purchasePrice: {
	          value: '0',
	          type: 'text'
	        },
	        costPrice: {
	          value: '0',
	          type: 'text'
	        }
	      },
	      currentPurchase: {
	        purchaseStatus: {
	          name: ''
	        }
	      },
	      hashId: '',
	      dropdownState: false,
	      dropdownState2: false,
	      userLang: 'no',
	      server: {
	        url: ''
	      }
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentStockProducts: 'currentStockProductsCustom',
	    warehouses: 'allWarehouses',
	    suppliers: 'allClientOptions',
	    status: 'purchaseStatuses'
	  }), {
	    purchaseTitle: function purchaseTitle() {
	      if (this.currentPurchase.purchaseStatus.name === 'pending') {
	        return 'pending_external';
	      }
	      return this.currentPurchase.purchaseStatus.name.replace(/ /g, '_');
	    },
	    showDraft: function showDraft() {
	      return this.currentPurchase.purchaseStatus.name === 'draft';
	    },
	    showCancelPurchase: function showCancelPurchase() {
	      return this.currentPurchase.purchaseStatus.name === 'progress' || this.currentPurchase.purchaseStatus.name === 'draft';
	    },
	    showSave: function showSave() {
	      return this.currentPurchase.purchaseStatus.name !== 'pending' && this.currentPurchase.purchaseStatus.name !== 'pending external' && this.currentPurchase.purchaseStatus.name !== 'progress' && this.currentPurchase.purchaseStatus.name !== 'done';
	    },
	    showComplete: function showComplete() {
	      return this.currentPurchase.purchaseStatus.name !== 'pending' && this.currentPurchase.purchaseStatus.name !== 'pending external' && this.currentPurchase.purchaseStatus.name !== 'done' && this.currentPurchase.purchaseStatus.name !== 'draft' && this.currentPurchase.purchaseStatus.name !== '';
	    },
	    isDisableForm: function isDisableForm() {
	      return this.currentPurchase.purchaseStatus.name === 'pending external' || this.currentPurchase.purchaseStatus.name === 'done';
	    },
	    isSharedToYou: function isSharedToYou() {
	      var _this = this;
	
	      var data = this.warehouses.items.filter(function (item) {
	        return item.id === _this.formBasicInformation.warehouseId;
	      });
	      if (data.length > 0) {
	        return data[0].isSharedToYou;
	      }
	      return false;
	    }
	  }),
	
	  watch: {
	    warehouses: function warehouses(_warehouses) {
	      this.formBasicInformation.setOptions('warehouseId', _warehouses.items);
	    },
	    status: function status(_status) {
	      this.formBasicInformation.setOptions('status', _status);
	    },
	
	
	    'formBasicInformation.warehouseId': function formBasicInformationWarehouseId(warehouseId) {
	      _store2.default.dispatch('setStockSelectedWarehouse', warehouseId);
	    },
	
	    suppliers: function suppliers(_suppliers) {
	      this.formBasicInformation.setOptions('supplierId', _suppliers.map(function (c) {
	        return { id: c.id, name: c.companyName || c.firstName + ' ' + c.lastName };
	      }));
	    }
	  },
	
	  created: function created() {
	    var self = this;
	    window.addEventListener('click', function (e) {
	      if (_helpers2.default.closeDropdown(e, self.dropdownState) === false) self.dropdownState = false;
	      if (_helpers2.default.closeDropdown(e, self.dropdownState2) === false) self.dropdownState2 = false;
	    });
	
	    this.loading = false;
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalButtonLoading: 'SET_MODAL_BUTTON_LOADING'
	  }), {
	    updateDraft: function updateDraft() {
	      this.store('draft');
	    },
	    update: function update() {
	      this.store('pending');
	    },
	    cancelPurchase: function cancelPurchase() {
	      var _this2 = this;
	
	      _purchase2.default.markAsCancel(this.$route.params.id).then(function () {
	        _this2.$message({
	          message: _this2.$t('static.purchase.cancel.success'),
	          type: 'success'
	        });
	        _this2.$router.push({
	          name: 'inventory.purchase.index'
	        });
	      });
	    },
	    searchMethod: function searchMethod(search, field) {
	      return Promise.all([_product2.default.searchAll({ search: search })]);
	    },
	    activateModal: function activateModal() {
	      this.setModalContent(function () {
	        return _purchaseRecieve2.default;
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    store: function store() {
	      var _this3 = this;
	
	      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'progress';
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _purchase4.default.send(Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts }));
	      var request = null;
	      if (status === 'draft') {
	        request = _purchase2.default.updateDraft(this.$route.params.id, client);
	      } else if (status === 'pending' || status === 'progress') {
	        client.status = status;
	        request = _purchase2.default.update(this.$route.params.id, client);
	      } else {
	        request = _purchase2.default.store({ purchaseId: this.$route.params.id });
	      }
	      request.then(function () {
	        _this3.$message({
	          message: _this3.$t('static.purchase.update.success'),
	          type: 'success'
	        });
	        _this3.$router.push({
	          name: 'inventory.purchase.index'
	        });
	      }).catch(function (errors) {
	        _this3.formBasicInformation.loading = false;
	        _this3.formBasicInformation.recordErrors(errors);
	        var message = errors.message;
	        if (errors.message) {
	          _this3.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    markAsDone: function markAsDone() {
	      this.activateModal();
	    },
	    previewSendDocument: function previewSendDocument() {
	      var _this4 = this;
	
	      var tempContact = [];
	      var warehouseContact = this.currentPurchase && this.currentPurchase.warehouse && this.currentPurchase.warehouse.contact ? this.currentPurchase.warehouse.contact : null;
	
	      if (warehouseContact && typeof warehouseContact.email !== 'undefined' && warehouseContact.email !== '') {
	        tempContact.push({
	          id: 0,
	          email: warehouseContact.email,
	          first_name: warehouseContact.firstName || '',
	          last_name: warehouseContact.lastName || '',
	          contact_types: [{ name: 'Primary' }]
	        });
	      }
	
	      var supplierContact = this.currentPurchase && this.currentPurchase.supplier && this.currentPurchase.supplier.contact ? this.currentPurchase.supplier.contact : null;
	
	      if (supplierContact && typeof supplierContact.email !== 'undefined' && supplierContact.email !== '') {
	        var supplierName = this.currentPurchase && this.currentPurchase.supplier && this.currentPurchase.supplier.name ? this.currentPurchase.supplier.name : '';
	        tempContact.push({
	          id: 1,
	          email: supplierContact.email,
	          first_name: supplierName,
	          last_name: '',
	          contact_types: [{ name: 'Primary' }]
	        });
	      }
	
	      _purchase2.default.showPurchaseEmailInformation(this.$route.params.id).then(function (purchaseEmailInformation) {
	        _this4.setModalContent(function () {
	          return _previewMessage2.default;
	        });
	        _this4.setModalSize('full');
	        _this4.setModalProps({
	          isEmailInput: true,
	          isMultiSelected: true,
	          contacts: tempContact.length > 0 ? tempContact : null,
	          message: purchaseEmailInformation.message,
	          subject: purchaseEmailInformation.title,
	
	          notes: '',
	          ccEmail: [purchaseEmailInformation.userEmail],
	
	          headerTexts: [_this4.$t('static.bills.edit.from') + ': ' + purchaseEmailInformation.fromName + ' <' + purchaseEmailInformation.fromEmail + '>'],
	          attachments: [{
	            attachmentName: purchaseEmailInformation.attachmentName,
	            action: _this4.showPurchase
	          }],
	          buttons: [{
	            name: _this4.$t('button.cancel'),
	            action: _this4.cancelModal,
	            title: _this4.$t('button.cancel')
	          }, {
	            name: _this4.isPending ? _this4.$t('button.send') : _this4.$t('button.resend'),
	            action: _this4.sendPurchase,
	            title: _this4.isPending ? _this4.$t('button.send') : _this4.$t('button.resend')
	          }]
	        });
	        _this4.toggleModal(true);
	      }).catch(function () {});
	    },
	    sendPurchase: function sendPurchase(ev) {
	      var _this5 = this;
	
	      var test = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      this.sendLoading = true;
	      this.setModalButtonLoading(true);
	      _purchase2.default.send(_store2.default.state.route.params.id, {
	        email_to: _store2.default.state.modal.modalProps.email_to,
	        email_cc: _store2.default.state.modal.modalProps.email_cc,
	        message: _store2.default.state.modal.modalProps.message,
	        subject: _store2.default.state.modal.modalProps.subject,
	
	        notes: _store2.default.state.modal.modalProps.notes,
	        test: test
	      }).then(function () {
	        _this5.toggleModal(false);
	        _this5.sendLoading = false;
	        _this5.setModalButtonLoading(false);
	        _purchase2.default.show(_store2.default.state.route.params.id);
	        _this5.$message({
	          showClose: true,
	          message: _this5.$t('static.purchase.edit.sendPurchaseSuccess'),
	          type: 'success'
	        });
	      }).catch(function () {
	        _this5.toggleModal(false);
	        _this5.sendLoading = false;
	        _this5.setModalButtonLoading(false);
	        _this5.$message({
	          showClose: true,
	          message: _this5.$t('static.purchase.edit.sendPurchaseError'),
	          type: 'error'
	        });
	      });
	    },
	    toggleDropdown: function toggleDropdown() {
	      this.dropdownState = !this.dropdownState;
	      if (this.dropdownState) {
	        this.dropdownState2 = false;
	      }
	    },
	    toggleDropdown2: function toggleDropdown2() {
	      this.dropdownState2 = !this.dropdownState2;
	      if (this.dropdownState2) {
	        this.dropdownState = false;
	      }
	    },
	    sendTestPurchase: function sendTestPurchase(ev) {
	      this.sendPurchase(ev, true);
	    },
	    showPurchase: function showPurchase() {
	      _purchase2.default.showPdf(this.hashId, this.userLang);
	    },
	    downloadPurchase: function downloadPurchase() {
	      _purchase2.default.download(this.hashId, this.userLang);
	    },
	    cancelModal: function cancelModal() {
	      this.toggleModal(false);
	    },
	    isPending: function isPending() {
	      return this.currentPurchase.purchaseStatus === 'Pending';
	    },
	    markAsDraft: function markAsDraft() {
	      var _this6 = this;
	
	      this.loading = false;
	
	      var client = _purchase4.default.send(Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts }));
	      _purchase2.default.saveAsDraft(this.$route.params.id, client).then(function () {
	        _this6.$message({
	          message: _this6.$t('static.purchase.update.success'),
	          type: 'success'
	        });
	        _this6.$router.push({
	          name: 'inventory.purchase.index'
	        });
	      }).catch(function (errors) {
	        _this6.formBasicInformation.loading = false;
	        _this6.formBasicInformation.recordErrors(errors);
	        var message = errors.message;
	        if (errors.message) {
	          _this6.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    }
	  }),
	  mounted: function mounted() {
	    var _this7 = this;
	
	    _store2.default.dispatch('allCurrentStockProductsCustom', []);
	    Promise.all([_purchase2.default.show(this.$route.params.id), _warehouse2.default.all(), _purchaseStatus2.default.all(), _client2.default.allOptions('&filter=supplier')]).then(function (data) {
	      _this7.hashId = data[0].hashId;
	      _this7.userLang = data[0].userLang;
	      _this7.currentPurchase = data[0];
	      _this7.formBasicInformation.assignData(_this7.currentPurchase);
	    });
	  },
	
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13),
	    VProductsTable: __webpack_require__(123)
	  }
	};

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(5);
	
	var _purchase = __webpack_require__(161);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _bridgeHandoff = __webpack_require__(81);
	
	var _bridgeHandoff2 = _interopRequireDefault(_bridgeHandoff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sortValue: '',
	      info: 'info',
	      primary: 'primary',
	      limit: 25
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    purchases: 'paginatePurchases',
	    view: 'getView'
	  }), {
	    purchasesListView: function purchasesListView() {
	      return this.purchases.items.map(function (c) {
	        return {
	          code: c.code,
	          name: c.name,
	          warehouse: c.warehouseName,
	          supplier: c.supplierName,
	          createdAt: c.createdAt,
	          comments: c.comments,
	          status: c.purchaseStatus.name,
	          id: c.id,
	          qty: c.total_qty
	        };
	      });
	    },
	    purchasesList: function purchasesList() {
	      return this.purchases.items.map(function (b) {
	        return b;
	      });
	    }
	  }),
	
	  watch: {
	    view: function view(_view) {
	      console.log(_view);
	      if (_view == 'card') {
	        this.info = 'info';
	        this.primary = 'primary';
	      } else {
	        this.primary = 'info';
	        this.info = 'primary';
	      }
	    },
	    $route: function $route() {
	      this.all(1, 50);
	    }
	  },
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19),
	    VTable: __webpack_require__(33)
	  },
	
	  mixins: [_search2.default, _bridgeHandoff2.default],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.setInnerSidebar([{
	      title: this.$t('static.inventory.transaction.title'),
	      options: [{
	        title: this.$t('static.stock.filters.title'),
	        route: {
	          name: 'inventory.stock.index'
	        }
	      }, {
	        title: this.$t('static.adjustment.filters.title'),
	        route: {
	          name: 'inventory.adjustment.index'
	        }
	      }, {
	        title: this.$t('static.purchase.filters.title'),
	        route: {
	          name: 'inventory.purchase.index'
	        }
	      }, {
	        title: this.$t('static.transfer.filters.title'),
	        route: {
	          name: 'inventory.transfer.index'
	        }
	      }],
	      button: this.bridgeStockWriteBlocked ? null : {
	        title: '+ ' + this.$t('static.warehouse.addTransaction.title'),
	        route: {
	          name: 'inventory.transaction.index'
	        }
	      }
	    }, {
	      title: this.$t('static.warehouse.filters.title'),
	      options: [{
	        title: this.$t('static.warehouse.filters.view'),
	        route: {
	          name: 'warehouse.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.warehouse.create.title'),
	        route: {
	          name: 'warehouse.create'
	        }
	      }
	    }]);
	
	    _account2.default.rememberPerPage('get', { from: 'purchase' }).then(function (data) {
	      _this.limit = data.size;
	      _this.all(1, _this.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	
	    console.log(this.view);
	    if (this.view == 'card') {
	      this.info = 'info';
	      this.primary = 'primary';
	    } else {
	      this.primary = 'info';
	      this.info = 'primary';
	    }
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'purchase', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this3 = this;
	
	      this.loading = true;
	      _purchase2.default.items({
	        page: page,
	        limit: limit,
	        search: this.getSearch(this.limit),
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this3.loading = false;
	      }).catch(function () {
	        _this3.loadProductsing = false;
	      });
	    }, 800),
	
	    changeView: function changeView(view) {
	      if (this.info != view) {
	        this.primary = this.info;
	        this.info = view;
	        if (this.info == 'info') {
	          _store2.default.dispatch('setView', 'card');
	        } else {
	          _store2.default.dispatch('setView', 'list');
	        }
	      }
	    },
	    editAdjustment: function editAdjustment(purchase) {
	      var name = 'inventory.purchase.view';
	      if (purchase.status != 'done') {
	        name = 'inventory.purchase.edit';
	      }
	      this.$router.push({
	        name: name,
	        params: { id: purchase.id }
	      });
	    }
	  })
	};

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(5);
	
	var _purchase = __webpack_require__(161);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _purchase3 = __webpack_require__(58);
	
	var _purchase4 = _interopRequireDefault(_purchase3);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      tabIndex: 'first',
	      currentPurchase: {
	        products: [],
	        warehouse: {
	          name: ''
	        },
	        supplier: {},
	        purchaseStatus: {
	          name: ''
	        },
	        stock: {
	          name: ''
	        }
	      }
	    };
	  },
	
	
	  computed: {
	    productList: function productList() {
	      return this.currentPurchase.products.map(function (c) {
	        return {
	          name: c.product.name,
	          qty: c.qty,
	          purchasePrice: c.purchasePrice,
	          costPrice: c.costPrice
	        };
	      });
	    }
	  },
	
	  watch: {
	    currentPurchase: function currentPurchase(_currentPurchase) {
	      console.log(_currentPurchase);
	    }
	  },
	
	  created: function created() {
	    this.loading = false;
	  },
	
	
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    Promise.all([_purchase2.default.show(this.$route.params.id)]).then(function (data) {
	      _this.currentPurchase = data[0];
	    });
	  },
	
	  components: {
	    VTable: __webpack_require__(33)
	  }
	};

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _purchase = __webpack_require__(161);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _previewMessage = __webpack_require__(418);
	
	var _previewMessage2 = _interopRequireDefault(_previewMessage);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      tabIndex: 'first',
	      currentPurchase: {
	        products: [],
	        warehouse: {
	          name: ''
	        },
	        supplier: {},
	        purchaseStatus: {
	          name: ''
	        },
	        stock: {
	          name: ''
	        }
	      },
	      hashId: '',
	      dropdownState: false,
	      userLang: 'no'
	    };
	  },
	
	
	  computed: {
	    productList: function productList() {
	      return this.currentPurchase.products.map(function (c) {
	        return {
	          sku: c.product.sku,
	          name: c.product.name,
	          qty: c.qty,
	          qtyReceive: c.qtyReceive,
	          qtyDamage: c.qtyDamage,
	          notes: c.notes
	        };
	      });
	    }
	  },
	
	  watch: {
	    currentPurchase: function currentPurchase(_currentPurchase) {
	      console.log(_currentPurchase);
	    }
	  },
	
	  created: function created() {
	    this.loading = false;
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalButtonLoading: 'SET_MODAL_BUTTON_LOADING'
	  }), {
	    previewSendDocument: function previewSendDocument() {
	      var _this = this;
	
	      var tempContact = [];
	      if (typeof this.currentPurchase.warehouse.contact.email !== 'undefined' && this.currentPurchase.warehouse.contact.email !== '') {
	        tempContact.push({
	          id: 0,
	          email: this.currentPurchase.warehouse.contact.email,
	          first_name: this.currentPurchase.warehouse.contact.firstName,
	          last_name: this.currentPurchase.warehouse.contact.lastName,
	          contact_types: [{ name: 'Primary' }]
	        });
	      }
	
	      if (typeof this.currentPurchase.supplier.contact.email !== 'undefined' && this.currentPurchase.supplier.contact.email !== '') {
	        tempContact.push({
	          id: 1,
	          email: this.currentPurchase.supplier.contact.email,
	          first_name: this.currentPurchase.supplier.name,
	          last_name: '',
	          contact_types: [{ name: 'Primary' }]
	        });
	      }
	
	      console.log(tempContact);
	
	      _purchase2.default.showPurchaseEmailInformation(this.$route.params.id).then(function (purchaseEmailInformation) {
	        console.log(purchaseEmailInformation);
	        _this.setModalContent(function () {
	          return _previewMessage2.default;
	        });
	        _this.setModalSize('full');
	        _this.setModalProps({
	          isEmailInput: true,
	          isMultiSelected: true,
	          contacts: tempContact.length > 0 ? tempContact : null,
	          message: purchaseEmailInformation.message,
	          subject: purchaseEmailInformation.title,
	          userEmail: purchaseEmailInformation.userEmail,
	          notes: "",
	          cc: true,
	          headerTexts: [_this.$t('static.bills.edit.from') + ': ' + purchaseEmailInformation.fromName + ' <' + purchaseEmailInformation.fromEmail + '>'],
	          attachments: [{
	            attachmentName: purchaseEmailInformation.attachmentName,
	            action: _this.showPurchase
	          }],
	          buttons: [{
	            name: _this.$t('button.cancel'),
	            action: _this.cancelModal,
	            title: _this.$t('button.cancel')
	          }, {
	            name: _this.isPending ? _this.$t('button.send') : _this.$t('button.resend'),
	            action: _this.sendPurchase,
	            title: _this.isPending ? _this.$t('button.send') : _this.$t('button.resend')
	          }]
	        });
	        _this.toggleModal(true);
	      }).catch(function () {});
	    },
	    sendPurchase: function sendPurchase(ev) {
	      var _this2 = this;
	
	      var test = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      this.sendLoading = true;
	      this.setModalButtonLoading(true);
	      _purchase2.default.send(_store2.default.state.route.params.id, {
	        email_to: _store2.default.state.modal.modalProps.email_to,
	        message: _store2.default.state.modal.modalProps.message,
	        subject: _store2.default.state.modal.modalProps.subject,
	        cc: _store2.default.state.modal.modalProps.cc,
	        notes: _store2.default.state.modal.modalProps.notes,
	        test: test
	      }).then(function () {
	        _this2.toggleModal(false);
	        _this2.sendLoading = false;
	        _this2.setModalButtonLoading(false);
	        _purchase2.default.show(_store2.default.state.route.params.id);
	        _this2.$message({
	          showClose: true,
	          message: _this2.$t('static.purchase.edit.sendPurchaseSuccess'),
	          type: 'success'
	        });
	      }).catch(function () {
	        _this2.toggleModal(false);
	        _this2.sendLoading = false;
	        _this2.setModalButtonLoading(false);
	        _this2.$message({
	          showClose: true,
	          message: _this2.$t('static.purchase.edit.sendPurchaseError'),
	          type: 'error'
	        });
	      });
	    },
	    sendTestPurchase: function sendTestPurchase(ev) {
	      this.sendPurchase(ev, true);
	    },
	    showPurchase: function showPurchase() {
	      _purchase2.default.showPdf(this.hashId, this.userLang);
	    },
	    downloadPurchase: function downloadPurchase() {
	      _purchase2.default.download(this.hashId, this.userLang);
	    },
	    toggleDropdown: function toggleDropdown() {
	      this.dropdownState = !this.dropdownState;
	    },
	    cancelModal: function cancelModal() {
	      this.toggleModal(false);
	    },
	    isPending: function isPending() {
	      return this.currentPurchase.purchaseStatus === 'Pending';
	    },
	    markAsDone: function markAsDone() {
	      var _this3 = this;
	
	      this.loading = false;
	
	      _purchase2.default.markAsDone(this.$route.params.id, []).then(function () {
	        _this3.$message({
	          message: _this3.$t('static.purchase.update.success'),
	          type: 'success'
	        });
	        _this3.$router.push({
	          name: 'inventory.purchase.index'
	        });
	      }).catch(function (errors) {});
	    },
	    markAsDraft: function markAsDraft() {
	      var _this4 = this;
	
	      this.loading = false;
	
	      _purchase2.default.saveAsDraft(this.$route.params.id, []).then(function () {
	        _this4.$message({
	          message: _this4.$t('static.purchase.update.success'),
	          type: 'success'
	        });
	        _this4.$router.push({
	          name: 'inventory.purchase.index'
	        });
	      }).catch(function (errors) {});
	    }
	  }),
	  mounted: function mounted() {
	    var _this5 = this;
	
	    Promise.all([_purchase2.default.show(this.$route.params.id)]).then(function (data) {
	      _this5.currentPurchase = data[0];
	      _this5.hashId = _this5.currentPurchase.hashId;
	      _this5.userLang = _this5.currentPurchase.userLang;
	    });
	  },
	
	  components: {
	    VTable: __webpack_require__(33)
	  }
	};

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _recipe = __webpack_require__(191);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	var _recipeType = __webpack_require__(479);
	
	var _recipeType2 = _interopRequireDefault(_recipeType);
	
	var _recipe3 = __webpack_require__(100);
	
	var _recipe4 = _interopRequireDefault(_recipe3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        notes: {
	          value: '',
	          type: 'textarea'
	        },
	        recipeTypeId: {
	          value: '',
	          type: 'select'
	        }
	      })
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    Promise.all([_recipe2.default.all(), _recipeType2.default.all()]).then(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    recipeTypes: 'allRecipeTypes'
	  })),
	
	  methods: {
	    store: function store() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var recipe = _recipe4.default.send(this.form.data());
	      _recipe2.default.store(recipe).then(function (response) {
	        _this2.form.loading = false;
	        _this2.$message({
	          message: _this2.$t('static.recipes.create.success'),
	          type: 'success'
	        });
	        console.log(response);
	        _this2.$router.push({
	          name: 'production.recipes.edit',
	          params: {
	            id: response.id
	          }
	        });
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  },
	
	  watch: {
	    recipeTypes: function recipeTypes(types) {
	      var _this3 = this;
	
	      this.form.setOptions('recipeTypeId', types.map(function (c) {
	        return {
	          id: c.id,
	          name: _this3.$t('static.recipes.types.' + _this3.camalize(c.name))
	        };
	      }));
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _recipe = __webpack_require__(191);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	var _recipeType = __webpack_require__(479);
	
	var _recipeType2 = _interopRequireDefault(_recipeType);
	
	var _material = __webpack_require__(125);
	
	var _material2 = _interopRequireDefault(_material);
	
	var _recipeIngredience = __webpack_require__(1259);
	
	var _recipeIngredience2 = _interopRequireDefault(_recipeIngredience);
	
	var _recipe3 = __webpack_require__(100);
	
	var _recipe4 = _interopRequireDefault(_recipe3);
	
	var _recipeIngredience3 = __webpack_require__(111);
	
	var _recipeIngredience4 = _interopRequireDefault(_recipeIngredience3);
	
	var _recipeProcedure = __webpack_require__(136);
	
	var _recipeProcedure2 = _interopRequireDefault(_recipeProcedure);
	
	var _recipeProcedureModal = __webpack_require__(2735);
	
	var _recipeProcedureModal2 = _interopRequireDefault(_recipeProcedureModal);
	
	var _equipment = __webpack_require__(228);
	
	var _equipment2 = _interopRequireDefault(_equipment);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _bulkAddProductModal = __webpack_require__(122);
	
	var _bulkAddProductModal2 = _interopRequireDefault(_bulkAddProductModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        notes: {
	          value: '',
	          type: 'textarea'
	        },
	        recipeTypeId: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      formProduct: new _forms2.default({
	        product: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        }
	      }),
	      formIngredience: new _forms2.default({
	        recipeId: {
	          value: '',
	          type: 'text'
	        },
	        materialId: {
	          value: '',
	          type: 'select'
	        },
	        amount: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      hiddenFields: ['recipeId'],
	      loading: false,
	      fetchedRecipe: null,
	      addProductsButton: [{
	        text: this.$t('table.orderProducts.addProductsButton'),
	        action: this.showBulkAddProductModal
	      }],
	      addIngrediencesButton: [{
	        text: this.$t('static.recipeIngrediences.index.addIngrediences'),
	        action: this.showBulkAddIngredienceModal
	      }]
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    Promise.all([_recipeType2.default.all(), _material2.default.all(), _equipment2.default.all()]).then(function () {
	      _this.loading = false;
	    });
	    this.show();
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    recipeTypes: 'allRecipeTypes',
	    materials: 'allMaterials',
	    ingrediences: 'allRecipeIngrediences',
	    procedures: 'allRecipeProcedures',
	    products: 'allRecipeProducts'
	  }), {
	    ingredienceList: function ingredienceList() {
	      return this.ingrediences.map(function (ingredience) {
	        return Object.assign({}, ingredience);
	      });
	    },
	    productList: function productList() {
	      return this.products.map(function (products) {
	        return Object.assign({}, products);
	      });
	    },
	    procedureList: function procedureList() {
	      return this.procedures.map(function (procedure) {
	        var p = Object.assign({}, procedure);
	        p.ingrediences = _recipeIngredience4.default.fetchCollection(procedure.ingrediences);
	        return p;
	      });
	    }
	  }),
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalButtonLoading: 'SET_MODAL_BUTTON_LOADING'
	  }), {
	    showBulkAddProductModal: function showBulkAddProductModal() {
	      this.setModalContent(function () {
	        return _bulkAddProductModal2.default;
	      });
	      this.setModalProps({
	        disableQuantity: true,
	        fetchProductsMethod: this.fetchAllProductsBasic,
	        onSave: this.handleBulkProductSave
	      });
	      this.toggleModal(true);
	    },
	    fetchAllProductsBasic: function fetchAllProductsBasic() {
	      return Promise.all([_product2.default.allBasic({
	        filter: 'active',
	        warehouse_id: ''
	      })]);
	    },
	    handleBulkProductSave: function handleBulkProductSave(selectedProducts) {
	      var _this2 = this;
	
	      var products = selectedProducts.map(function (p) {
	        return { product_id: p.id };
	      });
	      this.formProduct.loading = true;
	      return _recipe2.default.bulkStoreProduct(this.fetchedRecipe.id, products).then(function () {
	        _this2.formProduct.loading = false;
	      });
	    },
	    showBulkAddIngredienceModal: function showBulkAddIngredienceModal() {
	      this.setModalContent(function () {
	        return _bulkAddProductModal2.default;
	      });
	      this.setModalProps({
	        fetchProductsMethod: this.fetchAllMaterialsBasic,
	        onSave: this.handleBulkIngrediencesSave
	      });
	      this.toggleModal(true);
	    },
	    fetchAllMaterialsBasic: function fetchAllMaterialsBasic() {
	      return Promise.all([_product2.default.allBasic({
	        filter: 'active',
	        type: 'material'
	      })]);
	    },
	    handleBulkIngrediencesSave: function handleBulkIngrediencesSave(selectedProducts) {
	      var _this3 = this;
	
	      var products = selectedProducts.map(function (p) {
	        return {
	          materialId: p.id,
	          amount: p.qty
	        };
	      });
	      this.formIngredience.loading = true;
	      return _recipeIngredience2.default.bulkStore(this.fetchedRecipe.id, products).then(function () {
	        _this3.formIngredience.loading = false;
	      });
	    },
	    searchMethod: function searchMethod(search) {
	      return Promise.all([_product2.default.search({
	        search: search
	      })]);
	    },
	    update: function update() {
	      var _this4 = this;
	
	      this.form.loading = true;
	      var recipe = _recipe4.default.send(this.form.data());
	      _recipe2.default.update(_store2.default.state.route.params.id, recipe).then(function () {
	        _this4.form.loading = false;
	        _this4.$message({
	          message: _this4.$t('static.recipes.edit.success'),
	          type: 'success'
	        });
	        _this4.$router.push({
	          name: 'production.recipes.index'
	        });
	      }).catch(function (errors) {
	        _this4.form.loading = false;
	        _this4.form.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      var _this5 = this;
	
	      this.loading = true;
	      _recipe2.default.show(_store2.default.state.route.params.id).then(function (recipe) {
	        _this5.fetchedRecipe = recipe;
	        _this5.form.assignData(recipe);
	        var recipeIngrediences = _recipeIngredience4.default.fetchCollection(recipe.ingrediences);
	        _store2.default.dispatch('fetchAllRecipeIngrediences', recipeIngrediences);
	        var recipeProcedures = _recipeProcedure2.default.fetchCollection(recipe.procedures);
	        _store2.default.dispatch('fetchAllRecipeProcedures', recipeProcedures);
	        _store2.default.dispatch('fetchAllRecipeProducts', recipe.products);
	        _this5.loading = false;
	      });
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    },
	    saveProduct: function saveProduct() {
	      var _this6 = this;
	
	      this.formProduct.loading = true;
	      return _recipe2.default.storeProduct(this.fetchedRecipe.id, this.formProduct.data()).then(function () {
	        _this6.formProduct.loading = false;
	      }).catch(function (errors) {
	        _this6.formProduct.loading = false;
	        _this6.formProduct.recordErrors(errors);
	        var errorsKeys = Object.keys(_this6.formProduct.errors.errors);
	        _this6.$message({
	          showClose: true,
	          message: errors[errorsKeys[0]][0],
	          type: 'error'
	        });
	      });
	    },
	    destroyProduct: function destroyProduct(id) {
	      var _this7 = this;
	
	      this.destroyLoading = true;
	      _recipe2.default.destroyProduct(this.fetchedRecipe.id, id).then(function () {
	        _this7.destroyLoading = false;
	      }).catch(function () {
	        _this7.destroyLoading = false;
	      });
	    },
	    onFormIngredienceChange: function onFormIngredienceChange(name, value) {
	      this.form.clearSuccess(name, value);
	      this.form.clearErrors(name);
	      this.form[name] = value;
	      this.$forceUpdate();
	    },
	    saveIngredience: function saveIngredience() {
	      var _this8 = this;
	
	      this.formIngredience.loading = true;
	      var data = Object.assign(this.formIngredience.data(), {
	        recipeId: this.fetchedRecipe.id
	      });
	      return _recipeIngredience2.default.store(data).then(function () {
	        _this8.formIngredience.loading = false;
	      }).catch(function (errors) {
	        _this8.formIngredience.loading = false;
	        _this8.formIngredience.recordErrors(errors);
	        var errorsKeys = Object.keys(_this8.formIngredience.errors.errors);
	        _this8.$message({
	          showClose: true,
	          message: errors[errorsKeys[0]][0],
	          type: 'error'
	        });
	      });
	    },
	    updateIngredience: function updateIngredience(ingredienceId) {
	      var _this9 = this;
	
	      this.formIngredience.loading = true;
	      var data = Object.assign(this.formIngredience.data(), {
	        recipeId: this.fetchedRecipe.id
	      });
	      return _recipeIngredience2.default.update(ingredienceId, data).then(function () {
	        _this9.formIngredience.loading = false;
	      }).catch(function (errors) {
	        _this9.formIngredience.loading = false;
	        _this9.formIngredience.recordErrors(errors);
	        var errorsKeys = Object.keys(_this9.formIngredience.errors.errors);
	        _this9.$message({
	          showClose: true,
	          message: errors[errorsKeys[0]][0],
	          type: 'error'
	        });
	      });
	    },
	    destroyIngredience: function destroyIngredience(id) {
	      var _this10 = this;
	
	      this.$confirm(this.$t('static.recipeIngrediences.index.confirmDelete'), this.$t('static.recipeIngrediences.index.confirmDeleteTitle'), {
	        confirmButtonText: this.$t('button.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _this10.destroyLoading = true;
	        _recipeIngredience2.default.destroy(id).then(function () {
	          _this10.destroyLoading = false;
	        }).catch(function () {
	          _this10.destroyLoading = false;
	        });
	      }).catch(function () {});
	    },
	    addProcedure: function addProcedure() {
	      this.setModalContent(function () {
	        return _recipeProcedureModal2.default;
	      });
	      this.setModalSize('full');
	      this.toggleModal(true);
	      this.setModalProps({
	        recipeId: _store2.default.state.route.params.id.toString()
	      });
	    },
	    editProcedure: function editProcedure(procedure) {
	      this.setModalContent(function () {
	        return _recipeProcedureModal2.default;
	      });
	      this.setModalSize('full');
	      this.toggleModal(true);
	      this.setModalProps({
	        recipeId: _store2.default.state.route.params.id.toString(),
	        procedure: procedure
	      });
	    }
	  }),
	
	  watch: {
	    recipeTypes: function recipeTypes(types) {
	      var _this11 = this;
	
	      this.form.setOptions('recipeTypeId', types.map(function (c) {
	        return {
	          id: c.id,
	          name: _this11.$t('static.recipes.types.' + _this11.camalize(c.name))
	        };
	      }));
	    },
	    materials: function materials(_materials) {
	      this.formIngredience.setOptions('materialId', _materials.map(function (c) {
	        return {
	          id: c.id,
	          name: c.name + ' ' + (c.unitMeasure !== '' ? '(' + c.unitMeasure + ')' : '') + ' - ID: ' + c.id
	        };
	      }));
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9),
	    VFormTable: __webpack_require__(46)
	  }
	};

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _recipe = __webpack_require__(191);
	
	var _recipe2 = _interopRequireDefault(_recipe);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _bridgeHandoff = __webpack_require__(81);
	
	var _bridgeHandoff2 = _interopRequireDefault(_bridgeHandoff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sort: '',
	      info: 'info',
	      primary: 'primary',
	      search: ''
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    recipes: 'paginatedRecipes',
	    allRecipes: 'allRecipes',
	    view: 'getView',
	    searchQuery: 'recipeQuery',
	    account: 'account'
	  }), {
	    recipesListView: function recipesListView() {
	      return this.recipes.items.map(function (recipe) {
	        return {
	          id: recipe.id,
	          name: recipe.name,
	          recipeType: recipe.recipeType
	        };
	      });
	    }
	  }),
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19),
	    VTable: __webpack_require__(33)
	  },
	
	  mixins: [_search2.default, _bridgeHandoff2.default],
	
	  watch: {
	    $route: function $route() {
	      this.all(1, 25);
	    },
	    view: function view(_view) {
	      if (_view == 'card') {
	        this.info = 'info';
	        this.primary = 'primary';
	      } else {
	        this.primary = 'info';
	        this.info = 'primary';
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    this.setInnerSidebar([{
	      title: this.$t('static.materials.filters.title'),
	      options: [{
	        title: this.$t('static.materials.filters.active'),
	        route: {
	          name: 'production.materials.index',
	          query: {
	            filter: 'active'
	          }
	        }
	      }, {
	        title: this.$t('static.materials.filters.deactivated'),
	        route: {
	          name: 'production.materials.index',
	          query: {
	            filter: 'deactivated'
	          }
	        }
	      }, {
	        title: this.$t('static.materials.filters.all'),
	        route: {
	          name: 'production.materials.index',
	          query: {
	            filter: 'all'
	          }
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.materials.create.title'),
	        route: {
	          name: 'production.materials.create'
	        }
	      }
	    }, {
	      title: this.$t('static.batches.filters.title'),
	      options: [{
	        title: this.$t('static.batches.filters.notStarted'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'notStarted'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.upcoming'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'upcoming'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.ongoing'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'ongoing'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.completed'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'completed'
	          }
	        }
	      }, {
	        title: this.$t('static.batches.filters.all'),
	        route: {
	          name: 'production.batches.index',
	          query: {
	            filter: 'all'
	          }
	        }
	      }],
	      button: this.bridgeStockWriteBlocked ? null : {
	        title: '+ ' + this.$t('static.batches.create.title'),
	        route: {
	          name: 'production.batches.create'
	        }
	      }
	    }, {
	      title: this.$t('static.recipes.filters.title'),
	      options: [{
	        title: this.$t('static.recipes.filters.all'),
	        route: {
	          name: 'production.recipes.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.recipes.create.title'),
	        route: {
	          name: 'production.recipes.create'
	        }
	      }
	    }, {
	      title: this.$t('static.equipments.title'),
	      options: [{
	        title: this.$t('static.equipments.filters.all'),
	        route: {
	          name: 'production.equipments.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.equipments.create.title'),
	        route: {
	          name: 'production.equipments.create'
	        }
	      }
	    }]);
	
	    this.all(this.searchQuery.page, this.searchQuery.limit);
	    if (this.view == 'card') {
	      this.info = 'info';
	      this.primary = 'primary';
	    } else {
	      this.primary = 'info';
	      this.info = 'primary';
	    }
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    changeView: function changeView(view) {
	      if (this.info != view) {
	        this.primary = this.info;
	        this.info = view;
	        if (this.info == 'info') {
	          _store2.default.dispatch('setView', 'card');
	        } else {
	          _store2.default.dispatch('setView', 'list');
	        }
	      }
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this = this;
	
	      this.loading = true;
	
	      var query = { page: page, limit: limit, search: this.searchQuery.search };
	      _store2.default.dispatch('setRecipeQuery', query);
	      this.search = this.searchQuery.search;
	      _recipe2.default.items({
	        page: page,
	        limit: limit,
	        search: this.searchQuery.search,
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this.loading = false;
	      }).catch(function () {
	        _this.loading = false;
	      });
	    }, 800),
	
	    onChangeSearch: function onChangeSearch(name, value) {
	      _store2.default.dispatch('setRecipeQuery', { page: 1, limit: 25, search: value });
	      this.all(1, 25);
	    },
	    editRecipe: function editRecipe(recipe) {
	      this.$router.push({
	        name: 'production.recipes.edit',
	        params: { id: recipe.id }
	      });
	    },
	    camalize: function camalize(str) {
	      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	        return chr.toUpperCase();
	      });
	    }
	  })
	};

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _report = __webpack_require__(305);
	
	var _report2 = _interopRequireDefault(_report);
	
	var _aggregatedSalesReport = __webpack_require__(1654);
	
	var _aggregatedSalesReport2 = _interopRequireDefault(_aggregatedSalesReport);
	
	var _orderType = __webpack_require__(300);
	
	var _orderType2 = _interopRequireDefault(_orderType);
	
	var _helpers = __webpack_require__(11);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _transactionType = __webpack_require__(485);
	
	var _transactionType2 = _interopRequireDefault(_transactionType);
	
	var _vuex = __webpack_require__(5);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _bulkProcessTurnOverModal = __webpack_require__(2683);
	
	var _bulkProcessTurnOverModal2 = _interopRequireDefault(_bulkProcessTurnOverModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = {
	  data: function data() {
	    return {
	      clientSearch: '',
	      tabIndex: 'clients',
	      greenDotSelectedYear: '',
	      clientData: [],
	      client: '',
	      client_id: null,
	      warehouse: '',
	      warehouse_id: null,
	      transaction_type_id: '',
	      transactionDateRange: [],
	      transactionMonth: null,
	      groupByProduct: true,
	      loadingClients: false,
	      salesData: [],
	      loadingSales: false,
	      exciseLoading: false,
	      salesDateRange: [(0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()],
	      salesGrouping: '',
	      salesType: '',
	      salesFilter: '',
	      salesGroupingOptions: [{
	        name: this.$t('static.reports.sales.group.names.orders'),
	        id: ''
	      }, {
	        name: this.$t('static.reports.sales.group.names.clients'),
	        id: 'clients'
	      }, {
	        name: this.$t('static.reports.sales.group.names.products'),
	        id: 'products'
	      }],
	      loadingBills: false,
	      billData: [],
	      billsDateRange: [(0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()],
	      billClientId: '',
	      loadingFees: false,
	      feeData: [],
	      warehouseData: [],
	      warehouseTransactionData: [],
	      feesDateRange: [(0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()],
	      feesMonth: '',
	      feeReportLoaded: false,
	      exciseReport: [],
	      helsedirReport: [],
	      infinitumReport: [],
	      exciseDateRange: (0, _moment2.default)(),
	      loadingExcise: false,
	      warehouseLoading: false,
	      limit: 25,
	      yearList: [],
	      selectedYear: '',
	      multipleSelection: [],
	      buttonLoading: [],
	      buttonBulkSendLoading: false,
	      buttonBulkDownloadLoading: false,
	      disableBulk: true,
	      dropdownState: [],
	      dateOption: 'as_of_date',
	      asOfDate: '',
	      hideOutOfStock: true,
	
	      loadingAggSales: false,
	      aggSalesData: [],
	      aggSalesSummary: null,
	      aggSalesColumns: [],
	      aggSalesDateRange: [(0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()],
	      aggSalesGroupBy: ['product'],
	      aggSalesSort: 'revenue_desc',
	      aggSalesIncludeCancelled: false,
	      aggSalesStatuses: [],
	      aggSalesMetrics: ['totalRevenueNet', 'totalRevenueGross', 'totalVolumeLiters', 'orderCount', 'totalQuantityUnits']
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    warehouses: 'allWarehouses',
	    account: 'account',
	    excisePeriods: 'paginatedExcisePeriods',
	    transactionTypes: 'allTransactionTypes',
	    orderTypes: 'orderTypes'
	  }), {
	    clientList: function clientList() {
	      return this.clientData.map(function (c) {
	        return {
	          id: c.id,
	          name: c.name,
	          clientNumber: c.clientNumber,
	          balance: Number(c.balance.toFixed(0)),
	          createdAt: c.createdAt
	        };
	      });
	    },
	    salesList: function salesList() {
	      var _this = this;
	
	      return this.salesData.map(function (r) {
	        r.total = r.clearedInvoices - r.clearedCredit;
	        if (_this.salesGrouping !== '') {
	          delete r.status;
	        }
	        return r;
	      });
	    },
	    billList: function billList() {
	      return this.billData.map(function (r) {
	        delete r.address;
	        delete r.email;
	        delete r.invoiceDate;
	        delete r.vat;
	        delete r.sum;
	
	        return r;
	      });
	    },
	    feeList: function feeList() {
	      return this.feeData.map(function (r) {
	        return r;
	      });
	    },
	    warehouseList: function warehouseList() {
	      return this.warehouseData.map(function (_ref) {
	        var vmpNumber = _ref.vmpNumber,
	            fields = _objectWithoutProperties(_ref, ['vmpNumber']);
	
	        return fields;
	      });
	    },
	    transactionListNew: function transactionListNew() {
	      if (this.warehouseTransactionData.length === 0) {
	        return false;
	      }
	      return this.warehouseTransactionData.map(function (c) {
	        return {
	          id: c.parentModelId,
	          key: c.via + ' ' + c.code,
	          productName: c.productName,
	          via: c.via + ' #' + c.code,
	          warehouse: c.warehouse,
	          beforeqty: c.beforeQty,
	          qty: c.adjustmentQty,
	          afterqty: c.afterQty,
	          createdAt: c.createdAt
	        };
	      });
	    },
	    hasExcise: function hasExcise() {
	      var hasModule = false;
	      if (this.account.modules.length > 0) {
	        for (var i = 0; i < this.account.modules.length; i++) {
	          if (this.account.modules[i].name === 'Excise') {
	            hasModule = true;
	          }
	        }
	      }
	      return hasModule;
	    },
	    salesTypeOptions: function salesTypeOptions() {
	      var _this2 = this;
	
	      var salesTypes = this.orderTypes.map(function (type) {
	        return {
	          id: type.id,
	          name: _this2.$t('static.orders.types.' + type.name.toLowerCase())
	        };
	      });
	      salesTypes.unshift({
	        id: '',
	        name: this.$t('static.orders.types.all')
	      });
	      return salesTypes;
	    },
	    showAsOfDate: function showAsOfDate() {
	      return this.dateOption === 'as_of_date';
	    },
	    showDateRange: function showDateRange() {
	      return this.dateOption === 'date_range';
	    },
	    aggSalesGroupByOptions: function aggSalesGroupByOptions() {
	      return [{ id: 'product', name: this.$t('static.reports.aggregatedSales.groupBy.product') }, { id: 'client', name: this.$t('static.reports.aggregatedSales.groupBy.client') }, { id: 'client_type', name: this.$t('static.reports.aggregatedSales.groupBy.clientType') }, { id: 'month', name: this.$t('static.reports.aggregatedSales.groupBy.month') }, { id: 'year', name: this.$t('static.reports.aggregatedSales.groupBy.year') }];
	    },
	    aggSalesSortOptions: function aggSalesSortOptions() {
	      return [{ id: 'revenue_desc', name: this.$t('static.reports.aggregatedSales.sort.revenueDesc') }, { id: 'revenue_asc', name: this.$t('static.reports.aggregatedSales.sort.revenueAsc') }, { id: 'volume_desc', name: this.$t('static.reports.aggregatedSales.sort.volumeDesc') }, { id: 'volume_asc', name: this.$t('static.reports.aggregatedSales.sort.volumeAsc') }];
	    },
	    aggSalesStatusOptions: function aggSalesStatusOptions() {
	      var _this3 = this;
	
	      var keys = ['confirmed', 'shipped', 'delivered', 'invoiced', 'created', 'cancelled'];
	      return keys.map(function (k) {
	        return {
	          id: k,
	          name: _this3.$t('static.reports.aggregatedSales.statuses.options.' + k)
	        };
	      });
	    },
	    aggSalesDynamicColumns: function aggSalesDynamicColumns() {
	      var groupKeys = this.aggSalesGroupBy || [];
	      var cols = [];
	      if (groupKeys.includes('product')) {
	        cols.push({ key: 'product_name', prop: 'productName', label: this.$t('static.reports.aggregatedSales.columns.productName'), minWidth: 180 });
	        cols.push({ key: 'product_number', prop: 'productNumber', label: this.$t('static.reports.aggregatedSales.columns.productNumber'), minWidth: 110 });
	      }
	      if (groupKeys.includes('client')) {
	        cols.push({ key: 'client_name', prop: 'clientName', label: this.$t('static.reports.aggregatedSales.columns.clientName'), minWidth: 180 });
	        cols.push({ key: 'client_number', prop: 'clientNumber', label: this.$t('static.reports.aggregatedSales.columns.clientNumber'), minWidth: 100 });
	      }
	      if (groupKeys.includes('client_type')) {
	        cols.push({ key: 'client_type_name', prop: 'clientTypeName', label: this.$t('static.reports.aggregatedSales.columns.clientTypeName'), minWidth: 180 });
	      }
	      if (groupKeys.includes('month') || groupKeys.includes('year')) {
	        cols.push({ key: 'period', prop: 'period', label: this.$t('static.reports.aggregatedSales.columns.period'), minWidth: 90 });
	      }
	      return cols;
	    },
	    aggSalesMetricOptions: function aggSalesMetricOptions() {
	      return [{ id: 'totalRevenueNet', name: this.$t('static.reports.aggregatedSales.columns.totalRevenueNet') }, { id: 'totalRevenueGross', name: this.$t('static.reports.aggregatedSales.columns.totalRevenueGross') }, { id: 'totalVolumeLiters', name: this.$t('static.reports.aggregatedSales.columns.totalVolumeLiters') }, { id: 'orderCount', name: this.$t('static.reports.aggregatedSales.columns.orderCount') }, { id: 'totalQuantityUnits', name: this.$t('static.reports.aggregatedSales.columns.totalQuantityUnits') }];
	    }
	  }),
	
	  mounted: function mounted() {
	    this.urlCurrentTab();
	    this.assignTab(this.tabIndex);
	  },
	  created: function created() {
	    var _this4 = this;
	
	    var self = this;
	    window.addEventListener('click', function (e) {
	      if (_helpers2.default.closeDropdown(e, self.dropdownState) === false) {
	        self.dropdownState = false;
	      }
	    });
	
	    _account2.default.rememberPerPage('get', { from: 'report_excise_entry' }).then(function (data) {
	      _this4.limit = data.size;
	      _this4.showExcise(1, _this4.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	
	    this.initYearFilter();
	    this.showClients();
	    this.showBills();
	    this.showSales();
	
	
	    this.showWarehouses();
	    if (this.$route.query.t) {
	      this.tabIndex = this.$route.query.t;
	    }
	    Promise.all([_warehouse2.default.all(), _transactionType2.default.all(), _orderType2.default.all()]).then(function () {});
	  },
	
	  watch: {
	    clientSearch: function clientSearch(value) {
	      this.showClients({ clientSearch: value });
	    },
	    client: function client(_client) {
	      this.client_id = null;
	    },
	    selectedYear: function selectedYear(value) {
	      var _this5 = this;
	
	      this.loadingClients = true;
	      _report2.default.clients({ year: value }).then(function (clients) {
	        _this5.loadingClients = false;
	        _this5.clientData = clients;
	      });
	    },
	    multipleSelection: function multipleSelection(value) {
	      if (value.length === 0) {
	        this.disableBulk = true;
	      } else {
	        this.disableBulk = false;
	      }
	    },
	    $route: function $route() {
	      this.urlCurrentTab();
	    },
	    tabIndex: function tabIndex(value) {
	      this.assignTab(value);
	    }
	  },
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalProps: 'SET_MODAL_PROPS',
	    unsetModalContent: 'UNSET_MODAL_CONTENT',
	    setModalSize: 'SET_MODAL_SIZE',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE'
	  }), (_extends2 = {
	    assignTab: function assignTab(value) {
	      var tab = '';
	      if (value === 'excise') {
	        tab = '#excise';
	      } else if (value === 'warehouse') {
	        tab = '#warehouse';
	      } else if (value === 'bills') {
	        tab = '#bills';
	      } else if (value === 'sales') {
	        tab = '#sales';
	      } else if (value === 'greenDot') {
	        tab = '#greenDot';
	      } else if (value === 'aggregatedSales') {
	        tab = '#aggregatedSales';
	      } else {
	        tab = '#clients';
	      }
	      history.pushState({}, null, '/#' + this.$route.path + tab);
	    },
	    urlCurrentTab: function urlCurrentTab() {
	      if (this.$router.currentRoute.hash === '#excise') {
	        this.tabIndex = 'excise';
	      } else if (this.$router.currentRoute.hash === '#warehouse') {
	        this.tabIndex = 'warehouse';
	      } else if (this.$router.currentRoute.hash === '#bills') {
	        this.tabIndex = 'bills';
	      } else if (this.$router.currentRoute.hash === '#sales') {
	        this.tabIndex = 'sales';
	      } else if (this.$router.currentRoute.hash === '#greenDot') {
	        this.tabIndex = 'greenDot';
	      } else if (this.$router.currentRoute.hash === '#aggregatedSales') {
	        this.tabIndex = 'aggregatedSales';
	      } else {
	        this.tabIndex = 'clients';
	      }
	    },
	    generateGreenDotReport: function generateGreenDotReport() {
	      if (this.greenDotSelectedYear !== '') {
	        window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/reports/greendot/export', {
	          year: this.greenDotSelectedYear,
	          token: localStorage.getItem('id_token')
	        }));
	      }
	    },
	    generateGreenDotDetailedReport: function generateGreenDotDetailedReport() {
	      if (this.greenDotSelectedYear !== '') {
	        window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/reports/greendot/export/detailed', {
	          year: this.greenDotSelectedYear,
	          token: localStorage.getItem('id_token')
	        }));
	      }
	    },
	    selectable: function selectable(row, index) {
	      return true;
	    },
	    toggleDropdown: function toggleDropdown(value) {
	      this.dropdownState.splice(value.id, 1, !this.dropdownState[value.id]);
	    },
	    sendSelectedClient: function sendSelectedClient() {
	      this.previewModalSend(this.multipleSelection);
	    },
	    sendClient: function sendClient(value) {
	      this.previewModalSend([value.id]);
	    },
	    previewModalSend: function previewModalSend(selected) {
	      var selectedClients = this.clientData.filter(function (item) {
	        return selected.some(function (item2) {
	          return item2 === item.id;
	        });
	      });
	      this.setModalContent(function () {
	        return _bulkProcessTurnOverModal2.default;
	      });
	      this.setModalProps({
	        selected: selectedClients,
	        emailData: {
	          from: { id: this.account.email, name: this.account.organizationName },
	          subject: 'Omsetningsoppgave ' + this.selectedYear,
	          message: 'Se vedlegg for omsetningsoppgave for ' + this.selectedYear + '.',
	          selectedYear: this.selectedYear
	        }
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    downloadSelectedClient: function downloadSelectedClient() {
	      var _this6 = this;
	
	      this.buttonBulkDownloadLoading = true;
	      _report2.default.downloadTurnOverPdf('validate', { ids: this.multipleSelection, selectedYear: this.selectedYear }).then(function (response) {
	        if (response.data.noData.length > 0) {
	          _this6.setModalContent(function () {
	            return _bulkProcessTurnOverModal2.default;
	          });
	          _this6.setModalProps({
	            selected: [],
	            emailData: {},
	            noData: response.data.noData,
	            noDataAllSelected: response.data.noDataAllSelected,
	            period: _this6.selectedYear.toString()
	          });
	          _this6.setModalCloseOnClick(false);
	          _this6.setModalShowClose(false);
	          _this6.setModalCloseOnPressEscape(false);
	          _this6.toggleModal(true);
	        }
	        if (!response.data.noDataAllSelected) {
	          _this6.proceedProceedDownload();
	        } else {
	          _this6.buttonBulkDownloadLoading = false;
	        }
	      }).catch(function () {
	        _this6.buttonBulkDownloadLoading = false;
	      });
	    },
	    proceedProceedDownload: function proceedProceedDownload() {
	      var _this7 = this;
	
	      _report2.default.downloadTurnOverPdf('multiple', {
	        selectedYear: this.selectedYear,
	        ids: this.multipleSelection,
	        downloadTurnOver: true
	      }).then(function (response) {
	        var blob = new Blob([response.data], {
	          type: 'application/octet-stream'
	        });
	        var link = document.createElement('a');
	        link.href = window.URL.createObjectURL(blob);
	        link.download = 'omsetningsrapport-bulk.zip';
	        link.click();
	        _this7.buttonBulkDownloadLoading = false;
	      }).catch(function () {
	        _this7.buttonBulkDownloadLoading = false;
	      });
	    },
	    viewTurnoverReport: function viewTurnoverReport(value) {
	      var _this8 = this;
	
	      this.buttonLoading.splice(value.id, 1, true);
	      _report2.default.downloadTurnOverPdf('single', {
	        selectedYear: this.selectedYear,
	        id: value.id,
	        download: false
	      }).then(function (response) {
	        var file = new Blob([response.data], { type: 'application/pdf' });
	        var fileURL = URL.createObjectURL(file);
	        window.open(fileURL);
	        _this8.buttonLoading.splice(value.id, 1, false);
	      }).catch(function () {
	        _this8.buttonLoading.splice(value.id, 1, false);
	      });
	    },
	    handleSelectionChange: function handleSelectionChange(value) {
	      this.multipleSelection = value.map(function (item) {
	        return item.id;
	      });
	    },
	    initYearFilter: function initYearFilter() {
	      var _this9 = this;
	
	      _report2.default.exciseCalendar().then(function (response) {
	        var result = response.data[0].map(function (item) {
	          return new Date(item).getFullYear();
	        });
	        result = [].concat(_toConsumableArray(new Set(result)));
	        result = result.sort(function (a, b) {
	          return b - a;
	        });
	        _this9.yearList = result;
	        var defaultYear = new Date();
	        defaultYear.setFullYear(defaultYear.getFullYear() - 1);
	        _this9.selectedYear = defaultYear.getFullYear();
	      });
	    },
	    perPage: function perPage(size) {
	      var _this10 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'report_excise_entry', perPage: size }).then(function (data) {
	        _this10.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    showClients: function showClients() {
	      var _this11 = this;
	
	      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      this.loadingClients = true;
	      _report2.default.clients(filter).then(function (clients) {
	        _this11.loadingClients = false;
	        _this11.clientData = clients;
	        _this11.clientData.forEach(function (item) {
	          _this11.dropdownState[item.id] = false;
	          _this11.buttonLoading[item.id] = false;
	        });
	      });
	    },
	    showSales: function showSales() {
	      var _this12 = this;
	
	      this.loadingSales = true;
	      _report2.default.sales(this.salesGrouping, this.salesDateRange, this.salesFilter, this.salesType).then(function (report) {
	        _this12.loadingSales = false;
	        _this12.salesData = report;
	      });
	    },
	    aggFmtCurrency: function aggFmtCurrency(row, col, value) {
	      if (value === null || value === undefined || value === '') return '-';
	      return Number(value).toLocaleString('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	    },
	    aggFmtVolume: function aggFmtVolume(row, col, value) {
	      if (value === null || value === undefined || value === '') return '-';
	      return Number(value).toLocaleString('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	    },
	    aggFmtInt: function aggFmtInt(row, col, value) {
	      if (value === null || value === undefined || value === '') return '-';
	      return Number(value).toLocaleString('nb-NO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
	    },
	    aggFmtQty: function aggFmtQty(row, col, value) {
	      if (value === null || value === undefined || value === '') return '-';
	      var n = Number(value);
	      var dec = n % 1 === 0 ? 0 : 2;
	      return n.toLocaleString('nb-NO', { minimumFractionDigits: dec, maximumFractionDigits: dec });
	    },
	    aggFmtSumCurrency: function aggFmtSumCurrency(value) {
	      if (value === null || value === undefined) return '-';
	      return Number(value).toLocaleString('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	    },
	    aggFmtSumVolume: function aggFmtSumVolume(value) {
	      if (value === null || value === undefined) return '-';
	      return Number(value).toLocaleString('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	    },
	    showAggSales: function showAggSales() {
	      var _this13 = this;
	
	      if (!this.aggSalesDateRange[0] || !this.aggSalesDateRange[1]) return;
	      this.loadingAggSales = true;
	      _report2.default.aggregatedSales({
	        groupBy: this.aggSalesGroupBy,
	        dateRange: this.aggSalesDateRange,
	        includeCancelled: this.aggSalesIncludeCancelled,
	        sort: this.aggSalesSort,
	        statuses: this.aggSalesStatuses.length ? this.aggSalesStatuses : null
	      }).then(function (result) {
	        _this13.loadingAggSales = false;
	        _this13.aggSalesColumns = result.columns;
	        _this13.aggSalesSummary = result.summary;
	        _this13.aggSalesData = _aggregatedSalesReport2.default.fetchCollection(result.rows);
	      }).catch(function () {
	        _this13.loadingAggSales = false;
	      });
	    },
	    onAggSalesFilterChange: function onAggSalesFilterChange(name, value) {
	      if (name === 'aggSalesDateRange' && value === undefined) {
	        this.aggSalesDateRange = [(0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()];
	      } else {
	        this[name] = value;
	      }
	      this.showAggSales();
	    },
	    downloadAggSalesReport: function downloadAggSalesReport() {
	      var params = {};
	      if (this.aggSalesDateRange[0] && this.aggSalesDateRange[1]) {
	        params.start = (0, _moment2.default)(this.aggSalesDateRange[0]).format('YYYY-MM-DD');
	        params.end = (0, _moment2.default)(this.aggSalesDateRange[1]).format('YYYY-MM-DD');
	      }
	      (this.aggSalesGroupBy || []).forEach(function (g, i) {
	        params['group_by[' + i + ']'] = g;
	      });
	      params.sort = this.aggSalesSort;
	      if (this.aggSalesIncludeCancelled) {
	        params.include_cancelled = '1';
	      }
	      if (this.aggSalesStatuses.length) {
	        this.aggSalesStatuses.forEach(function (s, i) {
	          params['statuses[' + i + ']'] = s;
	        });
	      }
	      var metricKeyMap = {
	        totalRevenueNet: 'total_revenue_net',
	        totalRevenueGross: 'total_revenue_gross',
	        totalVolumeLiters: 'total_volume_liters',
	        orderCount: 'order_count',
	        totalQuantityUnits: 'total_quantity_units'
	      };
	      this.aggSalesMetrics.forEach(function (m, i) {
	        params['metrics[' + i + ']'] = metricKeyMap[m] || m;
	      });
	      params.locale = this.$i18n.locale;
	      window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/reports/aggregated_sales/export', _extends({
	        token: localStorage.getItem('id_token')
	      }, params)));
	    },
	
	
	    showExcise: (0, _debounce2.default)(function () {
	      var _this14 = this;
	
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	      this.loadingExcise = true;
	      _report2.default.excisePeriods({
	        page: page,
	        limit: limit
	      }).then(function () {
	        _this14.loadingExcise = false;
	      }).catch(function () {
	        _this14.loadingExcise = false;
	      });
	    }, 800),
	
	    exciseStatusClass: function exciseStatusClass(status) {
	      return {
	        'bg-info': status === 'Ongoing',
	        'bg-success': status === 'Ready to be closed',
	        'bg-default': status === 'Closed',
	        'bg-warning': status === 'Changed'
	      };
	    },
	    viewExciseMonthlyReport: function viewExciseMonthlyReport(excisePeriod) {
	      this.$router.push({
	        name: 'exciseMonthlyReport',
	        params: {
	          id: excisePeriod.id
	        }
	      });
	    },
	    showBills: function showBills() {
	      var _this15 = this;
	
	      this.loadingBills = true;
	      _report2.default.bills(this.billsDateRange, this.billClientId).then(function (report) {
	        _this15.loadingBills = false;
	        _this15.billData = report;
	      });
	    },
	    showFees: function showFees() {
	      var _this16 = this;
	
	      this.loadingFees = true;
	      _report2.default.fees(this.feesMonth, this.client).then(function (report) {
	        _this16.loadingFees = false;
	        _this16.feeData = report;
	        _this16.feeReportLoaded = true;
	      });
	    },
	    showWarehouses: function showWarehouses() {
	      var _this17 = this;
	
	      this.warehouseLoading = true;
	      this.warehouseTransactionData = [];
	      this.warehouseData = [];
	      var params = {};
	      params.warehouseId = this.warehouse;
	      params.transactionTypeId = this.transaction_type_id;
	      params.transactionDateRange = this.transactionDateRange;
	      params.asOfDate = this.asOfDate;
	      params.dateOption = this.dateOption;
	      params.groupByProduct = this.groupByProduct;
	      params.hideOutOfStock = this.hideOutOfStock;
	      _report2.default.warehouseTransactions(params).then(function (report) {
	        _this17.warehouseLoading = false;
	        if (!_this17.groupByProduct) {
	          _this17.warehouseTransactionData = report;
	        } else {
	          _this17.warehouseData = report;
	        }
	      });
	    },
	    onTransactionDateRangeChange: function onTransactionDateRangeChange(name, value) {
	      this[name] = value;
	    },
	
	
	    onFilterChangeDebounce: (0, _debounce2.default)(function (name, value) {
	      this.onFilterChange(name, value);
	    }, 800),
	    onFilterChange: function onFilterChange(name, value) {
	      if ((name === 'billsDateRange' || name === 'salesDateRange' || name === 'feesDateRange' || name === 'exciseDateRange') && value === undefined) {
	        this[name] = [(0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()];
	      } else {
	        this[name] = value;
	      }
	
	      if (name === 'billsDateRange') {
	        this.showBills();
	        return;
	      }
	      if (name === 'feesMonth') {
	        if (this.feesMonth != null) {
	          this.showFees();
	        } else {
	          this.feeData = [];
	          this.feeReportLoaded = false;
	        }
	        return;
	      }
	
	      this.showSales();
	    },
	    downloadBillReport: function downloadBillReport() {
	      var params = {};
	
	      if (this.rowLimit > 0) {
	        params.limit = this.rowLimit;
	      }
	
	      if (this.billClientId != null) {
	        params.client_id = this.billClientId;
	      }
	
	      if (this.billsDateRange[0] && this.billsDateRange[1]) {
	        params.start = (0, _moment2.default)(this.billsDateRange[0]).format('YYYY-MM-DD');
	        params.end = (0, _moment2.default)(this.billsDateRange[1]).format('YYYY-MM-DD');
	      }
	
	      window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/reports/bills/export/', _extends({
	        token: localStorage.getItem('id_token')
	      }, params)));
	    },
	    link: function link(bill) {
	      var name = bill.billTypeName !== 'Credit Note' ? 'bills.edit' : 'bills.creditNote';
	      var routeData = this.$router.resolve({
	        params: { id: bill.id },
	        name: name
	      });
	      window.open(routeData.href, '_blank');
	    },
	    querySearch: function querySearch(queryString, cb) {
	      var options = this.clientData.map(function (o) {
	        o.value = o.name.toString().toLowerCase();
	        return o;
	      });
	      var createFilter = function createFilter(option) {
	        return option.value.indexOf(queryString.toLowerCase()) === 0;
	      };
	      var results = queryString ? options.filter(createFilter) : options;
	      cb(results);
	    },
	    handleSelect: function handleSelect(item) {
	      this.client_id = item;
	      this.showFees();
	    },
	    handleSelectWarehouse: function handleSelectWarehouse(item) {
	      this.warehouse_id = item;
	      this.showWarehouses();
	    },
	    handleSelectTransaction: function handleSelectTransaction(item) {
	      this.transaction_id = item;
	    },
	    downloadFeesReport: function downloadFeesReport() {
	      var params = {};
	
	      if (this.rowLimit > 0) {
	        params.limit = this.rowLimit;
	      }
	
	      if (this.client != null) {
	        params.client = this.client;
	      }
	      if (this.feesDateRange[0] && this.feesDateRange[1]) {
	        params.start = (0, _moment2.default)(this.feesDateRange[0]).format('YYYY-MM-DD');
	        params.end = (0, _moment2.default)(this.feesDateRange[1]).format('YYYY-MM-DD');
	      }
	
	      window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/reports/fees/export/', _extends({
	        token: localStorage.getItem('id_token')
	      }, params)));
	    },
	    downloadSalesReport: function downloadSalesReport() {
	      var params = {};
	
	      if (this.rowLimit > 0) {
	        params.limit = this.rowLimit;
	      }
	
	      if (this.client != null) {
	        params.client = this.client;
	      }
	      if (this.salesDateRange[0] && this.salesDateRange[1]) {
	        params.start = (0, _moment2.default)(this.salesDateRange[0]).format('YYYY-MM-DD');
	        params.end = (0, _moment2.default)(this.salesDateRange[1]).format('YYYY-MM-DD');
	      }
	      params.filter = this.salesFilter;
	      params.group = this.salesGrouping;
	      params.type = this.salesType;
	
	      window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/reports/sales/export/', _extends({
	        token: localStorage.getItem('id_token')
	      }, params)));
	    },
	    downloadYtdSalesReport: function downloadYtdSalesReport() {
	      var params = {};
	
	      if (this.salesDateRange[0] && this.salesDateRange[1]) {
	        params.start = (0, _moment2.default)(this.salesDateRange[0]).format('YYYY-MM-DD');
	        params.end = (0, _moment2.default)(this.salesDateRange[1]).format('YYYY-MM-DD');
	      }
	      if (this.salesFilter) {
	        params.filter = this.salesFilter;
	      }
	      if (this.salesType) {
	        params.type = this.salesType;
	      }
	
	      window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/reports/sales/export-ytd', _extends({
	        token: localStorage.getItem('id_token')
	      }, params)));
	    },
	    downloadWarehousesReport: function downloadWarehousesReport() {
	      var params = {};
	
	      if (this.rowLimit > 0) {
	        params.limit = this.rowLimit;
	      }
	
	      if (this.client != null) {
	        params.warehouse_id = this.warehouse;
	      }
	
	      if (this.transaction_type_id) {
	        params.transaction_type_id = this.transaction_type_id;
	      }
	
	      if (this.dateOption === 'as_of_date') {
	        if (this.asOfDate) {
	          params.asOfDate = (0, _moment2.default)(this.asOfDate).format('YYYY-MM-DD');
	        }
	
	        if (this.hideOutOfStock) {
	          params.hide_out_of_stock = this.hideOutOfStock;
	        }
	      } else {
	        if (this.transactionDateRange.length) {
	          params.start = (0, _moment2.default)(this.transactionDateRange[0]).format('YYYY-MM-DD');
	          params.end = (0, _moment2.default)(this.transactionDateRange[1]).format('YYYY-MM-DD');
	        }
	      }
	
	      if (this.groupByProduct) {
	        params.group_by_product = this.groupByProduct;
	      }
	      var url = _helpers2.default.buildUrl(("https://api.kundan.no") + '/reports/warehouses_transactions/export/', _extends({
	        token: localStorage.getItem('id_token')
	      }, params));
	      window.open(url);
	    },
	    downloadWarehousesReportBeta: function downloadWarehousesReportBeta() {
	      var params = {};
	
	      if (this.rowLimit > 0) {
	        params.limit = this.rowLimit;
	      }
	
	      if (!this.warehouse) {
	        this.$message({
	          showClose: true,
	          message: this.$t('static.reports.warehouse.warehouse_required'),
	          customClass: 'error'
	        });
	        return;
	      }
	
	      if (!this.transactionMonth) {
	        this.$message({
	          showClose: true,
	          message: this.$t('static.reports.warehouse.month_required'),
	          customClass: 'error'
	        });
	        return;
	      }
	
	      if (this.client != null) {
	        params.warehouse_id = this.warehouse;
	      }
	
	      params.month = (0, _moment2.default)(this.transactionMonth).format('YYYY-MM-DD');
	      params.monthly = 1;
	
	      window.open(_helpers2.default.buildUrl(("https://api.kundan.no") + '/reports/warehouses_transactions/export/', _extends({
	        token: localStorage.getItem('id_token')
	      }, params)));
	    }
	  }, _defineProperty(_extends2, 'link', function link(item, key) {
	    var id = 0;
	    var name = '';
	    switch (key) {
	      case 'orderNumber':
	        id = item.orderId;
	        name = 'orders.edit';
	        break;
	      case 'client':
	        id = item.clientId;
	        name = 'clients.edit';
	        break;
	      case 'productName':
	        id = item.productId;
	        name = 'products.edit';
	        break;
	      case 'number':
	        id = item.order_id;
	        name = 'orders.edit';
	        break;
	      case 'order_number':
	        id = item.order_id;
	        name = 'orders.edit';
	        break;
	      case 'product_name':
	        id = item.product_id;
	        name = 'products.edit';
	        break;
	      case 'order_id':
	        id = item.order_id;
	        name = 'orders.edit';
	        break;
	    }
	    var routeData = this.$router.resolve({
	      params: { id: id },
	      name: name
	    });
	    window.open(routeData.href, '_blank');
	  }), _defineProperty(_extends2, 'camalize', function camalize(str) {
	    return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
	      return chr.toUpperCase();
	    });
	  }), _extends2)),
	
	  components: {
	    VTable: __webpack_require__(33),
	    VDateRange: __webpack_require__(156),
	    VMonth: __webpack_require__(2709),
	    VSelect: __webpack_require__(51),
	    VText: __webpack_require__(182),
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19)
	  }
	};

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _stock = __webpack_require__(162);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _stock3 = __webpack_require__(68);
	
	var _stock4 = _interopRequireDefault(_stock3);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        warehouseId: {
	          value: '',
	          type: 'select'
	        },
	        transactionDate: {
	          value: new Date(),
	          type: 'date',
	          attributes: {
	            datePickerOptions: {
	              disabledDate: this.disabledDate
	            }
	          }
	        },
	        descriptions: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      loading: true,
	      tabIndex: 'first',
	      fields: {
	        productId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        batchId: {
	          value: '',
	          type: 'select'
	        },
	        physicalCount: {
	          value: '0',
	          type: 'number'
	        },
	        currentCount: {
	          value: '0',
	          type: 'number',
	          disabled: true
	        },
	        variance: {
	          value: '0',
	          type: 'number',
	          disabled: true
	        }
	      },
	      isImport: true,
	      isExport: true,
	      download: this.downloadProduct,
	      server: {
	        url: ''
	      }
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentStockProducts: 'currentStockProductsCustom',
	    warehouses: 'allWarehouses'
	  }), {
	    additionalData: function additionalData() {
	      var Obj = Object.create({});
	      Obj.fromWarehouseId = this.formBasicInformation.warehouseId;
	      return Obj;
	    }
	  }),
	
	  watch: {
	    warehouses: function warehouses(_warehouses) {
	      var _this = this;
	
	      var data = _warehouses.items.filter(function (item) {
	        return !item.isSharedToYou;
	      });
	      this.formBasicInformation.setOptions('warehouseId', data.map(function (item) {
	        return { id: item.id, name: item.name + (item.isLocked ? _this.$t('static.warehouse.info.locked') : ''), disabled: item.isLocked };
	      }));
	    },
	
	    'formBasicInformation.warehouseId': function formBasicInformationWarehouseId(warehouseId) {
	      var _this2 = this;
	
	      this.server = {
	        url: ("https://api.kundan.no") + '/stocks/' + this.formBasicInformation.warehouseId + '/import-product?token=' + localStorage.getItem('id_token'),
	        process: {
	          onload: function onload(res) {
	            var name = 'inventory.stock.edit';
	
	            var obj = JSON.parse(res);
	            console.log(obj);
	            _this2.$router.push({
	              name: name,
	              params: { id: obj.id }
	            });
	          }
	        }
	      };
	      _store2.default.dispatch('setStockSelectedWarehouse', warehouseId);
	    },
	
	    $route: function $route() {
	      this.warehouseTarget();
	    }
	  },
	
	  created: function created() {
	    this.loading = false;
	  },
	
	
	  methods: {
	    disabledDate: function disabledDate(date) {
	      var nextDate = date.setDate(date.getDate());
	      var prevDate = date.setDate(date.getDate() + 350);
	      return prevDate < new Date() || nextDate > new Date();
	    },
	    warehouseTarget: function warehouseTarget() {
	      var warehouseIds = this.warehouses.items.map(function (item) {
	        return item.id;
	      });
	      var targeId = this.$router.currentRoute.hash.substring(1);
	      if (warehouseIds.indexOf(parseInt(targeId)) !== -1) {
	        this.formBasicInformation.setFieldValue('warehouseId', targeId);
	      }
	    },
	    store: function store() {
	      var _this3 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _stock4.default.send(Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts }));
	
	      _stock2.default.store(client).then(function () {
	        _this3.$message({
	          message: _this3.$t('static.stock.create.success'),
	          type: 'success'
	        });
	        _this3.$router.push({
	          name: 'inventory.stock.index'
	        });
	      }).catch(function (errors) {
	        _this3.formBasicInformation.loading = false;
	        _this3.formBasicInformation.recordErrors(errors);
	        var message = errors.message;
	        if (errors.message) {
	          _this3.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    saveDraft: function saveDraft() {
	      var _this4 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _stock4.default.send(Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts }));
	
	      _stock2.default.saveDraft(client).then(function () {
	        _this4.$message({
	          message: _this4.$t('static.stock.draft.success'),
	          type: 'success'
	        });
	        _this4.$router.push({
	          name: 'inventory.stock.index'
	        });
	      }).catch(function (errors) {
	        _this4.formBasicInformation.loading = false;
	        _this4.formBasicInformation.recordErrors(errors);
	        var message = errors.message;
	        if (errors.message) {
	          _this4.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    downloadProduct: function downloadProduct() {
	      console.log('clicked');
	      _stock2.default.downloadProduct(this.formBasicInformation.warehouseId);
	    },
	    searchMethod: function searchMethod(search, field) {
	      return Promise.all([_product2.default.searchAll({ search: search })]);
	    }
	  },
	  mounted: function mounted() {
	    var _this5 = this;
	
	    _store2.default.dispatch('allCurrentStockProductsCustom', []);
	    Promise.all([_warehouse2.default.all()]).then(function () {
	      _store2.default.dispatch('setStockSelectedWarehouse', 0);
	      _this5.warehouseTarget();
	    });
	
	    this.server = {
	      url: ("https://api.kundan.no") + '/stocks/' + this.formBasicInformation.warehouseId + '?token=' + localStorage.getItem('id_token')
	
	    };
	  },
	
	  components: {
	    VForm: __webpack_require__(9),
	    VProductsTable: __webpack_require__(123),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _stock = __webpack_require__(162);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _stock3 = __webpack_require__(68);
	
	var _stock4 = _interopRequireDefault(_stock3);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        warehouseId: {
	          value: '',
	          type: 'select'
	        },
	        transactionDate: {
	          value: new Date(),
	          type: 'date',
	          attributes: {
	            datePickerOptions: {
	              disabledDate: this.disabledDate
	            }
	          }
	        },
	        descriptions: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      loading: true,
	      tabIndex: 'first',
	      fields: {
	        productId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        batchId: {
	          value: '',
	          type: 'select'
	        },
	        physicalCount: {
	          value: '0',
	          type: 'number'
	        },
	        currentCount: {
	          value: '0',
	          type: 'number',
	          disabled: true
	        },
	        variance: {
	          value: '0',
	          type: 'number',
	          disabled: true
	        }
	      },
	      currentStock: {
	        products: [],
	        warehouse: {
	          name: ''
	        }
	      }
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentStockProducts: 'currentStockProductsCustom',
	    warehouses: 'allWarehouses'
	  }), {
	    isSharedToYou: function isSharedToYou() {
	      var _this = this;
	
	      var data = this.warehouses.items.filter(function (item) {
	        return item.id === _this.formBasicInformation.warehouseId;
	      });
	      if (data.length > 0) {
	        return data[0].isSharedToYou;
	      }
	      return false;
	    }
	  }),
	
	  watch: {
	    warehouses: function warehouses(_warehouses) {
	      var _this2 = this;
	
	      this.formBasicInformation.setOptions('warehouseId', _warehouses.items.map(function (item) {
	        return { id: item.id, name: item.name + (item.isLocked ? _this2.$t('static.warehouse.info.locked') : ''), disabled: item.isLocked };
	      }));
	    },
	
	    'formBasicInformation.warehouseId': function formBasicInformationWarehouseId(warehouseId) {
	      _store2.default.dispatch('setStockSelectedWarehouse', warehouseId);
	    },
	
	    currentStock: function currentStock(_currentStock) {
	      _store2.default.dispatch('allCurrentStockProductsCustom', this.currentStock.products.map(function (c) {
	        return {
	          qty: c.qty,
	          id: c.product.id,
	          batchId: c.batchId,
	          variance: c.variance,
	          productId: c.product,
	          physicalCount: c.physicalCount,
	          currentCount: c.currentCount
	        };
	      }));
	    }
	  },
	
	  created: function created() {},
	
	
	  methods: {
	    disabledDate: function disabledDate(date) {
	      var nextDate = date.setDate(date.getDate());
	      var prevDate = date.setDate(date.getDate() + 14);
	      return prevDate < new Date() || nextDate > new Date();
	    },
	    update: function update() {
	      var _this3 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _stock4.default.send(Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts }));
	
	      _stock2.default.update(this.$route.params.id, client).then(function () {
	        _this3.$message({
	          message: _this3.$t('static.stock.create.success'),
	          type: 'success'
	        });
	        _this3.$router.push({
	          name: 'inventory.stock.index'
	        });
	      }).catch(function (errors) {
	        _this3.formBasicInformation.loading = false;
	        _this3.formBasicInformation.recordErrors(errors);
	        var message = errors.message;
	        if (errors.message) {
	          _this3.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    updateDraft: function updateDraft() {
	      var _this4 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _stock4.default.send(Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts }));
	
	      _stock2.default.updateDraft(this.$route.params.id, client).then(function () {
	        _this4.$message({
	          message: _this4.$t('static.stock.draft.success'),
	          type: 'success'
	        });
	        _this4.$router.push({
	          name: 'inventory.stock.index'
	        });
	      }).catch(function (errors) {
	        _this4.formBasicInformation.loading = false;
	        _this4.formBasicInformation.recordErrors(errors);
	        var message = errors.message;
	        if (errors.message) {
	          _this4.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    downloadProduct: function downloadProduct() {
	      _stock2.default.downloadProduct(this.formBasicInformation.warehouseId);
	    },
	    searchMethod: function searchMethod(search, field) {
	      return Promise.all([_product2.default.searchAll({ search: search })]);
	    },
	    deleteDraft: function deleteDraft() {
	      var _this5 = this;
	
	      var me = this;
	      this.$confirm(this.$t('static.stock.draft.deleteMessage'), 'Warning', {
	        confirmButtonText: 'OK',
	        cancelButtonText: 'Cancel',
	        type: 'warning'
	      }).then(function () {
	        me.formBasicInformation.loading = true;
	        _stock2.default.destroy(_this5.$route.params.id).then(function () {
	          me.$router.push({
	            name: 'inventory.stock.index'
	          });
	        });
	      }).catch(function () {});
	    }
	  },
	  mounted: function mounted() {
	    var _this6 = this;
	
	    _store2.default.dispatch('allCurrentStockProductsCustom', []);
	    Promise.all([_warehouse2.default.all(), _stock2.default.show(this.$route.params.id)]).then(function (data) {
	      _this6.formBasicInformation.assignData(data[1]);
	      _this6.currentStock = data[1];
	      _this6.loading = false;
	    });
	  },
	
	  components: {
	    VForm: __webpack_require__(9),
	    VProductsTable: __webpack_require__(123),
	    VMessage: __webpack_require__(13)
	  }
	};

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(5);
	
	var _stock = __webpack_require__(162);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _bridgeHandoff = __webpack_require__(81);
	
	var _bridgeHandoff2 = _interopRequireDefault(_bridgeHandoff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sortValue: '',
	      limit: 25
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    stocks: 'paginateStocks'
	  }), {
	    stocksList: function stocksList() {
	      return this.stocks.items.map(function (b) {
	        return b;
	      });
	    }
	  }),
	
	  watch: {
	    $route: function $route() {
	      this.all(1, this.limit);
	    }
	  },
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19)
	  },
	
	  mixins: [_search2.default, _bridgeHandoff2.default],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.setInnerSidebar([{
	      title: this.$t('static.inventory.transaction.title'),
	      options: [{
	        title: this.$t('static.stock.filters.title'),
	        route: {
	          name: 'inventory.stock.index'
	        }
	      }, {
	        title: this.$t('static.adjustment.filters.title'),
	        route: {
	          name: 'inventory.adjustment.index'
	        }
	      }, {
	        title: this.$t('static.purchase.filters.title'),
	        route: {
	          name: 'inventory.purchase.index'
	        }
	      }, {
	        title: this.$t('static.transfer.filters.title'),
	        route: {
	          name: 'inventory.transfer.index'
	        }
	      }],
	      button: this.bridgeStockWriteBlocked ? null : {
	        title: '+ ' + this.$t('static.warehouse.addTransaction.title'),
	        route: {
	          name: 'inventory.transaction.index'
	        }
	      }
	
	    }, {
	      title: this.$t('static.warehouse.filters.title'),
	      options: [{
	        title: this.$t('static.warehouse.filters.view'),
	        route: {
	          name: 'warehouse.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.warehouse.create.title'),
	        route: {
	          name: 'warehouse.create'
	        }
	      }
	    }]);
	
	    _account2.default.rememberPerPage('get', { from: 'stock_count' }).then(function (data) {
	      _this.limit = data.size;
	      _this.all(1, _this.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    formatDate: function formatDate(value) {
	      var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';
	
	      if (!value) {
	        return '-';
	      }
	      var m = (0, _moment2.default)(value);
	      return m.isValid() ? m.format(pattern) : '-';
	    },
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'stock_count', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this3 = this;
	
	      this.loading = true;
	      _stock2.default.items({
	        page: page,
	        limit: limit,
	        search: this.getSearch(this.limit),
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this3.loading = false;
	      }).catch(function () {
	        _this3.loadProductsing = false;
	      });
	    }, 800),
	
	    showStatus: function showStatus(p) {
	      if (p.status == 1) {
	        return "Completed";
	      } else {
	        return 'Draft';
	      }
	    },
	    editStock: function editStock(stock) {
	      var name = 'inventory.stock.view';
	      if (stock.status == 'draft' || stock.status == 'pending') {
	        name = 'inventory.stock.edit';
	      }
	      this.$router.push({
	        name: name,
	        params: { id: stock.id }
	      });
	    }
	  })
	};

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(5);
	
	var _stock = __webpack_require__(162);
	
	var _stock2 = _interopRequireDefault(_stock);
	
	var _stock3 = __webpack_require__(68);
	
	var _stock4 = _interopRequireDefault(_stock3);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      tabIndex: 'first',
	      tabSecond: 'product',
	      currentStock: {
	        products: [],
	        warehouse: {
	          name: ''
	        }
	      }
	    };
	  },
	
	
	  computed: {
	    productList: function productList() {
	      return this.currentStock.products.map(function (c) {
	        return {
	          sku: c.product.sku,
	          name: c.product.name,
	          physicalCount: c.physicalCount,
	          currentCount: c.currentCount,
	          variance: c.variance
	        };
	      });
	    }
	  },
	
	  watch: {
	    currentStock: function currentStock(_currentStock) {
	      console.log(_currentStock);
	    }
	  },
	
	  created: function created() {
	    this.loading = false;
	  },
	
	
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    Promise.all([_stock2.default.show(this.$route.params.id)]).then(function (data) {
	      _this.currentStock = data[0];
	    });
	  },
	
	  components: {
	    VTable: __webpack_require__(33)
	  }
	};

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _subscriberList = __webpack_require__(192);
	
	var _subscriberList2 = _interopRequireDefault(_subscriberList);
	
	var _subscriberList3 = __webpack_require__(165);
	
	var _subscriberList4 = _interopRequireDefault(_subscriberList3);
	
	var _publicProfile = __webpack_require__(233);
	
	var _publicProfile2 = _interopRequireDefault(_publicProfile);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        selectDefaultEmail: {
	          value: 'true',
	          type: 'checkbox'
	        },
	        fromEmail: {
	          value: '',
	          type: 'email'
	        },
	        selectDefaultName: {
	          value: 'true',
	          type: 'checkbox'
	        },
	        fromName: {
	          value: '',
	          type: 'text'
	        },
	        description: {
	          value: '',
	          type: 'textarea'
	        },
	        doubleOptinRequired: {
	          value: 1,
	          type: 'switch'
	        },
	        optinEmailSubject: {
	          value: '',
	          type: 'text'
	        },
	        optinEmailBody: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      defaultName: '',
	      defaultEmail: '',
	      loading: false,
	      optinEmailSubjectHolder: '',
	      optinEmailBodyHolder: ''
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({})),
	
	  watch: {
	    'form.selectDefaultName': function formSelectDefaultName(value) {
	      if (value) {
	        this.form.disableField('fromName');
	        this.form.setFieldValue('fromName', this.defaultName);
	      } else {
	        this.form.enableField('fromName');
	        this.form.setFieldValue('fromName', '');
	      }
	    },
	
	    'form.selectDefaultEmail': function formSelectDefaultEmail(value) {
	      if (value) {
	        this.form.disableField('fromEmail');
	        this.form.setFieldValue('fromEmail', this.defaultEmail);
	      } else {
	        this.form.enableField('fromEmail');
	        this.form.setFieldValue('fromEmail', '');
	      }
	    },
	
	    'form.doubleOptinRequired': function formDoubleOptinRequired(value) {
	      if (value) {
	        this.addRemoveFields(true);
	      } else {
	        this.addRemoveFields(false);
	      }
	    }
	  },
	
	  created: function created() {
	    this.getOrgEmailName();
	  },
	
	
	  methods: {
	    getOrgEmailName: function getOrgEmailName() {
	      var _this = this;
	
	      _publicProfile2.default.show().then(function (data) {
	        _this.defaultName = data.orgName;
	        _this.defaultEmail = data.orgEmail;
	
	        _this.form.setFieldValue('fromName', _this.defaultName);
	        _this.form.setFieldValue('fromEmail', _this.defaultEmail);
	        _this.form.disableField('fromName');
	        _this.form.disableField('fromEmail');
	
	        _this.optinEmailSubjectHolder = data.optinEmailSubject;
	        _this.optinEmailBodyHolder = data.optinEmailBody;
	        _this.form.setFieldValue('optinEmailSubject', _this.optinEmailSubjectHolder);
	        _this.form.setFieldValue('optinEmailBody', _this.optinEmailBodyHolder);
	      }).catch(function (err) {
	        console.log('the error');
	        console.log(err);
	      });
	    },
	    addRemoveFields: function addRemoveFields(status) {
	      if (status === true) {
	        this.form.setFieldValue('optinEmailSubject', this.optinEmailSubjectHolder);
	        this.form.setFieldValue('optinEmailBody', this.optinEmailBodyHolder);
	        this.form.showField('optinEmailSubject');
	        this.form.showField('optinEmailBody');
	      } else {
	        this.form.hideField('optinEmailSubject');
	        this.form.hideField('optinEmailBody');
	      }
	    },
	    store: function store() {
	      var _this2 = this;
	
	      this.form.loading = true;
	      var subscriberList = _subscriberList4.default.send(this.form.data());
	      _subscriberList2.default.store(subscriberList).then(function () {
	        _this2.form.loading = false;
	        _this2.$message({
	          message: 'Create successfully',
	          type: 'success'
	        });
	      }).catch(function (errors) {
	        _this2.form.loading = false;
	        _this2.form.recordErrors(errors);
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _subscriberList = __webpack_require__(192);
	
	var _subscriberList2 = _interopRequireDefault(_subscriberList);
	
	var _subscriber = __webpack_require__(483);
	
	var _subscriber2 = _interopRequireDefault(_subscriber);
	
	var _subscriberList3 = __webpack_require__(165);
	
	var _subscriberList4 = _interopRequireDefault(_subscriberList3);
	
	var _publicProfile = __webpack_require__(233);
	
	var _publicProfile2 = _interopRequireDefault(_publicProfile);
	
	var _client = __webpack_require__(43);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _clientGroup = __webpack_require__(93);
	
	var _clientGroup2 = _interopRequireDefault(_clientGroup);
	
	var _clientGroupModal2 = __webpack_require__(2691);
	
	var _clientGroupModal3 = _interopRequireDefault(_clientGroupModal2);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      form: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        selectDefaultEmail: {
	          value: 'true',
	          type: 'checkbox'
	        },
	        fromEmail: {
	          value: '',
	          type: 'email'
	        },
	        selectDefaultName: {
	          value: 'true',
	          type: 'checkbox'
	        },
	        fromName: {
	          value: '',
	          type: 'text'
	        },
	        description: {
	          value: '',
	          type: 'textarea'
	        },
	        doubleOptinRequired: {
	          value: 1,
	          type: 'switch'
	        },
	        optinEmailSubject: {
	          value: '',
	          type: 'text'
	        },
	        optinEmailBody: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      selectedRule: '',
	      ruleOptions: [{ id: 'clientGroupIds', name: 'ClientGroup' }],
	      selectedRuleClientGroups: [],
	      allRuleClientGroups: [],
	      populateRules: [],
	      selectedClientGroupsLoading: false,
	      defaultName: '',
	      defaultEmail: '',
	      tempName: '',
	      tempEmail: '',
	      activeName: '1',
	      subscribers: {},
	      allClients: [],
	      allClientGroups: [],
	      selectedClients: [],
	      selectedClientGroups: [],
	      newSelectedClientGroups: [],
	      selectClientError: '',
	      selectClientGroupError: '',
	      addingClients: false,
	      addingClientGroups: false,
	      loading: false,
	      loadingClients: false,
	      loadingClientsGroup: false,
	      loadingSubscribers: false,
	      tempDataHolder: [],
	      tempIdHolder: [],
	      subscribeSwitchData: [],
	      filter: 'all',
	      FilterTypes: [{ id: 'all', name: this.$t('static.subscriberList.edit.filters.all') }, { id: 'unsubscribed', name: this.$t('static.subscriberList.edit.filters.unsubscribe') }],
	      sendingEmailsLoading: false,
	      optinEmailSubjectHolder: '',
	      optinEmailBodyHolder: '',
	      limit: 25
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    subscriberList: 'subscriberList',
	    subscriber: 'subscriber',
	    modifiedClientGroup: 'modifiedClientGroup',
	    cancelClientGroupAdd: 'cancelClientGroupAdd'
	  }), {
	    allClientsList: function allClientsList() {
	      return this.allClients.map(function (c) {
	        return { id: c.id, name: c.name || c.firstName + ' ' + c.lastName, disabled: c.disabled };
	      });
	    }
	  }),
	
	  watch: {
	    'form.doubleOptinRequired': function formDoubleOptinRequired(value) {
	      if (value) {
	        this.addRemoveFields(true);
	      } else {
	        this.addRemoveFields(false);
	      }
	    },
	
	    'form.selectDefaultName': function formSelectDefaultName(value) {
	      if (value) {
	        this.setThefield('fromName', this.defaultName, 'disable');
	      } else {
	        this.setThefield('fromName', this.tempName, 'enable');
	      }
	    },
	
	    'form.selectDefaultEmail': function formSelectDefaultEmail(value) {
	      if (value) {
	        this.setThefield('fromEmail', this.defaultEmail, 'disable');
	      } else {
	        this.setThefield('fromEmail', this.tempEmail, 'enable');
	      }
	    },
	
	    selectedClientGroups: function selectedClientGroups(newVal, oldVal) {
	      if (newVal.length > oldVal.length) {
	        var self = this;
	        setTimeout(function () {
	          self.subscriberList.currentClientGroup = newVal[newVal.length - 1];
	          self.clientGroupModal();
	        }, 500);
	      } else {}
	    },
	    modifiedClientGroup: function modifiedClientGroup(_modifiedClientGroup) {
	      var key = this.subscriberList.currentClientGroup;
	      this.tempDataHolder.push({ group: key, items: _modifiedClientGroup.items });
	
	      var self = this;
	      _modifiedClientGroup.items.forEach(function (item) {
	        if (item.status === true) {
	          self.newSelectedClientGroups.push(item.id);
	        }
	      });
	    },
	    cancelClientGroupAdd: function cancelClientGroupAdd(_cancelClientGroupAdd) {
	      if (_cancelClientGroupAdd.items === true) {
	        this.selectedClientGroups.pop();
	      }
	    },
	    selectedRule: function selectedRule(value) {
	      if (value === 'clientGroupIds') {
	        var rules = this.populateRules.rules.map(function (item) {
	          return { id: item.id, name: item.name };
	        });
	        this.allRuleClientGroups = rules;
	        this.selectedRuleClientGroups = rules.map(function (item) {
	          return item.id.toString();
	        });
	      }
	    },
	    $route: function $route() {
	      this.urlCurrentTab();
	    },
	    activeName: function activeName(value) {
	      this.assignTab(value);
	    }
	  },
	
	  mounted: function mounted() {
	    this.urlCurrentTab();
	    this.assignTab(this.activeName);
	    this.show();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    activateSubscriber: function activateSubscriber(type) {
	      var _this = this;
	
	      var message = type ? this.$t('static.subscriberList.edit.subscribers.subscribe') : this.$t('static.subscriberList.edit.subscribers.unsubscribe');
	      var warningMsg = type ? this.$t('static.subscriberList.edit.subscribers.ableToReceiveAll') : this.$t('static.subscriberList.edit.subscribers.unableToReceiveAll');
	      this.$confirm(warningMsg, this.$t('static.subscriberList.edit.subscribers.subscribeConfirmHeaderMsg'), {
	        confirmButtonText: message,
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _subscriber2.default.subscribeSwitchAll({ list_id: _this.$route.params.id, status: !type }).then(function () {
	          _this.fetchSubscriber(_this.subscribers.pagination.currentPage, _this.limit);
	          _this.$message({
	            message: message + ' successfully',
	            type: 'success'
	          });
	        }).catch(function (errors) {
	          console.log(errors);
	          _this.$message({
	            message: 'Something went wrong!',
	            type: 'error'
	          });
	        });
	      }).catch(function () {
	        console.log('go back');
	      });
	    },
	    assignTab: function assignTab(value) {
	      var tab = '';
	      if (value == '3') {
	        tab = '#rules';
	      } else if (value == '2') {
	        tab = '#settings';
	      } else {
	        tab = '#subscribers';
	      }
	      history.pushState({}, null, '/#' + this.$route.path + tab);
	    },
	    urlCurrentTab: function urlCurrentTab() {
	      if (this.$router.currentRoute.hash == '#rules') {
	        this.activeName = '3';
	      } else if (this.$router.currentRoute.hash == '#settings') {
	        this.activeName = '2';
	      } else {
	        this.activeName = '1';
	      }
	    },
	    onChangeRulesByGroup: function onChangeRulesByGroup(name, value) {
	      this[name] = value;
	    },
	    saveRule: function saveRule() {
	      var _this2 = this;
	
	      this.selectedClientGroupsLoading = true;
	      var converted = this.selectedRuleClientGroups.map(function (item) {
	        return parseInt(item);
	      });
	      _subscriberList2.default.storeRules(this.$route.params.id, { rules: this.selectedRule, groups: converted }).then(function () {
	        _this2.form.loading = false;
	        _this2.$message({
	          message: 'Save successfully',
	          type: 'success'
	        });
	        _this2.selectedClientGroupsLoading = false;
	      }).catch(function (errors) {
	        _this2.selectedClientGroupsLoading = false;
	      });
	    },
	    perPage: function perPage(size) {
	      var _this3 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'subscriber_list', perPage: size }).then(function (data) {
	        _this3.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    selectClientRemote: function selectClientRemote(query) {
	      if (query !== '') {
	        this.fetchClients(query);
	      }
	    },
	    selectClientGroupRemote: function selectClientGroupRemote(query) {
	      if (query !== '') {
	        this.fetchClientGroups(query);
	      }
	    },
	    selectRuleClientGroupRemote: function selectRuleClientGroupRemote(query) {
	      if (query !== '') {
	        this.fetchClientGroups(query, 'rules');
	      }
	    },
	    addRemoveFields: function addRemoveFields(status) {
	      if (status === true) {
	        this.form.setFieldValue('optinEmailSubject', this.optinEmailSubjectHolder);
	        this.form.setFieldValue('optinEmailBody', this.optinEmailBodyHolder);
	        this.form.showField('optinEmailSubject');
	        this.form.showField('optinEmailBody');
	        this.form.clearErrors('optinEmailSubject');
	        this.form.clearErrors('optinEmailBody');
	      } else {
	        this.form.hideField('optinEmailSubject');
	        this.form.hideField('optinEmailBody');
	      }
	    },
	    clientGroupModal: function clientGroupModal() {
	      this.setModalContent(function () {
	        return _clientGroupModal3.default;
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    show: function show() {
	      var _this4 = this;
	
	      this.loading = true;
	      Promise.all([_subscriberList2.default.show(this.$route.params.id), _subscriber2.default.all(this.$route.params.id), _subscriberList2.default.showRules(this.$route.params.id)]).then(function (data) {
	        _this4.populateRules = data[2];
	        _account2.default.rememberPerPage('get', { from: 'subscriber_list' }).then(function (data2) {
	          _this4.limit = data2.size;
	          _this4.fetchSubscriber(1, _this4.limit);
	        }).catch(function (error) {
	          console.log(error);
	        });
	
	        _this4.form.assignData(_this4.subscriberList.current);
	
	        var self = _this4;
	        _publicProfile2.default.show().then(function (data2) {
	          self.defaultName = data2.orgName;
	          self.defaultEmail = data2.orgEmail;
	
	          if (self.defaultName === self.form.fromName) {
	            self.setThefield('fromName', self.defaultName, 'disable');
	          } else {
	            self.tempName = self.form.fromName;
	            self.form.selectDefaultName = '';
	          }
	
	          if (self.defaultEmail === self.form.fromEmail) {
	            self.setThefield('fromEmail', self.defaultEmail, 'disable');
	          } else {
	            self.tempEmail = self.form.fromEmail;
	            self.form.selectDefaultEmail = '';
	          }
	          _this4.loading = false;
	
	          _this4.optinEmailSubjectHolder = _this4.form.optinEmailSubject;
	          _this4.optinEmailBodyHolder = _this4.form.optinEmailBody;
	          if (_this4.form.doubleOptinRequired === 0) {
	            _this4.optinEmailSubjectHolder = data.optinEmailSubject;
	            _this4.optinEmailBodyHolder = data.optinEmailBody;
	          }
	          _this4.form.setFieldValue('optinEmailSubject', _this4.optinEmailSubjectHolder);
	          _this4.form.setFieldValue('optinEmailBody', _this4.optinEmailBodyHolder);
	        }).catch(function (err) {
	          console.log(err);
	        });
	      });
	    },
	    setThefield: function setThefield(name, value, status) {
	      if (status === 'disable') {
	        this.form.disableField(name);
	      } else if (status === 'enable') {
	        this.form.enableField(name);
	      }
	      this.form.setFieldValue(name, value);
	    },
	    update: function update() {
	      var _this5 = this;
	
	      this.form.loading = true;
	      var subscriberList = _subscriberList4.default.send(this.form.data());
	      _subscriberList2.default.update(this.$route.params.id, subscriberList).then(function () {
	        _this5.form.loading = false;
	        _this5.$message({
	          message: 'Update successfully',
	          type: 'success'
	        });
	      }).catch(function (errors) {
	        _this5.form.loading = false;
	        _this5.form.recordErrors(errors);
	      });
	    },
	    destroy: function destroy() {
	      var _this6 = this;
	
	      this.$confirm(this.$t('static.subscriberList.edit.deleteConfirmBodyMsg'), this.$t('static.subscriberList.edit.deleteConfirmHeaderMsg'), {
	        confirmButtonText: this.$t('static.subscriberList.edit.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _this6.form.loading = true;
	        _subscriberList2.default.destroy(_this6.$route.params.id).then(function () {
	          _this6.form.loading = false;
	          _this6.$message({
	            message: 'Delete successfully',
	            type: 'success'
	          });
	          _this6.$router.push({
	            name: 'subscriberList.index'
	          });
	        }).catch(function (errors) {
	          _this6.form.loading = false;
	          _this6.form.recordErrors(errors);
	        });
	      }).catch(function () {});
	    },
	    onChange: function onChange(name, value) {
	      this[name] = value;
	      if (name === 'selectedClientGroups' && this.tempIdHolder.length > value.length) {
	        var group = this.tempIdHolder.filter(function (obj) {
	          return value.indexOf(obj) === -1;
	        })[0];
	
	        var self = this;
	        this.tempIdHolder = value;
	        this.tempDataHolder.forEach(function (item) {
	          if (item.group === group) {
	            item.items.forEach(function (item2) {
	              self.newSelectedClientGroups = self.newSelectedClientGroups.filter(function (e) {
	                return e !== item2.id;
	              });
	            });
	            return;
	          }
	        });
	      }
	    },
	    fetchClients: function fetchClients() {
	      var _this7 = this;
	
	      var remoteSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var self = this;
	      this.loadingClients = true;
	      _client2.default.all(remoteSearch).then(function (clients) {
	        self.allClients = [];
	        clients.forEach(function (item) {
	          item.contacts.forEach(function (item2) {
	            self.subscriber.items.forEach(function (item3) {
	              if (item3.contact_id === item2.id) {
	                item2.exist = true;
	              }
	            });
	            var type = item2.contact_types.length > 0 ? item2.contact_types[0].name : 'Primary';
	            _this7.allClients.push({
	              id: item2.id,
	              name: item.name + ' - ' + item2.email + '(' + type + ')' + (item2.exist ? _this7.$t('static.subscriberList.edit.subscribers.alreadyInList') : ''),
	              disabled: !!item2.exist
	            });
	          });
	        });
	        _this7.loadingClients = false;
	      });
	    },
	    fetchClientGroups: function fetchClientGroups() {
	      var _this8 = this;
	
	      var remoteSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.loadingClientsGroup = true;
	      this.allClientGroups = [];
	      _clientGroup2.default.all(remoteSearch).then(function (groups) {
	        if (type === 'rules') {
	          _this8.allRuleClientGroups = groups;
	        } else {
	          _this8.allClientGroups = groups;
	        }
	        _this8.loadingClientsGroup = false;
	      });
	    },
	    deleteSubscriber: function deleteSubscriber(id) {
	      var _this9 = this;
	
	      this.$confirm(this.$t('static.subscriberList.edit.subscribers.deleteConfirmBodyMsg'), this.$t('static.subscriberList.edit.subscribers.deleteConfirmHeaderMsg'), {
	        confirmButtonText: this.$t('static.subscriberList.edit.subscribers.delete'),
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _subscriber2.default.destroy(id).then(function (response) {
	          _this9.fetchSubscriber(_this9.subscribers.pagination.currentPage, _this9.limit);
	          _this9.$message({
	            message: 'Delete successfully',
	            type: 'success'
	          });
	          _this9.autoDisableEnabled(response.contact_id, 'remove');
	        }).catch(function (errors) {
	          console.log(errors);
	        });
	      }).catch(function () {});
	    },
	    fetchSubscriber: function fetchSubscriber(page, limit) {
	      var _this10 = this;
	
	      this.loadingSubscribers = true;
	      _subscriber2.default.items(this.$route.params.id, page, limit, this.filter).then(function (subscribers) {
	        _this10.subscribers = subscribers;
	        _this10.loadingSubscribers = false;
	        _this10.subscribeSwitchSet();
	      });
	    },
	    autoDisableEnabled: function autoDisableEnabled(ids, type) {
	      var self = this;
	      if (type === 'add') {
	        ids.forEach(function (item) {
	          self.allClients.forEach(function (item2) {
	            if (parseInt(item) === item2.id) {
	              item2.disabled = true;
	            }
	          });
	        });
	      } else if (type === 'remove') {
	        self.allClients.forEach(function (item2) {
	          if (parseInt(ids) === item2.id) {
	            item2.disabled = false;
	          }
	        });
	      }
	    },
	    addClients: function addClients() {
	      var _this11 = this;
	
	      var groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this.sendingEmailsLoading = true;
	      var data = !groups ? { contacts: this.selectedClients } : { contacts: this.newSelectedClientGroups };
	      if (!groups) {
	        this.addingClients = true;
	      } else {
	        this.addingClientGroups = true;
	      }
	      _subscriber2.default.store(this.$route.params.id, data).then(function () {
	        _this11.$message({
	          message: data.contacts.length + ' email(s) successfully added to list',
	          type: 'success'
	        });
	        _this11.fetchSubscriber(_this11.subscribers.pagination.currentPage, _this11.limit);
	        _this11.autoDisableEnabled(data.contacts, 'add');
	        _this11.addingClients = false;
	        _this11.addingClientGroups = false;
	        _this11.sendingEmailsLoading = false;
	        _this11.selectedClients = [];
	        _this11.newSelectedClientGroups = [];
	        _this11.selectedClientGroups = [];
	      }).catch(function (errors) {
	        _this11.$message({
	          message: 'Something went wrong!',
	          type: 'error'
	        });
	        console.log(errors);
	        _this11.addingClients = false;
	        _this11.addingClientGroups = false;
	        _this11.sendingEmailsLoading = false;
	      });
	    },
	    subscribeSwitch: function subscribeSwitch(id) {
	      var _this12 = this;
	
	      var action = this.subscribeSwitchData[id];
	      var message = action === 1 ? this.$t('static.subscriberList.edit.subscribers.subscribe') : this.$t('static.subscriberList.edit.subscribers.unsubscribe');
	      var warningMsg = action === 1 ? this.$t('static.subscriberList.edit.subscribers.ableToReceive') : this.$t('static.subscriberList.edit.subscribers.unableToReceive');
	      this.$confirm(warningMsg, this.$t('static.subscriberList.edit.subscribers.subscribeConfirmHeaderMsg'), {
	        confirmButtonText: message,
	        cancelButtonText: this.$t('button.cancel'),
	        type: 'warning'
	      }).then(function () {
	        _subscriber2.default.subscribeSwitch(id, { status: action === 0 }).then(function (email) {
	          _this12.fetchSubscriber(_this12.subscribers.pagination.currentPage, _this12.limit);
	          _this12.$message({
	            message: email + ' ' + message + ' successfully',
	            type: 'success'
	          });
	        }).catch(function (errors) {
	          console.log(errors);
	          _this12.$message({
	            message: 'Something went wrong!',
	            type: 'error'
	          });
	        });
	      }).catch(function () {
	        console.log('go back');
	      });
	    },
	    subscribeSwitchSet: function subscribeSwitchSet() {
	      var _this13 = this;
	
	      this.subscribers.subscriber.forEach(function (item) {
	        _this13.subscribeSwitchData[item.id] = item.subscribe;
	      });
	    },
	    onChangeFilter: function onChangeFilter(filter) {
	      this.filter = filter === 'all' ? 'unsubscribed' : 'all';
	      this.fetchSubscriber(1, this.limit);
	    }
	  }),
	
	  components: {
	    VForm: __webpack_require__(9),
	    VSelect: __webpack_require__(51),
	    VPagination: __webpack_require__(16)
	  }
	};

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _subscriberList = __webpack_require__(192);
	
	var _subscriberList2 = _interopRequireDefault(_subscriberList);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _date = __webpack_require__(107);
	
	var _date2 = _interopRequireDefault(_date);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    subscriberList: 'paginatedSubscriberList'
	  })),
	
	  mounted: function mounted() {
	    this.setInnerSidebar([{
	      title: this.$t('layouts.sidebar.newsletter'),
	      options: [{
	        title: this.$t('layouts.sidebar.all'),
	        route: {
	          name: 'campaigns.index'
	        }
	      }],
	      button: {
	        title: this.$t('button.addCampaign'),
	        route: {
	          name: 'campaigns.create'
	        }
	      }
	    }, {
	      title: this.$t('layouts.sidebar.subscriberList'),
	      options: [{
	        title: this.$t('layouts.sidebar.all'),
	        route: {
	          name: 'subscriberList.index'
	        }
	      }],
	      button: {
	        title: this.$t('button.addSubscriberList'),
	        route: {
	          name: 'subscriberList.create'
	        }
	      }
	    }]);
	    this.all(1, 15);
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    all: function all(page, limit) {
	      var _this = this;
	
	      this.loading = true;
	      _subscriberList2.default.items(page, limit).then(function () {
	        _this.loading = false;
	      }).catch(function () {
	        _this.loading = false;
	      });
	    },
	    edit: function edit(id) {
	      this.$router.push({
	        name: 'subscriberList.edit',
	        params: { id: id }
	      });
	    }
	  }),
	
	  mixins: [_search2.default, _date2.default],
	
	  components: {
	    VPagination: __webpack_require__(16),
	    VSelect: __webpack_require__(51),
	    VCard: __webpack_require__(21),
	    VNoData: __webpack_require__(19)
	  }
	};

/***/ }),
/* 1981 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _supplier = __webpack_require__(127);
	
	var _supplier2 = _interopRequireDefault(_supplier);
	
	var _country = __webpack_require__(66);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _postal = __webpack_require__(159);
	
	var _postal2 = _interopRequireDefault(_postal);
	
	var _supplier3 = __webpack_require__(112);
	
	var _supplier4 = _interopRequireDefault(_supplier3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        code: {
	          value: '',
	          type: 'text'
	        },
	        name: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      formContactInformation: new _forms2.default({
	        email: {
	          value: '',
	          type: 'text'
	        },
	        phonenumber: {
	          value: '',
	          type: 'text'
	        },
	        mobilenumber: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      formAddressInformation: new _forms2.default({
	        streetName1: {
	          value: '',
	          type: 'text'
	        },
	        streetName2: {
	          value: '',
	          type: 'text'
	        },
	        postalCode: {
	          value: '',
	          type: 'text'
	        },
	        city: {
	          value: '',
	          type: 'text'
	        },
	        countryId: {
	          value: 1,
	          type: 'select'
	        }
	      }),
	
	      loading: true,
	      tabIndex: 'first'
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    countries: 'allCountries',
	    municipalities: 'allMunicipalities',
	    postals: 'allPostals'
	  })),
	
	  watch: {
	    countries: function countries(_countries) {
	      this.formAddressInformation.setOptions('countryId', _countries.items);
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.loading = true;
	    Promise.all([_country2.default.all()]).then(function () {
	      _this.loading = false;
	      _this.formBasicInformation.disableField('code');
	    });
	  },
	
	
	  methods: {
	    store: function store() {
	      var _this2 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _supplier4.default.send(Object.assign({}, this.formBasicInformation.data(), this.formContactInformation.data(), this.formAddressInformation.data()));
	      _supplier2.default.store(client).then(function () {
	        _this2.$message({
	          message: _this2.$t('static.supplier.create.success'),
	          type: 'success'
	        });
	        _this2.$router.push({
	          name: 'supplier.index'
	        });
	      }).catch(function (errors) {
	        _this2.formBasicInformation.loading = false;
	        _this2.formAddressInformation.recordErrors(errors);
	        _this2.formContactInformation.recordErrors(errors);
	        _this2.formBasicInformation.recordErrors(errors);
	
	        if (_this2.formBasicInformation.errors.any()) {
	          _this2.tabIndex = 'first';
	        } else if (_this2.formAddressInformation.errors.any()) {
	          _this2.tabIndex = 'third';
	        } else if (_this2.formContactInformation.errors.any()) {
	          _this2.tabIndex = 'second';
	        }
	      });
	    },
	    showCityByPostalCode: function showCityByPostalCode(postalCode) {
	      if (this.postals.items.length > 0) {
	        var postal = this.postals.items.filter(function (p) {
	          return postalCode === p.postalCode.toString();
	        })[0];
	
	        this.formOtherInformation.cityName = postal.cityName;
	      }
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _supplier = __webpack_require__(127);
	
	var _supplier2 = _interopRequireDefault(_supplier);
	
	var _country = __webpack_require__(66);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _postal = __webpack_require__(159);
	
	var _postal2 = _interopRequireDefault(_postal);
	
	var _supplier3 = __webpack_require__(112);
	
	var _supplier4 = _interopRequireDefault(_supplier3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        code: {
	          value: '',
	          type: 'text'
	        },
	        name: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      formContactInformation: new _forms2.default({
	        email: {
	          value: '',
	          type: 'text'
	        },
	        phonenumber: {
	          value: '',
	          type: 'text'
	        },
	        mobilenumber: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      formAddressInformation: new _forms2.default({
	        streetName1: {
	          value: '',
	          type: 'text'
	        },
	        streetName2: {
	          value: '',
	          type: 'text'
	        },
	        postalCode: {
	          value: '',
	          type: 'text'
	        },
	        city: {
	          value: '',
	          type: 'text'
	        },
	        countryId: {
	          value: 1,
	          type: 'select'
	        }
	      }),
	
	      loading: true,
	      tabIndex: '1'
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    countries: 'allCountries',
	    municipalities: 'allMunicipalities',
	    postals: 'allPostals',
	    supplier: 'currentSupplier'
	  })),
	
	  watch: {
	    countries: function countries(_countries) {
	      this.formAddressInformation.setOptions('countryId', _countries.items);
	    },
	    $route: function $route() {
	      this.urlCurrentTab();
	    },
	    tabIndex: function tabIndex(value) {
	      this.assignTab(value);
	    }
	  },
	
	  mounted: function mounted() {
	    this.urlCurrentTab();
	    this.assignTab(this.tabIndex);
	  },
	  created: function created() {
	    this.show();
	  },
	
	
	  methods: {
	    assignTab: function assignTab(value) {
	      var tab = '';
	      if (value == '3') {
	        tab = '#address';
	      } else if (value == '2') {
	        tab = '#contact';
	      } else {
	        tab = '#basic';
	      }
	      history.pushState({}, null, '/#' + this.$route.path + tab);
	    },
	    urlCurrentTab: function urlCurrentTab() {
	      if (this.$router.currentRoute.hash == '#address') {
	        this.tabIndex = '3';
	      } else if (this.$router.currentRoute.hash == '#contact') {
	        this.tabIndex = '2';
	      } else {
	        this.tabIndex = '1';
	      }
	    },
	    update: function update() {
	      var _this = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var supp = _supplier4.default.send(Object.assign({}, this.formBasicInformation.data(), this.formContactInformation.data(), this.formAddressInformation.data()));
	      console.log(supp);
	      _supplier2.default.update(this.$route.params.id, supp).then(function () {
	        _this.$message({
	          message: _this.$t('static.supplier.update.success'),
	          type: 'success'
	        });
	        _this.$router.push({
	          name: 'supplier.index'
	        });
	      }).catch(function (errors) {
	        _this.formBasicInformation.loading = false;
	        _this.formAddressInformation.recordErrors(errors);
	        _this.formContactInformation.recordErrors(errors);
	        _this.formBasicInformation.recordErrors(errors);
	
	        if (_this.formBasicInformation.errors.any()) {
	          _this.tabIndex = '1';
	        } else if (_this.formAddressInformation.errors.any()) {
	          _this.tabIndex = '3';
	        } else if (_this.formContactInformation.errors.any()) {
	          _this.tabIndex = '2';
	        }
	      });
	    },
	    showCityByPostalCode: function showCityByPostalCode(postalCode) {
	      if (this.postals.items.length > 0) {
	        var postal = this.postals.items.filter(function (p) {
	          return postalCode === p.postalCode.toString();
	        })[0];
	
	        this.formOtherInformation.cityName = postal.cityName;
	      }
	    },
	    show: function show() {
	      var _this2 = this;
	
	      this.loading = true;
	      Promise.all([_supplier2.default.show(this.$route.params.id), _country2.default.all()]).then(function (data) {
	        _this2.loading = false;
	        var supp = data[0];
	        _this2.formBasicInformation.disableField('code');
	        _this2.formBasicInformation.assignData(supp);
	        _this2.formAddressInformation.assignData(supp.address);
	        _this2.formContactInformation.assignData(supp.contact);
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(5);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _supplier = __webpack_require__(127);
	
	var _supplier2 = _interopRequireDefault(_supplier);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sortValue: '',
	      info: 'info',
	      primary: 'primary',
	      limit: 25
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    suppliers: 'paginateSuppliers',
	    view: 'getView'
	  }), {
	    suppliersList: function suppliersList() {
	      return this.suppliers.items.map(function (b) {
	
	        return b;
	      });
	    },
	    suppliersListView: function suppliersListView() {
	      return this.suppliers.items.map(function (c) {
	        return {
	          number: c.number,
	          code: c.code,
	          name: c.name,
	          id: c.id
	        };
	      });
	    }
	  }),
	
	  watch: {
	
	    view: function view(_view) {
	      console.log(_view);
	      if (_view == 'card') {
	        this.info = 'info';
	        this.primary = 'primary';
	      } else {
	        this.primary = 'info';
	        this.info = 'primary';
	      }
	    },
	    $route: function $route() {
	      this.all(1, this.limit);
	    }
	  },
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19),
	    VTable: __webpack_require__(33)
	  },
	
	  mixins: [_search2.default],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.setInnerSidebar([{
	      title: this.$t('static.supplier.filters.title'),
	      options: [{
	        title: this.$t('static.supplier.filters.today'),
	        route: {
	          name: 'supplier.index',
	          query: {
	            filter: 'today'
	          }
	        }
	      }, {
	        title: this.$t('static.supplier.filters.all'),
	        route: {
	          name: 'supplier.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.supplier.create.title'),
	        route: {
	          name: 'supplier.create'
	        }
	      }
	    }]);
	
	    _account2.default.rememberPerPage('get', { from: 'supplier' }).then(function (data) {
	      _this.limit = data.size;
	      _this.all(1, _this.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	
	    console.log(this.view);
	    if (this.view == 'card') {
	      this.info = 'info';
	      this.primary = 'primary';
	    } else {
	      this.primary = 'info';
	      this.info = 'primary';
	    }
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	
	    changeView: function changeView(view) {
	      if (this.info != view) {
	        this.primary = this.info;
	        this.info = view;
	        if (this.info == 'info') {
	          _store2.default.dispatch('setView', 'card');
	        } else {
	          _store2.default.dispatch('setView', 'list');
	        }
	      }
	    },
	
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'supplier', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this3 = this;
	
	      this.loading = true;
	      _supplier2.default.items({
	        page: page,
	        limit: limit,
	        search: this.getSearch(this.limit),
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this3.loading = false;
	      }).catch(function () {
	        _this3.loadProductsing = false;
	      });
	    }, 800),
	
	    editSupplier: function editSupplier(supplier) {
	      var name = 'supplier.edit';
	      this.$router.push({
	        name: name,
	        params: { id: supplier.id }
	      });
	    },
	    editSupplierNewTab: function editSupplierNewTab(supplier) {
	      var name = 'supplier.edit';
	      var route = this.$router.resolve({
	        name: name,
	        params: { id: supplier.id }
	      });
	      window.open(route.href, '_blank');
	    }
	  })
	};

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _supplier = __webpack_require__(127);
	
	var _supplier2 = _interopRequireDefault(_supplier);
	
	var _country = __webpack_require__(66);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _postal = __webpack_require__(159);
	
	var _postal2 = _interopRequireDefault(_postal);
	
	var _supplier3 = __webpack_require__(112);
	
	var _supplier4 = _interopRequireDefault(_supplier3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        code: {
	          value: '',
	          type: 'text'
	        },
	        name: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      formContactInformation: new _forms2.default({
	        email: {
	          value: '',
	          type: 'text'
	        },
	        phonenumber: {
	          value: '',
	          type: 'text'
	        },
	        mobilenumber: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      formAddressInformation: new _forms2.default({
	        streetName1: {
	          value: '',
	          type: 'text'
	        },
	        streetName2: {
	          value: '',
	          type: 'text'
	        },
	        postalCode: {
	          value: '',
	          type: 'text'
	        },
	        city: {
	          value: '',
	          type: 'text'
	        },
	        countryId: {
	          value: 1,
	          type: 'select'
	        }
	      }),
	
	      loading: true,
	      tabIndex: 'first'
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    countries: 'allCountries',
	    municipalities: 'allMunicipalities',
	    postals: 'allPostals'
	  })),
	
	  watch: {
	    countries: function countries(_countries) {
	      this.formAddressInformation.setOptions('countryId', _countries.items);
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.loading = true;
	    Promise.all([_country2.default.all()]).then(function () {
	      _this.loading = false;
	      _this.formBasicInformation.disableField('code');
	    });
	  },
	
	
	  methods: {
	    store: function store() {
	      var _this2 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _supplier4.default.send(Object.assign({}, this.formBasicInformation.data(), this.formContactInformation.data(), this.formAddressInformation.data()));
	      _supplier2.default.store(client).then(function () {
	        _this2.$message({
	          message: _this2.$t('static.supplier.create.success'),
	          type: 'success'
	        });
	        _supplier2.default.all();
	        _this2.$emit('close');
	      }).catch(function (errors) {
	        _this2.formBasicInformation.loading = false;
	        _this2.formAddressInformation.recordErrors(errors);
	        _this2.formContactInformation.recordErrors(errors);
	        _this2.formBasicInformation.recordErrors(errors);
	      });
	    },
	    showCityByPostalCode: function showCityByPostalCode(postalCode) {
	      if (this.postals.items.length > 0) {
	        var postal = this.postals.items.filter(function (p) {
	          return postalCode === p.postalCode.toString();
	        })[0];
	
	        this.formOtherInformation.cityName = postal.cityName;
	      }
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sortValue: ''
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    warehouses: 'paginateWarehouses'
	  }), {
	    warehousesList: function warehousesList() {
	      return this.warehouses.items.map(function (b) {
	        return b;
	      });
	    }
	  }),
	
	  watch: {
	    $route: function $route() {
	      this.all(1, 25);
	    }
	  },
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19)
	  },
	
	  mixins: [_search2.default],
	
	  mounted: function mounted() {
	    this.setInnerSidebar([{
	      title: this.$t('static.inventory.transaction.title'),
	      options: [{
	        title: this.$t('static.stock.filters.title'),
	        route: {
	          name: 'inventory.stock.index'
	        }
	      }, {
	        title: this.$t('static.adjustment.filters.title'),
	        route: {
	          name: 'inventory.adjustment.index'
	        }
	      }, {
	        title: this.$t('static.purchase.filters.title'),
	        route: {
	          name: 'inventory.purchase.index'
	        }
	      }, {
	        title: this.$t('static.transfer.filters.title'),
	        route: {
	          name: 'inventory.transfer.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.warehouse.addTransaction.title'),
	        route: {
	          name: 'inventory.transaction.index'
	        }
	      }
	    }, {
	      title: this.$t('static.warehouse.filters.title'),
	      options: [{
	        title: this.$t('static.warehouse.filters.view'),
	        route: {
	          name: 'warehouse.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.warehouse.create.title'),
	        route: {
	          name: 'warehouse.create'
	        }
	      }
	    }]);
	    this.all(1, 25);
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this = this;
	
	      this.loading = true;
	      _warehouse2.default.items({
	        page: page,
	        limit: limit,
	        search: this.getSearch(),
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this.loading = false;
	      }).catch(function () {
	        _this.loadProductsing = false;
	      });
	    }, 800),
	
	    editWarehouse: function editWarehouse(warehouse) {
	      var name = 'warehouse.edit';
	      this.$router.push({
	        name: name,
	        params: { id: warehouse.id }
	      });
	    }
	  })
	};

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _transfer = __webpack_require__(234);
	
	var _transfer2 = _interopRequireDefault(_transfer);
	
	var _transfer3 = __webpack_require__(200);
	
	var _transfer4 = _interopRequireDefault(_transfer3);
	
	var _product = __webpack_require__(24);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _batch = __webpack_require__(60);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	var _batch3 = __webpack_require__(49);
	
	var _batch4 = _interopRequireDefault(_batch3);
	
	var _transactionType = __webpack_require__(485);
	
	var _transactionType2 = _interopRequireDefault(_transactionType);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        transferType: {
	          value: '',
	          type: 'select'
	        },
	        date: {
	          value: '',
	          type: 'date'
	        },
	        fromWarehouseId: {
	          value: '',
	          type: 'select'
	        },
	        toWarehouseId: {
	          value: '',
	          type: 'select'
	        },
	        batchId: {
	          value: '',
	          type: 'select'
	        },
	        comments: {
	          value: '',
	          type: 'textarea'
	        }
	      }),
	      loading: true,
	      tabIndex: 'first',
	      fields: {
	        productId: {
	          value: '',
	          type: 'autocomplete',
	          attributes: {
	            isSearch: true,
	            searchMethod: this.searchMethod,
	            loading: true
	          }
	        },
	        batchId: {
	          value: '',
	          type: 'select'
	        },
	        qty: {
	          value: '0',
	          type: 'text'
	        }
	      }
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    currentStockProducts: 'currentStockProductsCustom',
	    transactionTypes: 'allTransactionTypes',
	    warehouses: 'allWarehouses',
	    batches: 'allBatches',
	    account: 'account'
	  }), {
	    additionalData: function additionalData() {
	      var Obj = Object.create({});
	      Obj.fromWarehouseId = this.formBasicInformation.fromWarehouseId;
	      return Obj;
	    }
	  }),
	
	  watch: {
	    $route: function $route() {
	      this.warehouseTarget();
	    },
	    transactionTypes: function transactionTypes(_transactionTypes) {
	      this.formBasicInformation.setOptions('transferType', _transactionTypes.filter(function (type) {
	        return type.relations.filter(function (relation) {
	          return relation.includes('transfer');
	        }).length;
	      }).map(function (transactionType) {
	        return {
	          id: transactionType.id,
	          name: transactionType.description
	        };
	      }));
	    },
	    warehouses: function warehouses(_warehouses) {
	      var _this = this;
	
	      var data = _warehouses.items.filter(function (item) {
	        return !item.isSharedToYou;
	      });
	      this.formBasicInformation.setOptions('fromWarehouseId', data.map(function (item) {
	        return { id: item.id, name: item.name + (item.isLocked ? _this.$t('static.warehouse.info.locked') : '') };
	      }));
	      this.formBasicInformation.setOptions('toWarehouseId', data.map(function (item) {
	        return { id: item.id, name: item.name + (item.isLocked ? _this.$t('static.warehouse.info.locked') : '') };
	      }));
	    },
	    batches: function batches(_batches) {
	      if ('batchId' in this.formBasicInformation.hidden) {
	        this.formBasicInformation.setOptions('batchId', _batches.map(function (batch) {
	          return {
	            id: batch.id,
	            name: batch.name ? batch.batchNumber + ':' + batch.name : batch.batchNumber
	          };
	        }));
	      }
	    },
	
	    'formBasicInformation.fromWarehouseId': function formBasicInformationFromWarehouseId(fromWarehouseId) {
	      if (this.formBasicInformation.toWarehouseId === fromWarehouseId) {
	        this.formBasicInformation.toWarehouseId = '';
	      }
	      _store2.default.dispatch('setStockSelectedWarehouse', fromWarehouseId);
	    },
	
	    'formBasicInformation.toWarehouseId': function formBasicInformationToWarehouseId(toWarehouseId) {
	      if (this.formBasicInformation.fromWarehouseId === toWarehouseId) {
	        this.formBasicInformation.fromWarehouseId = '';
	      }
	      _store2.default.dispatch('setStockSelectedWarehouse', toWarehouseId);
	    },
	
	    'formBasicInformation.batchId': function formBasicInformationBatchId(batchId) {
	      if (batchId) {
	        var batch = this.batches.find(function (item) {
	          return item.id === batchId;
	        });
	        var products = [];
	        if (batch.recipe && batch.recipe.products) {
	          this.loading = true;
	
	          batch.recipe.products.forEach(function (product) {
	            if (!product.variations.length) {
	              products.push({
	                id: product.id,
	                name: product.name,
	                qty: '',
	                product: product,
	                productId: product,
	                batchId: batch.id
	              });
	            } else {
	              product.variations.forEach(function (childProduct) {
	                products.push({
	                  id: childProduct.id,
	                  name: childProduct.name,
	                  qty: '',
	                  product: childProduct,
	                  productId: childProduct,
	                  batchId: batch.id
	                });
	              });
	            }
	          });
	          if (products) {
	            _store2.default.dispatch('allCurrentStockProductsCustom', products);
	          }
	          this.loading = false;
	        }
	      }
	    },
	
	    'formBasicInformation.transferType': function formBasicInformationTransferType(typeId) {
	      var type = this.transactionTypes.filter(function (t) {
	        return typeId.toString() === t.id.toString();
	      })[0];
	
	      this.formBasicInformation.hideField('date');
	      this.formBasicInformation.hideField('fromWarehouseId');
	      this.formBasicInformation.hideField('toWarehouseId');
	      this.formBasicInformation.hideField('batchId');
	      this.formBasicInformation.hideField('comments');
	
	      if (type.code === 'TW') {
	        this.formBasicInformation.showField('toWarehouseId');
	        this.formBasicInformation.showField('fromWarehouseId');
	        this.formBasicInformation.showField('comments');
	      }
	
	      if (type.code === 'TTB') {
	        this.formBasicInformation.showField('fromWarehouseId');
	        this.formBasicInformation.showField('comments');
	        this.formBasicInformation.showField('batchId');
	        if (this.account.allowProducerBatches) {
	          this.formBasicInformation.setExtraAttr('batchId', {
	            hasButton: true,
	            buttonLabel: this.$t('static.batches.create.title'),
	            buttonHandler: this.addBatch
	          });
	        }
	      }
	
	      if (type.code === 'TB' || type.code === 'TL' || type.code === 'RS') {
	        this.formBasicInformation.showField('toWarehouseId');
	        this.formBasicInformation.hideField('fromWarehouseId');
	        this.formBasicInformation.showField('comments');
	        if (type.code === 'TB') {
	          this.formBasicInformation.showField('batchId');
	          this.formBasicInformation.setExtraAttr('batchId', {});
	          if (this.$route.query.batch) {
	            this.formBasicInformation.batchId = this.$route.query.batch;
	          }
	        }
	      }
	      if ('batchId' in this.formBasicInformation.hidden) {
	        this.formBasicInformation.setOptions('batchId', []);
	      } else {
	        this.formBasicInformation.setOptions('batchId', this.batches.map(function (batch) {
	          return {
	            id: batch.id,
	            name: batch.name ? batch.batchNumber + ':' + batch.name : batch.batchNumber
	          };
	        }));
	      }
	    }
	  },
	
	  created: function created() {
	    this.warehouseTarget();
	    this.loading = false;
	    this.formBasicInformation.hideField('date');
	    this.formBasicInformation.hideField('fromWarehouseId');
	    this.formBasicInformation.hideField('toWarehouseId');
	    this.formBasicInformation.hideField('comments');
	  },
	
	
	  methods: {
	    warehouseTarget: function warehouseTarget() {
	      this.formBasicInformation.setFieldValue('fromWarehouseId', this.$router.currentRoute.hash.substring(1));
	    },
	    store: function store() {
	      var _this2 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var products = this.currentStockProducts.filter(function (p) {
	        return p.qty > 0;
	      });
	      var type = this.transactionTypes.filter(function (t) {
	        return _this2.formBasicInformation.transferType.toString() === t.id.toString();
	      })[0];
	      var data = Object.assign({}, this.formBasicInformation.data(), { products: products });
	      if (type.code === 'TTB') {
	        data.toWarehouseId = this.formBasicInformation.fromWarehouseId;
	      }
	      var transfer = _transfer4.default.send(data);
	      _transfer2.default.store(transfer).then(function (response) {
	        _this2.$message({
	          message: _this2.$t('static.transfer.create.success'),
	          type: 'success'
	        });
	        if (response.data && response.data.transfer_order_id) {
	          _this2.$router.push({
	            name: 'orders.edit',
	            params: { id: response.data.transfer_order_id }
	          });
	        } else {
	          _this2.$router.push({
	            name: 'inventory.transfer.index'
	          });
	        }
	      }).catch(function (errors) {
	        _this2.formBasicInformation.loading = false;
	        _this2.formBasicInformation.recordErrors(errors);
	        var message = errors.message;
	        if (errors.message) {
	          _this2.$message({
	            showClose: true,
	            message: message,
	            customClass: 'error'
	          });
	        }
	      });
	    },
	    searchMethod: function searchMethod(search, field) {
	      return Promise.all([_product2.default.searchAll({ search: search })]);
	    },
	    addBatch: function addBatch(product) {
	      var _this3 = this;
	
	      this.$prompt('' + this.$t('form.batches.batchNumber.label'), this.$t('static.batches.create.title'), {
	        confirmButtonText: this.$t('button.save'),
	        cancelButtonText: this.$t('button.cancel')
	      }).then(function (_ref) {
	        var value = _ref.value;
	
	        _this3.batchLoading = true;
	        var batch = _batch4.default.send({
	          batchNumber: value,
	          status: 'completed',
	          custom: 1
	        });
	        _batch2.default.store(batch).then(function (data) {
	          _store2.default.dispatch('addBatch', data);
	          _this3.formBasicInformation.setOptions('batchId', _this3.batches.map(function (b) {
	            return {
	              id: b.id,
	              name: b.batchNumber + ':' + b.name
	            };
	          }));
	          _this3.$message({
	            message: _this3.$t('static.batches.create.success'),
	            type: 'success'
	          });
	        }).catch(function () {
	          _this3.batchLoading = false;
	          _this3.$message({
	            message: _this3.$t('static.batches.create.error'),
	            type: 'error'
	          });
	        });
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.loading = true;
	    _store2.default.dispatch('allCurrentStockProductsCustom', []);
	    _store2.default.dispatch('setStockSelectedWarehouse', 0);
	    Promise.all([_warehouse2.default.all(), _batch2.default.all(), _transactionType2.default.all()]).then(function () {
	      _store2.default.dispatch('RefreshStockProductsCustom');
	      if (_this4.$route.query.batch) {
	        var batchTransfer = _this4.transactionTypes.find(function (t) {
	          return t.code === 'TB';
	        });
	        if (batchTransfer) {
	          _this4.formBasicInformation.transferType = batchTransfer.id;
	        }
	      } else {
	        _this4.loading = false;
	      }
	    });
	  },
	
	  components: {
	    VForm: __webpack_require__(9),
	    VMessage: __webpack_require__(13),
	    VProductsTable: __webpack_require__(123)
	  }
	};

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(5);
	
	var _transfer = __webpack_require__(234);
	
	var _transfer2 = _interopRequireDefault(_transfer);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _store = __webpack_require__(2);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _bridgeHandoff = __webpack_require__(81);
	
	var _bridgeHandoff2 = _interopRequireDefault(_bridgeHandoff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sortValue: '',
	      info: 'info',
	      primary: 'primary',
	      limit: 25
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    transfers: 'paginateTransfers',
	    view: 'getView'
	  }), {
	    transfersListView: function transfersListView() {
	      return this.transfers.items.map(function (c) {
	        return {
	          warehouse: c.toWarehouseName,
	          status: c.status,
	          createdAt: c.createdAt,
	          comments: c.comments,
	          id: c.id
	        };
	      });
	    },
	    transfersList: function transfersList() {
	      return this.transfers.items.map(function (b) {
	        return b;
	      });
	    }
	  }),
	
	  watch: {
	    transfers: function transfers(_transfers) {},
	    view: function view(_view) {
	      if (_view == 'card') {
	        this.info = 'info';
	        this.primary = 'primary';
	      } else {
	        this.primary = 'info';
	        this.info = 'primary';
	      }
	    },
	    $route: function $route() {
	      this.all(1, this.limit);
	    }
	  },
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19),
	    VTable: __webpack_require__(33)
	  },
	
	  mixins: [_search2.default, _bridgeHandoff2.default],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.setInnerSidebar([{
	      title: this.$t('static.inventory.transaction.title'),
	      options: [{
	        title: this.$t('static.stock.filters.title'),
	        route: {
	          name: 'inventory.stock.index'
	        }
	      }, {
	        title: this.$t('static.adjustment.filters.title'),
	        route: {
	          name: 'inventory.adjustment.index'
	        }
	      }, {
	        title: this.$t('static.purchase.filters.title'),
	        route: {
	          name: 'inventory.purchase.index'
	        }
	      }, {
	        title: this.$t('static.transfer.filters.title'),
	        route: {
	          name: 'inventory.transfer.index'
	        }
	      }],
	      button: this.bridgeStockWriteBlocked ? null : {
	        title: '+ ' + this.$t('static.warehouse.addTransaction.title'),
	        route: {
	          name: 'inventory.transaction.index'
	        }
	      }
	    }, {
	      title: this.$t('static.warehouse.filters.title'),
	      options: [{
	        title: this.$t('static.warehouse.filters.view'),
	        route: {
	          name: 'warehouse.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.warehouse.create.title'),
	        route: {
	          name: 'warehouse.create'
	        }
	      }
	    }]);
	
	    _account2.default.rememberPerPage('get', { from: 'transfer' }).then(function (data) {
	      _this.limit = data.size;
	      _this.all(1, _this.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	
	    if (this.view == 'card') {
	      this.info = 'info';
	      this.primary = 'primary';
	    } else {
	      this.primary = 'info';
	      this.info = 'primary';
	    }
	  },
	  destroyed: function destroyed() {},
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    formatDate: function formatDate(value) {
	      var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';
	
	      if (!value) {
	        return '-';
	      }
	      var m = (0, _moment2.default)(value);
	      return m.isValid() ? m.format(pattern) : '-';
	    },
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'transfer', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this3 = this;
	
	      this.loading = true;
	      _transfer2.default.items({
	        page: page,
	        limit: limit,
	        search: this.getSearch(this.limit),
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this3.loading = false;
	      }).catch(function () {
	        _this3.loadProductsing = false;
	      });
	    }, 800),
	
	    changeView: function changeView(view) {
	      if (this.info != view) {
	        this.primary = this.info;
	        this.info = view;
	        if (this.info == 'info') {
	          _store2.default.dispatch('setView', 'card');
	        } else {
	          _store2.default.dispatch('setView', 'list');
	        }
	      }
	    },
	    viewTransfer: function viewTransfer(transfer) {
	      this.$router.push({
	        name: 'inventory.transfer.view',
	        params: { id: transfer.id }
	      });
	    }
	  })
	};

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _transfer = __webpack_require__(234);
	
	var _transfer2 = _interopRequireDefault(_transfer);
	
	var _batch = __webpack_require__(60);
	
	var _batch2 = _interopRequireDefault(_batch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      tabIndex: 'first',
	      currentTransfer: {
	        products: [],
	        toWarehouse: {
	          name: ''
	        },
	        stock: {
	          name: ''
	        }
	      }
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    account: 'account',
	    batches: 'allBatches'
	  }), {
	    productList: function productList() {
	      var _this = this;
	
	      return this.currentTransfer.products.map(function (c) {
	        var product = {
	          sku: c.productSku,
	          name: c.productName
	        };
	        if (_this.hasProduction) {
	          var batchId = c.batchId ? c.batchId : _this.currentTransfer.batchId || null;
	          product.batch = batchId ? _this.batches.find(function (b) {
	            return +b.id === +batchId;
	          }) : null;
	        }
	        product.qty = c.qty;
	        product.notes = c.notes;
	
	        return product;
	      });
	    },
	    hasProduction: function hasProduction() {
	      if (this.account.modules.length > 0) {
	        return this.account.modules.find(function (m) {
	          return m.name.toString() === 'Production';
	        });
	      }
	      if (this.account.allowProducerBatches) return true;
	      return false;
	    }
	  }),
	
	  watch: {
	    currentTransfer: function currentTransfer(_currentTransfer) {}
	  },
	
	  created: function created() {
	    this.loading = false;
	  },
	
	
	  methods: {
	    showPrintableDeliveryNote: function showPrintableDeliveryNote() {
	      _transfer2.default.showDeliveryNote(this.$route.params.id);
	    },
	    markAsDone: function markAsDone() {
	      var _this2 = this;
	
	      this.loading = false;
	      _transfer2.default.markAsDone(this.$route.params.id, []).then(function () {
	        _this2.$message({
	          message: _this2.$t('static.transfer.update.success'),
	          type: 'success'
	        });
	        _this2.$router.push({
	          name: 'inventory.transfer.index'
	        });
	      }).catch(function (errors) {});
	    },
	    markAsDraft: function markAsDraft() {
	      var _this3 = this;
	
	      this.loading = false;
	      _transfer2.default.markAsDraft(this.$route.params.id, []).then(function () {
	        _this3.$message({
	          message: _this3.$t('static.transfer.update.success'),
	          type: 'success'
	        });
	        _this3.$router.push({
	          name: 'inventory.transfer.index'
	        });
	      }).catch(function (errors) {});
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    Promise.all([_transfer2.default.show(this.$route.params.id), _batch2.default.all({
	      warehouse_id: '',
	      has_warehouse_transaction: 1,
	      for_select: 1
	    })]).then(function (data) {
	      _this4.currentTransfer = data[0];
	    });
	  },
	
	  components: {
	    VTable: __webpack_require__(33)
	  }
	};

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(5);
	
	var _unitOfMeasure = __webpack_require__(193);
	
	var _unitOfMeasure2 = _interopRequireDefault(_unitOfMeasure);
	
	var _unitOfMeasure3 = __webpack_require__(137);
	
	var _unitOfMeasure4 = _interopRequireDefault(_unitOfMeasure3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        code: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      loading: true,
	      tabIndex: 'first'
	    };
	  },
	
	
	  computed: {},
	
	  watch: {},
	
	  created: function created() {
	    this.loading = false;
	  },
	
	
	  methods: {
	    store: function store() {
	      var _this = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _unitOfMeasure4.default.send(Object.assign({}, this.formBasicInformation.data()));
	      _unitOfMeasure2.default.store(client).then(function () {
	        _this.$message({
	          message: _this.$t('static.unitOfMeasure.create.success'),
	          type: 'success'
	        });
	        _this.$router.push({
	          name: 'unitOfMeasure.index'
	        });
	      }).catch(function (errors) {
	        _this.formBasicInformation.loading = false;
	        _this.formBasicInformation.recordErrors(errors);
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _unitOfMeasure = __webpack_require__(193);
	
	var _unitOfMeasure2 = _interopRequireDefault(_unitOfMeasure);
	
	var _unitOfMeasure3 = __webpack_require__(137);
	
	var _unitOfMeasure4 = _interopRequireDefault(_unitOfMeasure3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        code: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      loading: true,
	      tabIndex: 'first'
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    unitOfMeasure: 'currentUnitOfMeasure'
	  })),
	
	  watch: {},
	
	  created: function created() {
	    this.show();
	  },
	
	
	  methods: {
	    update: function update() {
	      var _this = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var supp = _unitOfMeasure4.default.send(Object.assign({}, this.formBasicInformation.data()));
	      console.log(supp);
	      _unitOfMeasure2.default.update(this.$route.params.id, supp).then(function () {
	        _this.$message({
	          message: _this.$t('static.unitOfMeasure.update.success'),
	          type: 'success'
	        });
	        _this.$router.push({
	          name: 'unitOfMeasure.index'
	        });
	      }).catch(function (errors) {
	        _this.formBasicInformation.loading = false;
	        _this.formBasicInformation.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      var _this2 = this;
	
	      this.loading = true;
	      Promise.all([_unitOfMeasure2.default.show(this.$route.params.id)]).then(function (data) {
	        _this2.loading = false;
	        var ware = data[0];
	        _this2.formBasicInformation.assignData(ware);
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(5);
	
	var _unitOfMeasure = __webpack_require__(193);
	
	var _unitOfMeasure2 = _interopRequireDefault(_unitOfMeasure);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sortValue: ''
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    unitOfMeasures: 'paginateUnitOfMeasures'
	  }), {
	    unitOfMeasuresList: function unitOfMeasuresList() {
	      return this.unitOfMeasures.items.map(function (b) {
	
	        return b;
	      });
	    }
	  }),
	
	  watch: {
	    $route: function $route() {
	      this.all(1, 50);
	    }
	  },
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19)
	  },
	
	  mixins: [_search2.default],
	
	  mounted: function mounted() {
	    this.setInnerSidebar([{
	      title: this.$t('static.products.filters.title'),
	      options: [{
	        title: this.$t('static.products.filters.latest'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'latest'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.pastMonth'),
	        route: {
	          name: 'products.index',
	          query: {
	            filter: 'pastMonth'
	          }
	        }
	      }, {
	        title: this.$t('static.products.filters.all'),
	        route: {
	          name: 'products.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.products.create.title'),
	        route: {
	          name: 'products.create'
	        }
	      }
	    }, {
	      title: this.$t('static.productGroups.filters.title'),
	      options: [{
	        title: this.$t('static.productGroups.filters.latest'),
	        route: {
	          name: 'productGroups.index',
	          query: {
	            filter: 'latest'
	          }
	        }
	      }, {
	        title: this.$t('static.productGroups.filters.pastMonth'),
	        route: {
	          name: 'productGroups.index',
	          query: {
	            filter: 'pastMonth'
	          }
	        }
	      }, {
	        title: this.$t('static.productGroups.filters.all'),
	        route: {
	          name: 'productGroups.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.productGroups.create.title'),
	        route: {
	          name: 'productGroups.create'
	        }
	      }
	    }, {
	      title: this.$t('static.unitOfMeasure.filters.title'),
	      options: [{
	        title: this.$t('static.unitOfMeasure.filters.all'),
	        route: {
	          name: 'unitOfMeasure.index'
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.unitOfMeasure.create.title'),
	        route: {
	          name: 'unitOfMeasure.create'
	        }
	      }
	    }]);
	    this.all(1, 50);
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this = this;
	
	      this.loading = true;
	      _unitOfMeasure2.default.items({
	        page: page,
	        limit: limit,
	        search: this.getSearch(),
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this.loading = false;
	      }).catch(function () {
	        _this.loadProductsing = false;
	      });
	    }, 800),
	
	    editWarehouse: function editWarehouse(unitOfMeasure) {
	      var name = 'unitOfMeasure.edit';
	      this.$router.push({
	        name: name,
	        params: { id: unitOfMeasure.id }
	      });
	    }
	  })
	};

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _warehouse3 = __webpack_require__(62);
	
	var _warehouse4 = _interopRequireDefault(_warehouse3);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _partner = __webpack_require__(301);
	
	var _partner2 = _interopRequireDefault(_partner);
	
	var _actions = __webpack_require__(490);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        name: {
	          value: '',
	          type: 'text'
	        },
	        location: {
	          value: '',
	          type: 'text'
	        },
	        isBonded: {
	          value: 0,
	          type: 'switch'
	        },
	        partnerId: {
	          value: '',
	          type: 'select'
	        }
	      }),
	      loading: true,
	      tabIndex: 'first'
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    allPartners: 'allPartners'
	  })),
	
	  watch: {
	    allPartners: function allPartners(_allPartners) {
	      this.formBasicInformation.setOptions('partnerId', _allPartners);
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.formBasicInformation.hideField('partnerId');
	    this.loading = true;
	    Promise.all([_partner2.default.all()]).then(function () {
	      _this.loading = false;
	    });
	  },
	
	
	  methods: {
	    store: function store() {
	      var _this2 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var client = _warehouse4.default.send(Object.assign({}, this.formBasicInformation.data()));
	      _warehouse2.default.store(client).then(function () {
	        _this2.$message({
	          message: _this2.$t('static.warehouse.create.success'),
	          type: 'success'
	        });
	        _this2.$router.push({
	          name: 'warehouse.index'
	        });
	      }).catch(function (errors) {
	        _this2.formBasicInformation.loading = false;
	        _this2.formBasicInformation.recordErrors(errors);
	      });
	    }
	  },
	
	  components: {
	    VForm: __webpack_require__(9)
	  }
	};

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(5);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _warehouse3 = __webpack_require__(62);
	
	var _warehouse4 = _interopRequireDefault(_warehouse3);
	
	var _country = __webpack_require__(66);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _partner = __webpack_require__(301);
	
	var _partner2 = _interopRequireDefault(_partner);
	
	var _forms = __webpack_require__(8);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _minimumStock = __webpack_require__(2718);
	
	var _minimumStock2 = _interopRequireDefault(_minimumStock);
	
	var _shippingProvider = __webpack_require__(97);
	
	var _shippingProvider2 = _interopRequireDefault(_shippingProvider);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _bulkDestroyProductModal = __webpack_require__(2678);
	
	var _bulkDestroyProductModal2 = _interopRequireDefault(_bulkDestroyProductModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = {
	  data: function data() {
	    return {
	      formBasicInformation: new _forms2.default({
	        isActive: {
	          value: true,
	          type: 'switch'
	        },
	        typeName: {
	          value: '',
	          type: 'text'
	        },
	        name: {
	          value: '',
	          type: 'text'
	        },
	        location: {
	          value: '',
	          type: 'text'
	        },
	        partnerId: {
	          value: '',
	          type: 'select'
	        },
	        shippingProviders: {
	          value: '',
	          type: 'select',
	          attributes: {
	            multiple: true
	          }
	        }
	      }),
	      formContactInformation: new _forms2.default({
	        firstName: {
	          value: '',
	          type: 'text'
	        },
	        lastName: {
	          value: '',
	          type: 'text'
	        },
	        email: {
	          value: '',
	          type: 'text'
	        },
	        phoneNumber: {
	          value: '',
	          type: 'text'
	        }
	      }),
	      formAddressInformation: new _forms2.default({
	        streetName1: {
	          value: '',
	          type: 'text'
	        },
	        streetName2: {
	          value: '',
	          type: 'text'
	        },
	        postalCode: {
	          value: '',
	          type: 'text'
	        },
	        city: {
	          value: '',
	          type: 'text'
	        },
	        countryId: {
	          value: 1,
	          type: 'select'
	        }
	      }),
	      loading: true,
	      tabIndex: '2',
	      products: [],
	      productsLoading: true,
	      transactionLoading: true,
	      productFilter: {
	        options: [],
	        value: [],
	        list: [],
	        loading: true
	      },
	      typeFilter: {
	        options: [],
	        value: [],
	        list: []
	      },
	      transactionTypeList: [],
	      productDisplay: '',
	      batchDisplay: '',
	      transactionDisplay: 'all',
	      limit: 10,
	      batchFilter: {
	        options: [],
	        value: [],
	        list: [],
	        loading: true
	      },
	      dropdownStateTransactions: false,
	      hideOutOfStock: true,
	      productShowAction: false,
	      multipleSelection: [],
	      productSearch: ''
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    warehouse: 'currentWarehouse',
	
	    warehouseProducts: 'paginateWarehouseProducts',
	
	    transactionsV2: 'paginateWarehouseTransactionsV2',
	    account: 'account',
	    countries: 'allCountries',
	    municipalities: 'allMunicipalities',
	    postals: 'allPostals',
	    allPartners: 'allPartners'
	  }), {
	    isDestructionWarehouse: function isDestructionWarehouse() {
	      return this.warehouse.typeName === 'Destruction';
	    },
	    ediGrapesMoving: function ediGrapesMoving() {
	      return this.account.plan === 'EDI Grapsmoving';
	    },
	    productList: function productList() {
	      var _this = this;
	
	      return this.products.map(function (c) {
	        var data = {
	          id: c.id,
	          name: c.name,
	          producer: c.supplierName,
	          batchName: c.batchName,
	          minimumStockLevel: c.minimumStockLevel !== 0 ? c.minimumStockLevel : '',
	          qty: c.qty,
	          qtyNumber: c.qtyNumber
	        };
	        if (_this.hasProduction() === false) {
	          var _data = data,
	              batchName = _data.batchName,
	              newData = _objectWithoutProperties(_data, ['batchName']);
	
	          data = newData;
	        }
	        return data;
	      });
	    },
	    transactionListV2: function transactionListV2() {
	      var _this2 = this;
	
	      var newData = this.transactionsV2.items.map(function (c) {
	        var data = {
	          via: c.via + ' #' + c.code,
	          client: c.customerName,
	          batchName: c.batchName,
	          id: c.parentModelId,
	
	          productName: c.productName,
	          beforeqty: c.beforeQty,
	          qty: c.adjustmentQty,
	          afterqty: c.afterQty,
	          warehouse: c.warehouse,
	          createdAt: c.createdAt
	        };
	        if (_this2.hasProduction() === false) {
	          var _data2 = data,
	              batchName = _data2.batchName,
	              _newData = _objectWithoutProperties(_data2, ['batchName']);
	
	          data = _newData;
	        }
	        return data;
	      });
	
	      var self = this;
	      return newData.filter(function (obj) {
	        var transType = obj.via.split('#')[0].trim();
	
	        if (self.batchDisplay !== '' && self.productDisplay === '' && self.transactionDisplay === 'all') {
	          return self.batchDisplay === obj.batchName;
	        } else if (self.batchDisplay === '' && self.productDisplay !== '' && self.transactionDisplay === 'all') {
	          return self.productDisplay === obj.productName;
	        } else if (self.productDisplay === '' && self.batchDisplay === '' && self.transactionDisplay !== 'all') {
	          return transType === self.transactionDisplay;
	        } else if (self.batchDisplay !== '' && self.productDisplay !== '' && self.transactionDisplay === 'all') {
	          return self.batchDisplay === obj.batchName && self.productDisplay === obj.productName;
	        } else if (self.batchDisplay !== '' && self.productDisplay === '' && self.transactionDisplay !== 'all') {
	          return self.batchDisplay === obj.batchName && transType === self.transactionDisplay;
	        } else if (self.batchDisplay === '' && self.productDisplay !== '' && self.transactionDisplay !== 'all') {
	          return self.productDisplay === obj.productName && transType === self.transactionDisplay;
	        } else if (self.batchDisplay !== '' && self.productDisplay !== '' && self.transactionDisplay !== 'all') {
	          return self.batchDisplay === obj.batchName && self.productDisplay === obj.productName && self.transactionDisplay === transType;
	        }
	
	        return obj;
	      });
	    },
	    returnWarehouseType: function returnWarehouseType() {
	      var isBondedText = this.warehouse.isBonded ? this.$t('static.warehouse.info.isBonded') : this.$t('static.warehouse.info.notBonded');
	      return this.warehouse.typeName + ' ' + isBondedText;
	    },
	    productSelectedCount: function productSelectedCount() {
	      return this.multipleSelection.length || 0;
	    }
	  }),
	
	  watch: {
	    productSearch: function productSearch(value) {
	      if (value === '') {
	        this.allProduct(1, this.limit);
	      }
	    },
	    hideOutOfStock: function hideOutOfStock() {
	      this.allProduct(1, this.limit);
	    },
	    warehouseProducts: function warehouseProducts(_warehouseProducts) {
	      this.onUpdateBatchFilter(_warehouseProducts.items);
	      this.productsLoading = true;
	      this.products = _warehouseProducts.items;
	    },
	    products: function products(_products) {
	      var _this3 = this;
	
	      setTimeout(function () {
	        if (_this3.productsLoading === true && _products) _this3.productsLoading = false;
	      }, 1500);
	    },
	    $route: function $route() {
	      this.urlCurrentTab();
	      this.all(1, this.limit);
	      this.allProduct(1, this.limit);
	    },
	    countries: function countries(_countries) {
	      this.formAddressInformation.setOptions('countryId', _countries.items);
	    },
	    allPartners: function allPartners(_allPartners) {
	      this.formBasicInformation.setOptions('partnerId', _allPartners);
	    },
	    tabIndex: function tabIndex(value) {
	      this.assignTab(value);
	    },
	    multipleSelection: function multipleSelection(value) {
	      this.productShowAction = false;
	      if (value.length > 0) {
	        this.productShowAction = true;
	      }
	    }
	  },
	
	  created: function created() {
	    this.show();
	  },
	  mounted: function mounted() {
	    this.urlCurrentTab();
	    this.assignTab(this.tabIndex);
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    toggleModal: 'TOGGLE_MODAL',
	    setModalContent: 'SET_MODAL_CONTENT',
	    setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
	    setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
	    setModalProps: 'SET_MODAL_PROPS',
	    setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
	    unsetModalContent: 'UNSET_MODAL_CONTENT'
	  }), {
	    onProductSearch: function onProductSearch() {
	      this.allProduct(1, this.limit);
	    },
	    onSelectAction: function onSelectAction(type) {
	      if (type === 'minStockLevel') {
	        this.setModalContent(function () {
	          return _minimumStock2.default;
	        });
	        this.setModalProps({
	          type: 'bulk',
	          entries: { selected: this.multipleSelection },
	          queryProductWarehouse: this.queryProductWarehouse
	        });
	        this.setModalCloseOnClick(false);
	        this.setModalShowClose(true);
	        this.setModalCloseOnPressEscape(false);
	        this.toggleModal(true);
	      }
	    },
	    resetSelected: function resetSelected() {
	      this.productShowAction = false;
	      this.multipleSelection = [];
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    destroyProduct: function destroyProduct(product) {
	      this.multipleSelection = [];
	      if (!this.multipleSelection.find(function (p) {
	        return +p.id === +product.id;
	      })) {
	        this.multipleSelection.push(product);
	      }
	      this.destroySelectedProducts();
	    },
	    destroySelectedProducts: function destroySelectedProducts() {
	      this.setModalContent(function () {
	        return _bulkDestroyProductModal2.default;
	      });
	      this.setModalProps({
	        selectedProducts: this.multipleSelection,
	        warehouseId: +this.$route.params.id,
	        onSave: this.handleBulkProductDestroy,
	        onClose: this.handleBulkProductClose
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(false);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    handleBulkProductClose: function handleBulkProductClose() {
	      this.multipleSelection = [];
	    },
	    handleBulkProductDestroy: function handleBulkProductDestroy(products) {
	      var _this4 = this;
	
	      return _warehouse2.default.destroyProducts(this.$route.params.id, products.map(function (p) {
	        return { id: p.id, qty: p.selectedQty };
	      })).then(function () {
	        _this4.multipleSelection = [];
	        _this4.$message({
	          message: _this4.$t('static.warehouse.destroyProduct.success'),
	          type: 'success'
	        });
	        _this4.allProduct(1, _this4.limit);
	      }).catch(function (error) {
	        console.log(error);
	        _this4.$message({
	          message: _this4.$t('static.warehouse.destroyProduct.error'),
	          type: 'error'
	        });
	      });
	    },
	    perPage: function perPage(size) {
	      var _this5 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'bill', perPage: size }).then(function (data) {
	        _this5.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	    assignTab: function assignTab(value) {
	      var tab = '';
	      if (value == '3') {
	        tab = '#transactions';
	      } else if (value == '1') {
	        tab = '#basics';
	      } else {
	        tab = '#products';
	      }
	      history.pushState({}, null, '/#' + this.$route.path + tab);
	    },
	    urlCurrentTab: function urlCurrentTab() {
	      if (this.$router.currentRoute.hash == '#transactions') {
	        this.tabIndex = '3';
	      } else if (this.$router.currentRoute.hash == '#basics') {
	        this.tabIndex = '1';
	      } else {
	        this.tabIndex = '2';
	      }
	    },
	    toggleDropdownTransactions: function toggleDropdownTransactions() {
	      this.dropdownStateTransactions = !this.dropdownStateTransactions;
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this6 = this;
	
	      if (this.transactionLoading === false) this.transactionLoading = true;
	      var filters = {
	        productDisplay: this.productDisplay,
	        batchDisplay: this.batchDisplay,
	        transactionDisplay: this.transactionDisplay
	      };
	      var params = {
	        id: this.$route.params.id,
	        page: page,
	        limit: limit,
	        filter: JSON.stringify(filters)
	      };
	      _warehouse2.default.transactionsV2(params).then(function () {
	        setTimeout(function () {
	          if (_this6.transactionLoading === true) _this6.transactionLoading = false;
	        }, 500);
	      }).catch(function () {
	        setTimeout(function () {
	          if (_this6.transactionLoading === true) _this6.transactionLoading = false;
	        }, 500);
	      });
	    }, 800),
	
	    allProduct: (0, _debounce2.default)(function (page, limit) {
	      var _this7 = this;
	
	      if (this.productsLoading === false) this.productsLoading = true;
	      var filters = {
	        hide_out_of_stock: this.hideOutOfStock
	      };
	      var params = {
	        page: page,
	        limit: limit,
	        search: this.productSearch,
	        filter: JSON.stringify(filters)
	      };
	      _warehouse2.default.products(this.$route.params.id, params).then(function () {
	        setTimeout(function () {
	          if (_this7.productsLoading === true) _this7.productsLoading = false;
	        }, 500);
	      }).catch(function () {
	        setTimeout(function () {
	          if (_this7.productsLoading === true) _this7.productsLoading = false;
	        }, 500);
	      });
	    }, 800),
	
	    rowClass: function rowClass() {
	      return 'row-style';
	    },
	    switchTab: function switchTab(tab, event) {
	      this.tabIndex = tab.paneName ? tab.paneName : '1';
	    },
	    showDetails: function showDetails(value) {
	      this.tabIndex = '3';
	      this.transactionLoading = true;
	
	      this.productDisplay = '';
	      this.productFilter.value = '';
	      this.batchDisplay = '';
	      this.batchFilter.value = '';
	
	      this.productDisplay = value.name;
	      this.productFilter.value = value.name;
	      if (value.batchName !== '' && this.hasProduction() === true) {
	        this.batchDisplay = value.batchName;
	        this.batchFilter.value = value.batchName;
	      }
	      this.all(1, this.limit);
	    },
	    clearProductFilter: function clearProductFilter() {
	      this.productDisplay = '';
	      this.all(1, this.limit);
	    },
	    eventProductFilter: function eventProductFilter(value) {
	      this.transactionLoading = true;
	      this.productDisplay = value;
	      this.all(1, this.limit);
	    },
	    eventTransactionsV2Filter: function eventTransactionsV2Filter(value) {
	      this.transactionLoading = true;
	      this.transactionDisplay = value;
	      this.all(1, this.limit);
	    },
	    focusProductFilter: function focusProductFilter() {},
	    clearBatchFilter: function clearBatchFilter() {
	      this.batchDisplay = '';
	      this.all(1, this.limit);
	    },
	    focusBatchFilter: function focusBatchFilter() {},
	    getFilterBatches: function getFilterBatches(query) {
	      var _this8 = this;
	
	      this.batchFilter.loading = true;
	      if (query !== '') {
	        setTimeout(function () {
	          _this8.batchFilter.options = _this8.batchFilter.list.filter(function (item) {
	            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
	          });
	          _this8.batchFilter.loading = false;
	        }, 200);
	      } else {
	        this.batchFilter.options = [];
	        this.batchFilter.loading = false;
	      }
	    },
	    onUpdateBatchFilter: function onUpdateBatchFilter(value) {
	      var unique = value.filter(function (set) {
	        return function (f) {
	          return !set.has(f.batchName) && set.add(f.batchName);
	        };
	      }(new Set()));
	      return this.batchFilter.list = unique.map(function (item) {
	        return { value: '' + item.batchName, label: '' + item.batchName };
	      });
	    },
	    eventBatchFilter: function eventBatchFilter(value) {
	      this.transactionLoading = true;
	      this.batchDisplay = value;
	      this.all(1, this.limit);
	    },
	    queryTransacType: function queryTransacType() {
	      var _this9 = this;
	
	      _warehouse2.default.transactionTypes(this.$route.params.id).then(function (response) {
	        _this9.onUpdatetransactionsV2Filter(response.data.data);
	      });
	    },
	    onUpdatetransactionsV2Filter: function onUpdatetransactionsV2Filter(value) {
	      var tempData = value.map(function (item) {
	        return { value: '' + item };
	      });
	      var tempData2 = tempData;
	
	      this.typeFilter.options = [];
	      tempData2.unshift({ value: 'all' });
	      var transTypes = this.$t('static.warehouse.transactions.filter.transactionType');
	      this.typeFilter.options = tempData2.map(function (item) {
	        var temp = transTypes.find(function (item2) {
	          return item2.value === item.value;
	        });
	        if (temp.value) return { value: temp.value, label: temp.label };
	      });
	      this.typeFilter.value = 'all';
	    },
	    getFilterProducts: function getFilterProducts(query) {
	      var _this10 = this;
	
	      this.productFilter.loading = true;
	      if (query !== '') {
	        _warehouse2.default.search(this.$route.params.id, { search: query }).then(function (response) {
	          _this10.productFilter.options = Object.assign({}, response.data).data.map(function (item) {
	            return { value: item, label: item };
	          });
	          _this10.productFilter.loading = false;
	        }).catch(function (error) {
	          console.log(error);
	          _this10.productFilter.loading = false;
	        });
	      } else {
	        this.productFilter.options = [];
	        this.productFilter.loading = false;
	      }
	    },
	    update: function update() {
	      var _this11 = this;
	
	      this.loading = false;
	      this.formBasicInformation.loading = true;
	      var supp = _warehouse4.default.send(Object.assign({}, this.formBasicInformation.data(), this.formContactInformation.data(), this.formAddressInformation.data()));
	      _warehouse2.default.update(this.$route.params.id, supp).then(function () {
	        _this11.$message({
	          message: _this11.$t('static.warehouse.update.success'),
	          type: 'success'
	        });
	        _this11.$router.push({
	          name: 'warehouse.index',
	          query: {
	            filter: 'active'
	          }
	        });
	      }).catch(function (errors) {
	        _this11.formBasicInformation.loading = false;
	        _this11.formBasicInformation.recordErrors(errors);
	      });
	    },
	    show: function show() {
	      var _this12 = this;
	
	      this.formBasicInformation.hideField('partnerId');
	      this.loading = true;
	      Promise.all([_warehouse2.default.show(this.$route.params.id), _country2.default.all(), _partner2.default.all(), _shippingProvider2.default.all()]).then(function (data) {
	        _this12.loading = false;
	        var ware = data[0];
	        _this12.formBasicInformation.setOptions('shippingProviders', data[3]);
	
	        _this12.formBasicInformation.assignData(ware);
	        _this12.formBasicInformation.disableField('typeName');
	        _this12.formBasicInformation.typeName = _this12.returnWarehouseType;
	        _this12.formAddressInformation.assignData(ware.address);
	        _this12.formContactInformation.assignData(ware.contact);
	        _this12.allProduct(1, _this12.limit);
	        _this12.all(1, _this12.limit);
	        _this12.queryTransacType();
	      });
	    },
	    link: function link(warehouse) {
	      var routeData = this.$router.resolve({
	        params: { id: warehouse.warehouseId },
	        name: 'warehouse.edit'
	      });
	      window.open(routeData.href, '_blank');
	    },
	    transactionLink: function transactionLink(trans) {
	      var name = '';
	      if (trans.via == 'Stock count') {
	        name = 'inventory.stock.view';
	      } else if (trans.via == 'Stock Adjustment') {
	        name = 'inventory.adjustment.view';
	      } else if (trans.via == 'Order') {
	        name = 'orders.edit';
	      } else if (trans.via == 'Purchase') {
	        name = 'inventory.purchase.view';
	      } else if (trans.via.indexOf("SO") !== -1) {
	        name = "orders.edit";
	      } else if (trans.via.indexOf("OC") !== -1) {
	        name = "orders.edit";
	      } else if (trans.via.indexOf("PO") !== -1) {
	        name = "inventory.purchase.view";
	      } else if (trans.via.indexOf("AJ") !== -1) {
	        name = "inventory.adjustment.view";
	      } else if (trans.via.indexOf("SC") !== -1) {
	        name = "inventory.stock.view";
	      } else if (trans.via.indexOf("TW") !== -1) {
	        name = "inventory.transfer.view";
	      } else if (trans.via.indexOf("RS") !== -1) {
	        name = "bills.creditNote";
	      } else if (trans.via.indexOf("BI") !== -1) {
	        name = "production.batches.view";
	      }
	
	      if (trans.id !== null && trans.id !== 0) {
	        var routeData = this.$router.resolve({
	          params: { id: trans.id },
	          name: name
	        });
	        window.open(routeData.href, '_blank');
	      }
	    },
	    hasProduction: function hasProduction() {
	      if (this.account.modules.length > 0) {
	        if (this.account.modules.find(function (module) {
	          return module.name === 'Production';
	        })) return true;
	      }
	      return false;
	    },
	    activateModal: function activateModal(value) {
	      this.setModalContent(function () {
	        return _minimumStock2.default;
	      });
	      this.setModalProps({
	        entries: value,
	        queryProductWarehouse: this.queryProductWarehouse
	      });
	      this.setModalCloseOnClick(false);
	      this.setModalShowClose(true);
	      this.setModalCloseOnPressEscape(false);
	      this.toggleModal(true);
	    },
	    queryProductWarehouse: function queryProductWarehouse() {
	      this.resetSelected();
	      this.allProduct(1, this.limit);
	    }
	  }),
	
	  components: {
	    VPagination: __webpack_require__(16),
	    VForm: __webpack_require__(9),
	    VTable: __webpack_require__(33)
	  }
	};

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(5);
	
	var _warehouse = __webpack_require__(28);
	
	var _warehouse2 = _interopRequireDefault(_warehouse);
	
	var _account = __webpack_require__(12);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _debounce = __webpack_require__(20);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _search = __webpack_require__(22);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _bridgeHandoff = __webpack_require__(81);
	
	var _bridgeHandoff2 = _interopRequireDefault(_bridgeHandoff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: true,
	      sortValue: '',
	      limit: 25
	    };
	  },
	
	
	  computed: _extends({}, (0, _vuex.mapGetters)({
	    warehouses: 'paginateWarehouses'
	  }), {
	    warehousesList: function warehousesList() {
	      return this.warehouses.items.map(function (b) {
	        return b;
	      });
	    }
	  }),
	
	  watch: {
	    $route: function $route() {
	      this.all(1, this.limit);
	    }
	  },
	
	  components: {
	    VCard: __webpack_require__(21),
	    VPagination: __webpack_require__(16),
	    VNoData: __webpack_require__(19)
	  },
	
	  mixins: [_search2.default, _bridgeHandoff2.default],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.setInnerSidebar([{
	      title: this.$t('static.inventory.transaction.title'),
	      options: [{
	        title: this.$t('static.stock.filters.title'),
	        route: {
	          name: 'inventory.stock.index'
	        }
	      }, {
	        title: this.$t('static.adjustment.filters.title'),
	        route: {
	          name: 'inventory.adjustment.index'
	        }
	      }, {
	        title: this.$t('static.purchase.filters.title'),
	        route: {
	          name: 'inventory.purchase.index'
	        }
	      }, {
	        title: this.$t('static.transfer.filters.title'),
	        route: {
	          name: 'inventory.transfer.index'
	        }
	      }],
	      button: this.bridgeStockWriteBlocked ? null : {
	        title: '+ ' + this.$t('static.warehouse.addTransaction.title'),
	        route: {
	          name: 'inventory.transaction.index'
	        }
	      }
	    }, {
	      title: this.$t('static.warehouse.filters.title'),
	      options: [{
	        title: 'Active',
	        route: {
	          name: 'warehouse.index',
	          query: {
	            filter: 'active'
	          }
	        }
	      }, {
	        title: 'In-Active',
	        route: {
	          name: 'warehouse.index',
	          query: {
	            filter: 'inActive'
	          }
	        }
	      }],
	      button: {
	        title: '+ ' + this.$t('static.warehouse.create.title'),
	        route: {
	          name: 'warehouse.create'
	        }
	      }
	    }]);
	
	    _account2.default.rememberPerPage('get', { from: 'warehouse' }).then(function (data) {
	      _this.limit = data.size;
	      _this.all(1, _this.limit);
	    }).catch(function (error) {
	      console.log(error);
	    });
	  },
	  destroyed: function destroyed() {
	    this.unsetInnerSidebar();
	  },
	
	
	  methods: _extends({}, (0, _vuex.mapMutations)({
	    setInnerSidebar: 'SET_INNERSIDEBAR',
	    unsetInnerSidebar: 'UNSET_INNERSIDEBAR'
	  }), {
	    perPage: function perPage(size) {
	      var _this2 = this;
	
	      _account2.default.rememberPerPage('post', { from: 'warehouse', perPage: size }).then(function (data) {
	        _this2.limit = data.size;
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    all: (0, _debounce2.default)(function (page, limit) {
	      var _this3 = this;
	
	      this.loading = true;
	      _warehouse2.default.items({
	        page: page,
	        limit: limit,
	        search: this.getSearch(this.limit),
	        filter: this.$route.query.filter
	      }).then(function () {
	        _this3.loading = false;
	      }).catch(function () {
	        _this3.loadProductsing = false;
	      });
	    }, 800),
	
	    editWarehouse: function editWarehouse(warehouse) {
	      var name = 'warehouse.edit';
	      this.$router.push({
	        name: name,
	        params: { id: warehouse.id }
	      });
	    },
	    editWarehouseNewTab: function editWarehouseNewTab(warehouse) {
	      var name = 'warehouse.edit';
	      var route = this.$router.resolve({
	        name: name,
	        params: { id: warehouse.id }
	      });
	      window.open(route.href, '_blank');
	    },
	    returnWarehouseType: function returnWarehouseType(warehouseTypeName, isBonded) {
	      var isBondedText = isBonded ? this.$t('static.warehouse.info.isBonded') : this.$t('static.warehouse.info.notBonded');
	      return warehouseTypeName + ' ' + isBondedText;
	    }
	  })
	};

/***/ }),
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2262 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2263 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2264 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2265 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2266 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2267 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2268 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2269 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2270 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2271 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2272 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2273 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2274 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2275 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2276 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2277 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2278 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2279 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2280 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2281 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2282 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2283 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2284 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2285 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2286 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2287 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2288 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2289 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2290 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2291 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2292 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2293 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2294 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2295 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2296 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2297 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2298 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2299 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2300 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2301 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2302 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2303 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2304 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2305 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2306 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2307 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2308 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2309 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2310 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2311 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2312 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2313 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2314 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2315 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2316 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2317 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2318 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2319 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2320 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2321 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2322 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2323 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2324 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2325 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2326 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2327 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2328 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2329 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2330 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2331 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2332 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2333 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2334 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2335 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2336 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2337 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2338 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2339 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2340 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2341 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2342 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2343 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2344 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2345 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2346 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2347 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2348 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2349 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2350 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2351 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2352 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2353 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2354 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2355 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2356 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2357 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2358 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2359 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2360 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2361 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2362 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2363 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2364 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2365 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2366 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2367 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2368 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2369 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2370 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2371 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2372 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2373 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2374 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2375 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2376 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2377 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2378 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2379 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2380 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2381 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2382 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2383 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2384 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2385 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2386 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2387 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2388 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2389 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2390 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2391 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2392 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2393 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2394 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2395 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2396 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2397 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2398 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2399 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2400 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2401 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2402 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2403 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2404 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2405 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./geonames": 567,
		"./geonames.js": 567,
		"./google": 568,
		"./google.js": 568,
		"./yahoo": 569,
		"./yahoo.js": 569
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2412;


/***/ }),
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */
/***/ (function(module, exports) {

	module.exports = {"$id":"afterRequest.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["lastAccess","eTag","hitCount"],"properties":{"expires":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"lastAccess":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"eTag":{"type":"string"},"hitCount":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),
/* 2454 */
/***/ (function(module, exports) {

	module.exports = {"$id":"beforeRequest.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["lastAccess","eTag","hitCount"],"properties":{"expires":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"lastAccess":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"eTag":{"type":"string"},"hitCount":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),
/* 2455 */
/***/ (function(module, exports) {

	module.exports = {"$id":"browser.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","version"],"properties":{"name":{"type":"string"},"version":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),
/* 2456 */
/***/ (function(module, exports) {

	module.exports = {"$id":"cache.json#","$schema":"http://json-schema.org/draft-06/schema#","properties":{"beforeRequest":{"oneOf":[{"type":"null"},{"$ref":"beforeRequest.json#"}]},"afterRequest":{"oneOf":[{"type":"null"},{"$ref":"afterRequest.json#"}]},"comment":{"type":"string"}}}

/***/ }),
/* 2457 */
/***/ (function(module, exports) {

	module.exports = {"$id":"content.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["size","mimeType"],"properties":{"size":{"type":"integer"},"compression":{"type":"integer"},"mimeType":{"type":"string"},"text":{"type":"string"},"encoding":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),
/* 2458 */
/***/ (function(module, exports) {

	module.exports = {"$id":"cookie.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"path":{"type":"string"},"domain":{"type":"string"},"expires":{"type":["string","null"],"format":"date-time"},"httpOnly":{"type":"boolean"},"secure":{"type":"boolean"},"comment":{"type":"string"}}}

/***/ }),
/* 2459 */
/***/ (function(module, exports) {

	module.exports = {"$id":"creator.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","version"],"properties":{"name":{"type":"string"},"version":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),
/* 2460 */
/***/ (function(module, exports) {

	module.exports = {"$id":"entry.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["startedDateTime","time","request","response","cache","timings"],"properties":{"pageref":{"type":"string"},"startedDateTime":{"type":"string","format":"date-time","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))"},"time":{"type":"number","min":0},"request":{"$ref":"request.json#"},"response":{"$ref":"response.json#"},"cache":{"$ref":"cache.json#"},"timings":{"$ref":"timings.json#"},"serverIPAddress":{"type":"string","oneOf":[{"format":"ipv4"},{"format":"ipv6"}]},"connection":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),
/* 2461 */
/***/ (function(module, exports) {

	module.exports = {"$id":"har.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["log"],"properties":{"log":{"$ref":"log.json#"}}}

/***/ }),
/* 2462 */
/***/ (function(module, exports) {

	module.exports = {"$id":"header.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),
/* 2463 */
/***/ (function(module, exports) {

	module.exports = {"$id":"log.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["version","creator","entries"],"properties":{"version":{"type":"string"},"creator":{"$ref":"creator.json#"},"browser":{"$ref":"browser.json#"},"pages":{"type":"array","items":{"$ref":"page.json#"}},"entries":{"type":"array","items":{"$ref":"entry.json#"}},"comment":{"type":"string"}}}

/***/ }),
/* 2464 */
/***/ (function(module, exports) {

	module.exports = {"$id":"page.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["startedDateTime","id","title","pageTimings"],"properties":{"startedDateTime":{"type":"string","format":"date-time","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))"},"id":{"type":"string","unique":true},"title":{"type":"string"},"pageTimings":{"$ref":"pageTimings.json#"},"comment":{"type":"string"}}}

/***/ }),
/* 2465 */
/***/ (function(module, exports) {

	module.exports = {"$id":"pageTimings.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","properties":{"onContentLoad":{"type":"number","min":-1},"onLoad":{"type":"number","min":-1},"comment":{"type":"string"}}}

/***/ }),
/* 2466 */
/***/ (function(module, exports) {

	module.exports = {"$id":"postData.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["mimeType"],"properties":{"mimeType":{"type":"string"},"text":{"type":"string"},"params":{"type":"array","required":["name"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"fileName":{"type":"string"},"contentType":{"type":"string"},"comment":{"type":"string"}}},"comment":{"type":"string"}}}

/***/ }),
/* 2467 */
/***/ (function(module, exports) {

	module.exports = {"$id":"query.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),
/* 2468 */
/***/ (function(module, exports) {

	module.exports = {"$id":"request.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["method","url","httpVersion","cookies","headers","queryString","headersSize","bodySize"],"properties":{"method":{"type":"string"},"url":{"type":"string","format":"uri"},"httpVersion":{"type":"string"},"cookies":{"type":"array","items":{"$ref":"cookie.json#"}},"headers":{"type":"array","items":{"$ref":"header.json#"}},"queryString":{"type":"array","items":{"$ref":"query.json#"}},"postData":{"$ref":"postData.json#"},"headersSize":{"type":"integer"},"bodySize":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),
/* 2469 */
/***/ (function(module, exports) {

	module.exports = {"$id":"response.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["status","statusText","httpVersion","cookies","headers","content","redirectURL","headersSize","bodySize"],"properties":{"status":{"type":"integer"},"statusText":{"type":"string"},"httpVersion":{"type":"string"},"cookies":{"type":"array","items":{"$ref":"cookie.json#"}},"headers":{"type":"array","items":{"$ref":"header.json#"}},"content":{"$ref":"content.json#"},"redirectURL":{"type":"string"},"headersSize":{"type":"integer"},"bodySize":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),
/* 2470 */
/***/ (function(module, exports) {

	module.exports = {"$id":"timings.json#","$schema":"http://json-schema.org/draft-06/schema#","required":["send","wait","receive"],"properties":{"dns":{"type":"number","min":-1},"connect":{"type":"number","min":-1},"blocked":{"type":"number","min":-1},"send":{"type":"number","min":-1},"wait":{"type":"number","min":-1},"receive":{"type":"number","min":-1},"ssl":{"type":"number","min":-1},"comment":{"type":"string"}}}

/***/ }),
/* 2471 */
/***/ (function(module, exports) {

	module.exports = {"$schema":"http://json-schema.org/draft-07/schema#","$id":"https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON Schema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}

/***/ }),
/* 2472 */
/***/ (function(module, exports) {

	module.exports = {"$schema":"http://json-schema.org/draft-06/schema#","$id":"http://json-schema.org/draft-06/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"title":{"type":"string"},"description":{"type":"string"},"default":{},"examples":{"type":"array","items":{}},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":{}},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":{},"enum":{"type":"array","minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":{}}

/***/ }),
/* 2473 */
/***/ (function(module, exports) {

	module.exports = {"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atsc-dwd+xml":{"source":"iana","compressible":true},"application/atsc-held+xml":{"source":"iana","compressible":true},"application/atsc-rsat+xml":{"source":"iana","compressible":true},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","compressible":true},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/cbor":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana","compressible":true},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/dns-message":{"source":"iana"},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["ecma","es"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/expect-ct-report+json":{"source":"iana","compressible":true},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana","compressible":true},"application/fhir+json":{"source":"iana","compressible":true},"application/fhir+xml":{"source":"iana","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana","compressible":true},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mmt-aei+xml":{"source":"iana","compressible":true},"application/mmt-usd+xml":{"source":"iana","compressible":true},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true},"application/mrb-publish+xml":{"source":"iana","compressible":true},"application/msc-ivr+xml":{"source":"iana","compressible":true},"application/msc-mixer+xml":{"source":"iana","compressible":true},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana","extensions":["nq"]},"application/n-triples":{"source":"iana","extensions":["nt"]},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana"},"application/news-groupinfo":{"source":"iana"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana"},"application/nss":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odm+xml":{"source":"iana","compressible":true},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/oscore":{"source":"iana"},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p2p-overlay+xml":{"source":"iana","compressible":true},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pem-certificate-chain":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana"},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","compressible":true},"application/pidf-diff+xml":{"source":"iana","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true},"application/route-s-tsid+xml":{"source":"iana","compressible":true},"application/route-usd+xml":{"source":"iana","compressible":true},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana","extensions":["siv","sieve"]},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/stix+json":{"source":"iana","compressible":true},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/tetra_isi":{"source":"iana"},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana"},"application/ttml+xml":{"source":"iana","compressible":true},"application/tve-trigger":{"source":"iana"},"application/tzif":{"source":"iana"},"application/tzif-leap":{"source":"iana"},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true},"application/urc-targetdesc+xml":{"source":"iana","compressible":true},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcdata-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-init-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-transmission-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["keynote"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.exstream-empower+zip":{"source":"iana","compressible":false},"application/vnd.exstream-package":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+cbor":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana"},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.patientecommsdoc":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana"},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","compressible":true},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.veryant.thin":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"apache","extensions":["der","crt","pem"]},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true},"application/xcap-caps+xml":{"source":"iana","compressible":true},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true},"application/xcap-error+xml":{"source":"iana","compressible":true},"application/xcap-ns+xml":{"source":"iana","compressible":true},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana"},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana"},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tetra_acelp":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dts.uhd":{"source":"iana"},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana"},"image/avcs":{"source":"iana"},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana","extensions":["heic"]},"image/heic-sequence":{"source":"iana","extensions":["heics"]},"image/heif":{"source":"iana","extensions":["heif"]},"image/heif-sequence":{"source":"iana","extensions":["heifs"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/jxr":{"source":"iana","extensions":["jxr"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana","extensions":["3mf"]},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/stl":{"source":"iana","extensions":["stl"]},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana","extensions":["ogex"]},"model/vnd.parasolid.transmit.binary":{"source":"iana","extensions":["x_b"]},"model/vnd.parasolid.transmit.text":{"source":"iana","extensions":["x_t"]},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.usdz+zip":{"source":"iana","compressible":false,"extensions":["usdz"]},"model/vnd.valve.source.compiled-map":{"source":"iana","extensions":["bsp"]},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana","extensions":["x3db"]},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana","extensions":["x3dv"]},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana","compressible":false},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"compressible":true,"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mdx":{"compressible":true,"extensions":["mdx"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shex":{"extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.senx.warpscript":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana"},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vc2":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vp8":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}

/***/ }),
/* 2474 */
/***/ (function(module, exports) {

	module.exports = ["ac","com.ac","edu.ac","gov.ac","net.ac","mil.ac","org.ac","ad","nom.ad","ae","co.ae","net.ae","org.ae","sch.ae","ac.ae","gov.ae","mil.ae","aero","accident-investigation.aero","accident-prevention.aero","aerobatic.aero","aeroclub.aero","aerodrome.aero","agents.aero","aircraft.aero","airline.aero","airport.aero","air-surveillance.aero","airtraffic.aero","air-traffic-control.aero","ambulance.aero","amusement.aero","association.aero","author.aero","ballooning.aero","broker.aero","caa.aero","cargo.aero","catering.aero","certification.aero","championship.aero","charter.aero","civilaviation.aero","club.aero","conference.aero","consultant.aero","consulting.aero","control.aero","council.aero","crew.aero","design.aero","dgca.aero","educator.aero","emergency.aero","engine.aero","engineer.aero","entertainment.aero","equipment.aero","exchange.aero","express.aero","federation.aero","flight.aero","freight.aero","fuel.aero","gliding.aero","government.aero","groundhandling.aero","group.aero","hanggliding.aero","homebuilt.aero","insurance.aero","journal.aero","journalist.aero","leasing.aero","logistics.aero","magazine.aero","maintenance.aero","media.aero","microlight.aero","modelling.aero","navigation.aero","parachuting.aero","paragliding.aero","passenger-association.aero","pilot.aero","press.aero","production.aero","recreation.aero","repbody.aero","res.aero","research.aero","rotorcraft.aero","safety.aero","scientist.aero","services.aero","show.aero","skydiving.aero","software.aero","student.aero","trader.aero","trading.aero","trainer.aero","union.aero","workinggroup.aero","works.aero","af","gov.af","com.af","org.af","net.af","edu.af","ag","com.ag","org.ag","net.ag","co.ag","nom.ag","ai","off.ai","com.ai","net.ai","org.ai","al","com.al","edu.al","gov.al","mil.al","net.al","org.al","am","co.am","com.am","commune.am","net.am","org.am","ao","ed.ao","gv.ao","og.ao","co.ao","pb.ao","it.ao","aq","ar","com.ar","edu.ar","gob.ar","gov.ar","int.ar","mil.ar","musica.ar","net.ar","org.ar","tur.ar","arpa","e164.arpa","in-addr.arpa","ip6.arpa","iris.arpa","uri.arpa","urn.arpa","as","gov.as","asia","at","ac.at","co.at","gv.at","or.at","au","com.au","net.au","org.au","edu.au","gov.au","asn.au","id.au","info.au","conf.au","oz.au","act.au","nsw.au","nt.au","qld.au","sa.au","tas.au","vic.au","wa.au","act.edu.au","catholic.edu.au","eq.edu.au","nsw.edu.au","nt.edu.au","qld.edu.au","sa.edu.au","tas.edu.au","vic.edu.au","wa.edu.au","qld.gov.au","sa.gov.au","tas.gov.au","vic.gov.au","wa.gov.au","education.tas.edu.au","schools.nsw.edu.au","aw","com.aw","ax","az","com.az","net.az","int.az","gov.az","org.az","edu.az","info.az","pp.az","mil.az","name.az","pro.az","biz.az","ba","com.ba","edu.ba","gov.ba","mil.ba","net.ba","org.ba","bb","biz.bb","co.bb","com.bb","edu.bb","gov.bb","info.bb","net.bb","org.bb","store.bb","tv.bb","*.bd","be","ac.be","bf","gov.bf","bg","a.bg","b.bg","c.bg","d.bg","e.bg","f.bg","g.bg","h.bg","i.bg","j.bg","k.bg","l.bg","m.bg","n.bg","o.bg","p.bg","q.bg","r.bg","s.bg","t.bg","u.bg","v.bg","w.bg","x.bg","y.bg","z.bg","0.bg","1.bg","2.bg","3.bg","4.bg","5.bg","6.bg","7.bg","8.bg","9.bg","bh","com.bh","edu.bh","net.bh","org.bh","gov.bh","bi","co.bi","com.bi","edu.bi","or.bi","org.bi","biz","bj","asso.bj","barreau.bj","gouv.bj","bm","com.bm","edu.bm","gov.bm","net.bm","org.bm","bn","com.bn","edu.bn","gov.bn","net.bn","org.bn","bo","com.bo","edu.bo","gob.bo","int.bo","org.bo","net.bo","mil.bo","tv.bo","web.bo","academia.bo","agro.bo","arte.bo","blog.bo","bolivia.bo","ciencia.bo","cooperativa.bo","democracia.bo","deporte.bo","ecologia.bo","economia.bo","empresa.bo","indigena.bo","industria.bo","info.bo","medicina.bo","movimiento.bo","musica.bo","natural.bo","nombre.bo","noticias.bo","patria.bo","politica.bo","profesional.bo","plurinacional.bo","pueblo.bo","revista.bo","salud.bo","tecnologia.bo","tksat.bo","transporte.bo","wiki.bo","br","9guacu.br","abc.br","adm.br","adv.br","agr.br","aju.br","am.br","anani.br","aparecida.br","arq.br","art.br","ato.br","b.br","barueri.br","belem.br","bhz.br","bio.br","blog.br","bmd.br","boavista.br","bsb.br","campinagrande.br","campinas.br","caxias.br","cim.br","cng.br","cnt.br","com.br","contagem.br","coop.br","cri.br","cuiaba.br","curitiba.br","def.br","ecn.br","eco.br","edu.br","emp.br","eng.br","esp.br","etc.br","eti.br","far.br","feira.br","flog.br","floripa.br","fm.br","fnd.br","fortal.br","fot.br","foz.br","fst.br","g12.br","ggf.br","goiania.br","gov.br","ac.gov.br","al.gov.br","am.gov.br","ap.gov.br","ba.gov.br","ce.gov.br","df.gov.br","es.gov.br","go.gov.br","ma.gov.br","mg.gov.br","ms.gov.br","mt.gov.br","pa.gov.br","pb.gov.br","pe.gov.br","pi.gov.br","pr.gov.br","rj.gov.br","rn.gov.br","ro.gov.br","rr.gov.br","rs.gov.br","sc.gov.br","se.gov.br","sp.gov.br","to.gov.br","gru.br","imb.br","ind.br","inf.br","jab.br","jampa.br","jdf.br","joinville.br","jor.br","jus.br","leg.br","lel.br","londrina.br","macapa.br","maceio.br","manaus.br","maringa.br","mat.br","med.br","mil.br","morena.br","mp.br","mus.br","natal.br","net.br","niteroi.br","*.nom.br","not.br","ntr.br","odo.br","ong.br","org.br","osasco.br","palmas.br","poa.br","ppg.br","pro.br","psc.br","psi.br","pvh.br","qsl.br","radio.br","rec.br","recife.br","ribeirao.br","rio.br","riobranco.br","riopreto.br","salvador.br","sampa.br","santamaria.br","santoandre.br","saobernardo.br","saogonca.br","sjc.br","slg.br","slz.br","sorocaba.br","srv.br","taxi.br","tc.br","teo.br","the.br","tmp.br","trd.br","tur.br","tv.br","udi.br","vet.br","vix.br","vlog.br","wiki.br","zlg.br","bs","com.bs","net.bs","org.bs","edu.bs","gov.bs","bt","com.bt","edu.bt","gov.bt","net.bt","org.bt","bv","bw","co.bw","org.bw","by","gov.by","mil.by","com.by","of.by","bz","com.bz","net.bz","org.bz","edu.bz","gov.bz","ca","ab.ca","bc.ca","mb.ca","nb.ca","nf.ca","nl.ca","ns.ca","nt.ca","nu.ca","on.ca","pe.ca","qc.ca","sk.ca","yk.ca","gc.ca","cat","cc","cd","gov.cd","cf","cg","ch","ci","org.ci","or.ci","com.ci","co.ci","edu.ci","ed.ci","ac.ci","net.ci","go.ci","asso.ci","aéroport.ci","int.ci","presse.ci","md.ci","gouv.ci","*.ck","!www.ck","cl","gov.cl","gob.cl","co.cl","mil.cl","cm","co.cm","com.cm","gov.cm","net.cm","cn","ac.cn","com.cn","edu.cn","gov.cn","net.cn","org.cn","mil.cn","公司.cn","网络.cn","網絡.cn","ah.cn","bj.cn","cq.cn","fj.cn","gd.cn","gs.cn","gz.cn","gx.cn","ha.cn","hb.cn","he.cn","hi.cn","hl.cn","hn.cn","jl.cn","js.cn","jx.cn","ln.cn","nm.cn","nx.cn","qh.cn","sc.cn","sd.cn","sh.cn","sn.cn","sx.cn","tj.cn","xj.cn","xz.cn","yn.cn","zj.cn","hk.cn","mo.cn","tw.cn","co","arts.co","com.co","edu.co","firm.co","gov.co","info.co","int.co","mil.co","net.co","nom.co","org.co","rec.co","web.co","com","coop","cr","ac.cr","co.cr","ed.cr","fi.cr","go.cr","or.cr","sa.cr","cu","com.cu","edu.cu","org.cu","net.cu","gov.cu","inf.cu","cv","cw","com.cw","edu.cw","net.cw","org.cw","cx","gov.cx","cy","ac.cy","biz.cy","com.cy","ekloges.cy","gov.cy","ltd.cy","name.cy","net.cy","org.cy","parliament.cy","press.cy","pro.cy","tm.cy","cz","de","dj","dk","dm","com.dm","net.dm","org.dm","edu.dm","gov.dm","do","art.do","com.do","edu.do","gob.do","gov.do","mil.do","net.do","org.do","sld.do","web.do","dz","com.dz","org.dz","net.dz","gov.dz","edu.dz","asso.dz","pol.dz","art.dz","ec","com.ec","info.ec","net.ec","fin.ec","k12.ec","med.ec","pro.ec","org.ec","edu.ec","gov.ec","gob.ec","mil.ec","edu","ee","edu.ee","gov.ee","riik.ee","lib.ee","med.ee","com.ee","pri.ee","aip.ee","org.ee","fie.ee","eg","com.eg","edu.eg","eun.eg","gov.eg","mil.eg","name.eg","net.eg","org.eg","sci.eg","*.er","es","com.es","nom.es","org.es","gob.es","edu.es","et","com.et","gov.et","org.et","edu.et","biz.et","name.et","info.et","net.et","eu","fi","aland.fi","*.fj","*.fk","fm","fo","fr","asso.fr","com.fr","gouv.fr","nom.fr","prd.fr","tm.fr","aeroport.fr","avocat.fr","avoues.fr","cci.fr","chambagri.fr","chirurgiens-dentistes.fr","experts-comptables.fr","geometre-expert.fr","greta.fr","huissier-justice.fr","medecin.fr","notaires.fr","pharmacien.fr","port.fr","veterinaire.fr","ga","gb","gd","ge","com.ge","edu.ge","gov.ge","org.ge","mil.ge","net.ge","pvt.ge","gf","gg","co.gg","net.gg","org.gg","gh","com.gh","edu.gh","gov.gh","org.gh","mil.gh","gi","com.gi","ltd.gi","gov.gi","mod.gi","edu.gi","org.gi","gl","co.gl","com.gl","edu.gl","net.gl","org.gl","gm","gn","ac.gn","com.gn","edu.gn","gov.gn","org.gn","net.gn","gov","gp","com.gp","net.gp","mobi.gp","edu.gp","org.gp","asso.gp","gq","gr","com.gr","edu.gr","net.gr","org.gr","gov.gr","gs","gt","com.gt","edu.gt","gob.gt","ind.gt","mil.gt","net.gt","org.gt","gu","com.gu","edu.gu","gov.gu","guam.gu","info.gu","net.gu","org.gu","web.gu","gw","gy","co.gy","com.gy","edu.gy","gov.gy","net.gy","org.gy","hk","com.hk","edu.hk","gov.hk","idv.hk","net.hk","org.hk","公司.hk","教育.hk","敎育.hk","政府.hk","個人.hk","个人.hk","箇人.hk","網络.hk","网络.hk","组織.hk","網絡.hk","网絡.hk","组织.hk","組織.hk","組织.hk","hm","hn","com.hn","edu.hn","org.hn","net.hn","mil.hn","gob.hn","hr","iz.hr","from.hr","name.hr","com.hr","ht","com.ht","shop.ht","firm.ht","info.ht","adult.ht","net.ht","pro.ht","org.ht","med.ht","art.ht","coop.ht","pol.ht","asso.ht","edu.ht","rel.ht","gouv.ht","perso.ht","hu","co.hu","info.hu","org.hu","priv.hu","sport.hu","tm.hu","2000.hu","agrar.hu","bolt.hu","casino.hu","city.hu","erotica.hu","erotika.hu","film.hu","forum.hu","games.hu","hotel.hu","ingatlan.hu","jogasz.hu","konyvelo.hu","lakas.hu","media.hu","news.hu","reklam.hu","sex.hu","shop.hu","suli.hu","szex.hu","tozsde.hu","utazas.hu","video.hu","id","ac.id","biz.id","co.id","desa.id","go.id","mil.id","my.id","net.id","or.id","ponpes.id","sch.id","web.id","ie","gov.ie","il","ac.il","co.il","gov.il","idf.il","k12.il","muni.il","net.il","org.il","im","ac.im","co.im","com.im","ltd.co.im","net.im","org.im","plc.co.im","tt.im","tv.im","in","co.in","firm.in","net.in","org.in","gen.in","ind.in","nic.in","ac.in","edu.in","res.in","gov.in","mil.in","info","int","eu.int","io","com.io","iq","gov.iq","edu.iq","mil.iq","com.iq","org.iq","net.iq","ir","ac.ir","co.ir","gov.ir","id.ir","net.ir","org.ir","sch.ir","ایران.ir","ايران.ir","is","net.is","com.is","edu.is","gov.is","org.is","int.is","it","gov.it","edu.it","abr.it","abruzzo.it","aosta-valley.it","aostavalley.it","bas.it","basilicata.it","cal.it","calabria.it","cam.it","campania.it","emilia-romagna.it","emiliaromagna.it","emr.it","friuli-v-giulia.it","friuli-ve-giulia.it","friuli-vegiulia.it","friuli-venezia-giulia.it","friuli-veneziagiulia.it","friuli-vgiulia.it","friuliv-giulia.it","friulive-giulia.it","friulivegiulia.it","friulivenezia-giulia.it","friuliveneziagiulia.it","friulivgiulia.it","fvg.it","laz.it","lazio.it","lig.it","liguria.it","lom.it","lombardia.it","lombardy.it","lucania.it","mar.it","marche.it","mol.it","molise.it","piedmont.it","piemonte.it","pmn.it","pug.it","puglia.it","sar.it","sardegna.it","sardinia.it","sic.it","sicilia.it","sicily.it","taa.it","tos.it","toscana.it","trentin-sud-tirol.it","trentin-süd-tirol.it","trentin-sudtirol.it","trentin-südtirol.it","trentin-sued-tirol.it","trentin-suedtirol.it","trentino-a-adige.it","trentino-aadige.it","trentino-alto-adige.it","trentino-altoadige.it","trentino-s-tirol.it","trentino-stirol.it","trentino-sud-tirol.it","trentino-süd-tirol.it","trentino-sudtirol.it","trentino-südtirol.it","trentino-sued-tirol.it","trentino-suedtirol.it","trentino.it","trentinoa-adige.it","trentinoaadige.it","trentinoalto-adige.it","trentinoaltoadige.it","trentinos-tirol.it","trentinostirol.it","trentinosud-tirol.it","trentinosüd-tirol.it","trentinosudtirol.it","trentinosüdtirol.it","trentinosued-tirol.it","trentinosuedtirol.it","trentinsud-tirol.it","trentinsüd-tirol.it","trentinsudtirol.it","trentinsüdtirol.it","trentinsued-tirol.it","trentinsuedtirol.it","tuscany.it","umb.it","umbria.it","val-d-aosta.it","val-daosta.it","vald-aosta.it","valdaosta.it","valle-aosta.it","valle-d-aosta.it","valle-daosta.it","valleaosta.it","valled-aosta.it","valledaosta.it","vallee-aoste.it","vallée-aoste.it","vallee-d-aoste.it","vallée-d-aoste.it","valleeaoste.it","valléeaoste.it","valleedaoste.it","valléedaoste.it","vao.it","vda.it","ven.it","veneto.it","ag.it","agrigento.it","al.it","alessandria.it","alto-adige.it","altoadige.it","an.it","ancona.it","andria-barletta-trani.it","andria-trani-barletta.it","andriabarlettatrani.it","andriatranibarletta.it","ao.it","aosta.it","aoste.it","ap.it","aq.it","aquila.it","ar.it","arezzo.it","ascoli-piceno.it","ascolipiceno.it","asti.it","at.it","av.it","avellino.it","ba.it","balsan-sudtirol.it","balsan-südtirol.it","balsan-suedtirol.it","balsan.it","bari.it","barletta-trani-andria.it","barlettatraniandria.it","belluno.it","benevento.it","bergamo.it","bg.it","bi.it","biella.it","bl.it","bn.it","bo.it","bologna.it","bolzano-altoadige.it","bolzano.it","bozen-sudtirol.it","bozen-südtirol.it","bozen-suedtirol.it","bozen.it","br.it","brescia.it","brindisi.it","bs.it","bt.it","bulsan-sudtirol.it","bulsan-südtirol.it","bulsan-suedtirol.it","bulsan.it","bz.it","ca.it","cagliari.it","caltanissetta.it","campidano-medio.it","campidanomedio.it","campobasso.it","carbonia-iglesias.it","carboniaiglesias.it","carrara-massa.it","carraramassa.it","caserta.it","catania.it","catanzaro.it","cb.it","ce.it","cesena-forli.it","cesena-forlì.it","cesenaforli.it","cesenaforlì.it","ch.it","chieti.it","ci.it","cl.it","cn.it","co.it","como.it","cosenza.it","cr.it","cremona.it","crotone.it","cs.it","ct.it","cuneo.it","cz.it","dell-ogliastra.it","dellogliastra.it","en.it","enna.it","fc.it","fe.it","fermo.it","ferrara.it","fg.it","fi.it","firenze.it","florence.it","fm.it","foggia.it","forli-cesena.it","forlì-cesena.it","forlicesena.it","forlìcesena.it","fr.it","frosinone.it","ge.it","genoa.it","genova.it","go.it","gorizia.it","gr.it","grosseto.it","iglesias-carbonia.it","iglesiascarbonia.it","im.it","imperia.it","is.it","isernia.it","kr.it","la-spezia.it","laquila.it","laspezia.it","latina.it","lc.it","le.it","lecce.it","lecco.it","li.it","livorno.it","lo.it","lodi.it","lt.it","lu.it","lucca.it","macerata.it","mantova.it","massa-carrara.it","massacarrara.it","matera.it","mb.it","mc.it","me.it","medio-campidano.it","mediocampidano.it","messina.it","mi.it","milan.it","milano.it","mn.it","mo.it","modena.it","monza-brianza.it","monza-e-della-brianza.it","monza.it","monzabrianza.it","monzaebrianza.it","monzaedellabrianza.it","ms.it","mt.it","na.it","naples.it","napoli.it","no.it","novara.it","nu.it","nuoro.it","og.it","ogliastra.it","olbia-tempio.it","olbiatempio.it","or.it","oristano.it","ot.it","pa.it","padova.it","padua.it","palermo.it","parma.it","pavia.it","pc.it","pd.it","pe.it","perugia.it","pesaro-urbino.it","pesarourbino.it","pescara.it","pg.it","pi.it","piacenza.it","pisa.it","pistoia.it","pn.it","po.it","pordenone.it","potenza.it","pr.it","prato.it","pt.it","pu.it","pv.it","pz.it","ra.it","ragusa.it","ravenna.it","rc.it","re.it","reggio-calabria.it","reggio-emilia.it","reggiocalabria.it","reggioemilia.it","rg.it","ri.it","rieti.it","rimini.it","rm.it","rn.it","ro.it","roma.it","rome.it","rovigo.it","sa.it","salerno.it","sassari.it","savona.it","si.it","siena.it","siracusa.it","so.it","sondrio.it","sp.it","sr.it","ss.it","suedtirol.it","südtirol.it","sv.it","ta.it","taranto.it","te.it","tempio-olbia.it","tempioolbia.it","teramo.it","terni.it","tn.it","to.it","torino.it","tp.it","tr.it","trani-andria-barletta.it","trani-barletta-andria.it","traniandriabarletta.it","tranibarlettaandria.it","trapani.it","trento.it","treviso.it","trieste.it","ts.it","turin.it","tv.it","ud.it","udine.it","urbino-pesaro.it","urbinopesaro.it","va.it","varese.it","vb.it","vc.it","ve.it","venezia.it","venice.it","verbania.it","vercelli.it","verona.it","vi.it","vibo-valentia.it","vibovalentia.it","vicenza.it","viterbo.it","vr.it","vs.it","vt.it","vv.it","je","co.je","net.je","org.je","*.jm","jo","com.jo","org.jo","net.jo","edu.jo","sch.jo","gov.jo","mil.jo","name.jo","jobs","jp","ac.jp","ad.jp","co.jp","ed.jp","go.jp","gr.jp","lg.jp","ne.jp","or.jp","aichi.jp","akita.jp","aomori.jp","chiba.jp","ehime.jp","fukui.jp","fukuoka.jp","fukushima.jp","gifu.jp","gunma.jp","hiroshima.jp","hokkaido.jp","hyogo.jp","ibaraki.jp","ishikawa.jp","iwate.jp","kagawa.jp","kagoshima.jp","kanagawa.jp","kochi.jp","kumamoto.jp","kyoto.jp","mie.jp","miyagi.jp","miyazaki.jp","nagano.jp","nagasaki.jp","nara.jp","niigata.jp","oita.jp","okayama.jp","okinawa.jp","osaka.jp","saga.jp","saitama.jp","shiga.jp","shimane.jp","shizuoka.jp","tochigi.jp","tokushima.jp","tokyo.jp","tottori.jp","toyama.jp","wakayama.jp","yamagata.jp","yamaguchi.jp","yamanashi.jp","栃木.jp","愛知.jp","愛媛.jp","兵庫.jp","熊本.jp","茨城.jp","北海道.jp","千葉.jp","和歌山.jp","長崎.jp","長野.jp","新潟.jp","青森.jp","静岡.jp","東京.jp","石川.jp","埼玉.jp","三重.jp","京都.jp","佐賀.jp","大分.jp","大阪.jp","奈良.jp","宮城.jp","宮崎.jp","富山.jp","山口.jp","山形.jp","山梨.jp","岩手.jp","岐阜.jp","岡山.jp","島根.jp","広島.jp","徳島.jp","沖縄.jp","滋賀.jp","神奈川.jp","福井.jp","福岡.jp","福島.jp","秋田.jp","群馬.jp","香川.jp","高知.jp","鳥取.jp","鹿児島.jp","*.kawasaki.jp","*.kitakyushu.jp","*.kobe.jp","*.nagoya.jp","*.sapporo.jp","*.sendai.jp","*.yokohama.jp","!city.kawasaki.jp","!city.kitakyushu.jp","!city.kobe.jp","!city.nagoya.jp","!city.sapporo.jp","!city.sendai.jp","!city.yokohama.jp","aisai.aichi.jp","ama.aichi.jp","anjo.aichi.jp","asuke.aichi.jp","chiryu.aichi.jp","chita.aichi.jp","fuso.aichi.jp","gamagori.aichi.jp","handa.aichi.jp","hazu.aichi.jp","hekinan.aichi.jp","higashiura.aichi.jp","ichinomiya.aichi.jp","inazawa.aichi.jp","inuyama.aichi.jp","isshiki.aichi.jp","iwakura.aichi.jp","kanie.aichi.jp","kariya.aichi.jp","kasugai.aichi.jp","kira.aichi.jp","kiyosu.aichi.jp","komaki.aichi.jp","konan.aichi.jp","kota.aichi.jp","mihama.aichi.jp","miyoshi.aichi.jp","nishio.aichi.jp","nisshin.aichi.jp","obu.aichi.jp","oguchi.aichi.jp","oharu.aichi.jp","okazaki.aichi.jp","owariasahi.aichi.jp","seto.aichi.jp","shikatsu.aichi.jp","shinshiro.aichi.jp","shitara.aichi.jp","tahara.aichi.jp","takahama.aichi.jp","tobishima.aichi.jp","toei.aichi.jp","togo.aichi.jp","tokai.aichi.jp","tokoname.aichi.jp","toyoake.aichi.jp","toyohashi.aichi.jp","toyokawa.aichi.jp","toyone.aichi.jp","toyota.aichi.jp","tsushima.aichi.jp","yatomi.aichi.jp","akita.akita.jp","daisen.akita.jp","fujisato.akita.jp","gojome.akita.jp","hachirogata.akita.jp","happou.akita.jp","higashinaruse.akita.jp","honjo.akita.jp","honjyo.akita.jp","ikawa.akita.jp","kamikoani.akita.jp","kamioka.akita.jp","katagami.akita.jp","kazuno.akita.jp","kitaakita.akita.jp","kosaka.akita.jp","kyowa.akita.jp","misato.akita.jp","mitane.akita.jp","moriyoshi.akita.jp","nikaho.akita.jp","noshiro.akita.jp","odate.akita.jp","oga.akita.jp","ogata.akita.jp","semboku.akita.jp","yokote.akita.jp","yurihonjo.akita.jp","aomori.aomori.jp","gonohe.aomori.jp","hachinohe.aomori.jp","hashikami.aomori.jp","hiranai.aomori.jp","hirosaki.aomori.jp","itayanagi.aomori.jp","kuroishi.aomori.jp","misawa.aomori.jp","mutsu.aomori.jp","nakadomari.aomori.jp","noheji.aomori.jp","oirase.aomori.jp","owani.aomori.jp","rokunohe.aomori.jp","sannohe.aomori.jp","shichinohe.aomori.jp","shingo.aomori.jp","takko.aomori.jp","towada.aomori.jp","tsugaru.aomori.jp","tsuruta.aomori.jp","abiko.chiba.jp","asahi.chiba.jp","chonan.chiba.jp","chosei.chiba.jp","choshi.chiba.jp","chuo.chiba.jp","funabashi.chiba.jp","futtsu.chiba.jp","hanamigawa.chiba.jp","ichihara.chiba.jp","ichikawa.chiba.jp","ichinomiya.chiba.jp","inzai.chiba.jp","isumi.chiba.jp","kamagaya.chiba.jp","kamogawa.chiba.jp","kashiwa.chiba.jp","katori.chiba.jp","katsuura.chiba.jp","kimitsu.chiba.jp","kisarazu.chiba.jp","kozaki.chiba.jp","kujukuri.chiba.jp","kyonan.chiba.jp","matsudo.chiba.jp","midori.chiba.jp","mihama.chiba.jp","minamiboso.chiba.jp","mobara.chiba.jp","mutsuzawa.chiba.jp","nagara.chiba.jp","nagareyama.chiba.jp","narashino.chiba.jp","narita.chiba.jp","noda.chiba.jp","oamishirasato.chiba.jp","omigawa.chiba.jp","onjuku.chiba.jp","otaki.chiba.jp","sakae.chiba.jp","sakura.chiba.jp","shimofusa.chiba.jp","shirako.chiba.jp","shiroi.chiba.jp","shisui.chiba.jp","sodegaura.chiba.jp","sosa.chiba.jp","tako.chiba.jp","tateyama.chiba.jp","togane.chiba.jp","tohnosho.chiba.jp","tomisato.chiba.jp","urayasu.chiba.jp","yachimata.chiba.jp","yachiyo.chiba.jp","yokaichiba.chiba.jp","yokoshibahikari.chiba.jp","yotsukaido.chiba.jp","ainan.ehime.jp","honai.ehime.jp","ikata.ehime.jp","imabari.ehime.jp","iyo.ehime.jp","kamijima.ehime.jp","kihoku.ehime.jp","kumakogen.ehime.jp","masaki.ehime.jp","matsuno.ehime.jp","matsuyama.ehime.jp","namikata.ehime.jp","niihama.ehime.jp","ozu.ehime.jp","saijo.ehime.jp","seiyo.ehime.jp","shikokuchuo.ehime.jp","tobe.ehime.jp","toon.ehime.jp","uchiko.ehime.jp","uwajima.ehime.jp","yawatahama.ehime.jp","echizen.fukui.jp","eiheiji.fukui.jp","fukui.fukui.jp","ikeda.fukui.jp","katsuyama.fukui.jp","mihama.fukui.jp","minamiechizen.fukui.jp","obama.fukui.jp","ohi.fukui.jp","ono.fukui.jp","sabae.fukui.jp","sakai.fukui.jp","takahama.fukui.jp","tsuruga.fukui.jp","wakasa.fukui.jp","ashiya.fukuoka.jp","buzen.fukuoka.jp","chikugo.fukuoka.jp","chikuho.fukuoka.jp","chikujo.fukuoka.jp","chikushino.fukuoka.jp","chikuzen.fukuoka.jp","chuo.fukuoka.jp","dazaifu.fukuoka.jp","fukuchi.fukuoka.jp","hakata.fukuoka.jp","higashi.fukuoka.jp","hirokawa.fukuoka.jp","hisayama.fukuoka.jp","iizuka.fukuoka.jp","inatsuki.fukuoka.jp","kaho.fukuoka.jp","kasuga.fukuoka.jp","kasuya.fukuoka.jp","kawara.fukuoka.jp","keisen.fukuoka.jp","koga.fukuoka.jp","kurate.fukuoka.jp","kurogi.fukuoka.jp","kurume.fukuoka.jp","minami.fukuoka.jp","miyako.fukuoka.jp","miyama.fukuoka.jp","miyawaka.fukuoka.jp","mizumaki.fukuoka.jp","munakata.fukuoka.jp","nakagawa.fukuoka.jp","nakama.fukuoka.jp","nishi.fukuoka.jp","nogata.fukuoka.jp","ogori.fukuoka.jp","okagaki.fukuoka.jp","okawa.fukuoka.jp","oki.fukuoka.jp","omuta.fukuoka.jp","onga.fukuoka.jp","onojo.fukuoka.jp","oto.fukuoka.jp","saigawa.fukuoka.jp","sasaguri.fukuoka.jp","shingu.fukuoka.jp","shinyoshitomi.fukuoka.jp","shonai.fukuoka.jp","soeda.fukuoka.jp","sue.fukuoka.jp","tachiarai.fukuoka.jp","tagawa.fukuoka.jp","takata.fukuoka.jp","toho.fukuoka.jp","toyotsu.fukuoka.jp","tsuiki.fukuoka.jp","ukiha.fukuoka.jp","umi.fukuoka.jp","usui.fukuoka.jp","yamada.fukuoka.jp","yame.fukuoka.jp","yanagawa.fukuoka.jp","yukuhashi.fukuoka.jp","aizubange.fukushima.jp","aizumisato.fukushima.jp","aizuwakamatsu.fukushima.jp","asakawa.fukushima.jp","bandai.fukushima.jp","date.fukushima.jp","fukushima.fukushima.jp","furudono.fukushima.jp","futaba.fukushima.jp","hanawa.fukushima.jp","higashi.fukushima.jp","hirata.fukushima.jp","hirono.fukushima.jp","iitate.fukushima.jp","inawashiro.fukushima.jp","ishikawa.fukushima.jp","iwaki.fukushima.jp","izumizaki.fukushima.jp","kagamiishi.fukushima.jp","kaneyama.fukushima.jp","kawamata.fukushima.jp","kitakata.fukushima.jp","kitashiobara.fukushima.jp","koori.fukushima.jp","koriyama.fukushima.jp","kunimi.fukushima.jp","miharu.fukushima.jp","mishima.fukushima.jp","namie.fukushima.jp","nango.fukushima.jp","nishiaizu.fukushima.jp","nishigo.fukushima.jp","okuma.fukushima.jp","omotego.fukushima.jp","ono.fukushima.jp","otama.fukushima.jp","samegawa.fukushima.jp","shimogo.fukushima.jp","shirakawa.fukushima.jp","showa.fukushima.jp","soma.fukushima.jp","sukagawa.fukushima.jp","taishin.fukushima.jp","tamakawa.fukushima.jp","tanagura.fukushima.jp","tenei.fukushima.jp","yabuki.fukushima.jp","yamato.fukushima.jp","yamatsuri.fukushima.jp","yanaizu.fukushima.jp","yugawa.fukushima.jp","anpachi.gifu.jp","ena.gifu.jp","gifu.gifu.jp","ginan.gifu.jp","godo.gifu.jp","gujo.gifu.jp","hashima.gifu.jp","hichiso.gifu.jp","hida.gifu.jp","higashishirakawa.gifu.jp","ibigawa.gifu.jp","ikeda.gifu.jp","kakamigahara.gifu.jp","kani.gifu.jp","kasahara.gifu.jp","kasamatsu.gifu.jp","kawaue.gifu.jp","kitagata.gifu.jp","mino.gifu.jp","minokamo.gifu.jp","mitake.gifu.jp","mizunami.gifu.jp","motosu.gifu.jp","nakatsugawa.gifu.jp","ogaki.gifu.jp","sakahogi.gifu.jp","seki.gifu.jp","sekigahara.gifu.jp","shirakawa.gifu.jp","tajimi.gifu.jp","takayama.gifu.jp","tarui.gifu.jp","toki.gifu.jp","tomika.gifu.jp","wanouchi.gifu.jp","yamagata.gifu.jp","yaotsu.gifu.jp","yoro.gifu.jp","annaka.gunma.jp","chiyoda.gunma.jp","fujioka.gunma.jp","higashiagatsuma.gunma.jp","isesaki.gunma.jp","itakura.gunma.jp","kanna.gunma.jp","kanra.gunma.jp","katashina.gunma.jp","kawaba.gunma.jp","kiryu.gunma.jp","kusatsu.gunma.jp","maebashi.gunma.jp","meiwa.gunma.jp","midori.gunma.jp","minakami.gunma.jp","naganohara.gunma.jp","nakanojo.gunma.jp","nanmoku.gunma.jp","numata.gunma.jp","oizumi.gunma.jp","ora.gunma.jp","ota.gunma.jp","shibukawa.gunma.jp","shimonita.gunma.jp","shinto.gunma.jp","showa.gunma.jp","takasaki.gunma.jp","takayama.gunma.jp","tamamura.gunma.jp","tatebayashi.gunma.jp","tomioka.gunma.jp","tsukiyono.gunma.jp","tsumagoi.gunma.jp","ueno.gunma.jp","yoshioka.gunma.jp","asaminami.hiroshima.jp","daiwa.hiroshima.jp","etajima.hiroshima.jp","fuchu.hiroshima.jp","fukuyama.hiroshima.jp","hatsukaichi.hiroshima.jp","higashihiroshima.hiroshima.jp","hongo.hiroshima.jp","jinsekikogen.hiroshima.jp","kaita.hiroshima.jp","kui.hiroshima.jp","kumano.hiroshima.jp","kure.hiroshima.jp","mihara.hiroshima.jp","miyoshi.hiroshima.jp","naka.hiroshima.jp","onomichi.hiroshima.jp","osakikamijima.hiroshima.jp","otake.hiroshima.jp","saka.hiroshima.jp","sera.hiroshima.jp","seranishi.hiroshima.jp","shinichi.hiroshima.jp","shobara.hiroshima.jp","takehara.hiroshima.jp","abashiri.hokkaido.jp","abira.hokkaido.jp","aibetsu.hokkaido.jp","akabira.hokkaido.jp","akkeshi.hokkaido.jp","asahikawa.hokkaido.jp","ashibetsu.hokkaido.jp","ashoro.hokkaido.jp","assabu.hokkaido.jp","atsuma.hokkaido.jp","bibai.hokkaido.jp","biei.hokkaido.jp","bifuka.hokkaido.jp","bihoro.hokkaido.jp","biratori.hokkaido.jp","chippubetsu.hokkaido.jp","chitose.hokkaido.jp","date.hokkaido.jp","ebetsu.hokkaido.jp","embetsu.hokkaido.jp","eniwa.hokkaido.jp","erimo.hokkaido.jp","esan.hokkaido.jp","esashi.hokkaido.jp","fukagawa.hokkaido.jp","fukushima.hokkaido.jp","furano.hokkaido.jp","furubira.hokkaido.jp","haboro.hokkaido.jp","hakodate.hokkaido.jp","hamatonbetsu.hokkaido.jp","hidaka.hokkaido.jp","higashikagura.hokkaido.jp","higashikawa.hokkaido.jp","hiroo.hokkaido.jp","hokuryu.hokkaido.jp","hokuto.hokkaido.jp","honbetsu.hokkaido.jp","horokanai.hokkaido.jp","horonobe.hokkaido.jp","ikeda.hokkaido.jp","imakane.hokkaido.jp","ishikari.hokkaido.jp","iwamizawa.hokkaido.jp","iwanai.hokkaido.jp","kamifurano.hokkaido.jp","kamikawa.hokkaido.jp","kamishihoro.hokkaido.jp","kamisunagawa.hokkaido.jp","kamoenai.hokkaido.jp","kayabe.hokkaido.jp","kembuchi.hokkaido.jp","kikonai.hokkaido.jp","kimobetsu.hokkaido.jp","kitahiroshima.hokkaido.jp","kitami.hokkaido.jp","kiyosato.hokkaido.jp","koshimizu.hokkaido.jp","kunneppu.hokkaido.jp","kuriyama.hokkaido.jp","kuromatsunai.hokkaido.jp","kushiro.hokkaido.jp","kutchan.hokkaido.jp","kyowa.hokkaido.jp","mashike.hokkaido.jp","matsumae.hokkaido.jp","mikasa.hokkaido.jp","minamifurano.hokkaido.jp","mombetsu.hokkaido.jp","moseushi.hokkaido.jp","mukawa.hokkaido.jp","muroran.hokkaido.jp","naie.hokkaido.jp","nakagawa.hokkaido.jp","nakasatsunai.hokkaido.jp","nakatombetsu.hokkaido.jp","nanae.hokkaido.jp","nanporo.hokkaido.jp","nayoro.hokkaido.jp","nemuro.hokkaido.jp","niikappu.hokkaido.jp","niki.hokkaido.jp","nishiokoppe.hokkaido.jp","noboribetsu.hokkaido.jp","numata.hokkaido.jp","obihiro.hokkaido.jp","obira.hokkaido.jp","oketo.hokkaido.jp","okoppe.hokkaido.jp","otaru.hokkaido.jp","otobe.hokkaido.jp","otofuke.hokkaido.jp","otoineppu.hokkaido.jp","oumu.hokkaido.jp","ozora.hokkaido.jp","pippu.hokkaido.jp","rankoshi.hokkaido.jp","rebun.hokkaido.jp","rikubetsu.hokkaido.jp","rishiri.hokkaido.jp","rishirifuji.hokkaido.jp","saroma.hokkaido.jp","sarufutsu.hokkaido.jp","shakotan.hokkaido.jp","shari.hokkaido.jp","shibecha.hokkaido.jp","shibetsu.hokkaido.jp","shikabe.hokkaido.jp","shikaoi.hokkaido.jp","shimamaki.hokkaido.jp","shimizu.hokkaido.jp","shimokawa.hokkaido.jp","shinshinotsu.hokkaido.jp","shintoku.hokkaido.jp","shiranuka.hokkaido.jp","shiraoi.hokkaido.jp","shiriuchi.hokkaido.jp","sobetsu.hokkaido.jp","sunagawa.hokkaido.jp","taiki.hokkaido.jp","takasu.hokkaido.jp","takikawa.hokkaido.jp","takinoue.hokkaido.jp","teshikaga.hokkaido.jp","tobetsu.hokkaido.jp","tohma.hokkaido.jp","tomakomai.hokkaido.jp","tomari.hokkaido.jp","toya.hokkaido.jp","toyako.hokkaido.jp","toyotomi.hokkaido.jp","toyoura.hokkaido.jp","tsubetsu.hokkaido.jp","tsukigata.hokkaido.jp","urakawa.hokkaido.jp","urausu.hokkaido.jp","uryu.hokkaido.jp","utashinai.hokkaido.jp","wakkanai.hokkaido.jp","wassamu.hokkaido.jp","yakumo.hokkaido.jp","yoichi.hokkaido.jp","aioi.hyogo.jp","akashi.hyogo.jp","ako.hyogo.jp","amagasaki.hyogo.jp","aogaki.hyogo.jp","asago.hyogo.jp","ashiya.hyogo.jp","awaji.hyogo.jp","fukusaki.hyogo.jp","goshiki.hyogo.jp","harima.hyogo.jp","himeji.hyogo.jp","ichikawa.hyogo.jp","inagawa.hyogo.jp","itami.hyogo.jp","kakogawa.hyogo.jp","kamigori.hyogo.jp","kamikawa.hyogo.jp","kasai.hyogo.jp","kasuga.hyogo.jp","kawanishi.hyogo.jp","miki.hyogo.jp","minamiawaji.hyogo.jp","nishinomiya.hyogo.jp","nishiwaki.hyogo.jp","ono.hyogo.jp","sanda.hyogo.jp","sannan.hyogo.jp","sasayama.hyogo.jp","sayo.hyogo.jp","shingu.hyogo.jp","shinonsen.hyogo.jp","shiso.hyogo.jp","sumoto.hyogo.jp","taishi.hyogo.jp","taka.hyogo.jp","takarazuka.hyogo.jp","takasago.hyogo.jp","takino.hyogo.jp","tamba.hyogo.jp","tatsuno.hyogo.jp","toyooka.hyogo.jp","yabu.hyogo.jp","yashiro.hyogo.jp","yoka.hyogo.jp","yokawa.hyogo.jp","ami.ibaraki.jp","asahi.ibaraki.jp","bando.ibaraki.jp","chikusei.ibaraki.jp","daigo.ibaraki.jp","fujishiro.ibaraki.jp","hitachi.ibaraki.jp","hitachinaka.ibaraki.jp","hitachiomiya.ibaraki.jp","hitachiota.ibaraki.jp","ibaraki.ibaraki.jp","ina.ibaraki.jp","inashiki.ibaraki.jp","itako.ibaraki.jp","iwama.ibaraki.jp","joso.ibaraki.jp","kamisu.ibaraki.jp","kasama.ibaraki.jp","kashima.ibaraki.jp","kasumigaura.ibaraki.jp","koga.ibaraki.jp","miho.ibaraki.jp","mito.ibaraki.jp","moriya.ibaraki.jp","naka.ibaraki.jp","namegata.ibaraki.jp","oarai.ibaraki.jp","ogawa.ibaraki.jp","omitama.ibaraki.jp","ryugasaki.ibaraki.jp","sakai.ibaraki.jp","sakuragawa.ibaraki.jp","shimodate.ibaraki.jp","shimotsuma.ibaraki.jp","shirosato.ibaraki.jp","sowa.ibaraki.jp","suifu.ibaraki.jp","takahagi.ibaraki.jp","tamatsukuri.ibaraki.jp","tokai.ibaraki.jp","tomobe.ibaraki.jp","tone.ibaraki.jp","toride.ibaraki.jp","tsuchiura.ibaraki.jp","tsukuba.ibaraki.jp","uchihara.ibaraki.jp","ushiku.ibaraki.jp","yachiyo.ibaraki.jp","yamagata.ibaraki.jp","yawara.ibaraki.jp","yuki.ibaraki.jp","anamizu.ishikawa.jp","hakui.ishikawa.jp","hakusan.ishikawa.jp","kaga.ishikawa.jp","kahoku.ishikawa.jp","kanazawa.ishikawa.jp","kawakita.ishikawa.jp","komatsu.ishikawa.jp","nakanoto.ishikawa.jp","nanao.ishikawa.jp","nomi.ishikawa.jp","nonoichi.ishikawa.jp","noto.ishikawa.jp","shika.ishikawa.jp","suzu.ishikawa.jp","tsubata.ishikawa.jp","tsurugi.ishikawa.jp","uchinada.ishikawa.jp","wajima.ishikawa.jp","fudai.iwate.jp","fujisawa.iwate.jp","hanamaki.iwate.jp","hiraizumi.iwate.jp","hirono.iwate.jp","ichinohe.iwate.jp","ichinoseki.iwate.jp","iwaizumi.iwate.jp","iwate.iwate.jp","joboji.iwate.jp","kamaishi.iwate.jp","kanegasaki.iwate.jp","karumai.iwate.jp","kawai.iwate.jp","kitakami.iwate.jp","kuji.iwate.jp","kunohe.iwate.jp","kuzumaki.iwate.jp","miyako.iwate.jp","mizusawa.iwate.jp","morioka.iwate.jp","ninohe.iwate.jp","noda.iwate.jp","ofunato.iwate.jp","oshu.iwate.jp","otsuchi.iwate.jp","rikuzentakata.iwate.jp","shiwa.iwate.jp","shizukuishi.iwate.jp","sumita.iwate.jp","tanohata.iwate.jp","tono.iwate.jp","yahaba.iwate.jp","yamada.iwate.jp","ayagawa.kagawa.jp","higashikagawa.kagawa.jp","kanonji.kagawa.jp","kotohira.kagawa.jp","manno.kagawa.jp","marugame.kagawa.jp","mitoyo.kagawa.jp","naoshima.kagawa.jp","sanuki.kagawa.jp","tadotsu.kagawa.jp","takamatsu.kagawa.jp","tonosho.kagawa.jp","uchinomi.kagawa.jp","utazu.kagawa.jp","zentsuji.kagawa.jp","akune.kagoshima.jp","amami.kagoshima.jp","hioki.kagoshima.jp","isa.kagoshima.jp","isen.kagoshima.jp","izumi.kagoshima.jp","kagoshima.kagoshima.jp","kanoya.kagoshima.jp","kawanabe.kagoshima.jp","kinko.kagoshima.jp","kouyama.kagoshima.jp","makurazaki.kagoshima.jp","matsumoto.kagoshima.jp","minamitane.kagoshima.jp","nakatane.kagoshima.jp","nishinoomote.kagoshima.jp","satsumasendai.kagoshima.jp","soo.kagoshima.jp","tarumizu.kagoshima.jp","yusui.kagoshima.jp","aikawa.kanagawa.jp","atsugi.kanagawa.jp","ayase.kanagawa.jp","chigasaki.kanagawa.jp","ebina.kanagawa.jp","fujisawa.kanagawa.jp","hadano.kanagawa.jp","hakone.kanagawa.jp","hiratsuka.kanagawa.jp","isehara.kanagawa.jp","kaisei.kanagawa.jp","kamakura.kanagawa.jp","kiyokawa.kanagawa.jp","matsuda.kanagawa.jp","minamiashigara.kanagawa.jp","miura.kanagawa.jp","nakai.kanagawa.jp","ninomiya.kanagawa.jp","odawara.kanagawa.jp","oi.kanagawa.jp","oiso.kanagawa.jp","sagamihara.kanagawa.jp","samukawa.kanagawa.jp","tsukui.kanagawa.jp","yamakita.kanagawa.jp","yamato.kanagawa.jp","yokosuka.kanagawa.jp","yugawara.kanagawa.jp","zama.kanagawa.jp","zushi.kanagawa.jp","aki.kochi.jp","geisei.kochi.jp","hidaka.kochi.jp","higashitsuno.kochi.jp","ino.kochi.jp","kagami.kochi.jp","kami.kochi.jp","kitagawa.kochi.jp","kochi.kochi.jp","mihara.kochi.jp","motoyama.kochi.jp","muroto.kochi.jp","nahari.kochi.jp","nakamura.kochi.jp","nankoku.kochi.jp","nishitosa.kochi.jp","niyodogawa.kochi.jp","ochi.kochi.jp","okawa.kochi.jp","otoyo.kochi.jp","otsuki.kochi.jp","sakawa.kochi.jp","sukumo.kochi.jp","susaki.kochi.jp","tosa.kochi.jp","tosashimizu.kochi.jp","toyo.kochi.jp","tsuno.kochi.jp","umaji.kochi.jp","yasuda.kochi.jp","yusuhara.kochi.jp","amakusa.kumamoto.jp","arao.kumamoto.jp","aso.kumamoto.jp","choyo.kumamoto.jp","gyokuto.kumamoto.jp","kamiamakusa.kumamoto.jp","kikuchi.kumamoto.jp","kumamoto.kumamoto.jp","mashiki.kumamoto.jp","mifune.kumamoto.jp","minamata.kumamoto.jp","minamioguni.kumamoto.jp","nagasu.kumamoto.jp","nishihara.kumamoto.jp","oguni.kumamoto.jp","ozu.kumamoto.jp","sumoto.kumamoto.jp","takamori.kumamoto.jp","uki.kumamoto.jp","uto.kumamoto.jp","yamaga.kumamoto.jp","yamato.kumamoto.jp","yatsushiro.kumamoto.jp","ayabe.kyoto.jp","fukuchiyama.kyoto.jp","higashiyama.kyoto.jp","ide.kyoto.jp","ine.kyoto.jp","joyo.kyoto.jp","kameoka.kyoto.jp","kamo.kyoto.jp","kita.kyoto.jp","kizu.kyoto.jp","kumiyama.kyoto.jp","kyotamba.kyoto.jp","kyotanabe.kyoto.jp","kyotango.kyoto.jp","maizuru.kyoto.jp","minami.kyoto.jp","minamiyamashiro.kyoto.jp","miyazu.kyoto.jp","muko.kyoto.jp","nagaokakyo.kyoto.jp","nakagyo.kyoto.jp","nantan.kyoto.jp","oyamazaki.kyoto.jp","sakyo.kyoto.jp","seika.kyoto.jp","tanabe.kyoto.jp","uji.kyoto.jp","ujitawara.kyoto.jp","wazuka.kyoto.jp","yamashina.kyoto.jp","yawata.kyoto.jp","asahi.mie.jp","inabe.mie.jp","ise.mie.jp","kameyama.mie.jp","kawagoe.mie.jp","kiho.mie.jp","kisosaki.mie.jp","kiwa.mie.jp","komono.mie.jp","kumano.mie.jp","kuwana.mie.jp","matsusaka.mie.jp","meiwa.mie.jp","mihama.mie.jp","minamiise.mie.jp","misugi.mie.jp","miyama.mie.jp","nabari.mie.jp","shima.mie.jp","suzuka.mie.jp","tado.mie.jp","taiki.mie.jp","taki.mie.jp","tamaki.mie.jp","toba.mie.jp","tsu.mie.jp","udono.mie.jp","ureshino.mie.jp","watarai.mie.jp","yokkaichi.mie.jp","furukawa.miyagi.jp","higashimatsushima.miyagi.jp","ishinomaki.miyagi.jp","iwanuma.miyagi.jp","kakuda.miyagi.jp","kami.miyagi.jp","kawasaki.miyagi.jp","marumori.miyagi.jp","matsushima.miyagi.jp","minamisanriku.miyagi.jp","misato.miyagi.jp","murata.miyagi.jp","natori.miyagi.jp","ogawara.miyagi.jp","ohira.miyagi.jp","onagawa.miyagi.jp","osaki.miyagi.jp","rifu.miyagi.jp","semine.miyagi.jp","shibata.miyagi.jp","shichikashuku.miyagi.jp","shikama.miyagi.jp","shiogama.miyagi.jp","shiroishi.miyagi.jp","tagajo.miyagi.jp","taiwa.miyagi.jp","tome.miyagi.jp","tomiya.miyagi.jp","wakuya.miyagi.jp","watari.miyagi.jp","yamamoto.miyagi.jp","zao.miyagi.jp","aya.miyazaki.jp","ebino.miyazaki.jp","gokase.miyazaki.jp","hyuga.miyazaki.jp","kadogawa.miyazaki.jp","kawaminami.miyazaki.jp","kijo.miyazaki.jp","kitagawa.miyazaki.jp","kitakata.miyazaki.jp","kitaura.miyazaki.jp","kobayashi.miyazaki.jp","kunitomi.miyazaki.jp","kushima.miyazaki.jp","mimata.miyazaki.jp","miyakonojo.miyazaki.jp","miyazaki.miyazaki.jp","morotsuka.miyazaki.jp","nichinan.miyazaki.jp","nishimera.miyazaki.jp","nobeoka.miyazaki.jp","saito.miyazaki.jp","shiiba.miyazaki.jp","shintomi.miyazaki.jp","takaharu.miyazaki.jp","takanabe.miyazaki.jp","takazaki.miyazaki.jp","tsuno.miyazaki.jp","achi.nagano.jp","agematsu.nagano.jp","anan.nagano.jp","aoki.nagano.jp","asahi.nagano.jp","azumino.nagano.jp","chikuhoku.nagano.jp","chikuma.nagano.jp","chino.nagano.jp","fujimi.nagano.jp","hakuba.nagano.jp","hara.nagano.jp","hiraya.nagano.jp","iida.nagano.jp","iijima.nagano.jp","iiyama.nagano.jp","iizuna.nagano.jp","ikeda.nagano.jp","ikusaka.nagano.jp","ina.nagano.jp","karuizawa.nagano.jp","kawakami.nagano.jp","kiso.nagano.jp","kisofukushima.nagano.jp","kitaaiki.nagano.jp","komagane.nagano.jp","komoro.nagano.jp","matsukawa.nagano.jp","matsumoto.nagano.jp","miasa.nagano.jp","minamiaiki.nagano.jp","minamimaki.nagano.jp","minamiminowa.nagano.jp","minowa.nagano.jp","miyada.nagano.jp","miyota.nagano.jp","mochizuki.nagano.jp","nagano.nagano.jp","nagawa.nagano.jp","nagiso.nagano.jp","nakagawa.nagano.jp","nakano.nagano.jp","nozawaonsen.nagano.jp","obuse.nagano.jp","ogawa.nagano.jp","okaya.nagano.jp","omachi.nagano.jp","omi.nagano.jp","ookuwa.nagano.jp","ooshika.nagano.jp","otaki.nagano.jp","otari.nagano.jp","sakae.nagano.jp","sakaki.nagano.jp","saku.nagano.jp","sakuho.nagano.jp","shimosuwa.nagano.jp","shinanomachi.nagano.jp","shiojiri.nagano.jp","suwa.nagano.jp","suzaka.nagano.jp","takagi.nagano.jp","takamori.nagano.jp","takayama.nagano.jp","tateshina.nagano.jp","tatsuno.nagano.jp","togakushi.nagano.jp","togura.nagano.jp","tomi.nagano.jp","ueda.nagano.jp","wada.nagano.jp","yamagata.nagano.jp","yamanouchi.nagano.jp","yasaka.nagano.jp","yasuoka.nagano.jp","chijiwa.nagasaki.jp","futsu.nagasaki.jp","goto.nagasaki.jp","hasami.nagasaki.jp","hirado.nagasaki.jp","iki.nagasaki.jp","isahaya.nagasaki.jp","kawatana.nagasaki.jp","kuchinotsu.nagasaki.jp","matsuura.nagasaki.jp","nagasaki.nagasaki.jp","obama.nagasaki.jp","omura.nagasaki.jp","oseto.nagasaki.jp","saikai.nagasaki.jp","sasebo.nagasaki.jp","seihi.nagasaki.jp","shimabara.nagasaki.jp","shinkamigoto.nagasaki.jp","togitsu.nagasaki.jp","tsushima.nagasaki.jp","unzen.nagasaki.jp","ando.nara.jp","gose.nara.jp","heguri.nara.jp","higashiyoshino.nara.jp","ikaruga.nara.jp","ikoma.nara.jp","kamikitayama.nara.jp","kanmaki.nara.jp","kashiba.nara.jp","kashihara.nara.jp","katsuragi.nara.jp","kawai.nara.jp","kawakami.nara.jp","kawanishi.nara.jp","koryo.nara.jp","kurotaki.nara.jp","mitsue.nara.jp","miyake.nara.jp","nara.nara.jp","nosegawa.nara.jp","oji.nara.jp","ouda.nara.jp","oyodo.nara.jp","sakurai.nara.jp","sango.nara.jp","shimoichi.nara.jp","shimokitayama.nara.jp","shinjo.nara.jp","soni.nara.jp","takatori.nara.jp","tawaramoto.nara.jp","tenkawa.nara.jp","tenri.nara.jp","uda.nara.jp","yamatokoriyama.nara.jp","yamatotakada.nara.jp","yamazoe.nara.jp","yoshino.nara.jp","aga.niigata.jp","agano.niigata.jp","gosen.niigata.jp","itoigawa.niigata.jp","izumozaki.niigata.jp","joetsu.niigata.jp","kamo.niigata.jp","kariwa.niigata.jp","kashiwazaki.niigata.jp","minamiuonuma.niigata.jp","mitsuke.niigata.jp","muika.niigata.jp","murakami.niigata.jp","myoko.niigata.jp","nagaoka.niigata.jp","niigata.niigata.jp","ojiya.niigata.jp","omi.niigata.jp","sado.niigata.jp","sanjo.niigata.jp","seiro.niigata.jp","seirou.niigata.jp","sekikawa.niigata.jp","shibata.niigata.jp","tagami.niigata.jp","tainai.niigata.jp","tochio.niigata.jp","tokamachi.niigata.jp","tsubame.niigata.jp","tsunan.niigata.jp","uonuma.niigata.jp","yahiko.niigata.jp","yoita.niigata.jp","yuzawa.niigata.jp","beppu.oita.jp","bungoono.oita.jp","bungotakada.oita.jp","hasama.oita.jp","hiji.oita.jp","himeshima.oita.jp","hita.oita.jp","kamitsue.oita.jp","kokonoe.oita.jp","kuju.oita.jp","kunisaki.oita.jp","kusu.oita.jp","oita.oita.jp","saiki.oita.jp","taketa.oita.jp","tsukumi.oita.jp","usa.oita.jp","usuki.oita.jp","yufu.oita.jp","akaiwa.okayama.jp","asakuchi.okayama.jp","bizen.okayama.jp","hayashima.okayama.jp","ibara.okayama.jp","kagamino.okayama.jp","kasaoka.okayama.jp","kibichuo.okayama.jp","kumenan.okayama.jp","kurashiki.okayama.jp","maniwa.okayama.jp","misaki.okayama.jp","nagi.okayama.jp","niimi.okayama.jp","nishiawakura.okayama.jp","okayama.okayama.jp","satosho.okayama.jp","setouchi.okayama.jp","shinjo.okayama.jp","shoo.okayama.jp","soja.okayama.jp","takahashi.okayama.jp","tamano.okayama.jp","tsuyama.okayama.jp","wake.okayama.jp","yakage.okayama.jp","aguni.okinawa.jp","ginowan.okinawa.jp","ginoza.okinawa.jp","gushikami.okinawa.jp","haebaru.okinawa.jp","higashi.okinawa.jp","hirara.okinawa.jp","iheya.okinawa.jp","ishigaki.okinawa.jp","ishikawa.okinawa.jp","itoman.okinawa.jp","izena.okinawa.jp","kadena.okinawa.jp","kin.okinawa.jp","kitadaito.okinawa.jp","kitanakagusuku.okinawa.jp","kumejima.okinawa.jp","kunigami.okinawa.jp","minamidaito.okinawa.jp","motobu.okinawa.jp","nago.okinawa.jp","naha.okinawa.jp","nakagusuku.okinawa.jp","nakijin.okinawa.jp","nanjo.okinawa.jp","nishihara.okinawa.jp","ogimi.okinawa.jp","okinawa.okinawa.jp","onna.okinawa.jp","shimoji.okinawa.jp","taketomi.okinawa.jp","tarama.okinawa.jp","tokashiki.okinawa.jp","tomigusuku.okinawa.jp","tonaki.okinawa.jp","urasoe.okinawa.jp","uruma.okinawa.jp","yaese.okinawa.jp","yomitan.okinawa.jp","yonabaru.okinawa.jp","yonaguni.okinawa.jp","zamami.okinawa.jp","abeno.osaka.jp","chihayaakasaka.osaka.jp","chuo.osaka.jp","daito.osaka.jp","fujiidera.osaka.jp","habikino.osaka.jp","hannan.osaka.jp","higashiosaka.osaka.jp","higashisumiyoshi.osaka.jp","higashiyodogawa.osaka.jp","hirakata.osaka.jp","ibaraki.osaka.jp","ikeda.osaka.jp","izumi.osaka.jp","izumiotsu.osaka.jp","izumisano.osaka.jp","kadoma.osaka.jp","kaizuka.osaka.jp","kanan.osaka.jp","kashiwara.osaka.jp","katano.osaka.jp","kawachinagano.osaka.jp","kishiwada.osaka.jp","kita.osaka.jp","kumatori.osaka.jp","matsubara.osaka.jp","minato.osaka.jp","minoh.osaka.jp","misaki.osaka.jp","moriguchi.osaka.jp","neyagawa.osaka.jp","nishi.osaka.jp","nose.osaka.jp","osakasayama.osaka.jp","sakai.osaka.jp","sayama.osaka.jp","sennan.osaka.jp","settsu.osaka.jp","shijonawate.osaka.jp","shimamoto.osaka.jp","suita.osaka.jp","tadaoka.osaka.jp","taishi.osaka.jp","tajiri.osaka.jp","takaishi.osaka.jp","takatsuki.osaka.jp","tondabayashi.osaka.jp","toyonaka.osaka.jp","toyono.osaka.jp","yao.osaka.jp","ariake.saga.jp","arita.saga.jp","fukudomi.saga.jp","genkai.saga.jp","hamatama.saga.jp","hizen.saga.jp","imari.saga.jp","kamimine.saga.jp","kanzaki.saga.jp","karatsu.saga.jp","kashima.saga.jp","kitagata.saga.jp","kitahata.saga.jp","kiyama.saga.jp","kouhoku.saga.jp","kyuragi.saga.jp","nishiarita.saga.jp","ogi.saga.jp","omachi.saga.jp","ouchi.saga.jp","saga.saga.jp","shiroishi.saga.jp","taku.saga.jp","tara.saga.jp","tosu.saga.jp","yoshinogari.saga.jp","arakawa.saitama.jp","asaka.saitama.jp","chichibu.saitama.jp","fujimi.saitama.jp","fujimino.saitama.jp","fukaya.saitama.jp","hanno.saitama.jp","hanyu.saitama.jp","hasuda.saitama.jp","hatogaya.saitama.jp","hatoyama.saitama.jp","hidaka.saitama.jp","higashichichibu.saitama.jp","higashimatsuyama.saitama.jp","honjo.saitama.jp","ina.saitama.jp","iruma.saitama.jp","iwatsuki.saitama.jp","kamiizumi.saitama.jp","kamikawa.saitama.jp","kamisato.saitama.jp","kasukabe.saitama.jp","kawagoe.saitama.jp","kawaguchi.saitama.jp","kawajima.saitama.jp","kazo.saitama.jp","kitamoto.saitama.jp","koshigaya.saitama.jp","kounosu.saitama.jp","kuki.saitama.jp","kumagaya.saitama.jp","matsubushi.saitama.jp","minano.saitama.jp","misato.saitama.jp","miyashiro.saitama.jp","miyoshi.saitama.jp","moroyama.saitama.jp","nagatoro.saitama.jp","namegawa.saitama.jp","niiza.saitama.jp","ogano.saitama.jp","ogawa.saitama.jp","ogose.saitama.jp","okegawa.saitama.jp","omiya.saitama.jp","otaki.saitama.jp","ranzan.saitama.jp","ryokami.saitama.jp","saitama.saitama.jp","sakado.saitama.jp","satte.saitama.jp","sayama.saitama.jp","shiki.saitama.jp","shiraoka.saitama.jp","soka.saitama.jp","sugito.saitama.jp","toda.saitama.jp","tokigawa.saitama.jp","tokorozawa.saitama.jp","tsurugashima.saitama.jp","urawa.saitama.jp","warabi.saitama.jp","yashio.saitama.jp","yokoze.saitama.jp","yono.saitama.jp","yorii.saitama.jp","yoshida.saitama.jp","yoshikawa.saitama.jp","yoshimi.saitama.jp","aisho.shiga.jp","gamo.shiga.jp","higashiomi.shiga.jp","hikone.shiga.jp","koka.shiga.jp","konan.shiga.jp","kosei.shiga.jp","koto.shiga.jp","kusatsu.shiga.jp","maibara.shiga.jp","moriyama.shiga.jp","nagahama.shiga.jp","nishiazai.shiga.jp","notogawa.shiga.jp","omihachiman.shiga.jp","otsu.shiga.jp","ritto.shiga.jp","ryuoh.shiga.jp","takashima.shiga.jp","takatsuki.shiga.jp","torahime.shiga.jp","toyosato.shiga.jp","yasu.shiga.jp","akagi.shimane.jp","ama.shimane.jp","gotsu.shimane.jp","hamada.shimane.jp","higashiizumo.shimane.jp","hikawa.shimane.jp","hikimi.shimane.jp","izumo.shimane.jp","kakinoki.shimane.jp","masuda.shimane.jp","matsue.shimane.jp","misato.shimane.jp","nishinoshima.shimane.jp","ohda.shimane.jp","okinoshima.shimane.jp","okuizumo.shimane.jp","shimane.shimane.jp","tamayu.shimane.jp","tsuwano.shimane.jp","unnan.shimane.jp","yakumo.shimane.jp","yasugi.shimane.jp","yatsuka.shimane.jp","arai.shizuoka.jp","atami.shizuoka.jp","fuji.shizuoka.jp","fujieda.shizuoka.jp","fujikawa.shizuoka.jp","fujinomiya.shizuoka.jp","fukuroi.shizuoka.jp","gotemba.shizuoka.jp","haibara.shizuoka.jp","hamamatsu.shizuoka.jp","higashiizu.shizuoka.jp","ito.shizuoka.jp","iwata.shizuoka.jp","izu.shizuoka.jp","izunokuni.shizuoka.jp","kakegawa.shizuoka.jp","kannami.shizuoka.jp","kawanehon.shizuoka.jp","kawazu.shizuoka.jp","kikugawa.shizuoka.jp","kosai.shizuoka.jp","makinohara.shizuoka.jp","matsuzaki.shizuoka.jp","minamiizu.shizuoka.jp","mishima.shizuoka.jp","morimachi.shizuoka.jp","nishiizu.shizuoka.jp","numazu.shizuoka.jp","omaezaki.shizuoka.jp","shimada.shizuoka.jp","shimizu.shizuoka.jp","shimoda.shizuoka.jp","shizuoka.shizuoka.jp","susono.shizuoka.jp","yaizu.shizuoka.jp","yoshida.shizuoka.jp","ashikaga.tochigi.jp","bato.tochigi.jp","haga.tochigi.jp","ichikai.tochigi.jp","iwafune.tochigi.jp","kaminokawa.tochigi.jp","kanuma.tochigi.jp","karasuyama.tochigi.jp","kuroiso.tochigi.jp","mashiko.tochigi.jp","mibu.tochigi.jp","moka.tochigi.jp","motegi.tochigi.jp","nasu.tochigi.jp","nasushiobara.tochigi.jp","nikko.tochigi.jp","nishikata.tochigi.jp","nogi.tochigi.jp","ohira.tochigi.jp","ohtawara.tochigi.jp","oyama.tochigi.jp","sakura.tochigi.jp","sano.tochigi.jp","shimotsuke.tochigi.jp","shioya.tochigi.jp","takanezawa.tochigi.jp","tochigi.tochigi.jp","tsuga.tochigi.jp","ujiie.tochigi.jp","utsunomiya.tochigi.jp","yaita.tochigi.jp","aizumi.tokushima.jp","anan.tokushima.jp","ichiba.tokushima.jp","itano.tokushima.jp","kainan.tokushima.jp","komatsushima.tokushima.jp","matsushige.tokushima.jp","mima.tokushima.jp","minami.tokushima.jp","miyoshi.tokushima.jp","mugi.tokushima.jp","nakagawa.tokushima.jp","naruto.tokushima.jp","sanagochi.tokushima.jp","shishikui.tokushima.jp","tokushima.tokushima.jp","wajiki.tokushima.jp","adachi.tokyo.jp","akiruno.tokyo.jp","akishima.tokyo.jp","aogashima.tokyo.jp","arakawa.tokyo.jp","bunkyo.tokyo.jp","chiyoda.tokyo.jp","chofu.tokyo.jp","chuo.tokyo.jp","edogawa.tokyo.jp","fuchu.tokyo.jp","fussa.tokyo.jp","hachijo.tokyo.jp","hachioji.tokyo.jp","hamura.tokyo.jp","higashikurume.tokyo.jp","higashimurayama.tokyo.jp","higashiyamato.tokyo.jp","hino.tokyo.jp","hinode.tokyo.jp","hinohara.tokyo.jp","inagi.tokyo.jp","itabashi.tokyo.jp","katsushika.tokyo.jp","kita.tokyo.jp","kiyose.tokyo.jp","kodaira.tokyo.jp","koganei.tokyo.jp","kokubunji.tokyo.jp","komae.tokyo.jp","koto.tokyo.jp","kouzushima.tokyo.jp","kunitachi.tokyo.jp","machida.tokyo.jp","meguro.tokyo.jp","minato.tokyo.jp","mitaka.tokyo.jp","mizuho.tokyo.jp","musashimurayama.tokyo.jp","musashino.tokyo.jp","nakano.tokyo.jp","nerima.tokyo.jp","ogasawara.tokyo.jp","okutama.tokyo.jp","ome.tokyo.jp","oshima.tokyo.jp","ota.tokyo.jp","setagaya.tokyo.jp","shibuya.tokyo.jp","shinagawa.tokyo.jp","shinjuku.tokyo.jp","suginami.tokyo.jp","sumida.tokyo.jp","tachikawa.tokyo.jp","taito.tokyo.jp","tama.tokyo.jp","toshima.tokyo.jp","chizu.tottori.jp","hino.tottori.jp","kawahara.tottori.jp","koge.tottori.jp","kotoura.tottori.jp","misasa.tottori.jp","nanbu.tottori.jp","nichinan.tottori.jp","sakaiminato.tottori.jp","tottori.tottori.jp","wakasa.tottori.jp","yazu.tottori.jp","yonago.tottori.jp","asahi.toyama.jp","fuchu.toyama.jp","fukumitsu.toyama.jp","funahashi.toyama.jp","himi.toyama.jp","imizu.toyama.jp","inami.toyama.jp","johana.toyama.jp","kamiichi.toyama.jp","kurobe.toyama.jp","nakaniikawa.toyama.jp","namerikawa.toyama.jp","nanto.toyama.jp","nyuzen.toyama.jp","oyabe.toyama.jp","taira.toyama.jp","takaoka.toyama.jp","tateyama.toyama.jp","toga.toyama.jp","tonami.toyama.jp","toyama.toyama.jp","unazuki.toyama.jp","uozu.toyama.jp","yamada.toyama.jp","arida.wakayama.jp","aridagawa.wakayama.jp","gobo.wakayama.jp","hashimoto.wakayama.jp","hidaka.wakayama.jp","hirogawa.wakayama.jp","inami.wakayama.jp","iwade.wakayama.jp","kainan.wakayama.jp","kamitonda.wakayama.jp","katsuragi.wakayama.jp","kimino.wakayama.jp","kinokawa.wakayama.jp","kitayama.wakayama.jp","koya.wakayama.jp","koza.wakayama.jp","kozagawa.wakayama.jp","kudoyama.wakayama.jp","kushimoto.wakayama.jp","mihama.wakayama.jp","misato.wakayama.jp","nachikatsuura.wakayama.jp","shingu.wakayama.jp","shirahama.wakayama.jp","taiji.wakayama.jp","tanabe.wakayama.jp","wakayama.wakayama.jp","yuasa.wakayama.jp","yura.wakayama.jp","asahi.yamagata.jp","funagata.yamagata.jp","higashine.yamagata.jp","iide.yamagata.jp","kahoku.yamagata.jp","kaminoyama.yamagata.jp","kaneyama.yamagata.jp","kawanishi.yamagata.jp","mamurogawa.yamagata.jp","mikawa.yamagata.jp","murayama.yamagata.jp","nagai.yamagata.jp","nakayama.yamagata.jp","nanyo.yamagata.jp","nishikawa.yamagata.jp","obanazawa.yamagata.jp","oe.yamagata.jp","oguni.yamagata.jp","ohkura.yamagata.jp","oishida.yamagata.jp","sagae.yamagata.jp","sakata.yamagata.jp","sakegawa.yamagata.jp","shinjo.yamagata.jp","shirataka.yamagata.jp","shonai.yamagata.jp","takahata.yamagata.jp","tendo.yamagata.jp","tozawa.yamagata.jp","tsuruoka.yamagata.jp","yamagata.yamagata.jp","yamanobe.yamagata.jp","yonezawa.yamagata.jp","yuza.yamagata.jp","abu.yamaguchi.jp","hagi.yamaguchi.jp","hikari.yamaguchi.jp","hofu.yamaguchi.jp","iwakuni.yamaguchi.jp","kudamatsu.yamaguchi.jp","mitou.yamaguchi.jp","nagato.yamaguchi.jp","oshima.yamaguchi.jp","shimonoseki.yamaguchi.jp","shunan.yamaguchi.jp","tabuse.yamaguchi.jp","tokuyama.yamaguchi.jp","toyota.yamaguchi.jp","ube.yamaguchi.jp","yuu.yamaguchi.jp","chuo.yamanashi.jp","doshi.yamanashi.jp","fuefuki.yamanashi.jp","fujikawa.yamanashi.jp","fujikawaguchiko.yamanashi.jp","fujiyoshida.yamanashi.jp","hayakawa.yamanashi.jp","hokuto.yamanashi.jp","ichikawamisato.yamanashi.jp","kai.yamanashi.jp","kofu.yamanashi.jp","koshu.yamanashi.jp","kosuge.yamanashi.jp","minami-alps.yamanashi.jp","minobu.yamanashi.jp","nakamichi.yamanashi.jp","nanbu.yamanashi.jp","narusawa.yamanashi.jp","nirasaki.yamanashi.jp","nishikatsura.yamanashi.jp","oshino.yamanashi.jp","otsuki.yamanashi.jp","showa.yamanashi.jp","tabayama.yamanashi.jp","tsuru.yamanashi.jp","uenohara.yamanashi.jp","yamanakako.yamanashi.jp","yamanashi.yamanashi.jp","ke","ac.ke","co.ke","go.ke","info.ke","me.ke","mobi.ke","ne.ke","or.ke","sc.ke","kg","org.kg","net.kg","com.kg","edu.kg","gov.kg","mil.kg","*.kh","ki","edu.ki","biz.ki","net.ki","org.ki","gov.ki","info.ki","com.ki","km","org.km","nom.km","gov.km","prd.km","tm.km","edu.km","mil.km","ass.km","com.km","coop.km","asso.km","presse.km","medecin.km","notaires.km","pharmaciens.km","veterinaire.km","gouv.km","kn","net.kn","org.kn","edu.kn","gov.kn","kp","com.kp","edu.kp","gov.kp","org.kp","rep.kp","tra.kp","kr","ac.kr","co.kr","es.kr","go.kr","hs.kr","kg.kr","mil.kr","ms.kr","ne.kr","or.kr","pe.kr","re.kr","sc.kr","busan.kr","chungbuk.kr","chungnam.kr","daegu.kr","daejeon.kr","gangwon.kr","gwangju.kr","gyeongbuk.kr","gyeonggi.kr","gyeongnam.kr","incheon.kr","jeju.kr","jeonbuk.kr","jeonnam.kr","seoul.kr","ulsan.kr","kw","com.kw","edu.kw","emb.kw","gov.kw","ind.kw","net.kw","org.kw","ky","edu.ky","gov.ky","com.ky","org.ky","net.ky","kz","org.kz","edu.kz","net.kz","gov.kz","mil.kz","com.kz","la","int.la","net.la","info.la","edu.la","gov.la","per.la","com.la","org.la","lb","com.lb","edu.lb","gov.lb","net.lb","org.lb","lc","com.lc","net.lc","co.lc","org.lc","edu.lc","gov.lc","li","lk","gov.lk","sch.lk","net.lk","int.lk","com.lk","org.lk","edu.lk","ngo.lk","soc.lk","web.lk","ltd.lk","assn.lk","grp.lk","hotel.lk","ac.lk","lr","com.lr","edu.lr","gov.lr","org.lr","net.lr","ls","ac.ls","biz.ls","co.ls","edu.ls","gov.ls","info.ls","net.ls","org.ls","sc.ls","lt","gov.lt","lu","lv","com.lv","edu.lv","gov.lv","org.lv","mil.lv","id.lv","net.lv","asn.lv","conf.lv","ly","com.ly","net.ly","gov.ly","plc.ly","edu.ly","sch.ly","med.ly","org.ly","id.ly","ma","co.ma","net.ma","gov.ma","org.ma","ac.ma","press.ma","mc","tm.mc","asso.mc","md","me","co.me","net.me","org.me","edu.me","ac.me","gov.me","its.me","priv.me","mg","org.mg","nom.mg","gov.mg","prd.mg","tm.mg","edu.mg","mil.mg","com.mg","co.mg","mh","mil","mk","com.mk","org.mk","net.mk","edu.mk","gov.mk","inf.mk","name.mk","ml","com.ml","edu.ml","gouv.ml","gov.ml","net.ml","org.ml","presse.ml","*.mm","mn","gov.mn","edu.mn","org.mn","mo","com.mo","net.mo","org.mo","edu.mo","gov.mo","mobi","mp","mq","mr","gov.mr","ms","com.ms","edu.ms","gov.ms","net.ms","org.ms","mt","com.mt","edu.mt","net.mt","org.mt","mu","com.mu","net.mu","org.mu","gov.mu","ac.mu","co.mu","or.mu","museum","academy.museum","agriculture.museum","air.museum","airguard.museum","alabama.museum","alaska.museum","amber.museum","ambulance.museum","american.museum","americana.museum","americanantiques.museum","americanart.museum","amsterdam.museum","and.museum","annefrank.museum","anthro.museum","anthropology.museum","antiques.museum","aquarium.museum","arboretum.museum","archaeological.museum","archaeology.museum","architecture.museum","art.museum","artanddesign.museum","artcenter.museum","artdeco.museum","arteducation.museum","artgallery.museum","arts.museum","artsandcrafts.museum","asmatart.museum","assassination.museum","assisi.museum","association.museum","astronomy.museum","atlanta.museum","austin.museum","australia.museum","automotive.museum","aviation.museum","axis.museum","badajoz.museum","baghdad.museum","bahn.museum","bale.museum","baltimore.museum","barcelona.museum","baseball.museum","basel.museum","baths.museum","bauern.museum","beauxarts.museum","beeldengeluid.museum","bellevue.museum","bergbau.museum","berkeley.museum","berlin.museum","bern.museum","bible.museum","bilbao.museum","bill.museum","birdart.museum","birthplace.museum","bonn.museum","boston.museum","botanical.museum","botanicalgarden.museum","botanicgarden.museum","botany.museum","brandywinevalley.museum","brasil.museum","bristol.museum","british.museum","britishcolumbia.museum","broadcast.museum","brunel.museum","brussel.museum","brussels.museum","bruxelles.museum","building.museum","burghof.museum","bus.museum","bushey.museum","cadaques.museum","california.museum","cambridge.museum","can.museum","canada.museum","capebreton.museum","carrier.museum","cartoonart.museum","casadelamoneda.museum","castle.museum","castres.museum","celtic.museum","center.museum","chattanooga.museum","cheltenham.museum","chesapeakebay.museum","chicago.museum","children.museum","childrens.museum","childrensgarden.museum","chiropractic.museum","chocolate.museum","christiansburg.museum","cincinnati.museum","cinema.museum","circus.museum","civilisation.museum","civilization.museum","civilwar.museum","clinton.museum","clock.museum","coal.museum","coastaldefence.museum","cody.museum","coldwar.museum","collection.museum","colonialwilliamsburg.museum","coloradoplateau.museum","columbia.museum","columbus.museum","communication.museum","communications.museum","community.museum","computer.museum","computerhistory.museum","comunicações.museum","contemporary.museum","contemporaryart.museum","convent.museum","copenhagen.museum","corporation.museum","correios-e-telecomunicações.museum","corvette.museum","costume.museum","countryestate.museum","county.museum","crafts.museum","cranbrook.museum","creation.museum","cultural.museum","culturalcenter.museum","culture.museum","cyber.museum","cymru.museum","dali.museum","dallas.museum","database.museum","ddr.museum","decorativearts.museum","delaware.museum","delmenhorst.museum","denmark.museum","depot.museum","design.museum","detroit.museum","dinosaur.museum","discovery.museum","dolls.museum","donostia.museum","durham.museum","eastafrica.museum","eastcoast.museum","education.museum","educational.museum","egyptian.museum","eisenbahn.museum","elburg.museum","elvendrell.museum","embroidery.museum","encyclopedic.museum","england.museum","entomology.museum","environment.museum","environmentalconservation.museum","epilepsy.museum","essex.museum","estate.museum","ethnology.museum","exeter.museum","exhibition.museum","family.museum","farm.museum","farmequipment.museum","farmers.museum","farmstead.museum","field.museum","figueres.museum","filatelia.museum","film.museum","fineart.museum","finearts.museum","finland.museum","flanders.museum","florida.museum","force.museum","fortmissoula.museum","fortworth.museum","foundation.museum","francaise.museum","frankfurt.museum","franziskaner.museum","freemasonry.museum","freiburg.museum","fribourg.museum","frog.museum","fundacio.museum","furniture.museum","gallery.museum","garden.museum","gateway.museum","geelvinck.museum","gemological.museum","geology.museum","georgia.museum","giessen.museum","glas.museum","glass.museum","gorge.museum","grandrapids.museum","graz.museum","guernsey.museum","halloffame.museum","hamburg.museum","handson.museum","harvestcelebration.museum","hawaii.museum","health.museum","heimatunduhren.museum","hellas.museum","helsinki.museum","hembygdsforbund.museum","heritage.museum","histoire.museum","historical.museum","historicalsociety.museum","historichouses.museum","historisch.museum","historisches.museum","history.museum","historyofscience.museum","horology.museum","house.museum","humanities.museum","illustration.museum","imageandsound.museum","indian.museum","indiana.museum","indianapolis.museum","indianmarket.museum","intelligence.museum","interactive.museum","iraq.museum","iron.museum","isleofman.museum","jamison.museum","jefferson.museum","jerusalem.museum","jewelry.museum","jewish.museum","jewishart.museum","jfk.museum","journalism.museum","judaica.museum","judygarland.museum","juedisches.museum","juif.museum","karate.museum","karikatur.museum","kids.museum","koebenhavn.museum","koeln.museum","kunst.museum","kunstsammlung.museum","kunstunddesign.museum","labor.museum","labour.museum","lajolla.museum","lancashire.museum","landes.museum","lans.museum","läns.museum","larsson.museum","lewismiller.museum","lincoln.museum","linz.museum","living.museum","livinghistory.museum","localhistory.museum","london.museum","losangeles.museum","louvre.museum","loyalist.museum","lucerne.museum","luxembourg.museum","luzern.museum","mad.museum","madrid.museum","mallorca.museum","manchester.museum","mansion.museum","mansions.museum","manx.museum","marburg.museum","maritime.museum","maritimo.museum","maryland.museum","marylhurst.museum","media.museum","medical.museum","medizinhistorisches.museum","meeres.museum","memorial.museum","mesaverde.museum","michigan.museum","midatlantic.museum","military.museum","mill.museum","miners.museum","mining.museum","minnesota.museum","missile.museum","missoula.museum","modern.museum","moma.museum","money.museum","monmouth.museum","monticello.museum","montreal.museum","moscow.museum","motorcycle.museum","muenchen.museum","muenster.museum","mulhouse.museum","muncie.museum","museet.museum","museumcenter.museum","museumvereniging.museum","music.museum","national.museum","nationalfirearms.museum","nationalheritage.museum","nativeamerican.museum","naturalhistory.museum","naturalhistorymuseum.museum","naturalsciences.museum","nature.museum","naturhistorisches.museum","natuurwetenschappen.museum","naumburg.museum","naval.museum","nebraska.museum","neues.museum","newhampshire.museum","newjersey.museum","newmexico.museum","newport.museum","newspaper.museum","newyork.museum","niepce.museum","norfolk.museum","north.museum","nrw.museum","nyc.museum","nyny.museum","oceanographic.museum","oceanographique.museum","omaha.museum","online.museum","ontario.museum","openair.museum","oregon.museum","oregontrail.museum","otago.museum","oxford.museum","pacific.museum","paderborn.museum","palace.museum","paleo.museum","palmsprings.museum","panama.museum","paris.museum","pasadena.museum","pharmacy.museum","philadelphia.museum","philadelphiaarea.museum","philately.museum","phoenix.museum","photography.museum","pilots.museum","pittsburgh.museum","planetarium.museum","plantation.museum","plants.museum","plaza.museum","portal.museum","portland.museum","portlligat.museum","posts-and-telecommunications.museum","preservation.museum","presidio.museum","press.museum","project.museum","public.museum","pubol.museum","quebec.museum","railroad.museum","railway.museum","research.museum","resistance.museum","riodejaneiro.museum","rochester.museum","rockart.museum","roma.museum","russia.museum","saintlouis.museum","salem.museum","salvadordali.museum","salzburg.museum","sandiego.museum","sanfrancisco.museum","santabarbara.museum","santacruz.museum","santafe.museum","saskatchewan.museum","satx.museum","savannahga.museum","schlesisches.museum","schoenbrunn.museum","schokoladen.museum","school.museum","schweiz.museum","science.museum","scienceandhistory.museum","scienceandindustry.museum","sciencecenter.museum","sciencecenters.museum","science-fiction.museum","sciencehistory.museum","sciences.museum","sciencesnaturelles.museum","scotland.museum","seaport.museum","settlement.museum","settlers.museum","shell.museum","sherbrooke.museum","sibenik.museum","silk.museum","ski.museum","skole.museum","society.museum","sologne.museum","soundandvision.museum","southcarolina.museum","southwest.museum","space.museum","spy.museum","square.museum","stadt.museum","stalbans.museum","starnberg.museum","state.museum","stateofdelaware.museum","station.museum","steam.museum","steiermark.museum","stjohn.museum","stockholm.museum","stpetersburg.museum","stuttgart.museum","suisse.museum","surgeonshall.museum","surrey.museum","svizzera.museum","sweden.museum","sydney.museum","tank.museum","tcm.museum","technology.museum","telekommunikation.museum","television.museum","texas.museum","textile.museum","theater.museum","time.museum","timekeeping.museum","topology.museum","torino.museum","touch.museum","town.museum","transport.museum","tree.museum","trolley.museum","trust.museum","trustee.museum","uhren.museum","ulm.museum","undersea.museum","university.museum","usa.museum","usantiques.museum","usarts.museum","uscountryestate.museum","usculture.museum","usdecorativearts.museum","usgarden.museum","ushistory.museum","ushuaia.museum","uslivinghistory.museum","utah.museum","uvic.museum","valley.museum","vantaa.museum","versailles.museum","viking.museum","village.museum","virginia.museum","virtual.museum","virtuel.museum","vlaanderen.museum","volkenkunde.museum","wales.museum","wallonie.museum","war.museum","washingtondc.museum","watchandclock.museum","watch-and-clock.museum","western.museum","westfalen.museum","whaling.museum","wildlife.museum","williamsburg.museum","windmill.museum","workshop.museum","york.museum","yorkshire.museum","yosemite.museum","youth.museum","zoological.museum","zoology.museum","ירושלים.museum","иком.museum","mv","aero.mv","biz.mv","com.mv","coop.mv","edu.mv","gov.mv","info.mv","int.mv","mil.mv","museum.mv","name.mv","net.mv","org.mv","pro.mv","mw","ac.mw","biz.mw","co.mw","com.mw","coop.mw","edu.mw","gov.mw","int.mw","museum.mw","net.mw","org.mw","mx","com.mx","org.mx","gob.mx","edu.mx","net.mx","my","com.my","net.my","org.my","gov.my","edu.my","mil.my","name.my","mz","ac.mz","adv.mz","co.mz","edu.mz","gov.mz","mil.mz","net.mz","org.mz","na","info.na","pro.na","name.na","school.na","or.na","dr.na","us.na","mx.na","ca.na","in.na","cc.na","tv.na","ws.na","mobi.na","co.na","com.na","org.na","name","nc","asso.nc","nom.nc","ne","net","nf","com.nf","net.nf","per.nf","rec.nf","web.nf","arts.nf","firm.nf","info.nf","other.nf","store.nf","ng","com.ng","edu.ng","gov.ng","i.ng","mil.ng","mobi.ng","name.ng","net.ng","org.ng","sch.ng","ni","ac.ni","biz.ni","co.ni","com.ni","edu.ni","gob.ni","in.ni","info.ni","int.ni","mil.ni","net.ni","nom.ni","org.ni","web.ni","nl","no","fhs.no","vgs.no","fylkesbibl.no","folkebibl.no","museum.no","idrett.no","priv.no","mil.no","stat.no","dep.no","kommune.no","herad.no","aa.no","ah.no","bu.no","fm.no","hl.no","hm.no","jan-mayen.no","mr.no","nl.no","nt.no","of.no","ol.no","oslo.no","rl.no","sf.no","st.no","svalbard.no","tm.no","tr.no","va.no","vf.no","gs.aa.no","gs.ah.no","gs.bu.no","gs.fm.no","gs.hl.no","gs.hm.no","gs.jan-mayen.no","gs.mr.no","gs.nl.no","gs.nt.no","gs.of.no","gs.ol.no","gs.oslo.no","gs.rl.no","gs.sf.no","gs.st.no","gs.svalbard.no","gs.tm.no","gs.tr.no","gs.va.no","gs.vf.no","akrehamn.no","åkrehamn.no","algard.no","ålgård.no","arna.no","brumunddal.no","bryne.no","bronnoysund.no","brønnøysund.no","drobak.no","drøbak.no","egersund.no","fetsund.no","floro.no","florø.no","fredrikstad.no","hokksund.no","honefoss.no","hønefoss.no","jessheim.no","jorpeland.no","jørpeland.no","kirkenes.no","kopervik.no","krokstadelva.no","langevag.no","langevåg.no","leirvik.no","mjondalen.no","mjøndalen.no","mo-i-rana.no","mosjoen.no","mosjøen.no","nesoddtangen.no","orkanger.no","osoyro.no","osøyro.no","raholt.no","råholt.no","sandnessjoen.no","sandnessjøen.no","skedsmokorset.no","slattum.no","spjelkavik.no","stathelle.no","stavern.no","stjordalshalsen.no","stjørdalshalsen.no","tananger.no","tranby.no","vossevangen.no","afjord.no","åfjord.no","agdenes.no","al.no","ål.no","alesund.no","ålesund.no","alstahaug.no","alta.no","áltá.no","alaheadju.no","álaheadju.no","alvdal.no","amli.no","åmli.no","amot.no","åmot.no","andebu.no","andoy.no","andøy.no","andasuolo.no","ardal.no","årdal.no","aremark.no","arendal.no","ås.no","aseral.no","åseral.no","asker.no","askim.no","askvoll.no","askoy.no","askøy.no","asnes.no","åsnes.no","audnedaln.no","aukra.no","aure.no","aurland.no","aurskog-holand.no","aurskog-høland.no","austevoll.no","austrheim.no","averoy.no","averøy.no","balestrand.no","ballangen.no","balat.no","bálát.no","balsfjord.no","bahccavuotna.no","báhccavuotna.no","bamble.no","bardu.no","beardu.no","beiarn.no","bajddar.no","bájddar.no","baidar.no","báidár.no","berg.no","bergen.no","berlevag.no","berlevåg.no","bearalvahki.no","bearalváhki.no","bindal.no","birkenes.no","bjarkoy.no","bjarkøy.no","bjerkreim.no","bjugn.no","bodo.no","bodø.no","badaddja.no","bådåddjå.no","budejju.no","bokn.no","bremanger.no","bronnoy.no","brønnøy.no","bygland.no","bykle.no","barum.no","bærum.no","bo.telemark.no","bø.telemark.no","bo.nordland.no","bø.nordland.no","bievat.no","bievát.no","bomlo.no","bømlo.no","batsfjord.no","båtsfjord.no","bahcavuotna.no","báhcavuotna.no","dovre.no","drammen.no","drangedal.no","dyroy.no","dyrøy.no","donna.no","dønna.no","eid.no","eidfjord.no","eidsberg.no","eidskog.no","eidsvoll.no","eigersund.no","elverum.no","enebakk.no","engerdal.no","etne.no","etnedal.no","evenes.no","evenassi.no","evenášši.no","evje-og-hornnes.no","farsund.no","fauske.no","fuossko.no","fuoisku.no","fedje.no","fet.no","finnoy.no","finnøy.no","fitjar.no","fjaler.no","fjell.no","flakstad.no","flatanger.no","flekkefjord.no","flesberg.no","flora.no","fla.no","flå.no","folldal.no","forsand.no","fosnes.no","frei.no","frogn.no","froland.no","frosta.no","frana.no","fræna.no","froya.no","frøya.no","fusa.no","fyresdal.no","forde.no","førde.no","gamvik.no","gangaviika.no","gáŋgaviika.no","gaular.no","gausdal.no","gildeskal.no","gildeskål.no","giske.no","gjemnes.no","gjerdrum.no","gjerstad.no","gjesdal.no","gjovik.no","gjøvik.no","gloppen.no","gol.no","gran.no","grane.no","granvin.no","gratangen.no","grimstad.no","grong.no","kraanghke.no","kråanghke.no","grue.no","gulen.no","hadsel.no","halden.no","halsa.no","hamar.no","hamaroy.no","habmer.no","hábmer.no","hapmir.no","hápmir.no","hammerfest.no","hammarfeasta.no","hámmárfeasta.no","haram.no","hareid.no","harstad.no","hasvik.no","aknoluokta.no","ákŋoluokta.no","hattfjelldal.no","aarborte.no","haugesund.no","hemne.no","hemnes.no","hemsedal.no","heroy.more-og-romsdal.no","herøy.møre-og-romsdal.no","heroy.nordland.no","herøy.nordland.no","hitra.no","hjartdal.no","hjelmeland.no","hobol.no","hobøl.no","hof.no","hol.no","hole.no","holmestrand.no","holtalen.no","holtålen.no","hornindal.no","horten.no","hurdal.no","hurum.no","hvaler.no","hyllestad.no","hagebostad.no","hægebostad.no","hoyanger.no","høyanger.no","hoylandet.no","høylandet.no","ha.no","hå.no","ibestad.no","inderoy.no","inderøy.no","iveland.no","jevnaker.no","jondal.no","jolster.no","jølster.no","karasjok.no","karasjohka.no","kárášjohka.no","karlsoy.no","galsa.no","gálsá.no","karmoy.no","karmøy.no","kautokeino.no","guovdageaidnu.no","klepp.no","klabu.no","klæbu.no","kongsberg.no","kongsvinger.no","kragero.no","kragerø.no","kristiansand.no","kristiansund.no","krodsherad.no","krødsherad.no","kvalsund.no","rahkkeravju.no","ráhkkerávju.no","kvam.no","kvinesdal.no","kvinnherad.no","kviteseid.no","kvitsoy.no","kvitsøy.no","kvafjord.no","kvæfjord.no","giehtavuoatna.no","kvanangen.no","kvænangen.no","navuotna.no","návuotna.no","kafjord.no","kåfjord.no","gaivuotna.no","gáivuotna.no","larvik.no","lavangen.no","lavagis.no","loabat.no","loabát.no","lebesby.no","davvesiida.no","leikanger.no","leirfjord.no","leka.no","leksvik.no","lenvik.no","leangaviika.no","leaŋgaviika.no","lesja.no","levanger.no","lier.no","lierne.no","lillehammer.no","lillesand.no","lindesnes.no","lindas.no","lindås.no","lom.no","loppa.no","lahppi.no","láhppi.no","lund.no","lunner.no","luroy.no","lurøy.no","luster.no","lyngdal.no","lyngen.no","ivgu.no","lardal.no","lerdal.no","lærdal.no","lodingen.no","lødingen.no","lorenskog.no","lørenskog.no","loten.no","løten.no","malvik.no","masoy.no","måsøy.no","muosat.no","muosát.no","mandal.no","marker.no","marnardal.no","masfjorden.no","meland.no","meldal.no","melhus.no","meloy.no","meløy.no","meraker.no","meråker.no","moareke.no","moåreke.no","midsund.no","midtre-gauldal.no","modalen.no","modum.no","molde.no","moskenes.no","moss.no","mosvik.no","malselv.no","målselv.no","malatvuopmi.no","málatvuopmi.no","namdalseid.no","aejrie.no","namsos.no","namsskogan.no","naamesjevuemie.no","nååmesjevuemie.no","laakesvuemie.no","nannestad.no","narvik.no","narviika.no","naustdal.no","nedre-eiker.no","nes.akershus.no","nes.buskerud.no","nesna.no","nesodden.no","nesseby.no","unjarga.no","unjárga.no","nesset.no","nissedal.no","nittedal.no","nord-aurdal.no","nord-fron.no","nord-odal.no","norddal.no","nordkapp.no","davvenjarga.no","davvenjárga.no","nordre-land.no","nordreisa.no","raisa.no","ráisa.no","nore-og-uvdal.no","notodden.no","naroy.no","nærøy.no","notteroy.no","nøtterøy.no","odda.no","oksnes.no","øksnes.no","oppdal.no","oppegard.no","oppegård.no","orkdal.no","orland.no","ørland.no","orskog.no","ørskog.no","orsta.no","ørsta.no","os.hedmark.no","os.hordaland.no","osen.no","osteroy.no","osterøy.no","ostre-toten.no","østre-toten.no","overhalla.no","ovre-eiker.no","øvre-eiker.no","oyer.no","øyer.no","oygarden.no","øygarden.no","oystre-slidre.no","øystre-slidre.no","porsanger.no","porsangu.no","porsáŋgu.no","porsgrunn.no","radoy.no","radøy.no","rakkestad.no","rana.no","ruovat.no","randaberg.no","rauma.no","rendalen.no","rennebu.no","rennesoy.no","rennesøy.no","rindal.no","ringebu.no","ringerike.no","ringsaker.no","rissa.no","risor.no","risør.no","roan.no","rollag.no","rygge.no","ralingen.no","rælingen.no","rodoy.no","rødøy.no","romskog.no","rømskog.no","roros.no","røros.no","rost.no","røst.no","royken.no","røyken.no","royrvik.no","røyrvik.no","rade.no","råde.no","salangen.no","siellak.no","saltdal.no","salat.no","sálát.no","sálat.no","samnanger.no","sande.more-og-romsdal.no","sande.møre-og-romsdal.no","sande.vestfold.no","sandefjord.no","sandnes.no","sandoy.no","sandøy.no","sarpsborg.no","sauda.no","sauherad.no","sel.no","selbu.no","selje.no","seljord.no","sigdal.no","siljan.no","sirdal.no","skaun.no","skedsmo.no","ski.no","skien.no","skiptvet.no","skjervoy.no","skjervøy.no","skierva.no","skiervá.no","skjak.no","skjåk.no","skodje.no","skanland.no","skånland.no","skanit.no","skánit.no","smola.no","smøla.no","snillfjord.no","snasa.no","snåsa.no","snoasa.no","snaase.no","snåase.no","sogndal.no","sokndal.no","sola.no","solund.no","songdalen.no","sortland.no","spydeberg.no","stange.no","stavanger.no","steigen.no","steinkjer.no","stjordal.no","stjørdal.no","stokke.no","stor-elvdal.no","stord.no","stordal.no","storfjord.no","omasvuotna.no","strand.no","stranda.no","stryn.no","sula.no","suldal.no","sund.no","sunndal.no","surnadal.no","sveio.no","svelvik.no","sykkylven.no","sogne.no","søgne.no","somna.no","sømna.no","sondre-land.no","søndre-land.no","sor-aurdal.no","sør-aurdal.no","sor-fron.no","sør-fron.no","sor-odal.no","sør-odal.no","sor-varanger.no","sør-varanger.no","matta-varjjat.no","mátta-várjjat.no","sorfold.no","sørfold.no","sorreisa.no","sørreisa.no","sorum.no","sørum.no","tana.no","deatnu.no","time.no","tingvoll.no","tinn.no","tjeldsund.no","dielddanuorri.no","tjome.no","tjøme.no","tokke.no","tolga.no","torsken.no","tranoy.no","tranøy.no","tromso.no","tromsø.no","tromsa.no","romsa.no","trondheim.no","troandin.no","trysil.no","trana.no","træna.no","trogstad.no","trøgstad.no","tvedestrand.no","tydal.no","tynset.no","tysfjord.no","divtasvuodna.no","divttasvuotna.no","tysnes.no","tysvar.no","tysvær.no","tonsberg.no","tønsberg.no","ullensaker.no","ullensvang.no","ulvik.no","utsira.no","vadso.no","vadsø.no","cahcesuolo.no","čáhcesuolo.no","vaksdal.no","valle.no","vang.no","vanylven.no","vardo.no","vardø.no","varggat.no","várggát.no","vefsn.no","vaapste.no","vega.no","vegarshei.no","vegårshei.no","vennesla.no","verdal.no","verran.no","vestby.no","vestnes.no","vestre-slidre.no","vestre-toten.no","vestvagoy.no","vestvågøy.no","vevelstad.no","vik.no","vikna.no","vindafjord.no","volda.no","voss.no","varoy.no","værøy.no","vagan.no","vågan.no","voagat.no","vagsoy.no","vågsøy.no","vaga.no","vågå.no","valer.ostfold.no","våler.østfold.no","valer.hedmark.no","våler.hedmark.no","*.np","nr","biz.nr","info.nr","gov.nr","edu.nr","org.nr","net.nr","com.nr","nu","nz","ac.nz","co.nz","cri.nz","geek.nz","gen.nz","govt.nz","health.nz","iwi.nz","kiwi.nz","maori.nz","mil.nz","māori.nz","net.nz","org.nz","parliament.nz","school.nz","om","co.om","com.om","edu.om","gov.om","med.om","museum.om","net.om","org.om","pro.om","onion","org","pa","ac.pa","gob.pa","com.pa","org.pa","sld.pa","edu.pa","net.pa","ing.pa","abo.pa","med.pa","nom.pa","pe","edu.pe","gob.pe","nom.pe","mil.pe","org.pe","com.pe","net.pe","pf","com.pf","org.pf","edu.pf","*.pg","ph","com.ph","net.ph","org.ph","gov.ph","edu.ph","ngo.ph","mil.ph","i.ph","pk","com.pk","net.pk","edu.pk","org.pk","fam.pk","biz.pk","web.pk","gov.pk","gob.pk","gok.pk","gon.pk","gop.pk","gos.pk","info.pk","pl","com.pl","net.pl","org.pl","aid.pl","agro.pl","atm.pl","auto.pl","biz.pl","edu.pl","gmina.pl","gsm.pl","info.pl","mail.pl","miasta.pl","media.pl","mil.pl","nieruchomosci.pl","nom.pl","pc.pl","powiat.pl","priv.pl","realestate.pl","rel.pl","sex.pl","shop.pl","sklep.pl","sos.pl","szkola.pl","targi.pl","tm.pl","tourism.pl","travel.pl","turystyka.pl","gov.pl","ap.gov.pl","ic.gov.pl","is.gov.pl","us.gov.pl","kmpsp.gov.pl","kppsp.gov.pl","kwpsp.gov.pl","psp.gov.pl","wskr.gov.pl","kwp.gov.pl","mw.gov.pl","ug.gov.pl","um.gov.pl","umig.gov.pl","ugim.gov.pl","upow.gov.pl","uw.gov.pl","starostwo.gov.pl","pa.gov.pl","po.gov.pl","psse.gov.pl","pup.gov.pl","rzgw.gov.pl","sa.gov.pl","so.gov.pl","sr.gov.pl","wsa.gov.pl","sko.gov.pl","uzs.gov.pl","wiih.gov.pl","winb.gov.pl","pinb.gov.pl","wios.gov.pl","witd.gov.pl","wzmiuw.gov.pl","piw.gov.pl","wiw.gov.pl","griw.gov.pl","wif.gov.pl","oum.gov.pl","sdn.gov.pl","zp.gov.pl","uppo.gov.pl","mup.gov.pl","wuoz.gov.pl","konsulat.gov.pl","oirm.gov.pl","augustow.pl","babia-gora.pl","bedzin.pl","beskidy.pl","bialowieza.pl","bialystok.pl","bielawa.pl","bieszczady.pl","boleslawiec.pl","bydgoszcz.pl","bytom.pl","cieszyn.pl","czeladz.pl","czest.pl","dlugoleka.pl","elblag.pl","elk.pl","glogow.pl","gniezno.pl","gorlice.pl","grajewo.pl","ilawa.pl","jaworzno.pl","jelenia-gora.pl","jgora.pl","kalisz.pl","kazimierz-dolny.pl","karpacz.pl","kartuzy.pl","kaszuby.pl","katowice.pl","kepno.pl","ketrzyn.pl","klodzko.pl","kobierzyce.pl","kolobrzeg.pl","konin.pl","konskowola.pl","kutno.pl","lapy.pl","lebork.pl","legnica.pl","lezajsk.pl","limanowa.pl","lomza.pl","lowicz.pl","lubin.pl","lukow.pl","malbork.pl","malopolska.pl","mazowsze.pl","mazury.pl","mielec.pl","mielno.pl","mragowo.pl","naklo.pl","nowaruda.pl","nysa.pl","olawa.pl","olecko.pl","olkusz.pl","olsztyn.pl","opoczno.pl","opole.pl","ostroda.pl","ostroleka.pl","ostrowiec.pl","ostrowwlkp.pl","pila.pl","pisz.pl","podhale.pl","podlasie.pl","polkowice.pl","pomorze.pl","pomorskie.pl","prochowice.pl","pruszkow.pl","przeworsk.pl","pulawy.pl","radom.pl","rawa-maz.pl","rybnik.pl","rzeszow.pl","sanok.pl","sejny.pl","slask.pl","slupsk.pl","sosnowiec.pl","stalowa-wola.pl","skoczow.pl","starachowice.pl","stargard.pl","suwalki.pl","swidnica.pl","swiebodzin.pl","swinoujscie.pl","szczecin.pl","szczytno.pl","tarnobrzeg.pl","tgory.pl","turek.pl","tychy.pl","ustka.pl","walbrzych.pl","warmia.pl","warszawa.pl","waw.pl","wegrow.pl","wielun.pl","wlocl.pl","wloclawek.pl","wodzislaw.pl","wolomin.pl","wroclaw.pl","zachpomor.pl","zagan.pl","zarow.pl","zgora.pl","zgorzelec.pl","pm","pn","gov.pn","co.pn","org.pn","edu.pn","net.pn","post","pr","com.pr","net.pr","org.pr","gov.pr","edu.pr","isla.pr","pro.pr","biz.pr","info.pr","name.pr","est.pr","prof.pr","ac.pr","pro","aaa.pro","aca.pro","acct.pro","avocat.pro","bar.pro","cpa.pro","eng.pro","jur.pro","law.pro","med.pro","recht.pro","ps","edu.ps","gov.ps","sec.ps","plo.ps","com.ps","org.ps","net.ps","pt","net.pt","gov.pt","org.pt","edu.pt","int.pt","publ.pt","com.pt","nome.pt","pw","co.pw","ne.pw","or.pw","ed.pw","go.pw","belau.pw","py","com.py","coop.py","edu.py","gov.py","mil.py","net.py","org.py","qa","com.qa","edu.qa","gov.qa","mil.qa","name.qa","net.qa","org.qa","sch.qa","re","asso.re","com.re","nom.re","ro","arts.ro","com.ro","firm.ro","info.ro","nom.ro","nt.ro","org.ro","rec.ro","store.ro","tm.ro","www.ro","rs","ac.rs","co.rs","edu.rs","gov.rs","in.rs","org.rs","ru","ac.ru","edu.ru","gov.ru","int.ru","mil.ru","test.ru","rw","ac.rw","co.rw","coop.rw","gov.rw","mil.rw","net.rw","org.rw","sa","com.sa","net.sa","org.sa","gov.sa","med.sa","pub.sa","edu.sa","sch.sa","sb","com.sb","edu.sb","gov.sb","net.sb","org.sb","sc","com.sc","gov.sc","net.sc","org.sc","edu.sc","sd","com.sd","net.sd","org.sd","edu.sd","med.sd","tv.sd","gov.sd","info.sd","se","a.se","ac.se","b.se","bd.se","brand.se","c.se","d.se","e.se","f.se","fh.se","fhsk.se","fhv.se","g.se","h.se","i.se","k.se","komforb.se","kommunalforbund.se","komvux.se","l.se","lanbib.se","m.se","n.se","naturbruksgymn.se","o.se","org.se","p.se","parti.se","pp.se","press.se","r.se","s.se","t.se","tm.se","u.se","w.se","x.se","y.se","z.se","sg","com.sg","net.sg","org.sg","gov.sg","edu.sg","per.sg","sh","com.sh","net.sh","gov.sh","org.sh","mil.sh","si","sj","sk","sl","com.sl","net.sl","edu.sl","gov.sl","org.sl","sm","sn","art.sn","com.sn","edu.sn","gouv.sn","org.sn","perso.sn","univ.sn","so","com.so","net.so","org.so","sr","st","co.st","com.st","consulado.st","edu.st","embaixada.st","gov.st","mil.st","net.st","org.st","principe.st","saotome.st","store.st","su","sv","com.sv","edu.sv","gob.sv","org.sv","red.sv","sx","gov.sx","sy","edu.sy","gov.sy","net.sy","mil.sy","com.sy","org.sy","sz","co.sz","ac.sz","org.sz","tc","td","tel","tf","tg","th","ac.th","co.th","go.th","in.th","mi.th","net.th","or.th","tj","ac.tj","biz.tj","co.tj","com.tj","edu.tj","go.tj","gov.tj","int.tj","mil.tj","name.tj","net.tj","nic.tj","org.tj","test.tj","web.tj","tk","tl","gov.tl","tm","com.tm","co.tm","org.tm","net.tm","nom.tm","gov.tm","mil.tm","edu.tm","tn","com.tn","ens.tn","fin.tn","gov.tn","ind.tn","intl.tn","nat.tn","net.tn","org.tn","info.tn","perso.tn","tourism.tn","edunet.tn","rnrt.tn","rns.tn","rnu.tn","mincom.tn","agrinet.tn","defense.tn","turen.tn","to","com.to","gov.to","net.to","org.to","edu.to","mil.to","tr","av.tr","bbs.tr","bel.tr","biz.tr","com.tr","dr.tr","edu.tr","gen.tr","gov.tr","info.tr","mil.tr","k12.tr","kep.tr","name.tr","net.tr","org.tr","pol.tr","tel.tr","tsk.tr","tv.tr","web.tr","nc.tr","gov.nc.tr","tt","co.tt","com.tt","org.tt","net.tt","biz.tt","info.tt","pro.tt","int.tt","coop.tt","jobs.tt","mobi.tt","travel.tt","museum.tt","aero.tt","name.tt","gov.tt","edu.tt","tv","tw","edu.tw","gov.tw","mil.tw","com.tw","net.tw","org.tw","idv.tw","game.tw","ebiz.tw","club.tw","網路.tw","組織.tw","商業.tw","tz","ac.tz","co.tz","go.tz","hotel.tz","info.tz","me.tz","mil.tz","mobi.tz","ne.tz","or.tz","sc.tz","tv.tz","ua","com.ua","edu.ua","gov.ua","in.ua","net.ua","org.ua","cherkassy.ua","cherkasy.ua","chernigov.ua","chernihiv.ua","chernivtsi.ua","chernovtsy.ua","ck.ua","cn.ua","cr.ua","crimea.ua","cv.ua","dn.ua","dnepropetrovsk.ua","dnipropetrovsk.ua","dominic.ua","donetsk.ua","dp.ua","if.ua","ivano-frankivsk.ua","kh.ua","kharkiv.ua","kharkov.ua","kherson.ua","khmelnitskiy.ua","khmelnytskyi.ua","kiev.ua","kirovograd.ua","km.ua","kr.ua","krym.ua","ks.ua","kv.ua","kyiv.ua","lg.ua","lt.ua","lugansk.ua","lutsk.ua","lv.ua","lviv.ua","mk.ua","mykolaiv.ua","nikolaev.ua","od.ua","odesa.ua","odessa.ua","pl.ua","poltava.ua","rivne.ua","rovno.ua","rv.ua","sb.ua","sebastopol.ua","sevastopol.ua","sm.ua","sumy.ua","te.ua","ternopil.ua","uz.ua","uzhgorod.ua","vinnica.ua","vinnytsia.ua","vn.ua","volyn.ua","yalta.ua","zaporizhzhe.ua","zaporizhzhia.ua","zhitomir.ua","zhytomyr.ua","zp.ua","zt.ua","ug","co.ug","or.ug","ac.ug","sc.ug","go.ug","ne.ug","com.ug","org.ug","uk","ac.uk","co.uk","gov.uk","ltd.uk","me.uk","net.uk","nhs.uk","org.uk","plc.uk","police.uk","*.sch.uk","us","dni.us","fed.us","isa.us","kids.us","nsn.us","ak.us","al.us","ar.us","as.us","az.us","ca.us","co.us","ct.us","dc.us","de.us","fl.us","ga.us","gu.us","hi.us","ia.us","id.us","il.us","in.us","ks.us","ky.us","la.us","ma.us","md.us","me.us","mi.us","mn.us","mo.us","ms.us","mt.us","nc.us","nd.us","ne.us","nh.us","nj.us","nm.us","nv.us","ny.us","oh.us","ok.us","or.us","pa.us","pr.us","ri.us","sc.us","sd.us","tn.us","tx.us","ut.us","vi.us","vt.us","va.us","wa.us","wi.us","wv.us","wy.us","k12.ak.us","k12.al.us","k12.ar.us","k12.as.us","k12.az.us","k12.ca.us","k12.co.us","k12.ct.us","k12.dc.us","k12.de.us","k12.fl.us","k12.ga.us","k12.gu.us","k12.ia.us","k12.id.us","k12.il.us","k12.in.us","k12.ks.us","k12.ky.us","k12.la.us","k12.ma.us","k12.md.us","k12.me.us","k12.mi.us","k12.mn.us","k12.mo.us","k12.ms.us","k12.mt.us","k12.nc.us","k12.ne.us","k12.nh.us","k12.nj.us","k12.nm.us","k12.nv.us","k12.ny.us","k12.oh.us","k12.ok.us","k12.or.us","k12.pa.us","k12.pr.us","k12.ri.us","k12.sc.us","k12.tn.us","k12.tx.us","k12.ut.us","k12.vi.us","k12.vt.us","k12.va.us","k12.wa.us","k12.wi.us","k12.wy.us","cc.ak.us","cc.al.us","cc.ar.us","cc.as.us","cc.az.us","cc.ca.us","cc.co.us","cc.ct.us","cc.dc.us","cc.de.us","cc.fl.us","cc.ga.us","cc.gu.us","cc.hi.us","cc.ia.us","cc.id.us","cc.il.us","cc.in.us","cc.ks.us","cc.ky.us","cc.la.us","cc.ma.us","cc.md.us","cc.me.us","cc.mi.us","cc.mn.us","cc.mo.us","cc.ms.us","cc.mt.us","cc.nc.us","cc.nd.us","cc.ne.us","cc.nh.us","cc.nj.us","cc.nm.us","cc.nv.us","cc.ny.us","cc.oh.us","cc.ok.us","cc.or.us","cc.pa.us","cc.pr.us","cc.ri.us","cc.sc.us","cc.sd.us","cc.tn.us","cc.tx.us","cc.ut.us","cc.vi.us","cc.vt.us","cc.va.us","cc.wa.us","cc.wi.us","cc.wv.us","cc.wy.us","lib.ak.us","lib.al.us","lib.ar.us","lib.as.us","lib.az.us","lib.ca.us","lib.co.us","lib.ct.us","lib.dc.us","lib.fl.us","lib.ga.us","lib.gu.us","lib.hi.us","lib.ia.us","lib.id.us","lib.il.us","lib.in.us","lib.ks.us","lib.ky.us","lib.la.us","lib.ma.us","lib.md.us","lib.me.us","lib.mi.us","lib.mn.us","lib.mo.us","lib.ms.us","lib.mt.us","lib.nc.us","lib.nd.us","lib.ne.us","lib.nh.us","lib.nj.us","lib.nm.us","lib.nv.us","lib.ny.us","lib.oh.us","lib.ok.us","lib.or.us","lib.pa.us","lib.pr.us","lib.ri.us","lib.sc.us","lib.sd.us","lib.tn.us","lib.tx.us","lib.ut.us","lib.vi.us","lib.vt.us","lib.va.us","lib.wa.us","lib.wi.us","lib.wy.us","pvt.k12.ma.us","chtr.k12.ma.us","paroch.k12.ma.us","ann-arbor.mi.us","cog.mi.us","dst.mi.us","eaton.mi.us","gen.mi.us","mus.mi.us","tec.mi.us","washtenaw.mi.us","uy","com.uy","edu.uy","gub.uy","mil.uy","net.uy","org.uy","uz","co.uz","com.uz","net.uz","org.uz","va","vc","com.vc","net.vc","org.vc","gov.vc","mil.vc","edu.vc","ve","arts.ve","co.ve","com.ve","e12.ve","edu.ve","firm.ve","gob.ve","gov.ve","info.ve","int.ve","mil.ve","net.ve","org.ve","rec.ve","store.ve","tec.ve","web.ve","vg","vi","co.vi","com.vi","k12.vi","net.vi","org.vi","vn","com.vn","net.vn","org.vn","edu.vn","gov.vn","int.vn","ac.vn","biz.vn","info.vn","name.vn","pro.vn","health.vn","vu","com.vu","edu.vu","net.vu","org.vu","wf","ws","com.ws","net.ws","org.ws","gov.ws","edu.ws","yt","امارات","հայ","বাংলা","бг","бел","中国","中國","الجزائر","مصر","ею","გე","ελ","香港","公司.香港","教育.香港","政府.香港","個人.香港","網絡.香港","組織.香港","ಭಾರತ","ଭାରତ","ভাৰত","भारतम्","भारोत","ڀارت","ഭാരതം","भारत","بارت","بھارت","భారత్","ભારત","ਭਾਰਤ","ভারত","இந்தியா","ایران","ايران","عراق","الاردن","한국","қаз","ලංකා","இலங்கை","المغرب","мкд","мон","澳門","澳门","مليسيا","عمان","پاکستان","پاكستان","فلسطين","срб","пр.срб","орг.срб","обр.срб","од.срб","упр.срб","ак.срб","рф","قطر","السعودية","السعودیة","السعودیۃ","السعوديه","سودان","新加坡","சிங்கப்பூர்","سورية","سوريا","ไทย","ศึกษา.ไทย","ธุรกิจ.ไทย","รัฐบาล.ไทย","ทหาร.ไทย","เน็ต.ไทย","องค์กร.ไทย","تونس","台灣","台湾","臺灣","укр","اليمن","xxx","*.ye","ac.za","agric.za","alt.za","co.za","edu.za","gov.za","grondar.za","law.za","mil.za","net.za","ngo.za","nic.za","nis.za","nom.za","org.za","school.za","tm.za","web.za","zm","ac.zm","biz.zm","co.zm","com.zm","edu.zm","gov.zm","info.zm","mil.zm","net.zm","org.zm","sch.zm","zw","ac.zw","co.zw","gov.zw","mil.zw","org.zw","aaa","aarp","abarth","abb","abbott","abbvie","abc","able","abogado","abudhabi","academy","accenture","accountant","accountants","aco","actor","adac","ads","adult","aeg","aetna","afamilycompany","afl","africa","agakhan","agency","aig","aigo","airbus","airforce","airtel","akdn","alfaromeo","alibaba","alipay","allfinanz","allstate","ally","alsace","alstom","americanexpress","americanfamily","amex","amfam","amica","amsterdam","analytics","android","anquan","anz","aol","apartments","app","apple","aquarelle","arab","aramco","archi","army","art","arte","asda","associates","athleta","attorney","auction","audi","audible","audio","auspost","author","auto","autos","avianca","aws","axa","azure","baby","baidu","banamex","bananarepublic","band","bank","bar","barcelona","barclaycard","barclays","barefoot","bargains","baseball","basketball","bauhaus","bayern","bbc","bbt","bbva","bcg","bcn","beats","beauty","beer","bentley","berlin","best","bestbuy","bet","bharti","bible","bid","bike","bing","bingo","bio","black","blackfriday","blockbuster","blog","bloomberg","blue","bms","bmw","bnpparibas","boats","boehringer","bofa","bom","bond","boo","book","booking","bosch","bostik","boston","bot","boutique","box","bradesco","bridgestone","broadway","broker","brother","brussels","budapest","bugatti","build","builders","business","buy","buzz","bzh","cab","cafe","cal","call","calvinklein","cam","camera","camp","cancerresearch","canon","capetown","capital","capitalone","car","caravan","cards","care","career","careers","cars","cartier","casa","case","caseih","cash","casino","catering","catholic","cba","cbn","cbre","cbs","ceb","center","ceo","cern","cfa","cfd","chanel","channel","charity","chase","chat","cheap","chintai","christmas","chrome","chrysler","church","cipriani","circle","cisco","citadel","citi","citic","city","cityeats","claims","cleaning","click","clinic","clinique","clothing","cloud","club","clubmed","coach","codes","coffee","college","cologne","comcast","commbank","community","company","compare","computer","comsec","condos","construction","consulting","contact","contractors","cooking","cookingchannel","cool","corsica","country","coupon","coupons","courses","cpa","credit","creditcard","creditunion","cricket","crown","crs","cruise","cruises","csc","cuisinella","cymru","cyou","dabur","dad","dance","data","date","dating","datsun","day","dclk","dds","deal","dealer","deals","degree","delivery","dell","deloitte","delta","democrat","dental","dentist","desi","design","dev","dhl","diamonds","diet","digital","direct","directory","discount","discover","dish","diy","dnp","docs","doctor","dodge","dog","domains","dot","download","drive","dtv","dubai","duck","dunlop","dupont","durban","dvag","dvr","earth","eat","eco","edeka","education","email","emerck","energy","engineer","engineering","enterprises","epson","equipment","ericsson","erni","esq","estate","esurance","etisalat","eurovision","eus","events","everbank","exchange","expert","exposed","express","extraspace","fage","fail","fairwinds","faith","family","fan","fans","farm","farmers","fashion","fast","fedex","feedback","ferrari","ferrero","fiat","fidelity","fido","film","final","finance","financial","fire","firestone","firmdale","fish","fishing","fit","fitness","flickr","flights","flir","florist","flowers","fly","foo","food","foodnetwork","football","ford","forex","forsale","forum","foundation","fox","free","fresenius","frl","frogans","frontdoor","frontier","ftr","fujitsu","fujixerox","fun","fund","furniture","futbol","fyi","gal","gallery","gallo","gallup","game","games","gap","garden","gay","gbiz","gdn","gea","gent","genting","george","ggee","gift","gifts","gives","giving","glade","glass","gle","global","globo","gmail","gmbh","gmo","gmx","godaddy","gold","goldpoint","golf","goo","goodyear","goog","google","gop","got","grainger","graphics","gratis","green","gripe","grocery","group","guardian","gucci","guge","guide","guitars","guru","hair","hamburg","hangout","haus","hbo","hdfc","hdfcbank","health","healthcare","help","helsinki","here","hermes","hgtv","hiphop","hisamitsu","hitachi","hiv","hkt","hockey","holdings","holiday","homedepot","homegoods","homes","homesense","honda","horse","hospital","host","hosting","hot","hoteles","hotels","hotmail","house","how","hsbc","hughes","hyatt","hyundai","ibm","icbc","ice","icu","ieee","ifm","ikano","imamat","imdb","immo","immobilien","inc","industries","infiniti","ing","ink","institute","insurance","insure","intel","international","intuit","investments","ipiranga","irish","ismaili","ist","istanbul","itau","itv","iveco","jaguar","java","jcb","jcp","jeep","jetzt","jewelry","jio","jll","jmp","jnj","joburg","jot","joy","jpmorgan","jprs","juegos","juniper","kaufen","kddi","kerryhotels","kerrylogistics","kerryproperties","kfh","kia","kim","kinder","kindle","kitchen","kiwi","koeln","komatsu","kosher","kpmg","kpn","krd","kred","kuokgroup","kyoto","lacaixa","ladbrokes","lamborghini","lamer","lancaster","lancia","lancome","land","landrover","lanxess","lasalle","lat","latino","latrobe","law","lawyer","lds","lease","leclerc","lefrak","legal","lego","lexus","lgbt","liaison","lidl","life","lifeinsurance","lifestyle","lighting","like","lilly","limited","limo","lincoln","linde","link","lipsy","live","living","lixil","llc","llp","loan","loans","locker","locus","loft","lol","london","lotte","lotto","love","lpl","lplfinancial","ltd","ltda","lundbeck","lupin","luxe","luxury","macys","madrid","maif","maison","makeup","man","management","mango","map","market","marketing","markets","marriott","marshalls","maserati","mattel","mba","mckinsey","med","media","meet","melbourne","meme","memorial","men","menu","merckmsd","metlife","miami","microsoft","mini","mint","mit","mitsubishi","mlb","mls","mma","mobile","mobily","moda","moe","moi","mom","monash","money","monster","mopar","mormon","mortgage","moscow","moto","motorcycles","mov","movie","movistar","msd","mtn","mtr","mutual","nab","nadex","nagoya","nationwide","natura","navy","nba","nec","netbank","netflix","network","neustar","new","newholland","news","next","nextdirect","nexus","nfl","ngo","nhk","nico","nike","nikon","ninja","nissan","nissay","nokia","northwesternmutual","norton","now","nowruz","nowtv","nra","nrw","ntt","nyc","obi","observer","off","office","okinawa","olayan","olayangroup","oldnavy","ollo","omega","one","ong","onl","online","onyourside","ooo","open","oracle","orange","organic","origins","osaka","otsuka","ott","ovh","page","panasonic","paris","pars","partners","parts","party","passagens","pay","pccw","pet","pfizer","pharmacy","phd","philips","phone","photo","photography","photos","physio","piaget","pics","pictet","pictures","pid","pin","ping","pink","pioneer","pizza","place","play","playstation","plumbing","plus","pnc","pohl","poker","politie","porn","pramerica","praxi","press","prime","prod","productions","prof","progressive","promo","properties","property","protection","pru","prudential","pub","pwc","qpon","quebec","quest","qvc","racing","radio","raid","read","realestate","realtor","realty","recipes","red","redstone","redumbrella","rehab","reise","reisen","reit","reliance","ren","rent","rentals","repair","report","republican","rest","restaurant","review","reviews","rexroth","rich","richardli","ricoh","rightathome","ril","rio","rip","rmit","rocher","rocks","rodeo","rogers","room","rsvp","rugby","ruhr","run","rwe","ryukyu","saarland","safe","safety","sakura","sale","salon","samsclub","samsung","sandvik","sandvikcoromant","sanofi","sap","sarl","sas","save","saxo","sbi","sbs","sca","scb","schaeffler","schmidt","scholarships","school","schule","schwarz","science","scjohnson","scor","scot","search","seat","secure","security","seek","select","sener","services","ses","seven","sew","sex","sexy","sfr","shangrila","sharp","shaw","shell","shia","shiksha","shoes","shop","shopping","shouji","show","showtime","shriram","silk","sina","singles","site","ski","skin","sky","skype","sling","smart","smile","sncf","soccer","social","softbank","software","sohu","solar","solutions","song","sony","soy","space","sport","spot","spreadbetting","srl","srt","stada","staples","star","statebank","statefarm","stc","stcgroup","stockholm","storage","store","stream","studio","study","style","sucks","supplies","supply","support","surf","surgery","suzuki","swatch","swiftcover","swiss","sydney","symantec","systems","tab","taipei","talk","taobao","target","tatamotors","tatar","tattoo","tax","taxi","tci","tdk","team","tech","technology","telefonica","temasek","tennis","teva","thd","theater","theatre","tiaa","tickets","tienda","tiffany","tips","tires","tirol","tjmaxx","tjx","tkmaxx","tmall","today","tokyo","tools","top","toray","toshiba","total","tours","town","toyota","toys","trade","trading","training","travel","travelchannel","travelers","travelersinsurance","trust","trv","tube","tui","tunes","tushu","tvs","ubank","ubs","uconnect","unicom","university","uno","uol","ups","vacations","vana","vanguard","vegas","ventures","verisign","versicherung","vet","viajes","video","vig","viking","villas","vin","vip","virgin","visa","vision","vistaprint","viva","vivo","vlaanderen","vodka","volkswagen","volvo","vote","voting","voto","voyage","vuelos","wales","walmart","walter","wang","wanggou","warman","watch","watches","weather","weatherchannel","webcam","weber","website","wed","wedding","weibo","weir","whoswho","wien","wiki","williamhill","win","windows","wine","winners","wme","wolterskluwer","woodside","work","works","world","wow","wtc","wtf","xbox","xerox","xfinity","xihuan","xin","कॉम","セール","佛山","慈善","集团","在线","大众汽车","点看","คอม","八卦","موقع","公益","公司","香格里拉","网站","移动","我爱你","москва","католик","онлайн","сайт","联通","קום","时尚","微博","淡马锡","ファッション","орг","नेट","ストア","삼성","商标","商店","商城","дети","ポイント","新闻","工行","家電","كوم","中文网","中信","娱乐","谷歌","電訊盈科","购物","クラウド","通販","网店","संगठन","餐厅","网络","ком","诺基亚","食品","飞利浦","手表","手机","ارامكو","العليان","اتصالات","بازار","موبايلي","ابوظبي","كاثوليك","همراه","닷컴","政府","شبكة","بيتك","عرب","机构","组织机构","健康","招聘","рус","珠宝","大拿","みんな","グーグル","世界","書籍","网址","닷넷","コム","天主教","游戏","vermögensberater","vermögensberatung","企业","信息","嘉里大酒店","嘉里","广东","政务","xyz","yachts","yahoo","yamaxun","yandex","yodobashi","yoga","yokohama","you","youtube","yun","zappos","zara","zero","zip","zone","zuerich","cc.ua","inf.ua","ltd.ua","beep.pl","barsy.ca","*.compute.estate","*.alces.network","alwaysdata.net","cloudfront.net","*.compute.amazonaws.com","*.compute-1.amazonaws.com","*.compute.amazonaws.com.cn","us-east-1.amazonaws.com","cn-north-1.eb.amazonaws.com.cn","cn-northwest-1.eb.amazonaws.com.cn","elasticbeanstalk.com","ap-northeast-1.elasticbeanstalk.com","ap-northeast-2.elasticbeanstalk.com","ap-northeast-3.elasticbeanstalk.com","ap-south-1.elasticbeanstalk.com","ap-southeast-1.elasticbeanstalk.com","ap-southeast-2.elasticbeanstalk.com","ca-central-1.elasticbeanstalk.com","eu-central-1.elasticbeanstalk.com","eu-west-1.elasticbeanstalk.com","eu-west-2.elasticbeanstalk.com","eu-west-3.elasticbeanstalk.com","sa-east-1.elasticbeanstalk.com","us-east-1.elasticbeanstalk.com","us-east-2.elasticbeanstalk.com","us-gov-west-1.elasticbeanstalk.com","us-west-1.elasticbeanstalk.com","us-west-2.elasticbeanstalk.com","*.elb.amazonaws.com","*.elb.amazonaws.com.cn","s3.amazonaws.com","s3-ap-northeast-1.amazonaws.com","s3-ap-northeast-2.amazonaws.com","s3-ap-south-1.amazonaws.com","s3-ap-southeast-1.amazonaws.com","s3-ap-southeast-2.amazonaws.com","s3-ca-central-1.amazonaws.com","s3-eu-central-1.amazonaws.com","s3-eu-west-1.amazonaws.com","s3-eu-west-2.amazonaws.com","s3-eu-west-3.amazonaws.com","s3-external-1.amazonaws.com","s3-fips-us-gov-west-1.amazonaws.com","s3-sa-east-1.amazonaws.com","s3-us-gov-west-1.amazonaws.com","s3-us-east-2.amazonaws.com","s3-us-west-1.amazonaws.com","s3-us-west-2.amazonaws.com","s3.ap-northeast-2.amazonaws.com","s3.ap-south-1.amazonaws.com","s3.cn-north-1.amazonaws.com.cn","s3.ca-central-1.amazonaws.com","s3.eu-central-1.amazonaws.com","s3.eu-west-2.amazonaws.com","s3.eu-west-3.amazonaws.com","s3.us-east-2.amazonaws.com","s3.dualstack.ap-northeast-1.amazonaws.com","s3.dualstack.ap-northeast-2.amazonaws.com","s3.dualstack.ap-south-1.amazonaws.com","s3.dualstack.ap-southeast-1.amazonaws.com","s3.dualstack.ap-southeast-2.amazonaws.com","s3.dualstack.ca-central-1.amazonaws.com","s3.dualstack.eu-central-1.amazonaws.com","s3.dualstack.eu-west-1.amazonaws.com","s3.dualstack.eu-west-2.amazonaws.com","s3.dualstack.eu-west-3.amazonaws.com","s3.dualstack.sa-east-1.amazonaws.com","s3.dualstack.us-east-1.amazonaws.com","s3.dualstack.us-east-2.amazonaws.com","s3-website-us-east-1.amazonaws.com","s3-website-us-west-1.amazonaws.com","s3-website-us-west-2.amazonaws.com","s3-website-ap-northeast-1.amazonaws.com","s3-website-ap-southeast-1.amazonaws.com","s3-website-ap-southeast-2.amazonaws.com","s3-website-eu-west-1.amazonaws.com","s3-website-sa-east-1.amazonaws.com","s3-website.ap-northeast-2.amazonaws.com","s3-website.ap-south-1.amazonaws.com","s3-website.ca-central-1.amazonaws.com","s3-website.eu-central-1.amazonaws.com","s3-website.eu-west-2.amazonaws.com","s3-website.eu-west-3.amazonaws.com","s3-website.us-east-2.amazonaws.com","t3l3p0rt.net","tele.amune.org","apigee.io","on-aptible.com","user.aseinet.ne.jp","gv.vc","d.gv.vc","user.party.eus","pimienta.org","poivron.org","potager.org","sweetpepper.org","myasustor.com","go-vip.co","go-vip.net","wpcomstaging.com","myfritz.net","*.awdev.ca","*.advisor.ws","b-data.io","backplaneapp.io","balena-devices.com","app.banzaicloud.io","betainabox.com","bnr.la","blackbaudcdn.net","boomla.net","boxfuse.io","square7.ch","bplaced.com","bplaced.de","square7.de","bplaced.net","square7.net","browsersafetymark.io","uk0.bigv.io","dh.bytemark.co.uk","vm.bytemark.co.uk","mycd.eu","carrd.co","crd.co","uwu.ai","ae.org","ar.com","br.com","cn.com","com.de","com.se","de.com","eu.com","gb.com","gb.net","hu.com","hu.net","jp.net","jpn.com","kr.com","mex.com","no.com","qc.com","ru.com","sa.com","se.net","uk.com","uk.net","us.com","uy.com","za.bz","za.com","africa.com","gr.com","in.net","us.org","co.com","c.la","certmgr.org","xenapponazure.com","discourse.group","virtueeldomein.nl","cleverapps.io","*.lcl.dev","*.stg.dev","c66.me","cloud66.ws","cloud66.zone","jdevcloud.com","wpdevcloud.com","cloudaccess.host","freesite.host","cloudaccess.net","cloudcontrolled.com","cloudcontrolapp.com","cloudera.site","trycloudflare.com","workers.dev","wnext.app","co.ca","*.otap.co","co.cz","c.cdn77.org","cdn77-ssl.net","r.cdn77.net","rsc.cdn77.org","ssl.origin.cdn77-secure.org","cloudns.asia","cloudns.biz","cloudns.club","cloudns.cc","cloudns.eu","cloudns.in","cloudns.info","cloudns.org","cloudns.pro","cloudns.pw","cloudns.us","cloudeity.net","cnpy.gdn","co.nl","co.no","webhosting.be","hosting-cluster.nl","dyn.cosidns.de","dynamisches-dns.de","dnsupdater.de","internet-dns.de","l-o-g-i-n.de","dynamic-dns.info","feste-ip.net","knx-server.net","static-access.net","realm.cz","*.cryptonomic.net","cupcake.is","cyon.link","cyon.site","daplie.me","localhost.daplie.me","dattolocal.com","dattorelay.com","dattoweb.com","mydatto.com","dattolocal.net","mydatto.net","biz.dk","co.dk","firm.dk","reg.dk","store.dk","*.dapps.earth","*.bzz.dapps.earth","debian.net","dedyn.io","dnshome.de","online.th","shop.th","drayddns.com","dreamhosters.com","mydrobo.com","drud.io","drud.us","duckdns.org","dy.fi","tunk.org","dyndns-at-home.com","dyndns-at-work.com","dyndns-blog.com","dyndns-free.com","dyndns-home.com","dyndns-ip.com","dyndns-mail.com","dyndns-office.com","dyndns-pics.com","dyndns-remote.com","dyndns-server.com","dyndns-web.com","dyndns-wiki.com","dyndns-work.com","dyndns.biz","dyndns.info","dyndns.org","dyndns.tv","at-band-camp.net","ath.cx","barrel-of-knowledge.info","barrell-of-knowledge.info","better-than.tv","blogdns.com","blogdns.net","blogdns.org","blogsite.org","boldlygoingnowhere.org","broke-it.net","buyshouses.net","cechire.com","dnsalias.com","dnsalias.net","dnsalias.org","dnsdojo.com","dnsdojo.net","dnsdojo.org","does-it.net","doesntexist.com","doesntexist.org","dontexist.com","dontexist.net","dontexist.org","doomdns.com","doomdns.org","dvrdns.org","dyn-o-saur.com","dynalias.com","dynalias.net","dynalias.org","dynathome.net","dyndns.ws","endofinternet.net","endofinternet.org","endoftheinternet.org","est-a-la-maison.com","est-a-la-masion.com","est-le-patron.com","est-mon-blogueur.com","for-better.biz","for-more.biz","for-our.info","for-some.biz","for-the.biz","forgot.her.name","forgot.his.name","from-ak.com","from-al.com","from-ar.com","from-az.net","from-ca.com","from-co.net","from-ct.com","from-dc.com","from-de.com","from-fl.com","from-ga.com","from-hi.com","from-ia.com","from-id.com","from-il.com","from-in.com","from-ks.com","from-ky.com","from-la.net","from-ma.com","from-md.com","from-me.org","from-mi.com","from-mn.com","from-mo.com","from-ms.com","from-mt.com","from-nc.com","from-nd.com","from-ne.com","from-nh.com","from-nj.com","from-nm.com","from-nv.com","from-ny.net","from-oh.com","from-ok.com","from-or.com","from-pa.com","from-pr.com","from-ri.com","from-sc.com","from-sd.com","from-tn.com","from-tx.com","from-ut.com","from-va.com","from-vt.com","from-wa.com","from-wi.com","from-wv.com","from-wy.com","ftpaccess.cc","fuettertdasnetz.de","game-host.org","game-server.cc","getmyip.com","gets-it.net","go.dyndns.org","gotdns.com","gotdns.org","groks-the.info","groks-this.info","ham-radio-op.net","here-for-more.info","hobby-site.com","hobby-site.org","home.dyndns.org","homedns.org","homeftp.net","homeftp.org","homeip.net","homelinux.com","homelinux.net","homelinux.org","homeunix.com","homeunix.net","homeunix.org","iamallama.com","in-the-band.net","is-a-anarchist.com","is-a-blogger.com","is-a-bookkeeper.com","is-a-bruinsfan.org","is-a-bulls-fan.com","is-a-candidate.org","is-a-caterer.com","is-a-celticsfan.org","is-a-chef.com","is-a-chef.net","is-a-chef.org","is-a-conservative.com","is-a-cpa.com","is-a-cubicle-slave.com","is-a-democrat.com","is-a-designer.com","is-a-doctor.com","is-a-financialadvisor.com","is-a-geek.com","is-a-geek.net","is-a-geek.org","is-a-green.com","is-a-guru.com","is-a-hard-worker.com","is-a-hunter.com","is-a-knight.org","is-a-landscaper.com","is-a-lawyer.com","is-a-liberal.com","is-a-libertarian.com","is-a-linux-user.org","is-a-llama.com","is-a-musician.com","is-a-nascarfan.com","is-a-nurse.com","is-a-painter.com","is-a-patsfan.org","is-a-personaltrainer.com","is-a-photographer.com","is-a-player.com","is-a-republican.com","is-a-rockstar.com","is-a-socialist.com","is-a-soxfan.org","is-a-student.com","is-a-teacher.com","is-a-techie.com","is-a-therapist.com","is-an-accountant.com","is-an-actor.com","is-an-actress.com","is-an-anarchist.com","is-an-artist.com","is-an-engineer.com","is-an-entertainer.com","is-by.us","is-certified.com","is-found.org","is-gone.com","is-into-anime.com","is-into-cars.com","is-into-cartoons.com","is-into-games.com","is-leet.com","is-lost.org","is-not-certified.com","is-saved.org","is-slick.com","is-uberleet.com","is-very-bad.org","is-very-evil.org","is-very-good.org","is-very-nice.org","is-very-sweet.org","is-with-theband.com","isa-geek.com","isa-geek.net","isa-geek.org","isa-hockeynut.com","issmarterthanyou.com","isteingeek.de","istmein.de","kicks-ass.net","kicks-ass.org","knowsitall.info","land-4-sale.us","lebtimnetz.de","leitungsen.de","likes-pie.com","likescandy.com","merseine.nu","mine.nu","misconfused.org","mypets.ws","myphotos.cc","neat-url.com","office-on-the.net","on-the-web.tv","podzone.net","podzone.org","readmyblog.org","saves-the-whales.com","scrapper-site.net","scrapping.cc","selfip.biz","selfip.com","selfip.info","selfip.net","selfip.org","sells-for-less.com","sells-for-u.com","sells-it.net","sellsyourhome.org","servebbs.com","servebbs.net","servebbs.org","serveftp.net","serveftp.org","servegame.org","shacknet.nu","simple-url.com","space-to-rent.com","stuff-4-sale.org","stuff-4-sale.us","teaches-yoga.com","thruhere.net","traeumtgerade.de","webhop.biz","webhop.info","webhop.net","webhop.org","worse-than.tv","writesthisblog.com","ddnss.de","dyn.ddnss.de","dyndns.ddnss.de","dyndns1.de","dyn-ip24.de","home-webserver.de","dyn.home-webserver.de","myhome-server.de","ddnss.org","definima.net","definima.io","bci.dnstrace.pro","ddnsfree.com","ddnsgeek.com","giize.com","gleeze.com","kozow.com","loseyourip.com","ooguy.com","theworkpc.com","casacam.net","dynu.net","accesscam.org","camdvr.org","freeddns.org","mywire.org","webredirect.org","myddns.rocks","blogsite.xyz","dynv6.net","e4.cz","mytuleap.com","onred.one","staging.onred.one","enonic.io","customer.enonic.io","eu.org","al.eu.org","asso.eu.org","at.eu.org","au.eu.org","be.eu.org","bg.eu.org","ca.eu.org","cd.eu.org","ch.eu.org","cn.eu.org","cy.eu.org","cz.eu.org","de.eu.org","dk.eu.org","edu.eu.org","ee.eu.org","es.eu.org","fi.eu.org","fr.eu.org","gr.eu.org","hr.eu.org","hu.eu.org","ie.eu.org","il.eu.org","in.eu.org","int.eu.org","is.eu.org","it.eu.org","jp.eu.org","kr.eu.org","lt.eu.org","lu.eu.org","lv.eu.org","mc.eu.org","me.eu.org","mk.eu.org","mt.eu.org","my.eu.org","net.eu.org","ng.eu.org","nl.eu.org","no.eu.org","nz.eu.org","paris.eu.org","pl.eu.org","pt.eu.org","q-a.eu.org","ro.eu.org","ru.eu.org","se.eu.org","si.eu.org","sk.eu.org","tr.eu.org","uk.eu.org","us.eu.org","eu-1.evennode.com","eu-2.evennode.com","eu-3.evennode.com","eu-4.evennode.com","us-1.evennode.com","us-2.evennode.com","us-3.evennode.com","us-4.evennode.com","twmail.cc","twmail.net","twmail.org","mymailer.com.tw","url.tw","apps.fbsbx.com","ru.net","adygeya.ru","bashkiria.ru","bir.ru","cbg.ru","com.ru","dagestan.ru","grozny.ru","kalmykia.ru","kustanai.ru","marine.ru","mordovia.ru","msk.ru","mytis.ru","nalchik.ru","nov.ru","pyatigorsk.ru","spb.ru","vladikavkaz.ru","vladimir.ru","abkhazia.su","adygeya.su","aktyubinsk.su","arkhangelsk.su","armenia.su","ashgabad.su","azerbaijan.su","balashov.su","bashkiria.su","bryansk.su","bukhara.su","chimkent.su","dagestan.su","east-kazakhstan.su","exnet.su","georgia.su","grozny.su","ivanovo.su","jambyl.su","kalmykia.su","kaluga.su","karacol.su","karaganda.su","karelia.su","khakassia.su","krasnodar.su","kurgan.su","kustanai.su","lenug.su","mangyshlak.su","mordovia.su","msk.su","murmansk.su","nalchik.su","navoi.su","north-kazakhstan.su","nov.su","obninsk.su","penza.su","pokrovsk.su","sochi.su","spb.su","tashkent.su","termez.su","togliatti.su","troitsk.su","tselinograd.su","tula.su","tuva.su","vladikavkaz.su","vladimir.su","vologda.su","channelsdvr.net","fastly-terrarium.com","fastlylb.net","map.fastlylb.net","freetls.fastly.net","map.fastly.net","a.prod.fastly.net","global.prod.fastly.net","a.ssl.fastly.net","b.ssl.fastly.net","global.ssl.fastly.net","fastpanel.direct","fastvps-server.com","fhapp.xyz","fedorainfracloud.org","fedorapeople.org","cloud.fedoraproject.org","app.os.fedoraproject.org","app.os.stg.fedoraproject.org","mydobiss.com","filegear.me","filegear-au.me","filegear-de.me","filegear-gb.me","filegear-ie.me","filegear-jp.me","filegear-sg.me","firebaseapp.com","flynnhub.com","flynnhosting.net","freebox-os.com","freeboxos.com","fbx-os.fr","fbxos.fr","freebox-os.fr","freeboxos.fr","freedesktop.org","*.futurecms.at","*.ex.futurecms.at","*.in.futurecms.at","futurehosting.at","futuremailing.at","*.ex.ortsinfo.at","*.kunden.ortsinfo.at","*.statics.cloud","service.gov.uk","gehirn.ne.jp","usercontent.jp","lab.ms","github.io","githubusercontent.com","gitlab.io","glitch.me","cloudapps.digital","london.cloudapps.digital","homeoffice.gov.uk","ro.im","shop.ro","goip.de","run.app","a.run.app","web.app","*.0emm.com","appspot.com","blogspot.ae","blogspot.al","blogspot.am","blogspot.ba","blogspot.be","blogspot.bg","blogspot.bj","blogspot.ca","blogspot.cf","blogspot.ch","blogspot.cl","blogspot.co.at","blogspot.co.id","blogspot.co.il","blogspot.co.ke","blogspot.co.nz","blogspot.co.uk","blogspot.co.za","blogspot.com","blogspot.com.ar","blogspot.com.au","blogspot.com.br","blogspot.com.by","blogspot.com.co","blogspot.com.cy","blogspot.com.ee","blogspot.com.eg","blogspot.com.es","blogspot.com.mt","blogspot.com.ng","blogspot.com.tr","blogspot.com.uy","blogspot.cv","blogspot.cz","blogspot.de","blogspot.dk","blogspot.fi","blogspot.fr","blogspot.gr","blogspot.hk","blogspot.hr","blogspot.hu","blogspot.ie","blogspot.in","blogspot.is","blogspot.it","blogspot.jp","blogspot.kr","blogspot.li","blogspot.lt","blogspot.lu","blogspot.md","blogspot.mk","blogspot.mr","blogspot.mx","blogspot.my","blogspot.nl","blogspot.no","blogspot.pe","blogspot.pt","blogspot.qa","blogspot.re","blogspot.ro","blogspot.rs","blogspot.ru","blogspot.se","blogspot.sg","blogspot.si","blogspot.sk","blogspot.sn","blogspot.td","blogspot.tw","blogspot.ug","blogspot.vn","cloudfunctions.net","cloud.goog","codespot.com","googleapis.com","googlecode.com","pagespeedmobilizer.com","publishproxy.com","withgoogle.com","withyoutube.com","fin.ci","free.hr","caa.li","ua.rs","conf.se","hs.zone","hs.run","hashbang.sh","hasura.app","hasura-app.io","hepforge.org","herokuapp.com","herokussl.com","myravendb.com","ravendb.community","ravendb.me","development.run","ravendb.run","bpl.biz","orx.biz","ng.city","biz.gl","ng.ink","col.ng","firm.ng","gen.ng","ltd.ng","ng.school","sch.so","häkkinen.fi","*.moonscale.io","moonscale.net","iki.fi","dyn-berlin.de","in-berlin.de","in-brb.de","in-butter.de","in-dsl.de","in-dsl.net","in-dsl.org","in-vpn.de","in-vpn.net","in-vpn.org","biz.at","info.at","info.cx","ac.leg.br","al.leg.br","am.leg.br","ap.leg.br","ba.leg.br","ce.leg.br","df.leg.br","es.leg.br","go.leg.br","ma.leg.br","mg.leg.br","ms.leg.br","mt.leg.br","pa.leg.br","pb.leg.br","pe.leg.br","pi.leg.br","pr.leg.br","rj.leg.br","rn.leg.br","ro.leg.br","rr.leg.br","rs.leg.br","sc.leg.br","se.leg.br","sp.leg.br","to.leg.br","pixolino.com","ipifony.net","mein-iserv.de","test-iserv.de","iserv.dev","iobb.net","myjino.ru","*.hosting.myjino.ru","*.landing.myjino.ru","*.spectrum.myjino.ru","*.vps.myjino.ru","*.triton.zone","*.cns.joyent.com","js.org","kaas.gg","khplay.nl","keymachine.de","kinghost.net","uni5.net","knightpoint.systems","co.krd","edu.krd","git-repos.de","lcube-server.de","svn-repos.de","leadpages.co","lpages.co","lpusercontent.com","lelux.site","co.business","co.education","co.events","co.financial","co.network","co.place","co.technology","app.lmpm.com","linkitools.space","linkyard.cloud","linkyard-cloud.ch","members.linode.com","nodebalancer.linode.com","we.bs","loginline.app","loginline.dev","loginline.io","loginline.services","loginline.site","krasnik.pl","leczna.pl","lubartow.pl","lublin.pl","poniatowa.pl","swidnik.pl","uklugs.org","glug.org.uk","lug.org.uk","lugs.org.uk","barsy.bg","barsy.co.uk","barsyonline.co.uk","barsycenter.com","barsyonline.com","barsy.club","barsy.de","barsy.eu","barsy.in","barsy.info","barsy.io","barsy.me","barsy.menu","barsy.mobi","barsy.net","barsy.online","barsy.org","barsy.pro","barsy.pub","barsy.shop","barsy.site","barsy.support","barsy.uk","*.magentosite.cloud","mayfirst.info","mayfirst.org","hb.cldmail.ru","miniserver.com","memset.net","cloud.metacentrum.cz","custom.metacentrum.cz","flt.cloud.muni.cz","usr.cloud.muni.cz","meteorapp.com","eu.meteorapp.com","co.pl","azurecontainer.io","azurewebsites.net","azure-mobile.net","cloudapp.net","mozilla-iot.org","bmoattachments.org","net.ru","org.ru","pp.ru","ui.nabu.casa","pony.club","of.fashion","on.fashion","of.football","in.london","of.london","for.men","and.mom","for.mom","for.one","for.sale","of.work","to.work","nctu.me","bitballoon.com","netlify.com","4u.com","ngrok.io","nh-serv.co.uk","nfshost.com","dnsking.ch","mypi.co","n4t.co","001www.com","ddnslive.com","myiphost.com","forumz.info","16-b.it","32-b.it","64-b.it","soundcast.me","tcp4.me","dnsup.net","hicam.net","now-dns.net","ownip.net","vpndns.net","dynserv.org","now-dns.org","x443.pw","now-dns.top","ntdll.top","freeddns.us","crafting.xyz","zapto.xyz","nsupdate.info","nerdpol.ovh","blogsyte.com","brasilia.me","cable-modem.org","ciscofreak.com","collegefan.org","couchpotatofries.org","damnserver.com","ddns.me","ditchyourip.com","dnsfor.me","dnsiskinky.com","dvrcam.info","dynns.com","eating-organic.net","fantasyleague.cc","geekgalaxy.com","golffan.us","health-carereform.com","homesecuritymac.com","homesecuritypc.com","hopto.me","ilovecollege.info","loginto.me","mlbfan.org","mmafan.biz","myactivedirectory.com","mydissent.net","myeffect.net","mymediapc.net","mypsx.net","mysecuritycamera.com","mysecuritycamera.net","mysecuritycamera.org","net-freaks.com","nflfan.org","nhlfan.net","no-ip.ca","no-ip.co.uk","no-ip.net","noip.us","onthewifi.com","pgafan.net","point2this.com","pointto.us","privatizehealthinsurance.net","quicksytes.com","read-books.org","securitytactics.com","serveexchange.com","servehumour.com","servep2p.com","servesarcasm.com","stufftoread.com","ufcfan.org","unusualperson.com","workisboring.com","3utilities.com","bounceme.net","ddns.net","ddnsking.com","gotdns.ch","hopto.org","myftp.biz","myftp.org","myvnc.com","no-ip.biz","no-ip.info","no-ip.org","noip.me","redirectme.net","servebeer.com","serveblog.net","servecounterstrike.com","serveftp.com","servegame.com","servehalflife.com","servehttp.com","serveirc.com","serveminecraft.net","servemp3.com","servepics.com","servequake.com","sytes.net","webhop.me","zapto.org","stage.nodeart.io","nodum.co","nodum.io","pcloud.host","nyc.mn","nom.ae","nom.af","nom.ai","nom.al","nym.by","nym.bz","nom.cl","nym.ec","nom.gd","nom.ge","nom.gl","nym.gr","nom.gt","nym.gy","nym.hk","nom.hn","nym.ie","nom.im","nom.ke","nym.kz","nym.la","nym.lc","nom.li","nym.li","nym.lt","nym.lu","nym.me","nom.mk","nym.mn","nym.mx","nom.nu","nym.nz","nym.pe","nym.pt","nom.pw","nom.qa","nym.ro","nom.rs","nom.si","nym.sk","nom.st","nym.su","nym.sx","nom.tj","nym.tw","nom.ug","nom.uy","nom.vc","nom.vg","cya.gg","cloudycluster.net","nid.io","opencraft.hosting","operaunite.com","outsystemscloud.com","ownprovider.com","own.pm","ox.rs","oy.lc","pgfog.com","pagefrontapp.com","art.pl","gliwice.pl","krakow.pl","poznan.pl","wroc.pl","zakopane.pl","pantheonsite.io","gotpantheon.com","mypep.link","on-web.fr","*.platform.sh","*.platformsh.site","dyn53.io","co.bn","xen.prgmr.com","priv.at","prvcy.page","*.dweb.link","protonet.io","chirurgiens-dentistes-en-france.fr","byen.site","pubtls.org","qualifioapp.com","instantcloud.cn","ras.ru","qa2.com","dev-myqnapcloud.com","alpha-myqnapcloud.com","myqnapcloud.com","*.quipelements.com","vapor.cloud","vaporcloud.io","rackmaze.com","rackmaze.net","*.on-rancher.cloud","*.on-rio.io","readthedocs.io","rhcloud.com","app.render.com","onrender.com","repl.co","repl.run","resindevice.io","devices.resinstaging.io","hzc.io","wellbeingzone.eu","ptplus.fit","wellbeingzone.co.uk","git-pages.rit.edu","sandcats.io","logoip.de","logoip.com","schokokeks.net","scrysec.com","firewall-gateway.com","firewall-gateway.de","my-gateway.de","my-router.de","spdns.de","spdns.eu","firewall-gateway.net","my-firewall.org","myfirewall.org","spdns.org","biz.ua","co.ua","pp.ua","shiftedit.io","myshopblocks.com","shopitsite.com","mo-siemens.io","1kapp.com","appchizi.com","applinzi.com","sinaapp.com","vipsinaapp.com","siteleaf.net","bounty-full.com","alpha.bounty-full.com","beta.bounty-full.com","stackhero-network.com","static.land","dev.static.land","sites.static.land","apps.lair.io","*.stolos.io","spacekit.io","customer.speedpartner.de","api.stdlib.com","storj.farm","utwente.io","soc.srcf.net","user.srcf.net","temp-dns.com","applicationcloud.io","scapp.io","*.s5y.io","*.sensiosite.cloud","syncloud.it","diskstation.me","dscloud.biz","dscloud.me","dscloud.mobi","dsmynas.com","dsmynas.net","dsmynas.org","familyds.com","familyds.net","familyds.org","i234.me","myds.me","synology.me","vpnplus.to","direct.quickconnect.to","taifun-dns.de","gda.pl","gdansk.pl","gdynia.pl","med.pl","sopot.pl","edugit.org","telebit.app","telebit.io","*.telebit.xyz","gwiddle.co.uk","thingdustdata.com","cust.dev.thingdust.io","cust.disrec.thingdust.io","cust.prod.thingdust.io","cust.testing.thingdust.io","arvo.network","azimuth.network","bloxcms.com","townnews-staging.com","12hp.at","2ix.at","4lima.at","lima-city.at","12hp.ch","2ix.ch","4lima.ch","lima-city.ch","trafficplex.cloud","de.cool","12hp.de","2ix.de","4lima.de","lima-city.de","1337.pictures","clan.rip","lima-city.rocks","webspace.rocks","lima.zone","*.transurl.be","*.transurl.eu","*.transurl.nl","tuxfamily.org","dd-dns.de","diskstation.eu","diskstation.org","dray-dns.de","draydns.de","dyn-vpn.de","dynvpn.de","mein-vigor.de","my-vigor.de","my-wan.de","syno-ds.de","synology-diskstation.de","synology-ds.de","uber.space","*.uberspace.de","hk.com","hk.org","ltd.hk","inc.hk","virtualuser.de","virtual-user.de","lib.de.us","2038.io","router.management","v-info.info","voorloper.cloud","wafflecell.com","*.webhare.dev","wedeploy.io","wedeploy.me","wedeploy.sh","remotewd.com","wmflabs.org","half.host","xnbay.com","u2.xnbay.com","u2-local.xnbay.com","cistron.nl","demon.nl","xs4all.space","yandexcloud.net","storage.yandexcloud.net","website.yandexcloud.net","official.academy","yolasite.com","ybo.faith","yombo.me","homelink.one","ybo.party","ybo.review","ybo.science","ybo.trade","nohost.me","noho.st","za.net","za.org","now.sh","bss.design","basicserver.io","virtualserver.io","site.builder.nu","enterprisecloud.nu","zone.id"]

/***/ }),
/* 2475 */
/***/ (function(module, exports) {

	module.exports = {"_args":[["tough-cookie@2.4.3","/var/www/www.kundan.no/public_html"]],"_from":"tough-cookie@2.4.3","_id":"tough-cookie@2.4.3","_inBundle":false,"_integrity":"sha512-Q5srk/4vDM54WJsJio3XNn6K2sCG+CQ8G5Wz6bZhRZoAe/+TxjWB/GlFAnYEbkYVlON9FMk/fE3h2RLpPXo4lQ==","_location":"/tough-cookie","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"tough-cookie@2.4.3","name":"tough-cookie","escapedName":"tough-cookie","rawSpec":"2.4.3","saveSpec":null,"fetchSpec":"2.4.3"},"_requiredBy":["/request"],"_resolved":"https://registry.npmjs.org/tough-cookie/-/tough-cookie-2.4.3.tgz","_spec":"2.4.3","_where":"/var/www/www.kundan.no/public_html","author":{"name":"Jeremy Stashewsky","email":"jstash@gmail.com"},"bugs":{"url":"https://github.com/salesforce/tough-cookie/issues"},"contributors":[{"name":"Alexander Savin"},{"name":"Ian Livingstone"},{"name":"Ivan Nikulin"},{"name":"Lalit Kapoor"},{"name":"Sam Thompson"},{"name":"Sebastian Mayr"}],"dependencies":{"psl":"^1.1.24","punycode":"^1.4.1"},"description":"RFC6265 Cookies and Cookie Jar for node.js","devDependencies":{"async":"^1.4.2","nyc":"^11.6.0","string.prototype.repeat":"^0.2.0","vows":"^0.8.1"},"engines":{"node":">=0.8"},"files":["lib"],"homepage":"https://github.com/salesforce/tough-cookie","keywords":["HTTP","cookie","cookies","set-cookie","cookiejar","jar","RFC6265","RFC2965"],"license":"BSD-3-Clause","main":"./lib/cookie","name":"tough-cookie","repository":{"type":"git","url":"git://github.com/salesforce/tough-cookie.git"},"scripts":{"cover":"nyc --reporter=lcov --reporter=html vows test/*_test.js","test":"vows test/*_test.js"},"version":"2.4.3"}

/***/ }),
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */,
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */,
/* 2510 */,
/* 2511 */,
/* 2512 */,
/* 2513 */,
/* 2514 */,
/* 2515 */,
/* 2516 */,
/* 2517 */,
/* 2518 */,
/* 2519 */,
/* 2520 */,
/* 2521 */,
/* 2522 */,
/* 2523 */,
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */,
/* 2528 */,
/* 2529 */,
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */,
/* 2536 */,
/* 2537 */,
/* 2538 */,
/* 2539 */,
/* 2540 */,
/* 2541 */,
/* 2542 */,
/* 2543 */,
/* 2544 */,
/* 2545 */,
/* 2546 */,
/* 2547 */,
/* 2548 */,
/* 2549 */,
/* 2550 */,
/* 2551 */,
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 603,
		"./af.js": 603,
		"./ar": 610,
		"./ar-dz": 604,
		"./ar-dz.js": 604,
		"./ar-kw": 605,
		"./ar-kw.js": 605,
		"./ar-ly": 606,
		"./ar-ly.js": 606,
		"./ar-ma": 607,
		"./ar-ma.js": 607,
		"./ar-sa": 608,
		"./ar-sa.js": 608,
		"./ar-tn": 609,
		"./ar-tn.js": 609,
		"./ar.js": 610,
		"./az": 611,
		"./az.js": 611,
		"./be": 612,
		"./be.js": 612,
		"./bg": 613,
		"./bg.js": 613,
		"./bm": 614,
		"./bm.js": 614,
		"./bn": 616,
		"./bn-bd": 615,
		"./bn-bd.js": 615,
		"./bn.js": 616,
		"./bo": 617,
		"./bo.js": 617,
		"./br": 618,
		"./br.js": 618,
		"./bs": 619,
		"./bs.js": 619,
		"./ca": 620,
		"./ca.js": 620,
		"./cs": 621,
		"./cs.js": 621,
		"./cv": 622,
		"./cv.js": 622,
		"./cy": 623,
		"./cy.js": 623,
		"./da": 624,
		"./da.js": 624,
		"./de": 627,
		"./de-at": 625,
		"./de-at.js": 625,
		"./de-ch": 626,
		"./de-ch.js": 626,
		"./de.js": 627,
		"./dv": 628,
		"./dv.js": 628,
		"./el": 629,
		"./el.js": 629,
		"./en-au": 630,
		"./en-au.js": 630,
		"./en-ca": 631,
		"./en-ca.js": 631,
		"./en-gb": 632,
		"./en-gb.js": 632,
		"./en-ie": 633,
		"./en-ie.js": 633,
		"./en-il": 634,
		"./en-il.js": 634,
		"./en-in": 635,
		"./en-in.js": 635,
		"./en-nz": 636,
		"./en-nz.js": 636,
		"./en-sg": 637,
		"./en-sg.js": 637,
		"./eo": 638,
		"./eo.js": 638,
		"./es": 642,
		"./es-do": 639,
		"./es-do.js": 639,
		"./es-mx": 640,
		"./es-mx.js": 640,
		"./es-us": 641,
		"./es-us.js": 641,
		"./es.js": 642,
		"./et": 643,
		"./et.js": 643,
		"./eu": 644,
		"./eu.js": 644,
		"./fa": 645,
		"./fa.js": 645,
		"./fi": 646,
		"./fi.js": 646,
		"./fil": 647,
		"./fil.js": 647,
		"./fo": 648,
		"./fo.js": 648,
		"./fr": 651,
		"./fr-ca": 649,
		"./fr-ca.js": 649,
		"./fr-ch": 650,
		"./fr-ch.js": 650,
		"./fr.js": 651,
		"./fy": 652,
		"./fy.js": 652,
		"./ga": 653,
		"./ga.js": 653,
		"./gd": 654,
		"./gd.js": 654,
		"./gl": 655,
		"./gl.js": 655,
		"./gom-deva": 656,
		"./gom-deva.js": 656,
		"./gom-latn": 657,
		"./gom-latn.js": 657,
		"./gu": 658,
		"./gu.js": 658,
		"./he": 659,
		"./he.js": 659,
		"./hi": 660,
		"./hi.js": 660,
		"./hr": 661,
		"./hr.js": 661,
		"./hu": 662,
		"./hu.js": 662,
		"./hy-am": 663,
		"./hy-am.js": 663,
		"./id": 664,
		"./id.js": 664,
		"./is": 665,
		"./is.js": 665,
		"./it": 667,
		"./it-ch": 666,
		"./it-ch.js": 666,
		"./it.js": 667,
		"./ja": 668,
		"./ja.js": 668,
		"./jv": 669,
		"./jv.js": 669,
		"./ka": 670,
		"./ka.js": 670,
		"./kk": 671,
		"./kk.js": 671,
		"./km": 672,
		"./km.js": 672,
		"./kn": 673,
		"./kn.js": 673,
		"./ko": 674,
		"./ko.js": 674,
		"./ku": 675,
		"./ku.js": 675,
		"./ky": 676,
		"./ky.js": 676,
		"./lb": 677,
		"./lb.js": 677,
		"./lo": 678,
		"./lo.js": 678,
		"./lt": 679,
		"./lt.js": 679,
		"./lv": 680,
		"./lv.js": 680,
		"./me": 681,
		"./me.js": 681,
		"./mi": 682,
		"./mi.js": 682,
		"./mk": 683,
		"./mk.js": 683,
		"./ml": 684,
		"./ml.js": 684,
		"./mn": 685,
		"./mn.js": 685,
		"./mr": 686,
		"./mr.js": 686,
		"./ms": 688,
		"./ms-my": 687,
		"./ms-my.js": 687,
		"./ms.js": 688,
		"./mt": 689,
		"./mt.js": 689,
		"./my": 690,
		"./my.js": 690,
		"./nb": 691,
		"./nb.js": 691,
		"./ne": 692,
		"./ne.js": 692,
		"./nl": 694,
		"./nl-be": 693,
		"./nl-be.js": 693,
		"./nl.js": 694,
		"./nn": 695,
		"./nn.js": 695,
		"./oc-lnc": 696,
		"./oc-lnc.js": 696,
		"./pa-in": 697,
		"./pa-in.js": 697,
		"./pl": 698,
		"./pl.js": 698,
		"./pt": 700,
		"./pt-br": 699,
		"./pt-br.js": 699,
		"./pt.js": 700,
		"./ro": 701,
		"./ro.js": 701,
		"./ru": 702,
		"./ru.js": 702,
		"./sd": 703,
		"./sd.js": 703,
		"./se": 704,
		"./se.js": 704,
		"./si": 705,
		"./si.js": 705,
		"./sk": 706,
		"./sk.js": 706,
		"./sl": 707,
		"./sl.js": 707,
		"./sq": 708,
		"./sq.js": 708,
		"./sr": 710,
		"./sr-cyrl": 709,
		"./sr-cyrl.js": 709,
		"./sr.js": 710,
		"./ss": 711,
		"./ss.js": 711,
		"./sv": 712,
		"./sv.js": 712,
		"./sw": 713,
		"./sw.js": 713,
		"./ta": 714,
		"./ta.js": 714,
		"./te": 715,
		"./te.js": 715,
		"./tet": 716,
		"./tet.js": 716,
		"./tg": 717,
		"./tg.js": 717,
		"./th": 718,
		"./th.js": 718,
		"./tk": 719,
		"./tk.js": 719,
		"./tl-ph": 720,
		"./tl-ph.js": 720,
		"./tlh": 721,
		"./tlh.js": 721,
		"./tr": 722,
		"./tr.js": 722,
		"./tzl": 723,
		"./tzl.js": 723,
		"./tzm": 725,
		"./tzm-latn": 724,
		"./tzm-latn.js": 724,
		"./tzm.js": 725,
		"./ug-cn": 726,
		"./ug-cn.js": 726,
		"./uk": 727,
		"./uk.js": 727,
		"./ur": 728,
		"./ur.js": 728,
		"./uz": 730,
		"./uz-latn": 729,
		"./uz-latn.js": 729,
		"./uz.js": 730,
		"./vi": 731,
		"./vi.js": 731,
		"./x-pseudo": 732,
		"./x-pseudo.js": 732,
		"./yo": 733,
		"./yo.js": 733,
		"./zh-cn": 734,
		"./zh-cn.js": 734,
		"./zh-hk": 735,
		"./zh-hk.js": 735,
		"./zh-mo": 736,
		"./zh-mo.js": 736,
		"./zh-tw": 737,
		"./zh-tw.js": 737
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2592;


/***/ }),
/* 2593 */,
/* 2594 */,
/* 2595 */,
/* 2596 */,
/* 2597 */,
/* 2598 */,
/* 2599 */,
/* 2600 */,
/* 2601 */,
/* 2602 */,
/* 2603 */,
/* 2604 */,
/* 2605 */,
/* 2606 */,
/* 2607 */,
/* 2608 */,
/* 2609 */,
/* 2610 */,
/* 2611 */,
/* 2612 */,
/* 2613 */,
/* 2614 */,
/* 2615 */,
/* 2616 */,
/* 2617 */,
/* 2618 */,
/* 2619 */,
/* 2620 */,
/* 2621 */,
/* 2622 */,
/* 2623 */,
/* 2624 */,
/* 2625 */,
/* 2626 */,
/* 2627 */,
/* 2628 */,
/* 2629 */,
/* 2630 */,
/* 2631 */,
/* 2632 */,
/* 2633 */,
/* 2634 */,
/* 2635 */,
/* 2636 */,
/* 2637 */,
/* 2638 */,
/* 2639 */,
/* 2640 */,
/* 2641 */,
/* 2642 */,
/* 2643 */,
/* 2644 */,
/* 2645 */,
/* 2646 */,
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/client.ea8c588.jpg";

/***/ }),
/* 2648 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2649 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/user-avatar.c641e26.jpg";

/***/ }),
/* 2651 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2652 */,
/* 2653 */,
/* 2654 */,
/* 2655 */,
/* 2656 */,
/* 2657 */,
/* 2658 */,
/* 2659 */,
/* 2660 */,
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1731),
	  /* template */
	  __webpack_require__(3093),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1732),
	  /* template */
	  __webpack_require__(2936),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1733),
	  /* template */
	  __webpack_require__(3113),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1734),
	  /* template */
	  __webpack_require__(3075),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1735),
	  /* template */
	  __webpack_require__(2953),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1736),
	  /* template */
	  __webpack_require__(3006),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1737),
	  /* template */
	  __webpack_require__(3067),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1738),
	  /* template */
	  __webpack_require__(2918),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2309)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1739),
	  /* template */
	  __webpack_require__(2980),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2300)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1740),
	  /* template */
	  __webpack_require__(2956),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1741),
	  /* template */
	  __webpack_require__(3109),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1742),
	  /* template */
	  __webpack_require__(3002),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2344)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1744),
	  /* template */
	  __webpack_require__(3037),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1745),
	  /* template */
	  __webpack_require__(2893),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2322)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1746),
	  /* template */
	  __webpack_require__(3001),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1747),
	  /* template */
	  __webpack_require__(3045),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2321)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1748),
	  /* template */
	  __webpack_require__(2999),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2293)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1750),
	  /* template */
	  __webpack_require__(2948),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1751),
	  /* template */
	  __webpack_require__(3112),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2398)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1752),
	  /* template */
	  __webpack_require__(3137),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2364)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1753),
	  /* template */
	  __webpack_require__(3065),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2339)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1755),
	  /* template */
	  __webpack_require__(3032),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2354)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1756),
	  /* template */
	  __webpack_require__(3051),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2282)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1757),
	  /* template */
	  __webpack_require__(2927),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-193e156b",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2394)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1758),
	  /* template */
	  __webpack_require__(3133),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1759),
	  /* template */
	  __webpack_require__(2967),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1761),
	  /* template */
	  __webpack_require__(2966),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2346)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1763),
	  /* template */
	  __webpack_require__(3039),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2264)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1764),
	  /* template */
	  __webpack_require__(2889),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-0072a12a",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1766),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2281)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1767),
	  /* template */
	  __webpack_require__(2925),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1768),
	  /* template */
	  __webpack_require__(2973),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1769),
	  /* template */
	  __webpack_require__(3125),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1771),
	  /* template */
	  __webpack_require__(3119),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2274)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1772),
	  /* template */
	  __webpack_require__(2911),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2316)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1773),
	  /* template */
	  __webpack_require__(2993),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1775),
	  /* template */
	  __webpack_require__(3040),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1777),
	  /* template */
	  __webpack_require__(3089),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1778),
	  /* template */
	  __webpack_require__(3072),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2311)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1780),
	  /* template */
	  __webpack_require__(2984),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2299)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1782),
	  /* template */
	  __webpack_require__(2955),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-2dbf005b",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2315)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1783),
	  /* template */
	  __webpack_require__(2991),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-4a0d2ecb",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1786),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2704 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1787),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1788),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2348)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1791),
	  /* template */
	  null,
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2284)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1794),
	  /* template */
	  null,
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1795),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1797),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1801),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1805),
	  /* template */
	  __webpack_require__(2976),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2374)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1806),
	  /* template */
	  __webpack_require__(3095),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1807),
	  /* template */
	  __webpack_require__(3018),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2371)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1808),
	  /* template */
	  __webpack_require__(3083),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2385)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1809),
	  /* template */
	  __webpack_require__(3117),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1810),
	  /* template */
	  __webpack_require__(2904),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2384)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1811),
	  /* template */
	  __webpack_require__(3116),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2353)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1812),
	  /* template */
	  __webpack_require__(3050),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2308)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1814),
	  /* template */
	  __webpack_require__(2979),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1818),
	  /* template */
	  __webpack_require__(2914),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2721 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2317)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1819),
	  /* template */
	  __webpack_require__(2994),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1821),
	  /* template */
	  __webpack_require__(2964),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2723 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2263)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1822),
	  /* template */
	  __webpack_require__(2888),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2724 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1823),
	  /* template */
	  __webpack_require__(3059),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2375)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1825),
	  /* template */
	  __webpack_require__(3099),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2336)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1827),
	  /* template */
	  __webpack_require__(3026),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2272)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1828),
	  /* template */
	  __webpack_require__(2908),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1829),
	  /* template */
	  __webpack_require__(3049),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1830),
	  /* template */
	  __webpack_require__(2970),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1831),
	  /* template */
	  __webpack_require__(2932),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2332)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1832),
	  /* template */
	  __webpack_require__(3021),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2295)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1833),
	  /* template */
	  __webpack_require__(2950),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2357)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1835),
	  /* template */
	  __webpack_require__(3054),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2337)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1836),
	  /* template */
	  __webpack_require__(3027),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1839),
	  /* template */
	  __webpack_require__(3012),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1840),
	  /* template */
	  __webpack_require__(3082),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2388)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1841),
	  /* template */
	  __webpack_require__(3124),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2287)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1842),
	  /* template */
	  __webpack_require__(2935),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1843),
	  /* template */
	  __webpack_require__(3107),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1844),
	  /* template */
	  __webpack_require__(3122),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2373)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1846),
	  /* template */
	  __webpack_require__(3092),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2320)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1848),
	  /* template */
	  __webpack_require__(2998),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2355)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1849),
	  /* template */
	  __webpack_require__(3052),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1850),
	  /* template */
	  __webpack_require__(3088),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1851),
	  /* template */
	  __webpack_require__(2894),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2349)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1852),
	  /* template */
	  __webpack_require__(3043),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2747 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2267)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1853),
	  /* template */
	  __webpack_require__(2899),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2270)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1854),
	  /* template */
	  __webpack_require__(2905),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2296)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1855),
	  /* template */
	  __webpack_require__(2951),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-2c27b827",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2328)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1856),
	  /* template */
	  __webpack_require__(3014),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2365)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1857),
	  /* template */
	  __webpack_require__(3066),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2292)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1858),
	  /* template */
	  __webpack_require__(2944),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2345)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1859),
	  /* template */
	  __webpack_require__(3038),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2754 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2289)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1860),
	  /* template */
	  __webpack_require__(2941),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1861),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2301)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1863),
	  /* template */
	  __webpack_require__(2958),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2757 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2313)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1864),
	  /* template */
	  __webpack_require__(2986),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2298)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1719),
	  /* template */
	  __webpack_require__(2954),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2335)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1866),
	  /* template */
	  __webpack_require__(3025),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2760 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1867),
	  /* template */
	  __webpack_require__(2920),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2761 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2386)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1868),
	  /* template */
	  __webpack_require__(3118),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2762 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2372)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1869),
	  /* template */
	  __webpack_require__(3085),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1870),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2764 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2303)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1871),
	  /* template */
	  __webpack_require__(2961),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2266)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1720),
	  /* template */
	  __webpack_require__(2896),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-0588d2c2",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2766 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1872),
	  /* template */
	  __webpack_require__(3016),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2273)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1873),
	  /* template */
	  __webpack_require__(2910),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-0c78f358",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2768 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1874),
	  /* template */
	  __webpack_require__(3121),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1875),
	  /* template */
	  __webpack_require__(3102),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2770 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1876),
	  /* template */
	  __webpack_require__(3100),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1877),
	  /* template */
	  __webpack_require__(3069),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2378)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1878),
	  /* template */
	  __webpack_require__(3104),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-a7b97d42",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1879),
	  /* template */
	  __webpack_require__(2975),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2774 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1880),
	  /* template */
	  __webpack_require__(3074),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2775 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2288)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1881),
	  /* template */
	  __webpack_require__(2940),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-23ae5b59",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2776 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2302)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1882),
	  /* template */
	  __webpack_require__(2959),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-310197d3",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2777 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2334)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1721),
	  /* template */
	  __webpack_require__(3023),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2778 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1883),
	  /* template */
	  __webpack_require__(3097),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2291)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1885),
	  /* template */
	  __webpack_require__(2943),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-23f75817",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2382)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1886),
	  /* template */
	  __webpack_require__(3111),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-b8790806",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2781 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1887),
	  /* template */
	  __webpack_require__(2913),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1888),
	  /* template */
	  __webpack_require__(3132),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1889),
	  /* template */
	  __webpack_require__(3139),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2367)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1890),
	  /* template */
	  __webpack_require__(3078),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2785 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1891),
	  /* template */
	  __webpack_require__(2902),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1892),
	  /* template */
	  __webpack_require__(3000),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1894),
	  /* template */
	  __webpack_require__(2924),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2788 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2390)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1896),
	  /* template */
	  __webpack_require__(3126),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2280)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1897),
	  /* template */
	  __webpack_require__(2922),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2392)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1898),
	  /* template */
	  __webpack_require__(3129),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2310)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1900),
	  /* template */
	  __webpack_require__(2981),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1901),
	  /* template */
	  __webpack_require__(2962),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2401)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1903),
	  /* template */
	  __webpack_require__(3142),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-fdff3ae0",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2794 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2359)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1904),
	  /* template */
	  __webpack_require__(3056),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-6eb34d38",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2795 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1905),
	  /* template */
	  __webpack_require__(3079),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2796 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1906),
	  /* template */
	  __webpack_require__(3028),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2797 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2307)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1908),
	  /* template */
	  __webpack_require__(2978),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-3f2c8546",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2798 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1909),
	  /* template */
	  __webpack_require__(3011),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2799 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1910),
	  /* template */
	  __webpack_require__(3131),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2370)
	  __webpack_require__(2369)
	  __webpack_require__(2368)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1911),
	  /* template */
	  __webpack_require__(3080),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-7f00b5ec",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2318)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1912),
	  /* template */
	  __webpack_require__(2996),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2802 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2283)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1913),
	  /* template */
	  __webpack_require__(2928),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2803 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2343)
	  __webpack_require__(2342)
	  __webpack_require__(2341)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1914),
	  /* template */
	  __webpack_require__(3036),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-61f69bc1",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2804 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1915),
	  /* template */
	  __webpack_require__(2903),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2805 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2396)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1916),
	  /* template */
	  __webpack_require__(3135),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2806 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2347)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1917),
	  /* template */
	  __webpack_require__(3041),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-659b6778",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2807 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1722),
	  /* template */
	  __webpack_require__(2987),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2808 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1918),
	  /* template */
	  __webpack_require__(3096),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2809 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1919),
	  /* template */
	  __webpack_require__(3031),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2810 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1920),
	  /* template */
	  __webpack_require__(2916),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2811 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2297)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1921),
	  /* template */
	  __webpack_require__(2952),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2812 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1922),
	  /* template */
	  __webpack_require__(3076),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2813 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2286)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1924),
	  /* template */
	  __webpack_require__(2930),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2814 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1927),
	  /* template */
	  __webpack_require__(2892),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2815 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1928),
	  /* template */
	  __webpack_require__(2971),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2816 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1929),
	  /* template */
	  __webpack_require__(2982),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2817 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1930),
	  /* template */
	  __webpack_require__(3084),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2818 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2330)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1931),
	  /* template */
	  __webpack_require__(3017),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-5733d2cc",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2819 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2312)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1932),
	  /* template */
	  __webpack_require__(2985),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-44385ccc",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2820 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2269)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1933),
	  /* template */
	  __webpack_require__(2901),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-07847f80",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2821 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1934),
	  /* template */
	  __webpack_require__(3042),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2822 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1935),
	  /* template */
	  __webpack_require__(3007),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2823 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1936),
	  /* template */
	  __webpack_require__(3019),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2824 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1937),
	  /* template */
	  __webpack_require__(3128),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2825 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1938),
	  /* template */
	  __webpack_require__(2946),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2826 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1939),
	  /* template */
	  __webpack_require__(2974),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1940),
	  /* template */
	  __webpack_require__(3003),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2828 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2351)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1941),
	  /* template */
	  __webpack_require__(3047),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-6a19c52e",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2829 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1943),
	  /* template */
	  __webpack_require__(3141),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2830 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1944),
	  /* template */
	  __webpack_require__(2938),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2831 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1945),
	  /* template */
	  __webpack_require__(3098),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2832 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1947),
	  /* template */
	  __webpack_require__(3091),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2833 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1948),
	  /* template */
	  __webpack_require__(2963),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2834 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1949),
	  /* template */
	  __webpack_require__(3120),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2835 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1950),
	  /* template */
	  __webpack_require__(2933),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2836 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1951),
	  /* template */
	  __webpack_require__(2895),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2837 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1952),
	  /* template */
	  __webpack_require__(2960),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2838 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1953),
	  /* template */
	  __webpack_require__(2926),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2839 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1954),
	  /* template */
	  __webpack_require__(3090),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2840 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2362)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1955),
	  /* template */
	  __webpack_require__(3063),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2841 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2305)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1956),
	  /* template */
	  __webpack_require__(2969),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-3759488f",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2842 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2329)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1957),
	  /* template */
	  __webpack_require__(3015),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2843 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1958),
	  /* template */
	  __webpack_require__(2891),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2844 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1959),
	  /* template */
	  __webpack_require__(3029),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2845 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1960),
	  /* template */
	  __webpack_require__(3058),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2846 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1961),
	  /* template */
	  __webpack_require__(2945),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2847 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1962),
	  /* template */
	  __webpack_require__(3115),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2848 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1963),
	  /* template */
	  __webpack_require__(2934),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2849 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2363)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1964),
	  /* template */
	  __webpack_require__(3064),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2850 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1965),
	  /* template */
	  __webpack_require__(3005),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2851 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2358)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1966),
	  /* template */
	  __webpack_require__(3055),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-6e4b3e86",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2852 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2276)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1967),
	  /* template */
	  __webpack_require__(2915),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-107da22c",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2853 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1968),
	  /* template */
	  __webpack_require__(3077),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2854 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1969),
	  /* template */
	  __webpack_require__(2988),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2855 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1970),
	  /* template */
	  __webpack_require__(3094),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2856 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2304)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1972),
	  /* template */
	  __webpack_require__(2965),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-3456bed4",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2857 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2379)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1973),
	  /* template */
	  __webpack_require__(3105),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1974),
	  /* template */
	  __webpack_require__(2906),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2859 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1975),
	  /* template */
	  __webpack_require__(3086),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2860 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2350)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1976),
	  /* template */
	  __webpack_require__(3044),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-686f41c7",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1723),
	  /* template */
	  __webpack_require__(3073),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1977),
	  /* template */
	  __webpack_require__(2947),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2863 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2395)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1978),
	  /* template */
	  __webpack_require__(3134),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2277)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1979),
	  /* template */
	  __webpack_require__(2917),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1980),
	  /* template */
	  __webpack_require__(2897),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1981),
	  /* template */
	  __webpack_require__(2939),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1982),
	  /* template */
	  __webpack_require__(2937),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1983),
	  /* template */
	  __webpack_require__(3068),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2265)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1984),
	  /* template */
	  __webpack_require__(2890),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-0088be12",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1985),
	  /* template */
	  __webpack_require__(3087),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1724),
	  /* template */
	  __webpack_require__(2977),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2327)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1986),
	  /* template */
	  __webpack_require__(3013),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-5561f962",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2873 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1987),
	  /* template */
	  __webpack_require__(3127),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2874 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2275)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1988),
	  /* template */
	  __webpack_require__(2912),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-0e8e4116",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2875 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2399)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1989),
	  /* template */
	  __webpack_require__(3138),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1990),
	  /* template */
	  __webpack_require__(2931),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1991),
	  /* template */
	  __webpack_require__(2995),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2878 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2380)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1992),
	  /* template */
	  __webpack_require__(3108),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-b595efd8",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2879 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1725),
	  /* template */
	  __webpack_require__(2992),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1993),
	  /* template */
	  __webpack_require__(2968),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2881 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2271)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1994),
	  /* template */
	  __webpack_require__(2907),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2882 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2356)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1995),
	  /* template */
	  __webpack_require__(3053),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-6dbda9f4",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1726),
	  /* template */
	  __webpack_require__(3033),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2884 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1727),
	  /* template */
	  __webpack_require__(2990),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2885 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2340)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1728),
	  /* template */
	  __webpack_require__(3034),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2886 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1729),
	  /* template */
	  __webpack_require__(3035),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2887 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(2314)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(1730),
	  /* template */
	  __webpack_require__(2989),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2888 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('i', {
	    staticClass: "el-dialog__close el-icon el-icon-close align-right",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }), _vm._v(" "), _c('div', [_c('ol', _vm._l((_vm.allWidgets), function(widget, index) {
	    return _c('li', [_c('h2', [_vm._v(_vm._s(widget.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(widget.desc))]), _vm._v(" "), _c('el-button', {
	      staticClass: "btn-add-widgets el-button el-small",
	      attrs: {
	        "disabled": widget.disable
	      },
	      on: {
	        "click": function($event) {
	          return _vm.addWidget(widget, index)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('static.accountInformation.addWidgetBtn')))])], 1)
	  }), 0)])])
	},staticRenderFns: []}

/***/ }),
/* 2889 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('static.clientAddress.edit.title')))]), _vm._v(" "), (!_vm.loading) ? _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 24
	    }
	  }, [(_vm.clientAddresses) ? _c('el-collapse', {
	    model: {
	      value: (_vm.clientAddressNames),
	      callback: function($$v) {
	        _vm.clientAddressNames = $$v
	      },
	      expression: "clientAddressNames"
	    }
	  }, _vm._l((_vm.clientAddresses), function(address, index) {
	    return _c('el-collapse-item', {
	      key: address.id,
	      attrs: {
	        "title": _vm.$t(("form.addressTypes.options." + (_vm.camelize(address.name)))),
	        "name": address.name
	      }
	    }, [_c('v-client-address', {
	      attrs: {
	        "id": address.id,
	        "name": address.name,
	        "errors": _vm.getAddressFieldErrors(address.id),
	        "data": address,
	        "countries": _vm.countries.items,
	        "municipalities": _vm.municipalities.items
	      },
	      on: {
	        "update": function($event) {
	          _vm.clientAddresses[index] = $event
	        }
	      }
	    })], 1)
	  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "margin-t-10"
	  }, [_c('el-button', {
	    staticClass: "small dark",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)], 1) : _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2890 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.supplier.index.title')) + " (" + _vm._s(_vm.suppliers.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('el-button-group', [_c('el-button', {
	    attrs: {
	      "type": _vm.primary,
	      "size": "small",
	      "icon": "el-icon-menu",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('info')
	      }
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": _vm.info,
	      "size": "small",
	      "icon": "el-icon-tickets",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('primary')
	      }
	    }
	  })], 1), _vm._v(" "), _c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  })], 1)])], 1), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.suppliers.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.supplier.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'supplier.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.supplier.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.suppliers.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      attrs: {
	        "wide": true
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editSupplier(p)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-external-link pull-right",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.editSupplierNewTab(p)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "full-w flex wrap client-title-container margin-b-10"
	    }, [_c('img', {
	      staticClass: "client-img margin-b-10",
	      attrs: {
	        "src": __webpack_require__(2647),
	        "alt": ("$" + (p.name))
	      }
	    }), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(((p.number) + " - " + (p.name))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.supplier.info.name')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.name || '-'))])], _c('br'), _vm._v(" "), (p.contact.phonenumber || p.contact.mobilenumber) ? [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.supplier.info.phone')) + " ")]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.contact.phonenumber))]), _vm._v("\n            " + _vm._s((p.contact.phonenumber && p.contact.mobilenumber) ? ' / ' : '') + "\n            "), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.contact.mobilenumber))]), _c('br')] : _vm._e(), _vm._v(" "), _c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.supplier.info.email')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.contact.email || '-'))]), _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.supplier.info.streetName1')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.address.streetName1 || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.supplier.info.city')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.address.city.name || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.supplier.info.country')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.address.country.name || '-'))])], _c('br')], 2)
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('v-table', {
	    attrs: {
	      "list": _vm.suppliersListView,
	      "noDataMessage": _vm.$t('static.defaultText.supplier.noDataMsg'),
	      "link": _vm.editSupplier,
	      "linkKey": "number",
	      "rowKey": "id",
	      "translation": "static.supplier.table"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.suppliers.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2891 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 12
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.products.syncVmp.title')) + "\n      ")])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": _vm.tabIndex
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.products.formTabs.syncDetails'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [
	    [_c('div', {
	      staticStyle: {
	        "text-align": "center"
	      }
	    }, [_c('h2', {
	      staticClass: "margin-b-20",
	      staticStyle: {
	        "color": "#5d5959"
	      }
	    }, [_c('b', [_vm._v("Vinmonopolet Produkt API")])]), _vm._v(" "), _c('el-button', {
	      staticClass: "small margin-b-20",
	      attrs: {
	        "loading": _vm.syncLoading
	      },
	      on: {
	        "click": function($event) {
	          return _vm.startSync(true)
	        }
	      }
	    }, [_vm._v("\n                " + _vm._s(_vm.$t('button.fetchFromVmp').toUpperCase())), _c('br'), _vm._v(" "), _c('small', [(_vm.syncDate) ? _c('span', {
	      staticStyle: {
	        "color": "#2b4437",
	        "display": "block",
	        "margin-top": "4px",
	        "text-weight": "bold"
	      }
	    }, [_vm._v("(Sist oppdatert: " + _vm._s(_vm.syncDate) + ")")]) : _vm._e()])])], 1), _vm._v(" "), (_vm.products.forUpdate.length) ? _c('h3', [_vm._v("\n              " + _vm._s(_vm.$t('static.products.syncVmp.existingProducts')) + "\n              "), _c('b', [_vm._v("(" + _vm._s(_vm.products.forUpdate.length) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.products.forUpdate.length) ? _c('el-table', {
	      staticStyle: {
	        "width": "100%",
	        "margin-bottom": "30px"
	      },
	      attrs: {
	        "data": _vm.products.forUpdate,
	        "max-height": "400"
	      },
	      on: {
	        "selection-change": _vm.handleExistingProductsSelectionChange
	      }
	    }, [_c('el-table-column', {
	      attrs: {
	        "type": "selection"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "vmp",
	        "label": _vm.$t('form.products.vmp.label'),
	        "width": "100"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "name",
	        "label": _vm.$t('form.products.name.label'),
	        "min-width": "180"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "vintage",
	        "label": _vm.$t('form.products.vintage.label'),
	        "width": "100"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "gtin",
	        "label": _vm.$t('form.products.gtin.label'),
	        "width": "150"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "alcoholPercentage",
	        "label": _vm.$t('form.products.alcoholPercentage.label'),
	        "width": "100"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "bottleVolume",
	        "label": _vm.$t('form.products.bottle_volume.label'),
	        "width": "120"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "ddpVmp",
	        "label": _vm.$t('form.products.ddpVmp.label'),
	        "width": "100"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "lastChanged",
	        "label": _vm.$t('form.products.lastChanged.label'),
	        "width": "150"
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (_vm.products.forInsert.length) ? _c('h3', [_vm._v("\n              " + _vm._s(_vm.$t('static.products.syncVmp.newProducts')) + "\n              "), _c('b', [_vm._v("(" + _vm._s(_vm.products.forInsert.length) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.products.forInsert.length) ? _c('el-table', {
	      staticStyle: {
	        "width": "100%",
	        "margin-bottom": "30px"
	      },
	      attrs: {
	        "data": _vm.products.forInsert,
	        "max-height": "400"
	      },
	      on: {
	        "selection-change": _vm.handleNewProductsSelectionChange
	      }
	    }, [_c('el-table-column', {
	      attrs: {
	        "type": "selection"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "vmp",
	        "label": _vm.$t('form.products.vmp.label'),
	        "width": "100"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "name",
	        "label": _vm.$t('form.products.name.label'),
	        "min-width": "180"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "vintage",
	        "label": _vm.$t('form.products.vintage.label'),
	        "width": "100"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "gtin",
	        "label": _vm.$t('form.products.gtin.label'),
	        "width": "150"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "alcoholPercentage",
	        "label": _vm.$t('form.products.alcoholPercentage.label'),
	        "width": "100"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "bottleVolume",
	        "label": _vm.$t('form.products.bottle_volume.label'),
	        "width": "120"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "ddpVmp",
	        "label": _vm.$t('form.products.ddpVmp.label'),
	        "width": "100"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "lastChanged",
	        "label": _vm.$t('form.products.lastChanged.label'),
	        "width": "150"
	      }
	    })], 1) : _vm._e()], _vm._v(" "), _c('div', {
	      staticClass: "flex",
	      staticStyle: {
	        "justify-content": "center"
	      }
	    }, [(_vm.products.forUpdate.length || _vm.products.forInsert.length) ? _c('el-button', {
	      staticClass: "small margin-b-20",
	      attrs: {
	        "loading": _vm.syncLoading,
	        "disabled": !(_vm.newProductsSelection.length || _vm.existingProductsSelection.length)
	      },
	      on: {
	        "click": _vm.processSync
	      }
	    }, [_vm._v("\n              " + _vm._s(_vm.$t('button.confirmSync').toUpperCase()))]) : _vm._e()], 1)
	  ], 2)], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2892 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.priceFields.create.title')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.priceFields.formTabs.tagInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.priceFields",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'priceFields.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2893 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-alert', {
	    staticClass: "margin-b-20",
	    staticStyle: {
	      "margin-top": "15px"
	    },
	    attrs: {
	      "title": "",
	      "type": "error",
	      "closable": false
	    }
	  }, [_vm._t("default", [_c('p', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('ul', _vm._l((_vm.materials), function(material) {
	    return _c('li', {
	      key: material.id
	    }, [_vm._v("\n          " + _vm._s(material.name) + " (" + _vm._s(_vm.$t('table.recipeIngrediences.amount.label')) + ":" + _vm._s(material.needed_qty) + ") - " + _vm._s(_vm.$t('static.stock.products.currentCount')) + ": " + _vm._s(material.current_qty) + "\n        ")])
	  }), 0)])], 2), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "flex-direction": "column"
	    }
	  }, _vm._l((_vm.buttons), function(button) {
	    return _c('el-button', {
	      staticClass: "margin-b-20",
	      staticStyle: {
	        "width": "380px"
	      },
	      on: {
	        "click": button.action
	      }
	    }, [_vm._v("\n      " + _vm._s(button.name) + "\n  ")])
	  }), 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2894 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.vmpDataList,
	      "show-header": false
	    }
	  }, [_c('el-table-column', {
	    staticStyle: {
	      "padding": "5px 2px"
	    },
	    attrs: {
	      "prop": "label",
	      "label": "Field"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "value",
	      "label": "Value"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "flex margin-t-10",
	    staticStyle: {
	      "justify-content": "center",
	      "margin-top": "30px"
	    }
	  }, [_c('el-button', {
	    staticClass: "margin-b-20",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.confirmSync($event)
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.syncData')) + "\n  ")])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', [_vm._v("Result from "), _c('u', [_c('b', [_vm._v("Vinmonopolet")])])])
	}]}

/***/ }),
/* 2895 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.productTags.edit.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.productTags.formTabs.tagInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.productTags",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productTags.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2896 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content home-wrapper"
	  }, [_c('div', {
	    staticClass: "content-inner"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex-column"
	  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.message) + "\n      ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "buttons_login",
	    attrs: {
	      "to": {
	        name: 'auth.login'
	      }
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "color": "black"
	    },
	    attrs: {
	      "type": "primary"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.enter')))])], 1), _c('br'), _c('br')], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', {
	    staticClass: "title"
	  }, [_c('img', {
	    attrs: {
	      "height": "100",
	      "src": __webpack_require__(181)
	    }
	  })])
	}]}

/***/ }),
/* 2897 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.subscriberList.index.title')) + " (" + _vm._s(_vm.subscriberList.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, _vm._l((_vm.subscriberList.items), function(c, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.edit(c.id)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel"
	    }, [_c('span', {
	      staticClass: "cardBadge"
	    }, [_vm._v(_vm._s(_vm.$t('static.subscriberList.index.topInfo')))])]), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(c.name))]), _vm._v(" "), _c('span', {
	      staticClass: "cardLabel"
	    }, [_c('span', {
	      staticStyle: {
	        "font-weight": "bolder"
	      }
	    }, [_vm._v(_vm._s(_vm.$t('static.subscriberList.index.fromName')))]), _vm._v(" " + _vm._s(c.fromName))]), _c('br'), _vm._v(" "), _c('span', {
	      staticClass: "cardLabel"
	    }, [_c('span', {
	      staticStyle: {
	        "font-weight": "bolder"
	      }
	    }, [_vm._v(_vm._s(_vm.$t('static.subscriberList.index.fromEmail')))]), _vm._v(" " + _vm._s(c.fromEmail))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	      staticClass: "cardinnerBox"
	    }, [_c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-info",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent cardContent--small"
	    }, [_vm._v("\n              " + _vm._s(_vm.$t('static.subscriberList.index.emailCount')) + ": " + _vm._s(c.emailCount) + "\n            ")])])])])
	  }), 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [(_vm.subscriberList.length > 0) ? _c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "pagination": _vm.subscriberList.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1) : _vm._e()])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2898 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle",
	    class: {
	      'pageTitle--dark': !_vm.isInOwnRoute
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.productGroups.create.title')))])])], 1), _vm._v(" "), _c('div', {
	    class: {
	      'whiteWrapper': _vm.isInOwnRoute
	    }
	  }, [(_vm.isInOwnRoute) ? _c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.productGroups.formTabs.groupInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.productGroups",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1) : _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.productGroups",
	      "hasLabel": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [(_vm.isInOwnRoute) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productGroups.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
	    class: {
	      'outline': _vm.isInOwnRoute
	    },
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2899 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.products.syncVmp.packagingPopupTitle')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('div', [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.products.syncVmp.packagingPopupTitle')))]), _vm._v(" "), (_vm.products.length) ? _c('el-table', {
	    staticStyle: {
	      "width": "100%",
	      "margin-bottom": "30px"
	    },
	    attrs: {
	      "data": _vm.products,
	      "max-height": "400"
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "vmp",
	      "label": _vm.$t('form.products.vmp.label'),
	      "width": "100"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": _vm.$t('form.products.name.label'),
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "alcoholPercentage",
	      "label": _vm.$t('form.products.alcoholPercentage.label')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "bottleVolume",
	      "label": _vm.$t('form.products.bottleVolume.label')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Packaging",
	      "width": "300"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          staticClass: "flex"
	        }, [_c('el-select', {
	          attrs: {
	            "placeholder": "Select Packaging"
	          },
	          on: {
	            "change": function($event) {
	              return _vm.onUpdatePackaging(scope.row)
	            }
	          },
	          model: {
	            value: (scope.row.productPackagingId),
	            callback: function($$v) {
	              _vm.$set(scope.row, "productPackagingId", $$v)
	            },
	            expression: "scope.row.productPackagingId"
	          }
	        }, _vm._l((_vm.productPackagings.all), function(packaging) {
	          return (packaging.id) ? _c('el-option', {
	            key: packaging.id,
	            attrs: {
	              "label": packaging.name,
	              "value": packaging.id
	            }
	          }) : _vm._e()
	        }), 1), _vm._v(" "), _c('el-button', {
	          staticClass: "margin-l-10",
	          attrs: {
	            "type": "primary",
	            "icon": "el-icon-plus",
	            "circle": ""
	          },
	          on: {
	            "click": function($event) {
	              $event.preventDefault();
	              return _vm.addNewPackaging(scope.row)
	            }
	          }
	        })], 1)]
	      }
	    }], null, false, 1525779534)
	  })], 1) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [_c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "disabled": !!_vm.hasProductWithNoPackaging,
	      "loading": _vm.loading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.confirm($event)
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.continue').toUpperCase()))])], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2900 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "point-content--card",
	    class: _vm.appointment.orderStatus
	  }, [_c('div', {
	    staticClass: "full-w flex space-between margin-b-10"
	  }, [_c('span', [_vm._v(_vm._s(_vm.getTimeRange(_vm.appointment)) + " " + _vm._s(_vm.appointment.orderStatus === 'cancelled' ? ("(" + (_vm.appointment.orderStatus) + ")") : ''))]), _vm._v(" "), (_vm.edit && _vm.appointment.orderStatus !== 'cancelled') ? _c('a', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.edit(_vm.appointment)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.edit')))]) : _c('div', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex"
	  }, [_c('span', {
	    staticClass: "point-content--client"
	  }, [_vm._v(_vm._s(_vm.appointment.clientName) + ", " + _vm._s(_vm.appointment.serviceName))])]), _vm._v(" "), (_vm.fade) ? _c('div', {
	    staticClass: "point-content--fade full-w"
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2901 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('div', {
	    staticClass: "pricing-agreements-toolbar"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10,
	      "type": "flex",
	      "align": "middle"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle pricing-agreements-toolbar__title"
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('pricingAgreements.titleWithCount', {
	    count: _vm.pagination.totalCount
	  })))])])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pricing-agreement-options"
	  }, [_c('div', {
	    staticClass: "pricing-agreement-options__group pricing-agreement-options__view"
	  }, [_c('el-button-group', {
	    staticClass: "client-view-type pricing-agreement-options__view-toggle"
	  }, [_c('el-button', {
	    attrs: {
	      "type": _vm.primary,
	      "size": "small",
	      "icon": "el-icon-menu",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('info')
	      }
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": _vm.info,
	      "size": "small",
	      "icon": "el-icon-tickets",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('primary')
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('span', {
	    staticClass: "pricing-agreement-options__divider",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pricing-agreement-options__group pricing-agreement-options__filters"
	  }, [_c('v-text', {
	    staticClass: "searchForm pricing-agreement-options__search",
	    attrs: {
	      "name": "searchQuery",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.searchQuery,
	      "clearable": true
	    },
	    on: {
	      "keydown": _vm.onChangeSearch
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "pricing-agreement-options__sort-wrap"
	  }, [_c('label', {
	    staticClass: "pricing-agreement-options__sort-label"
	  }, [_vm._v(_vm._s(_vm.$t('sort.title')))]), _vm._v(" "), _c('v-select', {
	    staticClass: "sort pricing-agreement-options__sort",
	    attrs: {
	      "name": "sort",
	      "options": _vm.sortTypes,
	      "value": _vm.sort
	    },
	    on: {
	      "change": _vm.onChangeSort
	    }
	  })], 1)], 1), _vm._v(" "), _c('span', {
	    staticClass: "pricing-agreement-options__divider",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pricing-agreement-options__group pricing-agreement-options__actions"
	  }, [_c('el-button', {
	    staticClass: "pricing-agreement-options__import",
	    on: {
	      "click": function($event) {
	        _vm.showImportDialog = true
	      }
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('pricingAgreements.importFromTemplate')) + "\n            ")]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'pricingAgreements.create'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "pricing-agreement-options__new",
	    attrs: {
	      "type": "primary"
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('pricingAgreements.newAgreement')))])], 1)], 1)])])], 1)], 1), _vm._v(" "), (_vm.info === 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.sortedFilteredItems.length === 0) ? _c('v-no-data', [(_vm.items.length === 0) ? [_vm._v(_vm._s(_vm.$t('pricingAgreements.noAgreements')))] : [_vm._v(_vm._s(_vm.$t('pricingAgreements.noAgreementsMatchSearch')))], _vm._v(" "), (_vm.items.length === 0) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'pricingAgreements.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v(_vm._s(_vm.$t('pricingAgreements.createOne')))])], 1) : _vm._e(), _vm._v(" "), (_vm.items.length === 0) ? [_vm._v(" " + _vm._s(_vm.$t('pricingAgreements.orImportLink')) + " "), _c('a', {
	    attrs: {
	      "href": "javascript:void(0)"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showImportDialog = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.importFromTemplateLink')))]), _vm._v(".")] : _vm._e()], 2) : _vm._l((_vm.paginatedItems), function(a, i) {
	    return _c('v-card', {
	      key: a.id || i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.goToEdit(a)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel w-full"
	    }, [_c('span', {
	      class: ['cardBadge', (a.is_active === true) ? 'card-green' : 'card-red']
	    }, [_vm._v(_vm._s((a.is_active === true) ? _vm.$t('pricingAgreements.active') : _vm.$t('pricingAgreements.inactive')))]), _vm._v(" "), _c('span', {
	      staticClass: "pull-right"
	    }, [_c('i', {
	      staticClass: "fa fa-external-link",
	      staticStyle: {
	        "cursor": "pointer",
	        "margin-right": "8px"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.editInNewTab(a)
	        }
	      }
	    }), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-trash-o",
	      class: {
	        'loading': _vm.deletingId === a.id
	      },
	      staticStyle: {
	        "cursor": "pointer",
	        "color": "#f56c6c"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.deleteAgreement(a)
	        }
	      }
	    })])]), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(a.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.customer')) + ": ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(a.client && a.client.name ? a.client.name : '–'))]), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "margin-top": "8px"
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.valid')) + ": ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(a.valid_from) + " – " + _vm._s(a.valid_to))])]), _vm._v(" "), (a.lines && a.lines.length) ? _c('div', {
	      staticClass: "cardinnerBox",
	      staticStyle: {
	        "margin-top": "10px"
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.lineCount', {
	      n: a.lines.length
	    })))])]) : _vm._e()])
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary === 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : (_vm.sortedFilteredItems.length === 0) ? _c('v-no-data', [(_vm.items.length === 0) ? [_vm._v(_vm._s(_vm.$t('pricingAgreements.noAgreements')))] : [_vm._v(_vm._s(_vm.$t('pricingAgreements.noAgreementsMatchSearch')))], _vm._v(" "), (_vm.items.length === 0) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'pricingAgreements.create'
	      }
	    }
	  }, [_vm._v("\n         "), _c('el-button', [_vm._v(_vm._s(_vm.$t('pricingAgreements.createOne')))])], 1) : _vm._e()], 2) : _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.paginatedItems
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.name'),
	      "min-width": "180"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('a', {
	          on: {
	            "click": function($event) {
	              $event.preventDefault();
	              return _vm.goToEdit(scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(scope.row.name))])]
	      }
	    }], null, false, 1477792497)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.customer'),
	      "prop": "client.name",
	      "min-width": "160"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v(_vm._s(scope.row.client && scope.row.client.name ? scope.row.client.name : '–'))]
	      }
	    }], null, false, 894730354)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.validFrom'),
	      "prop": "valid_from",
	      "width": "110"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.validTo'),
	      "prop": "valid_to",
	      "width": "110"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('layouts.sidebar.active'),
	      "width": "100"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          class: [(scope.row.is_active === true) ? 'card-green' : 'card-red'],
	          staticStyle: {
	            "padding": "2px 8px",
	            "border-radius": "4px"
	          }
	        }, [_vm._v("\n            " + _vm._s((scope.row.is_active === true) ? _vm.$t('pricingAgreements.active') : _vm.$t('pricingAgreements.inactive')) + "\n          ")])]
	      }
	    }], null, false, 1883203708)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.lines'),
	      "width": "100"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v(_vm._s((scope.row.lines && scope.row.lines.length) || 0))]
	      }
	    }], null, false, 1685027486)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.actions'),
	      "width": "100",
	      "align": "right"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('i', {
	          staticClass: "fa fa-external-link",
	          staticStyle: {
	            "cursor": "pointer",
	            "margin-right": "8px"
	          },
	          attrs: {
	            "aria-hidden": "true",
	            "title": _vm.$t('pricingAgreements.editPricingAgreement')
	          },
	          on: {
	            "click": function($event) {
	              return _vm.editInNewTab(scope.row)
	            }
	          }
	        }), _vm._v(" "), _c('i', {
	          staticClass: "fa fa-trash-o",
	          class: {
	            'loading': _vm.deletingId === scope.row.id
	          },
	          staticStyle: {
	            "cursor": "pointer",
	            "color": "#f56c6c"
	          },
	          attrs: {
	            "aria-hidden": "true",
	            "title": _vm.$t('button.delete')
	          },
	          on: {
	            "click": function($event) {
	              return _vm.deleteAgreement(scope.row)
	            }
	          }
	        })]
	      }
	    }], null, false, 1877725916)
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.sortedFilteredItems.length > 0) ? _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.pagination,
	      "switchFunction": _vm.onPageChange
	    }
	  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.hasUnmatched ? _vm.$t('pricingAgreements.unmatchedTitle') : _vm.$t('pricingAgreements.importFromTemplate'),
	      "visible": _vm.showImportDialog,
	      "width": _vm.hasUnmatched ? '920px' : '500px',
	      "close-on-click-modal": false
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.showImportDialog = $event
	      }
	    }
	  }, [(_vm.hasUnmatched) ? [_c('p', {
	    staticClass: "unmatched-intro",
	    staticStyle: {
	      "margin-bottom": "12px",
	      "color": "#606266"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.unmatchedIntro')))]), _vm._v(" "), _c('el-table', {
	    staticClass: "unmatched-table",
	    attrs: {
	      "data": _vm.paginatedUnmatchedRows,
	      "border": "",
	      "stripe": "",
	      "row-style": function () { return ({
	        background: '#fffbe6'
	      }); }
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.product'),
	      "min-width": "220"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-select', {
	          staticStyle: {
	            "width": "100%"
	          },
	          attrs: {
	            "filterable": "",
	            "remote": "",
	            "placeholder": _vm.$t('pricingAgreements.searchProductByName'),
	            "remote-method": function (q) { return _vm.remoteProductSearchForUnmatched(q, scope.row); },
	            "loading": _vm.unmatchedSelections[scope.row.row_index] && _vm.unmatchedSelections[scope.row.row_index].loading,
	            "clearable": ""
	          },
	          on: {
	            "focus": function($event) {
	              _vm.ensureUnmatchedSelection(scope.row).productOptions.length === 0 && _vm.remoteProductSearchForUnmatched('', scope.row)
	            }
	          },
	          model: {
	            value: (_vm.unmatchedSelections[scope.row.row_index].productId),
	            callback: function($$v) {
	              _vm.$set(_vm.unmatchedSelections[scope.row.row_index], "productId", $$v)
	            },
	            expression: "unmatchedSelections[scope.row.row_index].productId"
	          }
	        }, _vm._l(((_vm.unmatchedSelections[scope.row.row_index] && _vm.unmatchedSelections[scope.row.row_index].productOptions) || []), function(p) {
	          return _c('el-option', {
	            key: p.id,
	            attrs: {
	              "label": p.number ? p.name + ' (' + p.number + ')' : p.name,
	              "value": p.id
	            }
	          })
	        }), 1)]
	      }
	    }], null, false, 1766926496)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.importedName'),
	      "min-width": "200",
	      "prop": "product_name"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.discountPercent'),
	      "min-width": "100",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-input', {
	          staticStyle: {
	            "width": "80px"
	          },
	          attrs: {
	            "type": "number",
	            "placeholder": "%",
	            "size": "small",
	            "min": "0",
	            "max": "100"
	          },
	          model: {
	            value: (_vm.unmatchedSelections[scope.row.row_index].discountPercent),
	            callback: function($$v) {
	              _vm.$set(_vm.unmatchedSelections[scope.row.row_index], "discountPercent", _vm._n($$v))
	            },
	            expression: "unmatchedSelections[scope.row.row_index].discountPercent"
	          }
	        })]
	      }
	    }], null, false, 879113495)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.discountAmount'),
	      "min-width": "120",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-input', {
	          staticStyle: {
	            "width": "90px"
	          },
	          attrs: {
	            "type": "number",
	            "placeholder": _vm.$t('pricingAgreements.perUnit'),
	            "size": "small",
	            "min": "0"
	          },
	          model: {
	            value: (_vm.unmatchedSelections[scope.row.row_index].discountAmount),
	            callback: function($$v) {
	              _vm.$set(_vm.unmatchedSelections[scope.row.row_index], "discountAmount", _vm._n($$v))
	            },
	            expression: "unmatchedSelections[scope.row.row_index].discountAmount"
	          }
	        })]
	      }
	    }], null, false, 2163540884)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "",
	      "min-width": "120",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-button', {
	          attrs: {
	            "type": "primary",
	            "size": "small"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.addUnmatchedLine(scope.row)
	            }
	          }
	        }, [_vm._v("\n              " + _vm._s(_vm.$t('pricingAgreements.addLine')) + "\n            ")])]
	      }
	    }], null, false, 1632589546)
	  })], 1), _vm._v(" "), (_vm.unmatchedPagination.lastPage > 1) ? _c('div', {
	    staticStyle: {
	      "margin-top": "12px",
	      "text-align": "right"
	    }
	  }, [_c('el-pagination', {
	    attrs: {
	      "current-page": _vm.unmatchedPagination.currentPage,
	      "page-size": _vm.unmatchedPagination.limit,
	      "total": _vm.unmatchedPagination.totalCount,
	      "layout": "total, prev, pager, next"
	    },
	    on: {
	      "current-change": _vm.onUnmatchedPageChange
	    }
	  })], 1) : _vm._e()] : [_c('p', {
	    staticStyle: {
	      "margin-bottom": "15px"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.templateDownloadUrl,
	      "download": "pricing-agreement-template.xlsx",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('pricingAgreements.downloadTemplate')) + "\n        ")])]), _vm._v(" "), _c('el-form', {
	    attrs: {
	      "label-width": "120px"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.customer'),
	      "required": ""
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "placeholder": _vm.$t('pricingAgreements.selectCustomer'),
	      "filterable": ""
	    },
	    model: {
	      value: (_vm.importForm.client_id),
	      callback: function($$v) {
	        _vm.$set(_vm.importForm, "client_id", $$v)
	      },
	      expression: "importForm.client_id"
	    }
	  }, _vm._l((_vm.clients), function(c) {
	    return _c('el-option', {
	      key: c.id,
	      attrs: {
	        "label": c.name,
	        "value": c.id,
	        "disabled": c.system_generated === 1
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.agreementName')
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": _vm.$t('pricingAgreements.agreementNamePlaceholder')
	    },
	    model: {
	      value: (_vm.importForm.name),
	      callback: function($$v) {
	        _vm.$set(_vm.importForm, "name", $$v)
	      },
	      expression: "importForm.name"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.file'),
	      "required": ""
	    }
	  }, [_c('el-upload', {
	    ref: "importUpload",
	    attrs: {
	      "auto-upload": false,
	      "limit": 1,
	      "on-change": _vm.onImportFileChange,
	      "on-remove": _vm.onImportFileRemove,
	      "accept": ".csv,.txt,.xlsx,.xls"
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "size": "small",
	      "type": "primary"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.chooseFile')))])], 1)], 1)], 1)], _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "flex-wrap": "wrap",
	      "gap": "10px",
	      "justify-content": "flex-end",
	      "align-items": "center"
	    },
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [(_vm.hasUnmatched) ? [_c('el-button', {
	    on: {
	      "click": _vm.closeUnmatchedAndGoToEdit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.closeAndViewAgreement')))])] : [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.showImportDialog = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.cancel')))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.importing
	    },
	    on: {
	      "click": _vm.doImport
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.import')))])]], 2)], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2902 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.campaigns.index.title')) + " (" + _vm._s(_vm.campaigns.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, _vm._l((_vm.campaigns.items), function(c, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.edit(c)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel"
	    }, [_c('span', {
	      staticClass: "cardBadge"
	    }, [_vm._v(_vm._s(c.campaignType))])]), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(c.name))]), _vm._v(" "), _c('span', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(c.amount))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDateLong(c.createdAt)))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	      staticClass: "cardinnerBox"
	    }, [_c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-info",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent cardContent--small"
	    }, [_vm._v("\n              " + _vm._s(c.description) + "\n            ")])])])])
	  }), 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "pagination": _vm.campaigns.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2903 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 2904 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v("\n          " + _vm._s(_vm.$t('static.module.subscribe.title')) + "\n          "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')))]), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.module",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.subscribe
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.subscribe').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2905 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "chart-contaier"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'orders.index',
	        query: {
	          filter: 'received'
	        }
	      }
	    }
	  }, [(_vm.loaded) ? _c('div', {
	    staticClass: "waiting-received"
	  }, [_c('div', {
	    staticClass: "number-container"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.number) + " "), _c('i', {
	    staticClass: "el-icon-sold-out"
	  })])])]) : _c('div', {
	    staticClass: "loading"
	  }, [_c('i', {
	    staticClass: "el-icon-loading"
	  })])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2906 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.stock.basicInformation'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.stock",
	      "hasLabel": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('v-products-table', {
	    attrs: {
	      "fields": _vm.fields,
	      "additionalData": _vm.additionalData,
	      "translation": "table.stock.products",
	      "page": "stock",
	      "isImport": _vm.isImport,
	      "isExport": _vm.isExport,
	      "exportClickHandler": _vm.download,
	      "server": _vm.server
	    }
	  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.stock.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.saveDraft
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.saveDraft').toUpperCase()))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.stockCount.completeStockCount').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2907 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 12
	    }
	  }, [(_vm.loading) ? _c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.warehouse.update.title')))]) : _c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.warehouse.name))])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 12
	    }
	  }, [_c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "flex-end"
	    }
	  }, [_c('div', {
	    staticClass: "btn-group margin-b-10 margin-r-10"
	  }, [_c('button', {
	    staticClass: "btn info el-button",
	    attrs: {
	      "type": "button",
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.transactionNavigation.addTransaction')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    on: {
	      "click": _vm.toggleDropdownTransactions
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu",
	    class: {
	      show: _vm.dropdownStateTransactions
	    }
	  }, [_c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button",
	      "href": ("#/inventory/stocks/create#" + (_vm.warehouse.id))
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.transactionNavigation.stockCount')))]), _vm._v(" "), _c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button",
	      "href": ("#/inventory/adjustment/create/stock#" + (_vm.warehouse.id))
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.transactionNavigation.stockAdjustment')))]), _vm._v(" "), _c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button",
	      "href": ("#/inventory/transfer/create#" + (_vm.warehouse.id))
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.transactionNavigation.transfer')))]), _vm._v(" "), _c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button",
	      "href": ("#/inventory/purchase/create#" + (_vm.warehouse.id))
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.transactionNavigation.purchase')))])])], 1)])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    on: {
	      "tab-click": _vm.switchTab
	    },
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.warehouse.basicInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 8
	    }
	  }, [_c('fieldset', {
	    staticClass: "margin-b-10 min-h-350"
	  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.warehouse.warehouseInformation')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.warehouse",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 8
	    }
	  }, [_c('fieldset', {
	    staticClass: "margin-b-10 min-h-350"
	  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.warehouse.contactInformation')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formContactInformation,
	      "translation": "form.warehouse.contact",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 8
	    }
	  }, [_c('fieldset', {
	    staticClass: "margin-b-10 min-h-350"
	  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.warehouse.addressInformation')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formAddressInformation,
	      "translation": "form.warehouse.address",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.warehouse.formTabs.products'),
	      "name": "2"
	    }
	  }, [_c('el-row', {
	    staticStyle: {
	      "margin-bottom": "20px"
	    },
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    staticStyle: {
	      "padding": "0px"
	    },
	    attrs: {
	      "sm": 24,
	      "md": 8,
	      "lg": 8,
	      "xl": 8
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "margin-bottom": "10px"
	    }
	  }, [_c('el-input', {
	    staticStyle: {
	      "width": "200px"
	    },
	    attrs: {
	      "type": "text"
	    },
	    model: {
	      value: (_vm.productSearch),
	      callback: function($$v) {
	        _vm.productSearch = $$v
	      },
	      expression: "productSearch"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--default small",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.onProductSearch
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.search')))])], 1), _vm._v(" "), _c('el-checkbox', {
	    model: {
	      value: (_vm.hideOutOfStock),
	      callback: function($$v) {
	        _vm.hideOutOfStock = $$v
	      },
	      expression: "hideOutOfStock"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.products.hideOutOfStock')))]), _vm._v(" "), (_vm.isDestructionWarehouse) ? _c('button', {
	    staticClass: "el-button el-button--default small",
	    staticStyle: {
	      "margin-bottom": "4px"
	    },
	    attrs: {
	      "disabled": !this.multipleSelection.length,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.destroySelectedProducts($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.products.bulkDestroyProducts')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(_vm.productShowAction) ? _c('el-row', {
	    staticClass: "bulkActions",
	    staticStyle: {
	      "margin-bottom": "10px"
	    },
	    attrs: {
	      "gutter": 5
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 8,
	      "lg": 6,
	      "xl": 4
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.productSelectedCount) + " products selected")])]), _vm._v(" "), (!_vm.isDestructionWarehouse) ? _c('el-col', {
	    staticStyle: {
	      "text-align": "right"
	    },
	    attrs: {
	      "md": 3,
	      "lg": 3,
	      "xl": 2
	    }
	  }, [(_vm.productShowAction) ? _c('label', [_vm._v(_vm._s(_vm.$t('productActions.select.label')) + " ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isDestructionWarehouse) ? _c('el-col', {
	    attrs: {
	      "md": 13,
	      "lg": 15,
	      "xl": 18
	    }
	  }, [_c('button', {
	    staticClass: "el-button el-button--default small",
	    staticStyle: {
	      "margin-bottom": "4px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onSelectAction('minStockLevel')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.setMinimumStock')))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.productsLoading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.productsLoading),
	      expression: "productsLoading"
	    }]
	  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br')]) : (_vm.productList) ? _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.productList,
	      "row-class-name": _vm.rowClass,
	      "stripe": "",
	      "default-sort": {
	        prop: 'name',
	        order: 'ascending'
	      }
	    },
	    on: {
	      "row-click": function($event) {
	        return _vm.showDetails($event)
	      },
	      "selection-change": _vm.handleSelectionChange
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "selection",
	      "width": "50"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": _vm.$t('static.warehouse.products.name'),
	      "sortable": "",
	      "order": ""
	    }
	  }), _vm._v(" "), (_vm.warehouse.typeName != 'Destruction') ? _c('el-table-column', {
	    attrs: {
	      "prop": "producer",
	      "label": _vm.$t('static.warehouse.products.producer'),
	      "sortable": ""
	    }
	  }) : _vm._e(), _vm._v(" "), ((_vm.warehouse.typeName == 'Destruction' || _vm.warehouse.typeName == 'Standard') && _vm.hasProduction() === true) ? _c('el-table-column', {
	    attrs: {
	      "prop": "batchName",
	      "label": _vm.$t('static.warehouse.products.batchName'),
	      "sortable": ""
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.warehouse.products.qty'),
	      "sortable": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('p', {
	          style: (scope.row.qty < scope.row.minimumStockLevel ? 'color:darkred' : '')
	        }, [_vm._v(_vm._s(scope.row.qty))])]
	      }
	    }])
	  }), _vm._v(" "), (!_vm.isDestructionWarehouse) ? _c('el-table-column', {
	    attrs: {
	      "prop": "minimumStockLevel",
	      "label": _vm.$t('static.warehouse.products.minimumStockLevel'),
	      "sortable": ""
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(!_vm.isDestructionWarehouse) ? _c('el-button', {
	          staticClass: "small",
	          attrs: {
	            "size": "mini",
	            "type": "primary"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.activateModal(scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(_vm.$t('button.edit').toUpperCase()))]) : _vm._e(), _vm._v(" "), (_vm.isDestructionWarehouse) ? _c('el-button', {
	          staticClass: "small",
	          attrs: {
	            "size": "mini",
	            "type": "primary"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.destroyProduct(scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(_vm.$t('button.destroy').toUpperCase()))]) : _vm._e()]
	      }
	    }])
	  })], 1) : _c('el-alert', {
	    attrs: {
	      "title": _vm.$t('static.warehouse.products.noDataMsg'),
	      "type": "warning"
	    }
	  }), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.warehouseProducts.pagination,
	      "switchFunction": _vm.allProduct
	    }
	  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.warehouse.formTabs.transactions'),
	      "name": "3"
	    }
	  }, [_c('el-row', {
	    staticStyle: {
	      "margin-top": "10px",
	      "margin-bottom": "10px"
	    },
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "sm": 24,
	      "md": 1,
	      "lg": 1,
	      "xl": 1
	    }
	  }, [_c('label', [_vm._v("Filter: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 24,
	      "md": 3,
	      "lg": 3,
	      "xl": 3
	    }
	  }, [(_vm.hasProduction()) ? _c('el-select', {
	    staticClass: "el-col-24",
	    attrs: {
	      "filterable": "",
	      "remote": "",
	      "clearable": "",
	      "size": "medium",
	      "placeholder": "Batch",
	      "remote-method": _vm.getFilterBatches,
	      "loading": _vm.batchFilter.loading
	    },
	    on: {
	      "change": function($event) {
	        return _vm.eventBatchFilter($event)
	      },
	      "clear": _vm.clearBatchFilter,
	      "focus": _vm.focusBatchFilter
	    },
	    model: {
	      value: (_vm.batchFilter.value),
	      callback: function($$v) {
	        _vm.$set(_vm.batchFilter, "value", $$v)
	      },
	      expression: "batchFilter.value"
	    }
	  }, _vm._l((_vm.batchFilter.options), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 24,
	      "md": 3,
	      "lg": 3,
	      "xl": 3
	    }
	  }, [_c('el-select', {
	    staticClass: "el-col-24",
	    attrs: {
	      "filterable": "",
	      "remote": "",
	      "clearable": "",
	      "size": "medium",
	      "placeholder": "Product name",
	      "remote-method": _vm.getFilterProducts,
	      "loading": _vm.productFilter.loading
	    },
	    on: {
	      "change": function($event) {
	        return _vm.eventProductFilter($event)
	      },
	      "clear": _vm.clearProductFilter,
	      "focus": _vm.focusProductFilter
	    },
	    model: {
	      value: (_vm.productFilter.value),
	      callback: function($$v) {
	        _vm.$set(_vm.productFilter, "value", $$v)
	      },
	      expression: "productFilter.value"
	    }
	  }, _vm._l((_vm.productFilter.options), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 24,
	      "md": 3,
	      "lg": 3,
	      "xl": 3
	    }
	  }, [_c('el-select', {
	    staticClass: "el-col-24",
	    attrs: {
	      "filterable": "",
	      "size": "medium",
	      "placeholder": "Transaction code",
	      "loading": _vm.typeFilter.loading
	    },
	    on: {
	      "change": function($event) {
	        return _vm.eventTransactionsV2Filter($event)
	      }
	    },
	    model: {
	      value: (_vm.typeFilter.value),
	      callback: function($$v) {
	        _vm.$set(_vm.typeFilter, "value", $$v)
	      },
	      expression: "typeFilter.value"
	    }
	  }, _vm._l((_vm.typeFilter.options), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(_vm.transactionLoading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.transactionLoading),
	      expression: "transactionLoading"
	    }]
	  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.transactionLoading && _vm.transactionListV2.length < 1) ? _c('div', {
	    staticClass: "whiteWrapper full-w flex justify-center",
	    staticStyle: {
	      "padding": "50px"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('static.warehouse.transactions.noDataMsg')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.transactionListV2.length > 0 && !_vm.transactionLoading) ? _c('v-table', {
	    attrs: {
	      "list": _vm.transactionListV2,
	      "noDataMessage": _vm.$t('static.warehouse.transactions.noDataMsg'),
	      "link": _vm.transactionLink,
	      "linkKey": "via",
	      "rowKey": "id",
	      "translation": "static.warehouse.transactions.table"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.transactionListV2.length > 0) ? _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.transactionsV2.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'warehouse.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2908 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('div', {
	    staticClass: "el-form-item"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.to')) + ":")]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item__content"
	  }, [_c('div', {
	    staticClass: "el-input"
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "placeholder": "Email to",
	      "filter-method": _vm.optionFilter,
	      "multiple": true,
	      "filterable": true,
	      "allow-create": true,
	      "popper-class": "ccEmail"
	    },
	    model: {
	      value: (_vm.previewEmailTo),
	      callback: function($$v) {
	        _vm.previewEmailTo = $$v
	      },
	      expression: "previewEmailTo"
	    }
	  }, _vm._l((_vm.to), function(email, key) {
	    return _c('el-option', {
	      key: key,
	      attrs: {
	        "label": email,
	        "value": email
	      }
	    })
	  }), 1)], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(" CC:")]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item__content"
	  }, [_c('div', {
	    staticClass: "el-input"
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "placeholder": "Email cc",
	      "filter-method": _vm.optionFilter,
	      "multiple": true,
	      "filterable": true,
	      "allow-create": true,
	      "popper-class": "ccEmail hidden"
	    },
	    model: {
	      value: (_vm.previewEmailCC),
	      callback: function($$v) {
	        _vm.previewEmailCC = $$v
	      },
	      expression: "previewEmailCC"
	    }
	  }, _vm._l((_vm.previewEmailCC), function(email, key) {
	    return _c('el-option', {
	      key: key,
	      attrs: {
	        "label": email,
	        "value": email
	      }
	    })
	  }), 1)], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.subject')) + ":")]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item__content"
	  }, [_c('div', {
	    staticClass: "el-input"
	  }, [_c('el-input', {
	    attrs: {
	      "name": "subject"
	    },
	    model: {
	      value: (_vm.previewSubject),
	      callback: function($$v) {
	        _vm.previewSubject = $$v
	      },
	      expression: "previewSubject"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "el-textarea margin-b-10"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.messageBody')) + ":")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.previewMessage),
	      expression: "previewMessage"
	    }],
	    staticClass: "el-textarea__inner",
	    attrs: {
	      "rows": "10",
	      "name": "message"
	    },
	    domProps: {
	      "value": (_vm.previewMessage)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.previewMessage = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex wrap justify-center buttons_under_main_body"
	  }, [_c('el-button', {
	    attrs: {
	      "loading": _vm.modalButtonLoading
	    },
	    on: {
	      "click": _vm.buttons[0].action
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.buttons[0].name) + "\n    ")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "loading": _vm.modalButtonLoading
	    },
	    on: {
	      "click": _vm.sendReminder
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.buttons[1].name) + "\n    ")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2909 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.materials.edit.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.materials.formTabs.materialInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.materials",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'production.materials.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.index.title')) + " (" + _vm._s(_vm.adjustments.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.adjustments.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.adjustment.noDataMsg')) + "\n        "), (!_vm.bridgeStockWriteBlocked) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.adjustment.stock.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.adjustment.noDataBtn')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.adjustments.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      attrs: {
	        "wide": true
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editAdjustment(p)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "full-w flex wrap client-title-container margin-b-10"
	    }, [_c('img', {
	      staticClass: "client-img margin-b-10",
	      attrs: {
	        "src": __webpack_require__(276),
	        "alt": ("" + (p.code))
	      }
	    }), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(("" + (p.code))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.adjustment.info.code')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.code || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.adjustment.info.qty')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.total_qty || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.adjustment.info.warehouse')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.warehouseName))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.adjustment.info.createdAt')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(_vm.formatDate(p.createdAt, 'DD-MM-YYYY')))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.adjustment.info.adjustmentType')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s((p.adjustmentType) ? _vm.$t(("form.adjustment.adjustmentTypeList." + (p.adjustmentType))) : '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.adjustment.info.status')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s((p.status) ? _vm.$t(("form.adjustment.adjustmentStatus." + (p.status))) : '-'))])], _c('br')], 2)
	  })], 2)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.adjustments.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2911 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.bills.crediNoteReason.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.bills.crediNoteReason.title')))]), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.registerCreditNoteReason",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.complete
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.index.title')) + " (" + _vm._s(_vm.transfers.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('el-button-group', [_c('el-button', {
	    attrs: {
	      "type": _vm.primary,
	      "size": "small",
	      "icon": "el-icon-menu",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('info')
	      }
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": _vm.info,
	      "size": "small",
	      "icon": "el-icon-tickets",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('primary')
	      }
	    }
	  })], 1), _vm._v(" "), _c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  })], 1)])], 1), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.transfers.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.transfer.noDataMsg')) + "\n        "), (!_vm.bridgeStockWriteBlocked) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.transfer.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.transfer.noDataBtn')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.transfers.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      attrs: {
	        "wide": true
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.viewTransfer(p)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "full-w flex wrap client-title-container margin-b-10"
	    }, [_c('img', {
	      staticClass: "client-img margin-b-10",
	      attrs: {
	        "src": __webpack_require__(276),
	        "alt": ("" + (p.code))
	      }
	    }), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v("TR-" + _vm._s(("" + (p.code))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.transfer.info.type')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.transferTypeName || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.transfer.info.fromWarehouse')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(" " + _vm._s(p.fromWarehouseName || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.transfer.info.toWarehouse')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(" " + _vm._s(p.toWarehouseName || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.transfer.info.createdAt')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(" " + _vm._s(_vm.formatDate(p.createdAt, 'DD-MM-YYYY') || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.transfer.info.status')) + " ")]), _c('span', {
	      staticClass: "cardContent capitalize"
	    }, [_vm._v(" " + _vm._s(p.status ? p.status : '-'))])], _c('br')], 2)
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('v-table', {
	    attrs: {
	      "list": _vm.transfersListView,
	      "noDataMessage": _vm.$t('static.defaultText.transfer.noDataMsg'),
	      "link": _vm.viewTransfer,
	      "linkKey": "code",
	      "rowKey": "id",
	      "translation": "static.transfer.info"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.transfers.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2913 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "newBookingDialog"
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitlxe"
	  }, [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.addBooking.title')))]), _vm._v(" "), _c('el-form', {
	    ref: "newBookingForm",
	    attrs: {
	      "model": _vm.newBookingForm,
	      "rules": _vm.newBookingRules,
	      "label-position": "top"
	    }
	  }, [(_vm.newBookingForm.order_number) ? _c('div', {
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'orders.edit',
	        params: {
	          id: _vm.newBookingForm.order_id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.addBooking.showOrder')) + " (#" + _vm._s(_vm.newBookingForm.order_number) + ")")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "center",
	      "background-color": "#eee",
	      "padding": "15px",
	      "margin-bottom": "10px"
	    }
	  }, [_c('h4', {
	    staticStyle: {
	      "font-size": "16px",
	      "margin-bottom": "10px",
	      "margin-top": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.formatDate(_vm.newBookingForm.date)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.newBookingForm.start_time) + " — " + _vm._s(_vm.newBookingForm.end_time))])]), _vm._v(" "), _c('el-form-item', {
	    staticStyle: {
	      "margin-bottom": "20px"
	    },
	    attrs: {
	      "prop": "product_id",
	      "label": _vm.$t('static.members.index.dialog.addBooking.selectProduct'),
	      "show-message": false
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "margin-top": "-5px",
	      "width": "100%"
	    },
	    attrs: {
	      "filterable": "",
	      "placeholder": _vm.$t('static.members.index.dialog.addBooking.selectProduct')
	    },
	    on: {
	      "change": function($event) {
	        _vm.newBookingForm.member_id = '';
	        _vm.updateEndTime();
	      }
	    },
	    model: {
	      value: (_vm.newBookingForm.product_id),
	      callback: function($$v) {
	        _vm.$set(_vm.newBookingForm, "product_id", $$v)
	      },
	      expression: "newBookingForm.product_id"
	    }
	  }, _vm._l((_vm.memberProducts), function(memberProduct) {
	    return _c('el-option', {
	      key: memberProduct.id,
	      attrs: {
	        "label": memberProduct.product.name,
	        "value": memberProduct.product.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
	    staticStyle: {
	      "margin-bottom": "20px"
	    },
	    attrs: {
	      "label": _vm.$t('static.members.index.dialog.addBooking.selectPractitioner'),
	      "prop": "member_id",
	      "show-message": false
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "margin-top": "-5px",
	      "width": "100%"
	    },
	    attrs: {
	      "disabled": _vm.productMembers.length == 0,
	      "filterable": "",
	      "placeholder": _vm.$t('static.members.index.dialog.addBooking.selectPractitioner')
	    },
	    model: {
	      value: (_vm.newBookingForm.member_id),
	      callback: function($$v) {
	        _vm.$set(_vm.newBookingForm, "member_id", $$v)
	      },
	      expression: "newBookingForm.member_id"
	    }
	  }, _vm._l((_vm.productMembers), function(member) {
	    return _c('el-option', {
	      key: member.id,
	      attrs: {
	        "label": member.user.full_name,
	        "value": member.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
	    staticStyle: {
	      "margin-bottom": "20px"
	    },
	    attrs: {
	      "label": _vm.$t('static.members.index.dialog.addBooking.selectClient'),
	      "prop": "client_id",
	      "show-message": false
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "margin-top": "-5px",
	      "width": "100%"
	    },
	    attrs: {
	      "filterable": "",
	      "placeholder": _vm.$t('static.members.index.dialog.addBooking.selectClient')
	    },
	    model: {
	      value: (_vm.newBookingForm.client_id),
	      callback: function($$v) {
	        _vm.$set(_vm.newBookingForm, "client_id", $$v)
	      },
	      expression: "newBookingForm.client_id"
	    }
	  }, _vm._l((_vm.clients), function(client) {
	    return _c('el-option', {
	      key: client.id,
	      attrs: {
	        "label": client.name,
	        "value": client.id
	      }
	    })
	  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "border": "solid 1px #1bbc9b",
	      "color": "#1bbc9b",
	      "background-color": "#fff",
	      "float": "left"
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.cancel')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [(_vm.action == 'EDIT') ? _c('span', [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.update')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.add')))])])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2914 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v("\n          " + _vm._s(_vm.$t('static.orders.shippingConfirm.title')) + "\n          "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('static.orders.shippingConfirm.title')) + "\n        ")]), _vm._v(" "), (_vm.displayError) ? _c('el-alert', {
	    attrs: {
	      "show-icon": "",
	      "title": _vm.$t('static.orders.shippingConfirm.shippingProviderRequired'),
	      "type": "error",
	      "center": "",
	      "closable": false
	    }
	  }, [(_vm.displayError) ? _c('div', {
	    staticStyle: {
	      "padding": "5px 0",
	      "text-decoration": "underline"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": ("/inventory/warehouse/" + _vm.warehouseId + "/edit#basics"),
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.orders.shippingConfirm.addShippingProviderBtn')))])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.shippingConfirm",
	      "hasLabel": true
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showReminder && _vm.currentOrder.orderType != 'EDI') ? _c('div', [(_vm.currentOrder.internalNote !== '') ? _c('div', [_c('span', {
	    staticClass: "label-content label-content--small",
	    staticStyle: {
	      "font-weight": "900",
	      "margin-bottom": "10px",
	      "display": "block"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.collicareConfirmedShippingReminder')))]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "border": "1px solid #f8e4c5",
	      "padding": "6px 18px",
	      "margin-bottom": "20px",
	      "background": "#fff1dc"
	    }
	  }, [_c('p', {
	    staticStyle: {
	      "white-space": "pre-line"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.currentOrder.internalNote.replace(/\r\n/g, '<br>'))
	    }
	  })])]) : _c('div', [_c('span', {
	    staticClass: "label-content label-content--small",
	    staticStyle: {
	      "font-weight": "900",
	      "margin-bottom": "10px",
	      "display": "block"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.collicareConfirmedShippingReminderEmpty')))])])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal(_vm.dashboard)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "disabled": _vm.displayError || (_vm.currentOrder.internalNote === '' && _vm.showReminder && _vm.currentOrder.orderType != 'EDI'),
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.index.title')) + " (" + _vm._s(_vm.purchases.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('el-button-group', [_c('el-button', {
	    attrs: {
	      "type": _vm.primary,
	      "size": "small",
	      "icon": "el-icon-menu",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('info')
	      }
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": _vm.info,
	      "size": "small",
	      "icon": "el-icon-tickets",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('primary')
	      }
	    }
	  })], 1), _vm._v(" "), _c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  })], 1)])], 1), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.purchases.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.purchase.noDataMsg')) + "\n        "), (!_vm.bridgeStockWriteBlocked) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.purchase.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.purchase.noDataBtn')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.purchases.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      attrs: {
	        "wide": true
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editAdjustment(p)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "full-w flex wrap client-title-container margin-b-10"
	    }, [_c('img', {
	      staticClass: "client-img margin-b-10",
	      attrs: {
	        "src": __webpack_require__(276),
	        "alt": ("" + (p.code))
	      }
	    }), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(("" + (p.code))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.purchase.info.code')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.code || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.purchase.info.qty')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.total_qty || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.purchase.info.warehouse')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(" " + _vm._s(p.warehouseName || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.purchase.info.supplier')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(" " + _vm._s(p.supplierName || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.purchase.info.status')) + " ")]), _c('span', {
	      staticClass: "cardContent capitalize"
	    }, [_vm._v(" " + _vm._s(p.purchaseStatus.name === 'pending' ? _vm.$t('static.purchase.status.pending_external') : _vm.$t('static.purchase.status.' + p.purchaseStatus.name.replace(/ /g, '_')) || '-'))])], _c('br')], 2)
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('v-table', {
	    attrs: {
	      "list": _vm.purchasesListView,
	      "noDataMessage": _vm.$t('static.defaultText.purchase.noDataMsg'),
	      "link": _vm.editAdjustment,
	      "linkKey": "code",
	      "rowKey": "id",
	      "translation": "static.purchase.info"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.purchases.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2916 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('static.news.edit.title')))]), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }]
	  }, [_c('br'), _c('br')]) : _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.news",
	      "hasLabel": true
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('button.save')) + "\n  ")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.sending
	    },
	    on: {
	      "click": _vm.test
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('button.sendTest')) + "\n  ")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2917 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body el-row"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.form.name))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.activeName),
	      callback: function($$v) {
	        _vm.activeName = $$v
	      },
	      expression: "activeName"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.subscriberList.edit.tab1Title'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    class: 'margin-b-10 ',
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "gutter": 20
	    }
	  }, [(_vm.sendingEmailsLoading && _vm.form.double_optin_required === 1) ? _c('div', {
	    staticClass: "optin-email-loading"
	  }, [_vm._v(_vm._s(_vm.$t('static.subscriberList.edit.sendingEmailLoading')))]) : _vm._e(), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "lg": 12
	    }
	  }, [_c('v-select', {
	    staticStyle: {
	      "width": "85%"
	    },
	    attrs: {
	      "name": "selectedClients",
	      "value": _vm.selectedClients,
	      "options": _vm.allClientsList,
	      "translation": "static.subscriberList.edit.addClients",
	      "error": _vm.selectClientError,
	      "multiple": true,
	      "searchable": "true",
	      "loading": _vm.loadingClients,
	      "remote": true,
	      "remoteMethod": _vm.selectClientRemote
	    },
	    on: {
	      "change": _vm.onChange
	    }
	  }), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "icon": "el-icon-plus",
	      "disabled": (_vm.selectedClients.length === 0) ? true : false,
	      "loading": _vm.addingClients
	    },
	    on: {
	      "click": function($event) {
	        return _vm.addClients(false)
	      }
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "lg": 12
	    }
	  }, [_c('v-select', {
	    staticStyle: {
	      "width": "85%"
	    },
	    attrs: {
	      "name": "selectedClientGroups",
	      "value": _vm.selectedClientGroups,
	      "options": _vm.allClientGroups,
	      "translation": "static.subscriberList.edit.addClientGroups",
	      "error": _vm.selectClientGroupError,
	      "multiple": true,
	      "searchable": "true",
	      "loading": _vm.loadingClientsGroup,
	      "remote": true,
	      "remoteMethod": _vm.selectClientGroupRemote
	    },
	    on: {
	      "change": _vm.onChange
	    }
	  }), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "icon": "el-icon-plus",
	      "disabled": (_vm.selectedClientGroups.length === 0) ? true : false,
	      "loading": _vm.addingClientGroups
	    },
	    on: {
	      "click": function($event) {
	        return _vm.addClients(true)
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    class: 'margin-b-10 flex',
	    attrs: {
	      "xs": 24,
	      "md": 12
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "margin-right": "5px"
	    }
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('static.subscriberList.edit.filterLabel')) + " ")]), _vm._v(" "), _c('v-select', {
	    attrs: {
	      "name": "filter",
	      "options": _vm.FilterTypes,
	      "value": _vm.filter
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onChangeFilter(_vm.filter)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-right": "5px"
	    }
	  }, [_c('el-button', {
	    staticClass: "el-button small danger",
	    on: {
	      "click": function($event) {
	        return _vm.activateSubscriber(false)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.unsubscribeAll')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "el-button small el-button--default",
	    on: {
	      "click": function($event) {
	        return _vm.activateSubscriber(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.subscribeAll')))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex-column start"
	  }, [(_vm.loadingSubscribers) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent",
	      "margin": "50px auto"
	    }
	  }, [_c('br'), _c('br')]) : _vm._l((_vm.subscribers.subscriber), function(c) {
	    return _c('div', {
	      staticClass: "full-w flex space-between list-item"
	    }, [_c('div', {
	      staticClass: "flex-column start"
	    }, [_c('div', {
	      staticClass: "full-w flex",
	      class: {
	        'danger-color': c.subscribe === 1
	      }
	    }, [_c('span', {
	      staticClass: "fa fa-user label label--small"
	    }), _vm._v(" "), _c('span', [_vm._v("   ")]), _vm._v(" "), _c('span', {
	      staticClass: "label-content label-content--small"
	    }, [_vm._v(_vm._s(c.name))])]), _vm._v(" "), _c('div', {
	      staticClass: "full-w flex list-item--details"
	    }, [_c('span', {
	      staticClass: "fa fa-envelope-o label label--small"
	    }), _vm._v(" "), _c('span', [_vm._v("   ")]), _vm._v(" "), _c('span', {
	      staticClass: "label label--small"
	    }, [_vm._v(_vm._s(c.email))])]), _vm._v(" "), _c('div', {
	      staticClass: "full-w flex list-item--details"
	    }, [_c('span', {
	      staticClass: "label label--small"
	    }, [_vm._v(_vm._s(c.hash_code))])])]), _vm._v(" "), _c('div', {
	      staticClass: "flex subscriber-actions"
	    }, [_c('el-tooltip', {
	      attrs: {
	        "content": (c.subscribe === 1) ? _vm.$t('static.subscriberList.edit.subscribers.unsubscribeSwitchTooltip') : _vm.$t('static.subscriberList.edit.subscribers.subscribeSwitchTooltip'),
	        "placement": "left"
	      }
	    }, [_c('el-switch', {
	      staticStyle: {
	        "margin-right": "10px"
	      },
	      attrs: {
	        "name": 'subscribeSwitch-' + c.id,
	        "active-value": 0,
	        "inactive-value": 1,
	        "value": _vm.subscribeSwitchData[c.id],
	        "active-color": "#13ce66",
	        "inactive-color": "red"
	      },
	      on: {
	        "change": function($event) {
	          return _vm.subscribeSwitch(c.id)
	        }
	      }
	    })], 1), _vm._v(" "), _c('el-button', {
	      staticClass: "small dark-outline",
	      attrs: {
	        "icon": "el-icon-delete"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.deleteSubscriber(c.id)
	        }
	      }
	    })], 1)])
	  })], 2)], 1), _vm._v(" "), (_vm.subscribers.pagination) ? _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.subscribers.pagination,
	      "switchFunction": _vm.fetchSubscriber
	    }
	  })], 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.subscriberList.edit.tab2Title'),
	      "name": "2"
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "save": _vm.update,
	      "form": _vm.form,
	      "translation": "form.subscriberList",
	      "hasLabel": true
	    }
	  })], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.subscriberList.edit.tab3Title'),
	      "name": "3"
	    }
	  }, [_c('el-row', {
	    staticClass: "margin-b-10",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "lg": 12
	    }
	  }, [_c('div', {
	    staticClass: "el-form-item__content"
	  }, [_c('div', {
	    staticClass: "el-input margin",
	    staticStyle: {
	      "margin-right": "1em"
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "filterable": true,
	      "allow-create": true,
	      "placeholder": "Rule",
	      "popper-class": "group hidden"
	    },
	    model: {
	      value: (_vm.selectedRule),
	      callback: function($$v) {
	        _vm.selectedRule = $$v
	      },
	      expression: "selectedRule"
	    }
	  }, _vm._l((_vm.ruleOptions), function(option, key) {
	    return _c('el-option', {
	      key: key,
	      attrs: {
	        "label": option.name,
	        "value": option.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "el-input margin",
	    staticStyle: {
	      "margin-right": "1em"
	    }
	  }, [_c('v-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "name": "selectedRuleClientGroups",
	      "value": _vm.selectedRuleClientGroups,
	      "options": _vm.allRuleClientGroups,
	      "translation": "static.subscriberList.edit.addClientGroups",
	      "multiple": true,
	      "searchable": "true",
	      "loading": _vm.loadingClientsGroup,
	      "remote": true,
	      "remoteMethod": _vm.selectRuleClientGroupRemote
	    },
	    on: {
	      "change": _vm.onChangeRulesByGroup
	    }
	  })], 1)]), _c('br'), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "disabled": (_vm.selectedRuleClientGroups.length === 0 || _vm.selectedRule === '') ? true : false,
	      "loading": _vm.selectedClientGroupsLoading
	    },
	    on: {
	      "click": _vm.saveRule
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('button.save').toUpperCase()) + "\n              ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('el-button', {
	    staticClass: "outline danger",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.destroy
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.subscriberList.edit.deleteList')))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2918 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('static.batches.logs.add')))]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [_c('el-col', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "save": _vm.save,
	      "form": _vm.form,
	      "translation": "form.batches"
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2919 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('div', [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.title')))]), _vm._v(" "), (_vm.hasExciseModule) ? _c('div', [(_vm.bevearageProducts.length) ? [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.clientType')) + ": " + _vm._s(_vm.currentOrder.client.clientType.name) + "\n                "), (_vm.currentOrder.client.clientType.exciseAdditionalCode) ? [_c('br'), _vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.exciseCode')) + ": " + _vm._s(_vm.currentOrder.client.clientType.exciseAdditionalCode) + "\n                ")] : _vm._e()], 2), _vm._v(" "), (_vm.hasNoExcise) ? _c('el-alert', {
	    staticStyle: {
	      "margin-bottom": "10px",
	      "margin-top": "15px",
	      "display": "flex"
	    },
	    attrs: {
	      "title": _vm.$t('static.orders.orderConfirm.exciseWarningMessage'),
	      "type": "warning",
	      "show-icon": "",
	      "closable": false
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "el-row",
	    staticStyle: {
	      "border": "1px solid #ebeef5",
	      "background": "#f4f3f3",
	      "padding": "10px"
	    }
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%",
	      "display": "block"
	    },
	    attrs: {
	      "data": _vm.bevearageProducts
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.orders.orderConfirm.table.product')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.noExcise || !scope.row.productPackaging) ? _c('a', {
	          on: {
	            "click": function($event) {
	              return _vm.quickProductEdit(scope.row.id)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "el-icon-edit"
	        }), _vm._v("\n                        " + _vm._s(scope.row.name))]) : _c('span', {
	          staticStyle: {
	            "word-break": "break-word"
	          }
	        }, [_vm._v(_vm._s(scope.row.name))])]
	      }
	    }], null, false, 3066984676)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.orders.orderConfirm.paidExcise')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.paidExcise) ? _c('i', {
	          staticClass: "el-icon-circle-check success-color",
	          staticStyle: {
	            "font-size": "16px"
	          }
	        }, [_c('span', {
	          staticStyle: {
	            "font-weight": "bold",
	            "font-family": "'Roboto'",
	            "font-size": "14px"
	          }
	        }, [_vm._v(" " + _vm._s(_vm.$t('static.orders.orderConfirm.paidExciseYes')))])]) : _c('i', {
	          staticClass: "el-icon-circle-close danger-color",
	          staticStyle: {
	            "font-size": "16px"
	          }
	        }, [_c('span', {
	          staticStyle: {
	            "font-weight": "bold",
	            "font-family": "'Roboto'",
	            "font-size": "14px"
	          }
	        }, [_vm._v(" " + _vm._s(_vm.$t('static.orders.orderConfirm.paidExciseNo')))])])]
	      }
	    }], null, false, 3591655623)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.orders.orderConfirm.exciseCheck')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(!scope.row.noExcise) ? _c('i', {
	          staticClass: "el-icon-circle-check success-color",
	          staticStyle: {
	            "font-size": "18px"
	          }
	        }) : _c('i', {
	          staticClass: "el-icon-circle-close danger-color",
	          staticStyle: {
	            "font-size": "18px"
	          }
	        })]
	      }
	    }], null, false, 3082525749)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.orders.orderConfirm.packagingCheck')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.productPackaging) ? _c('i', {
	          staticClass: "el-icon-circle-check success-color",
	          staticStyle: {
	            "font-size": "18px"
	          }
	        }) : _c('i', {
	          staticClass: "el-icon-circle-close danger-color",
	          staticStyle: {
	            "font-size": "18px"
	          }
	        })]
	      }
	    }], null, false, 2695315936)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "beverage",
	      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.beverage')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "packaging",
	      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.packaging')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "basic",
	      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.basic')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "bottleVolume",
	      "label": _vm.$t('static.orders.orderConfirm.table.bottleVolume')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "alcoholPercentage",
	      "label": _vm.$t('static.orders.orderConfirm.table.alcoholPercentage')
	    }
	  })], 1)], 1)] : _vm._e()], 2) : _c('div', [_c('el-alert', {
	    staticStyle: {
	      "margin-bottom": "10px",
	      "margin-top": "15px",
	      "display": "flex"
	    },
	    attrs: {
	      "title": _vm.$t('static.orders.orderConfirm.upsellMessage'),
	      "type": "info",
	      "show-icon": ""
	    }
	  })], 1)]), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
	    staticStyle: {
	      "margin-top": "15px"
	    },
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.orderConfirm",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal(_vm.dashboard)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading,
	      "disabled": !!(_vm.hasNoExcise || _vm.hasMissingPackaging)
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.save').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('div', {
	    staticClass: "content login-wrapper"
	  }, [_c('div', {
	    staticClass: "content-inner loginBox"
	  }, [_c('div', {
	    staticClass: "flex-column full-w centered"
	  }, [_c('div', {
	    staticClass: "min-width-300 max-width-300"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(181),
	      "width": "150px"
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('static.resetPassword.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.resetPassword.firstParagraph')))]), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "save": _vm.send,
	      "form": _vm.form,
	      "btn-text": "button.send",
	      "translation": "form.resetPassword"
	    }
	  })], 1)])])])])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2921 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('static.orders.edit.modalFormTitle')) + " ("), _c('a', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "href": ("/#/products/" + _vm.productId + "/edit#productInfo"),
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.goToEditPage')))]), _vm._v(")")]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "hasLabel": true,
	      "translation": "form.products",
	      "save": _vm.onSubmit
	    }
	  }) : _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2922 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper tab-wrapper client-create-page"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.clients.basicInformation'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.clients",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'clients.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2923 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('v-form-table', {
	    staticClass: "clientcontacts-table",
	    attrs: {
	      "form": _vm.form,
	      "list": _vm.currentClientContacts,
	      "create": _vm.save,
	      "update": _vm.update,
	      "destroy": _vm.destroy,
	      "noResultWarningText": _vm.$t('form.clients.noContactWarning'),
	      "translation": "form.clients",
	      "primaryContactError": _vm.primaryContactError,
	      "hiddenFields": _vm.hiddenFields
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2924 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clientGroups.edit.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.productGroups.formTabs.groupInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.clientGroups",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'clientGroups.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2925 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('p', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-spinner fa-spin fa-2x"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.subscriberList.edit.subscribers.groupModalHeaderTitle')) + " " + _vm._s(_vm.groupName))]), _vm._v(" "), _c('div', [_c('ul', {
	    staticClass: "client-group-modal-list"
	  }, _vm._l((_vm.clients), function(client, key) {
	    return _c('li', [_c('span', [_vm._v(_vm._s(client.name))]), _vm._v(" "), _c('ul', {
	      staticClass: "client-group-modal-list-child"
	    }, _vm._l((client.contacts), function(contact, key2) {
	      return _c('li', [(contact.exist) ? _c('p', [_vm._v("\n                    " + _vm._s(contact.email) + " \n                    (" + _vm._s((contact.contact_types[0]) ? contact.contact_types[0].name : 'Primary') + ")\n                    " + _vm._s(_vm.$t('static.subscriberList.edit.subscribers.alreadyInList')) + "\n                  ")]) : _c('el-checkbox', {
	        attrs: {
	          "checked": "",
	          "name": 'contact-' + contact.id
	        },
	        model: {
	          value: (_vm.selectedContact[contact.id]),
	          callback: function($$v) {
	            _vm.$set(_vm.selectedContact, contact.id, $$v)
	          },
	          expression: "selectedContact[contact.id]"
	        }
	      }, [_c('span', {
	        attrs: {
	          "for": 'contact-' + contact.id
	        }
	      }, [_vm._v("\n                      " + _vm._s(contact.email) + " \n                      (" + _vm._s((contact.contact_types[0]) ? contact.contact_types[0].name : 'Primary') + ")\n                  ")])])], 1)
	    }), 0)])
	  }), 0)])])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.subscriberList.edit.subscribers.groupModalCancel')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "disabled": _vm.loading,
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.subscriberList.edit.subscribers.groupModalApply')))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2926 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 2927 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('static.bundleProductPreview.title')))]), _vm._v(" "), _c('div', [_c('div', [_c('h3', [_vm._v("\n        " + _vm._s(_vm.$t('static.bundleProductPreview.openProductEdit')) + ": "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productBundles.edit',
	        params: {
	          id: _vm.productId
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.name))])], 1), _vm._v(" "), _c('div', [_c('v-form', {
	    staticStyle: {
	      "margin-top": "15px"
	    },
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.bundleProductPreview",
	      "hasLabel": true
	    }
	  })], 1)]), _vm._v(" "), _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('static.bundleProductPreview.bundleProducts')))]), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.products,
	      "border": "",
	      "stripe": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "sku",
	      "label": _vm.$t('static.bundleProductPreview.table.sku'),
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": _vm.$t('static.bundleProductPreview.table.name')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bundleProductPreview.table.action')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('router-link', {
	          attrs: {
	            "to": {
	              name: 'products.edit',
	              params: {
	                id: scope.row.id
	              }
	            },
	            "target": "_blank"
	          }
	        }, [_vm._v(_vm._s(_vm.$t('static.bundleProductPreview.view')))])]
	      }
	    }])
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "bundle-preview-button"
	  }, [_c('el-button', {
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save')))])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2928 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "id": "member_details"
	    }
	  }, [(_vm.member) ? _c('div', [_c('div', {
	    staticStyle: {
	      "min-height": "550px",
	      "position": "relative",
	      "background-color": "#fff",
	      "border-radius": "4px"
	    }
	  }, [(_vm.member) ? [_c('div', {
	    staticClass: "clearfix",
	    staticStyle: {
	      "border-bottom": "solid 1px #eee",
	      "padding": "15px"
	    },
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('el-tag', {
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "type": (_vm.acceptStatus == 'ACTIVE') ? 'success' : 'info'
	    }
	  }, [_vm._v("\n\t\t\t\t  \t\t\t" + _vm._s(_vm.acceptStatus) + "\n\t\t\t\t  \t\t")]), _vm._v(" "), _c('h2', [_vm._v("\n\t\t\t\t    \t\t" + _vm._s(_vm.member.user.first_name) + " " + _vm._s(_vm.member.user.last_name) + "\n\t\t\t\t    \t\t"), _c('el-color-picker', {
	    staticStyle: {
	      "display": "inline-block",
	      "vertical-align": "middle"
	    },
	    attrs: {
	      "size": "small"
	    },
	    on: {
	      "change": _vm.updateColor
	    },
	    model: {
	      value: (_vm.member.color),
	      callback: function($$v) {
	        _vm.$set(_vm.member, "color", $$v)
	      },
	      expression: "member.color"
	    }
	  })], 1), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.member.user.email))])], 1), _vm._v(" "), _c('el-row', {
	    staticStyle: {
	      "padding": "15px"
	    },
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 14
	    }
	  }, [_c('h2', {
	    staticStyle: {
	      "display": "inline-block"
	    }
	  }, [_vm._v(_vm._s(_vm.member.title))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "float": "right"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addProduct = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.members.show.addProduct')))]), _vm._v(" "), (_vm.member.organization_member_products.length == 0) ? _c('el-alert', {
	    attrs: {
	      "title": "No products found",
	      "type": "info",
	      "closable": false
	    }
	  }) : _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "highlight-current-row": "",
	      "data": _vm.member.organization_member_products
	    },
	    on: {
	      "current-change": _vm.selectProduct
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.members.show.table.product.name'),
	      "prop": "product.name"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.members.show.table.product.price'),
	      "prop": "product.price"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.members.show.table.product.duration'),
	      "prop": "product"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v("\n\t\t\t\t\t\t\t\t     \t" + _vm._s(scope.row.product.product_configuration.duration) + " mins\n\t\t\t\t\t\t\t\t    ")]
	      }
	    }], null, false, 59843197)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "width": "60"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-button', {
	          staticClass: "small",
	          staticStyle: {
	            "border-color": "red",
	            "background": "red"
	          },
	          attrs: {
	            "type": "danger"
	          },
	          on: {
	            "click": function($event) {
	              _vm.deleteMemberProduct = true;
	              _vm.product_delete_id = scope.row.id;
	            }
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-trash"
	        })])]
	      }
	    }], null, false, 2555358561)
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 10
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "box-shadow": "0 2px 12px 0 rgba(0,0,0,.1)",
	      "border": "1px solid #ebeef5",
	      "color": "#303133",
	      "border-radius": "4px",
	      "padding": "20px"
	    }
	  }, [(!_vm.selected_product) ? _c('el-alert', {
	    attrs: {
	      "title": "Please select a product to manage business hours",
	      "type": "info",
	      "closable": false,
	      "center": ""
	    }
	  }) : [_c('span', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_vm._v(_vm._s(_vm.selected_product.product.product_configuration.duration) + " mins")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.selected_product.product.name))]), _vm._v(" "), _c('el-collapse', {
	    staticStyle: {
	      "margin-top": "20px"
	    },
	    attrs: {
	      "accordion": ""
	    },
	    on: {
	      "change": _vm.setDay
	    },
	    model: {
	      value: (_vm.day),
	      callback: function($$v) {
	        _vm.day = $$v
	      },
	      expression: "day"
	    }
	  }, _vm._l((_vm.days), function(day, index) {
	    return _c('el-collapse-item', {
	      attrs: {
	        "title": day,
	        "name": day
	      }
	    }, [_vm._l((_vm.getHours(_vm.selected_product, day)), function(businesshour) {
	      return _c('el-tag', {
	        key: businesshour.id,
	        attrs: {
	          "closable": "",
	          "type": "success"
	        },
	        on: {
	          "close": function($event) {
	            return _vm.removeHour(businesshour.id)
	          }
	        }
	      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t  " + _vm._s(businesshour.start_time) + " - " + _vm._s(businesshour.end_time) + "\n\t\t\t\t\t\t\t\t\t\t")])
	    }), _vm._v(" "), (_vm.addTimeVisible) ? _c('div', {
	      attrs: {
	        "id": "time_selector"
	      }
	    }, [_c('el-time-select', {
	      ref: "saveTagInput",
	      refInFor: true,
	      staticClass: "input-new-tag",
	      attrs: {
	        "picker-options": {
	          start: '07:00',
	          step: _vm.timeslot_gap,
	          end: '23:50'
	        },
	        "prefix-icon": "''",
	        "clearable": false,
	        "editable": false,
	        "placeholder": _vm.$t('static.members.show.options.start')
	      },
	      on: {
	        "blur": _vm.confirmAddTime
	      },
	      nativeOn: {
	        "keyup": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.confirmAddTime($event)
	        }
	      },
	      model: {
	        value: (_vm.start_time),
	        callback: function($$v) {
	          _vm.start_time = $$v
	        },
	        expression: "start_time"
	      }
	    }), _vm._v(" "), _c('el-time-select', {
	      ref: "saveTagInput",
	      refInFor: true,
	      staticClass: "input-new-tag",
	      attrs: {
	        "picker-options": {
	          start: '07:00',
	          step: _vm.timeslot_gap,
	          end: '23:50'
	        },
	        "prefix-icon": "''",
	        "clearable": false,
	        "editable": false,
	        "placeholder": _vm.$t('static.members.show.options.end')
	      },
	      on: {
	        "blur": _vm.confirmAddTime
	      },
	      nativeOn: {
	        "keyup": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.confirmAddTime($event)
	        }
	      },
	      model: {
	        value: (_vm.end_time),
	        callback: function($$v) {
	          _vm.end_time = $$v
	        },
	        expression: "end_time"
	      }
	    })], 1) : _c('el-button', {
	      staticClass: "button-new-tag small",
	      on: {
	        "click": function($event) {
	          return _vm.showAddHour(index)
	        }
	      }
	    }, [_vm._v("+ " + _vm._s(_vm.$t('static.members.show.addHour')))])], 2)
	  }), 1)]], 2)])], 1)] : _vm._e(), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "border-color": "red",
	      "background": "red",
	      "position": "absolute",
	      "bottom": "15px",
	      "left": "15px"
	    },
	    attrs: {
	      "type": "danger"
	    },
	    on: {
	      "click": function($event) {
	        _vm.deleteMember = true;
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.members.show.deleteMember')))])], 2), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('static.members.show.dialog.addProduct.title'),
	      "visible": _vm.addProduct,
	      "width": "40%"
	    },
	    on: {
	      "close": function($event) {
	        _vm.new_product_id = null
	      },
	      "update:visible": function($event) {
	        _vm.addProduct = $event
	      }
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%",
	      "margin-top": "20px"
	    },
	    attrs: {
	      "placeholder": "Select product"
	    },
	    model: {
	      value: (_vm.new_product_id),
	      callback: function($$v) {
	        _vm.new_product_id = $$v
	      },
	      expression: "new_product_id"
	    }
	  }, _vm._l((_vm.organization_products), function(product) {
	    return _c('el-option', {
	      key: product.id,
	      attrs: {
	        "label": product.name,
	        "value": product.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "border": "solid 1px #1bbc9b",
	      "color": "#1bbc9b",
	      "background-color": "#fff",
	      "float": "left"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addProduct = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.cancel')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.addNewProduct
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.add')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('static.members.show.dialog.deleteMember.title'),
	      "visible": _vm.deleteMember,
	      "width": "40%"
	    },
	    on: {
	      "close": function($event) {
	        _vm.deleteMember = false;
	      },
	      "update:visible": function($event) {
	        _vm.deleteMember = $event
	      }
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.deleteMember.text')) + " "), _c('strong', [_vm._v(_vm._s(_vm.member.user.first_name) + " " + _vm._s(_vm.member.user.last_name))]), _vm._v("?")]), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "border": "solid 1px #1bbc9b",
	      "color": "#1bbc9b",
	      "background-color": "#fff",
	      "float": "left"
	    },
	    on: {
	      "click": function($event) {
	        _vm.deleteMember = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.cancel')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "background-color": "red",
	      "border-color": "red"
	    },
	    attrs: {
	      "type": "danger"
	    },
	    on: {
	      "click": _vm.confirmDeleteMember
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.delete')))])], 1)]), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('static.members.show.dialog.deleteMemberProduct.title'),
	      "visible": _vm.deleteMemberProduct,
	      "width": "40%"
	    },
	    on: {
	      "close": function($event) {
	        _vm.deleteMemberProduct = false;
	      },
	      "update:visible": function($event) {
	        _vm.deleteMemberProduct = $event
	      }
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.deleteMemberProduct.text')))]), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "border": "solid 1px #1bbc9b",
	      "color": "#1bbc9b",
	      "background-color": "#fff",
	      "float": "left"
	    },
	    on: {
	      "click": function($event) {
	        _vm.deleteMemberProduct = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.cancel')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "background-color": "red",
	      "border-color": "red"
	    },
	    attrs: {
	      "type": "danger"
	    },
	    on: {
	      "click": _vm.confirmDeleteMemberProduct
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.members.show.dialog.delete')))])], 1)])], 1) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2929 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-dialog', {
	    attrs: {
	      "title": "",
	      "visible": _vm.active,
	      "custom-class": (_vm.modalClass + " responsive-modal"),
	      "close-on-click-modal": _vm.modalCloseOnClick,
	      "show-close": _vm.modalShowClose,
	      "close-on-press-escape": _vm.modalCloseOnPressEscape
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.active = $event
	      },
	      "close": _vm.onClose
	    }
	  }, [(Object.keys(_vm.content).length) ? _c('div', [_c(_vm.content, _vm._b({
	    tag: "component",
	    on: {
	      "close": _vm.onClose
	    }
	  }, 'component', _vm.modalProps, false))], 1) : _c('div', [_vm._v("No content")])])
	},staticRenderFns: []}

/***/ }),
/* 2930 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 20,
	      "md": 16
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.title')) + " #" + _vm._s(_vm.currentOrder.number) + " - " + _vm._s(_vm.$t('static.orders.types.' + _vm.orderType)))])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 4,
	      "md": 8
	    }
	  }, [_c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "flex-end",
	      "margin-bottom": "1em"
	    }
	  }, [_c('div', [_c('i', {
	    staticClass: "el-icon-back",
	    class: {
	      'disabled': !this.previousOrderId
	    },
	    staticStyle: {
	      "margin-right": "10px",
	      "font-size": "1.8rem",
	      "font-weight": "bold",
	      "cursor": "pointer",
	      "color": "#fff"
	    },
	    on: {
	      "click": _vm.previousOrder
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "el-icon-back",
	    class: {
	      'disabled': !this.nextOrderId
	    },
	    staticStyle: {
	      "font-size": "1.8rem",
	      "font-weight": "bold",
	      "cursor": "pointer",
	      "color": "#fff",
	      "transform": "rotate(180deg)"
	    },
	    on: {
	      "click": _vm.nextOrder
	    }
	  })])])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.orders.formTabs.orderInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "lg": 16
	    }
	  }, [(_vm.is220 && true == _vm.currentOrder.isVinmonopolet) ? _c('el-alert', {
	    attrs: {
	      "title": "Type 220 - Normal bestilling",
	      "description": "Normal levering til Vinmonopolet etter inngåtte avtaler",
	      "type": "info",
	      "center": "",
	      "closable": false
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isZNB && true == _vm.currentOrder.isVinmonopolet) ? _c('el-alert', {
	    attrs: {
	      "title": "Type ZNB - Levert ikke bestilt vare",
	      "description": "Opprettes dersom Vinmonopolet mottek ein vare som ikkje er bestilt. Det opprettes ein ny ordre som sendes som bestilling til leverandør. Denne inneheld nytt ordrenummer og referanse til ordrenummeret som varen vart levert sammen med. Viktig at varen IKKE sendes på nytt! Vinmonopolet skal ha ein faktura med referanse til det nye ordrenummeret",
	      "type": "info",
	      "center": "",
	      "closable": false
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isZRE && true == _vm.currentOrder.isVinmonopolet) ? _c('el-alert', {
	    attrs: {
	      "title": "Type ZRE - Retur",
	      "description": "Opprettes dersom Vinmonopolet skal returnera ein eller fleire varer. Viktig at varen IKKE sendes på nytt! Vinmonopolet skal ha ein kreditnota med referanse til returordren",
	      "type": "info",
	      "center": "",
	      "closable": false
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isZKA && true == _vm.currentOrder.isVinmonopolet) ? _c('el-alert', {
	    attrs: {
	      "title": "Type ZKA - Kassasjon",
	      "description": "Opprettes dersom det er avtale om kassering av varer (destruering, taes bort fra salg pga utløpsdato osv.). Viktig at varen IKKE sendes på nytt! Vinmonopolet skal ha ein kreditnota med referanse til kassasjonsordren",
	      "type": "info",
	      "center": "",
	      "closable": false
	    }
	  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.orders.edit.detailsLegend')))]), _vm._v(" "), _c('el-row', {
	    staticClass: "margin-b-10"
	  }, [_c('el-col', {
	    attrs: {
	      "md": 14
	    }
	  }, [(_vm.currentOrder.orderType === 'EDI') ? [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-building",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.storeName')) + ":\n                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                        " + _vm._s(_vm.currentEdiOrder.ediStoreName) + " ( #" + _vm._s(_vm.currentEdiOrder.ediStorePartyId) + " )\n                      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10",
	    on: {
	      "click": _vm.scrollWindow
	    }
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-card-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.storeAddress')) + ":\n                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                        " + _vm._s(((_vm.currentEdiOrder.ediStoreStreet) + " " + (_vm.currentEdiOrder.ediStorePostCode))) + "\n                      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.requestedDeliveryDate')) + ":\n                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                        " + _vm._s(_vm.currentEdiOrder.requestedDeliveryDate) + "\n                      ")])]), _vm._v(" "), (_vm.currentOrder.shippingProvider && _vm.currentOrder.shippingProvider !== 0) ? _c('div', [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-truck",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.shippingProvider')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                          " + _vm._s(_vm.currentEdiOrder.shippingProvider) + "\n                        ")])]), _vm._v(" "), (_vm.currentOrder.pickup) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-archive",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.pickup')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.pickupStatus) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.pickupBy) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-user",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.pickupBy')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.pickupBy) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.pickupDate) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.pickupDate')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                          " + _vm._s(_vm.formatDate(_vm.currentOrder.pickupDate)) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.deliveryDate) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.deliveryDate')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                          " + _vm._s(_vm.formatDate(_vm.currentOrder.deliveryDate)) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.shippingDate) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.shippingDate')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                          " + _vm._s(_vm.formatDate(_vm.currentOrder.shippingDate)) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.note) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.note')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.note) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderPickupId) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-link",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.shippingOrder')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'orderPickups.index',
	        params: {
	          number: _vm.currentOrder.number
	        }
	      }
	    }
	  }, [_vm._v("\n                            " + _vm._s(_vm.$t('static.orders.edit.shippingOrderText')) + "\n                          ")])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderTrackingNumber) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.trackingNumber')) + ":\n                      ")]), _vm._v(" "), (_vm.currentOrder.trackingUrl != '#') ? _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.currentOrder.trackingUrl,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.currentOrder.orderTrackingNumber))])]) : _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                        " + _vm._s(_vm.currentOrder.orderTrackingNumber + ' - ' + _vm.$t('static.orders.edit.trackingUrlNotAvail')) + "\n                      ")])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderType !== 'EDI') ? [(_vm.currentClient.companyName) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-building",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.company')) + ":\n                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                        " + _vm._s(_vm.currentClient.companyName) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.currentClient.firstName || _vm.currentClient.lastName) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-user",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.name')) + ":\n                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                        " + _vm._s(_vm.currentClient.firstName + ' ' + _vm.currentClient.lastName) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderType !== 'Appointment') ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-card-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.address')) + ":\n                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                        " + _vm._s(((_vm.currentClient.streetName) + " " + (_vm.currentClient.postalCode))) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.shippingProvider && _vm.currentOrder.shippingProvider !== 0) ? _c('div', [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-truck",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.shippingProvider')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.shippingProvider) + "\n                        ")])]), _vm._v(" "), (_vm.currentOrder.pickup) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-archive",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.pickup')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.pickup) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.pickupBy) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-user",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.pickupBy')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.pickupBy) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.pickupDate) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.pickupDate')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.pickupDate) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.deliveryDate) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.deliveryDate')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.deliveryDate) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.shippingDate) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.shippingDate')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.shippingDate) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.note) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.note')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.note) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderPickupId) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-link",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.shippingOrder')) + ":\n                        ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'orderPickups.index',
	        params: {
	          number: _vm.currentOrder.number
	        }
	      }
	    }
	  }, [_vm._v("\n                            " + _vm._s(_vm.$t('static.orders.edit.shippingOrderText')) + "\n                          ")])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderTrackingNumber) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.trackingNumber')) + ":\n                      ")]), _vm._v(" "), (_vm.currentOrder.trackingUrl != '#') ? _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.currentOrder.trackingUrl,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.currentOrder.orderTrackingNumber))])]) : _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                        " + _vm._s(_vm.currentOrder.orderTrackingNumber + ' - ' + _vm.$t('static.orders.edit.trackingUrlNotAvail')) + "\n                      ")])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderType === 'Appointment') ? [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.appointmentDate')) + ":\n                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status",
	    class: _vm.currentOrder.orderStatus
	  }, [_vm._v("\n                        " + _vm._s(_vm.formatDate(_vm.currentOrder.booking.date)) + "\n                      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.appointmentTime')) + ":\n                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status",
	    class: _vm.currentOrder.orderStatus
	  }, [_vm._v("\n                        " + _vm._s(_vm.currentOrder.booking.startTime) + " - " + _vm._s(_vm.currentOrder.booking.endTime) + "\n                      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.appointmentDuration')) + ":\n                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status",
	    class: _vm.currentOrder.orderStatus
	  }, [_vm._v("\n                        " + _vm._s(_vm.currentOrder.booking.durations) + " " + _vm._s(_vm.$t('static.orders.edit.minutes')) + "\n                      ")])])] : _vm._e(), _vm._v(" "), (_vm.currentOrder.internalNote) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.internalNote')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentOrder.internalNote) + "\n                    ")])]) : _vm._e()], 2), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 10
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.orderNumber')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentOrder.number) + "\n                    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.orderType')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentOrder.orderType === 'EDI' ? _vm.$t('static.orders.types.' + _vm.orderType) + ' (' + _vm.currentEdiOrder.ediOrderTypeName + ')' : _vm.$t('static.orders.types.' + _vm.orderType)) + "\n                    ")])]), _vm._v(" "), (_vm.currentOrder.orderType === 'EDI') ? [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.ediNumber')) + ":\n                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                        " + _vm._s(_vm.currentEdiOrder.orderNumber) + "\n                      ")])]), _vm._v(" "), (_vm.currentEdiOrder.ediOrderSourceOrderNumber) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.linkedEdiNumber')) + ":\n                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'orders.edit',
	        params: {
	          id: _vm.currentEdiOrder.ediOrderSourceOrderId
	        }
	      }
	    }
	  }, [_vm._v("\n                          " + _vm._s(_vm.currentEdiOrder.ediOrderSourceOrderNumber) + "\n                        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.zreOrderSourceOrderNumber) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.linkedEdiNumber')) + ":\n                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'orders.edit',
	        params: {
	          id: _vm.currentOrder.zreOrderSource
	        }
	      }
	    }
	  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.zreOrderSourceOrderNumber) + "\n                        ")])], 1)]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.orderDate')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentOrder.orderType === 'EDI' ? _vm.currentEdiOrder.createdAt : _vm.formatDate(_vm.currentOrder.createdAt)) + "\n                    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-info",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.orderStatus')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status",
	    class: _vm.currentOrder.orderStatus
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentOrder.orderType === 'EDI' ?
	    _vm.$t(("static.ediOrders.index." + (_vm.currentOrder.sent && _vm.currentOrder.orderStatus !== 'cancelled' ? 'bill_sent' : _vm.currentEdiOrder.ediOrderStatusName))) :
	    _vm.$t(("static.orders.status." + (_vm.currentOrder.sent && _vm.currentOrder.orderStatus !== 'cancelled' ? 'bill_sent' : _vm.currentOrder.orderStatus)))) + "\n                    ")])]), _vm._v(" "), (_vm.currentClient.orderReference) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-info",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.orderReference')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentClient.orderReference) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.referenceNumber) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.referenceNumber')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentOrder.referenceNumber) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.checkHasInventory == true) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-info",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.warehouse')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status",
	    class: _vm.currentOrder.orderStatus
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentWarehouse) + "\n                      "), (_vm.warehouseOption) ? _c('button', {
	    staticClass: "el-button el-button--default small",
	    attrs: {
	      "type": "button",
	      "round": ""
	    },
	    on: {
	      "click": _vm.activateWarehouseModal
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-edit"
	  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.bills.length) ? _c('div', [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-id-card-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.bill')) + ":\n                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._l((_vm.bills), function(b, i) {
	    return [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'bills.edit',
	          params: {
	            id: b.id
	          }
	        }
	      }
	    }, [_vm._v("\n                            " + _vm._s(b.billingNumber ? ("#" + (b.billingNumber)) : _vm.$t('static.reports.bills.draft')) + "\n                          ")]), _vm._v(" "), (i < _vm.bills.length - 1) ? _c('span', [_vm._v(" | ")]) : _vm._e()]
	  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.creditNotes.length) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-id-card-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.creditNotes')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._l((_vm.creditNotes), function(c, i) {
	    return [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'bills.creditNote',
	          params: {
	            id: c.id
	          }
	        }
	      }
	    }, [_vm._v("\n                          " + _vm._s(c.billingNumber ? ("#" + (c.billingNumber)) : ((_vm.$t('static.reports.bills.draft')) + " " + (i + 1))) + "\n                        ")]), _vm._v(" "), (i < _vm.creditNotes.length - 1) ? _c('span', [_vm._v(" | ")]) : _vm._e()]
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.details) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   " + _vm._s(_vm.currentOrder.details) + "\n                    ")])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('el-row', [(_vm.currentOrder.orderType == 'Return' && _vm.currentOrder.orderStatus != 'completed') ? _c('el-col', {
	    attrs: {
	      "md": 24
	    }
	  }, [_c('div', {
	    staticClass: "el-alert--info full-w padding-a-15"
	  }, [_c('el-button', {
	    staticClass: "small margin-b-10",
	    on: {
	      "click": _vm.completeReturnOrder
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.$t('button.complete')) + "\n                    ")])], 1)]) : (_vm.currentOrder.orderType == 'Return' && _vm.currentOrder.orderStatus == 'completed') ? _c('el-col', {
	    attrs: {
	      "md": 24
	    }
	  }, [_c('div', {
	    staticClass: "el-alert--info full-w padding-a-15"
	  }, [_vm._v(_vm._s(_vm.$t('static.orders.edit.returnOrderComplete')))]), _vm._v(" "), ((_vm.isZNB || _vm.is220) && (_vm.isEdiConfirmed || _vm.isEdiProcessed || _vm.isAskoAndBilled) || (_vm.currentOrder.orderType != 'EDI')) ? _c('div', {
	    staticClass: "small btn-group margin-b-10 margin-t-10 ma  margin-r-10"
	  }, [_c('button', {
	    staticClass: "btn info el-button",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.showPrintableDeliveryNote
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('button.showPrintableDeliveryNote')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    on: {
	      "click": _vm.toggleDropdownDelivery
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu",
	    class: {
	      show: _vm.dropdownStateDelivery
	    }
	  }, [_c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": _vm.showPrintableDeliveryNote
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                         " + _vm._s(_vm.$t('button.showPrintableDeliveryNote')))]), _vm._v(" "), _c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": _vm.downloadPrintableDeliveryNote
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                         " + _vm._s(_vm.$t('button.downloadPrintableDeliveryNote')))])])], 1) : _vm._e()]) : _c('el-col', {
	    attrs: {
	      "md": 24
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 24
	    }
	  }, [_c('div', {
	    staticClass: "el-alert--info full-w padding-a-15"
	  }, [_c('div', {
	    staticClass: "full-w flex margin-b-10"
	  }, [(_vm.hasUnconfirmedOrderProduct && _vm.is220) ? _c('span', {
	    staticClass: "margin-b-10"
	  }, [_vm._v("\n                            " + _vm._s(_vm.$t('static.orders.edit.pleaseConfirmAllOrderProducts')) + "\n                          ")]) : _vm._e()]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 4
	    }
	  }, [(_vm.canCreateCreditNote) ? _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": _vm.createCreditNote
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm.$t('button.createCreditNote')) + "\n                            ")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 8
	    }
	  }, [((_vm.currentOrder.orderType !== 'EDI') && _vm.canCancelOrder) ? _c('el-button', {
	    staticClass: "small danger margin-b-10",
	    attrs: {
	      "icon": "el-icon-close",
	      "loading": _vm.cancelLoading
	    },
	    on: {
	      "click": _vm.cancelOrder
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm.$t('button.cancelOrder')) + "\n                            ")]) : _vm._e(), _vm._v(" "), ((_vm.isZNB || _vm.is220 || _vm.isZRE) && _vm.canCancelEdiOrder) ? _c('el-button', {
	    staticClass: "small danger margin-b-10",
	    attrs: {
	      "loading": _vm.cancelLoading
	    },
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm.$t('button.cancelEDIOrder')) + "\n                            ")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "order-actions-bar"
	  }, [((_vm.isZNB || _vm.is220) && (_vm.isEdiConfirmed || _vm.isEdiProcessed || _vm.isAskoAndBilled) || (_vm.currentOrder.orderType != 'EDI')) ? _c('div', {
	    staticClass: "btn-group order-action-secondary"
	  }, [_c('button', {
	    staticClass: "btn info el-button",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.showPrintableDeliveryNote
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('button.showPrintableDeliveryNote')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    on: {
	      "click": _vm.toggleDropdownDelivery
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu",
	    class: {
	      show: _vm.dropdownStateDelivery
	    }
	  }, [_c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": _vm.showPrintableDeliveryNote
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                                     " + _vm._s(_vm.$t('button.showPrintableDeliveryNote')))]), _vm._v(" "), _c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": _vm.downloadPrintableDeliveryNote
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                                     " + _vm._s(_vm.$t('button.downloadPrintableDeliveryNote')))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "order-actions-primary"
	  }, [(_vm.currentOrder.orderStatus == 'confirmed' && _vm.currentOrder.orderType !== 'EDI') ? _c('div', [_c('el-checkbox', {
	    attrs: {
	      "label": _vm.$t('static.orders.orderConfirm.orderConfirmNotification')
	    },
	    model: {
	      value: (_vm.orderConfirmNotification),
	      callback: function($$v) {
	        _vm.orderConfirmNotification = $$v
	      },
	      expression: "orderConfirmNotification"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.canConfirmOrder) ? _c('el-button', {
	    attrs: {
	      "loading": _vm.currentOrder.orderType === 'EDI' && _vm.loadingConfirm,
	      "disabled": _vm.hasUnconfirmedOrderProduct
	    },
	    on: {
	      "click": _vm.confirm
	    }
	  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('button.confirm')) + "\n                                ")]) : _vm._e(), _vm._v(" "), ((_vm.currentOrder.orderStatus == 'confirmed' && !['EDI', 'Wordpress'].includes(_vm.currentOrder.orderType)) || (_vm.currentEdiOrder.ediOrderStatusName == 'confirmed' && _vm.currentOrder.orderType == 'EDI')) ? _c('el-button', {
	    attrs: {
	      "loading": _vm.loadingConfirm
	    },
	    on: {
	      "click": _vm.showConfirmModalShipping
	    }
	  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('button.shippingConfirm')) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.canCreateInvoice && _vm.currentOrder.orderType == 'EDI') ? _c('el-button', {
	    on: {
	      "click": _vm.createBill
	    }
	  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('button.createInvoice')) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.canCreateInvoice && _vm.currentOrder.orderType != 'EDI' && ['shipping_confirmed', 'picked', 'shipped', 'delivered'].includes(_vm.currentOrder.orderStatus)) ? _c('div', {
	    staticClass: "btn-group invoice-action-group"
	  }, [_c('button', {
	    staticClass: "btn info el-button",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.createBill
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.createInvoice')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    on: {
	      "click": _vm.toggleDropdownInvoice
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu",
	    class: {
	      show: _vm.dropdownStateInvoice
	    }
	  }, [_c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": _vm.createBill
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.createInvoice')))]), _vm._v(" "), _c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": _vm.invoiceExternal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.invoiceExternally')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.canConfirmAsOrdered) ? _c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn info el-button",
	    attrs: {
	      "disabled": _vm.hasUnconfirmedOrderProduct,
	      "type": "button"
	    },
	    on: {
	      "click": _vm.confirm
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.confirm')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    on: {
	      "click": _vm.toggleDropdown
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu",
	    class: {
	      show: _vm.dropdownState
	    },
	    on: {
	      "click": _vm.confirmAsOrdered
	    }
	  }, [_c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.confirmAsOrder')))])])], 1) : _vm._e()], 1)])]), _vm._v(" "), (_vm.currentOrder.orderStatus == 'invoiced_externally' && _vm.currentOrder.orderType != 'EDI') ? _c('el-col', {
	    attrs: {
	      "md": 8
	    }
	  }, [_c('el-button', {
	    staticClass: "small margin-b-10",
	    on: {
	      "click": _vm.createReturnOrder
	    }
	  }, [_vm._v("\n                              " + _vm._s(_vm.$t('button.createReturnOrder')) + "\n                            ")])], 1) : _vm._e()], 1)], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
	    staticClass: "blockmainWrapper",
	    attrs: {
	      "lg": 8
	    }
	  }, [_c('v-client-info', {
	    attrs: {
	      "currentEdiOrder": _vm.currentEdiOrder,
	      "client": _vm.currentClient
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    staticClass: "orderproductWrapper margin-t-10",
	    attrs: {
	      "lg": 24
	    }
	  }, [_c('div', {
	    staticClass: "order-lines-card"
	  }, [_c('h3', {
	    staticClass: "order-lines-title"
	  }, [_vm._v(_vm._s(_vm.$t('static.orders.orderLines')))]), _vm._v(" "), _c('el-row', [(_vm.currentOrder.orderType) ? _c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [(_vm.currentOrder.orderType === 'EDI') ? _c('v-edi-order-items-table', {
	    attrs: {
	      "order": _vm.currentOrder
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderType !== 'EDI') ? _c('v-products-table', {
	    attrs: {
	      "order": _vm.currentOrder
	    }
	  }) : _vm._e()], 1) : _vm._e()], 1)], 1)])], 1)], 1), _vm._v(" "), (!_vm.isCancelled && _vm.currentOrder.orderType == 'EDI' && this.currentEdiOrder.standard === 'stand') ? _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.orders.formTabs.deliveryNote'),
	      "name": "2"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 35
	    }
	  }, [(_vm.unassignedProducts.length > 0) ? _c('el-col', {
	    attrs: {
	      "lg": 14
	    }
	  }, [_c('el-card', {
	    staticClass: "box-card unassigned-products-card"
	  }, [_c('div', {
	    staticClass: "clearfix",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.orders.package.UnassignedProductCardTitle')))])]), _vm._v(" "), _c('div', {
	    staticClass: "text item"
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.unassignedProducts,
	      "border": "",
	      "stripe": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": _vm.$t('static.orders.package.unassignedTable.name'),
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "gtin",
	      "label": _vm.$t('static.orders.package.unassignedTable.gtin'),
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "quantityConfirmed",
	      "label": _vm.$t('static.orders.package.unassignedTable.quantityConfirmed')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "quantityPacked",
	      "label": _vm.$t('static.orders.package.unassignedTable.quantityPacked')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "quantityUnpacked",
	      "label": _vm.$t('static.orders.package.unassignedTable.quantityUnpacked')
	    }
	  })], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderType) ? _c('el-col', {
	    attrs: {
	      "lg": 10
	    }
	  }, [_c('el-card', {
	    staticClass: "box-card new-package-card"
	  }, [_c('div', {
	    staticClass: "clearfix",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.orders.package.newPackageCardTitle')))])]), _vm._v(" "), _c('div', {
	    staticClass: "text item"
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.packageForm,
	      "translation": "form.addEditPackage",
	      "hasLabel": true
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "loading": _vm.packageForm.loading,
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createPackage()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save')))]), _vm._v(" "), _c('v-message', {
	    attrs: {
	      "success": _vm.successMessage
	    }
	  })], 1)]), _vm._v(" "), _c('h2')], 1) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 35
	    }
	  }, [(_vm.currentOrder.orderType) ? _c('el-col', {
	    attrs: {
	      "lg": 24
	    }
	  }, [_c('div', {
	    staticClass: "flex items-center",
	    staticStyle: {
	      "justify-content": "space-between"
	    }
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('static.orders.edit.packageTitle')))]), _vm._v(" "), _c('div', {
	    staticClass: "flex justify-end"
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.selectedPaperSize),
	      callback: function($$v) {
	        _vm.selectedPaperSize = $$v
	      },
	      expression: "selectedPaperSize"
	    }
	  }, _vm._l((_vm.paperSizes), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.name,
	        "value": item.value
	      }
	    })
	  }), 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "margin": "3px 5px"
	    },
	    attrs: {
	      "type": "text",
	      "size": "small"
	    },
	    on: {
	      "click": _vm.downloadShippingLabel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-pdf-o"
	  }), _vm._v(" " + _vm._s(_vm.$t('static.orders.package.downloadAllShippingLabel')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "margin": "3px 5px"
	    },
	    attrs: {
	      "type": "text",
	      "size": "small"
	    },
	    on: {
	      "click": _vm.downloadPalletLabel
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-pdf-o"
	  }), _vm._v(" " + _vm._s(_vm.$t('static.orders.package.downloadProductMixLabel')))])], 1)]), _vm._v(" "), _c('v-manage-package', {
	    attrs: {
	      "order": _vm.currentOrder,
	      "packages": _vm.packages
	    }
	  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isCancelled && !_vm.isAppointmentCompleted && !['Wordpress'].includes(_vm.currentOrder.orderType) && !_vm.currentOrder.sent) ? _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.orders.formTabs.edit'),
	      "name": "3"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.orders",
	      "hasLabel": true
	    }
	  }), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save')))]), _vm._v(" "), _c('v-message', {
	    attrs: {
	      "success": _vm.successMessage
	    }
	  })], 1)], 1) : _vm._e()], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2931 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.unitOfMeasure.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.unitOfMeasure.basicInformation'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.unitOfMeasure",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'unitOfMeasure.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2932 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.products.index.exportData')))]), _vm._v(" "), [_c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "flex-direction": "column"
	    }
	  }, [_c('el-button', {
	    staticClass: "margin-b-20",
	    staticStyle: {
	      "width": "380px"
	    },
	    on: {
	      "click": _vm.downloadAllProducts
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('static.products.index.downloadAllProducts')) + "\n        ")])], 1)]], 2), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.products.index.importData')))]), _vm._v(" "), [_c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('file-pond', {
	    ref: "pond",
	    attrs: {
	      "name": " import_excel",
	      "label-idle": _vm.$t('static.products.index.importProducts'),
	      "allow-multiple": "false",
	      "server": _vm.server
	    }
	  })], 1)])]], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2933 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.productTags.create.title')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.productTags.formTabs.tagInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.productTags",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productTags.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2934 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "main-body"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('static.publicProfile.title')))]), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.profileUrl.length > 0 && !_vm.loading) ? _c('p', [_vm._v(_vm._s(_vm.$t('static.publicProfile.profileUrl')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.profileUrl))])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "save": _vm.save,
	      "translation": "form.publicProfile",
	      "hasLabel": true,
	      "labelWidth": "120px"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('static.publicProfile.businessHoursTitle')))]), _vm._v(" "), _c('v-open-hours'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('static.publicProfile.businessHourExceptionsTitle')))]), _vm._v(" "), _c('v-exceptional-hours')], 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2935 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flex sidebar-container"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fadeLeft"
	    }
	  }, [_c('div', {
	    staticClass: "sideMenu"
	  }, [_c('el-menu', {
	    staticClass: "el-menu-vertical-demo",
	    attrs: {
	      "default-active": _vm.activeMenu
	    },
	    on: {
	      "open": function($event) {},
	      "close": function($event) {}
	    }
	  }, [(_vm.account.organizationName) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_c('el-menu-item', {
	    attrs: {
	      "index": "2"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-tachometer",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.dashboard')))])])], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'profile.account'
	      }
	    }
	  }, [_c('el-menu-item', {
	    attrs: {
	      "index": "3"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.profile')))])])], 1), _vm._v(" "), _c('router-link', {
	    class: {
	      'router-link-active': _vm.$route.name && (_vm.$route.name.split('.')[0] == 'clients' || _vm.$route.name.split('.')[0] == 'clientGroups' || _vm.$route.name.split('.')[0] == 'pricingAgreements')
	    },
	    attrs: {
	      "to": {
	        name: 'clients.index',
	        query: {
	          filter: 'active'
	        }
	      }
	    }
	  }, [(_vm.hasModule('Client') && _vm.isVerified) ? _c('el-menu-item', {
	    attrs: {
	      "index": "4"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-users",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.clients')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
	    class: {
	      'router-link-active': _vm.$route.name.split('.')[0] == 'production'
	    },
	    attrs: {
	      "to": {
	        name: 'production.batches.index',
	        query: {
	          filter: 'all'
	        }
	      }
	    }
	  }, [(_vm.hasModule('Production') && _vm.isVerified) ? _c('el-menu-item', {
	    attrs: {
	      "index": "5"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-industry",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.production')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
	    class: {
	      'router-link-active': _vm.$route.name.split('.')[0] == 'products'
	    },
	    attrs: {
	      "to": {
	        name: 'products.index',
	        query: {
	          filter: 'active'
	        }
	      }
	    }
	  }, [(_vm.hasModule('Product') && _vm.isVerified) ? _c('el-menu-item', {
	    attrs: {
	      "index": "5"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.products')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
	    class: {
	      'router-link-active': _vm.$route.name.split('.')[0] == 'appointments'
	    },
	    attrs: {
	      "to": {
	        name: 'orders.index',
	        query: {
	          filter: 'created'
	        }
	      }
	    }
	  }, [((_vm.hasModule('EDI') || _vm.hasModule('Appointment')) && _vm.isVerified) ? _c('el-menu-item', {
	    attrs: {
	      "index": "6"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.orders')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'bills.index'
	      }
	    }
	  }, [((_vm.hasModule('EDI') || _vm.hasModule('Appointment')) && _vm.isVerified) ? _c('el-menu-item', {
	    attrs: {
	      "index": "7"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-money",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.bills')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'members.index'
	      }
	    }
	  }, [(_vm.hasModule('Appointment') && _vm.isVerified) ? _c('el-menu-item', {
	    attrs: {
	      "index": "8"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.members')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'membership.index'
	      }
	    }
	  }, [(!_vm.account.organizationName && _vm.account.organizationMembers.length > 0) ? _c('el-menu-item', {
	    attrs: {
	      "index": "9"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user-plus",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', [_vm._v("Membership")])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'campaigns.index'
	      }
	    }
	  }, [(_vm.hasModule('Appointment') && _vm.isVerified) ? _c('el-menu-item', {
	    attrs: {
	      "index": "9"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-envelope-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.newsletter')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
	    class: {
	      'router-link-active': _vm.$route.name.split('.')[0] == 'inventory'
	    },
	    attrs: {
	      "to": {
	        name: 'warehouse.index',
	        query: {
	          filter: 'active'
	        }
	      }
	    }
	  }, [(_vm.hasModule('Inventory') && _vm.isVerified) ? _c('el-menu-item', {
	    attrs: {
	      "index": "12"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-archive",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.inventory')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'reports'
	      }
	    }
	  }, [((_vm.hasModule('EDI') || _vm.hasModule('Appointment')) && _vm.isVerified) ? _c('el-menu-item', {
	    attrs: {
	      "index": "13"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bar-chart",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.reports')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'application.settings'
	      }
	    }
	  }, [((_vm.hasModule('EDI') || _vm.hasModule('Appointment')) && _vm.isVerified) ? _c('el-menu-item', {
	    attrs: {
	      "index": "14"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cog",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.settings')))])]) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
	    ref: "sidebar",
	    staticClass: "side-subMenu"
	  }, [_vm._l((_vm.innerSidebar), function(section, index) {
	    return [(section.title) ? _c('div', {
	      key: index
	    }, [_c('h4', [_vm._v(_vm._s(section.title))]), _vm._v(" "), _c('ul', _vm._l((section.options), function(item, index) {
	      return _c('router-link', {
	        key: index,
	        class: {
	          'active': (JSON.stringify(item.route.query) || '{}') === JSON.stringify(_vm.$route.query) && item.route.name === _vm.$route.name, 'disabled': _vm.innerSidebarDisabled
	        },
	        attrs: {
	          "to": item.route
	        }
	      }, [_c('li', [_vm._v(_vm._s(item.title) + " "), (item.detail) ? _c('span', [_vm._v(_vm._s(item.detail))]) : _vm._e()])])
	    }), 1), _vm._v(" "), (section.button) ? _c('router-link', {
	      class: {
	        disabled: _vm.innerSidebarDisabled
	      },
	      attrs: {
	        "to": section.button.route
	      }
	    }, [_c('el-button', {
	      attrs: {
	        "type": "primary"
	      }
	    }, [_vm._v(_vm._s(section.button.title))])], 1) : _vm._e(), _vm._v(" "), (index < _vm.innerSidebar.length - 1) ? _c('hr') : _vm._e()], 1) : _vm._e()]
	  }), _vm._v(" "), _c('span', {
	    staticClass: "fa fa-close side-subMenu__close-btn hide-desktop",
	    on: {
	      "click": function($event) {
	        return _vm.toggleSidebar(false)
	      }
	    }
	  })], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2936 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')))]), _vm._v(" "), (!_vm.settings.hasFikenToken) ? _c('p', [_vm._v(_vm._s(_vm.$t('static.module.fiken.intro')))]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.settings.hasFikenToken) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "static.module.fiken",
	      "hasLabel": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div')], 1)], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.authorize
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.subscribe').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2937 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.supplier.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.supplier.basicInformation'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.supplier",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.supplier.contactInformation'),
	      "name": "second"
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formContactInformation,
	      "translation": "form.supplier",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.supplier.AddressInformation'),
	      "name": "third"
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formAddressInformation,
	      "translation": "form.supplier",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'supplier.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2938 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.productGroups.index.title')) + " (" + _vm._s(_vm.productGroups.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": _vm.$t('sort.placeholder')
	    },
	    model: {
	      value: (_vm.sort),
	      callback: function($$v) {
	        _vm.sort = $$v
	      },
	      expression: "sort"
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.productGroups.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.productGroup.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productGroups.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.productGroup.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.productGroups.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editProductGroup(p)
	        }
	      }
	    }, [_c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.goToProducts(p.id, $event)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "cardLabel"
	    }, [_vm._v("(" + _vm._s(p.productsCount) + " " + _vm._s(_vm.$t('static.productGroups.index.productsCount')) + ")")])]), _vm._v(" "), _c('hr'), _vm._v(" "), (p.description) ? _c('div', {
	      staticClass: "cardinnerBox"
	    }, [_c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-file-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(p.description))])])]) : _vm._e()])
	  })], 2)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.productGroups.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2939 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 2940 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.batches.index.title')) + " (" + _vm._s(_vm.batches.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('el-button-group', [_c('el-button', {
	    attrs: {
	      "type": _vm.primary,
	      "size": "small",
	      "icon": "el-icon-menu",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('info')
	      }
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": _vm.info,
	      "size": "small",
	      "icon": "el-icon-tickets",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('primary')
	      }
	    }
	  })], 1), _vm._v(" "), _c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search,
	      "clearable": true
	    },
	    on: {
	      "keydown": _vm.onChangeSearch
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": _vm.$t('sort.placeholder')
	    },
	    model: {
	      value: (_vm.sort),
	      callback: function($$v) {
	        _vm.sort = $$v
	      },
	      expression: "sort"
	    }
	  })], 1)])], 1), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.batches.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.batch.noDataMsg')) + "\n        "), (!_vm.bridgeStockWriteBlocked) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'production.batches.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.batch.noDataBtn')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batches.items), function(m, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.viewBatch(m)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel"
	    }, [_c('span', {
	      staticClass: "cardBadge"
	    }, [_vm._v(_vm._s(_vm.$t(("static.batches.statuses." + (m.status)))))])]), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [(m.status !== 'planned') ? _c('span', [_vm._v(_vm._s(m.batchNumber) + ":")]) : _vm._e(), _vm._v(_vm._s(m.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), (m.plannedStartingDate && m.status === 'planned') ? _c('div', {
	      staticClass: "cardinnerBox"
	    }, [_vm._v("\n          " + _vm._s(_vm.$t('static.batches.view.plannedStartingDate')) + "\n          "), _c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-calendar",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(m.plannedStartingDate))])])]) : _vm._e(), _vm._v(" "), (m.startDate && (m.status !== 'planned' && m.status !== 'completed')) ? _c('div', {
	      staticClass: "cardinnerBox"
	    }, [_vm._v("\n          " + _vm._s(_vm.$t('static.batches.view.startDate')) + "\n          "), _c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-calendar",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(m.startDate))])])]) : _vm._e(), _vm._v(" "), (m.description) ? _c('div', {
	      staticClass: "cardinnerBox"
	    }, [_c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-file-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(m.description))])])]) : _vm._e()])
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('v-table', {
	    attrs: {
	      "list": _vm.batchesListView,
	      "noDataMessage": _vm.$t('static.defaultText.batch.noDataMsg'),
	      "link": _vm.viewBatch,
	      "linkKey": "name",
	      "rowKey": "id",
	      "translation": "static.batches.table"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "pagination": _vm.batches.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2941 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "chart-contaier"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'orders.index',
	        query: {
	          filter: 'created'
	        }
	      }
	    }
	  }, [(_vm.loaded) ? _c('div', {
	    staticClass: "waiting-processed"
	  }, [_c('div', {
	    staticClass: "number-container"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.number) + " "), _c('i', {
	    staticClass: "el-icon-download"
	  })])])]) : _c('div', {
	    staticClass: "loading"
	  }, [_c('i', {
	    staticClass: "el-icon-loading"
	  })])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2942 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle",
	    class: {
	      'pageTitle--dark': !_vm.isInOwnRoute
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clientGroups.create.title')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [(_vm.isInOwnRoute) ? _c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.productGroups.formTabs.groupInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.clientGroups",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1) : _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.clientGroups",
	      "hasLabel": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [(_vm.isInOwnRoute) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'clientGroups.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
	    class: {
	      'outline': _vm.isInOwnRoute
	    },
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2943 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.exportBill.title')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.bills.exportBill.title'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "sm": 8
	    }
	  }, [_c('el-button', {
	    staticClass: "small dark-outline",
	    on: {
	      "click": _vm.showExportModal
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.bills.exportBill.btn')) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [_c('v-table', {
	    attrs: {
	      "list": _vm.dataList,
	      "noDataMessage": _vm.$t('static.bills.exportBill.download.noData'),
	      "link": _vm.downloadBillReport,
	      "linkKey": "download",
	      "rowKey": "id,date_start,date_stop",
	      "buttons": _vm.buttons,
	      "translation": "static.bills.exportBill.download"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('static.bills.message.title'),
	      "visible": _vm.dialogVisible,
	      "width": "30%",
	      "before-close": _vm.handleClose
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogVisible = $event
	      }
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.bills.message.delete')))]), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.dialogVisible = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.deleted
	    }
	  }, [_vm._v("Confirm")])], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2944 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "chart-contaier"
	  }, [_c('div', {
	    staticClass: "widgets-addition-action"
	  }, [_c('el-select', {
	    staticClass: "widget-filterBy",
	    attrs: {
	      "placeholder": "Select",
	      "size": "small"
	    },
	    on: {
	      "change": function($event) {
	        return _vm.updateChart($event)
	      }
	    },
	    model: {
	      value: (_vm.filterBySelected),
	      callback: function($$v) {
	        _vm.filterBySelected = $$v
	      },
	      expression: "filterBySelected"
	    }
	  }, _vm._l((_vm.filterBy), function(item, key) {
	    return _c('el-option', {
	      key: key,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1)], 1), _vm._v(" "), (_vm.loaded) ? _c('bar-chart', {
	    attrs: {
	      "chartdata": _vm.chartdata,
	      "options": _vm.options
	    }
	  }) : _c('div', {
	    staticClass: "loading"
	  }, [_c('i', {
	    staticClass: "el-icon-loading"
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2945 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "main-body"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('static.profileContact.title')))]), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "save": _vm.save,
	      "translation": "form.profileContact",
	      "hasLabel": true,
	      "labelWidth": "150px"
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2946 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 2947 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.view.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.stock.view.details'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.stock.view.detailsLegend')))]), _vm._v(" "), [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.info.code')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentStock.code) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.info.warehouse')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentStock.warehouse.name) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.info.qty')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentStock.total_qty) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.info.createdAt')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentStock.createdAt) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.info.transactionDate')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentStock.transactionDate) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.info.status')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentStock.status) + "\n                  ")])])]], 2)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.stock.view.products'),
	      "name": "products"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.stock.view.productsLegend')))]), _vm._v(" "), _c('v-table', {
	    attrs: {
	      "list": _vm.productList,
	      "noDataMessage": _vm.$t('static.stock.noData'),
	      "translation": "static.stock.products"
	    }
	  })], 1)])], 1)], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2948 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-row', {
	    staticClass: "bulk-product-add"
	  }, [_c('el-col', {
	    staticClass: "text-right",
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-button', {
	    staticClass: "small dark",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.cancel')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small btn-add-bulk",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "disabled": _vm.disableSubmit(),
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.handleSubmit
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.destroy')))])], 1), _vm._v(" "), _c('el-col', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "span": 24
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.bulkDestroyProducts.title')))]), _vm._v(" "), _c('el-table', {
	    staticClass: "selected-products",
	    staticStyle: {
	      "width": "100%",
	      "margin-bottom": "10px"
	    },
	    attrs: {
	      "data": _vm.selected,
	      "empty-text": _vm.$t('static.bulkDestroyProducts.noneSelected')
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bulkDestroyProducts.name')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v("\n            " + _vm._s(scope.row.name) + "\n          ")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bulkDestroyProducts.available')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(scope.row.qty))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bulkDestroyProducts.batch')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(scope.row.batchId))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bulkDestroyProducts.qtyToDestroy'),
	      "width": "170"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-input-number', {
	          ref: ("input" + (scope.$index)),
	          staticStyle: {
	            "width": "150px"
	          },
	          attrs: {
	            "min": -999999,
	            "max": scope.row.qtyNumber
	          },
	          model: {
	            value: (scope.row.selectedQty),
	            callback: function($$v) {
	              _vm.$set(scope.row, "selectedQty", $$v)
	            },
	            expression: "scope.row.selectedQty"
	          }
	        })]
	      }
	    }])
	  })], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2949 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "totals-container"
	  }, [_c('el-col', {
	    attrs: {
	      "xs": {
	        span: 24,
	        offset: 0
	      },
	      "sm": {
	        span: 12,
	        offset: 12
	      }
	    }
	  }, _vm._l((_vm.list), function(item, i) {
	    return _c('el-row', {
	      key: i,
	      staticClass: "summary",
	      class: {
	        'summary--total': i === _vm.list.length - 1
	      }
	    }, [_c('el-col', {
	      staticClass: "cell-heading",
	      attrs: {
	        "span": 12
	      }
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('el-col', {
	      staticClass: "cell-content",
	      attrs: {
	        "span": 12
	      }
	    }, [_vm._v(_vm._s(item.value))])], 1)
	  }), 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2950 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('v-form-table', {
	    staticClass: "product-table",
	    attrs: {
	      "form": _vm.form,
	      "list": _vm.prices,
	      "create": _vm.save,
	      "update": _vm.update,
	      "destroy": _vm.destroy,
	      "translation": "table.products",
	      "clickHandler": _vm.tableClickHandler
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2951 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "chart-contaier"
	  }, [_c('div', {
	    staticClass: "widgets-addition-action"
	  }, [_c('el-select', {
	    staticClass: "widget-filterBy",
	    attrs: {
	      "placeholder": "Select",
	      "size": "small"
	    },
	    on: {
	      "change": function($event) {
	        return _vm.updateChart($event)
	      }
	    },
	    model: {
	      value: (_vm.filterBySelected),
	      callback: function($$v) {
	        _vm.filterBySelected = $$v
	      },
	      expression: "filterBySelected"
	    }
	  }, _vm._l((_vm.filterBy), function(item, key) {
	    return _c('el-option', {
	      key: key,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1)], 1), _vm._v(" "), (_vm.loaded) ? _c('line-chart', {
	    attrs: {
	      "chartData": _vm.chartdata,
	      "options": _vm.options
	    }
	  }) : _c('div', {
	    staticClass: "loading"
	  }, [_c('i', {
	    staticClass: "el-icon-loading"
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2952 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orderPickups.title')) + " (" + _vm._s(_vm.orderPickups.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm order-pickup-status-search",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search,
	      "clearable": true
	    },
	    on: {
	      "keydown": _vm.onChangeSearch
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('static.orderPickups.filter.label')) + " ")]), _vm._v(" "), _c('v-select', {
	    staticClass: "order-pickups-shipping-providers",
	    attrs: {
	      "name": "shippingProvider",
	      "options": _vm.shippingProviderOptions,
	      "value": _vm.shippingProvider
	    },
	    on: {
	      "change": _vm.onChange
	    }
	  }), _vm._v(" "), _c('v-select', {
	    attrs: {
	      "name": "status",
	      "options": _vm.statusOptions,
	      "value": _vm.status
	    },
	    on: {
	      "change": _vm.onChange
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('el-table', {
	    ref: "orderPickupData",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "header-row-class-name": "order-pickups-head",
	      "row-class-name": "order-pickups-row",
	      "default-expand-all": _vm.defaulExpand,
	      "empty-text": _vm.$t('static.orderPickups.table.noData'),
	      "data": _vm.orderPickupTable
	    },
	    on: {
	      "row-click": _vm.rowClicked
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "expand"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-row', {
	          attrs: {
	            "gutter": 10
	          }
	        }, [_c('el-col', {
	          staticStyle: {
	            "padding-bottom": "6px"
	          },
	          attrs: {
	            "xs": 24,
	            "md": 12
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-link",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('static.orderPickups.table.number')) + ":")]), _vm._v(" "), _c('router-link', {
	          attrs: {
	            "to": ("/orders/" + (props.row.orderId) + "/edit")
	          }
	        }, [_vm._v(_vm._s((props.row.number) ? props.row.number : _vm.$t('static.orderPickups.table.missing')))])], 1), _vm._v(" "), (props.row.deletedAt) ? _c('el-col', {
	          staticStyle: {
	            "padding-bottom": "6px"
	          },
	          attrs: {
	            "xs": 24,
	            "md": 12
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-calendar",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('static.orderPickups.table.createdAt')) + ":")]), _vm._v(" " + _vm._s((props.row.createdAt) ? props.row.createdAt : _vm.$t('static.orderPickups.table.missing')))]) : _c('el-col', {
	          staticStyle: {
	            "padding-bottom": "6px"
	          },
	          attrs: {
	            "xs": 24,
	            "md": 12
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-calendar",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('static.orderPickups.table.createdAt')) + ":")]), _vm._v(" " + _vm._s((props.row.createdAt) ? props.row.createdAt : _vm.$t('static.orderPickups.table.missing')))]), _vm._v(" "), _c('el-col', {
	          staticStyle: {
	            "padding-bottom": "6px"
	          },
	          attrs: {
	            "xs": 24,
	            "md": 12
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-calendar",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('static.orderPickups.table.pickupDate')))]), _vm._v(" " + _vm._s((props.row.pickupDate) ? props.row.pickupDate : _vm.$t('static.orderPickups.table.missing')))]), _vm._v(" "), _c('el-col', {
	          staticStyle: {
	            "padding-bottom": "6px"
	          },
	          attrs: {
	            "xs": 24,
	            "md": 12
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-user",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('static.orderPickups.table.pickupBy')) + ":")]), _vm._v(" " + _vm._s((props.row.pickupBy) ? props.row.pickupBy : _vm.$t('static.orderPickups.table.missing')))]), _vm._v(" "), _c('el-col', {
	          staticStyle: {
	            "padding-bottom": "6px"
	          },
	          attrs: {
	            "xs": 24,
	            "md": 12
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-truck",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('static.orderPickups.table.shippingProvider')) + ":")]), _vm._v(" " + _vm._s((props.row.shippingProvider) ? props.row.shippingProvider : _vm.$t('static.orderPickups.table.missing')))]), _vm._v(" "), _c('el-col', {
	          staticStyle: {
	            "padding-bottom": "6px"
	          },
	          attrs: {
	            "xs": 24,
	            "md": 12
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-calendar",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('static.orderPickups.table.shippingDate')) + ":")]), _vm._v(" " + _vm._s((props.row.shippingDate) ? props.row.shippingDate : _vm.$t('static.orderPickups.table.missing')))]), _vm._v(" "), _c('el-col', {
	          staticStyle: {
	            "padding-bottom": "6px"
	          },
	          attrs: {
	            "xs": 24,
	            "md": 12
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-calendar",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('static.orderPickups.table.tracking')) + ": ")]), _vm._v(" "), (props.row.trackingUrl) ? _c('a', {
	          attrs: {
	            "href": ("" + (props.row.trackingUrl)),
	            "target": "_blank"
	          }
	        }, [_vm._v(_vm._s(_vm.$t('static.orderPickups.table.openTracking')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('static.orderPickups.table.noTracking')))])]), _vm._v(" "), _c('el-col', {
	          staticStyle: {
	            "padding-bottom": "6px"
	          },
	          attrs: {
	            "xs": 24,
	            "md": 12
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-calendar",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('static.orderPickups.table.deliveryDate')) + ":")]), _vm._v(" " + _vm._s((props.row.deliveryDate) ? props.row.deliveryDate : _vm.$t('static.orderPickups.table.missing')))])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.orderPickups.tableHead.order'),
	      "sortable": "",
	      "prop": "number",
	      "width": "80"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.orderPickups.tableHead.status'),
	      "sortable": "",
	      "prop": "shippingStatus",
	      "width": "100"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.orderPickups.tableHead.customer'),
	      "sortable": "",
	      "prop": "customerName"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.orderPickups.tableHead.shippingProvider'),
	      "sortable": "",
	      "prop": "shippingProvider",
	      "width": "250"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.orderPickups.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2953 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')))]), _vm._v(" "), (!_vm.settings.hasVismaToken) ? _c('p', [_vm._v(_vm._s(_vm.$t('static.module.visma.intro')))]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.settings.hasVismaToken) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "static.module.visma",
	      "hasLabel": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div')], 1)], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.authorize
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.subscribe').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2954 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "widht": "100%",
	      "height": "100vh"
	    }
	  }, [_c('br'), _c('br')]) : _c('router-view')
	},staticRenderFns: []}

/***/ }),
/* 2955 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-row', [_c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-row', {
	    staticClass: "margin-b-10 margin-10 padding-t-20",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    staticClass: "ml-3",
	    attrs: {
	      "sm": 8
	    }
	  }, [_c('div', {
	    staticClass: "filter-group"
	  }, [_c('span', {
	    staticClass: "margin-b-10"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('static.exciseEntry.filters.label')) + ":\n            ")]), _vm._v(" "), _c('v-form', {
	    staticClass: "excise-entry-filters",
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.exciseEntry",
	      "hasLabel": true,
	      "inline": true
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    staticClass: "margin-b-10 margin-10",
	    attrs: {
	      "gutter": 24
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('el-col', {
	    attrs: {
	      "sm": 24
	    }
	  }, [_c('v-excise-table', {
	    attrs: {
	      "list": _vm.entries,
	      "noDataMessage": _vm.$t('static.defaultText.exciseEntry.noDataMsg'),
	      "translation": "static.exciseEntry.table",
	      "loading": _vm.loading,
	      "update_list": _vm.updateList,
	      "link": _vm.openLink
	    }
	  })], 1)], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "pagination": _vm.pagination,
	      "sizePerPage": _vm.perPage,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2956 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('static.license.add')))]), _vm._v(" "), _c('el-row', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "gutter": 5
	    }
	  }, [_c('el-col', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "save": _vm.save,
	      "form": _vm.form,
	      "translation": "form.license",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2957 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-pagination', {
	    attrs: {
	      "page-sizes": _vm.pageSizes,
	      "page-size": _vm.pagination.limit,
	      "layout": "sizes, prev, pager, next",
	      "total": _vm.pagination.totalCount
	    },
	    on: {
	      "size-change": _vm.handleSizeChange,
	      "current-change": _vm.handleCurrentChange
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2958 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('form.wooCredentialsModal.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('div', [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('form.wooCredentialsModal.title')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    staticStyle: {
	      "margin-top": "15px"
	    },
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.wooCredentialsModal",
	      "hasLabel": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('fieldset', {
	    staticClass: "margin-b-10"
	  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.wooCredentialsModal.kundanWordpressPluginToken')))]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('el-input', {
	    ref: "tokenInput",
	    staticClass: "input-with-icon margin-b-10",
	    attrs: {
	      "readonly": ""
	    },
	    model: {
	      value: (_vm.token),
	      callback: function($$v) {
	        _vm.token = $$v
	      },
	      expression: "token"
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "padding": "12px 20px",
	      "margin-right": "-7px"
	    },
	    attrs: {
	      "slot": "append",
	      "loading": _vm.generateTokenLoading
	    },
	    on: {
	      "click": _vm.generateToken
	    },
	    slot: "append"
	  }, [_vm._v("Generate")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "padding": "12px 20px"
	    },
	    attrs: {
	      "slot": "append"
	    },
	    on: {
	      "click": _vm.copyToken
	    },
	    slot: "append"
	  }, [_vm._v("Copy")])], 1)], 1)])], 1)])], 1), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [_c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.cancel').toUpperCase()) + "\n      ")]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.save').toUpperCase()) + "\n      ")])], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2959 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle pageTitle--light"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n         "), (_vm.batch.status !== 'planned' && _vm.batch.batchNumber) ? _c('span', [_vm._v("#" + _vm._s(_vm.batch.batchNumber) + ":")]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.batch.name ? _vm.batch.name : _vm.$t('static.batches.view.title')) + "\n      ")])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.batches.formTabs.details'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 12
	    }
	  }, [_c('h3', [_c('i', {
	    staticClass: "fa fa-info-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              " + _vm._s(_vm.batch.status ? _vm.$t(("static.batches.statuses." + (_vm.batch.status))) : ' ') + "\n              "), ((_vm.batch.status === 'planned' || _vm.batch.status === 'started') && _vm.batch.recipe.procedures.length === 0) ? _c('el-button', {
	    staticStyle: {
	      "margin-left": "auto",
	      "padding": "7px 12px"
	    },
	    attrs: {
	      "loading": _vm.startBatchloading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.startBatch('started')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.batches.view.startBatch.title')))]) : _vm._e(), _vm._v(" "), (_vm.batch.status !== 'completed') ? _c('el-button', {
	    staticStyle: {
	      "margin-left": "auto",
	      "padding": "7px 12px"
	    },
	    attrs: {
	      "loading": _vm.completeBatchloading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.completeBatch()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.batches.view.completeBatch.title')))]) : _vm._e()], 1), _vm._v(" "), (_vm.batch.plannedStartingDate && _vm.batch.status === 'planned') ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small margin-r-10"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                " + _vm._s(_vm.$t('static.batches.view.plannedStartingDate')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                " + _vm._s(_vm.batch.plannedStartingDate) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.batch.startDate) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small margin-r-10"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                " + _vm._s(_vm.$t('static.batches.view.startDate')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                " + _vm._s(_vm.batch.startDate) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.batch.endDate && _vm.batch.status === 'completed') ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small margin-r-10"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                " + _vm._s(_vm.$t('static.batches.view.endDate')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                " + _vm._s(_vm.batch.startDate) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.batch.bestBeforeDate) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                " + _vm._s(_vm.$t('static.batches.view.bestBeforeDate')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                " + _vm._s(_vm.batch.bestBeforeDate) + "\n              ")])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 12
	    }
	  }, [(_vm.ongoingProcedures.length) ? _c('fieldset', {
	    staticClass: "margin-b-20 margin-t-10",
	    staticStyle: {
	      "padding-top": "15px"
	    }
	  }, [_c('legend', [_c('b', [_vm._v(_vm._s(_vm.$t('static.batches.view.ongoingProcedures')))])]), _vm._v(" "), _vm._l((_vm.ongoingProcedures), function(procedure) {
	    return _c('el-card', {
	      key: procedure.id,
	      staticClass: "box-card margin-b-10",
	      staticStyle: {
	        "width": "100%"
	      },
	      attrs: {
	        "shadow": "never"
	      }
	    }, [_c('div', {
	      staticClass: "flex",
	      attrs: {
	        "slot": "header"
	      },
	      slot: "header"
	    }, [_c('span', [(procedure.step) ? _c('b', {
	      staticStyle: {
	        "font-weight": "700"
	      }
	    }, [_vm._v(_vm._s(_vm.$t('static.recipes.edit.step')) + "\n                      " + _vm._s(procedure.step) + " -")]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(procedure.name))])]), _vm._v(" "), (_vm.batch.status !== 'completed') ? _c('el-button', {
	      staticStyle: {
	        "margin-left": "auto",
	        "padding": "7px 12px"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.setProcedureStatus(procedure.id, 'completed')
	        }
	      }
	    }, [_vm._v("Complete")]) : _vm._e()], 1), _vm._v(" "), (procedure.ingrediences.length) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.ingrediences')) + " ")]) : _vm._e(), _vm._v(" "), _vm._l((procedure.ingrediences), function(ingredience) {
	      return (procedure.ingrediences) ? _c('li', {
	        key: ingredience.id,
	        staticClass: "text item"
	      }, [_c('b', [_vm._v(_vm._s(ingredience.materialName))]), _vm._v(" - " + _vm._s(ingredience.amount) + " " + _vm._s(ingredience.unitMeasure) + "\n                ")]) : _vm._e()
	    }), _vm._v(" "), (procedure.equipment) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.equipment')))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(_vm._s(procedure.equipment))])], 2)
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.upcomingProcedures.length) ? _c('fieldset', {
	    staticClass: "margin-b-10 margin-t-10",
	    staticStyle: {
	      "padding-top": "15px"
	    }
	  }, [_c('legend', [_c('b', [_vm._v(_vm._s(_vm.$t('static.batches.view.upcomingProcedures')))])]), _vm._v(" "), _vm._l((_vm.upcomingProcedures), function(procedure) {
	    return _c('el-card', {
	      key: procedure.id,
	      staticClass: "box-card margin-b-10",
	      staticStyle: {
	        "width": "100%"
	      },
	      attrs: {
	        "shadow": "never"
	      }
	    }, [_c('div', {
	      staticClass: "flex",
	      attrs: {
	        "slot": "header"
	      },
	      slot: "header"
	    }, [_c('span', [(procedure.step) ? _c('b', {
	      staticStyle: {
	        "font-weight": "700"
	      }
	    }, [_vm._v(_vm._s(_vm.$t('static.recipes.edit.step')) + "\n                      " + _vm._s(procedure.step) + " -")]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(procedure.name))])]), _vm._v(" "), (_vm.batch.status !== 'completed') ? _c('el-button', {
	      staticClass: "dark",
	      staticStyle: {
	        "margin-left": "auto",
	        "padding": "7px 12px"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.batch.status !== 'ongoing' ? _vm.confirmProcedureStart(procedure.id, 'started') : _vm.setProcedureStatus(procedure.id, 'started')
	        }
	      }
	    }, [_vm._v("Start")]) : _vm._e()], 1), _vm._v(" "), (procedure.ingrediences.length) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.ingrediences')) + " ")]) : _vm._e(), _vm._v(" "), _vm._l((procedure.ingrediences), function(ingredience) {
	      return (procedure.ingrediences) ? _c('li', {
	        key: ingredience.id,
	        staticClass: "text item"
	      }, [_c('b', [_vm._v(_vm._s(ingredience.materialName))]), _vm._v(" - " + _vm._s(ingredience.amount) + " " + _vm._s(ingredience.unitMeasure) + "\n                ")]) : _vm._e()
	    }), _vm._v(" "), (procedure.equipment) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.equipment')))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(_vm._s(procedure.equipment))])], 2)
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.completedProcedures.length) ? _c('fieldset', {
	    staticClass: "margin-b-10 margin-t-10",
	    staticStyle: {
	      "padding-top": "15px"
	    }
	  }, [_c('legend', [_c('b', [_vm._v(_vm._s(_vm.$t('static.batches.view.completedProcedures')))])]), _vm._v(" "), _vm._l((_vm.completedProcedures), function(procedure) {
	    return _c('el-card', {
	      key: procedure.id,
	      staticClass: "box-card margin-b-10",
	      staticStyle: {
	        "width": "100%"
	      },
	      attrs: {
	        "shadow": "never"
	      }
	    }, [_c('div', {
	      staticClass: "clearfix",
	      attrs: {
	        "slot": "header"
	      },
	      slot: "header"
	    }, [_c('span', [(procedure.step) ? _c('b', {
	      staticStyle: {
	        "font-weight": "700"
	      }
	    }, [_vm._v(_vm._s(_vm.$t('static.recipes.edit.step')) + "\n                      " + _vm._s(procedure.step) + " -")]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(procedure.name))])])]), _vm._v(" "), (procedure.ingrediences.length) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.ingrediences')) + " ")]) : _vm._e(), _vm._v(" "), _vm._l((procedure.ingrediences), function(ingredience) {
	      return (procedure.ingrediences) ? _c('li', {
	        key: ingredience.id,
	        staticClass: "text item"
	      }, [_c('b', [_vm._v(_vm._s(ingredience.materialName))]), _vm._v(" - " + _vm._s(ingredience.amount) + " " + _vm._s(ingredience.unitMeasure) + "\n                ")]) : _vm._e()
	    }), _vm._v(" "), (procedure.equipment) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.equipment')))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(_vm._s(procedure.equipment))])], 2)
	  })], 2) : _vm._e()]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 12
	    }
	  }, [_c('fieldset', {
	    staticStyle: {
	      "padding-top": "15px"
	    }
	  }, [_c('legend', [_vm._v("Bevegelser")]), _vm._v(" "), (!_vm.bridgeStockWriteBlocked) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.transfer.create',
	        query: {
	          batch: _vm.batch.id
	        }
	      }
	    }
	  }, [_vm._v("\n                 "), (_vm.batch.status !== 'planned') ? _c('el-button', {
	    staticClass: "small margin-b-10"
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.batches.view.createBatchTransfer')) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-form-table', {
	    staticClass: "batches-table",
	    attrs: {
	      "form": _vm.form,
	      "list": _vm.tranferProducts,
	      "update": _vm.update,
	      "noResultWarningText": "No Result",
	      "translation": "form.batch",
	      "hiddenFields": ['id']
	    }
	  })], 1)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.batches.formTabs.edit'),
	      "name": "2"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "save": _vm.updateBatch,
	      "form": _vm.formBatchEdit,
	      "translation": "form.batches",
	      "hasLabel": true
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.batches.formTabs.materials'),
	      "name": "3"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.materialsLoading),
	      expression: "materialsLoading"
	    }],
	    attrs: {
	      "form": _vm.formIngredience,
	      "list": _vm.ingredienceList,
	      "update": _vm.updateIngredience,
	      "destroy": _vm.destroyIngredience,
	      "hiddenFields": _vm.hiddenFields,
	      "disabledRows": _vm.disabledItems,
	      "disableForm": _vm.disableForm,
	      "noResultWarningText": _vm.$t('table.recipeIngrediences.noResult'),
	      "translation": "table.recipeIngrediences",
	      "clickHandler": _vm.tableClickHandler,
	      "clickHandlerIcon": "fa fa-plus-circle",
	      "additionalButtons": _vm.additionalButtons
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.batches.formTabs.log'),
	      "name": "4"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [_c('el-button', {
	    staticClass: " margin-b-10 small",
	    on: {
	      "click": _vm.addBatchLog
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.batches.logs.add')))]), _vm._v(" "), _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.logs) ? _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.logs.items
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "timestamp",
	      "label": "Tid"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "description",
	      "label": "Detaljer"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "userFullname",
	      "label": "Bruker"
	    }
	  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "pagination": _vm.logs.pagination,
	      "switchFunction": _vm.fetchBatchLogs
	    }
	  })], 1)])], 1)], 1)], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2960 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.productTags.index.title')) + " (" + _vm._s(_vm.productTags.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": _vm.$t('sort.placeholder')
	    },
	    model: {
	      value: (_vm.sort),
	      callback: function($$v) {
	        _vm.sort = $$v
	      },
	      expression: "sort"
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.productTags.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.productTags.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productTags.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.productTags.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.productTags.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editproductTag(p)
	        }
	      }
	    }, [_c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(p.tag))]), _vm._v(" "), _c('span', {
	      staticClass: "cardLabel"
	    }, [_vm._v("(" + _vm._s(p.productCount) + " " + _vm._s(_vm.$t('static.productGroups.index.productsCount')) + ")")])])
	  })], 2)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.productTags.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2961 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-content"
	  }, [_c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "type": "flex",
	      "justify": "center"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 18,
	      "md": 14
	    }
	  }, [_c('div', {
	    staticClass: "release-content"
	  }, [_c('div', {
	    staticClass: "content-inner full-w"
	  }, [_c('div', {
	    staticClass: "header"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('static.releaseNote.page.subTitle')))]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('static.releaseNote.page.title')))])]), _vm._v(" "), _vm._l((_vm.releaseNotes), function(releaseNote) {
	    return _c('div', {
	      staticClass: "release-note"
	    }, [_c('h2', [_vm._v(_vm._s(_vm.formatDate(releaseNote.createdAt)) + "  "), _c('small', [_vm._v("v." + _vm._s(releaseNote.version))]), _vm._v("  "), _c('el-tag', {
	      attrs: {
	        "size": "small"
	      }
	    }, [_c('i', {
	      staticClass: "el-icon-document"
	    }), _vm._v(" " + _vm._s(releaseNote.module.toUpperCase()))])], 1), _vm._v(" "), _c('p', {
	      domProps: {
	        "innerHTML": _vm._s(releaseNote.description)
	      }
	    })])
	  })], 2)])])], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2962 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle pageTitle--light"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.equipments.create.title')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.equipments.formTabs.equipmentInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.equipments",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'production.equipments.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.store($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2963 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.productPackagings.index.title')) + " (" + _vm._s(_vm.productPackagings.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": _vm.$t('sort.placeholder')
	    },
	    model: {
	      value: (_vm.sort),
	      callback: function($$v) {
	        _vm.sort = $$v
	      },
	      expression: "sort"
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.productPackagings.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.productPackaging.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productPackagings.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.productPackaging.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.productPackagings.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editProductPackaging(p)
	        }
	      }
	    }, [_c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.goToProducts(p.id, $event)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "cardLabel"
	    }, [_vm._v("(" + _vm._s(p.productsCount) + " " + _vm._s(_vm.$t('static.productPackagings.index.productsCount')) + ")")])]), _vm._v(" "), _c('hr'), _vm._v(" "), (p.description) ? _c('div', {
	      staticClass: "cardinnerBox"
	    }, [_c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-file-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(p.description))])])]) : _vm._e()])
	  })], 2)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.productPackagings.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2964 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.ready) ? _c('div', [(!_vm.showTable) ? _c('v-message', {
	    attrs: {
	      "warning": _vm.$t('static.orders.edit.noProductWarning')
	    }
	  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.showTable) ? _c('div', {
	    staticClass: "tableContainer"
	  }, [_c('el-row', {
	    staticClass: "tablerow"
	  }, [_c('el-col', {
	    staticClass: "tableCol colHeading",
	    attrs: {
	      "span": 4
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('table.orderProducts.name.label')) + "\n      ")]), _vm._v(" "), _c('el-col', {
	    staticClass: "tableCol colHeading",
	    attrs: {
	      "span": 4
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('table.orderProducts.price.label')) + "\n      ")]), _vm._v(" "), _c('el-col', {
	    staticClass: "tableCol colHeading",
	    attrs: {
	      "span": 4
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('table.orderProducts.quantityOrdered.label')) + "\n      ")]), _vm._v(" "), _c('el-col', {
	    staticClass: "tableCol colHeading",
	    attrs: {
	      "span": 4
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('table.orderProducts.quantityConfirmed.label')) + "\n      ")]), _vm._v(" "), _c('el-col', {
	    staticClass: "tableCol colHeading",
	    attrs: {
	      "span": 4
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('table.orderProducts.quantityReceived.label')) + "\n      ")]), _vm._v(" "), _c('el-col', {
	    staticClass: "tableCol colHeading",
	    attrs: {
	      "span": 4
	    }
	  }, [_vm._v("\n         \n      ")])], 1), _vm._v(" "), _vm._l((_vm.ediOrderItems), function(p) {
	    return _c('el-row', {
	      key: p.id,
	      staticClass: "tablerow"
	    }, [_c('el-col', {
	      staticClass: "tableCol",
	      attrs: {
	        "span": 4,
	        "data-th": "Product Name"
	      }
	    }, [_vm._v("\n       " + _vm._s(p.description) + "\n      ")]), _vm._v(" "), _c('el-col', {
	      staticClass: "tableCol",
	      attrs: {
	        "span": 4,
	        "data-th": "Price"
	      }
	    }, [_vm._v("\n        " + _vm._s(p.price) + "\n      ")]), _vm._v(" "), _c('el-col', {
	      staticClass: "tableCol",
	      attrs: {
	        "span": 4,
	        "data-th": "Ordered"
	      }
	    }, [_vm._v("\n        " + _vm._s(p.quantityOrdered) + "\n      ")]), _vm._v(" "), _c('el-col', {
	      staticClass: "tableCol",
	      attrs: {
	        "span": 4,
	        "data-th": "Confirmed"
	      }
	    }, [_vm._v("\n        " + _vm._s(p.quantityConfirmed) + "\n      ")]), _vm._v(" "), _c('el-col', {
	      staticClass: "tableCol",
	      attrs: {
	        "span": 4,
	        "data-th": "Received"
	      }
	    }, [_vm._v("\n        " + _vm._s(p.quantityReceived) + "\n      ")]), _vm._v(" "), _c('el-col', {
	      staticClass: "tableCol buttonCol",
	      attrs: {
	        "span": 4
	      }
	    })], 1)
	  })], 2) : _vm._e(), _vm._v(" "), _c('br')], 1) : _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (!_vm.ready),
	      expression: "!ready"
	    }]
	  }, [_c('br'), _c('br'), _c('br')])
	},staticRenderFns: []}

/***/ }),
/* 2965 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.recipes.index.title')) + " (" + _vm._s(_vm.recipes.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('el-button-group', [_c('el-button', {
	    attrs: {
	      "type": _vm.primary,
	      "size": "small",
	      "icon": "el-icon-menu",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('info')
	      }
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": _vm.info,
	      "size": "small",
	      "icon": "el-icon-tickets",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('primary')
	      }
	    }
	  })], 1), _vm._v(" "), _c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search,
	      "clearable": true
	    },
	    on: {
	      "keydown": _vm.onChangeSearch
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": _vm.$t('sort.placeholder')
	    },
	    model: {
	      value: (_vm.sort),
	      callback: function($$v) {
	        _vm.sort = $$v
	      },
	      expression: "sort"
	    }
	  })], 1)])], 1), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.recipes.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.recipe.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'production.recipes.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.recipe.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.recipes.items), function(m, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editRecipe(m)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel"
	    }, [_c('span', {
	      staticClass: "cardBadge"
	    }, [_vm._v(_vm._s(_vm.$t(("static.recipes.types." + (_vm.camalize(m.recipeType))))))])]), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(m.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), (m.notes) ? _c('div', {
	      staticClass: "cardinnerBox"
	    }, [_c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-file-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(m.notes))])])]) : _vm._e()])
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('v-table', {
	    attrs: {
	      "list": _vm.recipesListView,
	      "noDataMessage": _vm.$t('static.defaultText.recipe.noDataMsg'),
	      "link": _vm.editRecipe,
	      "linkKey": "name",
	      "rowKey": "id",
	      "translation": "static.recipes.table"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "pagination": _vm.recipes.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2966 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.savingOrgDefault),
	      expression: "savingOrgDefault"
	    }],
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [(_vm.coaList.length > 0) ? [_c('v-form-table', {
	    attrs: {
	      "form": _vm.form,
	      "list": _vm.sortedCoaList,
	      "create": _vm.save,
	      "update": _vm.update,
	      "destroy": _vm.destroy,
	      "translation": "static.organizationSettings.coa",
	      "sortable-fields": ['code', 'name'],
	      "sort-field": _vm.sortField,
	      "sort-direction": _vm.sortDirection,
	      "extra-column-header-label": _vm.$t('static.organizationSettings.coa.orgDefault.label')
	    },
	    on: {
	      "sort": _vm.onSort
	    },
	    scopedSlots: _vm._u([{
	      key: "extraColumn",
	      fn: function(ref) {
	        var item = ref.item;
	
	        return [_c('el-select', {
	          staticClass: "full-w",
	          attrs: {
	            "value": _vm.orgDefaultRoleFor(item),
	            "disabled": _vm.savingOrgDefault,
	            "size": "small"
	          },
	          on: {
	            "change": function($event) {
	              return _vm.onOrgDefaultChange(item, $event)
	            }
	          }
	        }, [_c('el-option', {
	          attrs: {
	            "label": _vm.$t('static.organizationSettings.coa.orgDefault.none'),
	            "value": ""
	          }
	        }), _vm._v(" "), _c('el-option', {
	          attrs: {
	            "label": _vm.$t('static.organizationSettings.coa.orgDefault.receivables'),
	            "value": "receivables"
	          }
	        }), _vm._v(" "), _c('el-option', {
	          attrs: {
	            "label": _vm.$t('static.organizationSettings.coa.orgDefault.income'),
	            "value": "income"
	          }
	        }), _vm._v(" "), _c('el-option', {
	          attrs: {
	            "label": _vm.$t('static.organizationSettings.coa.orgDefault.vat'),
	            "value": "vat"
	          }
	        }), _vm._v(" "), _c('el-option', {
	          attrs: {
	            "label": _vm.$t('static.organizationSettings.coa.orgDefault.deposit'),
	            "value": "deposit"
	          }
	        })], 1)]
	      }
	    }], null, false, 14637755)
	  })] : [_c('div', [_c('v-message', {
	    attrs: {
	      "warning": _vm.$t('static.organizationSettings.coa.noCoa')
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center"
	  }, [_c('el-button', {
	    attrs: {
	      "loading": !_vm.ready
	    },
	    on: {
	      "click": _vm.createCoa
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.organizationSettings.coa.createCoa').toUpperCase()))])], 1)]], 2)
	},staticRenderFns: []}

/***/ }),
/* 2967 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "calendar-appointments-container"
	  }, [_vm._l((_vm.list(_vm.day)), function(a, k) {
	    return [(a.slot) ? _c('div', {
	      staticClass: "full-w flex start space-between calendar-appointments-slot",
	      style: ({
	        top: ((a.offsetTop) + "px"),
	        height: ((a.height) + "px")
	      })
	    }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.appointments.index.freeSlot')))]), _vm._v(" "), _c('a', {
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.create(_vm.day)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('button.book')))])]) : _vm._e(), _vm._v(" "), (a.exception) ? _c('div', {
	      staticClass: "full-w flex start space-between calendar-appointments-exception",
	      style: ({
	        top: ((a.offsetTop) + "px"),
	        height: ((a.height) + "px")
	      })
	    }, [_c('span', [_vm._v(_vm._s(a.message || _vm.$t('static.appointments.index.exception')))])]) : _vm._e(), _vm._v(" "), (!a.slot && !a.exception) ? _c('v-appointment-card', {
	      key: k,
	      staticClass: "calendar-appointments-item",
	      style: ({
	        top: ((a.offsetTop) + "px"),
	        height: ((a.height) + "px")
	      }),
	      attrs: {
	        "fade": true,
	        "appointment": a,
	        "edit": _vm.edit(_vm.day)
	      }
	    }) : _vm._e()]
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 2968 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.warehouse.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.warehouse.basicInformation'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.warehouse",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'warehouse.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2969 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n         " + _vm._s(_vm.$t('static.products.index.title')) + " (" + _vm._s(_vm.products.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search,
	      "clearable": true
	    },
	    on: {
	      "keydown": _vm.onChangeSearch
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "block product-filter",
	    staticStyle: {
	      "width": "320px",
	      "float": "right"
	    }
	  }, [_c('el-cascader', {
	    attrs: {
	      "placeholder": _vm.$t('static.products.filters.placeholder'),
	      "options": _vm.filters,
	      "clearable": ""
	    },
	    on: {
	      "change": _vm.handleFilterChange
	    },
	    model: {
	      value: (_vm.filterValue),
	      callback: function($$v) {
	        _vm.filterValue = $$v
	      },
	      expression: "filterValue"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('el-button', {
	    attrs: {
	      "type": _vm.primary,
	      "size": "small",
	      "icon": "el-icon-download",
	      "round": ""
	    },
	    on: {
	      "click": _vm.showImportDownloadModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.downloadImport')) + "\n          ")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": _vm.info,
	      "size": "small",
	      "icon": "el-icon-setting",
	      "circle": ""
	    },
	    on: {
	      "click": _vm.showProductIndexSettingsModal
	    }
	  })], 1)], 1)])], 1), _vm._v(" "), (_vm.showAction) ? _c('el-row', {
	    staticClass: "bulkActions",
	    attrs: {
	      "gutter": 5
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 8,
	      "lg": 6,
	      "xl": 4
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.selectedCount) + " products selected")])]), _vm._v(" "), _c('el-col', {
	    staticStyle: {
	      "text-align": "right"
	    },
	    attrs: {
	      "md": 3,
	      "lg": 3,
	      "xl": 2
	    }
	  }, [(_vm.showAction) ? _c('label', [_vm._v(_vm._s(_vm.$t('productActions.select.label')) + " ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 13,
	      "lg": 15,
	      "xl": 18
	    }
	  }, [_c('button', {
	    staticClass: "el-button el-button--default small",
	    staticStyle: {
	      "margin-bottom": "4px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onSelectAction('activateProduct')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('productActions.activateProduct')))]), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--danger danger small",
	    staticStyle: {
	      "margin-bottom": "4px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onSelectAction('deactivateProduct')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('productActions.deactivateProduct')))]), _vm._v(" "), (_vm.hasWooModule) ? _c('button', {
	    staticClass: "el-button el-button--default small",
	    staticStyle: {
	      "margin-bottom": "4px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onSelectAction('syncToWoo')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('productActions.syncToWoo')))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', [(_vm.products.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.product.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'products.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.product.noDataBtn')) + "\n          ")])], 1)], 1) : [(!_vm.searchQuery.grouping) ? _c('div', {
	    staticClass: "flex stretch wrap"
	  }, _vm._l((_vm.products.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editProduct(p)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel w-full"
	    }, [_c('span', {
	      staticClass: "cardBadge"
	    }, [_vm._v(_vm._s(_vm.$t(("static.products.types." + (_vm.camelize(p.productType))))))]), _vm._v(" "), (_vm.hasInventory && (!p.containsAlcohol && p.productTypeGroup === 'Beverage')) ? _c('span', {
	      staticClass: "cardBadge card-yellow"
	    }, [_vm._v(_vm._s(_vm.$t("static.products.labels.alcoholFree")))]) : _vm._e(), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-external-link pull-right",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.editProductNewTab(p)
	        }
	      }
	    })]), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('form.products.price.label')) + ": ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.selectedPrice.toFixed(2)) + " NOK")]), _vm._v(" "), (p.description) ? _c('div', {
	      staticClass: "cardinnerBox"
	    }, [_c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-file-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" \n                  " + _vm._s(p.description))])])]) : _vm._e()])
	  }), 1) : [_vm._l((_vm.productGroupedCardView), function(products, group) {
	    return [(group !== 'none') ? _c('h2', {
	      staticStyle: {
	        "font-size": "18px",
	        "font-weight": "bolder",
	        "margin-bottom": "4px",
	        "text-transform": "uppercase",
	        "color": "#0b5470"
	      }
	    }, [_vm._v(_vm._s(_vm.searchQuery.grouping === 'Type' ? _vm.$t(("static.products.types." + (_vm.camelize(group)))) : group))]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "flex stretch wrap"
	    }, _vm._l((products), function(p, i) {
	      return _c('v-card', {
	        key: i,
	        nativeOn: {
	          "click": function($event) {
	            return _vm.editProduct(p)
	          }
	        }
	      }, [_c('label', {
	        staticClass: "cardLabel"
	      }, [_c('span', {
	        staticClass: "cardBadge"
	      }, [_vm._v(_vm._s(_vm.$t(("static.products.types." + (_vm.camelize(p.productType))))))]), _vm._v(" "), (!p.containsAlcohol && p.productTypeGroup === 'Beverage') ? _c('span', {
	        staticClass: "cardBadge card-yellow"
	      }, [_vm._v(_vm._s(_vm.$t("static.products.labels.alcoholFree")))]) : _vm._e(), _vm._v(" "), _c('i', {
	        staticClass: "fa fa-external-link pull-right",
	        staticStyle: {
	          "cursor": "pointer"
	        },
	        attrs: {
	          "aria-hidden": "true"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            return _vm.editProductNewTab(p)
	          }
	        }
	      })]), _vm._v(" "), _c('h2', {
	        staticClass: "cardTitle"
	      }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('label', {
	        staticClass: "cardLabel"
	      }, [_vm._v(_vm._s(_vm.$t('form.products.price.label')) + ": ")]), _c('span', {
	        staticClass: "cardContent"
	      }, [_vm._v(_vm._s(p.selectedPrice.toFixed(2)) + " NOK")]), _vm._v(" "), (p.description) ? _c('div', {
	        staticClass: "cardinnerBox"
	      }, [_c('div', [_c('label', {
	        staticClass: "cardLabel cardLabel--small"
	      }, [_c('i', {
	        staticClass: "fa fa-file-o",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }), _vm._v(" \n                      " + _vm._s(p.description))])])]) : _vm._e()])
	    }), 1)]
	  })]]], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : [(!_vm.searchQuery.grouping) ? _c('el-table', {
	    ref: "multipleTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.productsListView
	    },
	    on: {
	      "selection-change": _vm.handleSelectionChange
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "selection",
	      "width": "30"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "number",
	      "label": _vm.$t('static.products.table.number'),
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.products.table.name'),
	      "sortable": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('a', {
	          on: {
	            "click": function($event) {
	              $event.preventDefault();
	              return _vm.editProduct(scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(scope.row.name))])]
	      }
	    }], null, false, 3795395497)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.products.table.price'),
	      "sortable": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          domProps: {
	            "innerHTML": _vm._s(scope.row.price)
	          }
	        })]
	      }
	    }], null, false, 3236041401)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.products.table.warehouses'),
	      "sortable": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          domProps: {
	            "innerHTML": _vm._s(scope.row.warehouses)
	          }
	        })]
	      }
	    }], null, false, 3400470626)
	  })], 1) : [_vm._l((_vm.productGroupedListView), function(products, group) {
	    return [(group !== 'none') ? _c('h2', {
	      staticStyle: {
	        "font-size": "18px",
	        "font-weight": "bolder",
	        "margin-bottom": "4px",
	        "text-transform": "uppercase",
	        "color": "#0b5470"
	      }
	    }, [_vm._v(_vm._s(_vm.searchQuery.grouping === 'Type' ? _vm.$t(("static.products.types." + (_vm.camelize(group)))) : group))]) : _vm._e(), _vm._v(" "), _c('v-table', {
	      attrs: {
	        "list": products,
	        "noDataMessage": _vm.$t('static.defaultText.product.noDataMsg'),
	        "link": _vm.editProduct,
	        "linkKey": "name",
	        "rowKey": "id",
	        "translation": "static.products.table"
	      }
	    })]
	  })]]], 2) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.products.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2970 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('static.products.index.importProductsErrorPopupTitle')))]), _vm._v(" "), _c('ul', _vm._l((_vm.errors), function(error) {
	    return _c('li', {
	      key: error.row,
	      staticStyle: {
	        "margin-bottom": "5px"
	      }
	    }, [_c('div', {
	      staticClass: "flex",
	      staticStyle: {
	        "align-items": "flex-start"
	      }
	    }, [_c('div', [_vm._v(_vm._s(_vm.$t('static.products.index.row')) + " " + _vm._s(error.row) + " - ")]), _vm._v(" "), _c('div', _vm._l((error.errors), function(err) {
	      return _c('span', {
	        staticStyle: {
	          "display": "block"
	        }
	      }, [_c('span', {
	        domProps: {
	          "innerHTML": _vm._s(err[0])
	        }
	      })])
	    }), 0)])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2971 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.priceFields.edit.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.priceFields.formTabs.tagInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.priceFields",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'priceFields.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2972 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 8,
	      "lg": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.orders.formTabs.orderInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    ref: "form",
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.orders",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex wrap justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'orders.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2973 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('static.products.index.importProductsErrorPopupTitle')))]), _vm._v(" "), _c('ul', _vm._l((_vm.errors), function(error) {
	    return _c('li', {
	      key: error.row,
	      staticStyle: {
	        "margin-bottom": "5px"
	      }
	    }, [_c('div', {
	      staticClass: "flex",
	      staticStyle: {
	        "align-items": "flex-start"
	      }
	    }, [_c('div', [_vm._v(_vm._s(_vm.$t('static.products.index.row')) + " " + _vm._s(error.row) + " - ")]), _vm._v(" "), _c('div', _vm._l((error.errors), function(err) {
	      return _c('span', {
	        staticStyle: {
	          "display": "block"
	        }
	      }, [_c('span', {
	        domProps: {
	          "innerHTML": _vm._s(err[0])
	        }
	      })])
	    }), 0)])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2974 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.productFlow.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.productFlow.basicInformation'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.productFlow",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productFlow.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2975 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle pageTitle--light"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.batches.create.title')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "label": _vm.$t('static.batches.formTabs.batchInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-20"
	  }, [_c('label', {
	    staticStyle: {
	      "width": "180px",
	      "display": "inline-block"
	    },
	    attrs: {
	      "for": "status"
	    }
	  }, [_vm._v("Select One:")]), _vm._v(" "), _c('el-radio-group', {
	    attrs: {
	      "id": "status"
	    },
	    on: {
	      "change": _vm.handleStatusChange
	    },
	    model: {
	      value: (_vm.form.status),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "status", $$v)
	      },
	      expression: "form.status"
	    }
	  }, [_c('el-radio-button', {
	    attrs: {
	      "label": "planned"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('form.batches.statuses.planned')) + "\n              ")]), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "started"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('form.batches.statuses.started')) + "\n              ")]), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "completed"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('form.batches.statuses.completed')) + "\n              ")])], 1)], 1), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.batches",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'production.batches.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.store($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2976 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.isSms2faEnabled) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.googleTwoFactorVerification.sms2faEnabledWarning')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))])], 1) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.googleTwoFactorVerification.title')))]), _vm._v(" "), _c('div', [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "panel panel-default"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [_c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.$t('static.googleTwoFactorVerification.enableWarningMessage'))
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "flex justify-center"
	  }, [(_vm.qrCodeImage) ? _c('img', {
	    staticStyle: {
	      "width": "120px",
	      "margin": "auto"
	    },
	    attrs: {
	      "alt": "Image of QR barcode",
	      "src": _vm.qrCodeImage
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(_vm._s(_vm.$t('static.googleTwoFactorVerification.codeVerification')))]), _vm._v(" "), _c('div', {
	    staticClass: "el-input"
	  }, [_c('el-input', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "placeholder": _vm.$t('static.googleTwoFactorVerification.enterToken')
	    },
	    model: {
	      value: (_vm.twoFactorAuthToken),
	      callback: function($$v) {
	        _vm.twoFactorAuthToken = $$v
	      },
	      expression: "twoFactorAuthToken"
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "box-shadow": "none"
	    },
	    attrs: {
	      "slot": "append",
	      "icon": "el-icon-check",
	      "loading": _vm.verifyLoading
	    },
	    on: {
	      "click": _vm.verifyToken
	    },
	    slot: "append"
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.googleTwoFactorVerification.verifyCode')) + "\n                ")])], 1)], 1)])])])])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2977 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 2978 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.materials.index.title')) + " (" + _vm._s(_vm.materials.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('el-button-group', [_c('el-button', {
	    attrs: {
	      "type": _vm.primary,
	      "size": "small",
	      "icon": "el-icon-menu",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('info')
	      }
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": _vm.info,
	      "size": "small",
	      "icon": "el-icon-tickets",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('primary')
	      }
	    }
	  })], 1), _vm._v(" "), _c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search,
	      "clearable": true
	    },
	    on: {
	      "keydown": _vm.onChangeSearch
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": _vm.$t('sort.placeholder')
	    },
	    model: {
	      value: (_vm.sort),
	      callback: function($$v) {
	        _vm.sort = $$v
	      },
	      expression: "sort"
	    }
	  })], 1)])], 1), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.materials.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.material.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'production.materials.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.material.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.materials.items), function(m, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editMaterial(m)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel"
	    }, [_c('span', {
	      staticClass: "cardBadge"
	    }, [_vm._v(_vm._s(_vm.$t(("static.materials.types." + (_vm.camalize(m.materialType))))))])]), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(m.name))]), _vm._v(" "), _c('span', [_vm._v("ID #" + _vm._s(m.id))]), _vm._v(" "), _c('hr'), _vm._v(" "), (m.description) ? _c('div', {
	      staticClass: "cardinnerBox"
	    }, [_c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-file-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(m.description))])])]) : _vm._e()])
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('v-table', {
	    attrs: {
	      "list": _vm.materialsListView,
	      "noDataMessage": _vm.$t('static.defaultText.material.noDataMsg'),
	      "link": _vm.editMaterial,
	      "linkKey": "name",
	      "rowKey": "id",
	      "translation": "static.materials.table"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "pagination": _vm.materials.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2979 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('i', {
	    staticClass: "el-dialog__close el-icon el-icon-close align-right",
	    staticStyle: {
	      "display": "none"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }), _vm._v(" "), _c('div', [_c('h2', {
	    staticClass: "release-version"
	  }, [_vm._v(_vm._s(_vm.$t('static.releaseNote.modal.versionRelease')) + " " + _vm._s(_vm.latestVersions.version))]), _vm._v(" "), (_vm.latestVersions != '') ? _c('VueSlickCarousel', _vm._b({
	    ref: "carousel",
	    on: {
	      "afterChange": _vm.handleAfterChange
	    }
	  }, 'VueSlickCarousel', _vm.settings, false), [_c('div', [_c('h2', {
	    staticClass: "module-title"
	  }, [_vm._v(_vm._s(_vm.latestVersions.title))]), _vm._v(" "), _c('div', {
	    staticClass: "module-description",
	    domProps: {
	      "innerHTML": _vm._s(_vm.latestVersions.excerpt)
	    }
	  })]), _vm._v(" "), _vm._l((_vm.latestVersions.release_modules_note), function(module, key) {
	    return _c('div', {
	      key: key
	    }, [(module.demo_image_link != null) ? _c('img', {
	      staticClass: "module-demo-image",
	      attrs: {
	        "src": _vm.backendUrl + '/storage/' + module.demo_image_link
	      }
	    }) : _vm._e(), _vm._v(" "), _c('h2', {
	      staticClass: "module-title"
	    }, [_vm._v(_vm._s(module.title))]), _vm._v(" "), _c('div', {
	      staticClass: "module-description",
	      domProps: {
	        "innerHTML": _vm._s(module.excerpt)
	      }
	    })])
	  })], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "all-release"
	  }, [_c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "/#/release-notes"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.releaseNote.modal.learnLink')))]), _vm._v("  \n    "), _c('span', {
	    staticClass: "align-right custom-close"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-up fa-2x",
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }), _vm._v(_vm._s(_vm.$t('static.releaseNote.close.gotIt')) + "  ")])]), _vm._v(" "), (_vm.latestVersions.release_modules_note && _vm.latestVersions.release_modules_note.length > 0) ? _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    staticClass: "release-btn-next",
	    attrs: {
	      "disabled": _vm.btnNextDisabled
	    },
	    on: {
	      "click": _vm.rShowNext
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.releaseNote.modal.btnNext')))]), _vm._v(" "), _c('div', {
	    staticClass: "release-note-pagination"
	  }, [_c('span', {
	    staticClass: "release-pagination"
	  }, [_vm._v(_vm._s(_vm.releasePagination))])]), _vm._v(" "), _c('el-button', {
	    staticClass: "release-btn-prev",
	    attrs: {
	      "disabled": _vm.btnPrevDisabled
	    },
	    on: {
	      "click": _vm.rShowPrev
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.releaseNote.modal.btnPrev')))])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2980 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "email-modal"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('static.news.create.title')))]), _vm._v(" "), (_vm.listMessage != null) ? _c('h3', {
	    staticClass: "warning-color text-center"
	  }, [_vm._v(_vm._s(_vm.listMessage))]) : _vm._e(), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "hasLabel": true,
	      "translation": "form.news"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex space-between wrap"
	  }, [_c('div', {
	    staticClass: "flex wrap margin-b-10"
	  }, [(!_vm.email || _vm.email.status === 'draft') ? _c('el-button', {
	    staticClass: "margin-b-10",
	    staticStyle: {
	      "margin-right": "10px"
	    },
	    attrs: {
	      "loading": _vm.form.loading === 'draft'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createEmail(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.saveDraft')))]) : _vm._e(), _vm._v(" "), (!_vm.email || _vm.email.status != 'done') ? _c('el-button', {
	    staticClass: "margin-b-10",
	    staticStyle: {
	      "margin-left": "0"
	    },
	    attrs: {
	      "loading": _vm.form.loading === 'ready'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.createEmail(false)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('el-button', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "loading": _vm.testLoading
	    },
	    on: {
	      "click": _vm.testEmail
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.sendTest')))])], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2981 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.loadComponent) ? _c('div', {
	    staticClass: "main-body"
	  }, [_c('h1', [_vm._v("\n      " + _vm._s(_vm.$t('static.dashboard.title')) + "\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "notificationWrapper"
	  }, [(!_vm.account.verified) ? _c('div', {
	    staticClass: "notification"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   \n        " + _vm._s(_vm.$t('static.dashboard.emailConfirmationWarning1')) + "\n        "), _c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.resendConfirmation($event)
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('static.dashboard.emailConfirmationWarning2')) + "\n        ")]), _vm._v("\n        " + _vm._s(_vm.$t('static.dashboard.emailConfirmationWarning3')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "notificationWrapper"
	  }, [(_vm.confirmationResent) ? _c('div', {
	    staticClass: "notification"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   \n        " + _vm._s(_vm.$t('static.dashboard.emailConfirmationResentWarning')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "notificationWrapper"
	  }, [(_vm.confirmationResentError) ? _c('div', [_c('el-alert', {
	    attrs: {
	      "title": "$t('static.dashboard.emailConfirmationResentError')",
	      "type": "error",
	      "show-icon": ""
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "notificationWrapper"
	  }, [(!_vm.account.subscribed) ? _c('div', {
	    staticClass: "notification"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("   \n          " + _vm._s(_vm.$t('static.dashboard.expiredSubscriptionWarning')) + "\n        ")]) : _vm._e()])]), _vm._v(" "), (_vm.account.verified) ? _c('div') : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "main-body dashboard-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 0
	    }
	  }, [_c('div', {
	    staticClass: "el-col-lg-24"
	  }, [_c('el-button', {
	    staticClass: "btn-add-widgets",
	    on: {
	      "click": function($event) {
	        return _vm.widgetsAdd()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.dashboard.addWidgetBtn')))])], 1)]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, _vm._l((_vm.cardItems), function(card, index) {
	    return (_vm.cardItems) ? _c('el-col', {
	      staticClass: "wrap box-card el-card--wide widgets-item",
	      attrs: {
	        "xs": 24,
	        "md": 12,
	        "lg": 12,
	        "xl": 8
	      }
	    }, [_c('el-card', [_c('div', {
	      staticClass: " widget-card-header"
	    }, [_c('div', {
	      staticClass: "card-header-item title"
	    }, [_c('h2', [_vm._v(_vm._s(card.title) + " "), _c('i', {
	      staticClass: "el-icon-info tooltip widget-tooltip"
	    }, [_c('span', {
	      staticClass: "tooltiptext"
	    }, [_vm._v(_vm._s(card.desc))])])]), _vm._v(" "), _c('span', {
	      staticClass: "widget-subtitle"
	    }, [_vm._v(_vm._s(card.sub))])]), _vm._v(" "), _c('div', {
	      staticClass: "card-header-item order"
	    }, [_c('el-select', {
	      staticClass: "widgets-order-select",
	      attrs: {
	        "placeholder": "Select"
	      },
	      on: {
	        "change": function($event) {
	          return _vm.onChangePos($event, index)
	        }
	      },
	      model: {
	        value: (_vm.cardCurrentOrder[index]),
	        callback: function($$v) {
	          _vm.$set(_vm.cardCurrentOrder, index, $$v)
	        },
	        expression: "cardCurrentOrder[index]"
	      }
	    }, _vm._l((_vm.cardItems.length), function(pos, index2) {
	      return _c('el-option', {
	        key: index2,
	        attrs: {
	          "label": index2 + 1,
	          "value": index2
	        }
	      })
	    }), 1)], 1), _vm._v(" "), _c('div', {
	      staticClass: "card-header-item close"
	    }, [_c('i', {
	      staticClass: "el-dialog__close el-icon el-icon-close align-right",
	      on: {
	        "click": function($event) {
	          return _vm.widgetsRemove(index)
	        }
	      }
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "widget-card-body"
	    }, [_c('div', {
	      staticClass: "widget-chart"
	    }, [(card.key === 'widget_1') ? _c('popular-product') : (card.key === 'widget_2') ? _c('amount-revenue') : (card.key === 'widget_3') ? _c('top-clients') : (card.key === 'widget_4') ? _c('waiting-processed') : (card.key === 'widget_5') ? _c('waiting-delivered') : (card.key === 'widget_6') ? _c('order-received') : _vm._e(), _vm._v(" "), (card.key === 'widget_7') ? _c('sold-product') : _vm._e()], 1), _vm._v(" "), _c('div', {
	      staticClass: "widget-others"
	    })])])], 1) : _vm._e()
	  }), 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2982 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.priceFields.index.title')) + " (" + _vm._s(_vm.priceFields.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": _vm.$t('sort.placeholder')
	    },
	    model: {
	      value: (_vm.sort),
	      callback: function($$v) {
	        _vm.sort = $$v
	      },
	      expression: "sort"
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.priceFields.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.priceFields.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'priceFields.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.priceFields.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.priceFields.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editpriceField(p)
	        }
	      }
	    }, [_c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(p.field))])])
	  })], 2)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "pagination": _vm.priceFields.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2983 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "whiteWrapper full-w flex justify-center",
	    staticStyle: {
	      "padding": "50px"
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 2984 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper email-send-tracking"
	  }, [_c('h2', {
	    staticClass: "head-title"
	  }, [_c('span', [_vm._v("Email subject: " + _vm._s(_vm.subject))])]), _vm._v(" "), _c('div', {
	    staticClass: "card-item sent-count"
	  }, [_c('span', {
	    staticClass: "success"
	  }, [_vm._v(_vm._s('Success: ' + _vm.success))]), _vm._v(" | "), _c('span', {
	    staticClass: "failed"
	  }, [_vm._v(_vm._s('Failed: ' + _vm.failed))])]), _vm._v(" "), _c('div', {
	    staticClass: "card-item sent-count"
	  }, [_c('el-collapse', {
	    on: {
	      "change": _vm.handleChange
	    },
	    model: {
	      value: (_vm.activeNames),
	      callback: function($$v) {
	        _vm.activeNames = $$v
	      },
	      expression: "activeNames"
	    }
	  }, [_c('el-collapse-item', {
	    attrs: {
	      "title": "Success",
	      "name": "1"
	    }
	  }, [_c('div', {
	    staticClass: "sub-collapse"
	  }, [(_vm.successContainer.length === 0) ? _c('div', [_vm._v("No success sent")]) : _c('el-collapse', {
	    attrs: {
	      "accordion": ""
	    }
	  }, _vm._l((_vm.successContainer), function(item) {
	    return _c('el-collapse-item', {
	      attrs: {
	        "title": item.client_contact.email
	      }
	    }, [_c('div', [_vm._v("Name: "), _c('span', [_vm._v(_vm._s(item.client_contact.first_name) + " " + _vm._s(item.client_contact.last_name))])]), _vm._v(" "), _c('div', [_vm._v("Client group: "), _c('span', [_vm._v(_vm._s(item.client_group.client.client_group.name))])]), _vm._v(" "), _c('div', [_vm._v("List: "), _c('span', [_vm._v(_vm._s(item.news_subscriber_list.name))])]), _vm._v(" "), _c('div', [_vm._v("Date sent: "), _c('span', [_vm._v(_vm._s(item.created_at))])]), _vm._v(" "), _c('div', [_vm._v("Sent: "), _c('span', [_vm._v(_vm._s(item.result))])])])
	  }), 1)], 1)]), _vm._v(" "), _c('el-collapse-item', {
	    attrs: {
	      "title": "Failed",
	      "name": "2"
	    }
	  }, [_c('div', {
	    staticClass: "sub-collapse"
	  }, [(_vm.failedContainer.length === 0) ? _c('div', [_vm._v("No failed sent")]) : _c('el-collapse', {
	    attrs: {
	      "accordion": ""
	    }
	  }, [_vm._l((_vm.failedContainer), function(item) {
	    return _c('el-collapse-item', {
	      attrs: {
	        "title": item.client_contact.email
	      }
	    }, [_c('div', [_vm._v("Name: "), _c('span', [_vm._v(_vm._s(item.client_contact.first_name) + " " + _vm._s(item.client_contact.last_name))])]), _vm._v(" "), _c('div', [_vm._v("Client group: "), _c('span', [_vm._v(_vm._s(item.client_group.client.client_group.name))])]), _vm._v(" "), _c('div', [_vm._v("List: "), _c('span', [_vm._v(_vm._s(item.news_subscriber_list.name))])]), _vm._v(" "), _c('div', [_vm._v("Date attempt to sent: "), _c('span', [_vm._v(_vm._s(item.created_at))])]), _vm._v(" "), _c('div', [_vm._v("Error:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.result))])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "help-message"
	  }, [_c('span', [_vm._v("If you are not sure about the error, feel free to send to us, Expect a email reply once we done our investigation.")])]), _vm._v(" "), _c('div', {
	    staticClass: "help-button"
	  }, [_c('el-button', {
	    staticClass: "small primary",
	    attrs: {
	      "icon": "el-icon-edit",
	      "disabled": (_vm.loadingSend) ? true : false
	    },
	    on: {
	      "click": _vm.sendReport
	    }
	  }, [_vm._v("Report this error")])], 1)], 2)], 1)])], 1)], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2985 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.editPricingAgreement')))]), _vm._v(" "), _c('el-form', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "140px"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.customer')
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.agreement.client && _vm.agreement.client.name ? _vm.agreement.client.name : '-'))])]), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.name'),
	      "required": ""
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": _vm.$t('pricingAgreements.namePlaceholder')
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.validFrom'),
	      "required": ""
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "date",
	      "value-format": "yyyy-MM-dd"
	    },
	    model: {
	      value: (_vm.form.valid_from),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "valid_from", $$v)
	      },
	      expression: "form.valid_from"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.validTo'),
	      "required": ""
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "date",
	      "value-format": "yyyy-MM-dd"
	    },
	    model: {
	      value: (_vm.form.valid_to),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "valid_to", $$v)
	      },
	      expression: "form.valid_to"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.active')
	    }
	  }, [_c('el-switch', {
	    model: {
	      value: (_vm.form.is_active),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "is_active", $$v)
	      },
	      expression: "form.is_active"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "small",
	      "loading": _vm.saving
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.save')))]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'pricingAgreements.index',
	        query: {
	          filter: 'active'
	        }
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "pricing-agreement-back-btn",
	    attrs: {
	      "type": "default",
	      "size": "small"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.back')))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "pricing-agreements-toolbar agreement-edit-products-toolbar",
	    staticStyle: {
	      "margin-bottom": "16px"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10,
	      "type": "flex",
	      "align": "middle"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h2', {
	    staticStyle: {
	      "margin": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.products')))])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pricing-agreement-options"
	  }, [_c('div', {
	    staticClass: "pricing-agreement-options__group pricing-agreement-options__view"
	  }, [_c('el-button-group', {
	    staticClass: "pricing-agreement-options__view-toggle"
	  }, [_c('el-button', {
	    attrs: {
	      "type": _vm.viewLineMode === 'info' ? 'primary' : 'default',
	      "size": "small",
	      "icon": "el-icon-menu",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeLineView('info')
	      }
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": _vm.viewLineMode === 'primary' ? 'primary' : 'default',
	      "size": "small",
	      "icon": "el-icon-tickets",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeLineView('primary')
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('span', {
	    staticClass: "pricing-agreement-options__divider",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pricing-agreement-options__group pricing-agreement-options__filters"
	  }, [(_vm.agreementLines.length > 0) ? _c('el-input', {
	    staticClass: "pricing-agreement-options__search",
	    attrs: {
	      "placeholder": _vm.$t('pricingAgreements.searchProductsInAgreement'),
	      "clearable": "",
	      "prefix-icon": "el-icon-search"
	    },
	    model: {
	      value: (_vm.productSearchQuery),
	      callback: function($$v) {
	        _vm.productSearchQuery = $$v
	      },
	      expression: "productSearchQuery"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "pricing-agreement-options__sort-wrap"
	  }, [_c('label', {
	    staticClass: "pricing-agreement-options__sort-label"
	  }, [_vm._v(_vm._s(_vm.$t('sort.title')))]), _vm._v(" "), _c('v-select', {
	    staticClass: "sort pricing-agreement-options__sort",
	    attrs: {
	      "name": "sortLine",
	      "options": _vm.sortLineTypes,
	      "value": _vm.sortLine
	    },
	    on: {
	      "change": _vm.onChangeLineSort
	    }
	  })], 1)], 1)])])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "agreement-add-product-wrapper"
	  }, [_c('v-card', {
	    staticClass: "agreement-product-card agreement-add-product-form"
	  }, [_c('el-form', {
	    staticClass: "agreement-add-product-form-inner",
	    attrs: {
	      "model": _vm.newLine,
	      "label-position": "top"
	    }
	  }, [_c('el-form-item', {
	    staticClass: "agreement-add-field-product",
	    attrs: {
	      "label": _vm.$t('pricingAgreements.addProduct')
	    }
	  }, [_c('el-select', {
	    staticClass: "agreement-add-field-input",
	    attrs: {
	      "filterable": "",
	      "remote": "",
	      "placeholder": _vm.$t('pricingAgreements.searchProductByName'),
	      "remote-method": _vm.remoteProductSearch,
	      "loading": _vm.productSearchLoading,
	      "clearable": ""
	    },
	    on: {
	      "focus": function($event) {
	        _vm.productOptions.length === 0 && _vm.remoteProductSearch('')
	      }
	    },
	    model: {
	      value: (_vm.newLine.product_id),
	      callback: function($$v) {
	        _vm.$set(_vm.newLine, "product_id", $$v)
	      },
	      expression: "newLine.product_id"
	    }
	  }, _vm._l((_vm.productOptions), function(p) {
	    return _c('el-option', {
	      key: p.id,
	      attrs: {
	        "label": p.number ? p.name + ' (' + p.number + ')' : p.name,
	        "value": p.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "agreement-add-field-minqty",
	    attrs: {
	      "label": _vm.$t('pricingAgreements.minQty')
	    }
	  }, [_c('el-input', {
	    staticClass: "agreement-add-field-input",
	    attrs: {
	      "type": "number",
	      "min": "1"
	    },
	    model: {
	      value: (_vm.newLine.min_qty_or_pack_qty),
	      callback: function($$v) {
	        _vm.$set(_vm.newLine, "min_qty_or_pack_qty", _vm._n($$v))
	      },
	      expression: "newLine.min_qty_or_pack_qty"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "agreement-add-field-pct",
	    attrs: {
	      "label": _vm.$t('pricingAgreements.discountPercent')
	    }
	  }, [_c('el-input', {
	    staticClass: "agreement-add-field-input",
	    attrs: {
	      "type": "number",
	      "placeholder": "%"
	    },
	    model: {
	      value: (_vm.newLine.discount_percent),
	      callback: function($$v) {
	        _vm.$set(_vm.newLine, "discount_percent", _vm._n($$v))
	      },
	      expression: "newLine.discount_percent"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "agreement-add-field-amount",
	    attrs: {
	      "label": _vm.$t('pricingAgreements.discountAmount')
	    }
	  }, [_c('el-input', {
	    staticClass: "agreement-add-field-input",
	    attrs: {
	      "type": "number",
	      "placeholder": _vm.$t('pricingAgreements.perUnit')
	    },
	    model: {
	      value: (_vm.newLine.discount_amount),
	      callback: function($$v) {
	        _vm.$set(_vm.newLine, "discount_amount", _vm._n($$v))
	      },
	      expression: "newLine.discount_amount"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "agreement-add-field-comment",
	    attrs: {
	      "label": _vm.$t('pricingAgreements.comment')
	    }
	  }, [_c('el-input', {
	    staticClass: "agreement-add-field-input",
	    attrs: {
	      "placeholder": _vm.$t('pricingAgreements.comment')
	    },
	    model: {
	      value: (_vm.newLine.comment),
	      callback: function($$v) {
	        _vm.$set(_vm.newLine, "comment", $$v)
	      },
	      expression: "newLine.comment"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "agreement-add-field-button"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.addingLine
	    },
	    on: {
	      "click": _vm.addLine
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.addProduct')))])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.agreementLines.length === 0) ? _c('v-no-data', {
	    staticClass: "agreement-products-empty"
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('pricingAgreements.noProductsInAgreement')) + "\n  ")]) : (_vm.sortedFilteredAgreementLines.length === 0) ? _c('v-no-data', {
	    staticClass: "agreement-products-empty"
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('pricingAgreements.noProductsMatchSearch')) + "\n  ")]) : (_vm.viewLineMode === 'info') ? _c('div', {
	    staticClass: "flex stretch wrap agreement-products-cards"
	  }, _vm._l((_vm.paginatedAgreementLines), function(line, i) {
	    return _c('v-card', {
	      key: line.id || i,
	      staticClass: "agreement-product-card"
	    }, [_c('label', {
	      staticClass: "cardLabel w-full"
	    }, [(line.discount_percent != null) ? _c('span', {
	      staticClass: "cardBadge card-green"
	    }, [_vm._v(_vm._s(line.discount_percent) + "%")]) : (line.discount_amount != null) ? _c('span', {
	      staticClass: "cardBadge"
	    }, [_vm._v("Fixed")]) : _c('span', {
	      staticClass: "cardBadge"
	    }, [_vm._v("–")]), _vm._v(" "), (_vm.isEditingLine(line)) ? [_c('span', {
	      staticClass: "agreement-card-actions"
	    }, [_c('el-button', {
	      attrs: {
	        "size": "mini",
	        "type": "primary",
	        "loading": _vm.savingLine
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.saveLine(line)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.save')))]), _vm._v(" "), _c('el-button', {
	      attrs: {
	        "size": "mini"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.cancelEditLine($event)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.cancel')))])], 1)] : [_c('span', {
	      staticClass: "agreement-card-actions"
	    }, [_c('el-button', {
	      attrs: {
	        "size": "mini",
	        "icon": "el-icon-edit"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.startEditLine(line)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('button.edit')))]), _vm._v(" "), _c('el-button', {
	      attrs: {
	        "size": "mini",
	        "type": "danger",
	        "icon": "el-icon-delete"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.deleteLine(line)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('button.delete')))])], 1)]], 2), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(line.product && line.product.name ? line.product.name : _vm.$t('pricingAgreements.productFallback') + line.product_id))]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.isEditingLine(line)) ? [_c('el-form', {
	      staticClass: "agreement-line-edit-form",
	      attrs: {
	        "label-width": "90px",
	        "size": "small"
	      }
	    }, [_c('el-form-item', {
	      attrs: {
	        "label": _vm.$t('pricingAgreements.minQty')
	      }
	    }, [_c('el-input', {
	      attrs: {
	        "type": "number",
	        "min": "1"
	      },
	      model: {
	        value: (_vm.editingForm.min_qty_or_pack_qty),
	        callback: function($$v) {
	          _vm.$set(_vm.editingForm, "min_qty_or_pack_qty", _vm._n($$v))
	        },
	        expression: "editingForm.min_qty_or_pack_qty"
	      }
	    })], 1), _vm._v(" "), _c('el-form-item', {
	      attrs: {
	        "label": _vm.$t('pricingAgreements.discountPercent')
	      }
	    }, [_c('el-input', {
	      attrs: {
	        "type": "number",
	        "placeholder": "%"
	      },
	      model: {
	        value: (_vm.editingForm.discount_percent),
	        callback: function($$v) {
	          _vm.$set(_vm.editingForm, "discount_percent", _vm._n($$v))
	        },
	        expression: "editingForm.discount_percent"
	      }
	    })], 1), _vm._v(" "), _c('el-form-item', {
	      attrs: {
	        "label": _vm.$t('pricingAgreements.discountAmt')
	      }
	    }, [_c('el-input', {
	      attrs: {
	        "type": "number",
	        "placeholder": _vm.$t('pricingAgreements.perUnit')
	      },
	      model: {
	        value: (_vm.editingForm.discount_amount),
	        callback: function($$v) {
	          _vm.$set(_vm.editingForm, "discount_amount", _vm._n($$v))
	        },
	        expression: "editingForm.discount_amount"
	      }
	    })], 1), _vm._v(" "), _c('el-form-item', {
	      attrs: {
	        "label": _vm.$t('pricingAgreements.comment')
	      }
	    }, [_c('el-input', {
	      attrs: {
	        "type": "textarea",
	        "rows": 2,
	        "placeholder": _vm.$t('pricingAgreements.comment')
	      },
	      model: {
	        value: (_vm.editingForm.comment),
	        callback: function($$v) {
	          _vm.$set(_vm.editingForm, "comment", $$v)
	        },
	        expression: "editingForm.comment"
	      }
	    })], 1)], 1)] : [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.minQty')) + ": ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(line.min_qty_or_pack_qty))]), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "margin-top": "8px"
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.discountLabel')) + ": ")]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(line.discount_percent != null ? line.discount_percent + '%' : (line.discount_amount != null ? line.discount_amount + ' ' + _vm.$t('pricingAgreements.perUnit') : '–')))])]), _vm._v(" "), (line.comment) ? _c('div', {
	      staticClass: "cardinnerBox",
	      staticStyle: {
	        "margin-top": "10px"
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_vm._v(_vm._s(line.comment))])]) : _vm._e()]], 2)
	  }), 1) : _c('el-table', {
	    staticStyle: {
	      "width": "100%",
	      "margin-top": "0"
	    },
	    attrs: {
	      "data": _vm.paginatedAgreementLines
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.product'),
	      "min-width": "220"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v("\n        " + _vm._s(scope.row.product && scope.row.product.name ? scope.row.product.name : _vm.$t('pricingAgreements.productFallback') + scope.row.product_id) + "\n      ")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.minQty'),
	      "prop": "min_qty_or_pack_qty",
	      "width": "100",
	      "align": "right"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.discountLabel'),
	      "min-width": "120"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.discount_percent != null) ? _c('span', [_vm._v(_vm._s(scope.row.discount_percent) + "%")]) : (scope.row.discount_amount != null) ? _c('span', [_vm._v(_vm._s(scope.row.discount_amount) + " " + _vm._s(_vm.$t('pricingAgreements.perUnit')))]) : _c('span', [_vm._v("–")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.comment'),
	      "min-width": "160",
	      "show-overflow-tooltip": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v(_vm._s(scope.row.comment || '–'))]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.actions'),
	      "width": "90",
	      "align": "right",
	      "fixed": "right"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          staticClass: "agreement-table-actions"
	        }, [_c('el-button', {
	          attrs: {
	            "size": "mini",
	            "icon": "el-icon-edit"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.startEditLine(scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(_vm.$t('button.edit')))]), _vm._v(" "), _c('el-button', {
	          attrs: {
	            "size": "mini",
	            "type": "danger",
	            "icon": "el-icon-delete"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.deleteLine(scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(_vm.$t('button.delete')))])], 1)]
	      }
	    }])
	  })], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('pricingAgreements.editPricingAgreement'),
	      "visible": _vm.showTableEditDialog,
	      "width": "400px",
	      "append-to-body": ""
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.showTableEditDialog = $event
	      },
	      "close": _vm.closeTableEditDialog
	    }
	  }, [(_vm.editingLineId != null) ? _c('el-form', {
	    staticClass: "agreement-line-edit-form",
	    attrs: {
	      "label-width": "120px",
	      "size": "small"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.minQty')
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "number",
	      "min": "1"
	    },
	    model: {
	      value: (_vm.editingForm.min_qty_or_pack_qty),
	      callback: function($$v) {
	        _vm.$set(_vm.editingForm, "min_qty_or_pack_qty", _vm._n($$v))
	      },
	      expression: "editingForm.min_qty_or_pack_qty"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.discountPercent')
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "number",
	      "placeholder": "%"
	    },
	    model: {
	      value: (_vm.editingForm.discount_percent),
	      callback: function($$v) {
	        _vm.$set(_vm.editingForm, "discount_percent", _vm._n($$v))
	      },
	      expression: "editingForm.discount_percent"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.discountAmt')
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "number",
	      "placeholder": _vm.$t('pricingAgreements.perUnit')
	    },
	    model: {
	      value: (_vm.editingForm.discount_amount),
	      callback: function($$v) {
	        _vm.$set(_vm.editingForm, "discount_amount", _vm._n($$v))
	      },
	      expression: "editingForm.discount_amount"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.comment')
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "textarea",
	      "rows": 2,
	      "placeholder": _vm.$t('pricingAgreements.comment')
	    },
	    model: {
	      value: (_vm.editingForm.comment),
	      callback: function($$v) {
	        _vm.$set(_vm.editingForm, "comment", $$v)
	      },
	      expression: "editingForm.comment"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": _vm.closeTableEditDialog
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.cancel')))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.savingLine
	    },
	    on: {
	      "click": function($event) {
	        return _vm.saveLine(_vm.editingLineRow)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.save')))])], 1)], 1), _vm._v(" "), (_vm.sortedFilteredAgreementLines.length > 0) ? _c('el-row', {
	    staticStyle: {
	      "margin-top": "15px"
	    }
	  }, [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.pagination,
	      "switchFunction": _vm.onPageChange
	    }
	  })], 1)])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2986 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('form.wordpressCredentialsModal.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('div', [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('form.wordpressCredentialsModal.title')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    staticStyle: {
	      "margin-top": "15px"
	    },
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.wordpressCredentialsModal",
	      "hasLabel": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('fieldset', {
	    staticClass: "margin-b-10"
	  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.wordpressCredentialsModal.kundanWordpressPluginToken')))]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('el-input', {
	    ref: "tokenInput",
	    staticClass: "input-with-icon margin-b-10",
	    attrs: {
	      "readonly": ""
	    },
	    model: {
	      value: (_vm.token),
	      callback: function($$v) {
	        _vm.token = $$v
	      },
	      expression: "token"
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "padding": "12px 20px",
	      "margin-right": "-7px"
	    },
	    attrs: {
	      "slot": "append",
	      "loading": _vm.generateTokenLoading
	    },
	    on: {
	      "click": _vm.generateToken
	    },
	    slot: "append"
	  }, [_vm._v("Generate")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "padding": "12px 20px"
	    },
	    attrs: {
	      "slot": "append"
	    },
	    on: {
	      "click": _vm.copyToken
	    },
	    slot: "append"
	  }, [_vm._v("Copy")])], 1)], 1)])], 1)])], 1), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [_c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.cancel').toUpperCase()) + "\n      ")]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.save').toUpperCase()) + "\n      ")])], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2987 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 2988 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.view.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.purchase.view.details'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.purchase.view.detailsLegend')))]), _vm._v(" "), [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.code')) + ":\n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.code) + "\n\t\t\t\t                      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.supplier')) + ":\n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'clients.edit',
	        params: {
	          id: _vm.currentPurchase.supplier.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.currentPurchase.supplier.name))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.warehouse')) + ":\n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'warehouse.edit',
	        params: {
	          id: _vm.currentPurchase.warehouse.id
	        }
	      }
	    }
	  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.warehouse.name) + "\n\t\t\t\t                        ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.qty')) + ":\n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.total_qty) + "\n\t\t\t\t                      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.comments')) + ":\n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.comments) + "\n\t\t\t\t                      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.createdAt')) + ":\n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.createdAt) + "\n\t\t\t\t                      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.receiveDate')) + ":\n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.receiveDate) + "\n\t\t\t\t                      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.status')) + ":\n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.purchaseStatus.name) + "\n\t\t\t\t                      ")])])]], 2)]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('div', {
	    staticClass: "btn-group margin-r-10"
	  }, [_c('el-button', {
	    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split small",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    on: {
	      "click": _vm.toggleDropdown
	    }
	  }, [_vm._v("\n\t\t\t\t\t\t\t  " + _vm._s(_vm.$t('static.purchase.view.documentBtnDropdown')) + " "), _c('span', {
	    staticClass: "sr-only"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu",
	    class: {
	      show: _vm.dropdownState
	    }
	  }, [_c('a', {
	    staticClass: "dropdown-item small",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": _vm.previewSendDocument
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.purchase.view.sendPurchaseDocument')))]), _vm._v(" "), _c('a', {
	    staticClass: "dropdown-item small",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": _vm.downloadPurchase
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.purchase.view.downloadPurchaseDocument')))])])], 1)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.purchase.view.products'),
	      "name": "products"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.purchase.view.productsLegend')))]), _vm._v(" "), _c('v-table', {
	    attrs: {
	      "list": _vm.productList,
	      "noDataMessage": _vm.$t('static.purchase.noData'),
	      "translation": "static.purchase.products"
	    }
	  })], 1)])], 1)], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2989 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-street-view-pano-container"
	  }, [_c('div', {
	    ref: "vue-street-view-pano",
	    staticClass: "vue-street-view-pano"
	  }), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 2990 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    ref: "flyaway"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2991 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-row', {
	    staticClass: "margin-b-10 margin-10",
	    attrs: {
	      "gutter": 24
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "sm": 24
	    }
	  }, [_c('v-excise-table', {
	    attrs: {
	      "list": _vm.entries,
	      "noDataMessage": _vm.$t('static.defaultText.exciseEntry.noDataMsg'),
	      "translation": "static.exciseEntry.table",
	      "group_key_id": "exciseGroup",
	      "additional_key_code": "exciseAdditionalCode",
	      "packaging_type_id": "excisePackaging",
	      "basic_id": "exciseBasic",
	      "rowKey": "id,additionalCodeDesc",
	      "loading": _vm.loading,
	      "update_list": _vm.updateList,
	      "link": _vm.openLink,
	      "linkKey": "excisableType"
	    }
	  })], 1)], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "pagination": _vm.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2992 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 2993 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "datebar-container flex stretch"
	  }, [_c('div', {
	    staticClass: "datebar-content datebar-content--button flex justify-center",
	    on: {
	      "click": function($event) {
	        _vm.changeDay(false, _vm.daysToSkip())
	      }
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-angle-left"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "datebar-content flex justify-center"
	  }, [_c('span', {
	    ref: "days",
	    staticClass: "hide-mobile"
	  }, [_vm._v("(" + _vm._s(_vm.$t('static.appointments.index.week')) + " " + _vm._s(_vm.finalDay.isoWeek()) + ")  -  ")]), _vm._v("\n    " + _vm._s(_vm.initialDay().format('dddd D. MMM. YY')) + "\n    "), _c('span', {
	    ref: "days",
	    staticClass: "hide-mobile"
	  }, [_vm._v("  -  " + _vm._s(_vm.finalDay.format('dddd D. MMM. YY')))])]), _vm._v(" "), _c('div', {
	    staticClass: "datebar-content datebar-content--button flex justify-center hide-mobile",
	    class: {
	      'danger': !_vm.displayWeekends
	    },
	    on: {
	      "click": _vm.toggleWeekends
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.appointments.index.displayWeekend')))]), _vm._v(" "), _c('div', {
	    staticClass: "datebar-content datebar-content--button flex justify-center",
	    on: {
	      "click": function($event) {
	        _vm.changeDay(true, _vm.daysToSkip())
	      }
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-angle-right"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2994 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.linesLoading),
	      expression: "linesLoading"
	    }],
	    staticClass: "product-lines-loading-wrap",
	    staticStyle: {
	      "width": "100%",
	      "min-height": "220px",
	      "position": "relative"
	    },
	    attrs: {
	      "element-loading-text": _vm.$t('static.loadingProductLines')
	    }
	  }, [_c('v-form-table', {
	    ref: "formTable",
	    staticClass: "orderproduct-table",
	    attrs: {
	      "form": _vm.form,
	      "list": _vm.list,
	      "additionalButtons": _vm.additionalButtons,
	      "update": _vm.update,
	      "destroy": _vm.order.orderStatus === 'created' ? _vm.destroy : null,
	      "hiddenFields": _vm.hiddenFields,
	      "translation": "table.orderProducts",
	      "disableForm": (_vm.order.isBilled || _vm.order.orderType === 'Wordpress' || (_vm.order.orderType == 'Return' && _vm.order.orderStatus == 'completed')) ? true : false,
	      "stack": {
	        name: 'note',
	        price: 'productDepositName'
	      },
	      "clickHandler": _vm.tableClickHandler
	    }
	  }), _vm._v(" "), _c('v-totals-table', {
	    attrs: {
	      "list": _vm.totalsTableList
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2995 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.unitOfMeasure.update.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.unitOfMeasure.basicInformation'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.unitOfMeasure",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'unitOfMeasure.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2996 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 2997 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-users",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clientGroups.index.title')) + " (" + _vm._s(_vm.clientGroups.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('v-select', {
	    attrs: {
	      "name": "sort",
	      "options": _vm.sortTypes,
	      "value": _vm.sort
	    },
	    on: {
	      "change": _vm.onChange
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.clientGroups.items.length === 0) ? _c('v-no-data', [_vm._v("\n          " + _vm._s(_vm.$t('static.defaultText.clientGroup.noDataMsg')) + "\n          "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'clientGroups.create'
	      }
	    }
	  }, [_vm._v("\n             "), _c('el-button', [_vm._v("\n              " + _vm._s(_vm.$t('static.defaultText.clientGroup.noDataBtn')) + "\n            ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.clientGroups.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editClientGroup(p)
	        }
	      }
	    }, [_c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.goToClients(p.id, $event)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "cardLabel"
	    }, [_vm._v("(" + _vm._s(p.clientsCount) + " " + _vm._s(_vm.$t('static.clientGroups.index.clientsCount')) + ")")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	      staticClass: "cardinnerBox"
	    }, [_c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-file-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(p.description || '-'))])])])])
	  })], 2)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.clientGroups.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2998 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('fieldset', {
	    staticClass: "margin-b-10"
	  }, [_c('legend', [_vm._v("UniMicro Environment")]), _vm._v(" "), _c('el-form', {
	    attrs: {
	      "label-position": "top"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Environment"
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "placeholder": "Select UniMicro Environment"
	    },
	    model: {
	      value: (_vm.form.fields.unimicro_environment.value),
	      callback: function($$v) {
	        _vm.$set(_vm.form.fields.unimicro_environment, "value", $$v)
	      },
	      expression: "form.fields.unimicro_environment.value"
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "Test",
	      "value": "https://test.unimicro.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "UniMicro",
	      "value": "https://app.unimicro.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "UniMicro SMB",
	      "value": "https://smb.unimicro.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "DNB Regnskap",
	      "value": "https://dnbregnskap.dnb.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Eika Regnskap",
	      "value": "https://system.eikaregnskap.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Azets Complete",
	      "value": "https://complete.azets.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "SB1 Regnskap Sør-Norge",
	      "value": "https://regnskap.sb1sornorge.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "SB1 Regnskap Østlandet",
	      "value": "https://regnskap.sb1ostlandet.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "SB1 Regnskap Nord-Norge",
	      "value": "https://regnskap.snn.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "SB1 Regnskap Hallingdal Valdres",
	      "value": "https://regnskap.sb1.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "SB1 Regnskap Nordmøre",
	      "value": "https://regnskap.bank.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "SB1 Regnskap Østfold Akershus",
	      "value": "https://regnskap.sparebank1oa.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "SB1 Regnskap Ringerike Hadeland",
	      "value": "https://regnskap.rhbank.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "SB1 Regnskap Gudbrandsdal",
	      "value": "https://regnskap.s1g.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "SB1 Regnskap Lom og Skjåk",
	      "value": "https://regnskap.sb1ls.no"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "SB1 SMN",
	      "value": "https://regnskap.smn.no"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Invoice Number Series"
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "placeholder": "Select Number Series for Kundan Invoices"
	    },
	    model: {
	      value: (_vm.form.fields.unimicro_invoice_series_id.value),
	      callback: function($$v) {
	        _vm.$set(_vm.form.fields.unimicro_invoice_series_id, "value", $$v)
	      },
	      expression: "form.fields.unimicro_invoice_series_id.value"
	    }
	  }, _vm._l((_vm.numberSeriesOptions), function(opt) {
	    return _c('el-option', {
	      key: opt.value,
	      attrs: {
	        "label": opt.label,
	        "value": opt.value
	      }
	    })
	  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "margin-t-10"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.loading
	    },
	    on: {
	      "click": _vm.saveEnvironment
	    }
	  }, [_vm._v("\n        Update Settings\n      ")])], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2999 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('form.billReminderModal.title')) + " " + _vm._s(_vm.billingNumber))]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [(!_vm.canCreateWithFee) ? _c('div', {
	    staticStyle: {
	      "padding": "10px",
	      "text-align": "left",
	      "border": "1px solid #e84c4c",
	      "background": "#f56c6c",
	      "color": "#fff",
	      "font-size": "16px",
	      "margin-bottom": "30px"
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('warnings.billReminder.unableToCreateWithFee')))]), _c('br'), _vm._v(" "), (_vm.reminderWarning[0] === 'first_reminder') ? _c('span', [_vm._v("- " + _vm._s(_vm.$t('warnings.billReminder.reasons.oneReminderFee')) + " " + _vm._s(("\n            " + (_vm.reminderWarning[1]) + " ")) + " " + _vm._s(_vm.$t('warnings.billReminder.reasons.oneReminderFeeDays'))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.reminderWarning[0] === 'max_reminder') ? _c('span', [_vm._v("- " + _vm._s(_vm.$t('warnings.billReminder.reasons.max2'))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.reminderWarning[0] === 'not_due') ? _c('span', [_vm._v("- " + _vm._s(_vm.$t('warnings.billReminder.reasons.notDue')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.billReminderModal",
	      "hasLabel": true
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "disabled": _vm.disableSaveButton,
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3000 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3001 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('form.billPaymentModal.title') + ' ' + _vm.billingNumber))]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('div', {
	    staticClass: "billpayment-top-summary"
	  }, [_c('i', {
	    staticClass: "fa fa-info-circle fa-2x",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('form.billPaymentModal.amountDue')) + " " + _vm._s(_vm.additionalData.due_date) + ":")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.reports.bills.invoiceAmount')) + ":")]), _vm._v(" " + _vm._s(new Intl.NumberFormat('no-NO', {
	    style: 'currency',
	    currency: 'NOK'
	  }).format(_vm.additionalData.total))), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('static.reports.bills.paidAmount')) + ":")]), _vm._v(" " + _vm._s(new Intl.NumberFormat('no-NO', {
	    style: 'currency',
	    currency: 'NOK'
	  }).format(_vm.additionalData.paid))), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('static.reports.bills.dueAmount')) + ":")]), _vm._v(" " + _vm._s(new Intl.NumberFormat('no-NO', {
	    style: 'currency',
	    currency: 'NOK'
	  }).format(_vm.additionalData.due)) + "\n            ")])]), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.billPaymentModal",
	      "hasLabel": true
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.complete
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.complete').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3002 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('static.producers.add')))]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [_c('el-col', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('v-form', {
	    attrs: {
	      "save": _vm.save,
	      "form": _vm.form,
	      "hasLabel": true,
	      "translation": "form.producers"
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3003 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.productFlow.update.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.productFlow.basicInformation'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.productFlow",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productFlow.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 3004 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.insideForm) ? _c('div', [_c('el-autocomplete', {
	    attrs: {
	      "popper-class": "my-autocomplete",
	      "name": _vm.setName,
	      "value": _vm.getValueData,
	      "fetch-suggestions": _vm.fetchSuggestions,
	      "placeholder": _vm.translation ? _vm.$t((_vm.translation + ".placeholder")) : _vm.name,
	      "disabled": _vm.disabled
	    },
	    on: {
	      "focus": _vm.changeData,
	      "select": _vm.handleSelect
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(ref) {
	        var item = ref.item;
	
	        return [_c('div', {
	          domProps: {
	            "innerHTML": _vm._s(_vm.showHtml(item))
	          }
	        })]
	      }
	    }], null, false, 2414759015)
	  }), _vm._v(" "), (_vm.quickForm) ? _c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "margin-left": "5px"
	    },
	    attrs: {
	      "icon": "el-icon-plus"
	    },
	    on: {
	      "click": _vm.onQuickFormClick
	    }
	  }) : _vm._e()], 1) : _c('div', [_c('el-form-item', {
	    attrs: {
	      "error": _vm.error,
	      "label": _vm.showLable
	    }
	  }, [_c('el-autocomplete', {
	    attrs: {
	      "popper-class": "my-autocomplete",
	      "name": _vm.setName,
	      "value": _vm.getValueData,
	      "fetch-suggestions": _vm.fetchSuggestions,
	      "placeholder": _vm.translation ? _vm.$t((_vm.translation + ".placeholder")) : _vm.name,
	      "disabled": _vm.disabled
	    },
	    on: {
	      "focus": _vm.changeData,
	      "select": _vm.handleSelect
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(ref) {
	        var item = ref.item;
	
	        return [_c('div', {
	          domProps: {
	            "innerHTML": _vm._s(_vm.showHtml(item))
	          }
	        })]
	      }
	    }])
	  }), _vm._v(" "), (_vm.quickForm) ? _c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "margin-left": "5px"
	    },
	    attrs: {
	      "icon": "el-icon-plus"
	    },
	    on: {
	      "click": _vm.onQuickFormClick
	    }
	  }) : _vm._e()], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3005 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.create.title')) + " " + _vm._s(_vm.currentStockProducts.length > 0 ? (" - " + (_vm.$t('static.purchase.create.unfinished'))) : ''))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.purchase.basicInformation'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.purchase",
	      "hasLabel": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('v-products-table', {
	    attrs: {
	      "additionalData": _vm.additionalData,
	      "fields": _vm.fields,
	      "page": "purchase"
	    }
	  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [(_vm.currentStockProducts.length > 0) ? _c('el-button', {
	    staticClass: "outline danger",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.destroy
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.delete').toUpperCase()))]) : _vm._e(), _vm._v(" "), _c('el-button', {
	    staticClass: "outline dark",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": function($event) {
	        return _vm.store('draft')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.saveDraft').toUpperCase()))]), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": function($event) {
	        return _vm.store()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 3006 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.alert.title) ? _c('el-alert', {
	    staticClass: "margin-t-10 margin-b-20",
	    attrs: {
	      "title": _vm.alert.title,
	      "type": _vm.alert.type,
	      "closable": false,
	      "show-icon": ""
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "flex-direction": "column"
	    }
	  }, _vm._l((_vm.buttons), function(button) {
	    return _c('el-button', {
	      key: button.name,
	      staticClass: "margin-b-20",
	      staticStyle: {
	        "width": "380px"
	      },
	      on: {
	        "click": button.action
	      }
	    }, [_vm._v("\n      " + _vm._s(button.text))])
	  }), 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3007 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle",
	    class: {
	      'pageTitle--dark': !_vm.isInOwnRoute
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.productBundles.create.title')) + "\n      ")])])], 1), _vm._v(" "), _c('div', {
	    class: {
	      'whiteWrapper': _vm.isInOwnRoute
	    }
	  }, [(_vm.isInOwnRoute) ? _c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.productBundles.formTabs.bundleInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.productBundles",
	      "hasLabel": true
	    }
	  }), _vm._v(" "), _c('div', [_c('div', [_c('el-button', {
	    staticClass: "primary small",
	    on: {
	      "click": _vm.showBulkAddModal
	    }
	  }, [_vm._v("Add Product")])], 1), _vm._v(" "), _vm._l((_vm.list), function(group, i) {
	    return _c('div', [_c('div', {
	      staticStyle: {
	        "margin-top": "30px"
	      }
	    }, [_c('el-row', {
	      attrs: {
	        "gutter": 10
	      }
	    }, [_c('el-col', {
	      staticStyle: {
	        "display": "flex",
	        "column-gap": "0.625rem"
	      },
	      attrs: {
	        "xs": 24
	      }
	    }, [_c('div', {
	      staticStyle: {
	        "width": "300px"
	      }
	    }, [_c('el-input', {
	      model: {
	        value: (group.name),
	        callback: function($$v) {
	          _vm.$set(group, "name", $$v)
	        },
	        expression: "group.name"
	      }
	    }, [_c('template', {
	      slot: "prepend"
	    }, [_vm._v(_vm._s(_vm.$t('form.productBundles.groupName.label')))])], 2), _vm._v(" "), (_vm.groupErrors[("bundles." + i + ".name")]) ? _c('span', {
	      staticStyle: {
	        "color": "red"
	      }
	    }, [_vm._v(_vm._s(_vm.groupErrors[("bundles." + i + ".name")][0]))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "width": "200px"
	      }
	    }, [_c('el-input', {
	      attrs: {
	        "value": group.price,
	        "disabled": true
	      }
	    }, [_c('template', {
	      slot: "prepend"
	    }, [_vm._v(_vm._s(_vm.$t('form.productBundles.groupPrice.label')))])], 2), _vm._v(" "), (_vm.groupErrors[("bundles." + i + ".price")]) ? _c('span', {
	      staticStyle: {
	        "color": "red"
	      }
	    }, [_vm._v(_vm._s(_vm.groupErrors[("bundles." + i + ".price")][0]))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "width": "130px"
	      }
	    }, [_c('el-input', {
	      attrs: {
	        "disabled": true
	      },
	      model: {
	        value: (group.taxPerc),
	        callback: function($$v) {
	          _vm.$set(group, "taxPerc", $$v)
	        },
	        expression: "group.taxPerc"
	      }
	    }, [_c('template', {
	      slot: "prepend"
	    }, [_vm._v(_vm._s(_vm.$t('form.productBundles.groupTax.label')))])], 2)], 1)])], 1)], 1), _vm._v(" "), _c('v-form-table', {
	      attrs: {
	        "form": _vm.formTable,
	        "list": group.items,
	        "update": _vm.updateTable,
	        "destroy": _vm.destroyTable,
	        "translation": "table.productBundles"
	      }
	    })], 1)
	  })], 2)], 1)], 1)], 1) : _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.productBundles",
	      "hasLabel": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [(_vm.isInOwnRoute) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productBundles.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
	    class: {
	      'outline': _vm.isInOwnRoute
	    },
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3008 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.index.title')) + " (" + _vm._s(_vm.orders.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('el-button-group', [_c('el-button', {
	    attrs: {
	      "type": _vm.primary,
	      "size": "small",
	      "icon": "el-icon-menu",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('info')
	      }
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": _vm.info,
	      "size": "small",
	      "icon": "el-icon-tickets",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('primary')
	      }
	    }
	  })], 1), _vm._v(" "), _c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search,
	      "clearable": true
	    },
	    on: {
	      "keydown": _vm.onChangeSearch
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('v-select', {
	    attrs: {
	      "name": "allType",
	      "translation": "static.clients.index.listing",
	      "options": _vm.listTypes,
	      "value": _vm.allType
	    },
	    on: {
	      "change": _vm.onChange
	    }
	  }), _vm._v(" "), _c('v-select', {
	    attrs: {
	      "name": "sort",
	      "translation": "static.clients.index.sortName",
	      "options": _vm.sortTypes,
	      "value": _vm.sort
	    },
	    on: {
	      "change": _vm.onChange
	    }
	  })], 1)])], 1), _vm._v(" "), (_vm.showAction) ? _c('el-row', {
	    staticClass: "bulkActions",
	    attrs: {
	      "gutter": 5
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 8,
	      "lg": 6,
	      "xl": 4
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.selectedCount) + " orders selected")])]), _vm._v(" "), _c('el-col', {
	    staticStyle: {
	      "text-align": "right"
	    },
	    attrs: {
	      "md": 3,
	      "lg": 3,
	      "xl": 2
	    }
	  }, [(_vm.showAction) ? _c('label', [_vm._v(_vm._s(_vm.$t('orderActions.select.label')) + " ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 13,
	      "lg": 15,
	      "xl": 18
	    }
	  }, [_c('button', {
	    staticClass: "el-button el-button--default small",
	    staticStyle: {
	      "margin-bottom": "4px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onSelectAction('confirmOrderAndShipping')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('orderActions.confirmOrderAndShipping')))]), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--default small",
	    staticStyle: {
	      "margin-bottom": "4px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onSelectAction('dowloadDeliverySlip')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('orderActions.dowloadDeliverySlip')))]), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--danger danger small",
	    staticStyle: {
	      "margin-bottom": "4px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onSelectAction('cancelOrder')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('orderActions.cancelOrder')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.ordersList.length === 0) ? _c('v-no-data', [(_vm.isOrderOverview) ? _c('p', [_vm._v(_vm._s(_vm.$t('static.defaultText.order.noDataMsg')))]) : _vm._e(), _vm._v(" "), (_vm.isEdiOverview) ? _c('p', [_vm._v(_vm._s(_vm.$t('static.defaultText.edi.noDataMsg')))]) : _vm._e(), _vm._v(" "), (_vm.isOrderOverview) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'orders.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.order.noDataBtn')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.ordersList), function(order, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editOrder(order)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel full-w"
	    }, [_c('span', [_vm._v("\n            #" + _vm._s(order.number) + "\n            "), _c('span', {
	      staticClass: "cardBadge"
	    }, [_vm._v(_vm._s(_vm.$t(("static.orders.types." + (order.orderType.toLowerCase())))))])]), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-external-link pull-right",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.editOrderNewTab(order)
	        }
	      }
	    })]), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(order.service || order.value))]), _vm._v(" "), _c('span', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('span', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(order.clientName) + " " + _vm._s(order.ediStore))]), _vm._v(" "), _c('div', {
	      staticClass: "cardinnerBox"
	    }, [_c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-info",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.index.type')) + ":\n            ")]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent cardContent--small"
	    }, [_vm._v("\n              " + _vm._s(_vm.$t(("static.orders.types." + (order.orderType.toLowerCase())))) + " ( " + _vm._s(order.ediType) + " )\n            ")])]), _vm._v(" "), (order.ediOrderId) ? _c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-info",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.index.ediNumber')) + ":\n            ")]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent cardContent--small"
	    }, [_vm._v("\n              " + _vm._s(order.orderNumber) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-clock-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.index.createdDate')) + ":\n            ")]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent cardContent--small"
	    }, [_vm._v("\n              " + _vm._s(_vm.formatDate(order.createdDate)) + "\n            ")])]), _vm._v(" "), (order.ediOrderId) ? _c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-clock-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.index.deliveryDate')) + ":\n            ")]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent cardContent--small"
	    }, [_vm._v("\n              " + _vm._s(_vm.formatDate(order.ediRequestedDeliveryDate)) + "\n            ")])]) : _vm._e(), _vm._v(" "), (order.pickupDate) ? _c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-clock-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.index.pickupDate')) + ":\n            ")]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent cardContent--small"
	    }, [_vm._v("\n              " + _vm._s(order.pickupDate) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-info",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.index.status')) + ":\n            ")]), _vm._v(" "), (order.ediOrderId) ? _c('span', {
	      staticClass: "cardContent cardContent--small status_",
	      class: order.ediStatus
	    }, [_vm._v("\n              " + _vm._s(_vm.$t(("static.ediOrders.index." + (order.ediStatus.toLowerCase())))) + " " + _vm._s(order.sendVia != '' ? ("via " + (order.sendVia)) : '') + "\n            ")]) : _c('span', {
	      staticClass: "cardContent cardContent--small status_",
	      class: order.orderStatus
	    }, [_vm._v("\n              " + _vm._s(_vm.$t(("static.orders.status." + (order.orderStatus.toLowerCase())))) + " " + _vm._s(order.orderStatus.toLowerCase() !== 'cancelled' && order.sendVia != '' ? ("via " + (order.sendVia)) : '') + "\n            ")])]), _vm._v(" "), (order.referenceNumber && !order.ediOrderId) ? _c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-info",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.index.referenceNumber')) + ":\n            ")]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent cardContent--small "
	    }, [_vm._v("\n              " + _vm._s(order.referenceNumber) + "\n            ")])]) : _vm._e()])])
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('el-table', {
	    ref: "multipleTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.ordersListView
	    },
	    on: {
	      "selection-change": _vm.handleSelectionChange
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "selection",
	      "width": "30"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "type": "expand"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [(props.row.orderProducts.length) ? _c('ul', _vm._l((props.row.orderProducts), function(product) {
	          return _c('li', {
	            key: product.id
	          }, [_c('span', {
	            staticStyle: {
	              "font-family": "'robotobold'"
	            }
	          }, [_vm._v(_vm._s(product.quantity) + " STK")]), _vm._v(" — "), _c('span', {
	            staticStyle: {
	              "font-family": "'robotobold'"
	            }
	          }, [_vm._v(_vm._s(product.name))])])
	        }), 0) : _c('span', [_vm._v(_vm._s(_vm.$t('static.orders.index.noProductFound')))])]
	      }
	    }], null, false, 3060253977)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.orders.table.name'),
	      "width": "100",
	      "sortable": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('router-link', {
	          attrs: {
	            "to": {
	              name: 'orders.edit',
	              params: {
	                id: scope.row.id
	              }
	            }
	          }
	        }, [_vm._v(_vm._s(scope.row.name))])]
	      }
	    }], null, false, 2254629758)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "type",
	      "label": _vm.$t('static.orders.table.type'),
	      "width": "90",
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "status",
	      "label": _vm.$t('static.orders.table.status'),
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "clientName",
	      "label": _vm.$t('static.orders.table.clientName'),
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "totalValue",
	      "label": _vm.$t('static.orders.table.totalValue'),
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "totalQuantity",
	      "label": _vm.$t('static.orders.table.totalQuantity'),
	      "width": "100",
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "createdDate",
	      "label": _vm.$t('static.orders.table.createdDate'),
	      "sortable": ""
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.orders.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3009 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flex user-layout-wrapper",
	    class: {
	      'expanded': _vm.innerSidebarState, 'innersidebar-expanded': _vm.innerSidebar.length
	    }
	  }, [_c('v-sidebar'), _vm._v(" "), _c('main', {
	    staticClass: "main"
	  }, [_c('v-header'), _vm._v(" "), _c('div', {
	    staticClass: "main-content"
	  }, [(_vm.alertWarning != '') ? _c('div', {
	    staticClass: "account_alert"
	  }, [_vm._v(_vm._s(_vm.alertWarning) + " "), _c('a', {
	    staticClass: "alert-warning-link",
	    attrs: {
	      "href": "mailTo:support@kundan.no"
	    }
	  }, [_vm._v("support@kundan.no")])]) : _vm._e(), _vm._v(" "), (_vm.hasUnpaidInvoice) ? _c('div', {
	    staticClass: "account_alert unpaid-invoice-alert"
	  }, [_c('svg', {
	    staticClass: "unpaid-invoice-icon",
	    attrs: {
	      "viewBox": "0 0 24 24",
	      "width": "40",
	      "height": "40",
	      "fill": "none",
	      "stroke": "currentColor",
	      "stroke-width": "1.5",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "aria-hidden": "true"
	    }
	  }, [_c('circle', {
	    attrs: {
	      "cx": "12",
	      "cy": "12",
	      "r": "10"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "16",
	      "x2": "12",
	      "y2": "12"
	    }
	  }), _vm._v(" "), _c('line', {
	    attrs: {
	      "x1": "12",
	      "y1": "8",
	      "x2": "12.01",
	      "y2": "8"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "unpaid-invoice-text"
	  }, [_c('span', {
	    staticClass: "unpaid-invoice-title"
	  }, [_vm._v(_vm._s(_vm.$t('static.unpaidInvoiceAlert.title')))]), _vm._v(" "), _c('span', {
	    staticClass: "unpaid-invoice-body"
	  }, [_vm._v(_vm._s(_vm.$t('static.unpaidInvoiceAlert.body')) + " "), _c('a', {
	    staticClass: "alert-warning-link",
	    attrs: {
	      "href": "mailTo:support@kundan.no"
	    }
	  }, [_vm._v("support@kundan.no")])])])]) : _vm._e(), _vm._v(" "), (_vm.bridgeHandoffMessage) ? _c('div', {
	    staticClass: "account_alert bridge-handoff-alert",
	    class: {
	      'bridge-handoff-decommissioned': _vm.stockDecommissioned
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.bridgeHandoffMessage) + "\n        "), (_vm.inventoryAppUrl) ? _c('a', {
	    staticClass: "alert-warning-link",
	    attrs: {
	      "href": _vm.inventoryAppUrl,
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('static.bridgeHandoff.openApp')) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('footer', [_c('div', {
	    staticClass: "footer-inner"
	  }, [_c('img', {
	    staticClass: "footer-logo",
	    attrs: {
	      "src": __webpack_require__(2648)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "footer-meta"
	  }, [_c('span', {
	    staticClass: "footer-copyright"
	  }, [_vm._v("© " + _vm._s(new Date().getFullYear()) + " Kundan + AS. All rights reserved.")]), _vm._v(" "), _c('a', {
	    staticClass: "footer-link",
	    attrs: {
	      "href": "mailto:support@kundan.no"
	    }
	  }, [_vm._v("support@kundan.no")])])])])], 2)], 1), _vm._v(" "), _c('v-dialog')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3010 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-row', {
	    staticClass: "bulk-product-add"
	  }, [_c('el-col', {
	    staticClass: "text-right",
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-button', {
	    staticClass: "small btn-add-bulk",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "disabled": _vm.disableSubmit(),
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.handleSubmit
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.add')))])], 1), _vm._v(" "), _c('el-col', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "span": 24
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.bulkAddProducts.selectedProducts.title')))]), _vm._v(" "), _c('el-table', {
	    staticClass: "selected-products",
	    staticStyle: {
	      "width": "100%",
	      "margin-bottom": "10px"
	    },
	    attrs: {
	      "data": _vm.selected,
	      "empty-text": _vm.$t('static.bulkAddProducts.selectedProducts.noneSelected')
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "width": "60px"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-button', {
	          staticClass: "danger",
	          attrs: {
	            "size": "mini",
	            "type": "danger",
	            "icon": "el-icon-delete",
	            "tabindex": "-1",
	            "circle": ""
	          },
	          nativeOn: {
	            "click": function($event) {
	              $event.preventDefault();
	              return _vm.handleRemove(scope.$index, _vm.selected)
	            }
	          }
	        })]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bulkAddProducts.selectedProducts.productName')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v("\n            " + _vm._s(scope.row.name) + " "), (scope.row.info) ? _c('small', {
	          staticClass: "details"
	        }, [_vm._v(" (" + _vm._s(scope.row.info) + ")")]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": 'Product Type',
	      "width": "110px"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v("\n            " + _vm._s(scope.row.productType) + " "), (scope.row.info) ? _c('small', {
	          staticClass: "details"
	        }, [_vm._v(" (" + _vm._s(scope.row.productType) + ")")]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), (_vm.batches.length) ? _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bulkAddProducts.selectedProducts.batch'),
	      "width": "150px"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          staticClass: "flex"
	        }, [(_vm.enableCustomBatch && _vm.account.allowProducerBatches) ? _c('el-button', {
	          staticStyle: {
	            "margin-right": "5px"
	          },
	          attrs: {
	            "type": "primary",
	            "icon": "el-icon-plus",
	            "size": "small",
	            "circle": ""
	          },
	          nativeOn: {
	            "click": function($event) {
	              $event.preventDefault();
	              return _vm.addBatch(scope.row)
	            }
	          }
	        }) : _vm._e(), _vm._v(" "), (scope.row.batches.length) ? _c('el-select', {
	          attrs: {
	            "placeholder": "Select"
	          },
	          model: {
	            value: (scope.row.batchId),
	            callback: function($$v) {
	              _vm.$set(scope.row, "batchId", $$v)
	            },
	            expression: "scope.row.batchId"
	          }
	        }, _vm._l((scope.row.batches), function(item) {
	          return _c('el-option', {
	            key: item.id,
	            attrs: {
	              "label": item.name,
	              "value": item.id
	            }
	          })
	        }), 1) : _vm._e()], 1)]
	      }
	    }], null, false, 1576689018)
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bulkAddProducts.selectedProducts.available'),
	      "width": "120"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(scope.row.currentQty))])]
	      }
	    }])
	  }), _vm._v(" "), (_vm.isOrderPage) ? [_c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bulkAddProducts.selectedProducts.unitTypeId'),
	      "width": "170"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.productTypeGroup == 'Beverage') ? _c('el-select', {
	          attrs: {
	            "placeholder": "Select"
	          },
	          model: {
	            value: (scope.row.unitTypeId),
	            callback: function($$v) {
	              _vm.$set(scope.row, "unitTypeId", $$v)
	            },
	            expression: "scope.row.unitTypeId"
	          }
	        }, _vm._l((_vm.unitTypes.all), function(item) {
	          return _c('el-option', {
	            key: item.id,
	            attrs: {
	              "label": item.name,
	              "value": item.id
	            }
	          })
	        }), 1) : _vm._e()]
	      }
	    }], null, false, 1166675701)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bulkAddProducts.selectedProducts.unitQty'),
	      "width": "170"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.productTypeGroup == 'Beverage') ? _c('el-input-number', {
	          ref: ("input" + (scope.$index)),
	          staticStyle: {
	            "width": "150px"
	          },
	          attrs: {
	            "min": -999999,
	            "max": 999999
	          },
	          model: {
	            value: (scope.row.unitQty),
	            callback: function($$v) {
	              _vm.$set(scope.row, "unitQty", $$v)
	            },
	            expression: "scope.row.unitQty"
	          }
	        }) : _vm._e()]
	      }
	    }], null, false, 101108438)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bulkAddProducts.selectedProducts.qty'),
	      "width": "170"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.productTypeGroup != 'Beverage') ? _c('el-input-number', {
	          ref: ("input" + (scope.$index)),
	          staticStyle: {
	            "width": "150px"
	          },
	          attrs: {
	            "min": -999999,
	            "max": 999999
	          },
	          model: {
	            value: (scope.row.qty),
	            callback: function($$v) {
	              _vm.$set(scope.row, "qty", $$v)
	            },
	            expression: "scope.row.qty"
	          }
	        }) : _vm._e()]
	      }
	    }], null, false, 2563757676)
	  })] : [_c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bulkAddProducts.selectedProducts.qty'),
	      "width": "170"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-input-number', {
	          ref: ("input" + (scope.$index)),
	          staticStyle: {
	            "width": "150px"
	          },
	          attrs: {
	            "min": -999999,
	            "max": 999999
	          },
	          model: {
	            value: (scope.row.qty),
	            callback: function($$v) {
	              _vm.$set(scope.row, "qty", $$v)
	            },
	            expression: "scope.row.qty"
	          }
	        })]
	      }
	    }])
	  })]], 2), _vm._v(" "), _c('el-input', {
	    staticStyle: {
	      "width": "100%",
	      "margin-top": "20px"
	    },
	    attrs: {
	      "placeholder": _vm.$t('static.bulkAddProducts.findProducts.search'),
	      "clearable": true
	    },
	    model: {
	      value: (_vm.search),
	      callback: function($$v) {
	        _vm.search = $$v
	      },
	      expression: "search"
	    }
	  }), _vm._v(" "), _c('el-table', {
	    staticClass: "product-search-table",
	    staticStyle: {
	      "width": "100%",
	      "overflow": "auto",
	      "height": "300px"
	    },
	    attrs: {
	      "data": _vm.products.filter(function (data) { return !_vm.search || data.name.toLowerCase().includes(_vm.search.toLowerCase()); }),
	      "show-header": false,
	      "row-class-name": _vm.searchTableRowClassName
	    },
	    on: {
	      "current-change": _vm.handleCurrentChange
	    }
	  }, [_c('el-table-column', {
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v("\n            " + _vm._s(scope.row.name) + " "), (scope.row.info) ? _c('small', {
	          staticClass: "details"
	        }, [_vm._v(" (" + _vm._s(scope.row.info) + ") - ID: " + _vm._s(scope.row.id))]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v("\n            " + _vm._s(scope.row.productType) + "\n          ")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v("\n            " + _vm._s(_vm.$t('static.bulkAddProducts.selectedProducts.available')) + " " + _vm._s(scope.row.currentQty) + "\n          ")]
	      }
	    }])
	  })], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3011 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3012 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [(_vm.procedure) ? [_vm._v(_vm._s(_vm.$t('static.recipes.edit.editProcedure')))] : [_vm._v(_vm._s(_vm.$t('static.recipes.edit.addProcedure')))]], 2), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [_c('el-col', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "save": _vm.save,
	      "form": _vm.form,
	      "translation": "form.recipes",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3013 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 24
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.stock.create'
	      }
	    }
	  }, [_c('a', [_c('el-col', {
	    staticClass: "el-card box-card is-always-shadow",
	    attrs: {
	      "span": 12
	    }
	  }, [_c('div', {
	    staticClass: "el-card__body"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('static.stock.filters.create')))]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-file-text-o fa-3x"
	  })])])], 1)]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.adjustment.stock.create'
	      }
	    }
	  }, [_c('a', [_c('el-col', {
	    staticClass: "el-card box-card is-always-shadow",
	    attrs: {
	      "span": 12
	    }
	  }, [_c('div', {
	    staticClass: "el-card__body"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('static.adjustment.filters.create')))]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-adjust fa-3x"
	  })])])], 1)]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.purchase.create'
	      }
	    }
	  }, [_c('a', [_c('el-col', {
	    staticClass: "el-card box-card is-always-shadow",
	    attrs: {
	      "span": 12
	    }
	  }, [_c('div', {
	    staticClass: "el-card__body"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('static.purchase.filters.create')))]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-shopping-cart fa-3x"
	  })])])], 1)]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.transfer.create'
	      }
	    }
	  }, [_c('a', [_c('el-col', {
	    staticClass: "el-card box-card is-always-shadow",
	    attrs: {
	      "span": 12
	    }
	  }, [_c('div', {
	    staticClass: "el-card__body"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('static.transfer.filters.create')))]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-exchange fa-3x"
	  })])])], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3014 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "chart-contaier"
	  }, [(_vm.loaded) ? _c('div', {
	    staticClass: "waiting-revenue"
	  }, [_c('div', {
	    staticClass: "number-container"
	  }, [_c('h2', [_c('span', {
	    staticClass: "currency"
	  }, [_vm._v(_vm._s(_vm.currencySymbol))]), _vm._v(" " + _vm._s(_vm.number.toLocaleString(_vm.currencyCode)))])])]) : _c('div', {
	    staticClass: "loading"
	  }, [_c('i', {
	    staticClass: "el-icon-loading"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 3015 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3016 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "content login-wrapper"
	  }, [_c('div', {
	    staticClass: "content-inner loginBox"
	  }, [_c('div', {
	    staticClass: "flex-column full-w centered"
	  }, [_c('div', {
	    staticClass: "min-width-300 max-width-300"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(181),
	      "width": "200px"
	    }
	  }), _vm._v(" "), (this.step == 1) ? _c('div', [_c('h3', [_vm._v(_vm._s(_vm.headerMessage1))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.headerMessage2))]), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "save": _vm.next,
	      "form": _vm.form,
	      "btn-text": "button.next",
	      "translation": "form.register"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (this.step == 2) ? _c('div', [_c('h3', [_vm._v("Du er nesten ferdig...")]), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "save": _vm.register,
	      "form": _vm.finalStep,
	      "btn-text": "button.getStarted",
	      "translation": "form.register"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.loginInstead) ? _c('p', [_vm._v(_vm._s(_vm.$t('static.emailSetup.emailExistSuggestion')))]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "forgot-password"
	  }, [_c('router-link', {
	    staticClass: "buttons_login",
	    attrs: {
	      "to": {
	        name: 'auth.login'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.login')))])], 1)])])])])])
	},staticRenderFns: []}

/***/ }),
/* 3017 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.newPricingAgreement')))]), _vm._v(" "), _c('p', {
	    staticClass: "mb-10"
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.orImportLink')) + " "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'pricingAgreements.index',
	        query: {
	          import: '1'
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.importFromTemplateLink')))]), _vm._v(".")], 1), _vm._v(" "), _c('el-form', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "140px"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.customer'),
	      "required": ""
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "placeholder": _vm.$t('pricingAgreements.selectCustomer'),
	      "filterable": ""
	    },
	    model: {
	      value: (_vm.form.client_id),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "client_id", $$v)
	      },
	      expression: "form.client_id"
	    }
	  }, _vm._l((_vm.clients), function(c) {
	    return _c('el-option', {
	      key: c.id,
	      attrs: {
	        "label": c.name,
	        "value": c.id,
	        "disabled": c.system_generated === 1
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.name'),
	      "required": ""
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": _vm.$t('pricingAgreements.namePlaceholder')
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.validFrom'),
	      "required": ""
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "date",
	      "value-format": "yyyy-MM-dd",
	      "placeholder": _vm.$t('pricingAgreements.from')
	    },
	    model: {
	      value: (_vm.form.valid_from),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "valid_from", $$v)
	      },
	      expression: "form.valid_from"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.validTo'),
	      "required": ""
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "date",
	      "value-format": "yyyy-MM-dd",
	      "placeholder": _vm.$t('pricingAgreements.to')
	    },
	    model: {
	      value: (_vm.form.valid_to),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "valid_to", $$v)
	      },
	      expression: "form.valid_to"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('pricingAgreements.active')
	    }
	  }, [_c('el-switch', {
	    model: {
	      value: (_vm.form.is_active),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "is_active", $$v)
	      },
	      expression: "form.is_active"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "small",
	      "loading": _vm.saving
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.createButton')))]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'pricingAgreements.index',
	        query: {
	          filter: 'active'
	        }
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "pricing-agreement-back-btn",
	    attrs: {
	      "type": "default",
	      "size": "small"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.cancel')))])], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3018 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.orderInternalNote.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('div', [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.orders.orderInternalNote.title')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    staticStyle: {
	      "margin-top": "15px"
	    },
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.orderInternalNote",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [_c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.cancel').toUpperCase()) + "\n      ")]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.save').toUpperCase()) + "\n      ")])], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3019 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle",
	    class: {
	      'pageTitle--dark': !_vm.isInOwnRoute
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.productBundles.edit.title')))])])], 1), _vm._v(" "), _c('div', {
	    class: {
	      'whiteWrapper': _vm.isInOwnRoute
	    }
	  }, [(_vm.isInOwnRoute) ? _c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.productBundles.formTabs.bundleInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.productBundles",
	      "hasLabel": true
	    }
	  }), _vm._v(" "), _c('div', [_c('div', [_c('el-button', {
	    staticClass: "primary small",
	    on: {
	      "click": _vm.showBulkAddModal
	    }
	  }, [_vm._v("Add Product")])], 1), _vm._v(" "), _vm._l((_vm.list), function(group, i) {
	    return _c('div', [_c('div', {
	      staticStyle: {
	        "margin-top": "30px"
	      }
	    }, [_c('el-row', {
	      attrs: {
	        "gutter": 10
	      }
	    }, [_c('el-col', {
	      staticStyle: {
	        "display": "flex",
	        "column-gap": "0.625rem"
	      },
	      attrs: {
	        "xs": 24
	      }
	    }, [_c('div', {
	      staticStyle: {
	        "width": "300px"
	      }
	    }, [_c('el-input', {
	      model: {
	        value: (group.name),
	        callback: function($$v) {
	          _vm.$set(group, "name", $$v)
	        },
	        expression: "group.name"
	      }
	    }, [_c('template', {
	      slot: "prepend"
	    }, [_vm._v(_vm._s(_vm.$t('form.productBundles.groupName.label')))])], 2), _vm._v(" "), (_vm.groupErrors[("bundles." + i + ".name")]) ? _c('span', {
	      staticStyle: {
	        "color": "red"
	      }
	    }, [_vm._v(_vm._s(_vm.groupErrors[("bundles." + i + ".name")][0]))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "width": "200px"
	      }
	    }, [_c('el-input', {
	      attrs: {
	        "disabled": true
	      },
	      model: {
	        value: (group.price),
	        callback: function($$v) {
	          _vm.$set(group, "price", $$v)
	        },
	        expression: "group.price"
	      }
	    }, [_c('template', {
	      slot: "prepend"
	    }, [_vm._v(_vm._s(_vm.$t('form.productBundles.groupPrice.label')))])], 2), _vm._v(" "), (_vm.groupErrors[("bundles." + i + ".price")]) ? _c('span', {
	      staticStyle: {
	        "color": "red"
	      }
	    }, [_vm._v(_vm._s(_vm.groupErrors[("bundles." + i + ".price")][0]))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "width": "130px"
	      }
	    }, [_c('el-input', {
	      attrs: {
	        "disabled": true
	      },
	      model: {
	        value: (group.taxPerc),
	        callback: function($$v) {
	          _vm.$set(group, "taxPerc", $$v)
	        },
	        expression: "group.taxPerc"
	      }
	    }, [_c('template', {
	      slot: "prepend"
	    }, [_vm._v(_vm._s(_vm.$t('form.productBundles.groupTax.label')))])], 2)], 1)])], 1)], 1), _vm._v(" "), _c('v-form-table', {
	      attrs: {
	        "form": _vm.formTable,
	        "list": group.items,
	        "update": _vm.updateTable,
	        "destroy": _vm.destroyTable,
	        "stack": {
	          price: 'productDepositName'
	        },
	        "noResultWarningText": "No Result",
	        "translation": "table.productBundles"
	      }
	    })], 1)
	  })], 2)], 1)], 1)], 1) : _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.productBundles",
	      "hasLabel": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [(_vm.isInOwnRoute) ? _c('el-button', {
	    staticClass: "danger",
	    on: {
	      "click": _vm.destroy
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.delete').toUpperCase()))]) : _vm._e(), _vm._v(" "), _c('el-button', {
	    class: {
	      'outline': _vm.isInOwnRoute
	    },
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3020 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_vm._l((_vm.headerTexts), function(headerText) {
	    return _c('p', [_vm._v("\n    " + _vm._s(headerText) + "\n  ")])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.to')) + ":")]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item__content"
	  }, [_c('div', {
	    staticClass: "el-input"
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "filterable": _vm.isEmailInput ? true : false,
	      "allow-create": _vm.isEmailInput ? true : false,
	      "placeholder": "Select Recipient",
	      "multiple": true
	    },
	    model: {
	      value: (_vm.emailTo),
	      callback: function($$v) {
	        _vm.emailTo = $$v
	      },
	      expression: "emailTo"
	    }
	  }, _vm._l((_vm.contactOptions), function(contact) {
	    return _c('el-option', {
	      key: contact.id,
	      attrs: {
	        "label": contact.name,
	        "value": contact.email
	      }
	    })
	  }), 1)], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(" CC:")]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item__content"
	  }, [_c('div', {
	    staticClass: "el-input"
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "filter-method": _vm.ccOptionFilter,
	      "filterable": true,
	      "allow-create": true,
	      "placeholder": "Select email cc",
	      "multiple": true,
	      "popper-class": "ccEmail hidden"
	    },
	    model: {
	      value: (_vm.emailcc),
	      callback: function($$v) {
	        _vm.emailcc = $$v
	      },
	      expression: "emailcc"
	    }
	  }, _vm._l((_vm.ccOptions), function(cc) {
	    return _c('el-option', {
	      key: cc.id,
	      attrs: {
	        "label": cc.email,
	        "value": cc.email
	      }
	    })
	  }), 1)], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.subject')) + ":")]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item__content"
	  }, [_c('div', {
	    staticClass: "el-input"
	  }, [_c('el-input', {
	    attrs: {
	      "name": "subject"
	    },
	    model: {
	      value: (_vm.previewSubject),
	      callback: function($$v) {
	        _vm.previewSubject = $$v
	      },
	      expression: "previewSubject"
	    }
	  })], 1)])]), _vm._v(" "), (_vm.server) ? _c('div', [_c('file-pond', {
	    ref: "pond",
	    attrs: {
	      "name": "pdfAttachment",
	      "label-idle": "Drag & Drop your files or <span class=\"filepond--label-action\"> Browse </span><br> <b>Pdf attachment only with maximum 2 files upload</b>",
	      "allow-multiple": "true",
	      "max-files": "3",
	      "maxFileSize": "500kb",
	      "accepted-file-types": "application/pdf",
	      "server": _vm.attachmentServer,
	      "files": _vm.attachmentInit
	    }
	  }), _vm._v(" "), _vm._m(0)], 1) : _c('p', [_vm._v(_vm._s(_vm.$t('static.bills.edit.attachment')) + ":\n    "), _vm._l((_vm.attachments), function(attachment) {
	    return _c('a', {
	      attrs: {
	        "loading": _vm.modalButtonLoading,
	        "title": attachment.title,
	        "role": "button"
	      },
	      on: {
	        "click": attachment.action
	      }
	    }, [_vm._v("\n        " + _vm._s(attachment.attachmentName) + "\n    ")])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "el-textarea margin-b-10"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.messageBody')) + ":")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.previewMessage),
	      expression: "previewMessage"
	    }],
	    staticClass: "el-textarea__inner",
	    attrs: {
	      "rows": "10",
	      "name": "message"
	    },
	    domProps: {
	      "value": (_vm.previewMessage)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.previewMessage = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "el-textarea"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.notes')) + ":")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.previewNotes),
	      expression: "previewNotes"
	    }],
	    staticClass: "el-textarea__inner",
	    attrs: {
	      "rows": "3",
	      "name": "note"
	    },
	    domProps: {
	      "value": (_vm.previewNotes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.previewNotes = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex wrap justify-center buttons_under_main_body"
	  }, _vm._l((_vm.buttons), function(button) {
	    return _c('el-button', {
	      attrs: {
	        "loading": _vm.modalButtonLoading
	      },
	      on: {
	        "click": button.action
	      }
	    }, [_vm._v("\n        " + _vm._s(button.name) + "\n    ")])
	  }), 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex wrap"
	  }, _vm._l((_vm.links), function(link) {
	    return _c('a', {
	      attrs: {
	        "loading": _vm.modalButtonLoading,
	        "title": link.title,
	        "role": "button"
	      },
	      on: {
	        "click": link.action
	      }
	    }, [_vm._v("\n        " + _vm._s(link.name) + "\n    ")])
	  }), 0)], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "errors filepond"
	  }, [_c('div')])
	}]}

/***/ }),
/* 3021 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "product-index-settings"
	  }, [_c('span', {
	    staticClass: "input-label"
	  }, [_vm._v(_vm._s(_vm.$t("static.products.indexSettings.displayType")) + ":")]), _vm._v(" "), _c('div', {
	    staticClass: "flex justify-center margin-b-10"
	  }, [_c('el-button-group', [_c('el-button', {
	    attrs: {
	      "type": _vm.primary,
	      "icon": "el-icon-menu",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('info')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t("static.products.indexSettings.views.grid")))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": _vm.info,
	      "icon": "el-icon-tickets",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('primary')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t("static.products.indexSettings.views.list")) + "\n      ")])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "margin-t-10"
	  }, [_c('span', {
	    staticClass: "input-label"
	  }, [_vm._v(_vm._s(_vm.$t("static.products.indexSettings.groupBy")) + ":")]), _vm._v(" "), _c('div', {
	    staticClass: "flex justify-center"
	  }, [_c('div', [_c('el-radio-group', {
	    attrs: {
	      "round": ""
	    },
	    on: {
	      "change": _vm.handleGroupByChange
	    },
	    model: {
	      value: (_vm.group),
	      callback: function($$v) {
	        _vm.group = $$v
	      },
	      expression: "group"
	    }
	  }, [_c('el-radio-button', {
	    attrs: {
	      "label": "None"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("static.products.indexSettings.groups.None")))]), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "Producer"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("static.products.indexSettings.groups.Producer")))]), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "Type"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("static.products.indexSettings.groups.Type")))])], 1)], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 3022 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('static.orders.edit.exciseModalFormTitle')) + " " + _vm._s(_vm.productName))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "hasLabel": true,
	      "translation": "form.products",
	      "save": _vm.onSubmit
	    }
	  }) : _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')])], 1)
	},staticRenderFns: []}

/***/ }),
/* 3023 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3024 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [(!_vm.show) ? _c('el-button', {
	    staticClass: "margin-b-10 small",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.show = true
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.add').toUpperCase()) + " " + _vm._s(_vm.$t(("form.addressTypes.options." + (_vm.camelize(_vm.name))))) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('el-collapse-transition', [(_vm.show) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.clients",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.show && _vm.form.streetName && _vm.name !== 'Postal') ? _c('el-button', {
	    staticClass: "margin-b-10 small dark",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.destroy($event)
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.delete').toUpperCase()) + "\n    ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 3025 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "content login-wrapper"
	  }, [_c('div', {
	    staticClass: "content-inner loginBox"
	  }, [_c('div', {
	    staticClass: "flex-column full-w centered"
	  }, [(_vm.maintenance) ? _c('el-alert', {
	    staticStyle: {
	      "padding": "20px"
	    },
	    attrs: {
	      "title": "Site on maintenance mode. Login is disabled",
	      "type": "error",
	      "closable": false
	    }
	  }) : _vm._e(), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "min-width-300 max-width-300"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(181),
	      "width": "200px"
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('static.login.title')))]), _vm._v(" "), (_vm.form.errorBox) ? _c('el-alert', {
	    attrs: {
	      "title": _vm.form.errorBoxTitle || _vm.$t('static.login.errorBoxTitle'),
	      "type": "error",
	      "closable": false
	    }
	  }) : _vm._e(), _c('br'), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "btn-text": "button.login",
	      "translation": "form.login"
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "loading": _vm.form.loading,
	      "disabled": _vm.maintenance
	    },
	    on: {
	      "click": _vm.login
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('button.login')) + "\n              ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "forgot-password"
	  }, [(false) ? _c('router-link', {
	    staticClass: "buttons_login",
	    attrs: {
	      "to": {
	        name: 'home.index'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.login.newUser')))]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'auth.resetPassword'
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.login.forgotPassword')))])], 1)], 1)], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 3026 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('div', {
	    staticClass: "el-form-item"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.to')) + ":")]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item__content"
	  }, [_c('div', {
	    staticClass: "el-input"
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "disabled": true,
	      "placeholder": "Email to",
	      "multiple": true
	    },
	    model: {
	      value: (_vm.previewEmailTo),
	      callback: function($$v) {
	        _vm.previewEmailTo = $$v
	      },
	      expression: "previewEmailTo"
	    }
	  }, _vm._l((_vm.previewEmailTo), function(email, key) {
	    return _c('el-option', {
	      key: key,
	      attrs: {
	        "label": email,
	        "value": email
	      }
	    })
	  }), 1)], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(" CC:")]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item__content"
	  }, [_c('div', {
	    staticClass: "el-input"
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "disabled": true,
	      "placeholder": "Email cc",
	      "multiple": true,
	      "popper-class": "ccEmail hidden"
	    },
	    model: {
	      value: (_vm.previewEmailCC),
	      callback: function($$v) {
	        _vm.previewEmailCC = $$v
	      },
	      expression: "previewEmailCC"
	    }
	  }, _vm._l((_vm.previewEmailCC), function(email, key) {
	    return _c('el-option', {
	      key: key,
	      attrs: {
	        "label": email,
	        "value": email
	      }
	    })
	  }), 1)], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.subject')) + ":")]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item__content"
	  }, [_c('div', {
	    staticClass: "el-input"
	  }, [_c('el-input', {
	    attrs: {
	      "disabled": true,
	      "name": "subject"
	    },
	    model: {
	      value: (_vm.previewSubject),
	      callback: function($$v) {
	        _vm.previewSubject = $$v
	      },
	      expression: "previewSubject"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "el-textarea margin-b-10"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.messageBody')) + ":")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.previewMessage),
	      expression: "previewMessage"
	    }],
	    staticClass: "el-textarea__inner",
	    attrs: {
	      "disabled": "disabled",
	      "rows": "10",
	      "name": "message"
	    },
	    domProps: {
	      "value": (_vm.previewMessage)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.previewMessage = $event.target.value
	      }
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 3027 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.purchaseReceive.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.orders.purchaseReceive.title')))]), _vm._v(" "), _c('div', [_c('center', [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.purchaseReceive",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('v-products-table', {
	    attrs: {
	      "fields": _vm.fields,
	      "translation": "table.productsCustom",
	      "page": "purchase"
	    }
	  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3028 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle pageTitle--light"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.materials.create.title')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.materials.formTabs.materialInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.materials",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'production.materials.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.store($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3029 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.accountInformation.profile')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": _vm.tabIndex
	    }
	  }, [(_vm.account.organizationName) ? _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.accountInformation.organizationInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('el-collapse', {
	    model: {
	      value: (_vm.activeProfileInformationName),
	      callback: function($$v) {
	        _vm.activeProfileInformationName = $$v
	      },
	      expression: "activeProfileInformationName"
	    }
	  }, [_c('el-collapse-item', {
	    attrs: {
	      "title": _vm.$t('static.accountInformation.organizationInformation'),
	      "name": "11"
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.organizationForm,
	      "translation": "form.accountInformation",
	      "hasLabel": true
	    }
	  })], 1), _vm._v(" "), _c('el-collapse-item', {
	    attrs: {
	      "title": _vm.$t('static.accountInformation.businessInformation'),
	      "name": "12"
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.businessInformation,
	      "translation": "form.accountInformation",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('el-collapse', {
	    model: {
	      value: (_vm.activeProfileInformationName),
	      callback: function($$v) {
	        _vm.activeProfileInformationName = $$v
	      },
	      expression: "activeProfileInformationName"
	    }
	  }, [_c('el-collapse-item', {
	    attrs: {
	      "title": _vm.$t('static.accountInformation.contactInformation'),
	      "name": "13"
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.contactInformationForm,
	      "translation": "form.accountInformation",
	      "hasLabel": true
	    }
	  })], 1), _vm._v(" "), _c('el-collapse-item', {
	    attrs: {
	      "title": _vm.$t('static.accountInformation.addressInformation'),
	      "name": "14"
	    }
	  }, [_c('v-form', {
	    staticClass: "form-panel",
	    attrs: {
	      "form": _vm.addressForm,
	      "translation": "form.contactForm",
	      "hasLabel": true
	    }
	  })], 1), _vm._v(" "), _c('el-collapse-item', {
	    attrs: {
	      "title": _vm.$t('static.accountInformation.userSetting'),
	      "name": "15"
	    }
	  }, [_c('v-form', {
	    staticClass: "form-panel",
	    attrs: {
	      "form": _vm.userSettingForm,
	      "translation": "form.userSettingForm",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('el-button', {
	    attrs: {
	      "loading": _vm.businessInformation.loading
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.accountInformation.userInformation'),
	      "name": "2"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 24,
	      "lg": 12
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.accountInformation.loginInformation')))]), _vm._v(" "), _c('v-form', {
	    staticClass: "form-panel",
	    attrs: {
	      "form": _vm.userInformationForm,
	      "translation": "form.accountInformation",
	      "hasLabel": true
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center"
	  }, [_c('el-button', {
	    attrs: {
	      "loading": _vm.userInformationForm.loading
	    },
	    on: {
	      "click": _vm.saveUserInformation
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "lg": 12
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.accountInformation.passwordTitle')))]), _vm._v(" "), _c('v-form', {
	    staticClass: "form-panel",
	    attrs: {
	      "form": _vm.passwordForm,
	      "translation": "form.passwordForm",
	      "hasLabel": true
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center"
	  }, [_c('el-button', {
	    attrs: {
	      "loading": _vm.addressForm.loading
	    },
	    on: {
	      "click": _vm.changePassword
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), (_vm.isOnlineBooking) ? _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.publicProfile.title'),
	      "name": "4"
	    }
	  }, [(_vm.publicProfile.profileUrl && _vm.publicPageDomain) ? _c('el-row', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v(_vm._s(_vm.$t('static.publicProfile.profileUrl')) + ": ")]), _c('a', {
	    staticClass: "label-content",
	    attrs: {
	      "target": "_blank",
	      "href": ("http://" + (_vm.publicProfile.profileUrl) + "." + _vm.publicPageDomain)
	    }
	  }, [_vm._v(_vm._s(_vm.publicProfile.profileUrl) + "." + _vm._s(_vm.publicPageDomain))])]) : _vm._e(), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 12
	    }
	  }, [_c('el-collapse', {
	    model: {
	      value: (_vm.activeNames),
	      callback: function($$v) {
	        _vm.activeNames = $$v
	      },
	      expression: "activeNames"
	    }
	  }, [_c('el-collapse-item', {
	    attrs: {
	      "title": _vm.$t('static.publicProfile.mainSettings'),
	      "name": "1"
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.mainPublicProfileForm,
	      "translation": "form.publicProfile",
	      "hasLabel": true
	    }
	  })], 1), _vm._v(" "), _c('el-collapse-item', {
	    attrs: {
	      "title": _vm.$t('static.publicProfile.checkoutSettings'),
	      "name": "3"
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.checkoutSettingsForm,
	      "translation": "form.checkout",
	      "hasLabel": true
	    }
	  }), _vm._v(" "), (!_vm.publicProfile.stripeConnect) ? _c('a', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.stripeButtonLoading),
	      expression: "stripeButtonLoading"
	    }],
	    staticClass: "el-button el-button--default",
	    staticStyle: {
	      "color": "white"
	    },
	    attrs: {
	      "href": 'https://connect.stripe.com/oauth/authorize?response_type=code&client_id=' + _vm.stripe_client_id + '&scope=read_write'
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.publicProfile.connectToStripe')))]) : _c('button', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.stripeButtonLoading),
	      expression: "stripeButtonLoading"
	    }],
	    staticClass: "el-button el-button--default",
	    attrs: {
	      "disabled": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check"
	  }), _vm._v("  " + _vm._s(_vm.$t('static.publicProfile.stripeConnected')))])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 12
	    }
	  }, [_c('el-collapse', {
	    model: {
	      value: (_vm.activeNames),
	      callback: function($$v) {
	        _vm.activeNames = $$v
	      },
	      expression: "activeNames"
	    }
	  }, [_c('el-collapse-item', {
	    attrs: {
	      "title": _vm.$t('static.publicProfile.defaults'),
	      "name": "2"
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.defaultsPublicProfileForm,
	      "translation": "form.publicProfile",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('el-button', {
	    attrs: {
	      "loading": _vm.mainPublicProfileForm.loading
	    },
	    on: {
	      "click": _vm.savePublicProfile
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isOnlineBooking) ? _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.businessHours.title'),
	      "name": "5"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    staticStyle: {
	      "margin-bottom": "25px"
	    },
	    attrs: {
	      "xs": 24,
	      "md": 24
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.businessHours.businessHoursTitle')))]), _vm._v(" "), _c('v-open-hours')], 1)]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 24
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.businessHours.businessHourExceptionsTitle')))]), _vm._v(" "), _c('v-exceptional-hours')], 1)])], 1)], 1) : _vm._e()], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3030 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-users",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.index.title')) + "\n        (" + _vm._s(_vm.clients.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions client-options"
	  }, [_c('el-button-group', {
	    staticClass: "client-view-type"
	  }, [_c('el-button', {
	    attrs: {
	      "type": _vm.primary,
	      "size": "small",
	      "icon": "el-icon-menu",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('info')
	      }
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": _vm.info,
	      "size": "small",
	      "icon": "el-icon-tickets",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('primary')
	      }
	    }
	  })], 1), _vm._v(" "), _c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "static.clients.index.search",
	      "value": _vm.search,
	      "clearable": true
	    },
	    on: {
	      "keydown": _vm.onChangeSearch
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('v-select', {
	    staticClass: "sort",
	    attrs: {
	      "name": "sort",
	      "options": _vm.sortTypes,
	      "value": _vm.sort
	    },
	    on: {
	      "change": _vm.onChange
	    }
	  }), _vm._v(" "), _c('el-button', {
	    staticClass: "client-import small",
	    attrs: {
	      "type": _vm.primary,
	      "icon": "el-icon-download",
	      "round": ""
	    },
	    on: {
	      "click": _vm.showImportDownloadModal
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('button.downloadImport')) + "\n        ")])], 1)])], 1), _vm._v(" "), (_vm.showAction) ? _c('el-row', {
	    staticClass: "bulkActions",
	    attrs: {
	      "gutter": 5
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 8,
	      "lg": 6,
	      "xl": 4
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.selectedCount) + " clients selected")])]), _vm._v(" "), _c('el-col', {
	    staticStyle: {
	      "text-align": "right"
	    },
	    attrs: {
	      "md": 3,
	      "lg": 3,
	      "xl": 2
	    }
	  }, [(_vm.showAction) ? _c('label', [_vm._v(_vm._s(_vm.$t('clientActions.select.label')) + " ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 13,
	      "lg": 15,
	      "xl": 18
	    }
	  }, [_c('button', {
	    staticClass: "el-button el-button--default small",
	    staticStyle: {
	      "margin-bottom": "4px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onSelectAction('isSubClient')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('clientActions.isSubClient')))]), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--default small",
	    staticStyle: {
	      "margin-bottom": "4px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onSelectAction('isProducer')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('clientActions.isProducer')))]), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--default small",
	    staticStyle: {
	      "margin-bottom": "4px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onSelectAction('activateClient')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('clientActions.activateClient')))]), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--danger danger small",
	    staticStyle: {
	      "margin-bottom": "4px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onSelectAction('deactivateClient')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('clientActions.deactivateClient')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 16
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.clients.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.client.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'clients.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.client.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.clients.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      attrs: {
	        "wide": true
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editClient(p)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-external-link pull-right",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.editClientNewTab(p)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "full-w flex wrap client-title-container margin-b-10"
	    }, [(p.picture) ? _c('img', {
	      staticClass: "client-img margin-b-10",
	      attrs: {
	        "src": p.picture.url,
	        "alt": p.companyName || ((p.firstName) + " " + (p.lastName))
	      }
	    }) : _c('div', {
	      staticClass: "client-avatar-initials margin-b-10",
	      style: ({
	        backgroundColor: _vm.getAvatarColor(p)
	      }),
	      attrs: {
	        "title": p.companyName || ((p.firstName) + " " + (p.lastName))
	      }
	    }, [_vm._v("\n            " + _vm._s(_vm.getInitials(p)) + "\n          ")]), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(p.companyName || ((p.firstName) + " " + (p.lastName))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	      staticClass: "margin-b-10"
	    }, [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.clients.table.organizationNumber')) + " ")]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.organizationNumber || '–'))])]), _vm._v(" "), (_vm.hasEHFModule) ? _c('div', {
	      staticClass: "margin-b-10 client-ehf-card-block"
	    }, [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.clients.info.ehfListLabel')) + " ")]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent client-ehf-card-value"
	    }, [(p.ehfBilling3_0) ? _c('i', {
	      staticClass: "fa fa-check-circle client-ehf-icon client-ehf-icon--yes",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }) : _c('i', {
	      staticClass: "fa fa-times-circle client-ehf-icon client-ehf-icon--no",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "client-ehf-card-text"
	    }, [_vm._v(_vm._s(p.ehfBilling3_0 ? _vm.$t('static.clients.info.ehfListVerified') : _vm.$t('static.clients.info.ehfListNotVerified')))])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (p.phoneNumber || p.mobileNumber) ? [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.clients.info.phone')) + " ")]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.phoneNumber))]), _vm._v("\n          " + _vm._s((p.phoneNumber && p.mobileNumber) ? ' / ' : '') + "\n          "), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.mobileNumber))]), _c('br')] : _vm._e(), _vm._v(" "), _c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.clients.info.email')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.email ||
	      '-'))]), _vm._v(" "), _c('div', {
	      staticClass: "client-metrics"
	    }, [_c('div', {
	      staticClass: "client-metric-row"
	    }, [_c('span', {
	      staticClass: "client-metric-label"
	    }, [_vm._v(_vm._s(_vm.$t('static.clients.info.totalOrders')))]), _vm._v(" "), _c('span', {
	      staticClass: "client-metric-value"
	    }, [_vm._v(_vm._s(p.ordersCount || 0))])]), _vm._v(" "), _c('div', {
	      staticClass: "client-metric-row"
	    }, [_c('span', {
	      staticClass: "client-metric-label"
	    }, [_vm._v(_vm._s(_vm.$t('static.clients.info.totalRevenue')))]), _vm._v(" "), _c('span', {
	      staticClass: "client-metric-value"
	    }, [_vm._v(_vm._s(p.totalValueInvoiced.toFixed(2)) + " NOK")])]), _vm._v(" "), _c('div', {
	      staticClass: "client-metric-row"
	    }, [_c('span', {
	      staticClass: "client-metric-label"
	    }, [_vm._v(_vm._s(_vm.$t('static.clients.info.pendingPayments')))]), _vm._v(" "), _c('span', {
	      staticClass: "client-metric-value"
	    }, [_vm._v(_vm._s(p.totalValueInvoicedDue.toFixed(2)) + " NOK")])])])], 2)
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 16
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('el-table', {
	    ref: "multipleTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.clientsListView
	    },
	    on: {
	      "selection-change": _vm.handleSelectionChange
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "selection",
	      "width": "30"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "custNo",
	      "label": _vm.$t('static.clients.table.custNo'),
	      "sortable": "",
	      "width": "88"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.clients.table.name'),
	      "sortable": "",
	      "min-width": "280",
	      "class-name": "client-table-col-name"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('a', {
	          on: {
	            "click": function($event) {
	              $event.preventDefault();
	              return _vm.editClient(scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(scope.row.name))])]
	      }
	    }], null, false, 3832337083)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "organizationNumber",
	      "label": _vm.$t('static.clients.table.organizationNumber'),
	      "sortable": "",
	      "min-width": "120"
	    }
	  }), _vm._v(" "), (_vm.hasEHFModule) ? _c('el-table-column', {
	    attrs: {
	      "prop": "ehfSort",
	      "label": _vm.$t('static.clients.info.ehfListLabel'),
	      "sortable": "",
	      "width": "220",
	      "align": "left",
	      "class-name": "client-table-col-ehf"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticClass: "client-ehf-table-cell"
	        }, [(scope.row.ehfBilling3_0) ? _c('i', {
	          staticClass: "fa fa-check-circle client-ehf-icon client-ehf-icon--yes",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }) : _c('i', {
	          staticClass: "fa fa-times-circle client-ehf-icon client-ehf-icon--no",
	          attrs: {
	            "aria-hidden": "true"
	          }
	        }), _vm._v(" "), _c('span', {
	          staticClass: "client-ehf-table-text"
	        }, [_vm._v(_vm._s(scope.row.ehfBilling3_0 ? _vm.$t('static.clients.info.ehfListVerified') : _vm.$t('static.clients.info.ehfListNotVerified')))])])]
	      }
	    }], null, false, 3449862900)
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "phone",
	      "label": _vm.$t('static.clients.table.phone'),
	      "min-width": "80",
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "email",
	      "label": _vm.$t('static.clients.table.email'),
	      "sortable": "",
	      "min-width": "120"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "ordersCount",
	      "label": _vm.$t('static.clients.table.ordersCount'),
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "createdAt",
	      "label": _vm.$t('static.clients.table.createdAt'),
	      "sortable": ""
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.clients.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3031 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('static.news.create.title')))]), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }]
	  }, [_c('br'), _c('br')]) : _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.news",
	      "hasLabel": true
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('button.save')) + "\n  ")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.sending
	    },
	    on: {
	      "click": _vm.test
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.$t('button.sendTest')) + "\n  ")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 3032 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-row', {
	    staticClass: "bulk-client-add"
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('h3', [_vm._v(_vm._s('Bulk processing of products'))]), _vm._v(" "), [_c('el-table', {
	    staticClass: "products",
	    staticStyle: {
	      "width": "100%",
	      "margin-bottom": "10px"
	    },
	    attrs: {
	      "data": _vm.products
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "property": "number",
	      "label": _vm.$t('static.products.table.number'),
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "name",
	      "label": _vm.$t('static.products.table.name'),
	      "sortable": ""
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [_c('el-button', {
	    staticClass: "small dark",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.proceed
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.proceed')))])], 1)]], 2)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3033 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    ref: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder
	    },
	    domProps: {
	      "value": _vm.value
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 3034 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-map-container"
	  }, [_c('div', {
	    ref: "vue-map",
	    staticClass: "vue-map"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "vue-map-hidden"
	  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
	},staticRenderFns: []}

/***/ }),
/* 3035 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_c('span', {
	    domProps: {
	      "textContent": _vm._s(_vm.label)
	    }
	  }), _vm._v(" "), _c('input', {
	    ref: "input",
	    class: _vm.className,
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 3036 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    on: {
	      "tab-click": _vm.navigateTab
	    },
	    model: {
	      value: (_vm.current_tab),
	      callback: function($$v) {
	        _vm.current_tab = $$v
	      },
	      expression: "current_tab"
	    }
	  }, [_c('el-tab-pane', {
	    staticStyle: {
	      "margin-top": "-20px"
	    },
	    attrs: {
	      "label": "Organizations",
	      "name": "organizations"
	    }
	  }, [(_vm.organizationsLoading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, _vm._l((_vm.organization_members), function(organization_member) {
	    return _c('router-link', {
	      attrs: {
	        "to": '/membership/' + organization_member.id
	      }
	    }, [_c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_c('el-card', {
	      staticClass: "box-card border-hover",
	      staticStyle: {
	        "position": "relative"
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "position": "absolute",
	        "top": "10px",
	        "right": "10px",
	        "width": "22px",
	        "height": "22px",
	        "border-radius": "50%"
	      },
	      style: ('backgroundColor:' + organization_member.color)
	    }), _vm._v(" "), _c('div', {
	      staticClass: "text flex"
	    }, [_c('div', {
	      staticStyle: {
	        "width": "45px",
	        "height": "45px",
	        "border-radius": "50%",
	        "border": "solid 1px #ccc",
	        "margin-right": "10px",
	        "background-size": "cover",
	        "background-repeat": "no-repeat",
	        "background-position": "center"
	      },
	      style: ('background-image: url(' + _vm.api_location + organization_member.organization.profile_picture + ')')
	    }), _vm._v(" "), _c('div', [_c('h3', {
	      staticStyle: {
	        "margin-bottom": "0",
	        "font-weight": "bold"
	      }
	    }, [_vm._v(_vm._s(organization_member.organization.name))]), _vm._v("\n\t\t\t\t\t\t\t    \t\t" + _vm._s(organization_member.organization.organization_type.name) + "\n\t\t\t\t\t\t\t    \t")])])])], 1)], 1)
	  }), 1)], 1)]), _vm._v(" "), _c('el-tab-pane', {
	    staticStyle: {
	      "margin-top": "-20px"
	    },
	    attrs: {
	      "label": "Calendar Schedule",
	      "name": "calendar_schedule"
	    }
	  }, [(_vm.calendarLoading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', [_c('el-select', {
	    staticStyle: {
	      "margin-bottom": "10px"
	    },
	    model: {
	      value: (_vm.calendar_data_type),
	      callback: function($$v) {
	        _vm.calendar_data_type = $$v
	      },
	      expression: "calendar_data_type"
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": _vm.$t('static.members.index.options.businessHours'),
	      "value": "businesshours"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": _vm.$t('static.members.index.options.booking'),
	      "value": "bookings"
	    }
	  })], 1), _vm._v(" "), _c('FullCalendar', {
	    ref: "fullCalendar",
	    attrs: {
	      "minTime": _vm.min_time,
	      "slotDuration": _vm.timeslot_gap,
	      "selectable": _vm.calendar_data_type == 'bookings',
	      "defaultView": "timeGridWeek",
	      "events": _vm.events,
	      "allDaySlot": false,
	      "height": "auto",
	      "slotEventOverlap": false,
	      "eventRender": _vm.showToolTip,
	      "plugins": _vm.calendarPlugins,
	      "buttonText": {
	        today: _vm.$t('static.members.index.calendar.today')
	      },
	      "firstDay": 1,
	      "locale": "nb"
	    }
	  })], 1)])], 1)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-user-plus",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  Membership")])
	}]}

/***/ }),
/* 3037 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-content"
	  }, [(_vm.loading) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-table', {
	    staticClass: "selected-products",
	    staticStyle: {
	      "width": "100%",
	      "margin-bottom": "10px"
	    },
	    attrs: {
	      "data": _vm.list,
	      "empty-text": _vm.$t('static.bulkAddProducts.selectedProducts.noneSelected')
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "width": "60px"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bulkAddProducts.selectedProducts.productName')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v("\n          " + _vm._s(scope.row.name) + "\n        ")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bulkAddProducts.selectedProducts.batch'),
	      "width": "170px"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.batches.length) ? _c('el-select', {
	          attrs: {
	            "placeholder": "Select"
	          },
	          on: {
	            "change": function($event) {
	              return _vm.updateBatch(scope.row.id, $event)
	            }
	          },
	          model: {
	            value: (scope.row.batchId),
	            callback: function($$v) {
	              _vm.$set(scope.row, "batchId", $$v)
	            },
	            expression: "scope.row.batchId"
	          }
	        }, _vm._l((scope.row.batches), function(item) {
	          return _c('el-option', {
	            key: item.id,
	            attrs: {
	              "label": item.name,
	              "value": item.id
	            }
	          })
	        }), 1) : _vm._e()]
	      }
	    }])
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "flex justify-center"
	  }, [_c('el-button', {
	    staticClass: "small margin-t-10",
	    attrs: {
	      "disabled": _vm.loading
	    },
	    on: {
	      "click": _vm.proceedToCreateBill
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.proceed').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3038 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "chart-contaier"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'orders.index',
	        query: {
	          filter: 'processed'
	        }
	      }
	    }
	  }, [(_vm.loaded) ? _c('div', {
	    staticClass: "waiting-delivered"
	  }, [_c('div', {
	    staticClass: "number-container"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.number) + " "), _c('i', {
	    staticClass: "el-icon-upload2"
	  })])])]) : _c('div', {
	    staticClass: "loading"
	  }, [_c('i', {
	    staticClass: "el-icon-loading"
	  })])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 3039 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('h2', [_vm._v("Result from "), _c('u', [_c('b', [_vm._v(_vm._s(_vm.orgNumberInput))])])]), _vm._v(" "), _c('fieldset', {
	    staticClass: "margin-b-10"
	  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('static.accountInformation.organizationInformation')))]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-info",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('form.clients.companyName.label')) + ":\n      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n        " + _vm._s(_vm.orgData.name) + "\n      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-user-secret",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('form.clients.clientType.label')) + ":\n      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n        " + _vm._s(_vm.orgData.code) + "\n      ")])]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [(_vm.displayPostalAddress) ? _c('el-col', {
	    attrs: {
	      "sm": 24,
	      "md": (_vm.displayBusinessAddress && _vm.displayLocationAddress) ? 8 : 12
	    }
	  }, [_c('fieldset', {
	    staticClass: "margin-b-10"
	  }, [_c('div', [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.streetName')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v(" " + _vm._s(_vm.displayPostalAddress.street_name) + "\n              ")])]), _vm._v(" "), (_vm.displayPostalAddress.street_name_2) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.secondStreetName')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v(" " + _vm._s(_vm.displayPostalAddress.street_name_2) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.postalCode')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v(" " + _vm._s(_vm.displayPostalAddress.postal) + "\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.city')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v(" " + _vm._s(_vm.displayPostalAddress.city) + "\n              ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "el-input"
	  }, [_c('el-checkbox-group', {
	    on: {
	      "change": function($event) {
	        return _vm.addressEvent1($event)
	      }
	    },
	    model: {
	      value: (_vm.addressResult1),
	      callback: function($$v) {
	        _vm.addressResult1 = $$v
	      },
	      expression: "addressResult1"
	    }
	  }, _vm._l((_vm.addressTypes), function(type) {
	    return _c('el-checkbox', {
	      key: type.id,
	      staticClass: "margin-b-10 display-block",
	      staticStyle: {
	        "margin-left": "30px"
	      },
	      attrs: {
	        "label": type.id
	      }
	    }, [_c('b', [_vm._v(_vm._s(_vm.$t(("form.addressTypes.options." + (_vm.camelize(type.name))))))])])
	  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayBusinessAddress) ? _c('el-col', {
	    attrs: {
	      "sm": 24,
	      "md": (_vm.displayPostalAddress && _vm.displayLocationAddress) ? 8 : 12
	    }
	  }, [_c('fieldset', {
	    staticClass: "margin-b-10"
	  }, [_c('div', [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.streetName')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v(" " + _vm._s(_vm.displayBusinessAddress.street_name) + "\n              ")])]), _vm._v(" "), (_vm.displayBusinessAddress.street_name_2) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.secondStreetName')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v(" " + _vm._s(_vm.displayBusinessAddress.street_name_2) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.postalCode')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v(" " + _vm._s(_vm.displayBusinessAddress.postal) + "\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.city')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v(" " + _vm._s(_vm.displayBusinessAddress.city) + "\n              ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "el-input"
	  }, [_c('el-checkbox-group', {
	    on: {
	      "change": function($event) {
	        return _vm.addressEvent2($event)
	      }
	    },
	    model: {
	      value: (_vm.addressResult2),
	      callback: function($$v) {
	        _vm.addressResult2 = $$v
	      },
	      expression: "addressResult2"
	    }
	  }, _vm._l((_vm.addressTypes), function(type) {
	    return _c('el-checkbox', {
	      key: type.id,
	      staticClass: "margin-b-10 display-block",
	      staticStyle: {
	        "margin-left": "30px"
	      },
	      attrs: {
	        "label": type.id
	      }
	    }, [_c('b', [_vm._v(_vm._s(_vm.$t(("form.addressTypes.options." + (_vm.camelize(type.name))))))])])
	  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayLocationAddress) ? _c('el-col', {
	    attrs: {
	      "sm": 24,
	      "md": (_vm.displayBusinessAddress && _vm.displayPostalAddress) ? 8 : 12
	    }
	  }, [_c('fieldset', {
	    staticClass: "margin-b-10"
	  }, [_c('div', [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.streetName')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v(" " + _vm._s(_vm.displayLocationAddress.street_name) + "\n              ")])]), _vm._v(" "), (_vm.displayLocationAddress.street_name_2) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.secondStreetName')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v(" " + _vm._s(_vm.displayLocationAddress.street_name_2) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.postalCode')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v(" " + _vm._s(_vm.displayLocationAddress.postal) + "\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.city')) + "\n              ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v(" " + _vm._s(_vm.displayLocationAddress.city) + "\n              ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "el-input"
	  }, [_c('el-checkbox-group', {
	    on: {
	      "change": function($event) {
	        return _vm.addressEvent3($event)
	      }
	    },
	    model: {
	      value: (_vm.addressResult3),
	      callback: function($$v) {
	        _vm.addressResult3 = $$v
	      },
	      expression: "addressResult3"
	    }
	  }, _vm._l((_vm.addressTypes), function(type) {
	    return _c('el-checkbox', {
	      key: type.id,
	      staticClass: "margin-b-10 display-block",
	      staticStyle: {
	        "margin-left": "30px"
	      },
	      attrs: {
	        "label": type.id
	      }
	    }, [_c('b', [_vm._v(_vm._s(_vm.$t(("form.addressTypes.options." + (_vm.camelize(type.name))))))])])
	  }), 1)], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex wrap justify-center buttons_under_main_body"
	  }, [_c('el-button', {
	    staticClass: "dark",
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.cancel')) + "\n    ")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "loading": _vm.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.update')) + "\n    ")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3040 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [(_vm.unassignedProducts.length > 0 && this.currentEdiOrder.standard == 'stand' && !this.currentEdiOrder.clientName.toLowerCase().includes('rema')) ? _c('el-row', {
	    staticStyle: {
	      "margin-top": "20px"
	    },
	    attrs: {
	      "gutter": 5
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('el-alert', {
	    attrs: {
	      "title": _vm.$t('static.orders.shippingConfirm.unassignedProductError'),
	      "type": "error",
	      "show-icon": "",
	      "closable": false
	    }
	  })], 1)], 1) : (_vm.unassignedProducts.length > 0 && this.currentEdiOrder.standard == 'stand' && !this.currentEdiOrder.clientName.toLowerCase().includes('rema')) ? _c('el-row', {
	    staticStyle: {
	      "margin-top": "20px"
	    },
	    attrs: {
	      "gutter": 5
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [(_vm.displayError) ? _c('el-alert', {
	    attrs: {
	      "show-icon": "",
	      "title": _vm.$t('static.orders.shippingConfirm.shippingProviderRequired'),
	      "type": "error",
	      "center": "",
	      "closable": false
	    }
	  }, [(_vm.displayError) ? _c('div', {
	    staticStyle: {
	      "padding": "5px 0",
	      "text-decoration": "underline"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": ("/inventory/warehouse/" + _vm.warehouseId + "/edit#basics"),
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.orders.shippingConfirm.addShippingProviderBtn')))])], 1) : _vm._e()]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v("\n          " + _vm._s(_vm.$t('static.orders.shippingConfirm.title')) + "\n          "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('static.orders.shippingConfirm.title')) + "\n        ")]), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.shippingConfirm",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "disabled": _vm.unassignedProducts.length > 0 && this.currentEdiOrder.standard == 'stand' && !this.currentEdiOrder.clientName.toLowerCase().includes('rema') ? true : false,
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3041 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.module.index.title')))])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _vm._l((_vm.modulesList), function(mdule) {
	    return _c('div', {
	      staticClass: "flex stretch wrap"
	    }, [_c('el-col', {
	      attrs: {
	        "span": 24
	      }
	    }, [_c('div', {
	      staticClass: "full-w flex wrap client-title-container margin-b-10"
	    }, [_c('i', {
	      staticClass: "el-icon-news",
	      staticStyle: {
	        "font-size": "40px",
	        "padding-right": "10px"
	      }
	    }), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(("" + (mdule.group))))])])]), _vm._v(" "), _c('el-col', {
	      staticStyle: {
	        "margin-bottom": "30px"
	      },
	      attrs: {
	        "span": 24
	      }
	    }, [_c('div', {
	      staticClass: "flex stretch wrap"
	    }, _vm._l((mdule.modules), function(p, i) {
	      return (p.name != 'Lokalbrygg') ? _c('v-card', {
	        key: i,
	        attrs: {
	          "wide": false
	        }
	      }, [_c('div', {
	        staticClass: "full-w flex wrap client-title-container margin-b-10"
	      }, [_c('i', {
	        staticClass: "el-icon-news",
	        staticStyle: {
	          "font-size": "40px",
	          "padding-right": "10px"
	        }
	      }), _vm._v(" "), _c('h2', {
	        staticClass: "cardTitle"
	      }, [_vm._v(_vm._s(("" + (p.name))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), [_c('span', {
	        staticClass: "cardLabel"
	      }, [_vm._v(_vm._s(p.description))])], _c('br'), _vm._v(" "), [(p.price) ? _c('span', {
	        staticClass: "cardBadge"
	      }, [_vm._v("Kr. " + _vm._s(p.price) + " /mnd")]) : _vm._e()], _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), (p.subscribe == 1 && p.disabled == false) ? [_c('label', {
	        staticClass: "cardLabel"
	      }, [_c('el-button', {
	        staticClass: "dark small right",
	        attrs: {
	          "disabled": p.requested
	        },
	        on: {
	          "click": function($event) {
	            return _vm.unsubscribe(p.id)
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.$t('button.unsubscribe').toUpperCase()))])], 1)] : _vm._e(), _vm._v(" "), (p.subscribe == 0 && p.disabled == false) ? [_c('label', {
	        staticClass: "cardLabel"
	      }, [_c('el-button', {
	        staticClass: "green small right",
	        attrs: {
	          "disabled": p.requested
	        },
	        on: {
	          "click": function($event) {
	            return _vm.subscribe(p)
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.$t('button.subscribe').toUpperCase()))])], 1)] : _vm._e(), _vm._v(" "), (p.subscribe == 1 && p.disabled == false && p.allowUpdate === true) ? [_c('label', {
	        staticClass: "cardLabel"
	      }, [_c('el-button', {
	        staticClass: "green small right",
	        attrs: {
	          "disabled": p.requested
	        },
	        on: {
	          "click": function($event) {
	            return _vm.updateFields(p)
	          }
	        }
	      }, [_vm._v(_vm._s('Update fields'))])], 1)] : _vm._e()], 2) : _vm._e()
	    }), 1)])], 1)
	  })], 2), _vm._v(" "), _c('el-row', [_c('el-col')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3042 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3043 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [(!(_vm.hasNewSelection && _vm.result.length)) ? [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.products.syncVmp.syncFieldTitle')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('div', [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.products.syncVmp.syncFieldTitle')))]), _vm._v(" "), _c('v-form', {
	    staticStyle: {
	      "margin-top": "15px"
	    },
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.vmpSync",
	      "hasLabel": true
	    }
	  })], 1)])], 1), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center",
	      "margin-bottom": "20px"
	    }
	  }, [_c('el-button', {
	    staticClass: "small danger",
	    attrs: {
	      "loading": _vm.loading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.closeModal($event)
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('button.close').toUpperCase()))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "disabled": !_vm.form.syncFields.length,
	      "loading": _vm.loading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.confirm($event)
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('button.syncNow').toUpperCase()))])], 1)] : _vm._e(), _vm._v(" "), (_vm.result.length) ? [_c('h3', [_vm._v("Results:")]), _vm._v(" "), _vm._l((_vm.result), function(item) {
	    return _c('div', {
	      key: item.vmp
	    }, [_c('p', [_vm._v("\n          - " + _vm._s(item.vmp) + ": " + _vm._s(item.name) + ",\n          "), (!item.success) ? _c('span', [_vm._v(_vm._s(item.message) + " "), _c('i', {
	      staticClass: "el-icon-error danger-color"
	    })]) : _c('span', [_vm._v(_vm._s(item.message) + "\n            "), _c('i', {
	      staticClass: "el-icon-success",
	      staticStyle: {
	        "color": "green"
	      }
	    })])])])
	  }), _vm._v(" "), (_vm.hasNewSelection && _vm.result.length) ? _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center",
	      "margin-bottom": "20px"
	    }
	  }, [_c('el-button', {
	    staticClass: "small danger",
	    attrs: {
	      "loading": _vm.loading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.closeModal($event)
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.close').toUpperCase()))])], 1) : _vm._e()] : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 3044 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.index.title')) + " (" + _vm._s(_vm.stocks.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.stocks.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.stock.noDataMsg')) + "\n        "), (!_vm.bridgeStockWriteBlocked) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.stock.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.stock.noDataBtn')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.stocks.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      attrs: {
	        "wide": true
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editStock(p)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "full-w flex wrap client-title-container margin-b-10"
	    }, [_c('img', {
	      staticClass: "client-img margin-b-10",
	      attrs: {
	        "src": __webpack_require__(276),
	        "alt": ("" + (p.code))
	      }
	    }), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(("" + (p.code))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.stock.info.code')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.code || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.stock.info.name')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.name || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.stock.info.qty')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.total_qty || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.stock.info.warehouse')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.warehouseName || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.stock.info.transactionDate')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(_vm.formatDate(p.createdAt, 'DD-MM-YYYY')))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.stock.info.status')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.status || '-'))])]], 2)
	  })], 2)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.stocks.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3045 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (!_vm.ready),
	      expression: "!ready"
	    }],
	    staticClass: "product-lines-loading-wrap",
	    staticStyle: {
	      "width": "100%",
	      "min-height": "220px",
	      "position": "relative"
	    },
	    attrs: {
	      "element-loading-text": _vm.$t('static.loadingProductLines')
	    }
	  }, [(_vm.ready) ? _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('v-form-table', {
	    attrs: {
	      "form": _vm.form,
	      "list": _vm.billProductsList,
	      "additionalButtons": _vm.additionalButtons,
	      "update": _vm.update,
	      "destroy": _vm.destroy,
	      "translation": "table.billProducts",
	      "disableForm": _vm.bill.billStatusId === 3 || _vm.bill.billStatusId === 4 || _vm.bill.billStatusId === 5,
	      "stack": {
	        price: 'productDepositName',
	        orderProductId: 'billNote'
	      },
	      "clickHandler": _vm.tableClickHandler,
	      "columnWidths": _vm.columnWidths,
	      "hiddenFields": _vm.hiddenFields
	    }
	  }), _vm._v(" "), _c('v-totals-table', {
	    attrs: {
	      "list": _vm.totalsTableList
	    }
	  })], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 3046 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('v-form-table', {
	    attrs: {
	      "form": _vm.form,
	      "list": _vm.hours,
	      "create": _vm.save,
	      "destroy": _vm.destroy,
	      "translation": "table.businessHours"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 3047 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.productFlow.index.title')))])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.productFlows.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.productFlow.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productFlow.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.productFlow.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.productFlows.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      attrs: {
	        "wide": true
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editproductFlow(p)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "full-w flex wrap client-title-container margin-b-10"
	    }, [_c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(("" + (p.title))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.productFlow.info.title')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.title || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.productFlow.info.order')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.orderNumber || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.productFlow.info.product')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.productName || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.productFlow.info.qty')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.qty || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.productFlow.info.descriptions')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.descriptions || '-'))])], _c('br')], 2)
	  })], 2)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "pagination": _vm.productFlows.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3048 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(!_vm.isCreditNote ?
	    _vm.$t('static.bills.edit.title') : _vm.$t('static.bills.edit.creditNoteTitle')) + " " + _vm._s(_vm.currentBill.billingNumber ?
	    ("#" + (_vm.currentBill.billingNumber)) : ''))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.bills.formTabs.invoiceInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(_vm.currentOrder) ? _c('el-col', {
	    attrs: {
	      "lg": 16
	    }
	  }, [(_vm.isClientContactEmailMissing && _vm.isInvoice && !['EHF', 'EDI'].includes(_vm.currentBill.sendVia.toUpperCase())) ? _c('div', {
	    staticClass: "account_alert"
	  }, [_vm._v(_vm._s(_vm.$t('static.alertMissingDetails.customerNoContactEmail.message')) + " "), _c('router-link', {
	    staticClass: "alert-warning-link",
	    attrs: {
	      "to": {
	        name: 'clients.edit',
	        params: {
	          id: _vm.currentClient.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.alertMissingDetails.customerNoContactEmail.linkText')))])], 1) : _vm._e(), _vm._v(" "), (_vm.returnWarning && _vm.isCreditNote && !['EHF', 'EDI'].includes(_vm.currentBill.sendVia.toUpperCase())) ? _c('div', {
	    staticStyle: {
	      "padding": "10px",
	      "text-align": "left",
	      "border": "1px solid #e84c4c",
	      "background": "#F56C6C",
	      "color": "#fff",
	      "font-size": "16px",
	      "margin-bottom": "30px"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.returnWarning)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showOverdueInvoiceNotice) ? _c('div', {
	    staticClass: "account_alert",
	    staticStyle: {
	      "margin-bottom": "20px"
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('static.bills.edit.overdueInvoiceNotice')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.bills.edit.detailsLegend')))]), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "md": 8
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.billStatus')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small",
	    class: _vm.currentOrdeStatus.toLowerCase()
	  }, [_vm._v("\n                      " + _vm._s(_vm.$t(("static.reports.bills." + (_vm.currentOrdeStatus.replace(/\s+/g, '').toLowerCase())))) + " " + _vm._s(_vm.currentBill.sendVia && _vm.currentBill.sendVia != '' ? ("via " + (_vm.currentBill.sendVia.toUpperCase())) : '') + "\n                    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.date')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                      " + _vm._s(_vm.isValidDate(_vm.currentBill.date) ? _vm.formatDate(_vm.currentBill.date) : '-') + "\n                    ")])]), _vm._v(" "), (!_vm.isCreditNote) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.dueDate')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small",
	    class: {
	      'bill-invoice-due-overdue': _vm.invoiceDueDateIsOverdue
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.isValidDate(_vm.currentBill.dueDate) ? _vm.formatDate(_vm.currentBill.dueDate) : '-') + "\n                      "), (_vm.invoiceDueDateIsOverdue) ? _c('span', {
	    staticClass: "bill-overdue-badge bill-overdue-badge--detail"
	  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.overdueBadge')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isValidDate(_vm.currentBill.paymentDate)) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.paymentDate')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_c('a', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function () { return _vm.tabIndex = '2'; }
	    }
	  }, [_vm._v("\n                        " + _vm._s(_vm.isValidDate(_vm.currentBill.paymentDate) ? _vm.formatDate(_vm.currentBill.paymentDate) : '-') + "\n                      ")])])]) : _vm._e(), _vm._v(" "), (_vm.isEdiOrder) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-truck",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.deliveredTo')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentOrder.clientName) + ", " + _vm._s(_vm.currentOrder.ediStore) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.currentBill.note) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.orderReference')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentBill.note) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.currentBill.paymentMessage) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-envelope-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('form.bills.paymentMessage.label')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentBill.paymentMessage) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.currentBill.billStatus != 'Draft' && (_vm.settings.paymentIdentitificationGeneration || _vm.currentBill.kidNumber)) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-hashtag",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('form.bills.kidNumber.label')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentBill.kidNumber) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.creditNotes && _vm.creditNotes.length) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-id-card-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.creditNotes')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._l((_vm.creditNotes), function(c, i) {
	    return [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'bills.creditNote',
	          params: {
	            id: c.id
	          }
	        }
	      }
	    }, [_vm._v("\n                          " + _vm._s(c.billing_number ? ("#" + (c.billing_number)) : ((_vm.$t('static.reports.bills.draft')) + " " + (i + 1))) + "\n                        ")]), _vm._v(" "), (i < _vm.creditNotes.length - 1) ? _c('span', [_vm._v(" | ")]) : _vm._e()]
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.currentBill.sourceBillNumber) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-id-card-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.invoiceNumber')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'bills.edit',
	        params: {
	          id: _vm.currentBill.creditNoteSource
	        }
	      }
	    }
	  }, [_vm._v("\n                        #" + _vm._s(_vm.currentBill.sourceBillNumber) + "\n                      ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isCreditNote && _vm.currentBill.creditNoteReason) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-id-card-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.creditNoteReason')) + ":\n                    ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentBill.creditNoteReason.name) + "\n                    ")])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "full-w flex wrap justify-end bill-toolbar-actions"
	  }, [(_vm.isDraft) ? _c('el-button', {
	    staticClass: "small dark-outline margin-b-10",
	    attrs: {
	      "icon": "el-icon-close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.deleteBill(_vm.currentBill)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isDraft && _vm.isCreditNote) ? _c('el-button', {
	    staticClass: "small margin-b-10",
	    attrs: {
	      "loading": _vm.submitLoading,
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.save('Pending')
	      }
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.$t('button.save')) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('v-message', {
	    attrs: {
	      "info": _vm.previewWait,
	      "customClass": "preview-msg-alert"
	    }
	  }), _vm._v(" "), _c('v-message', {
	    attrs: {
	      "success": _vm.successMessage
	    }
	  }), _vm._v(" "), (_vm.showEhfModuleUpsellBanner) ? _c('el-alert', {
	    staticClass: "margin-b-10 bill-ehf-info-alert",
	    attrs: {
	      "type": "info",
	      "closable": false,
	      "show-icon": "",
	      "title": _vm.ehfModuleUpsellCustomerVerified ? _vm.$t('static.bills.edit.ehfModuleUpsellTitle') : _vm.$t('static.bills.edit.ehfModuleUpsellTitleNoPeppolYet')
	    }
	  }, [_c('p', {
	    staticClass: "margin-b-0"
	  }, [_vm._v(_vm._s(_vm.ehfModuleUpsellCustomerVerified ?
	    _vm.$t('static.bills.edit.ehfModuleUpsellBody') :
	    _vm.$t('static.bills.edit.ehfModuleUpsellBodyNoPeppolYet')))]), _vm._v(" "), _c('p', {
	    staticClass: "margin-t-10 margin-b-0"
	  }, [_c('a', {
	    staticClass: "alert-warning-link",
	    attrs: {
	      "role": "button",
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.showEHFModuleModal($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.ehfModuleUpsellLink')))])])]) : _vm._e(), _vm._v(" "), (_vm.showEhfPendingVerificationBanner) ? _c('el-alert', {
	    staticClass: "margin-b-10 bill-ehf-warning-alert",
	    attrs: {
	      "type": "warning",
	      "closable": false,
	      "show-icon": "",
	      "title": _vm.$t('static.bills.edit.ehfNotVerifiedTitle')
	    }
	  }, [_c('p', {
	    staticClass: "margin-b-0"
	  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.ehfNotVerifiedBody')))]), _vm._v(" "), (!_vm.currentClient.email) ? _c('p', {
	    staticClass: "margin-b-10 margin-t-10"
	  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.ehfNotVerifiedNoEmail')))]) : _vm._e(), _vm._v(" "), (_vm.currentClient && _vm.currentClient.id) ? _c('router-link', {
	    staticClass: "alert-warning-link",
	    attrs: {
	      "to": {
	        name: 'clients.edit',
	        params: {
	          id: _vm.currentClient.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.ehfNotVerifiedClientLink')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showEhfPreferredOverEmailBanner) ? _c('el-alert', {
	    staticClass: "margin-b-10 bill-ehf-info-alert",
	    attrs: {
	      "type": "info",
	      "closable": false,
	      "show-icon": "",
	      "title": _vm.$t('static.bills.edit.ehfPreferredOverEmailTitle')
	    }
	  }, [_c('p', {
	    staticClass: "margin-b-0"
	  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.ehfPreferredOverEmailBody')))]), _vm._v(" "), (!_vm.currentClient.email) ? _c('p', {
	    staticClass: "margin-b-10 margin-t-10"
	  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.ehfPreferredOverEmailNoEmail')))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "margin-t-10 bill-ehf-preferred-actions"
	  }, [_c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "type": "primary",
	      "loading": _vm.sendEHFLoading,
	      "disabled": !(_vm.billProducts.length > 0 || _vm.orderProducts.length > 0) || (_vm.isCreditNote && !_vm.hasCreditNoteReason)
	    },
	    on: {
	      "click": _vm.sendEHFInvoice
	    }
	  }, [_vm._v("\n                          " + _vm._s(_vm.$t('static.bills.edit.ehfPreferredOverEmailSendEhfBtn')) + "\n                        ")]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.sendLoading,
	      "disabled": !_vm.currentClient.email || !(_vm.billProducts.length > 0 || _vm.orderProducts.length > 0) || (_vm.isCreditNote && !_vm.hasCreditNoteReason)
	    },
	    on: {
	      "click": _vm.previewSendInvoice
	    }
	  }, [_vm._v("\n                          " + _vm._s(_vm.isCreditNote ? _vm.$t('static.bills.edit.ehfPreferredOverEmailSendCreditNoteEmailBtn') : _vm.$t('static.bills.edit.ehfPreferredOverEmailSendInvoiceEmailBtn')) + "\n                        ")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.hasCreditNoteReason && _vm.isCreditNote && typeof(_vm.currentOrder) !== 'undefined' && !_vm.isDraft) ? _c('el-button', {
	    staticClass: "small margin-b-10",
	    attrs: {
	      "disabled": !(_vm.billProducts.length > 0 || _vm.orderProducts.length > 0)
	    },
	    on: {
	      "click": _vm.submitCreditNoteReason
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.creditNoteReason')))]) : _vm._e(), _vm._v(" "), ((_vm.invoiceSendMethodIsEmail || _vm.showSendInvoiceEmailFallbackForEhf) && !_vm.showEhfPreferredOverEmailBanner && ((_vm.isCreditNote && _vm.isPending) || (!_vm.isCreditNote && _vm.isPending)) && _vm.currentClient.email && typeof(_vm.currentOrder) !== 'undefined' && !_vm.isEdiOrder) ? _c('el-button', {
	    staticClass: "small margin-b-10",
	    attrs: {
	      "loading": _vm.sendLoading,
	      "disabled": !(_vm.billProducts.length > 0 || _vm.orderProducts.length > 0) || (_vm.isCreditNote && !_vm.hasCreditNoteReason)
	    },
	    on: {
	      "click": _vm.previewSendInvoice
	    }
	  }, [(_vm.showSendInvoiceEmailFallbackForEhf) ? [_vm._v("\n                        " + _vm._s(_vm.isCreditNote ? _vm.$t('static.bills.edit.sendCreditNoteEmailFallbackBtn') : _vm.$t('static.bills.edit.sendInvoiceEmailFallbackBtn')) + "\n                      ")] : [_vm._v("\n                        " + _vm._s(_vm.isCreditNote ? _vm.$t('static.bills.edit.sendCreditNoteBtn') :
	    _vm.$t('static.bills.edit.sendInvoiceBtn')) + "\n                      ")]], 2) : _vm._e(), _vm._v(" "), (_vm.hasEHFModule && _vm.isPending && _vm.invoiceSendMethodIsEhf && _vm.currentClient.ehfBilling3_0 && typeof(_vm.currentOrder) !== 'undefined' && !_vm.isEdiOrder) ? _c('el-button', {
	    staticClass: "small warning margin-b-10",
	    staticStyle: {
	      "background-color": "#ffb000",
	      "border-color": "1px solid #ff9c00",
	      "color": "#6f4800"
	    },
	    attrs: {
	      "loading": _vm.sendEHFLoading,
	      "disabled": !(_vm.billProducts.length > 0 || _vm.orderProducts.length > 0) || (_vm.isCreditNote && !_vm.hasCreditNoteReason)
	    },
	    on: {
	      "click": _vm.sendEHFInvoice
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.$t('static.bills.edit.sendEhfInvoiceBtn')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.isCreditNote && _vm.isSent && (_vm.invoiceSendMethodIsEmail ? _vm.currentClient.email : _vm.invoiceSendMethodIsEhf) && typeof(_vm.currentOrder) !== 'undefined' && !_vm.isEdiOrder) ? _c('div', {
	    staticClass: "btn-group margin-b-10 margin-r-10"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "disabled": "",
	      "type": "button"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.invoiceSent')) + " " + _vm._s(_vm.invoiceSentAt))]), _vm._v(" "), _c('el-button', {
	    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    on: {
	      "click": _vm.toggleDropdown
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu",
	    class: {
	      show: _vm.dropdownState
	    }
	  }, [_c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.showInvoice()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.showInvoiceBtn')))]), _vm._v(" "), _c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": _vm.downloadInvoice
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.downloadInvoiceBtn')))]), _vm._v(" "), (_vm.showCreateReminderButton) ? _c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": _vm.createBillReminder
	    }
	  }, [_vm._v("\n                          " + _vm._s(_vm.$t('button.createReminder')) + "\n                        ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (typeof(_vm.currentOrder) !== 'undefined' && _vm.isEdiOrder && _vm.isPending) ? _c('el-button', {
	    staticClass: "small margin-b-10",
	    attrs: {
	      "loading": _vm.sendLoading,
	      "disabled": !_vm.billProducts.length > 0 || (_vm.isCreditNote && !_vm.hasCreditNoteReason)
	    },
	    on: {
	      "click": _vm.sendBillEDI
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.isCreditNote ? _vm.$t('static.bills.edit.sendEdiCreditNoteBtn') :
	    _vm.$t('static.bills.edit.sendEdiInvoiceBtn')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.isEdiOrder) ? _c('el-button', {
	    staticClass: "small margin-b-10",
	    attrs: {
	      "disabled": Object.keys(_vm.currentOrder).length === 0
	    },
	    on: {
	      "click": function($event) {
	        return _vm.showInvoice()
	      }
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.isCreditNote ? _vm.$t('static.bills.edit.showCreditNoteBtn') : _vm.$t('static.bills.edit.showInvoiceBtn')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.isEdiOrder) ? _c('div', {
	    staticClass: "btn-group margin-b-10"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "disabled": "",
	      "type": "button"
	    }
	  }, [_vm._v(_vm._s(_vm.isCreditNote ?
	    _vm.$t('static.bills.edit.showCreditNoteBtn') : _vm.$t('static.bills.edit.showInvoiceBtn')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    on: {
	      "click": _vm.toggleDropdown
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu",
	    class: {
	      show: _vm.dropdownState
	    }
	  }, [_c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.showInvoice()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.isCreditNote ?
	    _vm.$t('static.bills.edit.showCreditNoteBtn') : _vm.$t('static.bills.edit.showInvoiceBtn')))]), _vm._v(" "), _c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": _vm.downloadInvoice
	    }
	  }, [_vm._v(_vm._s(_vm.isCreditNote ?
	    _vm.$t('static.bills.edit.downloadCreditNoteBtn') :
	    _vm.$t('static.bills.edit.downloadInvoiceBtn')))])])], 1) : _vm._e(), _vm._v(" "), ((_vm.isSent || _vm.isPartlyPaid) && !_vm.isCreditNote) ? _c('el-button', {
	    staticClass: "small margin-b-10",
	    attrs: {
	      "loading": _vm.form.loading === 'Cleared',
	      "disabled": Object.keys(_vm.currentOrder).length === 0
	    },
	    on: {
	      "click": _vm.markAsCleared
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.$t('button.markAsCleared')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.isCreditNote) ? _c('el-button', {
	    staticClass: "small margin-b-10",
	    attrs: {
	      "loading": _vm.loadingCreditNote,
	      "disabled": Object.keys(_vm.currentOrder).length === 0
	    },
	    on: {
	      "click": _vm.createCreditNote
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.$t('static.bills.edit.createCreditNoteBtn')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.currentBill.billStatus != 'Draft' && _vm.settings.paymentIdentitificationGeneration && _vm.settings.paymentIdentitificationGeneration) ? [(_vm.currentBill.kidNumber) ? _c('el-button', {
	    staticClass: "small margin-b-10",
	    attrs: {
	      "loading": _vm.kidLoading
	    },
	    on: {
	      "click": _vm.validateKidNumber
	    }
	  }, [_vm._v("\n                        " + _vm._s(_vm.$t('static.bills.edit.validateKidNumber')) + "\n                      ")]) : _c('el-button', {
	    staticClass: "small margin-b-10",
	    attrs: {
	      "loading": _vm.kidLoading
	    },
	    on: {
	      "click": _vm.generateKidNumber
	    }
	  }, [_vm._v("\n                        " + _vm._s(_vm.$t('static.bills.edit.generateKidNumber')) + "\n                      ")])] : _vm._e()], 2)])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('el-col', {
	    staticClass: "blockmainWrapper",
	    attrs: {
	      "lg": 8
	    }
	  }, [_c('v-client-info', {
	    attrs: {
	      "client": _vm.currentClient,
	      "billId": _vm.currentBill.id,
	      "currentEdiOrder": _vm.currentOrder
	    }
	  })], 1), _vm._v(" "), (Object.keys(_vm.currentOrder).length > 0) ? _c('el-col', [_c('div', {
	    staticClass: "bill-lines-card"
	  }, [_c('h3', {
	    staticClass: "bill-lines-title"
	  }, [_vm._v(_vm._s(_vm.$t('static.bills.billLines')))]), _vm._v(" "), _c('el-row', [(!_vm.loading && (!_vm.isCreditNote || (_vm.currentOrder.ediType == 'ZKA' || _vm.currentOrder.ediType == 'ZRE'))) ? _c('v-products-table', {
	    attrs: {
	      "order": _vm.currentOrder,
	      "bill": _vm.currentBill,
	      "billRoundInvoiceTotal": _vm.currentBill.roundInvoiceTotal
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.loading && (_vm.isCreditNote && _vm.currentOrder.ediType != 'ZKA' && _vm.currentOrder.ediType != 'ZRE')) ? _c('v-credit-note-table', {
	    attrs: {
	      "order": _vm.currentOrder,
	      "bill": _vm.currentBill,
	      "billRoundInvoiceTotal": _vm.currentBill.roundInvoiceTotal
	    }
	  }) : _vm._e(), _vm._v(" "), ((_vm.isDraft || _vm.isPending) && (typeof(_vm.currentOrder) !== 'undefined' && !_vm.isEdiOrder)) ? _c('div', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_c('el-checkbox', {
	    attrs: {
	      "name": "roundInvoiceTotal"
	    },
	    on: {
	      "change": _vm.roundInvoice
	    },
	    model: {
	      value: (_vm.roundInvoiceTotal),
	      callback: function($$v) {
	        _vm.roundInvoiceTotal = $$v
	      },
	      expression: "roundInvoiceTotal"
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('static.orders.edit.roundInvoiceTotal')))])], 1) : _vm._e()], 1)], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.isEdiOrder && !_vm.isCreditNote) ? _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.bills.formTabs.reminders'),
	      "name": "4"
	    }
	  }, [_c('div', [(_vm.canSendPaymentReminderActions) ? _c('el-button', {
	    staticClass: "el-button small margin-b-10 el-button--button",
	    attrs: {
	      "loading": _vm.sendReminderPreviewLoading
	    },
	    on: {
	      "click": _vm.sendReminderPreview
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.sendReminder')))]) : _vm._e(), _vm._v(" "), (_vm.canSendPaymentReminderActions) ? _c('el-button', {
	    staticClass: "el-button small margin-b-10 el-button--button",
	    on: {
	      "click": function($event) {
	        return _vm.showInvoice(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.invoiceWithReminderFee')))]) : _vm._e()], 1), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.billReminders,
	      "stripe": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "index",
	      "width": "110"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v(_vm._s(_vm.$t('static.reminderTable.reminder')) + " " + _vm._s(scope.$index + 1))]
	      }
	    }], null, false, 2827682467)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "type": "expand"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.reminderTable.notes')) + ":")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(props.row.notes))])]
	      }
	    }], null, false, 599892944)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.reminderTable.type'),
	      "width": "100"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(scope.row.penalty_fee_id ? _vm.$t(("static.reminderTable." + (scope.row.penaltyFee.type))) : '--'))])]
	      }
	    }], null, false, 4255879427)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.reminderTable.freeAmount'),
	      "width": "300"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(!scope.row.penalty_fee_id && scope.row.fee_amount == 0) ? _c('span', [_vm._v("--")]) : (scope.row.penaltyFee.type == 'percentage') ? _c('span', [_vm._v("\n              " + _vm._s(((scope.row.fee_amount) + " " + _vm.currency + " "))), _c('strong', [_vm._v(_vm._s(("(" + (scope.row.penaltyFee.fee_rate) + "% of " + (scope.row.bill_amount.toFixed(2)) + " " + _vm.currency + ")")))])]) : _c('span', [_vm._v(_vm._s(((scope.row.fee_amount) + " " + _vm.currency)))])]
	      }
	    }], null, false, 3482646224)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "date",
	      "label": _vm.$t('static.reminderTable.dateCreated')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.reminderTable.newDueDate')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(scope.row.newDueDate ? scope.row.newDueDate : '--'))])]
	      }
	    }], null, false, 2761063459)
	  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.bills.formTabs.edit'),
	      "name": "2"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.bills",
	      "hasLabel": true
	    }
	  }), _vm._v(" "), (_vm.isDraft) ? _c('el-button', {
	    attrs: {
	      "loading": _vm.form.loading === 'Draft',
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.save('Draft')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.saveDraft')))]) : _vm._e(), _vm._v(" "), ((_vm.isDraft || _vm.isPending) && !_vm.isCreditNote) ? _c('el-button', {
	    attrs: {
	      "loading": _vm.form.loading === 'Pending',
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.save('Pending')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.isDraft ? _vm.$t('button.createInvoice') : _vm.$t('button.updateInvoice')))]) : _vm._e(), _vm._v(" "), (_vm.isCleared && !_vm.isCreditNote) ? _c('el-button', {
	    attrs: {
	      "loading": _vm.form.loading === 'Pending',
	      "type": "primary"
	    },
	    on: {
	      "childSave": _vm.save,
	      "click": function($event) {
	        return _vm.save('Cleared')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.isDraft ? _vm.$t('button.createInvoice') : _vm.$t('button.updateInvoice')))]) : _vm._e(), _vm._v(" "), ((_vm.isDraft || _vm.isPending) && _vm.isCreditNote) ? _c('el-button', {
	    attrs: {
	      "loading": _vm.form.loading === 'Pending',
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.save('Pending')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save')))]) : _vm._e(), _vm._v(" "), (_vm.isSent) ? _c('el-button', {
	    attrs: {
	      "loading": _vm.form.loading === 'Cleared',
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.markAsCleared
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.markAsCleared')) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-message', {
	    attrs: {
	      "success": _vm.successMessage
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.bills.formTabs.emails'),
	      "name": "3"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, _vm._l((_vm.emailCopies), function(item, key) {
	    return _c('el-col', {
	      key: key,
	      attrs: {
	        "xs": 24,
	        "sm": 12,
	        "md": 6,
	        "lg": 6
	      }
	    }, [_c('div', {
	      staticClass: "card-header",
	      class: _vm.emailCopyClass[key],
	      on: {
	        "click": function($event) {
	          return _vm.recipients(item.tracking.email_tracking_recipients, key)
	        }
	      }
	    }, [_c('el-card', {
	      staticClass: "box-card",
	      staticStyle: {
	        "margin-bottom": "1em",
	        "width": "100%"
	      }
	    }, [_c('div', {
	      staticClass: "clearfix",
	      staticStyle: {
	        "position": "relative"
	      },
	      attrs: {
	        "slot": "header"
	      },
	      slot: "header"
	    }, [_c('span', [_c('strong', [_vm._v(_vm._s(item.subject))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.send_after_date))]), _vm._v(" "), _c('span', {
	      staticClass: "mail-status",
	      class: item.sent == 1 ? 'sent' : 'queued'
	    }, [_vm._v(_vm._s(item.sent == 1 ? 'Sent' : 'Queued'))]), _vm._v(" "), _c('el-button', {
	      staticClass: "view-message",
	      attrs: {
	        "size": "mini"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.previewMailTracking(item)
	        }
	      }
	    }, [_vm._v("\n                    " + _vm._s(_vm.$t('button.view')) + "\n                  ")])], 1), _vm._v(" "), _c('div', {
	      staticClass: "text item"
	    }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.bills.edit.emailTracking.delivered')) + ": ")]), _vm._v(_vm._s((item.tracking) ? item.tracking.delivered : 0))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.bills.edit.emailTracking.opened')) + ": ")]), _vm._v(_vm._s((item.tracking) ? item.tracking.opened : 0))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.bills.edit.emailTracking.clicked')) + ": ")]), _vm._v(_vm._s((item.tracking) ? item.tracking.clicked : 0))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.bills.edit.emailTracking.dropped')) + ": ")]), _vm._v(_vm._s((item.tracking) ? item.tracking.dropped : 0))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.bills.edit.emailTracking.bounced')) + ": ")]), _vm._v(_vm._s((item.tracking) ? item.tracking.bounced : 0))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.bills.edit.emailTracking.complained')) + ": ")]), _vm._v(_vm._s((item.tracking) ? item.tracking.complained : 0))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.bills.edit.emailTracking.failed')) + ": ")]), _vm._v(_vm._s((item.tracking) ? item.tracking.failed : 0))])])])], 1)])
	  }), 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.emailTrackingRecipients,
	      "stripe": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "recipient",
	      "label": _vm.$t('static.bills.edit.emailTracking.recipient')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "email_event_type.name",
	      "label": _vm.$t('static.bills.edit.emailTracking.type')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "event_timestamp",
	      "label": _vm.$t('static.bills.edit.emailTracking.date')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "device_type.name",
	      "label": _vm.$t('static.bills.edit.emailTracking.device')
	    }
	  })], 1)], 1)], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3049 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-alert', {
	    staticClass: "margin-b-20",
	    attrs: {
	      "title": _vm.$t('static.products.create.success'),
	      "type": "success"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "flex-direction": "column"
	    }
	  }, [_c('el-button', {
	    staticClass: "margin-b-20",
	    staticStyle: {
	      "width": "380px"
	    },
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.products.create.options.edit')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "margin-b-20",
	    staticStyle: {
	      "width": "380px"
	    },
	    on: {
	      "click": _vm.addMore
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.products.create.options.addMore')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "margin-b-20",
	    staticStyle: {
	      "width": "380px"
	    },
	    on: {
	      "click": _vm.gotoIndex
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.products.create.options.gotoIndex')))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3050 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('h2', [_vm._v("\n    " + _vm._s(_vm.$t('form.warehouse.productTab.modal.title')) + "\n  ")]), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.warehouse.productTab.modal",
	      "hasLabel": true
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "flex-direction": "column"
	    }
	  }, [_c('el-button', {
	    staticClass: "margin-b-20",
	    attrs: {
	      "loading": _vm.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3051 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-row', {
	    staticClass: "bulk-product-add"
	  }, [_c('el-col', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "span": 24
	    }
	  }, [(_vm.noData.length > 0) ? _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.bulk.yearOf')) + " " + _vm._s(_vm.period))]), _vm._v(" "), (!_vm.noDataAllSelected) ? _c('h3', [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.bulk.noDataSelectedClient')))]) : _c('h3', [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.bulk.noDataAllSelectedClient')))])]) : _c('h3', [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.bulk.title')))]), _vm._v(" "), (_vm.noData.length > 0) ? [_vm._l((_vm.noData), function(item, key) {
	    return _c('div', {
	      key: key
	    }, [_c('p', [_vm._v("\n            - " + _vm._s(item.name) + ",\n            "), _c('span', [_vm._v(_vm._s(item.message) + " "), _c('i', {
	      staticClass: "el-icon-error danger-color"
	    })])])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [_c('el-button', {
	    staticClass: "small dark",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.closeModal($event)
	      }
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.close')))])], 1)] : (!_vm.submitted) ? [_c('div', {
	    staticClass: "wrapper"
	  }, [(_vm.submitLoading) ? _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.bulk.processing')))])]) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 18
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    staticStyle: {
	      "margin-top": "15px"
	    },
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.bulkSendTurnOver",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.handleSend
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('button.send')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small dark",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px",
	      "color": "#fff"
	    },
	    attrs: {
	      "disabled": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('button.close')))])], 1)], 1)], 1), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.bulk.clients')))]), _vm._v(" "), _c('el-table', {
	    ref: "multipleTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.selectedClients
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "property": "id",
	      "label": _vm.$t('table.clientReports.id'),
	      "width": "100",
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "name",
	      "label": _vm.$t('table.clientReports.name'),
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.emails) ? _c('el-select', {
	          attrs: {
	            "placeholder": "Select"
	          },
	          model: {
	            value: (scope.row.email),
	            callback: function($$v) {
	              _vm.$set(scope.row, "email", $$v)
	            },
	            expression: "scope.row.email"
	          }
	        }, _vm._l((scope.row.emails.split(',')), function(email) {
	          return _c('el-option', {
	            key: email,
	            attrs: {
	              "label": email,
	              "value": email
	            }
	          })
	        }), 1) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "lastSent",
	      "label": _vm.$t('table.clientReports.lastSent'),
	      "sortable": ""
	    }
	  })], 1)] : [_c('div', [_vm._l((_vm.result), function(item) {
	    return _c('div', {
	      key: item.client_id
	    }, [_c('p', [_vm._v("\n              - " + _vm._s(item.client_name) + ",\n              "), (!item.success) ? _c('span', [_vm._v(_vm._s(item.message) + " "), _c('i', {
	      staticClass: "el-icon-error danger-color"
	    })]) : _c('span', [_vm._v(_vm._s(item.message) + "\n                "), _c('i', {
	      staticClass: "el-icon-success",
	      staticStyle: {
	        "color": "green"
	      }
	    })])])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [(_vm.submitted) ? _c('el-button', {
	    staticClass: "small dark",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.closeModal($event)
	      }
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('button.close')))]) : _vm._e()], 1)], 2)]], 2)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3052 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper um-wrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 8
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    staticClass: "um-loading",
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('p', {
	    staticClass: "um-title"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('static.module.subscribe.title')) + "\n          "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    staticClass: "um-body",
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h2', {
	    staticClass: "um-heading"
	  }, [_vm._v("Connect UniMicro (Certificate)")]), _vm._v(" "), _c('p', {
	    staticClass: "um-text"
	  }, [_vm._v("\n          To connect your UniMicro account with Kundan, follow the steps below.\n          Your company’s "), _c('b', [_vm._v("Organization Number (Org.nr)")]), _vm._v(" is already stored in your organization details.\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "um-section"
	  }, [_c('p', {
	    staticClass: "um-subtitle"
	  }, [_vm._v("Log in to UniMicro")]), _vm._v(" "), _c('a', {
	    staticClass: "um-link",
	    attrs: {
	      "href": "https://test.unimicro.no",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n            https://test.unimicro.no\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "um-section"
	  }, [_c('p', {
	    staticClass: "um-subtitle"
	  }, [_vm._v("Enable Kundan Integration")]), _vm._v(" "), _c('ol', {
	    staticClass: "um-steps"
	  }, [_c('li', [_vm._v("Open your "), _c('b', [_vm._v("Uni Economy")]), _vm._v(" dashboard.")]), _vm._v(" "), _c('li', [_vm._v("Go to "), _c('b', [_vm._v("Markedsplass → Integrasjoner")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("Find "), _c('b', [_vm._v("Kundan")]), _vm._v(" in the list of available integrations.")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Les mer")]), _vm._v(" on the Kundan integration card.")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Aktiver")]), _vm._v(" to enable the Kundan integration.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "um-section"
	  }, [_c('p', {
	    staticClass: "um-subtitle"
	  }, [_vm._v("Once you choose your UniMicro environment, Kundan will:")]), _vm._v(" "), _c('ul', {
	    staticClass: "um-list"
	  }, [_c('li', [_vm._v("Authenticate using our UniMicro certificate")]), _vm._v(" "), _c('li', [_vm._v("Generate a secure access token")]), _vm._v(" "), _c('li', [_vm._v("Fetch and match your Company Key")]), _vm._v(" "), _c('li', [_vm._v("Use your stored Org.nr to identify your company")]), _vm._v(" "), _c('li', [_vm._v("Store everything securely in your organization settings")])])]), _vm._v(" "), _c('div', {
	    staticClass: "um-section"
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "static.module.unimicro",
	      "hasLabel": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "activation-check"
	  }, [_c('el-checkbox', {
	    model: {
	      value: (_vm.activationConfirmed),
	      callback: function($$v) {
	        _vm.activationConfirmed = $$v
	      },
	      expression: "activationConfirmed"
	    }
	  }, [_vm._v("\n            I have enabled Kundan inside UniMicro Integrations.\n          ")])], 1)])], 1), _vm._v(" "), _c('div', {
	    staticClass: "um-footer"
	  }, [_c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal(true)
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.close')) + "\n      ")]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "type": "primary",
	      "loading": _vm.form.loading,
	      "disabled": !_vm.activationConfirmed
	    },
	    on: {
	      "click": _vm.authorize
	    }
	  }, [_vm._v("\n        Subscribe\n      ")])], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3053 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.warehouse.index.title')) + " (" + _vm._s(_vm.warehouses.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.warehouses.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.warehouse.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'warehouse.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.warehouse.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.warehouses.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      attrs: {
	        "wide": true
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editWarehouse(p)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-external-link pull-right",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.editWarehouseNewTab(p)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "full-w flex wrap client-title-container margin-b-10"
	    }, [_c('img', {
	      staticClass: "client-img margin-b-10",
	      attrs: {
	        "src": __webpack_require__(2651),
	        "alt": ("" + (p.name))
	      }
	    }), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(("" + (p.name))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.warehouse.info.name')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.name || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.warehouse.info.location')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.location || '-'))])], _c('br'), _c('br'), _vm._v(" "), [_c('span', {
	      staticClass: "cardContent"
	    }, [(p.typeName == 'Standard') ? [_c('el-tag', {
	      attrs: {
	        "type": "danger"
	      }
	    }, [_vm._v(_vm._s(_vm.returnWarehouseType(p.typeName, p.isBonded)))])] : [_c('el-tag', {
	      attrs: {
	        "type": "success"
	      }
	    }, [_vm._v(_vm._s(_vm.returnWarehouseType(p.typeName, p.isBonded)))])]], 2)]], 2)
	  })], 2)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.warehouses.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3054 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('v-form-table', {
	    staticClass: "project-table",
	    attrs: {
	      "form": _vm.form,
	      "list": _vm.allProjects,
	      "create": _vm.save,
	      "update": _vm.update,
	      "destroy": _vm.destroy,
	      "translation": "table.projects"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 3055 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [(_vm.isSharedToYou) ? _c('div', [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('h2', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.sharedWarehouse.notAllowed')))])])], 1) : _c('div', [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 12
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.update.title')) + " - " + _vm._s(_vm.$t('static.purchase.status.' + _vm.purchaseTitle)))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.purchase.basicInformation'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "sm": 12,
	      "span": 24
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.purchase",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 12,
	      "span": 24
	    }
	  }, [_c('div', {
	    staticClass: "btn-group margin-r-10"
	  }, [_c('el-button', {
	    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split small",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    on: {
	      "click": _vm.toggleDropdown
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.purchase.view.documentBtnDropdown')) + " "), _c('span', {
	    staticClass: "sr-only"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu",
	    class: {
	      show: _vm.dropdownState
	    }
	  }, [_c('a', {
	    staticClass: "dropdown-item small",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": _vm.previewSendDocument
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.purchase.view.sendPurchaseDocument')))]), _vm._v(" "), _c('a', {
	    staticClass: "dropdown-item small",
	    attrs: {
	      "role": "button"
	    },
	    on: {
	      "click": _vm.downloadPurchase
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.purchase.view.downloadPurchaseDocument')))])])], 1)]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('v-products-table', {
	    attrs: {
	      "disableForm": _vm.isDisableForm,
	      "fields": _vm.fields,
	      "translation": "table.productsCustom",
	      "page": "purchase"
	    }
	  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.purchase.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.close').toUpperCase()))])], 1), _vm._v(" "), (_vm.showCancelPurchase) ? _c('el-button', {
	    staticClass: "outline danger",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.cancelPurchase
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))]) : _vm._e(), _vm._v(" "), (_vm.showDraft) ? _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.updateDraft
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.updateDraft').toUpperCase()))]) : _vm._e(), _vm._v(" "), (_vm.showSave) ? _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": function($event) {
	        return _vm.store()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))]) : _vm._e(), _vm._v(" "), (_vm.showComplete) ? _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.markAsDone
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.complete').toUpperCase()))]) : _vm._e()], 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3056 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.exciseEntry.index.title')))])])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-row', {
	    staticClass: "margin-b-10 margin-10 padding-t-20",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    staticClass: "ml-3",
	    attrs: {
	      "sm": 8
	    }
	  }, [_c('span', {
	    staticClass: "margin-b-10"
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.sales.dateRange.placeholder')) + ":\n                ")]), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "type": "month",
	      "placeholder": "Pick a month"
	    },
	    on: {
	      "change": _vm.changeData
	    },
	    model: {
	      value: (_vm.filter.month),
	      callback: function($$v) {
	        _vm.$set(_vm.filter, "month", $$v)
	      },
	      expression: "filter.month"
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    staticClass: "ml-3",
	    attrs: {
	      "sm": 8
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.exciseEntry",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', {
	    staticClass: "margin-b-10 margin-10",
	    attrs: {
	      "gutter": 24
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "sm": 24
	    }
	  }, [_c('v-excise-table', {
	    attrs: {
	      "list": _vm.entries,
	      "noDataMessage": _vm.$t('static.defaultText.exciseEntry.noDataMsg'),
	      "translation": "static.exciseEntry.table",
	      "loading": _vm.loading,
	      "update_list": _vm.updateList,
	      "link": _vm.openLink
	    }
	  })], 1)], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3057 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.loading == true) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : (_vm.loading == false && _vm.list.length) ? _c('el-table', {
	    ref: "tableData",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.list,
	      "stripe": "",
	      "default-sort": {
	        prop: 'balance',
	        order: 'descending'
	      }
	    },
	    on: {
	      "row-click": _vm.rowClicked
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "expand"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-row', {
	          attrs: {
	            "gutter": 10
	          }
	        }, [(props.row.volume) ? _c('el-col', {
	          attrs: {
	            "xs": 24,
	            "sm": 24,
	            "md": 12,
	            "lg": 3,
	            "xl": 3
	          }
	        }, [_c('div', {
	          staticClass: "grid-content"
	        }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.translation + ".volume"))) + ": ")]), _vm._v(" " + _vm._s(props.row.volume))])])]) : _vm._e(), _vm._v(" "), (props.row.abv) ? _c('el-col', {
	          attrs: {
	            "xs": 24,
	            "sm": 24,
	            "md": 12,
	            "lg": 3,
	            "xl": 3
	          }
	        }, [_c('div', {
	          staticClass: "grid-content"
	        }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.translation + ".abv"))) + ": ")]), _vm._v(" " + _vm._s(props.row.abv))])])]) : _vm._e(), _vm._v(" "), (props.row.amountLiter) ? _c('el-col', {
	          attrs: {
	            "xs": 24,
	            "sm": 24,
	            "md": 12,
	            "lg": 3,
	            "xl": 3
	          }
	        }, [_c('div', {
	          staticClass: "grid-content"
	        }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.translation + ".liter"))) + ": ")]), _vm._v(" " + _vm._s(props.row.amountLiter))])])]) : _vm._e(), _vm._v(" "), (props.row.exciseGroup) ? _c('el-col', {
	          attrs: {
	            "xs": 24,
	            "sm": 24,
	            "md": 12,
	            "lg": 3,
	            "xl": 3
	          }
	        }, [_c('div', {
	          staticClass: "grid-content"
	        }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.translation + ".exciseGroup"))) + ": ")]), _vm._v(" " + _vm._s(props.row.exciseGroup))])])]) : _vm._e(), _vm._v(" "), (props.row.exciseBasic) ? _c('el-col', {
	          attrs: {
	            "xs": 24,
	            "sm": 24,
	            "md": 12,
	            "lg": 3,
	            "xl": 3
	          }
	        }, [_c('div', {
	          staticClass: "grid-content"
	        }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.translation + ".exciseBasic"))) + ": ")]), _vm._v(" " + _vm._s(props.row.exciseBasic))])])]) : _vm._e(), _vm._v(" "), (props.row.excisePackaging) ? _c('el-col', {
	          attrs: {
	            "xs": 24,
	            "sm": 24,
	            "md": 12,
	            "lg": 3,
	            "xl": 3
	          }
	        }, [_c('div', {
	          staticClass: "grid-content"
	        }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.translation + ".excisePackaging"))) + ": ")]), _vm._v(" " + _vm._s(props.row.excisePackaging))])])]) : _vm._e(), _vm._v(" "), (props.row.exciseAdditionalCode) ? _c('el-col', {
	          attrs: {
	            "xs": 24,
	            "sm": 24,
	            "md": 12,
	            "lg": 3,
	            "xl": 3
	          }
	        }, [_c('div', {
	          staticClass: "grid-content"
	        }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.translation + ".exciseAdditionalCode"))) + ": ")]), _vm._v(" " + _vm._s(props.row.exciseAdditionalCode))])])]) : _vm._e()], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t((_vm.translation + ".flag")),
	      "sortable": true
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('p', [(scope.row['flag'] == false) ? _c('i', {
	          staticClass: "el-icon-success success"
	        }) : _c('i', {
	          staticClass: "el-icon-warning status_ cancelled"
	        })])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t((_vm.translation + ".createdAt")),
	      "sortable": true
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('p', [_vm._v(_vm._s(scope.row['createdAt']))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t((_vm.translation + ".exciseType")),
	      "sortable": true
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('p', [_c('a', {
	          attrs: {
	            "type": "text",
	            "size": "small"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.link(scope.row)
	            }
	          }
	        }, [_vm._v("\n          " + _vm._s(scope.row['excisableType']) + "\n        ")])])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t((_vm.translation + ".receiverName")),
	      "sortable": true
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('p', [_vm._v(_vm._s(scope.row['receiverName']))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t((_vm.translation + ".productName")),
	      "sortable": true
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('p', [_vm._v(_vm._s(scope.row['productName']))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t((_vm.translation + ".qty")),
	      "sortable": true
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('p', [_vm._v(_vm._s(scope.row['qty']))])]
	      }
	    }])
	  })], 1) : _c('el-alert', {
	    attrs: {
	      "title": this.noDataMessage || _vm.$t('table.noData'),
	      "type": "warning"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 3058 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "main-body"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('static.profileAddress.title')))]), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "save": _vm.save,
	      "translation": "form.profileAddress",
	      "hasLabel": true,
	      "labelWidth": "150px"
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3059 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', [_c('center', [_c('ul', {
	    staticClass: "pagination no-margin"
	  }, [_c('li', {
	    class: {
	      'disabled': this.previousDisabled
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.previousPage($event)
	      }
	    }
	  }, [_c('span', [_vm._v("«")])])]), _vm._v(" "), _vm._l((_vm.pagination.totalPages), function(page, index) {
	    return _c('li', {
	      class: {
	        'active': index + 1 === _vm.pagination.currentPage
	      }
	    }, [_c('a', {
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.goToPage(index + 1)
	        }
	      }
	    }, [_vm._v(_vm._s(index + 1))])])
	  }), _vm._v(" "), _c('li', {
	    class: {
	      'disabled': this.nextDisabled
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.nextPage($event)
	      }
	    }
	  }, [_c('span', [_vm._v("»")])])])], 2)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 3060 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [(_vm.isZNB) ? _c('span', [_vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.znbTitle')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.title')))]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [(_vm.isZNB) ? _c('span', [_vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.znbTitle')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.title')))])]), _vm._v(" "), (_vm.hasExciseModule) ? _c('div', [(_vm.bevearageProducts.length) ? [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.clientType')) + ": " + _vm._s(_vm.currentOrder.client.clientType.name) + "\n                "), (_vm.currentOrder.client && _vm.currentOrder.client.clientType.exciseAdditionalCode) ? [_c('br'), _vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.exciseCode')) + ": " + _vm._s(_vm.currentOrder.client.clientType.exciseAdditionalCode) + "\n                ")] : _vm._e()], 2), _vm._v(" "), (_vm.hasNoExcise) ? _c('el-alert', {
	    staticStyle: {
	      "margin-bottom": "10px",
	      "margin-top": "15px",
	      "display": "flex"
	    },
	    attrs: {
	      "title": _vm.$t('static.orders.orderConfirm.exciseWarningMessage'),
	      "type": "warning",
	      "show-icon": "",
	      "closable": false
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "el-row",
	    staticStyle: {
	      "border": "1px solid #ebeef5",
	      "background": "#f4f3f3",
	      "padding": "10px"
	    }
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%",
	      "display": "block"
	    },
	    attrs: {
	      "data": _vm.bevearageProducts
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.orders.orderConfirm.table.product')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.noExcise || !scope.row.productPackaging) ? _c('a', {
	          on: {
	            "click": function($event) {
	              return _vm.quickProductEdit(scope.row.id)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "el-icon-edit"
	        }), _vm._v(" " + _vm._s(scope.row.name))]) : _c('span', [_vm._v(_vm._s(scope.row.name))])]
	      }
	    }], null, false, 4066193461)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.orders.orderConfirm.exciseCheck')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(!scope.row.noExcise) ? _c('i', {
	          staticClass: "el-icon-circle-check success-color",
	          staticStyle: {
	            "font-size": "18px"
	          }
	        }) : _c('i', {
	          staticClass: "el-icon-circle-close danger-color",
	          staticStyle: {
	            "font-size": "18px"
	          }
	        })]
	      }
	    }], null, false, 3082525749)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.orders.orderConfirm.packagingCheck')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.productPackaging) ? _c('i', {
	          staticClass: "el-icon-circle-check success-color",
	          staticStyle: {
	            "font-size": "18px"
	          }
	        }) : _c('i', {
	          staticClass: "el-icon-circle-close danger-color",
	          staticStyle: {
	            "font-size": "18px"
	          }
	        })]
	      }
	    }], null, false, 2695315936)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "beverage",
	      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.beverage')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "packaging",
	      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.packaging')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "basic",
	      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.basic')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "bottleVolume",
	      "label": _vm.$t('static.orders.orderConfirm.table.bottleVolume')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "alcoholPercentage",
	      "label": _vm.$t('static.orders.orderConfirm.table.alcoholPercentage')
	    }
	  })], 1)], 1)] : _vm._e()], 2) : _c('div', [_c('el-alert', {
	    staticStyle: {
	      "margin-bottom": "10px",
	      "margin-top": "15px",
	      "display": "flex"
	    },
	    attrs: {
	      "title": _vm.$t('static.orders.orderConfirm.upsellMessage'),
	      "type": "info",
	      "show-icon": ""
	    }
	  })], 1), _vm._v(" "), _c('div', [(!_vm.loading && !_vm.isZNB) ? _c('v-form', {
	    staticStyle: {
	      "margin-top": "15px"
	    },
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.orderConfirm",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), (!_vm.isZNB) ? [_c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal(_vm.dashboard)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading,
	      "disabled": !!(_vm.hasNoExcise || _vm.hasMissingPackaging)
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.save').toUpperCase()))])] : _c('div', {
	    staticClass: "flex justify-center"
	  }, [_c('el-button', {
	    staticClass: "small margin-t-10",
	    attrs: {
	      "loading": _vm.form.loading,
	      "disabled": !!(_vm.hasNoExcise || _vm.hasMissingPackaging)
	    },
	    on: {
	      "click": _vm.nextProcess
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.next').toUpperCase()))])], 1)], 2)])
	},staticRenderFns: []}

/***/ }),
/* 3061 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.equipments.edit.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.equipments.formTabs.equipmentInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.equipments",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'production.equipments.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3062 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle",
	    class: {
	      'pageTitle--dark': !_vm.isInOwnRoute
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.productPackagings.create.title')))])])], 1), _vm._v(" "), _c('div', {
	    class: {
	      'whiteWrapper': _vm.isInOwnRoute
	    }
	  }, [(_vm.isInOwnRoute) ? _c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.productPackagings.formTabs.packagingInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.productPackagings",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1) : _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.productPackagings",
	      "hasLabel": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [(_vm.isInOwnRoute) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productPackagings.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
	    class: {
	      'outline': _vm.isInOwnRoute
	    },
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3063 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [(_vm.sharedWarehouseNotice) ? _c('div', {
	    staticStyle: {
	      "padding": "10px",
	      "text-align": "left",
	      "border": "1px solid #e84c4c",
	      "background": "#F56C6C",
	      "color": "#fff",
	      "font-size": "16px",
	      "margin-bottom": "30px"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.sharedWarehouseNotice)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.product.productParentId) ? _c('el-breadcrumb', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "separator-class": "el-icon-arrow-right"
	    }
	  }, [_c('el-breadcrumb-item', {
	    attrs: {
	      "to": {
	        name: 'products.edit',
	        params: {
	          id: _vm.product.productParentId
	        },
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.product.productParentName))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.product.name))])], 1) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-edit",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.products.edit.title')))]) : _c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-edit",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.product.name))])], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.products.formTabs.productInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.checkHasInventory),
	      expression: "checkHasInventory"
	    }],
	    attrs: {
	      "xs": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [(_vm.productType && _vm.checkHasInventory && +_vm.productType.stockable !== 0) ? _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.customSkuform,
	      "label-width": "180px",
	      "label-position": "left"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "error": _vm.customSkuform.custom_sk_error,
	      "label": _vm.$t('form.products.sku.label')
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "disabled": (_vm.customSkuform.custom_sku && _vm.customSkuform.update_sku === false) ? true : false,
	      "placeholder": "Please input"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        return _vm.customSkuKeydown($event)
	      }
	    },
	    model: {
	      value: (_vm.customSkuform.custom_sku),
	      callback: function($$v) {
	        _vm.$set(_vm.customSkuform, "custom_sku", $$v)
	      },
	      expression: "customSkuform.custom_sku"
	    }
	  })], 1), _vm._v(" "), (!_vm.account.hasPartner) ? [_c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('form.products.updateSku.label')
	    }
	  }, [_c('el-checkbox', {
	    model: {
	      value: (_vm.customSkuform.update_sku),
	      callback: function($$v) {
	        _vm.$set(_vm.customSkuform, "update_sku", $$v)
	      },
	      expression: "customSkuform.update_sku"
	    }
	  })], 1), _vm._v(" "), (_vm.customSkuform.update_sku === true && !_vm.hasSkuInitial) ? _c('el-form-item', {
	    attrs: {
	      "label": 'With sku initial?'
	    }
	  }, [_c('el-checkbox', {
	    on: {
	      "change": function($event) {
	        return _vm.addSkuInitial($event)
	      }
	    },
	    model: {
	      value: (_vm.customSkuform.sku_initial),
	      callback: function($$v) {
	        _vm.$set(_vm.customSkuform, "sku_initial", $$v)
	      },
	      expression: "customSkuform.sku_initial"
	    }
	  })], 1) : _vm._e()] : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.products",
	      "hasLabel": true
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-tabs', {
	    staticClass: "product-tabs",
	    attrs: {
	      "stretch": "",
	      "value": "productInformation"
	    }
	  }, [_vm._l((_vm.forms), function(newform) {
	    return [((newform.name != 'lokalbrygg' && newform.name != 'onlineStore') || (newform.name == 'onlineStore' && _vm.hasWooModule === true)) ? _c('el-tab-pane', {
	      key: newform.name,
	      attrs: {
	        "name": newform.name
	      }
	    }, [_c('span', {
	      class: {
	        'has-error': newform.form.errors.any()
	      },
	      attrs: {
	        "slot": "label"
	      },
	      slot: "label"
	    }, [(newform.form.errors.any()) ? _c('i', {
	      staticClass: "el-icon-warning"
	    }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(("static.products.labels." + (newform.name)))))]), _vm._v(" "), _c('el-row', {
	      attrs: {
	        "gutter": 20
	      }
	    }, [_c('v-form', {
	      attrs: {
	        "form": newform.form,
	        "translation": "form.products",
	        "hasLabel": true,
	        "information": newform.information,
	        "imageRemove": _vm.onImageRemove
	      }
	    }), _vm._v(" "), (newform.name === 'marketplace') ? _c('v-marketplace', {
	      attrs: {
	        "disabled": !_vm.showMarketplaceForm,
	        "product": _vm.product,
	        "data": _vm.marketplaceData
	      },
	      on: {
	        "update": function($event) {
	          _vm.marketplaceData = $event;
	        },
	        "priceUpdate": _vm.marketplacePriceUpdated
	      }
	    }) : _vm._e()], 1)], 1) : _vm._e()]
	  })], 2)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.products.formTabs.inventory'),
	      "name": "2"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-table', {
	    attrs: {
	      "list": _vm.warehouseList,
	      "noDataMessage": _vm.$t('static.products.warehouse.noDataMsg'),
	      "link": _vm.link,
	      "linkKey": "name",
	      "rowKey": "id",
	      "translation": "static.products.warehouse.table"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.products.formTabs.transactions'),
	      "name": "3"
	    }
	  }, [_c('el-row', {
	    staticStyle: {
	      "margin-top": "10px",
	      "margin-bottom": "10px"
	    },
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "sm": 24,
	      "md": 1,
	      "lg": 1,
	      "xl": 1
	    }
	  }, [_c('label', [_vm._v("Filter: ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 24,
	      "md": 3,
	      "lg": 3,
	      "xl": 3
	    }
	  }, [(_vm.hasProduction) ? _c('el-select', {
	    staticClass: "el-col-24",
	    attrs: {
	      "filterable": "",
	      "remote": "",
	      "clearable": "",
	      "size": "medium",
	      "placeholder": "Batch",
	      "remote-method": _vm.getFilterBatches,
	      "loading": _vm.batchFilter.loading
	    },
	    on: {
	      "change": function($event) {
	        return _vm.eventBatchFilter($event)
	      },
	      "clear": _vm.clearBatchFilter,
	      "focus": _vm.focusBatchFilter
	    },
	    model: {
	      value: (_vm.batchFilter.value),
	      callback: function($$v) {
	        _vm.$set(_vm.batchFilter, "value", $$v)
	      },
	      expression: "batchFilter.value"
	    }
	  }, _vm._l((_vm.batchFilter.options), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 24,
	      "md": 3,
	      "lg": 3,
	      "xl": 3
	    }
	  }, [_c('el-select', {
	    staticClass: "el-col-24",
	    attrs: {
	      "remote-method": _vm.getFilterWarehouse,
	      "loading": _vm.warehouseFilter.loading,
	      "filterable": "",
	      "remote": "",
	      "clearable": "",
	      "size": "medium",
	      "placeholder": "Warehouse"
	    },
	    on: {
	      "change": function($event) {
	        return _vm.eventWarehouseFilter($event)
	      },
	      "clear": _vm.clearWarehouseFilter,
	      "focus": _vm.focusWarehouseFilter
	    },
	    model: {
	      value: (_vm.warehouseFilter.value),
	      callback: function($$v) {
	        _vm.$set(_vm.warehouseFilter, "value", $$v)
	      },
	      expression: "warehouseFilter.value"
	    }
	  }, _vm._l((_vm.warehouseFilter.options), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(_vm.transactionLoading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.transactionLoading),
	      expression: "transactionLoading"
	    }]
	  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.transactionLoading && _vm.transactionListNew && _vm.transactionListNew.length < 1) ? _c('div', {
	    staticClass: "whiteWrapper full-w flex justify-center",
	    staticStyle: {
	      "padding": "50px"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('static.warehouse.transactions.noDataMsg')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.transactionListNew && _vm.transactionListNew.length > 0 && !_vm.transactionLoading) ? _c('v-table', {
	    attrs: {
	      "list": _vm.transactionListNew,
	      "noDataMessage": _vm.$t('static.products.transactions.noDataMsg'),
	      "link": _vm.transactionLink,
	      "linkKey": "via",
	      "rowKey": "id,key",
	      "translation": "static.products.transactions.table"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.transactionListNew && _vm.transactionListNew.length > 0) ? _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.transactionsV2.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.sharedWarehouseNotice) ? _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.products.formTabs.mergeProduct'),
	      "name": "4"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.products.labels.mergeProduct')))]), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "form": _vm.productMergeForm,
	      "translation": "form.products",
	      "hasLabel": true
	    }
	  }), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.productMergeForm.loading
	    },
	    on: {
	      "click": _vm.mergeProduct
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.merge').toUpperCase()))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
	    attrs: {
	      "title": "Merging products with orders warehouse and stock record? Please contact the support.",
	      "type": "info",
	      "closable": false
	    }
	  })], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.sharedWarehouseNotice && _vm.product.childProducts && _vm.product.childProducts.length) ? _c('el-tab-pane', {
	    attrs: {
	      "label": ((_vm.$t('static.products.formTabs.childProducts')) + " (" + (_vm.product.childProducts.length) + ")"),
	      "name": "5"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-table', {
	    attrs: {
	      "list": _vm.product.childProducts,
	      "noDataMessage": _vm.$t('static.defaultText.product.noDataMsg'),
	      "link": _vm.editProduct,
	      "linkKey": "name",
	      "rowKey": "id",
	      "translation": "static.products.table"
	    }
	  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('el-button', {
	    staticClass: "outline danger",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.destroy
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.deleteProduct').toUpperCase()))]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'products.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 3064 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', [_c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.organizationSettings.title')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper org-settings"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.accountInformation.general'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.settings.generalSettings')))]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.generalSettingsFormSet1,
	      "translation": "form.organizationSettings",
	      "hasLabel": true,
	      "labelWidth": "180px"
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.generalSettingsFormSet2,
	      "translation": "form.organizationSettings",
	      "hasLabel": true,
	      "labelWidth": "180px"
	    }
	  }), _vm._v(" "), _vm._l((_vm.tagsOptions), function(item, key) {
	    return _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(_vm.showTagOptions(key))
	      }
	    })
	  }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.ediNotifyRecipients.title')))]), _vm._v(" "), _vm._l((_vm.ediNotificationRecipients), function(email) {
	    return _c('el-tag', {
	      key: email,
	      staticClass: "edi-notification-recipients",
	      attrs: {
	        "closable": "",
	        "disable-transitions": false
	      },
	      on: {
	        "close": function($event) {
	          return _vm.ediNotifyRecipHandleClose(email)
	        }
	      }
	    }, [_vm._v("\n                    " + _vm._s(email) + "\n                  ")])
	  }), _vm._v(" "), (_vm.ediNotifyRecipInputVisible) ? _c('el-input', {
	    ref: "saveEmailInput",
	    staticClass: "input-new-tag",
	    class: _vm.ediNotifyRecipInvalidValue ? 'danger' : '',
	    attrs: {
	      "size": "medium"
	    },
	    on: {
	      "blur": _vm.ediNotifyRecipHandleInputConfirm
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.ediNotifyRecipHandleInputConfirm($event)
	      }
	    },
	    model: {
	      value: (_vm.ediNotifyRecipInputValue),
	      callback: function($$v) {
	        _vm.ediNotifyRecipInputValue = $$v
	      },
	      expression: "ediNotifyRecipInputValue"
	    }
	  }) : _c('el-button', {
	    staticClass: "button-new-tag",
	    attrs: {
	      "size": "small"
	    },
	    on: {
	      "click": _vm.ediNotifyRecipShowInput
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('static.organizationSettings.ediNotifyRecipients.addBtn')))]), _vm._v(" "), (_vm.ediNotifyRecipInvalidValue) ? _c('p', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.ediNotifyRecipInvalidValue) + " ")]) : _vm._e()], 2), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.lowStockNotifyRecipients.title')))]), _vm._v(" "), _vm._l((_vm.lowStockNotificationRecipients), function(email) {
	    return _c('el-tag', {
	      key: email,
	      staticClass: "edi-notification-recipients",
	      attrs: {
	        "closable": "",
	        "disable-transitions": false
	      },
	      on: {
	        "close": function($event) {
	          return _vm.lowStockNotifyRecipHandleClose(email)
	        }
	      }
	    }, [_vm._v("\n                    " + _vm._s(email) + "\n                    ")])
	  }), _vm._v(" "), (_vm.lowStockNotifyRecipInputVisible) ? _c('el-input', {
	    ref: "saveEmailInputLowStock",
	    staticClass: "input-new-tag",
	    class: _vm.lowStockNotifyRecipInvalidValue ? 'danger' : '',
	    attrs: {
	      "size": "medium"
	    },
	    on: {
	      "blur": _vm.lowStockNotifyRecipHandleInputConfirm
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.lowStockNotifyRecipHandleInputConfirm($event)
	      }
	    },
	    model: {
	      value: (_vm.lowStockNotifyRecipInputValue),
	      callback: function($$v) {
	        _vm.lowStockNotifyRecipInputValue = $$v
	      },
	      expression: "lowStockNotifyRecipInputValue"
	    }
	  }) : _c('el-button', {
	    staticClass: "button-new-tag",
	    attrs: {
	      "size": "small"
	    },
	    on: {
	      "click": _vm.lowStockNotifyRecipShowInput
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('static.organizationSettings.lowStockNotifyRecipients.addBtn')))]), _vm._v(" "), (_vm.lowStockNotifyRecipInvalidValue) ? _c('p', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.lowStockNotifyRecipInvalidValue) + " ")]) : _vm._e()], 2)], 2), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.settings.productDisplay')))]), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
	    return _c('el-tag', {
	      key: tag,
	      attrs: {
	        "closable": "",
	        "disable-transitions": false
	      },
	      on: {
	        "close": function($event) {
	          return _vm.handleClose(tag)
	        }
	      }
	    }, [_vm._v("\n                    " + _vm._s(tag) + "\n                  ")])
	  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-select', {
	    ref: "saveTagInput",
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.inputValue),
	      callback: function($$v) {
	        _vm.inputValue = $$v
	      },
	      expression: "inputValue"
	    }
	  }, _vm._l((_vm.tagsOptions), function(item, key) {
	    return _c('el-option', {
	      key: key,
	      attrs: {
	        "label": item.label,
	        "value": key
	      }
	    }, [_c('span', {
	      staticStyle: {
	        "float": "left"
	      }
	    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
	      staticStyle: {
	        "float": "right",
	        "color": "#8492a6",
	        "font-size": "13px"
	      }
	    }, [_vm._v(_vm._s(key))])])
	  }), 1) : _c('el-button', {
	    staticClass: "button-new-tag",
	    attrs: {
	      "size": "small"
	    },
	    on: {
	      "click": _vm.showInput
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('static.settings.newField')))])], 2)])], 1)]), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('el-button', {
	    attrs: {
	      "loading": _vm.generalSettingsFormSet1.loading
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.accountInformation.email'),
	      "name": "2"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.messageTemplates')))]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.messagesFormSet1,
	      "translation": "form.organizationSettings",
	      "hasLabel": true,
	      "labelWidth": "180px"
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.messagesFormSet2,
	      "translation": "form.organizationSettings",
	      "hasLabel": true,
	      "labelWidth": "180px"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.messagesFormSet3,
	      "translation": "form.organizationSettings",
	      "hasLabel": true,
	      "labelWidth": "180px"
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.messagesFormSet4,
	      "translation": "form.organizationSettings",
	      "hasLabel": true,
	      "labelWidth": "180px"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.messagesFormSet5,
	      "translation": "form.organizationSettings",
	      "hasLabel": true,
	      "labelWidth": "180px"
	    }
	  })], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('el-button', {
	    attrs: {
	      "loading": _vm.messagesFormSet1.loading
	    },
	    on: {
	      "click": _vm.saveMessages
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.isOnlineBooking) ? _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.accountInformation.booking'),
	      "name": "3"
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.booking')))]), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.bookingSettingsSet1,
	      "translation": "form.organizationSettings",
	      "hasLabel": true,
	      "labelWidth": "180px"
	    }
	  })], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('el-button', {
	    attrs: {
	      "loading": _vm.bookingSettingsSet1.loading
	    },
	    on: {
	      "click": _vm.saveBooking
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.accountInformation.accounting'),
	      "name": "4"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(" " + _vm._s(_vm.$t('static.organizationSettings.payment_identification')))]), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "form": _vm.accountingFormSet2,
	      "translation": "form.organizationSettings",
	      "hasLabel": true,
	      "labelWidth": "180px"
	    }
	  }), _vm._v(" "), (!_vm.settings.paymentIdentitificationGeneration && !_vm.settings.paymentIdentitificationTemplate) ? [_c('hr'), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center"
	  }, [_c('el-button', {
	    attrs: {
	      "loading": _vm.accountingFormSet2.loading
	    },
	    on: {
	      "click": _vm.saveBilling
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(" " + _vm._s(_vm.$t('static.organizationSettings.accounting')))]), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "form": _vm.accountingFormSet1,
	      "translation": "form.organizationSettings",
	      "hasLabel": true,
	      "labelWidth": "180px"
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center"
	  }, [_c('el-button', {
	    attrs: {
	      "loading": _vm.accountingFormSet1.loading
	    },
	    on: {
	      "click": _vm.saveAccounting
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.coa.title')))]), _vm._v(" "), _c('chart-of-accounts')], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.emailInvoiceCopy.title')))]), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "form": _vm.emailInvoiceCopyForm,
	      "translation": "form.organizationSettings",
	      "hasLabel": true,
	      "labelWidth": "180px"
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center"
	  }, [_c('el-button', {
	    attrs: {
	      "loading": _vm.emailInvoiceCopyForm.loading
	    },
	    on: {
	      "click": _vm.saveEmailInvoiceCopy
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), (_vm.isEDI) ? _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.accountInformation.shippingProvider'),
	      "name": "5"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('shipping-provider-table')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (true === _vm.checkProjectModule) ? _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.accountInformation.project'),
	      "name": "6"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('project-table')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.accountInformation.advance'),
	      "name": "7"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 12
	    }
	  }, [(_vm.bulkPriceUpdateStatus === 'running') ? _c('div', [_c('h3', [_c('b', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.bulk_price_update_status.running.title')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.bulk_price_update_status.running.description')))])]) : _vm._e(), _vm._v(" "), (_vm.bulkPriceUpdateStatus === 'failed') ? _c('div', [_c('h3', [_c('b', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.bulk_price_update_status.failed.title')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.organizationSettings.bulk_price_update_status.failed.description')))])]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(" " + _vm._s(_vm.$t('static.organizationSettings.bulk_price_update')))]), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "form": _vm.advanceFormSet,
	      "translation": "form.organizationSettings",
	      "hasLabel": true,
	      "labelWidth": "180px"
	    }
	  }), _vm._v(" "), [_c('hr'), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center"
	  }, [_c('el-button', {
	    attrs: {
	      "disabled": _vm.bulkPriceUpdateStatus === 'running' || _vm.bulkPriceUpdateStatus === 'failed'
	    },
	    on: {
	      "click": _vm.bulkPriceUpdateModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.bulkPriceUpdate').toUpperCase()))])], 1) : _vm._e()]], 2)]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 12
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(" " + _vm._s(_vm.$t('static.organizationSettings.bulk_price_update_entries.title')))]), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": [].concat( _vm.bulkPriceUpdateEntries ).reverse(),
	      "stripe": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "date_time",
	      "label": _vm.$t('static.organizationSettings.bulkPriceUpdateHistory.date'),
	      "width": "100"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Status",
	      "width": "80"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(scope.row.status ? _vm.$t(("static.organizationSettings." + (scope.row.status))) : ''))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "percentage",
	      "label": _vm.$t('static.organizationSettings.bulkPriceUpdateHistory.percentage'),
	      "width": "50"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "rounding_rules",
	      "label": _vm.$t('static.organizationSettings.bulkPriceUpdateHistory.roundingRules'),
	      "width": "100"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.organizationSettings.bulkPriceUpdateHistory.priceTypes')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          domProps: {
	            "innerHTML": _vm._s(_vm.getPriceTypes(scope.row.price_types))
	          }
	        })]
	      }
	    }])
	  })], 1)], 1)])], 1)], 1)], 1)], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3065 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-row', {
	    staticClass: "bulk-client-add"
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('h3', [_vm._v(_vm._s('Bulk processing of clients'))]), _vm._v(" "), [_c('h4', [_vm._v(_vm._s(_vm.subTitle))]), _vm._v(" "), _c('el-table', {
	    staticClass: "clients",
	    staticStyle: {
	      "width": "100%",
	      "margin-bottom": "10px"
	    },
	    attrs: {
	      "data": _vm.clients
	    }
	  }, [(_vm.type === 'isSubClient') ? _c('el-table-column', {
	    attrs: {
	      "label": "$t('static.clients.table.parentClient)",
	      "width": "200",
	      "sortable": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-select', {
	          attrs: {
	            "filterable": "",
	            "remote": "",
	            "placeholder": "Please enter a keyword",
	            "remote-method": function (query) { return _vm.searchMethod(query, props.row.id); },
	            "loading": _vm.optionsLoading
	          },
	          on: {
	            "change": function (value) { return _vm.onClientParent(value, props.row.id); }
	          },
	          model: {
	            value: (props.row.clientParent),
	            callback: function($$v) {
	              _vm.$set(props.row, "clientParent", $$v)
	            },
	            expression: "props.row.clientParent"
	          }
	        }, _vm._l((_vm.clientOptions), function(item, index) {
	          return _c('el-option', {
	            key: item.value,
	            attrs: {
	              "label": item.label,
	              "value": item.value
	            }
	          })
	        }), 1)]
	      }
	    }], null, false, 3002562091)
	  }) : _vm._e(), _vm._v(" "), (_vm.type === 'isSubClient') ? _c('el-table-column', {
	    attrs: {
	      "label": "$t('static.clients.table.billMainParent)",
	      "width": "150",
	      "sortable": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-checkbox', {
	          attrs: {
	            "value": props.row.billMainParent
	          },
	          on: {
	            "change": function (value) { return _vm.onBillMainParent(value, props.row.id); }
	          }
	        }, [_vm._v("Bill main parent")])]
	      }
	    }], null, false, 2306019296)
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "name",
	      "label": _vm.$t('static.clients.table.name'),
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "billType",
	      "label": _vm.$t('static.clients.table.billType'),
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "email",
	      "label": _vm.$t('static.clients.table.email'),
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "ordersCount",
	      "label": _vm.$t('static.clients.table.ordersCount'),
	      "sortable": ""
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [_c('el-button', {
	    staticClass: "small dark",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.proceed
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.proceed')))])], 1)]], 2)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3066 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "chart-contaier sold-product"
	  }, [_c('div', {
	    staticClass: "widgets-addition-action"
	  }, [_c('el-select', {
	    staticClass: "widget-filterBy",
	    attrs: {
	      "placeholder": "Select",
	      "size": "small"
	    },
	    on: {
	      "change": function($event) {
	        return _vm.updateChart($event)
	      }
	    },
	    model: {
	      value: (_vm.filterBySelected),
	      callback: function($$v) {
	        _vm.filterBySelected = $$v
	      },
	      expression: "filterBySelected"
	    }
	  }, _vm._l((_vm.filterBy), function(item, key) {
	    return _c('el-option', {
	      key: key,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1)], 1), _vm._v(" "), (_vm.loaded) ? _c('line-chart', {
	    attrs: {
	      "chartData": _vm.chartdata,
	      "options": _vm.options
	    }
	  }) : _c('div', {
	    staticClass: "loading"
	  }, [_c('i', {
	    staticClass: "el-icon-loading"
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 3067 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "full-w flex-column start"
	  }, [_c('h2', {
	    staticStyle: {
	      "margin-bottom": "0"
	    }
	  }, [_vm._v(_vm._s(this.appointment ? _vm.$t('static.appointments.edit.title') : _vm.$t('static.appointments.create.title')))]), _vm._v(" "), (_vm.appointment) ? _c('a', {
	    staticStyle: {
	      "cursor": "pointer",
	      "margin-bottom": "1rem"
	    },
	    on: {
	      "click": _vm.goToOverviewPage
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.appointments.edit.editButton')))]) : _vm._e()]), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "hasLabel": true,
	      "translation": "form.orders"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex space-between wrap"
	  }, [_c('div', {
	    staticClass: "flex wrap margin-b-10"
	  }, [_c('el-button', {
	    staticClass: "dark margin-b-10",
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]), _vm._v(" "), _c('el-button', {
	    staticClass: " margin-b-10",
	    on: {
	      "click": _vm.createAppointment
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [(_vm.destroy && _vm.appointment) ? _c('el-button', {
	    staticClass: "danger margin-b-10",
	    on: {
	      "click": function($event) {
	        return _vm.destroyAppointment(_vm.appointment.id)
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.delete')) + "\n      ")]) : _vm._e()], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 3068 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.supplier.update.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.supplier.basicInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.supplier",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.supplier.contactInformation'),
	      "name": "2"
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formContactInformation,
	      "translation": "form.supplier",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.supplier.AddressInformation'),
	      "name": "3"
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formAddressInformation,
	      "translation": "form.supplier",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'supplier.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 3069 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3070 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('v-form-table', {
	    staticClass: "product-table",
	    attrs: {
	      "form": _vm.form,
	      "list": _vm.currentStockProducts,
	      "additionalButtons": _vm.additionalButtons,
	      "update": _vm.update,
	      "destroy": _vm.destroy,
	      "translation": _vm.translation,
	      "disableForm": _vm.checkWarehouse,
	      "clickHandler": _vm.tableClickHandler,
	      "isImport": _vm.isImport,
	      "isExport": _vm.isExport,
	      "exportClickHandler": _vm.exportClickHandler,
	      "server": _vm.server,
	      "hiddenFields": _vm.hiddenFields
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 3071 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.orderWarehouse.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('div', [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.orders.orderWarehouse.title')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    staticStyle: {
	      "margin-top": "15px"
	    },
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.orderWarehouse",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [_c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.store($event)
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3072 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.editProductToPackageTitle')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.orders.package.editProductToPackageTitle')))]), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.addEditProductToPackage",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3073 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3074 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle pageTitle--dark"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n         " + _vm._s(_vm.$t('static.batches.edit.title')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.batches.formTabs.batchInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-20"
	  }, [_c('label', {
	    staticStyle: {
	      "width": "180px",
	      "display": "inline-block"
	    },
	    attrs: {
	      "for": "status"
	    }
	  }, [_vm._v("Select One:")]), _vm._v(" "), _c('el-radio-group', {
	    attrs: {
	      "id": "status"
	    },
	    on: {
	      "change": _vm.handleStatusChange
	    },
	    model: {
	      value: (_vm.form.status),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "status", $$v)
	      },
	      expression: "form.status"
	    }
	  }, [_c('el-radio-button', {
	    attrs: {
	      "label": "planned"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('form.batches.statuses.planned')) + "\n              ")]), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "started"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('form.batches.statuses.started')) + "\n              ")]), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "completed"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('form.batches.statuses.completed')) + "\n              ")])], 1)], 1), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.batches",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'production.batches.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.update($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()) + "\n    ")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3075 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')))]), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.module",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.authorize
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.subscribe').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3076 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3077 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.view.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.purchase.view.details'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.purchase.view.detailsLegend')))]), _vm._v(" "), [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.code')) + ": \n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.code) + " \n\t\t\t\t                      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.supplier')) + ": \n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'supplier.edit',
	        params: {
	          id: _vm.currentPurchase.supplier.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.currentPurchase.supplier.name))])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.warehouse')) + ": \n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'warehouse.edit',
	        params: {
	          id: _vm.currentPurchase.warehouse.id
	        }
	      }
	    }
	  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.warehouse.name) + "\n\t\t\t\t                        ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.qty')) + ": \n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.total_qty) + "\n\t\t\t\t                      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.comments')) + ": \n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.comments) + "\n\t\t\t\t                      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.createdAt')) + ": \n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.createdAt) + "\n\t\t\t\t                      ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.purchase.info.status')) + ": \n\t\t\t\t                      ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n\t\t\t\t                        " + _vm._s(_vm.currentPurchase.purchaseStatus.name) + "\n\t\t\t\t                      ")])])]], 2)]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.purchase.view.productsLegend')))]), _vm._v(" "), _c('v-table', {
	    attrs: {
	      "list": _vm.productList,
	      "noDataMessage": _vm.$t('static.purchase.noData'),
	      "translation": "static.purchase.products"
	    }
	  })], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.purchase.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "info"
	  }, [_vm._v(_vm._s(_vm.$t('button.receipt').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3078 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body el-row"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.campaigns.edit.overview')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.activeName),
	      callback: function($$v) {
	        _vm.activeName = $$v
	      },
	      expression: "activeName"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.campaigns.create.tabTitle'),
	      "name": "overview"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "full-w flex"
	  }, [_c('h2', {
	    staticClass: "title",
	    staticStyle: {
	      "margin-top": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.currentCampaign.name))])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.campaigns.edit.campaignInfo')))]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-envelope-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('form.campaigns.campaignTypeId.label')) + ":  \n                ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.currentCampaign.campaignType) + "\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-list-ul",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('form.campaigns.newsSubscriberListId.label')) + ":  \n                ")]), _vm._v(" "), (_vm.currentCampaign.newsSubscriberList) ? _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.currentCampaign.newsSubscriberList) + "\n                ")]) : _c('span', {
	    staticClass: "label-content label-content--small warning-color"
	  }, [_vm._v("\n                  " + _vm._s(_vm.ifListNotSet) + "\n                  "), _c('a', {
	    attrs: {
	      "href": "#tab-editcampaign"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.redirectEditCampaign($event)
	      }
	    }
	  }, [_vm._v("\n                    click here\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-info-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("    \n                ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.currentCampaign.description) + "\n                ")])])])])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": "Email Tracking",
	      "name": "emailTracking"
	    }
	  }, [(_vm.emailTracking.emailSubject.length > 0) ? _c('div', {
	    staticClass: "emailtracking-container"
	  }, [_c('el-card', {
	    staticClass: "box-card email-tracking-card"
	  }, [_c('div', [_c('h2', [_vm._v(_vm._s(_vm.emailTracking.selectedDayOrRangeText))])]), _vm._v(" "), _c('div', [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 4,
	      "lg": 4,
	      "xl": 3
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onSelectEmailSubject($event)
	      }
	    },
	    model: {
	      value: (_vm.emailTracking.selectEmailSubject),
	      callback: function($$v) {
	        _vm.$set(_vm.emailTracking, "selectEmailSubject", $$v)
	      },
	      expression: "emailTracking.selectEmailSubject"
	    }
	  }, [_c('el-option-group', {
	    key: 0,
	    attrs: {
	      "label": "Email subject"
	    }
	  }, _vm._l((_vm.emailTracking.emailSubject), function(item, key) {
	    return _c('el-option', {
	      key: key,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 4,
	      "lg": 4,
	      "xl": 3
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onSelectDayOrRange($event)
	      }
	    },
	    model: {
	      value: (_vm.emailTracking.selectDayOrRange),
	      callback: function($$v) {
	        _vm.$set(_vm.emailTracking, "selectDayOrRange", $$v)
	      },
	      expression: "emailTracking.selectDayOrRange"
	    }
	  }, _vm._l((_vm.emailTracking.selectDayOrRangeOption), function(item, key) {
	    return _c('el-option-group', {
	      key: key,
	      attrs: {
	        "label": item.group
	      }
	    }, _vm._l((item.item), function(item2, key2) {
	      return _c('el-option', {
	        key: key2,
	        attrs: {
	          "label": item2,
	          "value": {
	            value: key2,
	            label: item2
	          }
	        }
	      })
	    }), 1)
	  }), 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 4,
	      "lg": 4,
	      "xl": 3
	    }
	  }, [(_vm.emailTracking.selectDayOrRangeVisble) ? _c('el-date-picker', {
	    ref: "emailTrackingDate",
	    attrs: {
	      "popper-class": "email-tracking-date-range",
	      "type": "daterange",
	      "value-format": "yyyy-MM-dd",
	      "format": "MMM d yyyy",
	      "unlink-panels": "",
	      "range-separator": "To",
	      "start-placeholder": "Start date",
	      "end-placeholder": "End date",
	      "picker-options": _vm.emailTracking.pickerOptions
	    },
	    on: {
	      "change": function($event) {
	        return _vm.onChangeDate($event)
	      }
	    },
	    model: {
	      value: (_vm.emailTracking.selectRange),
	      callback: function($$v) {
	        _vm.$set(_vm.emailTracking, "selectRange", $$v)
	      },
	      expression: "emailTracking.selectRange"
	    }
	  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.emailTracking.selectDayOrRange.value === 'all' || _vm.emailTracking.selectDayOrRange.value === 'date_range') ? _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 24,
	      "lg": 24,
	      "xl": 24
	    }
	  }, [_c('div', {
	    staticClass: "date-range-display"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.campaigns.edit.emailTracking.dateRange')) + " ")]), _c('span', [_vm._v(_vm._s(_vm.emailTracking.dateRangDisplay))])])])], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.emailTracking.selectEmailSubject !== '') ? _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 4,
	      "lg": 4,
	      "xl": 3
	    }
	  }, [_c('div', {
	    staticClass: "email-icon",
	    class: _vm.emailTracking.iconActive.opened,
	    on: {
	      "click": function($event) {
	        return _vm.showChartOf('opened')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "fa-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-envelope-open fa-3x",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "email-text"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.campaigns.edit.emailTracking.countLabel.opened')))])]), _vm._v(" "), _c('div', {
	    staticClass: "email-count"
	  }, [(_vm.emailTracking.loaded) ? _c('span', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('i', {
	    staticClass: "fa fa-spinner fa-spin fa-1x fa-fw"
	  })]) : _c('span', [_vm._v(_vm._s(_vm.emailTracking.iconCountData.opened))])])])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 4,
	      "lg": 4,
	      "xl": 3
	    }
	  }, [_c('div', {
	    staticClass: "email-icon",
	    class: _vm.emailTracking.iconActive.delivered,
	    on: {
	      "click": function($event) {
	        return _vm.showChartOf('delivered')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "fa-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-truck fa-3x",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "email-text"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.campaigns.edit.emailTracking.countLabel.delivered')))])]), _vm._v(" "), _c('div', {
	    staticClass: "email-count"
	  }, [(_vm.emailTracking.loaded) ? _c('span', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('i', {
	    staticClass: "fa fa-spinner fa-spin fa-1x fa-fw"
	  })]) : _c('span', [_vm._v(_vm._s(_vm.emailTracking.iconCountData.delivered))])])])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 4,
	      "lg": 4,
	      "xl": 3
	    }
	  }, [_c('div', {
	    staticClass: "email-icon",
	    class: _vm.emailTracking.iconActive.clicked,
	    on: {
	      "click": function($event) {
	        return _vm.showChartOf('clicked')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "fa-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-o-up fa-3x",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "email-text"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.campaigns.edit.emailTracking.countLabel.clicked')))])]), _vm._v(" "), _c('div', {
	    staticClass: "email-count"
	  }, [(_vm.emailTracking.loaded) ? _c('span', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('i', {
	    staticClass: "fa fa-spinner fa-spin fa-1x fa-fw"
	  })]) : _c('span', [_vm._v(_vm._s(_vm.emailTracking.iconCountData.clicked))])])])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 4,
	      "lg": 4,
	      "xl": 3
	    }
	  }, [_c('div', {
	    staticClass: "email-icon",
	    class: _vm.emailTracking.iconActive.dropped,
	    on: {
	      "click": function($event) {
	        return _vm.showChartOf('dropped')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "fa-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-tint fa-3x",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "email-text"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.campaigns.edit.emailTracking.countLabel.dropped')))])]), _vm._v(" "), _c('div', {
	    staticClass: "email-count"
	  }, [(_vm.emailTracking.loaded) ? _c('span', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('i', {
	    staticClass: "fa fa-spinner fa-spin fa-1x fa-fw"
	  })]) : _c('span', [_vm._v(_vm._s(_vm.emailTracking.iconCountData.dropped))])])])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 4,
	      "lg": 4,
	      "xl": 3
	    }
	  }, [_c('div', {
	    staticClass: "email-icon",
	    class: _vm.emailTracking.iconActive.bounced,
	    on: {
	      "click": function($event) {
	        return _vm.showChartOf('bounced')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "fa-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-line-chart fa-3x",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "email-text"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.campaigns.edit.emailTracking.countLabel.bounced')))])]), _vm._v(" "), _c('div', {
	    staticClass: "email-count"
	  }, [(_vm.emailTracking.loaded) ? _c('span', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('i', {
	    staticClass: "fa fa-spinner fa-spin fa-1x fa-fw"
	  })]) : _c('span', [_vm._v(_vm._s(_vm.emailTracking.iconCountData.bounced))])])])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 4,
	      "lg": 4,
	      "xl": 3
	    }
	  }, [_c('div', {
	    staticClass: "email-icon",
	    class: _vm.emailTracking.iconActive.complained,
	    on: {
	      "click": function($event) {
	        return _vm.showChartOf('complained')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "fa-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-comment fa-3x",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "email-text"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.campaigns.edit.emailTracking.countLabel.complained')))])]), _vm._v(" "), _c('div', {
	    staticClass: "email-count"
	  }, [(_vm.emailTracking.loaded) ? _c('span', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('i', {
	    staticClass: "fa fa-spinner fa-spin fa-1x fa-fw"
	  })]) : _c('span', [_vm._v(_vm._s(_vm.emailTracking.iconCountData.complained))])])])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 4,
	      "lg": 4,
	      "xl": 3
	    }
	  }, [_c('div', {
	    staticClass: "email-icon",
	    class: _vm.emailTracking.iconActive.failed,
	    on: {
	      "click": function($event) {
	        return _vm.showChartOf('failed')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "fa-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-times fa-3x",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "email-text"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.campaigns.edit.emailTracking.countLabel.failed')))])]), _vm._v(" "), _c('div', {
	    staticClass: "email-count"
	  }, [(_vm.emailTracking.loaded) ? _c('span', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('i', {
	    staticClass: "fa fa-spinner fa-spin fa-1x fa-fw"
	  })]) : _c('span', [_vm._v(_vm._s(_vm.emailTracking.iconCountData.failed))])])])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 4,
	      "lg": 4,
	      "xl": 3
	    }
	  }, [_c('div', {
	    staticClass: "email-icon",
	    class: _vm.emailTracking.iconActive.unsubscribed,
	    on: {
	      "click": function($event) {
	        return _vm.showChartOf('unsubscribed')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "fa-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out fa-3x",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "email-text"
	  }, [_c('span', {
	    staticClass: "email-text"
	  }, [_vm._v(_vm._s(_vm.$t('static.campaigns.edit.emailTracking.countLabel.unsubscribed')))])]), _vm._v(" "), _c('div', {
	    staticClass: "email-count"
	  }, [(_vm.emailTracking.loaded) ? _c('span', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('i', {
	    staticClass: "fa fa-spinner fa-spin fa-1x fa-fw"
	  })]) : _c('span', {
	    staticClass: "email-count"
	  }, [_vm._v(_vm._s(_vm.emailTracking.iconCountData.unsubscribed))])])])])], 1) : _vm._e()], 1), _c('br'), _vm._v(" "), (_vm.emailTracking.selectDayOrRangeVisble) ? _c('el-card', {
	    staticClass: "box-card email-tracking-card"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 24,
	      "lg": 18,
	      "xl": 18
	    }
	  }, [_c('div', {
	    staticClass: "chart-container",
	    staticStyle: {
	      "min-height": "420px",
	      "margin-top": "30px"
	    }
	  }, [_c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('static.campaigns.edit.emailTracking.graphLabel')))])]), _vm._v(" "), _c('line-chart', {
	    attrs: {
	      "chart-data": _vm.emailTracking.lineChart.chartData,
	      "options": _vm.emailTracking.lineChart.options
	    }
	  })], 1)]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 24,
	      "lg": 6,
	      "xl": 6
	    }
	  }, [_c('div', {
	    staticClass: "recipient-container",
	    staticStyle: {
	      "min-height": "100px",
	      "margin-top": "30px"
	    }
	  }, [_c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('static.campaigns.edit.emailTracking.recipientLabel')))])]), _vm._v(" "), (_vm.emailTracking.emailTrackingRecipients.length > 0) ? _c('div', [_c('ol', _vm._l((_vm.emailTracking.emailTrackingRecipients), function(item) {
	    return _c('li', [_c('span', [_vm._v(_vm._s(item.recipient))])])
	  }), 0)]) : _c('div', [_vm._v(_vm._s(_vm.$t('static.campaigns.edit.emailTracking.noRecipientAvailable')))])])])], 1)], 1) : _vm._e(), _c('br'), _vm._v(" "), (_vm.emailTracking.selectDayOrRange.value === 'all' || _vm.emailTracking.selectDayOrRange.value === 'today') ? _c('el-card', {
	    staticClass: "box-card email-tracking-card"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', [_c('div', {
	    staticClass: "recipient-container",
	    staticStyle: {
	      "min-height": "100px",
	      "margin-top": "30px"
	    }
	  }, [_c('div', [_c('h2', [_vm._v("Recipients")])]), _vm._v(" "), (_vm.emailTracking.emailTrackingRecipients.length > 0) ? _c('div', [_c('ol', _vm._l((_vm.emailTracking.emailTrackingRecipients), function(item) {
	    return _c('li', [_c('span', [_vm._v(_vm._s(item.recipient))])])
	  }), 0)]) : _c('div', [_vm._v(_vm._s('No data available'))])])])], 1)], 1) : _vm._e()], 1) : _c('v-no-data', [_vm._v("\n          " + _vm._s(_vm.$t('static.campaigns.edit.emailTracking.noDataMsg')) + "\n        ")])], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t("static.campaigns.edit.emails"),
	      "name": "emails"
	    }
	  }, [_c('div', {
	    staticClass: "full-w flex space-between wrap"
	  }, [_c('h2', {
	    staticClass: "title",
	    staticStyle: {
	      "margin": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.news.index.title')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": _vm.openAddEmail
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('static.news.create.title')) + "\n          ")])], 1), _vm._v(" "), (typeof(_vm.emails.items) != 'undefined' && _vm.emails.items.length > 0) ? _c('div', {
	    staticClass: "news-email-container"
	  }, [_c('el-row', [_c('div', {
	    staticClass: "full-w flex-column start"
	  }, _vm._l((_vm.emails.items), function(e) {
	    return _c('div', {
	      staticClass: "full-w flex space-between list-item"
	    }, [_c('div', {
	      staticClass: "flex-column start"
	    }, [_c('div', {
	      staticClass: "full-w flex"
	    }, [_c('span', {
	      staticClass: "fa fa-envelope-open-o label label--small"
	    }), _vm._v(" "), _c('span', [_vm._v("   ")]), _vm._v(" "), _c('span', {
	      staticClass: "label-content label-content--small"
	    }, [_vm._v(_vm._s(e.subject))])]), _vm._v(" "), _c('div', {
	      staticClass: "full-w flex list-item--details"
	    }, [_c('span', {
	      staticClass: "fa fa-clock-o label label--small"
	    }, [_vm._v("\n                       \n                      " + _vm._s(_vm.currentCampaign.campaignType === 'Sequence' ? _vm.$t('form.news.sendAfter.label') : _vm.$t('form.news.sendAfterDate.label')) + ":\n                    ")]), _vm._v(" "), _c('span', [_vm._v("   ")]), _vm._v(" "), _c('span', {
	      staticClass: "label label--small"
	    }, [_vm._v(_vm._s(_vm.currentCampaign.campaignType === 'Sequence' ? e.sendAfter : e.sendAfterDate))])]), _vm._v(" "), _c('div', {
	      staticClass: "full-w flex list-item--details"
	    }, [_c('span', {
	      staticClass: "fa fa-info-circle label label--small"
	    }, [_vm._v("\n                       \n                      " + _vm._s(_vm.$t('form.news.status.label')) + ":\n                    ")]), _vm._v(" "), _c('span', [_vm._v("   ")]), _vm._v(" "), _c('span', {
	      staticClass: "label label--small",
	      staticStyle: {
	        "text-transform": "capitalize"
	      }
	    }, [_vm._v(_vm._s(e.status))])])]), _vm._v(" "), _c('div', {
	      staticClass: "flex"
	    }, [(e.status === 'done') ? _c('div', {
	      staticClass: "sent-status",
	      on: {
	        "click": function($event) {
	          return _vm.sentStatusTracking(e)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "success-status"
	    }, [_vm._v(_vm._s('Success: ' + e.sentSuccess))]), _vm._v(" "), _c('span', [_vm._v("|")]), _vm._v(" "), _c('span', {
	      staticClass: "fail-status"
	    }, [_vm._v(_vm._s('Failed: ' + e.sentFailed))])]) : _vm._e(), _vm._v(" "), _c('el-button', {
	      staticClass: "small dark-outline",
	      attrs: {
	        "icon": "el-icon-edit"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openEditEmail(e)
	        }
	      }
	    }), _vm._v(" "), _c('el-button', {
	      staticClass: "small dark-outline",
	      attrs: {
	        "icon": "el-icon-delete"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.deleteEmail(e)
	        }
	      }
	    })], 1)])
	  }), 0)]), _vm._v(" "), (_vm.emails.pagination) ? _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "pagination": _vm.emails.pagination,
	      "switchFunction": _vm.fetchEmails
	    }
	  })], 1)])], 1) : _vm._e()], 1) : _c('v-no-data', [_vm._v("\n          " + _vm._s(_vm.$t('static.campaigns.noDataMsg')) + "\n        ")])], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t("static.campaigns.edit.title"),
	      "name": "editcampaign"
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "save": _vm.update,
	      "form": _vm.form,
	      "translation": "form.campaigns",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3079 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('el-breadcrumb', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "separator-class": "el-icon-arrow-right"
	    }
	  }, [_c('el-breadcrumb-item', {
	    attrs: {
	      "to": {
	        name: 'reports',
	        query: {
	          t: 'excise'
	        },
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.reports.fees.title')))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.excisePeriod.monthName))])], 1), _vm._v(" "), _c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.reports.exciseEntry.title')))])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [(_vm.excisePeriod) ? _c('el-tab-pane', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "label": _vm.excisePeriod.monthName,
	      "name": "1"
	    }
	  }, [(_vm.exciseReports.length) ? _c('el-collapse', {
	    model: {
	      value: (_vm.activeNames),
	      callback: function($$v) {
	        _vm.activeNames = $$v
	      },
	      expression: "activeNames"
	    }
	  }, _vm._l((_vm.exciseReports), function(exciseReport, index) {
	    return _c('el-collapse-item', {
	      key: index,
	      attrs: {
	        "title": "",
	        "name": index
	      }
	    }, [_c('template', {
	      slot: "title"
	    }, [_c('h3', {
	      staticStyle: {
	        "font-size": "1.1rem"
	      }
	    }, [(exciseReport.period) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('static.reports.fees.exciseStatus.closed')) + " (" + _vm._s(exciseReport.period) + ")")])]) : _vm._e(), _vm._v(" "), (!exciseReport.period) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t(("static.reports.fees.exciseStatus." + (_vm.camalize(_vm.excisePeriod.exciseStatus))))))]), _vm._v(" "), (_vm.excisePeriod.exciseStatus === 'Changed') ? _c('i', {
	      staticClass: "header-icon el-icon-info"
	    }) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('el-row', {
	      staticClass: "margin-b-10",
	      attrs: {
	        "gutter": 20
	      }
	    }, [(!_vm.hasExcise) ? [_c('el-alert', {
	      attrs: {
	        "title": "For å hente avgifter   for rapportering må du abonnere på særavgift og lagermodul. Ta kontakt med support for mer info.",
	        "type": "error",
	        "closable": false
	      }
	    })] : [_c('el-col', {
	      attrs: {
	        "span": 24
	      }
	    })]], 2), _vm._v(" "), _c('el-row', {
	      attrs: {
	        "gutter": 20
	      }
	    }, [(!exciseReport.period && (_vm.excisePeriod.exciseStatus === 'Ready to be closed' || _vm.excisePeriod.exciseStatus === 'Changed')) ? _c('el-col', {
	      attrs: {
	        "span": 24
	      }
	    }, [_c('el-alert', {
	      staticClass: "margin-b-10",
	      attrs: {
	        "title": "",
	        "type": "warning",
	        "closable": false,
	        "show-icon": ""
	      }
	    }, [_vm._t("default", [_vm._v("\n                    " + _vm._s(_vm.excisePeriod.exciseStatus === 'Ready to be closed' ? _vm.$t('static.reports.fees.readyToCloseWarning') : _vm.$t('static.reports.fees.changedWarning')) + "\n                  ")])], 2), _vm._v(" "), _c('div', {
	      staticClass: "flex justify-center"
	    }, [_c('el-button', {
	      staticClass: "margin-b-20 text-center",
	      attrs: {
	        "loading": _vm.closeLoading
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.closePeriod($event)
	        }
	      }
	    }, [_vm._v("\n                    " + _vm._s(_vm.$t('static.reports.fees.closeButton')) + " " + _vm._s(_vm.excisePeriod.monthName) + "\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "xs": 24,
	        "sm": 24,
	        "mg": 12,
	        "lg": 12,
	        "xl": 6
	      }
	    }, [_c('fieldset', {
	      staticClass: "margin-b-10"
	    }, [_c('legend', [_vm._v(_vm._s(_vm.$t('static.reports.fees.skatteetaten.title')) + " "), _c('span', {
	      staticClass: "warning"
	    }, [_vm._v("(" + _vm._s(_vm.$t('static.reports.fees.skatteetaten.due_info')) + ")")])]), _vm._v(" "), (exciseReport.entries.length) ? [_vm._l((exciseReport.entries), function(item) {
	      return [_c('div', {
	        staticClass: "margin-b-10"
	      }, [_c('label', {}, [_vm._v("\n                          " + _vm._s(item['group']) + " (" + _vm._s(item['description']) + "):\n                        ")]), _vm._v(" "), _c('span', {
	        staticClass: "label-content label-content--small"
	      }, [_vm._v("\n                          " + _vm._s(item['totalVolume']) + "\n                          " + _vm._s(item['unitType']) + "\n                        ")])])]
	    }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-col', [(exciseReport.period && (_vm.excisePeriod.exciseStatus === 'Closed' || _vm.excisePeriod.exciseStatus ===
	      'Changed')) ? _c('el-button', {
	      staticClass: "small dark-outline",
	      on: {
	        "click": function($event) {
	          return _vm.downloadExciseReport(exciseReport.period)
	        }
	      }
	    }, [_vm._v("\n                        " + _vm._s(_vm.$t('static.reports.fees.export')) + "\n                      ")]) : _vm._e(), _vm._v(" "), (exciseReport.period && (_vm.excisePeriod.exciseStatus === 'Closed' || _vm.excisePeriod.exciseStatus ===
	      'Changed')) ? _c('el-button', {
	      staticClass: "small dark-outline",
	      staticStyle: {
	        "color": "#F56C6C",
	        "font-weight": "bold"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.downloadExciseReport(exciseReport.period, 'csv')
	        }
	      }
	    }, [_vm._v("\n                        BETA! " + _vm._s(_vm.$t('static.reports.fees.exportCsv')) + "\n                      ")]) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (!exciseReport.entries.length) ? _c('el-alert', {
	      attrs: {
	        "title": _vm.$t('static.reports.noData'),
	        "type": "warning",
	        "closable": false
	      }
	    }) : _vm._e()], 2)]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "xs": 24,
	        "sm": 24,
	        "mg": 12,
	        "lg": 12,
	        "xl": 6
	      }
	    }, [_c('fieldset', {
	      staticClass: "margin-b-10"
	    }, [_c('legend', [_vm._v(_vm._s(_vm.$t('static.reports.fees.helsedir.title')) + " "), _c('span', {
	      staticClass: "warning"
	    }, [_vm._v("(" + _vm._s(_vm.$t('static.reports.fees.helsedir.due_info')) + ")")])]), _vm._v(" "), [(!_vm.getHelsedirReportByPeriod(exciseReport.period)) ? _c('el-alert', {
	      attrs: {
	        "title": _vm.$t('static.reports.noData'),
	        "type": "warning",
	        "closable": false
	      }
	    }) : [_c('div', {
	      staticClass: "margin-b-10"
	    }, [_c('label', {}, [_vm._v("\n                          Gruppe 1 (2,6% - 4,7%):\n                        ")]), _vm._v(" "), _c('span', {
	      staticClass: "label-content label-content--small"
	    }, [_vm._v("\n                          " + _vm._s(parseFloat(_vm.getHelsedirReportByPeriod(exciseReport.period).group_1.liters).toFixed(2)) + " liter\n                        ")])]), _vm._v(" "), _c('div', {
	      staticClass: "margin-b-10"
	    }, [_c('label', {}, [_vm._v("\n                          Gruppe 2 (4,8% - 21,9%):\n                        ")]), _vm._v(" "), _c('span', {
	      staticClass: "label-content label-content--small"
	    }, [_vm._v("\n                          " + _vm._s(parseFloat(_vm.getHelsedirReportByPeriod(exciseReport.period).group_2.liters).toFixed(2)) + " liter\n                        ")])]), _vm._v(" "), _c('div', {
	      staticClass: "margin-b-10"
	    }, [_c('label', {}, [_vm._v("\n                          Gruppe 3 (22% - 60%):\n                        ")]), _vm._v(" "), _c('span', {
	      staticClass: "label-content label-content--small"
	    }, [_vm._v("\n                          " + _vm._s(parseFloat(_vm.getHelsedirReportByPeriod(exciseReport.period).group_3.liters).toFixed(2)) + " liter\n                        ")])])]]], 2)]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "xs": 24,
	        "sm": 24,
	        "mg": 12,
	        "lg": 12,
	        "xl": 6
	      }
	    }, [_c('fieldset', {
	      staticClass: "margin-b-10"
	    }, [_c('legend', [_vm._v(_vm._s(_vm.$t('static.reports.fees.brod.title')) + " "), _c('span', {
	      staticClass: "warning"
	    }, [_vm._v("(" + _vm._s(_vm.$t('static.reports.fees.brod.due_info')) + ")")])]), _vm._v(" "), _c('div', {
	      staticClass: "margin-b-10"
	    }, [(!exciseReport.entries.length) ? _c('el-alert', {
	      attrs: {
	        "title": _vm.$t('static.reports.noData'),
	        "type": "warning",
	        "closable": false
	      }
	    }) : _vm._e(), _vm._v(" "), (exciseReport.period && (_vm.excisePeriod.exciseStatus === 'Closed' || _vm.excisePeriod.exciseStatus === 'Changed')) ? _c('el-button', {
	      staticClass: "small dark-outline",
	      on: {
	        "click": function($event) {
	          return _vm.downloadBrodReport(exciseReport.period)
	        }
	      }
	    }, [_vm._v("\n                      " + _vm._s(_vm.$t('static.reports.brod.export')) + "\n                    ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "xs": 24,
	        "sm": 24,
	        "mg": 12,
	        "lg": 12,
	        "xl": 6
	      }
	    }, [_c('fieldset', {
	      staticClass: "margin-b-10"
	    }, [_c('legend', [_vm._v(_vm._s(_vm.$t('static.reports.fees.infinitum.title')) + " "), _c('span', {
	      staticClass: "warning"
	    }, [_vm._v("(" + _vm._s(_vm.$t('static.reports.fees.infinitum.due_info')) + ")")])]), _vm._v(" "), _c('div', {
	      staticClass: "margin-b-10"
	    }, [(!_vm.getInfinitumReportByPeriod(exciseReport.period)) ? _c('el-alert', {
	      attrs: {
	        "title": _vm.$t('static.reports.noData'),
	        "type": "warning",
	        "closable": false
	      }
	    }) : _vm._l((_vm.getInfinitumReportByPeriod(exciseReport.period)), function(item) {
	      return _c('div', {
	        staticClass: "margin-b-10"
	      }, [_c('label', {}, [_vm._v("\n                          " + _vm._s(item.product_name) + ":\n                        ")]), _vm._v(" "), _c('span', {
	        staticClass: "label-content label-content--small"
	      }, [_vm._v("\n                          " + _vm._s(item.qty) + "\n                        ")])])
	    })], 2)])])], 1)], 2)
	  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.reports.exciseEntryLabel'),
	      "name": "2"
	    }
	  }, [(_vm.exciseEntryDate !== null) ? _c('v-excise-entry', {
	    attrs: {
	      "exciseDate": _vm.exciseEntryDate
	    }
	  }) : _vm._e()], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3080 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-user-circle",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.members.title')))]), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    on: {
	      "tab-click": _vm.navigateTab
	    },
	    model: {
	      value: (_vm.current_tab),
	      callback: function($$v) {
	        _vm.current_tab = $$v
	      },
	      expression: "current_tab"
	    }
	  }, [_c('el-tab-pane', {
	    staticStyle: {
	      "margin-top": "-20px"
	    },
	    attrs: {
	      "label": _vm.$t('static.members.index.tab.members'),
	      "name": "members"
	    }
	  }, [(_vm.membersLoading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', [_c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": _vm.addMember
	    }
	  }, [_vm._v("+ " + _vm._s(_vm.$t('static.members.index.addMember')))]), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%",
	      "margin-top": "10px"
	    },
	    attrs: {
	      "stripe": "",
	      "data": _vm.organization_members
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "color",
	      "width": "40"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticClass: "member_color",
	          style: ('background-color:' + scope.row.color)
	        })]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "user.first_name",
	      "label": _vm.$t('static.members.index.table.members.firstName'),
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "user.last_name",
	      "label": _vm.$t('static.members.index.table.members.lastName'),
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "user.email",
	      "label": _vm.$t('static.members.index.table.members.email'),
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "color",
	      "label": _vm.$t('static.members.index.table.members.title'),
	      "width": "180"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v("\n\t\t\t\t\t        \t" + _vm._s(scope.row.title) + "\n\t\t\t\t\t        ")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "is_accepted",
	      "label": _vm.$t('static.members.index.table.members.status'),
	      "width": "180"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-tag', {
	          attrs: {
	            "type": (_vm.acceptStatus(scope.row) == 'ACTIVE') ? 'success' : 'info'
	          }
	        }, [_vm._v("\n\t\t\t\t\t\t  \t\t\t" + _vm._s(_vm.acceptStatus(scope.row)) + "\n\t\t\t\t\t\t  \t\t")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "align": "right"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('router-link', {
	          staticClass: "el-button small el-button--default",
	          staticStyle: {
	            "color": "#fff"
	          },
	          attrs: {
	            "to": '/members/' + scope.row.id.toString()
	          }
	        }, [_c('i', {
	          staticClass: "fa fa-eye"
	        }), _vm._v("  " + _vm._s(_vm.$t('static.members.index.table.members.view')) + "\n\t\t\t\t\t        ")])]
	      }
	    }])
	  })], 1)], 1)]), _vm._v(" "), _c('el-tab-pane', {
	    staticStyle: {
	      "margin-top": "-20px"
	    },
	    attrs: {
	      "label": _vm.$t('static.members.index.tab.calendarSchedule'),
	      "name": "calendar_schedule"
	    }
	  }, [(_vm.calendarLoading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', [_c('el-select', {
	    staticStyle: {
	      "margin-bottom": "10px"
	    },
	    model: {
	      value: (_vm.calendar_data_type),
	      callback: function($$v) {
	        _vm.calendar_data_type = $$v
	      },
	      expression: "calendar_data_type"
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": _vm.$t('static.members.index.options.businessHours'),
	      "value": "businesshours"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": _vm.$t('static.members.index.options.booking'),
	      "value": "bookings"
	    }
	  })], 1), _vm._v(" "), _c('FullCalendar', {
	    ref: "fullCalendar",
	    class: _vm.calendar_data_type == 'bookings' ? 'fc-event-clickable' : '',
	    attrs: {
	      "customButtons": _vm.customButtons,
	      "header": _vm.header,
	      "minTime": _vm.min_time,
	      "slotDuration": _vm.timeslot_gap,
	      "selectable": _vm.calendar_data_type == 'bookings',
	      "selectAllow": _vm.selectAllow,
	      "defaultView": _vm.default_view,
	      "events": _vm.events,
	      "allDaySlot": false,
	      "height": "auto",
	      "slotEventOverlap": false,
	      "eventRender": _vm.showToolTip,
	      "plugins": _vm.calendarPlugins,
	      "buttonText": {
	        today: _vm.$t('static.members.index.calendar.today')
	      },
	      "firstDay": 1,
	      "locale": "nb",
	      "datesRender": _vm.updateBookingEvents
	    },
	    on: {
	      "dateClick": _vm.handleSlotClick,
	      "eventClick": _vm.handleEventClick
	    }
	  })], 1)])], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3081 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.module.ehf.intro')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.module.ehf.terms')))]), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.module",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.subscribe
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.subscribe').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3082 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('static.clients.catalogues.sendCatalogue')))]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [(_vm.loading) ? _c('p', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })]) : _c('el-col', {
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "save": _vm.save,
	      "form": _vm.form,
	      "translation": "form.catalogues"
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3083 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, _vm._l((_vm.packages.all), function(package, index) {
	    return (package.packingLevel == 2 || package.packingLevel == 3) ? _c('el-row', [_c('el-col', {
	      attrs: {
	        "span": 24
	      }
	    }, [_c('el-card', {
	      staticClass: "box-card package-card"
	    }, [_c('div', {
	      staticClass: "clearfix card-header",
	      attrs: {
	        "slot": "header"
	      },
	      slot: "header"
	    }, [_c('span', {
	      staticClass: "card-header-text"
	    }, [_c('i', {
	      staticClass: "el-icon-goods"
	    }), _vm._v(" " + _vm._s(package.packingLevel == 2 ? 'Pallet' : 'Box') + " # " + _vm._s(index) + " - " + _vm._s(package.sscc) + " ")]), _vm._v(" "), _c('el-select', {
	      staticStyle: {
	        "width": "140px"
	      },
	      attrs: {
	        "placeholder": "Select"
	      },
	      model: {
	        value: (_vm.selectedPaperSize),
	        callback: function($$v) {
	          _vm.selectedPaperSize = $$v
	        },
	        expression: "selectedPaperSize"
	      }
	    }, _vm._l((_vm.paperSizes), function(item) {
	      return _c('el-option', {
	        key: item.value,
	        attrs: {
	          "label": item.name,
	          "value": item.value
	        }
	      })
	    }), 1), _vm._v(" "), _c('el-button', {
	      staticClass: "small",
	      staticStyle: {
	        "margin": "3px 0px"
	      },
	      attrs: {
	        "type": "text",
	        "size": "small"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.viewPackageBarcode(package.id)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-file-pdf-o"
	    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.package.viewShippingLabel')))]), _vm._v(" "), _c('el-button', {
	      staticClass: "small",
	      staticStyle: {
	        "margin": "3px 0px"
	      },
	      attrs: {
	        "type": "text",
	        "size": "small"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.viewMixPalletPackageBarcode(package.id)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-file-pdf-o"
	    }), _vm._v(" " + _vm._s(_vm.$t('static.orders.package.viewProductMixLabel')))]), _vm._v(" "), _c('el-button', {
	      staticStyle: {
	        "margin": "5px 5px",
	        "float": "right",
	        "padding": "4px 12px",
	        "background": "#1bbc9b",
	        "color": "#FFF",
	        "border": "0"
	      },
	      attrs: {
	        "type": "text"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.activateAddProductToPackageModal(package.id)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('static.orders.package.addProduct')))]), _vm._v(" "), _c('el-button', {
	      staticStyle: {
	        "margin": "5px 5px",
	        "float": "right",
	        "padding": "4px 12px",
	        "background": "#1bbc9b",
	        "color": "#FFF",
	        "border": "0"
	      },
	      attrs: {
	        "type": "text"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.activateEditPacakge(package)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('static.orders.package.editPackage')))]), _vm._v(" "), _c('el-button', {
	      staticStyle: {
	        "margin": "5px 5px",
	        "float": "right",
	        "padding": "4px 12px",
	        "background": "#ff6c5f",
	        "color": "#FFF",
	        "border": "0"
	      },
	      attrs: {
	        "type": "text"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.confirmDeletePackage(package.id)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('static.orders.package.deletePackage')))])], 1), _vm._v(" "), _c('div', [_c('el-row', {
	      attrs: {
	        "gutter": 35
	      }
	    }, [_c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.createdPackage.sscc')) + ": " + _vm._s(package.sscc) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.createdPackage.unitType')) + ": " + _vm._s(package.packageUnitTypeNoCode) + " ")])]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.createdPackage.numberOfProducts')) + ": " + _vm._s(package.numberOfProducts) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.createdPackage.totalQuantity')) + ": " + _vm._s(package.totalQuantity) + " ")])]), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 8
	      }
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.createdPackage.totalNetWeight')) + ": " + _vm._s(package.totalNetWeight) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.createdPackage.totalGrossWeight')) + ": " + _vm._s(package.totalGrossWeight) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.createdPackage.totalStackWeight')) + ": " + _vm._s(package.totalStackWeight) + " ")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Products: ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
	      attrs: {
	        "span": 24
	      }
	    }, [_c('el-table', {
	      staticStyle: {
	        "width": "100%"
	      },
	      attrs: {
	        "data": _vm.getPackageOrderProductById(package.id),
	        "cell-class-name": "package-cell"
	      }
	    }, [_c('el-table-column', {
	      attrs: {
	        "prop": "gtin",
	        "label": _vm.$t('static.orders.package.createdPackage.table.gtin'),
	        "width": "180"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "productName",
	        "label": _vm.$t('static.orders.package.createdPackage.table.productName'),
	        "width": "180"
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "quantityText",
	        "label": _vm.$t('static.orders.package.createdPackage.table.quantity')
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "weights",
	        "label": _vm.$t('static.orders.package.createdPackage.table.weight')
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "bestBefore",
	        "label": _vm.$t('static.orders.package.createdPackage.table.bestBefore')
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "maxTopLoad",
	        "label": _vm.$t('static.orders.package.createdPackage.table.maxTopLoad')
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "batchLotNumber",
	        "label": _vm.$t('static.orders.package.createdPackage.table.lotBatchNumber')
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "prop": "temperatureText",
	        "label": _vm.$t('static.orders.package.createdPackage.table.temperatureRequirement')
	      }
	    }), _vm._v(" "), _c('el-table-column', {
	      attrs: {
	        "label": " ",
	        "align": "center"
	      },
	      scopedSlots: _vm._u([{
	        key: "default",
	        fn: function(scope) {
	          return [_c('el-button', {
	            staticClass: "small",
	            staticStyle: {
	              "margin": "3px 0px"
	            },
	            attrs: {
	              "type": "text",
	              "size": "small"
	            },
	            on: {
	              "click": function($event) {
	                _vm.viewProductBarcode(_vm.getPackageOrderProductById(package.id)[scope.$index])
	              }
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-file-pdf-o"
	          })]), _vm._v(" "), _c('el-button', {
	            staticClass: "small",
	            staticStyle: {
	              "margin": "3px 0px"
	            },
	            attrs: {
	              "type": "text",
	              "size": "small"
	            },
	            on: {
	              "click": function($event) {
	                _vm.editpackageOrderProduct(_vm.getPackageOrderProductById(package.id)[scope.$index])
	              }
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-edit"
	          })]), _vm._v(" "), _c('el-button', {
	            staticClass: "small danger",
	            staticStyle: {
	              "margin": "3px 0px"
	            },
	            attrs: {
	              "type": "text",
	              "size": "small"
	            },
	            on: {
	              "click": function($event) {
	                _vm.confirmToRemovePackage(_vm.getPackageOrderProductById(package.id)[scope.$index])
	              }
	            }
	          }, [_c('i', {
	            staticClass: "fa fa-times"
	          })])]
	        }
	      }], null, true)
	    })], 1)], 1)], 1)], 1)])], 1)], 1) : _vm._e()
	  }), 1)
	},staticRenderFns: []}

/***/ }),
/* 3084 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3085 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content home-wrapper"
	  }, [_c('div', {
	    staticClass: "content-inner"
	  }, [_vm._m(0), _vm._v(" "), _c('small', {
	    staticClass: "subtitle"
	  }, [_vm._v("\n      " + _vm._s(_vm.$t("static.home.welcomeMsg")) + "\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "buttons homebuttons centered"
	  }, [_c('router-link', {
	    staticClass: "buttons_login",
	    attrs: {
	      "to": {
	        name: 'auth.login'
	      }
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "color": "black"
	    },
	    attrs: {
	      "type": "primary"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.enter')))])], 1), _c('br'), _c('br')], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', {
	    staticClass: "title"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(181)
	    }
	  })])
	}]}

/***/ }),
/* 3086 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [(_vm.isSharedToYou) ? _c('div', [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('h2', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.sharedWarehouse.notAllowed')))])])], 1) : _c('div', [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.draft.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.stock.basicInformation'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.stock",
	      "hasLabel": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('v-products-table', {
	    attrs: {
	      "fields": _vm.fields,
	      "translation": "table.stock.products",
	      "page": "stock"
	    }
	  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.stock.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.updateDraft
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.saveDraft').toUpperCase()))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.stockCount.completeStockCount').toUpperCase()))]), _vm._v(" "), _c('el-button', {
	    staticClass: "danger",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.deleteDraft
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.delete').toUpperCase()))])], 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3087 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 12
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.supplier.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('fieldset', {
	    staticClass: "margin-b-10"
	  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.supplier.basicInformation')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.supplier",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('fieldset', {
	    staticClass: "margin-b-10"
	  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.supplier.contactInformation')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formContactInformation,
	      "translation": "form.supplier",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('fieldset', {
	    staticClass: "margin-b-10"
	  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.supplier.AddressInformation')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formAddressInformation,
	      "translation": "form.supplier",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('el-button', {
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 3088 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.module.vmp.intro')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('static.module.vmp.step1')) + " "), _c('a', {
	    attrs: {
	      "href": "https://api.vinmonopolet.no/blog/authorization-management",
	      "target": "_blank"
	    }
	  }, [_c('b', [_vm._v("https://api.vinmonopolet.no/blog/authorization-management")])]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm.$t('static.module.vmp.step2')) + " "), _c('b', [_vm._v("api@kundan.no")])]), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.module",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.authorize
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.subscribe').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3089 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.editPackage')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.orders.package.editPackage')))]), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.addEditPackage",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3090 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.products.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": _vm.tabIndex
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.products.formTabs.productInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.products",
	      "hasLabel": true
	    }
	  }), _vm._v(" "), (_vm.form.productTypeId && _vm.productTypeName !== 'Child') ? _c('v-form', {
	    attrs: {
	      "form": _vm.productInfoForm,
	      "translation": "form.products",
	      "hasLabel": true
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.productTypeName === 'Child') ? _c('v-form', {
	    attrs: {
	      "form": _vm.childProductForm,
	      "translation": "form.products",
	      "hasLabel": true
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.productTypeName === 'Child') ? _c('el-button', {
	    staticClass: "margin-b-20",
	    staticStyle: {
	      "margin-left": "180px"
	    },
	    attrs: {
	      "loading": _vm.loading,
	      "disabled": this.form.errors.any()
	    },
	    on: {
	      "click": _vm.createChildProduct
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.next').toUpperCase()))]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'products.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 3091 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.productPackagings.edit.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.productPackagings.formTabs.packagingInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.productPackagings",
	      "hasLabel": true
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "form": _vm.inheritFieldsform,
	      "translation": "form.products",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productPackagings.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), (_vm.productsCount == 0) ? _c('el-button', {
	    staticClass: "outline danger",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.destroy
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.delete').toUpperCase()))]) : _vm._e(), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3092 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "full-w flex-column timeline-container"
	  }, [_vm._l((_vm.points), function(p) {
	    return _c('div', {
	      staticClass: "point-container"
	    }, [_c('div', {
	      staticClass: "full-w flex point-header space-between"
	    }, [_c('div', {
	      staticClass: "flex point-date"
	    }, [_c('span', {
	      staticClass: "point-day flex justify-center",
	      class: {
	        'weekend': _vm.isWeekend(p.date)
	      }
	    }, [_vm._v(_vm._s(p.day))]), _vm._v(" "), _c('span', {
	      staticClass: "point-month"
	    }, [_vm._v(_vm._s(p.month))])]), _vm._v(" "), _c('a', {
	      staticClass: "point-add",
	      on: {
	        "click": function($event) {
	          return _vm.create(p.date)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('button.add')))])]), _vm._v(" "), _c('div', {
	      staticClass: "flex-column start point-content"
	    }, [_vm._l((_vm.getDayOrders(p.date)), function(o) {
	      return _c('v-appointment-card', {
	        staticClass: "full-w",
	        attrs: {
	          "appointment": o,
	          "edit": _vm.onEdit(p.date)
	        }
	      })
	    }), _vm._v(" "), (_vm.getDayOrders(p.date).length === 0) ? _c('span', {
	      staticStyle: {
	        "padding": "1rem"
	      }
	    }, [_vm._v(_vm._s(_vm.$t('static.appointments.index.nothingScheduled')))]) : _vm._e()], 2)])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "trace"
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 3093 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.bills.exportBill.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.bills.exportBill.title')))]), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "static.bills.exportBill",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal(_vm.dashboard)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3094 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle pageTitle--light"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.recipes.create.title')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.recipes.formTabs.recipeInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.recipes",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'production.recipes.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.store($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3095 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "flex space-between top-header"
	  }, [_c('div', {
	    staticClass: "header__left-menu"
	  }, [_c('a', {
	    staticClass: "flex hide-desktop",
	    on: {
	      "click": function($event) {
	        return _vm.toggleSidebar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bars",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "flex justify-end stretch top-menu"
	  }, [(_vm.hasModule('Appointment')) ? _c('router-link', {
	    staticClass: "top-menu_item flex",
	    attrs: {
	      "to": "/members?tab=calendar&data=bookings"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-calendar",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('el-switch', {
	    attrs: {
	      "on-color": "#13ce66",
	      "off-color": "#ff4949"
	    },
	    on: {
	      "change": _vm.toggleDebugMode
	    },
	    model: {
	      value: (_vm.debugMode),
	      callback: function($$v) {
	        _vm.debugMode = $$v
	      },
	      expression: "debugMode"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-dropdown', {
	    staticClass: "top-menu_item flex",
	    attrs: {
	      "hide-on-click": true,
	      "trigger": "click"
	    }
	  }, [_c('span', {
	    staticClass: "el-dropdown-link"
	  }, [_c('span', {
	    staticClass: "user-avatar"
	  }, [(_vm.avatar) ? _c('img', {
	    attrs: {
	      "alt": "",
	      "src": _vm.avatar
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.avatar) ? _c('img', {
	    attrs: {
	      "alt": "",
	      "src": __webpack_require__(2650)
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('span', {
	    staticClass: "user-name"
	  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('i', {
	    staticClass: "el-icon-arrow-down"
	  })]), _vm._v(" "), _c('el-dropdown-menu', {
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, [_c('el-dropdown-item', [_c('router-link', {
	    staticClass: "top-menu_item flex",
	    attrs: {
	      "to": {
	        name: 'profile.account'
	      }
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-cog",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" \n            " + _vm._s(_vm.$t('layouts.sidebar.settings')) + "\n          ")])], 1), _vm._v(" "), _c('el-dropdown-item', [_c('router-link', {
	    staticClass: "top-menu_item flex",
	    attrs: {
	      "to": {
	        name: 'modules.index'
	      }
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-cog",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" \n            " + _vm._s(_vm.$t('layouts.sidebar.modules')) + "\n          ")])], 1), _vm._v(" "), _vm._l((_vm.organizations), function(organization) {
	    return _c('el-dropdown-item', [_c('a', {
	      staticClass: "top-menu_item flex",
	      attrs: {
	        "size": "small"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.switchOrganization($event)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "fa fa-exchange"
	    }), _vm._v("  " + _vm._s(_vm.$t('layouts.sidebar.switchToOrganization')) + " " + _vm._s(organization.name))])])
	  }), _vm._v(" "), _c('el-dropdown-item', [_c('a', {
	    staticClass: "top-menu_item flex",
	    attrs: {
	      "size": "small"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.logout($event)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-sign-out"
	  }), _vm._v("  " + _vm._s(_vm.$t('layouts.sidebar.logout')))])])], 2)], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3096 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-layout', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3097 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.bills.formTabs.invoiceInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.bills",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex wrap justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'bills.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": function($event) {
	        return _vm.save('Draft')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.saveDraft').toUpperCase()))]), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": function($event) {
	        return _vm.save('Pending')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.createInvoice').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 3098 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3099 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('fieldset', {
	    staticClass: "margin-b-10"
	  }, [_c('legend', [_vm._v("PowerOffice Credentials")]), _vm._v(" "), _c('el-form', {
	    attrs: {
	      "label-position": "top"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Client Key"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Enter Client Key"
	    },
	    model: {
	      value: (_vm.form.fields.poweroffice_client_key.value),
	      callback: function($$v) {
	        _vm.$set(_vm.form.fields.poweroffice_client_key, "value", $$v)
	      },
	      expression: "form.fields.poweroffice_client_key.value"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Company Slug"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Enter Company Slug"
	    },
	    model: {
	      value: (_vm.form.fields.poweroffice_company_slug.value),
	      callback: function($$v) {
	        _vm.$set(_vm.form.fields.poweroffice_company_slug, "value", $$v)
	      },
	      expression: "form.fields.poweroffice_company_slug.value"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Integration Type"
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "placeholder": "Select Integration Type"
	    },
	    model: {
	      value: (_vm.form.fields.poweroffice_integration_type.value),
	      callback: function($$v) {
	        _vm.$set(_vm.form.fields.poweroffice_integration_type, "value", $$v)
	      },
	      expression: "form.fields.poweroffice_integration_type.value"
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "Direct",
	      "value": "direct"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Iframe",
	      "value": "iframe"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "margin-t-10"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.loading
	    },
	    on: {
	      "click": _vm.saveSettings
	    }
	  }, [_vm._v("\n        Update Settings\n      ")])], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3100 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.view.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.adjustment.view.details'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.adjustment.view.detailsLegend')))]), _vm._v(" "), [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.info.code')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentAdjustment.code) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.info.warehouse')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'warehouse.edit',
	        params: {
	          id: _vm.currentAdjustment.warehouse.id
	        }
	      }
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentAdjustment.warehouse.name) + "\n                    ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.info.qty')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentAdjustment.total_qty) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.info.status')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.$t(("form.adjustment.adjustmentStatus." + (_vm.currentAdjustment.status)))) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.info.adjustmentType')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.$t(("form.adjustment.adjustmentTypeList." + (_vm.currentAdjustment.adjustmentType)))) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.info.reason')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentAdjustment.reason) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.info.createdAt')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentAdjustment.createdAt) + "\n                  ")])])]], 2)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.adjustment.view.products'),
	      "name": "products"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.adjustment.view.productsLegend')))]), _vm._v(" "), _c('v-table', {
	    attrs: {
	      "list": _vm.productList,
	      "noDataMessage": _vm.$t('static.adjustment.noData'),
	      "translation": "static.adjustment.products"
	    }
	  })], 1)])], 1)], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3101 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3102 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [(_vm.isSharedToYou) ? _c('div', [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('h2', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.sharedWarehouse.notAllowed')))])])], 1) : _c('div', [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.adjustment.basicInformation'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.adjustment",
	      "hasLabel": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('v-products-table', {
	    attrs: {
	      "fields": _vm.fields,
	      "page": "adjustment",
	      "translation": "table.adjustment.products"
	    }
	  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.adjustment.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.saveDraft
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.saveDraft').toUpperCase()))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.adjustment.completeAdjustment').toUpperCase()))]), _vm._v(" "), _c('el-button', {
	    staticClass: "danger",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.deleteDraft
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.delete').toUpperCase()))])], 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3103 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-card', {
	    staticClass: "box-card",
	    class: {
	      'el-card--wide': _vm.wide
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 3104 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isTimeline) ? _c('div', {
	    staticClass: "appointmentsindex-container"
	  }, [_c('div', {
	    staticClass: "full-w flex-column end daterange-container"
	  }, [_c('v-date-range', {
	    attrs: {
	      "name": "dateRange",
	      "value": _vm.dateRange,
	      "disabled": _vm.loading,
	      "translation": "static.reports.sales.dateRange"
	    },
	    on: {
	      "change": _vm.onRangeChange
	    }
	  })], 1), _vm._v(" "), _c('v-timeline', {
	    attrs: {
	      "dateRange": _vm.dateRange,
	      "list": _vm.ordersList,
	      "direction": _vm.timelineDirection,
	      "create": _vm.onDateAdd,
	      "edit": _vm.onDateEdit
	    }
	  })], 1) : _c('div', [(!_vm.loading) ? [_c('v-date-bar', {
	    attrs: {
	      "day": _vm.calendarDay,
	      "changeDay": _vm.changeCalendarDay,
	      "displayWeekends": _vm.displayWeekends,
	      "toggleWeekends": _vm.toggleWeekends
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "calendar--weekdays-bar full-w flex"
	  }, _vm._l((_vm.weekdays), function(w) {
	    return _c('span', {
	      staticClass: "calendar--weekdays-bar--item flex justify-center"
	    }, [_vm._v(_vm._s(w))])
	  }), 0), _vm._v(" "), _c('v-calendar', {
	    attrs: {
	      "startTime": "7:00",
	      "create": _vm.onDateAdd,
	      "list": _vm.ordersList,
	      "exceptions": _vm.exceptions,
	      "day": _vm.calendarDay,
	      "edit": _vm.onDateEdit,
	      "displayWeekends": _vm.displayWeekends
	    }
	  })] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 3105 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-users",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('layouts.sidebar.reports')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.reports.clients.title'),
	      "name": "clients"
	    }
	  }, [_c('el-row', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 20
	    }
	  }, [_c('el-input', {
	    staticClass: "mr-10 m-auto mb-10",
	    attrs: {
	      "placeholder": _vm.$t('static.reports.clients.clientSearch.placeholder'),
	      "size": "medium",
	      "clearable": ""
	    },
	    model: {
	      value: (_vm.clientSearch),
	      callback: function($$v) {
	        _vm.clientSearch = $$v
	      },
	      expression: "clientSearch"
	    }
	  }), _vm._v(" "), _c('el-select', {
	    staticClass: "mr-10 mb-10",
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select",
	      "size": "medium"
	    },
	    model: {
	      value: (_vm.selectedYear),
	      callback: function($$v) {
	        _vm.selectedYear = $$v
	      },
	      expression: "selectedYear"
	    }
	  }, _vm._l((_vm.yearList), function(item, key) {
	    return _c('el-option', {
	      key: key,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }), 1), _vm._v(" "), _c('el-button', {
	    staticClass: "el-button mr-10 mb-10 small el-button--default",
	    attrs: {
	      "type": "button",
	      "disabled": _vm.disableBulk,
	      "loading": _vm.buttonBulkDownloadLoading
	    },
	    on: {
	      "click": _vm.downloadSelectedClient
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.downloadTurnover')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "el-button ml-0-important mr-10 mb-10 small el-button--default",
	    attrs: {
	      "type": "button",
	      "disabled": _vm.disableBulk,
	      "loading": _vm.buttonBulkSendLoading
	    },
	    on: {
	      "click": _vm.sendSelectedClient
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.emailTurnover')))])], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('el-table', {
	    ref: "multipleTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.clientList
	    },
	    on: {
	      "selection-change": _vm.handleSelectionChange
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "selection",
	      "selectable": _vm.selectable
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "type": "expand"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          staticClass: "btn-group margin-b-10 margin-r-10"
	        }, [_c('button', {
	          staticClass: "btn btn-danger",
	          attrs: {
	            "disabled": "",
	            "type": "button"
	          }
	        }, [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.groupButton')))]), _vm._v(" "), _c('el-button', {
	          staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
	          attrs: {
	            "type": "button",
	            "loading": _vm.buttonLoading[scope.row.id],
	            "data-toggle": "dropdown"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.toggleDropdown(scope.row)
	            }
	          }
	        }, [_c('span', {
	          staticClass: "sr-only"
	        })]), _vm._v(" "), _c('div', {
	          staticClass: "dropdown-menu",
	          class: {
	            show: _vm.dropdownState[scope.row.id]
	          }
	        }, [_c('a', {
	          staticClass: "dropdown-item",
	          attrs: {
	            "role": "button"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.viewTurnoverReport(scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.viewTurnover')))]), _vm._v(" "), _c('a', {
	          staticClass: "dropdown-item",
	          attrs: {
	            "role": "button"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.sendClient(scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(_vm.$t('static.reports.clients.turnover.emailTurnover')))])])], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "id",
	      "label": _vm.$t('table.clientReports.id'),
	      "width": "100",
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "name",
	      "label": _vm.$t('table.clientReports.name'),
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "clientNumber",
	      "label": _vm.$t('table.clientReports.clientNumber'),
	      "width": "100",
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "balance",
	      "label": _vm.$t('table.clientReports.balance'),
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "createdAt",
	      "label": _vm.$t('table.clientReports.createdAt'),
	      "sortable": ""
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.reports.sales.title'),
	      "name": "sales"
	    }
	  }, [_c('el-row', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "sm": 8
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('span', {
	    staticClass: "margin-b-10"
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.sales.dateRange.placeholder')) + ":\n                ")])]), _vm._v(" "), _c('v-date-range', {
	    attrs: {
	      "name": "salesDateRange",
	      "value": _vm.salesDateRange,
	      "disabled": _vm.loadingSales,
	      "translation": "static.reports.sales.dateRange"
	    },
	    on: {
	      "change": _vm.onFilterChange
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 4
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('span', {
	    staticClass: "margin-b-10"
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.sales.group.placeholder')) + ":\n                ")])]), _vm._v(" "), _c('v-select', {
	    attrs: {
	      "name": "salesGrouping",
	      "value": _vm.salesGrouping,
	      "disabled": _vm.loadingSales,
	      "options": _vm.salesGroupingOptions,
	      "translation": "static.reports.sales.group"
	    },
	    on: {
	      "change": _vm.onFilterChange
	    },
	    model: {
	      value: (_vm.salesGrouping),
	      callback: function($$v) {
	        _vm.salesGrouping = $$v
	      },
	      expression: "salesGrouping"
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 4
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('span', {
	    staticClass: "margin-b-10"
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.sales.type.placeholder')) + ":\n                ")])]), _vm._v(" "), _c('v-select', {
	    attrs: {
	      "name": "salesType",
	      "value": _vm.salesType,
	      "disabled": _vm.loadingSales,
	      "options": _vm.salesTypeOptions,
	      "translation": "static.reports.sales.type"
	    },
	    on: {
	      "change": _vm.onFilterChange
	    },
	    model: {
	      value: (_vm.salesType),
	      callback: function($$v) {
	        _vm.salesType = $$v
	      },
	      expression: "salesType"
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 5
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('span', {
	    staticClass: "margin-b-10"
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.sales.filter.placeholder')) + ":\n                ")])]), _vm._v(" "), _c('v-text', {
	    attrs: {
	      "name": "salesFilter",
	      "type": "text",
	      "value": _vm.salesFilter,
	      "disabled": _vm.loadingSales,
	      "translation": "static.reports.sales.filter"
	    },
	    on: {
	      "keydown": _vm.onFilterChangeDebounce
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 2
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('span', {
	    staticClass: "margin-b-10"
	  }, [_vm._v("\n                   \n                ")])]), _vm._v(" "), _c('el-button', {
	    staticClass: "small dark-outline",
	    on: {
	      "click": _vm.downloadSalesReport
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.reports.sales.export')) + "\n              ")])], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 3
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('span', {
	    staticClass: "margin-b-10"
	  }, [_vm._v("\n                   \n                ")])]), _vm._v(" "), _c('el-button', {
	    staticClass: "small dark-outline",
	    on: {
	      "click": _vm.downloadYtdSalesReport
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.reports.sales.exportYtd')) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('v-table', {
	    attrs: {
	      "list": _vm.salesList,
	      "noDataMessage": _vm.$t('static.reports.noData'),
	      "translation": "static.reports.sales"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.reports.aggregatedSales.title'),
	      "name": "aggregatedSales"
	    }
	  }, [_c('el-row', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "sm": 4
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.dateRange.placeholder')) + ":")])]), _vm._v(" "), _c('v-date-range', {
	    staticStyle: {
	      "width": "100%",
	      "height": "36px"
	    },
	    attrs: {
	      "name": "aggSalesDateRange",
	      "value": _vm.aggSalesDateRange,
	      "disabled": _vm.loadingAggSales,
	      "translation": "static.reports.sales.dateRange"
	    },
	    on: {
	      "change": _vm.onAggSalesFilterChange
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 4
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.groupBy.placeholder')) + ":")])]), _vm._v(" "), _c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "multiple": "",
	      "placeholder": _vm.$t('static.reports.aggregatedSales.groupBy.placeholder'),
	      "disabled": _vm.loadingAggSales,
	      "size": "medium"
	    },
	    on: {
	      "change": _vm.showAggSales
	    },
	    model: {
	      value: (_vm.aggSalesGroupBy),
	      callback: function($$v) {
	        _vm.aggSalesGroupBy = $$v
	      },
	      expression: "aggSalesGroupBy"
	    }
	  }, _vm._l((_vm.aggSalesGroupByOptions), function(opt) {
	    return _c('el-option', {
	      key: opt.id,
	      attrs: {
	        "label": opt.name,
	        "value": opt.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 4
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.statuses.label')) + ":")])]), _vm._v(" "), _c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "multiple": "",
	      "clearable": "",
	      "placeholder": _vm.$t('static.reports.aggregatedSales.statuses.placeholder'),
	      "disabled": _vm.loadingAggSales,
	      "size": "medium"
	    },
	    on: {
	      "change": _vm.showAggSales
	    },
	    model: {
	      value: (_vm.aggSalesStatuses),
	      callback: function($$v) {
	        _vm.aggSalesStatuses = $$v
	      },
	      expression: "aggSalesStatuses"
	    }
	  }, _vm._l((_vm.aggSalesStatusOptions), function(opt) {
	    return _c('el-option', {
	      key: opt.id,
	      attrs: {
	        "label": opt.name,
	        "value": opt.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 4
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.sort.placeholder')) + ":")])]), _vm._v(" "), _c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "disabled": _vm.loadingAggSales,
	      "size": "medium"
	    },
	    on: {
	      "change": _vm.showAggSales
	    },
	    model: {
	      value: (_vm.aggSalesSort),
	      callback: function($$v) {
	        _vm.aggSalesSort = $$v
	      },
	      expression: "aggSalesSort"
	    }
	  }, _vm._l((_vm.aggSalesSortOptions), function(opt) {
	    return _c('el-option', {
	      key: opt.id,
	      attrs: {
	        "label": opt.name,
	        "value": opt.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 4
	    }
	  }, [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "align-items": "center",
	      "gap": "10px",
	      "flex-wrap": "wrap"
	    }
	  }, [_c('el-checkbox', {
	    attrs: {
	      "disabled": _vm.loadingAggSales
	    },
	    on: {
	      "change": _vm.showAggSales
	    },
	    model: {
	      value: (_vm.aggSalesIncludeCancelled),
	      callback: function($$v) {
	        _vm.aggSalesIncludeCancelled = $$v
	      },
	      expression: "aggSalesIncludeCancelled"
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.aggregatedSales.includeCancelled')) + "\n                ")]), _vm._v(" "), _c('el-button', {
	    staticClass: "small dark-outline",
	    attrs: {
	      "disabled": _vm.loadingAggSales
	    },
	    on: {
	      "click": _vm.downloadAggSalesReport
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.aggregatedSales.export')) + "\n                ")])], 1)])], 1), _vm._v(" "), _c('el-row', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('span', {
	    staticClass: "margin-r-10"
	  }, [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.metrics.label')) + ":")]), _vm._v(" "), _c('el-checkbox-group', {
	    staticStyle: {
	      "display": "inline-flex",
	      "flex-wrap": "wrap",
	      "gap": "4px 16px"
	    },
	    model: {
	      value: (_vm.aggSalesMetrics),
	      callback: function($$v) {
	        _vm.aggSalesMetrics = $$v
	      },
	      expression: "aggSalesMetrics"
	    }
	  }, _vm._l((_vm.aggSalesMetricOptions), function(opt) {
	    return _c('el-checkbox', {
	      key: opt.id,
	      attrs: {
	        "label": opt.id
	      }
	    }, [_vm._v(_vm._s(opt.name))])
	  }), 1)], 1)], 1), _vm._v(" "), (_vm.aggSalesSummary) ? _c('el-row', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('div', {
	    staticClass: "summary-bar"
	  }, [_c('span', {
	    staticClass: "summary-item"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.summary.totalRevenueNet')) + ":")]), _vm._v(" " + _vm._s(_vm.aggFmtSumCurrency(_vm.aggSalesSummary.total_revenue_net)))]), _vm._v(" "), _c('span', {
	    staticClass: "summary-item"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.summary.totalVolumeliters')) + ":")]), _vm._v(" " + _vm._s(_vm.aggFmtSumVolume(_vm.aggSalesSummary.total_volume_liters)) + " L")]), _vm._v(" "), _c('span', {
	    staticClass: "summary-item"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('static.reports.aggregatedSales.summary.orderCount')) + ":")]), _vm._v(" " + _vm._s(_vm.aggSalesSummary.order_count))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.loadingAggSales) ? _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "min-height": "80px",
	      "background": "transparent"
	    }
	  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingAggSales && _vm.aggSalesData.length === 0) ? _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.reports.noData')))])])], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingAggSales && _vm.aggSalesData.length > 0) ? _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.aggSalesData,
	      "stripe": ""
	    }
	  }, [_vm._l((_vm.aggSalesDynamicColumns), function(col) {
	    return _c('el-table-column', {
	      key: col.key,
	      attrs: {
	        "prop": col.prop,
	        "label": col.label,
	        "min-width": col.minWidth,
	        "sortable": ""
	      }
	    })
	  }), _vm._v(" "), (_vm.aggSalesMetrics.includes('totalRevenueNet')) ? _c('el-table-column', {
	    attrs: {
	      "prop": "totalRevenueNet",
	      "label": _vm.$t('static.reports.aggregatedSales.columns.totalRevenueNet'),
	      "formatter": _vm.aggFmtCurrency,
	      "min-width": "140",
	      "sortable": ""
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.aggSalesMetrics.includes('totalRevenueGross')) ? _c('el-table-column', {
	    attrs: {
	      "prop": "totalRevenueGross",
	      "label": _vm.$t('static.reports.aggregatedSales.columns.totalRevenueGross'),
	      "formatter": _vm.aggFmtCurrency,
	      "min-width": "150",
	      "sortable": ""
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.aggSalesMetrics.includes('totalVolumeLiters')) ? _c('el-table-column', {
	    attrs: {
	      "prop": "totalVolumeLiters",
	      "label": _vm.$t('static.reports.aggregatedSales.columns.totalVolumeLiters'),
	      "formatter": _vm.aggFmtVolume,
	      "min-width": "120",
	      "sortable": ""
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.aggSalesMetrics.includes('orderCount')) ? _c('el-table-column', {
	    attrs: {
	      "prop": "orderCount",
	      "label": _vm.$t('static.reports.aggregatedSales.columns.orderCount'),
	      "formatter": _vm.aggFmtInt,
	      "min-width": "90",
	      "sortable": ""
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.aggSalesMetrics.includes('totalQuantityUnits')) ? _c('el-table-column', {
	    attrs: {
	      "prop": "totalQuantityUnits",
	      "label": _vm.$t('static.reports.aggregatedSales.columns.totalQuantityUnits'),
	      "formatter": _vm.aggFmtQty,
	      "min-width": "80",
	      "sortable": ""
	    }
	  }) : _vm._e()], 2)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.reports.bills.title'),
	      "name": "bills"
	    }
	  }, [_c('el-row', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "sm": 8
	    }
	  }, [_c('v-date-range', {
	    attrs: {
	      "name": "billsDateRange",
	      "value": _vm.billsDateRange,
	      "disabled": _vm.loadingBills,
	      "translation": "static.reports.sales.dateRange"
	    },
	    on: {
	      "change": _vm.onFilterChange
	    }
	  })], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 5
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.billClientId),
	      callback: function($$v) {
	        _vm.billClientId = $$v
	      },
	      expression: "billClientId"
	    }
	  }, [_c('el-option', {
	    key: "",
	    attrs: {
	      "label": _vm.$t('static.reports.bills.allClients'),
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.clientList), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  })], 2)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "sm": 8
	    }
	  }, [_c('el-button', {
	    staticClass: "small dark-outline",
	    on: {
	      "click": _vm.downloadBillReport
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.reports.bills.export')) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('v-table', {
	    attrs: {
	      "list": _vm.billList,
	      "noDataMessage": _vm.$t('static.reports.noData'),
	      "link": _vm.link,
	      "linkKey": "invoiceNumber",
	      "rowKey": "id",
	      "translation": "static.reports.bills"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.reports.warehouse.warehouse'),
	      "name": "warehouse"
	    }
	  }, [_c('el-row', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-radio-group', {
	    model: {
	      value: (_vm.dateOption),
	      callback: function($$v) {
	        _vm.dateOption = $$v
	      },
	      expression: "dateOption"
	    }
	  }, [_c('el-radio', {
	    attrs: {
	      "label": "as_of_date"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.reports.warehouse.as_of_date')))]), _vm._v(" "), _c('el-radio', {
	    attrs: {
	      "label": "date_range"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.reports.warehouse.date_range')))])], 1)], 1), _vm._v(" "), _c('el-row', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 20
	    }
	  }, [(_vm.showDateRange) ? _c('div', [_c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.warehouse),
	      callback: function($$v) {
	        _vm.warehouse = $$v
	      },
	      expression: "warehouse"
	    }
	  }, [_c('el-option', {
	    key: "",
	    attrs: {
	      "label": _vm.$t('static.reports.warehouse.all'),
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.warehouses.items), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  })], 2), _vm._v(" "), _c('el-select', {
	    staticStyle: {
	      "width": "200px"
	    },
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.transaction_type_id),
	      callback: function($$v) {
	        _vm.transaction_type_id = $$v
	      },
	      expression: "transaction_type_id"
	    }
	  }, [_c('el-option', {
	    key: "",
	    attrs: {
	      "label": _vm.$t('static.reports.warehouse.transactionType.all'),
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.transactionTypes), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": ((item.description) + " (" + (item.code) + ")"),
	        "value": item.id
	      }
	    })
	  })], 2), _vm._v(" "), _c('v-date-range', {
	    attrs: {
	      "name": "transactionDateRange",
	      "value": _vm.transactionDateRange,
	      "translation": "static.reports.sales.dateRange"
	    },
	    on: {
	      "change": _vm.onTransactionDateRangeChange
	    }
	  }), _vm._v(" "), _c('el-checkbox', {
	    model: {
	      value: (_vm.groupByProduct),
	      callback: function($$v) {
	        _vm.groupByProduct = $$v
	      },
	      expression: "groupByProduct"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.reports.warehouse.transactionType.groupByProduct')))])], 1) : _vm._e(), _vm._v(" "), (_vm.showAsOfDate) ? _c('div', [_c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.warehouse),
	      callback: function($$v) {
	        _vm.warehouse = $$v
	      },
	      expression: "warehouse"
	    }
	  }, [_c('el-option', {
	    key: "",
	    attrs: {
	      "label": _vm.$t('static.reports.warehouse.all'),
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.warehouses.items), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  })], 2), _vm._v(" "), _c('el-select', {
	    staticStyle: {
	      "width": "200px"
	    },
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.transaction_type_id),
	      callback: function($$v) {
	        _vm.transaction_type_id = $$v
	      },
	      expression: "transaction_type_id"
	    }
	  }, [_c('el-option', {
	    key: "",
	    attrs: {
	      "label": _vm.$t('static.reports.warehouse.transactionType.all'),
	      "value": ""
	    }
	  }), _vm._v(" "), _vm._l((_vm.transactionTypes), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": ((item.description) + " (" + (item.code) + ")"),
	        "value": item.id
	      }
	    })
	  })], 2), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "type": "date",
	      "placeholder": _vm.$t('static.reports.warehouse.pick_date')
	    },
	    model: {
	      value: (_vm.asOfDate),
	      callback: function($$v) {
	        _vm.asOfDate = $$v
	      },
	      expression: "asOfDate"
	    }
	  }), _vm._v(" "), _c('el-checkbox', {
	    model: {
	      value: (_vm.groupByProduct),
	      callback: function($$v) {
	        _vm.groupByProduct = $$v
	      },
	      expression: "groupByProduct"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.reports.warehouse.transactionType.groupByProduct')))]), _vm._v(" "), _c('el-checkbox', {
	    model: {
	      value: (_vm.hideOutOfStock),
	      callback: function($$v) {
	        _vm.hideOutOfStock = $$v
	      },
	      expression: "hideOutOfStock"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.products.hideOutOfStock')))])], 1) : _vm._e()]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 4
	    }
	  }, [_c('div', {
	    staticClass: "flex"
	  }, [_c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.warehouseLoading
	    },
	    on: {
	      "click": _vm.showWarehouses
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.fees.filter')) + "\n                ")]), _vm._v(" "), _c('el-button', {
	    staticClass: "small dark-outline",
	    on: {
	      "click": _vm.downloadWarehousesReport
	    }
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('static.reports.fees.export')) + "\n                ")])], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [(_vm.groupByProduct) ? _c('v-table', {
	    attrs: {
	      "list": _vm.warehouseList,
	      "noDataMessage": _vm.$t('static.reports.noData'),
	      "translation": "table.warehouseReports"
	    }
	  }) : (_vm.transactionListNew) ? _c('v-table', {
	    attrs: {
	      "list": _vm.transactionListNew,
	      "noDataMessage": _vm.$t('static.products.transactions.noDataMsg'),
	      "rowKey": "id,key",
	      "translation": "static.products.transactions.table"
	    }
	  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loadingExcise),
	      expression: "loadingExcise"
	    }],
	    attrs: {
	      "label": _vm.$t('static.reports.exciseEntry.title'),
	      "name": "excise"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.exciseLoading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.exciseLoading),
	      expression: "exciseLoading"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, _vm._l((_vm.excisePeriods.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.viewExciseMonthlyReport(p)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel"
	    }, [_c('span', {
	      staticClass: "cardBadge",
	      class: _vm.exciseStatusClass(p.exciseStatus)
	    }, [_vm._v(_vm._s(_vm.$t(("static.reports.fees.exciseStatus." + (_vm.camalize(p.exciseStatus))))))])]), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(p.monthName))]), _vm._v(" "), _c('hr')])
	  }), 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.excisePeriods.pagination,
	      "switchFunction": _vm.showExcise
	    }
	  })], 1)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": "Grønt Punkt",
	      "name": "greenDot"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [_c('div', {
	    staticClass: "year-select"
	  }, [_c('el-select', {
	    staticClass: "margin-r-10",
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.greenDotSelectedYear),
	      callback: function($$v) {
	        _vm.greenDotSelectedYear = $$v
	      },
	      expression: "greenDotSelectedYear"
	    }
	  }, _vm._l((_vm.yearList), function(item, key) {
	    return _c('el-option', {
	      key: key,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }), 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small dark-outline",
	    on: {
	      "click": _vm.generateGreenDotReport
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.reports.downloadReport')) + "\n              ")]), _vm._v(" "), _c('el-button', {
	    staticClass: "small dark-outline",
	    on: {
	      "click": _vm.generateGreenDotDetailedReport
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.reports.greenDot.detailed.downloadDetailedReport')) + "\n              ")])], 1)])], 1), _vm._v(" "), (_vm.account.stockReportBeta) ? _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.reports.warehouse.warehouse_beta'),
	      "name": "warehouse_beta"
	    }
	  }, [_c('el-row', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 24
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.warehouse),
	      callback: function($$v) {
	        _vm.warehouse = $$v
	      },
	      expression: "warehouse"
	    }
	  }, _vm._l((_vm.warehouses.items), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }), 1), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "type": "month",
	      "placeholder": "Pick a month"
	    },
	    model: {
	      value: (_vm.transactionMonth),
	      callback: function($$v) {
	        _vm.transactionMonth = $$v
	      },
	      expression: "transactionMonth"
	    }
	  }), _vm._v(" "), _c('el-button', {
	    staticClass: "small dark-outline",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.downloadWarehousesReportBeta($event)
	      }
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.reports.fees.export')) + "\n              ")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3106 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.error || _vm.success || _vm.warning || _vm.info) ? _c('div', {
	    class: _vm.customClass
	  }, [_c('br'), _vm._v(" "), _c('el-alert', {
	    attrs: {
	      "title": _vm.error || _vm.success || _vm.warning || _vm.info,
	      "type": _vm.type,
	      "closable": false,
	      "show-icon": true
	    }
	  }), _vm._v(" "), _c('br')], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 3107 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.isGoogle2faEnabled) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.smsTwoFactorVerification.google2faEnabledWarning')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))])], 1) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.smsTwoFactorVerification.title')))]), _vm._v(" "), _c('div', [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "panel panel-default"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [_c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.$t('static.smsTwoFactorVerification.enableWarningMessage'))
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item margin-b-0"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(_vm._s(_vm.$t('static.smsTwoFactorVerification.verifyMobileNUmber')))]), _vm._v(" "), _c('div', {
	    staticClass: "el-input"
	  }, [_c('el-input', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "placeholder": _vm.$t('static.smsTwoFactorVerification.enterMobileNUmber')
	    },
	    model: {
	      value: (_vm.mobileNumber),
	      callback: function($$v) {
	        _vm.mobileNumber = $$v
	      },
	      expression: "mobileNumber"
	    }
	  }, [_c('template', {
	    slot: "prepend"
	  }, [_vm._v("+47")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "box-shadow": "none"
	    },
	    attrs: {
	      "slot": "append",
	      "icon": "el-icon-mobile-phone",
	      "disabled": _vm.twoFactorTimerCount > 0,
	      "loading": _vm.sendLoading
	    },
	    on: {
	      "click": _vm.sendVerificationToken
	    },
	    slot: "append"
	  }, [_vm._v("\n                    " + _vm._s(_vm.verificationSent ? _vm.$t('static.smsTwoFactorVerification.resendCode') : _vm.$t('static.smsTwoFactorVerification.sendCode')) + "\n                    "), (_vm.twoFactorTimerCount > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.twoFactorTimerCount || '') + ")")]) : _vm._e()])], 2)], 1)]), _vm._v(" "), (_vm.verificationSent) ? _c('div', {
	    staticClass: "el-form-item"
	  }, [_c('label', {
	    staticClass: "el-form-item__label"
	  }, [_vm._v(_vm._s(_vm.$t('static.smsTwoFactorVerification.codeVerification')))]), _vm._v(" "), _c('div', {
	    staticClass: "el-input"
	  }, [_c('el-input', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "placeholder": _vm.$t('static.smsTwoFactorVerification.enterToken')
	    },
	    model: {
	      value: (_vm.twoFactorAuthToken),
	      callback: function($$v) {
	        _vm.twoFactorAuthToken = $$v
	      },
	      expression: "twoFactorAuthToken"
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "box-shadow": "none"
	    },
	    attrs: {
	      "slot": "append",
	      "icon": "el-icon-check",
	      "loading": _vm.verifyLoading
	    },
	    on: {
	      "click": _vm.verifyToken
	    },
	    slot: "append"
	  }, [_vm._v("\n                    " + _vm._s(_vm.$t('static.smsTwoFactorVerification.verifyCode')) + "\n                  ")])], 1)], 1)]) : _vm._e()])])])])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3108 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.unitOfMeasure.index.title')) + " (" + _vm._s(_vm.unitOfMeasures.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search
	    },
	    on: {
	      "keydown": _vm.onChange
	    }
	  })], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.unitOfMeasures.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.unitOfMeasure.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'unitOfMeasure.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.unitOfMeasure.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.unitOfMeasures.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      attrs: {
	        "wide": true
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editWarehouse(p)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "full-w flex wrap client-title-container margin-b-10"
	    }, [_c('img', {
	      staticClass: "client-img margin-b-10",
	      attrs: {
	        "src": __webpack_require__(2649),
	        "alt": ("" + (p.name))
	      }
	    }), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(("" + (p.name))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.unitOfMeasure.info.name')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.name || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('static.unitOfMeasure.info.code')) + " ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.code || '-'))])]], 2)
	  })], 2)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "pagination": _vm.unitOfMeasures.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3109 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.addProductToPackageTitle')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.orders.package.addProductToPackageTitle')))]), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.addEditProductToPackage",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3110 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.list.length) ? _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.list,
	      "stripe": "",
	      "default-sort": {
	        prop: 'balance',
	        order: 'descending'
	      }
	    }
	  }, [_vm._l((Object.keys(_vm.list[0])), function(key, index) {
	    return (!_vm.inArray(key, _vm.rowKey)) ? _c('el-table-column', {
	      attrs: {
	        "prop": key,
	        "label": _vm.$t((_vm.translation + "." + key)),
	        "sortable": true,
	        "type": key == _vm.expandableKey ? 'expand' : 'normal'
	      },
	      scopedSlots: _vm._u([{
	        key: "default",
	        fn: function(scope) {
	          return [(key == _vm.expandableKey) ? _c('div', _vm._l((Object.keys(scope.row[key])), function(key2, index2) {
	            return _c('p', _vm._l((_vm.convertToArray(_vm.expandableRows)), function(key3, index3) {
	              return _c('span', [(!_vm.inArray(key3, _vm.linkKey)) ? _c('span', [_vm._v(" " + _vm._s(_vm.$t((_vm.translation + "." + key3))) + ": " + _vm._s(scope.row[key][index2][key3]) + " ")]) : (_vm.link && _vm.inArray(key3, _vm.linkKey)) ? _c('a', {
	                staticStyle: {
	                  "cursor": "pointer"
	                },
	                attrs: {
	                  "type": "text",
	                  "size": "small"
	                },
	                on: {
	                  "click": function($event) {
	                    return _vm.link(scope.row[key][index2], key3)
	                  }
	                }
	              }, [_vm._v("\n              " + _vm._s(_vm.$t((_vm.translation + "." + key3))) + ": " + _vm._s(scope.row[key][index2][key3]) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('span', {
	                staticStyle: {
	                  "margin": "0px 8px"
	                }
	              })])
	            }), 0)
	          }), 0) : (!_vm.inArray(key, _vm.linkKey)) ? _c('p', {
	            domProps: {
	              "innerHTML": _vm._s(_vm.html(scope.row[key]))
	            }
	          }) : (scope.row.id <= 0 || scope.row === null) ? _c('p', [_vm._v(_vm._s(scope.row[key]))]) : (_vm.link && _vm.inArray(key, _vm.linkKey)) ? _c('a', {
	            attrs: {
	              "type": "text",
	              "size": "small"
	            },
	            on: {
	              "click": function($event) {
	                return _vm.link(scope.row, key)
	              }
	            }
	          }, [_vm._v("\n        " + _vm._s(scope.row[key]) + "\n      ")]) : _vm._e()]
	        }
	      }], null, true)
	    }) : _vm._e()
	  }), _vm._v(" "), (_vm.buttons !== undefined) ? _c('el-table-column', {
	    attrs: {
	      "prop": "button",
	      "sortable": false
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return _vm._l((_vm.buttons), function(button) {
	          return _c('button', {
	            class: button.class,
	            on: {
	              "click": function($event) {
	                return button.click(scope)
	              }
	            }
	          }, [_vm._v(" " + _vm._s(button.label))])
	        })
	      }
	    }], null, false, 2913389307)
	  }) : _vm._e()], 2) : _c('el-alert', {
	    attrs: {
	      "title": this.noDataMessage || _vm.$t('table.noData'),
	      "type": "warning"
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 3111 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.index.title')) + " (" + _vm._s(_vm.bills.pagination.totalCount) + ")\n      ")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('el-button-group', [_c('el-button', {
	    attrs: {
	      "type": _vm.primary,
	      "size": "small",
	      "icon": "el-icon-menu",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('info')
	      }
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": _vm.info,
	      "size": "small",
	      "icon": "el-icon-tickets",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('primary')
	      }
	    }
	  })], 1), _vm._v(" "), _c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search,
	      "clearable": true
	    },
	    on: {
	      "keydown": _vm.onChangeSearch
	    }
	  })], 1)])], 1), _vm._v(" "), (_vm.showAction) ? _c('el-row', {
	    staticClass: "bulkActions",
	    attrs: {
	      "gutter": 5
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 8,
	      "lg": 6,
	      "xl": 4
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.selectedCount) + " bills selected")])]), _vm._v(" "), _c('el-col', {
	    staticStyle: {
	      "text-align": "right"
	    },
	    attrs: {
	      "md": 3,
	      "lg": 3,
	      "xl": 2
	    }
	  }, [(_vm.showAction) ? _c('label', [_vm._v(_vm._s(_vm.$t('orderActions.select.label')) + " ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 13,
	      "lg": 15,
	      "xl": 18
	    }
	  }, [_c('button', {
	    staticClass: "el-button el-button--default small",
	    staticStyle: {
	      "margin-bottom": "4px",
	      "margin-left": "10px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onSelectAction('markBilledAsPaid')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('billActions.markBilledAsPaid')) + "\n      ")]), _vm._v(" "), _c('button', {
	    staticClass: "el-button el-button--default small",
	    staticStyle: {
	      "margin-bottom": "4px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.onSelectAction('downloadInvoicePdf')
	      }
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('billActions.downloadInvoicePdf')) + "\n      ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.billsList.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.bill.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'bills.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.bill.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.billsList), function(bill) {
	    return _c('v-card', {
	      key: bill.id,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editBill(bill)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v("\n          " + _vm._s(bill.number) + "\n          "), _c('span', {
	      staticClass: "cardBadge"
	    }, [_vm._v(_vm._s(_vm.$t(("static.bills.edit." + (bill.billType.replace(/\s+/g,
	            '').toLowerCase())))))]), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-external-link pull-right",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.editBillNewTab(bill)
	        }
	      }
	    })]), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(bill.cardTotalGross))]), _vm._v(" "), (bill.billStatus === 'Partly Paid') ? _c('span', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(bill.cardAmountDue) + " (" + _vm._s(_vm.$t('static.bills.index.remainingToPay')) + ")"), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(bill.amount))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('span', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(bill.client))]), _vm._v(" "), (bill.storeName) ? _c('span', {
	      staticClass: "cardContent cardContent--small"
	    }, [_c('br'), _vm._v(_vm._s(bill.storeName))]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "cardinnerBox",
	      class: bill.cardClass
	    }, [_c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-calendar",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(_vm.$t('static.bills.index.invoiceDateFormated')) + ": ")]), _c('span', {
	      staticClass: "cardContent cardContent--small"
	    }, [_vm._v(_vm._s(bill.invoiceDateFormated))])]), _vm._v(" "), _c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-calendar",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(_vm.$t('static.bills.index.dueDateFormated')) + ": ")]), _c('span', {
	      staticClass: "cardContent cardContent--small",
	      class: {
	        'bill-due-overdue': bill.overdue
	      }
	    }, [_vm._v(_vm._s(bill.dueDateFormated)), (bill.overdue) ? [_vm._v(" "), _c('span', {
	      staticClass: "bill-overdue-badge"
	    }, [_vm._v(_vm._s(_vm.$t('static.bills.index.overdueBadge')))])] : _vm._e()], 2)]), _vm._v(" "), _c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-info",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s(_vm.$t('static.bills.index.billStatus')) + ": ")]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent cardContent--small status_",
	      class: bill.billStatus
	    }, [_vm._v(_vm._s(_vm.$t(("static.reports.bills." + (bill.billStatus.replace(/\s+/g, '').toLowerCase())))))])]), _vm._v(" "), (bill.sendVia) ? _c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-info",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" " + _vm._s('Type') + ": ")]), _vm._v(" "), _c('span', {
	      staticClass: "cardContent cardContent--small status_",
	      class: bill.billStatus
	    }, [_vm._v(_vm._s(_vm.$t('static.bills.index.sent')) + " via " + _vm._s(_vm.$t(("static.bills.index." + (bill.sendVia)))))])]) : _vm._e()])])
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('el-table', {
	    ref: "multipleTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.billsListView,
	      "row-class-name": _vm.billRowClassName
	    },
	    on: {
	      "selection-change": _vm.handleSelectionChange
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "selection",
	      "width": "30"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "type": "expand"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [(props.row.billProducts.length) ? _c('ul', _vm._l((props.row.billProducts), function(product) {
	          return _c('li', {
	            key: product.id
	          }, [_c('span', {
	            staticStyle: {
	              "font-family": "'robotobold'"
	            }
	          }, [_vm._v(_vm._s(product.quantity) + " STK")]), _vm._v("\n              —\n              "), _c('span', {
	            staticStyle: {
	              "font-family": "'robotobold'"
	            }
	          }, [_vm._v(_vm._s(product.name))])])
	        }), 0) : _c('span', [_vm._v(_vm._s(_vm.$t('static.orders.index.noProductFound')))])]
	      }
	    }], null, false, 2765092089)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bills.table.name'),
	      "width": "100",
	      "sortable": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('router-link', {
	          attrs: {
	            "to": {
	              name: (scope.row.billType !== 'Credit Note') ? 'bills.edit' : 'bills.creditNote',
	              params: {
	                id: scope.row.id
	              }
	            }
	          }
	        }, [_vm._v(_vm._s(scope.row.name))])]
	      }
	    }], null, false, 3512144603)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "type",
	      "label": _vm.$t('static.bills.table.type'),
	      "width": "100",
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "status",
	      "label": _vm.$t('static.bills.table.status'),
	      "width": "100",
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "client",
	      "label": _vm.$t('static.bills.table.client'),
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "invoiceDate",
	      "label": _vm.$t('static.bills.table.invoiceDate'),
	      "width": "150",
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bills.table.dueDate'),
	      "width": "170",
	      "sortable": "",
	      "prop": "dueDate"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          class: {
	            'bill-due-overdue': scope.row.overdue
	          }
	        }, [_vm._v(_vm._s(scope.row.dueDate))]), _vm._v(" "), (scope.row.overdue) ? _c('span', {
	          staticClass: "bill-overdue-badge"
	        }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.index.overdueBadge')))]) : _vm._e()]
	      }
	    }], null, false, 4160977039)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "totalGross",
	      "label": _vm.$t('static.bills.table.totalGross'),
	      "width": "150",
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "amountDue",
	      "label": _vm.$t('static.bills.table.amountDue'),
	      "width": "150",
	      "sortable": ""
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.bills.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3112 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('div', [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.organizationSettings.bulk_price_update')) + " -  " + _vm._s(_vm.$t('static.organizationSettings.summary')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('form.organizationSettings.percentage.label')) + ": "), _c('b', [_vm._v(_vm._s(_vm.info.percentage))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('form.organizationSettings.enableRounding.label')) + ": "), _c('b', [_vm._v(_vm._s(_vm.info.enableRounding === true ? 'True' : 'False'))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('form.organizationSettings.roundingType.label')) + ": "), _c('b', [_vm._v(_vm._s(_vm.info.enableRounding === true ? _vm.info.roundingType : 'None'))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('form.organizationSettings.priceType.label')) + ": "), _c('b', [_vm._v(_vm._s(_vm.info.priceType))])])])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [_c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.loading
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.run($event)
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.confirm').toUpperCase()))])], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3113 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v("\n          " + _vm._s(_vm.$t('static.module.subscribe.title')) + "\n          "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')))]), _vm._v(" "), (!_vm.settings.hasPowerOfficeToken) ? _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.$t('static.module.poweroffice.intro'))
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.module",
	      "hasLabel": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div')], 1)], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.authorize
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.subscribe').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3114 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.recipes.edit.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.recipes.formTabs.recipeInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.recipes",
	      "hasLabel": true
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.recipes.formTabs.ingrediencesAndProcedures'),
	      "name": "2"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('fieldset', {
	    staticStyle: {
	      "padding-top": "15px"
	    }
	  }, [_c('legend', [_vm._v(" " + _vm._s(_vm.$t('static.recipes.edit.ingrediences')))]), _vm._v(" "), _c('v-form-table', {
	    attrs: {
	      "form": _vm.formIngredience,
	      "list": _vm.ingredienceList,
	      "additionalButtons": _vm.addIngrediencesButton,
	      "update": _vm.updateIngredience,
	      "destroy": _vm.destroyIngredience,
	      "hiddenFields": _vm.hiddenFields,
	      "noResultWarningText": _vm.$t('table.recipeIngrediences.noResult'),
	      "translation": "table.recipeIngrediences"
	    }
	  })], 1)]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 24,
	      "lg": 24
	    }
	  }, [_c('fieldset', {
	    staticStyle: {
	      "padding-top": "15px",
	      "margin-top": "15px"
	    }
	  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.procedures')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small margin-b-10",
	    on: {
	      "click": _vm.addProcedure
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.add')) + "\n              ")]), _vm._v(" "), _vm._l((_vm.procedureList), function(procedure) {
	    return _c('el-card', {
	      key: procedure.id,
	      staticClass: "box-card margin-b-10",
	      staticStyle: {
	        "width": "100%"
	      },
	      attrs: {
	        "shadow": "never"
	      }
	    }, [_c('div', {
	      staticClass: "flex",
	      attrs: {
	        "slot": "header"
	      },
	      slot: "header"
	    }, [_c('span', [(procedure.step) ? _c('b', {
	      staticStyle: {
	        "font-weight": "700"
	      }
	    }, [_vm._v(_vm._s(_vm.$t('static.recipes.edit.step')) + "\n                        " + _vm._s(procedure.step) + " -")]) : _vm._e(), _vm._v("\n                      " + _vm._s(procedure.name) + "\n                    ")]), _vm._v(" "), _c('el-button', {
	      staticStyle: {
	        "margin-left": "auto",
	        "padding": "7px 12px"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.editProcedure(procedure)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('button.edit')))])], 1), _vm._v(" "), (procedure.ingrediences.length) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.ingrediences')) + " ")]) : _vm._e(), _vm._v(" "), _vm._l((procedure.ingrediences), function(ingredience) {
	      return (procedure.ingrediences) ? _c('li', {
	        key: ingredience.id,
	        staticClass: "text item"
	      }, [_c('b', [_vm._v(_vm._s(ingredience.materialName))]), _vm._v(" - " + _vm._s(ingredience.amount) + " " + _vm._s(ingredience.unitMeasure) + "\n                  ")]) : _vm._e()
	    }), _vm._v(" "), (procedure.equipment) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.equipment')))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(_vm._s(procedure.equipment))])], 2)
	  })], 2)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.recipes.formTabs.products'),
	      "name": "3"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form-table', {
	    attrs: {
	      "form": _vm.formProduct,
	      "list": _vm.productList,
	      "additionalButtons": _vm.addProductsButton,
	      "destroy": _vm.destroyProduct,
	      "noResultWarningText": "No products yet.",
	      "translation": "form.recipes"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'production.recipes.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3115 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-view')
	},staticRenderFns: []}

/***/ }),
/* 3116 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "marketplace-wrapper"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.products",
	      "hasLabel": true
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3117 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('gmap-map', {
	    ref: "map",
	    staticClass: "map-container",
	    attrs: {
	      "center": {
	        lat: _vm.currentLocation.lat,
	        lng: _vm.currentLocation.lng
	      },
	      "zoom": 12
	    }
	  }, [_c('gmap-marker', {
	    attrs: {
	      "position": {
	        lat: _vm.currentLocation.lat,
	        lng: _vm.currentLocation.lng
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 3118 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('div', {
	    staticClass: "content login-wrapper"
	  }, [_c('div', {
	    staticClass: "content-inner loginBox"
	  }, [_c('div', {
	    staticClass: "flex-column full-w centered"
	  }, [_c('div', {
	    staticClass: "min-width-300 max-width-300"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(181),
	      "width": "150px"
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v("\n                " + _vm._s(_vm.isSms ? _vm.$t('static.smsTwoFactorVerification.title') : _vm.$t('static.googleTwoFactorVerification.title')) + "\n              ")]), _vm._v(" "), (_vm.isSms) ? _c('span', {
	    staticClass: "display-block mobile-number-message"
	  }, [_vm._v(_vm._s(_vm.$t('static.smsTwoFactorVerification.verificationCodeSent')) + ": "), _c('b', [_vm._v(_vm._s(_vm.mobileNumber))])]) : _vm._e(), _vm._v(" "), _c('v-form', {
	    attrs: {
	      "btn-text": "button.login",
	      "form": _vm.form,
	      "translation": "form.twoFactorVerification"
	    }
	  }), _vm._v(" "), (_vm.isSms) ? _c('el-button', {
	    staticClass: "dark",
	    staticStyle: {
	      "padding": "15px 20px"
	    },
	    attrs: {
	      "loading": _vm.resendLoading,
	      "disabled": _vm.twoFactorTimerCount > 0
	    },
	    on: {
	      "click": _vm.resend
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('form.twoFactorVerification.resendButton.label')) + " "), (_vm.twoFactorTimerCount) ? _c('span', [_vm._v("(" + _vm._s(_vm.twoFactorTimerCount || '') + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.verify
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('form.twoFactorVerification.verifyButton.label')) + "\n              ")])], 1)])])])])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3119 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (!_vm.ready),
	      expression: "!ready"
	    }],
	    staticClass: "product-lines-loading-wrap",
	    staticStyle: {
	      "width": "100%",
	      "min-height": "220px",
	      "position": "relative"
	    },
	    attrs: {
	      "element-loading-text": _vm.$t('static.loadingProductLines')
	    }
	  }, [(_vm.ready) ? _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('v-form-table', {
	    attrs: {
	      "form": _vm.form,
	      "list": _vm.creditProductsList,
	      "additionalButtons": _vm.additionalButtons,
	      "update": _vm.update,
	      "destroy": _vm.destroy,
	      "translation": "table.billProducts",
	      "columnWidths": _vm.columnWidths,
	      "disableForm": _vm.bill.billStatusId === 3 || _vm.bill.billStatusId === 4 || _vm.bill.billStatusId === 5,
	      "stack": {
	        price: 'productDepositName',
	        billProductId: 'billNote'
	      }
	    }
	  }), _vm._v(" "), _c('v-totals-table', {
	    attrs: {
	      "list": _vm.totalsTableList
	    }
	  })], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 3120 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3121 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body test"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.adjustment.basicInformation'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.adjustment",
	      "hasLabel": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('v-products-table', {
	    attrs: {
	      "fields": _vm.fields,
	      "page": "adjustment",
	      "translation": "table.adjustment.products",
	      "isImport": _vm.isImport,
	      "isExport": _vm.isExport,
	      "exportClickHandler": _vm.download,
	      "server": _vm.server
	    }
	  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.adjustment.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.saveDraft
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.saveDraft').toUpperCase()))]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.adjustment.completeAdjustment').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 3122 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "wizardWrapper"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 2
	    }
	  }, [(_vm.loading) ? _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24,
	      "md": 12,
	      "lg": 12
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')) + " "), _c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  })])]) : _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "sm": 24
	    }
	  }, [_c('h3', {
	    staticClass: "wizardTitle"
	  }, [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')))]), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.module",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    on: {
	      "click": function($event) {
	        return _vm.closeModal()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.subscribe').toUpperCase()))])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 3123 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "client-info--wrapper"
	  }, [_c('div', {
	    staticClass: "client-info--content"
	  }, [_c('div', {
	    staticClass: "full-w flex wrap end"
	  }, [_c('el-row', {
	    staticStyle: {
	      "width": "100%",
	      "display": "flex",
	      "align-items": "flex-end"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 18,
	      "sm": 24
	    }
	  }, [_c('div', {
	    staticClass: "flex-column start"
	  }, [_c('span', {
	    staticClass: "clientName"
	  }, [_vm._v(_vm._s(_vm.currentClient.companyName || ((_vm.currentClient.firstName) + " " + (_vm.currentClient.lastName))))]), _vm._v(" "), (_vm.currentClient.clientType && _vm.currentClient.clientType.id !== undefined) ? _c('span', {
	    staticClass: "badge"
	  }, [_vm._v(_vm._s(_vm.currentClient.clientType.id != 1 ? _vm.$t('layouts.header.company') : _vm.$t('layouts.header.individual')))]) : _vm._e()])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 6,
	      "sm": 24
	    }
	  }, [_c('div', {
	    staticClass: "flex-column"
	  }, [_c('router-link', {
	    staticClass: "el-button el-button--default small",
	    staticStyle: {
	      "color": "#fff"
	    },
	    attrs: {
	      "to": ("/clients/" + (_vm.currentClient.id) + "/edit")
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('layouts.header.viewClient')) + "\n            ")])], 1)])], 1)], 1), _vm._v(" "), _c('hr', {
	    staticClass: "inverted"
	  }), _vm._v(" "), _c('p'), (_vm.isBillEdit === true) ? _c('div', {
	    staticClass: "address-wrap"
	  }, [(_vm.billingAddressMissing === true) ? _c('p', {
	    staticClass: "fa fa-info missing-bill-address"
	  }, [_vm._v("  " + _vm._s(_vm.$t('static.clientInfo.billAddressMissing')) + " "), _c('span', {
	    staticClass: "fa fa-arrow-right"
	  })]) : _c('div', {
	    staticStyle: {
	      "float": "left"
	    }
	  }, [(_vm.billAddress.care_of) ? _c('span', [_c('strong', [_vm._v("c/o")]), _vm._v(" " + _vm._s(("" + (_vm.billAddress.care_of)))), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "fa fa-map-marker"
	  }), _vm._v(" "), (_vm.billAddress.street_name) ? _c('span', [_vm._v(" " + _vm._s(("" + (_vm.billAddress.street_name)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.billAddress.second_street_name) ? _c('span', [_vm._v(_vm._s(("" + (_vm.billAddress.second_street_name)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.billAddress.postal_code) ? _c('span', [_vm._v(_vm._s(("" + (_vm.billAddress.postal_code))))]) : _vm._e(), _vm._v(" "), (_vm.billAddress.city) ? _c('span', [_vm._v(_vm._s(("" + (_vm.billAddress.city)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.billAddress.country && _vm.billAddress.country.name) ? _c('span', [_vm._v(_vm._s(("" + (_vm.billAddress.country.name))))]) : _vm._e()]), _vm._v(" "), (_vm.currentEdiOrder.orderType !== 'EDI') ? _c('button', {
	    staticClass: "el-button el-button--default small",
	    staticStyle: {
	      "margin": "10px"
	    },
	    attrs: {
	      "type": "button",
	      "round": ""
	    },
	    on: {
	      "click": _vm.editClientAddress
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-edit"
	  })]) : _vm._e()]) : _c('div', {
	    staticClass: "address-wrap"
	  }, [(!_vm.currentEdiOrder.id) ? _c('div', {
	    staticStyle: {
	      "float": "left"
	    }
	  }, [(_vm.currentClient.deliveryAddress.care_of) ? _c('span', [_c('strong', [_vm._v("c/o")]), _vm._v(" " + _vm._s(("" + (_vm.currentClient.deliveryAddress.care_of)))), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "fa fa-map-marker"
	  }), _vm._v(" "), (_vm.currentClient.deliveryAddress.street_name) ? _c('span', [_vm._v(" " + _vm._s(("" + (_vm.currentClient.deliveryAddress.street_name)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.currentClient.deliveryAddress.second_street_name) ? _c('span', [_vm._v(_vm._s(("" + (_vm.currentClient.deliveryAddress.second_street_name)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.currentClient.deliveryAddress.postal_code) ? _c('span', [_vm._v(_vm._s(((_vm.currentClient.deliveryAddress.postal_code) + " " + (_vm.currentClient.deliveryAddress.city_name)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.currentClient.deliveryAddress.country) ? _c('span', [_vm._v(_vm._s(("" + (_vm.currentClient.deliveryAddress.country))))]) : _vm._e()]) : _c('div', {
	    staticStyle: {
	      "float": "left"
	    }
	  }, [(_vm.currentClient.careOf) ? _c('span', [_c('strong', [_vm._v("c/o")]), _vm._v(" " + _vm._s(("" + (_vm.currentClient.careOf)))), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "fa fa-map-marker"
	  }), _vm._v(" "), (_vm.currentClient.streetName) ? _c('span', [_vm._v(" " + _vm._s(("" + (_vm.currentClient.streetName)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.currentClient.secondStreetName) ? _c('span', [_vm._v(_vm._s(("" + (_vm.currentClient.secondStreetName)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.currentClient.cityName) ? _c('span', [_vm._v(_vm._s(((_vm.currentClient.postalCode) + " " + (_vm.currentClient.cityName)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.currentClient.country) ? _c('span', [_vm._v(_vm._s(("" + (_vm.currentClient.country))))]) : _vm._e()]), _vm._v(" "), (_vm.currentEdiOrder.orderType !== 'EDI') ? _c('button', {
	    staticClass: "el-button el-button--default small",
	    staticStyle: {
	      "margin": "10px"
	    },
	    attrs: {
	      "type": "button",
	      "round": ""
	    },
	    on: {
	      "click": _vm.editClientAddress
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-edit"
	  })]) : _vm._e()]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('span', {
	    staticClass: "fa fa-phone"
	  }, [(_vm.currentClient.phoneNumber) ? _c('span') : _vm._e(), _vm._v("  " + _vm._s(_vm.currentClient.phoneNumber))]), _vm._v(" "), (_vm.currentClient.mobileNumber) ? _c('span', [_vm._v(" |  " + _vm._s(_vm.currentClient.mobileNumber))]) : _vm._e()]), _vm._v(" "), (_vm.currentClient.email) ? _c('p', [_c('span', {
	    staticClass: "fa fa-envelope-o"
	  }), _vm._v("  "), _c('a', {
	    attrs: {
	      "href": 'mailto:' + _vm.currentClient.email
	    }
	  }, [_vm._v(_vm._s(_vm.currentClient.email))])]) : _vm._e(), _vm._v(" "), (_vm.currentClient.contactFirstname || _vm.currentClient.contactLastname) ? _c('p', [_c('span', {
	    staticClass: "fa fa-user-o"
	  }), _vm._v("  " + _vm._s(((_vm.currentClient.contactFirstname) + " " + (_vm.currentClient.contactLastname))) + "\n    ")]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 3124 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('v-form-table', {
	    staticClass: "product-table",
	    attrs: {
	      "form": _vm.form,
	      "list": _vm.shippingProviders,
	      "create": _vm.save,
	      "update": _vm.update,
	      "destroy": _vm.destroy,
	      "translation": "table.shippingProviders",
	      "clickHandler": _vm.tableClickHandler
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 3125 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.clients.index.exportData')))]), _vm._v(" "), [_c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "flex-direction": "column"
	    }
	  }, [_c('el-button', {
	    staticClass: "margin-b-20",
	    staticStyle: {
	      "width": "380px"
	    },
	    on: {
	      "click": _vm.downloadAllClients
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('static.clients.index.downloadAllClients')) + "\n        ")])], 1)]], 2), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.clients.index.importData')))]), _vm._v(" "), [_c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('file-pond', {
	    ref: "pond",
	    attrs: {
	      "name": " import_excel",
	      "label-idle": _vm.$t('static.clients.index.importClients'),
	      "allow-multiple": "false",
	      "server": _vm.server
	    }
	  })], 1)])]], 2)])
	},staticRenderFns: []}

/***/ }),
/* 3126 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3127 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.transfer.basicInformation'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.transfer",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('v-products-table', {
	    attrs: {
	      "additionalData": _vm.additionalData,
	      "fields": _vm.fields,
	      "page": "transfer",
	      "transferType": _vm.formBasicInformation.transferType.toString(),
	      "translation": "form.transfer"
	    }
	  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'inventory.transfer.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 3128 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n         " + _vm._s(_vm.$t('static.productBundles.index.title')) + " (" + _vm._s(_vm.products.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search,
	      "clearable": true
	    },
	    on: {
	      "keydown": _vm.onChangeSearch
	    }
	  })], 1)])], 1), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', [(_vm.products.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.productBundle.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productBundles.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.productBundle.noDataBtn')) + "\n          ")])], 1)], 1) : [_c('div', {
	    staticClass: "flex stretch wrap"
	  }, _vm._l((_vm.products.items), function(p, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editProduct(p)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "cardLabel w-full"
	    }, [_c('span', {
	      staticClass: "cardBadge"
	    }, [_vm._v(_vm._s(_vm.$t(("static.products.types." + (_vm.camelize(p.productType))))))]), _vm._v(" "), (_vm.hasInventory && (!p.containsAlcohol && p.productTypeGroup === 'Beverage')) ? _c('span', {
	      staticClass: "cardBadge card-yellow"
	    }, [_vm._v(_vm._s(_vm.$t("static.products.labels.alcoholFree")))]) : _vm._e(), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-external-link pull-right",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      attrs: {
	        "aria-hidden": "true"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.editProductNewTab(p)
	        }
	      }
	    })]), _vm._v(" "), _c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('label', {
	      staticClass: "cardLabel"
	    }, [_vm._v(_vm._s(_vm.$t('form.products.price.label')) + ": ")]), _c('span', {
	      staticClass: "cardContent"
	    }, [_vm._v(_vm._s(p.productBundleGroupPrice) + " NOK")]), _vm._v(" "), (p.description) ? _c('div', {
	      staticClass: "cardinnerBox"
	    }, [_c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-file-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v(" \n                  " + _vm._s(p.description))])])]) : _vm._e()])
	  }), 1)]], 2)]) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "sizePerPage": _vm.perPage,
	      "pagination": _vm.products.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3129 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body el-row"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.edit.title')) + "\n      ")])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.clients.edit.overview'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    staticClass: "margin-b-10",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "full-w flex wrap"
	  }, [(_vm.client.picture && Object.keys(_vm.client.picture).length) ? _c('img', {
	    staticClass: "client-picture",
	    attrs: {
	      "src": _vm.client.picture.url,
	      "alt": _vm.client.firstName
	    }
	  }) : _c('div', {
	    staticClass: "client-picture client-avatar-initials",
	    style: ({
	      backgroundColor: _vm.getAvatarColor(_vm.client)
	    }),
	    attrs: {
	      "title": _vm.client.companyName || ((_vm.client.firstName) + " " + (_vm.client.lastName))
	    }
	  }, [_vm._v(_vm._s(_vm.getInitials(_vm.client)))]), _vm._v(" "), _c('h2', {
	    staticClass: "title"
	  }, [_vm._v("\n                " + _vm._s(_vm.client.companyName || ((_vm.client.firstName) + "\n                " + (_vm.client.lastName))) + "\n              ")])])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  })], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('fieldset', {
	    staticClass: "margin-b-10"
	  }, [_c('legend', [_vm._v("\n                " + _vm._s(_vm.$t('static.accountInformation.organizationInformation')) + "\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-info",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.clientNumber')) + "\n                ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.client.clientNumber) + "\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-building-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.organizationNumber')) + "\n                ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.client.organizationNumber || '–') + "\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-envelope-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.email')) + "\n                ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.client.email) + "\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-user-secret",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.clientType')) + "\n                ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.currentType.name) + "\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-users",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.clientGroup')) + "\n                ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.currentGroup.name) + "\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-user-secret",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.isProducer')) + "\n                ")]), _vm._v(" "), (_vm.client.isProducer) ? _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('button.yes')) + "\n                ")]) : _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('button.no')) + "\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-user-secret",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.systemGenerated')) + "\n                ")]), _vm._v(" "), (_vm.client.systemGenerated) ? _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('button.yes')) + "\n                ")]) : _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.$t('button.no')) + "\n                ")])]), _vm._v(" "), (_vm.hasEHFModule) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.ehfInvoiceSupport')) + "\n                ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.ehfSupportStatusText) + "\n                ")])]) : _vm._e()]), _vm._v(" "), (_vm.client.contacts.length) ? _c('h4', {
	    staticClass: "margin-b-10"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('static.accountInformation.contactInformation')) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.client.contacts), function(contact) {
	    return (contact.id) ? _c('fieldset', {
	      key: ("contact-" + (contact.id)),
	      staticClass: "margin-b-10"
	    }, [_c('legend', _vm._l((contact.contact_types), function(type) {
	      return _c('span', [_vm._v("\n                  " + _vm._s(_vm.$t(("form.contactTypes.options." + (_vm.camelize(type.name))))) + "\n                  " + _vm._s(contact.contact_types.length > 1 ? '/' : '') + "\n                ")])
	    }), 0), _vm._v(" "), (contact.first_name) ? _c('div', {
	      staticClass: "margin-b-10"
	    }, [_c('label', {
	      staticClass: "label label--small"
	    }, [_c('i', {
	      staticClass: "fa fa-envelope-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.firstName')) + "\n                ")]), _vm._v(" "), _c('span', {
	      staticClass: "label-content label-content--small"
	    }, [_vm._v("\n                  " + _vm._s(contact.first_name) + "\n                ")])]) : _vm._e(), _vm._v(" "), (contact.last_name) ? _c('div', {
	      staticClass: "margin-b-10"
	    }, [_c('label', {
	      staticClass: "label label--small"
	    }, [_c('i', {
	      staticClass: "fa fa-envelope-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.lastName')) + "\n                ")]), _vm._v(" "), _c('span', {
	      staticClass: "label-content label-content--small"
	    }, [_vm._v("\n                  " + _vm._s(contact.last_name) + "\n                ")])]) : _vm._e(), _vm._v(" "), (contact.email) ? _c('div', {
	      staticClass: "margin-b-10"
	    }, [_c('label', {
	      staticClass: "label label--small"
	    }, [_c('i', {
	      staticClass: "fa fa-envelope-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.email')) + "\n                ")]), _vm._v(" "), _c('span', {
	      staticClass: "label-content label-content--small"
	    }, [_vm._v("\n                  " + _vm._s(contact.email) + "\n                ")])]) : _vm._e(), _vm._v(" "), (contact.phone_number) ? _c('div', {
	      staticClass: "margin-b-10"
	    }, [_c('label', {
	      staticClass: "label label--small"
	    }, [_c('i', {
	      staticClass: "fa fa-phone",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.phoneNumber')) + "\n                ")]), _vm._v(" "), _c('span', {
	      staticClass: "label-content label-content--small"
	    }, [_vm._v("\n                  " + _vm._s(contact.phone_number) + "\n                ")])]) : _vm._e(), _vm._v(" "), (contact.mobile_number) ? _c('div', {
	      staticClass: "margin-b-10"
	    }, [_c('label', {
	      staticClass: "label label--small"
	    }, [_c('i', {
	      staticClass: "fa fa-mobile",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.mobileNumber')) + "\n                ")]), _vm._v(" "), _c('span', {
	      staticClass: "label-content label-content--small"
	    }, [_vm._v("\n                  " + _vm._s(contact.mobile_number) + "\n                ")])]) : _vm._e()]) : _vm._e()
	  }), _vm._v(" "), (_vm.client.addresses.length) ? _c('h4', {
	    staticClass: "margin-b-10"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('static.accountInformation.addressInformation')) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.client.addresses), function(address) {
	    return (address.id) ? _c('fieldset', {
	      key: ("address-" + (address.id)),
	      staticClass: "margin-b-10"
	    }, [_c('legend', [_vm._v("\n                " + _vm._s(_vm.$t(("form.addressTypes.options." + (_vm.camelize(address.address_type.name))))) + "\n              ")]), _vm._v(" "), _c('div', {
	      staticClass: "margin-b-10"
	    }, [_c('label', {
	      staticClass: "label label--small"
	    }, [_c('i', {
	      staticClass: "fa fa-address-book-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("\n                   " + _vm._s(_vm.$t('static.clients.info.streetName')) + "\n                ")]), _vm._v(" "), _c('span', {
	      staticClass: "label-content label-content--small"
	    }, [_vm._v("\n                  " + _vm._s(address.street_name) + "\n                ")])]), _vm._v(" "), _c('div', {
	      staticClass: "margin-b-10"
	    }, [_c('label', {
	      staticClass: "label label--small"
	    }, [_c('i', {
	      staticClass: "fa fa-address-book-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("\n                   " + _vm._s(_vm.$t('static.clients.info.secondStreetName')) + "\n                ")]), _vm._v(" "), _c('span', {
	      staticClass: "label-content label-content--small"
	    }, [_vm._v("\n                  " + _vm._s(address.second_street_name) + "\n                ")])]), _vm._v(" "), _c('div', {
	      staticClass: "margin-b-10"
	    }, [_c('label', {
	      staticClass: "label label--small"
	    }, [_c('i', {
	      staticClass: "fa fa-address-book",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.postalCode')) + "\n                ")]), _vm._v(" "), _c('span', {
	      staticClass: "label-content label-content--small"
	    }, [_vm._v("\n                  " + _vm._s(address.postal_code) + "\n                ")])]), _vm._v(" "), _c('div', {
	      staticClass: "margin-b-10"
	    }, [_c('label', {
	      staticClass: "label label--small"
	    }, [_c('i', {
	      staticClass: "fa fa-address-book",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.city')) + "\n                ")]), _vm._v(" "), _c('span', {
	      staticClass: "label-content label-content--small"
	    }, [_vm._v("\n                  " + _vm._s(address.city_name) + "\n                ")])])]) : _vm._e()
	  }), _vm._v(" "), (_vm.glnOverviewShow('gln')) ? _c('fieldset', [_c('legend', [_c('span', [_vm._v("\n                  " + _vm._s('GLN Registry') + "\n                ")])]), _vm._v(" "), (_vm.glnOverviewShow('gln_number')) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book-o",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  \n                  GLN number\n                ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.formBasicInformation.gln) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.glnOverviewShow('gln_x_koord')) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  \n                    GLN X-coordinates\n                ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.formBasicInformation.glnXKoord) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.glnOverviewShow('gln_y_koord')) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-address-book",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  \n                  GLN Y-coordinates\n                ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small"
	  }, [_vm._v("\n                  " + _vm._s(_vm.formBasicInformation.glnYKoord) + "\n                ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasMarketplaceModule && _vm.marketplaces.length) ? [(_vm.marketplaces.length) ? _c('h4', {
	    staticClass: "margin-b-10"
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('static.accountInformation.marketplace')) + "\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.marketplaces), function(marketplace) {
	    return _c('fieldset', {
	      key: ("marketplace-" + (marketplace.id)),
	      staticClass: "margin-b-10"
	    }, [_c('legend', [_vm._v(_vm._s(marketplace.name))]), _vm._v(" "), _c('el-button', {
	      staticClass: "small",
	      on: {
	        "click": function($event) {
	          return _vm.inviteToMarketplace(marketplace.id)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('button.invite').toUpperCase()))])], 1)
	  })] : _vm._e()], 2), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('div', {
	    staticClass: "full-w flex-column"
	  }, [_c('div', {
	    staticClass: "full-w flex justify-center wrap"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'orders.index',
	        query: {
	          filter: ("client," + (_vm.client.id))
	        }
	      }
	    }
	  }, [_c('div', {
	    staticClass: "\n                      flex-column\n                      justify-center\n                      margin-b-10 margin-r-10\n                      stats-card\n                    "
	  }, [_c('span', {
	    staticClass: "stats-card--number margin-b-10"
	  }, [_vm._v(_vm._s(_vm.client.ordersCount))]), _vm._v(" "), _c('span', {
	    staticClass: "stats-card--text"
	  }, [_vm._v(_vm._s(_vm.$t('static.clients.info.orders')))])])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'bills.index',
	        query: {
	          filter: ("client," + (_vm.client.id))
	        }
	      }
	    }
	  }, [_c('div', {
	    staticClass: "\n                      flex-column\n                      justify-center\n                      margin-b-10 margin-r-10\n                      stats-card\n                    "
	  }, [_c('span', {
	    staticClass: "stats-card--number margin-b-10"
	  }, [_vm._v(_vm._s(_vm.client.billsCount))]), _vm._v(" "), _c('span', {
	    staticClass: "stats-card--text"
	  }, [_vm._v(_vm._s(_vm.$t('static.clients.info.bills')))])])])], 1)])])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.clients.basicInformation'),
	      "name": "2"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    attrs: {
	      "form": _vm.formBasicInformation,
	      "translation": "form.clients",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.clients.contacts'),
	      "name": "3"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 24
	    }
	  }, [(_vm.contactFormErrors.primary) ? _c('span', {
	    staticClass: "text-danger"
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('form.clients.primaryContactError')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('v-client-contact', {
	    attrs: {
	      "clientId": _vm.currentClient.id
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.clients.addresses'),
	      "name": "4"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 24
	    }
	  }, [(_vm.clientAddresses) ? _c('el-collapse', {
	    model: {
	      value: (_vm.clientAddressNames),
	      callback: function($$v) {
	        _vm.clientAddressNames = $$v
	      },
	      expression: "clientAddressNames"
	    }
	  }, _vm._l((_vm.clientAddresses), function(address, index) {
	    return _c('el-collapse-item', {
	      key: address.id,
	      attrs: {
	        "title": _vm.$t(("form.addressTypes.options." + (_vm.camelize(address.name)))),
	        "name": address.name
	      }
	    }, [_c('v-client-address', {
	      attrs: {
	        "id": address.id,
	        "name": address.name,
	        "errors": _vm.getAddressFieldErrors(address.id),
	        "data": address,
	        "countries": _vm.countries.items,
	        "municipalities": _vm.municipalities.items
	      },
	      on: {
	        "update": function($event) {
	          _vm.clientAddresses[index] = $event
	        }
	      }
	    })], 1)
	  }), 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('form.clients.licenses'),
	      "name": "5"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-button', {
	    staticClass: "margin-b-10 small",
	    on: {
	      "click": _vm.addLicense
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.license.add')))]), _vm._v(" "), (_vm.licenses.length) ? _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.licenses
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "organizationNumber",
	      "label": _vm.$t('static.license.organizationNumber')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "licenseNumber",
	      "label": _vm.$t('static.license.licenseNumber')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "licenseType",
	      "label": _vm.$t('static.license.licenseType')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "licensePermitType",
	      "label": _vm.$t('static.license.licensePermitType')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "validFrom",
	      "label": _vm.$t('static.license.validFrom')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "validTo",
	      "label": _vm.$t('static.license.validTo')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.license.groups')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.licensePermitGroups.length > 0) ? _c('ul', {
	          staticStyle: {
	            "padding": "0"
	          }
	        }, _vm._l((scope.row.licensePermitGroups), function(group) {
	          return _c('li', [_vm._v("\n                      " + _vm._s(group.licenseGroup) + "\n                    ")])
	        }), 0) : _vm._e()]
	      }
	    }], null, false, 1675627584)
	  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.clients.catalogues.title'),
	      "name": "6"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-button', {
	    staticClass: "margin-b-10 small",
	    on: {
	      "click": _vm.sendCatalogue
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.clients.catalogues.sendCatalogue')))])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.tabIndex !== 'overview') ? _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'clients.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), (_vm.client.ordersCount == 0) ? _c('el-button', {
	    staticClass: "outline danger",
	    attrs: {
	      "disabled": _vm.client.systemGenerated ? true : false,
	      "loading": _vm.loading
	    },
	    on: {
	      "click": _vm.destroy
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.deleteClient').toUpperCase()) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "disabled": _vm.client.systemGenerated ? true : false,
	      "loading": _vm.formBasicInformation.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 3130 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (!_vm.ready),
	      expression: "!ready"
	    }],
	    staticClass: "product-lines-loading-wrap",
	    staticStyle: {
	      "width": "100%",
	      "min-height": "220px",
	      "position": "relative"
	    },
	    attrs: {
	      "element-loading-text": _vm.$t('static.loadingProductLines')
	    }
	  }, [_c('v-form-table', {
	    ref: "formTable",
	    staticClass: "ediorderproduct-table",
	    attrs: {
	      "form": _vm.form,
	      "list": _vm.list,
	      "translation": "table.orderProducts",
	      "disableForm": !_vm.canBeConfirmed,
	      "update": _vm.confirm,
	      "stack": {
	        price: 'productDepositName'
	      },
	      "clickHandler": _vm.tableClickHandler,
	      "tagHandler": _vm.tableTagHandler,
	      "is-edi": true,
	      "hiddenFields": _vm.hiddenFields
	    }
	  }), _vm._v(" "), _c('v-totals-table', {
	    attrs: {
	      "list": _vm.totalsTableList
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 3131 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', {
	    staticClass: "wizardTitlxe"
	  }, [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.addMember.title')))]), _vm._v(" "), _c('el-form', {
	    ref: "newMemberForm",
	    attrs: {
	      "model": _vm.newMemberForm,
	      "rules": _vm.newMemberRules
	    }
	  }, [_c('el-form-item', {
	    staticStyle: {
	      "margin-top": "24px",
	      "margin-bottom": "12px"
	    },
	    attrs: {
	      "prop": "firstname",
	      "show-message": false
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": _vm.$t('static.members.index.dialog.addMember.firstName')
	    },
	    model: {
	      value: (_vm.newMemberForm.firstname),
	      callback: function($$v) {
	        _vm.$set(_vm.newMemberForm, "firstname", $$v)
	      },
	      expression: "newMemberForm.firstname"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    staticStyle: {
	      "margin-bottom": "12px"
	    },
	    attrs: {
	      "prop": "lastname",
	      "show-message": false
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": _vm.$t('static.members.index.dialog.addMember.lastName')
	    },
	    model: {
	      value: (_vm.newMemberForm.lastname),
	      callback: function($$v) {
	        _vm.$set(_vm.newMemberForm, "lastname", $$v)
	      },
	      expression: "newMemberForm.lastname"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "prop": "email",
	      "show-message": false
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "email",
	      "placeholder": _vm.$t('static.members.index.dialog.addMember.email')
	    },
	    model: {
	      value: (_vm.newMemberForm.email),
	      callback: function($$v) {
	        _vm.$set(_vm.newMemberForm, "email", $$v)
	      },
	      expression: "newMemberForm.email"
	    }
	  })], 1)], 1), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "border": "solid 1px #1bbc9b",
	      "color": "#1bbc9b",
	      "background-color": "#fff",
	      "float": "left"
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.cancel')))]), _vm._v(" "), _c('el-button', {
	    staticClass: "small",
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.addMember
	    }
	  }, [_vm._v(_vm._s(_vm.$t('static.members.index.dialog.add')))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3132 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 3133 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "full-w flex stretch calendar-appointments-wrapper"
	  }, [_c('div', {
	    ref: "timeframes",
	    staticClass: "timebar-container flex-column"
	  }, _vm._l((_vm.timeframes), function(t) {
	    return _c('div', {
	      staticClass: "timebar-content flex-column end"
	    }, [_c('span', {
	      staticClass: "timebar-content--time"
	    }, [_vm._v(_vm._s(t))]), _vm._v(" "), _c('span', {
	      staticClass: "timebar-content--half"
	    }, [_vm._v("30")])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex",
	    staticStyle: {
	      "height": "100%"
	    }
	  }, _vm._l((_vm.daysArray()), function(d) {
	    return _c('v-calendar-day', {
	      attrs: {
	        "day": _vm.changeDay(_vm.day, 'add', d),
	        "list": _vm.appointments,
	        "create": _vm.create,
	        "edit": _vm.onEdit
	      }
	    })
	  }), 1)])
	},staticRenderFns: []}

/***/ }),
/* 3134 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.subscriberList.create.title')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.subscriberList.create.tabTitle'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.subscriberList",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex wrap justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'subscriberList.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3135 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "id": "member_details"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "min-height": "550px",
	      "position": "relative",
	      "background-color": "#fff",
	      "border-radius": "4px"
	    }
	  }, [(_vm.member) ? [_c('div', {
	    staticClass: "clearfix",
	    staticStyle: {
	      "border-bottom": "solid 1px #eee",
	      "padding": "15px"
	    },
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('el-tag', {
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "type": (_vm.acceptStatus == 'ACTIVE') ? 'success' : 'info'
	    }
	  }, [_vm._v("\n\t\t\t  \t\t\t" + _vm._s(_vm.acceptStatus) + "\n\t\t\t  \t\t")]), _vm._v(" "), _c('h2', [_vm._v("\n\t\t\t    \t\t" + _vm._s(_vm.member.organization.name) + " \n\t\t\t    \t\t"), _c('span', {
	    staticStyle: {
	      "display": "inline-block",
	      "vertical-align": "middle",
	      "width": "22px",
	      "height": "22px",
	      "border-radius": "50%"
	    },
	    style: ('backgroundColor:' + _vm.member.color)
	  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.member.organization.organization_type.name))]), _vm._v(" "), _c('h4', [_vm._v("Member since: " + _vm._s(_vm.formatDate(_vm.member.created_at)))])], 1), _vm._v(" "), _c('el-row', {
	    staticStyle: {
	      "padding": "15px"
	    },
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 14
	    }
	  }, [_c('h2', [_vm._v(_vm._s(_vm.member.title))]), _vm._v(" "), (_vm.member.organization_member_products.length == 0) ? _c('el-alert', {
	    attrs: {
	      "title": "No products found",
	      "type": "info",
	      "closable": false
	    }
	  }) : _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "highlight-current-row": "",
	      "data": _vm.member.organization_member_products
	    },
	    on: {
	      "current-change": _vm.selectProduct
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "Product",
	      "prop": "product.name"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Price",
	      "prop": "product.price"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Duration",
	      "prop": "product"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v("\n\t\t\t\t\t\t\t     \t" + _vm._s(scope.row.product.product_configuration.duration) + " mins\n\t\t\t\t\t\t\t    ")]
	      }
	    }], null, false, 3880701885)
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 10
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "box-shadow": "0 2px 12px 0 rgba(0,0,0,.1)",
	      "border": "1px solid #ebeef5",
	      "color": "#303133",
	      "border-radius": "4px",
	      "padding": "20px"
	    }
	  }, [(!_vm.selected_product) ? _c('el-alert', {
	    attrs: {
	      "title": "Please select a product to manage business hours",
	      "type": "info",
	      "closable": false,
	      "center": ""
	    }
	  }) : [_c('span', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_vm._v(_vm._s(_vm.selected_product.product.product_configuration.duration) + " mins")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.selected_product.product.name))]), _vm._v(" "), _c('el-collapse', {
	    staticStyle: {
	      "margin-top": "20px"
	    },
	    attrs: {
	      "accordion": ""
	    },
	    on: {
	      "change": _vm.setDay
	    },
	    model: {
	      value: (_vm.day),
	      callback: function($$v) {
	        _vm.day = $$v
	      },
	      expression: "day"
	    }
	  }, _vm._l((_vm.days), function(day, index) {
	    return _c('el-collapse-item', {
	      attrs: {
	        "title": day,
	        "name": day
	      }
	    }, [_vm._l((_vm.getHours(_vm.selected_product, day)), function(businesshour) {
	      return _c('el-tag', {
	        key: businesshour.id,
	        attrs: {
	          "closable": "",
	          "type": "success"
	        },
	        on: {
	          "close": function($event) {
	            return _vm.removeHour(businesshour.id)
	          }
	        }
	      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t  " + _vm._s(businesshour.start_time) + " - " + _vm._s(businesshour.end_time) + "\n\t\t\t\t\t\t\t\t\t")])
	    }), _vm._v(" "), (_vm.addTimeVisible) ? _c('div', {
	      attrs: {
	        "id": "time_selector"
	      }
	    }, [_c('el-time-select', {
	      ref: "saveTagInput",
	      refInFor: true,
	      staticClass: "input-new-tag",
	      attrs: {
	        "picker-options": {
	          start: '07:00',
	          step: _vm.timeslot_gap,
	          end: '23:50'
	        },
	        "prefix-icon": "''",
	        "clearable": false,
	        "editable": false,
	        "placeholder": "Start"
	      },
	      on: {
	        "blur": _vm.confirmAddTime
	      },
	      nativeOn: {
	        "keyup": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.confirmAddTime($event)
	        }
	      },
	      model: {
	        value: (_vm.start_time),
	        callback: function($$v) {
	          _vm.start_time = $$v
	        },
	        expression: "start_time"
	      }
	    }), _vm._v(" "), _c('el-time-select', {
	      ref: "saveTagInput",
	      refInFor: true,
	      staticClass: "input-new-tag",
	      attrs: {
	        "picker-options": {
	          start: '07:00',
	          step: _vm.timeslot_gap,
	          end: '23:50'
	        },
	        "prefix-icon": "''",
	        "clearable": false,
	        "editable": false,
	        "placeholder": "End"
	      },
	      on: {
	        "blur": _vm.confirmAddTime
	      },
	      nativeOn: {
	        "keyup": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.confirmAddTime($event)
	        }
	      },
	      model: {
	        value: (_vm.end_time),
	        callback: function($$v) {
	          _vm.end_time = $$v
	        },
	        expression: "end_time"
	      }
	    })], 1) : _c('el-button', {
	      staticClass: "button-new-tag small",
	      on: {
	        "click": function($event) {
	          return _vm.showAddHour(index)
	        }
	      }
	    }, [_vm._v("+ Add Hour")])], 2)
	  }), 1)]], 2)])], 1)] : _vm._e()], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 3136 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('v-form-table', {
	    attrs: {
	      "form": _vm.form,
	      "list": _vm.exceptionList,
	      "create": _vm.save,
	      "destroy": _vm.destroy,
	      "translation": "table.businessHourExceptions"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 3137 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-row', {
	    staticClass: "bulk-product-add"
	  }, [_c('el-col', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "span": 24
	    }
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('static.bulkProcessBill.title')))]), _vm._v(" "), (!_vm.submitted) ? [(_vm.showForm) ? _c('div', {
	    staticClass: "wrapper"
	  }, [(_vm.submitLoading) ? _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [_c('p', [_vm._v("Processing Bills...")])]) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 18
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    staticStyle: {
	      "margin-top": "15px"
	    },
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.billConfirm",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.confirm
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('button.confirm')))]), _vm._v(" "), (_vm.showForm) ? _c('el-button', {
	    staticClass: "small dark",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px",
	      "color": "#fff"
	    },
	    attrs: {
	      "disabled": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('button.close')))]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Bills")]), _vm._v(" "), _c('el-table', {
	    staticClass: "orders",
	    staticStyle: {
	      "width": "100%",
	      "margin-bottom": "10px"
	    },
	    attrs: {
	      "data": _vm.bills
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "expand"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [(props.row.billProducts.length) ? _c('ul', _vm._l((props.row.billProducts), function(product) {
	          return _c('li', {
	            key: product.id
	          }, [_c('span', {
	            staticStyle: {
	              "font-family": "'robotobold'"
	            }
	          }, [_vm._v(_vm._s(product.quantity) + " STK")]), _vm._v(" — "), _c('span', {
	            staticStyle: {
	              "font-family": "'robotobold'"
	            }
	          }, [_vm._v(_vm._s(product.name))])])
	        }), 0) : _c('span', [_vm._v(_vm._s(_vm.$t('static.orders.index.noProductFound')))])]
	      }
	    }], null, false, 4003464249)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "name",
	      "label": _vm.$t('static.bills.table.name'),
	      "width": "100",
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bills.table.paymentDate')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-date-picker', {
	          staticStyle: {
	            "width": "100%"
	          },
	          attrs: {
	            "size": "small",
	            "prefix-icon": "false",
	            "type": "date",
	            "value-format": "yyyy-MM-dd",
	            "format": "dd-MM-yyyy",
	            "placeholder": "Pick date",
	            "picker-options": {
	              firstDayOfWeek: 1
	            }
	          },
	          model: {
	            value: (props.row.paymentDate),
	            callback: function($$v) {
	              _vm.$set(props.row, "paymentDate", $$v)
	            },
	            expression: "props.row.paymentDate"
	          }
	        })]
	      }
	    }], null, false, 1527284939)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "type",
	      "label": _vm.$t('static.bills.table.type'),
	      "width": "80",
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "status",
	      "label": _vm.$t('static.bills.table.status'),
	      "width": "90",
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "client",
	      "label": _vm.$t('static.bills.table.client'),
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "totalGross",
	      "label": _vm.$t('static.bills.table.totalGross'),
	      "width": "120",
	      "sortable": ""
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.bills.table.amountDue'),
	      "width": "120",
	      "sortable": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('el-input', {
	          staticStyle: {
	            "width": "100%"
	          },
	          attrs: {
	            "type": "text",
	            "size": "small"
	          },
	          model: {
	            value: (props.row.amountDueNum),
	            callback: function($$v) {
	              _vm.$set(props.row, "amountDueNum", $$v)
	            },
	            expression: "props.row.amountDueNum"
	          }
	        })]
	      }
	    }], null, false, 2807037779)
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [(!_vm.showForm) ? _c('el-button', {
	    staticClass: "small dark",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "disabled": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.close')))]) : _vm._e(), _vm._v(" "), (_vm.operation == 'cancelOrder') ? _c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.cancelOrder
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.cancelOrders')))]) : _vm._e(), _vm._v(" "), (_vm.operation == 'createInvoice') ? _c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.createInvoices
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.createInvoices')))]) : _vm._e()], 1)] : [_c('div', [_vm._l((_vm.bills), function(bill) {
	    return _c('div', {
	      key: bill.id
	    }, [_c('p', [_vm._v("- Bill " + _vm._s(bill.name) + ",\n              "), (_vm.errorsByBill[bill.id] && _vm.errorsByBill[bill.id].length) ? _c('span', [_vm._v("Failed "), _c('i', {
	      staticClass: "el-icon-error danger-color"
	    })]) : _c('span', [_vm._v(_vm._s(_vm.successStatus) + " "), _c('i', {
	      staticClass: "el-icon-success",
	      staticStyle: {
	        "color": "green"
	      }
	    })])]), _vm._v(" "), (_vm.errorsByBill[bill.id] && _vm.errorsByBill[bill.id].length) ? _c('ul', _vm._l((_vm.errorsByBill[bill.id]), function(error) {
	      return _c('li', [_c('span', [_vm._v(_vm._s(error.message))])])
	    }), 0) : _vm._e()])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [(_vm.submitted) ? _c('el-button', {
	    staticClass: "small dark",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('button.close')))]) : _vm._e()], 1)], 2)]], 2)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3138 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.view.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    model: {
	      value: (_vm.tabIndex),
	      callback: function($$v) {
	        _vm.tabIndex = $$v
	      },
	      expression: "tabIndex"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.transfer.view.details'),
	      "name": "first"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.transfer.view.detailsLegend')))]), _vm._v(" "), [_c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.info.code')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentTransfer.code) + " - " + _vm._s(_vm.currentTransfer.name) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.info.fromWarehouse')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'warehouse.edit',
	        params: {
	          id: _vm.currentTransfer.fromWarehouseId
	        }
	      }
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentTransfer.fromWarehouse.name) + "\n                    ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.info.toWarehouse')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'warehouse.edit',
	        params: {
	          id: _vm.currentTransfer.toWarehouseId
	        }
	      }
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.currentTransfer.toWarehouse.name) + "\n                    ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.info.comments')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentTransfer.comments) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.info.createdAt')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status"
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentTransfer.createdAt) + "\n                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('label', {
	    staticClass: "label label--small"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.transfer.info.status')) + ":\n                  ")]), _vm._v(" "), _c('span', {
	    staticClass: "label-content label-content--small _status",
	    staticStyle: {
	      "text-transform": "capitalize"
	    }
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentTransfer.status) + "\n                  ")])]), _vm._v(" "), (_vm.currentTransfer.transferType === 6) ? _c('div', {
	    staticClass: "margin-b-10"
	  }, [_c('button', {
	    staticClass: "btn info el-button",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.showPrintableDeliveryNote
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('button.showPrintableDeliveryNote')))])]) : _vm._e()]], 2)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.transfer.view.products'),
	      "name": "products"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.transfer.view.productsLegend')))]), _vm._v(" "), _c('el-table', {
	    staticClass: "transfer-product-table",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.productList,
	      "stripe": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": _vm.$t('static.transfer.products.name')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.transfer.products.batch')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.batch) ? _c('router-link', {
	          attrs: {
	            "to": {
	              name: 'production.batches.view',
	              params: {
	                id: scope.row.batch.id
	              }
	            },
	            "target": "_blank"
	          }
	        }, [_vm._v("\n                      " + _vm._s(scope.row.batch.code) + "\n                    ")]) : _c('span', [_vm._v("-")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "qty",
	      "label": _vm.$t('static.transfer.products.qty')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "notes",
	      "label": _vm.$t('static.transfer.products.notes')
	    }
	  })], 1)], 1)])], 1)], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3139 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.campaigns.create.title')))])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.campaigns.create.tabTitle'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.campaigns",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex wrap justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'campaigns.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.store
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3140 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-row', {
	    staticClass: "bulk-product-add"
	  }, [_c('el-col', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    attrs: {
	      "span": 24
	    }
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('static.bulkProcessOrder.title')))]), _vm._v(" "), (!_vm.submitted) ? [(_vm.showForm) ? _c('div', {
	    staticClass: "wrapper"
	  }, [(_vm.submitLoading) ? _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [_c('p', [_vm._v("Processing Orders...")])]) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 18
	    }
	  }, [(!_vm.loading) ? _c('v-form', {
	    staticStyle: {
	      "margin-top": "15px"
	    },
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.orderConfirm",
	      "hasLabel": true
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "disabled": _vm.hasNoExcise,
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.confirm
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('button.confirm')))]), _vm._v(" "), (_vm.showForm) ? _c('el-button', {
	    staticClass: "small dark",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px",
	      "color": "#fff"
	    },
	    attrs: {
	      "disabled": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t('button.close')))]) : _vm._e()], 1)], 1), _vm._v(" "), (['confirmOrder', 'confirmOrderAndShipping'].includes(_vm.operation)) ? [(_vm.hasExciseModule) ? _c('div', [(_vm.bevearageProducts.length) ? [(_vm.hasNoExcise) ? _c('el-alert', {
	    staticStyle: {
	      "margin-bottom": "10px",
	      "margin-top": "15px",
	      "display": "flex"
	    },
	    attrs: {
	      "title": _vm.$t('static.orders.orderConfirm.exciseWarningMessage'),
	      "type": "warning",
	      "show-icon": "",
	      "closable": false
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "el-row",
	    staticStyle: {
	      "border": "1px solid #ebeef5",
	      "background": "#f4f3f3",
	      "padding": "10px"
	    }
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%",
	      "display": "block"
	    },
	    attrs: {
	      "data": _vm.bevearageProducts
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.orders.orderConfirm.table.product')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.noExcise) ? _c('a', {
	          on: {
	            "click": function($event) {
	              return _vm.quickProductEdit(scope.row.id)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "el-icon-edit"
	        }), _vm._v("\n                          " + _vm._s(scope.row.name))]) : _c('span', [_vm._v(_vm._s(scope.row.name))])]
	      }
	    }], null, false, 3554632850)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('static.orders.orderConfirm.exciseCheck')
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(!scope.row.noExcise) ? _c('i', {
	          staticClass: "el-icon-circle-check success-color",
	          staticStyle: {
	            "font-size": "18px"
	          }
	        }) : _c('i', {
	          staticClass: "el-icon-circle-close danger-color",
	          staticStyle: {
	            "font-size": "18px"
	          }
	        })]
	      }
	    }], null, false, 3082525749)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "beverage",
	      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.beverage')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "packaging",
	      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.packaging')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "basic",
	      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.basic')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "bottleVolume",
	      "label": _vm.$t('static.orders.orderConfirm.table.bottleVolume')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "alcoholPercentage",
	      "label": _vm.$t('static.orders.orderConfirm.table.alcoholPercentage')
	    }
	  })], 1)], 1)] : _vm._e()], 2) : _c('div', [_c('el-alert', {
	    staticStyle: {
	      "margin-bottom": "10px",
	      "margin-top": "15px",
	      "display": "flex"
	    },
	    attrs: {
	      "title": _vm.$t('static.orders.orderConfirm.upsellMessage'),
	      "type": "info",
	      "show-icon": ""
	    }
	  })], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Orders")]), _vm._v(" "), _c('el-table', {
	    staticClass: "orders",
	    staticStyle: {
	      "width": "100%",
	      "margin-bottom": "10px"
	    },
	    attrs: {
	      "data": _vm.orders
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "expand"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [(props.row.orderProducts.length) ? _c('ul', _vm._l((props.row.orderProducts), function(product) {
	          return _c('li', {
	            key: product.id
	          }, [_c('span', {
	            staticStyle: {
	              "font-family": "'robotobold'"
	            }
	          }, [_vm._v(_vm._s(product.quantity) + " STK")]), _vm._v(" — "), _c('span', {
	            staticStyle: {
	              "font-family": "'robotobold'"
	            }
	          }, [_vm._v(_vm._s(product.name))])])
	        }), 0) : _c('span', [_vm._v(_vm._s(_vm.$t('static.orders.index.noProductFound')))])]
	      }
	    }], null, false, 3060253977)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "name",
	      "label": _vm.$t('static.orders.table.name')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "status",
	      "label": _vm.$t('static.orders.table.status')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "clientName",
	      "label": _vm.$t('static.orders.table.clientName')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "totalValue",
	      "label": _vm.$t('static.orders.table.totalValue')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "totalQuantity",
	      "label": _vm.$t('static.orders.table.totalQuantity')
	    }
	  })], 1), _vm._v(" "), (_vm.batchProducts.length) ? [_c('p', [_vm._v("Set batch for product")]), _vm._v(" "), _c('el-table', {
	    staticClass: "batchProducts",
	    staticStyle: {
	      "width": "100%",
	      "margin-bottom": "10px"
	    },
	    attrs: {
	      "data": _vm.batchProducts
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": _vm.$t('static.orders.orderConfirm.table.product')
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "batchOptions"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-select', {
	          attrs: {
	            "multiple": "",
	            "placeholder": "Non-batch",
	            "default-first-option": ""
	          },
	          on: {
	            "change": function($event) {
	              return _vm.updateBatchProduct(scope.row)
	            }
	          },
	          model: {
	            value: (scope.row.selectedBatch),
	            callback: function($$v) {
	              _vm.$set(scope.row, "selectedBatch", $$v)
	            },
	            expression: "scope.row.selectedBatch"
	          }
	        }, _vm._l((scope.row.batchOptions), function(item, index) {
	          return _c('el-option', {
	            key: index,
	            attrs: {
	              "label": item.label,
	              "value": item.value
	            }
	          })
	        }), 1)]
	      }
	    }], null, false, 3138576737)
	  })], 1)] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [(!_vm.showForm) ? _c('el-button', {
	    staticClass: "small dark",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "disabled": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.close')))]) : _vm._e(), _vm._v(" "), (_vm.operation == 'cancelOrder') ? _c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.cancelOrder
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.cancelOrders')))]) : _vm._e(), _vm._v(" "), (_vm.operation == 'createInvoice') ? _c('el-button', {
	    staticClass: "small",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.createInvoices
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.createInvoices')))]) : _vm._e()], 1)] : [_c('div', [_vm._l((_vm.orders), function(order) {
	    return _c('div', {
	      key: order.id
	    }, [_c('p', [_vm._v("- Order " + _vm._s(order.name) + ",\n              "), (_vm.errorsByOrder[order.id] && _vm.errorsByOrder[order.id].length) ? _c('span', [_vm._v("Failed "), _c('i', {
	      staticClass: "el-icon-error danger-color"
	    })]) : _c('span', [_vm._v(_vm._s(_vm.successStatus) + " "), _c('i', {
	      staticClass: "el-icon-success",
	      staticStyle: {
	        "color": "green"
	      }
	    })])]), _vm._v(" "), (_vm.errorsByOrder[order.id] && _vm.errorsByOrder[order.id].length) ? _c('ul', _vm._l((_vm.errorsByOrder[order.id]), function(error) {
	      return _c('li', [_c('span', [_vm._v(_vm._s(error.message))])])
	    }), 0) : _vm._e()])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "flex",
	    staticStyle: {
	      "justify-content": "center"
	    }
	  }, [(_vm.submitted) ? _c('el-button', {
	    staticClass: "small dark",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "10px 20px"
	    },
	    attrs: {
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.$t('button.close')))]) : _vm._e()], 1)], 2)]], 2)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3141 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.productGroups.edit.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "whiteWrapper"
	  }, [_c('el-tabs', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": _vm.$t('static.productGroups.formTabs.groupInformation'),
	      "name": "1"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('v-form', {
	    attrs: {
	      "form": _vm.form,
	      "translation": "form.productGroups",
	      "hasLabel": true
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "full-w flex justify-center buttons_under_main_body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'productGroups.index'
	      }
	    }
	  }, [_c('el-button', {
	    staticClass: "dark"
	  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
	    staticClass: "outline",
	    attrs: {
	      "loading": _vm.form.loading
	    },
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3142 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 8
	    }
	  }, [_c('h1', {
	    staticClass: "pageTitle"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('static.equipments.index.title')) + " (" + _vm._s(_vm.equipments.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "xs": 24,
	      "md": 16
	    }
	  }, [_c('div', {
	    staticClass: "listOptions pull-right"
	  }, [_c('el-button-group', [_c('el-button', {
	    attrs: {
	      "type": _vm.primary,
	      "size": "small",
	      "icon": "el-icon-menu",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('info')
	      }
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": _vm.info,
	      "size": "small",
	      "icon": "el-icon-tickets",
	      "round": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeView('primary')
	      }
	    }
	  })], 1), _vm._v(" "), _c('v-text', {
	    staticClass: "searchForm",
	    attrs: {
	      "name": "search",
	      "type": "text",
	      "translation": "search.title",
	      "value": _vm.search,
	      "clearable": true
	    },
	    on: {
	      "keydown": _vm.onChangeSearch
	    }
	  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('sort.title')) + " ")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": _vm.$t('sort.placeholder')
	    },
	    model: {
	      value: (_vm.sort),
	      callback: function($$v) {
	        _vm.sort = $$v
	      },
	      expression: "sort"
	    }
	  })], 1)])], 1), _vm._v(" "), (_vm.info == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('div', {
	    staticClass: "flex stretch wrap"
	  }, [(_vm.equipments.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.equipment.noDataMsg')) + "\n        "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'production.equipments.create'
	      }
	    }
	  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.equipment.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.equipments.items), function(m, i) {
	    return _c('v-card', {
	      key: i,
	      nativeOn: {
	        "click": function($event) {
	          return _vm.editEquipment(m)
	        }
	      }
	    }, [_c('h2', {
	      staticClass: "cardTitle"
	    }, [_vm._v(_vm._s(m.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), (m.description) ? _c('div', {
	      staticClass: "cardinnerBox"
	    }, [_c('div', [_c('label', {
	      staticClass: "cardLabel cardLabel--small"
	    }, [_c('i', {
	      staticClass: "fa fa-file-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }), _vm._v("  " + _vm._s(m.description))])])]) : _vm._e()])
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.primary == 'info') ? _c('el-row', {
	    attrs: {
	      "gutter": 5
	    }
	  }, [(_vm.loading) ? _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (true),
	      expression: "true"
	    }],
	    staticStyle: {
	      "background": "transparent"
	    }
	  }, [_c('br'), _c('br')]) : _c('v-table', {
	    attrs: {
	      "list": _vm.equipmentsListView,
	      "noDataMessage": _vm.$t('static.defaultText.equipment.noDataMsg'),
	      "link": _vm.editEquipment,
	      "linkKey": "name",
	      "rowKey": "id",
	      "translation": "static.equipments.table"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
	    staticClass: "pagination"
	  }, [_c('v-pagination', {
	    attrs: {
	      "pagination": _vm.equipments.pagination,
	      "switchFunction": _vm.all
	    }
	  })], 1)])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 3143 */,
/* 3144 */,
/* 3145 */,
/* 3146 */,
/* 3147 */,
/* 3148 */,
/* 3149 */,
/* 3150 */,
/* 3151 */,
/* 3152 */,
/* 3153 */,
/* 3154 */,
/* 3155 */,
/* 3156 */,
/* 3157 */,
/* 3158 */,
/* 3159 */,
/* 3160 */,
/* 3161 */,
/* 3162 */,
/* 3163 */,
/* 3164 */,
/* 3165 */,
/* 3166 */,
/* 3167 */,
/* 3168 */,
/* 3169 */,
/* 3170 */,
/* 3171 */,
/* 3172 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 3173 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 3174 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 3175 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.8833aa34bac854fa50e4.js